const europeData = {
  type: "FeatureCollection",

  features: [
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "AJ",
        ISO2: "AZ",
        ISO3: "AZE",
        UN: 31,
        NAME: "Azerbaijan",
        AREA: 8260,
        POP2005: 8352021,
        REGION: 142,
        SUBREGION: 145,
        LON: 47.395,
        LAT: 40.43,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [45.083321, 39.768044000000145],
              [45.266388, 39.611107000000118],
              [45.319984, 39.546944],
              [45.326096, 39.538322],
              [45.330826000000116, 39.535271],
              [45.457497, 39.493607000000111],
              [45.47248100000013, 39.494431],
              [45.49694, 39.502213],
              [45.507767, 39.506653],
              [45.528328000000101, 39.517212],
              [45.558327, 39.533875000000137],
              [45.590546000000131, 39.54861],
              [45.60777, 39.554703],
              [45.626656, 39.55999],
              [45.725266, 39.57972],
              [45.732201000000146, 39.580544000000145],
              [45.740822, 39.57972],
              [45.755272, 39.576653],
              [45.783333, 39.569153000000142],
              [45.800545000000113, 39.561928],
              [45.811371, 39.556374000000119],
              [45.81998, 39.54972],
              [45.823044, 39.545273],
              [45.829987, 39.455544],
              [45.829987, 39.449425],
              [45.829163, 39.442757],
              [45.826653, 39.43748],
              [45.8555530000001, 39.348038],
              [45.978043000000127, 39.279984000000127],
              [45.992210000000114, 39.270821000000126],
              [46.0, 39.263611],
              [46.00888, 39.250832],
              [46.009995000000117, 39.24527],
              [46.003609, 39.236382000000106],
              [45.989983, 39.22664600000013],
              [45.982201, 39.21944],
              [45.971924000000115, 39.206650000000138],
              [45.966927, 39.188881],
              [45.967209, 39.182770000000119],
              [45.970261, 39.166382],
              [46.107216, 38.936104],
              [46.123604, 38.909981],
              [46.178246000000115, 38.84115],
              [46.074715, 38.871933],
              [45.950829, 38.887215],
              [45.8411, 38.903603],
              [45.607491, 38.951378],
              [45.538605, 38.965546000000131],
              [45.518593, 38.970543],
              [45.477264000000105, 38.984962],
              [45.439423, 38.998047],
              [45.427528, 39.008324],
              [45.423882, 39.019707],
              [45.42499, 39.025826],
              [45.421097, 39.06082],
              [45.348877, 39.160538],
              [45.342209000000139, 39.168877000000123],
              [45.30999, 39.19832],
              [45.30304, 39.199715],
              [45.296097, 39.19860100000011],
              [45.284431, 39.193871],
              [45.274712, 39.187759],
              [45.267769000000101, 39.186646],
              [45.22581, 39.19498],
              [45.1461, 39.214149000000134],
              [45.14193, 39.217484],
              [45.13999200000012, 39.221657],
              [45.14222, 39.24054],
              [45.14137, 39.253609],
              [45.130547, 39.28555],
              [45.115822, 39.312202],
              [45.063042, 39.373047],
              [45.004433, 39.416382],
              [45.0, 39.417],
              [44.974709, 39.42054],
              [44.958878, 39.428879],
              [44.950272, 39.435822],
              [44.92777, 39.476646],
              [44.908043000000134, 39.535828],
              [44.904709000000139, 39.546654],
              [44.90137, 39.564438000000109],
              [44.888596000000121, 39.60582],
              [44.871933, 39.62165],
              [44.864998, 39.62305],
              [44.81304200000011, 39.63081],
              [44.816376000000105, 39.64582],
              [44.80305, 39.681656],
              [44.801384, 39.684441000000106],
              [44.789986, 39.698044],
              [44.778862, 39.70638300000013],
              [44.789398000000119, 39.709698],
              [44.799164, 39.712769],
              [44.85833, 39.724991],
              [44.882767000000115, 39.724709000000132],
              [44.896378, 39.7211],
              [44.92054000000013, 39.718323],
              [44.933044, 39.72137],
              [44.951935, 39.726372],
              [44.969147, 39.732491],
              [44.99749, 39.750832000000116],
              [45.0, 39.753006],
              [45.014153, 39.765266],
              [45.028046000000131, 39.774437],
              [45.039986, 39.77833],
              [45.05415, 39.779984],
              [45.061928, 39.77887],
              [45.07360100000011, 39.774155],
              [45.083321, 39.768044000000145],
            ],
          ],
          [
            [
              [45.245270000000119, 40.976940000000127],
              [45.22916, 40.969151000000124],
              [45.206379, 40.97943],
              [45.194988, 40.9911],
              [45.19582, 40.997768],
              [45.204708, 41.00471],
              [45.212608, 41.004162],
              [45.236938000000123, 40.990269],
              [45.245270000000119, 40.98305],
              [45.245270000000119, 40.976940000000127],
            ],
          ],
          [
            [
              [45.04527, 41.035271],
              [45.02583, 41.030548],
              [45.00999, 41.033051],
              [44.987770000000125, 41.050541],
              [44.980549, 41.064709],
              [44.984161, 41.08194],
              [45.00111, 41.088879],
              [45.017490000000123, 41.089161000000104],
              [45.03027, 41.084991],
              [45.051659, 41.066669],
              [45.05888, 41.052769000000126],
              [45.054161000000136, 41.042221],
              [45.04527, 41.035271],
            ],
          ],
          [
            [
              [46.57138, 41.871933000000126],
              [46.639709, 41.816093],
              [46.644707, 41.819153],
              [46.754166000000112, 41.862488],
              [46.760818, 41.863884],
              [46.764992, 41.860268],
              [46.76693, 41.85526],
              [46.76888300000013, 41.844437],
              [46.769981, 41.832764],
              [46.769981, 41.826653000000135],
              [46.76888300000013, 41.819984],
              [46.76888300000013, 41.807487],
              [46.770821, 41.796654000000103],
              [46.77887, 41.78916],
              [46.80693, 41.769150000000138],
              [46.861664000000133, 41.734711],
              [46.940536, 41.683868],
              [47.021378, 41.618599],
              [47.084160000000111, 41.565536],
              [47.100548, 41.57304],
              [47.11304, 41.576653],
              [47.127762000000132, 41.578049],
              [47.135818, 41.576653],
              [47.141663000000108, 41.574158],
              [47.156647, 41.564713],
              [47.160538, 41.561104000000114],
              [47.253052, 41.433327000000133],
              [47.258881, 41.424706],
              [47.260818, 41.419716],
              [47.263611, 41.403313],
              [47.26249700000011, 41.390266],
              [47.260277, 41.376938],
              [47.260277, 41.370827],
              [47.261101, 41.359154],
              [47.265831000000105, 41.331100000000106],
              [47.271660000000111, 41.322495000000117],
              [47.275551, 41.318604],
              [47.28555, 41.312202],
              [47.37109, 41.271935],
              [47.56471, 41.213051],
              [47.571663, 41.211098],
              [47.580544000000145, 41.210274],
              [47.587769, 41.210815],
              [47.599434, 41.215271],
              [47.624428, 41.22998],
              [47.636932000000115, 41.234154000000103],
              [47.643326000000116, 41.23555],
              [47.659714, 41.23555],
              [47.72137, 41.21054],
              [47.750832000000116, 41.197762000000125],
              [47.7586060000001, 41.196381],
              [47.76693, 41.196091],
              [47.796097, 41.198868000000118],
              [47.859154000000103, 41.207764],
              [47.904984000000127, 41.217766],
              [47.910812, 41.2197],
              [47.91999, 41.22637],
              [47.926102, 41.236107],
              [47.926384, 41.24221],
              [47.92526, 41.24749],
              [47.919716000000108, 41.25639],
              [47.915825, 41.259995],
              [47.909981, 41.26888300000013],
              [47.908043, 41.273598],
              [47.9072, 41.27916],
              [47.908318000000122, 41.290833000000134],
              [47.958321, 41.35582],
              [48.066093, 41.460274],
              [48.074432, 41.46777],
              [48.096375, 41.47777],
              [48.115273, 41.482758],
              [48.149994, 41.488319],
              [48.186104000000114, 41.492210000000114],
              [48.225548, 41.50054200000011],
              [48.231377, 41.502495],
              [48.248871000000122, 41.509163],
              [48.370827, 41.570267000000115],
              [48.38582, 41.579163],
              [48.399712, 41.589149],
              [48.416100000000142, 41.604706000000135],
              [48.42305, 41.613319000000104],
              [48.436928, 41.639153000000135],
              [48.531380000000127, 41.76721],
              [48.583954, 41.83577],
              [48.613045, 41.824432],
              [48.672768, 41.78611],
              [48.677773000000116, 41.782761000000107],
              [48.724991, 41.737762],
              [48.780823, 41.679436],
              [48.858330000000137, 41.596931],
              [48.87888, 41.56693300000012],
              [48.887497, 41.553879],
              [48.89666, 41.530266],
              [48.89944, 41.525826000000109],
              [48.910812, 41.51443],
              [48.986382000000106, 41.443604000000107],
              [48.997208, 41.437759],
              [49.010818, 41.433594],
              [49.022484, 41.428322],
              [49.0322, 41.421654000000103],
              [49.039986000000113, 41.414146],
              [49.136101, 41.277771000000143],
              [49.140549, 41.268326],
              [49.141373, 41.262772],
              [49.140831, 41.250542],
              [49.140266, 41.238319000000104],
              [49.141373, 41.2211],
              [49.154984, 41.151649000000134],
              [49.192757, 41.061104],
              [49.206383, 41.03916],
              [49.222214, 41.018326000000116],
              [49.23249, 41.006386],
              [49.251389, 40.987206],
              [49.39804, 40.849709],
              [49.412491000000102, 40.839989000000116],
              [49.423882, 40.834435],
              [49.439423, 40.831383],
              [49.463051000000121, 40.831383],
              [49.4786, 40.828331000000105],
              [49.491096, 40.823601],
              [49.50054200000011, 40.816933],
              [49.524994, 40.794991],
              [49.532494, 40.78749],
              [49.537766, 40.7786],
              [49.538605000000132, 40.773041],
              [49.537209000000132, 40.766388],
              [49.528046000000131, 40.751938000000109],
              [49.517212, 40.72998],
              [49.511101, 40.712212000000136],
              [49.508324, 40.699158],
              [49.508041000000105, 40.69305],
              [49.510544, 40.682487],
              [49.513329000000113, 40.67804],
              [49.528046000000131, 40.662766],
              [49.567772000000105, 40.631653],
              [49.577209, 40.625259],
              [49.582764000000111, 40.62249],
              [49.704163000000108, 40.580544],
              [49.719704, 40.577492],
              [49.804993000000138, 40.56471],
              [49.828606, 40.56248],
              [49.856934, 40.565262],
              [49.876381, 40.569153000000142],
              [49.918602, 40.581657],
              [49.930275000000108, 40.585815000000139],
              [49.973038, 40.589432000000102],
              [50.000000000000114, 40.58597600000013],
              [50.032768, 40.575554],
              [50.231377, 40.493607],
              [50.236107, 40.490273000000116],
              [50.333878, 40.40332],
              [50.347488, 40.3875],
              [50.356384000000105, 40.37471],
              [50.358887, 40.370270000000119],
              [50.363609, 40.35555],
              [50.36721, 40.333878000000141],
              [50.37499, 40.262215],
              [50.354713, 40.268051],
              [50.34388, 40.27972],
              [50.313606, 40.304436],
              [50.30888, 40.30777],
              [50.303322, 40.310547],
              [50.262497, 40.329163000000108],
              [50.25666, 40.330551],
              [50.219986, 40.3386],
              [50.133049, 40.357216],
              [50.124161, 40.35833],
              [49.960815000000139, 40.348877],
              [49.847481, 40.322220000000129],
              [49.57166, 40.212769],
              [49.566666, 40.209984],
              [49.517769, 40.174164],
              [49.5, 40.160538],
              [49.488045000000113, 40.150536000000102],
              [49.426941, 40.059708],
              [49.424988, 40.053879],
              [49.425545, 40.04832],
              [49.428322, 40.043877],
              [49.45527, 40.014992],
              [49.449997, 39.964989],
              [49.42666, 39.89971],
              [49.39693, 39.747208000000114],
              [49.392220000000123, 39.69165],
              [49.38248, 39.686104],
              [49.32222, 39.62915],
              [49.318886000000134, 39.62498],
              [49.31332, 39.614716000000101],
              [49.280823, 39.50054],
              [49.281662, 39.49527],
              [49.284988, 39.485268],
              [49.287491, 39.480820000000108],
              [49.293877000000123, 39.472755],
              [49.304993, 39.46137],
              [49.339989, 39.434433],
              [49.349152, 39.427773],
              [49.353882, 39.424706],
              [49.37638, 39.413872],
              [49.4072, 39.39222],
              [49.413605, 39.38388],
              [49.414146, 39.37832],
              [49.395546000000138, 39.350266],
              [49.351662, 39.32138],
              [49.340775, 39.329079],
              [49.324997, 39.33694],
              [49.31304200000011, 39.34137],
              [49.297211000000118, 39.343323],
              [49.290276, 39.342209],
              [49.278603, 39.337769],
              [49.26915, 39.33138300000013],
              [49.258041, 39.319443],
              [49.252213, 39.310265],
              [49.244156, 39.29554],
              [49.238045, 39.279427],
              [49.203049, 39.056656],
              [49.20221, 39.0430530000001],
              [49.20361, 39.03749],
              [49.20332, 39.030823],
              [49.201935, 39.024712],
              [49.194427, 39.016663],
              [49.161377, 38.988045],
              [49.156647000000135, 38.984711],
              [49.140549, 38.977211],
              [49.128036, 38.973312],
              [49.08804, 38.964706],
              [49.0811, 38.963608],
              [49.072220000000129, 38.963875],
              [49.060265, 38.966927],
              [49.0561, 38.970543],
              [49.053596, 38.975266],
              [49.05166, 39.00139],
              [49.053596, 39.006653000000142],
              [49.05999, 39.0086060000001],
              [49.073318, 39.011375],
              [49.102486, 39.015266000000111],
              [49.108597000000145, 39.016930000000116],
              [49.118599, 39.022758],
              [49.12694, 39.029984],
              [49.13721, 39.0425],
              [49.14222, 39.05248],
              [49.147217, 39.062759],
              [49.149712, 39.074715],
              [49.149994, 39.081657000000121],
              [49.148041, 39.093323000000112],
              [49.144707, 39.097481],
              [49.140549, 39.101105],
              [49.049431, 39.176941000000113],
              [49.038322000000107, 39.182213],
              [49.01054, 39.1886],
              [49.002769, 39.189423],
              [48.98749, 39.188042],
              [48.97499, 39.184433],
              [48.964989, 39.178596],
              [48.961372, 39.174431],
              [48.955544000000145, 39.165268],
              [48.93249, 39.113602],
              [48.930275000000108, 39.058594],
              [48.933327, 39.047493],
              [48.936646, 39.04332],
              [48.949997, 39.032761000000107],
              [48.95332, 39.0286],
              [48.953873, 39.022217],
              [48.952492, 39.016388],
              [48.935265, 38.95694],
              [48.933044000000109, 38.951378],
              [48.911377, 38.905823000000112],
              [48.9086, 38.901093],
              [48.90193, 38.892487000000131],
              [48.890831, 38.8808140000001],
              [48.882484, 38.873604],
              [48.866653, 38.745827],
              [48.871933000000126, 38.569153],
              [48.87859, 38.465271],
              [48.881054, 38.455467000000112],
              [48.888283, 38.442406],
              [48.847214, 38.44999700000011],
              [48.839432, 38.450829],
              [48.830826000000116, 38.451096000000121],
              [48.789429, 38.447762000000125],
              [48.778046, 38.44331],
              [48.742210000000114, 38.424164],
              [48.66638, 38.389153],
              [48.659424, 38.389153],
              [48.630219000000125, 38.392464000000132],
              [48.62305, 38.39526],
              [48.61055, 38.405823],
              [48.599152, 38.416939000000127],
              [48.568604, 38.467209000000139],
              [48.561928, 38.475548],
              [48.441933, 38.62165],
              [48.436928, 38.624702],
              [48.42999, 38.626099000000124],
              [48.422211, 38.625824000000136],
              [48.40804, 38.623322],
              [48.389435000000105, 38.61776],
              [48.361931, 38.60582],
              [48.342484, 38.600822],
              [48.3336, 38.601105000000132],
              [48.327766, 38.60332],
              [48.322762, 38.606102],
              [48.247765, 38.663605],
              [48.243607, 38.667206000000135],
              [48.241096, 38.671928],
              [48.241936, 38.68555],
              [48.249718, 38.70721],
              [48.250275000000101, 38.713875],
              [48.249428, 38.719986],
              [48.243874, 38.72777],
              [48.232758000000103, 38.732758],
              [48.184708, 38.75054200000011],
              [48.152771, 38.760277],
              [48.145821, 38.761932],
              [48.123604, 38.772217000000126],
              [48.10304, 38.7836],
              [48.03665, 38.820824],
              [48.024155, 38.831383],
              [48.020821, 38.835541],
              [48.016930000000116, 38.845818],
              [48.01388, 38.856934000000138],
              [48.0125, 38.869156],
              [48.01082, 38.88749700000011],
              [48.01110100000011, 38.89444],
              [48.012215, 38.90054],
              [48.014153, 38.905823000000112],
              [48.071381, 38.951378],
              [48.08221, 38.95638300000013],
              [48.14415, 38.968323],
              [48.185265000000129, 38.969147],
              [48.224709, 38.971375000000137],
              [48.260818, 38.976646],
              [48.266621, 38.97855],
              [48.276093, 38.98166],
              [48.291382000000112, 38.989983],
              [48.304993, 38.999718],
              [48.312485, 39.007767000000115],
              [48.3238750000001, 39.026375],
              [48.326935, 39.038048],
              [48.327766, 39.05166],
              [48.326096, 39.057213],
              [48.29388, 39.112488],
              [48.286385, 39.12027],
              [48.276093, 39.125824],
              [48.269981, 39.128036],
              [48.256943, 39.131927000000132],
              [48.236107, 39.136658],
              [48.22998, 39.138878],
              [48.214706, 39.147484],
              [48.134995000000117, 39.208878],
              [48.131653, 39.213051],
              [48.122765, 39.246094],
              [48.121368, 39.251389000000131],
              [48.11998, 39.263611],
              [48.12249, 39.275826],
              [48.125259000000142, 39.28054],
              [48.143044000000145, 39.301102],
              [48.150269, 39.309151],
              [48.159424, 39.315819],
              [48.189156, 39.333321],
              [48.200829, 39.337769],
              [48.214989, 39.339989],
              [48.23888, 39.34137],
              [48.253052, 39.3436],
              [48.27887, 39.350266],
              [48.35979, 39.385216],
              [48.355980000000102, 39.394604],
              [48.342209, 39.421371],
              [48.338875, 39.425545],
              [48.321938, 39.440819],
              [48.283875, 39.472755],
              [48.250832, 39.49471],
              [48.21249, 39.526375],
              [48.159157, 39.57332],
              [48.087494, 39.63999200000012],
              [48.07749200000012, 39.652489000000116],
              [48.06971, 39.660271],
              [48.056931, 39.670830000000137],
              [48.038322000000107, 39.683327000000133],
              [48.014153, 39.699158],
              [47.99276, 39.71194],
              [47.976662, 39.719231],
              [47.819153000000142, 39.681107000000111],
              [47.80666, 39.677216],
              [47.797493000000145, 39.670830000000137],
              [47.790276, 39.662766],
              [47.776649000000134, 39.638596000000121],
              [47.763054, 39.628876],
              [47.542496, 39.515266],
              [47.466927, 39.5],
              [47.45443, 39.496384],
              [47.391663, 39.470543000000134],
              [47.340828, 39.42832],
              [47.3336, 39.420273000000122],
              [47.322220000000129, 39.401375],
              [47.314995, 39.393600000000106],
              [47.292213, 39.376938000000109],
              [47.281662, 39.371933],
              [47.207497, 39.342209],
              [47.19498, 39.338326000000109],
              [47.188042, 39.337212000000136],
              [47.17027, 39.337494],
              [47.158875000000137, 39.333054],
              [47.099709, 39.304436],
              [47.044991, 39.243607],
              [47.041939000000127, 39.232201],
              [47.041100000000142, 39.204987],
              [47.038048, 39.20027],
              [47.030823, 39.192215],
              [47.025551, 39.189423],
              [46.961372, 39.158318],
              [46.948868, 39.154427],
              [46.93998, 39.154427],
              [46.919434, 39.16582],
              [46.913315, 39.16805],
              [46.90554, 39.168877000000123],
              [46.896660000000111, 39.168877000000123],
              [46.874702000000127, 39.167496],
              [46.854439, 39.163048000000117],
              [46.848328, 39.16109],
              [46.838326, 39.15527],
              [46.765266, 39.093323000000112],
              [46.753609, 39.081383],
              [46.751656, 39.075829],
              [46.75054200000011, 39.064438],
              [46.74749, 39.052773],
              [46.745537, 39.047493],
              [46.738319, 39.039429],
              [46.652206, 38.97693],
              [46.572495000000117, 38.915825],
              [46.540375, 38.875587],
              [46.49749, 38.949425000000133],
              [46.495537000000127, 38.95443],
              [46.494713, 38.959717000000126],
              [46.494431, 38.96583],
              [46.498871000000122, 38.99165],
              [46.505547, 39.008041],
              [46.511932, 39.017487],
              [46.520264, 39.032204],
              [46.523598, 39.044159],
              [46.51971, 39.065819],
              [46.515831, 39.081657000000121],
              [46.500275000000101, 39.120537],
              [46.49749, 39.124985],
              [46.493607000000111, 39.128593000000137],
              [46.48888, 39.131653],
              [46.47749, 39.136658],
              [46.458321, 39.14277],
              [46.435547, 39.152771],
              [46.42388, 39.163872],
              [46.421097, 39.16805],
              [46.417206, 39.177773],
              [46.415268, 39.188881],
              [46.4161, 39.201378],
              [46.418602, 39.206650000000138],
              [46.421928, 39.211655],
              [46.425545, 39.214149000000134],
              [46.431107, 39.216385],
              [46.444427, 39.21859],
              [46.452209, 39.21859],
              [46.459984, 39.217484],
              [46.46666, 39.215546],
              [46.496094, 39.20361],
              [46.537766, 39.189423],
              [46.54554, 39.189423],
              [46.616096, 39.217209],
              [46.620827, 39.219986],
              [46.62249, 39.224709],
              [46.620537, 39.229424000000108],
              [46.58138300000013, 39.253609],
              [46.557487, 39.26915],
              [46.40387, 39.378593],
              [46.392487, 39.389709],
              [46.386658, 39.398331],
              [46.381653, 39.413605000000132],
              [46.38055, 39.42499],
              [46.382484, 39.438324],
              [46.385818, 39.442757],
              [46.395264, 39.448601],
              [46.400826000000109, 39.450829],
              [46.40776, 39.45165],
              [46.44860100000011, 39.457764],
              [46.494431, 39.466927],
              [46.500832, 39.468323000000112],
              [46.511932, 39.472755],
              [46.516663, 39.475815],
              [46.519981, 39.480263],
              [46.54639, 39.538605],
              [46.548050000000103, 39.544434],
              [46.546944, 39.549988],
              [46.541382000000112, 39.564438000000109],
              [46.53443, 39.572495000000117],
              [46.53054, 39.576096],
              [46.519981, 39.581940000000145],
              [46.364441, 39.62498],
              [46.349991, 39.62804],
              [46.335815, 39.626656],
              [46.32304, 39.623604],
              [46.311104, 39.619713],
              [46.30555, 39.617493],
              [46.300819000000104, 39.614441],
              [46.256386, 39.596657],
              [46.25027, 39.594994],
              [46.24305, 39.594147000000135],
              [46.227211, 39.594147000000135],
              [46.2111, 39.5961],
              [46.204163000000108, 39.598038],
              [46.18971, 39.607216],
              [46.067772, 39.689423],
              [46.056099, 39.70054],
              [46.05304, 39.704712],
              [46.04332, 39.723038],
              [46.03054, 39.745537],
              [46.018593, 39.762772],
              [46.01082, 39.76998],
              [46.006104, 39.773041],
              [45.999161, 39.774994],
              [45.983871, 39.777489],
              [45.960274, 39.7786],
              [45.92638, 39.788048],
              [45.908875, 39.795273000000122],
              [45.88666, 39.805817],
              [45.876099000000124, 39.81137],
              [45.85666, 39.823601],
              [45.844704, 39.83443],
              [45.829163, 39.849152000000117],
              [45.819153000000142, 39.861382],
              [45.816376, 39.86554],
              [45.807213, 39.884438000000102],
              [45.80222, 39.89971],
              [45.799988, 39.910538],
              [45.793877000000123, 39.92526],
              [45.784157, 39.937485],
              [45.77444, 39.943604],
              [45.751099, 39.95332],
              [45.729706000000135, 39.958321],
              [45.705269, 39.961372],
              [45.618317, 39.967766],
              [45.611382, 39.96944],
              [45.60555, 39.971924],
              [45.595818, 39.978043],
              [45.59277, 39.982491],
              [45.5936, 39.99499],
              [45.599991, 40.004166],
              [45.603882000000112, 40.007767000000115],
              [45.613602, 40.014435],
              [45.638039, 40.021660000000111],
              [45.681931000000134, 40.025826],
              [45.713608, 40.026093000000117],
              [45.763611, 40.024437],
              [45.82443, 40.019981000000143],
              [45.847771000000137, 40.01611],
              [45.87305, 40.01361],
              [45.888039, 40.014435],
              [45.900826, 40.017487],
              [45.90554, 40.020546000000138],
              [45.909424, 40.024437],
              [45.9161, 40.03333],
              [45.973877, 40.112488],
              [45.97693, 40.116936],
              [45.979424, 40.122208000000114],
              [46.00194, 40.213608],
              [46.00277, 40.220261000000107],
              [46.00194, 40.225548],
              [45.999718000000144, 40.23053700000014],
              [45.993874000000119, 40.23916],
              [45.962494, 40.26859],
              [45.958321, 40.27222],
              [45.951653000000135, 40.27387],
              [45.92054000000013, 40.265549],
              [45.906151, 40.263451000000146],
              [45.888596000000121, 40.265266],
              [45.875824, 40.26971],
              [45.66277, 40.375824000000136],
              [45.638039, 40.39111],
              [45.540276000000119, 40.453316],
              [45.53249, 40.46054],
              [45.413605, 40.60804000000013],
              [45.391106, 40.643326000000116],
              [45.389153, 40.64833],
              [45.386932, 40.659157000000107],
              [45.386658, 40.66527],
              [45.388329000000113, 40.6711],
              [45.391373000000101, 40.675819],
              [45.418877000000123, 40.71777],
              [45.42193, 40.722214000000122],
              [45.42915, 40.729149],
              [45.443604, 40.738319],
              [45.455544, 40.74221],
              [45.523315, 40.763054],
              [45.574158, 40.776375],
              [45.57972, 40.7786],
              [45.594147, 40.78777],
              [45.603882000000112, 40.80138],
              [45.606377000000123, 40.806374],
              [45.615273, 40.828049],
              [45.620827, 40.84388],
              [45.623322, 40.856659],
              [45.622208000000114, 40.862206],
              [45.61805, 40.871933000000126],
              [45.614159, 40.87554],
              [45.368317, 41.001656],
              [45.3536, 41.000000000000114],
              [45.34499, 41.000542],
              [45.33694, 41.001656],
              [45.101379, 41.056656],
              [45.09137, 41.06276],
              [45.082207, 41.075554000000125],
              [45.077766000000111, 41.085258000000124],
              [45.07332, 41.101105],
              [45.074158, 41.107773],
              [45.076653, 41.113045000000113],
              [45.081383, 41.1161],
              [45.087769, 41.11776],
              [45.11055, 41.119713],
              [45.128319, 41.118599],
              [45.13637, 41.117203],
              [45.171928, 41.114998],
              [45.179993, 41.114998],
              [45.1947100000001, 41.116936],
              [45.201096, 41.118317],
              [45.20665, 41.120827],
              [45.216385, 41.126938000000109],
              [45.220543, 41.13055],
              [45.22275500000012, 41.13582],
              [45.22275500000012, 41.14193],
              [45.218323, 41.151649000000134],
              [45.211372, 41.159714],
              [45.19305, 41.17305],
              [45.15387, 41.198601],
              [45.147774, 41.201096000000121],
              [45.140831, 41.202766],
              [45.131927, 41.20361],
              [45.046944, 41.223312],
              [45.022942, 41.297050000000127],
              [45.051384, 41.316376000000105],
              [45.14137, 41.376656],
              [45.186104, 41.40498],
              [45.255272000000105, 41.446938000000102],
              [45.266663, 41.451653000000135],
              [45.27887, 41.455544],
              [45.291939, 41.458878],
              [45.306656, 41.461098],
              [45.328606, 41.463608],
              [45.336655000000121, 41.462494],
              [45.35055, 41.458878],
              [45.61111, 41.381927],
              [45.716927, 41.348595000000103],
              [45.7197, 41.320541000000105],
              [45.715546, 41.316933],
              [45.709160000000111, 41.30777],
              [45.7075, 41.301926],
              [45.7075, 41.29583],
              [45.708603, 41.290276],
              [45.710815, 41.285271],
              [45.717766, 41.277489],
              [45.748047, 41.260277],
              [45.796097000000145, 41.234428],
              [45.81304200000011, 41.22637],
              [45.850822, 41.21277],
              [45.869713, 41.206093],
              [45.895546000000138, 41.197487],
              [45.922493, 41.189156],
              [45.966103, 41.17915],
              [45.996941, 41.173607000000118],
              [46.03138, 41.170273000000122],
              [46.047768000000133, 41.170273000000122],
              [46.062202, 41.171928],
              [46.0825, 41.175819],
              [46.100548, 41.181931000000134],
              [46.128036000000122, 41.19999700000011],
              [46.133881, 41.20249200000012],
              [46.140266, 41.20387],
              [46.227211, 41.20665],
              [46.235268000000133, 41.20665],
              [46.243317, 41.205544],
              [46.254166, 41.19999700000011],
              [46.268044, 41.183868],
              [46.279984, 41.172768000000133],
              [46.294159, 41.16277],
              [46.340828, 41.12999],
              [46.359711000000118, 41.116936],
              [46.378319, 41.104156],
              [46.483871000000136, 41.05555],
              [46.501656000000139, 41.04805],
              [46.50861, 41.046097],
              [46.520821000000126, 41.049988],
              [46.62249, 41.100548000000117],
              [46.663315, 41.146103],
              [46.669991, 41.154984],
              [46.697205, 41.211655000000121],
              [46.710815, 41.255272],
              [46.710815, 41.261375],
              [46.693871, 41.312202],
              [46.690819, 41.316666000000112],
              [46.686928, 41.32027],
              [46.621094, 41.364998],
              [46.593323, 41.37943300000012],
              [46.55304, 41.386932000000115],
              [46.506104000000107, 41.395264],
              [46.499161000000129, 41.397217],
              [46.333878, 41.481659],
              [46.329987000000131, 41.485268],
              [46.23333, 41.598595],
              [46.2161, 41.624985],
              [46.197762, 41.669159],
              [46.194427000000132, 41.685822],
              [46.194427000000132, 41.698044],
              [46.198044, 41.72499],
              [46.208046, 41.744431000000134],
              [46.211372, 41.748871],
              [46.224541, 41.76106],
              [46.236382000000106, 41.76388],
              [46.251938000000109, 41.764992],
              [46.26082, 41.764153],
              [46.283875, 41.75972],
              [46.297768, 41.755829],
              [46.31388, 41.75332],
              [46.321381, 41.754166],
              [46.33194, 41.75916],
              [46.350548000000117, 41.773315000000139],
              [46.408875000000137, 41.825829],
              [46.42054, 41.837769],
              [46.433327, 41.856659],
              [46.438324000000136, 41.866936],
              [46.451752, 41.897057],
              [46.505272, 41.8936],
              [46.556374000000119, 41.887497],
              [46.563324, 41.885544],
              [46.568329, 41.882484],
              [46.57138, 41.871933000000126],
            ],
            [
              [45.51305, 40.60722],
              [45.528881, 40.606098],
              [45.573051000000135, 40.632488],
              [45.588329, 40.64833],
              [45.58749, 40.653881],
              [45.572491, 40.663052000000107],
              [45.55534, 40.665371],
              [45.51749, 40.665539],
              [45.501389000000131, 40.658039000000144],
              [45.49194, 40.63694],
              [45.499161000000129, 40.61694],
              [45.51305, 40.60722],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "AL",
        ISO2: "AL",
        ISO3: "ALB",
        UN: 8,
        NAME: "Albania",
        AREA: 2740,
        POP2005: 3153731,
        REGION: 150,
        SUBREGION: 39,
        LON: 20.068,
        LAT: 41.143,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [19.436214, 41.021065],
            [19.450554, 41.059998],
            [19.513611, 41.251938],
            [19.513885, 41.256104],
            [19.51083, 41.274437],
            [19.509441, 41.277771],
            [19.504719, 41.287216],
            [19.492496, 41.300552],
            [19.482777, 41.30722],
            [19.467499, 41.310829],
            [19.452221, 41.309715],
            [19.442497, 41.406944],
            [19.519997, 41.57],
            [19.566666, 41.584999],
            [19.584721, 41.605827],
            [19.586941, 41.638611],
            [19.570829, 41.685268],
            [19.57972, 41.692497],
            [19.584164, 41.698883],
            [19.598053, 41.771111],
            [19.600277, 41.78833],
            [19.600555, 41.796661],
            [19.59972, 41.804161],
            [19.596664, 41.810555],
            [19.593887, 41.813049],
            [19.524757, 41.835243],
            [19.488888, 41.849442],
            [19.469997, 41.854996],
            [19.449165, 41.859718],
            [19.431664, 41.862221],
            [19.421108, 41.861938],
            [19.411388, 41.86055],
            [19.367771, 41.848999],
            [19.34333, 41.912498],
            [19.346943, 41.955551],
            [19.373333, 42.06694],
            [19.374603, 42.071487],
            [19.378052, 42.078606],
            [19.380981, 42.081001],
            [19.384163, 42.083611],
            [19.398888, 42.101387],
            [19.400276, 42.10527],
            [19.398331, 42.10833],
            [19.386387, 42.11805],
            [19.369999, 42.128883],
            [19.332222, 42.152496],
            [19.300278, 42.171104],
            [19.284443, 42.182777],
            [19.282497, 42.185555],
            [19.286942, 42.192215],
            [19.519722, 42.448608],
            [19.606388, 42.539444],
            [19.608887, 42.542496],
            [19.612499, 42.549995],
            [19.610832, 42.561104],
            [19.608608, 42.568054],
            [19.609444, 42.572495],
            [19.615833, 42.582497],
            [19.633331, 42.603333],
            [19.645832, 42.61805],
            [19.657219, 42.628326],
            [19.708885, 42.658882],
            [19.713055, 42.660553],
            [19.722775, 42.661942],
            [19.726665, 42.659996],
            [19.75333, 42.64222],
            [19.755833, 42.639717],
            [19.773052, 42.597496],
            [19.773609, 42.593605],
            [19.772778, 42.589996],
            [19.770275, 42.586937],
            [19.766109, 42.585548],
            [19.759998, 42.586388],
            [19.752499, 42.583054],
            [19.75, 42.579994],
            [19.746944, 42.546944],
            [19.746666, 42.543053],
            [19.765274, 42.504715],
            [19.773609, 42.497215],
            [19.790276, 42.486107],
            [19.79361, 42.483887],
            [19.801666, 42.48027],
            [19.822498, 42.471939],
            [19.919441, 42.512497],
            [19.935276, 42.518608],
            [20.049164, 42.561661],
            [20.053333, 42.563049],
            [20.057777, 42.563889],
            [20.064163, 42.563049],
            [20.071423, 42.560913],
            [20.0975, 42.536942],
            [20.106667, 42.529999],
            [20.158054, 42.513329],
            [20.161942, 42.511665],
            [20.16861, 42.506943],
            [20.220833, 42.433327],
            [20.224163, 42.423332],
            [20.241943, 42.368889],
            [20.241108, 42.364166],
            [20.237778, 42.356667],
            [20.237499, 42.352493],
            [20.24361, 42.33194],
            [20.24472, 42.328606],
            [20.25222, 42.32444],
            [20.2575, 42.323326],
            [20.355675, 42.311844],
            [20.386944, 42.304161],
            [20.450832, 42.278328],
            [20.458054, 42.274437],
            [20.470432, 42.264557],
            [20.508888, 42.23027],
            [20.524166, 42.214439],
            [20.526108, 42.211662],
            [20.595276, 42.04361],
            [20.623333, 41.966942],
            [20.623886, 41.963333],
            [20.621944, 41.954163],
            [20.617775, 41.941666],
            [20.611385, 41.937492],
            [20.595276, 41.931938],
            [20.588608, 41.927498],
            [20.583054, 41.922218],
            [20.581108, 41.918884],
            [20.58083, 41.906662],
            [20.589642, 41.882187],
            [20.568951, 41.874542],
            [20.533607, 41.776939],
            [20.519997, 41.75222],
            [20.516941, 41.743889],
            [20.514164, 41.727776],
            [20.533886, 41.63472],
            [20.46611, 41.55555],
            [20.458054, 41.526382],
            [20.457775, 41.522217],
            [20.458885, 41.518883],
            [20.460552, 41.515831],
            [20.469719, 41.500832],
            [20.471664, 41.497772],
            [20.50861, 41.459717],
            [20.561386, 41.411385],
            [20.562496, 41.408051],
            [20.562222, 41.403885],
            [20.549999, 41.373055],
            [20.524166, 41.350273],
            [20.50222, 41.348053],
            [20.497498, 41.347221],
            [20.496109, 41.34333],
            [20.492775, 41.331108],
            [20.495552, 41.320549],
            [20.502499, 41.304443],
            [20.519165, 41.246384],
            [20.578331, 41.162773],
            [20.600613, 41.093185],
            [20.654999, 41.090271],
            [20.669998, 41.088051],
            [20.733887, 40.911942],
            [20.735119, 40.911057],
            [20.743332, 40.907776],
            [20.75333, 40.905273],
            [20.759163, 40.904442],
            [20.802498, 40.899994],
            [20.811943, 40.901108],
            [20.82111, 40.908882],
            [20.830276, 40.92083],
            [20.840832, 40.932495],
            [20.848331, 40.935555],
            [20.944164, 40.919167],
            [20.957222, 40.914162],
            [20.968887, 40.908607],
            [20.971943, 40.906387],
            [20.982445, 40.895248],
            [20.983887, 40.893608],
            [20.984165, 40.891663],
            [20.98349, 40.855888],
            [20.983887, 40.793053],
            [21.020832, 40.715553],
            [21.028889, 40.708054],
            [21.036587, 40.698563],
            [21.046665, 40.685829],
            [21.051941, 40.676666],
            [21.053055, 40.673332],
            [21.054165, 40.661942],
            [21.053608, 40.622772],
            [21.053055, 40.618607],
            [21.042774, 40.566109],
            [21.041386, 40.561943],
            [20.951942, 40.471382],
            [20.948887, 40.468887],
            [20.945553, 40.466942],
            [20.936943, 40.464439],
            [20.91861, 40.461662],
            [20.914165, 40.463051],
            [20.910831, 40.465271],
            [20.833332, 40.462219],
            [20.791924, 40.431541],
            [20.78722, 40.394722],
            [20.75861, 40.311943],
            [20.740276, 40.309166],
            [20.73333, 40.305275],
            [20.714996, 40.281662],
            [20.713055, 40.278328],
            [20.711941, 40.273888],
            [20.710831, 40.264999],
            [20.714722, 40.255272],
            [20.720833, 40.246666],
            [20.721386, 40.227219],
            [20.721107, 40.223053],
            [20.673885, 40.101387],
            [20.671944, 40.098053],
            [20.665276, 40.094162],
            [20.657219, 40.091385],
            [20.621387, 40.085274],
            [20.604721, 40.075272],
            [20.583332, 40.070549],
            [20.555832, 40.066383],
            [20.48222, 40.064995],
            [20.476944, 40.066109],
            [20.461571, 40.074165],
            [20.449997, 40.072495],
            [20.43861, 40.068054],
            [20.421944, 40.058052],
            [20.316109, 39.993332],
            [20.31472, 39.990273],
            [20.336388, 39.924721],
            [20.338055, 39.921661],
            [20.36972, 39.891388],
            [20.408886, 39.849159],
            [20.41222, 39.84333],
            [20.415276, 39.836937],
            [20.414444, 39.82444],
            [20.41222, 39.815826],
            [20.407219, 39.804443],
            [20.401943, 39.799164],
            [20.385277, 39.788605],
            [20.381386, 39.787216],
            [20.37611, 39.787498],
            [20.371666, 39.788887],
            [20.306129, 39.812119],
            [20.302219, 39.811661],
            [20.29472, 39.808609],
            [20.291386, 39.806664],
            [20.289444, 39.803055],
            [20.298054, 39.771942],
            [20.318054, 39.739998],
            [20.320831, 39.733604],
            [20.319443, 39.729439],
            [20.317497, 39.726105],
            [20.31472, 39.72361],
            [20.221664, 39.648331],
            [20.21833, 39.646385],
            [20.199165, 39.644722],
            [20.193333, 39.645271],
            [20.166664, 39.650276],
            [20.141388, 39.656105],
            [20.105, 39.669441],
            [20.09861, 39.673882],
            [20.093887, 39.679161],
            [20.090553, 39.681389],
            [20.031944, 39.69722],
            [20.021111, 39.697495],
            [20.013332, 39.694717],
            [20.010029, 39.6912],
            [19.994999, 39.686661],
            [19.990555, 39.685829],
            [19.987499, 39.688049],
            [19.982498, 39.696388],
            [19.981941, 39.700272],
            [19.983608, 39.765274],
            [19.987778, 39.867218],
            [19.937496, 39.937492],
            [19.865555, 40.036942],
            [19.863052, 40.039719],
            [19.850277, 40.048607],
            [19.84111, 40.051384],
            [19.825554, 40.054718],
            [19.764999, 40.071938],
            [19.756664, 40.079437],
            [19.749165, 40.090271],
            [19.730553, 40.10305],
            [19.616665, 40.149162],
            [19.510555, 40.193604],
            [19.495552, 40.201385],
            [19.463333, 40.21833],
            [19.452774, 40.224716],
            [19.444721, 40.231941],
            [19.401108, 40.279999],
            [19.288609, 40.417496],
            [19.28833, 40.421104],
            [19.291111, 40.423607],
            [19.318886, 40.438889],
            [19.339443, 40.43222],
            [19.344166, 40.43055],
            [19.386665, 40.393051],
            [19.396664, 40.382774],
            [19.400555, 40.376663],
            [19.405277, 40.363327],
            [19.406109, 40.355827],
            [19.407497, 40.344444],
            [19.415554, 40.32972],
            [19.418888, 40.326942],
            [19.424164, 40.326111],
            [19.433609, 40.325829],
            [19.437878, 40.326431],
            [19.447498, 40.328049],
            [19.457115, 40.332672],
            [19.470833, 40.341942],
            [19.478611, 40.350273],
            [19.480274, 40.359444],
            [19.487499, 40.436661],
            [19.487778, 40.440826],
            [19.45583, 40.561104],
            [19.451385, 40.566666],
            [19.420277, 40.57666],
            [19.414997, 40.577774],
            [19.395832, 40.581108],
            [19.390831, 40.580826],
            [19.337776, 40.618607],
            [19.307209, 40.645309],
            [19.349442, 40.688049],
            [19.35722, 40.696663],
            [19.358887, 40.699997],
            [19.404999, 40.819717],
            [19.41333, 40.866386],
            [19.452419, 40.883842],
            [19.463608, 40.882217],
            [19.46833, 40.88166],
            [19.471664, 40.882774],
            [19.478886, 40.886108],
            [19.521385, 40.908051],
            [19.521942, 40.911659],
            [19.524166, 40.929161],
            [19.523331, 40.936661],
            [19.522778, 40.940277],
            [19.51083, 40.969994],
            [19.506386, 40.975555],
            [19.461109, 41.006943],
            [19.436214, 41.021065],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "AM",
        ISO2: "AM",
        ISO3: "ARM",
        UN: 51,
        NAME: "Armenia",
        AREA: 2820,
        POP2005: 3017661,
        REGION: 142,
        SUBREGION: 145,
        LON: 44.563,
        LAT: 40.534,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [45.573051000000135, 40.632488],
              [45.528881, 40.606098],
              [45.51305, 40.60722],
              [45.499161000000129, 40.61694],
              [45.49194, 40.63694],
              [45.501389000000131, 40.658039000000144],
              [45.51749, 40.665539],
              [45.55534, 40.665371],
              [45.572491, 40.663052000000107],
              [45.58749, 40.653881],
              [45.588329, 40.64833],
              [45.573051000000135, 40.632488],
            ],
          ],
          [
            [
              [45.15387, 41.198601],
              [45.19305, 41.17305],
              [45.211372, 41.159714],
              [45.218323, 41.151649000000134],
              [45.22275500000012, 41.14193],
              [45.22275500000012, 41.13582],
              [45.220543, 41.13055],
              [45.216385, 41.126938000000109],
              [45.20665, 41.120827],
              [45.201096, 41.118317],
              [45.1947100000001, 41.116936],
              [45.179993, 41.114998],
              [45.171928, 41.114998],
              [45.13637, 41.117203],
              [45.128319, 41.118599],
              [45.11055, 41.119713],
              [45.087769, 41.11776],
              [45.081383, 41.1161],
              [45.076653, 41.113045000000113],
              [45.074158, 41.107773],
              [45.07332, 41.101105],
              [45.077766000000111, 41.085258000000124],
              [45.082207, 41.075554000000125],
              [45.09137, 41.06276],
              [45.101379, 41.056656],
              [45.33694, 41.001656],
              [45.34499, 41.000542],
              [45.3536, 41.000000000000114],
              [45.368317, 41.001656],
              [45.614159, 40.87554],
              [45.61805, 40.871933000000126],
              [45.622208000000114, 40.862206],
              [45.623322, 40.856659],
              [45.620827, 40.84388],
              [45.615273, 40.828049],
              [45.606377000000123, 40.806374],
              [45.603882000000112, 40.80138],
              [45.594147, 40.78777],
              [45.57972, 40.7786],
              [45.574158, 40.776375],
              [45.523315, 40.763054],
              [45.455544, 40.74221],
              [45.443604, 40.738319],
              [45.42915, 40.729149],
              [45.42193, 40.722214000000122],
              [45.418877000000123, 40.71777],
              [45.391373000000101, 40.675819],
              [45.388329000000113, 40.6711],
              [45.386658, 40.66527],
              [45.386932, 40.659157000000107],
              [45.389153, 40.64833],
              [45.391106, 40.643326000000116],
              [45.413605, 40.60804000000013],
              [45.53249, 40.46054],
              [45.540276000000119, 40.453316],
              [45.638039, 40.39111],
              [45.66277, 40.375824000000136],
              [45.875824, 40.26971],
              [45.888596000000121, 40.265266],
              [45.906151, 40.263451000000146],
              [45.92054000000013, 40.265549],
              [45.951653000000135, 40.27387],
              [45.958321, 40.27222],
              [45.962494, 40.26859],
              [45.993874000000119, 40.23916],
              [45.999718000000144, 40.23053700000014],
              [46.00194, 40.225548],
              [46.00277, 40.220261000000107],
              [46.00194, 40.213608],
              [45.979424, 40.122208000000114],
              [45.97693, 40.116936],
              [45.973877, 40.112488],
              [45.9161, 40.03333],
              [45.909424, 40.024437],
              [45.90554, 40.020546000000138],
              [45.900826, 40.017487],
              [45.888039, 40.014435],
              [45.87305, 40.01361],
              [45.847771000000137, 40.01611],
              [45.82443, 40.019981000000143],
              [45.763611, 40.024437],
              [45.713608, 40.026093000000117],
              [45.681931000000134, 40.025826],
              [45.638039, 40.021660000000111],
              [45.613602, 40.014435],
              [45.603882000000112, 40.007767000000115],
              [45.599991, 40.004166],
              [45.5936, 39.99499],
              [45.59277, 39.982491],
              [45.595818, 39.978043],
              [45.60555, 39.971924],
              [45.611382, 39.96944],
              [45.618317, 39.967766],
              [45.705269, 39.961372],
              [45.729706000000135, 39.958321],
              [45.751099, 39.95332],
              [45.77444, 39.943604],
              [45.784157, 39.937485],
              [45.793877000000123, 39.92526],
              [45.799988, 39.910538],
              [45.80222, 39.89971],
              [45.807213, 39.884438000000102],
              [45.816376, 39.86554],
              [45.819153000000142, 39.861382],
              [45.829163, 39.849152000000117],
              [45.844704, 39.83443],
              [45.85666, 39.823601],
              [45.876099000000124, 39.81137],
              [45.88666, 39.805817],
              [45.908875, 39.795273000000122],
              [45.92638, 39.788048],
              [45.960274, 39.7786],
              [45.983871, 39.777489],
              [45.999161, 39.774994],
              [46.006104, 39.773041],
              [46.01082, 39.76998],
              [46.018593, 39.762772],
              [46.03054, 39.745537],
              [46.04332, 39.723038],
              [46.05304, 39.704712],
              [46.056099, 39.70054],
              [46.067772, 39.689423],
              [46.18971, 39.607216],
              [46.204163000000108, 39.598038],
              [46.2111, 39.5961],
              [46.227211, 39.594147000000135],
              [46.24305, 39.594147000000135],
              [46.25027, 39.594994],
              [46.256386, 39.596657],
              [46.300819000000104, 39.614441],
              [46.30555, 39.617493],
              [46.311104, 39.619713],
              [46.32304, 39.623604],
              [46.335815, 39.626656],
              [46.349991, 39.62804],
              [46.364441, 39.62498],
              [46.519981, 39.581940000000145],
              [46.53054, 39.576096],
              [46.53443, 39.572495000000117],
              [46.541382000000112, 39.564438000000109],
              [46.546944, 39.549988],
              [46.548050000000103, 39.544434],
              [46.54639, 39.538605],
              [46.519981, 39.480263],
              [46.516663, 39.475815],
              [46.511932, 39.472755],
              [46.500832, 39.468323000000112],
              [46.494431, 39.466927],
              [46.44860100000011, 39.457764],
              [46.40776, 39.45165],
              [46.400826000000109, 39.450829],
              [46.395264, 39.448601],
              [46.385818, 39.442757],
              [46.382484, 39.438324],
              [46.38055, 39.42499],
              [46.381653, 39.413605000000132],
              [46.386658, 39.398331],
              [46.392487, 39.389709],
              [46.40387, 39.378593],
              [46.557487, 39.26915],
              [46.58138300000013, 39.253609],
              [46.620537, 39.229424000000108],
              [46.62249, 39.224709],
              [46.620827, 39.219986],
              [46.616096, 39.217209],
              [46.54554, 39.189423],
              [46.537766, 39.189423],
              [46.496094, 39.20361],
              [46.46666, 39.215546],
              [46.459984, 39.217484],
              [46.452209, 39.21859],
              [46.444427, 39.21859],
              [46.431107, 39.216385],
              [46.425545, 39.214149000000134],
              [46.421928, 39.211655],
              [46.418602, 39.206650000000138],
              [46.4161, 39.201378],
              [46.415268, 39.188881],
              [46.417206, 39.177773],
              [46.421097, 39.16805],
              [46.42388, 39.163872],
              [46.435547, 39.152771],
              [46.458321, 39.14277],
              [46.47749, 39.136658],
              [46.48888, 39.131653],
              [46.493607000000111, 39.128593000000137],
              [46.49749, 39.124985],
              [46.500275000000101, 39.120537],
              [46.515831, 39.081657000000121],
              [46.51971, 39.065819],
              [46.523598, 39.044159],
              [46.520264, 39.032204],
              [46.511932, 39.017487],
              [46.505547, 39.008041],
              [46.498871000000122, 38.99165],
              [46.494431, 38.96583],
              [46.494713, 38.959717000000126],
              [46.495537000000127, 38.95443],
              [46.49749, 38.949425000000133],
              [46.540375, 38.875587],
              [46.51639, 38.878036000000122],
              [46.451935000000105, 38.88999200000012],
              [46.376381, 38.906937],
              [46.354706, 38.91054],
              [46.347481, 38.90942],
              [46.294716, 38.895821000000126],
              [46.273598, 38.885262],
              [46.26361, 38.879433],
              [46.25027, 38.869431],
              [46.239716000000101, 38.86416],
              [46.195534, 38.844147000000135],
              [46.178246000000115, 38.84115],
              [46.123604, 38.909981],
              [46.107216, 38.936104],
              [45.970261, 39.166382],
              [45.967209, 39.182770000000119],
              [45.966927, 39.188881],
              [45.971924000000115, 39.206650000000138],
              [45.982201, 39.21944],
              [45.989983, 39.22664600000013],
              [46.003609, 39.236382000000106],
              [46.009995000000117, 39.24527],
              [46.00888, 39.250832],
              [46.0, 39.263611],
              [45.992210000000114, 39.270821000000126],
              [45.978043000000127, 39.279984000000127],
              [45.8555530000001, 39.348038],
              [45.826653, 39.43748],
              [45.829163, 39.442757],
              [45.829987, 39.449425],
              [45.829987, 39.455544],
              [45.823044, 39.545273],
              [45.81998, 39.54972],
              [45.811371, 39.556374000000119],
              [45.800545000000113, 39.561928],
              [45.783333, 39.569153000000142],
              [45.755272, 39.576653],
              [45.740822, 39.57972],
              [45.732201000000146, 39.580544000000145],
              [45.725266, 39.57972],
              [45.626656, 39.55999],
              [45.60777, 39.554703],
              [45.590546000000131, 39.54861],
              [45.558327, 39.533875000000137],
              [45.528328000000101, 39.517212],
              [45.507767, 39.506653],
              [45.49694, 39.502213],
              [45.47248100000013, 39.494431],
              [45.457497, 39.493607000000111],
              [45.330826000000116, 39.535271],
              [45.326096, 39.538322],
              [45.319984, 39.546944],
              [45.266388, 39.611107000000118],
              [45.083321, 39.768044000000145],
              [45.07360100000011, 39.774155],
              [45.061928, 39.77887],
              [45.05415, 39.779984],
              [45.039986, 39.77833],
              [45.028046000000131, 39.774437],
              [45.014153, 39.765266],
              [45.0, 39.753006],
              [44.99749, 39.750832000000116],
              [44.969147, 39.732491],
              [44.951935, 39.726372],
              [44.933044, 39.72137],
              [44.92054000000013, 39.718323],
              [44.896378, 39.7211],
              [44.882767000000115, 39.724709000000132],
              [44.85833, 39.724991],
              [44.799164, 39.712769],
              [44.789398000000119, 39.709698],
              [44.778862, 39.70638300000013],
              [44.746101, 39.73055],
              [44.64889, 39.799721],
              [44.63388, 39.807770000000119],
              [44.594162, 39.830544],
              [44.590828, 39.833054000000118],
              [44.560265, 39.879433],
              [44.55471, 39.888611],
              [44.551941, 39.895264],
              [44.552216, 39.898888],
              [44.54832, 39.91221],
              [44.487778, 39.962769],
              [44.399155, 40.00361],
              [44.356110000000115, 40.020554000000118],
              [44.347214, 40.023888000000113],
              [44.285271000000137, 40.046097],
              [44.279999, 40.046097],
              [44.052208, 40.013054],
              [44.040543000000127, 40.008606],
              [44.032219000000111, 40.006653000000142],
              [43.971375, 40.01082],
              [43.933884, 40.01361],
              [43.91249, 40.0186],
              [43.673607000000118, 40.100822],
              [43.668877000000123, 40.102486],
              [43.657494, 40.108597000000145],
              [43.648888, 40.119713000000104],
              [43.647774, 40.122765],
              [43.648331, 40.126381],
              [43.650269, 40.13055],
              [43.65778, 40.139709],
              [43.663849, 40.14446],
              [43.670547, 40.148041],
              [43.68193, 40.152489],
              [43.707764000000111, 40.15222],
              [43.711937, 40.15333],
              [43.719719, 40.15638],
              [43.72166, 40.159714],
              [43.72166, 40.163322],
              [43.72054, 40.166939000000127],
              [43.661652, 40.27444],
              [43.606934, 40.368889],
              [43.583054, 40.451111],
              [43.59277, 40.501099],
              [43.653046000000131, 40.531380000000127],
              [43.71666, 40.619156],
              [43.719208, 40.622681],
              [43.741379, 40.666656],
              [43.751938, 40.739998],
              [43.748878, 40.75],
              [43.74249, 40.770264000000111],
              [43.673325, 40.92499],
              [43.671654, 40.92805],
              [43.60638, 40.988319],
              [43.59943, 40.992493],
              [43.590546, 40.99583],
              [43.584435, 40.996666000000118],
              [43.581135, 40.996418],
              [43.569443, 40.995544],
              [43.559166000000118, 40.996666000000118],
              [43.554153, 40.99805],
              [43.493599, 41.01693],
              [43.48527, 41.020554],
              [43.47916, 41.025269],
              [43.477486, 41.028328000000101],
              [43.453888, 41.090271000000143],
              [43.453888, 41.097214000000122],
              [43.454987, 41.10194],
              [43.46077, 41.112961],
              [43.546387, 41.134995000000117],
              [43.561661000000129, 41.136375],
              [43.578606, 41.13472],
              [43.599709, 41.129715],
              [43.637497, 41.123047],
              [43.734428, 41.113602],
              [43.752213, 41.112488],
              [43.760277, 41.11276],
              [43.7822, 41.115822],
              [43.79499, 41.11916],
              [43.806099000000131, 41.123871],
              [43.828331, 41.14111],
              [43.83694, 41.148041],
              [43.84083, 41.151932000000102],
              [43.850548000000117, 41.158043],
              [43.86249, 41.162209],
              [43.88444, 41.165268],
              [43.900536, 41.165543],
              [43.99276, 41.16414600000013],
              [44.122765000000129, 41.181931000000134],
              [44.14471, 41.18499],
              [44.15749, 41.188324],
              [44.174431, 41.19553],
              [44.178322, 41.19916],
              [44.18055, 41.20443],
              [44.248871, 41.223595],
              [44.340546, 41.212494000000106],
              [44.429993, 41.19221],
              [44.484154, 41.187759],
              [44.562202000000127, 41.185265000000129],
              [44.570267, 41.185265000000129],
              [44.7286, 41.212212],
              [44.82471, 41.212494000000106],
              [44.848877, 41.213051],
              [44.863602000000128, 41.21471],
              [44.875824000000136, 41.21859],
              [44.9786, 41.270264],
              [45.022942, 41.297050000000127],
              [45.046944, 41.223312],
              [45.131927, 41.20361],
              [45.140831, 41.202766],
              [45.147774, 41.201096000000121],
              [45.15387, 41.198601],
            ],
            [
              [45.00999, 41.033051],
              [45.02583, 41.030548],
              [45.04527, 41.035271],
              [45.054161000000136, 41.042221],
              [45.05888, 41.052769000000126],
              [45.051659, 41.066669],
              [45.03027, 41.084991],
              [45.017490000000123, 41.089161000000104],
              [45.00111, 41.088879],
              [44.984161, 41.08194],
              [44.980549, 41.064709],
              [44.987770000000125, 41.050541],
              [45.00999, 41.033051],
            ],
            [
              [45.19582, 40.997768],
              [45.194988, 40.9911],
              [45.206379, 40.97943],
              [45.22916, 40.969151000000124],
              [45.245270000000119, 40.976940000000127],
              [45.245270000000119, 40.98305],
              [45.236938000000123, 40.990269],
              [45.212608, 41.004162],
              [45.204708, 41.00471],
              [45.19582, 40.997768],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "BK",
        ISO2: "BA",
        ISO3: "BIH",
        UN: 70,
        NAME: "Bosnia and Herzegovina",
        AREA: 5120,
        POP2005: 3915238,
        REGION: 150,
        SUBREGION: 39,
        LON: 17.786,
        LAT: 44.169,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [17.649841, 42.889076],
            [17.578526, 42.943825],
            [17.668331, 42.960548],
            [17.676666, 42.963333],
            [17.683609, 42.967216],
            [17.688015, 42.974609],
            [17.680832, 42.992775],
            [17.670555, 43.016663],
            [17.664719, 43.02916],
            [17.659164, 43.039444],
            [17.649719, 43.054993],
            [17.643055, 43.063889],
            [17.630276, 43.076942],
            [17.589443, 43.102219],
            [17.571388, 43.112221],
            [17.559166, 43.117775],
            [17.434719, 43.179443],
            [17.309444, 43.270554],
            [17.298054, 43.28083],
            [17.289719, 43.296944],
            [17.285553, 43.30722],
            [17.279163, 43.325272],
            [17.277222, 43.332771],
            [17.256107, 43.414444],
            [17.257221, 43.422775],
            [17.261944, 43.428604],
            [17.270275, 43.436386],
            [17.271942, 43.444443],
            [17.271111, 43.448608],
            [17.269444, 43.451942],
            [17.261665, 43.459717],
            [17.247776, 43.46833],
            [17.223331, 43.47805],
            [17.160275, 43.497772],
            [17.114998, 43.506943],
            [17.098331, 43.513611],
            [17.071388, 43.526382],
            [17.059719, 43.531944],
            [17.046387, 43.54055],
            [16.976387, 43.586105],
            [16.95583, 43.603333],
            [16.937496, 43.621666],
            [16.82972, 43.725555],
            [16.711941, 43.826385],
            [16.707222, 43.84111],
            [16.701385, 43.850555],
            [16.696663, 43.85611],
            [16.650276, 43.908051],
            [16.642498, 43.916382],
            [16.53722, 44.013611],
            [16.52972, 44.017776],
            [16.516109, 44.021942],
            [16.504719, 44.023048],
            [16.463608, 44.026665],
            [16.438889, 44.031944],
            [16.426666, 44.036942],
            [16.415554, 44.043327],
            [16.354721, 44.081665],
            [16.338886, 44.09333],
            [16.32972, 44.104164],
            [16.323055, 44.11805],
            [16.322498, 44.122215],
            [16.316944, 44.135826],
            [16.309444, 44.148605],
            [16.302219, 44.157219],
            [16.280277, 44.176941],
            [16.264999, 44.189438],
            [16.249294, 44.196732],
            [16.238052, 44.198326],
            [16.214443, 44.197495],
            [16.199165, 44.195274],
            [16.172222, 44.192215],
            [16.16, 44.192772],
            [16.149998, 44.194443],
            [16.145554, 44.196663],
            [16.143055, 44.19944],
            [16.14333, 44.204163],
            [16.191944, 44.313889],
            [16.198055, 44.353607],
            [16.133331, 44.486107],
            [16.126389, 44.498604],
            [16.119164, 44.506943],
            [16.111664, 44.511383],
            [16.074165, 44.530548],
            [16.033333, 44.574165],
            [16.010555, 44.616943],
            [15.961666, 44.693886],
            [15.956944, 44.699997],
            [15.943888, 44.708611],
            [15.939444, 44.710548],
            [15.92861, 44.712219],
            [15.874998, 44.710274],
            [15.864166, 44.711388],
            [15.858889, 44.712494],
            [15.854721, 44.714439],
            [15.7675, 44.776108],
            [15.759998, 44.783882],
            [15.742222, 44.803604],
            [15.736944, 44.812492],
            [15.736387, 44.81694],
            [15.738888, 44.824165],
            [15.74361, 44.829994],
            [15.769165, 44.922775],
            [15.764999, 45.056389],
            [15.764721, 45.073608],
            [15.765554, 45.082222],
            [15.781111, 45.161942],
            [15.786665, 45.171944],
            [15.794167, 45.179993],
            [15.8025, 45.188049],
            [15.81111, 45.195549],
            [15.823332, 45.205276],
            [15.834166, 45.211937],
            [15.8825, 45.222496],
            [15.924999, 45.22805],
            [15.936666, 45.228607],
            [16.015274, 45.21833],
            [16.023052, 45.214996],
            [16.03611, 45.205826],
            [16.109444, 45.130829],
            [16.116108, 45.121666],
            [16.19722, 45.044441],
            [16.209721, 45.034439],
            [16.220276, 45.028328],
            [16.248055, 45.014999],
            [16.263885, 45.008331],
            [16.291759, 44.999115],
            [16.342712, 45.0009],
            [16.351208, 45.003586],
            [16.357018, 45.008499],
            [16.359699, 45.016548],
            [16.366402, 45.042023],
            [16.417805, 45.12426],
            [16.476387, 45.185829],
            [16.502277, 45.209633],
            [16.508537, 45.214546],
            [16.526386, 45.224442],
            [16.530437, 45.226173],
            [16.541164, 45.227066],
            [16.589882, 45.230194],
            [16.601952, 45.230194],
            [16.629662, 45.22081],
            [16.662777, 45.210274],
            [16.682777, 45.204994],
            [16.812496, 45.187492],
            [16.824444, 45.187492],
            [16.83839, 45.190414],
            [16.845989, 45.194435],
            [16.846882, 45.198456],
            [16.846436, 45.202034],
            [16.913925, 45.265945],
            [17.036388, 45.227219],
            [17.040276, 45.212494],
            [17.04361, 45.206108],
            [17.049999, 45.201385],
            [17.07111, 45.188332],
            [17.177219, 45.148605],
            [17.188332, 45.148048],
            [17.230553, 45.14666],
            [17.240555, 45.148605],
            [17.246666, 45.153053],
            [17.282497, 45.176384],
            [17.48111, 45.131104],
            [17.484444, 45.11805],
            [17.483887, 45.111107],
            [17.494164, 45.109993],
            [17.519554, 45.109512],
            [17.596386, 45.108887],
            [17.689999, 45.122772],
            [17.758053, 45.086662],
            [17.832775, 45.05555],
            [17.851944, 45.049438],
            [17.863888, 45.048332],
            [17.873608, 45.050278],
            [17.912498, 45.068054],
            [17.933052, 45.080276],
            [18.070274, 45.104439],
            [18.110832, 45.086105],
            [18.119999, 45.083328],
            [18.130276, 45.082222],
            [18.166943, 45.078606],
            [18.179165, 45.077774],
            [18.197498, 45.081665],
            [18.205555, 45.084999],
            [18.212776, 45.088882],
            [18.218052, 45.095276],
            [18.217499, 45.102219],
            [18.212776, 45.107773],
            [18.210278, 45.114716],
            [18.211388, 45.123329],
            [18.216663, 45.129715],
            [18.233055, 45.135826],
            [18.251942, 45.138885],
            [18.269722, 45.136665],
            [18.419167, 45.108887],
            [18.634163, 45.083328],
            [18.794167, 44.997215],
            [18.79583, 44.989998],
            [18.800831, 44.949715],
            [18.797775, 44.942215],
            [18.789997, 44.938889],
            [18.780552, 44.940277],
            [18.773609, 44.944443],
            [18.763885, 44.945],
            [18.761108, 44.938889],
            [18.768055, 44.915833],
            [18.788055, 44.899719],
            [18.794167, 44.894997],
            [18.834442, 44.86805],
            [18.841389, 44.863609],
            [18.849998, 44.860832],
            [18.861111, 44.858604],
            [18.957222, 44.85305],
            [18.96833, 44.853607],
            [19.02972, 44.860275],
            [19.039719, 44.861382],
            [19.121109, 44.901382],
            [19.168053, 44.921387],
            [19.177219, 44.923607],
            [19.188053, 44.923332],
            [19.299442, 44.910271],
            [19.310276, 44.908607],
            [19.371387, 44.88916],
            [19.381622, 44.866577],
            [19.382774, 44.863052],
            [19.345833, 44.769165],
            [19.344612, 44.766304],
            [19.336109, 44.747215],
            [19.31361, 44.70472],
            [19.193981, 44.560158],
            [19.135883, 44.524864],
            [19.128136, 44.521423],
            [19.123402, 44.514542],
            [19.105553, 44.376663],
            [19.104443, 44.355827],
            [19.127705, 44.316574],
            [19.130276, 44.313889],
            [19.158054, 44.28833],
            [19.161705, 44.286011],
            [19.165833, 44.284439],
            [19.234867, 44.265358],
            [19.239998, 44.264999],
            [19.357952, 44.209412],
            [19.485832, 44.120277],
            [19.596943, 44.060272],
            [19.617031, 44.054909],
            [19.61972, 44.052216],
            [19.620476, 44.048454],
            [19.621765, 44.021767],
            [19.619442, 44.018883],
            [19.616173, 44.016602],
            [19.532249, 43.962379],
            [19.524502, 43.958939],
            [19.514175, 43.958076],
            [19.485275, 43.958885],
            [19.428532, 43.960655],
            [19.374165, 43.965553],
            [19.365833, 43.969162],
            [19.359722, 43.974159],
            [19.355274, 43.979721],
            [19.351498, 43.981743],
            [19.311108, 43.996941],
            [19.30674, 43.998528],
            [19.244335, 44.01445],
            [19.239441, 44.01416],
            [19.237019, 44.011009],
            [19.237019, 44.002831],
            [19.251221, 43.962379],
            [19.366943, 43.859444],
            [19.437496, 43.800278],
            [19.475277, 43.772774],
            [19.487499, 43.763329],
            [19.492775, 43.753609],
            [19.498333, 43.740273],
            [19.500832, 43.733887],
            [19.505554, 43.718887],
            [19.50972, 43.700272],
            [19.510277, 43.69194],
            [19.51083, 43.679718],
            [19.493889, 43.588051],
            [19.480553, 43.571388],
            [19.408607, 43.584442],
            [19.287498, 43.544167],
            [19.228809, 43.513214],
            [19.223888, 43.516388],
            [19.211666, 43.52166],
            [19.011665, 43.556107],
            [19.006664, 43.555832],
            [18.951664, 43.512497],
            [18.949444, 43.509438],
            [18.948608, 43.505272],
            [18.949718, 43.496941],
            [18.95583, 43.458328],
            [18.956665, 43.454437],
            [18.960278, 43.452499],
            [18.976944, 43.453049],
            [18.988609, 43.452499],
            [18.998608, 43.449997],
            [19.011387, 43.444717],
            [19.023052, 43.435555],
            [19.027496, 43.429161],
            [19.093609, 43.308884],
            [19.09222, 43.301666],
            [19.078888, 43.262497],
            [19.07222, 43.248055],
            [19.068607, 43.241386],
            [19.06583, 43.238884],
            [19.054996, 43.232498],
            [19.048866, 43.231026],
            [19.016666, 43.239441],
            [18.956921, 43.290833],
            [18.954441, 43.29361],
            [18.951942, 43.300278],
            [18.954166, 43.308884],
            [18.960545, 43.318924],
            [18.960293, 43.326683],
            [18.957497, 43.329163],
            [18.91972, 43.357216],
            [18.914238, 43.358315],
            [18.908607, 43.35833],
            [18.888332, 43.356384],
            [18.873325, 43.354691],
            [18.83934, 43.348022],
            [18.706665, 43.260277],
            [18.699997, 43.255554],
            [18.697777, 43.252495],
            [18.645832, 43.147217],
            [18.643887, 43.13916],
            [18.644997, 43.13166],
            [18.650555, 43.122215],
            [18.65361, 43.115273],
            [18.657776, 43.09166],
            [18.659164, 43.080276],
            [18.657776, 43.071938],
            [18.651665, 43.047493],
            [18.649998, 43.044167],
            [18.647221, 43.041382],
            [18.640831, 43.037216],
            [18.631664, 43.034439],
            [18.57972, 43.02916],
            [18.552219, 43.022774],
            [18.535553, 43.01722],
            [18.524441, 43.012215],
            [18.508888, 43.000549],
            [18.497219, 42.990273],
            [18.483887, 42.971939],
            [18.480553, 42.964439],
            [18.478611, 42.956383],
            [18.454441, 42.833328],
            [18.455555, 42.825554],
            [18.457222, 42.82222],
            [18.490833, 42.766388],
            [18.515831, 42.73111],
            [18.518608, 42.728607],
            [18.526386, 42.724442],
            [18.535553, 42.722221],
            [18.546665, 42.720833],
            [18.551388, 42.719162],
            [18.558052, 42.715271],
            [18.560276, 42.712219],
            [18.561665, 42.70916],
            [18.576385, 42.663055],
            [18.577499, 42.654999],
            [18.574444, 42.643326],
            [18.570553, 42.635826],
            [18.56583, 42.630554],
            [18.549999, 42.619438],
            [18.536663, 42.610832],
            [18.463886, 42.569443],
            [18.455555, 42.565826],
            [18.411942, 42.606384],
            [18.397499, 42.614441],
            [18.362499, 42.626663],
            [18.346664, 42.629166],
            [18.335278, 42.628883],
            [18.311665, 42.619438],
            [18.302498, 42.616943],
            [18.288055, 42.614441],
            [18.276943, 42.615555],
            [18.268608, 42.618332],
            [18.264999, 42.620277],
            [18.231941, 42.64222],
            [18.221943, 42.648888],
            [18.160553, 42.695],
            [17.998886, 42.761383],
            [17.98222, 42.768051],
            [17.959999, 42.77916],
            [17.882774, 42.81916],
            [17.876663, 42.823608],
            [17.8475, 42.856667],
            [17.845276, 42.859718],
            [17.84111, 42.870277],
            [17.797497, 42.903885],
            [17.744442, 42.920273],
            [17.714996, 42.926941],
            [17.698055, 42.927216],
            [17.687775, 42.921661],
            [17.684444, 42.918884],
            [17.649841, 42.889076],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "BU",
        ISO2: "BG",
        ISO3: "BGR",
        UN: 100,
        NAME: "Bulgaria",
        AREA: 11063,
        POP2005: 7744591,
        REGION: 150,
        SUBREGION: 151,
        LON: 25.231,
        LAT: 42.761,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [27.879166, 42.841103],
            [27.894997, 42.802498],
            [27.898605, 42.785271],
            [27.899441, 42.774155],
            [27.898331, 42.707222],
            [27.896938, 42.702766],
            [27.893055, 42.701111],
            [27.888054, 42.701111],
            [27.80555, 42.708054],
            [27.777493, 42.713051],
            [27.766388, 42.714165],
            [27.736938, 42.712494],
            [27.728886, 42.709717],
            [27.6325, 42.631653],
            [27.514996, 42.556389],
            [27.506386, 42.54805],
            [27.495831, 42.535828],
            [27.450554, 42.48082],
            [27.448605, 42.476944],
            [27.44833, 42.469994],
            [27.450829, 42.464165],
            [27.464993, 42.449432],
            [27.50555, 42.431107],
            [27.51083, 42.431107],
            [27.514164, 42.433327],
            [27.530273, 42.445],
            [27.553883, 42.448875],
            [27.616665, 42.44722],
            [27.679165, 42.41832],
            [27.704163, 42.399994],
            [27.700272, 42.398331],
            [27.698051, 42.394997],
            [27.698887, 42.387772],
            [27.703888, 42.368889],
            [27.750832, 42.262497],
            [27.759995, 42.246101],
            [27.780552, 42.227219],
            [27.85722, 42.164162],
            [27.899162, 42.133606],
            [27.938889, 42.103043],
            [27.968609, 42.072495],
            [27.996941, 42.0411],
            [28.004166, 42.033051],
            [28.022221, 41.998055],
            [28.021381, 41.990273],
            [28.013054, 41.982216],
            [27.971104, 41.984154],
            [27.903606, 41.994713],
            [27.869717, 42.005547],
            [27.864441, 42.005547],
            [27.834721, 42.001938],
            [27.830273, 42.001389],
            [27.70583, 41.977486],
            [27.638054, 41.958321],
            [27.628609, 41.953331],
            [27.595551, 41.935555],
            [27.581661, 41.913048],
            [27.580555, 41.909431],
            [27.576664, 41.907776],
            [27.57222, 41.907219],
            [27.566666, 41.907776],
            [27.556107, 41.910553],
            [27.441109, 41.976944],
            [27.413052, 41.993607],
            [27.41, 41.995827],
            [27.394997, 42.008041],
            [27.391937, 42.010544],
            [27.373055, 42.039986],
            [27.365555, 42.059166],
            [27.364162, 42.062218],
            [27.361664, 42.064995],
            [27.313332, 42.089432],
            [27.304993, 42.093323],
            [27.292217, 42.098885],
            [27.287777, 42.100548],
            [27.282494, 42.102219],
            [27.233051, 42.109993],
            [27.070271, 42.089989],
            [27.043053, 42.085831],
            [27.031384, 42.081383],
            [26.962221, 42.003323],
            [26.935555, 42.006943],
            [26.93055, 42.006943],
            [26.621384, 41.973053],
            [26.572777, 41.939438],
            [26.568083, 41.935966],
            [26.566383, 41.934708],
            [26.560593, 41.928925],
            [26.575294, 41.898643],
            [26.565826, 41.871384],
            [26.558331, 41.851662],
            [26.547218, 41.83416],
            [26.544994, 41.830826],
            [26.542217, 41.828049],
            [26.538052, 41.826935],
            [26.528332, 41.826111],
            [26.477776, 41.824158],
            [26.467773, 41.824158],
            [26.446663, 41.824997],
            [26.391388, 41.823875],
            [26.38166, 41.823044],
            [26.377499, 41.821938],
            [26.374722, 41.819153],
            [26.350277, 41.79332],
            [26.345551, 41.786652],
            [26.339993, 41.774712],
            [26.332771, 41.753052],
            [26.331944, 41.748878],
            [26.332222, 41.741379],
            [26.333611, 41.738319],
            [26.342773, 41.727486],
            [26.350262, 41.719997],
            [26.355827, 41.714432],
            [26.361095, 41.711052],
            [26.309715, 41.707764],
            [26.294167, 41.708054],
            [26.277222, 41.709991],
            [26.264996, 41.715828],
            [26.236961, 41.737267],
            [26.234772, 41.740028],
            [26.222759, 41.7435],
            [26.177498, 41.748055],
            [26.171944, 41.748322],
            [26.163052, 41.746666],
            [26.138611, 41.739159],
            [26.08083, 41.71666],
            [26.074444, 41.711937],
            [26.066109, 41.697495],
            [26.065826, 41.685822],
            [26.068604, 41.660271],
            [26.099159, 41.628876],
            [26.10305, 41.627213],
            [26.117493, 41.628609],
            [26.129719, 41.63221],
            [26.13472, 41.63221],
            [26.137215, 41.629433],
            [26.181664, 41.54332],
            [26.183884, 41.536942],
            [26.198051, 41.439438],
            [26.139996, 41.354713],
            [25.987778, 41.321106],
            [25.97916, 41.319443],
            [25.905552, 41.311104],
            [25.886662, 41.309166],
            [25.881104, 41.309708],
            [25.814159, 41.336098],
            [25.653049, 41.317772],
            [25.567776, 41.32222],
            [25.559441, 41.32],
            [25.549995, 41.313042],
            [25.503609, 41.289444],
            [25.344994, 41.250542],
            [25.335831, 41.249161],
            [25.285, 41.24305],
            [25.279716, 41.24305],
            [25.243889, 41.252769],
            [25.239441, 41.254433],
            [25.190826, 41.301453],
            [25.185833, 41.305275],
            [25.163052, 41.31749],
            [25.061192, 41.362572],
            [25.036507, 41.370438],
            [24.903889, 41.411942],
            [24.898888, 41.411942],
            [24.819443, 41.404999],
            [24.817497, 41.402496],
            [24.812496, 41.378326],
            [24.809444, 41.352219],
            [24.767776, 41.370552],
            [24.612499, 41.430275],
            [24.608887, 41.43222],
            [24.603333, 41.437492],
            [24.567497, 41.489441],
            [24.564442, 41.503326],
            [24.46611, 41.551941],
            [24.307777, 41.546387],
            [24.304722, 41.548607],
            [24.269444, 41.57],
            [24.263885, 41.570549],
            [24.253887, 41.57],
            [24.245552, 41.567772],
            [24.215275, 41.554993],
            [24.199993, 41.543785],
            [24.157219, 41.541107],
            [24.101665, 41.550827],
            [24.0975, 41.551109],
            [24.09333, 41.549995],
            [24.080276, 41.541107],
            [24.064999, 41.524437],
            [24.063053, 41.520828],
            [24.063053, 41.51722],
            [24.066387, 41.485275],
            [23.978886, 41.441109],
            [23.974442, 41.440552],
            [23.886387, 41.451942],
            [23.796387, 41.436661],
            [23.738331, 41.408607],
            [23.63583, 41.378052],
            [23.631107, 41.377495],
            [23.598053, 41.380829],
            [23.551109, 41.391663],
            [23.538887, 41.397217],
            [23.440552, 41.409439],
            [23.29472, 41.406105],
            [23.285275, 41.404716],
            [23.273888, 41.399719],
            [23.231388, 41.377495],
            [23.228333, 41.374992],
            [23.226387, 41.366943],
            [23.230274, 41.353333],
            [23.229443, 41.349716],
            [23.227219, 41.346382],
            [23.214722, 41.336937],
            [23.201111, 41.329163],
            [23.189442, 41.324715],
            [23.180832, 41.322777],
            [23.119999, 41.320831],
            [23.094444, 41.320549],
            [22.975555, 41.335548],
            [22.935604, 41.342125],
            [22.942497, 41.344719],
            [22.955555, 41.35305],
            [22.960831, 41.358604],
            [22.964722, 41.366104],
            [22.966663, 41.374161],
            [22.959164, 41.476387],
            [22.951664, 41.59861],
            [22.951664, 41.626106],
            [22.952499, 41.634438],
            [22.956387, 41.641663],
            [22.986942, 41.665833],
            [23.011387, 41.690826],
            [23.018608, 41.699997],
            [23.02972, 41.71666],
            [23.031387, 41.720551],
            [23.032776, 41.728333],
            [23.029999, 41.734718],
            [23.014721, 41.762215],
            [23.012775, 41.765274],
            [23.00972, 41.767494],
            [22.999722, 41.770271],
            [22.972221, 41.771942],
            [22.967499, 41.773605],
            [22.961941, 41.77861],
            [22.942497, 41.807777],
            [22.899441, 41.879166],
            [22.895832, 41.885277],
            [22.878052, 41.934715],
            [22.875832, 41.941666],
            [22.828609, 42.026939],
            [22.817497, 42.027771],
            [22.685833, 42.065277],
            [22.609444, 42.103333],
            [22.521111, 42.148605],
            [22.517776, 42.150833],
            [22.407776, 42.279442],
            [22.365276, 42.323883],
            [22.410831, 42.335274],
            [22.459442, 42.363052],
            [22.519444, 42.399162],
            [22.522221, 42.402222],
            [22.536388, 42.423332],
            [22.538055, 42.427498],
            [22.558052, 42.479164],
            [22.558887, 42.487495],
            [22.549442, 42.510277],
            [22.544441, 42.515549],
            [22.522499, 42.531105],
            [22.472221, 42.564995],
            [22.464165, 42.568886],
            [22.44722, 42.599442],
            [22.440277, 42.81472],
            [22.44083, 42.818604],
            [22.442219, 42.821663],
            [22.44833, 42.82666],
            [22.514164, 42.873055],
            [22.520832, 42.87722],
            [22.524998, 42.878609],
            [22.585831, 42.892776],
            [22.603886, 42.896111],
            [22.614998, 42.894722],
            [22.654999, 42.884995],
            [22.66222, 42.880829],
            [22.73333, 42.889717],
            [22.741943, 42.891663],
            [22.745552, 42.893608],
            [22.966389, 43.101662],
            [22.990555, 43.133049],
            [22.99361, 43.141663],
            [23.004997, 43.192772],
            [22.940552, 43.210548],
            [22.907497, 43.228607],
            [22.904442, 43.230827],
            [22.84972, 43.282219],
            [22.847221, 43.284996],
            [22.845554, 43.288055],
            [22.845276, 43.291664],
            [22.834999, 43.325829],
            [22.833054, 43.328888],
            [22.824997, 43.336388],
            [22.766666, 43.385826],
            [22.761944, 43.387497],
            [22.724163, 43.399994],
            [22.718609, 43.401382],
            [22.669167, 43.415833],
            [22.628052, 43.430832],
            [22.550552, 43.46833],
            [22.543331, 43.472496],
            [22.536388, 43.480827],
            [22.414165, 43.709442],
            [22.406666, 43.725555],
            [22.367222, 43.826942],
            [22.416943, 44.006943],
            [22.420277, 44.009438],
            [22.536942, 44.057777],
            [22.552776, 44.063889],
            [22.614719, 44.117493],
            [22.614998, 44.121666],
            [22.619164, 44.169998],
            [22.650276, 44.211937],
            [22.653332, 44.214439],
            [22.676388, 44.224716],
            [22.681435, 44.224701],
            [22.686386, 44.218887],
            [22.696941, 44.212219],
            [22.907497, 44.113609],
            [22.921665, 44.108604],
            [22.945274, 44.104439],
            [22.951385, 44.103607],
            [22.997444, 44.100632],
            [23.003609, 44.099442],
            [23.021942, 44.092773],
            [23.03722, 44.084442],
            [23.044167, 44.076111],
            [23.046108, 44.06916],
            [23.044441, 44.060555],
            [23.042774, 44.056664],
            [23.032497, 44.044716],
            [23.003407, 44.017799],
            [22.995831, 44.01416],
            [22.987499, 44.011665],
            [22.98222, 44.011383],
            [22.959431, 44.012276],
            [22.919857, 44.002838],
            [22.906944, 43.998886],
            [22.88472, 43.988052],
            [22.879719, 43.981667],
            [22.843243, 43.90506],
            [22.840687, 43.888283],
            [22.847618, 43.86821],
            [22.857471, 43.853256],
            [22.863331, 43.848328],
            [22.875275, 43.842499],
            [22.894444, 43.836105],
            [22.966942, 43.81694],
            [23.063602, 43.802177],
            [23.071457, 43.802177],
            [23.138885, 43.808327],
            [23.147499, 43.811104],
            [23.162109, 43.81823],
            [23.198608, 43.831383],
            [23.224499, 43.838661],
            [23.255142, 43.846321],
            [23.269009, 43.849243],
            [23.283607, 43.85083],
            [23.418224, 43.856171],
            [23.427147, 43.855232],
            [23.446663, 43.851105],
            [23.50703, 43.83773],
            [23.516003, 43.835381],
            [23.528042, 43.825523],
            [23.539352, 43.819328],
            [23.570274, 43.806938],
            [23.601665, 43.798607],
            [23.612499, 43.796104],
            [23.629719, 43.794998],
            [23.774166, 43.78833],
            [23.987499, 43.744164],
            [24.067982, 43.720627],
            [24.116077, 43.699913],
            [24.155617, 43.689911],
            [24.179996, 43.684715],
            [24.185833, 43.684441],
            [24.195553, 43.685272],
            [24.224163, 43.689438],
            [24.257221, 43.694443],
            [24.286388, 43.697495],
            [24.307777, 43.697495],
            [24.319706, 43.696632],
            [24.343052, 43.69416],
            [24.352497, 43.695549],
            [24.360832, 43.698051],
            [24.364719, 43.699715],
            [24.405277, 43.719719],
            [24.43861, 43.736382],
            [24.457775, 43.74472],
            [24.497219, 43.760277],
            [24.506386, 43.762215],
            [24.52861, 43.761108],
            [24.562496, 43.759163],
            [24.598331, 43.753883],
            [24.613331, 43.749161],
            [24.686932, 43.718384],
            [24.705555, 43.715271],
            [24.722775, 43.714165],
            [24.79361, 43.712776],
            [24.881386, 43.712219],
            [25.022751, 43.71019],
            [25.224716, 43.687485],
            [25.261944, 43.678055],
            [25.275272, 43.672493],
            [25.314442, 43.652222],
            [25.339439, 43.636932],
            [25.348885, 43.62999],
            [25.363049, 43.624718],
            [25.375275, 43.622765],
            [25.380711, 43.622437],
            [25.396111, 43.623322],
            [25.416111, 43.624718],
            [25.430229, 43.626778],
            [25.440952, 43.630112],
            [25.463852, 43.639206],
            [25.53194, 43.6436],
            [25.609161, 43.662209],
            [25.681339, 43.69043],
            [25.731377, 43.694077],
            [25.739246, 43.695122],
            [25.760551, 43.701111],
            [25.772495, 43.705544],
            [25.786942, 43.713051],
            [25.878262, 43.778824],
            [25.8825, 43.792213],
            [25.887238, 43.799103],
            [25.89027, 43.801941],
            [25.938049, 43.844719],
            [25.947495, 43.852219],
            [26.085278, 43.949715],
            [26.111664, 43.968323],
            [26.128609, 43.979156],
            [26.144161, 43.986382],
            [26.301941, 44.030823],
            [26.381943, 44.04332],
            [26.391388, 44.044434],
            [26.413036, 44.043129],
            [26.438416, 44.041306],
            [26.478611, 44.049431],
            [26.671104, 44.071938],
            [26.79472, 44.095276],
            [26.840832, 44.115555],
            [26.890205, 44.131989],
            [26.913403, 44.136124],
            [27.036427, 44.147339],
            [27.111111, 44.140831],
            [27.165833, 44.12999],
            [27.187492, 44.124435],
            [27.199715, 44.122208],
            [27.222775, 44.119987],
            [27.237778, 44.121666],
            [27.250549, 44.124985],
            [27.272713, 44.132149],
            [27.278889, 44.105553],
            [27.279716, 44.102219],
            [27.29055, 44.088051],
            [27.299995, 44.080544],
            [27.396111, 44.024155],
            [27.399998, 44.021935],
            [27.416943, 44.020554],
            [27.475826, 44.01944],
            [27.614162, 44.023598],
            [27.623333, 44.025269],
            [27.629719, 44.030266],
            [27.631943, 44.0336],
            [27.64222, 44.040276],
            [27.650555, 44.043053],
            [27.656109, 44.042496],
            [27.660828, 44.040833],
            [27.673882, 44.035271],
            [27.676941, 44.032776],
            [27.67944, 44.029999],
            [27.684715, 44.020821],
            [27.698353, 43.993607],
            [27.706944, 43.977219],
            [27.711662, 43.971657],
            [27.717773, 43.966942],
            [27.730827, 43.961098],
            [27.736382, 43.959717],
            [27.747215, 43.95916],
            [27.806107, 43.964165],
            [27.820271, 43.965828],
            [27.833328, 43.969162],
            [27.852776, 43.977486],
            [27.86805, 43.984154],
            [27.914444, 44.004433],
            [27.918884, 44.005547],
            [27.927773, 44.002769],
            [27.944717, 43.987221],
            [27.951664, 43.978882],
            [27.95472, 43.972771],
            [27.957771, 43.958878],
            [27.958328, 43.951653],
            [27.962215, 43.938332],
            [27.991108, 43.871666],
            [27.997215, 43.859154],
            [28.001942, 43.8536],
            [28.029716, 43.839165],
            [28.047218, 43.831657],
            [28.133053, 43.801659],
            [28.181942, 43.785271],
            [28.235554, 43.769997],
            [28.257771, 43.764435],
            [28.403889, 43.750275],
            [28.484997, 43.744164],
            [28.583244, 43.747765],
            [28.576382, 43.733047],
            [28.57, 43.689713],
            [28.572777, 43.600822],
            [28.57333, 43.597488],
            [28.578606, 43.588326],
            [28.585548, 43.579987],
            [28.593884, 43.57222],
            [28.598328, 43.566666],
            [28.603611, 43.557487],
            [28.605827, 43.551102],
            [28.606384, 43.543877],
            [28.606384, 43.536385],
            [28.605553, 43.532219],
            [28.602219, 43.523331],
            [28.596661, 43.511101],
            [28.588329, 43.495544],
            [28.561382, 43.458321],
            [28.553883, 43.448318],
            [28.54166, 43.437775],
            [28.525555, 43.425819],
            [28.479443, 43.393326],
            [28.453331, 43.385277],
            [28.431389, 43.389435],
            [28.412216, 43.396378],
            [28.404716, 43.400551],
            [28.394722, 43.407776],
            [28.381943, 43.413322],
            [28.376659, 43.414986],
            [28.34166, 43.421097],
            [28.330273, 43.422211],
            [28.299721, 43.421654],
            [28.152493, 43.404999],
            [28.148331, 43.403885],
            [28.1325, 43.398041],
            [28.121941, 43.39193],
            [28.093327, 43.369713],
            [28.085548, 43.360268],
            [28.080273, 43.349152],
            [28.071663, 43.322777],
            [28.055275, 43.284714],
            [28.051388, 43.276932],
            [28.015831, 43.225822],
            [27.945, 43.167213],
            [27.888882, 43.041382],
            [27.88583, 43.032494],
            [27.886387, 43.014153],
            [27.896381, 42.924988],
            [27.903606, 42.894722],
            [27.90416, 42.887497],
            [27.901665, 42.855553],
            [27.879166, 42.841103],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "CY",
        ISO2: "CY",
        ISO3: "CYP",
        UN: 196,
        NAME: "Cyprus",
        AREA: 924,
        POP2005: 836321,
        REGION: 142,
        SUBREGION: 145,
        LON: 33.219,
        LAT: 35.043,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.652618, 35.354103],
            [33.713051, 35.381943],
            [33.749161, 35.397217],
            [33.756943, 35.399719],
            [33.774994, 35.402222],
            [33.80722, 35.400276],
            [33.853607, 35.403053],
            [33.871109, 35.406387],
            [33.969719, 35.436104],
            [34.292221, 35.566666],
            [34.314163, 35.575554],
            [34.336662, 35.589439],
            [34.342499, 35.599159],
            [34.349998, 35.606941],
            [34.360275, 35.611938],
            [34.389442, 35.623886],
            [34.549438, 35.680832],
            [34.556938, 35.683327],
            [34.581665, 35.688606],
            [34.590271, 35.690277],
            [34.590553, 35.686943],
            [34.569717, 35.643608],
            [34.386665, 35.535271],
            [34.28083, 35.476944],
            [34.259438, 35.467499],
            [34.225273, 35.455551],
            [34.119995, 35.400833],
            [33.958054, 35.312775],
            [33.948326, 35.30722],
            [33.940552, 35.299438],
            [33.921387, 35.272774],
            [33.910553, 35.253052],
            [33.90583, 35.242218],
            [33.901939, 35.215828],
            [33.900276, 35.198051],
            [33.901665, 35.164444],
            [33.902496, 35.161659],
            [33.973885, 35.088051],
            [34.030548, 35.046387],
            [34.035553, 35.041382],
            [34.054443, 35.020554],
            [34.067215, 35.003883],
            [34.077217, 34.989998],
            [34.079163, 34.986938],
            [34.087219, 34.963882],
            [34.083328, 34.959442],
            [34.067215, 34.960274],
            [34.062775, 34.961662],
            [34.034721, 34.971939],
            [34.026108, 34.978607],
            [34.02166, 34.979996],
            [33.976944, 34.981384],
            [33.955826, 34.97805],
            [33.929443, 34.97361],
            [33.91333, 34.969444],
            [33.903053, 34.964165],
            [33.899162, 34.959717],
            [33.896385, 34.955551],
            [33.885277, 34.946106],
            [33.882217, 34.94416],
            [33.86805, 34.937775],
            [33.864166, 34.936661],
            [33.858887, 34.936661],
            [33.848328, 34.942497],
            [33.834717, 34.954163],
            [33.830276, 34.959442],
            [33.814438, 34.965828],
            [33.790276, 34.970276],
            [33.763054, 34.972771],
            [33.709999, 34.974159],
            [33.705276, 34.97361],
            [33.685272, 34.968048],
            [33.677498, 34.965553],
            [33.667496, 34.960274],
            [33.661942, 34.955551],
            [33.649719, 34.942215],
            [33.646111, 34.935555],
            [33.640549, 34.92083],
            [33.638611, 34.912773],
            [33.636108, 34.899994],
            [33.632774, 34.873886],
            [33.637772, 34.864998],
            [33.638054, 34.860832],
            [33.636108, 34.857773],
            [33.606667, 34.820274],
            [33.599998, 34.816666],
            [33.516388, 34.783607],
            [33.372772, 34.727776],
            [33.365273, 34.725273],
            [33.326385, 34.71611],
            [33.317215, 34.714722],
            [33.272293, 34.709549],
            [33.217216, 34.69944],
            [33.153053, 34.702499],
            [33.133606, 34.70166],
            [33.116943, 34.698608],
            [33.104996, 34.695274],
            [33.066666, 34.68222],
            [33.059715, 34.679161],
            [33.029999, 34.657776],
            [33.007023, 34.632397],
            [33.007023, 34.595886],
            [33.030838, 34.56255],
            [32.981625, 34.572071],
            [32.941936, 34.56255],
            [32.941936, 34.594299],
            [32.918125, 34.629223],
            [32.899075, 34.651447],
            [32.859444, 34.666107],
            [32.831108, 34.667496],
            [32.769165, 34.656944],
            [32.761108, 34.654716],
            [32.751663, 34.648888],
            [32.744438, 34.645828],
            [32.739998, 34.644997],
            [32.713882, 34.640274],
            [32.698326, 34.64222],
            [32.654716, 34.65361],
            [32.641663, 34.657219],
            [32.491943, 34.702217],
            [32.471107, 34.713051],
            [32.407494, 34.748886],
            [32.40416, 34.750832],
            [32.342773, 34.859993],
            [32.339996, 34.866661],
            [32.323326, 34.909439],
            [32.276382, 35.036942],
            [32.274162, 35.043884],
            [32.270271, 35.062492],
            [32.269165, 35.07444],
            [32.270554, 35.083328],
            [32.275276, 35.093605],
            [32.281944, 35.097221],
            [32.291939, 35.096664],
            [32.298332, 35.092499],
            [32.304718, 35.08416],
            [32.312492, 35.076942],
            [32.32666, 35.065552],
            [32.341385, 35.054443],
            [32.354164, 35.046387],
            [32.369164, 35.039719],
            [32.373604, 35.038605],
            [32.378609, 35.037773],
            [32.397774, 35.039444],
            [32.419998, 35.043053],
            [32.428055, 35.045273],
            [32.438606, 35.050278],
            [32.460274, 35.064438],
            [32.491661, 35.094162],
            [32.496109, 35.099716],
            [32.501938, 35.109161],
            [32.515831, 35.135826],
            [32.522217, 35.14444],
            [32.549164, 35.173607],
            [32.553604, 35.173332],
            [32.565552, 35.168884],
            [32.622215, 35.184166],
            [32.651382, 35.189163],
            [32.660553, 35.190277],
            [32.721939, 35.180832],
            [32.769722, 35.163887],
            [32.808609, 35.148331],
            [32.820549, 35.143883],
            [32.830551, 35.14222],
            [32.839722, 35.143608],
            [32.85833, 35.150551],
            [32.882774, 35.162216],
            [32.895828, 35.169716],
            [32.901939, 35.174164],
            [32.906944, 35.179443],
            [32.912773, 35.188606],
            [32.916939, 35.199997],
            [32.932098, 35.263626],
            [32.939163, 35.327499],
            [32.922886, 35.35828],
            [32.921299, 35.393208],
            [32.938763, 35.394001],
            [33.002777, 35.365555],
            [33.271942, 35.339722],
            [33.354439, 35.330276],
            [33.369438, 35.328606],
            [33.385277, 35.328331],
            [33.427498, 35.328049],
            [33.468048, 35.328049],
            [33.477219, 35.329163],
            [33.63166, 35.350273],
            [33.652618, 35.354103],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "DA",
        ISO2: "DK",
        ISO3: "DNK",
        UN: 208,
        NAME: "Denmark",
        AREA: 4243,
        POP2005: 5416945,
        REGION: 150,
        SUBREGION: 154,
        LON: 9.264,
        LAT: 56.058,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [11.513887, 54.829720000000123],
              [11.564444, 54.82194],
              [11.6425, 54.877777],
              [11.64167, 54.900833],
              [11.64194, 54.903885],
              [11.64389, 54.9061],
              [11.64861100000013, 54.906662],
              [11.656944, 54.903885],
              [11.708611, 54.87527],
              [11.73527700000011, 54.854996],
              [11.845, 54.769997000000103],
              [11.849443000000122, 54.765831],
              [11.861666, 54.746109],
              [11.862221, 54.74305],
              [11.858332, 54.689438],
              [11.85611, 54.683327000000133],
              [11.84417, 54.669441],
              [11.833887, 54.66111],
              [11.785, 54.639999],
              [11.775555000000111, 54.64083],
              [11.73639, 54.645271],
              [11.7225, 54.651108000000136],
              [11.693888, 54.655548000000124],
              [11.640554, 54.6625],
              [11.588333, 54.663605000000132],
              [11.57888800000012, 54.66333],
              [11.522499, 54.64194],
              [11.4725, 54.622772],
              [11.466389, 54.619995000000131],
              [11.46139, 54.618889],
              [11.45555, 54.619438],
              [11.451387, 54.620552],
              [11.377222, 54.64666],
              [11.350277000000119, 54.658882000000119],
              [11.315277, 54.675552],
              [11.278055000000109, 54.699715],
              [11.26222, 54.70722],
              [11.245832000000121, 54.711662],
              [11.190554000000134, 54.725555],
              [11.144444, 54.736938],
              [11.125555, 54.740273000000116],
              [11.099165, 54.742493],
              [11.03167, 54.756104],
              [11.02611, 54.75861],
              [11.019722000000115, 54.762772],
              [10.994999, 54.78278],
              [10.99111, 54.787216],
              [10.989891000000114, 54.79085],
              [11.025276, 54.814438000000109],
              [11.013611, 54.890274],
              [11.014444, 54.895828],
              [11.027498, 54.910271],
              [11.031944, 54.914719],
              [11.042221, 54.923050000000103],
              [11.05778, 54.934998],
              [11.07139, 54.940826],
              [11.118889, 54.95083],
              [11.136389, 54.95388800000012],
              [11.164444, 54.956665],
              [11.193144, 54.957397],
              [11.239721, 54.957222000000115],
              [11.275555, 54.94971],
              [11.288332, 54.943054],
              [11.33111, 54.91944100000012],
              [11.336111, 54.91555],
              [11.339998, 54.911385],
              [11.347221, 54.896111000000133],
              [11.351110000000119, 54.891937],
              [11.361111, 54.883888],
              [11.393332, 54.86805],
              [11.408888, 54.86249],
              [11.513887, 54.829720000000123],
            ],
          ],
          [
            [
              [12.03805, 54.892494],
              [12.060833, 54.891106],
              [12.07944300000014, 54.89361],
              [12.085278, 54.89361],
              [12.095554, 54.892494],
              [12.10361, 54.890274],
              [12.11055, 54.88749700000011],
              [12.119444000000101, 54.882217],
              [12.136665, 54.868607],
              [12.16805, 54.84166],
              [12.169443, 54.839165],
              [12.16861, 54.8361],
              [12.166666, 54.833885000000123],
              [12.158333, 54.82861],
              [12.11972, 54.806389],
              [12.10722, 54.799721],
              [12.08861, 54.79361],
              [12.0783330000001, 54.789162],
              [12.071943, 54.785828],
              [12.055277000000103, 54.774719],
              [11.98139, 54.710274],
              [11.969721000000106, 54.69944],
              [11.963055000000111, 54.68527],
              [11.96083, 54.675827],
              [11.958611000000133, 54.66333],
              [11.959999, 54.64777400000014],
              [11.963055000000111, 54.629715],
              [11.967777, 54.609444],
              [11.974443, 54.58694],
              [11.978888, 54.576111],
              [11.98, 54.570274],
              [11.978611, 54.567215],
              [11.969166, 54.562218000000144],
              [11.964443, 54.561661],
              [11.94472, 54.567497000000117],
              [11.929443000000106, 54.572777],
              [11.92305, 54.576111],
              [11.871944, 54.651382],
              [11.871111, 54.66722],
              [11.877777, 54.687775000000101],
              [11.891943, 54.701111],
              [11.899166, 54.718605000000139],
              [11.85611, 54.774162000000103],
              [11.80194, 54.839165],
              [11.792776, 54.844719],
              [11.781944, 54.848885000000109],
              [11.755554, 54.85472],
              [11.751944, 54.859161],
              [11.708611, 54.936661],
              [11.713333, 54.94167],
              [11.73222, 54.954437],
              [11.742222, 54.95916],
              [11.750832, 54.960831],
              [11.766943, 54.961662000000103],
              [11.846666, 54.95611],
              [11.850587, 54.954784],
              [11.865035, 54.947559000000126],
              [11.99694, 54.903885],
              [12.019999, 54.896385],
              [12.03805, 54.892494],
            ],
          ],
          [
            [
              [10.432777, 54.84166],
              [10.407221000000106, 54.82139],
              [10.399443000000133, 54.824165],
              [10.248333000000116, 54.90416],
              [10.243055, 54.907776],
              [10.190832, 54.958054],
              [10.185555, 54.968048],
              [10.184166, 54.97361],
              [10.18861, 54.97805],
              [10.285555, 54.936104],
              [10.306665, 54.926941],
              [10.440832, 54.86388],
              [10.432777, 54.84166],
            ],
          ],
          [
            [
              [12.557499, 54.964165],
              [12.557499, 54.960831],
              [12.55611, 54.957771],
              [12.548054, 54.949165000000107],
              [12.544722, 54.947220000000129],
              [12.53666, 54.945000000000107],
              [12.52055, 54.94416],
              [12.501665, 54.947220000000129],
              [12.472776, 54.955826],
              [12.463888, 54.957497000000103],
              [12.40416, 54.963051000000121],
              [12.377222, 54.963051000000121],
              [12.361666, 54.962219],
              [12.338055, 54.958885],
              [12.311943, 54.950554000000125],
              [12.308887000000141, 54.948883],
              [12.264166, 54.919167],
              [12.18361, 54.880272],
              [12.163610000000119, 54.883049000000142],
              [12.150833, 54.886108],
              [12.115833000000123, 54.90416],
              [12.132221, 54.95138500000013],
              [12.135832, 54.956665],
              [12.177776, 54.982498000000135],
              [12.311943, 55.035271000000137],
              [12.395277, 55.032494],
              [12.452221000000122, 55.026939],
              [12.506666000000109, 55.015831],
              [12.527777000000128, 55.01028],
              [12.532776, 55.00666],
              [12.536388000000102, 55.001938000000109],
              [12.554722, 54.972221],
              [12.557499, 54.964165],
            ],
          ],
          [
            [
              [10.615, 54.950272],
              [10.565277, 54.94611],
              [10.555832000000123, 54.946938],
              [10.549166000000127, 54.949997],
              [10.51694300000014, 54.978882000000112],
              [10.513054, 54.98333],
              [10.49861, 55.001663000000121],
              [10.49861, 55.006386],
              [10.504999, 55.00944],
              [10.622499, 55.043884000000105],
              [10.631943, 55.043327],
              [10.674444000000108, 54.994438],
              [10.677221, 54.989441000000113],
              [10.674721, 54.98333],
              [10.671110000000112, 54.97805],
              [10.666666000000134, 54.97361],
              [10.615, 54.950272],
            ],
          ],
          [
            [
              [9.792500000000132, 55.07499700000011],
              [9.96611, 55.012497],
              [9.97194, 55.00889],
              [10.0, 54.983719],
              [10.004721, 54.979721],
              [10.042221, 54.940277],
              [10.04389, 54.937775],
              [10.069166, 54.895264],
              [10.071943, 54.88999200000012],
              [10.073055, 54.88082],
              [10.07111, 54.874710000000107],
              [10.067499000000112, 54.87305],
              [9.988888, 54.859993],
              [9.978611000000114, 54.858604000000128],
              [9.956388, 54.85805],
              [9.936388000000136, 54.860275],
              [9.926943, 54.86249],
              [9.895832, 54.871666000000118],
              [9.804165, 54.899437],
              [9.785831, 54.9061],
              [9.781387, 54.910271],
              [9.77861, 54.91555],
              [9.772499, 54.92889],
              [9.758333, 54.961388],
              [9.75861, 54.978882000000112],
              [9.760555, 54.98111],
              [9.765276, 54.98055],
              [9.781387, 54.96916],
              [9.819166, 54.946663],
              [9.829166, 54.94194],
              [9.836943, 54.93972],
              [9.842222000000106, 54.939995],
              [9.84417, 54.942215],
              [9.843611, 54.945274],
              [9.838888000000111, 54.970551],
              [9.836111, 54.976387],
              [9.798887, 55.01111],
              [9.793610000000115, 55.014999],
              [9.782776, 55.015549],
              [9.741943, 55.012215],
              [9.718054000000109, 55.00944],
              [9.700832, 55.00972],
              [9.696665, 55.010551],
              [9.681110000000103, 55.015274],
              [9.674721, 55.018326],
              [9.632221000000129, 55.046944],
              [9.630554, 55.049438000000123],
              [9.630833, 55.052773],
              [9.639444, 55.058609],
              [9.66472, 55.067772],
              [9.707777000000135, 55.080826000000116],
              [9.716944000000126, 55.0825],
              [9.754166, 55.08444],
              [9.77194, 55.080826000000116],
              [9.792500000000132, 55.07499700000011],
            ],
          ],
          [
            [
              [10.756943, 54.777222],
              [10.714722000000108, 54.724998000000141],
              [10.703609, 54.725555],
              [10.697222, 54.729164],
              [10.688332, 54.737495],
              [10.674999, 54.75388],
              [10.655554, 54.802498],
              [10.651943, 54.837219000000118],
              [10.68194, 54.908607],
              [10.693609, 54.922218],
              [10.736666000000127, 54.959717000000126],
              [10.76639, 54.97694],
              [10.773333, 54.979721],
              [10.790277, 54.98389],
              [10.796944, 54.98694],
              [10.801388, 54.991104],
              [10.85055, 55.044998],
              [10.886389000000122, 55.104721],
              [10.891109, 55.113052],
              [10.907499, 55.138611],
              [10.91139, 55.14361],
              [10.925833, 55.155273],
              [10.93222, 55.158882],
              [10.935833, 55.160271],
              [10.944443, 55.1616590000001],
              [10.949165, 55.16111],
              [10.955, 55.157494],
              [10.958887, 55.152771000000143],
              [10.95972, 55.149994],
              [10.958887, 55.14444],
              [10.936943, 55.09],
              [10.93111, 55.075829],
              [10.91055, 55.02833],
              [10.89777800000013, 55.001106],
              [10.895832, 54.997772],
              [10.88611, 54.988884],
              [10.876944, 54.98333],
              [10.857777000000112, 54.967773],
              [10.838888, 54.943329],
              [10.786943, 54.843887000000109],
              [10.756943, 54.777222],
            ],
          ],
          [
            [
              [15.051666, 54.994995000000131],
              [15.042500000000132, 54.99472],
              [14.942499000000112, 55.013329],
              [14.881943, 55.028885],
              [14.746944, 55.065277],
              [14.729443, 55.072777],
              [14.679722, 55.099716],
              [14.677776, 55.101944],
              [14.698889, 55.214996],
              [14.744165, 55.292496000000142],
              [14.746387, 55.295555],
              [14.759998, 55.304443000000106],
              [14.763887, 55.30555],
              [14.769999, 55.30555],
              [14.798611, 55.281944000000124],
              [14.80555500000014, 55.276108],
              [14.81278, 55.2691650000001],
              [14.82, 55.260826],
              [14.825277, 55.25694],
              [14.83861, 55.250549],
              [14.88722, 55.229439000000127],
              [14.9975, 55.187218000000144],
              [15.064999, 55.162498],
              [15.07361, 55.159721],
              [15.090832, 55.155273],
              [15.123055, 55.148888],
              [15.134165, 55.144165],
              [15.141109, 55.138611],
              [15.148611, 55.12917],
              [15.15, 55.089165],
              [15.148333, 55.0825],
              [15.107222, 55.02583],
              [15.10333, 55.020554000000118],
              [15.07667, 55.001106],
              [15.061388, 54.99638],
              [15.051666, 54.994995000000131],
            ],
          ],
          [
            [
              [8.46361, 55.33416],
              [8.45278, 55.333885],
              [8.439165, 55.339996],
              [8.429722, 55.348053000000107],
              [8.403055, 55.37944],
              [8.388887, 55.398048],
              [8.356943, 55.452217000000132],
              [8.360277, 55.45777],
              [8.365555, 55.461662],
              [8.380833000000109, 55.466385],
              [8.389444, 55.468048000000124],
              [8.401388, 55.4675],
              [8.45833, 55.42638],
              [8.461111, 55.421387],
              [8.47333, 55.342499],
              [8.471388, 55.336388],
              [8.46361, 55.33416],
            ],
          ],
          [
            [
              [10.745277000000101, 55.482216],
              [10.79055, 55.362778],
              [10.82833, 55.306664],
              [10.834721, 55.293884],
              [10.834444, 55.290276000000119],
              [10.815832, 55.20527600000014],
              [10.81167, 55.186386],
              [10.785555000000102, 55.12805],
              [10.782776, 55.122498],
              [10.779444, 55.117775],
              [10.740276, 55.06721],
              [10.733332000000132, 55.064438],
              [10.725555, 55.062218],
              [10.66555, 55.060555000000136],
              [10.627222, 55.060829],
              [10.616388000000143, 55.060555000000136],
              [10.598888000000102, 55.05805],
              [10.584166, 55.052773],
              [10.529444, 55.029442000000131],
              [10.519444, 55.02861],
              [10.49778, 55.028885],
              [10.15278, 55.08444],
              [10.13528, 55.117218],
              [10.150555, 55.121941000000106],
              [10.154444, 55.126938],
              [10.15278, 55.132774],
              [10.15, 55.137497],
              [10.11861, 55.17889],
              [10.108332, 55.186386],
              [10.098610000000122, 55.18805],
              [10.005833, 55.193329],
              [9.896944, 55.279716],
              [9.89667, 55.28583],
              [9.888332, 55.33666],
              [9.88722, 55.342216000000121],
              [9.810833, 55.436661],
              [9.768055, 55.466942],
              [9.72889, 55.47416],
              [9.684999, 55.491104000000121],
              [9.678333, 55.494438000000116],
              [9.675554, 55.499161000000129],
              [9.679998000000126, 55.503609],
              [9.74861, 55.540276],
              [9.81305, 55.547493],
              [9.82416, 55.54722],
              [9.832499, 55.544716000000108],
              [9.834721000000116, 55.539993],
              [9.835278, 55.5275],
              [9.8375, 55.522499],
              [9.843332, 55.518883],
              [9.85639, 55.512497],
              [9.864721, 55.509995],
              [9.883333, 55.505829],
              [9.895277000000135, 55.505554],
              [9.904999, 55.505829],
              [9.921665, 55.50972],
              [9.935833, 55.515],
              [10.0003, 55.541264000000126],
              [10.073889, 55.556664000000126],
              [10.124722, 55.568054],
              [10.148611, 55.574165000000107],
              [10.164721, 55.578606],
              [10.177776, 55.584442],
              [10.2125, 55.59888],
              [10.2897210000001, 55.614998],
              [10.29889, 55.616661],
              [10.309721, 55.616943],
              [10.327221000000122, 55.611938000000123],
              [10.39917, 55.588882],
              [10.405554, 55.585548],
              [10.484722, 55.53249],
              [10.473610000000122, 55.515],
              [10.452221, 55.481667],
              [10.445276, 55.47861],
              [10.427776, 55.468048000000124],
              [10.42222, 55.464439],
              [10.416111, 55.452774],
              [10.4175, 55.44722],
              [10.420277, 55.442497],
              [10.42555, 55.438606],
              [10.437498, 55.43777],
              [10.46889, 55.437218],
              [10.478611, 55.438049],
              [10.600277000000119, 55.482773],
              [10.60611, 55.486382],
              [10.60889, 55.492493000000138],
              [10.61417, 55.51944],
              [10.6175, 55.563889],
              [10.612778, 55.592499],
              [10.607222, 55.602493],
              [10.603333, 55.607216],
              [10.610554, 55.617218],
              [10.613888, 55.618607],
              [10.619165, 55.619164],
              [10.62694, 55.616661],
              [10.63444, 55.610275],
              [10.658054, 55.589996],
              [10.662498, 55.585274],
              [10.744444000000101, 55.496666],
              [10.747221, 55.491104000000121],
              [10.745277000000101, 55.482216],
            ],
          ],
          [
            [
              [12.579443, 55.551384],
              [12.570833000000107, 55.549438],
              [12.559999, 55.55055],
              [12.5525, 55.55305],
              [12.546665, 55.556664000000126],
              [12.527222, 55.57278],
              [12.52222, 55.57694],
              [12.5175, 55.58416],
              [12.511665, 55.606667],
              [12.51194, 55.6097180000001],
              [12.513887, 55.612495],
              [12.521839, 55.619118],
              [12.550278, 55.63694],
              [12.55861, 55.642494],
              [12.57833, 55.666382],
              [12.590277, 55.681107000000111],
              [12.60611, 55.69611],
              [12.60999900000013, 55.694717],
              [12.61611, 55.688049],
              [12.650122, 55.640987],
              [12.666943, 55.616661],
              [12.67639, 55.59888],
              [12.678333000000123, 55.593605],
              [12.67861, 55.59055],
              [12.675833, 55.588608000000136],
              [12.579443, 55.551384],
            ],
          ],
          [
            [
              [10.630554, 55.865555],
              [10.639999000000103, 55.86360900000011],
              [10.65083, 55.86360900000011],
              [10.65889, 55.865829000000133],
              [10.663332000000139, 55.870277000000101],
              [10.665833000000134, 55.876389],
              [10.666893, 55.892586],
              [10.666943000000117, 55.875549],
              [10.66555, 55.868607000000111],
              [10.613888, 55.763329000000113],
              [10.608055, 55.759720000000129],
              [10.600277000000119, 55.757500000000107],
              [10.58917, 55.757500000000107],
              [10.54472, 55.761108],
              [10.53417, 55.762497],
              [10.527498, 55.765831],
              [10.524721000000113, 55.770828000000108],
              [10.511665, 55.801941000000113],
              [10.511665, 55.80805],
              [10.516388, 55.970833],
              [10.523611, 55.98138],
              [10.540833, 55.992775000000108],
              [10.547499, 55.995827],
              [10.555277, 55.99805],
              [10.562498000000119, 55.996109000000104],
              [10.560833, 55.989441000000113],
              [10.557499, 55.984161],
              [10.556665000000123, 55.969719],
              [10.560555, 55.952774],
              [10.619999, 55.873055],
              [10.623888, 55.868889],
              [10.630554, 55.865555],
            ],
          ],
          [
            [
              [12.567221, 55.992218],
              [12.53, 55.94971],
              [12.525555, 55.94194],
              [12.516943, 55.92555],
              [12.515554, 55.91944100000012],
              [12.519165, 55.911385],
              [12.55887, 55.867237000000102],
              [12.566944, 55.857498],
              [12.57444, 55.848053],
              [12.575832, 55.845551000000114],
              [12.596388, 55.79888],
              [12.59861, 55.793327],
              [12.599998, 55.76722],
              [12.600277, 55.75444],
              [12.58417, 55.735275],
              [12.59944, 55.707222000000115],
              [12.600277, 55.704163],
              [12.59611, 55.69944],
              [12.561388, 55.666939],
              [12.549999, 55.657219],
              [12.540833, 55.650833],
              [12.524166, 55.639442000000145],
              [12.502777, 55.631386],
              [12.496944, 55.606667],
              [12.495554000000141, 55.603882],
              [12.49222200000014, 55.602219000000105],
              [12.486666000000127, 55.601662],
              [12.448055, 55.60416],
              [12.444721, 55.604996],
              [12.441666, 55.607216],
              [12.435833, 55.614166],
              [12.432499, 55.615555],
              [12.421665, 55.616386],
              [12.403889, 55.616661],
              [12.39138800000012, 55.613609],
              [12.380833, 55.609993000000145],
              [12.344444000000124, 55.593048],
              [12.339458, 55.590206],
              [12.269444000000135, 55.559998000000121],
              [12.253332, 55.552498],
              [12.24444, 55.54361],
              [12.20583, 55.50222],
              [12.19611, 55.490273000000116],
              [12.191666000000112, 55.482216],
              [12.190832, 55.47861],
              [12.190554000000134, 55.465553],
              [12.19278, 55.45777],
              [12.195276, 55.452217000000132],
              [12.200554000000125, 55.444717],
              [12.20666, 55.438332],
              [12.224165, 55.427773],
              [12.23166700000013, 55.424438000000123],
              [12.297777, 55.40305],
              [12.343611000000124, 55.401665],
              [12.363888, 55.39889],
              [12.37666, 55.395271],
              [12.399443, 55.381104],
              [12.430555, 55.361664],
              [12.43611, 55.357498000000135],
              [12.444166, 55.348328],
              [12.45194400000014, 55.336388],
              [12.453609, 55.330551],
              [12.462776, 55.29277],
              [12.461666, 55.286385],
              [12.449165, 55.276382],
              [12.443333, 55.272499],
              [12.425833000000125, 55.261665],
              [12.412498, 55.255829000000119],
              [12.333887, 55.234993],
              [12.32528, 55.23333],
              [12.315554, 55.232773000000122],
              [12.293888, 55.23305],
              [12.272499, 55.233887],
              [12.243889, 55.236938000000123],
              [12.20333, 55.22805000000011],
              [12.176109, 55.220551000000114],
              [12.036110000000122, 55.17333200000013],
              [12.025555, 55.169441],
              [12.014999000000103, 55.161385],
              [12.013054, 55.158607],
              [12.012777, 55.155548],
              [12.013054, 55.152496],
              [12.015276, 55.150276],
              [12.018055, 55.148605],
              [12.058054, 55.133049],
              [12.065554, 55.130554],
              [12.075, 55.12888],
              [12.086943, 55.12888],
              [12.096109, 55.129440000000102],
              [12.115000000000123, 55.132774],
              [12.130554, 55.13361],
              [12.149443000000133, 55.130272],
              [12.17333, 55.122772000000111],
              [12.17916, 55.11972],
              [12.18111, 55.117218],
              [12.181389000000138, 55.114166],
              [12.173611, 55.004997000000117],
              [12.173054, 55.001389],
              [12.171665, 54.998886],
              [12.166666, 54.995552],
              [12.158609, 54.992775000000108],
              [12.071943, 54.968605],
              [12.041111, 54.966385000000116],
              [12.013332, 54.96833],
              [11.994999000000121, 54.971382],
              [11.97833, 54.97916],
              [11.953333, 54.998886],
              [11.949999, 55.00027],
              [11.945833, 55.001938000000109],
              [11.936388, 55.003326],
              [11.91389, 55.004715],
              [11.91028, 55.003326],
              [11.896387000000118, 54.991386],
              [11.895555, 54.98832700000014],
              [11.896111, 54.98583200000013],
              [11.900913000000116, 54.97882],
              [11.859722, 55.013885],
              [11.840277, 55.023331],
              [11.730555, 55.060555000000136],
              [11.783054000000106, 55.1325],
              [11.797777, 55.15583],
              [11.741110000000106, 55.198883],
              [11.730833000000132, 55.20361],
              [11.717777, 55.20666],
              [11.69451, 55.20760300000012],
              [11.683332, 55.204163],
              [11.658333, 55.187218000000144],
              [11.61222, 55.187218000000144],
              [11.553055, 55.190826],
              [11.543055, 55.192772000000105],
              [11.518888, 55.199997],
              [11.453888, 55.212494],
              [11.42778, 55.21583],
              [11.41694, 55.21583],
              [11.400276, 55.21222],
              [11.350832, 55.201385],
              [11.323055, 55.190552],
              [11.30611, 55.188889],
              [11.27277800000013, 55.192772000000105],
              [11.262499, 55.19444],
              [11.253054, 55.196388],
              [11.246666, 55.19971],
              [11.244165, 55.20444],
              [11.187777, 55.338882000000126],
              [11.218054, 55.393608],
              [11.217222, 55.399162],
              [11.203609000000142, 55.448883000000137],
              [11.149166, 55.567497000000117],
              [11.144444, 55.577499000000103],
              [11.089167, 55.662773],
              [11.083611, 55.669998],
              [11.075277, 55.672775000000115],
              [10.994165, 55.692497],
              [10.879999, 55.729439],
              [10.87361, 55.7325],
              [10.878054, 55.736938],
              [10.88722, 55.738327],
              [10.897221, 55.739166000000125],
              [10.940832000000114, 55.738884],
              [10.953054, 55.73805],
              [11.129444, 55.721664],
              [11.138611, 55.713608],
              [11.152777000000128, 55.707771],
              [11.168610000000115, 55.70277],
              [11.18916, 55.699165],
              [11.201111, 55.698051],
              [11.211111, 55.698883],
              [11.34333, 55.747498000000121],
              [11.486944, 55.84166],
              [11.496387000000141, 55.85083],
              [11.500000000000114, 55.85611],
              [11.506388, 55.867218],
              [11.511665, 55.879440000000102],
              [11.5158330000001, 55.891937],
              [11.516388, 55.89833],
              [11.51028, 55.91416],
              [11.50778, 55.918884],
              [11.491665, 55.930275],
              [11.478611, 55.93694],
              [11.470276000000126, 55.939438],
              [11.449165, 55.942497000000117],
              [11.379721, 55.946938],
              [11.359722, 55.949165000000107],
              [11.283333, 55.971382],
              [11.278055000000109, 55.975273],
              [11.274166, 55.979439000000127],
              [11.273333, 55.991661000000136],
              [11.31278, 55.98111],
              [11.409166, 55.961388],
              [11.60639, 55.936386],
              [11.664444000000117, 55.941666000000112],
              [11.706388000000118, 55.950829000000113],
              [11.737778000000105, 55.959442],
              [11.74472, 55.962494],
              [11.752777, 55.964439],
              [11.76389, 55.964722],
              [11.772778, 55.962219],
              [11.778610000000128, 55.958328000000108],
              [11.781944, 55.954163000000108],
              [11.778332, 55.948608],
              [11.73972, 55.92139],
              [11.670277000000112, 55.890549],
              [11.67055, 55.814163],
              [11.7175, 55.793327],
              [11.727499000000137, 55.794716],
              [11.732777, 55.794441],
              [11.73639, 55.7930530000001],
              [11.745277000000101, 55.784164],
              [11.765554, 55.75861],
              [11.79972, 55.687218],
              [11.799999, 55.683884],
              [11.79444, 55.66166],
              [11.819721, 55.674721],
              [11.822498, 55.676666],
              [11.825554, 55.682495],
              [11.832083000000125, 55.707016000000124],
              [11.843611, 55.764442],
              [11.902777, 55.925827],
              [11.905277, 55.927773],
              [11.914165, 55.929718],
              [11.924999000000128, 55.92889],
              [11.941111, 55.924438],
              [11.959444000000133, 55.917221],
              [11.986944, 55.90472],
              [11.99278, 55.901108],
              [11.998888, 55.89444],
              [12.001389, 55.88916],
              [12.035276, 55.806389],
              [12.04055, 55.793327],
              [12.055555, 55.751389],
              [12.05694, 55.742218],
              [12.056389, 55.736107],
              [12.054443, 55.729996],
              [12.050833, 55.724442000000124],
              [12.045555, 55.720551],
              [12.031111, 55.715271000000143],
              [12.02611, 55.714722],
              [12.009722, 55.715271000000143],
              [11.970554000000106, 55.717499],
              [11.936666, 55.676941],
              [11.935833, 55.653328000000101],
              [12.05722, 55.653328000000101],
              [12.061943, 55.658051000000114],
              [12.092222, 55.698326],
              [12.093887000000109, 55.711105],
              [12.092222, 55.722496],
              [12.090832, 55.72805],
              [12.087776, 55.738884],
              [12.07222, 55.76453800000013],
              [12.042221, 55.91917],
              [12.03972, 55.924164],
              [12.014721, 55.956108],
              [12.007500000000107, 55.959442],
              [11.97917, 55.95666],
              [11.933887, 55.949997],
              [11.886665, 55.93694],
              [11.87611, 55.936104],
              [11.866388, 55.937218000000144],
              [11.853611, 55.943886000000134],
              [11.848610000000122, 55.947777],
              [11.845833, 55.952499000000103],
              [11.84833, 55.958611],
              [11.859444, 55.966660000000104],
              [11.865833, 55.969719],
              [11.919167, 55.994438],
              [12.174166, 56.103607000000125],
              [12.200277, 56.11222],
              [12.275, 56.12722],
              [12.290554, 56.12888],
              [12.301666, 56.128609],
              [12.312498000000119, 56.12722],
              [12.331388, 56.124161],
              [12.51417, 56.087776000000133],
              [12.533609, 56.080826000000116],
              [12.612499, 56.045273],
              [12.618889, 56.041939],
              [12.61972, 56.039444],
              [12.618055, 56.033882000000119],
              [12.593887, 56.004715],
              [12.58417, 55.999443],
              [12.573332000000107, 55.995827],
              [12.567221, 55.992218],
            ],
          ],
          [
            [
              [11.565832, 56.670830000000137],
              [11.556665, 56.66944100000012],
              [11.545832000000132, 56.670830000000137],
              [11.503054, 56.70166],
              [11.503332000000114, 56.707771],
              [11.51028, 56.710831],
              [11.637777, 56.722771],
              [11.648054, 56.723328],
              [11.64861100000013, 56.719994],
              [11.565832, 56.670830000000137],
            ],
          ],
          [
            [
              [8.924721, 56.91861],
              [8.878887000000134, 56.798607000000118],
              [8.831388, 56.743332],
              [8.77, 56.693604000000107],
              [8.766943, 56.692215],
              [8.744999, 56.68722],
              [8.734999, 56.685555],
              [8.655277, 56.674164000000133],
              [8.63694, 56.697220000000129],
              [8.603054, 56.72583],
              [8.563889000000131, 56.73722],
              [8.55472200000014, 56.738884],
              [8.542776000000117, 56.738609],
              [8.52472, 56.731384],
              [8.519722, 56.73111],
              [8.514166, 56.731941],
              [8.510832000000107, 56.733604],
              [8.509165, 56.73555],
              [8.509722, 56.741661000000136],
              [8.546110000000112, 56.793327],
              [8.617005, 56.830849],
              [8.647499, 56.88721],
              [8.65, 56.889442],
              [8.658054000000106, 56.89138800000012],
              [8.66889, 56.892776],
              [8.696943, 56.89222],
              [8.733332, 56.894165],
              [8.73889, 56.894722000000115],
              [8.81361, 56.904999],
              [8.817221, 56.906662],
              [8.82639, 56.914719],
              [8.83917, 56.935555],
              [8.85333, 56.951660000000118],
              [8.855833, 56.953888],
              [8.85972, 56.95527600000014],
              [8.865276, 56.955551],
              [8.899721, 56.95527600000014],
              [8.91083, 56.948326000000122],
              [8.924721, 56.92249],
              [8.924721, 56.91861],
            ],
          ],
          [
            [
              [9.974274, 57.071732000000111],
              [10.12361, 57.018326000000116],
              [10.146944, 57.0075],
              [10.157499, 57.003052],
              [10.179443000000106, 56.994164],
              [10.20472100000012, 56.987495],
              [10.218054, 56.984161],
              [10.22833, 56.982498],
              [10.245832000000121, 56.981941],
              [10.311891, 56.981304],
              [10.288055, 56.963051],
              [10.282221, 56.952217],
              [10.272221, 56.926384],
              [10.26916, 56.917221],
              [10.26833, 56.90416],
              [10.281111, 56.825554],
              [10.286110000000122, 56.801666],
              [10.286943000000122, 56.798882000000106],
              [10.305277, 56.748055],
              [10.24055, 56.717773],
              [10.15944, 56.720551],
              [10.154444, 56.719994],
              [9.866388000000143, 56.65028],
              [9.88639, 56.64194],
              [9.933054000000141, 56.641663],
              [10.003611, 56.65916],
              [10.077221, 56.686104],
              [10.17722, 56.696388],
              [10.31611, 56.69611],
              [10.33861, 56.695274],
              [10.3475, 56.689995],
              [10.353333, 56.682777000000101],
              [10.36055, 56.670273],
              [10.361944, 56.664444],
              [10.36360900000011, 56.645],
              [10.36360900000011, 56.638885],
              [10.35861, 56.631660000000124],
              [10.34094, 56.622604000000138],
              [10.331989, 56.616249],
              [10.329277, 56.614441],
              [10.31278, 56.611774],
              [10.307943, 56.610443],
              [10.285276, 56.600555],
              [10.273333, 56.59305],
              [10.245554, 56.573326000000122],
              [10.218887, 56.55305],
              [10.210554000000116, 56.535553],
              [10.187777, 56.4686],
              [10.230833, 56.47305],
              [10.22611, 56.489166],
              [10.224165, 56.506943],
              [10.223888000000102, 56.53833],
              [10.230276, 56.54944],
              [10.236666, 56.553604],
              [10.308666, 56.578159000000142],
              [10.329666, 56.569992000000127],
              [10.330499, 56.566162000000134],
              [10.358332000000132, 56.562218],
              [10.36055, 56.55971],
              [10.36861, 56.553329],
              [10.41472, 56.528053],
              [10.42583, 56.524162000000103],
              [10.508888000000127, 56.510826],
              [10.530277, 56.50833],
              [10.584999, 56.511383],
              [10.646111, 56.52166],
              [10.76528, 56.532494],
              [10.786943, 56.534164],
              [10.84417, 56.523888],
              [10.85111, 56.520828000000108],
              [10.86083200000013, 56.515831],
              [10.872499, 56.508888],
              [10.960833, 56.445],
              [10.963055, 56.439438],
              [10.921389, 56.343605],
              [10.907499, 56.328606],
              [10.744999, 56.163887],
              [10.673887, 56.18777],
              [10.683054, 56.189163],
              [10.68639, 56.19416],
              [10.69222, 56.206383],
              [10.69194, 56.212219000000118],
              [10.690554, 56.217773000000136],
              [10.684444, 56.221107000000131],
              [10.66861, 56.226662],
              [10.6475, 56.229439],
              [10.636389, 56.229439],
              [10.625555000000134, 56.228333],
              [10.617777, 56.22639],
              [10.611111, 56.22361],
              [10.589722, 56.207222],
              [10.555277, 56.176941000000113],
              [10.549166000000127, 56.166382],
              [10.547777, 56.16],
              [10.550554, 56.154716000000121],
              [10.554165, 56.149994],
              [10.57222, 56.132774],
              [10.57778, 56.123055],
              [10.57555, 56.116661],
              [10.571388, 56.111382],
              [10.559999000000118, 56.103607000000125],
              [10.553610000000106, 56.10083],
              [10.545832000000132, 56.098885],
              [10.535831, 56.09833],
              [10.524166, 56.09861],
              [10.515276, 56.10083],
              [10.39, 56.161942],
              [10.353054, 56.19527],
              [10.358332000000132, 56.199715],
              [10.4275, 56.221107000000131],
              [10.43694, 56.221939],
              [10.442499000000112, 56.21833],
              [10.479443000000117, 56.220551000000114],
              [10.508333, 56.265],
              [10.5075, 56.270828],
              [10.501944, 56.274162],
              [10.44861, 56.291939],
              [10.400555000000111, 56.290833],
              [10.24679, 56.178551],
              [10.231943, 56.16666],
              [10.219166, 56.151665],
              [10.216110000000128, 56.146111],
              [10.215, 56.139717],
              [10.220833, 56.129715],
              [10.226387000000102, 56.125832000000116],
              [10.238888, 56.11916],
              [10.244165, 56.114998],
              [10.255833, 56.095551],
              [10.261665000000107, 56.07972],
              [10.279722, 56.018883],
              [10.251944, 55.920555],
              [10.249722000000133, 55.91416],
              [10.193054, 55.833054000000118],
              [10.189165, 55.828049],
              [10.183054, 55.824715],
              [10.17305, 55.826942000000145],
              [10.150555, 55.834999],
              [10.143888000000118, 55.838333],
              [10.140276, 55.843048000000124],
              [10.137499000000105, 55.84833],
              [10.13499800000011, 55.85916],
              [10.132221, 55.864441],
              [10.126665, 55.868332000000123],
              [10.11972, 55.871666000000118],
              [10.105555, 55.87722],
              [10.09389, 55.878609],
              [10.061388, 55.878609],
              [10.04972, 55.878319],
              [10.01229, 55.874622000000102],
              [9.982498, 55.871666000000118],
              [9.871666, 55.849998000000141],
              [9.86555, 55.846382000000119],
              [9.867222, 55.840828000000101],
              [9.873888, 55.837776],
              [9.882221, 55.83527400000014],
              [9.892221, 55.833328],
              [9.922777, 55.82861],
              [9.956388, 55.825],
              [10.0, 55.82164],
              [10.040277, 55.81694],
              [10.04861, 55.814438000000109],
              [10.045832, 55.750275],
              [9.992777, 55.704994],
              [9.831665, 55.671387],
              [9.811666, 55.66944],
              [9.802221, 55.670273],
              [9.737498, 55.683773],
              [9.73267, 55.685276000000101],
              [9.72516, 55.689606],
              [9.68778, 55.703606],
              [9.671944, 55.708885],
              [9.649721, 55.711388],
              [9.638887000000125, 55.711388],
              [9.55722, 55.708885],
              [9.55, 55.705826],
              [9.552776, 55.70055],
              [9.558332, 55.696663],
              [9.566387, 55.694443],
              [9.574165, 55.693329000000119],
              [9.585278, 55.693329000000119],
              [9.616665, 55.695],
              [9.639444, 55.692772],
              [9.652777, 55.686661000000129],
              [9.721722, 55.653107],
              [9.819166, 55.604721],
              [9.70417, 55.531105000000139],
              [9.592777, 55.426109],
              [9.588333, 55.421661],
              [9.5875, 55.414719000000105],
              [9.590277000000128, 55.410271000000137],
              [9.59805, 55.401665],
              [9.603611000000114, 55.3975],
              [9.610275000000115, 55.39444],
              [9.599998000000141, 55.378326],
              [9.596943000000124, 55.373329000000126],
              [9.596666000000141, 55.367218],
              [9.66111, 55.287498000000141],
              [9.6675, 55.28083],
              [9.67333200000013, 55.277222],
              [9.683887, 55.272774],
              [9.69444, 55.268883],
              [9.706944000000135, 55.265549],
              [9.71111100000013, 55.26111],
              [9.712221000000113, 55.258331],
              [9.711666, 55.244995],
              [9.711388000000113, 55.241661],
              [9.71, 55.23888],
              [9.68861, 55.196938],
              [9.683054, 55.192497000000117],
              [9.676388, 55.189995],
              [9.660555, 55.185272],
              [9.638611, 55.180832],
              [9.633888, 55.181664000000126],
              [9.619999, 55.19111],
              [9.606943000000115, 55.193886],
              [9.590555, 55.193054],
              [9.577221, 55.190552],
              [9.565277, 55.187218000000144],
              [9.489443000000108, 55.151939],
              [9.463055, 55.128609],
              [9.45917, 55.123886],
              [9.461943, 55.11805],
              [9.5075, 55.050278],
              [9.548611, 55.032494],
              [9.636389, 55.016388],
              [9.71917, 54.99472],
              [9.722776, 54.99305],
              [9.727499, 54.989441000000113],
              [9.73305, 54.982498000000135],
              [9.746666000000118, 54.947777],
              [9.76417, 54.901665],
              [9.768055, 54.891106],
              [9.75028, 54.84111],
              [9.747221, 54.8361],
              [9.742777, 54.831383],
              [9.737221, 54.827774],
              [9.726665, 54.827499],
              [9.627777, 54.851944],
              [9.620554, 54.855270000000132],
              [9.614166, 54.890549],
              [9.63361, 54.901108],
              [9.642776, 54.9025],
              [9.646944, 54.906944000000124],
              [9.648054000000116, 54.913887000000102],
              [9.643888, 54.91833],
              [9.638611, 54.922218],
              [9.632221000000129, 54.925278000000105],
              [9.612778000000105, 54.928329],
              [9.601944, 54.928604000000121],
              [9.593054, 54.926941],
              [9.502777, 54.868332000000123],
              [9.458055000000115, 54.838608000000136],
              [9.45278, 54.835],
              [9.448332000000107, 54.83027600000014],
              [9.445358, 54.825401],
              [9.414721, 54.833328],
              [9.3925, 54.83527400000014],
              [9.378611, 54.829720000000123],
              [9.368889, 54.82278],
              [9.36861, 54.820831],
              [9.358889, 54.812492],
              [9.342777, 54.808609000000104],
              [9.253611, 54.80888],
              [9.243055, 54.816383],
              [9.23361, 54.82444],
              [9.22805, 54.83416],
              [9.23361, 54.845551000000114],
              [9.22416, 54.853607],
              [9.168888, 54.864998000000128],
              [8.94111, 54.905548],
              [8.919998000000135, 54.908051],
              [8.841301000000101, 54.913689],
              [8.82889, 54.913887000000102],
              [8.785831, 54.9061],
              [8.763054, 54.898888],
              [8.754721000000131, 54.897217],
              [8.719444, 54.891106],
              [8.699444, 54.892776],
              [8.68611, 54.898888],
              [8.66454, 54.913094],
              [8.654722000000106, 54.981941],
              [8.676109, 55.114166],
              [8.561388000000136, 55.10083],
              [8.561943, 55.094719],
              [8.560833, 55.088051],
              [8.556389, 55.083328],
              [8.504166000000112, 55.061943],
              [8.495832000000121, 55.060272],
              [8.487499, 55.06277],
              [8.480833, 55.06583],
              [8.471388, 55.073608],
              [8.468054, 55.084999],
              [8.456944, 55.123886],
              [8.45833, 55.130554],
              [8.47, 55.169998000000135],
              [8.471943, 55.17582700000014],
              [8.47555, 55.181389],
              [8.483055, 55.19111],
              [8.488333000000125, 55.195],
              [8.506388, 55.197495000000117],
              [8.558054000000141, 55.19416],
              [8.568054000000132, 55.193329],
              [8.585554, 55.188606],
              [8.592777, 55.185555],
              [8.593616, 55.179817],
              [8.588333, 55.176384],
              [8.567221000000131, 55.16861],
              [8.561666, 55.164719],
              [8.553888, 55.154442],
              [8.554443, 55.149719],
              [8.569166000000109, 55.144165],
              [8.58475, 55.140495],
              [8.632158000000118, 55.13239],
              [8.643888, 55.131104000000107],
              [8.68361, 55.1325],
              [8.688889, 55.136383],
              [8.691387000000134, 55.14222],
              [8.692221, 55.149162000000103],
              [8.689444, 55.160271],
              [8.661388000000102, 55.203331],
              [8.658054000000106, 55.258606],
              [8.658609, 55.301666],
              [8.662498, 55.313606000000107],
              [8.663887000000102, 55.320549],
              [8.66222, 55.3325],
              [8.63805, 55.402771],
              [8.623888, 55.427498],
              [8.612499000000128, 55.434715],
              [8.599443, 55.44111],
              [8.589722, 55.443054000000132],
              [8.536110000000122, 55.449165],
              [8.48, 55.453888],
              [8.468054, 55.454163],
              [8.44972, 55.451942],
              [8.439999, 55.452217000000132],
              [8.307499000000121, 55.553329],
              [8.256943, 55.491104000000121],
              [8.104166000000134, 55.537773000000129],
              [8.091389, 55.544716000000108],
              [8.087221, 55.548882],
              [8.087221, 55.554993],
              [8.093332, 55.565826],
              [8.11944, 55.59333],
              [8.126665000000116, 55.603333],
              [8.13944400000014, 55.624718],
              [8.17861, 55.710548],
              [8.18222, 55.723053000000107],
              [8.185555000000136, 55.74305],
              [8.183611, 55.75527],
              [8.16639, 55.84833],
              [8.15333, 55.899162],
              [8.14305, 55.93805],
              [8.134443, 55.959442],
              [8.126665000000116, 55.979721],
              [8.12611, 55.983055],
              [8.127222, 55.98555],
              [8.130833, 55.986938000000123],
              [8.13944400000014, 55.984718],
              [8.1475, 55.976944000000117],
              [8.152222000000108, 55.968605],
              [8.154722, 55.96361],
              [8.158333, 55.953606],
              [8.161943000000122, 55.942772],
              [8.168055, 55.920555],
              [8.173332, 55.897499],
              [8.18222, 55.83944],
              [8.183332, 55.814720000000136],
              [8.186388000000136, 55.809998],
              [8.193609, 55.80805],
              [8.202221, 55.809998],
              [8.276667, 55.834999],
              [8.32389, 55.85611],
              [8.3941650000001, 55.891937],
              [8.397221, 55.897499],
              [8.38528, 55.92333],
              [8.31694, 56.010826],
              [8.31694, 56.017220000000123],
              [8.313055, 56.04666],
              [8.312498, 56.050278000000105],
              [8.31111, 56.053055],
              [8.308887, 56.054718],
              [8.270832, 56.07499700000011],
              [8.255, 56.082771],
              [8.22389, 56.092773],
              [8.146111, 56.111107],
              [8.141109, 56.111664],
              [8.137499, 56.110832],
              [8.141109, 56.10249],
              [8.145277000000135, 56.080826000000116],
              [8.14639, 56.071106],
              [8.14639, 56.067497],
              [8.1425, 55.999161],
              [8.14194300000014, 55.996384],
              [8.133333, 55.994164],
              [8.127222, 55.994438],
              [8.119165, 55.996941],
              [8.113888, 56.000832],
              [8.108332, 56.01777600000014],
              [8.10111, 56.052216],
              [8.101665000000139, 56.071388],
              [8.10555, 56.11805],
              [8.12278, 56.3491590000001],
              [8.119999000000121, 56.450272],
              [8.118332, 56.53083],
              [8.120832000000121, 56.549995],
              [8.12278, 56.556107],
              [8.156111, 56.63777],
              [8.165277, 56.653328000000101],
              [8.175554, 56.66777],
              [8.194721, 56.69138],
              [8.209166, 56.707771],
              [8.212221, 56.709442000000138],
              [8.216665, 56.710548000000131],
              [8.221109, 56.709442000000138],
              [8.22416, 56.707771],
              [8.229166, 56.703331],
              [8.237778000000105, 56.687775000000101],
              [8.223331, 56.66499],
              [8.211388, 56.653885],
              [8.206388, 56.646385],
              [8.203888, 56.638054],
              [8.2058320000001, 56.635551],
              [8.24972, 56.604996],
              [8.32722, 56.579994],
              [8.390554000000122, 56.582222],
              [8.40167, 56.581108],
              [8.415833, 56.578331],
              [8.470833, 56.561104000000114],
              [8.51916, 56.54305],
              [8.592222, 56.50388],
              [8.626665, 56.478607000000125],
              [8.629721, 56.47666],
              [8.632776, 56.475273000000129],
              [8.646944000000133, 56.472771],
              [8.653055, 56.472771],
              [8.728333, 56.48222],
              [8.739443000000108, 56.486382],
              [8.745832, 56.49305],
              [8.747221, 56.498886],
              [8.756914, 56.549],
              [8.758055000000127, 56.549721],
              [8.763054, 56.553886],
              [8.765554000000122, 56.556389],
              [8.766109, 56.558609000000104],
              [8.764444, 56.564438000000109],
              [8.759443, 56.568604],
              [8.729443000000117, 56.57944],
              [8.712776, 56.58416],
              [8.70666, 56.587776],
              [8.680832, 56.614166],
              [8.68028, 56.617218],
              [8.68111, 56.619995],
              [8.838333, 56.715828],
              [8.845554000000106, 56.729439],
              [8.862778, 56.750832000000116],
              [8.873055, 56.762497],
              [8.952499, 56.804718],
              [8.9675, 56.80583],
              [9.070000000000107, 56.80778],
              [9.07557, 56.807449],
              [9.105276000000117, 56.79583],
              [9.111387, 56.792770000000132],
              [9.113333, 56.790276],
              [9.152498, 56.70388800000012],
              [9.144999, 56.70083],
              [9.134722, 56.693329],
              [9.055277, 56.630554000000132],
              [9.053333, 56.628052],
              [9.043333, 56.602219000000105],
              [9.043333, 56.599159],
              [9.04611, 56.590553000000114],
              [9.055555, 56.571663],
              [9.05861, 56.56694],
              [9.064165000000116, 56.56305],
              [9.073332000000107, 56.561386],
              [9.081388, 56.563332000000116],
              [9.09111, 56.568886],
              [9.093611, 56.57139],
              [9.101387, 56.583611],
              [9.100277, 56.589996],
              [9.09833, 56.592773000000136],
              [9.097500000000139, 56.598610000000122],
              [9.099443000000122, 56.604439000000127],
              [9.103888, 56.609161],
              [9.106943, 56.61055],
              [9.177776, 56.626663],
              [9.210833, 56.633049000000142],
              [9.225832, 56.63444],
              [9.248888, 56.633331],
              [9.274166, 56.629997],
              [9.280054, 56.62316],
              [9.284056, 56.619164],
              [9.284389, 56.615334],
              [9.28355, 56.611832],
              [9.281944, 56.604164],
              [9.273333, 56.602219000000105],
              [9.264999000000103, 56.599159],
              [9.25166, 56.583328],
              [9.25083, 56.58027600000014],
              [9.2675, 56.558327],
              [9.27833, 56.547775],
              [9.312498, 56.525551000000121],
              [9.31722, 56.524994],
              [9.321665, 56.525551000000121],
              [9.371111, 56.540833000000134],
              [9.373055000000136, 56.54305],
              [9.373888000000136, 56.546104],
              [9.37611, 56.55888],
              [9.376389, 56.564995],
              [9.370832, 56.568886],
              [9.361666000000127, 56.570549],
              [9.344166, 56.56638],
              [9.323056000000122, 56.67638],
              [9.32, 56.68139],
              [9.304443, 56.699997],
              [9.301943000000108, 56.702217],
              [9.294722, 56.70499],
              [9.288887, 56.705551],
              [9.28028, 56.70416],
              [9.276388, 56.703049000000135],
              [9.273333, 56.701111],
              [9.26638800000012, 56.695],
              [9.260555000000124, 56.69138],
              [9.186388, 56.66972],
              [9.180832000000123, 56.66944100000012],
              [9.173332, 56.67194400000011],
              [9.16972, 56.673882],
              [9.16611, 56.67805],
              [9.165, 56.892494],
              [9.178200000000118, 56.916031],
              [9.290277000000117, 56.99555],
              [9.301109, 57.000000000000114],
              [9.309444, 57.001938],
              [9.365555, 57.012215],
              [9.409721, 57.018326000000116],
              [9.42555, 57.02],
              [9.46694, 57.01944],
              [9.47805, 57.018883],
              [9.51694300000014, 57.01611],
              [9.521944, 57.015549],
              [9.551109, 57.007217],
              [9.559166000000118, 57.00471],
              [9.68611, 57.038605],
              [9.76417, 57.053329000000133],
              [9.774721, 57.054161],
              [9.80722, 57.050552],
              [9.853611, 57.04555],
              [9.939999000000114, 57.054161],
              [9.945, 57.054993000000138],
              [9.95167, 57.058327000000133],
              [9.966499, 57.066544],
              [9.974274, 57.071732000000111],
            ],
          ],
          [
            [
              [11.19583, 57.310829000000126],
              [11.079166, 57.250275000000101],
              [11.058332000000121, 57.240829000000133],
              [11.023888, 57.22972],
              [10.997499, 57.22333],
              [10.982222, 57.22166],
              [10.961943000000133, 57.238052],
              [10.949999000000105, 57.245827000000133],
              [10.933887000000141, 57.250275000000101],
              [10.922499, 57.250832],
              [10.907776, 57.248329],
              [10.896111, 57.24472],
              [10.884722, 57.24555],
              [10.874998, 57.247772000000111],
              [10.865, 57.25222],
              [10.855, 57.260826],
              [10.854443000000117, 57.26305],
              [10.860554, 57.26722],
              [10.918055, 57.301109],
              [10.921389, 57.302773],
              [11.02583, 57.320274],
              [11.144444, 57.33138300000013],
              [11.15028, 57.33166],
              [11.183887, 57.327499000000103],
              [11.188889, 57.32638500000013],
              [11.191944, 57.324997],
              [11.194443, 57.322777],
              [11.19694, 57.314163000000121],
              [11.19583, 57.310829000000126],
            ],
          ],
          [
            [
              [10.432499000000121, 57.592216],
              [10.43111, 57.579163],
              [10.435833000000116, 57.551384],
              [10.438332000000116, 57.543327],
              [10.444721000000129, 57.532776000000126],
              [10.448332000000107, 57.52833],
              [10.453054, 57.524162000000103],
              [10.528055000000109, 57.41389],
              [10.54222, 57.229996000000142],
              [10.534721, 57.223885],
              [10.53083, 57.22166],
              [10.51333, 57.214722],
              [10.45333, 57.184715],
              [10.442778, 57.176666],
              [10.423887, 57.157219],
              [10.414165, 57.143326],
              [10.33662, 56.991665],
              [10.244999000000121, 56.989716000000101],
              [10.22805, 56.991104],
              [10.218611, 56.992775],
              [10.193054, 57.002777],
              [10.151943, 57.024719000000118],
              [10.11972, 57.041664],
              [10.031944, 57.083046],
              [10.02083, 57.086929],
              [10.01166, 57.089157],
              [10.006666, 57.089989],
              [10.00028, 57.08967],
              [9.5, 57.046387],
              [9.289444000000117, 57.00471],
              [9.269722, 56.998329],
              [9.25528, 56.996109],
              [9.243889000000138, 56.99555],
              [9.23389, 56.997215],
              [9.221388, 57.001389000000131],
              [9.20361, 57.011665],
              [9.181389, 57.023888],
              [9.15917, 57.035271],
              [9.140554000000122, 57.04277],
              [9.115549, 57.052773000000116],
              [9.118610000000103, 57.04805],
              [9.12028, 57.03916],
              [9.115833, 57.034996],
              [9.107498000000135, 57.03249],
              [9.038610000000119, 57.01194],
              [9.032776, 57.011665],
              [9.027777000000128, 57.01277],
              [9.027222, 57.015549],
              [9.028610000000128, 57.018608],
              [9.0275, 57.021111],
              [9.021387, 57.024437],
              [9.01055, 57.025833],
              [9.000555, 57.024994000000106],
              [8.885832000000107, 56.997498],
              [8.827166, 56.971069],
              [8.775, 56.95194],
              [8.766109, 56.94971],
              [8.754999, 56.950554],
              [8.73555, 56.95666],
              [8.724443000000122, 56.957497],
              [8.68111, 56.949997],
              [8.67333, 56.94722],
              [8.670832, 56.945274],
              [8.619165000000123, 56.88555],
              [8.617222, 56.873329],
              [8.617777, 56.863052],
              [8.616943000000106, 56.85694100000012],
              [8.611666000000127, 56.84861],
              [8.607498, 56.844162],
              [8.57249800000011, 56.81944],
              [8.563889000000131, 56.813606],
              [8.56, 56.812218],
              [8.533054, 56.803886],
              [8.51444, 56.800552],
              [8.50111, 56.7972180000001],
              [8.491665000000125, 56.792496],
              [8.48722, 56.788055],
              [8.48361, 56.782494],
              [8.48278, 56.779999],
              [8.463055000000111, 56.697777],
              [8.415797, 56.678127],
              [8.44171, 56.67435],
              [8.445214, 56.674011],
              [8.48838000000012, 56.67034],
              [8.51444, 56.66777],
              [8.519444000000135, 56.668610000000115],
              [8.53583, 56.673882],
              [8.550833, 56.68222],
              [8.57028, 56.688889],
              [8.58, 56.68972],
              [8.584999, 56.689163],
              [8.591389, 56.686104],
              [8.594999, 56.680832],
              [8.60722, 56.630554000000132],
              [8.59889, 56.60833],
              [8.5975, 56.60611],
              [8.554998, 56.582497],
              [8.549444, 56.582222],
              [8.54139, 56.584442],
              [8.532221, 56.589439],
              [8.524166, 56.595276000000126],
              [8.47805, 56.631386],
              [8.4591, 56.642181],
              [8.457266, 56.645184],
              [8.453599, 56.64918],
              [8.448765, 56.65301],
              [8.43693, 56.65852],
              [8.398278, 56.672043000000144],
              [8.36833, 56.677216],
              [8.248888, 56.698608],
              [8.240276, 56.707222000000115],
              [8.23860900000011, 56.712776],
              [8.235554, 56.736938],
              [8.234999, 56.755554],
              [8.235832, 56.768883],
              [8.236387, 56.775551],
              [8.245832, 56.806664],
              [8.25611, 56.822777],
              [8.26417, 56.83277],
              [8.29055, 56.860275000000115],
              [8.336666, 56.905548],
              [8.378887, 56.945549],
              [8.450554000000125, 57.004997],
              [8.577221000000122, 57.096107],
              [8.60389, 57.11472],
              [8.617222, 57.121666],
              [8.624166, 57.124443],
              [8.628611, 57.125275],
              [8.639444, 57.124718000000144],
              [8.654444, 57.121666],
              [8.713888, 57.10611],
              [8.737221, 57.102219],
              [8.766109, 57.101105],
              [8.804998, 57.103882000000112],
              [8.846666, 57.10833],
              [8.89416, 57.119995000000131],
              [9.017221, 57.15361],
              [9.079721, 57.145271],
              [9.16139, 57.137497],
              [9.19611, 57.136108],
              [9.243889000000138, 57.13694],
              [9.26528, 57.138885],
              [9.38416500000011, 57.150276],
              [9.39, 57.151108000000136],
              [9.406944000000124, 57.156944],
              [9.458887, 57.176109],
              [9.47361, 57.181664],
              [9.495832000000121, 57.190277],
              [9.540833, 57.213882],
              [9.54666, 57.2175],
              [9.580555, 57.241104],
              [9.649443, 57.303329],
              [9.707777000000135, 57.364998],
              [9.720554, 57.37944],
              [9.731388, 57.395271],
              [9.763611, 57.435555],
              [9.772778, 57.444717],
              [9.793333000000132, 57.462219],
              [9.949720000000127, 57.583611],
              [9.960278, 57.588333],
              [9.971109, 57.589439],
              [10.0, 57.589722000000108],
              [10.04361, 57.588608000000136],
              [10.104166, 57.589722000000108],
              [10.12861, 57.590271],
              [10.16111, 57.592216],
              [10.18111, 57.594994],
              [10.218332, 57.602219000000105],
              [10.26694, 57.613052],
              [10.2897210000001, 57.620827000000133],
              [10.300833, 57.625549],
              [10.408333, 57.673607],
              [10.45333, 57.697495000000117],
              [10.51, 57.725273],
              [10.5375, 57.737495],
              [10.544167, 57.740273],
              [10.56111, 57.74528],
              [10.577221, 57.746666],
              [10.605276, 57.744164000000126],
              [10.644999, 57.737495],
              [10.645953000000134, 57.736267],
              [10.62194, 57.727776],
              [10.578054, 57.710831],
              [10.560276000000101, 57.702499000000103],
              [10.526388, 57.683609],
              [10.505554000000132, 57.666664],
              [10.48111, 57.645828],
              [10.461666, 57.628609],
              [10.454721, 57.622215],
              [10.447498, 57.614998000000128],
              [10.437777, 57.603333],
              [10.432499000000121, 57.592216],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "EI",
        ISO2: "IE",
        ISO3: "IRL",
        UN: 372,
        NAME: "Ireland",
        AREA: 6889,
        POP2005: 4143294,
        REGION: 150,
        SUBREGION: 154,
        LON: -8.152,
        LAT: 53.177,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-9.65639, 53.222221],
              [-9.663334, 53.221382],
              [-9.68861, 53.222771],
              [-9.695557, 53.223328],
              [-9.70389, 53.226944000000117],
              [-9.709723, 53.232498000000135],
              [-9.72556, 53.263885],
              [-9.72472, 53.26805],
              [-9.67056, 53.28166],
              [-9.664446, 53.281944],
              [-9.660833, 53.279999],
              [-9.64194, 53.251938000000109],
              [-9.64861, 53.226944000000117],
              [-9.65639, 53.222221],
            ],
          ],
          [
            [
              [-9.964169, 54.018608],
              [-9.940556, 53.997772],
              [-9.93611, 53.99139],
              [-9.92389, 53.950554000000125],
              [-9.92389, 53.945831],
              [-9.92611, 53.923882],
              [-9.940834, 53.886665],
              [-9.943335, 53.883331],
              [-9.95056, 53.878326],
              [-9.955, 53.876663],
              [-9.96139, 53.875832],
              [-9.978613, 53.87944],
              [-10.05556, 53.909439],
              [-10.06139, 53.919716],
              [-10.062778, 53.923332],
              [-10.062778, 53.927773000000116],
              [-10.15222, 53.959717000000126],
              [-10.17417, 53.96083],
              [-10.26417, 53.968605000000139],
              [-10.268612, 53.974998],
              [-10.26556, 53.977776],
              [-10.19667, 54.008331000000112],
              [-10.18944, 54.008888],
              [-10.15889, 54.009163],
              [-10.125, 54.001663000000121],
              [-10.119522, 54.0],
              [-10.06917, 54.02166],
              [-10.06306, 54.0225],
              [-9.974167, 54.021942],
              [-9.96806, 54.020828000000108],
              [-9.964169, 54.018608],
            ],
          ],
          [
            [
              [-8.43694, 54.944443],
              [-8.44333, 54.943886000000134],
              [-8.448891, 54.945274],
              [-8.4525, 54.947777],
              [-8.454723, 54.95083],
              [-8.45389, 54.95499],
              [-8.450556, 54.957771],
              [-8.44417, 54.957497000000103],
              [-8.43861, 54.955276],
              [-8.43639, 54.951942],
              [-8.435, 54.948326],
              [-8.43694, 54.944443],
            ],
          ],
          [
            [
              [-8.518612, 54.964165],
              [-8.526669, 54.963882000000126],
              [-8.553057, 54.965828],
              [-8.558334, 54.966660000000104],
              [-8.562223, 54.969719000000111],
              [-8.56444, 54.972771],
              [-8.56361, 54.988884],
              [-8.55028, 55.008331],
              [-8.54695, 55.01194],
              [-8.538612, 55.015831],
              [-8.530834, 55.015549],
              [-8.526945, 55.013885],
              [-8.493334, 54.997498000000121],
              [-8.49056, 54.99472],
              [-8.484446, 54.97583],
              [-8.48556, 54.971382],
              [-8.48944, 54.969994],
              [-8.518612, 54.964165],
            ],
          ],
          [
            [
              [-7.40639, 54.953331],
              [-7.44389, 54.8825],
              [-7.458056, 54.857773],
              [-7.482839, 54.82993],
              [-7.553334, 54.762772],
              [-7.73917, 54.710548],
              [-7.819167, 54.731110000000115],
              [-7.824445, 54.73444400000011],
              [-7.82972, 54.735550000000103],
              [-7.843056, 54.733604],
              [-7.92528, 54.702217],
              [-7.927501, 54.698883000000137],
              [-7.91389, 54.671104],
              [-7.90639, 54.664444],
              [-7.855278, 54.63472],
              [-7.849445, 54.633049],
              [-7.7775, 54.626938000000109],
              [-7.752223, 54.594444],
              [-7.833611, 54.55389],
              [-7.95083, 54.532219000000111],
              [-8.04695, 54.507217],
              [-8.17167, 54.463879000000134],
              [-8.15944, 54.44194],
              [-8.15667, 54.438606],
              [-8.065556, 54.372772],
              [-8.05583, 54.36639],
              [-8.045279, 54.361382],
              [-8.030279, 54.357216000000108],
              [-7.94139, 54.299438],
              [-7.90028, 54.294167],
              [-7.878056, 54.28916],
              [-7.875556, 54.28583],
              [-7.874722, 54.282494],
              [-7.86944, 54.253052],
              [-7.86917, 54.23111],
              [-7.8675, 54.2241590000001],
              [-7.86194, 54.218048],
              [-7.85139, 54.212219],
              [-7.82056, 54.199165000000107],
              [-7.81556, 54.199165000000107],
              [-7.74778, 54.200272],
              [-7.7025, 54.202499000000103],
              [-7.69694, 54.202499000000103],
              [-7.62778, 54.169716000000108],
              [-7.624445, 54.166382000000112],
              [-7.62306, 54.16305],
              [-7.624167, 54.155548],
              [-7.62361, 54.148888],
              [-7.620001, 54.146111000000133],
              [-7.610001, 54.142494],
              [-7.55944, 54.126938],
              [-7.330278, 54.113052],
              [-7.313334, 54.112495000000138],
              [-7.28694, 54.121941000000106],
              [-7.280834, 54.124992000000134],
              [-7.14583, 54.225273],
              [-7.14139, 54.252495],
              [-7.1425, 54.255829],
              [-7.145, 54.258888000000127],
              [-7.175556, 54.28916],
              [-7.16083, 54.336662],
              [-7.05833, 54.41],
              [-7.03639, 54.417221],
              [-7.030834, 54.41777],
              [-7.02528, 54.416939000000127],
              [-6.974445, 54.401665],
              [-6.92694, 54.379166000000112],
              [-6.91722, 54.373604],
              [-6.87611, 54.345276],
              [-6.87, 54.33888],
              [-6.85056, 54.291939],
              [-6.851667, 54.287498000000141],
              [-6.73472, 54.18361],
              [-6.65556, 54.065277],
              [-6.632501, 54.045273000000122],
              [-6.625, 54.039162],
              [-6.620001, 54.03722],
              [-6.608056, 54.042221],
              [-6.60583, 54.044441],
              [-6.5675, 54.05082700000014],
              [-6.4475, 54.058327],
              [-6.365834, 54.09944],
              [-6.36611, 54.10249],
              [-6.36528, 54.105553],
              [-6.363611, 54.108604],
              [-6.360001, 54.111664000000133],
              [-6.355, 54.114166],
              [-6.34972, 54.115555],
              [-6.33889, 54.115555],
              [-6.288611, 54.108604],
              [-6.278611, 54.107216],
              [-6.2725, 54.104996000000142],
              [-6.2675, 54.101944],
              [-6.26697, 54.099831],
              [-6.27083, 54.097771],
              [-6.26972, 54.093605],
              [-6.240834, 54.074715],
              [-6.17056, 54.036942],
              [-6.158334, 54.030548],
              [-6.14528, 54.02861],
              [-6.133889, 54.03139],
              [-6.12861, 54.029716],
              [-6.10528, 54.002777],
              [-6.10333, 53.999443],
              [-6.10306, 53.995827],
              [-6.105, 53.992218],
              [-6.10833, 53.989166000000125],
              [-6.120833, 53.982773],
              [-6.13806, 53.974998],
              [-6.14861, 53.972221],
              [-6.155001, 53.972221],
              [-6.1625, 53.972771],
              [-6.22806, 53.987778],
              [-6.288611, 54.00444],
              [-6.31194, 54.009438],
              [-6.33028, 54.013054],
              [-6.344167, 54.01444],
              [-6.35056, 54.013885],
              [-6.35556, 54.01221],
              [-6.35889, 54.009438],
              [-6.38083, 53.953606],
              [-6.38194, 53.94944],
              [-6.38083, 53.91722],
              [-6.37944, 53.909439],
              [-6.37361, 53.899719000000118],
              [-6.36222, 53.888054],
              [-6.351667, 53.88083],
              [-6.345, 53.876389000000131],
              [-6.33694, 53.871941],
              [-6.325556, 53.869164],
              [-6.28972, 53.86388],
              [-6.255, 53.833611],
              [-6.240001, 53.782776],
              [-6.24694, 53.754166],
              [-6.25097, 53.728249],
              [-6.25111, 53.719444000000124],
              [-6.241127, 53.681198],
              [-6.23639, 53.671387],
              [-6.21417, 53.635551],
              [-6.14917, 53.590271000000143],
              [-6.14444, 53.58833],
              [-6.123889, 53.585831],
              [-6.10139, 53.583054],
              [-6.081112, 53.563606000000107],
              [-6.0775, 53.548332],
              [-6.076945, 53.53999],
              [-6.077778, 53.525833],
              [-6.07889, 53.522499],
              [-6.14972, 53.386108],
              [-6.159167, 53.382774],
              [-6.22472, 53.35388],
              [-6.22444, 53.35166],
              [-6.22083, 53.342216],
              [-6.18028, 53.307495],
              [-6.11056, 53.252495],
              [-6.03556, 53.11388],
              [-6.03361, 53.10611],
              [-6.013056, 52.945],
              [-6.06944, 52.865829],
              [-6.1075, 52.839996],
              [-6.1175, 52.832222],
              [-6.120001, 52.828888],
              [-6.1375, 52.80167],
              [-6.14528, 52.787498],
              [-6.14833, 52.77916],
              [-6.15056, 52.766106],
              [-6.14778, 52.738327],
              [-6.19111, 52.695831],
              [-6.19667, 52.689438000000109],
              [-6.21417, 52.667496],
              [-6.218056, 52.66027],
              [-6.22222, 52.643326],
              [-6.22278, 52.629997000000117],
              [-6.22028, 52.618607],
              [-6.21667, 52.611938],
              [-6.21111, 52.606384],
              [-6.20917, 52.60305],
              [-6.201112, 52.580551],
              [-6.2, 52.564163],
              [-6.200278, 52.555275],
              [-6.20333, 52.547775000000115],
              [-6.21111, 52.53833],
              [-6.23028, 52.517220000000123],
              [-6.244722, 52.502777],
              [-6.361945, 52.392776],
              [-6.459723, 52.376106000000107],
              [-6.46667, 52.377777],
              [-6.475, 52.37444],
              [-6.498889, 52.356110000000115],
              [-6.4975, 52.351944],
              [-6.41167, 52.285828],
              [-6.40833, 52.284164],
              [-6.38194, 52.277222000000108],
              [-6.33361, 52.251106],
              [-6.329722, 52.248886],
              [-6.321667, 52.240273],
              [-6.31944, 52.23722],
              [-6.32528, 52.22583],
              [-6.329722, 52.219162],
              [-6.357779, 52.18055],
              [-6.361112, 52.177498000000128],
              [-6.366389, 52.176666],
              [-6.3725, 52.17610900000011],
              [-6.38667, 52.176941],
              [-6.39833, 52.179443000000106],
              [-6.400278, 52.182495],
              [-6.46667, 52.193054],
              [-6.62278, 52.192215],
              [-6.78944, 52.216942],
              [-6.818334, 52.187218],
              [-6.82889, 52.17194400000011],
              [-6.83278, 52.169716],
              [-6.87056, 52.163055],
              [-6.9025, 52.166382],
              [-6.91306, 52.20305],
              [-6.91639, 52.20916],
              [-6.97944, 52.276665],
              [-6.994722, 52.282776000000126],
              [-6.99612, 52.282242],
              [-6.998889, 52.276108000000136],
              [-6.998056, 52.2725],
              [-6.995382, 52.269821],
              [-6.98889, 52.264160000000118],
              [-6.97389, 52.233604],
              [-6.97056, 52.221939000000134],
              [-6.97417, 52.168053],
              [-6.998334, 52.140831000000105],
              [-7.00528, 52.13611],
              [-7.03639, 52.13277],
              [-7.100834, 52.128883],
              [-7.105834, 52.130554000000132],
              [-7.10694, 52.134163000000115],
              [-7.160278, 52.15028],
              [-7.36889, 52.134163000000115],
              [-7.435, 52.126106],
              [-7.578889, 52.100273],
              [-7.62028, 52.06472],
              [-7.60194, 52.06305],
              [-7.5675, 52.059166],
              [-7.54806, 52.056389],
              [-7.546112, 52.05305],
              [-7.54556, 52.048882],
              [-7.585, 51.99472],
              [-7.58833, 51.991661],
              [-7.71278, 51.938889000000131],
              [-7.725278, 51.93777],
              [-7.811945, 51.941666],
              [-7.81778, 51.942772],
              [-7.823611, 51.944443],
              [-7.83167, 51.948326],
              [-7.85134, 51.976799],
              [-7.85139, 51.961105],
              [-7.85167, 51.948326],
              [-7.85389, 51.940277],
              [-7.88917, 51.890274],
              [-8.01833, 51.834717000000126],
              [-8.08667, 51.810829],
              [-8.16639, 51.792221],
              [-8.172224, 51.791664],
              [-8.23333, 51.795830000000137],
              [-8.239, 51.804108],
              [-8.2415, 51.805107000000135],
              [-8.24383, 51.80677],
              [-8.24433, 51.811440000000118],
              [-8.226667, 51.83138300000013],
              [-8.22222, 51.833611],
              [-8.206945, 51.836662000000103],
              [-8.18111, 51.84861],
              [-8.175556, 51.854439],
              [-8.210556, 51.88444],
              [-8.286667, 51.889442000000145],
              [-8.365835, 51.89222],
              [-8.38278, 51.89277600000014],
              [-8.38593, 51.892059000000131],
              [-8.415279, 51.88528],
              [-8.421112, 51.88389],
              [-8.42944, 51.880554],
              [-8.42831, 51.879524],
              [-8.426668, 51.878052],
              [-8.419445, 51.876938000000109],
              [-8.399445, 51.87555],
              [-8.37195, 51.876389],
              [-8.35778, 51.87555],
              [-8.346111, 51.873886],
              [-8.341112, 51.871666],
              [-8.334723, 51.866943],
              [-8.30433, 51.820381],
              [-8.297001, 51.803719],
              [-8.297168, 51.801216],
              [-8.296946, 51.760826],
              [-8.308334, 51.744995],
              [-8.31306, 51.738609],
              [-8.339724, 51.722771000000137],
              [-8.34889, 51.719444],
              [-8.417778, 51.706383],
              [-8.52417, 51.665276],
              [-8.54139, 51.648331],
              [-8.557501, 51.633888],
              [-8.694168, 51.573608],
              [-8.69917, 51.572495],
              [-8.73722, 51.576111],
              [-8.88278, 51.56721],
              [-8.98389, 51.559715],
              [-9.11222, 51.54805],
              [-9.16361, 51.51777600000014],
              [-9.22611, 51.484161],
              [-9.23417, 51.48055],
              [-9.35278, 51.470551],
              [-9.366667, 51.469719],
              [-9.378334, 51.470833],
              [-9.45472, 51.53083],
              [-9.63833, 51.50944],
              [-9.703611, 51.469994],
              [-9.703611, 51.467216000000121],
              [-9.7075, 51.464996],
              [-9.716946, 51.46194],
              [-9.76806, 51.451942],
              [-9.79806, 51.447220000000129],
              [-9.807516, 51.44622],
              [-9.817501, 51.445549],
              [-9.816668, 51.473053],
              [-9.800835, 51.490273],
              [-9.77472, 51.501938000000109],
              [-9.71667, 51.525551],
              [-9.7025, 51.529442000000131],
              [-9.67972, 51.537773],
              [-9.67056, 51.541382],
              [-9.65361, 51.548882000000106],
              [-9.64972, 51.551109],
              [-9.593889, 51.589722],
              [-9.591946, 51.609993],
              [-9.68111, 51.579994],
              [-9.785278, 51.548607],
              [-9.80528, 51.542770000000132],
              [-9.82944, 51.539993],
              [-9.83611, 51.54055000000011],
              [-9.84111, 51.541939],
              [-9.84472, 51.544167],
              [-9.84472, 51.547775],
              [-9.77917, 51.583885],
              [-9.74528, 51.599442000000124],
              [-9.613001, 51.64222],
              [-9.607, 51.643723],
              [-9.550556, 51.658333],
              [-9.525278, 51.660828],
              [-9.515, 51.66333],
              [-9.47056, 51.676384],
              [-9.46139, 51.680832],
              [-9.45167, 51.68805],
              [-9.45, 51.690826],
              [-9.44195, 51.712776],
              [-9.45167, 51.724716000000114],
              [-9.53556, 51.750000000000114],
              [-9.54861, 51.719994],
              [-9.55139, 51.717216],
              [-9.62694, 51.687996],
              [-9.630112, 51.686829],
              [-9.660779, 51.680164],
              [-9.66711, 51.678829],
              [-9.7775, 51.65778],
              [-9.806391, 51.653885000000116],
              [-9.93028, 51.629166000000112],
              [-9.93028, 51.62555],
              [-9.932501, 51.62221],
              [-9.935556, 51.619720000000143],
              [-9.946667, 51.613884],
              [-10.02583, 51.595276],
              [-10.03694, 51.593048],
              [-10.04361, 51.592773],
              [-10.1325, 51.59333],
              [-10.130001, 51.61222],
              [-10.06028, 51.64361],
              [-9.98806, 51.677773],
              [-9.98083, 51.708328],
              [-9.991667, 51.710548],
              [-9.99611, 51.712494],
              [-9.998056, 51.71583],
              [-9.99667, 51.719444],
              [-9.976667, 51.729164],
              [-9.971945, 51.731384000000105],
              [-9.905556, 51.757774],
              [-9.776669, 51.800827],
              [-9.592501, 51.86472],
              [-9.57917, 51.869995000000131],
              [-9.5775, 51.87221],
              [-9.583612, 51.873604000000114],
              [-9.642223, 51.869438],
              [-9.68833, 51.86111],
              [-9.71, 51.856384],
              [-9.939167, 51.799438],
              [-10.05139, 51.771111000000133],
              [-10.10195, 51.752220000000136],
              [-10.18278, 51.78583],
              [-10.172501, 51.81222],
              [-10.17472, 51.820549],
              [-10.17639, 51.824165000000107],
              [-10.17889, 51.826942],
              [-10.200279, 51.845833],
              [-10.205278, 51.847221],
              [-10.21194, 51.847771],
              [-10.23056, 51.845551],
              [-10.24528, 51.84111],
              [-10.24889, 51.838882000000126],
              [-10.338593, 51.78292],
              [-10.35389, 51.842773],
              [-10.371946, 51.87888],
              [-10.263613, 51.988052],
              [-10.249445, 51.99305],
              [-10.12389, 52.025551000000121],
              [-10.10167, 52.03083],
              [-10.091112, 52.033333],
              [-10.05695, 52.038605],
              [-9.98667, 52.049995],
              [-9.801111, 52.122772],
              [-9.75778, 52.148605],
              [-9.76306, 52.150551],
              [-9.81139, 52.1525],
              [-9.844168, 52.151939],
              [-9.872501, 52.151382],
              [-9.88667, 52.150551],
              [-9.942501, 52.144722],
              [-10.025, 52.13611],
              [-10.05389, 52.131386],
              [-10.093056, 52.123604],
              [-10.18472, 52.107216],
              [-10.275, 52.10833],
              [-10.33, 52.113327],
              [-10.36583, 52.111664],
              [-10.38167, 52.103882],
              [-10.436668, 52.092216],
              [-10.444168, 52.092499],
              [-10.44945, 52.093887000000109],
              [-10.465557, 52.101944000000117],
              [-10.470001, 52.107498],
              [-10.473612, 52.129166],
              [-10.47472, 52.145554],
              [-10.466946, 52.176666],
              [-10.464724, 52.179718],
              [-10.46083, 52.18222],
              [-10.35972, 52.229721],
              [-10.265, 52.267494000000113],
              [-10.25056, 52.271385],
              [-10.20417, 52.281105],
              [-10.169445, 52.287498],
              [-10.162779, 52.287773],
              [-10.158335, 52.285828],
              [-10.156946, 52.282219],
              [-10.156946, 52.27389],
              [-10.15722, 52.270271],
              [-9.95195, 52.23111],
              [-9.94583, 52.23027],
              [-9.92028, 52.229996],
              [-9.88389, 52.229996],
              [-9.746946, 52.243332],
              [-9.740835, 52.244720000000143],
              [-9.742224, 52.247772],
              [-9.749445, 52.253052000000139],
              [-9.76917, 52.264160000000118],
              [-9.781946, 52.265274],
              [-9.78722, 52.26444],
              [-9.83583, 52.286659],
              [-9.83972, 52.379715],
              [-9.76278, 52.44277],
              [-9.68028, 52.51277],
              [-9.67556, 52.545273],
              [-9.67389, 52.54805],
              [-9.65556, 52.559715],
              [-9.651669, 52.56194],
              [-9.628889, 52.569160000000124],
              [-9.616667, 52.570831],
              [-9.36861, 52.57972],
              [-9.365002, 52.578331],
              [-9.36132, 52.575615],
              [-9.357592, 52.569168],
              [-9.33167, 52.57111],
              [-9.2225, 52.584999],
              [-8.98389, 52.630554],
              [-8.81833, 52.66555],
              [-8.84889, 52.689995],
              [-8.946945, 52.72361],
              [-9.028057, 52.730553],
              [-9.03333, 52.719162],
              [-9.065556, 52.688606],
              [-9.09083, 52.667221],
              [-9.12917, 52.635277],
              [-9.14695, 52.622772],
              [-9.15556, 52.619164000000126],
              [-9.16694, 52.61666],
              [-9.17972, 52.615829],
              [-9.241667, 52.613327],
              [-9.48056, 52.616943],
              [-9.554167, 52.638054],
              [-9.69417, 52.602219],
              [-9.70167, 52.597771],
              [-9.704723, 52.59499],
              [-9.70667, 52.591385000000116],
              [-9.70667, 52.587776000000133],
              [-9.701389, 52.581665],
              [-9.703056, 52.578049],
              [-9.707779, 52.57638],
              [-9.795279, 52.560829],
              [-9.886112, 52.550278000000105],
              [-9.900278, 52.549995000000138],
              [-9.92639, 52.552498000000128],
              [-9.932501, 52.553604],
              [-9.93639, 52.555832000000123],
              [-9.934168, 52.558884],
              [-9.91556, 52.570831],
              [-9.91111, 52.572495],
              [-9.84806, 52.58888],
              [-9.821667, 52.590828],
              [-9.81167, 52.593887],
              [-9.735001, 52.63888500000013],
              [-9.7275, 52.643326],
              [-9.565001, 52.745827000000133],
              [-9.485834, 52.80055],
              [-9.405556, 52.88638],
              [-9.394724, 52.926666],
              [-9.46083, 52.926941],
              [-9.467779, 52.927498000000128],
              [-9.47139, 52.929993000000138],
              [-9.473612, 52.93305],
              [-9.475, 52.936943],
              [-9.473333, 52.940552],
              [-9.280834, 53.139717],
              [-9.26667, 53.14944],
              [-9.26056, 53.150276000000133],
              [-9.25361, 53.149719],
              [-9.23167, 53.143051],
              [-9.19722, 53.127495000000124],
              [-9.17361, 53.11388],
              [-9.15417, 53.106941],
              [-9.06944, 53.117218],
              [-9.00148, 53.145592],
              [-9.03417, 53.15722],
              [-9.04333, 53.160553000000107],
              [-9.04611, 53.16333],
              [-9.04361, 53.166664],
              [-9.0375, 53.167496000000142],
              [-8.981112, 53.16333],
              [-8.980835, 53.15916],
              [-8.978613, 53.15583],
              [-8.944168, 53.139717],
              [-8.938057, 53.140549],
              [-8.934723, 53.143326000000116],
              [-8.94111, 53.26416],
              [-8.96028, 53.267220000000123],
              [-9.032778, 53.27166],
              [-9.04028, 53.27166],
              [-9.04639, 53.270554000000118],
              [-9.05528, 53.26694],
              [-9.10056, 53.258049],
              [-9.16778, 53.248329000000126],
              [-9.20222, 53.24638],
              [-9.22972, 53.245552],
              [-9.3, 53.24472],
              [-9.43889, 53.23389],
              [-9.44611, 53.233055],
              [-9.477501, 53.224716],
              [-9.4975, 53.223053],
              [-9.60806, 53.232216],
              [-9.618057, 53.236107000000118],
              [-9.62389, 53.241661000000136],
              [-9.62528, 53.24528],
              [-9.624168, 53.25361],
              [-9.61028, 53.29916],
              [-9.588335, 53.319443],
              [-9.582224, 53.3186],
              [-9.5775, 53.319717],
              [-9.57361, 53.322495],
              [-9.55778, 53.335548],
              [-9.55611, 53.339165],
              [-9.555, 53.37917],
              [-9.563334, 53.38333],
              [-9.648056, 53.386108],
              [-9.655001, 53.385826],
              [-9.663612, 53.38166],
              [-9.699722, 53.361382],
              [-9.703611, 53.355553],
              [-9.70639, 53.342773],
              [-9.711113, 53.336388],
              [-9.74028, 53.311943],
              [-9.744167, 53.309715],
              [-9.77972, 53.294716],
              [-9.786667, 53.294167],
              [-9.901945, 53.314720000000136],
              [-9.90472, 53.31721],
              [-9.904446, 53.32194],
              [-9.88728, 53.350773000000117],
              [-9.88311, 53.35377],
              [-9.84361, 53.368607000000111],
              [-9.81889, 53.37138],
              [-9.808889, 53.374992],
              [-9.80028, 53.37917],
              [-9.789446, 53.386665000000107],
              [-9.78472, 53.393051],
              [-9.786112, 53.39666],
              [-9.79722, 53.41333],
              [-9.80611, 53.417221],
              [-9.81361, 53.417221],
              [-9.88167, 53.409164],
              [-9.921334, 53.39338],
              [-9.92233, 53.388550000000123],
              [-9.923335, 53.386051000000123],
              [-9.92517, 53.384384],
              [-9.95917, 53.371941000000106],
              [-9.96639, 53.371941000000106],
              [-10.013056, 53.378609],
              [-10.175835, 53.407776],
              [-10.17722, 53.4116590000001],
              [-10.20167, 53.540833],
              [-10.198612, 53.543884],
              [-10.18611, 53.550278000000105],
              [-10.03611, 53.60055],
              [-10.000557, 53.60555],
              [-9.99445, 53.606384],
              [-9.87611, 53.61083200000013],
              [-9.79945, 53.596382],
              [-9.78889, 53.594444],
              [-9.781113, 53.593887],
              [-9.704723, 53.594994],
              [-9.69917, 53.595833],
              [-9.69528, 53.59861],
              [-9.69748, 53.602547000000129],
              [-9.76389, 53.60194],
              [-9.77917, 53.602493],
              [-9.79945, 53.604721],
              [-9.819723, 53.61083200000013],
              [-9.86278, 53.62722],
              [-9.90472, 53.643326],
              [-9.91306, 53.6475],
              [-9.91445, 53.650551],
              [-9.92445, 53.691383],
              [-9.906389, 53.75861],
              [-9.896946, 53.762497],
              [-9.851946, 53.76944],
              [-9.84639, 53.770271],
              [-9.68417, 53.784164],
              [-9.63444, 53.783333],
              [-9.630001, 53.78083],
              [-9.62444, 53.779442],
              [-9.61, 53.778885000000116],
              [-9.587778, 53.784439000000134],
              [-9.56806, 53.795273],
              [-9.56944, 53.799438],
              [-9.581945, 53.80055],
              [-9.588057, 53.80194],
              [-9.617224, 53.811943],
              [-9.62028, 53.814995],
              [-9.614168, 53.83527400000014],
              [-9.61028, 53.837776],
              [-9.60167, 53.841385],
              [-9.589169, 53.843048],
              [-9.57806, 53.845833],
              [-9.56139, 53.8597180000001],
              [-9.56639, 53.890831000000105],
              [-9.56778, 53.894722],
              [-9.6975, 53.896660000000111],
              [-9.72556, 53.895828],
              [-9.76445, 53.89444],
              [-9.77083, 53.893608],
              [-9.775278, 53.89194],
              [-9.77917, 53.889717000000132],
              [-9.785002, 53.883606],
              [-9.79306, 53.879166],
              [-9.81778, 53.871109],
              [-9.84139, 53.866943],
              [-9.89667, 53.858604000000128],
              [-9.91, 53.857498],
              [-9.936668, 53.864716000000101],
              [-9.940556, 53.866943],
              [-9.94278, 53.869995],
              [-9.91278, 53.94944],
              [-9.90833, 53.95138],
              [-9.896389, 53.953606],
              [-9.864779, 53.951496],
              [-9.861112, 53.951496],
              [-9.817501, 53.941383],
              [-9.81194, 53.93972],
              [-9.809723, 53.936661000000129],
              [-9.80778, 53.928886],
              [-9.81111, 53.92610900000011],
              [-9.8125, 53.923332],
              [-9.80583, 53.913605],
              [-9.80278, 53.91083],
              [-9.7975, 53.909439],
              [-9.791945, 53.909996],
              [-9.785002, 53.914719],
              [-9.78472, 53.91944100000012],
              [-9.787779, 53.941940000000102],
              [-9.79139, 53.948883],
              [-9.82894, 53.979774],
              [-9.85328, 53.99844],
              [-9.935835, 54.060829],
              [-9.93861, 54.110832],
              [-9.92639, 54.123886],
              [-9.94883, 54.18005],
              [-9.950667, 54.181717000000106],
              [-10.00611, 54.21889],
              [-10.013056, 54.219444],
              [-10.017223, 54.217216],
              [-10.083612, 54.148605],
              [-10.07167, 54.125549],
              [-10.06444, 54.095551000000114],
              [-10.06444, 54.09166],
              [-10.06695, 54.088608],
              [-10.078611, 54.086388000000113],
              [-10.08639, 54.086388000000113],
              [-10.10583, 54.088882],
              [-10.116667, 54.09166],
              [-10.12444, 54.096382000000119],
              [-10.127501, 54.09916],
              [-10.128889, 54.111938],
              [-10.11222, 54.229996],
              [-10.08167, 54.257217],
              [-10.06444, 54.269440000000145],
              [-10.00889, 54.300827],
              [-10.003056, 54.30138],
              [-9.99778, 54.300827],
              [-9.88583, 54.260826],
              [-9.88417, 54.258331],
              [-9.89417, 54.24555],
              [-9.905556, 54.233604000000128],
              [-9.92389, 54.221382],
              [-9.93, 54.220276000000126],
              [-9.942501, 54.21833],
              [-9.95056, 54.218605],
              [-9.95889, 54.22222],
              [-9.962778, 54.224998],
              [-9.96722, 54.23138],
              [-9.971111, 54.23333],
              [-9.976667, 54.235275],
              [-9.982779, 54.233887],
              [-9.98389, 54.230270000000132],
              [-9.98306, 54.225555],
              [-9.979445, 54.21833],
              [-9.974167, 54.21333],
              [-9.9625, 54.210274],
              [-9.92028, 54.20694],
              [-9.898056, 54.20694],
              [-9.892778, 54.208054],
              [-9.88889, 54.210548000000131],
              [-9.871113, 54.225555],
              [-9.851946, 54.269440000000145],
              [-9.84694, 54.31139],
              [-9.848333, 54.315552],
              [-9.84806, 54.319717],
              [-9.84639, 54.322777],
              [-9.843334, 54.32555],
              [-9.83861, 54.32777],
              [-9.803057, 54.333885],
              [-9.79667, 54.33472],
              [-9.753056, 54.328331],
              [-9.740557, 54.32555],
              [-9.58722, 54.312775000000101],
              [-9.4975, 54.313049],
              [-9.33639, 54.316940000000102],
              [-9.26583, 54.297493],
              [-9.211945, 54.274719000000118],
              [-9.209723, 54.27166],
              [-9.19806, 54.236938000000123],
              [-9.150557, 54.177773],
              [-9.131773, 54.159683],
              [-9.135, 54.171944],
              [-9.13139, 54.200829000000113],
              [-9.060556, 54.279716],
              [-9.056391, 54.281944],
              [-9.047501, 54.285553],
              [-9.04139, 54.286942],
              [-9.02639, 54.286659],
              [-8.93694, 54.283607],
              [-8.93028, 54.282776],
              [-8.91833, 54.280273],
              [-8.91389, 54.278328000000101],
              [-8.74861, 54.263329],
              [-8.62, 54.257217],
              [-8.47806, 54.273048],
              [-8.471668, 54.273888000000113],
              [-8.511112, 54.322495],
              [-8.519445, 54.326111],
              [-8.529446, 54.329163],
              [-8.58389, 54.339439],
              [-8.59167, 54.339722],
              [-8.604445, 54.338051],
              [-8.62667, 54.333054],
              [-8.647223, 54.33111],
              [-8.66639, 54.337776000000133],
              [-8.66861, 54.34166],
              [-8.669168, 54.345276],
              [-8.668335, 54.349442000000124],
              [-8.66167, 54.35527],
              [-8.65111, 54.36222],
              [-8.43445, 54.447495],
              [-8.395557, 54.461937],
              [-8.38098, 54.467087],
              [-8.34833, 54.469994],
              [-8.28444, 54.473328],
              [-8.268057, 54.51944],
              [-8.26611, 54.524162],
              [-8.20111, 54.573051000000135],
              [-8.17, 54.591385],
              [-8.188334, 54.6336060000001],
              [-8.39056, 54.624443],
              [-8.559723, 54.61332700000014],
              [-8.58445, 54.609718],
              [-8.62667, 54.617775000000108],
              [-8.68, 54.628052],
              [-8.702778, 54.642220000000123],
              [-8.74861, 54.648048],
              [-8.788334, 54.657494],
              [-8.79139, 54.659721000000104],
              [-8.800835, 54.691666],
              [-8.79972, 54.695274],
              [-8.79639, 54.698051],
              [-8.74417, 54.725273000000129],
              [-8.73528, 54.729439],
              [-8.669168, 54.759720000000129],
              [-8.62361, 54.76944],
              [-8.61806, 54.770554],
              [-8.533611, 54.784439],
              [-8.52639, 54.784721],
              [-8.490835, 54.79361],
              [-8.36861, 54.831940000000145],
              [-8.35389, 54.839439],
              [-8.31583, 54.86972],
              [-8.31417, 54.872772],
              [-8.31611, 54.876389000000131],
              [-8.335556, 54.901108],
              [-8.339169, 54.903610000000128],
              [-8.34556, 54.905],
              [-8.3525, 54.905273],
              [-8.37195, 54.903053],
              [-8.38333, 54.900551],
              [-8.38194, 54.89222],
              [-8.37861, 54.88472],
              [-8.38139, 54.8811],
              [-8.38611, 54.879997],
              [-8.396946, 54.882774],
              [-8.4375, 54.89694],
              [-8.45667, 54.913887000000102],
              [-8.45833, 54.921104],
              [-8.459723, 54.93833],
              [-8.4, 54.93354],
              [-8.38512, 54.941982],
              [-8.40289, 54.952869],
              [-8.427325, 54.96664],
              [-8.457779, 54.994995000000131],
              [-8.45667, 54.998604000000114],
              [-8.3175, 55.108887],
              [-8.181667, 55.141937],
              [-8.022223, 55.181664000000126],
              [-7.98145, 55.216457],
              [-7.94591, 55.19646],
              [-7.899699, 55.177803],
              [-7.872595, 55.199131],
              [-7.859266, 55.22179],
              [-7.79351, 55.243118],
              [-7.796173, 55.220013],
              [-7.81439, 55.203129],
              [-7.810835, 55.176472],
              [-7.770847, 55.183578],
              [-7.712197, 55.1587],
              [-7.70287, 55.14581],
              [-7.696646, 55.128929],
              [-7.70211, 55.11073],
              [-7.705, 55.09805],
              [-7.70389, 55.094162],
              [-7.696667, 55.093048],
              [-7.693334, 55.095276],
              [-7.66778, 55.141937],
              [-7.6675, 55.146385],
              [-7.67667, 55.16777],
              [-7.69861, 55.214165],
              [-7.70556, 55.218887000000109],
              [-7.71111, 55.220551000000114],
              [-7.71667, 55.219719],
              [-7.720278, 55.21666],
              [-7.721667, 55.20805],
              [-7.721111, 55.19472],
              [-7.71131, 55.173805],
              [-7.715751, 55.171139],
              [-7.73797, 55.179138],
              [-7.75352, 55.1898],
              [-7.788175, 55.201351000000102],
              [-7.79173, 55.212017000000117],
              [-7.76507, 55.230679],
              [-7.73663, 55.245785],
              [-7.69861, 55.26194],
              [-7.67, 55.271942],
              [-7.6575, 55.274437],
              [-7.63639, 55.268051000000128],
              [-7.62861, 55.263054],
              [-7.528611, 55.12805],
              [-7.525278, 55.120552],
              [-7.526112, 55.111938],
              [-7.53056, 55.09583],
              [-7.538611, 55.086662],
              [-7.544445, 55.085274],
              [-7.56361, 55.083054],
              [-7.575, 55.075554],
              [-7.598333, 55.061104],
              [-7.616667, 55.053886],
              [-7.63639, 55.03833],
              [-7.683056, 54.955276],
              [-7.683333, 54.95166],
              [-7.68139, 54.948326],
              [-7.66333, 54.95388800000012],
              [-7.64417, 54.961105],
              [-7.608334, 54.982216],
              [-7.57583, 55.004997000000117],
              [-7.56361, 55.012215],
              [-7.521945, 55.02833],
              [-7.51722, 55.029999],
              [-7.506667, 55.033051000000114],
              [-7.47778, 55.039444],
              [-7.47139, 55.039719000000105],
              [-7.46, 55.042496],
              [-7.4525, 55.047493],
              [-7.446945, 55.053604],
              [-7.446112, 55.057777],
              [-7.45417, 55.127777],
              [-7.45583, 55.135551000000135],
              [-7.51472, 55.179718],
              [-7.525278, 55.186386],
              [-7.54472, 55.19444],
              [-7.54972, 55.200554],
              [-7.551111, 55.204163],
              [-7.55056, 55.20888],
              [-7.5475, 55.216942000000131],
              [-7.51194, 55.274437],
              [-7.391389, 55.290276000000119],
              [-7.354445, 55.333611000000133],
              [-7.39889, 55.37722],
              [-7.393889, 55.37944],
              [-7.37944, 55.380272000000105],
              [-7.373889, 55.379715],
              [-7.240834, 55.351944],
              [-7.190834, 55.333885],
              [-7.1825, 55.329437],
              [-7.05194, 55.271660000000111],
              [-6.956112, 55.249443],
              [-6.93861, 55.241104],
              [-6.931667, 55.235832],
              [-6.935834, 55.219719],
              [-6.953611, 55.211662],
              [-7.067223, 55.174438],
              [-7.14417, 55.15083],
              [-7.15917, 55.14583],
              [-7.18361, 55.131943],
              [-7.1975, 55.121384],
              [-7.25251, 55.070595],
              [-7.32639, 55.045273000000122],
              [-7.40639, 54.953331],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "EN",
        ISO2: "EE",
        ISO3: "EST",
        UN: 233,
        NAME: "Estonia",
        AREA: 4239,
        POP2005: 1344312,
        REGION: 150,
        SUBREGION: 154,
        LON: 25.793,
        LAT: 58.674,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [23.990829, 58.099998],
              [23.97805000000011, 58.097771],
              [23.962772, 58.09943],
              [23.952774, 58.103607],
              [23.944996000000117, 58.108604],
              [23.938885, 58.114441000000113],
              [23.938606, 58.122765],
              [23.939995, 58.131935],
              [23.94305, 58.139992],
              [23.94777, 58.147217],
              [23.955551, 58.152489],
              [23.964996, 58.156654],
              [23.97916, 58.15777],
              [23.994717, 58.156097000000102],
              [24.006386, 58.152771],
              [24.016109, 58.1486],
              [24.022186, 58.14275],
              [24.024719, 58.137215],
              [24.02528, 58.128876],
              [24.015831000000105, 58.114441000000113],
              [24.00972, 58.10833],
              [24.001663, 58.10332],
              [23.990829, 58.099998],
            ],
          ],
          [
            [
              [22.990829, 58.597771],
              [23.090832, 58.564438],
              [23.263054, 58.496101],
              [23.273052, 58.491936],
              [23.289165, 58.482208000000128],
              [23.319717000000139, 58.46166],
              [23.332218000000125, 58.449997],
              [23.332775, 58.441658],
              [23.328053000000125, 58.434433000000126],
              [23.2675, 58.429436],
              [23.250000000000114, 58.430275],
              [23.226105, 58.43665],
              [23.206104, 58.444992],
              [23.198051, 58.44971],
              [23.142494000000113, 58.443604000000107],
              [23.076942, 58.413879],
              [23.064163, 58.385826],
              [23.02861, 58.357773000000122],
              [22.756943, 58.240273000000116],
              [22.648884000000123, 58.23027],
              [22.58194, 58.241104000000121],
              [22.520554, 58.242218],
              [22.487495000000138, 58.242218],
              [22.474995, 58.241936],
              [22.37833, 58.223045],
              [22.367496000000131, 58.219711],
              [22.288609, 58.188042],
              [22.279163, 58.183876000000112],
              [22.271664000000101, 58.178604],
              [22.26722, 58.171379000000115],
              [22.266388, 58.163879],
              [22.2691650000001, 58.15638],
              [22.273609, 58.149719000000118],
              [22.276108, 58.142494],
              [22.264721, 58.102219],
              [22.261944, 58.093880000000127],
              [22.202496, 57.986107],
              [22.09916, 57.93055],
              [22.07333, 57.91666],
              [22.051662, 57.909714000000122],
              [22.037777, 57.908325000000104],
              [22.022221, 57.909714000000122],
              [22.01028, 57.913048000000117],
              [22.000553, 57.91694],
              [21.994160000000136, 57.922768],
              [21.980549, 57.958046],
              [21.98582800000014, 57.976379],
              [22.082218, 58.07666],
              [22.089718, 58.08194],
              [22.10055, 58.085266],
              [22.112495000000138, 58.083878000000141],
              [22.151108, 58.08638],
              [22.197216, 58.137497],
              [22.201385, 58.144714],
              [22.196941, 58.151382],
              [22.188606, 58.15638],
              [22.17694, 58.159431],
              [22.145275, 58.1586],
              [22.131664, 58.16082],
              [22.07861, 58.17083],
              [22.068607, 58.174713000000111],
              [21.884441, 58.25222],
              [21.869717, 58.262497],
              [21.848606000000132, 58.278877000000136],
              [21.84416, 58.285553000000107],
              [21.841385, 58.29305],
              [21.843887000000109, 58.299164],
              [21.874439, 58.339989],
              [21.885273, 58.343323],
              [21.899162, 58.342766],
              [21.955551, 58.34305],
              [22.0075, 58.35332],
              [22.006386, 58.359993],
              [21.99638, 58.381378],
              [21.916664, 58.4575],
              [21.910275, 58.463051000000121],
              [21.901939, 58.468048],
              [21.878052, 58.4741590000001],
              [21.867775, 58.478325],
              [21.85139, 58.48777],
              [21.83194, 58.504997000000117],
              [21.842773000000136, 58.508331000000112],
              [21.924995, 58.517212],
              [21.98472, 58.516388],
              [22.000553, 58.514999],
              [22.112495000000138, 58.492218],
              [22.189163000000121, 58.544998],
              [22.19833, 58.549438000000123],
              [22.327221, 58.577492],
              [22.501663, 58.602219],
              [22.62416, 58.593323000000112],
              [22.76833, 58.60027],
              [22.775761, 58.606155000000115],
              [22.807774000000109, 58.616386],
              [22.82361, 58.616936],
              [22.871662000000129, 58.617767],
              [22.905273, 58.617493000000138],
              [22.917217000000107, 58.616104000000121],
              [22.978882, 58.601105],
              [22.990829, 58.597771],
            ],
          ],
          [
            [
              [23.364998, 58.529991000000109],
              [23.227219000000105, 58.529716],
              [23.215271, 58.53305],
              [23.091106000000138, 58.580276],
              [23.07111, 58.588326],
              [23.06472, 58.594154000000117],
              [23.060276000000101, 58.60083],
              [23.057774, 58.608330000000137],
              [23.060829, 58.616386],
              [23.06861, 58.621658000000139],
              [23.140274, 58.665825],
              [23.149719, 58.670273],
              [23.173607000000118, 58.675827],
              [23.186382, 58.678047],
              [23.200829, 58.67916],
              [23.216385, 58.677773],
              [23.247459, 58.671051],
              [23.271385, 58.664436],
              [23.317219, 58.650826],
              [23.339165, 58.643326],
              [23.347218, 58.638603000000103],
              [23.394997, 58.565544000000102],
              [23.399162, 58.558884],
              [23.396385000000123, 58.550827],
              [23.376106, 58.53305],
              [23.364998, 58.529991000000109],
            ],
          ],
          [
            [
              [23.277222, 58.963051],
              [23.18055, 58.9611],
              [23.16472, 58.962769],
              [23.152496, 58.965828000000101],
              [23.14444, 58.970825],
              [23.138050000000135, 58.976654],
              [23.113331, 59.01721],
              [23.110828, 59.024712],
              [23.117218, 59.030823],
              [23.12666, 59.034996],
              [23.137775, 59.03833],
              [23.15083, 59.04055],
              [23.181385, 59.042221],
              [23.19216, 59.041985000000125],
              [23.325829000000113, 59.037498],
              [23.339718, 59.035271],
              [23.35194, 59.031937],
              [23.361942000000113, 59.027771000000143],
              [23.370274000000109, 59.023048],
              [23.38722, 59.00471],
              [23.391663, 58.99805],
              [23.392220000000123, 58.989716],
              [23.387497, 58.98276],
              [23.3811070000001, 58.976379],
              [23.369995000000131, 58.973045],
              [23.291943, 58.964157],
              [23.277222, 58.963051],
            ],
          ],
          [
            [
              [22.749718000000144, 59.000000000000114],
              [22.801109, 58.997215],
              [22.843052000000114, 59.00222],
              [22.860828, 59.001663],
              [22.929718, 58.98249],
              [22.952496, 58.96693],
              [23.04361, 58.851105],
              [23.04805, 58.844437],
              [23.045277, 58.83638],
              [23.021664000000101, 58.820549],
              [23.005276, 58.830551],
              [22.960827000000108, 58.84499],
              [22.948330000000112, 58.844437],
              [22.88444, 58.833054],
              [22.865551, 58.82444],
              [22.868328000000133, 58.818886],
              [22.882217, 58.816666],
              [22.888607, 58.810822000000144],
              [22.887218, 58.787773],
              [22.88444, 58.779716],
              [22.848053, 58.7736],
              [22.81583, 58.772766],
              [22.798332, 58.7736],
              [22.784443, 58.775826],
              [22.77805, 58.781662],
              [22.77722, 58.78999],
              [22.783333, 58.796104],
              [22.792774000000122, 58.80027],
              [22.803886, 58.803604],
              [22.823051, 58.81221],
              [22.829163, 58.818329000000119],
              [22.826385, 58.824165],
              [22.812496, 58.82638],
              [22.79805, 58.824997],
              [22.77583, 58.818604000000107],
              [22.74721, 58.80555],
              [22.739437, 58.80027],
              [22.721107, 58.781662],
              [22.70138, 58.753883],
              [22.692493, 58.739433000000133],
              [22.68972, 58.731102],
              [22.680828000000133, 58.716660000000104],
              [22.674717, 58.710548],
              [22.666939, 58.705269000000101],
              [22.646385000000123, 58.697769],
              [22.62416, 58.691101],
              [22.59555, 58.68832],
              [22.56527, 58.686653],
              [22.5475, 58.68721],
              [22.53167, 58.688599],
              [22.517776, 58.691101],
              [22.479996000000142, 58.69971],
              [22.469715, 58.703606],
              [22.465271, 58.710274],
              [22.46944, 58.715546],
              [22.47194, 58.76361],
              [22.44999700000011, 58.831383],
              [22.445549000000142, 58.838043],
              [22.426105, 58.85527],
              [22.404995, 58.871658],
              [22.390274, 58.8822100000001],
              [22.381939, 58.88694],
              [22.369717, 58.890274],
              [22.336109, 58.89222],
              [22.276943, 58.88943],
              [22.24555, 58.878601],
              [22.229439000000127, 58.87804],
              [22.177219, 58.88888500000013],
              [22.164997, 58.891937],
              [22.06361, 58.923607000000118],
              [22.05333, 58.927773],
              [22.044998, 58.932495],
              [22.04222, 58.939987],
              [22.046387, 58.945267000000115],
              [22.052219, 58.949715],
              [22.064999000000114, 58.952217000000132],
              [22.191105, 58.947487000000137],
              [22.375553, 58.95166],
              [22.434441, 58.966385],
              [22.468052, 58.978043],
              [22.487774000000115, 58.992218],
              [22.523609, 59.022491000000116],
              [22.575829000000113, 59.068604],
              [22.699162, 59.051384],
              [22.694717, 59.044159],
              [22.6986, 59.019989],
              [22.70305, 59.013611],
              [22.719715000000122, 59.003609],
              [22.733883, 59.001389],
              [22.749718000000144, 59.000000000000114],
            ],
          ],
          [
            [
              [25.780277, 59.628876000000105],
              [25.873051, 59.598877],
              [25.979996000000142, 59.632767],
              [26.03083, 59.622765],
              [26.04361, 59.619987],
              [26.078053, 59.600548],
              [26.263054000000125, 59.585823],
              [26.389717, 59.561661000000129],
              [26.458328000000108, 59.541107],
              [26.479996, 59.533882000000119],
              [26.496105000000114, 59.53277],
              [26.525276, 59.536385000000109],
              [26.538052, 59.539162],
              [26.561665000000119, 59.545273],
              [26.57249800000011, 59.54916],
              [26.578053, 59.55555],
              [26.58889, 59.55916],
              [26.621662, 59.557213],
              [26.650551000000121, 59.553322],
              [26.67582700000014, 59.547493],
              [26.736938, 59.522491],
              [26.772774, 59.503883],
              [26.817219, 59.48082],
              [26.84972, 59.469437],
              [26.860275, 59.46583],
              [26.8836060000001, 59.45916],
              [26.921383000000105, 59.450829000000113],
              [26.964718, 59.444992],
              [26.98083, 59.44388],
              [27.033333, 59.44249],
              [27.0875, 59.442215],
              [27.185272000000111, 59.446938],
              [27.391106, 59.448601],
              [27.427219, 59.44833],
              [27.4436070000001, 59.44721],
              [27.45805, 59.445267],
              [27.483051, 59.43943],
              [27.50999800000011, 59.434433000000126],
              [27.553051, 59.428604000000121],
              [27.848053, 59.406654000000117],
              [27.88055, 59.407768],
              [27.89527500000014, 59.409431],
              [27.933331000000123, 59.41721],
              [27.953884, 59.425270000000125],
              [27.97805, 59.440544],
              [27.99305, 59.45138500000013],
              [27.998882, 59.457771],
              [28.015831, 59.4786],
              [28.026386, 59.47499],
              [28.07611, 59.453323],
              [28.10944, 59.436104],
              [28.170273, 59.397774],
              [28.180828, 59.389435],
              [28.193886000000134, 59.375824],
              [28.195274, 59.369438],
              [28.19361, 59.363327],
              [28.17932100000013, 59.328236000000118],
              [28.170359, 59.30978],
              [28.158232000000112, 59.297653],
              [28.143995, 59.290802],
              [28.09549, 59.283947],
              [28.055418, 59.279202],
              [28.030111, 59.277092],
              [28.01113, 59.279728],
              [27.995840000000101, 59.284473],
              [27.97106, 59.287109],
              [27.951551, 59.285530000000108],
              [27.920444, 59.275509],
              [27.912537, 59.271820000000105],
              [27.879847, 59.22806],
              [27.837219, 59.150826],
              [27.810555, 59.102493],
              [27.803329, 59.085266],
              [27.792221, 59.063324],
              [27.788052000000107, 59.058601],
              [27.704994, 58.98582],
              [27.689438000000109, 58.97943],
              [27.596943000000124, 58.931381000000101],
              [27.549999000000128, 58.907768],
              [27.533886, 58.902214],
              [27.493607, 58.881935],
              [27.457218, 58.85249],
              [27.43944, 58.83416],
              [27.435551, 58.829437],
              [27.428608, 58.819160000000124],
              [27.426105, 58.813606000000107],
              [27.423050000000103, 58.80138],
              [27.421661, 58.78833],
              [27.421661, 58.78138],
              [27.451107, 58.686935],
              [27.488049, 58.576385],
              [27.490551, 58.570831],
              [27.495827, 58.55999],
              [27.500832, 58.548882000000106],
              [27.517498, 58.50972],
              [27.521385000000123, 58.498329000000126],
              [27.535275, 58.450829],
              [27.542496000000142, 58.413879],
              [27.543610000000115, 58.393883],
              [27.543331000000137, 58.373322],
              [27.541943, 58.36721],
              [27.539165, 58.361664],
              [27.534996, 58.356941],
              [27.525829000000101, 58.348045],
              [27.514999, 58.339989],
              [27.496662, 58.32888],
              [27.48582800000014, 58.320831000000112],
              [27.467216, 58.303047],
              [27.464718, 58.297775],
              [27.464439, 58.283882],
              [27.47166, 58.226379],
              [27.474163, 58.213882],
              [27.476662, 58.208603],
              [27.48055, 58.203606],
              [27.54888, 58.13694],
              [27.554165, 58.132767000000115],
              [27.565830000000119, 58.125267],
              [27.58, 58.11916],
              [27.60194, 58.109993000000145],
              [27.60972, 58.107216],
              [27.625275, 58.101662],
              [27.641106, 58.0961],
              [27.65, 58.094154],
              [27.663052, 58.087212000000136],
              [27.67332800000014, 58.07888000000014],
              [27.677219, 58.074165000000107],
              [27.680828, 58.062492],
              [27.686661, 57.965271],
              [27.77333, 57.902214],
              [27.784721, 57.89888],
              [27.805275, 57.891106],
              [27.809998000000121, 57.88888500000013],
              [27.817497000000117, 57.88388],
              [27.820274, 57.881104],
              [27.823051000000135, 57.873878000000104],
              [27.822773, 57.869713000000104],
              [27.82111, 57.865829],
              [27.813885, 57.860275000000115],
              [27.785275, 57.84833],
              [27.753052, 57.839157],
              [27.734993, 57.835548],
              [27.702217000000132, 57.831665],
              [27.673607000000118, 57.830276],
              [27.629997000000117, 57.828606],
              [27.577221, 57.82277],
              [27.55139, 57.819443],
              [27.545830000000137, 57.817772],
              [27.40583, 57.68499],
              [27.400829, 57.678047],
              [27.348053, 57.595543000000134],
              [27.34694, 57.5911],
              [27.34694, 57.586937],
              [27.348053, 57.583054000000118],
              [27.353329, 57.568604],
              [27.361664000000133, 57.547493000000145],
              [27.363331, 57.54416],
              [27.372059, 57.535637],
              [27.31028, 57.531380000000127],
              [27.08722, 57.56221],
              [27.080551, 57.563606],
              [27.07027, 57.567497],
              [27.051662000000135, 57.588326],
              [27.03944, 57.599716000000114],
              [27.03194, 57.604713],
              [27.01861, 57.611382000000106],
              [26.996105, 57.61832],
              [26.96999, 57.62332],
              [26.906105, 57.633049000000142],
              [26.898331, 57.633881],
              [26.883884, 57.633606],
              [26.873051, 57.630547],
              [26.69777, 57.575554],
              [26.63499, 57.555824],
              [26.626385, 57.551102000000128],
              [26.619995, 57.544998000000135],
              [26.615273000000116, 57.533051],
              [26.612774000000115, 57.529434],
              [26.60889, 57.526939],
              [26.602776000000119, 57.525826000000109],
              [26.53889, 57.522217000000126],
              [26.523609000000135, 57.523048000000131],
              [26.51139, 57.5261],
              [26.313332, 57.605],
              [26.299164, 57.611382000000106],
              [26.287498, 57.618881],
              [26.274166, 57.62971],
              [26.204441, 57.69499],
              [26.034996, 57.823326],
              [25.946941, 57.85388],
              [25.883053, 57.85583],
              [25.836384, 57.860550000000103],
              [25.80139, 57.865829],
              [25.622772000000111, 57.916382],
              [25.618053, 57.918327],
              [25.461105, 57.994438],
              [25.453327, 57.999435],
              [25.44944, 58.005829000000119],
              [25.444996, 58.020828],
              [25.439995, 58.026939],
              [25.436108, 58.029434],
              [25.42166, 58.03555],
              [25.307499000000121, 58.08138300000013],
              [25.301662000000135, 58.083054],
              [25.294998000000135, 58.084435],
              [25.28722, 58.08416],
              [25.275555000000111, 58.081665],
              [25.266941, 58.076942],
              [25.263054000000125, 58.06916],
              [25.264442, 58.061378000000104],
              [25.288887, 58.047218],
              [25.29472, 58.04138],
              [25.296944, 58.038048],
              [25.300274, 58.026939],
              [25.30055, 58.018883],
              [25.299999, 58.01416],
              [25.294441, 58.0075],
              [25.28583, 58.003052],
              [25.247215, 57.99249],
              [25.232494, 57.992767000000129],
              [25.223885, 57.997215],
              [25.215, 58.005829000000119],
              [25.210827, 58.01249700000011],
              [25.207218, 58.028046],
              [25.203884, 58.03916],
              [25.199718000000132, 58.049995000000138],
              [25.192493, 58.059433000000126],
              [25.179718, 58.070274],
              [25.169994, 58.07444],
              [25.163052, 58.07583],
              [25.139164, 58.07666],
              [25.124439000000109, 58.076103],
              [25.09166, 58.071663],
              [25.07, 58.065269],
              [25.060829, 58.061104],
              [25.03833, 58.050270000000125],
              [25.015831000000105, 58.039436],
              [24.723885, 57.964996],
              [24.56055, 57.95555],
              [24.553608, 57.954712],
              [24.542774000000122, 57.95166],
              [24.453049, 57.913322],
              [24.443329000000119, 57.904434],
              [24.441105000000107, 57.900826000000109],
              [24.438328, 57.89277],
              [24.433884, 57.88583],
              [24.42777, 57.879433],
              [24.420273, 57.874435],
              [24.4025, 57.870544000000109],
              [24.37305, 57.868881],
              [24.32444, 57.87027],
              [24.31498, 57.871826],
              [24.338051, 57.923882],
              [24.345829, 57.93943],
              [24.353886, 57.954712],
              [24.363052, 57.96888],
              [24.389996, 58.002777],
              [24.400829000000101, 58.016106],
              [24.41194, 58.029434],
              [24.426105, 58.040833],
              [24.433884, 58.046104],
              [24.456661, 58.076103],
              [24.46999, 58.122765],
              [24.471661, 58.131935],
              [24.471107, 58.1486],
              [24.468884000000116, 58.156097000000102],
              [24.452496, 58.18277],
              [24.469440000000134, 58.23916],
              [24.472771, 58.247215],
              [24.47916, 58.253326],
              [24.486938, 58.25861],
              [24.498051, 58.26166],
              [24.526665, 58.274162000000103],
              [24.542496, 58.284439],
              [24.555275000000108, 58.296944],
              [24.559998, 58.303879000000109],
              [24.561665, 58.31305],
              [24.559441, 58.320549],
              [24.55555, 58.327217],
              [24.541386, 58.33804],
              [24.51778, 58.35305000000011],
              [24.458885, 58.37833],
              [24.419716, 58.38666],
              [24.390553, 58.390831000000105],
              [24.362495, 58.39194],
              [24.348331000000144, 58.390831000000105],
              [24.335552, 58.3886],
              [24.326107, 58.38472],
              [24.30055, 58.359993],
              [24.29583, 58.352776],
              [24.29305, 58.33638],
              [24.293331, 58.328049],
              [24.291943, 58.318886],
              [24.28722, 58.311661],
              [24.28083, 58.30555],
              [24.246105, 58.27666],
              [24.238049, 58.271378],
              [24.110554, 58.232208],
              [24.100552000000107, 58.236382],
              [24.092773, 58.24138],
              [24.056664, 58.26777],
              [24.050552, 58.273605],
              [24.01083, 58.29861],
              [23.99305, 58.30777],
              [23.973328, 58.315826],
              [23.949718, 58.322495000000117],
              [23.937775, 58.325829000000113],
              [23.826385, 58.354713],
              [23.78167, 58.350273],
              [23.770832, 58.346939],
              [23.728607, 58.370827],
              [23.679161, 58.425552],
              [23.630829000000119, 58.5236],
              [23.61694, 58.5261],
              [23.524719, 58.558327],
              [23.50111, 58.576942],
              [23.495548, 58.69415],
              [23.523331, 58.73555],
              [23.529442, 58.741661],
              [23.538887, 58.746101000000124],
              [23.549442000000113, 58.743881000000101],
              [23.56944, 58.73555],
              [23.583332, 58.733047],
              [23.60083, 58.732491],
              [23.725552, 58.744713],
              [23.867496, 58.766388],
              [23.874996, 58.7686],
              [23.85722, 58.7786],
              [23.827221, 58.79111],
              [23.805275, 58.798607],
              [23.79139, 58.800827],
              [23.59166, 58.788048],
              [23.483051000000103, 58.80999],
              [23.420273, 58.903877000000136],
              [23.416107, 58.910545],
              [23.41555000000011, 58.91888],
              [23.431107, 58.939430000000129],
              [23.445549000000142, 58.940544000000102],
              [23.477219, 58.937492],
              [23.507500000000107, 58.93721],
              [23.57694, 58.947212],
              [23.58833, 58.950546],
              [23.637775, 58.970543000000134],
              [23.635551, 58.978043],
              [23.628330000000119, 59.000549],
              [23.623329, 59.015549],
              [23.617218, 59.021378],
              [23.590553000000114, 59.035271],
              [23.57222, 59.044159],
              [23.56028, 59.047493],
              [23.56472, 59.040833],
              [23.570831, 59.035271],
              [23.60139, 59.022766000000104],
              [23.60944, 59.01777],
              [23.611942, 59.010277],
              [23.6055530000001, 59.004166],
              [23.55638, 58.98777],
              [23.514164000000108, 58.981102],
              [23.46638, 58.98416],
              [23.45249600000011, 58.986382],
              [23.436108, 58.997215],
              [23.413609, 59.012772],
              [23.407219, 59.0186],
              [23.42833, 59.051933],
              [23.43305, 59.059158],
              [23.440830000000119, 59.064438],
              [23.482494, 59.08943],
              [23.465549, 59.191376],
              [23.463051, 59.19887],
              [23.464161, 59.206383],
              [23.470551, 59.212494],
              [23.49972, 59.225266],
              [23.51083, 59.228325],
              [23.613609, 59.23972],
              [23.711384, 59.231102000000135],
              [23.727219, 59.22971],
              [23.738605, 59.232765],
              [23.744995000000131, 59.23916],
              [23.742493, 59.24638],
              [23.736382, 59.25222],
              [23.725552, 59.264717],
              [23.721382, 59.271378000000141],
              [23.729439, 59.276657000000114],
              [23.742218, 59.278603],
              [23.830830000000105, 59.289719],
              [23.85694100000012, 59.284164],
              [23.891106, 59.273323000000119],
              [23.905273, 59.270828000000108],
              [23.936108000000104, 59.272217000000126],
              [24.027222, 59.287773],
              [24.024166, 59.356102],
              [24.02, 59.36277],
              [24.019444, 59.371101],
              [24.022774, 59.379158],
              [24.029163, 59.38527],
              [24.03722, 59.390549],
              [24.050274000000115, 59.392769],
              [24.064999, 59.393883],
              [24.08111, 59.39222],
              [24.105274, 59.385551],
              [24.12361, 59.37666],
              [24.148052, 59.361664000000133],
              [24.176662, 59.348328],
              [24.186661, 59.344154],
              [24.19916, 59.342766],
              [24.212215000000128, 59.344994],
              [24.318886000000134, 59.425827],
              [24.325275, 59.431938000000116],
              [24.32444, 59.45694],
              [24.329163000000108, 59.464157000000114],
              [24.339165, 59.468323],
              [24.350552, 59.471375000000137],
              [24.363609, 59.473602],
              [24.394718, 59.47499],
              [24.41083, 59.473320000000115],
              [24.536663, 59.457214000000135],
              [24.72277, 59.452774],
              [24.791943, 59.51028],
              [24.779163, 59.520271],
              [24.776943, 59.527489],
              [24.771664, 59.557495],
              [24.776665, 59.564438],
              [24.79, 59.566666],
              [24.801941, 59.563324],
              [24.860554, 59.545547],
              [24.868607, 59.54055000000011],
              [24.887218, 59.523048],
              [24.909439, 59.507217],
              [24.927494, 59.506386],
              [25.05055, 59.51194],
              [25.100552, 59.5261],
              [25.10722, 59.532211],
              [25.121941, 59.533333],
              [25.154442000000131, 59.53166],
              [25.25833, 59.51416],
              [25.282776, 59.509163],
              [25.318886, 59.498878],
              [25.358887, 59.490547],
              [25.392494, 59.485825],
              [25.405926, 59.49064],
              [25.490829, 59.561104],
              [25.486938, 59.5686],
              [25.46944, 59.648331],
              [25.471107, 59.656654],
              [25.476383000000112, 59.663048000000117],
              [25.49277, 59.66415400000011],
              [25.591663, 59.60388],
              [25.59916, 59.59833],
              [25.609997, 59.585548],
              [25.631939000000102, 59.568886],
              [25.64277, 59.565269],
              [25.655552, 59.562767],
              [25.673885, 59.562767],
              [25.700829000000113, 59.568329000000119],
              [25.709995, 59.57277],
              [25.715271, 59.579437],
              [25.715271, 59.5886],
              [25.71333, 59.596657000000107],
              [25.707771, 59.60305],
              [25.693329, 59.61416],
              [25.687775, 59.62054],
              [25.66916, 59.653603],
              [25.67472, 59.659988],
              [25.6836, 59.664711],
              [25.694439, 59.668327],
              [25.70916, 59.66666],
              [25.719994, 59.662766],
              [25.7675, 59.640831],
              [25.774719000000118, 59.635551000000135],
              [25.780277, 59.628876000000105],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "AU",
        ISO2: "AT",
        ISO3: "AUT",
        UN: 40,
        NAME: "Austria",
        AREA: 8245,
        POP2005: 8291979,
        REGION: 150,
        SUBREGION: 155,
        LON: 14.912,
        LAT: 47.683,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [13.833611, 48.773605],
            [13.858055, 48.770554],
            [13.88361, 48.763611],
            [13.99, 48.717773],
            [14.007221, 48.710274],
            [14.049166, 48.674721],
            [14.051388, 48.671944],
            [14.0525, 48.668327],
            [14.0525, 48.664162],
            [14.184166, 48.596107],
            [14.278332, 48.582497],
            [14.390276, 48.592499],
            [14.446388, 48.618889],
            [14.505554, 48.628326],
            [14.608889, 48.628883],
            [14.615, 48.628052],
            [14.652498, 48.609444],
            [14.656387, 48.607498],
            [14.70028, 48.581379],
            [14.704166, 48.583611],
            [14.706665, 48.586662],
            [14.718611, 48.602219],
            [14.720276, 48.605827],
            [14.721388, 48.643326],
            [14.715832, 48.652771],
            [14.714722, 48.660553],
            [14.722221, 48.684715],
            [14.72611, 48.69194],
            [14.730276, 48.698608],
            [14.812498, 48.781387],
            [14.815832, 48.783882],
            [14.830276, 48.787498],
            [14.836388, 48.787498],
            [14.849443, 48.786385],
            [14.885555, 48.782776],
            [14.958887, 48.794716],
            [14.984999, 48.939163],
            [14.978054, 48.973053],
            [14.978054, 48.977219],
            [14.98111, 48.984718],
            [14.996944, 49.0075],
            [15.011389, 49.015274],
            [15.025833, 49.018883],
            [15.031387, 49.018608],
            [15.065554, 49.014717],
            [15.156666, 48.999718],
            [15.301388, 48.987778],
            [15.353333, 48.985832],
            [15.364721, 48.983604],
            [15.3925, 48.97361],
            [15.451666, 48.951111],
            [15.509722, 48.921661],
            [15.519165, 48.918327],
            [15.546665, 48.912216],
            [15.564439, 48.909164],
            [15.584999, 48.899162],
            [15.683332, 48.864716],
            [15.68861, 48.863327],
            [15.746387, 48.858604],
            [15.849432, 48.859703],
            [15.964167, 48.804718],
            [16.021664, 48.777222],
            [16.060555, 48.760277],
            [16.081108, 48.754715],
            [16.103333, 48.75],
            [16.333054, 48.733055],
            [16.370552, 48.733887],
            [16.376389, 48.734444],
            [16.386387, 48.736382],
            [16.395275, 48.739441],
            [16.403332, 48.74305],
            [16.413055, 48.750549],
            [16.417774, 48.756943],
            [16.430832, 48.782219],
            [16.451664, 48.806389],
            [16.457497, 48.811943],
            [16.461941, 48.813332],
            [16.537498, 48.812775],
            [16.54361, 48.811943],
            [16.644997, 48.79055],
            [16.65583, 48.787773],
            [16.667221, 48.781387],
            [16.711666, 48.746384],
            [16.782776, 48.720551],
            [16.78833, 48.719162],
            [16.827221, 48.715828],
            [16.838608, 48.71666],
            [16.863052, 48.722221],
            [16.871944, 48.724998],
            [16.875832, 48.727219],
            [16.885277, 48.729439],
            [16.899719, 48.722221],
            [16.913055, 48.708885],
            [16.91861, 48.703331],
            [16.919998, 48.700272],
            [16.946182, 48.619064],
            [16.943333, 48.573326],
            [16.933331, 48.532776],
            [16.907497, 48.506943],
            [16.866943, 48.470276],
            [16.864441, 48.467216],
            [16.855831, 48.44944],
            [16.840275, 48.376389],
            [16.839996, 48.372215],
            [16.84222, 48.365273],
            [16.845276, 48.358604],
            [16.8475, 48.355827],
            [16.920555, 48.283882],
            [16.927219, 48.280273],
            [16.94972, 48.278049],
            [16.950832, 48.257774],
            [16.953888, 48.242775],
            [16.975277, 48.188332],
            [16.998016, 48.169701],
            [17.023331, 48.150276],
            [17.03075, 48.145859],
            [17.040051, 48.142464],
            [17.069145, 48.135265],
            [17.081108, 48.088333],
            [17.116665, 48.038605],
            [17.166386, 48.012497],
            [17.146942, 48.0],
            [17.108055, 47.971382],
            [17.060555, 47.876938],
            [17.054443, 47.847221],
            [17.054996, 47.799721],
            [17.058609, 47.789444],
            [17.068607, 47.768326],
            [17.071663, 47.728607],
            [17.053886, 47.709442],
            [16.955276, 47.694717],
            [16.910831, 47.690826],
            [16.824444, 47.683884],
            [16.768608, 47.684715],
            [16.761944, 47.685272],
            [16.7575, 47.686943],
            [16.737221, 47.700829],
            [16.734444, 47.703331],
            [16.729164, 47.713051],
            [16.725555, 47.727493],
            [16.723331, 47.730553],
            [16.715832, 47.734718],
            [16.635555, 47.760277],
            [16.612221, 47.759163],
            [16.561386, 47.75666],
            [16.555832, 47.756104],
            [16.450554, 47.698051],
            [16.426941, 47.671387],
            [16.425831, 47.668327],
            [16.429443, 47.666107],
            [16.44833, 47.659721],
            [16.493053, 47.64666],
            [16.590832, 47.629166],
            [16.602497, 47.628609],
            [16.624722, 47.635826],
            [16.630833, 47.635826],
            [16.636665, 47.63472],
            [16.645275, 47.631943],
            [16.648888, 47.629715],
            [16.663887, 47.617218],
            [16.668888, 47.611664],
            [16.713886, 47.543884],
            [16.705276, 47.521111],
            [16.655205, 47.458153],
            [16.592499, 47.425278],
            [16.482777, 47.418053],
            [16.470833, 47.419716],
            [16.459164, 47.419167],
            [16.454998, 47.41777],
            [16.451942, 47.415276],
            [16.450554, 47.41111],
            [16.450554, 47.407219],
            [16.456387, 47.368889],
            [16.491108, 47.283882],
            [16.491665, 47.279999],
            [16.477219, 47.261383],
            [16.47361, 47.259438],
            [16.469166, 47.257774],
            [16.444721, 47.244438],
            [16.420555, 47.213333],
            [16.420555, 47.20916],
            [16.421944, 47.205826],
            [16.452499, 47.148888],
            [16.456108, 47.146942],
            [16.461666, 47.146385],
            [16.466942, 47.146942],
            [16.505554, 47.114998],
            [16.510555, 47.009995],
            [16.510555, 47.00666],
            [16.506943, 47.004715],
            [16.497776, 47.00222],
            [16.481388, 47.000549],
            [16.445, 47.004715],
            [16.412498, 47.007774],
            [16.346943, 47.009995],
            [16.302776, 47.011383],
            [16.276665, 46.988052],
            [16.253609, 46.958328],
            [16.139721, 46.879997],
            [16.136108, 46.877777],
            [16.111805, 46.86972],
            [16.009308, 46.835487],
            [15.99361, 46.834717],
            [15.988609, 46.833611],
            [15.985554, 46.831108],
            [15.985554, 46.826942],
            [15.987778, 46.759163],
            [15.988054, 46.751106],
            [15.868332, 46.723053],
            [15.849722, 46.723328],
            [15.832777, 46.722221],
            [15.806665, 46.718605],
            [15.602499, 46.686661],
            [15.406111, 46.652496],
            [15.139444, 46.657219],
            [15.105276, 46.657219],
            [15.100555, 46.656105],
            [15.074408, 46.648571],
            [15.064444, 46.651939],
            [15.045832, 46.652222],
            [14.870554, 46.615829],
            [14.864443, 46.610832],
            [14.834999, 46.574715],
            [14.832499, 46.566666],
            [14.824999, 46.541382],
            [14.814722, 46.512772],
            [14.811666, 46.509995],
            [14.544998, 46.407494],
            [14.478054, 46.419441],
            [14.159443, 46.440826],
            [14.154165, 46.44194],
            [14.150555, 46.443886],
            [14.131666, 46.458328],
            [14.12611, 46.467773],
            [14.119165, 46.476662],
            [14.112499, 46.48111],
            [14.084721, 46.488609],
            [14.079721, 46.489716],
            [13.936943, 46.515831],
            [13.845554, 46.519997],
            [13.77611, 46.518326],
            [13.718655, 46.526611],
            [13.611111, 46.54805],
            [13.558054, 46.555832],
            [13.551943, 46.556664],
            [13.428888, 46.563049],
            [13.2575, 46.561943],
            [12.827499, 46.630272],
            [12.82361, 46.632217],
            [12.787777, 46.644997],
            [12.768888, 46.650833],
            [12.76222, 46.651108],
            [12.753332, 46.648331],
            [12.747929, 46.644493],
            [12.743332, 46.641388],
            [12.738609, 46.640274],
            [12.732498, 46.641106],
            [12.728054, 46.642494],
            [12.692499, 46.659721],
            [12.590277, 46.658882],
            [12.554443, 46.661659],
            [12.486174, 46.682365],
            [12.440554, 46.690826],
            [12.410276, 46.702774],
            [12.398333, 46.708328],
            [12.388887, 46.715553],
            [12.378611, 46.726662],
            [12.301666, 46.84111],
            [12.232222, 46.888885],
            [12.189722, 46.906105],
            [12.181389, 46.909721],
            [12.160276, 46.928055],
            [12.13611, 46.966942],
            [12.127777, 47.001663],
            [12.127222, 47.00972],
            [12.128887, 47.013329],
            [12.134165, 47.019165],
            [12.138332, 47.020828],
            [12.152777, 47.024437],
            [12.185276, 47.028885],
            [12.189999, 47.029999],
            [12.19861, 47.033882],
            [12.204443, 47.039162],
            [12.223888, 47.063049],
            [12.230833, 47.07222],
            [12.23111, 47.080826],
            [12.22611, 47.086662],
            [12.221666, 47.088333],
            [12.189165, 47.094719],
            [12.183054, 47.094444],
            [12.140131, 47.084812],
            [12.075277, 47.059441],
            [11.766666, 46.978882],
            [11.755833, 46.977493],
            [11.736387, 46.977776],
            [11.725832, 46.979996],
            [11.71361, 46.994164],
            [11.706665, 46.998604],
            [11.628611, 47.012497],
            [11.615276, 47.013054],
            [11.483889, 47.01416],
            [11.186388, 46.970276],
            [11.171389, 46.96666],
            [11.164444, 46.962219],
            [11.118055, 46.929993],
            [11.111666, 46.924995],
            [11.099443, 46.914993],
            [11.096666, 46.912498],
            [11.094444, 46.909164],
            [11.094721, 46.904999],
            [11.098888, 46.89444],
            [11.098055, 46.885277],
            [11.096666, 46.88166],
            [11.072498, 46.824997],
            [11.070276, 46.821938],
            [11.018888, 46.774162],
            [11.014721, 46.772499],
            [10.887777, 46.771111],
            [10.834166, 46.786942],
            [10.791666, 46.801384],
            [10.764444, 46.822777],
            [10.766109, 46.826385],
            [10.764444, 46.83416],
            [10.758055, 46.838882],
            [10.689444, 46.872215],
            [10.684721, 46.873604],
            [10.679443, 46.874718],
            [10.666943, 46.874718],
            [10.651388, 46.871941],
            [10.6425, 46.868889],
            [10.599722, 46.857773],
            [10.566387, 46.849159],
            [10.560833, 46.84861],
            [10.497776, 46.85527],
            [10.477777, 46.864441],
            [10.474443, 46.866943],
            [10.471235, 46.871353],
            [10.488913, 46.934212],
            [10.487499, 46.937775],
            [10.429998, 46.984161],
            [10.400833, 47.001106],
            [10.391109, 47.003609],
            [10.385555, 47.002777],
            [10.357222, 46.997215],
            [10.353611, 46.994995],
            [10.345833, 46.986382],
            [10.323332, 46.955551],
            [10.313332, 46.933609],
            [10.231388, 46.878883],
            [10.22361, 46.874992],
            [10.170555, 46.857216],
            [10.15111, 46.852776],
            [10.141807, 46.851341],
            [10.140276, 46.851105],
            [10.122776, 46.849716],
            [10.109444, 46.850273],
            [10.058887, 46.866386],
            [9.934999, 46.912773],
            [9.879444, 46.939156],
            [9.87611, 46.941658],
            [9.87361, 46.958603],
            [9.873333, 46.962769],
            [9.875555, 46.970543],
            [9.880833, 46.98082],
            [9.889444, 46.993324],
            [9.893055, 47.000267],
            [9.891943, 47.003876],
            [9.875555, 47.022491],
            [9.870277, 47.023598],
            [9.719444, 47.050278],
            [9.6325, 47.056664],
            [9.598635, 47.063835],
            [9.603611, 47.065826],
            [9.610277, 47.070274],
            [9.627222, 47.086388],
            [9.634998, 47.094994],
            [9.63611, 47.103607],
            [9.633888, 47.130554],
            [9.622776, 47.150551],
            [9.566387, 47.243889],
            [9.533569, 47.274544],
            [9.539999, 47.284164],
            [9.599722, 47.354164],
            [9.605276, 47.359993],
            [9.614443, 47.367493],
            [9.624422, 47.367252],
            [9.625832, 47.367218],
            [9.631388, 47.36805],
            [9.641666, 47.369995],
            [9.650555, 47.373055],
            [9.664999, 47.381386],
            [9.669998, 47.387772],
            [9.673054, 47.394997],
            [9.673332, 47.398605],
            [9.65361, 47.455551],
            [9.65111, 47.458328],
            [9.646944, 47.460274],
            [9.611666, 47.468887],
            [9.594166, 47.46833],
            [9.590277, 47.470276],
            [9.567499, 47.491104],
            [9.562222, 47.496666],
            [9.559721, 47.499718],
            [9.557772, 47.505783],
            [9.566724, 47.540451],
            [9.577914, 47.537418],
            [9.607064, 47.529514],
            [9.610482, 47.529514],
            [9.651506, 47.529514],
            [9.692531, 47.529514],
            [9.7292, 47.535297],
            [9.736387, 47.546944],
            [9.743055, 47.560829],
            [9.749443, 47.570831],
            [9.763054, 47.584717],
            [9.773611, 47.591385],
            [9.782499, 47.594444],
            [9.808332, 47.594719],
            [9.81361, 47.593605],
            [9.955, 47.539719],
            [10.043055, 47.495277],
            [10.231388, 47.381386],
            [10.232777, 47.373604],
            [10.231388, 47.369995],
            [10.211666, 47.322495],
            [10.173332, 47.274719],
            [10.221943, 47.275276],
            [10.228054, 47.275551],
            [10.232777, 47.276665],
            [10.274443, 47.288887],
            [10.329443, 47.308327],
            [10.337221, 47.312492],
            [10.339998, 47.314995],
            [10.429722, 47.396111],
            [10.473331, 47.435555],
            [10.474165, 47.43972],
            [10.469721, 47.476387],
            [10.469166, 47.480553],
            [10.467499, 47.483604],
            [10.458332, 47.491104],
            [10.436388, 47.52916],
            [10.426943, 47.576942],
            [10.429998, 47.57972],
            [10.434166, 47.581383],
            [10.443609, 47.583885],
            [10.4725, 47.591385],
            [10.478054, 47.591942],
            [10.482777, 47.590553],
            [10.484444, 47.587219],
            [10.484165, 47.582771],
            [10.569443, 47.540276],
            [10.690832, 47.553886],
            [10.909443, 47.518051],
            [10.971109, 47.403328],
            [10.97361, 47.400551],
            [10.978333, 47.399162],
            [10.98361, 47.398048],
            [11.008333, 47.395828],
            [11.02861, 47.395271],
            [11.095554, 47.396111],
            [11.112499, 47.396942],
            [11.296389, 47.428886],
            [11.457499, 47.512215],
            [11.505278, 47.509163],
            [11.554443, 47.515549],
            [11.574444, 47.519997],
            [11.577776, 47.521942],
            [11.583611, 47.527222],
            [11.683054, 47.584717],
            [11.919998, 47.614166],
            [12.006388, 47.624443],
            [12.059999, 47.620552],
            [12.111111, 47.614716],
            [12.141388, 47.611107],
            [12.195745, 47.608124],
            [12.199377, 47.61026],
            [12.20472, 47.61496],
            [12.206388, 47.618607],
            [12.207777, 47.62722],
            [12.206856, 47.639534],
            [12.201111, 47.657494],
            [12.455, 47.66777],
            [12.508888, 47.635277],
            [12.512777, 47.633331],
            [12.518055, 47.632217],
            [12.566666, 47.641937],
            [12.57639, 47.644165],
            [12.596943, 47.667496],
            [12.602777, 47.672775],
            [12.606943, 47.674438],
            [12.665833, 47.684998],
            [12.722776, 47.684441],
            [12.735554, 47.684166],
            [12.74472, 47.681107],
            [12.82361, 47.627495],
            [12.829166, 47.622215],
            [12.830832, 47.618889],
            [12.827776, 47.616386],
            [12.814444, 47.616943],
            [12.808887, 47.616386],
            [12.800278, 47.613052],
            [12.787777, 47.589439],
            [12.78611, 47.585831],
            [12.789444, 47.579437],
            [12.80361, 47.55722],
            [12.809721, 47.552216],
            [12.952686, 47.478477],
            [12.963055, 47.475555],
            [13.004999, 47.469444],
            [13.011665, 47.469162],
            [13.016666, 47.470276],
            [13.050278, 47.493889],
            [13.053055, 47.496384],
            [13.054998, 47.5],
            [13.100277, 47.640831],
            [13.099998, 47.644997],
            [13.08, 47.684441],
            [13.074999, 47.690277],
            [13.058332, 47.706108],
            [13.034443, 47.722221],
            [13.024443, 47.724998],
            [13.019165, 47.725273],
            [13.014166, 47.724159],
            [13.003332, 47.717773],
            [12.995554, 47.714165],
            [12.99111, 47.712494],
            [12.984999, 47.712219],
            [12.923611, 47.714722],
            [12.9175, 47.715553],
            [12.911943, 47.720833],
            [12.910831, 47.724442],
            [12.911388, 47.729164],
            [12.912498, 47.733055],
            [12.939722, 47.784721],
            [12.94861, 47.79277],
            [12.967777, 47.807777],
            [12.973331, 47.813332],
            [13.008888, 47.854164],
            [12.966665, 47.906944],
            [12.918888, 47.957771],
            [12.865342, 47.994598],
            [12.863194, 48.0],
            [12.858332, 48.012215],
            [12.853333, 48.017776],
            [12.8375, 48.029999],
            [12.805555, 48.049721],
            [12.792776, 48.059441],
            [12.768332, 48.079163],
            [12.764166, 48.085274],
            [12.754444, 48.105553],
            [12.753332, 48.109161],
            [12.754999, 48.116943],
            [12.758333, 48.123886],
            [12.760832, 48.12722],
            [12.7675, 48.131943],
            [12.867498, 48.200829],
            [12.874998, 48.204994],
            [13.017776, 48.259438],
            [13.154444, 48.292221],
            [13.258055, 48.298882],
            [13.27861, 48.303055],
            [13.291943, 48.307495],
            [13.313055, 48.315826],
            [13.334999, 48.328606],
            [13.394999, 48.366104],
            [13.419167, 48.38694],
            [13.421665, 48.389999],
            [13.423332, 48.393608],
            [13.435833, 48.423607],
            [13.439999, 48.435272],
            [13.457222, 48.513329],
            [13.457777, 48.517776],
            [13.447498, 48.544441],
            [13.443609, 48.550552],
            [13.435276, 48.556938],
            [13.434999, 48.561104],
            [13.441666, 48.565552],
            [13.450554, 48.568886],
            [13.505278, 48.583054],
            [13.515276, 48.585274],
            [13.526943, 48.584999],
            [13.602777, 48.568054],
            [13.651667, 48.554161],
            [13.657776, 48.549164],
            [13.666943, 48.537216],
            [13.674721, 48.533051],
            [13.683054, 48.529442],
            [13.725996, 48.515587],
            [13.8025, 48.581108],
            [13.804998, 48.58416],
            [13.822777, 48.617218],
            [13.825277, 48.625275],
            [13.826944, 48.638885],
            [13.826666, 48.643051],
            [13.814722, 48.738052],
            [13.833611, 48.773605],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "EZ",
        ISO2: "CZ",
        ISO3: "CZE",
        UN: 203,
        NAME: "Czech Republic",
        AREA: 7727,
        POP2005: 10191762,
        REGION: 150,
        SUBREGION: 151,
        LON: 15.338,
        LAT: 49.743,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [14.70028, 48.581379],
            [14.656387, 48.607498],
            [14.652498, 48.609444],
            [14.615, 48.628052],
            [14.608889, 48.628883],
            [14.505554, 48.628326],
            [14.446388, 48.618889],
            [14.390276, 48.592499],
            [14.278332, 48.582497],
            [14.184166, 48.596107],
            [14.0525, 48.664162],
            [14.0525, 48.668327],
            [14.051388, 48.671944],
            [14.049166, 48.674721],
            [14.007221, 48.710274],
            [13.99, 48.717773],
            [13.88361, 48.763611],
            [13.858055, 48.770554],
            [13.833611, 48.773605],
            [13.832499, 48.774994],
            [13.815554, 48.778328],
            [13.812222, 48.78083],
            [13.812777, 48.785271],
            [13.815832, 48.79277],
            [13.815554, 48.796944],
            [13.813889, 48.800278],
            [13.802776, 48.810829],
            [13.785831, 48.830826],
            [13.779444, 48.835831],
            [13.769444, 48.838608],
            [13.765554, 48.840828],
            [13.763054, 48.843605],
            [13.761389, 48.846939],
            [13.756666, 48.852493],
            [13.753332, 48.859161],
            [13.745832, 48.867775],
            [13.742498, 48.874443],
            [13.740833, 48.88166],
            [13.736666, 48.883888],
            [13.731943, 48.883606],
            [13.724443, 48.87944],
            [13.719444, 48.878326],
            [13.707777, 48.880272],
            [13.691111, 48.878326],
            [13.677776, 48.884163],
            [13.666666, 48.894722],
            [13.661943, 48.896385],
            [13.655554, 48.901108],
            [13.649166, 48.906105],
            [13.641109, 48.914162],
            [13.625555, 48.939163],
            [13.624998, 48.947495],
            [13.627499, 48.950554],
            [13.626389, 48.953331],
            [13.605276, 48.950829],
            [13.599722, 48.951942],
            [13.593332, 48.95694],
            [13.59111, 48.959717],
            [13.587776, 48.966385],
            [13.580555, 48.970833],
            [13.564826, 48.973667],
            [13.509722, 48.972496],
            [13.402542, 49.006187],
            [13.396944, 49.04805],
            [13.395277, 49.050278],
            [13.322777, 49.098328],
            [13.314165, 49.103333],
            [13.173054, 49.167221],
            [13.031111, 49.287773],
            [12.966665, 49.33194],
            [12.957222, 49.336388],
            [12.945555, 49.339439],
            [12.890833, 49.346939],
            [12.88611, 49.346939],
            [12.884165, 49.345276],
            [12.884165, 49.342216],
            [12.885277, 49.339722],
            [12.893055, 49.331108],
            [12.891109, 49.328888],
            [12.887777, 49.327774],
            [12.883333, 49.327499],
            [12.878611, 49.328049],
            [12.80361, 49.337776],
            [12.795555, 49.339722],
            [12.78611, 49.344162],
            [12.674444, 49.424995],
            [12.597776, 49.527496],
            [12.578609, 49.560555],
            [12.554722, 49.616661],
            [12.524443, 49.66555],
            [12.515554, 49.679443],
            [12.513054, 49.681389],
            [12.508888, 49.682495],
            [12.47611, 49.690826],
            [12.455555, 49.695549],
            [12.467499, 49.782219],
            [12.469444, 49.784721],
            [12.546944, 49.897499],
            [12.547222, 49.907219],
            [12.545555, 49.91555],
            [12.544167, 49.918053],
            [12.492777, 49.974998],
            [12.49, 49.976662],
            [12.471109, 49.985832],
            [12.429443, 49.993889],
            [12.307499, 50.047493],
            [12.265554, 50.066109],
            [12.206142, 50.106209],
            [12.192499, 50.13166],
            [12.193888, 50.138054],
            [12.196388, 50.143883],
            [12.209166, 50.160553],
            [12.209721, 50.163887],
            [12.208611, 50.169441],
            [12.123333, 50.307495],
            [12.120832, 50.309441],
            [12.093704, 50.322533],
            [12.177221, 50.318054],
            [12.180277, 50.316383],
            [12.195833, 50.305832],
            [12.278055, 50.221664],
            [12.284166, 50.215271],
            [12.323055, 50.206665],
            [12.325554, 50.236107],
            [12.398611, 50.309166],
            [12.486111, 50.373055],
            [12.51222, 50.391106],
            [12.51861, 50.393883],
            [12.61861, 50.411942],
            [12.623333, 50.411942],
            [12.671389, 50.411942],
            [12.734722, 50.428329],
            [12.746111, 50.434715],
            [12.768332, 50.44416],
            [12.77611, 50.445831],
            [12.818888, 50.454437],
            [12.831388, 50.45166],
            [12.855833, 50.442215],
            [12.896944, 50.426109],
            [12.899721, 50.424438],
            [12.917221, 50.414719],
            [12.938889, 50.408882],
            [12.950554, 50.41111],
            [12.985558, 50.418327],
            [12.991943, 50.421104],
            [13.011665, 50.436386],
            [13.018888, 50.442215],
            [13.079443, 50.498055],
            [13.183332, 50.501938],
            [13.191111, 50.503609],
            [13.203333, 50.516937],
            [13.208887, 50.523888],
            [13.222776, 50.544167],
            [13.223888, 50.546944],
            [13.223888, 50.550278],
            [13.222221, 50.55555],
            [13.222221, 50.558609],
            [13.224165, 50.56472],
            [13.248055, 50.588333],
            [13.25111, 50.589996],
            [13.378332, 50.62944],
            [13.413332, 50.612221],
            [13.416388, 50.61055],
            [13.436666, 50.60527],
            [13.458611, 50.600555],
            [13.463888, 50.600273],
            [13.4725, 50.60527],
            [13.518332, 50.637772],
            [13.520277, 50.639999],
            [13.519722, 50.642776],
            [13.515554, 50.646942],
            [13.510832, 50.650551],
            [13.541111, 50.68972],
            [13.582222, 50.709442],
            [13.634722, 50.722221],
            [13.669443, 50.72583],
            [13.734165, 50.730827],
            [13.891109, 50.768883],
            [13.902777, 50.786942],
            [13.904444, 50.789444],
            [13.986666, 50.813606],
            [13.99472, 50.815277],
            [14.155554, 50.843048],
            [14.311388, 50.882217],
            [14.368332, 50.934998],
            [14.322777, 50.945274],
            [14.319721, 50.946938],
            [14.256109, 50.987778],
            [14.254999, 50.990273],
            [14.255554, 50.99305],
            [14.265554, 51.009438],
            [14.285555, 51.037498],
            [14.302776, 51.051384],
            [14.309721, 51.053604],
            [14.491665, 51.036659],
            [14.569166, 51.005554],
            [14.597221, 50.982498],
            [14.628332, 50.923607],
            [14.631388, 50.881104],
            [14.618055, 50.859993],
            [14.619165, 50.857498],
            [14.621666, 50.855553],
            [14.651667, 50.847221],
            [14.717777, 50.829163],
            [14.739721, 50.823883],
            [14.766666, 50.818329],
            [14.776388, 50.818329],
            [14.801666, 50.818886],
            [14.804165, 50.820549],
            [14.824999, 50.856384],
            [14.828333, 50.865829],
            [14.966665, 50.859161],
            [15.001665, 50.866386],
            [15.005278, 50.867218],
            [15.006943, 50.869995],
            [15.019165, 50.950554],
            [15.020555, 50.964722],
            [15.020555, 50.967773],
            [15.013887, 50.979721],
            [15.010555, 50.984161],
            [15.176943, 51.014717],
            [15.239443, 50.991943],
            [15.275276, 50.974998],
            [15.295277, 50.954163],
            [15.294167, 50.948608],
            [15.276943, 50.938889],
            [15.272778, 50.934441],
            [15.271944, 50.931107],
            [15.270832, 50.921387],
            [15.274443, 50.91111],
            [15.282221, 50.893326],
            [15.283333, 50.890831],
            [15.30361, 50.864166],
            [15.310555, 50.85833],
            [15.328888, 50.854721],
            [15.355555, 50.846107],
            [15.361944, 50.84333],
            [15.364166, 50.841385],
            [15.36972, 50.831665],
            [15.37972, 50.779442],
            [15.488333, 50.786659],
            [15.606667, 50.772774],
            [15.787498, 50.744164],
            [15.946943, 50.689438],
            [16.024441, 50.629997],
            [16.071388, 50.635551],
            [16.118053, 50.657799],
            [16.137497, 50.656105],
            [16.237499, 50.670555],
            [16.325554, 50.66555],
            [16.334999, 50.663887],
            [16.341942, 50.66111],
            [16.369999, 50.644165],
            [16.429165, 50.602493],
            [16.431389, 50.600555],
            [16.444443, 50.585548],
            [16.447777, 50.581108],
            [16.449165, 50.575829],
            [16.448055, 50.572777],
            [16.406666, 50.523048],
            [16.368332, 50.498604],
            [16.361111, 50.496384],
            [16.351944, 50.496384],
            [16.346664, 50.496941],
            [16.338333, 50.499161],
            [16.319164, 50.505272],
            [16.310833, 50.504166],
            [16.213886, 50.449715],
            [16.209164, 50.445549],
            [16.203888, 50.437775],
            [16.202774, 50.431389],
            [16.203331, 50.428604],
            [16.20583, 50.423882],
            [16.217499, 50.41111],
            [16.220554, 50.409439],
            [16.266109, 50.389717],
            [16.303055, 50.378052],
            [16.371944, 50.361107],
            [16.441387, 50.316666],
            [16.458611, 50.303604],
            [16.546108, 50.229164],
            [16.549999, 50.224998],
            [16.559166, 50.214165],
            [16.565277, 50.202217],
            [16.566387, 50.178055],
            [16.56361, 50.164719],
            [16.567497, 50.160553],
            [16.587776, 50.139999],
            [16.614441, 50.11972],
            [16.638054, 50.109444],
            [16.641941, 50.10833],
            [16.703888, 50.098328],
            [16.713886, 50.097496],
            [16.71833, 50.097771],
            [16.725277, 50.099716],
            [16.786663, 50.140549],
            [16.802935, 50.169651],
            [16.806942, 50.174995],
            [16.815552, 50.183884],
            [16.843887, 50.200272],
            [16.849998, 50.203331],
            [16.909164, 50.222221],
            [16.913609, 50.222496],
            [16.968609, 50.222771],
            [17.00222, 50.216942],
            [16.972775, 50.309998],
            [16.937496, 50.340553],
            [16.869442, 50.405273],
            [16.867496, 50.410553],
            [16.868053, 50.413055],
            [16.869999, 50.415833],
            [16.887497, 50.437492],
            [16.890274, 50.439438],
            [16.898609, 50.440277],
            [16.910831, 50.440132],
            [16.941387, 50.434998],
            [17.057777, 50.410553],
            [17.118053, 50.39666],
            [17.201942, 50.363884],
            [17.208611, 50.358055],
            [17.226944, 50.345276],
            [17.283607, 50.320274],
            [17.37833, 50.279442],
            [17.433052, 50.270271],
            [17.619999, 50.265549],
            [17.63361, 50.265549],
            [17.656666, 50.269997],
            [17.665554, 50.274719],
            [17.692219, 50.296661],
            [17.694443, 50.298882],
            [17.695, 50.307777],
            [17.693886, 50.316383],
            [17.694164, 50.319443],
            [17.69611, 50.321938],
            [17.703888, 50.323326],
            [17.722775, 50.319717],
            [17.726109, 50.318329],
            [17.753052, 50.297775],
            [17.762775, 50.234718],
            [17.763054, 50.231941],
            [17.764164, 50.211662],
            [17.763885, 50.208611],
            [17.762497, 50.205551],
            [17.698887, 50.179993],
            [17.691666, 50.178055],
            [17.651943, 50.171944],
            [17.63361, 50.171944],
            [17.623333, 50.172775],
            [17.614719, 50.172493],
            [17.607498, 50.170555],
            [17.600555, 50.164162],
            [17.59861, 50.161659],
            [17.597775, 50.158333],
            [17.60083, 50.153885],
            [17.60722, 50.147774],
            [17.657776, 50.108055],
            [17.836388, 49.990829],
            [17.843887, 49.988327],
            [17.867222, 49.98111],
            [17.882774, 49.976944],
            [17.887775, 49.976662],
            [17.913609, 49.976387],
            [17.922497, 49.976944],
            [17.933052, 49.979721],
            [18.009441, 50.011108],
            [18.053162, 50.055931],
            [18.094166, 50.038055],
            [18.270275, 49.957771],
            [18.350277, 49.938889],
            [18.549721, 49.922493],
            [18.553608, 49.92305],
            [18.557777, 49.921661],
            [18.577221, 49.914444],
            [18.579441, 49.912498],
            [18.581108, 49.907494],
            [18.57935, 49.814995],
            [18.634163, 49.737778],
            [18.786942, 49.681938],
            [18.809998, 49.674438],
            [18.811665, 49.672218],
            [18.839443, 49.594994],
            [18.847775, 49.554161],
            [18.852219, 49.527771],
            [18.851246, 49.517357],
            [18.792774, 49.513885],
            [18.655552, 49.504166],
            [18.581108, 49.497772],
            [18.568886, 49.496109],
            [18.562222, 49.493889],
            [18.551388, 49.486938],
            [18.548332, 49.481667],
            [18.547775, 49.478333],
            [18.548332, 49.463608],
            [18.546108, 49.457497],
            [18.541111, 49.453331],
            [18.386944, 49.335831],
            [18.379444, 49.330276],
            [18.317776, 49.307495],
            [18.30722, 49.303886],
            [18.281387, 49.301941],
            [18.269997, 49.299995],
            [18.216389, 49.289162],
            [18.212776, 49.288055],
            [18.208054, 49.284164],
            [18.179722, 49.249443],
            [18.175831, 49.244438],
            [18.174721, 49.241661],
            [18.174164, 49.210274],
            [18.161942, 49.174164],
            [18.158886, 49.165276],
            [18.15583, 49.159721],
            [18.145277, 49.145],
            [18.150833, 49.129997],
            [18.151386, 49.124443],
            [18.147778, 49.115555],
            [18.121944, 49.082771],
            [18.075279, 49.041943],
            [17.91111, 48.984993],
            [17.841942, 48.928329],
            [17.763054, 48.879715],
            [17.7575, 48.876663],
            [17.712219, 48.85611],
            [17.677498, 48.851944],
            [17.654999, 48.851944],
            [17.645554, 48.851944],
            [17.502777, 48.838882],
            [17.41861, 48.82666],
            [17.403889, 48.822777],
            [17.390274, 48.822777],
            [17.38583, 48.823326],
            [17.376389, 48.827499],
            [17.33083, 48.850273],
            [17.252777, 48.870827],
            [17.239998, 48.872772],
            [17.230274, 48.873055],
            [17.187908, 48.869446],
            [17.113888, 48.833054],
            [17.110554, 48.830551],
            [17.044167, 48.771385],
            [17.038887, 48.765274],
            [17.022499, 48.743607],
            [16.988331, 48.681664],
            [16.946182, 48.619064],
            [16.919998, 48.700272],
            [16.91861, 48.703331],
            [16.913055, 48.708885],
            [16.899719, 48.722221],
            [16.885277, 48.729439],
            [16.875832, 48.727219],
            [16.871944, 48.724998],
            [16.863052, 48.722221],
            [16.838608, 48.71666],
            [16.827221, 48.715828],
            [16.78833, 48.719162],
            [16.782776, 48.720551],
            [16.711666, 48.746384],
            [16.667221, 48.781387],
            [16.65583, 48.787773],
            [16.644997, 48.79055],
            [16.54361, 48.811943],
            [16.537498, 48.812775],
            [16.461941, 48.813332],
            [16.457497, 48.811943],
            [16.451664, 48.806389],
            [16.430832, 48.782219],
            [16.417774, 48.756943],
            [16.413055, 48.750549],
            [16.403332, 48.74305],
            [16.395275, 48.739441],
            [16.386387, 48.736382],
            [16.376389, 48.734444],
            [16.370552, 48.733887],
            [16.333054, 48.733055],
            [16.103333, 48.75],
            [16.081108, 48.754715],
            [16.060555, 48.760277],
            [16.021664, 48.777222],
            [15.964167, 48.804718],
            [15.849432, 48.859703],
            [15.746387, 48.858604],
            [15.68861, 48.863327],
            [15.683332, 48.864716],
            [15.584999, 48.899162],
            [15.564439, 48.909164],
            [15.546665, 48.912216],
            [15.519165, 48.918327],
            [15.509722, 48.921661],
            [15.451666, 48.951111],
            [15.3925, 48.97361],
            [15.364721, 48.983604],
            [15.353333, 48.985832],
            [15.301388, 48.987778],
            [15.156666, 48.999718],
            [15.065554, 49.014717],
            [15.031387, 49.018608],
            [15.025833, 49.018883],
            [15.011389, 49.015274],
            [14.996944, 49.0075],
            [14.98111, 48.984718],
            [14.978054, 48.977219],
            [14.978054, 48.973053],
            [14.984999, 48.939163],
            [14.958887, 48.794716],
            [14.885555, 48.782776],
            [14.849443, 48.786385],
            [14.836388, 48.787498],
            [14.830276, 48.787498],
            [14.815832, 48.783882],
            [14.812498, 48.781387],
            [14.730276, 48.698608],
            [14.72611, 48.69194],
            [14.722221, 48.684715],
            [14.714722, 48.660553],
            [14.715832, 48.652771],
            [14.721388, 48.643326],
            [14.720276, 48.605827],
            [14.718611, 48.602219],
            [14.706665, 48.586662],
            [14.704166, 48.583611],
            [14.70028, 48.581379],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "FI",
        ISO2: "FI",
        ISO3: "FIN",
        UN: 246,
        NAME: "Finland",
        AREA: 30459,
        POP2005: 5246004,
        REGION: 150,
        SUBREGION: 154,
        LON: 26.272,
        LAT: 64.504,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [23.705826, 59.927216000000101],
              [23.649437, 59.92083],
              [23.616386, 59.925552],
              [23.596664, 59.923882000000106],
              [23.507221000000129, 59.91555000000011],
              [23.402222000000108, 59.90083],
              [23.391109, 59.901382],
              [23.38055, 59.903053000000114],
              [23.37278, 59.906387000000109],
              [23.369999, 59.911385000000109],
              [23.370831, 59.916939000000127],
              [23.38388, 59.925827],
              [23.51833, 59.95861],
              [23.527775, 59.959717],
              [23.53833, 59.960274],
              [23.54944, 59.959717],
              [23.723328, 59.933884],
              [23.729439, 59.931938],
              [23.726383000000112, 59.929718],
              [23.705826, 59.927216000000101],
            ],
          ],
          [
            [
              [22.833611, 59.956383],
              [22.843052000000114, 59.953331000000105],
              [22.94028, 59.9566650000001],
              [22.981937, 59.95861],
              [23.001938000000109, 59.960548],
              [23.054161, 59.95861],
              [23.068054, 59.955551000000128],
              [23.072498, 59.951111],
              [23.07194, 59.945549000000142],
              [23.05611, 59.90333],
              [23.049999000000128, 59.8986],
              [23.040554, 59.897217],
              [23.018055000000118, 59.899994],
              [22.945831000000112, 59.902222000000108],
              [22.927776, 59.8986],
              [22.9175, 59.898331],
              [22.885277, 59.901939],
              [22.87722, 59.905273000000136],
              [22.847496, 59.919441],
              [22.80778, 59.94527],
              [22.803333, 59.949715],
              [22.802219, 59.954994],
              [22.808887, 59.9675],
              [22.815, 59.972496],
              [22.82361, 59.974716],
              [22.830555000000118, 59.972221],
              [22.831387, 59.966942],
              [22.8291660000001, 59.96083],
              [22.833611, 59.956383],
            ],
          ],
          [
            [
              [22.438885000000141, 59.995827000000133],
              [22.38138, 59.986664000000133],
              [22.373329000000126, 59.989998000000128],
              [22.367714, 60.0],
              [22.353333000000134, 60.034164],
              [22.34833, 60.049438],
              [22.349442, 60.060829000000126],
              [22.35194, 60.06694],
              [22.35778, 60.071663],
              [22.364719, 60.075829000000113],
              [22.404442000000131, 60.083885],
              [22.415833, 60.081383],
              [22.434444, 60.076385],
              [22.440552, 60.072495000000117],
              [22.445831, 60.06444],
              [22.451385, 60.054993],
              [22.4525, 60.04972],
              [22.450275, 60.01416],
              [22.44778, 60.008049],
              [22.442635000000109, 60.0],
              [22.438885000000141, 59.995827000000133],
            ],
          ],
          [
            [
              [21.598053, 60.098053],
              [21.520554, 60.093605],
              [21.51083, 60.096664],
              [21.484722, 60.10833],
              [21.48527, 60.11388],
              [21.50194, 60.139442],
              [21.529720000000111, 60.154716],
              [21.552776, 60.164444],
              [21.562222000000133, 60.165833],
              [21.596386, 60.16499],
              [21.633331, 60.16166],
              [21.646664, 60.159721],
              [21.655552000000114, 60.155548000000124],
              [21.655277, 60.145554000000118],
              [21.63833, 60.109993000000145],
              [21.63528, 60.10472],
              [21.598053, 60.098053],
            ],
          ],
          [
            [
              [21.748886, 60.111382000000106],
              [21.73917, 60.109993000000145],
              [21.727776000000119, 60.110275],
              [21.703331, 60.112495],
              [21.695274, 60.115829],
              [21.704441, 60.166939],
              [21.708885, 60.179161],
              [21.715553, 60.183052],
              [21.723331, 60.186386],
              [21.827221000000122, 60.190826000000129],
              [21.856388, 60.191666],
              [21.87278, 60.184715],
              [21.885277, 60.177216],
              [21.88472, 60.171387],
              [21.864719, 60.155],
              [21.785000000000139, 60.118889],
              [21.748886, 60.111382000000106],
            ],
          ],
          [
            [
              [21.39666, 60.178604000000121],
              [21.385277, 60.156662],
              [21.307499, 60.173882],
              [21.271942, 60.184715],
              [21.268330000000105, 60.188049],
              [21.273888000000113, 60.193054],
              [21.287498000000141, 60.201111],
              [21.296108, 60.203331],
              [21.30555, 60.204994],
              [21.338886000000116, 60.204994],
              [21.350277, 60.20472],
              [21.386387, 60.188049],
              [21.39666, 60.178604000000121],
            ],
          ],
          [
            [
              [22.000832, 60.12944],
              [21.990276000000108, 60.128883],
              [21.962219, 60.1325],
              [21.952221, 60.13528],
              [21.943054, 60.143883],
              [21.93861, 60.164719],
              [21.937496, 60.169998],
              [21.942219, 60.175827],
              [21.949997, 60.178886],
              [22.032776000000126, 60.205276],
              [22.060833, 60.20388800000012],
              [22.07, 60.195274],
              [22.07027, 60.190826000000129],
              [22.030552000000114, 60.142776],
              [22.023888000000113, 60.138885],
              [22.000832, 60.12944],
            ],
          ],
          [
            [
              [25.84861, 60.195549],
              [25.83, 60.192497],
              [25.81889, 60.195274],
              [25.813053, 60.199165],
              [25.810555, 60.204163],
              [25.81444, 60.20916],
              [25.821663, 60.213051000000121],
              [25.839443, 60.216942],
              [25.85166, 60.215553],
              [25.874996, 60.211105],
              [25.869720000000143, 60.207771],
              [25.855831, 60.19944],
              [25.84861, 60.195549],
            ],
          ],
          [
            [
              [22.824444, 60.227219],
              [22.834999, 60.19389],
              [22.847221, 60.124718],
              [22.848053, 60.119438],
              [22.839165, 60.09638],
              [22.83583, 60.09111],
              [22.73611, 60.00305],
              [22.72666, 60.001663],
              [22.68222, 59.997772000000111],
              [22.67610900000011, 60.001663],
              [22.633331, 60.004715],
              [22.601109000000122, 59.983330000000137],
              [22.60133, 60.0],
              [22.600277, 60.004997],
              [22.572498, 60.027496],
              [22.528889000000106, 60.006104000000107],
              [22.521111000000133, 60.00305],
              [22.51166, 60.001663],
              [22.472771, 59.996941000000106],
              [22.469463000000133, 60.0],
              [22.471132, 60.072083000000134],
              [22.424164, 60.10833],
              [22.415276, 60.152222],
              [22.430275, 60.194443],
              [22.443607, 60.213333],
              [22.449718000000132, 60.21833],
              [22.4575, 60.221382],
              [22.467777, 60.221939000000134],
              [22.47416, 60.218048],
              [22.475277000000119, 60.212776000000133],
              [22.587776, 60.2025],
              [22.645275, 60.21083],
              [22.7325, 60.21999],
              [22.824444, 60.227219],
            ],
          ],
          [
            [
              [22.24222200000014, 60.181107000000111],
              [22.224163, 60.177498000000128],
              [22.215275, 60.179443000000106],
              [22.214165, 60.184715],
              [22.2125, 60.200829],
              [22.217777000000126, 60.218605000000139],
              [22.222775000000127, 60.224442],
              [22.228611, 60.22916],
              [22.23555, 60.23333],
              [22.242496, 60.23722],
              [22.25027, 60.240273],
              [22.284721, 60.249443],
              [22.29444100000012, 60.248604],
              [22.30611, 60.223053000000107],
              [22.302776, 60.217773],
              [22.291111000000114, 60.208054],
              [22.264442, 60.191383],
              [22.24222200000014, 60.181107000000111],
            ],
          ],
          [
            [
              [25.677219, 60.234993],
              [25.634998, 60.19805],
              [25.598053, 60.207771],
              [25.59111, 60.210548],
              [25.56166, 60.260551000000135],
              [25.561108, 60.265831],
              [25.576664, 60.290833],
              [25.585552, 60.2930530000001],
              [25.595276, 60.291939000000127],
              [25.60472, 60.288605000000132],
              [25.673885, 60.25055],
              [25.679722, 60.24638],
              [25.681942, 60.24166],
              [25.677219, 60.234993],
            ],
          ],
          [
            [
              [22.342220000000111, 60.28305],
              [22.335831, 60.268326],
              [22.33083, 60.262497],
              [22.320274, 60.26194],
              [22.310555, 60.264999000000103],
              [22.297222, 60.266937],
              [22.285831, 60.26722],
              [22.277222, 60.264999000000103],
              [22.234722, 60.252777],
              [22.226944, 60.249718000000144],
              [22.21333, 60.24166],
              [22.218887000000109, 60.269722],
              [22.20916, 60.2725],
              [22.144722000000115, 60.281105],
              [22.14138800000012, 60.277771],
              [22.179443, 60.2736],
              [22.180553, 60.268326],
              [22.177219, 60.263054],
              [22.169441, 60.259995000000117],
              [22.151108, 60.256104],
              [22.12917, 60.255829],
              [22.078888, 60.261383],
              [22.071941, 60.263885],
              [22.068886, 60.268608],
              [22.069164000000114, 60.285271000000137],
              [22.069721, 60.291107],
              [22.075554, 60.29583],
              [22.096107, 60.30778],
              [22.20583, 60.30917],
              [22.21722, 60.308884],
              [22.241943, 60.306389],
              [22.318054, 60.293327],
              [22.34111, 60.28833],
              [22.342220000000111, 60.28305],
            ],
          ],
          [
            [
              [22.383331000000112, 60.28833],
              [22.373608000000104, 60.286942],
              [22.315277, 60.316666],
              [22.32527, 60.334717],
              [22.33111, 60.339722],
              [22.338886000000116, 60.342773],
              [22.39666, 60.351105],
              [22.402775, 60.34944],
              [22.472221, 60.327774],
              [22.476944, 60.32361],
              [22.47361, 60.31833],
              [22.4675, 60.313606],
              [22.460552, 60.309441],
              [22.452774, 60.306389],
              [22.418888, 60.296387],
              [22.383331000000112, 60.28833],
            ],
          ],
          [
            [
              [21.982777000000112, 60.324165],
              [21.972221, 60.32361],
              [21.959721000000116, 60.324715],
              [21.946388, 60.326942000000145],
              [21.89944, 60.335274],
              [21.818886, 60.35805],
              [21.79639, 60.368607000000111],
              [21.789997, 60.372498],
              [21.78527, 60.376938],
              [21.784721, 60.387772],
              [21.804996000000131, 60.459442],
              [21.807499, 60.465553],
              [21.81611, 60.46777],
              [21.826664, 60.466385],
              [21.896385, 60.444443],
              [21.933331, 60.416664],
              [21.996666, 60.358887],
              [21.999443, 60.337494000000106],
              [21.99722, 60.331383],
              [21.982777000000112, 60.324165],
            ],
          ],
          [
            [
              [21.75166, 60.498329],
              [21.691666, 60.450272],
              [21.684444, 60.452774],
              [21.684998, 60.458611],
              [21.688889, 60.469444],
              [21.695, 60.482216],
              [21.699165, 60.488884],
              [21.73, 60.520271],
              [21.736664, 60.524162],
              [21.745552, 60.526382],
              [21.756943, 60.526108],
              [21.763332, 60.522499],
              [21.76388500000013, 60.515831000000105],
              [21.757500000000107, 60.503052],
              [21.75166, 60.498329],
            ],
          ],
          [
            [
              [21.32889, 60.48111],
              [21.323608, 60.477493],
              [21.275833, 60.47805],
              [21.23, 60.54777],
              [21.226944000000117, 60.552498000000128],
              [21.23111, 60.55694],
              [21.25027, 60.554993000000138],
              [21.278053000000114, 60.54028],
              [21.283886, 60.53583],
              [21.298332, 60.52277400000014],
              [21.321388, 60.495827],
              [21.32889, 60.48111],
            ],
          ],
          [
            [
              [21.483330000000137, 60.520271],
              [21.432499, 60.469719],
              [21.419167, 60.471664],
              [21.409164, 60.474442],
              [21.324997, 60.51611],
              [21.32194, 60.543053],
              [21.332775, 60.553886],
              [21.338608, 60.556389],
              [21.358055, 60.559441000000106],
              [21.369442, 60.559166000000118],
              [21.39278, 60.556664],
              [21.457497, 60.53583],
              [21.47583, 60.529442],
              [21.480553, 60.525276],
              [21.483330000000137, 60.520271],
            ],
          ],
          [
            [
              [21.29028, 60.61222],
              [21.289165, 60.56139],
              [21.276665, 60.562492000000134],
              [21.2305530000001, 60.590553],
              [21.221107000000131, 60.59916],
              [21.21805, 60.603882000000112],
              [21.213886, 60.613884],
              [21.214165, 60.619720000000143],
              [21.21833, 60.623886],
              [21.25583, 60.643051],
              [21.2666660000001, 60.643608],
              [21.276108, 60.634995000000117],
              [21.29028, 60.61222],
            ],
          ],
          [
            [
              [21.3275, 60.87722],
              [21.31861, 60.874992],
              [21.263885, 60.879166],
              [21.245831, 60.94999700000011],
              [21.254166, 60.958885],
              [21.268055000000118, 60.964722],
              [21.28666, 60.968605000000139],
              [21.296387, 60.967773],
              [21.304722, 60.964439],
              [21.32194, 60.953606],
              [21.3475, 60.932495],
              [21.35722, 60.92194],
              [21.3275, 60.87722],
            ],
          ],
          [
            [
              [21.080276, 63.281387],
              [21.29222, 63.239441000000113],
              [21.299721, 63.24333],
              [21.348331, 63.254166],
              [21.370552, 63.256386],
              [21.41333, 63.251389000000131],
              [21.41861, 63.246941],
              [21.427219, 63.196938],
              [21.42083, 63.192215],
              [21.309998, 63.15361],
              [21.300552, 63.151382000000126],
              [21.279442, 63.148331],
              [21.246944, 63.144722000000115],
              [21.252220000000136, 63.152771000000143],
              [21.248055000000136, 63.156105000000139],
              [21.195000000000107, 63.187492],
              [21.18611, 63.190826],
              [21.182777, 63.185555],
              [21.182220000000143, 63.179993],
              [21.175831, 63.174995],
              [21.165276, 63.173607],
              [21.15166, 63.174438],
              [21.144722000000115, 63.178329],
              [21.132774, 63.192215],
              [21.09889, 63.236107000000118],
              [21.081387, 63.270554000000118],
              [21.08, 63.275833],
              [21.080276, 63.281387],
            ],
          ],
          [
            [
              [22.180832, 63.265274],
              [22.17028, 63.263885],
              [22.078331000000105, 63.279442],
              [22.061108, 63.289719],
              [22.044167, 63.301941],
              [22.040833, 63.306938000000116],
              [22.046387, 63.310272000000111],
              [22.075275, 63.317215],
              [22.08583, 63.318604000000107],
              [22.192497000000117, 63.321938000000102],
              [22.197498, 63.32],
              [22.206944000000135, 63.30555],
              [22.21, 63.300827],
              [22.207497, 63.294716],
              [22.186386, 63.270828],
              [22.180832, 63.265274],
            ],
          ],
          [
            [
              [21.32333, 63.28916],
              [21.315552, 63.287216],
              [21.23333, 63.320274],
              [21.231941, 63.325554000000125],
              [21.238331, 63.330276],
              [21.29111, 63.349998],
              [21.301666, 63.351387000000102],
              [21.338608, 63.351662],
              [21.352219, 63.35055],
              [21.37611, 63.345276],
              [21.38111, 63.341110000000128],
              [21.378887000000134, 63.334999],
              [21.345554000000106, 63.30110900000011],
              [21.32333, 63.28916],
            ],
          ],
          [
            [
              [22.873608, 63.799995],
              [22.868332000000123, 63.770554],
              [22.853333, 63.776939],
              [22.81694, 63.780548],
              [22.770275, 63.784164],
              [22.750832000000116, 63.779716],
              [22.706665, 63.775276],
              [22.679443000000106, 63.78527],
              [22.672497, 63.789162],
              [22.671387, 63.794441],
              [22.672222, 63.79805],
              [22.676941, 63.804443],
              [22.683609, 63.809441],
              [22.70305, 63.82055],
              [22.80611, 63.876938],
              [22.866665, 63.874161000000129],
              [22.880554, 63.87277],
              [22.89222, 63.871109],
              [22.897499, 63.866943000000106],
              [22.916943, 63.833054000000118],
              [22.918331, 63.827774],
              [22.917221, 63.82194],
              [22.91166, 63.816383],
              [22.88777, 63.815277],
              [22.879997, 63.811386],
              [22.876389, 63.806107],
              [22.873608, 63.799995],
            ],
          ],
          [
            [
              [24.734997000000135, 64.944443],
              [24.72277, 64.94415],
              [24.707497000000103, 64.94638],
              [24.603054, 64.96193],
              [24.596107, 64.96582],
              [24.585831, 64.972488],
              [24.568054000000132, 64.990555],
              [24.551666, 65.024994000000106],
              [24.554996, 65.031097],
              [24.562222, 65.03583],
              [24.615555, 65.056381],
              [24.624996000000124, 65.059158000000139],
              [24.64583, 65.063599],
              [24.67805, 65.068878],
              [24.700832, 65.071381],
              [24.808609, 65.078049],
              [24.833611000000133, 65.078598000000113],
              [24.848053000000107, 65.07721],
              [25.018887, 65.043610000000115],
              [25.03, 65.040543],
              [25.035, 65.036102],
              [25.029442, 65.029709000000139],
              [25.021111000000133, 65.027771],
              [25.000000000000114, 65.025848],
              [24.961109000000135, 65.024429000000112],
              [24.84666, 65.003601],
              [24.820274, 64.963882],
              [24.734997000000135, 64.944443],
            ],
          ],
          [
            [
              [24.462219, 65.763885],
              [24.449718, 65.76361],
              [24.43694, 65.769714],
              [24.440552, 65.775833],
              [24.454441, 65.786102000000142],
              [24.465275000000133, 65.78833],
              [24.48, 65.786942],
              [24.495831, 65.784714],
              [24.503052000000139, 65.780548000000124],
              [24.5, 65.776657],
              [24.462219, 65.763885],
            ],
          ],
          [
            [
              [28.165833, 69.912216000000114],
              [28.197220000000129, 69.906387000000109],
              [28.226665000000139, 69.902222000000108],
              [28.276108000000136, 69.896652],
              [28.31028, 69.890823],
              [28.32333, 69.8875],
              [28.339165, 69.87944],
              [28.34472, 69.87498],
              [28.358330000000137, 69.85083],
              [28.358330000000137, 69.845551],
              [28.366665, 69.836105],
              [28.37194, 69.83166],
              [28.379719, 69.827499000000103],
              [28.404999, 69.821655],
              [28.694721, 69.7686],
              [28.744164, 69.75972],
              [28.909721, 69.733887],
              [28.94611, 69.72861],
              [28.992222, 69.722488000000112],
              [29.009441, 69.720551000000114],
              [29.09889, 69.708054000000118],
              [29.106667, 69.703888],
              [29.127499, 69.685822],
              [29.176109, 69.635269],
              [29.183887, 69.626099],
              [29.29472, 69.495270000000119],
              [29.299721, 69.48555],
              [29.299721, 69.480270000000132],
              [29.285553, 69.463608000000136],
              [29.2691650000001, 69.451935000000105],
              [29.122219, 69.37082],
              [29.064163, 69.343887],
              [29.033333, 69.330551000000128],
              [29.002499, 69.317215000000147],
              [28.991665000000125, 69.313889000000131],
              [28.931664, 69.288605000000132],
              [28.92194400000011, 69.284164],
              [28.902775, 69.274994],
              [28.83639, 69.242767],
              [28.82694, 69.23805],
              [28.819164, 69.231934],
              [28.796665, 69.188324],
              [28.784164, 69.16055],
              [28.78167, 69.149719],
              [28.781944, 69.13415],
              [28.784443, 69.123886],
              [28.786942, 69.119156],
              [28.802219, 69.10554500000012],
              [28.827499, 69.093597000000102],
              [28.857777000000112, 69.082214],
              [28.890553, 69.07138],
              [28.957340000000102, 69.05162],
              [28.91333, 69.04332],
              [28.877777, 69.036102],
              [28.8555530000001, 69.029709],
              [28.746387, 68.99721],
              [28.456944000000135, 68.91832],
              [28.446663, 68.914719000000105],
              [28.439163000000121, 68.908325],
              [28.431942, 68.896942],
              [28.43222, 68.886383],
              [28.447498, 68.878326],
              [28.4625, 68.87527],
              [28.479164, 68.873596],
              [28.509163000000115, 68.872772],
              [28.564999, 68.874435000000119],
              [28.705830000000105, 68.878326],
              [28.737778000000105, 68.87582],
              [28.792774, 68.85777],
              [28.812775, 68.850266],
              [28.815552000000139, 68.848877],
              [28.820553, 68.844437],
              [28.803333, 68.815826],
              [28.796108, 68.804443],
              [28.76416, 68.757767],
              [28.759163, 68.751938],
              [28.73860900000011, 68.73416],
              [28.654999, 68.679993],
              [28.525833, 68.589722],
              [28.510277, 68.578049],
              [28.46583, 68.540833],
              [28.458611, 68.534714],
              [28.457497, 68.53194],
              [28.559998, 68.385818],
              [28.663055, 68.239441],
              [28.693333000000109, 68.197495],
              [28.696663000000115, 68.193329000000119],
              [28.823330000000112, 68.172485000000108],
              [29.16, 68.11665],
              [29.35694100000012, 68.082489000000123],
              [29.38361, 68.062485],
              [29.539444, 67.938889000000131],
              [29.691666, 67.815277],
              [29.7275, 67.803329000000133],
              [29.9025, 67.740829],
              [30.02861, 67.69472],
              [29.977776, 67.572495],
              [29.964722, 67.544434000000138],
              [29.95472, 67.532776000000126],
              [29.932777, 67.513885],
              [29.899998, 67.492493],
              [29.881664000000114, 67.483597000000145],
              [29.745552, 67.41638],
              [29.525276000000133, 67.293884],
              [29.156944000000124, 67.030823000000112],
              [29.134163, 67.013611],
              [29.0925, 66.97583],
              [29.087776, 66.969986],
              [29.083054000000118, 66.958603],
              [29.079998, 66.943604],
              [29.075275, 66.911377],
              [29.07499700000011, 66.895828000000108],
              [29.07499700000011, 66.87999],
              [29.077221000000122, 66.874985],
              [29.086388000000113, 66.860825],
              [29.09333, 66.85138],
              [29.097775, 66.846939000000134],
              [29.123055, 66.824707],
              [29.13444, 66.8161],
              [29.202774, 66.774429000000112],
              [29.221107000000131, 66.76694],
              [29.246109000000104, 66.75499],
              [29.25972, 66.746658],
              [29.273331, 66.73832700000014],
              [29.318886, 66.708878000000141],
              [29.33, 66.700272],
              [29.350277000000119, 66.682495],
              [29.359444, 66.673325],
              [29.385548, 66.62831100000011],
              [29.414165000000139, 66.599991000000102],
              [29.554443, 66.470276],
              [29.567924000000119, 66.42857400000014],
              [29.573055000000124, 66.41137700000013],
              [29.574718, 66.406937],
              [29.577499000000103, 66.401657],
              [29.583332, 66.39221],
              [29.590275, 66.382767000000115],
              [29.62527, 66.33638],
              [29.638611000000139, 66.322495000000117],
              [29.770832, 66.214157],
              [29.782219, 66.205276],
              [29.799164, 66.19249],
              [29.826111000000139, 66.175552],
              [29.849998, 66.163605000000132],
              [29.876389000000131, 66.152222000000108],
              [29.897221, 66.140823],
              [29.910275, 66.126938000000109],
              [29.918888, 66.112778],
              [29.94833, 66.049713],
              [30.032219, 65.922211000000118],
              [30.091110000000128, 65.842773],
              [30.09666, 65.833328],
              [30.1025, 65.8186],
              [30.134163, 65.71916],
              [30.134998, 65.709152],
              [30.135277, 65.703598000000113],
              [30.13361, 65.676941],
              [30.123886, 65.66499],
              [30.111664000000133, 65.66527],
              [30.085278, 65.67139],
              [30.068054000000132, 65.679443],
              [30.036110000000122, 65.68999],
              [30.024441, 65.691101000000117],
              [29.992496000000131, 65.685272000000111],
              [29.818886, 65.653320000000122],
              [29.834164, 65.588333],
              [29.798054, 65.53749],
              [29.77916, 65.530273],
              [29.761387, 65.523041],
              [29.746109, 65.514435],
              [29.738331, 65.481110000000115],
              [29.739719, 65.455551],
              [29.745552, 65.414719000000105],
              [29.75, 65.352768],
              [29.74944, 65.347763],
              [29.747498, 65.341934],
              [29.70611, 65.31972],
              [29.679996, 65.306931],
              [29.662220000000104, 65.298874],
              [29.620831, 65.276657],
              [29.605274000000122, 65.265823000000125],
              [29.598888, 65.25972],
              [29.596943, 65.253876],
              [29.596386, 65.24889],
              [29.599163, 65.243607000000111],
              [29.60305, 65.239441],
              [29.609444, 65.23527],
              [29.62639, 65.22749],
              [29.639721000000122, 65.224442],
              [29.652222000000108, 65.22333],
              [29.6655540000001, 65.22333],
              [29.73722, 65.226654],
              [29.787498, 65.226379],
              [29.81389, 65.224442],
              [29.827499, 65.22249],
              [29.843052000000114, 65.219986],
              [29.853611, 65.21611],
              [29.866108, 65.208054000000118],
              [29.869999, 65.203323],
              [29.87278, 65.19832],
              [29.874443, 65.12582],
              [29.873886, 65.12082],
              [29.864719, 65.116653],
              [29.836666, 65.106934],
              [29.806942, 65.099152],
              [29.773888, 65.09471],
              [29.726387000000102, 65.092499],
              [29.683609, 65.08444],
              [29.664719000000105, 65.079163],
              [29.65472, 65.075546],
              [29.63722, 65.068329000000119],
              [29.628887, 65.063049],
              [29.622498, 65.056381],
              [29.616665000000125, 65.044998],
              [29.609444, 65.02304],
              [29.60639, 65.007217],
              [29.60666700000013, 65.001663],
              [29.609997000000135, 64.991943],
              [29.636665, 64.92805],
              [29.644997, 64.913879000000122],
              [29.652775, 64.904709],
              [29.67194, 64.887207],
              [29.714443, 64.852219],
              [29.730553, 64.839432],
              [29.736664, 64.834991000000116],
              [29.755, 64.822495],
              [29.774441, 64.809708],
              [29.79416700000013, 64.797211],
              [29.804722, 64.793884000000105],
              [29.818333, 64.792496],
              [29.843052000000114, 64.792496],
              [29.8916660000001, 64.793045],
              [29.926388, 64.794708],
              [29.95027, 64.795547],
              [30.04805, 64.795547],
              [30.074444, 64.79361],
              [30.08778, 64.79166],
              [30.115833, 64.785828],
              [30.126389, 64.782486000000119],
              [30.140831, 64.774155],
              [30.144722000000115, 64.769989000000123],
              [30.20916, 64.672775000000115],
              [30.210552, 64.66777],
              [30.208611, 64.662491000000102],
              [30.199165, 64.65027],
              [30.186386, 64.63777],
              [30.17889, 64.631653],
              [30.17028, 64.628052],
              [30.141666, 64.619431000000134],
              [30.07249800000011, 64.60443],
              [30.033333, 64.599152],
              [30.020554000000118, 64.5961],
              [29.980831, 64.585831],
              [29.974998, 64.581100000000106],
              [29.974998, 64.57443],
              [29.986942000000113, 64.55305],
              [30.00967, 64.51286],
              [30.01139, 64.511658],
              [30.04888, 64.50249],
              [30.068607, 64.49472],
              [30.087219, 64.483047],
              [30.088608, 64.478333],
              [30.088333, 64.467773],
              [30.083054, 64.45221],
              [30.061386, 64.422485],
              [30.053608, 64.404999],
              [30.065552, 64.396942],
              [30.11889, 64.36916],
              [30.12722, 64.36499],
              [30.135277, 64.361374],
              [30.156109, 64.354156],
              [30.17028, 64.351379000000122],
              [30.196941, 64.348877],
              [30.321663, 64.329437],
              [30.359444, 64.31972],
              [30.389721, 64.309433000000126],
              [30.55278, 64.248322],
              [30.560833000000116, 64.244431000000134],
              [30.566666000000112, 64.23999],
              [30.573887, 64.23082],
              [30.576664000000108, 64.226105000000132],
              [30.578053, 64.221375],
              [30.611111000000108, 64.101654],
              [30.614441000000113, 64.086655000000121],
              [30.611664, 64.075821],
              [30.608887, 64.06499],
              [30.595276000000126, 64.046936],
              [30.558887, 64.020554000000118],
              [30.54361, 64.009995],
              [30.528610000000128, 64.0],
              [30.48860900000011, 63.977776],
              [30.47194, 63.968887],
              [30.398052, 63.93055],
              [30.27861, 63.832771],
              [30.263611, 63.82222],
              [30.255833000000109, 63.817772000000105],
              [30.210552, 63.80082700000014],
              [30.134998, 63.779999],
              [30.114719, 63.775276],
              [30.063053, 63.766663000000108],
              [30.033054, 63.760826000000122],
              [30.013054, 63.756386000000134],
              [30.004719, 63.75278],
              [29.996712, 63.74802],
              [29.993332, 63.743607],
              [29.995831, 63.738884],
              [30.00333, 63.729439],
              [30.206387, 63.612778],
              [30.228333, 63.600555],
              [30.244442, 63.593048],
              [30.254719000000136, 63.58972],
              [30.308887, 63.572495000000117],
              [30.357498000000135, 63.559998000000121],
              [30.391388, 63.549995],
              [30.399441, 63.546104],
              [30.4525, 63.508049],
              [30.461941, 63.499161000000129],
              [30.472775, 63.48555],
              [30.4775, 63.481110000000115],
              [30.481667, 63.47861],
              [30.648888000000113, 63.439720000000136],
              [30.714722, 63.424438000000123],
              [30.91222, 63.353607],
              [31.186386, 63.238327],
              [31.219719, 63.223053],
              [31.236664000000133, 63.21027400000014],
              [31.24222200000014, 63.205551],
              [31.245831000000123, 63.20111],
              [31.38305, 63.06916],
              [31.514999000000103, 62.986938],
              [31.524166, 62.978333000000134],
              [31.588928000000124, 62.914413000000138],
              [31.574997, 62.901382],
              [31.521664, 62.853333],
              [31.501389, 62.835548],
              [31.480553, 62.818886],
              [31.4675, 62.806389],
              [31.429996, 62.758888],
              [31.32194, 62.615273],
              [31.310555, 62.598053],
              [31.294167, 62.56416],
              [31.280277, 62.53611],
              [31.269165, 62.51861],
              [31.25972, 62.507774],
              [31.251942, 62.503326000000129],
              [31.082775, 62.41305],
              [30.964165, 62.339165],
              [30.834442, 62.271385000000123],
              [30.7925, 62.253883],
              [30.704166, 62.210548000000131],
              [30.6325, 62.166107000000125],
              [30.396111, 62.016663000000108],
              [30.300552, 61.95611],
              [30.203888, 61.890549],
              [30.155102, 61.85635],
              [30.142174000000125, 61.846954],
              [30.005554, 61.739441],
              [29.991386, 61.729439],
              [29.809166, 61.60833],
              [29.79472, 61.5991590000001],
              [29.683331000000123, 61.533882],
              [29.652496, 61.517776],
              [29.497498, 61.436661],
              [29.362499, 61.364166],
              [29.348053000000107, 61.35527],
              [29.334164, 61.345276],
              [29.301941, 61.318329000000119],
              [29.285076000000117, 61.302864],
              [29.277496, 61.294716],
              [29.271111, 61.289444],
              [29.249722, 61.27583],
              [29.21361, 61.253326],
              [29.174164, 61.235275],
              [29.157497, 61.228882000000112],
              [29.071941, 61.19944],
              [28.970833, 61.162773000000129],
              [28.820553, 61.106941],
              [28.812775, 61.103333],
              [28.719997, 61.04527],
              [28.674164, 61.00166],
              [28.652222000000108, 60.976105],
              [28.638885, 60.966110000000128],
              [28.6311070000001, 60.962494000000106],
              [28.622498000000121, 60.959717],
              [28.612499, 60.958885],
              [28.57777, 60.961662],
              [28.547775000000115, 60.958885],
              [28.529163, 60.954994],
              [28.520554, 60.952217],
              [28.466389, 60.92528],
              [28.38888500000013, 60.886665],
              [28.351109, 60.865829],
              [28.344166, 60.861382],
              [28.338055, 60.855827],
              [28.33444, 60.849998],
              [28.3325, 60.84416],
              [28.326385, 60.838882000000126],
              [28.298611, 60.820549],
              [28.269444000000135, 60.804161],
              [28.246387, 60.793327],
              [28.093887000000109, 60.712219000000118],
              [27.88472, 60.58916],
              [27.807831, 60.546402],
              [27.80666, 60.548607],
              [27.789997, 60.566109],
              [27.785275, 60.570549],
              [27.774719, 60.573883],
              [27.76277, 60.574715],
              [27.75222, 60.574165],
              [27.74361, 60.572495],
              [27.739441, 60.567497],
              [27.734997, 60.551666],
              [27.734165000000132, 60.535553],
              [27.738052, 60.511383000000137],
              [27.671108000000117, 60.50444],
              [27.60667, 60.506104],
              [27.476665000000139, 60.506386],
              [27.472221000000104, 60.502495],
              [27.473053, 60.476387],
              [27.29555, 60.503883],
              [27.271942, 60.525276],
              [27.270832, 60.541939],
              [27.223053000000107, 60.58194],
              [27.215275000000133, 60.585548],
              [27.031387, 60.53889],
              [27.025555000000111, 60.53333],
              [27.020554, 60.52694],
              [26.9675, 60.445274],
              [26.960278, 60.44194],
              [26.9525, 60.445549],
              [26.905277000000126, 60.476105000000132],
              [26.811108, 60.47277],
              [26.739441, 60.448883],
              [26.666943000000117, 60.426666000000125],
              [26.56361, 60.42805],
              [26.503052, 60.443054],
              [26.497219, 60.446938],
              [26.483608000000117, 60.46],
              [26.474998, 60.468605],
              [26.473053, 60.473328],
              [26.474163, 60.47916],
              [26.48, 60.48555],
              [26.564163, 60.574165],
              [26.575832000000105, 60.585548],
              [26.594997, 60.598053000000107],
              [26.617222, 60.605827],
              [26.628887000000134, 60.608055],
              [26.648888, 60.60889],
              [26.668331, 60.607498],
              [26.68889, 60.597771],
              [26.702499, 60.586105],
              [26.734997, 60.575272],
              [26.753887, 60.571663000000115],
              [26.754997, 60.577217],
              [26.721943, 60.617775],
              [26.69527, 60.640831],
              [26.68861, 60.64416],
              [26.659164, 60.6475],
              [26.645554, 60.645271],
              [26.61555, 60.640274],
              [26.60722, 60.63694],
              [26.546089000000109, 60.58192],
              [26.526943000000131, 60.565277],
              [26.461941, 60.5075],
              [26.456944, 60.500832],
              [26.45388800000012, 60.494995],
              [26.452774, 60.483887],
              [26.459442, 60.469444],
              [26.468052, 60.460548000000131],
              [26.471664, 60.455826],
              [26.478333000000134, 60.446938],
              [26.48222, 60.43694],
              [26.479164000000139, 60.431107],
              [26.47277, 60.426384],
              [26.458611, 60.416107000000125],
              [26.421665, 60.391937],
              [26.411388000000102, 60.39138800000012],
              [26.146111, 60.393883],
              [26.06111, 60.423882],
              [26.051388, 60.427498],
              [26.046665, 60.41583],
              [26.111664, 60.330276],
              [26.109722, 60.324715],
              [26.104721, 60.318054000000132],
              [26.094444, 60.306107],
              [26.083054, 60.294998],
              [26.074444, 60.2930530000001],
              [26.041943, 60.2930530000001],
              [26.036942000000124, 60.296104000000128],
              [26.03805, 60.301941000000113],
              [26.04361, 60.30722],
              [26.04639, 60.313606],
              [26.044441, 60.31833],
              [26.04055, 60.322495],
              [25.996109, 60.344719],
              [25.893608, 60.38805],
              [25.884163, 60.39138800000012],
              [25.838055000000111, 60.401108],
              [25.838333, 60.395828],
              [25.863609, 60.385826],
              [25.87833, 60.379997],
              [25.909443, 60.360275000000115],
              [25.915276, 60.35583],
              [25.9180530000001, 60.35139],
              [25.928608, 60.248604],
              [25.927776000000108, 60.244438],
              [25.919998, 60.24166],
              [25.910275000000127, 60.240273],
              [25.899166, 60.240273],
              [25.887497, 60.24166],
              [25.881664, 60.245552],
              [25.880554, 60.251106],
              [25.877777, 60.260826000000122],
              [25.873886, 60.270828000000108],
              [25.870831, 60.275551],
              [25.864998, 60.279442000000131],
              [25.753887, 60.314720000000136],
              [25.744776, 60.310219],
              [25.740442000000144, 60.307388000000117],
              [25.742775, 60.29805],
              [25.741665, 60.29055],
              [25.74555, 60.286110000000122],
              [25.788055, 60.268608],
              [25.799999000000128, 60.26722],
              [25.829166, 60.270828000000108],
              [25.841110000000128, 60.26944],
              [25.845833, 60.264999000000103],
              [25.780277, 60.232773],
              [25.769444, 60.234444],
              [25.720554, 60.248055],
              [25.674164, 60.275276],
              [25.65361, 60.29166],
              [25.649719, 60.296387],
              [25.647778, 60.301109],
              [25.647778, 60.335548],
              [25.657497, 60.337494000000106],
              [25.6675, 60.337494000000106],
              [25.693554, 60.339382],
              [25.694553, 60.342216],
              [25.69339, 60.34522],
              [25.690277, 60.35694],
              [25.683331, 60.36055],
              [25.6725, 60.362778000000105],
              [25.66222, 60.362221],
              [25.652775000000133, 60.360275000000115],
              [25.576111, 60.328888],
              [25.545277, 60.311104000000114],
              [25.48944, 60.245827],
              [25.478886, 60.248329000000126],
              [25.367775, 60.255829],
              [25.200832000000105, 60.241943],
              [25.192219000000136, 60.239998],
              [25.148888000000113, 60.22361],
              [25.14638, 60.219444],
              [25.156109, 60.216385000000116],
              [25.180832000000123, 60.213333],
              [25.193333000000109, 60.21083],
              [25.201111, 60.2075],
              [25.203331000000105, 60.20277],
              [25.19527, 60.186386],
              [25.188053, 60.18222],
              [25.06583, 60.156105],
              [24.958878, 60.136681000000124],
              [24.949436000000105, 60.135559],
              [24.85083, 60.13666],
              [24.75111, 60.13694],
              [24.603333, 60.121941],
              [24.608887, 60.095276000000126],
              [24.60805, 60.089722000000108],
              [24.591942, 60.056664000000126],
              [24.586666, 60.05305],
              [24.48222, 59.991386],
              [24.462776000000133, 59.989441],
              [24.421104, 59.987221],
              [24.421387, 60.027222],
              [24.366665, 60.068054],
              [24.355, 60.070549],
              [24.333054, 60.071938],
              [24.292221, 60.068604],
              [24.285275, 60.06444],
              [24.281944, 60.059441],
              [24.216942, 60.039444],
              [24.07416, 60.01527],
              [23.7972180000001, 59.961937],
              [23.70194, 59.95444],
              [23.62833, 59.952217000000132],
              [23.61805, 59.951942],
              [23.5613570000001, 59.970669],
              [23.50979, 59.96849],
              [23.434444, 59.950554],
              [23.426662, 59.953888],
              [23.43083, 59.960274],
              [23.479443, 59.996666],
              [23.521942, 60.019165],
              [23.537498, 60.025276000000133],
              [23.5425, 60.031105000000139],
              [23.54611, 60.067215],
              [23.53833, 60.06972],
              [23.519444, 60.066109],
              [23.493889000000138, 60.058327],
              [23.365829, 59.94221],
              [23.252499000000114, 59.839165],
              [23.246109, 59.836662000000103],
              [23.193886, 59.82777],
              [22.909721, 59.804993000000138],
              [22.889721, 59.80639],
              [22.891941, 59.810829],
              [22.93472, 59.840553],
              [23.086941000000138, 59.879166000000112],
              [23.114998, 59.884438],
              [23.156109, 59.8836060000001],
              [23.16555, 59.88611],
              [23.257217, 59.919441],
              [23.29666, 59.95861],
              [23.325577, 60.0],
              [23.33833, 60.02],
              [23.335278, 60.027496],
              [23.33083, 60.028328],
              [23.317234, 60.02066],
              [23.311234, 60.014832],
              [23.297009000000116, 60.0],
              [23.280273, 59.979439],
              [23.250549, 59.94527],
              [23.234718, 59.932495],
              [23.224995, 59.926109],
              [23.215549000000124, 59.924995],
              [23.117496, 59.922493],
              [23.10722, 59.922493],
              [23.101109, 59.926109],
              [23.098053000000107, 59.93083],
              [23.0975, 59.935829],
              [23.107777, 59.96833],
              [23.114441, 59.972221],
              [23.16694, 59.985275000000115],
              [23.202496, 59.993332],
              [23.218563000000131, 60.0],
              [23.224720000000104, 60.003326000000129],
              [23.25972, 60.035553000000107],
              [23.250000000000114, 60.038605],
              [23.19833, 60.04722],
              [23.18555, 60.04833200000013],
              [23.14666, 60.046104],
              [23.126389, 60.04416700000013],
              [23.109444, 60.039444],
              [23.101665, 60.036385],
              [23.083885, 60.032219000000111],
              [23.073887, 60.031387],
              [23.049442, 60.03611],
              [22.995831, 60.054443],
              [22.987778, 60.057777],
              [22.985554, 60.062775],
              [22.992496, 60.081108],
              [23.00361, 60.091385],
              [23.017288, 60.10122],
              [23.04361, 60.116661],
              [23.041943, 60.120827],
              [23.027775, 60.128052],
              [23.022499, 60.129166],
              [22.967499, 60.111938000000123],
              [22.906109000000129, 60.126389000000131],
              [22.87444, 60.145554000000118],
              [22.86972, 60.179161],
              [22.901386000000116, 60.213333],
              [22.907219000000111, 60.21833],
              [22.92, 60.227219],
              [22.93361, 60.23472],
              [22.964443, 60.248329000000126],
              [22.97111, 60.25222],
              [23.011387000000127, 60.277496],
              [23.023052, 60.286942],
              [23.086388, 60.34166],
              [23.086941000000138, 60.346939],
              [23.07889, 60.350555],
              [23.066944, 60.35305],
              [23.055832000000123, 60.353333],
              [22.91917, 60.304161],
              [22.808331, 60.26194],
              [22.793888, 60.254997000000117],
              [22.760555, 60.244164000000126],
              [22.74361, 60.23972],
              [22.72555, 60.234993],
              [22.699165, 60.22916],
              [22.66278, 60.222221],
              [22.574997, 60.210548],
              [22.55595, 60.213326],
              [22.451385, 60.240273],
              [22.44722, 60.244438],
              [22.460278, 60.261108],
              [22.46527, 60.266663000000108],
              [22.480274, 60.28139],
              [22.488052, 60.285],
              [22.53611, 60.312492],
              [22.62028, 60.370277000000101],
              [22.62611, 60.374992000000134],
              [22.631386, 60.381104000000107],
              [22.63361, 60.38694],
              [22.632221, 60.391937],
              [22.62278, 60.393051],
              [22.483608, 60.391937],
              [22.276943, 60.385826],
              [22.259163000000115, 60.398048],
              [22.23666, 60.408333],
              [22.17583100000013, 60.431389000000138],
              [22.114719, 60.448883],
              [22.08361, 60.443886000000134],
              [22.01444, 60.465271],
              [21.971107, 60.488052],
              [21.949165000000107, 60.513054],
              [21.947498, 60.518608],
              [21.937496, 60.521385000000123],
              [21.86972, 60.524162],
              [21.851944, 60.524162],
              [21.839722000000108, 60.524162],
              [21.8375, 60.51833],
              [21.84166, 60.50805],
              [21.863052, 60.471939],
              [21.803055, 60.482498000000135],
              [21.796665, 60.555832000000123],
              [21.796944, 60.56194],
              [21.799999, 60.566940000000102],
              [21.81361, 60.575829],
              [21.828888, 60.58194],
              [21.830555000000118, 60.59499],
              [21.824444, 60.61916],
              [21.775, 60.60305],
              [21.76638800000012, 60.599716],
              [21.664165, 60.552498000000128],
              [21.58833, 60.50694],
              [21.587776, 60.51194],
              [21.576942, 60.562492000000134],
              [21.557499, 60.568329000000119],
              [21.545555, 60.570831],
              [21.51861, 60.574715],
              [21.5075, 60.574715],
              [21.497219, 60.573608],
              [21.489719, 60.57],
              [21.47361, 60.56472],
              [21.452774, 60.562492000000134],
              [21.429996, 60.573326],
              [21.418331, 60.585274],
              [21.358608, 60.65361],
              [21.354721, 60.673607000000118],
              [21.355, 60.683609000000104],
              [21.363609, 60.686386],
              [21.386108, 60.686386],
              [21.392498000000103, 60.755554],
              [21.35555, 60.814995],
              [21.328331, 60.865273],
              [21.387775, 60.940826000000129],
              [21.405552, 61.030548],
              [21.44444, 61.167221],
              [21.493889, 61.23555],
              [21.54444100000012, 61.276382],
              [21.554443, 61.309441],
              [21.530552, 61.44722],
              [21.519444, 61.509163000000115],
              [21.51083, 61.51249700000011],
              [21.497498, 61.52],
              [21.465275, 61.550552],
              [21.4725, 61.562492000000134],
              [21.493332000000123, 61.573883],
              [21.503330000000119, 61.57305],
              [21.603333000000134, 61.544716],
              [21.659721000000104, 61.533607],
              [21.668053, 61.54694400000011],
              [21.601387, 61.601662],
              [21.535275, 61.65333],
              [21.470276, 61.755272],
              [21.47083, 61.760826],
              [21.478333, 61.772774],
              [21.489441, 61.797775],
              [21.488052, 61.80305],
              [21.410553, 61.890549],
              [21.363331, 61.929443000000106],
              [21.299603, 61.941826000000106],
              [21.28889, 61.944717],
              [21.280277, 61.948051],
              [21.25333, 62.005554],
              [21.285553, 62.06944],
              [21.305832000000123, 62.108887],
              [21.333885, 62.153885000000116],
              [21.37778, 62.179443],
              [21.382774, 62.185272],
              [21.389999000000103, 62.203606],
              [21.38861, 62.208885],
              [21.371666, 62.259995],
              [21.33667, 62.348885],
              [21.32777, 62.352219],
              [21.25916, 62.375832000000116],
              [21.155552, 62.412773],
              [21.111664000000133, 62.45166],
              [21.114998000000128, 62.491386],
              [21.125275000000101, 62.547493],
              [21.067497, 62.591660000000104],
              [21.064163, 62.596382],
              [21.064720000000136, 62.612221],
              [21.101944, 62.762772],
              [21.106110000000115, 62.76944],
              [21.112499000000128, 62.77444],
              [21.13028, 62.787773],
              [21.137497, 62.791939],
              [21.29805, 62.860832],
              [21.339722, 62.85472],
              [21.351944, 62.854439000000127],
              [21.362499, 62.855827],
              [21.370831, 62.859161],
              [21.37722, 62.86388],
              [21.382500000000107, 62.86972],
              [21.396385, 62.886665],
              [21.433331, 62.943329],
              [21.445831, 62.967499],
              [21.450554, 63.006386],
              [21.434166, 63.030273000000136],
              [21.434719, 63.035828],
              [21.439163, 63.042496],
              [21.49555, 63.06583],
              [21.50611, 63.06721],
              [21.51972, 63.06611],
              [21.537498, 63.059441],
              [21.54444100000012, 63.05555],
              [21.54722, 63.045273000000122],
              [21.552219, 63.040833],
              [21.561108, 63.037498],
              [21.619999, 63.018608],
              [21.670277, 63.01777600000014],
              [21.67972200000014, 63.019997],
              [21.686108, 63.024994],
              [21.682777000000101, 63.029716],
              [21.677776, 63.03388],
              [21.658607, 63.04583],
              [21.651665, 63.049721],
              [21.611385, 63.068054000000132],
              [21.575275, 63.075829],
              [21.566387000000134, 63.079163],
              [21.561108, 63.08361],
              [21.521942000000138, 63.120552],
              [21.51527, 63.129997],
              [21.501663, 63.159721],
              [21.492496, 63.19194],
              [21.49305, 63.197495000000117],
              [21.497776000000101, 63.21],
              [21.504166, 63.214722000000108],
              [21.53416, 63.228607],
              [21.542774, 63.231941],
              [21.555553, 63.229439000000127],
              [21.56444, 63.226105000000132],
              [21.569443, 63.221939],
              [21.570831000000112, 63.21666],
              [21.576111, 63.21222],
              [21.583054, 63.208611],
              [21.63361, 63.193054],
              [21.647221, 63.19194],
              [21.690277, 63.20916],
              [21.869164, 63.25694],
              [21.881943, 63.25666],
              [21.890831000000105, 63.253326],
              [21.892776, 63.206108],
              [21.96666, 63.183052],
              [22.086109, 63.222771000000137],
              [22.179722, 63.230827],
              [22.216942000000131, 63.236382000000106],
              [22.337219, 63.2736],
              [22.342777, 63.279442],
              [22.36777, 63.310555],
              [22.371387, 63.315826000000129],
              [22.35555, 63.339722],
              [22.327221, 63.366104],
              [22.320274, 63.369995000000131],
              [22.298611, 63.375832000000116],
              [22.27194, 63.386108],
              [22.203053, 63.417221],
              [22.198055, 63.421387],
              [22.191666, 63.430832],
              [22.185555, 63.440552],
              [22.186108000000104, 63.446106],
              [22.188053, 63.463051],
              [22.283886, 63.524162],
              [22.292500000000132, 63.527222],
              [22.32888800000012, 63.52166],
              [22.337776, 63.518326],
              [22.37611, 63.489716],
              [22.39638, 63.472496],
              [22.429443, 63.498886],
              [22.489441, 63.565826],
              [22.50528, 63.583611],
              [22.512981000000138, 63.598732],
              [22.504166, 63.607773000000122],
              [22.5, 63.617493],
              [22.502777, 63.623886],
              [22.589165, 63.695549],
              [22.65694, 63.698883],
              [22.668888, 63.69944],
              [22.68055, 63.697777],
              [22.699718, 63.685829],
              [22.70277, 63.681107000000111],
              [22.707775, 63.66499],
              [22.70611, 63.653885],
              [22.733608, 63.621666],
              [22.740833, 63.617775000000108],
              [22.752499, 63.618332],
              [22.78055, 63.625832],
              [22.824444, 63.641388],
              [22.899998, 63.698608],
              [22.931389000000138, 63.755829],
              [22.930275, 63.760826000000122],
              [22.925278, 63.765274],
              [22.918331, 63.76916],
              [22.92333, 63.801109],
              [23.066387, 63.85083],
              [23.143055, 63.876938],
              [23.152775, 63.879166],
              [23.19527, 63.885277],
              [23.206108, 63.886665],
              [23.318886000000134, 63.896660000000111],
              [23.371944, 63.938889],
              [23.368889, 63.943604],
              [23.371387, 63.986938000000123],
              [23.379997, 64.04222],
              [23.38472, 64.0486],
              [23.395832, 64.049988],
              [23.42055, 64.049988],
              [23.434719, 64.048874000000126],
              [23.511387, 64.03637700000013],
              [23.602219000000105, 64.064438],
              [23.60833, 64.09833],
              [23.652222, 64.140823],
              [23.694164, 64.1586],
              [23.711662000000103, 64.1629],
              [23.722221, 64.184158],
              [23.855274, 64.243881000000101],
              [23.926666000000125, 64.2691650000001],
              [23.923885, 64.284988000000112],
              [23.929996000000131, 64.29693600000013],
              [23.99222200000014, 64.381104],
              [23.999443, 64.38582],
              [24.119999000000121, 64.436386],
              [24.209721, 64.47276],
              [24.278053, 64.496933000000126],
              [24.33527800000013, 64.519714000000135],
              [24.34333, 64.523605],
              [24.359165, 64.543045],
              [24.376663, 64.579712],
              [24.375832, 64.584991],
              [24.367222, 64.599442],
              [24.367496, 64.610275],
              [24.36861, 64.616104],
              [24.37167, 64.622208],
              [24.376942, 64.628601],
              [24.424999000000128, 64.675278000000105],
              [24.535275000000127, 64.741379000000109],
              [24.535553, 64.75221],
              [24.536942, 64.795822],
              [24.542221, 64.80249],
              [24.73111, 64.854431],
              [24.803333000000123, 64.869156],
              [25.000000000000114, 64.892212],
              [25.075832, 64.910828],
              [25.086388, 64.912766],
              [25.09972, 64.912216],
              [25.112778, 64.909439000000134],
              [25.11972, 64.905548],
              [25.180275, 64.866943000000106],
              [25.191387, 64.84776],
              [25.196388, 64.843323000000112],
              [25.2275, 64.820831],
              [25.233330000000137, 64.817764000000125],
              [25.246387, 64.814987],
              [25.26083, 64.813599000000124],
              [25.297497000000135, 64.814438],
              [25.31944, 64.817764000000125],
              [25.339996, 64.82193],
              [25.359722, 64.826935],
              [25.364166, 64.83194],
              [25.366943, 64.891663],
              [25.365555, 64.902222],
              [25.360832, 64.906662],
              [25.348610000000122, 64.9086],
              [25.33722, 64.90721],
              [25.317219, 64.902222],
              [25.30305, 64.903885000000116],
              [25.233608, 64.927765000000136],
              [25.226665, 64.931656],
              [25.190277, 64.96193],
              [25.188332, 64.96611],
              [25.208054, 64.987213],
              [25.218609000000129, 64.989166],
              [25.311943, 64.983047],
              [25.32333, 64.981934000000138],
              [25.339165, 64.974442],
              [25.359997, 64.962494],
              [25.37611, 64.954712],
              [25.407497, 64.94472],
              [25.420830000000137, 64.94415],
              [25.44055, 64.949158],
              [25.447220000000129, 64.954712],
              [25.448608, 64.960541],
              [25.413055, 65.034164000000146],
              [25.37055, 65.079437],
              [25.360832, 65.088333],
              [25.346943, 65.096375],
              [25.298054, 65.108047000000113],
              [25.284721, 65.110825],
              [25.267498000000103, 65.169998000000135],
              [25.29305, 65.26639],
              [25.301109, 65.29361],
              [25.324997, 65.345825000000104],
              [25.355274000000122, 65.410828],
              [25.357498, 65.445541],
              [25.356941, 65.450821],
              [25.353333, 65.476944],
              [25.349163, 65.480545],
              [25.310833000000116, 65.511108],
              [25.296665, 65.51916],
              [25.21972, 65.55249],
              [25.210552, 65.556107],
              [25.196941, 65.558884],
              [25.18222, 65.560272],
              [25.16972, 65.559998],
              [25.15333, 65.551666000000125],
              [25.140831, 65.5511],
              [25.123333, 65.557495000000131],
              [25.10889, 65.565277],
              [25.094719, 65.57332],
              [25.092735, 65.591873],
              [25.086666, 65.603043],
              [25.079441, 65.606934000000138],
              [25.070274, 65.61055],
              [24.898052000000121, 65.647018],
              [24.88444, 65.64976],
              [24.796108, 65.658325],
              [24.771664, 65.656662],
              [24.752499, 65.650543],
              [24.74472, 65.645828],
              [24.66917, 65.654709000000139],
              [24.56277, 65.723328],
              [24.557499, 65.727768],
              [24.554722, 65.732498000000135],
              [24.553333, 65.753876],
              [24.553608, 65.764709],
              [24.553886, 65.775543],
              [24.556389, 65.786942],
              [24.561943, 65.79332],
              [24.629997, 65.854431],
              [24.68916, 65.8961],
              [24.631386, 65.88916],
              [24.621666000000118, 65.886108],
              [24.563332, 65.830276],
              [24.560833, 65.819153],
              [24.538609000000122, 65.795273],
              [24.448952000000133, 65.79427],
              [24.419998, 65.768326],
              [24.40944, 65.766388],
              [24.226109, 65.771942],
              [24.214443, 65.774994],
              [24.176666, 65.789154],
              [24.173332, 65.793884000000105],
              [24.167007, 65.814026],
              [24.16861, 65.819992],
              [24.166664, 65.830551],
              [24.160553, 65.84],
              [24.031387, 66.020264],
              [23.967777000000126, 66.072495],
              [23.94861, 66.101379000000122],
              [23.940277, 66.121384000000148],
              [23.930832, 66.135544],
              [23.92555, 66.139999],
              [23.912498, 66.148331],
              [23.89333, 66.15527],
              [23.879444, 66.158051000000114],
              [23.864166, 66.159164],
              [23.84805, 66.161377],
              [23.82027, 66.16666],
              [23.80833, 66.169708],
              [23.754719, 66.184998],
              [23.735275, 66.19194],
              [23.727776, 66.195831],
              [23.722221, 66.20027],
              [23.71917, 66.204987],
              [23.68472, 66.263321],
              [23.66639, 66.30222],
              [23.661942000000124, 66.31221],
              [23.660831, 66.317215],
              [23.639164, 66.430542],
              [23.640274, 66.436096],
              [23.646664000000101, 66.448318],
              [23.652222, 66.454712],
              [23.658886, 66.460541],
              [23.66639, 66.465271000000143],
              [23.725277, 66.50082],
              [23.80722, 66.53777],
              [23.826942, 66.543884000000105],
              [23.861942, 66.5486],
              [23.87194, 66.551666],
              [23.878609, 66.55722],
              [23.884163, 66.563889000000131],
              [23.887497, 66.569992],
              [23.891941, 66.5816650000001],
              [23.902775, 66.680267],
              [23.90083, 66.712494],
              [23.891109000000142, 66.737778],
              [23.89, 66.743042],
              [23.89361, 66.749161],
              [23.936943, 66.786942],
              [23.948055, 66.788879],
              [23.987778, 66.790268],
              [23.999722, 66.791382],
              [24.006386, 66.794998],
              [24.00777, 66.800552],
              [24.00111, 66.810272000000111],
              [23.949997, 66.87082],
              [23.94111, 66.87999],
              [23.935833000000116, 66.884155],
              [23.866943000000106, 66.931107],
              [23.787777, 66.981384000000105],
              [23.75777, 66.991943000000106],
              [23.744442, 67.000000000000114],
              [23.73111, 67.008331],
              [23.68111, 67.047485],
              [23.580555000000118, 67.147491],
              [23.571663, 67.156662],
              [23.57055, 67.161942],
              [23.586666, 67.234985000000108],
              [23.594444, 67.24638],
              [23.6055530000001, 67.259430000000123],
              [23.614441, 67.263321],
              [23.624722, 67.26638800000012],
              [23.63583, 67.2686],
              [23.683052, 67.27554],
              [23.708054, 67.278046000000131],
              [23.73166700000013, 67.28166],
              [23.741665000000125, 67.284714000000122],
              [23.749722, 67.289444000000117],
              [23.773331, 67.314438000000109],
              [23.781944, 67.326385],
              [23.783054, 67.332214],
              [23.768887, 67.41083],
              [23.76777600000014, 67.416107000000125],
              [23.761944, 67.420273],
              [23.734997000000135, 67.426102],
              [23.581944000000135, 67.449997],
              [23.549164, 67.453323],
              [23.536663, 67.451935],
              [23.527496, 67.448044],
              [23.51194, 67.438599],
              [23.500553000000139, 67.436386],
              [23.486942, 67.43805],
              [23.474442000000124, 67.441101000000117],
              [23.464165, 67.44472],
              [23.44833, 67.452499000000103],
              [23.43111, 67.465546000000131],
              [23.428886, 67.47583],
              [23.429996, 67.485825],
              [23.433331000000123, 67.491943],
              [23.471943000000124, 67.556381000000101],
              [23.507774, 67.665543000000127],
              [23.49139, 67.712494],
              [23.469997, 67.816940000000102],
              [23.471107, 67.822769000000108],
              [23.48333, 67.86305],
              [23.486942, 67.86916],
              [23.492496, 67.87582],
              [23.511108, 67.8836060000001],
              [23.545555, 67.889999],
              [23.596386000000109, 67.89526],
              [23.607777, 67.897491],
              [23.644722, 67.913055],
              [23.65277, 67.918045],
              [23.659721, 67.9236],
              [23.665554, 67.929993],
              [23.667221, 67.936386],
              [23.666111000000114, 67.941666],
              [23.656944000000124, 67.950821],
              [23.648888, 67.95471],
              [23.638332000000105, 67.958054000000118],
              [23.53167, 67.99249],
              [23.394444000000135, 68.042496],
              [23.376942, 68.055542],
              [23.367496000000131, 68.06471],
              [23.353333000000134, 68.083603],
              [23.066944, 68.286377],
              [23.058609, 68.290268],
              [23.04805, 68.29388],
              [22.969444, 68.317764000000125],
              [22.936386, 68.32222],
              [22.910275, 68.328323],
              [22.899719, 68.3316650000001],
              [22.86360900000011, 68.357498],
              [22.829720000000123, 68.383881],
              [22.82361, 68.388046],
              [22.67388, 68.42082],
              [22.659721, 68.422485],
              [22.58166, 68.42722],
              [22.5, 68.440132],
              [22.43055, 68.451660000000118],
              [22.371944, 68.46361],
              [22.1675, 68.46443],
              [22.15083, 68.465546000000131],
              [22.063889000000131, 68.4761],
              [22.050552, 68.47916],
              [22.041943, 68.483047],
              [22.038055, 68.487778],
              [22.035, 68.498047],
              [22.0225, 68.506653000000142],
              [22.003887, 68.519440000000145],
              [21.99778, 68.5236],
              [21.959442, 68.543884000000105],
              [21.933887, 68.555267],
              [21.89722, 68.569992],
              [21.881386, 68.572495],
              [21.864719, 68.573608],
              [21.82472, 68.570267],
              [21.809166, 68.570541],
              [21.773331, 68.574432],
              [21.757500000000107, 68.576935],
              [21.735554, 68.5836],
              [21.71833, 68.591110000000128],
              [21.710552, 68.60055],
              [21.711109, 68.606384],
              [21.714165, 68.612488],
              [21.710278, 68.617218],
              [21.701664, 68.62082],
              [21.64277600000014, 68.642487],
              [21.62305, 68.649429],
              [21.601109000000122, 68.6561],
              [21.585278, 68.6586],
              [21.55055, 68.661652],
              [21.500832, 68.66832],
              [21.487499000000128, 68.67139],
              [21.465553000000114, 68.678055],
              [21.452774, 68.686661],
              [21.44861, 68.691101],
              [21.420555, 68.724152],
              [21.21666, 68.816101000000117],
              [21.207775, 68.81972],
              [21.081387, 68.86665],
              [21.058887000000141, 68.873322],
              [21.02472, 68.877487],
              [20.990833, 68.87944],
              [20.959442000000138, 68.87999],
              [20.94472, 68.88138],
              [20.915276000000119, 68.886658],
              [20.904163, 68.889999],
              [20.895275, 68.893600000000106],
              [20.888611, 68.898041],
              [20.88277, 68.907776000000126],
              [20.883053000000132, 68.91333],
              [20.888885, 68.925827],
              [20.915554, 68.939438],
              [20.93111, 68.946381],
              [20.938332, 68.952774],
              [20.938889, 68.958328],
              [20.932777000000101, 68.968323000000112],
              [20.928608000000111, 68.97305],
              [20.908886, 68.985550000000103],
              [20.884441, 68.997498],
              [20.866665, 69.00499],
              [20.846386000000109, 69.011932],
              [20.79166, 69.023331],
              [20.744164, 69.0311],
              [20.65006, 69.043793000000107],
              [20.604164000000139, 69.05305],
              [20.580929, 69.0603],
              [20.609444, 69.06944],
              [20.675, 69.087219000000118],
              [20.69749800000011, 69.09277],
              [20.72389, 69.095825],
              [20.738331, 69.096375],
              [20.773888, 69.093597000000102],
              [20.82222, 69.08638],
              [20.835831, 69.083603],
              [20.935555, 69.058609000000104],
              [20.98055, 69.04527],
              [21.033054, 69.033325000000104],
              [21.059444, 69.034439],
              [21.067497, 69.03915400000011],
              [21.074165, 69.044998000000135],
              [21.084721, 69.058044],
              [21.10139, 69.083328],
              [21.109722, 69.0961],
              [21.112499000000128, 69.102219000000105],
              [21.113052, 69.108047],
              [21.0791660000001, 69.117767000000129],
              [21.06611, 69.126389000000131],
              [21.053608, 69.140549],
              [21.04222, 69.16083],
              [21.02805, 69.208054],
              [21.0325, 69.21304],
              [21.039165, 69.218887],
              [21.054996, 69.228607],
              [21.320831, 69.326111],
              [21.68194, 69.284714],
              [21.9946020000001, 69.078369000000123],
              [22.04139, 69.05222],
              [22.208332, 68.954987000000131],
              [22.203053, 68.951111],
              [22.197498, 68.944717],
              [22.194164, 68.938599],
              [22.19722, 68.928055],
              [22.27889, 68.881653000000142],
              [22.346664, 68.844711000000132],
              [22.34861, 68.842499],
              [22.363888, 68.804718],
              [22.369720000000143, 68.786102],
              [22.398331, 68.7111],
              [22.5, 68.728989],
              [22.549999, 68.73778],
              [22.802776000000108, 68.691376],
              [22.86360900000011, 68.69305],
              [23.063889, 68.695541],
              [23.072498, 68.691666],
              [23.09916, 68.674713],
              [23.139442, 68.649155],
              [23.16472, 68.637497],
              [23.18861, 68.631104],
              [23.204166, 68.628601000000117],
              [23.260555, 68.636383],
              [23.281944000000124, 68.642487],
              [23.291386000000102, 68.646378000000141],
              [23.333054, 68.659439],
              [23.407776, 68.680832],
              [23.46722, 68.691666],
              [23.517498000000103, 68.69861],
              [23.583054000000118, 68.70527600000014],
              [23.664165, 68.71138],
              [23.679722, 68.710831],
              [23.69278, 68.712219000000118],
              [23.703609000000142, 68.715271],
              [23.711941, 68.719986],
              [23.740833, 68.74249],
              [23.762497, 68.75943],
              [23.783886000000109, 68.776382],
              [23.796108, 68.789154],
              [23.802219, 68.79582],
              [23.816666, 68.819992],
              [23.821388000000127, 68.825272],
              [23.83, 68.829987],
              [23.856388, 68.83249],
              [23.899441000000138, 68.833878000000141],
              [23.97639, 68.83249],
              [24.029163, 68.82666],
              [24.04472, 68.823883],
              [24.055553, 68.820541000000105],
              [24.066109, 68.81694],
              [24.082775, 68.809158],
              [24.088608, 68.804718],
              [24.092220000000111, 68.799988],
              [24.098053000000107, 68.79582],
              [24.120552, 68.7836],
              [24.19666, 68.751663],
              [24.215553, 68.746384],
              [24.33833, 68.713608000000136],
              [24.351387, 68.710541],
              [24.363331, 68.708328],
              [24.416943, 68.70166],
              [24.45027, 68.69888],
              [24.513332, 68.695831],
              [24.578888, 68.691376],
              [24.628887, 68.68721],
              [24.69028, 68.676376],
              [24.75444, 68.660263],
              [24.773331, 68.652771],
              [24.79777, 68.640823],
              [24.811665000000119, 68.63249],
              [24.82889, 68.619431],
              [24.834442000000138, 68.614990000000148],
              [24.843624, 68.60601800000012],
              [24.855862, 68.59201],
              [24.859203, 68.587341],
              [24.93492, 68.580811],
              [25.07638500000013, 68.621384000000148],
              [25.095833, 68.629166000000112],
              [25.103333000000134, 68.634720000000129],
              [25.109722, 68.641098],
              [25.111385, 68.646652],
              [25.104721, 68.656387],
              [25.10305, 68.66666],
              [25.10611, 68.678055],
              [25.15472, 68.767776],
              [25.166664, 68.78583],
              [25.17305, 68.792221],
              [25.188332, 68.803329],
              [25.214443, 68.81749],
              [25.234165, 68.825272],
              [25.36389, 68.873886],
              [25.38472, 68.88055],
              [25.406944000000124, 68.886383],
              [25.43111, 68.890549],
              [25.444443, 68.891663],
              [25.47333, 68.892212],
              [25.49028, 68.890823],
              [25.508053, 68.888321000000133],
              [25.554443, 68.88026],
              [25.57111, 68.878601],
              [25.585552, 68.878876],
              [25.612221, 68.88138],
              [25.623333, 68.884155],
              [25.63222, 68.888885],
              [25.647499, 68.899719000000118],
              [25.652775000000133, 68.906387000000109],
              [25.661388000000102, 68.911652],
              [25.692219, 68.933884],
              [25.76111, 68.989166],
              [25.768330000000105, 69.04527],
              [25.73222, 69.109161],
              [25.708332, 69.206375],
              [25.707775, 69.211655],
              [25.71333, 69.255264],
              [25.739441000000113, 69.318329000000119],
              [25.749722, 69.336105],
              [25.754997, 69.342209000000139],
              [25.770554000000118, 69.353882],
              [25.811665, 69.368607000000111],
              [25.82972, 69.37805],
              [25.833611000000133, 69.384155000000135],
              [25.83583, 69.389435],
              [25.874165, 69.486374],
              [25.949165, 69.57805],
              [25.957497, 69.590271000000143],
              [25.963608, 69.601944],
              [25.971107, 69.61888],
              [25.973331, 69.624161],
              [25.97472, 69.630264],
              [25.97416, 69.635269],
              [25.964722, 69.649719],
              [25.94778, 69.65805],
              [25.942497, 69.66222],
              [25.94194, 69.667221],
              [25.945831, 69.673325],
              [25.952774, 69.679993],
              [25.965832, 69.691376],
              [25.978333, 69.701935],
              [25.988331, 69.7066650000001],
              [25.99889, 69.71054],
              [26.009998, 69.713333],
              [26.10055, 69.726379],
              [26.134441, 69.734985000000108],
              [26.15583, 69.74249],
              [26.174164000000133, 69.751663],
              [26.36944, 69.84999],
              [26.378052, 69.854431],
              [26.395, 69.865555],
              [26.402222, 69.871933],
              [26.416111000000114, 69.889999],
              [26.424164, 69.901932],
              [26.43583, 69.914444],
              [26.449997, 69.927216],
              [26.470554, 69.935272000000111],
              [26.483055, 69.937485],
              [26.601944, 69.950272],
              [26.61639, 69.95166],
              [26.80658, 69.95206],
              [26.85722, 69.948608],
              [26.865276000000108, 69.944717],
              [26.866108, 69.934433],
              [26.87222, 69.929718],
              [26.884998, 69.926666],
              [26.90361, 69.924164000000133],
              [27.03722, 69.908051000000114],
              [27.054443, 69.907486],
              [27.068886, 69.9086],
              [27.08083, 69.910553],
              [27.20611, 69.93332],
              [27.28055, 69.94722],
              [27.291943000000117, 69.949997],
              [27.303055, 69.95389],
              [27.31028, 69.960266000000104],
              [27.306942, 69.970276],
              [27.303886, 69.975266],
              [27.297497, 69.979431],
              [27.29555, 69.98443600000013],
              [27.299999, 69.99055],
              [27.42139, 70.016663000000108],
              [27.567497, 70.063889000000131],
              [27.57333, 70.068878],
              [27.599442000000124, 70.072495],
              [27.87305, 70.088043],
              [27.902496, 70.088882],
              [27.918888, 70.088333],
              [27.926556, 70.087158],
              [27.936108, 70.084442],
              [27.944164000000114, 70.08027600000014],
              [27.960552, 70.06694],
              [27.968887, 70.057495000000131],
              [27.97472, 70.04805],
              [27.974998, 70.04277],
              [27.9725, 70.037216],
              [27.973331, 70.016388],
              [27.979164, 70.006653],
              [27.98472, 70.00221],
              [27.998055, 69.993607],
              [28.094166, 69.938599],
              [28.109997, 69.930542000000116],
              [28.1525, 69.915543],
              [28.165833, 69.912216000000114],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "FR",
        ISO2: "FR",
        ISO3: "FRA",
        UN: 250,
        NAME: "France",
        AREA: 55010,
        POP2005: 60990544,
        REGION: 150,
        SUBREGION: 155,
        LON: 2.55,
        LAT: 46.565,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [9.48583200000013, 42.615273000000116],
              [9.49472, 42.603607000000125],
              [9.482777000000112, 42.613052],
              [9.47778, 42.617218],
              [9.465277, 42.630829],
              [9.457777, 42.643326],
              [9.48583200000013, 42.615273000000116],
            ],
          ],
          [
            [
              [9.446665, 42.67889],
              [9.448055000000124, 42.64944],
              [9.452221, 42.630272],
              [9.473888, 42.582222],
              [9.47805, 42.576111],
              [9.50555, 42.563889000000131],
              [9.509998, 42.563606],
              [9.51139, 42.56721],
              [9.511665, 42.571663000000115],
              [9.509443, 42.578049],
              [9.503054, 42.59166],
              [9.497221, 42.60083],
              [9.50028, 42.59861],
              [9.520277000000135, 42.572495],
              [9.531666, 42.54916],
              [9.533888000000104, 42.541939000000127],
              [9.562222, 42.272774],
              [9.559999000000118, 42.19221],
              [9.55555500000014, 42.127777],
              [9.553333000000123, 42.115555],
              [9.54583, 42.102219],
              [9.448055000000124, 41.999443],
              [9.42555, 41.975],
              [9.41111, 41.954163],
              [9.405554, 41.934998],
              [9.397192, 41.875931],
              [9.396666, 41.862778],
              [9.398611, 41.85083],
              [9.402498, 41.840271000000143],
              [9.404444, 41.828331],
              [9.404165, 41.819160000000124],
              [9.398888, 41.698883],
              [9.382776, 41.658882],
              [9.379444, 41.651939],
              [9.366665, 41.638611],
              [9.32055, 41.60249],
              [9.27167, 41.520554],
              [9.241943, 41.451942],
              [9.247499, 41.425827],
              [9.25194, 41.42610900000011],
              [9.254166000000112, 41.423332],
              [9.254166000000112, 41.418610000000115],
              [9.25278, 41.41499],
              [9.248888, 41.408882000000119],
              [9.2225, 41.368607],
              [9.219166, 41.366386],
              [9.214443, 41.365555],
              [9.18611, 41.364166],
              [9.180832000000123, 41.364716000000101],
              [9.17722, 41.366661],
              [9.132221, 41.3941650000001],
              [9.115833, 41.431938000000116],
              [8.978054, 41.476662],
              [8.97389, 41.47805],
              [8.94111, 41.489441],
              [8.9175, 41.499718000000144],
              [8.791943, 41.55555],
              [8.789165, 41.55805],
              [8.78861, 41.562218],
              [8.78555, 41.613327],
              [8.792776, 41.629440000000102],
              [8.79472, 41.6325],
              [8.801666, 41.636665],
              [8.80611, 41.637772],
              [8.810833, 41.63694],
              [8.812498000000119, 41.63361],
              [8.816111, 41.631660000000124],
              [8.82111, 41.6325],
              [8.87361, 41.646942000000138],
              [8.876665000000116, 41.649162],
              [8.913887, 41.676384],
              [8.919443, 41.681389000000138],
              [8.921389, 41.684441],
              [8.921389, 41.68805],
              [8.919722, 41.69138],
              [8.916111, 41.693329],
              [8.911110000000122, 41.69416],
              [8.878887000000134, 41.698051000000135],
              [8.85667, 41.698326000000122],
              [8.85055, 41.698608],
              [8.840832, 41.700554],
              [8.79694400000011, 41.710274],
              [8.725832000000139, 41.729439000000127],
              [8.705, 41.75944],
              [8.74778, 41.810555],
              [8.78889, 41.853333],
              [8.803055, 41.8975],
              [8.802500000000123, 41.901665],
              [8.800833, 41.904999],
              [8.784166000000141, 41.924438000000123],
              [8.78111, 41.926666],
              [8.773054, 41.929993],
              [8.749722, 41.933327],
              [8.744165, 41.933609000000104],
              [8.740555, 41.931938],
              [8.738054, 41.929161000000136],
              [8.735832, 41.921387],
              [8.732777000000112, 41.91916700000013],
              [8.717222, 41.912498],
              [8.707222, 41.910828],
              [8.66861, 41.908333],
              [8.627222, 41.90666],
              [8.592777, 41.956940000000145],
              [8.58861, 41.963051],
              [8.589443, 41.96611],
              [8.593054, 41.968048000000124],
              [8.61360900000011, 41.97083],
              [8.634998, 41.96833],
              [8.646111000000133, 41.969162],
              [8.664999, 41.982498],
              [8.6675, 41.98527],
              [8.66805, 41.988327],
              [8.659443, 42.008331],
              [8.740555, 42.040833],
              [8.744999, 42.046944],
              [8.744999, 42.051384],
              [8.742222, 42.058327],
              [8.68111, 42.106384],
              [8.63889, 42.12028],
              [8.608332000000132, 42.13277],
              [8.587221, 42.169716],
              [8.570555000000127, 42.22166],
              [8.618332000000123, 42.253052000000139],
              [8.648888, 42.258331000000112],
              [8.68222, 42.265274],
              [8.68611, 42.26722],
              [8.688055000000134, 42.270271],
              [8.687498, 42.27444],
              [8.685833000000116, 42.277496],
              [8.631666, 42.336937],
              [8.615833000000123, 42.348328],
              [8.60722, 42.351105000000132],
              [8.594721, 42.35139],
              [8.584166, 42.349998],
              [8.575832000000105, 42.383606],
              [8.665277, 42.51111],
              [8.71472, 42.566666],
              [8.721666, 42.57444],
              [8.886944, 42.62805],
              [9.055277, 42.677498],
              [9.058332, 42.689163000000121],
              [9.060833000000116, 42.69194],
              [9.083887, 42.710831],
              [9.087221, 42.713051],
              [9.115833, 42.728607],
              [9.11944, 42.730270000000132],
              [9.148333, 42.73333],
              [9.153332, 42.73333],
              [9.251389, 42.720833],
              [9.254999000000112, 42.718887000000109],
              [9.269444, 42.702217],
              [9.27833, 42.690552],
              [9.283888, 42.676666000000125],
              [9.28694, 42.674438],
              [9.290833000000134, 42.67333200000013],
              [9.29389, 42.67555],
              [9.31139, 42.690277],
              [9.31722, 42.69527],
              [9.319166, 42.698326000000122],
              [9.34111, 42.734161],
              [9.342499, 42.737778],
              [9.343332, 42.746666000000118],
              [9.338888, 42.79055],
              [9.337221000000113, 42.798332],
              [9.33027600000014, 42.811386],
              [9.321665, 42.81889],
              [9.31139, 42.82972],
              [9.309166, 42.8325],
              [9.308054, 42.836105],
              [9.340832, 42.994438000000116],
              [9.344721, 43.000832],
              [9.34861, 43.002495000000124],
              [9.3530540000001, 43.003883],
              [9.383333, 43.00861],
              [9.418333, 43.010277],
              [9.424166, 43.01055],
              [9.458332, 42.989716],
              [9.460833, 42.986382],
              [9.489443000000108, 42.814438],
              [9.489166000000125, 42.805275],
              [9.485554, 42.793884],
              [9.468887, 42.7691650000001],
              [9.46611, 42.76194],
              [9.455, 42.718605],
              [9.448332000000107, 42.687218000000144],
              [9.446665, 42.67889],
            ],
          ],
          [
            [
              [-1.19444, 45.822495000000117],
              [-1.211945, 45.806938],
              [-1.23972, 45.858887],
              [-1.250834, 45.873604],
              [-1.28222, 45.905548000000124],
              [-1.285833, 45.907776],
              [-1.31667, 45.923607],
              [-1.33917, 45.935829],
              [-1.365556, 45.950272],
              [-1.37361, 45.958054],
              [-1.376111, 45.965271000000143],
              [-1.403056, 46.046661],
              [-1.40167, 46.050552],
              [-1.396111, 46.051109],
              [-1.38472, 46.049438000000123],
              [-1.363611, 46.044716],
              [-1.359167, 46.0430530000001],
              [-1.273334, 45.995827],
              [-1.23306, 45.964722],
              [-1.17306, 45.898605],
              [-1.170833, 45.891663],
              [-1.170556, 45.88749700000011],
              [-1.18194, 45.847771000000137],
              [-1.18694, 45.83166],
              [-1.18889, 45.828049],
              [-1.19444, 45.822495000000117],
            ],
          ],
          [
            [
              [-1.26083, 46.156387],
              [-1.284167, 46.155548],
              [-1.299445, 46.156662],
              [-1.31861, 46.160828],
              [-1.50694, 46.204163000000108],
              [-1.520556, 46.20916],
              [-1.531389, 46.215271],
              [-1.53444, 46.217773000000136],
              [-1.55222, 46.241104],
              [-1.553056, 46.244995],
              [-1.551944, 46.248055000000136],
              [-1.548333, 46.25],
              [-1.503056, 46.255554000000132],
              [-1.492222, 46.25666],
              [-1.480278, 46.25666],
              [-1.474445, 46.25583],
              [-1.291667, 46.198051000000135],
              [-1.255556, 46.168327],
              [-1.254167, 46.164993],
              [-1.254167, 46.160828],
              [-1.256667, 46.157776],
              [-1.26083, 46.156387],
            ],
          ],
          [
            [
              [-2.27083, 46.693329000000119],
              [-2.276389, 46.692772],
              [-2.36389, 46.698051],
              [-2.37, 46.701385],
              [-2.37833, 46.709160000000111],
              [-2.385278, 46.717773],
              [-2.385, 46.72555],
              [-2.38194, 46.72805],
              [-2.36611, 46.735275000000115],
              [-2.360834, 46.736107],
              [-2.354167, 46.735550000000103],
              [-2.33361, 46.73055],
              [-2.303056, 46.718605000000139],
              [-2.276111, 46.704437],
              [-2.273056, 46.702217],
              [-2.268611, 46.696388],
              [-2.27083, 46.693329000000119],
            ],
          ],
          [
            [
              [-2.196945, 47.017220000000123],
              [-2.14333, 46.953049000000135],
              [-2.13722, 46.943886000000134],
              [-2.13556, 46.936386],
              [-2.13639, 46.919167],
              [-2.14139, 46.907776],
              [-2.145, 46.90583],
              [-2.18278, 46.949165000000107],
              [-2.199445, 46.961105],
              [-2.208889, 46.963882000000126],
              [-2.221667, 46.965271],
              [-2.234445, 46.965553],
              [-2.24472, 46.963882000000126],
              [-2.250834, 46.963882000000126],
              [-2.25667, 46.964722],
              [-2.262778, 46.969719],
              [-2.28472, 47.020554000000118],
              [-2.277223, 47.027496],
              [-2.25667, 47.030548000000124],
              [-2.24556, 47.031944],
              [-2.23278, 47.030548000000124],
              [-2.22194, 47.02861],
              [-2.20778, 47.023888000000113],
              [-2.196945, 47.017220000000123],
            ],
          ],
          [
            [
              [-3.06667, 47.306664],
              [-3.08167, 47.289444],
              [-3.08583, 47.287773000000129],
              [-3.108334, 47.295555],
              [-3.118333, 47.29805],
              [-3.16417, 47.303329000000133],
              [-3.16944, 47.303604000000121],
              [-3.188889, 47.302773000000116],
              [-3.20528, 47.300278000000105],
              [-3.21111, 47.300827],
              [-3.21583, 47.302498],
              [-3.22306, 47.306664],
              [-3.2375, 47.315277],
              [-3.239167, 47.318604000000107],
              [-3.260278, 47.365273],
              [-3.26083, 47.369438],
              [-3.25861, 47.376106],
              [-3.25222, 47.390549],
              [-3.24889, 47.39277600000014],
              [-3.243333, 47.391663],
              [-3.06333, 47.320274],
              [-3.06139, 47.317215],
              [-3.063056, 47.313606000000107],
              [-3.06667, 47.306664],
            ],
          ],
          [
            [
              [-5.055, 48.454163],
              [-5.10139, 48.44221],
              [-5.134723, 48.45472],
              [-5.134723, 48.458328],
              [-5.13111, 48.46083],
              [-5.10556, 48.474716],
              [-5.06944, 48.482498],
              [-5.064723, 48.483055],
              [-5.055, 48.48027],
              [-5.04889, 48.477776000000119],
              [-5.045, 48.468605000000139],
              [-5.05194, 48.45694],
              [-5.055, 48.454163],
            ],
          ],
          [
            [
              [-3.57667, 48.803886],
              [-3.582222, 48.803886],
              [-3.58278, 48.80722],
              [-3.579722, 48.809715],
              [-3.575556, 48.81249],
              [-3.570834, 48.81277],
              [-3.56528, 48.81166],
              [-3.56333, 48.808609],
              [-3.56611, 48.805832000000123],
              [-3.57667, 48.803886],
            ],
          ],
          [
            [
              [2.541667000000132, 51.09111],
              [2.5975, 50.995827000000133],
              [2.597777, 50.92582700000014],
              [2.650555, 50.816109],
              [2.781944000000124, 50.755554000000132],
              [2.867503, 50.713379],
              [2.898056, 50.703049],
              [2.943055, 50.741386],
              [2.960556, 50.7575],
              [3.008611, 50.7691650000001],
              [3.02, 50.770554000000118],
              [3.026988, 50.76984],
              [3.041667, 50.777222],
              [3.050833000000125, 50.780273],
              [3.11638900000014, 50.791664],
              [3.14333, 50.790833],
              [3.149722, 50.78999],
              [3.154444, 50.78833],
              [3.162222, 50.783607],
              [3.164722, 50.780548000000124],
              [3.182874, 50.757050000000106],
              [3.187222000000133, 50.74667],
              [3.197778, 50.727219000000105],
              [3.242222, 50.66805],
              [3.243055, 50.660271],
              [3.278611000000126, 50.541664],
              [3.28, 50.53833],
              [3.29555, 50.525551],
              [3.298611, 50.523048],
              [3.367222, 50.495552],
              [3.37278, 50.494995000000131],
              [3.4525, 50.509438],
              [3.456666, 50.511383],
              [3.518055, 50.518883],
              [3.607778, 50.495827],
              [3.620155, 50.490044000000125],
              [3.654444000000126, 50.461662000000103],
              [3.657728, 50.45887],
              [3.66055, 50.45638300000013],
              [3.66889, 50.44416],
              [3.67055, 50.440826],
              [3.67167, 50.433327000000133],
              [3.676944, 50.395271],
              [3.774722000000111, 50.353882],
              [3.889722, 50.339996],
              [3.98389, 50.345276000000126],
              [4.033177, 50.35643],
              [4.038333, 50.3555530000001],
              [4.165, 50.283051],
              [4.194444, 50.237495000000138],
              [4.17139, 50.137215],
              [4.147222, 50.009995],
              [4.149238, 49.978371],
              [4.174179, 49.979881],
              [4.183055000000138, 49.97639],
              [4.215261, 49.959602000000132],
              [4.231111000000112, 49.96249],
              [4.24805, 49.964439],
              [4.317222, 49.969719],
              [4.413333, 49.949165],
              [4.43001, 49.945007],
              [4.445833, 49.940552],
              [4.458333, 49.938606],
              [4.46417, 49.93889],
              [4.510555, 49.947495],
              [4.673611, 49.996384],
              [4.67972200000014, 50.001938],
              [4.69444, 50.041939],
              [4.697499, 50.05555],
              [4.693889, 50.06194],
              [4.687778, 50.067215],
              [4.688055, 50.07111],
              [4.693055, 50.083328000000108],
              [4.696944, 50.09083],
              [4.763055, 50.135551],
              [4.81472, 50.165833],
              [4.819166, 50.16722],
              [4.832503, 50.16861],
              [4.882777, 50.154716],
              [4.894722, 50.140274],
              [4.894444, 50.13611],
              [4.8875, 50.131104],
              [4.883333, 50.129166],
              [4.880555, 50.12639],
              [4.853333, 50.095551],
              [4.838888, 50.06916],
              [4.820833, 49.992775],
              [4.863889, 49.80722],
              [4.873055000000136, 49.797218],
              [4.906666, 49.789719000000105],
              [4.912777000000119, 49.78889],
              [4.924444, 49.789444],
              [4.93528, 49.790833],
              [4.944722, 49.79361],
              [4.959167, 49.802216],
              [4.984444, 49.804718],
              [4.996666, 49.802498000000128],
              [5.331111, 49.656662],
              [5.392305, 49.62255],
              [5.39861100000013, 49.621384],
              [5.415, 49.613327],
              [5.42722, 49.60694],
              [5.437778, 49.599998000000141],
              [5.474166, 49.541107],
              [5.475555, 49.537773],
              [5.47611, 49.534164],
              [5.47389, 49.530548],
              [5.465278, 49.52166],
              [5.46361, 49.51778],
              [5.47028, 49.508888],
              [5.47305, 49.506104],
              [5.4775, 49.504166000000112],
              [5.514444, 49.508888],
              [5.530555000000106, 49.511108],
              [5.59333, 49.526382],
              [5.631944, 49.535828],
              [5.70222, 49.5430530000001],
              [5.792222, 49.54583],
              [5.80788, 49.545044],
              [5.809999, 49.538887],
              [5.811666, 49.53638],
              [5.838611, 49.514160000000118],
              [5.85528, 49.501106],
              [5.977777000000117, 49.448608],
              [5.98139, 49.448326],
              [6.090555, 49.453049],
              [6.094444000000124, 49.454163],
              [6.118055, 49.469719000000111],
              [6.12, 49.471664],
              [6.122499, 49.48055],
              [6.123055, 49.48722],
              [6.12417, 49.48972],
              [6.156111, 49.50388],
              [6.165277000000117, 49.504715],
              [6.229722, 49.508331000000112],
              [6.23972, 49.507774],
              [6.247318, 49.50597],
              [6.302777, 49.476662],
              [6.32833, 49.469162],
              [6.36217, 49.45939],
              [6.41139, 49.47555],
              [6.416111, 49.47583],
              [6.468333, 49.461388],
              [6.50833, 49.442772],
              [6.532222, 49.430832000000123],
              [6.540555, 49.425827],
              [6.546111, 49.41944],
              [6.594722000000104, 49.363052],
              [6.686944, 49.244995],
              [6.716389000000106, 49.191383],
              [6.714722, 49.188889000000131],
              [6.714167, 49.185829],
              [6.715, 49.18305],
              [6.723611, 49.171661],
              [6.727500000000134, 49.167496],
              [6.730833, 49.166107],
              [6.735, 49.165276],
              [6.82194, 49.153885],
              [6.831388, 49.15305],
              [6.838888, 49.154999],
              [6.844166, 49.158333],
              [6.85944400000011, 49.172493000000145],
              [6.861111, 49.174995],
              [6.861111, 49.177773],
              [6.859722, 49.179993],
              [6.855000000000132, 49.183884],
              [6.849722, 49.190552],
              [6.84111, 49.203331000000105],
              [6.840278, 49.206108],
              [6.841389, 49.208885000000123],
              [6.843055, 49.211388],
              [6.8475, 49.215271],
              [6.853889, 49.218048000000124],
              [6.920555, 49.220551],
              [6.930555, 49.22083],
              [6.934166, 49.219719],
              [7.019444, 49.187492],
              [7.090555, 49.127495],
              [7.151667, 49.121109000000104],
              [7.287777, 49.111107],
              [7.29167, 49.11222],
              [7.36, 49.14222],
              [7.361666, 49.14444],
              [7.367222, 49.160553],
              [7.369015, 49.16878],
              [7.371944, 49.17083],
              [7.375278, 49.171944],
              [7.38361, 49.173332],
              [7.41361, 49.176941000000113],
              [7.423611, 49.177216000000101],
              [7.432500000000118, 49.175827],
              [7.486944, 49.164162],
              [7.625833000000114, 49.06916],
              [7.63028, 49.065277],
              [7.652089, 49.044937000000118],
              [7.66889, 49.04222],
              [7.737499, 49.04277],
              [7.821388, 49.046387],
              [7.933332000000121, 49.048882],
              [7.938611, 49.048882],
              [8.039721, 49.01111],
              [8.051943, 49.005272],
              [8.155554000000109, 48.97639],
              [8.22608, 48.964417],
              [8.20611, 48.95888],
              [8.190554, 48.951942000000145],
              [8.139166, 48.895554],
              [8.135832, 48.890831],
              [8.121666, 48.864998],
              [8.112499, 48.846382],
              [8.110277, 48.840828000000101],
              [8.10639, 48.82222],
              [8.103888, 48.816666],
              [8.092222, 48.803604],
              [7.96194400000013, 48.7241590000001],
              [7.88, 48.66416],
              [7.80222, 48.575829],
              [7.745403000000124, 48.42495],
              [7.736666, 48.3986],
              [7.736666, 48.389442000000145],
              [7.743055, 48.371109000000104],
              [7.75177, 48.345406],
              [7.750833, 48.336662000000103],
              [7.746111, 48.330551],
              [7.693333, 48.276382],
              [7.607729, 48.164185],
              [7.580832, 48.122772],
              [7.578888, 48.119720000000143],
              [7.576898, 48.113152],
              [7.569722000000127, 48.08916],
              [7.568889000000127, 48.085274],
              [7.56667, 48.059998],
              [7.56919, 48.044777],
              [7.571666, 48.037216000000114],
              [7.574444, 48.034439],
              [7.583888, 48.027222000000108],
              [7.61361, 48.006104],
              [7.618518, 48.0],
              [7.622499000000118, 47.993889],
              [7.624444, 47.986107000000118],
              [7.624166, 47.976944000000117],
              [7.622222, 47.96916],
              [7.584167, 47.903328],
              [7.557221, 47.862778000000105],
              [7.526667, 47.788055],
              [7.510833, 47.703331],
              [7.513333000000102, 47.68694],
              [7.51944, 47.66833],
              [7.521944, 47.66555],
              [7.528889, 47.66083],
              [7.540277000000117, 47.655],
              [7.56111, 47.641663],
              [7.567222, 47.636665],
              [7.585833, 47.60833],
              [7.589722000000108, 47.601944000000117],
              [7.589747, 47.592697000000101],
              [7.588268, 47.58448],
              [7.586944, 47.585],
              [7.567222, 47.583611],
              [7.557221, 47.581383],
              [7.550833, 47.576385],
              [7.546665, 47.565552000000139],
              [7.521667, 47.55971],
              [7.513055, 47.556664000000126],
              [7.501389, 47.55055],
              [7.49861, 47.548050000000103],
              [7.497222, 47.544441],
              [7.502222, 47.500549],
              [7.49694, 47.494995],
              [7.452777, 47.46999],
              [7.433054, 47.460548],
              [7.41555, 47.44527],
              [7.388333, 47.434166000000118],
              [7.3825, 47.432495],
              [7.358055, 47.433609],
              [7.355897, 47.434017],
              [7.343611, 47.438606],
              [7.336944, 47.439438],
              [7.308332000000121, 47.440277],
              [7.275555000000111, 47.432495],
              [7.251389, 47.421944],
              [7.24694, 47.42083],
              [7.24111, 47.421944],
              [7.187499, 47.44221],
              [7.178333, 47.445831],
              [7.14642, 47.499054000000115],
              [7.025, 47.508049],
              [6.990555, 47.497215],
              [6.884444, 47.372772],
              [6.88111, 47.36472],
              [6.879999, 47.360275],
              [6.88111, 47.356941],
              [6.931389000000138, 47.35889],
              [6.980833, 47.361664],
              [7.00083, 47.364998],
              [6.971666, 47.291939],
              [6.839722, 47.17361],
              [6.8375, 47.171104],
              [6.838888, 47.16777],
              [6.84972, 47.164989000000105],
              [6.793333, 47.130829],
              [6.69944, 47.063889000000131],
              [6.678333, 47.034164],
              [6.639722, 47.004166],
              [6.629722, 46.99721],
              [6.620832, 46.994438],
              [6.566388, 46.979996],
              [6.528333, 46.971664],
              [6.460278, 46.895828],
              [6.446944, 46.839439],
              [6.45861, 46.785271],
              [6.4575, 46.78083],
              [6.452777, 46.77444],
              [6.434999000000118, 46.758049],
              [6.366666, 46.720551],
              [6.355, 46.714439],
              [6.346666, 46.711388],
              [6.26917, 46.682777000000101],
              [6.129999000000112, 46.59333],
              [6.12778, 46.589996],
              [6.127222, 46.585831],
              [6.129722000000129, 46.583054],
              [6.13528, 46.539719],
              [6.086944, 46.44944],
              [6.071111, 46.426384],
              [6.111111, 46.40972],
              [6.148333, 46.38861],
              [6.151667, 46.386383],
              [6.157222, 46.37722],
              [6.158333, 46.373886],
              [6.15861, 46.369995],
              [6.154166, 46.36305],
              [6.120277, 46.31194],
              [6.115, 46.30555],
              [6.106109, 46.297489],
              [6.118055, 46.268051000000128],
              [6.119166, 46.264442000000145],
              [6.117222, 46.260551],
              [6.107778, 46.253052],
              [6.0825, 46.24667],
              [6.072499, 46.249718],
              [6.060833, 46.250549],
              [6.03, 46.241386],
              [6.009166, 46.233887],
              [5.98139, 46.221939],
              [5.968055, 46.212494],
              [5.966666, 46.209442],
              [5.96611, 46.20528],
              [5.967222, 46.20194],
              [5.996388, 46.146942000000138],
              [6.12361, 46.148048],
              [6.133611, 46.14944],
              [6.152222, 46.153610000000128],
              [6.185833, 46.17083],
              [6.189166, 46.17333200000013],
              [6.245555, 46.21833],
              [6.271944000000133, 46.26194],
              [6.24375, 46.31551],
              [6.22805, 46.319717],
              [6.225555, 46.322495],
              [6.23, 46.333885],
              [6.236388, 46.344719000000111],
              [6.243333, 46.354996],
              [6.246388, 46.357773],
              [6.295555, 46.39416],
              [6.31111, 46.401382],
              [6.32833, 46.406944],
              [6.491944, 46.453049],
              [6.51028, 46.457771],
              [6.52, 46.45916],
              [6.633611, 46.464165],
              [6.702777, 46.454720000000123],
              [6.737778, 46.447495],
              [6.791389, 46.434166],
              [6.800278, 46.43055],
              [6.803055, 46.427773],
              [6.808332, 46.41861],
              [6.809444, 46.415276],
              [6.807016, 46.404228],
              [6.8, 46.378326],
              [6.78083, 46.166107],
              [6.781111, 46.162498],
              [6.78389, 46.148048],
              [6.788055, 46.14222],
              [6.873888, 46.088051],
              [6.933055000000138, 46.055275],
              [7.005833000000109, 45.999443],
              [7.00861, 45.996666],
              [7.030555, 45.96194],
              [7.03805, 45.931938000000116],
              [6.99667, 45.885551],
              [6.987499, 45.876938],
              [6.980833, 45.872215],
              [6.973055, 45.868889],
              [6.943889, 45.85833],
              [6.92222, 45.852219000000105],
              [6.908055, 45.849442],
              [6.896111000000133, 45.850273],
              [6.874999, 45.85611],
              [6.869721, 45.855827],
              [6.81861, 45.839165],
              [6.808888, 45.831383],
              [6.807221000000141, 45.827217],
              [6.79972, 45.796661],
              [6.798970000000111, 45.78067],
              [6.80778, 45.73444400000011],
              [6.809722000000136, 45.727776000000119],
              [6.814166000000114, 45.72194],
              [6.969444, 45.596939],
              [6.98972, 45.53333],
              [6.99944, 45.518326000000116],
              [7.002777, 45.516106],
              [7.089159, 45.47686],
              [7.146944, 45.43055],
              [7.15861, 45.377495],
              [7.129167, 45.262215],
              [7.127777, 45.25777],
              [7.124999000000116, 45.254997],
              [7.064722, 45.223053],
              [6.939444, 45.179443],
              [6.826944, 45.149719],
              [6.816388000000131, 45.156387],
              [6.771944, 45.16805],
              [6.760833, 45.168327],
              [6.6975, 45.150276000000133],
              [6.688889, 45.147774],
              [6.675833, 45.143883],
              [6.637777, 45.126106000000107],
              [6.634121, 45.124001],
              [6.627222000000131, 45.11944],
              [6.621666000000118, 45.11388],
              [6.61976, 45.110138],
              [6.661666, 45.039993],
              [6.746944, 44.91944],
              [6.751111, 44.91722],
              [6.775277000000131, 44.905548000000124],
              [6.84083, 44.874161],
              [6.85777800000011, 44.866661000000136],
              [6.89222100000012, 44.860275],
              [6.904444, 44.859161],
              [6.917777, 44.861938000000123],
              [6.936388, 44.871384],
              [6.948333, 44.869995],
              [6.964444, 44.865829],
              [6.973888, 44.862778],
              [7.002777, 44.852776],
              [7.009999, 44.848610000000122],
              [7.031666, 44.83138300000013],
              [7.02833, 44.74472],
              [6.980277, 44.691666],
              [6.970555000000104, 44.684715],
              [6.950833, 44.664719000000105],
              [6.852777, 44.540833],
              [6.853611000000114, 44.517776],
              [6.876944, 44.376663],
              [6.878888, 44.373604],
              [6.9763880000001, 44.284164],
              [7.031388, 44.246941],
              [7.348332, 44.131943],
              [7.353333000000134, 44.131104],
              [7.418888, 44.125549],
              [7.423055, 44.126663],
              [7.466389000000106, 44.138611],
              [7.52028, 44.1561],
              [7.61472, 44.180275],
              [7.66222, 44.170830000000137],
              [7.657777000000124, 44.144722],
              [7.658333, 44.137215],
              [7.661666, 44.131104],
              [7.66889, 44.122772],
              [7.709045000000117, 44.091309000000138],
              [7.70833, 44.07944],
              [7.70417, 44.07222],
              [7.66, 44.00833],
              [7.657222, 44.005272],
              [7.59833, 43.964722],
              [7.50111, 43.88694],
              [7.495, 43.88166],
              [7.493333, 43.877777],
              [7.492222, 43.869438],
              [7.493333, 43.862221],
              [7.49861, 43.849442],
              [7.512500000000102, 43.82111],
              [7.528055, 43.788605],
              [7.519722, 43.790833],
              [7.50778, 43.792221],
              [7.48417, 43.782776],
              [7.439293000000134, 43.757523000000106],
              [7.438333000000114, 43.760277],
              [7.432500000000118, 43.769165],
              [7.429444, 43.771385],
              [7.42472, 43.773048],
              [7.419999000000132, 43.772499],
              [7.41611, 43.770554],
              [7.403055000000109, 43.761383000000137],
              [7.387777, 43.748604],
              [7.386389000000122, 43.74555],
              [7.386389000000122, 43.74194],
              [7.391609, 43.727547],
              [7.31861, 43.709717],
              [7.25472, 43.70444],
              [7.238889, 43.69888],
              [7.15861, 43.66305],
              [7.152778000000126, 43.658051],
              [7.07472, 43.57222],
              [6.89222100000012, 43.43583],
              [6.88417, 43.433327],
              [6.84639, 43.424164],
              [6.794167, 43.422775],
              [6.636389, 43.311104000000114],
              [6.6375, 43.287773],
              [6.68444, 43.287216],
              [6.689444, 43.285553],
              [6.696944, 43.28139],
              [6.700277000000142, 43.275551],
              [6.699721000000125, 43.271385],
              [6.69778, 43.268051],
              [6.6416660000001, 43.184998],
              [6.599444, 43.192497],
              [6.5275, 43.189163],
              [6.406111, 43.163055],
              [6.18694, 43.12861],
              [6.178888, 43.125549],
              [6.172222, 43.121384],
              [6.166666000000134, 43.115555],
              [6.16472, 43.112221],
              [6.161944, 43.103607],
              [6.157222, 43.067215],
              [6.165277000000117, 43.05055],
              [6.137777, 43.055832],
              [6.11555, 43.06444],
              [6.062222, 43.101387],
              [5.955555, 43.118332],
              [5.936666000000116, 43.09083],
              [5.937222000000133, 43.087219],
              [5.929722, 43.083611],
              [5.871388, 43.05971],
              [5.86222, 43.057495000000131],
              [5.838611, 43.059998000000121],
              [5.8291660000001, 43.06305],
              [5.781111, 43.082497000000103],
              [5.776111, 43.088051],
              [5.77583, 43.091942000000131],
              [5.7775, 43.100555],
              [5.78361, 43.104996],
              [5.791389, 43.10833],
              [5.817499, 43.114998],
              [5.815555000000131, 43.12028],
              [5.68922, 43.188507],
              [5.68134, 43.190102],
              [5.671666, 43.191666],
              [5.52, 43.209999],
              [5.415833, 43.21666],
              [5.39805, 43.217773],
              [5.380278, 43.219162],
              [5.36361, 43.221939000000134],
              [5.35666700000013, 43.226387000000102],
              [5.35111, 43.23111],
              [5.35111, 43.235275],
              [5.355556, 43.247772],
              [5.360833, 43.253609],
              [5.367222, 43.258331000000112],
              [5.372222, 43.264717],
              [5.373888, 43.26888300000013],
              [5.373888, 43.276665],
              [5.36389, 43.328331000000105],
              [5.361666, 43.33527400000014],
              [5.348611, 43.351944],
              [5.335555, 43.361382],
              [5.322222000000124, 43.366661],
              [5.316111, 43.367493000000138],
              [5.30639, 43.365555],
              [5.272222, 43.356384],
              [5.258333, 43.34833],
              [5.250000000000114, 43.345276],
              [5.22305, 43.33944],
              [5.213055, 43.338608],
              [5.09639, 43.336937],
              [5.057777, 43.341385],
              [5.0388880000001, 43.347496],
              [5.03083, 43.35139],
              [5.042277, 43.37766],
              [5.040444, 43.381496],
              [5.04078, 43.38866],
              [5.041944, 43.391167],
              [5.04561, 43.393997],
              [5.063944, 43.401833],
              [5.074778, 43.404495],
              [5.077777, 43.404663],
              [5.092277, 43.402828],
              [5.14222100000012, 43.416107000000125],
              [5.151388000000111, 43.417221],
              [5.188611, 43.43388],
              [5.23056, 43.464165],
              [5.232499, 43.467499],
              [5.230833, 43.490273],
              [5.2272210000001, 43.496109000000104],
              [5.031388, 43.556664],
              [5.023055000000113, 43.553886],
              [5.021111, 43.549995000000138],
              [5.010833, 43.516663],
              [5.009722, 43.512215],
              [5.01667, 43.488884],
              [5.02277800000013, 43.484161],
              [5.028055000000109, 43.482498000000135],
              [5.045278, 43.480827],
              [5.0525, 43.476944000000117],
              [5.057500000000118, 43.471382],
              [5.039555, 43.458607],
              [5.04072200000013, 43.45427],
              [5.041222000000118, 43.44744],
              [5.04055, 43.439941],
              [5.0397210000001, 43.437607],
              [5.035722000000135, 43.434772],
              [5.017388, 43.428272],
              [4.994722, 43.425274],
              [4.991555, 43.425774],
              [4.988555, 43.42894],
              [4.957777, 43.424995],
              [4.935555, 43.432777],
              [4.924999, 43.435272],
              [4.919167, 43.435555],
              [4.876111, 43.423882],
              [4.853611, 43.41333],
              [4.83005, 43.411385],
              [4.828388, 43.406551],
              [4.833388, 43.404221],
              [4.839889, 43.403217],
              [4.842555, 43.399887],
              [4.844889, 43.391384],
              [4.83939, 43.390217],
              [4.822722, 43.395885],
              [4.815055, 43.399216],
              [4.793388, 43.409554],
              [4.783889, 43.414219],
              [4.75, 43.423607],
              [4.743889000000138, 43.428604000000121],
              [4.740833, 43.435272],
              [4.740833, 43.438606],
              [4.741944, 43.45138500000013],
              [4.75, 43.486938000000123],
              [4.750833, 43.49528],
              [4.751111, 43.507217],
              [4.74917, 43.518051000000128],
              [4.746666, 43.52499],
              [4.739444, 43.537216000000114],
              [4.71667, 43.565277],
              [4.711666, 43.570274],
              [4.705, 43.57499700000011],
              [4.696666, 43.57777],
              [4.727221, 43.441666000000112],
              [4.73277800000011, 43.428329],
              [4.736111, 43.42222],
              [4.741666, 43.417496],
              [4.73189, 43.400444],
              [4.741555000000119, 43.395775],
              [4.747221000000138, 43.393944],
              [4.76472200000012, 43.3861],
              [4.768722000000139, 43.383442000000116],
              [4.771055, 43.380108000000121],
              [4.772555, 43.375938],
              [4.77272, 43.373608],
              [4.771888, 43.37144],
              [4.767388, 43.36894],
              [4.75089, 43.36911],
              [4.652778, 43.359718],
              [4.619166, 43.361107],
              [4.606944000000112, 43.361938],
              [4.60139, 43.363052],
              [4.583888, 43.369995],
              [4.573333, 43.379997],
              [4.572499000000107, 43.387772],
              [4.57444, 43.391106],
              [4.591389, 43.40749],
              [4.598055, 43.417496],
              [4.601666, 43.424995],
              [4.60111, 43.428604000000121],
              [4.597221, 43.434166],
              [4.59111, 43.439163000000121],
              [4.583888, 43.443329],
              [4.565555, 43.449997],
              [4.535555000000102, 43.458328000000108],
              [4.50611, 43.462776],
              [4.47389, 43.461937],
              [4.453333, 43.460548000000131],
              [4.439166, 43.458885],
              [4.421944, 43.453888],
              [4.32583, 43.457222],
              [4.321111, 43.458328000000108],
              [4.318055, 43.461105],
              [4.316111, 43.464722],
              [4.317499, 43.471664],
              [4.321111, 43.492493],
              [4.319166, 43.499718],
              [4.31778, 43.503883],
              [4.30944, 43.512215],
              [4.28611, 43.505554000000132],
              [4.251389000000131, 43.493889],
              [4.24722, 43.491943],
              [4.241433, 43.485954],
              [4.29194, 43.45916],
              [4.28778, 43.45694],
              [4.205, 43.460274],
              [4.190555, 43.461937],
              [4.16222, 43.47111],
              [4.13111, 43.491661000000136],
              [4.124722, 43.498329],
              [4.124444, 43.505272000000105],
              [4.126666, 43.508331],
              [4.136389, 43.50805],
              [4.13833, 43.51138],
              [4.138888, 43.518883],
              [4.138055, 43.526108000000136],
              [4.133055, 43.536659],
              [4.127777, 43.543053],
              [4.117222, 43.55138],
              [4.10805, 43.554993000000138],
              [4.09639, 43.55805],
              [4.062222, 43.563332],
              [4.050278, 43.562218],
              [3.964722, 43.540833],
              [3.918611, 43.523888000000113],
              [3.90778, 43.518608],
              [3.843611, 43.47555],
              [3.7225, 43.41166],
              [3.546667, 43.319717],
              [3.430555, 43.286942],
              [3.41528, 43.288605000000132],
              [3.405278, 43.2866590000001],
              [3.335, 43.265274],
              [3.313056000000131, 43.25527],
              [3.25805, 43.22749],
              [3.14111, 43.138885],
              [3.081388000000118, 43.069443],
              [3.07777700000014, 43.041382000000112],
              [3.045278, 42.954163],
              [3.003611, 42.881104],
              [2.963889, 42.848328],
              [2.961389, 42.844994],
              [2.96, 42.837776000000133],
              [2.972777, 42.812218],
              [2.979167, 42.806664],
              [3.012222, 42.79805],
              [3.03805, 42.728333],
              [3.040833000000134, 42.616943000000106],
              [3.041944, 42.608330000000137],
              [3.049444000000108, 42.553886],
              [3.053889, 42.546661],
              [3.060277, 42.539719000000105],
              [3.06889, 42.536385000000109],
              [3.091389, 42.528885],
              [3.110278, 42.526939],
              [3.119722, 42.524719000000118],
              [3.139722, 42.51916],
              [3.143055, 42.516388],
              [3.16, 42.478333000000134],
              [3.174444, 42.445549],
              [3.177655000000129, 42.436806],
              [3.17111100000011, 42.435555],
              [3.158333000000141, 42.433327],
              [3.106111, 42.429161],
              [3.092222, 42.429993000000138],
              [3.075833, 42.439438],
              [3.049444000000108, 42.459717000000126],
              [3.047778000000108, 42.469719000000111],
              [3.045278, 42.474716],
              [2.95, 42.48055],
              [2.724722, 42.41944100000012],
              [2.678333, 42.401665],
              [2.65722, 42.38444],
              [2.656944, 42.37944],
              [2.674444000000108, 42.357216],
              [2.666389, 42.341942000000131],
              [2.54194, 42.332497],
              [2.525833, 42.333328],
              [2.484722, 42.343048000000124],
              [2.46972, 42.353333],
              [2.442778, 42.376389000000131],
              [2.438889, 42.380554000000132],
              [2.332222, 42.418053],
              [2.280534, 42.434288],
              [2.269166, 42.43722],
              [2.2625, 42.436661],
              [2.151389, 42.421387],
              [2.137777, 42.417221],
              [2.129167000000109, 42.408051],
              [2.124166, 42.39833],
              [2.123055000000136, 42.393326000000116],
              [2.116944, 42.383331],
              [2.093611, 42.364166],
              [2.062222, 42.356941],
              [2.023889000000111, 42.352219000000105],
              [2.017222, 42.35305000000011],
              [2.004722000000129, 42.357216],
              [1.987778000000105, 42.367775],
              [1.976666000000137, 42.374718],
              [1.968889, 42.384163000000115],
              [1.95917, 42.41083],
              [1.906389000000104, 42.446938],
              [1.851389, 42.469994],
              [1.78, 42.48832700000014],
              [1.723611, 42.50944],
              [1.723333, 42.515274],
              [1.724444, 42.524994],
              [1.725278, 42.529999],
              [1.735278, 42.554443],
              [1.74305500000014, 42.563606],
              [1.753889, 42.57],
              [1.768055, 42.571106],
              [1.774722, 42.571106],
              [1.78172, 42.569962],
              [1.73861, 42.616386],
              [1.698333, 42.626106000000107],
              [1.563056, 42.655548],
              [1.556389, 42.656387],
              [1.491944000000103, 42.65361],
              [1.481111000000112, 42.647217000000126],
              [1.445833000000107, 42.601944],
              [1.41722, 42.65083],
              [1.390278000000137, 42.688332000000116],
              [1.359167000000127, 42.715271],
              [1.328333, 42.719994],
              [1.321666, 42.714996],
              [1.17389, 42.709717],
              [1.150833, 42.723610000000122],
              [1.144722, 42.727776],
              [1.1408330000001, 42.731941],
              [1.137778000000139, 42.736938000000123],
              [1.1408330000001, 42.741661],
              [1.1400000000001, 42.753052],
              [1.132222000000127, 42.760826],
              [1.121111, 42.768608],
              [1.091666, 42.78444],
              [1.085, 42.785271],
              [0.896944, 42.813049],
              [0.823611000000142, 42.833054],
              [0.72, 42.859161],
              [0.712222, 42.858604],
              [0.692778, 42.853607],
              [0.66778, 42.839165],
              [0.651944, 42.784996],
              [0.655555000000106, 42.754166],
              [0.668056, 42.748055000000136],
              [0.681389000000138, 42.729439000000127],
              [0.683889, 42.713051],
              [0.683056, 42.70805],
              [0.680000000000121, 42.693329],
              [0.675506, 42.688484],
              [0.661667, 42.69194],
              [0.59556, 42.695],
              [0.56, 42.695831000000112],
              [0.509167, 42.69194],
              [0.501667000000111, 42.69138],
              [0.43278, 42.686661],
              [0.2725, 42.702499],
              [0.269722000000115, 42.707771],
              [0.261944000000142, 42.717499],
              [0.186389, 42.7347180000001],
              [0.178611, 42.735275],
              [0.172222, 42.73333],
              [0.14417, 42.722221000000104],
              [0.111944000000108, 42.709442],
              [0.008333, 42.68693],
              [0.0, 42.68544],
              [-0.00556, 42.684998000000121],
              [-0.05056, 42.69194],
              [-0.057222, 42.69416],
              [-0.06194, 42.69778],
              [-0.06194, 42.703331],
              [-0.060833, 42.70916],
              [-0.063056, 42.71583],
              [-0.12361, 42.7575],
              [-0.151944, 42.776657],
              [-0.18, 42.78444],
              [-0.20556, 42.794167],
              [-0.2625, 42.817497],
              [-0.300833, 42.839439],
              [-0.30556, 42.844162],
              [-0.308739, 42.848381],
              [-0.315, 42.835831],
              [-0.31778, 42.83111],
              [-0.323611, 42.82666],
              [-0.39194, 42.796387],
              [-0.54944, 42.77861],
              [-0.562222, 42.781387],
              [-0.712778, 42.882500000000107],
              [-0.718889, 42.886665000000107],
              [-0.72389, 42.891388],
              [-0.73194, 42.899162],
              [-0.73389, 42.904442000000131],
              [-0.73278, 42.909164],
              [-0.72332, 42.918945],
              [-0.722778, 42.922493000000145],
              [-0.72417, 42.937218],
              [-0.742778, 42.9611],
              [-0.746667, 42.965553],
              [-0.76, 42.96611],
              [-0.76694, 42.964722],
              [-0.786945, 42.95694],
              [-0.79056, 42.9525],
              [-0.81861, 42.946106],
              [-0.93417, 42.9525],
              [-0.946389, 42.955826000000116],
              [-0.99361, 42.976105],
              [-1.07278, 43.00639],
              [-1.200556, 43.04583],
              [-1.300278, 43.071663],
              [-1.34306, 43.039162],
              [-1.346667, 43.034721],
              [-1.360278, 43.031662],
              [-1.398056, 43.03805],
              [-1.42778, 43.04361],
              [-1.43444, 43.045555],
              [-1.445833, 43.051666000000125],
              [-1.45, 43.056664000000126],
              [-1.47056, 43.085831],
              [-1.4725, 43.09111],
              [-1.46889, 43.095833],
              [-1.45861, 43.10305],
              [-1.45167, 43.10305],
              [-1.429445, 43.116386],
              [-1.42222, 43.123604000000114],
              [-1.41139, 43.136665],
              [-1.385, 43.20166],
              [-1.38278, 43.217773],
              [-1.3825, 43.24721],
              [-1.38417, 43.253052000000139],
              [-1.39139, 43.262772],
              [-1.40889, 43.273048000000131],
              [-1.50361, 43.287773],
              [-1.65556, 43.309441],
              [-1.69278, 43.30778],
              [-1.711389, 43.304161000000136],
              [-1.73038, 43.29898100000014],
              [-1.776945, 43.3425],
              [-1.78088, 43.359924],
              [-1.73, 43.378883],
              [-1.666945, 43.385277],
              [-1.595, 43.43388],
              [-1.585278, 43.44138],
              [-1.53194, 43.509995],
              [-1.528056, 43.514999],
              [-1.48667, 43.570549000000142],
              [-1.443889, 43.640549000000135],
              [-1.4425, 43.66555],
              [-1.44028, 43.691383],
              [-1.42472, 43.784721],
              [-1.34694, 44.053604],
              [-1.34194, 44.07],
              [-1.333889, 44.085548],
              [-1.32917, 44.089722000000108],
              [-1.326389, 44.094444],
              [-1.305, 44.195549],
              [-1.26417, 44.393326],
              [-1.25861, 44.452217],
              [-1.24894, 44.49911],
              [-1.24961, 44.511772],
              [-1.25011, 44.515106],
              [-1.23378, 44.558109],
              [-1.208611, 44.625832000000116],
              [-1.15639, 44.658333],
              [-1.146389, 44.65583],
              [-1.12611, 44.651108000000136],
              [-1.094167, 44.65333],
              [-1.085834, 44.654160000000104],
              [-1.054167, 44.66],
              [-1.046389, 44.66333],
              [-1.04056, 44.66861],
              [-1.03611, 44.675278],
              [-1.03694, 44.68305],
              [-1.057222, 44.708054000000118],
              [-1.0625, 44.713608],
              [-1.12111, 44.754997],
              [-1.13444, 44.763611],
              [-1.158334, 44.773888],
              [-1.16889, 44.776108],
              [-1.176667, 44.772774],
              [-1.22556, 44.713051],
              [-1.23417, 44.699715],
              [-1.24, 44.689720000000136],
              [-1.245, 44.678329],
              [-1.248056, 44.67083],
              [-1.250278, 44.662498],
              [-1.2475, 44.757774],
              [-1.207222, 45.013329000000113],
              [-1.168334, 45.208611],
              [-1.15194, 45.37138],
              [-1.15222, 45.39222],
              [-1.148611, 45.427498],
              [-1.14111, 45.489716000000101],
              [-1.138889, 45.498055000000136],
              [-1.095, 45.552773000000116],
              [-1.08389, 45.564438],
              [-1.07667, 45.568604000000107],
              [-1.06806, 45.57083],
              [-1.058056, 45.571388],
              [-1.05361, 45.565826],
              [-1.05194, 45.558327],
              [-1.05222, 45.554161],
              [-1.053334, 45.550278000000105],
              [-1.059167, 45.539444],
              [-1.06111, 45.53083],
              [-1.061389, 45.527222],
              [-1.05778, 45.520828],
              [-1.045, 45.511665],
              [-0.99889, 45.479439000000127],
              [-0.99194, 45.474998],
              [-0.983889, 45.471107000000131],
              [-0.97056, 45.466385],
              [-0.947222, 45.463051],
              [-0.93694, 45.460548],
              [-0.92222, 45.452499],
              [-0.91556, 45.44778],
              [-0.80806, 45.367218],
              [-0.80222, 45.362495],
              [-0.7975, 45.35694100000012],
              [-0.77111, 45.321938000000102],
              [-0.759167, 45.30444],
              [-0.73611, 45.235497000000123],
              [-0.73444, 45.231331],
              [-0.733111, 45.224663],
              [-0.73361, 45.209496000000115],
              [-0.730611, 45.19133],
              [-0.714722, 45.130554],
              [-0.70639, 45.111382000000106],
              [-0.699445, 45.09861],
              [-0.54583, 44.896385000000123],
              [-0.54056, 44.890831000000105],
              [-0.53667, 44.895554000000118],
              [-0.53667, 44.899719000000118],
              [-0.53917, 44.983604],
              [-0.54167, 44.990273],
              [-0.554167, 45.023331],
              [-0.605, 45.051941000000113],
              [-0.61972, 45.060272],
              [-0.632222, 45.069717],
              [-0.643889, 45.079994],
              [-0.648056, 45.085831],
              [-0.65528, 45.098328],
              [-0.668333, 45.124161000000129],
              [-0.67306, 45.138054],
              [-0.70604, 45.32205],
              [-0.717778, 45.357216000000108],
              [-0.745833, 45.419998000000135],
              [-0.749722, 45.426384],
              [-0.77667, 45.4611],
              [-0.78639, 45.471939],
              [-0.80361, 45.487221],
              [-0.8625, 45.528885],
              [-1.000278, 45.614441000000113],
              [-1.08167, 45.65555],
              [-1.08972, 45.659439],
              [-1.165833, 45.68749],
              [-1.22333, 45.700554],
              [-1.23278, 45.698608],
              [-1.240834, 45.70166],
              [-1.24281, 45.707825000000128],
              [-1.242778, 45.710274],
              [-1.23444, 45.77583],
              [-1.23056, 45.78805],
              [-1.22556, 45.793884],
              [-1.188909, 45.799889],
              [-1.14594, 45.80294],
              [-1.148056, 45.867775],
              [-1.0775, 45.896660000000111],
              [-1.070833, 45.901382],
              [-1.06778, 45.908882],
              [-1.053334, 46.01221],
              [-1.05056, 46.034439],
              [-1.05194, 46.037773],
              [-1.05361, 46.041107],
              [-1.12, 46.125832],
              [-1.148611, 46.153328],
              [-1.10583, 46.258606],
              [-1.11463, 46.31658],
              [-1.16222, 46.326942],
              [-1.16806, 46.326942],
              [-1.172778, 46.325829],
              [-1.2, 46.318329000000119],
              [-1.20417, 46.316666],
              [-1.207778, 46.31472],
              [-1.21333, 46.309166000000118],
              [-1.215278, 46.30555],
              [-1.220278, 46.289719],
              [-1.26583, 46.304993000000138],
              [-1.46972, 46.39278],
              [-1.6543, 46.445358],
              [-1.78639, 46.488327],
              [-1.82194, 46.566109],
              [-1.8275, 46.583885],
              [-1.86056, 46.63777],
              [-1.91389, 46.688606000000107],
              [-1.91972, 46.693604000000107],
              [-2.007223, 46.761665000000107],
              [-2.033334, 46.776382000000126],
              [-2.05889, 46.786942],
              [-2.082778, 46.798607000000118],
              [-2.10139, 46.809166],
              [-2.10806, 46.813606],
              [-2.12, 46.82361],
              [-2.130834, 46.838333],
              [-2.133334, 46.849716000000114],
              [-2.133889, 46.891388],
              [-2.13, 46.89833],
              [-2.12444, 46.90416],
              [-2.087778, 46.941666000000112],
              [-2.03472, 46.98166700000013],
              [-1.98432, 47.031624],
              [-1.98417, 47.034439],
              [-1.9875, 47.040833],
              [-2.00028, 47.059166000000118],
              [-2.008334, 47.06721],
              [-2.02417, 47.079163],
              [-2.051667, 47.097221],
              [-2.05889, 47.100555],
              [-2.0725, 47.10527],
              [-2.11, 47.117218],
              [-2.11528, 47.118332],
              [-2.17083, 47.126663],
              [-2.165167, 47.221107000000131],
              [-2.160167, 47.23994],
              [-2.157167, 47.243275],
              [-2.154667, 47.244274],
              [-2.134167, 47.278053],
              [-2.043612, 47.287216],
              [-1.998889, 47.282219],
              [-1.938334, 47.274162],
              [-1.91889, 47.26944],
              [-1.91917, 47.266663],
              [-1.90333, 47.25444],
              [-1.89167, 47.248604],
              [-1.8025, 47.211937],
              [-1.773056, 47.208054000000118],
              [-1.746389, 47.206940000000145],
              [-1.735, 47.207771],
              [-1.73, 47.20916],
              [-1.72861, 47.210831],
              [-1.88389, 47.28666],
              [-1.896945, 47.290833],
              [-1.921389, 47.297775000000115],
              [-2.00333, 47.31916],
              [-2.022223, 47.320549],
              [-2.034167, 47.320274],
              [-2.12944, 47.309715],
              [-2.18756, 47.284607],
              [-2.194722, 47.27544],
              [-2.273334, 47.241661],
              [-2.28917, 47.23888],
              [-2.43361, 47.26249700000011],
              [-2.480278, 47.277222],
              [-2.53556, 47.294998],
              [-2.540278, 47.29666],
              [-2.54139, 47.300278000000105],
              [-2.5275, 47.38611],
              [-2.47972, 47.413055],
              [-2.46667, 47.417496],
              [-2.4475, 47.408333],
              [-2.44056, 47.403885],
              [-2.406389, 47.407494],
              [-2.41056, 47.42305],
              [-2.4596, 47.45299],
              [-2.471111, 47.44694],
              [-2.47667, 47.446388000000127],
              [-2.481112, 47.447777],
              [-2.48472, 47.45027],
              [-2.48694, 47.453049],
              [-2.491667, 47.49305],
              [-2.48667, 47.498604],
              [-2.481112, 47.49944],
              [-2.474445, 47.499161000000129],
              [-2.42278, 47.49944],
              [-2.37472, 47.5],
              [-2.36861, 47.500275000000101],
              [-2.36389, 47.501663],
              [-2.361111, 47.504166],
              [-2.38833, 47.510277],
              [-2.50944, 47.52916],
              [-2.58083, 47.537773],
              [-2.663611, 47.512772],
              [-2.79306, 47.48888],
              [-2.818334, 47.493607000000111],
              [-2.83361, 47.497215],
              [-2.837778, 47.499161000000129],
              [-2.86994, 47.540276],
              [-2.87028, 47.542774],
              [-2.868445, 47.547104],
              [-2.865945, 47.548107],
              [-2.864111, 47.548607],
              [-2.845611, 47.548107],
              [-2.81078, 47.544941],
              [-2.775278, 47.54722],
              [-2.755, 47.543884],
              [-2.736945, 47.543884],
              [-2.732778, 47.545555],
              [-2.687222, 47.59416],
              [-2.685, 47.597221000000104],
              [-2.680556, 47.613052],
              [-2.681111, 47.617218],
              [-2.694723, 47.634995],
              [-2.698056, 47.637215],
              [-2.70417, 47.638054],
              [-2.88883, 47.599720000000104],
              [-2.925333, 47.581051],
              [-3.09167, 47.584717],
              [-3.09528, 47.58722],
              [-3.119722, 47.598328],
              [-3.125, 47.599442],
              [-3.12722, 47.59638],
              [-3.128334, 47.587494],
              [-3.12889, 47.52916],
              [-3.126667, 47.52166],
              [-3.12028, 47.500549],
              [-3.09611, 47.484993],
              [-3.08611, 47.47361],
              [-3.10639, 47.472221],
              [-3.13139, 47.47527],
              [-3.13389, 47.47805],
              [-3.150278, 47.524994],
              [-3.148612, 47.52861],
              [-3.140833, 47.532776],
              [-3.13639, 47.538887000000102],
              [-3.135, 47.542496],
              [-3.13194, 47.559441],
              [-3.13139, 47.568604],
              [-3.13222, 47.576660000000118],
              [-3.134445, 47.58416],
              [-3.14, 47.593887000000109],
              [-3.150278, 47.6097180000001],
              [-3.157222, 47.61388],
              [-3.190556, 47.62861],
              [-3.21694, 47.650551],
              [-3.50889, 47.7586060000001],
              [-3.633266, 47.777458000000138],
              [-3.79278, 47.793884000000105],
              [-3.833889, 47.800552],
              [-3.84806, 47.805832],
              [-3.87528, 47.824165],
              [-3.88833, 47.833611],
              [-3.89111, 47.836388000000113],
              [-3.904445, 47.85278],
              [-3.98222, 47.889717],
              [-4.10139, 47.874992000000134],
              [-4.151112, 47.854439],
              [-4.155834, 47.8361],
              [-4.15528, 47.831940000000145],
              [-4.15972, 47.825554],
              [-4.1675, 47.81721],
              [-4.18278, 47.804161],
              [-4.209445, 47.799438000000123],
              [-4.215, 47.798607000000118],
              [-4.255834, 47.794716],
              [-4.26944, 47.794998],
              [-4.36194, 47.802773],
              [-4.366389, 47.804161],
              [-4.369167, 47.806938],
              [-4.37194, 47.821106],
              [-4.3725, 47.82527],
              [-4.370556, 47.82861],
              [-4.366945, 47.83083],
              [-4.34833, 47.835548],
              [-4.34583, 47.838051],
              [-4.344167, 47.841942],
              [-4.343334, 47.84944],
              [-4.343889, 47.85361],
              [-4.35, 47.871941000000106],
              [-4.36389, 47.898888],
              [-4.39222, 47.934441],
              [-4.419445, 47.960831],
              [-4.43611, 47.9725],
              [-4.45083, 47.980827],
              [-4.48486, 48.0],
              [-4.495831, 48.005836],
              [-4.524721, 48.021111],
              [-4.529443, 48.022499],
              [-4.541943, 48.017220000000123],
              [-4.591111, 48.01694],
              [-4.689167, 48.03],
              [-4.69444, 48.031387000000109],
              [-4.718334, 48.037773],
              [-4.72614, 48.04058],
              [-4.710556, 48.065552],
              [-4.70806, 48.068329000000119],
              [-4.7025, 48.069160000000124],
              [-4.360001, 48.113327],
              [-4.34778, 48.112495],
              [-4.331944, 48.104439],
              [-4.30611, 48.09861],
              [-4.3, 48.098053000000107],
              [-4.29472, 48.098885],
              [-4.291667, 48.101387000000102],
              [-4.28361, 48.11472],
              [-4.28222, 48.118332],
              [-4.27611, 48.139160000000118],
              [-4.27528, 48.143326],
              [-4.27556, 48.151939],
              [-4.27806, 48.159164],
              [-4.30222, 48.193054000000132],
              [-4.31028, 48.201385],
              [-4.32028, 48.208328],
              [-4.441389, 48.238327],
              [-4.46194, 48.242493000000138],
              [-4.47472, 48.242218],
              [-4.48472, 48.239441],
              [-4.49306, 48.236107],
              [-4.495001, 48.232773],
              [-4.49389, 48.229164],
              [-4.49389, 48.225555],
              [-4.511111, 48.2],
              [-4.53722, 48.176109],
              [-4.54083, 48.17388],
              [-4.552501, 48.172775],
              [-4.555834, 48.174995],
              [-4.62028, 48.26722],
              [-4.62389, 48.281944000000124],
              [-4.62139, 48.284721],
              [-4.57361, 48.328049000000135],
              [-4.55944, 48.336105],
              [-4.55111, 48.339439],
              [-4.53583, 48.343048],
              [-4.531112, 48.341660000000104],
              [-4.531389, 48.338051000000121],
              [-4.54194, 48.318329],
              [-4.55139, 48.306107],
              [-4.55083, 48.30305],
              [-4.54528, 48.298332],
              [-4.535278, 48.291382000000112],
              [-4.530556, 48.28999],
              [-4.408334, 48.283607],
              [-4.26333, 48.284721],
              [-4.205278, 48.294716000000108],
              [-4.18611, 48.299995],
              [-4.18861, 48.301384],
              [-4.3, 48.320549],
              [-4.40222, 48.328331],
              [-4.43861, 48.333054],
              [-4.44213, 48.34175],
              [-4.440556, 48.354996],
              [-4.605278, 48.344719],
              [-4.71139, 48.334717000000126],
              [-4.75278, 48.333328000000108],
              [-4.758889, 48.333885],
              [-4.76361, 48.335274],
              [-4.767222, 48.337494],
              [-4.775, 48.35055],
              [-4.784167, 48.366943],
              [-4.78472, 48.37028],
              [-4.790278, 48.421387],
              [-4.790278, 48.426109],
              [-4.77778, 48.509438],
              [-4.77556, 48.512772],
              [-4.758056, 48.533051],
              [-4.74389, 48.54583],
              [-4.72889, 48.55888],
              [-4.701945, 48.57],
              [-4.6975, 48.571663],
              [-4.63194, 48.579720000000123],
              [-4.625556, 48.579994],
              [-4.604167, 48.57194],
              [-4.600278, 48.57],
              [-4.596945, 48.567772000000105],
              [-4.58972, 48.559998000000121],
              [-4.58694, 48.573883],
              [-4.565556, 48.62083],
              [-4.56361, 48.623886],
              [-4.54167, 48.635277],
              [-4.536945, 48.636383000000137],
              [-4.35417, 48.674164],
              [-4.17194, 48.687492],
              [-3.99361, 48.722771],
              [-3.968056, 48.72555],
              [-3.97194, 48.714165],
              [-3.97361, 48.705826],
              [-3.9725, 48.702217],
              [-3.96417, 48.685272000000111],
              [-3.949445, 48.6561],
              [-3.8575, 48.636108],
              [-3.851111, 48.655548],
              [-3.86111, 48.68055],
              [-3.86028, 48.683609],
              [-3.83333, 48.713882000000126],
              [-3.83056, 48.716660000000104],
              [-3.81056, 48.726105],
              [-3.72806, 48.712776],
              [-3.717778, 48.710274],
              [-3.678334, 48.69472],
              [-3.638611, 48.681938000000116],
              [-3.59611, 48.675827],
              [-3.583056, 48.675827],
              [-3.575278, 48.679718],
              [-3.531945, 48.739166000000125],
              [-3.56278, 48.764717],
              [-3.5675, 48.76611],
              [-3.57778, 48.764999],
              [-3.580556, 48.76694],
              [-3.58167, 48.774994],
              [-3.580556, 48.783607000000131],
              [-3.5775, 48.791107],
              [-3.575278, 48.794167],
              [-3.536667, 48.825829],
              [-3.5125, 48.837219],
              [-3.47472, 48.840828000000101],
              [-3.38, 48.82194],
              [-3.366389, 48.82666],
              [-3.23139, 48.868607000000111],
              [-3.220834, 48.870552],
              [-3.12444, 48.864998],
              [-3.06083, 48.826385],
              [-2.87917, 48.67889],
              [-2.81194, 48.614166],
              [-2.72056, 48.533051],
              [-2.695556, 48.513054000000125],
              [-2.68528, 48.50166],
              [-2.474445, 48.622498],
              [-2.464723, 48.629997],
              [-2.462778, 48.633049000000142],
              [-2.461667, 48.637215],
              [-2.418334, 48.653610000000128],
              [-2.307222, 48.67610900000011],
              [-2.284445, 48.672218],
              [-2.128334, 48.638611],
              [-2.03928, 48.599552],
              [-2.03961, 48.596886],
              [-1.98222, 48.51416],
              [-1.97722, 48.512497],
              [-1.9725, 48.512772],
              [-1.94944, 48.524719],
              [-1.94647, 48.526543000000117],
              [-1.94361, 48.529999],
              [-1.94194, 48.533607],
              [-1.95278, 48.57666],
              [-1.95528, 48.57944],
              [-1.963611, 48.587494],
              [-1.969445, 48.592773000000136],
              [-1.97889, 48.595833],
              [-1.984445, 48.596107000000131],
              [-1.99444, 48.593605],
              [-2.006667, 48.602776],
              [-2.008778, 48.630775],
              [-2.01411, 48.642273],
              [-2.01678, 48.64844],
              [-2.01711, 48.65094],
              [-1.98806, 48.68694],
              [-1.9325, 48.697220000000129],
              [-1.84889, 48.70916],
              [-1.84611, 48.70916],
              [-1.83889, 48.689163],
              [-1.83861, 48.684998],
              [-1.84083, 48.681938000000116],
              [-1.84444, 48.679718],
              [-1.861111, 48.672775000000115],
              [-1.867222, 48.657776],
              [-1.87, 48.649994000000106],
              [-1.854167, 48.628883],
              [-1.846667, 48.62055],
              [-1.84028, 48.615555],
              [-1.825556, 48.611382000000106],
              [-1.812222, 48.61055],
              [-1.78722, 48.61055],
              [-1.72278, 48.611107],
              [-1.64917, 48.615273],
              [-1.633056, 48.617775],
              [-1.61944, 48.622215],
              [-1.61083, 48.62611],
              [-1.588626, 48.639679],
              [-1.521111, 48.636383000000137],
              [-1.465, 48.637215],
              [-1.36889, 48.64361],
              [-1.449722, 48.675552],
              [-1.48972, 48.685829],
              [-1.49889, 48.689163],
              [-1.56056, 48.74472],
              [-1.5625, 48.747772],
              [-1.563611, 48.751663000000121],
              [-1.578611, 48.83778],
              [-1.57556, 48.862778000000105],
              [-1.564167, 48.91444],
              [-1.556389, 49.015831000000105],
              [-1.57667, 49.008331],
              [-1.58083, 49.00666],
              [-1.585, 49.008888000000127],
              [-1.589445, 49.015],
              [-1.5975, 49.040276000000119],
              [-1.61, 49.089439],
              [-1.60972, 49.215],
              [-1.68111, 49.294441],
              [-1.70583, 49.318329],
              [-1.740834, 49.351662],
              [-1.75, 49.359444],
              [-1.7775, 49.373604000000114],
              [-1.79, 49.374992],
              [-1.80278, 49.374443],
              [-1.80917, 49.37527],
              [-1.812222, 49.377777],
              [-1.84556, 49.499718000000144],
              [-1.846667, 49.568329],
              [-1.84, 49.578331000000105],
              [-1.83806, 49.586388000000113],
              [-1.83833, 49.59833],
              [-1.84194, 49.61360900000011],
              [-1.84861, 49.635826],
              [-1.855278, 49.64944],
              [-1.857778, 49.652222],
              [-1.864444, 49.656944000000124],
              [-1.88389, 49.66305],
              [-1.900278, 49.666382000000112],
              [-1.91306, 49.66777],
              [-1.941667, 49.67333],
              [-1.94556, 49.67555],
              [-1.94611, 49.679443],
              [-1.94444, 49.71611],
              [-1.944167, 49.720551],
              [-1.941667, 49.723885],
              [-1.938056, 49.72583],
              [-1.93278, 49.72722],
              [-1.92639, 49.727493],
              [-1.91444, 49.72555],
              [-1.84472, 49.713882000000126],
              [-1.71528, 49.680275],
              [-1.673611, 49.664719],
              [-1.670833, 49.66166],
              [-1.666945, 49.659721],
              [-1.64944, 49.657776],
              [-1.620556, 49.655273],
              [-1.53722, 49.656662],
              [-1.518813, 49.658356],
              [-1.50111, 49.664444],
              [-1.482778, 49.67555],
              [-1.47972, 49.678329],
              [-1.472778, 49.687492],
              [-1.46667, 49.697777],
              [-1.41083, 49.704994000000113],
              [-1.38, 49.70694],
              [-1.37306, 49.70666],
              [-1.322778, 49.700829000000113],
              [-1.288611, 49.694443],
              [-1.26417, 49.684166],
              [-1.23861, 49.65583],
              [-1.23056, 49.630272],
              [-1.22722, 49.619164],
              [-1.22778, 49.614441],
              [-1.23028, 49.611382],
              [-1.259167, 49.59833],
              [-1.29222, 49.583885000000123],
              [-1.296111, 49.5816650000001],
              [-1.30139, 49.575829],
              [-1.30444, 49.568329],
              [-1.305, 49.563606],
              [-1.303056, 49.547493000000145],
              [-1.29833, 49.537216],
              [-1.291945, 49.527771],
              [-1.28722, 49.522217],
              [-1.26417, 49.49638],
              [-1.256667, 49.48805],
              [-1.251389, 49.482216000000108],
              [-1.23806, 49.46833],
              [-1.165278, 49.406662],
              [-1.11389, 49.365273],
              [-1.105278, 49.373604000000114],
              [-1.09167, 49.383049000000142],
              [-1.08472, 49.38777],
              [-1.07278, 49.393608],
              [-1.06778, 49.394722],
              [-0.976944, 49.396660000000111],
              [-0.92778, 49.394722],
              [-0.92139, 49.393883],
              [-0.90917, 49.383606],
              [-0.901945, 49.379166],
              [-0.887778, 49.374443],
              [-0.868056, 49.368607],
              [-0.85139, 49.364998],
              [-0.827222, 49.361664],
              [-0.72556, 49.351662],
              [-0.62194, 49.344994],
              [-0.58056, 49.345276000000126],
              [-0.50306, 49.346107000000131],
              [-0.42417, 49.341942000000131],
              [-0.410833, 49.34083],
              [-0.38222, 49.331108],
              [-0.369722, 49.325554],
              [-0.36, 49.32222],
              [-0.301111, 49.30416],
              [-0.2875, 49.299995],
              [-0.22833, 49.283607],
              [-0.104167, 49.299164],
              [-0.09333, 49.301109],
              [-0.073333, 49.30555],
              [-0.039444, 49.31472],
              [0.0, 49.32877],
              [0.062222000000133, 49.351944000000117],
              [0.079167, 49.358887],
              [0.085556, 49.364166],
              [0.098611, 49.378883],
              [0.113611, 49.391388],
              [0.131944, 49.4025],
              [0.149167, 49.409439],
              [0.169444, 49.41416],
              [0.235278, 49.427216],
              [0.270278, 49.430275],
              [0.29524, 49.431458],
              [0.368611, 49.439438],
              [0.384722, 49.44221],
              [0.424722, 49.45166],
              [0.45138900000012, 49.461105],
              [0.46333, 49.466942],
              [0.474167, 49.47361],
              [0.494444, 49.48805],
              [0.49166700000012, 49.48805],
              [0.48333300000013, 49.484444],
              [0.441389000000129, 49.471664],
              [0.388056, 49.457771],
              [0.371667, 49.455551],
              [0.353611, 49.454163],
              [0.3225, 49.453049],
              [0.309167000000116, 49.453331],
              [0.25611, 49.457222000000115],
              [0.160833, 49.468887],
              [0.119167, 49.48472],
              [0.107222, 49.490829],
              [0.078056, 49.511665000000107],
              [0.073889, 49.51778],
              [0.074167000000102, 49.526665],
              [0.07722200000012, 49.534164],
              [0.16972, 49.688889],
              [0.184444, 49.702774],
              [0.187500000000114, 49.705276],
              [0.208889, 49.718048],
              [0.213333, 49.719719],
              [0.266944, 49.733604000000128],
              [0.31111, 49.744995000000131],
              [0.426944000000105, 49.788605],
              [0.563333000000114, 49.844719000000111],
              [0.585833, 49.852776000000119],
              [0.640278000000137, 49.866104000000121],
              [0.683333, 49.873604],
              [0.694722, 49.874992],
              [0.71333, 49.87555],
              [1.068611, 49.926109],
              [1.073611, 49.927216],
              [1.201944, 49.969719],
              [1.22, 49.976105000000132],
              [1.2325, 49.981667],
              [1.37243, 50.065781],
              [1.39389, 50.07471],
              [1.409444, 50.083054],
              [1.435555, 50.098328],
              [1.441944, 50.103333000000134],
              [1.461111, 50.124161],
              [1.505555, 50.201942],
              [1.534167, 50.288605],
              [1.53472, 50.292221],
              [1.549444, 50.352493],
              [1.552778, 50.359993],
              [1.555278, 50.363052],
              [1.56, 50.364716000000101],
              [1.585278, 50.370277],
              [1.598333, 50.37055],
              [1.603851, 50.36879],
              [1.562778, 50.39611],
              [1.560278, 50.399162],
              [1.558055, 50.4061],
              [1.577222, 50.528053000000114],
              [1.564167, 50.68471],
              [1.564444, 50.705826],
              [1.598611000000119, 50.809166],
              [1.625, 50.877777],
              [1.733333, 50.942497],
              [1.745833000000118, 50.948051],
              [1.768889, 50.95583],
              [1.792778, 50.962776],
              [1.943333000000109, 50.995277000000101],
              [2.23528, 51.03805],
              [2.35944400000011, 51.054443],
              [2.38472, 51.051941],
              [2.407222, 51.054993],
              [2.42305, 51.058052],
              [2.492222, 51.07611],
              [2.5166660000001, 51.082771],
              [2.541667000000132, 51.09111],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "GG",
        ISO2: "GE",
        ISO3: "GEO",
        UN: 268,
        NAME: "Georgia",
        AREA: 6949,
        POP2005: 4473409,
        REGION: 142,
        SUBREGION: 145,
        LON: 43.518,
        LAT: 42.176,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [41.547623, 42.405777],
            [41.536385, 42.452766],
            [41.52887, 42.486649],
            [41.525826, 42.518044],
            [41.525269, 42.524155],
            [41.526093, 42.544434],
            [41.525551, 42.550545],
            [41.522484, 42.561371],
            [41.500542, 42.624985],
            [41.487762, 42.661934],
            [41.481102, 42.675545],
            [41.469986, 42.694153],
            [41.461372, 42.708046],
            [41.450829, 42.720543],
            [41.443047, 42.728043],
            [41.438599, 42.731659],
            [41.428596, 42.738045],
            [41.410538, 42.74527],
            [41.371368, 42.757767],
            [41.220818, 42.798607],
            [41.213608, 42.800262],
            [41.207207, 42.800819],
            [41.199715, 42.799721],
            [41.193047, 42.797768],
            [41.187485, 42.795273],
            [41.18277, 42.791939],
            [41.171371, 42.786942],
            [41.162209, 42.786942],
            [41.155823, 42.789162],
            [41.146935, 42.796097],
            [41.101662, 42.842766],
            [41.094704, 42.850822],
            [41.084984, 42.890549],
            [41.078049, 42.91832],
            [41.072762, 42.92804],
            [41.032761, 42.973038],
            [41.01944, 42.98333],
            [41.013878, 42.986382],
            [41.0075, 42.988319],
            [40.998322, 42.988602],
            [40.990822, 42.987488],
            [40.961655, 42.974991],
            [40.948318, 42.971375],
            [40.93998, 42.970818],
            [40.93277, 42.972214],
            [40.924706, 42.97998],
            [40.908875, 43.001938],
            [40.876938, 43.044716],
            [40.859993, 43.059151],
            [40.843597, 43.067772],
            [40.830544, 43.071938],
            [40.809433, 43.077209],
            [40.794716, 43.079987],
            [40.73082, 43.088875],
            [40.722481, 43.089706],
            [40.661377, 43.091927],
            [40.36055, 43.163315],
            [40.274155, 43.241653],
            [40.269707, 43.251938],
            [40.254433, 43.274437],
            [40.221603, 43.314209],
            [40.215271, 43.318604],
            [40.109154, 43.353882],
            [40.051384, 43.37027],
            [40.002968, 43.379265],
            [40.009163, 43.411934],
            [40.021103, 43.444153],
            [40.077492, 43.546944],
            [40.084984, 43.554993],
            [40.089989, 43.558327],
            [40.106934, 43.566376],
            [40.126656, 43.57222],
            [40.162491, 43.579987],
            [40.177483, 43.582497],
            [40.201935, 43.584717],
            [40.220818, 43.584717],
            [40.253387, 43.58252],
            [40.294716, 43.576096],
            [40.324432, 43.56971],
            [40.34388, 43.563324],
            [40.354996, 43.55777],
            [40.36805, 43.553322],
            [40.488884, 43.517769],
            [40.518593, 43.511658],
            [40.543053, 43.508606],
            [40.569153, 43.50972],
            [40.582497, 43.513611],
            [40.588036, 43.516106],
            [40.603325, 43.525269],
            [40.613045, 43.531937],
            [40.635818, 43.542496],
            [40.642487, 43.544434],
            [40.658318, 43.546097],
            [40.676102, 43.546654],
            [40.684708, 43.54583],
            [40.695969, 43.543015],
            [40.71666, 43.521378],
            [40.7211, 43.517769],
            [40.737762, 43.509438],
            [40.749718, 43.504433],
            [40.810822, 43.486931],
            [40.83416, 43.48333],
            [40.863884, 43.477211],
            [40.882484, 43.469986],
            [40.898041, 43.460815],
            [40.961098, 43.423607],
            [41.006653, 43.395546],
            [41.021378, 43.385818],
            [41.037766, 43.377213],
            [41.044159, 43.374985],
            [41.05999, 43.372765],
            [41.077766, 43.373047],
            [41.119156, 43.383041],
            [41.134438, 43.385262],
            [41.168053, 43.387215],
            [41.193047, 43.38472],
            [41.213608, 43.378876],
            [41.435547, 43.296097],
            [41.564995, 43.232201],
            [41.589706, 43.222755],
            [41.605263, 43.220261],
            [42.031097, 43.187485],
            [42.111176, 43.197281],
            [42.163872, 43.228043],
            [42.174431, 43.233871],
            [42.181107, 43.23555],
            [42.196938, 43.237206],
            [42.270821, 43.238045],
            [42.363884, 43.237488],
            [42.371368, 43.238602],
            [42.388329, 43.239426],
            [42.415268, 43.239159],
            [42.433044, 43.237762],
            [42.453873, 43.232201],
            [42.46666, 43.227768],
            [42.4786, 43.222755],
            [42.489159, 43.216103],
            [42.52887, 43.184151],
            [42.534431, 43.181107],
            [42.539719, 43.178322],
            [42.613045, 43.147774],
            [42.625824, 43.143044],
            [42.642487, 43.143883],
            [42.649155, 43.145546],
            [42.660812, 43.150536],
            [42.665543, 43.15387],
            [42.673607, 43.161652],
            [42.679993, 43.171097],
            [42.688881, 43.17804],
            [42.701096, 43.182487],
            [42.76944, 43.185822],
            [42.849991, 43.179153],
            [42.857216, 43.177483],
            [42.863602, 43.175262],
            [42.948868, 43.121651],
            [43.010818, 43.068047],
            [43.009438, 43.061928],
            [43.010818, 43.056656],
            [43.133881, 42.969704],
            [43.144707, 42.963875],
            [43.183868, 42.944427],
            [43.200829, 42.936371],
            [43.213608, 42.931664],
            [43.377762, 42.900536],
            [43.392891, 42.900124],
            [43.447205, 42.889153],
            [43.532494, 42.868317],
            [43.560547, 42.860825],
            [43.591927, 42.849152],
            [43.6036, 42.84388],
            [43.619431, 42.834984],
            [43.623604, 42.831383],
            [43.636932, 42.813599],
            [43.641106, 42.80999],
            [43.649712, 42.802773],
            [43.67083, 42.7911],
            [43.696938, 42.782204],
            [43.712494, 42.779427],
            [43.756386, 42.775826],
            [43.821106, 42.753609],
            [43.827209, 42.751389],
            [43.832497, 42.748322],
            [43.835815, 42.744156],
            [43.838036, 42.739159],
            [43.837769, 42.733871],
            [43.836098, 42.727768],
            [43.823875, 42.716103],
            [43.806099, 42.702209],
            [43.762772, 42.67305],
            [43.744713, 42.659157],
            [43.740822, 42.655266],
            [43.736542, 42.648308],
            [43.735268, 42.645264],
            [43.73555, 42.639153],
            [43.738884, 42.634995],
            [43.773041, 42.606102],
            [43.778328, 42.603043],
            [43.784714, 42.600822],
            [43.911934, 42.583321],
            [44.184433, 42.623871],
            [44.189728, 42.625206],
            [44.197487, 42.627213],
            [44.20916, 42.631927],
            [44.220818, 42.636932],
            [44.225548, 42.639992],
            [44.237762, 42.651375],
            [44.244431, 42.660538],
            [44.369431, 42.708046],
            [44.499718, 42.750832],
            [44.527206, 42.756653],
            [44.549721, 42.759438],
            [44.566376, 42.759995],
            [44.59388, 42.758324],
            [44.625824, 42.753052],
            [44.633041, 42.751389],
            [44.63826, 42.74881],
            [44.640266, 42.749428],
            [44.657494, 42.747765],
            [44.671928, 42.744156],
            [44.684433, 42.739426],
            [44.705269, 42.727211],
            [44.747208, 42.696938],
            [44.754715, 42.688881],
            [44.765549, 42.67054],
            [44.808327, 42.665268],
            [44.854996, 42.743317],
            [44.859154, 42.747208],
            [44.869156, 42.753319],
            [44.886658, 42.760277],
            [44.900826, 42.763054],
            [44.927483, 42.761932],
            [44.934708, 42.760277],
            [44.947205, 42.755272],
            [44.962769, 42.745537],
            [44.972214, 42.738884],
            [44.976372, 42.734993],
            [45.002213, 42.719147],
            [45.017769, 42.709984],
            [45.04583, 42.696091],
            [45.05304, 42.694153],
            [45.060265, 42.69249],
            [45.068604, 42.69249],
            [45.082764, 42.694984],
            [45.091476, 42.697422],
            [45.12027, 42.70694],
            [45.134438, 42.709435],
            [45.151649, 42.707764],
            [45.158875, 42.705826],
            [45.171371, 42.700829],
            [45.207497, 42.679436],
            [45.216927, 42.672768],
            [45.241936, 42.650826],
            [45.315819, 42.58194],
            [45.323044, 42.574158],
            [45.332497, 42.561104],
            [45.334717, 42.556374],
            [45.335815, 42.550819],
            [45.338036, 42.54583],
            [45.343323, 42.536652],
            [45.351662, 42.529427],
            [45.358887, 42.527489],
            [45.376381, 42.526932],
            [45.432213, 42.537491],
            [45.481102, 42.546387],
            [45.49527, 42.548882],
            [45.526932, 42.550819],
            [45.552773, 42.550262],
            [45.576096, 42.546097],
            [45.700539, 42.516106],
            [45.724991, 42.506386],
            [45.730263, 42.503319],
            [45.744713, 42.493317],
            [45.756943, 42.482201],
            [45.760277, 42.477913],
            [45.760544, 42.473312],
            [45.754715, 42.457207],
            [45.707497, 42.356102],
            [45.689713, 42.319153],
            [45.655266, 42.259163],
            [45.646103, 42.244713],
            [45.638596, 42.228867],
            [45.636932, 42.223038],
            [45.637215, 42.216927],
            [45.639153, 42.211937],
            [45.647484, 42.204712],
            [45.662766, 42.195267],
            [45.986931, 42.028603],
            [46.054153, 42.024994],
            [46.231934, 42.002769],
            [46.239983, 42.001389],
            [46.253052, 41.996941],
            [46.39415, 41.940536],
            [46.40609, 41.935547],
            [46.421371, 41.926102],
            [46.430275, 41.919159],
            [46.446381, 41.904427],
            [46.451752, 41.897057],
            [46.438324, 41.866936],
            [46.433327, 41.856659],
            [46.42054, 41.837769],
            [46.408875, 41.825829],
            [46.350548, 41.773315],
            [46.33194, 41.759163],
            [46.321381, 41.754166],
            [46.313881, 41.753319],
            [46.297768, 41.755829],
            [46.283875, 41.75972],
            [46.260818, 41.764153],
            [46.251938, 41.764992],
            [46.236382, 41.763878],
            [46.224541, 41.761063],
            [46.211372, 41.748871],
            [46.208046, 41.744431],
            [46.198044, 41.724991],
            [46.194427, 41.698044],
            [46.194427, 41.685822],
            [46.197762, 41.669159],
            [46.216103, 41.624985],
            [46.23333, 41.598595],
            [46.329987, 41.485268],
            [46.333878, 41.481659],
            [46.499161, 41.397217],
            [46.506104, 41.395264],
            [46.55304, 41.386932],
            [46.593323, 41.379433],
            [46.621094, 41.364998],
            [46.686928, 41.320267],
            [46.690819, 41.316666],
            [46.693871, 41.312202],
            [46.710815, 41.261375],
            [46.710815, 41.255272],
            [46.697205, 41.211655],
            [46.669991, 41.154984],
            [46.663315, 41.146103],
            [46.62249, 41.100548],
            [46.520821, 41.049988],
            [46.508606, 41.046097],
            [46.501656, 41.04805],
            [46.483871, 41.05555],
            [46.378319, 41.104156],
            [46.359711, 41.116936],
            [46.340828, 41.12999],
            [46.294159, 41.162766],
            [46.279984, 41.172768],
            [46.268044, 41.183868],
            [46.254166, 41.199997],
            [46.243317, 41.205544],
            [46.235268, 41.20665],
            [46.227211, 41.20665],
            [46.140266, 41.203873],
            [46.133881, 41.202492],
            [46.128036, 41.199997],
            [46.100548, 41.181931],
            [46.082497, 41.175819],
            [46.062202, 41.171928],
            [46.047768, 41.170273],
            [46.03138, 41.170273],
            [45.996941, 41.173607],
            [45.966103, 41.179153],
            [45.922493, 41.189156],
            [45.895546, 41.197487],
            [45.869713, 41.206093],
            [45.850822, 41.212769],
            [45.813042, 41.226372],
            [45.796097, 41.234428],
            [45.748047, 41.260277],
            [45.717766, 41.277489],
            [45.710815, 41.285271],
            [45.708603, 41.290276],
            [45.707497, 41.29583],
            [45.707497, 41.301926],
            [45.70916, 41.30777],
            [45.715546, 41.316933],
            [45.719704, 41.320541],
            [45.716927, 41.348595],
            [45.611107, 41.381927],
            [45.350548, 41.458878],
            [45.336655, 41.462494],
            [45.328606, 41.463608],
            [45.306656, 41.461098],
            [45.291939, 41.458878],
            [45.27887, 41.455544],
            [45.266663, 41.451653],
            [45.255272, 41.446938],
            [45.186104, 41.404984],
            [45.141373, 41.376656],
            [45.051384, 41.316376],
            [45.022942, 41.29705],
            [44.9786, 41.270264],
            [44.875824, 41.21859],
            [44.863602, 41.214706],
            [44.848877, 41.213051],
            [44.824715, 41.212494],
            [44.7286, 41.212212],
            [44.570267, 41.185265],
            [44.562202, 41.185265],
            [44.484154, 41.187759],
            [44.429993, 41.192215],
            [44.340546, 41.212494],
            [44.248871, 41.223595],
            [44.18055, 41.20443],
            [44.178322, 41.199158],
            [44.174431, 41.195534],
            [44.157494, 41.188324],
            [44.144707, 41.18499],
            [44.122765, 41.181931],
            [43.99276, 41.164146],
            [43.900536, 41.165543],
            [43.884438, 41.165268],
            [43.862488, 41.162209],
            [43.850548, 41.158043],
            [43.840828, 41.151932],
            [43.836937, 41.148041],
            [43.828331, 41.141106],
            [43.806099, 41.123871],
            [43.794991, 41.119156],
            [43.782204, 41.115822],
            [43.760277, 41.112762],
            [43.752213, 41.112488],
            [43.734428, 41.113602],
            [43.637497, 41.123047],
            [43.599709, 41.129715],
            [43.578606, 41.13472],
            [43.561661, 41.136375],
            [43.546387, 41.134995],
            [43.46077, 41.112961],
            [43.474152, 41.1325],
            [43.475548, 41.136375],
            [43.474709, 41.139992],
            [43.473053, 41.143044],
            [43.457497, 41.1661],
            [43.454987, 41.168877],
            [43.451935, 41.171097],
            [43.434166, 41.181656],
            [43.425819, 41.185265],
            [43.387215, 41.200554],
            [43.369713, 41.202766],
            [43.349709, 41.201935],
            [43.233597, 41.190269],
            [43.126381, 41.32],
            [43.039719, 41.374161],
            [43.016106, 41.393326],
            [42.892769, 41.506943],
            [42.84024, 41.578873],
            [42.827492, 41.584991],
            [42.816109, 41.586937],
            [42.681389, 41.594719],
            [42.651665, 41.592766],
            [42.61055, 41.586388],
            [42.597771, 41.583054],
            [42.590271, 41.579163],
            [42.564995, 41.508324],
            [42.550819, 41.49527],
            [42.48333, 41.438332],
            [42.472214, 41.433327],
            [42.455269, 41.434708],
            [42.366936, 41.460274],
            [42.311935, 41.476662],
            [42.287491, 41.487488],
            [42.272774, 41.491653],
            [42.182487, 41.5075],
            [42.166939, 41.5075],
            [42.097771, 41.5075],
            [41.979439, 41.518044],
            [41.96804, 41.519157],
            [41.963051, 41.518883],
            [41.954987, 41.516388],
            [41.947777, 41.512772],
            [41.916939, 41.494987],
            [41.905266, 41.484993],
            [41.901375, 41.478043],
            [41.883041, 41.458321],
            [41.837769, 41.428879],
            [41.833321, 41.428322],
            [41.828606, 41.42971],
            [41.820824, 41.433601],
            [41.75972, 41.468597],
            [41.724709, 41.492493],
            [41.569153, 41.518044],
            [41.531559, 41.523876],
            [41.609428, 41.627213],
            [41.622765, 41.641663],
            [41.635544, 41.645264],
            [41.642769, 41.644997],
            [41.649994, 41.642769],
            [41.657204, 41.643883],
            [41.683868, 41.671654],
            [41.727211, 41.7211],
            [41.730263, 41.725548],
            [41.772758, 41.809433],
            [41.774994, 41.821663],
            [41.776093, 41.841927],
            [41.774727, 41.885628],
            [41.760818, 41.961372],
            [41.661652, 42.121094],
            [41.656647, 42.130547],
            [41.652489, 42.140831],
            [41.653313, 42.154427],
            [41.656647, 42.169716],
            [41.65554, 42.181931],
            [41.64666, 42.220261],
            [41.632767, 42.271935],
            [41.596375, 42.350266],
            [41.589432, 42.358597],
            [41.547623, 42.405777],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "GM",
        ISO2: "DE",
        ISO3: "DEU",
        UN: 276,
        NAME: "Germany",
        AREA: 34895,
        POP2005: 82652369,
        REGION: 150,
        SUBREGION: 155,
        LON: 9.851,
        LAT: 51.11,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [8.710255, 47.69681],
              [8.678595, 47.693344],
              [8.67555, 47.697495],
              [8.6733, 47.701771000000122],
              [8.670277, 47.7075],
              [8.670555, 47.711105],
              [8.675278, 47.712494],
              [8.698889, 47.713608],
              [8.705, 47.713051000000121],
              [8.708332, 47.710548],
              [8.709721, 47.70694],
              [8.710255, 47.69681],
            ],
          ],
          [
            [
              [6.806389, 53.602219],
              [6.80472200000014, 53.60055],
              [6.799444, 53.601105],
              [6.796666, 53.602219],
              [6.775277000000131, 53.602219],
              [6.753055, 53.598328],
              [6.749166000000116, 53.597221],
              [6.72555, 53.58694],
              [6.723055, 53.584999],
              [6.72694, 53.580551],
              [6.746944, 53.560272000000111],
              [6.690555, 53.567497],
              [6.673333, 53.571388],
              [6.663888, 53.57583],
              [6.66, 53.580276],
              [6.658333000000141, 53.586105],
              [6.658610000000124, 53.593048],
              [6.661111000000119, 53.59861],
              [6.663055, 53.60083],
              [6.669444, 53.603882000000112],
              [6.747499, 53.618607],
              [6.75861, 53.618889],
              [6.77222, 53.616661000000136],
              [6.80417, 53.604439],
              [6.806389, 53.602219],
            ],
          ],
          [
            [
              [6.939444, 53.669441],
              [6.893611, 53.666382],
              [6.88278, 53.666939000000127],
              [6.878611, 53.6680530000001],
              [6.876389, 53.670273000000122],
              [6.878333, 53.672493],
              [6.881389, 53.674164],
              [6.898889000000111, 53.6775],
              [6.94361, 53.681107],
              [7.063611, 53.687218],
              [7.081111, 53.686943],
              [7.085555, 53.686104],
              [7.088333, 53.684166000000118],
              [7.088333, 53.681664],
              [7.08417, 53.679993],
              [6.939444, 53.669441],
            ],
          ],
          [
            [
              [7.242499000000123, 53.70444],
              [7.15861, 53.698883000000137],
              [7.148333, 53.699715],
              [7.14083, 53.702217000000132],
              [7.135833, 53.706108],
              [7.137221, 53.708885000000123],
              [7.14028, 53.710548],
              [7.175278, 53.720276],
              [7.201111, 53.72527],
              [7.298611, 53.726944],
              [7.32694, 53.72666],
              [7.336944, 53.725555],
              [7.340833, 53.724442000000124],
              [7.346944000000121, 53.721107],
              [7.345833, 53.71833],
              [7.327499000000103, 53.714722],
              [7.262777000000142, 53.705826000000116],
              [7.242499000000123, 53.70444],
            ],
          ],
          [
            [
              [8.19111, 53.724716],
              [8.124166000000116, 53.708885000000123],
              [8.120832000000121, 53.710274],
              [8.119999000000121, 53.713051],
              [8.124722, 53.72361],
              [8.129166, 53.72805],
              [8.13528, 53.731384],
              [8.14277600000014, 53.733604],
              [8.156387000000109, 53.73555],
              [8.17305, 53.734718],
              [8.18166, 53.732773],
              [8.188332, 53.729996000000142],
              [8.193333000000109, 53.726105],
              [8.19111, 53.724716],
            ],
          ],
          [
            [
              [7.622222, 53.754440000000102],
              [7.628611, 53.744438000000116],
              [7.628888, 53.742218],
              [7.621666000000118, 53.744438000000116],
              [7.60778, 53.746666],
              [7.586944, 53.748604],
              [7.575277, 53.748886],
              [7.51833, 53.745827000000133],
              [7.514166000000102, 53.744995],
              [7.51111, 53.743332],
              [7.478055, 53.722221],
              [7.473611000000119, 53.723053],
              [7.469166, 53.727219],
              [7.467777, 53.733055],
              [7.468611000000124, 53.739998000000128],
              [7.472221, 53.748604],
              [7.47889, 53.754997],
              [7.485833, 53.7575],
              [7.51583, 53.759995],
              [7.575555000000122, 53.761108],
              [7.609722, 53.760826],
              [7.615000000000123, 53.760277],
              [7.618333, 53.758888],
              [7.622222, 53.754440000000102],
            ],
          ],
          [
            [
              [7.75889, 53.76055],
              [7.669722, 53.754715],
              [7.66472, 53.75861],
              [7.664444, 53.76166],
              [7.665833, 53.764442],
              [7.669444, 53.769165],
              [7.674444, 53.773048000000131],
              [7.683888000000138, 53.777771000000143],
              [7.69861, 53.77916],
              [7.80472200000014, 53.777771000000143],
              [7.809999000000118, 53.777222],
              [7.812778, 53.775551000000121],
              [7.810833, 53.773048000000131],
              [7.807221000000141, 53.771942000000138],
              [7.75889, 53.76055],
            ],
          ],
          [
            [
              [8.425278000000105, 53.928055],
              [8.422222, 53.92638],
              [8.413055, 53.928055],
              [8.40694, 53.947777],
              [8.407776, 53.950829],
              [8.41166, 53.955551],
              [8.42277700000011, 53.962776000000133],
              [8.43111, 53.964722],
              [8.441111, 53.965553],
              [8.455, 53.963051000000121],
              [8.457222000000115, 53.96083],
              [8.425278000000105, 53.928055],
            ],
          ],
          [
            [
              [11.45917, 53.961105],
              [11.451387, 53.95916],
              [11.428888000000143, 53.961388],
              [11.42361, 53.96194],
              [11.3925, 53.968048],
              [11.388611, 53.969162],
              [11.377499, 53.974716],
              [11.37555, 53.976944],
              [11.373333, 53.982216000000108],
              [11.373888, 53.988609],
              [11.374998, 53.99166],
              [11.378611, 53.996666],
              [11.38444, 54.000275],
              [11.401667, 54.006943],
              [11.44444, 54.022217],
              [11.452776, 54.02389],
              [11.4625, 54.024719],
              [11.47305, 54.024719],
              [11.488609, 54.023048],
              [11.491665, 54.021385],
              [11.49528, 54.016663000000108],
              [11.49416, 54.009995000000117],
              [11.480276000000117, 53.984161],
              [11.4772210000001, 53.978882000000112],
              [11.469721, 53.968887],
              [11.467777000000126, 53.96666],
              [11.45917, 53.961105],
            ],
          ],
          [
            [
              [13.94028, 54.024994],
              [13.930832, 54.016388],
              [13.92583, 54.018326],
              [13.927221, 54.021385],
              [13.93444, 54.027771],
              [13.938889, 54.027496],
              [13.94028, 54.024994],
            ],
          ],
          [
            [
              [8.695555, 54.041107],
              [8.691944, 54.039993],
              [8.681665, 54.040833],
              [8.676666000000125, 54.044716],
              [8.673054, 54.049438000000123],
              [8.666111, 54.063889000000131],
              [8.6675, 54.073326],
              [8.66889, 54.075829],
              [8.67139, 54.077774],
              [8.67805, 54.08083],
              [8.690554000000134, 54.083611],
              [8.693333, 54.082497],
              [8.699999, 54.058609],
              [8.697498, 54.04361],
              [8.695555, 54.041107],
            ],
          ],
          [
            [
              [11.544167, 54.061386],
              [11.51111, 54.048607000000118],
              [11.51111, 54.051666],
              [11.514721000000122, 54.060555000000136],
              [11.528889, 54.076942000000145],
              [11.535831, 54.082497],
              [11.555832, 54.094719],
              [11.55944, 54.09583],
              [11.61242, 54.10458],
              [11.568054, 54.074715],
              [11.544167, 54.061386],
            ],
          ],
          [
            [
              [14.001317, 54.065361],
              [14.105, 53.998604],
              [14.181110000000103, 53.94805],
              [14.186943, 53.944717],
              [14.214167, 53.932495],
              [14.225555, 53.928604000000121],
              [14.21583, 53.899994000000106],
              [14.218887000000109, 53.869019],
              [14.195833, 53.874718],
              [14.19111, 53.87527],
              [14.0825, 53.873329],
              [14.045277, 53.872215],
              [14.037777, 53.869995],
              [14.029165, 53.864716000000101],
              [14.00805, 53.853882],
              [13.992498000000126, 53.84972],
              [13.949165000000107, 53.843605],
              [13.893055, 53.839439],
              [13.877499000000114, 53.84083],
              [13.82694, 53.850822],
              [13.823431, 53.853745],
              [13.825, 53.85833],
              [13.833332, 53.867493],
              [13.835554, 53.86972],
              [13.838888, 53.871384],
              [13.871944, 53.878052],
              [13.92916, 53.897499],
              [13.939631000000134, 53.914864000000136],
              [13.95757, 53.941113],
              [13.98207, 53.962551000000133],
              [14.012691, 53.94942],
              [14.03063, 53.942863000000102],
              [14.048565, 53.942425],
              [14.056003, 53.984863],
              [14.04769, 54.005424000000119],
              [14.014, 54.014175000000137],
              [14.00832, 54.026424],
              [13.998255, 54.039986],
              [13.97988, 54.05661],
              [13.954068, 54.060547],
              [13.929569, 54.063171],
              [13.918633, 54.054859000000135],
              [13.92607, 54.03648],
              [13.91222, 54.026665],
              [13.902777000000128, 54.014160000000118],
              [13.89805, 54.00972],
              [13.86055, 53.998604],
              [13.857498, 54.000275],
              [13.82278, 54.036659],
              [13.80868, 54.071613],
              [13.81743, 54.09785],
              [13.804192, 54.111092],
              [13.759998, 54.139717],
              [13.75861, 54.14222],
              [13.75611, 54.150276000000133],
              [13.757500000000107, 54.157219000000111],
              [13.759165, 54.159996],
              [13.763887000000125, 54.164444],
              [13.769722, 54.16777],
              [13.781111, 54.171104],
              [13.800554, 54.17139],
              [13.813055, 54.16861],
              [13.81805, 54.164719],
              [13.81944, 54.162216],
              [13.823055, 54.154716000000121],
              [13.825554, 54.143326],
              [13.828054000000122, 54.138329],
              [13.831665, 54.133888],
              [13.86611, 54.106667],
              [13.89238, 54.090298000000132],
              [13.921257, 54.081985],
              [13.93832, 54.077171],
              [13.96544, 54.073235],
              [14.001317, 54.065361],
            ],
          ],
          [
            [
              [10.979443, 54.380554],
              [10.994999, 54.381943],
              [11.017776, 54.380272],
              [11.016943, 54.378609],
              [11.013332, 54.377495],
              [11.003054000000134, 54.376938],
              [10.986111, 54.378052000000139],
              [10.979443, 54.380554],
            ],
          ],
          [
            [
              [12.729721, 54.41666],
              [12.68861, 54.41555],
              [12.68611, 54.418327],
              [12.696943, 54.424995],
              [12.70278, 54.428329],
              [12.706944, 54.427773],
              [12.727221, 54.42305],
              [12.731943000000115, 54.41888],
              [12.729721, 54.41666],
            ],
          ],
          [
            [
              [8.893055, 54.461937],
              [8.8375, 54.461662],
              [8.826944, 54.462776],
              [8.819443, 54.465271],
              [8.814722, 54.469162],
              [8.814165, 54.472496],
              [8.814165, 54.49777],
              [8.814999, 54.500832],
              [8.816944, 54.503052],
              [8.86222, 54.524162],
              [8.865833, 54.525276000000133],
              [8.921389, 54.524994],
              [8.942499, 54.523048],
              [8.960554, 54.519165],
              [8.954721, 54.509163000000115],
              [8.924999, 54.474159],
              [8.917776000000117, 54.467773000000136],
              [8.91472, 54.46611],
              [8.906944, 54.463882],
              [8.893055, 54.461937],
            ],
          ],
          [
            [
              [11.31278, 54.406944],
              [11.13917, 54.40666],
              [11.123888000000136, 54.406944],
              [11.021049000000119, 54.438759],
              [11.009998, 54.4461060000001],
              [11.008055, 54.448326],
              [11.005833, 54.45361],
              [11.006388000000129, 54.461662],
              [11.011389, 54.476944],
              [11.01861, 54.490829000000133],
              [11.025555, 54.501106000000107],
              [11.031944, 54.508049000000142],
              [11.04389, 54.518326000000116],
              [11.06472, 54.53416],
              [11.068888, 54.534996],
              [11.184166, 54.52],
              [11.229166000000134, 54.50471],
              [11.235277, 54.501389],
              [11.242777000000103, 54.49555],
              [11.24472, 54.493332000000123],
              [11.27393, 54.458736],
              [11.300554, 54.426384],
              [11.303888, 54.421661],
              [11.312222, 54.40972],
              [11.31278, 54.406944],
            ],
          ],
          [
            [
              [8.662777, 54.494164],
              [8.632776, 54.491386],
              [8.616388, 54.492775],
              [8.612499000000128, 54.493889],
              [8.61027700000011, 54.495827000000133],
              [8.59778, 54.508888],
              [8.591944, 54.515549],
              [8.59028, 54.524719],
              [8.59111, 54.527771000000143],
              [8.593054, 54.53],
              [8.599722, 54.53333],
              [8.64222100000012, 54.54583],
              [8.691387000000134, 54.55389],
              [8.702776, 54.55389],
              [8.710833, 54.55167],
              [8.71111100000013, 54.548607],
              [8.709721, 54.53249],
              [8.708332, 54.52972],
              [8.691944, 54.511383],
              [8.685555, 54.50471],
              [8.68028, 54.500832],
              [8.67111, 54.495827000000133],
              [8.662777, 54.494164],
            ],
          ],
          [
            [
              [13.07361, 54.488609],
              [13.063055, 54.465271],
              [13.060833, 54.469162],
              [13.06, 54.47639],
              [13.06111, 54.486382000000106],
              [13.063889000000131, 54.500000000000114],
              [13.096666000000141, 54.590553],
              [13.10389, 54.596939],
              [13.109999, 54.600273],
              [13.117498, 54.602776],
              [13.13694, 54.60416],
              [13.147499, 54.60416],
              [13.151388000000111, 54.602776],
              [13.154165, 54.60083],
              [13.155277, 54.598328],
              [13.158054000000106, 54.58416],
              [13.158054000000106, 54.581108],
              [13.110832, 54.533882],
              [13.10861, 54.531387],
              [13.07361, 54.488609],
            ],
          ],
          [
            [
              [13.383055, 54.638885],
              [13.391313, 54.60695],
              [13.40743, 54.588757],
              [13.433424, 54.57784],
              [13.456300000000113, 54.573158],
              [13.481774, 54.574718],
              [13.516088, 54.576797000000113],
              [13.59305, 54.584717000000126],
              [13.617777000000103, 54.586105],
              [13.633888000000127, 54.585831],
              [13.639166, 54.585274],
              [13.646944, 54.582771],
              [13.671665000000132, 54.56916],
              [13.676666, 54.56528],
              [13.678055, 54.562775],
              [13.679165, 54.542496],
              [13.677776, 54.53249],
              [13.675278000000105, 54.526382],
              [13.670277, 54.522217],
              [13.666943, 54.520828],
              [13.647499, 54.515549],
              [13.6408330000001, 54.512772],
              [13.591389, 54.486107],
              [13.585278, 54.482773],
              [13.581388, 54.477776],
              [13.57833, 54.472221000000104],
              [13.576387, 54.46249],
              [13.576792, 54.459988],
              [13.577776, 54.453888],
              [13.583611, 54.441666],
              [13.617498, 54.404160000000104],
              [13.620554, 54.402496],
              [13.631109, 54.40111],
              [13.646387000000118, 54.401382000000126],
              [13.666666, 54.402222],
              [13.676109, 54.40083],
              [13.7025, 54.388054000000125],
              [13.7075, 54.384163],
              [13.713888000000111, 54.37778],
              [13.73111, 54.354721],
              [13.743889000000138, 54.33111],
              [13.730833, 54.275833],
              [13.727499, 54.274437],
              [13.715, 54.27166],
              [13.711111, 54.272217],
              [13.695555, 54.280548000000124],
              [13.693888, 54.282776],
              [13.696388, 54.28416],
              [13.71083, 54.29694400000011],
              [13.712776000000133, 54.32111],
              [13.712221, 54.324165],
              [13.689444, 54.34833],
              [13.68444, 54.34916],
              [13.508333, 54.342773],
              [13.504444, 54.34166],
              [13.46944, 54.328331],
              [13.359444, 54.274719000000118],
              [13.35667, 54.273048],
              [13.355, 54.270271],
              [13.3575, 54.25972],
              [13.40305, 54.265274],
              [13.408333, 54.265274],
              [13.413332000000139, 54.264717000000132],
              [13.419998, 54.261383000000137],
              [13.421944, 54.25916],
              [13.42639, 54.251938000000109],
              [13.428888, 54.243889],
              [13.429443, 54.238052],
              [13.424444000000108, 54.233604000000128],
              [13.39777800000013, 54.221939],
              [13.393055, 54.221382],
              [13.31861, 54.248604000000114],
              [13.268055000000118, 54.254997],
              [13.25694, 54.256104],
              [13.249722, 54.258331],
              [13.156111, 54.30555],
              [13.12194, 54.330551],
              [13.118332, 54.333885],
              [13.117222, 54.339439],
              [13.117777, 54.343048],
              [13.129166, 54.36805],
              [13.130833, 54.370827],
              [13.134165, 54.37221],
              [13.141666, 54.37444],
              [13.151388000000111, 54.375275],
              [13.15667, 54.375275],
              [13.200554, 54.372772],
              [13.217222, 54.369995],
              [13.223055, 54.369438],
              [13.235832, 54.371666],
              [13.261389000000122, 54.378609],
              [13.265276, 54.380272],
              [13.2675, 54.382500000000107],
              [13.238983, 54.411472],
              [13.207789, 54.428108],
              [13.164639000000136, 54.434349],
              [13.228611, 54.464996],
              [13.23222, 54.485817],
              [13.167238, 54.51337100000012],
              [13.14696, 54.545605000000137],
              [13.231388, 54.552498],
              [13.25562, 54.551323],
              [13.30397, 54.550285],
              [13.337764, 54.5664],
              [13.3674, 54.580437],
              [13.377795, 54.55808],
              [13.394952000000103, 54.541965],
              [13.42043, 54.52169],
              [13.447461, 54.488937],
              [13.48385, 54.483738],
              [13.50309, 54.493095],
              [13.516607000000135, 54.51337100000012],
              [13.502570000000105, 54.549767],
              [13.459419, 54.550804],
              [13.426146, 54.570042],
              [13.383514, 54.57836],
              [13.374676, 54.610073],
              [13.35544, 54.604355000000112],
              [13.32972100000012, 54.582771],
              [13.310555, 54.57333],
              [13.286221, 54.565052],
              [13.282054, 54.563553000000127],
              [13.251389000000131, 54.557777],
              [13.246111, 54.557777],
              [13.24472, 54.559166],
              [13.224722, 54.633888000000127],
              [13.224722, 54.639999],
              [13.22611, 54.643051000000128],
              [13.230555, 54.64777400000014],
              [13.24472, 54.656662],
              [13.263332000000105, 54.666664],
              [13.27861, 54.671387],
              [13.29222, 54.673332],
              [13.36444, 54.67944],
              [13.383888, 54.680832000000123],
              [13.424166, 54.682777000000101],
              [13.429998, 54.68222],
              [13.43778, 54.679718],
              [13.443054000000132, 54.675827],
              [13.443609, 54.67305],
              [13.44194, 54.67055],
              [13.42861, 54.660271000000137],
              [13.422499, 54.656944],
              [13.397221, 54.652222000000108],
              [13.390554, 54.649162],
              [13.385555, 54.644997],
              [13.383055, 54.638885],
            ],
          ],
          [
            [
              [8.364443, 54.61332700000014],
              [8.353611, 54.612778],
              [8.34889, 54.613609],
              [8.342222, 54.616661000000136],
              [8.331944000000135, 54.623604000000114],
              [8.298054, 54.658607000000131],
              [8.294998000000135, 54.66333],
              [8.294443, 54.666664],
              [8.296665, 54.6722180000001],
              [8.307499000000121, 54.687218],
              [8.311943, 54.691383],
              [8.342777000000126, 54.707771],
              [8.349722, 54.71083],
              [8.35389, 54.711662],
              [8.35805, 54.710548],
              [8.4, 54.627777],
              [8.36805500000014, 54.614441000000113],
              [8.364443, 54.61332700000014],
            ],
          ],
          [
            [
              [8.567778, 54.68527],
              [8.56361, 54.684166000000118],
              [8.488333000000125, 54.685555000000136],
              [8.47833, 54.686943],
              [8.402498, 54.70472],
              [8.39694, 54.708328],
              [8.39694, 54.713882],
              [8.406387, 54.729439],
              [8.413332, 54.735832],
              [8.425833, 54.742218],
              [8.44472, 54.748329],
              [8.461666, 54.751938],
              [8.53861, 54.755272],
              [8.551109, 54.75388],
              [8.569721, 54.750275],
              [8.581944, 54.746941],
              [8.584721, 54.744995],
              [8.586943, 54.74305],
              [8.594721, 54.721382],
              [8.594999, 54.71833],
              [8.572222, 54.689438],
              [8.567778, 54.68527],
            ],
          ],
          [
            [
              [10.979443, 54.380554],
              [10.955555, 54.382774],
              [10.955832, 54.380272],
              [10.958887, 54.376938],
              [10.962776000000133, 54.375832000000116],
              [10.986944, 54.371941],
              [11.016943, 54.369995],
              [11.044722, 54.369720000000143],
              [11.07389, 54.376389],
              [11.094166, 54.210274],
              [11.094444, 54.203888],
              [11.093054000000109, 54.197495000000117],
              [11.064444, 54.179718],
              [11.055555, 54.17472],
              [10.8875, 54.09333],
              [10.877499, 54.088882],
              [10.86972, 54.087494000000106],
              [10.839443, 54.09],
              [10.824999, 54.09166],
              [10.801388, 54.08944],
              [10.76639, 54.061104000000114],
              [10.758055, 54.051941000000113],
              [10.754999, 54.046661],
              [10.754721, 54.039993],
              [10.756388, 54.034439],
              [10.763332, 54.022217],
              [10.770277, 54.012772],
              [10.783888, 54.00055],
              [10.789999, 53.99721],
              [10.801109, 53.993889000000138],
              [10.822222000000124, 53.994164000000126],
              [10.861387, 53.993889000000138],
              [10.870554, 53.991943],
              [10.879999, 53.987778],
              [10.88389, 53.98333],
              [10.884722, 53.98055],
              [10.889721000000122, 53.957771],
              [10.890554000000122, 53.950829],
              [10.863609, 53.916939],
              [10.818535, 53.890053],
              [10.898888000000113, 53.931107000000111],
              [10.90443, 53.957344],
              [10.964722, 53.98027],
              [11.013054000000125, 53.995277],
              [11.05539, 54.007355],
              [11.094721, 54.01361],
              [11.176943, 54.015831],
              [11.18222, 54.015274],
              [11.189444, 54.012497],
              [11.192221, 54.010551000000135],
              [11.196665, 53.993889000000138],
              [11.244165, 53.942497],
              [11.248888, 53.938606000000107],
              [11.252222, 53.93694],
              [11.263332, 53.933052],
              [11.271944, 53.931664],
              [11.412777, 53.919716],
              [11.480833, 53.960274],
              [11.49222200000014, 53.99305],
              [11.49333, 53.99611],
              [11.5175, 54.031944],
              [11.52444, 54.034721000000104],
              [11.528889, 54.034439],
              [11.54472, 54.026382],
              [11.554722, 54.026939],
              [11.573889, 54.032494],
              [11.57972100000012, 54.036110000000122],
              [11.625555, 54.075554],
              [11.62944, 54.080551000000128],
              [11.630278, 54.086662],
              [11.627499, 54.09166],
              [11.621387, 54.098053],
              [11.61861, 54.10305],
              [11.61972, 54.106110000000115],
              [11.626665000000116, 54.112778000000105],
              [11.63944, 54.122772000000111],
              [11.676109, 54.149994],
              [11.68278, 54.152771000000143],
              [11.69083, 54.154716000000121],
              [11.700277, 54.155548],
              [11.747499, 54.156387],
              [11.986111, 54.17333],
              [12.129721, 54.191109],
              [12.326944, 54.286659],
              [12.343611000000124, 54.29777],
              [12.356110000000115, 54.308609],
              [12.436943, 54.391106],
              [12.480555, 54.44416],
              [12.526943, 54.474159],
              [12.540554, 54.458885000000123],
              [12.638611000000139, 54.448944],
              [12.66044, 54.44611],
              [12.680777, 54.444942],
              [12.803333, 54.442497],
              [12.892776, 54.443329],
              [12.908609, 54.441383],
              [12.919722, 54.433884],
              [12.923611, 54.429718],
              [12.924166, 54.426941000000113],
              [12.923054, 54.42388],
              [12.920832000000132, 54.421661],
              [12.917500000000132, 54.419998000000135],
              [12.880554000000132, 54.411942],
              [12.758337, 54.413044000000127],
              [12.729240000000118, 54.423363],
              [12.7129, 54.42967],
              [12.694698, 54.42967],
              [12.676065, 54.420498000000123],
              [12.665316000000132, 54.408745],
              [12.643222, 54.413887],
              [12.465555000000109, 54.395828000000108],
              [12.462221000000113, 54.39444],
              [12.425833000000125, 54.372498000000121],
              [12.36666, 54.307495],
              [12.365, 54.304718],
              [12.364443, 54.30110900000011],
              [12.36972, 54.264999],
              [12.372499, 54.263054],
              [12.385555000000124, 54.25666],
              [12.40361, 54.249718],
              [12.412777, 54.247772],
              [12.445, 54.246941],
              [12.453054000000122, 54.248886],
              [12.455832, 54.250832],
              [12.452499, 54.252220000000136],
              [12.43639, 54.253883],
              [12.427221, 54.255829],
              [12.41805, 54.260826],
              [12.414165000000139, 54.265274],
              [12.413332000000139, 54.271111],
              [12.41555, 54.277222000000108],
              [12.420555, 54.285271],
              [12.427221, 54.29222],
              [12.4775, 54.329994],
              [12.482777, 54.333885],
              [12.54972, 54.360550000000103],
              [12.581944, 54.368332],
              [12.624722, 54.372772],
              [12.682777, 54.376106],
              [12.764721, 54.372498000000121],
              [13.02389, 54.399719],
              [13.113888, 54.279716],
              [13.117777, 54.275276],
              [13.12889, 54.271111],
              [13.2125, 54.251938000000109],
              [13.282221, 54.236664],
              [13.288055, 54.233055],
              [13.379166000000112, 54.174438],
              [13.4533330000001, 54.098053],
              [13.4558320000001, 54.096107],
              [13.47972, 54.088608],
              [13.494444000000101, 54.0861],
              [13.499722, 54.0861],
              [13.480000000000132, 54.116943000000106],
              [13.480555, 54.11972],
              [13.495554, 54.124161000000129],
              [13.706665, 54.171104],
              [13.71167, 54.17139],
              [13.71833, 54.169716000000108],
              [13.788887, 54.109718],
              [13.799721, 54.087494000000106],
              [13.79833200000013, 54.08083],
              [13.786110000000122, 54.049995],
              [13.829721, 53.986382],
              [13.86694, 53.905],
              [13.863609, 53.903328000000101],
              [13.82111, 53.876389000000131],
              [13.807499, 53.860832],
              [13.806110000000103, 53.857773000000122],
              [13.807499, 53.855270000000132],
              [13.813055, 53.845276000000126],
              [13.95917, 53.774994],
              [14.22389, 53.700829],
              [14.247499000000118, 53.69694],
              [14.26528, 53.697777],
              [14.275627, 53.699066],
              [14.30972, 53.55555],
              [14.413261, 53.33896],
              [14.412777, 53.30444],
              [14.391689, 53.144165],
              [14.3825, 53.116386],
              [14.378054, 53.103882],
              [14.352499, 53.052773],
              [14.342222, 53.044998000000135],
              [14.299702, 53.021431],
              [14.287777000000119, 53.016106],
              [14.22889, 52.990273000000116],
              [14.221943, 52.987495],
              [14.200277, 52.98472],
              [14.16889, 52.97333],
              [14.149443, 52.962776000000133],
              [14.146111, 52.9575],
              [14.145555000000115, 52.95389],
              [14.149166, 52.862778],
              [14.19639, 52.820549],
              [14.214443000000131, 52.816666000000112],
              [14.348888, 52.751663],
              [14.361111000000108, 52.744995],
              [14.383333, 52.73083],
              [14.448332, 52.675278],
              [14.475555, 52.654160000000104],
              [14.481943000000115, 52.65083],
              [14.505833, 52.641388],
              [14.518332, 52.637772],
              [14.527777, 52.636108],
              [14.54749900000013, 52.629997000000117],
              [14.561666000000116, 52.62444],
              [14.58722, 52.611938],
              [14.60433, 52.601723],
              [14.638332000000105, 52.574715],
              [14.640276, 52.572495],
              [14.641388, 52.57],
              [14.637220000000127, 52.497215],
              [14.636389000000122, 52.490555],
              [14.623333, 52.477219000000105],
              [14.587776, 52.441666000000112],
              [14.582499, 52.43805],
              [14.567221, 52.43388],
              [14.559166, 52.432495000000131],
              [14.54861, 52.42889],
              [14.54611, 52.426941],
              [14.54389, 52.42472],
              [14.53722, 52.406944],
              [14.534443, 52.397774],
              [14.534443, 52.394722000000115],
              [14.57805, 52.29055000000011],
              [14.58166, 52.286110000000122],
              [14.596109000000126, 52.274437],
              [14.601665, 52.271111],
              [14.65583, 52.26028],
              [14.692497, 52.25444],
              [14.70388800000012, 52.249718000000144],
              [14.710554000000116, 52.243889000000138],
              [14.713333, 52.239166000000125],
              [14.760765, 52.069862],
              [14.718542, 51.945091000000104],
              [14.71656, 51.941132],
              [14.692499, 51.898888000000113],
              [14.68722, 51.894997],
              [14.648054, 51.866943],
              [14.645277, 51.864998],
              [14.640276, 51.862221],
              [14.61611, 51.853882000000112],
              [14.605, 51.843887],
              [14.603333, 51.84111],
              [14.600555, 51.83138300000013],
              [14.599165, 51.821388],
              [14.599443000000122, 51.818604000000107],
              [14.60472, 51.80888],
              [14.663332, 51.728607],
              [14.666943, 51.724159],
              [14.678333, 51.714165],
              [14.698055000000124, 51.70222],
              [14.715832, 51.69416],
              [14.72833, 51.68777],
              [14.755278, 51.669998000000135],
              [14.756388, 51.667496],
              [14.757500000000107, 51.659439],
              [14.76111, 51.617218],
              [14.761389, 51.611382],
              [14.759998, 51.604439],
              [14.75444, 51.596939000000134],
              [14.714998, 51.554722],
              [14.73611, 51.528053000000114],
              [14.74278, 51.52499],
              [14.8375, 51.498604000000114],
              [14.92111, 51.481941],
              [14.95111, 51.471382],
              [14.95417, 51.469719],
              [14.95583, 51.467499],
              [14.975555, 51.440826],
              [14.981833, 51.36805],
              [14.971666, 51.358887],
              [14.971666, 51.355553],
              [14.980555, 51.338333],
              [14.986111000000108, 51.328888],
              [14.995554, 51.3211060000001],
              [15.009722, 51.312492],
              [15.03, 51.294716],
              [15.03639, 51.285553],
              [15.03889, 51.27166],
              [15.032221, 51.23917],
              [14.99444, 51.118607],
              [14.978888, 51.078331],
              [14.966389, 51.053604],
              [14.96472, 51.050827],
              [14.93111, 51.002495000000124],
              [14.896944000000133, 50.959442],
              [14.827776, 50.88694],
              [14.824165, 50.881943],
              [14.824999000000105, 50.876389],
              [14.8283330000001, 50.865829],
              [14.824999000000105, 50.856384],
              [14.804165, 50.820549],
              [14.801666, 50.81889],
              [14.776388, 50.818329],
              [14.76667, 50.818329],
              [14.739721, 50.823883],
              [14.717777, 50.829163],
              [14.65167, 50.847221],
              [14.62167, 50.85555],
              [14.61916, 50.8575],
              [14.61805500000014, 50.859993],
              [14.631388, 50.881104],
              [14.628332000000114, 50.923607000000118],
              [14.597221000000104, 50.982498],
              [14.569166, 51.005554],
              [14.491665, 51.03666],
              [14.30972, 51.053604],
              [14.302776, 51.051384],
              [14.28555, 51.037498],
              [14.265554, 51.009438000000102],
              [14.255554000000132, 50.99305],
              [14.254999, 50.990273000000116],
              [14.256109, 50.987778000000105],
              [14.319721000000129, 50.94694],
              [14.322777, 50.94527],
              [14.368332, 50.934998],
              [14.311388, 50.88222],
              [14.155554, 50.843048],
              [13.99472, 50.815277],
              [13.986666, 50.813606000000107],
              [13.904444, 50.789444],
              [13.902777000000128, 50.78694],
              [13.89111, 50.768883],
              [13.734165, 50.730827],
              [13.66944, 50.72583],
              [13.634722, 50.722221000000104],
              [13.582222, 50.709442],
              [13.541111, 50.68972],
              [13.510832, 50.650551000000121],
              [13.515554, 50.646942000000138],
              [13.519722000000115, 50.642776],
              [13.520277, 50.64],
              [13.518332, 50.637772],
              [13.4725, 50.60527],
              [13.463888, 50.60027],
              [13.458611, 50.600555],
              [13.436666, 50.60527],
              [13.416388, 50.61055],
              [13.413332000000139, 50.612221],
              [13.378332, 50.629440000000102],
              [13.25111, 50.59],
              [13.248055000000136, 50.588333],
              [13.224165, 50.564720000000136],
              [13.222221000000104, 50.558609],
              [13.222221000000104, 50.55555],
              [13.223888, 50.550278],
              [13.223888, 50.546944],
              [13.222776, 50.544167],
              [13.20889, 50.523888000000113],
              [13.20333, 50.51694],
              [13.19111, 50.50361],
              [13.183332000000121, 50.501938000000109],
              [13.079443, 50.498055],
              [13.01889, 50.442215],
              [13.011665, 50.436386],
              [12.991943, 50.421104],
              [12.985558, 50.41833],
              [12.950554000000125, 50.41111],
              [12.938889, 50.408882],
              [12.91722, 50.414719],
              [12.899721, 50.424438],
              [12.89694, 50.42610900000011],
              [12.85583, 50.442215],
              [12.83139, 50.45166],
              [12.818888, 50.454437],
              [12.77611, 50.44583],
              [12.768332, 50.44416],
              [12.74611, 50.434715],
              [12.73472, 50.428329000000133],
              [12.671389, 50.411942000000124],
              [12.623333, 50.411942000000124],
              [12.618610000000103, 50.411942000000124],
              [12.51861, 50.393883],
              [12.51222, 50.391106],
              [12.486111, 50.373055000000136],
              [12.398611, 50.309166],
              [12.325554, 50.236107],
              [12.323055, 50.2066650000001],
              [12.28417, 50.21527],
              [12.278055000000109, 50.22166],
              [12.195833000000107, 50.305832],
              [12.180277, 50.31638],
              [12.177221, 50.318054],
              [12.093704, 50.322533],
              [12.120832, 50.309441],
              [12.123333, 50.307495000000131],
              [12.208611, 50.169441],
              [12.209721, 50.16389],
              [12.20917, 50.160553],
              [12.196388, 50.143883],
              [12.193888000000129, 50.138054],
              [12.192499000000112, 50.13166],
              [12.206142, 50.106209],
              [12.265554000000122, 50.066109],
              [12.307499, 50.047493],
              [12.429443, 49.993889],
              [12.471109, 49.985832],
              [12.490000000000123, 49.976662],
              [12.492777, 49.975],
              [12.544167, 49.91805],
              [12.545555, 49.91555],
              [12.54722, 49.907219],
              [12.54694400000011, 49.8975],
              [12.469444, 49.784721000000104],
              [12.467499, 49.782219],
              [12.455555000000118, 49.695549],
              [12.47611, 49.690826],
              [12.508888, 49.682495],
              [12.513054, 49.681389000000138],
              [12.515554, 49.679443],
              [12.524443000000133, 49.66555],
              [12.554722, 49.616661],
              [12.578609, 49.560555000000136],
              [12.597776, 49.527496],
              [12.674444, 49.424995000000138],
              [12.78611, 49.34416],
              [12.795555, 49.33972],
              [12.80361, 49.337776],
              [12.87861, 49.328049000000135],
              [12.883333, 49.327499000000103],
              [12.887777, 49.327774],
              [12.891109, 49.328888],
              [12.893055, 49.331108],
              [12.885277, 49.33972],
              [12.88416500000011, 49.342216],
              [12.88416500000011, 49.345276000000126],
              [12.88611, 49.346939],
              [12.8908330000001, 49.346939],
              [12.945555, 49.339439],
              [12.957222000000115, 49.33639],
              [12.96666, 49.33194],
              [13.031111, 49.287773000000129],
              [13.173054, 49.16722],
              [13.314165, 49.103333000000134],
              [13.322777, 49.098328],
              [13.39528, 49.050278000000105],
              [13.396944, 49.04805],
              [13.40254, 49.006187],
              [13.50972, 48.9725],
              [13.564826, 48.973667],
              [13.580555, 48.970833],
              [13.587776, 48.966385],
              [13.59111, 48.959717],
              [13.593332, 48.956940000000145],
              [13.59972, 48.951942000000145],
              [13.605276000000117, 48.950829000000113],
              [13.626389000000131, 48.953331],
              [13.6275, 48.950554],
              [13.624998, 48.947495000000117],
              [13.625555, 48.939163000000121],
              [13.641109, 48.914162],
              [13.649166, 48.906105000000139],
              [13.655554000000109, 48.901108],
              [13.661943, 48.896385],
              [13.666666, 48.894722000000115],
              [13.677776, 48.884163],
              [13.691111, 48.878326],
              [13.707777, 48.880272],
              [13.719444000000124, 48.878326],
              [13.724443, 48.879440000000102],
              [13.731943, 48.88361],
              [13.736666, 48.883888],
              [13.740833, 48.88166],
              [13.7425, 48.87444],
              [13.745832, 48.867775],
              [13.753332, 48.85916],
              [13.756666, 48.85249],
              [13.761389, 48.84694],
              [13.763054000000125, 48.8436],
              [13.765554, 48.840828000000101],
              [13.76944, 48.838608],
              [13.77944, 48.83583],
              [13.78583, 48.830826000000116],
              [13.802776000000108, 48.810829],
              [13.81389, 48.800278],
              [13.815554, 48.796944],
              [13.815832, 48.792770000000132],
              [13.81278, 48.785271000000137],
              [13.812222, 48.78083],
              [13.815554, 48.77833],
              [13.832499, 48.774994],
              [13.833611, 48.7736],
              [13.81472, 48.73805],
              [13.826666, 48.643051],
              [13.82694400000014, 48.638885],
              [13.825277, 48.62527],
              [13.82278, 48.617218],
              [13.804998, 48.58416],
              [13.8025, 48.581108],
              [13.725996, 48.515587],
              [13.683054, 48.529442],
              [13.674721, 48.533051],
              [13.666943, 48.537216],
              [13.657776, 48.549164],
              [13.65167, 48.554161000000136],
              [13.602777000000117, 48.56805],
              [13.526943, 48.585],
              [13.51528, 48.58527400000014],
              [13.50528, 48.583054000000118],
              [13.450554, 48.568886],
              [13.441666, 48.565552],
              [13.435, 48.561104000000114],
              [13.43528, 48.556938],
              [13.443609, 48.55055],
              [13.4475, 48.544441],
              [13.457777, 48.517776],
              [13.457222, 48.513329000000113],
              [13.44, 48.43527],
              [13.435833, 48.423607],
              [13.423332, 48.393608],
              [13.421665, 48.389999],
              [13.419167, 48.38694],
              [13.394999, 48.366104],
              [13.334999, 48.328606],
              [13.31305, 48.315826],
              [13.291943, 48.307495],
              [13.27861, 48.30305],
              [13.258055000000127, 48.298882],
              [13.154444, 48.292221],
              [13.01777600000014, 48.259438000000102],
              [12.874998000000119, 48.204994],
              [12.867498, 48.200829],
              [12.7675, 48.131943],
              [12.76083, 48.12722],
              [12.75833, 48.123886],
              [12.755, 48.116943],
              [12.753332, 48.109161],
              [12.754444, 48.10555],
              [12.764166000000102, 48.085274],
              [12.768332, 48.079163],
              [12.79278, 48.059441000000106],
              [12.805555, 48.049721],
              [12.8375, 48.03],
              [12.853333, 48.01777600000014],
              [12.85833, 48.012215],
              [12.863194, 48.0],
              [12.865342, 47.99459800000011],
              [12.918888, 47.957771],
              [12.96666, 47.906944000000124],
              [13.008888, 47.854164],
              [12.97333, 47.813332],
              [12.967777, 47.80778],
              [12.94861, 47.792770000000132],
              [12.939722, 47.784721000000104],
              [12.912498000000141, 47.733055],
              [12.91139, 47.72916],
              [12.910831, 47.724442],
              [12.911943, 47.720833],
              [12.917500000000132, 47.715553],
              [12.923611, 47.714722],
              [12.98499900000013, 47.712219],
              [12.99111, 47.712494],
              [12.995554, 47.714165],
              [13.003332, 47.717773],
              [13.014166, 47.72416],
              [13.01916, 47.725273000000129],
              [13.024443, 47.724998],
              [13.034443, 47.722221],
              [13.058332, 47.70611],
              [13.074999000000105, 47.690277],
              [13.08, 47.684441000000106],
              [13.099998000000141, 47.645],
              [13.100277000000119, 47.640831000000105],
              [13.054998, 47.5],
              [13.053055, 47.496384],
              [13.050278, 47.49389],
              [13.01667, 47.470276],
              [13.011665, 47.469162],
              [13.004999000000112, 47.469444000000124],
              [12.963055000000111, 47.475555],
              [12.95269, 47.478477],
              [12.809721, 47.55222],
              [12.80361, 47.557220000000143],
              [12.78944, 47.579437],
              [12.78611, 47.585831],
              [12.787777, 47.589439],
              [12.800278, 47.613052],
              [12.808887, 47.616386],
              [12.814444, 47.616943],
              [12.827776, 47.616386],
              [12.83083, 47.618889],
              [12.82917, 47.622215],
              [12.82361, 47.62749],
              [12.74472, 47.681107000000111],
              [12.735554, 47.684166],
              [12.722776000000124, 47.684441000000106],
              [12.665833, 47.684998],
              [12.606943, 47.674438],
              [12.60278, 47.672775000000115],
              [12.596943, 47.667496000000142],
              [12.57639, 47.6441650000001],
              [12.56667, 47.64194],
              [12.518055, 47.632217],
              [12.51278, 47.633331],
              [12.508888, 47.63528],
              [12.455, 47.66777],
              [12.201111, 47.65749],
              [12.206856, 47.639534],
              [12.20778, 47.627220000000136],
              [12.206388, 47.618607],
              [12.20472, 47.61496],
              [12.199377, 47.61026],
              [12.195745000000102, 47.608124],
              [12.14139, 47.611107000000118],
              [12.111111, 47.614716000000101],
              [12.059999, 47.62055],
              [12.006388000000129, 47.624443],
              [11.919998, 47.614166],
              [11.683054000000141, 47.584717],
              [11.583611000000133, 47.527222],
              [11.57778, 47.521942000000138],
              [11.57444, 47.52],
              [11.554443000000106, 47.51555],
              [11.505278, 47.509163],
              [11.457499, 47.51221],
              [11.296389, 47.428886],
              [11.1125, 47.396942],
              [11.095554, 47.396111],
              [11.02861, 47.395271],
              [11.008333000000107, 47.395828],
              [10.98361, 47.398048],
              [10.978333, 47.399162],
              [10.97361, 47.400551],
              [10.971109, 47.40333],
              [10.909443, 47.518051],
              [10.690832, 47.55389],
              [10.569443, 47.540276],
              [10.484165, 47.582771],
              [10.484444, 47.58722],
              [10.482777000000112, 47.59055],
              [10.47805, 47.591942000000131],
              [10.472500000000139, 47.591385],
              [10.44361, 47.583885],
              [10.434166, 47.581383],
              [10.43, 47.57972],
              [10.426943, 47.57694],
              [10.436388, 47.52916],
              [10.458332, 47.491104000000121],
              [10.467499, 47.483604],
              [10.46917, 47.480553],
              [10.469721, 47.47639],
              [10.474165, 47.439720000000136],
              [10.47333, 47.435555000000136],
              [10.429722, 47.396111],
              [10.339998, 47.314995],
              [10.337221000000113, 47.312492000000134],
              [10.329443, 47.308327000000133],
              [10.274443, 47.28889],
              [10.232777, 47.276665],
              [10.22805, 47.275551],
              [10.221943, 47.27528],
              [10.173332, 47.274719],
              [10.21167, 47.322495],
              [10.23139, 47.369995000000131],
              [10.232777, 47.3736],
              [10.23139, 47.381386],
              [10.04305, 47.495277000000101],
              [9.955, 47.539719],
              [9.81361, 47.593605],
              [9.808332, 47.594719],
              [9.782499, 47.594444],
              [9.773611, 47.591385],
              [9.763054, 47.584717],
              [9.749443, 47.570831000000112],
              [9.74305500000014, 47.560829000000126],
              [9.73639, 47.546944],
              [9.7292, 47.535297],
              [9.692531, 47.52951400000012],
              [9.651506, 47.52951400000012],
              [9.610482, 47.52951400000012],
              [9.607064, 47.52951400000012],
              [9.577914, 47.537418],
              [9.566724, 47.54045],
              [9.478322000000105, 47.57585],
              [9.261095, 47.662842],
              [9.086943, 47.684998],
              [9.07833, 47.685829],
              [9.0425, 47.688889],
              [9.02417, 47.687775000000101],
              [9.004999, 47.682495],
              [8.996666000000118, 47.679161],
              [8.98555, 47.672775000000115],
              [8.973331, 47.667496000000142],
              [8.94778, 47.65749],
              [8.934166, 47.653053],
              [8.917776000000117, 47.650551],
              [8.904999, 47.650276],
              [8.89278, 47.651382],
              [8.883299000000136, 47.654148],
              [8.855833, 47.698883],
              [8.835278, 47.718048],
              [8.808887, 47.73583200000013],
              [8.804165, 47.73722],
              [8.799999000000128, 47.735275],
              [8.777777, 47.722771],
              [8.772221, 47.717499],
              [8.772778, 47.713333],
              [8.774721000000113, 47.710274],
              [8.800133, 47.681725],
              [8.761389000000122, 47.692215],
              [8.74528, 47.695],
              [8.720222, 47.69662],
              [8.729166, 47.70388800000012],
              [8.730698, 47.705673],
              [8.734165, 47.709717000000126],
              [8.734999, 47.713882000000126],
              [8.736944000000108, 47.75444],
              [8.736944000000108, 47.758049],
              [8.734999, 47.761383],
              [8.685555, 47.786659],
              [8.661388000000102, 47.79805],
              [8.61472, 47.803604],
              [8.60861, 47.804161],
              [8.56611, 47.806938],
              [8.559721, 47.806389],
              [8.479443, 47.7725],
              [8.47611, 47.769997000000103],
              [8.47333, 47.767494000000113],
              [8.406666, 47.70388800000012],
              [8.407221, 47.699715],
              [8.413332, 47.678329000000133],
              [8.424721, 47.66944100000012],
              [8.47555, 47.646942],
              [8.495277, 47.647217],
              [8.51833, 47.649719000000118],
              [8.52583, 47.65361],
              [8.52805, 47.65694],
              [8.536943000000122, 47.664444],
              [8.545832, 47.667496000000142],
              [8.55139, 47.66833],
              [8.580555000000118, 47.668610000000115],
              [8.610254, 47.667732000000115],
              [8.620832, 47.66111],
              [8.626944, 47.656105],
              [8.629444, 47.653328000000101],
              [8.630833, 47.649719000000118],
              [8.629166, 47.646111],
              [8.594721, 47.601662],
              [8.591389, 47.599442],
              [8.57642, 47.59137],
              [8.569430000000125, 47.598537000000135],
              [8.565554, 47.614441000000113],
              [8.562222, 47.621384],
              [8.558332, 47.623329],
              [8.53139, 47.63277],
              [8.519999, 47.634163000000115],
              [8.51111, 47.631104],
              [8.477499, 47.612221],
              [8.464998, 47.602493],
              [8.435833, 47.57361],
              [8.3908330000001, 47.579994000000113],
              [8.2925, 47.605827],
              [8.28805, 47.611664],
              [8.283333, 47.613052],
              [8.240833, 47.619438],
              [8.205555, 47.62167],
              [8.198889, 47.62167],
              [8.193333000000109, 47.620827],
              [8.18528, 47.617218],
              [8.11083200000013, 47.581108],
              [8.108055, 47.578331],
              [8.103888, 47.571938],
              [8.102499, 47.568329],
              [8.09972, 47.565552000000139],
              [8.092222, 47.561661],
              [8.086666, 47.560555],
              [8.033333000000141, 47.556107],
              [7.93194, 47.55222],
              [7.91889, 47.552773],
              [7.91361, 47.55389],
              [7.906388, 47.558052],
              [7.769722, 47.553329],
              [7.697223, 47.543327],
              [7.656111000000124, 47.55055],
              [7.621111, 47.5611],
              [7.666666, 47.574165000000107],
              [7.669999, 47.576385],
              [7.671944, 47.579437],
              [7.676944, 47.603607],
              [7.674444, 47.606384000000105],
              [7.64055, 47.603882],
              [7.588268, 47.58448],
              [7.589747, 47.592697000000101],
              [7.589722000000108, 47.601944000000117],
              [7.585833, 47.60833],
              [7.567222, 47.636665],
              [7.56111, 47.641663],
              [7.540277000000117, 47.655],
              [7.528889, 47.66083],
              [7.521944, 47.66555],
              [7.51944, 47.66833],
              [7.513333000000102, 47.68694],
              [7.510833, 47.703331],
              [7.526667, 47.788055],
              [7.557221, 47.862778000000105],
              [7.584167, 47.903328],
              [7.622222, 47.96916],
              [7.624166, 47.976944000000117],
              [7.624444, 47.986107000000118],
              [7.622499000000118, 47.993889],
              [7.618518, 48.0],
              [7.61361, 48.006104],
              [7.583888, 48.027222000000108],
              [7.574444, 48.034439],
              [7.571666, 48.037216000000114],
              [7.56919, 48.044777],
              [7.56667, 48.059998],
              [7.568889000000127, 48.085274],
              [7.569722000000127, 48.08916],
              [7.576898, 48.113152],
              [7.578888, 48.119720000000143],
              [7.580832, 48.122772],
              [7.607729, 48.164185],
              [7.693333, 48.276382],
              [7.746111, 48.330551],
              [7.750833, 48.336662000000103],
              [7.75177, 48.345406],
              [7.743055, 48.371109000000104],
              [7.736666, 48.389442000000145],
              [7.736666, 48.3986],
              [7.745403000000124, 48.42495],
              [7.80222, 48.575829],
              [7.88, 48.66416],
              [7.96194400000013, 48.7241590000001],
              [8.092222, 48.803604],
              [8.103888, 48.816666],
              [8.10639, 48.82222],
              [8.110277, 48.840828000000101],
              [8.112499, 48.846382],
              [8.121666, 48.864998],
              [8.135832, 48.890831],
              [8.139166, 48.895554],
              [8.190554, 48.951942000000145],
              [8.20611, 48.95888],
              [8.22608, 48.964417],
              [8.155554000000109, 48.97639],
              [8.051943, 49.005272],
              [8.039721, 49.01111],
              [7.938611, 49.048882],
              [7.933332000000121, 49.048882],
              [7.821388, 49.046387],
              [7.737499, 49.04277],
              [7.66889, 49.04222],
              [7.652089, 49.044937000000118],
              [7.63028, 49.065277],
              [7.625833000000114, 49.06916],
              [7.486944, 49.164162],
              [7.432500000000118, 49.175827],
              [7.423611, 49.177216000000101],
              [7.41361, 49.176941000000113],
              [7.38361, 49.173332],
              [7.375278, 49.171944],
              [7.371944, 49.17083],
              [7.369015, 49.16878],
              [7.367222, 49.160553],
              [7.361666, 49.14444],
              [7.36, 49.14222],
              [7.29167, 49.11222],
              [7.287777, 49.111107],
              [7.151667, 49.121109000000104],
              [7.090555, 49.127495],
              [7.019444, 49.187492],
              [6.934166, 49.219719],
              [6.930555, 49.22083],
              [6.920555, 49.220551],
              [6.853889, 49.218048000000124],
              [6.8475, 49.215271],
              [6.843055, 49.211388],
              [6.841389, 49.208885000000123],
              [6.840278, 49.206108],
              [6.84111, 49.203331000000105],
              [6.849722, 49.190552],
              [6.855000000000132, 49.183884],
              [6.859722, 49.179993],
              [6.861111, 49.177773],
              [6.861111, 49.174995],
              [6.85944400000011, 49.172493000000145],
              [6.844166, 49.158333],
              [6.838888, 49.154999],
              [6.831388, 49.15305],
              [6.82194, 49.153885],
              [6.735, 49.165276],
              [6.730833, 49.166107],
              [6.727500000000134, 49.167496],
              [6.723611, 49.171661],
              [6.715, 49.18305],
              [6.714167, 49.185829],
              [6.714722, 49.188889000000131],
              [6.716389000000106, 49.191383],
              [6.686944, 49.244995],
              [6.594722000000104, 49.363052],
              [6.546111, 49.41944],
              [6.540555, 49.425827],
              [6.532222, 49.430832000000123],
              [6.50833, 49.442772],
              [6.468333, 49.461388],
              [6.416111, 49.47583],
              [6.41139, 49.47555],
              [6.36217, 49.45939],
              [6.362778, 49.489166000000125],
              [6.356486, 49.525864],
              [6.420833, 49.665833],
              [6.466110000000128, 49.691109],
              [6.47305, 49.693604],
              [6.48472, 49.69611],
              [6.505835, 49.706627],
              [6.524722000000111, 49.80555],
              [6.524444, 49.808609],
              [6.522222, 49.811104],
              [6.481944, 49.811104],
              [6.42972200000014, 49.808884],
              [6.395555, 49.817772],
              [6.321111, 49.84833],
              [6.315938000000131, 49.85531600000013],
              [6.25528, 49.880554],
              [6.250278, 49.884163],
              [6.234166, 49.8975],
              [6.175278, 49.949997],
              [6.173055, 49.95222],
              [6.14055500000012, 49.993889],
              [6.130555000000129, 50.013885],
              [6.11333, 50.055832],
              [6.112778, 50.05888],
              [6.118333, 50.09083],
              [6.128055, 50.116386],
              [6.13028, 50.121941],
              [6.134414, 50.127846],
              [6.13972200000012, 50.154442000000131],
              [6.16389, 50.221382],
              [6.165555, 50.22361],
              [6.173333, 50.232498],
              [6.280833, 50.283607],
              [6.34972, 50.31277],
              [6.398204, 50.32317],
              [6.37444, 50.44055],
              [6.37361, 50.443329],
              [6.371111, 50.448326],
              [6.344444, 50.484161],
              [6.333888000000115, 50.48972],
              [6.3175, 50.49638],
              [6.30944, 50.498055],
              [6.264722, 50.497772],
              [6.247777, 50.589165],
              [6.27055, 50.615829000000133],
              [6.27167, 50.618607000000111],
              [6.270833, 50.621384],
              [6.268611, 50.623604],
              [6.16722, 50.656387],
              [6.05472200000014, 50.723610000000122],
              [6.011798, 50.757271],
              [6.008055000000127, 50.802216],
              [6.013333, 50.838608],
              [6.013888000000122, 50.84166],
              [6.026111, 50.847771],
              [6.04611, 50.851944],
              [6.051666, 50.851944],
              [6.056389, 50.848328],
              [6.060833, 50.847496],
              [6.064722, 50.848328],
              [6.06778, 50.849716],
              [6.071666, 50.85416],
              [6.08417, 50.870552],
              [6.084722, 50.873604],
              [6.081388, 50.913605000000132],
              [6.080277000000137, 50.915833],
              [6.02833, 50.97666],
              [6.025555, 50.978333],
              [6.0175, 50.98027],
              [5.948889, 50.984993],
              [5.944722, 50.984993],
              [5.9325, 50.982216],
              [5.908055, 50.973885],
              [5.900277, 50.971939],
              [5.891666, 50.972771],
              [5.869444000000101, 51.018883],
              [5.864166, 51.04361],
              [5.86472, 51.046104],
              [5.866944, 51.048050000000103],
              [5.902499, 51.06305],
              [5.906944000000124, 51.063889],
              [5.910277, 51.062492],
              [6.00305, 51.08416],
              [6.0975, 51.131104],
              [6.090278, 51.168884],
              [6.083611000000133, 51.17166],
              [6.079444000000137, 51.175827],
              [6.07667, 51.181107000000111],
              [6.074721, 51.189995000000124],
              [6.071388, 51.211662],
              [6.071666, 51.215],
              [6.072222, 51.218048],
              [6.076388, 51.240273],
              [6.07889, 51.242493],
              [6.143055, 51.295273000000122],
              [6.222221000000104, 51.361664000000133],
              [6.222777, 51.364716],
              [6.222221000000104, 51.46583],
              [6.221944, 51.468887],
              [6.2075, 51.509995],
              [6.202222, 51.51694],
              [6.15861, 51.558327000000133],
              [6.136666, 51.569160000000124],
              [6.131389, 51.572495],
              [6.094166, 51.604439],
              [6.093055000000106, 51.607216000000108],
              [6.028889, 51.706665],
              [5.95205, 51.747528],
              [5.980833, 51.760277],
              [5.985833, 51.763885],
              [5.986666, 51.766937],
              [5.984722, 51.780548],
              [5.98139, 51.785271],
              [5.964722, 51.80555],
              [5.9625, 51.807777],
              [6.00305, 51.82999],
              [6.12361, 51.888054],
              [6.182221, 51.895271],
              [6.35111, 51.848053],
              [6.462777, 51.853607],
              [6.5275, 51.874443],
              [6.594722000000104, 51.896111],
              [6.67611, 51.91389],
              [6.685555, 51.914162],
              [6.691667, 51.911110000000122],
              [6.69361, 51.908882000000119],
              [6.701944, 51.90361],
              [6.720555, 51.89777400000014],
              [6.724444, 51.898048],
              [6.746388, 51.906105],
              [6.776944, 51.921387],
              [6.789166, 51.928055],
              [6.828888, 51.965553],
              [6.8308320000001, 51.971382],
              [6.83, 51.97749],
              [6.826111, 51.98860900000011],
              [6.80055, 52.00722],
              [6.794444, 52.010277],
              [6.728611, 52.035271],
              [6.73639, 52.076660000000118],
              [6.759428, 52.114563],
              [6.8425, 52.117775],
              [6.8525, 52.11833],
              [6.860555, 52.12028],
              [6.86861, 52.125549],
              [6.87194, 52.130272],
              [6.87472, 52.13916],
              [6.876111, 52.148605],
              [6.8775, 52.151382],
              [6.901111, 52.171387],
              [6.904166, 52.17305],
              [6.96472, 52.190277],
              [7.042222, 52.23166700000013],
              [7.053094, 52.23776],
              [7.031388, 52.268883],
              [7.028055, 52.276939],
              [7.028055, 52.280273000000136],
              [7.028889, 52.286942],
              [7.032222, 52.298882000000106],
              [7.038055, 52.31277],
              [7.058114000000103, 52.337639],
              [7.069722, 52.352776000000119],
              [7.071111, 52.358887],
              [7.065555, 52.385826],
              [7.061944, 52.39361],
              [7.058888, 52.398605],
              [6.99083, 52.459717],
              [6.987499, 52.4611],
              [6.983889, 52.46],
              [6.973888, 52.448608],
              [6.965833, 52.443054],
              [6.95417, 52.436386],
              [6.950833, 52.434998000000121],
              [6.94611, 52.434441],
              [6.76444400000014, 52.45916],
              [6.753333000000111, 52.462776],
              [6.705555, 52.485832],
              [6.7025, 52.490555],
              [6.688889, 52.549164000000133],
              [6.690277, 52.551941],
              [6.7225, 52.559441000000106],
              [6.75611, 52.563332],
              [6.75944, 52.56472],
              [6.760833, 52.56721],
              [6.729444, 52.616104],
              [6.72611, 52.62111],
              [6.718923000000132, 52.626785],
              [6.720833, 52.62944],
              [6.756666, 52.649162000000103],
              [6.76805, 52.65222],
              [6.78167, 52.654160000000104],
              [6.894722000000115, 52.653053],
              [6.902222, 52.651939],
              [6.905555000000106, 52.650551],
              [6.91305, 52.644997000000103],
              [6.916944, 52.640549000000135],
              [6.920278, 52.63888500000013],
              [7.025, 52.632500000000107],
              [7.030833, 52.632500000000107],
              [7.035832000000141, 52.632774],
              [7.043333000000132, 52.634995000000117],
              [7.048055, 52.63888500000013],
              [7.051666, 52.643608],
              [7.055277, 52.651939],
              [7.058888, 52.663887],
              [7.063611, 52.721382000000119],
              [7.065277, 52.75222],
              [7.064722, 52.76861],
              [7.065555, 52.78583],
              [7.066944, 52.799164],
              [7.069722, 52.814995],
              [7.076944, 52.82444],
              [7.091067000000123, 52.836906],
              [7.133055, 52.888885],
              [7.179722, 52.934166000000118],
              [7.19333, 52.95722],
              [7.197778, 52.965],
              [7.200277, 52.970551],
              [7.210278, 53.001938],
              [7.211666, 53.015831],
              [7.207222, 53.17610900000011],
              [7.208364, 53.242805],
              [7.245000000000118, 53.311386],
              [7.25, 53.315277],
              [7.256389, 53.318329000000119],
              [7.271944000000133, 53.319160000000124],
              [7.320000000000107, 53.317497],
              [7.329721, 53.316383],
              [7.336944, 53.313889000000131],
              [7.3425, 53.310272],
              [7.346389, 53.30555],
              [7.351944000000117, 53.302216000000101],
              [7.355277, 53.300827],
              [7.364444, 53.29916],
              [7.358611, 53.308609],
              [7.35111, 53.317497],
              [7.341666, 53.32222],
              [7.3325, 53.323883000000137],
              [7.226944, 53.336388],
              [7.183888, 53.340828000000101],
              [7.126389, 53.34],
              [7.0925, 53.338051],
              [7.073333, 53.336105],
              [7.058055, 53.337219],
              [7.05055, 53.339722],
              [7.04777700000011, 53.34166],
              [7.043333000000132, 53.34583],
              [7.024166, 53.364998],
              [7.019444, 53.372215],
              [7.016388, 53.380554],
              [7.0158330000001, 53.38361],
              [7.014444, 53.404999],
              [7.015555, 53.414719],
              [7.021944, 53.442497000000117],
              [7.031388, 53.479439000000127],
              [7.033333000000141, 53.485275],
              [7.088055000000111, 53.582771],
              [7.09611, 53.591942],
              [7.101944, 53.595276],
              [7.184722000000136, 53.64222],
              [7.226944, 53.664993],
              [7.23722, 53.669441],
              [7.29583, 53.685272],
              [7.34111, 53.688606],
              [7.450555, 53.687492],
              [7.4675, 53.686943],
              [7.4725, 53.686386],
              [7.484444, 53.68305],
              [7.508333000000107, 53.672493],
              [7.51861, 53.671661],
              [7.581666, 53.681389],
              [7.698333, 53.70027],
              [7.843333, 53.714165],
              [7.882500000000107, 53.7175],
              [7.9075, 53.719444000000124],
              [7.949166, 53.7175],
              [7.981667, 53.715271],
              [8.008333, 53.709999],
              [8.020277, 53.7066650000001],
              [8.026388, 53.70361],
              [8.028610000000128, 53.701385],
              [8.02972, 53.69861],
              [8.023888, 53.691666],
              [8.022499, 53.688889000000131],
              [8.021666, 53.685829],
              [8.022221, 53.676109],
              [8.024721, 53.67083],
              [8.04611, 53.636383],
              [8.058054, 53.626389],
              [8.123888, 53.584717000000126],
              [8.157221, 53.56472],
              [8.159443, 53.562492000000134],
              [8.162498, 53.557777000000101],
              [8.165833, 53.549721],
              [8.166666, 53.54333],
              [8.16833, 53.527222],
              [8.168055, 53.524437],
              [8.163332, 53.520554],
              [8.13528, 53.511383000000137],
              [8.12361, 53.508049000000142],
              [8.10305, 53.504166],
              [8.084444, 53.501938],
              [8.06333, 53.502777],
              [8.061388, 53.500549],
              [8.06167, 53.497498],
              [8.066111, 53.479996],
              [8.069721000000129, 53.472221000000104],
              [8.075832, 53.462494],
              [8.080276, 53.458054000000118],
              [8.097776, 53.44444],
              [8.204721, 53.404160000000104],
              [8.20861, 53.403053],
              [8.22305, 53.40083],
              [8.23444400000011, 53.400551000000121],
              [8.244165, 53.401382000000126],
              [8.248333, 53.402222],
              [8.281111, 53.416939],
              [8.28916, 53.422493000000145],
              [8.29278, 53.42722],
              [8.309721, 53.451385],
              [8.313055, 53.456383],
              [8.314999, 53.46611],
              [8.319721, 53.498886],
              [8.320555, 53.509163000000115],
              [8.319721, 53.515274],
              [8.314722, 53.522499],
              [8.308611, 53.525551],
              [8.303333, 53.526108],
              [8.293333, 53.52528],
              [8.272778, 53.520828],
              [8.263611, 53.519722],
              [8.237499, 53.518608],
              [8.233055, 53.51944],
              [8.231943000000115, 53.522217],
              [8.232222, 53.532219],
              [8.236944, 53.557777000000101],
              [8.243055, 53.586105],
              [8.26111, 53.60305],
              [8.272778, 53.60999],
              [8.283333, 53.613884],
              [8.306110000000103, 53.616943],
              [8.323055, 53.616943],
              [8.341389, 53.613609],
              [8.494444, 53.554993000000138],
              [8.51833, 53.513611],
              [8.508333000000107, 53.505554000000132],
              [8.503887, 53.501389000000131],
              [8.496387, 53.491943],
              [8.49111, 53.484444],
              [8.488333000000125, 53.479164],
              [8.485277, 53.470276000000126],
              [8.48278, 53.453888],
              [8.484165, 53.418327],
              [8.485277, 53.406105],
              [8.488609, 53.38166],
              [8.490833, 53.373055],
              [8.497776, 53.360275000000115],
              [8.503054, 53.354164],
              [8.506666, 53.362495000000138],
              [8.508055, 53.372498],
              [8.505833, 53.424995],
              [8.504999000000112, 53.434441],
              [8.49861, 53.450554],
              [8.496111, 53.462494],
              [8.498055, 53.471939],
              [8.501665000000116, 53.4805530000001],
              [8.506388, 53.488052],
              [8.511389, 53.492218],
              [8.560867, 53.515434],
              [8.565554, 53.521385],
              [8.568333000000109, 53.526939],
              [8.568333000000109, 53.53333],
              [8.567499, 53.53611],
              [8.55778, 53.550552],
              [8.511734000000104, 53.617218],
              [8.49472, 53.64194],
              [8.488333000000125, 53.651665],
              [8.485554, 53.66],
              [8.483055, 53.671944],
              [8.482222, 53.681107],
              [8.483332, 53.690277],
              [8.487778, 53.701942],
              [8.54805, 53.818329],
              [8.574444, 53.851387],
              [8.580276, 53.858604000000128],
              [8.60111, 53.87749],
              [8.604166, 53.87944],
              [8.611944, 53.88166],
              [8.6525, 53.891388],
              [8.66555, 53.893883],
              [8.680555, 53.894722],
              [8.683887, 53.893051000000128],
              [8.706388, 53.875832],
              [8.71139, 53.87167],
              [8.713055, 53.866104],
              [8.71472, 53.86388],
              [8.7280540000001, 53.857773000000122],
              [8.756388, 53.846664],
              [8.775555, 53.84055],
              [8.797222, 53.835831],
              [8.85305, 53.82972],
              [8.9075, 53.828049],
              [9.02055, 53.846664],
              [9.105276000000117, 53.863327],
              [9.128887, 53.866104],
              [9.213055, 53.864998],
              [9.218887, 53.864716000000101],
              [9.27611, 53.858887],
              [9.279999, 53.857773000000122],
              [9.283333, 53.856384000000105],
              [9.29416700000013, 53.849159],
              [9.32028, 53.83027600000014],
              [9.324444, 53.82611],
              [9.35139, 53.798050000000103],
              [9.379444, 53.760826],
              [9.408888, 53.730553],
              [9.415833, 53.724442000000124],
              [9.547777, 53.61055],
              [9.562222, 53.598328],
              [9.573055, 53.59111],
              [9.582777, 53.586105],
              [9.672777, 53.55555],
              [9.695833, 53.550278000000105],
              [9.764746, 53.543732],
              [9.802221, 53.534721],
              [9.811388, 53.533051],
              [9.821665, 53.53249],
              [9.826387000000125, 53.533051],
              [9.83, 53.53444],
              [9.832499, 53.536385],
              [9.833887, 53.53889],
              [9.833887, 53.542221],
              [9.830276, 53.54666],
              [9.82472, 53.550278000000105],
              [9.82083, 53.551666],
              [9.783888, 53.561386],
              [9.774166, 53.562775000000101],
              [9.741083, 53.565],
              [9.724165, 53.56555],
              [9.699444, 53.568329],
              [9.68194, 53.571938000000102],
              [9.66361, 53.578606],
              [9.57528, 53.613609],
              [9.56111, 53.621666],
              [9.54666, 53.6336060000001],
              [9.437777, 53.739441],
              [9.430555, 53.748604],
              [9.417221, 53.771111000000133],
              [9.407776, 53.792221],
              [9.394444, 53.821388],
              [9.393055, 53.823883],
              [9.337776, 53.852776],
              [9.327776, 53.857216],
              [9.286388, 53.874443],
              [9.27833, 53.876663],
              [9.234444, 53.886383000000137],
              [9.220833, 53.888885],
              [9.205276, 53.890549],
              [9.063055000000134, 53.898048],
              [8.993055, 53.89111],
              [8.983332000000132, 53.890274],
              [8.967222, 53.895],
              [8.9475, 53.907219],
              [8.9275, 53.919716],
              [8.913887, 53.928604000000121],
              [8.899721, 53.940826000000129],
              [8.883055, 53.961105],
              [8.849998, 54.008888],
              [8.837221, 54.02833],
              [8.836111, 54.031105],
              [8.840555, 54.035271000000137],
              [8.846666, 54.038605000000132],
              [8.85417, 54.041107],
              [8.86611, 54.044167],
              [8.880833, 54.045273000000122],
              [8.890554, 54.044167],
              [8.926666, 54.03722],
              [8.945555000000127, 54.030548],
              [8.960554, 54.022217],
              [8.971109, 54.01778],
              [8.97889, 54.018608],
              [9.000555, 54.026108000000136],
              [9.003054, 54.02805],
              [9.01111, 54.043884000000105],
              [9.012777000000142, 54.049995],
              [9.017221, 54.084999],
              [8.971109, 54.131660000000124],
              [8.85861, 54.123886],
              [8.8475, 54.131104000000107],
              [8.844721000000106, 54.133049],
              [8.829721, 54.148048],
              [8.824999, 54.155273],
              [8.812777, 54.174995],
              [8.816387, 54.189995],
              [8.823332, 54.207222],
              [8.841389000000106, 54.250549],
              [8.842777, 54.253326],
              [8.845276, 54.255272000000105],
              [8.85305, 54.2575],
              [8.88361, 54.294167],
              [8.83, 54.29333],
              [8.695555, 54.270271],
              [8.694166, 54.26777600000014],
              [8.691111, 54.26611],
              [8.679998000000126, 54.26611],
              [8.669443, 54.26694],
              [8.655554, 54.269440000000145],
              [8.643610000000137, 54.273048],
              [8.631666, 54.27916],
              [8.611944, 54.30138],
              [8.60722, 54.308609],
              [8.603054, 54.316383],
              [8.60028, 54.324715],
              [8.59916, 54.330551],
              [8.599443, 54.333885],
              [8.62194, 54.378609],
              [8.633888, 54.392776],
              [8.63889, 54.39666],
              [8.646111000000133, 54.399162000000103],
              [8.650833, 54.399719],
              [8.76861, 54.410828],
              [8.823332, 54.41555],
              [8.828054, 54.41472],
              [8.831388, 54.41305],
              [8.837776000000133, 54.40666],
              [8.840555, 54.404999],
              [8.845833, 54.404442],
              [8.85555, 54.405548],
              [8.886944, 54.414162],
              [8.99472, 54.451942000000145],
              [9.004999, 54.46027400000014],
              [9.015, 54.471939],
              [9.01639, 54.474716000000114],
              [9.019444, 54.49305],
              [9.016943, 54.498329],
              [9.005554, 54.508606],
              [8.967777, 54.541107000000125],
              [8.960278, 54.543610000000115],
              [8.946943, 54.54639],
              [8.940277, 54.549438],
              [8.921665, 54.559441],
              [8.916111, 54.562775],
              [8.850832, 54.620827],
              [8.814165, 54.668327],
              [8.804998, 54.685555000000136],
              [8.75444, 54.711662],
              [8.734444, 54.721107],
              [8.696943, 54.746941],
              [8.655554, 54.80082700000014],
              [8.648611, 54.810272],
              [8.645555000000115, 54.814995],
              [8.64222100000012, 54.826385],
              [8.640554, 54.838051],
              [8.573443, 54.850273],
              [8.57728, 54.861107],
              [8.58055, 54.867878],
              [8.545610000000124, 54.870605],
              [8.39011, 54.86694],
              [8.3025, 54.859993],
              [8.30055, 54.857498],
              [8.298054, 54.848328],
              [8.294443, 54.82527],
              [8.292221, 54.789444000000117],
              [8.29361, 54.783607],
              [8.299999, 54.773888],
              [8.30055, 54.767494000000113],
              [8.29861, 54.740273000000116],
              [8.29833200000013, 54.738884],
              [8.28833, 54.737495],
              [8.282221000000106, 54.744164],
              [8.281111, 54.746941],
              [8.280554, 54.752777],
              [8.280554, 54.774994],
              [8.281387, 54.81805],
              [8.282776, 54.83527400000014],
              [8.291111, 54.894722],
              [8.295555, 54.906387],
              [8.30361, 54.926384],
              [8.310833000000116, 54.93972],
              [8.373333, 55.033333],
              [8.383055000000127, 55.045273000000122],
              [8.3933320000001, 55.053055],
              [8.405, 55.056664],
              [8.41111, 55.056389],
              [8.447222000000124, 55.053055],
              [8.459444000000133, 55.049721],
              [8.463055000000111, 55.04805],
              [8.438332, 55.024162],
              [8.421665000000132, 55.013054],
              [8.41028, 55.00944],
              [8.40111, 55.008049],
              [8.397499, 55.00666],
              [8.371944, 54.994164000000126],
              [8.35389, 54.973053],
              [8.3522210000001, 54.966942],
              [8.352777000000117, 54.95138500000013],
              [8.41663, 54.926727],
              [8.41846, 54.9179],
              [8.421297, 54.91356],
              [8.426464, 54.910229000000129],
              [8.430631, 54.908562],
              [8.456798, 54.900558],
              [8.465631, 54.899391],
              [8.490464, 54.900558],
              [8.598331, 54.9059],
              [8.602464, 54.91356],
              [8.602797000000123, 54.917725],
              [8.66454, 54.913094],
              [8.68611, 54.898888],
              [8.699444, 54.892776],
              [8.719444, 54.891106],
              [8.754721000000131, 54.897217],
              [8.763054, 54.898888],
              [8.785831, 54.9061],
              [8.82889, 54.913887000000102],
              [8.841301000000101, 54.913689],
              [8.919998000000135, 54.908051],
              [8.94111, 54.905548],
              [9.168888, 54.864998000000128],
              [9.22416, 54.853607],
              [9.23361, 54.845551000000114],
              [9.22805, 54.83416],
              [9.23361, 54.82444],
              [9.243055, 54.816383],
              [9.253611, 54.80888],
              [9.342777, 54.808609000000104],
              [9.358889, 54.812492],
              [9.36861, 54.820831],
              [9.368889, 54.82278],
              [9.378611, 54.829720000000123],
              [9.3925, 54.83527400000014],
              [9.414721, 54.833328],
              [9.445358, 54.825401],
              [9.441944, 54.819717],
              [9.437498, 54.80778],
              [9.43916, 54.80222],
              [9.5783330000001, 54.825554],
              [9.660555, 54.812218],
              [9.78555, 54.78611],
              [9.88972, 54.788887],
              [9.89639, 54.79166],
              [9.905832, 54.79277],
              [9.916666, 54.791107],
              [9.935833, 54.781944],
              [9.96194, 54.76861],
              [9.97278, 54.761108],
              [9.976665, 54.75666],
              [10.036943, 54.67115],
              [10.037777, 54.665321],
              [10.039999, 54.633072],
              [10.0325, 54.555275],
              [10.01083, 54.52888],
              [10.00639, 54.524719],
              [10.000323, 54.520866000000126],
              [9.970554, 54.5075],
              [9.89305, 54.481941],
              [9.871111, 54.477493],
              [9.849998, 54.479164],
              [9.845276, 54.478607],
              [9.843332, 54.476105],
              [9.843611, 54.473053],
              [9.85194, 54.464439],
              [9.863609, 54.457497],
              [9.870277, 54.45444],
              [9.878332, 54.452774],
              [9.89333, 54.453888],
              [10.006666, 54.474236],
              [10.101387, 54.48888],
              [10.110832, 54.489998000000128],
              [10.126944, 54.489716],
              [10.368332000000123, 54.43555],
              [10.60972, 54.360550000000103],
              [10.633055, 54.349998],
              [10.638887000000125, 54.34666],
              [10.643055, 54.34222],
              [10.646111, 54.337219],
              [10.652222, 54.330826000000116],
              [10.679165, 54.312492000000134],
              [10.685833, 54.309441000000106],
              [10.690554, 54.308327000000133],
              [10.706665, 54.30694],
              [10.765, 54.306664],
              [10.78, 54.307777000000101],
              [10.787777000000119, 54.309715],
              [10.802221, 54.314995000000124],
              [10.82111, 54.323608],
              [10.827499000000103, 54.326942],
              [10.835833, 54.332222000000115],
              [10.843054, 54.338608],
              [10.88528, 54.361938],
              [10.936666, 54.38361],
              [10.945833, 54.384995000000117],
              [10.95167, 54.384720000000129],
              [10.979443, 54.380554],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "GR",
        ISO2: "GR",
        ISO3: "GRC",
        UN: 300,
        NAME: "Greece",
        AREA: 12890,
        POP2005: 11099737,
        REGION: 150,
        SUBREGION: 39,
        LON: 21.766,
        LAT: 39.666,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [24.128609, 34.85666700000013],
              [24.128609, 34.808884],
              [24.119164000000126, 34.809166],
              [24.08333, 34.82444],
              [24.069443, 34.832497000000103],
              [24.062775000000101, 34.836662000000103],
              [24.04472, 34.849998],
              [24.044998, 34.85416],
              [24.074718, 34.868607],
              [24.10555, 34.865829],
              [24.12361, 34.86083200000013],
              [24.127777, 34.859161],
              [24.128609, 34.85666700000013],
            ],
          ],
          [
            [
              [26.900555, 35.358887],
              [26.880554, 35.34333],
              [26.85666700000013, 35.350555],
              [26.853333000000134, 35.35249],
              [26.85055, 35.357498],
              [26.84972, 35.372215],
              [26.898052, 35.42],
              [26.901665, 35.421661],
              [26.99694, 35.434441],
              [27.016109000000142, 35.432220000000143],
              [27.019997000000103, 35.430832],
              [26.998333, 35.40416],
              [26.964443, 35.392776],
              [26.900555, 35.358887],
            ],
          ],
          [
            [
              [23.858608, 35.52166],
              [23.971386000000109, 35.514717000000132],
              [23.99555, 35.515549],
              [24.038610000000119, 35.528717000000142],
              [24.042942, 35.530548000000124],
              [24.069611000000123, 35.54805],
              [24.071276, 35.549553],
              [24.071775000000116, 35.551552],
              [24.08333, 35.568054],
              [24.07888800000012, 35.573608],
              [24.0775, 35.57666],
              [24.07777, 35.580551],
              [24.079166, 35.583611000000133],
              [24.084999, 35.588333],
              [24.118053, 35.599998],
              [24.12611, 35.601944],
              [24.13528, 35.599998],
              [24.172222, 35.590553],
              [24.18055, 35.587219],
              [24.205276, 35.54277],
              [24.205276, 35.53889],
              [24.203888, 35.534996],
              [24.187222, 35.509995],
              [24.183887000000141, 35.508331],
              [24.169441, 35.502777],
              [24.161942, 35.50027],
              [24.140553, 35.503326],
              [24.128777, 35.49738],
              [24.11394, 35.498215],
              [24.111441, 35.497719],
              [24.109444, 35.496719],
              [24.106108, 35.493885],
              [24.103109, 35.49055],
              [24.102608, 35.488384],
              [24.103943, 35.48672],
              [24.105942, 35.48555],
              [24.174164, 35.453606],
              [24.183887000000141, 35.45111],
              [24.266109000000142, 35.36722],
              [24.271942000000138, 35.362495000000138],
              [24.285, 35.358604],
              [24.319721, 35.35166],
              [24.334442, 35.351105],
              [24.348053, 35.35166],
              [24.366108, 35.35305],
              [24.464722, 35.361938],
              [24.484165, 35.364716],
              [24.496666, 35.366661],
              [24.588608, 35.381104000000107],
              [24.600555, 35.38361],
              [24.60805, 35.386108],
              [24.61805, 35.39138800000012],
              [24.629444, 35.400551000000121],
              [24.78889, 35.408882],
              [24.963333, 35.404442],
              [25.04639, 35.383888],
              [25.04472, 35.37971],
              [25.045277, 35.369438000000116],
              [25.048611, 35.35583],
              [25.049999, 35.35278],
              [25.054996, 35.347771],
              [25.063889, 35.344719],
              [25.201385, 35.334442],
              [25.280552, 35.333885000000123],
              [25.302498, 35.335548],
              [25.363052, 35.33583],
              [25.377220000000136, 35.335548],
              [25.38749700000011, 35.333328],
              [25.390274, 35.33083],
              [25.39694, 35.315277],
              [25.40472, 35.30778],
              [25.429996, 35.294441],
              [25.445274, 35.29166],
              [25.46333, 35.292496],
              [25.491108, 35.298607000000118],
              [25.564442, 35.318604],
              [25.618053, 35.333328],
              [25.658054000000106, 35.3425],
              [25.662777, 35.3425],
              [25.7666660000001, 35.334717],
              [25.768887, 35.331940000000145],
              [25.767220000000123, 35.328049],
              [25.765274, 35.324715],
              [25.75777, 35.31611],
              [25.746109, 35.30722],
              [25.732777000000112, 35.300278],
              [25.73, 35.29805],
              [25.728333, 35.294167],
              [25.722775000000127, 35.263885],
              [25.728333, 35.259163],
              [25.73305, 35.257774],
              [25.737221, 35.2586060000001],
              [25.739441000000113, 35.26194],
              [25.741386, 35.269722],
              [25.741386, 35.2736],
              [25.742758, 35.286358],
              [25.754139000000123, 35.28257],
              [25.756208, 35.27118],
              [25.755173, 35.253593000000137],
              [25.739307, 35.23187],
              [25.71833, 35.219162],
              [25.71722, 35.214722],
              [25.71027800000013, 35.174438],
              [25.710831, 35.171104],
              [25.717499, 35.15916],
              [25.7280540000001, 35.14194],
              [25.75666, 35.126389000000131],
              [25.78, 35.115555],
              [25.788055, 35.112221],
              [25.797497, 35.1097180000001],
              [25.80805, 35.10805],
              [25.81583, 35.109993000000145],
              [25.82805, 35.11833],
              [25.866943, 35.152222],
              [25.896111, 35.176941],
              [26.02666, 35.224442],
              [26.030552, 35.22555],
              [26.039997, 35.225273000000129],
              [26.093052, 35.21666],
              [26.111942000000113, 35.205276],
              [26.217777, 35.24055],
              [26.301109, 35.28305],
              [26.29055, 35.131104],
              [26.275, 35.087494],
              [26.241943, 35.039719],
              [26.237499, 35.033607],
              [26.205555, 35.02166],
              [26.142498, 34.999161000000129],
              [26.138611000000139, 34.998055],
              [26.11972, 34.992775],
              [26.110832, 34.992218],
              [26.10611, 34.993332],
              [26.102776, 34.995552],
              [26.101109000000122, 35.00222],
              [26.101109000000122, 35.006104000000107],
              [26.09972, 35.009163],
              [26.095, 35.01416],
              [26.086666, 35.017494],
              [25.987499000000128, 35.033051],
              [25.59694, 35.009720000000129],
              [25.589443, 35.00722],
              [25.582222, 35.004440000000102],
              [25.560833, 34.996109],
              [25.557499, 34.994438000000116],
              [25.552219, 34.989441],
              [25.513332, 34.98194100000012],
              [25.50444, 34.981384],
              [25.33527800000013, 34.984993],
              [25.188053, 34.952217000000132],
              [25.016941, 34.93083],
              [24.928055, 34.93055],
              [24.82111, 34.937492],
              [24.752777, 34.94221],
              [24.75583, 34.95027],
              [24.762775, 35.015831],
              [24.759163, 35.033051],
              [24.7561070000001, 35.046661],
              [24.744164, 35.0711060000001],
              [24.739998, 35.076385],
              [24.723053, 35.09055],
              [24.698608, 35.096664],
              [24.69361, 35.096939],
              [24.685833000000116, 35.094994],
              [24.676941, 35.09416],
              [24.638611, 35.095276000000126],
              [24.588608, 35.096939],
              [24.565552, 35.098053],
              [24.560833, 35.103333],
              [24.547775, 35.119438],
              [24.535553, 35.135826],
              [24.526665, 35.142494],
              [24.399441, 35.18694],
              [24.385555, 35.190826000000129],
              [24.19666, 35.200272],
              [24.192219000000136, 35.200272],
              [24.139721, 35.199715],
              [24.10083, 35.197777],
              [24.070553, 35.190826000000129],
              [24.053333, 35.189995000000124],
              [24.04888, 35.189995000000124],
              [24.03833, 35.191109],
              [24.029442, 35.194160000000124],
              [24.026108, 35.19611],
              [23.946663, 35.221107],
              [23.89027, 35.23389],
              [23.824165, 35.246666],
              [23.81944, 35.24638],
              [23.702221, 35.233604],
              [23.694443, 35.23111],
              [23.681942000000106, 35.224442],
              [23.598331, 35.23055],
              [23.593609, 35.231941],
              [23.586666, 35.23583200000013],
              [23.521111, 35.288055],
              [23.519997000000103, 35.301941000000113],
              [23.569164, 35.526665],
              [23.582497, 35.569160000000124],
              [23.58388, 35.573051],
              [23.593887000000109, 35.59222],
              [23.606388, 35.613327],
              [23.608608, 35.61083],
              [23.609444, 35.607216000000108],
              [23.609722, 35.603607000000125],
              [23.609997, 35.567497],
              [23.613609, 35.52694],
              [23.616108, 35.520554000000118],
              [23.618332000000123, 35.51777600000014],
              [23.649166, 35.499718],
              [23.656944000000124, 35.496384],
              [23.666664, 35.496109000000104],
              [23.704441, 35.501938000000109],
              [23.718887, 35.5075],
              [23.724998, 35.511665],
              [23.727497, 35.514442000000145],
              [23.731941, 35.546104],
              [23.73028, 35.56316],
              [23.72694, 35.574715],
              [23.711388, 35.604164],
              [23.708054, 35.64416],
              [23.708332, 35.648331],
              [23.709442, 35.651939],
              [23.717220000000111, 35.66555],
              [23.738609, 35.68555],
              [23.741665000000125, 35.68777],
              [23.748608000000104, 35.686386],
              [23.77055, 35.671104000000128],
              [23.775555, 35.666107],
              [23.775276, 35.661942],
              [23.77277800000013, 35.659164],
              [23.76694, 35.648888],
              [23.76694, 35.645271],
              [23.772221, 35.613327],
              [23.781944, 35.564438],
              [23.784443, 35.554443000000106],
              [23.787498, 35.548332],
              [23.7925, 35.54333],
              [23.799721, 35.54028],
              [23.84361, 35.523888000000113],
              [23.848331, 35.522499],
              [23.858608, 35.52166],
            ],
          ],
          [
            [
              [27.157497, 35.445831000000112],
              [27.142220000000123, 35.399719],
              [27.121666000000118, 35.428604],
              [27.067497000000117, 35.592773],
              [27.066387, 35.596382],
              [27.06611, 35.604996],
              [27.067776, 35.60833],
              [27.12028, 35.666939000000127],
              [27.15833, 35.718887000000109],
              [27.162498000000141, 35.724716000000114],
              [27.163055, 35.728882],
              [27.158607, 35.746941000000106],
              [27.158607, 35.76944],
              [27.16, 35.79583],
              [27.213333, 35.825554000000125],
              [27.217220000000111, 35.826942],
              [27.22805, 35.82638500000013],
              [27.23139, 35.82444],
              [27.230831, 35.811104],
              [27.215553, 35.724716000000114],
              [27.212498, 35.718048000000124],
              [27.177498000000128, 35.601105],
              [27.202221, 35.47805],
              [27.16222, 35.45111],
              [27.157497, 35.445831000000112],
            ],
          ],
          [
            [
              [23.332222, 35.825272],
              [23.329998000000103, 35.822495000000117],
              [23.325554000000125, 35.82333],
              [23.298054, 35.8511],
              [23.29583, 35.853882],
              [23.278889000000106, 35.883888000000127],
              [23.27333, 35.896385000000123],
              [23.273052, 35.89999],
              [23.275833, 35.899162],
              [23.28083, 35.893883],
              [23.303333, 35.887497],
              [23.31416, 35.883331],
              [23.31778, 35.881386],
              [23.325832, 35.87221],
              [23.32917, 35.866104],
              [23.331944, 35.852219],
              [23.332222, 35.825272],
            ],
          ],
          [
            [
              [23.049442, 36.13694],
              [23.045830000000137, 36.135826],
              [23.040554, 36.136108],
              [22.997219, 36.141937],
              [22.988052, 36.146111000000133],
              [22.929996, 36.17805],
              [22.922775, 36.185829],
              [22.91222, 36.19944],
              [22.91111, 36.20277],
              [22.906387, 36.22583],
              [22.89583, 36.318329000000119],
              [22.895275, 36.325829],
              [22.926109, 36.377495],
              [22.929443, 36.379440000000102],
              [22.951664000000108, 36.386108],
              [22.958054, 36.381943],
              [22.95916, 36.378609],
              [22.95694, 36.377495],
              [22.97, 36.354164],
              [22.987778, 36.32499700000011],
              [22.989998, 36.32222],
              [23.005554000000132, 36.307495],
              [23.00972, 36.305832000000123],
              [23.02027500000014, 36.303886],
              [23.085552, 36.25944],
              [23.101387000000102, 36.248604000000114],
              [23.10722, 36.243889],
              [23.10833, 36.23694],
              [23.05722, 36.145],
              [23.049442, 36.13694],
            ],
          ],
          [
            [
              [25.83888, 36.34805],
              [25.778606, 36.345551],
              [25.767773, 36.346931],
              [25.73889, 36.354996000000142],
              [25.731667, 36.362778000000105],
              [25.730270000000132, 36.366096],
              [25.730270000000132, 36.36971],
              [25.733604000000128, 36.377495],
              [25.767220000000123, 36.40083],
              [25.771111, 36.40193],
              [25.798328, 36.389153000000135],
              [25.85693700000013, 36.358887],
              [25.85693700000013, 36.354996000000142],
              [25.854443, 36.352219],
              [25.851662, 36.349991000000102],
              [25.847775, 36.348885],
              [25.83888, 36.34805],
            ],
          ],
          [
            [
              [25.399162, 36.39444],
              [25.394722, 36.39444],
              [25.391663, 36.39666],
              [25.390831000000105, 36.403885000000116],
              [25.391388, 36.408051],
              [25.393887, 36.410828],
              [25.397778, 36.411942],
              [25.401665, 36.411942],
              [25.406666, 36.410553000000107],
              [25.41, 36.408333],
              [25.410275, 36.404709],
              [25.4086, 36.40083],
              [25.40611, 36.398041],
              [25.399162, 36.39444],
            ],
          ],
          [
            [
              [27.78666, 35.890549],
              [27.781387, 35.890274],
              [27.76861, 35.893608],
              [27.73305, 35.91111],
              [27.730274, 35.91333],
              [27.72861, 35.916664],
              [27.722221, 35.929718],
              [27.719166, 35.940826000000129],
              [27.721386000000109, 35.94944],
              [27.730831000000137, 35.97888],
              [27.740829000000133, 36.104439000000127],
              [27.719719, 36.1661],
              [27.788883000000112, 36.251656],
              [27.80305, 36.268326],
              [27.805832, 36.270554000000118],
              [27.876106, 36.31971],
              [27.895828, 36.332222],
              [27.909161, 36.339722],
              [28.068333, 36.404999],
              [28.107494, 36.41861],
              [28.207222000000115, 36.44249],
              [28.210831, 36.452492],
              [28.21277, 36.455544000000145],
              [28.21583, 36.457764000000111],
              [28.21917, 36.456940000000145],
              [28.22583, 36.453049],
              [28.23389, 36.441376],
              [28.238049, 36.431107],
              [28.206944, 36.343597],
              [28.186939, 36.29999],
              [28.141388, 36.210541],
              [28.12277, 36.185822000000144],
              [28.063606, 36.111931],
              [28.009163, 36.068886],
              [27.956661000000111, 36.044991],
              [27.945827, 36.034714000000122],
              [27.931664, 36.0186],
              [27.906109, 35.98805],
              [27.898888000000113, 35.975555],
              [27.89277600000014, 35.96083],
              [27.865555, 35.93222],
              [27.842777000000126, 35.913605000000132],
              [27.839443, 35.911659],
              [27.79972, 35.893326],
              [27.78666, 35.890549],
            ],
          ],
          [
            [
              [27.40027, 36.372498],
              [27.395554, 36.371666],
              [27.317776, 36.410828],
              [27.297497, 36.422211000000118],
              [27.29472, 36.424431000000141],
              [27.29583, 36.461098000000106],
              [27.297771, 36.464432000000102],
              [27.303055, 36.46916],
              [27.354443, 36.476662],
              [27.358887, 36.475548],
              [27.362221, 36.473610000000122],
              [27.44305, 36.41111],
              [27.445827000000122, 36.4086],
              [27.447495000000117, 36.40554],
              [27.44722, 36.401665],
              [27.438889, 36.39138800000012],
              [27.4175, 36.376656000000139],
              [27.413326, 36.37554],
              [27.40027, 36.372498],
            ],
          ],
          [
            [
              [25.457771, 36.33361],
              [25.447220000000129, 36.329163],
              [25.420267, 36.33901],
              [25.38485, 36.3446],
              [25.41944, 36.362488],
              [25.430054, 36.3968],
              [25.41607, 36.43036],
              [25.391371, 36.456924],
              [25.37055, 36.463608000000136],
              [25.369164, 36.46666],
              [25.368889, 36.470276000000126],
              [25.371941, 36.472488],
              [25.3825, 36.477219000000105],
              [25.400272, 36.474442],
              [25.421104, 36.469994],
              [25.427498, 36.465546],
              [25.45083, 36.446938],
              [25.453606, 36.44444],
              [25.48, 36.4161],
              [25.486382, 36.408051],
              [25.488888, 36.397774],
              [25.484997000000135, 36.359154000000103],
              [25.46917, 36.343323000000112],
              [25.457771, 36.33361],
            ],
          ],
          [
            [
              [26.342216, 36.506386],
              [26.31805, 36.50471],
              [26.312492, 36.50499],
              [26.304440000000113, 36.507767],
              [26.297218, 36.511101],
              [26.288609000000122, 36.518044],
              [26.286942, 36.52111],
              [26.270554, 36.556107000000111],
              [26.26221500000014, 36.576935],
              [26.259995000000117, 36.58416],
              [26.260830000000112, 36.58833],
              [26.262497, 36.59166],
              [26.26527, 36.593880000000127],
              [26.38028, 36.640266],
              [26.385551, 36.640549],
              [26.406109000000129, 36.63388],
              [26.409443000000124, 36.63221],
              [26.458328000000108, 36.600822],
              [26.460548000000131, 36.598053000000107],
              [26.472218, 36.579987000000131],
              [26.471104, 36.578331],
              [26.466660000000104, 36.576378],
              [26.405827, 36.565269],
              [26.35416, 36.51944],
              [26.35583, 36.51166],
              [26.35583, 36.508041],
              [26.342216, 36.506386],
            ],
          ],
          [
            [
              [27.854717, 36.527222],
              [27.840275, 36.524994000000106],
              [27.796661, 36.551941],
              [27.79055, 36.556107000000111],
              [27.764996, 36.574997],
              [27.768887, 36.585831],
              [27.812492, 36.628052000000139],
              [27.82694, 36.641388],
              [27.834438, 36.64444],
              [27.851109000000122, 36.649155],
              [27.85527, 36.650269],
              [27.859718, 36.650269],
              [27.865555, 36.641388],
              [27.866665, 36.637772],
              [27.872772, 36.61472],
              [27.876106, 36.59861],
              [27.876389000000131, 36.594437],
              [27.87527, 36.542763],
              [27.873882, 36.538879],
              [27.858051, 36.528885],
              [27.854717, 36.527222],
            ],
          ],
          [
            [
              [24.950275, 36.590553],
              [24.94555, 36.590553],
              [24.924442000000113, 36.59333],
              [24.915276, 36.596107],
              [24.85694100000012, 36.636383],
              [24.851387000000102, 36.64111],
              [24.8425, 36.651939],
              [24.841110000000128, 36.654999],
              [24.840832, 36.65888],
              [24.843887, 36.659721000000104],
              [24.85555, 36.661942],
              [24.85972, 36.662498],
              [24.868889000000138, 36.661385000000109],
              [24.938332, 36.632774],
              [24.95333, 36.62138],
              [24.954720000000123, 36.618332],
              [24.9625, 36.5991590000001],
              [24.961388000000113, 36.594719000000111],
              [24.958332, 36.592499],
              [24.950275, 36.590553],
            ],
          ],
          [
            [
              [25.089722, 36.63388],
              [25.07694, 36.63194],
              [25.06694, 36.63388],
              [25.063606, 36.63582],
              [25.063889, 36.639992],
              [25.102219, 36.69333],
              [25.141388, 36.715828000000101],
              [25.145828, 36.71666],
              [25.18777, 36.71666],
              [25.188332, 36.714722],
              [25.184166000000118, 36.705544],
              [25.156666, 36.675545],
              [25.13528, 36.660553],
              [25.119717, 36.650269],
              [25.099716, 36.639153],
              [25.089722, 36.63388],
            ],
          ],
          [
            [
              [21.785831000000144, 36.736938],
              [21.775, 36.69778],
              [21.76722, 36.701385],
              [21.750553000000139, 36.712494000000106],
              [21.748886, 36.715553],
              [21.748608, 36.719162],
              [21.74944, 36.722771],
              [21.757500000000107, 36.752495000000124],
              [21.760555000000124, 36.754997],
              [21.764442, 36.754997],
              [21.783333, 36.743332000000123],
              [21.785553, 36.740829000000133],
              [21.785831000000144, 36.736938],
            ],
          ],
          [
            [
              [24.413609, 36.660271000000137],
              [24.33083, 36.649994],
              [24.32694, 36.651108000000136],
              [24.324718, 36.652771],
              [24.32278, 36.659721000000104],
              [24.323055, 36.667496],
              [24.34055, 36.73305],
              [24.34389, 36.740829000000133],
              [24.349163, 36.746109],
              [24.352776, 36.747772000000111],
              [24.513332, 36.767494],
              [24.526943, 36.767494],
              [24.535831000000144, 36.764717],
              [24.548054, 36.759438000000102],
              [24.549442000000113, 36.75639],
              [24.550552, 36.700554],
              [24.548332, 36.691666],
              [24.544441, 36.684441],
              [24.54055, 36.677773],
              [24.53805, 36.674995],
              [24.53472, 36.67305],
              [24.476944, 36.662773],
              [24.413609, 36.660271000000137],
            ],
          ],
          [
            [
              [25.385551, 36.651665],
              [25.357777, 36.644997],
              [25.342773000000136, 36.651665],
              [25.339722000000108, 36.65416],
              [25.25861, 36.728882],
              [25.26194, 36.762772],
              [25.26416, 36.76638800000012],
              [25.275829, 36.781380000000127],
              [25.279160000000104, 36.783333],
              [25.30305, 36.789162],
              [25.308048, 36.788322],
              [25.326111000000139, 36.775826],
              [25.407219, 36.717766],
              [25.40833, 36.715271],
              [25.39222, 36.661110000000122],
              [25.389439, 36.652771],
              [25.385551, 36.651665],
            ],
          ],
          [
            [
              [24.662777000000119, 36.747498],
              [24.658607, 36.746666],
              [24.648609, 36.746941000000106],
              [24.628330000000119, 36.74944],
              [24.624996000000124, 36.751389],
              [24.62055, 36.756943],
              [24.609722, 36.778328],
              [24.611942, 36.781662],
              [24.619999, 36.78805],
              [24.62389, 36.789444],
              [24.64222, 36.788887000000102],
              [24.645554, 36.787498],
              [24.665276000000119, 36.776382000000126],
              [24.670277, 36.767494],
              [24.67083, 36.759995],
              [24.670277, 36.755829],
              [24.665833, 36.749718],
              [24.662777000000119, 36.747498],
            ],
          ],
          [
            [
              [21.698608, 36.739166],
              [21.693886, 36.73888],
              [21.69611, 36.772499],
              [21.699165, 36.785828],
              [21.704441, 36.796661],
              [21.70722, 36.799164],
              [21.728333, 36.79277],
              [21.728611000000114, 36.789162],
              [21.720554000000106, 36.770271],
              [21.718609000000129, 36.766937],
              [21.701111, 36.741943000000106],
              [21.698608, 36.739166],
            ],
          ],
          [
            [
              [24.558609000000104, 36.775551000000121],
              [24.549721, 36.774719],
              [24.544441, 36.775276000000133],
              [24.53805, 36.779716000000121],
              [24.53167, 36.787773000000129],
              [24.522221, 36.804993],
              [24.521111, 36.812218000000144],
              [24.521111, 36.823883],
              [24.522778, 36.827774],
              [24.559166, 36.848328],
              [24.562496, 36.848610000000122],
              [24.591942, 36.833885],
              [24.59916, 36.823883],
              [24.594997, 36.807777],
              [24.5925, 36.798882],
              [24.577774, 36.781662],
              [24.574718000000132, 36.779442],
              [24.558609000000104, 36.775551000000121],
            ],
          ],
          [
            [
              [25.459995, 36.82222],
              [25.45194, 36.820267],
              [25.432774, 36.820541000000105],
              [25.420277, 36.827766],
              [25.420830000000137, 36.83194],
              [25.422497, 36.835831],
              [25.4741590000001, 36.869164],
              [25.481384, 36.849152],
              [25.48333, 36.846931],
              [25.48333, 36.843323],
              [25.47944, 36.833611],
              [25.47694, 36.830826],
              [25.459995, 36.82222],
            ],
          ],
          [
            [
              [25.826664, 36.779709],
              [25.79444, 36.764153000000135],
              [25.769444, 36.764435],
              [25.761387000000127, 36.76722],
              [25.740273, 36.777771000000143],
              [25.736938000000123, 36.78443],
              [25.738605, 36.787491],
              [25.839439, 36.840546],
              [25.961941, 36.889435],
              [25.97666, 36.874161],
              [25.920551, 36.8361],
              [25.826664, 36.779709],
            ],
          ],
          [
            [
              [26.965832, 36.681664],
              [26.971386, 36.672211],
              [26.96666, 36.672493000000145],
              [26.953053, 36.675278],
              [26.946384000000137, 36.67915],
              [26.92305, 36.7061],
              [26.92083, 36.708878],
              [26.91861, 36.7161],
              [26.917770000000132, 36.755272],
              [26.921944, 36.761101],
              [27.060833000000116, 36.837212000000136],
              [27.064159000000132, 36.838875],
              [27.152493000000106, 36.881386],
              [27.168053, 36.887215],
              [27.177498000000128, 36.88888],
              [27.284443, 36.900551],
              [27.340549000000124, 36.88528],
              [27.346661, 36.881104],
              [27.352776000000119, 36.872208],
              [27.355553, 36.865273],
              [27.35527, 36.858887],
              [27.344166, 36.849442],
              [27.32944, 36.842766],
              [27.302498, 36.837494],
              [27.279442000000131, 36.83416],
              [27.243332, 36.82693],
              [27.218327, 36.8197100000001],
              [27.03611, 36.766106],
              [27.028049, 36.763611],
              [26.992222, 36.751389],
              [26.980553, 36.746941000000106],
              [26.97416, 36.742775],
              [26.971943000000124, 36.740273000000116],
              [26.970551, 36.736382],
              [26.96639, 36.70361],
              [26.965832, 36.681664],
            ],
          ],
          [
            [
              [25.680832, 36.878052],
              [25.672771, 36.876389000000131],
              [25.612778000000105, 36.88083],
              [25.609997, 36.883324],
              [25.60916, 36.886658],
              [25.614716, 36.891930000000116],
              [25.638882, 36.903328000000101],
              [25.651939, 36.906097],
              [25.668884, 36.899437],
              [25.671661, 36.89693],
              [25.683048, 36.883881],
              [25.68388, 36.880272],
              [25.680832, 36.878052],
            ],
          ],
          [
            [
              [25.076664000000108, 36.951935],
              [25.071663, 36.943871],
              [25.068886000000134, 36.946091],
              [25.027222, 36.981934],
              [25.024998, 36.984711000000118],
              [25.023605, 36.999146],
              [25.024162, 37.003319],
              [25.025829, 37.0072100000001],
              [25.034161, 37.014702],
              [25.05444, 37.03138],
              [25.057499, 37.0336],
              [25.06083, 37.035255],
              [25.079163000000108, 37.042480000000126],
              [25.083881, 37.042480000000126],
              [25.086941, 37.040543],
              [25.076664000000108, 36.951935],
            ],
          ],
          [
            [
              [24.711941, 36.903053000000114],
              [24.708054, 36.903053000000114],
              [24.695000000000107, 36.91555],
              [24.683052, 36.930275],
              [24.660275, 36.979721],
              [24.64, 37.029160000000104],
              [24.641109000000142, 37.042221],
              [24.649719, 37.04361],
              [24.661942000000124, 37.041382],
              [24.703053000000125, 37.029716],
              [24.70666, 37.027771],
              [24.740833, 36.99166],
              [24.74528, 36.986382],
              [24.765274, 36.958328],
              [24.766666, 36.955276],
              [24.76694, 36.95138],
              [24.76583, 36.946938000000102],
              [24.76111, 36.940826000000129],
              [24.73389, 36.918884],
              [24.724163, 36.91166],
              [24.711941, 36.903053000000114],
            ],
          ],
          [
            [
              [26.97555, 36.924431],
              [26.969719, 36.924431],
              [26.946384000000137, 36.928055],
              [26.935555000000136, 36.932213],
              [26.919167, 36.946663],
              [26.88194, 37.068886],
              [26.886662, 37.07332],
              [26.890831, 37.07638],
              [26.960548, 37.056107],
              [26.985828, 37.044167],
              [27.04832800000014, 36.993607],
              [27.049995, 36.99055],
              [27.049995, 36.949158000000125],
              [27.049438, 36.94611],
              [27.04583, 36.944153],
              [26.97555, 36.924431],
            ],
          ],
          [
            [
              [25.83444, 37.09304],
              [25.831944, 37.090271],
              [25.819443, 37.091385],
              [25.801662, 37.099442],
              [25.793884, 37.103043],
              [25.79055, 37.104996000000142],
              [25.783051, 37.116653],
              [25.78249, 37.119987],
              [25.785, 37.121384],
              [25.82555, 37.125542],
              [25.837215, 37.112488],
              [25.838608, 37.10944400000011],
              [25.836105, 37.096931],
              [25.83444, 37.09304],
            ],
          ],
          [
            [
              [25.250275, 37.008324],
              [25.191383, 36.973885],
              [25.165833, 36.979439],
              [25.152493, 36.98389],
              [25.123333, 36.994164000000126],
              [25.120274000000109, 36.996666],
              [25.10527, 37.011658],
              [25.0991590000001, 37.023888],
              [25.098328, 37.027489],
              [25.098885, 37.03138],
              [25.109997000000135, 37.057213],
              [25.132771000000105, 37.09332],
              [25.151382, 37.111931],
              [25.16333, 37.121666000000118],
              [25.22361, 37.140831],
              [25.2686, 37.138611],
              [25.284443, 37.128319],
              [25.26833, 37.052773],
              [25.26416, 37.039162],
              [25.250275, 37.008324],
            ],
          ],
          [
            [
              [26.886662, 37.096657000000107],
              [26.863888, 37.095276],
              [26.853886, 37.096657000000107],
              [26.849442, 37.097771],
              [26.820553, 37.11055],
              [26.769444, 37.169434],
              [26.768330000000105, 37.173325],
              [26.769161000000111, 37.176384],
              [26.778049, 37.187775],
              [26.780827000000102, 37.189995],
              [26.78555, 37.190819],
              [26.820553, 37.187218000000144],
              [26.855, 37.18277],
              [26.85833, 37.181107],
              [26.860554, 37.17722],
              [26.872498000000121, 37.150551],
              [26.888882, 37.109154000000103],
              [26.88972, 37.10166],
              [26.889164, 37.09861],
              [26.886662, 37.096657000000107],
            ],
          ],
          [
            [
              [25.461388, 36.919434],
              [25.45277, 36.918320000000108],
              [25.436939, 36.91999],
              [25.433331, 36.922211],
              [25.342773000000136, 37.07194],
              [25.341106, 37.075],
              [25.34666, 37.086388000000113],
              [25.349716000000114, 37.088608],
              [25.4961, 37.186378000000104],
              [25.503052, 37.189995],
              [25.50694, 37.191109],
              [25.535275000000127, 37.197777],
              [25.539444000000117, 37.198601],
              [25.54472, 37.198044],
              [25.54805, 37.19611],
              [25.565552, 37.180832],
              [25.576664, 37.16805],
              [25.583054, 37.159988],
              [25.59583, 37.135818],
              [25.600552, 37.118889],
              [25.600552, 37.11527],
              [25.59944, 37.106934],
              [25.59027, 37.057213],
              [25.587215000000128, 37.044167],
              [25.580273, 37.015549000000135],
              [25.556664, 36.957764],
              [25.554165, 36.954987000000131],
              [25.551105, 36.952766],
              [25.486382, 36.927773000000116],
              [25.461388, 36.919434],
            ],
          ],
          [
            [
              [24.535000000000139, 37.182495],
              [24.534164, 37.130554],
              [24.509163, 37.112778000000105],
              [24.501389, 37.11027],
              [24.494999000000121, 37.121666000000118],
              [24.492222, 37.12389],
              [24.460278, 37.135826],
              [24.45611, 37.136108],
              [24.43944, 37.132217],
              [24.433609, 37.127777],
              [24.42194400000011, 37.12389],
              [24.416943, 37.12444],
              [24.414719, 37.12722],
              [24.41528, 37.131104000000107],
              [24.421108, 37.156387],
              [24.430832000000123, 37.17139],
              [24.441944, 37.184166],
              [24.460278, 37.195831000000112],
              [24.479443, 37.201942],
              [24.492222, 37.202774],
              [24.515831, 37.201111],
              [24.531109, 37.19194],
              [24.533333, 37.189163000000121],
              [24.53472, 37.186104],
              [24.535000000000139, 37.182495],
            ],
          ],
          [
            [
              [26.767494, 37.186935],
              [26.763611, 37.185555],
              [26.759995, 37.186661],
              [26.76499600000011, 37.196663],
              [26.772221, 37.206657],
              [26.774998, 37.208878000000141],
              [26.779716, 37.209717000000126],
              [26.787495, 37.20694],
              [26.788609, 37.202209],
              [26.767494, 37.186935],
            ],
          ],
          [
            [
              [23.15667, 37.240273],
              [23.134998, 37.237221],
              [23.129719, 37.237495],
              [23.123333000000116, 37.241661000000136],
              [23.097775, 37.270828],
              [23.096107, 37.273888000000113],
              [23.096943000000124, 37.277496],
              [23.099442000000124, 37.278885],
              [23.115276, 37.28333],
              [23.119442, 37.28416],
              [23.125275, 37.28333],
              [23.134720000000129, 37.28],
              [23.150555, 37.27277400000014],
              [23.16027, 37.266388],
              [23.166111, 37.261665],
              [23.168331, 37.258888000000127],
              [23.166943000000117, 37.255829],
              [23.16222, 37.245552],
              [23.16027, 37.242218],
              [23.15667, 37.240273],
            ],
          ],
          [
            [
              [23.410831, 37.300827],
              [23.400276, 37.296104],
              [23.377777, 37.298607],
              [23.373886, 37.299721],
              [23.374443, 37.302498000000128],
              [23.385555, 37.31139],
              [23.388885, 37.313049],
              [23.4775, 37.352776000000119],
              [23.516109, 37.36472],
              [23.520554, 37.36555],
              [23.552498, 37.369438000000116],
              [23.561665, 37.368889000000138],
              [23.582497, 37.366104000000121],
              [23.583332, 37.36417],
              [23.575275, 37.356110000000115],
              [23.5, 37.316666],
              [23.496387, 37.315277],
              [23.44944, 37.313049],
              [23.414719000000105, 37.302216],
              [23.410831, 37.300827],
            ],
          ],
          [
            [
              [24.37944, 37.305832000000123],
              [24.374722, 37.30555],
              [24.37055, 37.30722],
              [24.367496, 37.309441000000106],
              [24.366665, 37.313049],
              [24.367496, 37.423607000000118],
              [24.36861, 37.427216],
              [24.371944, 37.433609000000104],
              [24.398609, 37.45916],
              [24.410275, 37.46833],
              [24.43861, 37.481941],
              [24.44278, 37.481667],
              [24.442497, 37.474716000000114],
              [24.440830000000119, 37.47083],
              [24.43055, 37.442215],
              [24.433331000000123, 37.43972],
              [24.445274, 37.431389],
              [24.463055000000111, 37.427498],
              [24.472221, 37.426941000000113],
              [24.48222, 37.408882],
              [24.483608, 37.40583],
              [24.48333, 37.398048000000131],
              [24.48167, 37.39388300000013],
              [24.44611, 37.351387000000102],
              [24.41639, 37.325554],
              [24.401665, 37.314163],
              [24.383331, 37.30694],
              [24.37944, 37.305832000000123],
            ],
          ],
          [
            [
              [25.359161, 37.40778],
              [25.3555530000001, 37.407219],
              [25.328053, 37.41776],
              [25.309998000000121, 37.469994],
              [25.309166, 37.473328],
              [25.310272, 37.481667],
              [25.313889, 37.488045],
              [25.331661, 37.495544],
              [25.349442, 37.501389],
              [25.401108, 37.493332000000123],
              [25.460548000000131, 37.472214],
              [25.463608, 37.469719],
              [25.463608, 37.46583],
              [25.462215, 37.449997],
              [25.461105, 37.446381],
              [25.457771, 37.44444],
              [25.371105, 37.410553],
              [25.359161, 37.40778],
            ],
          ],
          [
            [
              [24.952499, 37.385551000000135],
              [24.88444, 37.363609],
              [24.895275, 37.495277000000101],
              [24.89167, 37.497215],
              [24.889442, 37.500000000000114],
              [24.887775, 37.503052],
              [24.88694, 37.509995],
              [24.889721, 37.51249700000011],
              [24.909721, 37.509438000000102],
              [24.924999, 37.504997],
              [24.933331, 37.501389],
              [24.93972, 37.496384],
              [24.944164, 37.491104],
              [24.951111000000139, 37.475273],
              [24.971664, 37.406105],
              [24.9725, 37.402771],
              [24.969997, 37.399719],
              [24.95583, 37.38721],
              [24.952499, 37.385551000000135],
            ],
          ],
          [
            [
              [23.497776, 37.50471],
              [23.48389, 37.503883],
              [23.451942, 37.509163000000115],
              [23.44749800000011, 37.510826],
              [23.43305, 37.522774],
              [23.432777, 37.526665],
              [23.483608, 37.537773000000129],
              [23.518055, 37.525833],
              [23.5225, 37.524162],
              [23.523331, 37.520828],
              [23.515553000000125, 37.512772],
              [23.509720000000129, 37.508049000000142],
              [23.506386000000134, 37.506386],
              [23.497776, 37.50471],
            ],
          ],
          [
            [
              [25.228333, 37.534431],
              [25.205830000000105, 37.527222],
              [25.195827, 37.527489000000116],
              [25.168327, 37.532776],
              [25.113888, 37.551102],
              [24.994999, 37.639999],
              [24.97889, 37.662498],
              [24.975, 37.671944],
              [24.97583, 37.675552],
              [24.97972, 37.676666],
              [25.010551, 37.677498000000128],
              [25.04222, 37.676659],
              [25.053883, 37.67582],
              [25.07444, 37.652489],
              [25.083054, 37.649155],
              [25.137215, 37.644722],
              [25.184998, 37.641930000000116],
              [25.190552, 37.64111],
              [25.214165, 37.63221],
              [25.238888, 37.621941],
              [25.247498, 37.614441000000113],
              [25.250275, 37.611931],
              [25.25528, 37.591660000000104],
              [25.25555, 37.583878000000141],
              [25.254993, 37.579987],
              [25.231667, 37.536385],
              [25.228333, 37.534431],
            ],
          ],
          [
            [
              [24.29861, 37.526382],
              [24.285275, 37.524719],
              [24.279720000000111, 37.525551],
              [24.276943, 37.528053],
              [24.275276000000133, 37.531105000000139],
              [24.269165, 37.588882000000126],
              [24.269722000000115, 37.593048],
              [24.273609, 37.60833],
              [24.276108, 37.617218],
              [24.281666, 37.627777],
              [24.285831, 37.63472],
              [24.29833, 37.654999],
              [24.300831, 37.657776000000126],
              [24.327221, 37.677773],
              [24.334442, 37.680832000000123],
              [24.35083, 37.68222],
              [24.367222, 37.68222],
              [24.37028, 37.68222],
              [24.3941650000001, 37.673332],
              [24.41139, 37.654999],
              [24.41139, 37.651382],
              [24.397221, 37.619164000000126],
              [24.393055000000118, 37.612495],
              [24.381386, 37.596939],
              [24.371387, 37.585548000000131],
              [24.365833, 37.580551],
              [24.31472, 37.53611],
              [24.308887, 37.531662],
              [24.29861, 37.526382],
            ],
          ],
          [
            [
              [26.020828, 37.514435],
              [25.98416, 37.506943],
              [25.98083, 37.508881],
              [25.976944, 37.51499200000012],
              [25.975552, 37.5186],
              [25.974716000000114, 37.526932],
              [25.974716000000114, 37.53138],
              [25.981937, 37.544167],
              [25.98416, 37.54694400000011],
              [26.046944, 37.616379],
              [26.06444, 37.62999],
              [26.06805, 37.63194],
              [26.08083, 37.635544],
              [26.312492, 37.67999],
              [26.351383, 37.686378],
              [26.361111, 37.686661000000129],
              [26.361664000000133, 37.68333],
              [26.36055, 37.679436],
              [26.356937, 37.672493],
              [26.32333, 37.63472],
              [26.308331, 37.618889],
              [26.302498, 37.614441000000113],
              [26.267494000000113, 37.591103],
              [26.214993, 37.55888],
              [26.020828, 37.514435],
            ],
          ],
          [
            [
              [23.513054000000125, 37.691666],
              [23.486111, 37.677216000000101],
              [23.476387000000102, 37.679161],
              [23.464722, 37.68861],
              [23.431664, 37.733330000000137],
              [23.42388, 37.756386000000134],
              [23.423611, 37.75999],
              [23.425552, 37.762497],
              [23.428886, 37.764442],
              [23.465, 37.768051],
              [23.508053, 37.770271],
              [23.541664000000139, 37.770828000000108],
              [23.55722, 37.76722],
              [23.56389, 37.762772],
              [23.56472, 37.759438],
              [23.563332, 37.756386000000134],
              [23.558887, 37.75],
              [23.523609, 37.703606],
              [23.513054000000125, 37.691666],
            ],
          ],
          [
            [
              [27.06944, 37.711937],
              [27.064159000000132, 37.70694],
              [27.060555, 37.705269],
              [27.039719, 37.702766],
              [26.895554000000118, 37.665276],
              [26.81805, 37.636658],
              [26.753883, 37.691376],
              [26.746384, 37.694443],
              [26.711388000000113, 37.708321000000126],
              [26.705555000000118, 37.708321000000126],
              [26.686939000000109, 37.704987000000131],
              [26.649715, 37.698318],
              [26.641106, 37.696106],
              [26.62333, 37.687218],
              [26.620548, 37.684998],
              [26.613331, 37.680275],
              [26.59722, 37.67499],
              [26.593609000000129, 37.676941],
              [26.581661000000111, 37.685822],
              [26.580555, 37.688599],
              [26.571663000000115, 37.730553],
              [26.572777, 37.734154000000103],
              [26.59583, 37.7572100000001],
              [26.598885, 37.759438],
              [26.66555, 37.790543000000127],
              [26.66972, 37.791939],
              [26.729717, 37.808044],
              [26.743332000000123, 37.811104000000114],
              [26.748608, 37.811378],
              [26.988888, 37.781937],
              [27.028606000000138, 37.77166],
              [27.06694, 37.727219],
              [27.06944, 37.711937],
            ],
          ],
          [
            [
              [20.898052, 37.805275000000108],
              [20.992496000000131, 37.725273000000129],
              [20.99861, 37.713882],
              [20.994442, 37.698608],
              [20.943333, 37.71972],
              [20.924164000000133, 37.728607000000125],
              [20.915276000000119, 37.731667],
              [20.89583, 37.731110000000115],
              [20.87833, 37.728333],
              [20.87028, 37.726105],
              [20.866943, 37.72416],
              [20.84111, 37.687218],
              [20.839722000000108, 37.68333],
              [20.836109000000135, 37.646385000000123],
              [20.831108, 37.646385000000123],
              [20.812222, 37.651665],
              [20.808609000000104, 37.65361],
              [20.713608, 37.722771],
              [20.703331000000105, 37.732773],
              [20.629997000000117, 37.80888],
              [20.62722, 37.817497000000117],
              [20.619999000000121, 37.8475],
              [20.621944, 37.860832],
              [20.62861, 37.875549],
              [20.64333, 37.89833],
              [20.67833, 37.920555],
              [20.699718000000132, 37.930275],
              [20.702774, 37.92805],
              [20.79416700000013, 37.848885000000109],
              [20.863331, 37.829163],
              [20.886387000000127, 37.814438000000109],
              [20.898052, 37.805275000000108],
            ],
          ],
          [
            [
              [24.791664, 37.998329000000126],
              [24.962776, 37.872498],
              [24.998608, 37.767776],
              [24.998886, 37.76388500000013],
              [24.997219, 37.75999],
              [24.985832, 37.733604],
              [24.96027800000013, 37.685555000000136],
              [24.947498, 37.693054000000132],
              [24.916664000000139, 37.715553],
              [24.914444000000117, 37.718048],
              [24.873055, 37.76638800000012],
              [24.830555, 37.814438000000109],
              [24.768608, 37.871109],
              [24.765553, 37.873604],
              [24.752777, 37.87833],
              [24.736942000000113, 37.881104],
              [24.716942, 37.873329],
              [24.71333, 37.872772],
              [24.69361, 37.926941],
              [24.69028, 37.95138500000013],
              [24.690552000000139, 37.955551],
              [24.692219, 37.959442000000138],
              [24.69694, 37.965828],
              [24.703331, 37.969719000000111],
              [24.743889, 37.99055],
              [24.778053000000114, 37.996941],
              [24.791664, 37.998329000000126],
            ],
          ],
          [
            [
              [23.462498, 37.87861],
              [23.45833, 37.877777],
              [23.448055, 37.87944],
              [23.409164, 37.893326000000116],
              [23.405552000000114, 37.895271],
              [23.40361, 37.906944000000124],
              [23.410275, 37.929161],
              [23.437496000000124, 37.98583200000013],
              [23.484997, 37.999443],
              [23.49361, 38.000832000000116],
              [23.50111, 37.999161],
              [23.50611, 37.998055],
              [23.519444, 37.994995000000131],
              [23.524441, 37.993607],
              [23.538887, 37.98583200000013],
              [23.54055, 37.982773],
              [23.547222, 37.931938000000116],
              [23.54611, 37.929718],
              [23.540276, 37.920555],
              [23.53722, 37.918053],
              [23.469444000000124, 37.882217],
              [23.462498, 37.87861],
            ],
          ],
          [
            [
              [20.612499, 38.39416],
              [20.68055, 38.2775],
              [20.811665, 38.121384],
              [20.813332000000116, 38.118332],
              [20.81361, 38.114441],
              [20.811943, 38.105553],
              [20.796665, 38.066666],
              [20.7925, 38.060272],
              [20.78805, 38.059441],
              [20.734997, 38.060829],
              [20.557777, 38.090553],
              [20.51722, 38.10249],
              [20.512775, 38.103882],
              [20.377777, 38.156662],
              [20.344444000000124, 38.174995],
              [20.34139, 38.17722],
              [20.34, 38.184441],
              [20.340832, 38.196938],
              [20.34222, 38.200829000000113],
              [20.356110000000115, 38.231941],
              [20.398609, 38.325554000000125],
              [20.44083, 38.32805],
              [20.442776, 38.324997],
              [20.47361, 38.309166],
              [20.478611, 38.308052],
              [20.483608, 38.308327000000133],
              [20.487221, 38.309715],
              [20.500553, 38.317215],
              [20.507221, 38.32111],
              [20.516388, 38.32777],
              [20.53639, 38.344719000000111],
              [20.54472, 38.3575],
              [20.546665, 38.361107],
              [20.547497, 38.36472],
              [20.550552, 38.387772],
              [20.547775000000115, 38.39416],
              [20.539719, 38.409439],
              [20.534443000000124, 38.43278],
              [20.533886, 38.436661],
              [20.536942000000124, 38.467773],
              [20.539165, 38.470551000000114],
              [20.543053, 38.471939],
              [20.548332, 38.471939],
              [20.562222000000133, 38.471107],
              [20.57111, 38.468048000000124],
              [20.612499, 38.39416],
            ],
          ],
          [
            [
              [20.735554, 38.309998],
              [20.719719, 38.305275],
              [20.714722, 38.306389],
              [20.707222, 38.309998],
              [20.699444, 38.317497],
              [20.67083, 38.35305],
              [20.644722, 38.398048],
              [20.61555, 38.462494000000106],
              [20.61333100000013, 38.469162],
              [20.614166000000125, 38.47361],
              [20.648888000000113, 38.500275000000101],
              [20.65667, 38.501106000000107],
              [20.671108, 38.493332000000123],
              [20.706387, 38.444717],
              [20.708054, 38.44194],
              [20.743332, 38.372498000000121],
              [20.761108, 38.325272],
              [20.760277, 38.321663],
              [20.735554, 38.309998],
            ],
          ],
          [
            [
              [26.025555000000111, 38.17694],
              [26.014721, 38.14944],
              [25.996105, 38.15527],
              [25.971661, 38.163605],
              [25.964722, 38.167496],
              [25.924995, 38.19471],
              [25.86416, 38.238319],
              [25.862495, 38.241379],
              [25.862495, 38.246101000000124],
              [25.864441, 38.253876],
              [25.869164000000126, 38.26388],
              [25.873882, 38.26944],
              [25.906384, 38.290276000000119],
              [25.9180530000001, 38.294716],
              [25.93666, 38.297211],
              [25.942493, 38.297211],
              [25.991665, 38.343880000000127],
              [25.989716, 38.375275],
              [25.989162, 38.38388],
              [25.988049, 38.387497],
              [25.945827, 38.455269],
              [25.939442, 38.45943],
              [25.91666, 38.468323000000112],
              [25.907776000000126, 38.470551000000114],
              [25.89222, 38.471931],
              [25.888054, 38.47361],
              [25.88166, 38.47778],
              [25.860828, 38.493889],
              [25.851944, 38.500832],
              [25.845833, 38.509438000000102],
              [25.827221, 38.53611],
              [25.82555, 38.539444],
              [25.824997, 38.54361],
              [25.843609000000129, 38.570541000000105],
              [25.851109, 38.578049000000135],
              [25.861664, 38.583611],
              [25.869999000000121, 38.586388],
              [25.88472, 38.588875],
              [26.001389, 38.601379],
              [26.138611000000139, 38.564995],
              [26.150829000000101, 38.556107],
              [26.157776, 38.547768],
              [26.159443, 38.544434],
              [26.160553, 38.538048000000117],
              [26.13888, 38.431664],
              [26.13361, 38.417496],
              [26.133327, 38.408333],
              [26.146111, 38.363602],
              [26.161385000000109, 38.329163],
              [26.163052, 38.326111],
              [26.16111, 38.305275],
              [26.160275, 38.30138],
              [26.10222, 38.246941],
              [26.035553000000107, 38.191933],
              [26.027222, 38.18027],
              [26.025555000000111, 38.17694],
            ],
          ],
          [
            [
              [20.903053, 38.545555],
              [20.899441, 38.54417],
              [20.89611, 38.545273],
              [20.899166, 38.56638],
              [20.914165, 38.583328000000108],
              [20.935833, 38.60416],
              [20.938889, 38.605270000000132],
              [20.94139, 38.602493],
              [20.939999, 38.59389],
              [20.903053, 38.545555],
            ],
          ],
          [
            [
              [25.599995, 38.531937],
              [25.561939, 38.530823],
              [25.527222000000108, 38.592766],
              [25.527222000000108, 38.596375000000137],
              [25.52916, 38.599709000000132],
              [25.53194, 38.601944000000117],
              [25.56611, 38.60833],
              [25.591942, 38.600822],
              [25.61055, 38.592499],
              [25.613331, 38.589989],
              [25.61694, 38.583611],
              [25.620274, 38.577209],
              [25.609997, 38.542496],
              [25.608887, 38.538879000000122],
              [25.60722, 38.535553000000107],
              [25.60416, 38.533333],
              [25.599995, 38.531937],
            ],
          ],
          [
            [
              [20.643608, 38.581108],
              [20.543610000000115, 38.564438],
              [20.542774, 38.56777],
              [20.542221, 38.58833],
              [20.557777, 38.683884],
              [20.559166, 38.688049],
              [20.601665000000139, 38.778885],
              [20.64305, 38.826942000000145],
              [20.648331, 38.832222],
              [20.655552000000114, 38.835548],
              [20.701385, 38.834717],
              [20.709721, 38.832222],
              [20.715832, 38.827774],
              [20.729443, 38.807495000000131],
              [20.730000000000132, 38.803886],
              [20.72416, 38.634995],
              [20.72305, 38.626389000000131],
              [20.72055, 38.623604000000114],
              [20.643608, 38.581108],
            ],
          ],
          [
            [
              [24.683052, 38.79805],
              [24.683609, 38.779716],
              [24.680832, 38.776939],
              [24.65916, 38.767494000000113],
              [24.646942000000138, 38.764160000000118],
              [24.626389, 38.765274],
              [24.62055, 38.766388],
              [24.616943000000106, 38.768326],
              [24.612499000000128, 38.773605],
              [24.60472, 38.78527],
              [24.598053, 38.78972],
              [24.592777, 38.789993],
              [24.57111, 38.780548],
              [24.56694, 38.773605],
              [24.56694, 38.769997000000103],
              [24.568886, 38.760826000000122],
              [24.553333, 38.768326],
              [24.53472, 38.78361],
              [24.456665, 38.880829000000119],
              [24.45027, 38.896942000000138],
              [24.449718, 38.946938],
              [24.450832, 38.950554000000125],
              [24.45277, 38.95388800000012],
              [24.45833, 38.962776],
              [24.46083, 38.965553],
              [24.477219, 38.97555],
              [24.480831, 38.977219],
              [24.48472, 38.978607],
              [24.489998, 38.97805],
              [24.502499, 38.972771],
              [24.50611, 38.970833],
              [24.577499, 38.926109],
              [24.66555, 38.824165],
              [24.67916, 38.807495000000131],
              [24.681389000000138, 38.804718],
              [24.683052, 38.79805],
            ],
          ],
          [
            [
              [23.46194, 38.853333],
              [23.471386, 38.8425],
              [23.516109, 38.811386],
              [23.591942000000131, 38.764717],
              [23.765274, 38.706665],
              [23.84666, 38.68222],
              [23.946663, 38.662773],
              [23.951111000000139, 38.66333],
              [24.0075, 38.67305],
              [24.153889, 38.64666],
              [24.15361, 38.573326000000122],
              [24.187222, 38.392494000000113],
              [24.247219, 38.231941],
              [24.25722, 38.217773000000136],
              [24.25944, 38.214996],
              [24.269165, 38.204437],
              [24.299164, 38.189995],
              [24.334721, 38.160271],
              [24.338886, 38.158607],
              [24.427776, 38.144165],
              [24.460552, 38.13888500000013],
              [24.465832, 38.138329],
              [24.47583, 38.138054000000125],
              [24.553886, 38.141106],
              [24.568607, 38.147499],
              [24.590553000000114, 38.064163],
              [24.590832, 38.060272],
              [24.589443, 38.04805],
              [24.588333, 38.039719000000105],
              [24.587219000000118, 38.03166],
              [24.586109, 38.027222000000108],
              [24.57583, 38.004166000000112],
              [24.564163, 37.98722],
              [24.516941, 37.95611],
              [24.513332, 37.95416],
              [24.504444, 37.953331],
              [24.483055, 37.955551],
              [24.47805, 37.95694],
              [24.387218000000132, 37.993607],
              [24.32611, 38.044716],
              [24.208611, 38.156662],
              [24.148609000000135, 38.215271],
              [24.11083200000013, 38.28833],
              [24.049999000000128, 38.365829],
              [24.056942000000106, 38.373886],
              [24.059166, 38.37722],
              [24.058887, 38.381104],
              [24.05722, 38.384163],
              [24.049721, 38.391937],
              [24.04472, 38.393051],
              [24.000000000000114, 38.401665],
              [23.99472, 38.401939],
              [23.9780540000001, 38.392494000000113],
              [23.970554, 38.38944],
              [23.938332000000116, 38.386665000000107],
              [23.905277, 38.384995000000117],
              [23.80583, 38.389160000000118],
              [23.773331, 38.39222],
              [23.673332, 38.41],
              [23.64222, 38.418884000000105],
              [23.61694, 38.452217000000132],
              [23.61805, 38.470551000000114],
              [23.621387000000141, 38.472496],
              [23.626389000000131, 38.478333],
              [23.63694, 38.503052],
              [23.63749700000011, 38.507217],
              [23.631943, 38.525276000000133],
              [23.625832, 38.541664],
              [23.623608, 38.544441],
              [23.59861, 38.570000000000107],
              [23.595554, 38.572495000000117],
              [23.492222, 38.632217],
              [23.33138700000012, 38.742493],
              [23.2, 38.830826],
              [23.19611, 38.832771],
              [23.1575, 38.847496],
              [23.148052, 38.850273],
              [23.137218, 38.852219000000105],
              [23.132774, 38.85166],
              [23.128887000000134, 38.850273],
              [23.125832000000116, 38.848053],
              [23.118053, 38.845276],
              [23.098053000000107, 38.839439],
              [22.833054000000118, 38.823051],
              [22.830276, 38.82527],
              [22.829998, 38.829163],
              [22.832497, 38.83749],
              [22.837776, 38.848885000000109],
              [22.844997, 38.861382000000106],
              [22.84889, 38.862778000000105],
              [22.929996, 38.891663],
              [23.09666, 38.9836],
              [23.129719, 39.003326],
              [23.279442, 39.036659],
              [23.2925, 39.03889],
              [23.29972, 39.038605000000132],
              [23.310555, 39.036659],
              [23.314999, 39.034996],
              [23.370831, 39.0075],
              [23.374722, 39.00555],
              [23.376942, 39.002777],
              [23.377777, 38.999443],
              [23.376663, 38.99472],
              [23.374722, 38.991386],
              [23.374165, 38.984161],
              [23.375832, 38.977219],
              [23.37861, 38.970833],
              [23.446388, 38.872498],
              [23.46194, 38.853333],
            ],
          ],
          [
            [
              [23.736664, 39.074715],
              [23.724442, 39.071388],
              [23.709442, 39.073883000000137],
              [23.662777000000119, 39.086105],
              [23.657776, 39.092773],
              [23.59083, 39.197495],
              [23.589996, 39.200829],
              [23.59083, 39.20444],
              [23.593887000000109, 39.206665],
              [23.598331, 39.207497],
              [23.610832, 39.204994],
              [23.783054, 39.126106],
              [23.786663, 39.124161],
              [23.78889, 39.12138],
              [23.789165, 39.117775],
              [23.787777, 39.114166],
              [23.775276, 39.099442000000124],
              [23.77027500000014, 39.093605000000139],
              [23.753887, 39.083611000000133],
              [23.736664, 39.074715],
            ],
          ],
          [
            [
              [23.50861, 39.159721],
              [23.455830000000105, 39.13],
              [23.3975, 39.14388300000013],
              [23.393608, 39.144997000000103],
              [23.392498, 39.152222],
              [23.393887, 39.16],
              [23.395832, 39.16333],
              [23.444443, 39.198883],
              [23.461388, 39.208328],
              [23.47166, 39.208054000000118],
              [23.486942, 39.20527600000014],
              [23.489998, 39.203049],
              [23.501389, 39.193329],
              [23.506664, 39.188332],
              [23.509998, 39.18222],
              [23.51194, 39.17555],
              [23.512218, 39.171661],
              [23.510555000000124, 39.16305],
              [23.50861, 39.159721],
            ],
          ],
          [
            [
              [20.198330000000112, 39.17444],
              [20.17805, 39.174164],
              [20.16555, 39.177498],
              [20.162777000000119, 39.179443],
              [20.136665, 39.200554],
              [20.124165000000119, 39.221382000000119],
              [20.122776000000101, 39.232773],
              [20.123608, 39.236382000000106],
              [20.133331, 39.239441],
              [20.13749700000011, 39.240273],
              [20.165, 39.222496],
              [20.187496, 39.203049],
              [20.19944, 39.186386],
              [20.202221, 39.17582700000014],
              [20.198330000000112, 39.17444],
            ],
          ],
          [
            [
              [23.862499, 39.136665000000107],
              [23.855553, 39.133049],
              [23.85139, 39.134720000000129],
              [23.836109, 39.141663000000108],
              [23.83361, 39.148048000000131],
              [23.834164000000101, 39.152222],
              [23.92361, 39.260277],
              [23.949165, 39.28916],
              [23.953609, 39.289719],
              [23.95666, 39.287498000000141],
              [23.95666, 39.284996],
              [23.978611, 39.267776],
              [23.979443000000117, 39.26416],
              [23.9780540000001, 39.260277],
              [23.921665, 39.178604],
              [23.904442, 39.163605],
              [23.862499, 39.136665000000107],
            ],
          ],
          [
            [
              [26.37722, 39.273598],
              [26.377773, 39.26944],
              [26.379993, 39.266663],
              [26.383327, 39.26471],
              [26.405, 39.253876],
              [26.474716, 39.21944],
              [26.528332, 39.154160000000104],
              [26.606667, 39.053322],
              [26.61222, 39.044167],
              [26.618332, 39.026108000000136],
              [26.618889000000138, 39.02193],
              [26.61694, 39.015266000000111],
              [26.614441, 39.012497],
              [26.525272, 38.974152],
              [26.51833, 38.972488],
              [26.450554000000125, 38.968323],
              [26.39027, 38.9711],
              [26.323887000000127, 38.977776],
              [26.187492000000134, 39.017220000000123],
              [26.136387000000127, 39.040276],
              [26.089165, 39.07222],
              [26.086941, 39.07499700000011],
              [26.08861, 39.078049],
              [26.107777000000112, 39.090828],
              [26.112495, 39.09166],
              [26.117222, 39.090828],
              [26.167500000000132, 39.102776000000119],
              [26.276939, 39.156380000000127],
              [26.286110000000122, 39.16776],
              [26.29277, 39.176384],
              [26.293327, 39.18055],
              [26.292217, 39.184166],
              [26.286942, 39.189438000000109],
              [26.261662, 39.202492],
              [26.252499, 39.204430000000116],
              [26.24055, 39.204430000000116],
              [26.235271000000125, 39.204163],
              [26.199162000000115, 39.20111],
              [26.172497, 39.19471],
              [26.16528, 39.19111],
              [26.16111, 39.184998000000121],
              [26.157776, 39.16916700000013],
              [26.153606, 39.1586],
              [26.112221, 39.11222],
              [26.109718, 39.10971],
              [26.084721, 39.089722],
              [26.077496, 39.086098],
              [26.06805, 39.084435],
              [26.062775, 39.084717],
              [26.045277, 39.089432],
              [25.988106, 39.105164],
              [25.889996, 39.141106],
              [25.86416, 39.153603],
              [25.83666, 39.178055],
              [25.833881, 39.18055],
              [25.832222000000115, 39.1836],
              [25.854717000000107, 39.250000000000114],
              [25.856384, 39.253052],
              [25.861938, 39.258041],
              [25.880276, 39.271111000000133],
              [25.907776000000126, 39.286942000000124],
              [25.92388, 39.291939],
              [25.921944, 39.284157000000107],
              [25.922497, 39.28],
              [25.924721, 39.277222],
              [25.928883, 39.275826],
              [25.95027, 39.273888],
              [25.97861, 39.271935],
              [25.98444400000011, 39.271660000000111],
              [26.169167, 39.323601],
              [26.172771, 39.325554000000125],
              [26.175831, 39.327766],
              [26.17639, 39.33194],
              [26.170830000000137, 39.345551],
              [26.16499, 39.367775000000108],
              [26.165833, 39.371941],
              [26.178329000000133, 39.37498],
              [26.221661, 39.383041],
              [26.22749, 39.383041],
              [26.323887000000127, 39.37443],
              [26.396111000000133, 39.341103],
              [26.419994, 39.32583],
              [26.414719, 39.32249],
              [26.395, 39.305832],
              [26.392494, 39.30305],
              [26.379719, 39.285271],
              [26.37722, 39.273598],
            ],
          ],
          [
            [
              [24.992496, 39.466385],
              [24.98889, 39.464722],
              [24.985832, 39.466110000000128],
              [24.979443, 39.478607000000125],
              [24.97639, 39.484718],
              [24.969719, 39.508049],
              [24.971386000000109, 39.51666],
              [24.976665, 39.533333],
              [24.978333, 39.537216],
              [24.995831000000123, 39.55888],
              [25.000000000000114, 39.561722],
              [25.001942, 39.562752],
              [25.006386, 39.56331],
              [25.01527, 39.560814000000107],
              [25.027222, 39.556084000000112],
              [25.044994, 39.545815],
              [25.052498, 39.537766],
              [25.053608000000111, 39.530823],
              [25.04972, 39.523315],
              [25.03138, 39.50359],
              [24.992496, 39.466385],
            ],
          ],
          [
            [
              [19.926109, 39.794441],
              [19.94694, 39.783607000000131],
              [19.95055, 39.774437],
              [19.95055, 39.76221],
              [19.94278, 39.744164000000126],
              [19.929165, 39.73111],
              [19.92639, 39.728607],
              [19.91611, 39.722771],
              [19.91222, 39.721382],
              [19.875553, 39.71611],
              [19.848888, 39.705826],
              [19.842499, 39.70277],
              [19.839996, 39.699997],
              [19.83861, 39.695831],
              [19.839443, 39.67638],
              [19.846664, 39.649162],
              [19.927776, 39.477219],
              [19.931942000000106, 39.47166],
              [20.018055, 39.434441],
              [20.027775, 39.431938],
              [20.03278, 39.43222],
              [20.048054, 39.436943],
              [20.057499, 39.44221],
              [20.063332, 39.44722],
              [20.067497, 39.453606],
              [20.071663, 39.453606],
              [20.07472, 39.451385],
              [20.121666000000118, 39.377777],
              [20.122219, 39.373886],
              [20.120277000000101, 39.370552],
              [20.114998000000128, 39.364998],
              [20.111664000000133, 39.36305],
              [20.079720000000123, 39.368332],
              [19.88416, 39.444443],
              [19.880276, 39.446388000000127],
              [19.87527, 39.45166],
              [19.854721, 39.483887],
              [19.85305, 39.486938],
              [19.85083, 39.49389],
              [19.846943, 39.519722000000115],
              [19.84722, 39.535828],
              [19.84972, 39.54277],
              [19.84417, 39.55194],
              [19.823330000000112, 39.57611],
              [19.818333, 39.581383],
              [19.806389000000138, 39.590553000000114],
              [19.740276, 39.624718],
              [19.675831, 39.674721],
              [19.673332, 39.677216],
              [19.641388, 39.744438],
              [19.639999000000103, 39.75666],
              [19.65083, 39.7725],
              [19.67305, 39.7930530000001],
              [19.692219000000136, 39.794998],
              [19.696941, 39.794441],
              [19.791664, 39.790276],
              [19.796665, 39.79055000000011],
              [19.80389, 39.793884000000105],
              [19.855, 39.81833],
              [19.864998, 39.81694],
              [19.926109, 39.794441],
            ],
          ],
          [
            [
              [19.404163, 39.843605],
              [19.39361, 39.838333],
              [19.388054000000125, 39.838608],
              [19.384163, 39.840271],
              [19.377777, 39.844719],
              [19.37611, 39.847771],
              [19.377777, 39.865555],
              [19.37889, 39.868607000000111],
              [19.381664, 39.871109],
              [19.4225, 39.870277000000101],
              [19.42778, 39.869995],
              [19.430553, 39.867493000000138],
              [19.428608, 39.86388],
              [19.404163, 39.843605],
            ],
          ],
          [
            [
              [25.44167, 40.00471],
              [25.39194, 39.952209],
              [25.356667, 39.910553000000107],
              [25.351662, 39.90416],
              [25.338055, 39.879990000000134],
              [25.336388000000113, 39.876099],
              [25.33833, 39.850822000000107],
              [25.339722000000108, 39.847771],
              [25.348885000000109, 39.836937],
              [25.351944, 39.83443],
              [25.3555530000001, 39.8325],
              [25.365273, 39.825554],
              [25.373608, 39.814438],
              [25.372498, 39.810822],
              [25.355827, 39.786385000000109],
              [25.338882, 39.788879],
              [25.317776, 39.793877],
              [25.308331, 39.796944],
              [25.30083100000013, 39.800819],
              [25.29416700000013, 39.805275],
              [25.29194, 39.808044],
              [25.266937, 39.86805],
              [25.27833, 39.888878],
              [25.279442, 39.892487000000131],
              [25.279160000000104, 39.896378],
              [25.26777, 39.909988],
              [25.264996, 39.91221],
              [25.259720000000129, 39.913605],
              [25.239716, 39.913879000000122],
              [25.235271000000125, 39.913048000000117],
              [25.228611000000114, 39.909157],
              [25.213608, 39.896935],
              [25.207771, 39.889153000000135],
              [25.18194, 39.854713],
              [25.178608, 39.846657000000107],
              [25.178608, 39.84304],
              [25.201664, 39.827492],
              [25.221943000000124, 39.810555000000136],
              [25.227219, 39.805275],
              [25.22666, 39.80138],
              [25.22305, 39.799431],
              [25.168327, 39.799721],
              [25.16249, 39.800819],
              [25.06694, 39.8425],
              [25.06083, 39.848053],
              [25.05444, 39.86055],
              [25.043053, 39.963326000000109],
              [25.045277, 39.983597],
              [25.049995, 39.989716000000101],
              [25.1325, 40.005272],
              [25.1402700000001, 40.006653000000142],
              [25.22666, 40.003052],
              [25.23193700000013, 40.002495],
              [25.27194, 39.988319],
              [25.368607, 40.00583],
              [25.447777, 40.0336],
              [25.451382, 40.033875],
              [25.453606, 40.03138],
              [25.445553, 40.00972],
              [25.44167, 40.00471],
            ],
          ],
          [
            [
              [25.60166, 40.398041],
              [25.566383, 40.39777400000014],
              [25.557499, 40.40137],
              [25.515831, 40.422493],
              [25.490273, 40.436935],
              [25.464165, 40.454987000000131],
              [25.460831, 40.457764],
              [25.44389, 40.475822],
              [25.494164000000126, 40.49638],
              [25.525555, 40.506943],
              [25.542770000000132, 40.510544],
              [25.55583, 40.511658],
              [25.571384000000137, 40.5113750000001],
              [25.57944, 40.509995000000117],
              [25.657219000000111, 40.49305],
              [25.69027, 40.471375],
              [25.694717000000139, 40.466103],
              [25.695553, 40.462494],
              [25.69611, 40.428322],
              [25.695000000000107, 40.424721],
              [25.69194, 40.422493],
              [25.66, 40.412491000000102],
              [25.606110000000115, 40.398598000000106],
              [25.60166, 40.398041],
            ],
          ],
          [
            [
              [24.773331, 40.631660000000124],
              [24.766388, 40.611382000000106],
              [24.671108, 40.578888],
              [24.64361, 40.570831],
              [24.642776, 40.574165],
              [24.638885, 40.579994],
              [24.601665, 40.610275],
              [24.59111, 40.616661],
              [24.575275, 40.624161000000129],
              [24.56944, 40.625275000000101],
              [24.53361, 40.62055],
              [24.52972, 40.621666000000118],
              [24.51361, 40.63694],
              [24.511944, 40.64],
              [24.50944, 40.658051],
              [24.52166, 40.692772],
              [24.53361, 40.714165],
              [24.540833000000134, 40.723885],
              [24.565552, 40.75055],
              [24.596943, 40.776939],
              [24.600555, 40.778885],
              [24.621387, 40.789993],
              [24.641109000000142, 40.796661],
              [24.645275, 40.797775],
              [24.654720000000111, 40.796387],
              [24.696663, 40.780548000000124],
              [24.73333, 40.765549],
              [24.761387000000127, 40.749161],
              [24.763885, 40.731941],
              [24.773331, 40.631660000000124],
            ],
          ],
          [
            [
              [26.29416700000013, 41.708054],
              [26.30971, 41.707764],
              [26.36109, 41.711052],
              [26.39833, 41.690819],
              [26.519444000000135, 41.63361],
              [26.570271, 41.611382],
              [26.604443, 41.546097],
              [26.63583, 41.419716],
              [26.636387, 41.416382],
              [26.636662, 41.408875],
              [26.63721500000014, 41.37861],
              [26.636662, 41.366936000000123],
              [26.635277, 41.358887],
              [26.633884, 41.354439000000127],
              [26.63166, 41.350822],
              [26.617775, 41.336937],
              [26.611382, 41.332497],
              [26.603611000000114, 41.32943],
              [26.415276000000119, 41.259438000000102],
              [26.38472, 41.253319],
              [26.379719, 41.253319],
              [26.368607, 41.254166],
              [26.35833, 41.256943],
              [26.325, 41.234711],
              [26.323887000000127, 41.09304],
              [26.36722200000014, 41.03333],
              [26.37388, 41.028603],
              [26.375275000000101, 41.025551],
              [26.375549, 41.02193],
              [26.361382000000106, 40.955826],
              [26.35944, 40.951935000000105],
              [26.28749, 40.90193],
              [26.251106, 40.888611],
              [26.213608, 40.877213],
              [26.173328, 40.8186],
              [26.129993, 40.75555],
              [26.124722, 40.75],
              [26.118332, 40.745544],
              [26.107777000000112, 40.73972],
              [26.090549, 40.736107000000118],
              [26.067219, 40.734154],
              [26.051804, 40.734375],
              [26.04472, 40.735825],
              [26.038326, 40.743332],
              [26.035, 40.75721],
              [26.028332, 40.792213],
              [26.041943, 40.807213],
              [26.022778, 40.82972],
              [25.911659, 40.847771],
              [25.80555, 40.852486000000113],
              [25.771111, 40.851379],
              [25.748608, 40.84805],
              [25.719994, 40.84583],
              [25.682217, 40.852219],
              [25.580555, 40.869431],
              [25.501389, 40.886658],
              [25.41944, 40.90527],
              [25.35611, 40.93693],
              [25.347775000000127, 40.94082],
              [25.320553, 40.945267000000115],
              [25.304165000000125, 40.946663],
              [25.300278, 40.945267000000115],
              [25.235554, 40.938332000000116],
              [25.17639, 40.94193],
              [25.13528, 40.951935000000105],
              [25.132217, 40.954430000000116],
              [25.129166, 40.960541],
              [25.132771000000105, 40.973328],
              [25.135551, 40.976379],
              [25.15583, 40.986931],
              [25.16639, 40.991379],
              [25.166111, 40.994164],
              [25.14777800000013, 41.00832],
              [25.14333, 41.010277],
              [25.138054, 41.01137],
              [25.07451, 41.00762],
              [25.039951, 41.004845],
              [25.035450000000139, 41.004272],
              [24.887497, 40.91555],
              [24.858608, 40.894997000000103],
              [24.801344, 40.85197],
              [24.780277, 40.851944],
              [24.632221, 40.857773],
              [24.627499000000114, 40.858604],
              [24.623055, 40.864166],
              [24.59916, 40.898331],
              [24.568886, 40.948051],
              [24.566666, 40.950554],
              [24.561386, 40.951942000000145],
              [24.507774, 40.954994],
              [24.43111, 40.94416],
              [24.398052, 40.936943],
              [24.390553, 40.934166],
              [24.337219, 40.895271],
              [24.320274, 40.880554],
              [24.317497000000117, 40.877777],
              [24.31583, 40.873886],
              [24.311386, 40.84833],
              [24.31583, 40.828888],
              [24.15667, 40.742493],
              [24.149166, 40.739441000000113],
              [24.096664, 40.71916],
              [24.084164, 40.71611],
              [24.06861, 40.71611],
              [24.051941, 40.717773],
              [23.994442, 40.728333000000134],
              [23.989166, 40.729721],
              [23.96611, 40.737495],
              [23.915833000000134, 40.754997],
              [23.908333, 40.75889],
              [23.88666, 40.775276],
              [23.846107, 40.787216000000114],
              [23.836666, 40.786385000000109],
              [23.735275, 40.754997],
              [23.723053, 40.746666],
              [23.717499, 40.741386],
              [23.712219, 40.73555],
              [23.696388, 40.712776],
              [23.689163, 40.69194],
              [23.687775, 40.679718],
              [23.690277, 40.673050000000103],
              [23.794998, 40.583054000000118],
              [23.823055, 40.508331000000112],
              [23.818607, 40.491104000000121],
              [23.82027, 40.476387000000102],
              [23.824718000000132, 40.463051],
              [23.828053, 40.45694],
              [23.834999, 40.448883],
              [23.858608, 40.42194],
              [23.874165, 40.406662],
              [23.88333, 40.399437],
              [23.887218, 40.397499],
              [23.922775, 40.384163],
              [23.961109000000135, 40.37861],
              [24.001942, 40.38444],
              [24.005833000000109, 40.385826],
              [24.169167, 40.352493],
              [24.181942, 40.34722],
              [24.238052, 40.314163000000121],
              [24.241108000000111, 40.311661],
              [24.37611, 40.187218],
              [24.386944, 40.176941000000113],
              [24.393055000000118, 40.16861],
              [24.396385000000123, 40.162498],
              [24.39833, 40.151939],
              [24.396664000000101, 40.143326],
              [24.393887, 40.140274],
              [24.390274, 40.13861],
              [24.320553, 40.119720000000143],
              [24.31111, 40.118889000000138],
              [24.30611, 40.118889000000138],
              [24.301109, 40.119995],
              [24.29722, 40.121941],
              [24.292774, 40.127495],
              [24.29083, 40.134163],
              [24.29055, 40.141937],
              [24.284721, 40.154442000000131],
              [24.171665, 40.272774],
              [24.169167, 40.275276000000133],
              [24.159443, 40.281944000000124],
              [24.14972, 40.28416],
              [24.124165, 40.28999],
              [24.113888, 40.28999],
              [24.095554000000106, 40.287773000000129],
              [24.051941, 40.292221],
              [24.04694400000011, 40.29361],
              [24.02972, 40.300278],
              [24.001389000000131, 40.313332000000116],
              [23.993889, 40.317215],
              [23.968887000000109, 40.33166],
              [23.96583, 40.33416],
              [23.95666, 40.345276000000126],
              [23.947498, 40.352493],
              [23.936943, 40.358604000000128],
              [23.924164, 40.363884],
              [23.907776, 40.367218],
              [23.850555, 40.373329],
              [23.832222, 40.371109000000104],
              [23.73166700000013, 40.351944000000117],
              [23.727776, 40.35055],
              [23.708332, 40.335274],
              [23.698887, 40.322777],
              [23.69694, 40.319443],
              [23.69278, 40.306389000000138],
              [23.691109, 40.297775],
              [23.69916, 40.274719],
              [23.704998000000103, 40.262215],
              [23.72472, 40.240829000000133],
              [23.773888000000113, 40.196106],
              [23.784443, 40.189720000000136],
              [23.793331, 40.19111],
              [23.79805, 40.19194],
              [23.879997, 40.17388],
              [23.906109, 40.164444000000117],
              [23.91, 40.162498],
              [23.974442, 40.129166000000112],
              [23.989719, 40.113884],
              [23.99222200000014, 40.111107],
              [24.014721000000122, 40.030548000000124],
              [24.015, 40.011383000000137],
              [24.013885, 40.00694],
              [23.992775, 39.954994000000113],
              [23.989719, 39.952774],
              [23.985832, 39.951385],
              [23.942219, 39.943329],
              [23.932220000000143, 39.943054],
              [23.899998, 39.968048],
              [23.826942, 40.025551],
              [23.7905540000001, 40.080276],
              [23.791664, 40.08888],
              [23.789997, 40.091942],
              [23.762497, 40.124718000000144],
              [23.72555, 40.1680530000001],
              [23.703053000000125, 40.191666],
              [23.671108, 40.21833],
              [23.653053, 40.228607],
              [23.638885, 40.23305],
              [23.413609, 40.281387],
              [23.403332, 40.281662],
              [23.398888000000113, 40.28083],
              [23.38833, 40.275551],
              [23.376663, 40.265549],
              [23.353611, 40.245277000000101],
              [23.33833, 40.22778],
              [23.331944, 40.217773],
              [23.330276, 40.213608],
              [23.329998000000103, 40.209442],
              [23.33166, 40.202774],
              [23.368053, 40.14388300000013],
              [23.479721, 40.045273],
              [23.498886, 40.031662],
              [23.51083, 40.026108],
              [23.595833, 39.999718],
              [23.61278, 39.994438],
              [23.675552, 39.971382],
              [23.74778, 39.932777],
              [23.748886, 39.92555],
              [23.746666, 39.92222],
              [23.743332, 39.920555],
              [23.72694, 39.91583],
              [23.71, 39.911942],
              [23.64361, 39.916107],
              [23.612221, 39.919441],
              [23.595833, 39.921944],
              [23.436943, 39.971107000000131],
              [23.37944, 39.992775000000108],
              [23.320831000000112, 40.119164000000126],
              [23.324165000000107, 40.126938],
              [23.32444, 40.176384],
              [23.323608, 40.18777],
              [23.320553, 40.20166],
              [23.31444, 40.218048000000124],
              [23.311108, 40.224159],
              [23.305553, 40.229164],
              [23.298332, 40.233887],
              [23.290833, 40.237778000000105],
              [23.26527, 40.248055],
              [23.26083, 40.249718],
              [23.177498, 40.273048],
              [23.11083, 40.299164],
              [22.899441000000138, 40.39666],
              [22.843609, 40.474998],
              [22.863052, 40.50388],
              [22.87444, 40.50278],
              [22.88888, 40.50388],
              [22.92222, 40.512497],
              [22.946663, 40.519722],
              [22.96472, 40.52833],
              [22.973888, 40.535553],
              [22.98111, 40.544716],
              [22.98222, 40.549164],
              [22.978611, 40.558884],
              [22.950275, 40.619438],
              [22.946663, 40.625549],
              [22.941387000000134, 40.630554],
              [22.91166, 40.642776],
              [22.901386000000116, 40.645],
              [22.896385, 40.645],
              [22.865833000000123, 40.638611],
              [22.861942, 40.629440000000102],
              [22.862778000000105, 40.62611],
              [22.862499000000128, 40.62194],
              [22.85944400000011, 40.597496],
              [22.85389, 40.592216],
              [22.81694, 40.569717],
              [22.813332, 40.567772000000105],
              [22.704441, 40.518326],
              [22.652775, 40.510277],
              [22.59111, 40.47666],
              [22.582497, 40.463333],
              [22.583611, 40.459999],
              [22.611111, 40.407776],
              [22.621109, 40.393326],
              [22.629997, 40.38305],
              [22.612499, 40.291664],
              [22.604164, 40.2775],
              [22.548885, 40.160553],
              [22.547775, 40.156105],
              [22.54722, 40.147774],
              [22.548885, 40.133049],
              [22.568886, 40.05722],
              [22.595, 40.012215],
              [22.61583, 39.99555],
              [22.625826, 39.98917],
              [22.686386, 39.96611],
              [22.70305, 39.958885],
              [22.709721000000116, 39.95472],
              [22.712219, 39.95194],
              [22.852219, 39.79361],
              [22.856388, 39.784164],
              [22.85944400000011, 39.77389],
              [22.86055, 39.751106],
              [22.864998000000128, 39.729721],
              [22.867496, 39.723328],
              [22.91305, 39.618889],
              [22.924442, 39.593605],
              [22.929443, 39.584442],
              [22.93861, 39.577499],
              [22.945553, 39.573326000000122],
              [23.020832, 39.529160000000104],
              [23.025276, 39.527496],
              [23.118053, 39.45694],
              [23.138054000000125, 39.439995000000124],
              [23.25861, 39.331665],
              [23.267776, 39.32111],
              [23.27639, 39.309998],
              [23.326664000000108, 39.226944],
              [23.328331, 39.223885000000109],
              [23.34333, 39.192772000000105],
              [23.345, 39.185829000000126],
              [23.345, 39.178055],
              [23.341389, 39.170555],
              [23.325275, 39.154442],
              [23.31583, 39.148048000000131],
              [23.206108, 39.10527],
              [23.161110000000122, 39.093605000000139],
              [23.122498, 39.087776000000133],
              [23.090275000000133, 39.085548],
              [23.085278, 39.085274],
              [23.080555, 39.086105],
              [23.05805, 39.093887],
              [23.054443000000106, 39.09583],
              [23.052776, 39.098885],
              [23.054165, 39.10305],
              [23.069721, 39.13361],
              [23.073887, 39.140549000000135],
              [23.07889, 39.146385],
              [23.086109, 39.14944],
              [23.10972, 39.152496],
              [23.115276, 39.14361],
              [23.116943, 39.140549000000135],
              [23.114441, 39.13222],
              [23.108055, 39.121941],
              [23.10555, 39.119164],
              [23.098331, 39.104164],
              [23.10083, 39.10166],
              [23.105, 39.10249],
              [23.174442000000113, 39.130272],
              [23.210831, 39.15083],
              [23.213333, 39.15361],
              [23.22166, 39.177498],
              [23.222221000000104, 39.181664000000126],
              [23.221107, 39.184998000000121],
              [23.178608, 39.255554000000132],
              [23.16333, 39.271111000000133],
              [23.160831000000144, 39.273605],
              [23.122776, 39.304161],
              [23.119720000000143, 39.306389000000138],
              [22.99528, 39.352776],
              [22.94611, 39.36055],
              [22.941666000000112, 39.35972],
              [22.937775, 39.358604],
              [22.829720000000123, 39.273888],
              [22.826664, 39.271385],
              [22.82222, 39.265274],
              [22.81694, 39.253883],
              [22.81694, 39.24583],
              [22.818054000000132, 39.23888],
              [22.8225, 39.217499],
              [22.824718000000132, 39.206940000000145],
              [22.833885000000123, 39.18805],
              [22.85028, 39.161385],
              [22.854443, 39.15583],
              [22.858608, 39.155548],
              [22.875275000000101, 39.17083],
              [22.877499, 39.174164],
              [22.876389, 39.177773],
              [22.91333, 39.156387],
              [22.965275, 39.118607000000111],
              [22.973888, 39.107498],
              [22.99528, 39.068054],
              [22.994999, 39.042770000000132],
              [23.03416, 39.03611],
              [23.072777, 39.036942],
              [23.05139, 39.016388],
              [23.00972, 38.977776],
              [22.937775, 38.928604000000121],
              [22.833054000000118, 38.891106],
              [22.759998, 38.871109],
              [22.755554, 38.870277000000101],
              [22.750832000000116, 38.869995],
              [22.734444, 38.871384],
              [22.682997, 38.8785],
              [22.678165, 38.879993],
              [22.658886, 38.885277],
              [22.654163, 38.890549],
              [22.653332, 38.894165],
              [22.651665, 38.896942000000138],
              [22.646942, 38.9025],
              [22.643330000000105, 38.904442],
              [22.616943, 38.90916],
              [22.611942000000113, 38.908882],
              [22.526943, 38.8825],
              [22.523888, 38.880272],
              [22.523609, 38.876106000000107],
              [22.523052000000121, 38.860832],
              [22.52333, 38.857216],
              [22.553608, 38.83416],
              [22.558052, 38.832497],
              [22.57917, 38.825829],
              [22.584721, 38.825],
              [22.60611, 38.82361],
              [22.610275, 38.82444],
              [22.617775, 38.827499],
              [22.66855, 38.830441000000121],
              [22.713333, 38.823051],
              [22.756664, 38.787498],
              [22.771942, 38.779999],
              [22.953609, 38.751663000000121],
              [23.063889, 38.692497],
              [23.06861, 38.683327000000133],
              [23.092220000000111, 38.648331],
              [23.105831, 38.631386],
              [23.10889, 38.629166],
              [23.113331, 38.627495],
              [23.117496, 38.628052],
              [23.13361, 38.63277],
              [23.167774000000122, 38.643051000000128],
              [23.185833, 38.650833],
              [23.189163, 38.652771],
              [23.19222, 38.655],
              [23.1936070000001, 38.65916],
              [23.192776, 38.662498000000141],
              [23.281387, 38.65416],
              [23.286942000000124, 38.653328000000101],
              [23.316109, 38.645271],
              [23.318886000000134, 38.64277600000014],
              [23.333885, 38.623329],
              [23.335552000000121, 38.62028],
              [23.33833, 38.609993000000145],
              [23.33833, 38.605827],
              [23.336941, 38.601944000000117],
              [23.305553, 38.567497000000117],
              [23.335, 38.53805],
              [23.338886, 38.53611],
              [23.399441, 38.507774],
              [23.465832, 38.498886],
              [23.534721, 38.49944],
              [23.592499, 38.463333],
              [23.59333, 38.446106],
              [23.601944, 38.431107],
              [23.655552, 38.361382],
              [23.658607, 38.359161],
              [23.675552, 38.34861],
              [23.79916, 38.323883],
              [23.851109, 38.313049],
              [23.926666000000125, 38.294998],
              [23.960552, 38.281662],
              [24.073887, 38.196938],
              [24.07416, 38.193054],
              [24.06889, 38.159164],
              [24.060555, 38.143051],
              [24.005554000000132, 38.067772],
              [24.01083, 37.971382],
              [24.030552, 37.872498],
              [24.056664, 37.845276000000126],
              [24.086109, 37.799995],
              [24.086941000000138, 37.79639],
              [24.090275000000133, 37.77861],
              [24.089722, 37.774719],
              [24.069443, 37.689438],
              [24.06222, 37.676941],
              [24.040833, 37.65583],
              [24.03444, 37.651665],
              [24.030277, 37.651939],
              [23.950832, 37.669716],
              [23.94444, 37.67416],
              [23.92444, 37.720276],
              [23.907776, 37.761108],
              [23.887497, 37.782776],
              [23.861664000000133, 37.804161000000136],
              [23.847221, 37.812218],
              [23.821663000000115, 37.82278],
              [23.817219000000136, 37.82444],
              [23.774441, 37.834442],
              [23.562496, 37.966942],
              [23.559444, 37.969162],
              [23.555553, 37.978607],
              [23.556389, 37.982216000000108],
              [23.56361, 37.985275],
              [23.570831, 37.98832700000014],
              [23.588055, 38.00055],
              [23.592499, 38.00666],
              [23.5975, 38.018608],
              [23.598331, 38.026939],
              [23.597221000000104, 38.029442000000131],
              [23.586109000000135, 38.03889],
              [23.578053, 38.042496],
              [23.57222, 38.043327],
              [23.515553000000125, 38.04055000000011],
              [23.507774, 38.038055],
              [23.458611000000133, 38.02055],
              [23.428333000000123, 38.00388],
              [23.425831, 38.001106],
              [23.418888, 37.991943],
              [23.412220000000104, 37.979996],
              [23.33166, 37.97805],
              [23.248333, 37.977776],
              [23.23555, 37.97555],
              [23.231667, 37.9741590000001],
              [23.176668, 37.951942],
              [23.15361, 37.932777000000101],
              [23.14444, 37.92610900000011],
              [23.134163, 37.920830000000137],
              [23.126389, 37.918053],
              [23.109165, 37.915276000000119],
              [23.063889, 37.912773000000129],
              [23.035275, 37.918610000000115],
              [23.01694, 37.923607],
              [23.011665, 37.91833],
              [22.992222, 37.884163000000115],
              [22.991386, 37.880554000000132],
              [23.0025, 37.85139],
              [23.00472, 37.848885000000109],
              [23.012218000000132, 37.844994],
              [23.021595000000104, 37.841873],
              [23.063053, 37.839439],
              [23.083611000000133, 37.838608000000136],
              [23.103611, 37.84166],
              [23.14861, 37.758049],
              [23.161388, 37.619995000000131],
              [23.16222, 37.616661000000136],
              [23.169998000000135, 37.611664],
              [23.195831, 37.59528],
              [23.2775, 37.553329],
              [23.322777, 37.53249],
              [23.328609, 37.531662],
              [23.336666, 37.533607],
              [23.35833, 37.54277],
              [23.364998, 37.54639],
              [23.366386, 37.550278],
              [23.360554, 37.566666000000112],
              [23.346664, 37.586388],
              [23.329441, 37.60444],
              [23.32638500000013, 37.60666700000013],
              [23.40583, 37.58833],
              [23.421801, 37.527229],
              [23.445553, 37.50471],
              [23.49833, 37.476944],
              [23.520832, 37.461662],
              [23.521942, 37.458328],
              [23.525276, 37.439163],
              [23.522778, 37.436386],
              [23.513611, 37.429443],
              [23.506664, 37.42582700000014],
              [23.499165, 37.42333200000013],
              [23.422222, 37.410271],
              [23.413055, 37.409164],
              [23.39194, 37.411110000000122],
              [23.381386, 37.41333],
              [23.354443000000117, 37.416107],
              [23.270554, 37.40083],
              [23.231667, 37.380554],
              [23.22972, 37.37722],
              [23.19611, 37.313332],
              [23.201664, 37.304443000000106],
              [23.204166, 37.29805],
              [23.201111000000139, 37.295830000000137],
              [23.18222, 37.290276],
              [23.177219, 37.29055000000011],
              [23.153889, 37.296104],
              [23.149719, 37.297493],
              [23.070274, 37.35305],
              [23.066387, 37.358604],
              [23.066387, 37.393051],
              [23.069443, 37.395271],
              [23.073608, 37.396111],
              [23.07777, 37.39444],
              [23.084442000000138, 37.390274],
              [23.08889, 37.389717],
              [23.10611, 37.392494000000113],
              [23.136944, 37.41805],
              [23.136108, 37.437218],
              [23.128887000000134, 37.448051],
              [22.979164000000139, 37.515831000000105],
              [22.931942, 37.53416],
              [22.927498, 37.53583],
              [22.779999, 37.589996],
              [22.774719, 37.590271],
              [22.762218, 37.588882000000126],
              [22.74361, 37.58194],
              [22.73055, 37.574165000000107],
              [22.72583, 37.568329],
              [22.722775, 37.561386],
              [22.723053000000107, 37.54972],
              [22.727497, 37.487221],
              [22.728611, 37.483887],
              [22.75861, 37.408051],
              [22.80917, 37.345551],
              [22.911388000000102, 37.19416],
              [22.91166, 37.190552000000139],
              [22.907497, 37.18055],
              [22.9025, 37.17472],
              [22.900555000000111, 37.171104],
              [22.895275, 37.141937],
              [22.896111000000133, 37.130554],
              [22.901943, 37.11805],
              [22.907219000000111, 37.113052],
              [22.910275, 37.111664000000133],
              [22.92, 37.110832],
              [22.926941, 37.118607000000111],
              [22.930275, 37.120277000000101],
              [22.934998000000121, 37.12055],
              [22.954441, 37.118607000000111],
              [22.957222, 37.116104],
              [23.006386, 37.024719],
              [23.00916, 36.99055],
              [23.014164, 36.937775000000101],
              [23.014999, 36.934441000000106],
              [23.052776, 36.868607],
              [23.090832, 36.822495000000117],
              [23.11417, 36.774719],
              [23.114998, 36.771385],
              [23.11305, 36.768051],
              [23.086941000000138, 36.748329],
              [23.066944, 36.739998000000128],
              [23.062222, 36.741104000000121],
              [23.052776, 36.740555],
              [23.032219, 36.732773],
              [23.030277, 36.729164],
              [23.026665, 36.716385],
              [23.02861, 36.65666],
              [23.032776, 36.635551],
              [23.033886000000109, 36.63222],
              [23.036942, 36.626106],
              [23.07889, 36.57666],
              [23.109997, 36.562492000000134],
              [23.200554, 36.455826],
              [23.204166, 36.449997],
              [23.20444, 36.446388],
              [23.203053, 36.437775],
              [23.201385, 36.43388],
              [23.19833, 36.431938],
              [23.140274, 36.426109],
              [23.135277, 36.426384],
              [23.09, 36.439995],
              [22.972775000000127, 36.518883],
              [22.969719, 36.52111],
              [22.967499, 36.523605],
              [22.95472, 36.54805],
              [22.88805, 36.647217],
              [22.788055, 36.79583],
              [22.785553, 36.798607],
              [22.781944, 36.80055],
              [22.77277800000013, 36.80222],
              [22.73055, 36.805832],
              [22.643608, 36.804993],
              [22.63416, 36.804443],
              [22.62611, 36.802498],
              [22.596107000000131, 36.792221],
              [22.588886, 36.789162],
              [22.57278, 36.773888],
              [22.51277, 36.667770000000132],
              [22.482498, 36.60611],
              [22.479443, 36.592773],
              [22.480553, 36.532219],
              [22.482498, 36.525551],
              [22.48555, 36.51944],
              [22.49361, 36.50444],
              [22.495831, 36.501663],
              [22.5, 36.499058],
              [22.502499, 36.497498],
              [22.504166, 36.494438],
              [22.50611, 36.487778],
              [22.50722, 36.472771000000137],
              [22.507774, 36.465271],
              [22.508331, 36.453049],
              [22.5075, 36.44861],
              [22.488888, 36.386108],
              [22.476665, 36.402771000000143],
              [22.3975, 36.473885000000109],
              [22.377499, 36.535553],
              [22.35611, 36.69944],
              [22.29694400000011, 36.814995],
              [22.24361, 36.873329],
              [22.185555, 36.892776],
              [22.146385, 36.950829],
              [22.160553, 37.002495],
              [22.158886, 37.013329000000113],
              [22.156387, 37.019722],
              [22.152775, 37.02166],
              [22.147778, 37.022774],
              [22.120831, 37.026665],
              [22.073055, 37.03083],
              [22.063053, 37.03083],
              [22.05, 37.029160000000104],
              [22.02916, 37.024719],
              [21.97944, 37.00722],
              [21.953609, 36.997498000000121],
              [21.937496, 36.987778],
              [21.933052, 36.981384],
              [21.926388, 36.96666],
              [21.922775000000115, 36.866661],
              [21.923054, 36.862778],
              [21.92555, 36.848610000000122],
              [21.931389000000138, 36.820549],
              [21.933052, 36.817497000000117],
              [21.937775, 36.812218000000144],
              [21.949718, 36.80305],
              [21.961666, 36.798050000000103],
              [21.938053000000139, 36.762215],
              [21.881386, 36.720276],
              [21.876663, 36.721382000000119],
              [21.873608, 36.72361],
              [21.868889, 36.728882],
              [21.846386000000109, 36.759438000000102],
              [21.83277500000014, 36.779442],
              [21.82944, 36.785553000000107],
              [21.827499, 36.792221],
              [21.82694, 36.79972],
              [21.825275, 36.802773],
              [21.82222, 36.804993],
              [21.818333, 36.806107],
              [21.809719, 36.805832],
              [21.770275, 36.800278],
              [21.76722, 36.798607],
              [21.765274, 36.795],
              [21.764164000000108, 36.79055],
              [21.704441, 36.815277],
              [21.70277, 36.818054],
              [21.691387, 36.84333],
              [21.68639, 36.87055],
              [21.686665000000119, 36.8825],
              [21.688053, 36.89111],
              [21.69722, 36.91416],
              [21.706944, 36.919716],
              [21.711388, 36.92610900000011],
              [21.712776000000133, 36.929993000000138],
              [21.713608, 36.933609],
              [21.711941000000138, 36.944443],
              [21.707775, 36.950272],
              [21.6375, 37.009438],
              [21.612221, 37.026939],
              [21.58194, 37.061104000000114],
              [21.580276, 37.066666],
              [21.564999, 37.145],
              [21.56416, 37.1525],
              [21.566109, 37.161385],
              [21.577221, 37.193886000000134],
              [21.578888, 37.197777],
              [21.585552, 37.20694],
              [21.590553, 37.212219],
              [21.605, 37.2241590000001],
              [21.630276, 37.234444],
              [21.66972, 37.268326],
              [21.674999000000128, 37.2736],
              [21.694721, 37.305275],
              [21.695831, 37.309715],
              [21.696388, 37.325829],
              [21.681389, 37.376389],
              [21.659721000000104, 37.423882],
              [21.649719000000118, 37.44194],
              [21.604721, 37.50471],
              [21.580555, 37.53083],
              [21.572220000000129, 37.538055],
              [21.557777, 37.54972],
              [21.532497, 37.56694],
              [21.40111, 37.651665],
              [21.29361, 37.77861],
              [21.276943, 37.789162],
              [21.234444, 37.80888],
              [21.21833, 37.815552],
              [21.209442, 37.818604],
              [21.174164, 37.82611],
              [21.146942000000138, 37.82972],
              [21.120277000000101, 37.834717],
              [21.109997, 37.840553000000114],
              [21.106388, 37.846664],
              [21.106388, 37.854439000000127],
              [21.10944400000011, 37.876938],
              [21.112499000000128, 37.89444],
              [21.124165, 37.929443000000106],
              [21.127499, 37.93694],
              [21.13361, 37.941109],
              [21.13888, 37.940826],
              [21.1425, 37.939163],
              [21.14917, 37.930832],
              [21.152775000000133, 37.928886],
              [21.163609, 37.926941],
              [21.17778, 37.927773000000116],
              [21.190552000000139, 37.930275],
              [21.207222, 37.93972],
              [21.216389, 37.94583],
              [21.283607, 37.994164000000126],
              [21.315830000000119, 38.028885],
              [21.367222, 38.114166],
              [21.373886, 38.13694],
              [21.373886, 38.152496],
              [21.372776, 38.163887000000102],
              [21.38444, 38.21139],
              [21.445, 38.200829000000113],
              [21.473331, 38.18972],
              [21.48305, 38.183327],
              [21.529720000000111, 38.1616590000001],
              [21.539719, 38.159439000000134],
              [21.59528, 38.148888],
              [21.612499, 38.152222],
              [21.641666, 38.158882],
              [21.66833, 38.16805],
              [21.671665000000132, 38.169998000000135],
              [21.676941, 38.175278],
              [21.715832, 38.21666],
              [21.722221, 38.226662],
              [21.732498, 38.248886],
              [21.740276, 38.2736],
              [21.742775, 38.276665],
              [21.773609, 38.303886],
              [21.779999, 38.308052],
              [21.84889, 38.338333],
              [21.85833, 38.340828],
              [21.958611, 38.329437],
              [22.02138, 38.309715],
              [22.024719000000118, 38.303604000000121],
              [22.026386, 38.29277],
              [22.02833, 38.28583],
              [22.04222, 38.273888],
              [22.17139, 38.20361],
              [22.174999, 38.201660000000118],
              [22.215553000000114, 38.185272],
              [22.224442, 38.181938],
              [22.37833, 38.146385],
              [22.455555, 38.133331],
              [22.536942, 38.113327],
              [22.652222, 38.076111],
              [22.709999, 38.049438000000123],
              [22.721664, 38.043884000000105],
              [22.72472, 38.041664],
              [22.729443, 38.036385000000109],
              [22.761108, 38.006386],
              [22.799442000000113, 37.971382],
              [22.857498, 37.941109],
              [22.86805, 37.938049],
              [22.908054000000106, 37.938049],
              [22.943054, 37.943604000000107],
              [22.954998000000103, 37.946938000000102],
              [22.958332, 37.948608],
              [22.96611, 37.95694],
              [22.97222, 37.966942],
              [22.978886, 37.982216000000108],
              [22.97722, 37.985275],
              [22.949165000000107, 38.001663000000121],
              [22.907776, 38.022217],
              [22.89055, 38.029999],
              [22.872776000000101, 38.031105],
              [22.869164, 38.029442000000131],
              [22.858887, 38.029999],
              [22.85389, 38.031387000000109],
              [22.85472, 38.034721000000104],
              [22.85805, 38.036659],
              [22.881386, 38.049995],
              [22.944443, 38.079163],
              [22.952499000000103, 38.081108],
              [22.9625, 38.080826000000116],
              [22.995831, 38.07222],
              [23.008888000000127, 38.067497],
              [23.0191650000001, 38.061386],
              [23.023609, 38.059715],
              [23.04555, 38.058327],
              [23.059166000000118, 38.057495],
              [23.097775, 38.058609],
              [23.1025, 38.058884],
              [23.11413, 38.06077],
              [23.124722000000133, 38.062492],
              [23.16889, 38.07444],
              [23.209999, 38.095551],
              [23.216389, 38.099716],
              [23.21833, 38.10305],
              [23.22639, 38.14944],
              [23.226109, 38.153053],
              [23.223053, 38.155548],
              [23.120552, 38.209717],
              [23.116108, 38.2111],
              [23.025276, 38.217499],
              [22.966942, 38.213608000000136],
              [22.943054, 38.20805],
              [22.944443, 38.186943],
              [22.92333, 38.195000000000107],
              [22.835278, 38.226387],
              [22.78139, 38.23333],
              [22.765553, 38.244438],
              [22.68972, 38.323608],
              [22.587776, 38.330551],
              [22.533886, 38.34499],
              [22.510277, 38.375275],
              [22.463886, 38.424721],
              [22.46083, 38.427216000000101],
              [22.4175, 38.44444],
              [22.413055, 38.446106],
              [22.40333, 38.448051],
              [22.400555, 38.445549000000142],
              [22.37833, 38.391937],
              [22.376942, 38.388054],
              [22.377777, 38.38472],
              [22.388332, 38.363609],
              [22.39666, 38.35083],
              [22.39638, 38.347771],
              [22.393608, 38.345276],
              [22.38194, 38.33583],
              [22.37861, 38.33416],
              [22.368332, 38.33416],
              [22.193886, 38.337219],
              [22.168331, 38.346939000000134],
              [22.12555, 38.37138],
              [22.042774, 38.398048],
              [21.97555, 38.40666],
              [21.947777, 38.409439],
              [21.713055, 38.35305],
              [21.660275, 38.354721],
              [21.636665, 38.35416],
              [21.595833, 38.343605000000139],
              [21.546665, 38.319717],
              [21.53333, 38.312218],
              [21.463886, 38.36666],
              [21.36555, 38.43305],
              [21.35055, 38.43278],
              [21.339443, 38.394997000000103],
              [21.334999, 38.38861],
              [21.26694, 38.339165],
              [21.238331, 38.321663],
              [21.176109, 38.298882],
              [21.171944, 38.29805],
              [21.160831, 38.299164000000133],
              [21.147778, 38.304161],
              [21.108887, 38.348053000000107],
              [21.108608, 38.36305],
              [21.11055, 38.369720000000143],
              [21.12694, 38.379715],
              [21.13555, 38.386665000000107],
              [21.139721, 38.393051],
              [21.139442, 38.396942],
              [21.122776000000101, 38.429718],
              [21.116386, 38.438049],
              [21.110815, 38.43415],
              [21.108913, 38.430569],
              [21.105000000000132, 38.429173],
              [21.10278, 38.429443],
              [21.106388, 38.430832],
              [21.108887, 38.433884],
              [21.110832, 38.437218],
              [21.112499000000128, 38.44527],
              [21.11138, 38.448883000000137],
              [21.086388, 38.503052],
              [20.98944, 38.669998],
              [20.986385, 38.672218],
              [20.901108, 38.73194100000012],
              [20.80972, 38.759438],
              [20.774719, 38.75722],
              [20.769722000000115, 38.758331000000112],
              [20.766666, 38.760826000000122],
              [20.76416, 38.763329000000113],
              [20.733330000000137, 38.797775],
              [20.73222, 38.801109],
              [20.732777, 38.809441],
              [20.74972, 38.909721],
              [20.781109, 38.93166],
              [20.970276, 38.94194],
              [21.02972, 38.93055],
              [21.03167, 38.927498],
              [21.031944, 38.915833],
              [21.031109, 38.911385],
              [21.02583, 38.906105000000139],
              [21.024067, 38.902756],
              [21.02583, 38.895828],
              [21.028889, 38.89361],
              [21.04583, 38.883049000000142],
              [21.049442000000113, 38.881104000000107],
              [21.08333, 38.864166],
              [21.086941, 38.86388],
              [21.140831, 38.931938000000116],
              [21.166386000000102, 38.975273],
              [21.164997, 38.982498000000135],
              [21.16333, 38.985275],
              [21.149998, 39.001938000000109],
              [21.138611, 39.015549],
              [21.109165000000132, 39.04666],
              [21.106110000000115, 39.048882000000106],
              [21.09861, 39.053055],
              [21.094166, 39.054718],
              [21.083050000000128, 39.056664],
              [21.045277000000112, 39.013329],
              [20.933052, 39.05805],
              [20.826111000000139, 39.113884],
              [20.821663, 39.114441],
              [20.817776, 39.11305],
              [20.774719, 39.085274],
              [20.7575, 39.020554000000118],
              [20.787498, 38.997772],
              [20.824165, 38.974716],
              [20.82722, 38.9725],
              [20.82972, 38.969719],
              [20.83083, 38.966385],
              [20.83055, 38.962219],
              [20.82917, 38.958328000000108],
              [20.824718, 38.957497000000103],
              [20.740833, 38.94971],
              [20.735832, 38.950829000000113],
              [20.73194100000012, 38.952499000000103],
              [20.72472, 38.960548000000131],
              [20.712219, 38.977219],
              [20.703331000000105, 38.992493],
              [20.702221, 38.995827],
              [20.7025, 39.0],
              [20.711109, 39.006104],
              [20.713608, 39.009163],
              [20.71527, 39.012497],
              [20.71527, 39.020554000000118],
              [20.703888, 39.046104],
              [20.694721, 39.061943],
              [20.688053, 39.070274],
              [20.67639, 39.07972],
              [20.534443000000124, 39.185829000000126],
              [20.480274, 39.273605],
              [20.466942000000131, 39.275833],
              [20.385555000000124, 39.284439000000134],
              [20.34861, 39.287498000000141],
              [20.34333, 39.288605],
              [20.30444, 39.31472],
              [20.298332, 39.31916],
              [20.290276, 39.32666],
              [20.214165, 39.43777],
              [20.215275, 39.439995000000124],
              [20.24528, 39.441383],
              [20.227776, 39.51944],
              [20.18861, 39.619164],
              [20.176109, 39.628052],
              [20.165276000000119, 39.633888000000127],
              [20.063332, 39.679993000000138],
              [20.059444, 39.681664],
              [20.054165, 39.682777000000101],
              [20.010029, 39.6912],
              [20.013332, 39.69472],
              [20.021111, 39.697495],
              [20.031944, 39.697220000000129],
              [20.090553000000114, 39.68139],
              [20.093887000000109, 39.679161],
              [20.09861, 39.673882],
              [20.105000000000132, 39.66944100000012],
              [20.14139, 39.656105],
              [20.166664, 39.65028],
              [20.193333, 39.64527],
              [20.199165000000107, 39.644722],
              [20.21833, 39.646385000000123],
              [20.221664, 39.64833],
              [20.314720000000136, 39.72361],
              [20.317497, 39.726105],
              [20.319443, 39.729439],
              [20.320831, 39.733604],
              [20.318054, 39.739998],
              [20.29805, 39.771942],
              [20.289444, 39.803055],
              [20.29139, 39.806664],
              [20.29472, 39.808609],
              [20.302219, 39.811661],
              [20.306129, 39.812119],
              [20.371666, 39.788887],
              [20.37611, 39.787498],
              [20.381386000000134, 39.78722],
              [20.385277, 39.788605000000132],
              [20.401943, 39.799164],
              [20.407219, 39.804443],
              [20.41222, 39.815826],
              [20.41444, 39.82444],
              [20.415276, 39.836937],
              [20.41222, 39.84333],
              [20.408886, 39.84916],
              [20.36972, 39.89138800000012],
              [20.338055, 39.921661],
              [20.336388, 39.92472],
              [20.314720000000136, 39.990273],
              [20.316109, 39.993332],
              [20.421944, 40.05805],
              [20.43861, 40.068054],
              [20.449997, 40.072495],
              [20.461571, 40.074165],
              [20.476944, 40.066109],
              [20.48222, 40.064995000000124],
              [20.555832, 40.066383],
              [20.583332, 40.070549],
              [20.604721, 40.075272],
              [20.621387, 40.085274],
              [20.657219, 40.091385000000116],
              [20.665276, 40.094162],
              [20.671944, 40.098053000000107],
              [20.67388, 40.101387000000102],
              [20.721107, 40.223053],
              [20.721386, 40.227219],
              [20.72083, 40.246666000000118],
              [20.714722, 40.255272],
              [20.71083, 40.265],
              [20.71194, 40.273888],
              [20.713055, 40.278328],
              [20.715, 40.281662],
              [20.733330000000137, 40.305275],
              [20.740276, 40.309166],
              [20.75861, 40.31194],
              [20.78722, 40.394722],
              [20.791924, 40.43154],
              [20.833332, 40.462219],
              [20.910831, 40.465271000000143],
              [20.914165, 40.463051],
              [20.918610000000115, 40.461662],
              [20.93694, 40.464439],
              [20.945553, 40.466942],
              [20.948887, 40.468887],
              [20.951942, 40.471382],
              [21.041386, 40.561943],
              [21.042774000000122, 40.56611],
              [21.053055, 40.618607],
              [21.053608, 40.62277],
              [21.054165, 40.661942000000124],
              [21.053055, 40.673332],
              [21.051941000000113, 40.676666],
              [21.046665, 40.685829],
              [21.036587, 40.698563],
              [21.028889, 40.708054],
              [21.020832, 40.715553],
              [20.98389, 40.7930530000001],
              [20.98349, 40.855888],
              [21.12155, 40.85722],
              [21.150833, 40.857498],
              [21.31472, 40.868607000000111],
              [21.343052, 40.871941000000106],
              [21.35667, 40.87444],
              [21.36861, 40.878326],
              [21.380554, 40.888054000000125],
              [21.399719, 40.906944],
              [21.405552, 40.9116590000001],
              [21.41555, 40.91777],
              [21.41972, 40.91916700000013],
              [21.513611, 40.910553],
              [21.529720000000111, 40.908882],
              [21.533607, 40.907219000000111],
              [21.53666, 40.904716000000121],
              [21.54833, 40.891106],
              [21.570000000000107, 40.874992],
              [21.573608, 40.873055],
              [21.57972, 40.872215],
              [21.599998, 40.872772000000111],
              [21.78028, 40.928886],
              [21.792221, 40.93278],
              [21.911942000000124, 41.049438],
              [21.913609, 41.053329000000133],
              [21.913887000000102, 41.056938000000116],
              [21.91055, 41.067215],
              [21.90916, 41.07444],
              [21.916111000000114, 41.095276],
              [21.97361, 41.129997000000117],
              [21.98055, 41.1336060000001],
              [22.20555, 41.167770000000132],
              [22.256664000000114, 41.171387],
              [22.26249700000011, 41.17055],
              [22.304722, 41.15333],
              [22.34333, 41.134438],
              [22.434719, 41.12138],
              [22.450275, 41.12138],
              [22.484722, 41.12138],
              [22.58083, 41.119995000000131],
              [22.585552, 41.119438],
              [22.590275, 41.119995000000131],
              [22.720554000000106, 41.14277600000014],
              [22.72916, 41.144722],
              [22.73583, 41.148888000000113],
              [22.741943, 41.159164],
              [22.74361, 41.16333],
              [22.758053, 41.227776000000119],
              [22.761543000000131, 41.25174],
              [22.765274, 41.296661],
              [22.76361, 41.29972],
              [22.760555, 41.30194],
              [22.759441, 41.30527],
              [22.75972, 41.309441],
              [22.763988, 41.315315],
              [22.772221, 41.32444],
              [22.78139, 41.33166],
              [22.803886, 41.346939],
              [22.813053, 41.348610000000122],
              [22.926388, 41.343048],
              [22.935604, 41.342125],
              [22.97555, 41.335548],
              [23.094444000000124, 41.320549],
              [23.119999, 41.320831000000112],
              [23.180832, 41.32278],
              [23.189442, 41.32471],
              [23.201111000000139, 41.329163000000108],
              [23.214722000000108, 41.336937],
              [23.227219000000105, 41.34638],
              [23.229443, 41.34972],
              [23.230274, 41.353333],
              [23.22639, 41.366943],
              [23.228333, 41.374992],
              [23.231388, 41.37749],
              [23.273888, 41.399719000000118],
              [23.285275, 41.404716],
              [23.29472, 41.406105],
              [23.440552, 41.409439],
              [23.538887, 41.397217],
              [23.551109, 41.391663],
              [23.598053, 41.38083],
              [23.631107, 41.37749],
              [23.63583, 41.378052],
              [23.73833100000013, 41.408607],
              [23.796387, 41.436661000000129],
              [23.886387, 41.451942],
              [23.974442, 41.440552],
              [23.97889, 41.441109],
              [24.06639, 41.485275],
              [24.06305, 41.51722],
              [24.06305, 41.520828000000108],
              [24.064999, 41.524437],
              [24.080276, 41.541107],
              [24.09333, 41.549995],
              [24.0975, 41.551109],
              [24.10166, 41.55082700000014],
              [24.157219, 41.541107],
              [24.19999, 41.543785000000128],
              [24.215275, 41.554993],
              [24.24555, 41.567772],
              [24.25389, 41.57],
              [24.26388, 41.570549000000142],
              [24.269444, 41.57],
              [24.304722, 41.548607000000118],
              [24.307777, 41.546387],
              [24.466110000000128, 41.551941000000113],
              [24.564442, 41.503326],
              [24.567497, 41.489441],
              [24.603333, 41.437492000000134],
              [24.608887, 41.43222],
              [24.612499000000128, 41.430275],
              [24.76777600000014, 41.37055],
              [24.809444, 41.352219000000105],
              [24.812496000000124, 41.378326],
              [24.817497, 41.4025],
              [24.819443, 41.405],
              [24.898888, 41.41194],
              [24.903889, 41.41194],
              [25.036507, 41.37044],
              [25.061192, 41.362572],
              [25.163052, 41.31749],
              [25.185833, 41.30527],
              [25.19083, 41.301453],
              [25.239441, 41.254433],
              [25.24389, 41.252769],
              [25.279716000000121, 41.24305],
              [25.285000000000139, 41.24305],
              [25.335831, 41.249161000000129],
              [25.344994, 41.250542],
              [25.50361, 41.289444],
              [25.549995, 41.31304200000011],
              [25.559441, 41.320000000000107],
              [25.567776, 41.32222],
              [25.653049, 41.317772000000105],
              [25.814159, 41.336098000000106],
              [25.881104, 41.309708000000114],
              [25.886662, 41.309166],
              [25.90555, 41.3111],
              [25.97916, 41.31944],
              [25.987778000000105, 41.3211060000001],
              [26.139996, 41.354713],
              [26.198051, 41.439438],
              [26.183884, 41.536942],
              [26.181664, 41.54332],
              [26.137215, 41.629433],
              [26.13472, 41.63221],
              [26.12972, 41.63221],
              [26.117493, 41.628609],
              [26.10305, 41.627213],
              [26.0991590000001, 41.628876],
              [26.068604, 41.660271],
              [26.065826, 41.685822],
              [26.066109, 41.697495000000117],
              [26.074444, 41.711937],
              [26.08083, 41.716660000000104],
              [26.138611000000139, 41.739159],
              [26.163052, 41.746666],
              [26.17194, 41.748322],
              [26.177498000000128, 41.748055000000136],
              [26.22275900000011, 41.7435],
              [26.234772, 41.740028],
              [26.23696, 41.73727],
              [26.264996, 41.71583],
              [26.277222, 41.709991],
              [26.29416700000013, 41.708054],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "HR",
        ISO2: "HR",
        ISO3: "HRV",
        UN: 191,
        NAME: "Croatia",
        AREA: 5592,
        POP2005: 455149,
        REGION: 150,
        SUBREGION: 39,
        LON: 16.693,
        LAT: 45.723,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [16.903889, 42.726105000000132],
              [16.89444, 42.724716000000114],
              [16.83583, 42.727776],
              [16.830276, 42.728882],
              [16.82222, 42.732216],
              [16.812496000000124, 42.74333],
              [16.813889, 42.768051000000128],
              [16.818333, 42.775551],
              [16.86083, 42.777771],
              [16.865276, 42.777771],
              [16.871387, 42.7775],
              [16.927219, 42.773605],
              [16.93278, 42.772499],
              [16.93972, 42.768326000000116],
              [16.940277, 42.760277],
              [16.927219, 42.741104],
              [16.91555, 42.73111],
              [16.911942, 42.729164],
              [16.903889, 42.726105000000132],
            ],
          ],
          [
            [
              [17.744999, 42.69194],
              [17.74, 42.691666000000112],
              [17.727497, 42.698326000000122],
              [17.699718, 42.705551],
              [17.689442, 42.707771],
              [17.634720000000129, 42.71833],
              [17.61138, 42.720551000000114],
              [17.548611, 42.728333],
              [17.372498, 42.757217],
              [17.358608, 42.761665],
              [17.334721, 42.772499],
              [17.328609, 42.777222],
              [17.321663, 42.788055],
              [17.325275, 42.78999],
              [17.363052, 42.802216],
              [17.378052, 42.801941],
              [17.39944, 42.797775000000115],
              [17.662498, 42.736664],
              [17.667221, 42.735275],
              [17.7305530000001, 42.71],
              [17.740276, 42.703049],
              [17.746109, 42.69416],
              [17.744999, 42.69194],
            ],
          ],
          [
            [
              [16.820553, 42.959999],
              [16.863331, 42.956108],
              [16.873608, 42.95694],
              [16.896385, 42.961937],
              [16.911388, 42.968887],
              [16.940552, 42.97333],
              [16.965553000000114, 42.97639],
              [17.01972, 42.97666],
              [17.04472, 42.97527],
              [17.13583, 42.961937],
              [17.183609, 42.91861],
              [17.134441, 42.911659],
              [17.123886, 42.911385000000109],
              [16.981972, 42.928719000000115],
              [16.94111, 42.911385000000109],
              [16.866108, 42.89777400000014],
              [16.831665, 42.903885],
              [16.723610000000122, 42.919441],
              [16.67222, 42.926109],
              [16.660887, 42.921288],
              [16.64082, 42.929462000000115],
              [16.669064, 42.949532],
              [16.707712000000129, 42.956963],
              [16.694334, 42.969597],
              [16.633053, 42.981110000000115],
              [16.63472, 42.983604],
              [16.64333, 42.986664000000133],
              [16.68611, 42.990829000000133],
              [16.72111, 42.984993],
              [16.733608000000117, 42.979996000000142],
              [16.75694, 42.972771],
              [16.772221, 42.969162],
              [16.820553, 42.959999],
            ],
          ],
          [
            [
              [17.298885, 43.006943],
              [17.42610900000011, 42.959999],
              [17.439163, 42.954994],
              [17.4425, 42.953049],
              [17.448055000000124, 42.94778],
              [17.52277800000013, 42.920273000000122],
              [17.661663, 42.874718000000144],
              [17.653053, 42.88694],
              [17.64984, 42.889076000000102],
              [17.684444, 42.918884000000105],
              [17.687775, 42.921661],
              [17.698055, 42.927216000000101],
              [17.714996, 42.926941000000113],
              [17.744442, 42.920273000000122],
              [17.797497, 42.903885],
              [17.84111, 42.870277],
              [17.845276, 42.85972],
              [17.8475, 42.85666700000013],
              [17.876663000000121, 42.823608],
              [17.882774, 42.81916],
              [17.959999, 42.77916],
              [17.98222, 42.768051000000128],
              [17.998886, 42.761383000000137],
              [18.160553, 42.695],
              [18.221943000000124, 42.648888],
              [18.231941, 42.64222],
              [18.264999000000103, 42.620277000000101],
              [18.268608, 42.618332],
              [18.276943, 42.61555],
              [18.28805, 42.614441],
              [18.302498, 42.616943000000106],
              [18.311665, 42.619438000000116],
              [18.335278, 42.62888],
              [18.34666, 42.62917],
              [18.362499000000128, 42.626663],
              [18.397499, 42.614441],
              [18.411942000000124, 42.606384],
              [18.455555, 42.56583],
              [18.453331, 42.521111],
              [18.453331, 42.512497],
              [18.455276, 42.50027],
              [18.460278, 42.48694],
              [18.466389, 42.477776],
              [18.479443000000117, 42.465271000000143],
              [18.49805, 42.451111],
              [18.503197, 42.44944],
              [18.519165, 42.435272000000111],
              [18.521942, 42.432495],
              [18.524998, 42.426384],
              [18.526108000000136, 42.39833],
              [18.524166, 42.396660000000111],
              [18.513054, 42.398888],
              [18.50444, 42.4061],
              [18.357067, 42.496559],
              [18.214722, 42.57944],
              [18.057777, 42.663605],
              [17.87722, 42.767776],
              [17.750000000000114, 42.799164000000133],
              [17.735275, 42.794998],
              [17.5525, 42.840828],
              [17.439163, 42.873886],
              [17.365, 42.915276],
              [17.218052, 42.979164],
              [17.20361, 42.98305],
              [17.198608, 42.983604],
              [17.194721, 42.98194100000012],
              [17.188889, 42.976944],
              [17.18528, 42.974998000000141],
              [17.17388, 42.974998000000141],
              [17.14527500000014, 42.97666],
              [17.071663, 42.986382],
              [17.013054, 43.005272],
              [17.011665, 43.007217],
              [17.004166, 43.046661],
              [17.006664000000114, 43.047775],
              [17.015831, 43.048882],
              [17.26888700000012, 43.01194],
              [17.298885, 43.006943],
            ],
          ],
          [
            [
              [16.20833, 43.022217000000126],
              [16.09333, 43.009995],
              [16.06444, 43.01055],
              [16.050552, 43.06305],
              [16.066109, 43.070274],
              [16.084999, 43.077499000000103],
              [16.103611, 43.081108],
              [16.113888, 43.082222],
              [16.13972, 43.082497000000103],
              [16.184998, 43.08166],
              [16.230553, 43.078331],
              [16.24694, 43.073883],
              [16.25194, 43.072495000000117],
              [16.25333, 43.06916],
              [16.254719, 43.062492],
              [16.252499, 43.05971],
              [16.211388, 43.024719],
              [16.20833, 43.022217000000126],
            ],
          ],
          [
            [
              [16.562035, 43.23085],
              [16.577642000000139, 43.21301],
              [16.595482, 43.218216],
              [16.613331, 43.21388],
              [16.64751, 43.216728000000103],
              [16.660145000000114, 43.211525],
              [16.66222, 43.200272],
              [16.690619, 43.182541000000128],
              [16.699537000000134, 43.166187],
              [16.7196, 43.161728],
              [16.811108, 43.161385],
              [16.961388000000113, 43.149162],
              [17.116386, 43.13611],
              [17.15664, 43.137943],
              [17.190083000000129, 43.126053],
              [17.16407, 43.120106],
              [17.109997000000135, 43.116386],
              [17.057777, 43.112495],
              [16.879719, 43.12055],
              [16.74785, 43.131256000000121],
              [16.666111, 43.119164],
              [16.654163, 43.11972],
              [16.53389, 43.143608],
              [16.464722, 43.160271],
              [16.43055, 43.16944],
              [16.37861, 43.188889],
              [16.374443, 43.190826000000129],
              [16.373055000000136, 43.194160000000124],
              [16.37611, 43.196663],
              [16.379997, 43.198051],
              [16.457222000000115, 43.210274],
              [16.47583, 43.21194],
              [16.51744, 43.207809],
              [16.561293, 43.181053],
              [16.582102, 43.184025000000133],
              [16.55312, 43.21301],
              [16.524872, 43.22193],
              [16.527845, 43.229362],
              [16.544197000000111, 43.224903],
              [16.550142000000108, 43.23308],
              [16.562035, 43.23085],
            ],
          ],
          [
            [
              [16.851665, 43.26916],
              [16.843052, 43.266663000000108],
              [16.826111, 43.267494000000113],
              [16.793331000000137, 43.268608],
              [16.716389, 43.266106],
              [16.706108, 43.265274],
              [16.687222000000133, 43.261665000000107],
              [16.628887, 43.26194],
              [16.577499, 43.268608],
              [16.519722, 43.276382],
              [16.487778, 43.28527],
              [16.418610000000115, 43.31277],
              [16.410831, 43.316666],
              [16.408054, 43.31916],
              [16.40472, 43.325554],
              [16.40472, 43.329720000000123],
              [16.42639, 43.38916],
              [16.429996, 43.391106],
              [16.436108, 43.390831],
              [16.601109, 43.379166],
              [16.700275, 43.368607000000111],
              [16.753052, 43.362778000000105],
              [16.776108, 43.35944400000011],
              [16.805275, 43.352219],
              [16.80944, 43.350555],
              [16.879719, 43.32166],
              [16.883888, 43.319717],
              [16.886665000000107, 43.31721],
              [16.888611, 43.310272],
              [16.887218, 43.297775],
              [16.851665, 43.26916],
            ],
          ],
          [
            [
              [16.390553, 43.332771],
              [16.377220000000136, 43.329163],
              [16.37167, 43.329994],
              [16.314442, 43.34583],
              [16.20861, 43.382774],
              [16.205830000000105, 43.385277],
              [16.19778, 43.403885000000116],
              [16.19722, 43.40749],
              [16.19833, 43.41166],
              [16.206944, 43.41416],
              [16.239441, 43.413887000000102],
              [16.25194, 43.412773000000129],
              [16.279720000000111, 43.408333],
              [16.326385, 43.394165],
              [16.33055, 43.39222],
              [16.389721000000122, 43.340553000000114],
              [16.391109, 43.337219000000118],
              [16.390553, 43.332771],
            ],
          ],
          [
            [
              [15.687498, 43.630829],
              [15.68444, 43.630554],
              [15.666943, 43.63694],
              [15.640833, 43.65083],
              [15.608889, 43.672218],
              [15.606667, 43.674995],
              [15.61055, 43.67555],
              [15.628054, 43.67333200000013],
              [15.631943, 43.67305],
              [15.662222, 43.665833000000134],
              [15.665554, 43.663887],
              [15.703054, 43.636665000000107],
              [15.687498, 43.630829],
            ],
          ],
          [
            [
              [15.34639, 43.80888],
              [15.376669, 43.775925],
              [15.327776, 43.78999],
              [15.253887, 43.836662000000103],
              [15.242498, 43.845833],
              [15.240276, 43.84861],
              [15.227221, 43.866104],
              [15.225832, 43.869438],
              [15.225, 43.873055],
              [15.227499000000137, 43.876106],
              [15.232498, 43.876663000000121],
              [15.238609, 43.874992],
              [15.250832, 43.860275],
              [15.256388, 43.85527],
              [15.26639, 43.84861],
              [15.293333, 43.836105],
              [15.32361, 43.82471],
              [15.34083, 43.813889],
              [15.34639, 43.80888],
            ],
          ],
          [
            [
              [15.44666500000011, 43.887215],
              [15.442221, 43.88611],
              [15.415, 43.889999],
              [15.409443, 43.89111],
              [15.35111, 43.92638],
              [15.302776, 43.959160000000111],
              [15.262499, 44.002495],
              [15.260832, 44.00666],
              [15.265554, 44.009720000000129],
              [15.271944000000133, 44.010826],
              [15.282776, 44.010277],
              [15.376944, 43.968048],
              [15.383055000000127, 43.963333],
              [15.444721, 43.8975],
              [15.448055, 43.890831],
              [15.44666500000011, 43.887215],
            ],
          ],
          [
            [
              [15.250555, 44.016663000000108],
              [15.244165000000123, 44.014999000000103],
              [15.179165, 44.05055],
              [15.129999000000112, 44.084442],
              [15.069443, 44.13277],
              [15.062222, 44.153610000000128],
              [15.062498000000119, 44.157219],
              [15.067499, 44.15749],
              [15.156111, 44.108887],
              [15.172777, 44.099716000000114],
              [15.243055, 44.05305],
              [15.248333, 44.047775],
              [15.25611, 44.022774],
              [15.250555, 44.016663000000108],
            ],
          ],
          [
            [
              [14.855276, 44.175278000000105],
              [14.992498, 44.083611],
              [15.0214, 44.071758],
              [15.026441, 44.042675000000145],
              [15.03666, 44.026939],
              [15.050278000000105, 44.01388500000013],
              [15.0825, 43.986938],
              [15.085554000000116, 43.98444400000011],
              [15.0947, 43.98243],
              [15.098855, 43.985989],
              [15.118146000000138, 43.976791],
              [15.120223, 43.964622000000134],
              [15.125269, 43.959282],
              [15.143055, 43.95166],
              [15.184328, 43.926338000000101],
              [15.216389, 43.911942],
              [15.222776, 43.907494],
              [15.22639, 43.901108000000136],
              [15.22389, 43.898048],
              [15.217222, 43.890831],
              [15.19417, 43.871109000000104],
              [15.18861, 43.871941],
              [15.179998, 43.87527],
              [15.148333, 43.889999],
              [15.137499, 43.896385000000123],
              [15.108055, 43.919998],
              [15.09972, 43.927498000000128],
              [15.071665, 43.9575],
              [15.05722, 43.973885],
              [15.047222, 43.988884],
              [15.03611, 44.003609],
              [15.028889, 44.01194],
              [14.989443000000108, 44.05555],
              [14.977777000000117, 44.065277],
              [14.97139, 44.07],
              [14.935923000000116, 44.090458],
              [14.916943, 44.109161],
              [14.881943, 44.130272],
              [14.86796, 44.13052],
              [14.860243000000139, 44.129929000000118],
              [14.848966, 44.135567],
              [14.83056, 44.1418],
              [14.821364, 44.145954000000131],
              [14.816319, 44.152782],
              [14.816913, 44.15902],
              [14.821364, 44.16346],
              [14.824630000000127, 44.16317],
              [14.824332, 44.155453],
              [14.835314, 44.146252000000118],
              [14.84511, 44.145954000000131],
              [14.85015, 44.150406],
              [14.860837, 44.143581],
              [14.871387, 44.142776],
              [14.859999, 44.156944000000124],
              [14.85389, 44.166107000000125],
              [14.852499000000137, 44.173607],
              [14.855276, 44.175278000000105],
            ],
          ],
          [
            [
              [14.838655, 44.609501000000137],
              [14.872221, 44.606941],
              [14.87555, 44.609161],
              [14.909166, 44.607773],
              [14.92861, 44.598328],
              [14.96027800000013, 44.579163],
              [14.969755, 44.558628],
              [14.98815500000012, 44.542011],
              [15.00834, 44.53281],
              [15.039999000000137, 44.525551],
              [15.043055, 44.523048],
              [15.047499, 44.517220000000123],
              [15.07305, 44.481941],
              [15.074999, 44.478882],
              [15.07222, 44.477219000000105],
              [15.062498000000119, 44.47972],
              [15.054443000000106, 44.483604000000128],
              [15.037718, 44.496601000000112],
              [15.017241, 44.499275],
              [15.010832, 44.51416],
              [14.992607, 44.524204000000111],
              [14.97035, 44.528358],
              [14.9469, 44.545570000000112],
              [14.916038, 44.550915],
              [14.914257000000134, 44.542305],
              [14.936219, 44.536964],
              [14.992311, 44.487995],
              [15.058196000000123, 44.42656],
              [15.097668, 44.408161],
              [15.071848000000102, 44.430717000000129],
              [15.050183, 44.44496],
              [15.042764, 44.475533],
              [15.046389, 44.476662],
              [15.051666, 44.476387],
              [15.055832000000123, 44.47472],
              [15.085278, 44.458611],
              [15.116943, 44.43944],
              [15.240555, 44.35027],
              [15.250000000000114, 44.339165],
              [15.251389, 44.33583],
              [15.248888, 44.327774],
              [15.219166, 44.30583],
              [15.174534, 44.318237],
              [15.174166, 44.296104000000128],
              [15.168888, 44.29555],
              [15.140276, 44.303886],
              [15.132500000000107, 44.30778],
              [15.125277, 44.311943],
              [15.10972, 44.32361],
              [15.101665, 44.331383],
              [15.09861, 44.338051],
              [15.091435, 44.367504],
              [15.112210000000118, 44.37225],
              [15.116959000000122, 44.37878],
              [15.102714000000105, 44.38946],
              [15.078971, 44.396587],
              [15.063539, 44.39065],
              [15.035641, 44.39302],
              [15.023499, 44.421051],
              [14.976284, 44.45594],
              [14.907246, 44.480892],
              [14.898672, 44.49375],
              [14.91783, 44.504887],
              [14.74472, 44.675552],
              [14.736666, 44.68777],
              [14.73361, 44.69416],
              [14.73278, 44.698051],
              [14.73499900000013, 44.70027],
              [14.73944, 44.69861],
              [14.745277, 44.69444],
              [14.789049, 44.660946],
              [14.838655, 44.609501000000137],
            ],
          ],
          [
            [
              [14.521944, 44.474159],
              [14.516666, 44.473328],
              [14.51111, 44.474159],
              [14.367498000000126, 44.590271000000143],
              [14.347776, 44.655273000000136],
              [14.336111, 44.699165],
              [14.335278, 44.707222],
              [14.3375, 44.710274],
              [14.343332, 44.710274],
              [14.380554, 44.69778],
              [14.384998, 44.696106],
              [14.39083, 44.691383],
              [14.39305, 44.688332],
              [14.395277000000135, 44.681389],
              [14.395555, 44.67305],
              [14.39389, 44.659439],
              [14.39416, 44.629997000000117],
              [14.39667, 44.623055],
              [14.407221, 44.603882000000112],
              [14.416111, 44.592216000000121],
              [14.42639, 44.581665],
              [14.476665, 44.53583],
              [14.489721, 44.526665],
              [14.50417, 44.522499],
              [14.515833, 44.51249700000011],
              [14.530554, 44.497772],
              [14.534443, 44.491661],
              [14.534443, 44.487495],
              [14.529999, 44.477219000000105],
              [14.521944, 44.474159],
            ],
          ],
          [
            [
              [14.757311, 44.803753000000142],
              [14.778726, 44.79248],
              [14.825219, 44.762333],
              [14.861944, 44.72166],
              [14.865276, 44.7066650000001],
              [14.861111, 44.705276],
              [14.846666000000141, 44.702499],
              [14.840832, 44.703331000000105],
              [14.836666, 44.704994],
              [14.74111, 44.762772],
              [14.699828, 44.764023],
              [14.65925, 44.794735],
              [14.687993, 44.795300000000111],
              [14.699828, 44.806572],
              [14.726944, 44.79722],
              [14.710278, 44.820274],
              [14.695276, 44.829437],
              [14.686666, 44.836937],
              [14.684999, 44.840271],
              [14.68694, 44.84333],
              [14.72361, 44.853333000000134],
              [14.744999000000121, 44.8475],
              [14.758888, 44.83861],
              [14.757311, 44.803753000000142],
            ],
          ],
          [
            [
              [14.455074, 44.909698000000105],
              [14.445271, 44.87865],
              [14.45944, 44.827499000000103],
              [14.46569, 44.809216000000106],
              [14.459159, 44.780621],
              [14.473864000000106, 44.760197],
              [14.47055, 44.740555],
              [14.475497, 44.700562],
              [14.506388000000129, 44.67083],
              [14.52916, 44.640274],
              [14.531387, 44.633331000000112],
              [14.529999, 44.630554],
              [14.518332, 44.615273],
              [14.51528, 44.612778],
              [14.493332, 44.606384],
              [14.488054, 44.605827],
              [14.483889, 44.607773],
              [14.451111, 44.626389],
              [14.38944400000014, 44.695],
              [14.388902, 44.73242],
              [14.3742, 44.74876],
              [14.365211, 44.797775],
              [14.331388, 44.849716],
              [14.316195, 44.886822],
              [14.294137, 44.9072460000001],
              [14.29659, 44.931755000000123],
              [14.308842, 44.947277],
              [14.339443, 44.91722],
              [14.343332, 44.91499],
              [14.359165, 44.907776],
              [14.365, 44.906944],
              [14.387499, 44.90583],
              [14.39277600000014, 44.906662],
              [14.396944, 44.908051000000114],
              [14.399166, 44.91111],
              [14.400276, 44.91528],
              [14.3925, 44.95611],
              [14.357222, 45.0386],
              [14.353888, 45.045273000000122],
              [14.351665000000139, 45.04833200000013],
              [14.343054, 45.05555],
              [14.339167, 45.05778],
              [14.32111, 45.063889000000131],
              [14.313889, 45.068054000000132],
              [14.308054, 45.073051],
              [14.27528, 45.103333],
              [14.273611, 45.114998000000128],
              [14.273333, 45.119164],
              [14.27611, 45.126663],
              [14.305832, 45.167496],
              [14.31167, 45.172775000000115],
              [14.315277, 45.174995],
              [14.32, 45.175827],
              [14.34833, 45.168327],
              [14.35778, 45.165276000000119],
              [14.363609, 45.160553000000107],
              [14.36972, 45.151382],
              [14.368610000000103, 45.147217],
              [14.365, 45.145271],
              [14.362221, 45.142494],
              [14.358055, 45.136108],
              [14.353888, 45.119164],
              [14.358889, 45.101105],
              [14.376944, 45.052498],
              [14.41, 45.004715],
              [14.418888, 44.99305],
              [14.42639, 44.98472],
              [14.464061, 44.9824],
              [14.476315, 44.95953],
              [14.462426, 44.950542],
              [14.455074, 44.909698000000105],
            ],
          ],
          [
            [
              [14.755833, 44.941383],
              [14.73361, 44.939995000000124],
              [14.721388, 44.940277],
              [14.69833, 44.947777],
              [14.643055, 44.966942],
              [14.638611, 44.968605000000139],
              [14.56291, 45.01998],
              [14.486944, 45.033333],
              [14.47972, 45.037498],
              [14.46361, 45.04805],
              [14.439444, 45.067497],
              [14.433332, 45.072495],
              [14.428888, 45.07833],
              [14.428055, 45.0861],
              [14.429165, 45.090271],
              [14.46406, 45.12455],
              [14.523697, 45.144974],
              [14.53916, 45.239441000000113],
              [14.549166, 45.246109000000104],
              [14.5525, 45.248329000000126],
              [14.557777, 45.24805],
              [14.583055, 45.241943],
              [14.588055, 45.240555],
              [14.59166, 45.238609],
              [14.595554, 45.232216],
              [14.657776, 45.12277],
              [14.704166, 45.068329],
              [14.7925, 45.009163],
              [14.80666, 44.99638],
              [14.813332, 44.987778],
              [14.815554, 44.98055],
              [14.814444, 44.97666],
              [14.804998, 44.969444000000124],
              [14.760555, 44.942497],
              [14.755833, 44.941383],
            ],
          ],
          [
            [
              [16.5725, 46.475273],
              [16.584721, 46.473053],
              [16.599258, 46.47496],
              [16.6078720000001, 46.476234],
              [16.628609, 46.474998000000141],
              [16.66111, 46.465553000000114],
              [16.80139, 46.391388],
              [16.840553, 46.369995],
              [16.866108, 46.355827],
              [16.873886, 46.346939000000134],
              [16.87833, 46.341110000000128],
              [16.878887000000134, 46.337494],
              [16.879025, 46.308571],
              [16.880577, 46.304504],
              [16.889999000000103, 46.284996],
              [16.892776, 46.28249],
              [16.91972, 46.259995],
              [16.937771, 46.249451],
              [16.973053, 46.233604000000128],
              [17.040276000000119, 46.214165],
              [17.149719000000118, 46.181664000000126],
              [17.153889, 46.179993],
              [17.157497, 46.177773],
              [17.179996, 46.157219000000111],
              [17.185555000000136, 46.151939],
              [17.23, 46.097221],
              [17.239441, 46.083611],
              [17.254719, 46.053329],
              [17.25861, 46.023048],
              [17.255554, 46.02055],
              [17.256943, 46.01722],
              [17.311386, 45.975273],
              [17.351109, 45.953331],
              [17.358608, 45.949997],
              [17.389442, 45.938049],
              [17.418053, 45.934715],
              [17.423332, 45.934441000000106],
              [17.431664, 45.937218],
              [17.43472, 45.93972],
              [17.434166, 45.943604000000107],
              [17.432858, 45.945427000000109],
              [17.427776, 45.9525],
              [17.458611, 45.954437],
              [17.576664, 45.94055],
              [17.585278, 45.93694],
              [17.591663, 45.93222],
              [17.62611, 45.90583],
              [17.64027, 45.893051000000128],
              [17.649441000000138, 45.87749],
              [17.652695, 45.853134000000125],
              [17.657219000000111, 45.84083],
              [17.66, 45.83833],
              [17.669441, 45.835],
              [17.880833, 45.783882],
              [18.00639, 45.786942],
              [18.153332, 45.787216],
              [18.189163, 45.784439],
              [18.201942, 45.783333],
              [18.220833, 45.781105000000139],
              [18.230831, 45.778328],
              [18.23805, 45.773888],
              [18.242775, 45.768326],
              [18.250553000000139, 45.764442],
              [18.260830000000112, 45.762497],
              [18.32944, 45.754715],
              [18.335831, 45.75417],
              [18.407497, 45.748329],
              [18.424164, 45.749161],
              [18.443333, 45.752777],
              [18.551666, 45.79833200000013],
              [18.559444, 45.801666000000125],
              [18.595276, 45.825554],
              [18.601665, 45.83027600000014],
              [18.614719, 45.845833],
              [18.62222, 45.856941],
              [18.715553000000114, 45.913605],
              [18.723331, 45.90944],
              [18.78, 45.894722],
              [18.807499, 45.902771],
              [18.817020000000127, 45.91296],
              [18.831654, 45.877129],
              [18.833054, 45.873886],
              [18.88305, 45.828888],
              [18.88972, 45.824997],
              [18.90361, 45.82027],
              [18.908886000000109, 45.81944],
              [18.924442, 45.811943],
              [18.955276, 45.784721],
              [18.957489, 45.781944],
              [18.95861, 45.77861],
              [18.96948, 45.671616],
              [18.969166, 45.667496],
              [18.968357, 45.663017000000139],
              [18.960552, 45.65416],
              [18.939163, 45.630829],
              [18.933609, 45.62527],
              [18.912498, 45.623329000000126],
              [18.909458, 45.620758],
              [18.907215, 45.613281],
              [18.90083, 45.577499000000103],
              [18.902496, 45.570274],
              [18.904785, 45.56728],
              [18.925346000000104, 45.547844000000111],
              [18.933018, 45.541855],
              [18.942181, 45.538681000000111],
              [18.955269, 45.537186],
              [18.965366, 45.538681000000111],
              [18.973969, 45.5413],
              [18.99694, 45.558052],
              [18.999771000000123, 45.561119],
              [19.003887000000134, 45.562492],
              [19.01416, 45.563889],
              [19.020523000000139, 45.562988000000132],
              [19.024719, 45.561386],
              [19.09587, 45.521851],
              [19.099987, 45.515869],
              [19.101673, 45.50895],
              [19.0998, 45.49979],
              [19.094753, 45.493805],
              [19.08784, 45.48950200000013],
              [19.07389, 45.486107],
              [19.057545, 45.48558],
              [19.051666000000125, 45.48666],
              [19.0425, 45.489716000000101],
              [19.030621, 45.49548],
              [19.020523000000139, 45.49866500000013],
              [19.010239, 45.49717],
              [19.0, 45.49083],
              [18.997711, 45.48745],
              [18.996387, 45.48333],
              [18.978054, 45.389717],
              [18.98032400000011, 45.378624],
              [18.98860900000011, 45.370827],
              [19.1125, 45.29805],
              [19.138611, 45.2875],
              [19.190205, 45.270332],
              [19.260521, 45.247429],
              [19.285004, 45.243408000000102],
              [19.320339, 45.238365000000101],
              [19.34446, 45.235001000000125],
              [19.356667, 45.234161],
              [19.38896, 45.235748000000115],
              [19.400093, 45.23583200000013],
              [19.418331, 45.234718],
              [19.423885, 45.22583],
              [19.426109, 45.21],
              [19.42444, 45.18916],
              [19.422775, 45.179993],
              [19.41583, 45.175827],
              [19.41111, 45.174995],
              [19.3525, 45.173332],
              [19.261665, 45.180275],
              [19.250832000000116, 45.182777],
              [19.24722, 45.18471],
              [19.234997000000135, 45.198883],
              [19.21833, 45.208332],
              [19.207331, 45.211662000000103],
              [19.187496, 45.216942],
              [19.171108, 45.216385],
              [19.163609, 45.212219],
              [19.104164, 45.09666],
              [19.115555, 45.031944],
              [19.05083100000013, 44.928055],
              [19.04305, 44.931664],
              [19.036663, 44.932495],
              [19.0325, 44.930832000000123],
              [19.013611, 44.916664],
              [19.01083, 44.91416],
              [19.00611, 44.907776],
              [19.004444, 44.904442],
              [19.004719, 44.900276],
              [19.00944, 44.894440000000145],
              [19.015831, 44.889442000000145],
              [19.02861, 44.880272000000105],
              [19.039719, 44.86138],
              [19.029720000000111, 44.860275],
              [18.96833, 44.853607],
              [18.957222, 44.85305],
              [18.861111000000108, 44.858604000000128],
              [18.849998, 44.860832],
              [18.841389, 44.863609],
              [18.834442, 44.86805],
              [18.794167, 44.894997],
              [18.788055, 44.899719000000118],
              [18.768055, 44.915833],
              [18.761108, 44.938889],
              [18.763885, 44.945],
              [18.773609, 44.944443],
              [18.780552, 44.940277],
              [18.79, 44.938889],
              [18.797775000000115, 44.94221],
              [18.800831, 44.949715],
              [18.79583, 44.989998],
              [18.794167, 44.99721],
              [18.634163, 45.083328],
              [18.41917, 45.108887],
              [18.269722, 45.136665],
              [18.25194, 45.138885],
              [18.233055, 45.135826],
              [18.216663, 45.12971],
              [18.211388, 45.123329],
              [18.210278, 45.114716],
              [18.212776000000133, 45.107773],
              [18.2175, 45.102219000000105],
              [18.218052, 45.095276],
              [18.212776000000133, 45.088882],
              [18.205555, 45.084999],
              [18.197498, 45.0816650000001],
              [18.179165, 45.077774],
              [18.166943, 45.07861],
              [18.130276, 45.082222],
              [18.119999, 45.083328],
              [18.110832, 45.0861],
              [18.070274, 45.104439],
              [17.93305, 45.08027600000014],
              [17.912498, 45.068054000000132],
              [17.87361, 45.050278],
              [17.863888, 45.04833200000013],
              [17.851944, 45.049438000000123],
              [17.832775, 45.05555],
              [17.758053000000132, 45.086662],
              [17.689999, 45.12277],
              [17.596386, 45.108887],
              [17.51955, 45.109512],
              [17.494164000000126, 45.109993],
              [17.48389, 45.111107],
              [17.484444, 45.11805],
              [17.48111, 45.131104000000107],
              [17.2825, 45.176384],
              [17.246666, 45.153053],
              [17.24055, 45.148605],
              [17.230553, 45.146660000000111],
              [17.188332, 45.148048],
              [17.177219, 45.148605],
              [17.07111, 45.188332000000116],
              [17.049999, 45.20138500000013],
              [17.043610000000115, 45.206108],
              [17.040276000000119, 45.212494],
              [17.036388000000102, 45.227219],
              [16.913925, 45.26594],
              [16.846436, 45.20203],
              [16.846882, 45.198456],
              [16.845989, 45.194435],
              [16.838390000000118, 45.190414],
              [16.82444, 45.187492],
              [16.812496000000124, 45.187492],
              [16.682777, 45.204994000000113],
              [16.662777, 45.210274],
              [16.629662, 45.22081],
              [16.60195, 45.230194],
              [16.58988, 45.230194],
              [16.54116, 45.227066],
              [16.530437, 45.226173000000131],
              [16.526386, 45.224442],
              [16.508537000000103, 45.21455],
              [16.50228, 45.20963300000011],
              [16.476387000000102, 45.18583],
              [16.417805, 45.12426],
              [16.366402, 45.04202],
              [16.3597, 45.016548],
              [16.35702, 45.008499000000143],
              [16.35121, 45.003586],
              [16.342712, 45.0009],
              [16.291759, 44.999115],
              [16.26388, 45.008331000000112],
              [16.248055, 45.014999000000103],
              [16.220276, 45.02833],
              [16.209721, 45.034439],
              [16.19722, 45.044441],
              [16.116108, 45.121666000000118],
              [16.109444, 45.130829000000119],
              [16.03611, 45.205826],
              [16.023052, 45.214996],
              [16.015274, 45.21833],
              [15.936666000000116, 45.228607],
              [15.924999, 45.22805],
              [15.8825, 45.2225],
              [15.834166, 45.21194],
              [15.823332, 45.205276],
              [15.81111, 45.195549],
              [15.802500000000123, 45.18805],
              [15.794167, 45.179993],
              [15.786665, 45.171944],
              [15.781111, 45.161942000000124],
              [15.76555, 45.082222],
              [15.76472, 45.07361],
              [15.764999, 45.056389],
              [15.769165, 44.92277],
              [15.743610000000103, 44.829994000000113],
              [15.738888, 44.824165000000107],
              [15.736387, 44.81694],
              [15.736944000000108, 44.812492],
              [15.742222, 44.803604],
              [15.759998, 44.783882],
              [15.7675, 44.776108],
              [15.854721, 44.71444],
              [15.85889, 44.712494000000106],
              [15.864166, 44.711388000000113],
              [15.874998, 44.710274],
              [15.92861, 44.712219000000118],
              [15.939444, 44.710548],
              [15.943888, 44.708611],
              [15.956944000000135, 44.69999700000011],
              [15.961666, 44.693886],
              [16.010555, 44.616943],
              [16.03333, 44.574165],
              [16.07416, 44.530548000000124],
              [16.111664, 44.511383000000137],
              [16.119164000000126, 44.50694],
              [16.126389, 44.498604000000114],
              [16.133331000000112, 44.486107000000118],
              [16.198055, 44.353607000000125],
              [16.19194, 44.313889000000131],
              [16.14333, 44.20416],
              [16.14305, 44.19944],
              [16.14555, 44.196663],
              [16.15, 44.194443],
              [16.16, 44.192772],
              [16.172222, 44.192215],
              [16.199165, 44.195274],
              [16.214443, 44.197495],
              [16.238052, 44.198326],
              [16.249294, 44.196732000000111],
              [16.265, 44.189438],
              [16.280277, 44.176941],
              [16.302219, 44.157219],
              [16.309444, 44.148605],
              [16.31694, 44.135826],
              [16.322498, 44.122215],
              [16.323055, 44.11805],
              [16.32972, 44.104164],
              [16.338886, 44.09333],
              [16.35472, 44.08166],
              [16.415554, 44.043327],
              [16.426666, 44.036942],
              [16.438889, 44.031944],
              [16.463608, 44.026665],
              [16.504719, 44.023048000000131],
              [16.516109, 44.021942],
              [16.52972, 44.017776],
              [16.53722, 44.013611],
              [16.6425, 43.916382],
              [16.650276000000133, 43.908051000000114],
              [16.696663, 43.85611],
              [16.70138500000013, 43.85055],
              [16.707222, 43.84111],
              [16.711941, 43.82638500000013],
              [16.82972, 43.725555],
              [16.937496, 43.621666],
              [16.95583, 43.603333],
              [16.97639, 43.586105],
              [17.04639, 43.54055000000011],
              [17.05972, 43.531944],
              [17.071388, 43.526382],
              [17.098331000000144, 43.51361],
              [17.114998, 43.50694],
              [17.160275, 43.497772],
              [17.223331, 43.47805],
              [17.247776, 43.46833],
              [17.261665000000107, 43.459717000000126],
              [17.269444, 43.451942],
              [17.271111, 43.448608],
              [17.271942, 43.444443],
              [17.270275, 43.436386],
              [17.26194, 43.428604000000121],
              [17.257221000000129, 43.422775],
              [17.25611, 43.414444],
              [17.277222, 43.332771],
              [17.27916, 43.32527],
              [17.285553, 43.30722],
              [17.289719, 43.296944],
              [17.298054, 43.28083],
              [17.309444, 43.270554],
              [17.43472, 43.179443000000106],
              [17.559166000000118, 43.117775000000108],
              [17.571388000000127, 43.112221],
              [17.589443, 43.102219000000105],
              [17.63028, 43.07694],
              [17.643055, 43.063889],
              [17.649719, 43.054993],
              [17.659164, 43.039444],
              [17.664719, 43.02916],
              [17.670555, 43.016663],
              [17.680832, 42.992775],
              [17.688015, 42.9746090000001],
              [17.683609000000104, 42.967216],
              [17.676666000000125, 42.963333],
              [17.668331, 42.960548],
              [17.578526, 42.94382],
              [17.533054, 42.947495],
              [17.51916, 42.951942],
              [17.511665, 42.955826000000116],
              [17.487778, 42.974998000000141],
              [17.47361, 42.987495000000138],
              [17.471664, 42.990555],
              [17.470554, 43.017776],
              [17.454998000000103, 43.033333],
              [17.33027600000014, 43.114441000000113],
              [17.32278, 43.118332],
              [17.25166, 43.15416],
              [17.2225, 43.161385],
              [17.18305, 43.17166],
              [17.178886, 43.173332],
              [17.174721, 43.175278000000105],
              [17.131386, 43.198883],
              [17.073055000000124, 43.23389],
              [17.06333, 43.248055],
              [17.049164, 43.268608],
              [17.040833, 43.276382],
              [16.939999, 43.364716],
              [16.88444, 43.403053],
              [16.878887000000134, 43.40416],
              [16.86083, 43.405273],
              [16.838055000000111, 43.405273],
              [16.81361, 43.406944000000124],
              [16.764164, 43.411385],
              [16.736385, 43.416107000000125],
              [16.64, 43.44028],
              [16.63555, 43.44194],
              [16.618889, 43.448883],
              [16.499165, 43.503052],
              [16.465553, 43.528328000000101],
              [16.473053000000107, 43.531944],
              [16.473053000000107, 43.534996],
              [16.465275000000133, 43.53889],
              [16.433331000000123, 43.545273],
              [16.427776, 43.546104],
              [16.359722, 43.550827],
              [16.348331000000144, 43.550827],
              [16.310276, 43.543053],
              [16.190552, 43.511665],
              [16.17055, 43.495827],
              [16.169998, 43.488052],
              [16.116108, 43.476662],
              [16.105831, 43.47555],
              [16.094444, 43.47555],
              [16.039444, 43.48111],
              [16.034443000000124, 43.482498000000135],
              [15.988333, 43.50444],
              [15.926666000000125, 43.556664],
              [15.9175, 43.568329000000119],
              [15.91555, 43.571388],
              [15.91528, 43.622772],
              [15.91528, 43.626938],
              [15.917221, 43.630554],
              [15.922222, 43.631104],
              [15.931389, 43.628052000000139],
              [15.936943, 43.62722],
              [15.957777000000135, 43.629166000000112],
              [15.967499, 43.630829],
              [15.96917, 43.63361],
              [15.940832, 43.683609000000104],
              [15.787498, 43.754997],
              [15.783333, 43.756660000000124],
              [15.778889, 43.756660000000124],
              [15.688889, 43.77888],
              [15.599443, 43.84528],
              [15.533888, 43.88194],
              [15.533054, 43.88972],
              [15.530832, 43.89277600000014],
              [15.520128000000113, 43.898834],
              [15.49694, 43.910271000000137],
              [15.484999, 43.915833],
              [15.463055, 43.919716],
              [15.451944, 43.925552],
              [15.405554000000109, 43.96527],
              [15.281666, 44.073051],
              [15.23222, 44.119164],
              [15.151667, 44.196388],
              [15.157914, 44.22119],
              [15.11333, 44.26028],
              [15.113888, 44.263885],
              [15.120832000000121, 44.278053000000114],
              [15.123888, 44.28083],
              [15.138332, 44.283333],
              [15.14333, 44.282219],
              [15.146944, 44.279999],
              [15.151943, 44.27472],
              [15.174534, 44.246120000000133],
              [15.203888, 44.254997000000117],
              [15.206587, 44.263927],
              [15.18878, 44.285294],
              [15.208367, 44.2847],
              [15.213116, 44.29242],
              [15.23211, 44.282921],
              [15.284166, 44.246666],
              [15.289444, 44.24721],
              [15.292221, 44.249718000000144],
              [15.29361, 44.25361],
              [15.292776, 44.2575],
              [15.28, 44.30583],
              [15.261788, 44.324471000000131],
              [15.268910000000119, 44.330406],
              [15.287905, 44.32387],
              [15.34189, 44.28749],
              [15.385055, 44.270164],
              [15.414444, 44.259995000000117],
              [15.50611, 44.254166000000112],
              [15.522778, 44.254715],
              [15.527498, 44.255829],
              [15.529999, 44.258888],
              [15.529722, 44.263054],
              [15.52611, 44.269440000000145],
              [15.520555, 44.274437],
              [15.515554, 44.275551],
              [15.503332, 44.276108000000136],
              [15.48139, 44.274994],
              [15.475832, 44.276108000000136],
              [15.451111, 44.282494],
              [15.44611, 44.28388],
              [15.27667, 44.364441],
              [15.264444, 44.373886],
              [15.181665, 44.438606],
              [15.14083, 44.473053],
              [15.095833, 44.518051000000128],
              [15.025276, 44.563606000000107],
              [15.020277, 44.564995000000124],
              [15.00861, 44.56472],
              [15.000832, 44.568604000000107],
              [14.990555, 44.579437],
              [14.975832000000139, 44.596107],
              [14.966389, 44.607216000000108],
              [14.926388, 44.654999],
              [14.896111000000133, 44.69194],
              [14.893332, 44.69861],
              [14.888611, 44.712494000000106],
              [14.88694, 44.71999],
              [14.87889, 44.805275],
              [14.878332, 44.817497000000117],
              [14.87805, 44.83833],
              [14.879166, 44.851662],
              [14.881943, 44.859161],
              [14.891943, 44.88611],
              [14.896111000000133, 44.89277600000014],
              [14.907776, 44.908051000000114],
              [14.911388000000102, 44.91499],
              [14.91917, 44.949165],
              [14.920832, 44.966942],
              [14.91861, 44.973885],
              [14.8425, 45.111664000000133],
              [14.839443, 45.114166],
              [14.824999000000105, 45.117493000000138],
              [14.819166000000109, 45.118332000000123],
              [14.800278, 45.123055],
              [14.757500000000107, 45.134163000000115],
              [14.748055, 45.137215],
              [14.732222, 45.14444],
              [14.717499, 45.152771000000143],
              [14.674444, 45.182220000000143],
              [14.585, 45.25222],
              [14.482777, 45.311104],
              [14.4558320000001, 45.319160000000124],
              [14.441387, 45.323326],
              [14.329443, 45.354439],
              [14.324999, 45.353333],
              [14.318888000000129, 45.348053000000107],
              [14.292776, 45.32499700000011],
              [14.288055, 45.318886],
              [14.282776, 45.30805],
              [14.253887, 45.231941],
              [14.246944, 45.207497000000103],
              [14.245832, 45.203331],
              [14.250000000000114, 45.188889],
              [14.23972, 45.16416],
              [14.231667, 45.145828],
              [14.23, 45.142494],
              [14.21666, 45.123329],
              [14.176388, 45.085548],
              [14.169722, 45.080826],
              [14.16528, 45.079720000000123],
              [14.15416, 45.079994],
              [14.153889, 45.07222],
              [14.155832, 45.039444000000117],
              [14.16555, 45.002495],
              [14.166801000000135, 45.0],
              [14.16889, 44.995827],
              [14.170555, 44.988609],
              [14.16694, 44.981384],
              [14.148611, 44.96416],
              [14.145832, 44.961662],
              [14.14138800000012, 44.961388],
              [14.0875, 44.961388],
              [13.997499, 44.896385000000123],
              [13.992222, 44.88472],
              [13.976387, 44.84888],
              [13.975277, 44.844994],
              [13.974998, 44.825272],
              [13.976665000000139, 44.822777],
              [13.994165, 44.818054],
              [13.996387, 44.815277],
              [13.997221, 44.811386],
              [13.995554, 44.808052],
              [13.91222, 44.770554],
              [13.907221000000106, 44.770828],
              [13.899166, 44.77444],
              [13.820833, 44.854439000000127],
              [13.813055, 44.865829],
              [13.82944300000014, 44.866104],
              [13.842222, 44.876106],
              [13.84333, 44.879997],
              [13.841665, 44.883331],
              [13.756943, 44.981384],
              [13.68111, 45.051384],
              [13.60305, 45.157776],
              [13.595554, 45.24721],
              [13.594444, 45.254166],
              [13.575832, 45.30028],
              [13.533609, 45.401665],
              [13.496387, 45.49083],
              [13.504444, 45.504166],
              [13.50722, 45.506660000000124],
              [13.51111, 45.506386],
              [13.555, 45.494438],
              [13.591740000000129, 45.481697],
              [13.595276000000126, 45.477776],
              [13.607498000000135, 45.468605],
              [13.626944, 45.458885000000123],
              [13.63944400000014, 45.453888],
              [13.647778, 45.45111],
              [13.668055, 45.44639],
              [13.678888, 45.445],
              [13.703609000000142, 45.44416],
              [13.906944000000124, 45.453331],
              [13.952499000000103, 45.456665],
              [13.98139, 45.458885000000123],
              [13.986666, 45.46],
              [13.989166000000125, 45.462776],
              [13.995832, 45.471939],
              [14.13722, 45.475273],
              [14.387499, 45.485275],
              [14.3975, 45.486938],
              [14.407221, 45.489166],
              [14.41972, 45.494164],
              [14.485832, 45.529716],
              [14.495832, 45.541664],
              [14.501389, 45.551666],
              [14.535, 45.612221],
              [14.562498, 45.661659],
              [14.564999, 45.664993],
              [14.57694400000014, 45.669441],
              [14.60139, 45.675278],
              [14.606667, 45.674438000000123],
              [14.609722, 45.671944],
              [14.61167, 45.669167],
              [14.612221, 45.664162],
              [14.609444, 45.639160000000118],
              [14.609722, 45.626938000000109],
              [14.615555, 45.617218],
              [14.62611, 45.606941],
              [14.72361, 45.531387],
              [14.818054000000132, 45.46611],
              [14.82297, 45.464767000000109],
              [14.831673, 45.465454],
              [14.863714, 45.468658],
              [14.907776, 45.476662],
              [14.91132, 45.4785],
              [14.91361, 45.481667],
              [14.918644, 45.493149],
              [14.9790670000001, 45.500473],
              [15.090555, 45.472771000000137],
              [15.0935, 45.470261000000107],
              [15.150555, 45.431938],
              [15.162794, 45.42664],
              [15.174458, 45.425819],
              [15.277222, 45.462776],
              [15.306358, 45.534805],
              [15.30416, 45.537773000000129],
              [15.302677000000131, 45.54097],
              [15.294, 45.594536],
              [15.307089000000133, 45.629868000000101],
              [15.352591, 45.651756],
              [15.368055, 45.702774],
              [15.367498, 45.70694],
              [15.365555, 45.709717],
              [15.358610000000112, 45.714439],
              [15.34833, 45.715553],
              [15.30416, 45.706383],
              [15.305, 45.698051],
              [15.305, 45.693886],
              [15.302776, 45.69083],
              [15.29417, 45.68777],
              [15.28972, 45.689163],
              [15.283333, 45.694717],
              [15.28083, 45.701385],
              [15.281666, 45.705826000000116],
              [15.291943, 45.731110000000115],
              [15.29611, 45.737495000000138],
              [15.309166, 45.751938],
              [15.322498, 45.761383],
              [15.333887, 45.76638800000012],
              [15.49944, 45.835831],
              [15.602777, 45.848610000000122],
              [15.60944, 45.848610000000122],
              [15.61472, 45.8475],
              [15.620277, 45.842216],
              [15.624722, 45.836662],
              [15.634722, 45.82972],
              [15.646387, 45.823883],
              [15.650833, 45.823051],
              [15.656666, 45.823326000000122],
              [15.694443, 45.841942000000131],
              [15.697777, 45.84416],
              [15.72444, 45.938606000000107],
              [15.719444, 46.038887],
              [15.718332, 46.0472180000001],
              [15.714722, 46.053604],
              [15.711666, 46.05583],
              [15.706944, 46.057495],
              [15.679165, 46.065826],
              [15.661388000000102, 46.06721],
              [15.656944000000124, 46.06944],
              [15.636389, 46.082222],
              [15.629444, 46.086937],
              [15.606388, 46.115829000000133],
              [15.599722, 46.142494],
              [15.60111, 46.146111000000133],
              [15.611944, 46.166939],
              [15.649166, 46.213882],
              [15.65472, 46.219444],
              [15.661388000000102, 46.22388],
              [15.67139, 46.226387],
              [15.676666, 46.226662],
              [15.695276, 46.225273],
              [15.797777, 46.23333],
              [16.01722, 46.29805],
              [16.07777, 46.32888800000012],
              [16.08111, 46.33111],
              [16.083332, 46.33416],
              [16.079441, 46.349998],
              [16.0775, 46.352776],
              [16.07416, 46.363609],
              [16.074718, 46.372498000000121],
              [16.07592, 46.384331],
              [16.135830000000112, 46.40527],
              [16.139999, 46.40666],
              [16.266109000000142, 46.419441],
              [16.25, 46.486107],
              [16.24944, 46.49027],
              [16.251858, 46.498924],
              [16.258331, 46.506943],
              [16.2675, 46.514442],
              [16.292507000000114, 46.530815000000132],
              [16.335552, 46.533882],
              [16.38416, 46.53583],
              [16.461388, 46.52166],
              [16.466389000000106, 46.520271],
              [16.49361, 46.510551],
              [16.495831, 46.5075],
              [16.494438, 46.503326000000129],
              [16.498055, 46.501389],
              [16.517792, 46.491646],
              [16.556412, 46.478905000000111],
              [16.5725, 46.475273],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "HU",
        ISO2: "HU",
        ISO3: "HUN",
        UN: 348,
        NAME: "Hungary",
        AREA: 9210,
        POP2005: 10086387,
        REGION: 150,
        SUBREGION: 151,
        LON: 19.134,
        LAT: 47.07,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [18.81702, 45.912964],
            [18.807499, 45.902771],
            [18.779999, 45.894722],
            [18.723331, 45.909439],
            [18.715553, 45.913605],
            [18.622219, 45.856941],
            [18.614719, 45.845833],
            [18.601665, 45.830276],
            [18.595276, 45.825554],
            [18.559444, 45.801666],
            [18.551666, 45.798332],
            [18.443333, 45.752777],
            [18.424164, 45.749161],
            [18.407497, 45.748329],
            [18.335831, 45.754166],
            [18.329441, 45.754715],
            [18.26083, 45.762497],
            [18.250553, 45.764442],
            [18.242775, 45.768326],
            [18.238052, 45.773888],
            [18.230831, 45.778328],
            [18.220833, 45.781105],
            [18.201942, 45.783333],
            [18.189163, 45.784439],
            [18.153332, 45.787216],
            [18.006386, 45.786942],
            [17.880833, 45.783882],
            [17.669441, 45.834999],
            [17.66, 45.838333],
            [17.657219, 45.840828],
            [17.652695, 45.853134],
            [17.649441, 45.877495],
            [17.640274, 45.893051],
            [17.62611, 45.90583],
            [17.591663, 45.93222],
            [17.585278, 45.936943],
            [17.576664, 45.940552],
            [17.458611, 45.954437],
            [17.427776, 45.952499],
            [17.432858, 45.945427],
            [17.434166, 45.943604],
            [17.434719, 45.93972],
            [17.431664, 45.937218],
            [17.423332, 45.934441],
            [17.418053, 45.934715],
            [17.389442, 45.938049],
            [17.358608, 45.949997],
            [17.351109, 45.953331],
            [17.311386, 45.975273],
            [17.256943, 46.01722],
            [17.255554, 46.020554],
            [17.25861, 46.023048],
            [17.254719, 46.053329],
            [17.239441, 46.083611],
            [17.23, 46.097221],
            [17.185555, 46.151939],
            [17.179996, 46.157219],
            [17.157497, 46.177773],
            [17.153889, 46.179993],
            [17.149719, 46.181664],
            [17.040276, 46.214165],
            [16.973053, 46.233604],
            [16.937771, 46.249451],
            [16.91972, 46.259995],
            [16.892776, 46.282494],
            [16.889999, 46.284996],
            [16.880577, 46.304504],
            [16.879025, 46.308571],
            [16.878887, 46.337494],
            [16.87833, 46.34111],
            [16.873886, 46.346939],
            [16.866108, 46.355827],
            [16.840553, 46.369995],
            [16.801388, 46.391388],
            [16.66111, 46.465553],
            [16.628609, 46.474998],
            [16.607872, 46.476234],
            [16.532497, 46.507774],
            [16.529442, 46.510277],
            [16.408607, 46.658882],
            [16.385555, 46.70166],
            [16.375328, 46.722771],
            [16.364998, 46.719162],
            [16.359444, 46.718887],
            [16.356388, 46.721382],
            [16.326385, 46.75444],
            [16.324165, 46.757217],
            [16.313889, 46.785553],
            [16.313889, 46.793884],
            [16.315277, 46.797775],
            [16.318886, 46.799995],
            [16.337219, 46.809166],
            [16.350555, 46.836937],
            [16.350555, 46.84111],
            [16.348888, 46.844444],
            [16.346107, 46.846939],
            [16.303055, 46.867775],
            [16.293331, 46.870827],
            [16.269722, 46.874443],
            [16.231941, 46.876663],
            [16.226944, 46.875832],
            [16.191666, 46.86972],
            [16.180832, 46.863609],
            [16.175831, 46.862495],
            [16.145554, 46.85833],
            [16.140831, 46.85833],
            [16.136387, 46.859993],
            [16.111805, 46.86972],
            [16.136108, 46.877777],
            [16.139721, 46.879997],
            [16.253609, 46.958328],
            [16.276665, 46.988052],
            [16.302776, 47.011383],
            [16.346943, 47.009995],
            [16.412498, 47.007774],
            [16.445, 47.004715],
            [16.481388, 47.000549],
            [16.497776, 47.00222],
            [16.506943, 47.004715],
            [16.510555, 47.00666],
            [16.510555, 47.009995],
            [16.505554, 47.114998],
            [16.466942, 47.146942],
            [16.461666, 47.146385],
            [16.456108, 47.146942],
            [16.452499, 47.148888],
            [16.421944, 47.205826],
            [16.420555, 47.20916],
            [16.420555, 47.213333],
            [16.444721, 47.244438],
            [16.469166, 47.257774],
            [16.47361, 47.259438],
            [16.477219, 47.261383],
            [16.491665, 47.279999],
            [16.491108, 47.283882],
            [16.456387, 47.368889],
            [16.450554, 47.407219],
            [16.450554, 47.41111],
            [16.451942, 47.415276],
            [16.454998, 47.41777],
            [16.459164, 47.419167],
            [16.470833, 47.419716],
            [16.482777, 47.418053],
            [16.592499, 47.425278],
            [16.655205, 47.458153],
            [16.705276, 47.521111],
            [16.713886, 47.543884],
            [16.668888, 47.611664],
            [16.663887, 47.617218],
            [16.648888, 47.629715],
            [16.645275, 47.631943],
            [16.636665, 47.63472],
            [16.630833, 47.635826],
            [16.624722, 47.635826],
            [16.602497, 47.628609],
            [16.590832, 47.629166],
            [16.493053, 47.64666],
            [16.44833, 47.659721],
            [16.429443, 47.666107],
            [16.425831, 47.668327],
            [16.426941, 47.671387],
            [16.450554, 47.698051],
            [16.555832, 47.756104],
            [16.561386, 47.75666],
            [16.612221, 47.759163],
            [16.635555, 47.760277],
            [16.715832, 47.734718],
            [16.723331, 47.730553],
            [16.725555, 47.727493],
            [16.729164, 47.713051],
            [16.734444, 47.703331],
            [16.737221, 47.700829],
            [16.7575, 47.686943],
            [16.761944, 47.685272],
            [16.768608, 47.684715],
            [16.824444, 47.683884],
            [16.910831, 47.690826],
            [16.955276, 47.694717],
            [17.053886, 47.709442],
            [17.071663, 47.728607],
            [17.068607, 47.768326],
            [17.058609, 47.789444],
            [17.054996, 47.799721],
            [17.054443, 47.847221],
            [17.060555, 47.876938],
            [17.108055, 47.971382],
            [17.146942, 48.0],
            [17.166386, 48.012497],
            [17.176388, 48.01944],
            [17.180832, 48.021111],
            [17.19083, 48.023048],
            [17.236664, 48.025833],
            [17.241713, 48.025551],
            [17.251656, 48.024994],
            [17.254166, 48.016106],
            [17.26083, 48.007217],
            [17.264442, 48.004997],
            [17.273331, 48.001663],
            [17.311943, 47.998055],
            [17.335831, 47.998329],
            [17.340553, 47.997498],
            [17.355553, 47.988884],
            [17.411884, 47.944748],
            [17.442219, 47.916664],
            [17.447498, 47.91111],
            [17.448887, 47.907776],
            [17.457775, 47.895828],
            [17.466389, 47.888329],
            [17.485867, 47.877968],
            [17.712219, 47.770554],
            [17.784409, 47.746803],
            [17.790161, 47.746056],
            [17.896942, 47.747551],
            [17.901386, 47.749161],
            [17.916386, 47.75222],
            [17.976109, 47.763611],
            [18.086109, 47.759438],
            [18.119164, 47.756943],
            [18.131664, 47.755272],
            [18.195831, 47.747772],
            [18.297222, 47.737221],
            [18.312222, 47.737778],
            [18.337498, 47.740829],
            [18.378609, 47.747215],
            [18.41333, 47.753883],
            [18.446941, 47.766937],
            [18.451664, 47.767776],
            [18.540833, 47.767494],
            [18.597221, 47.763054],
            [18.636944, 47.759163],
            [18.655277, 47.758606],
            [18.67083, 47.760826],
            [18.675278, 47.762497],
            [18.690552, 47.770271],
            [18.720554, 47.78611],
            [18.726944, 47.791107],
            [18.732498, 47.797218],
            [18.738609, 47.807495],
            [18.749729, 47.813156],
            [18.765831, 47.815552],
            [18.788055, 47.817215],
            [18.84972, 47.817772],
            [18.855831, 47.830276],
            [18.853611, 47.833054],
            [18.82, 47.855553],
            [18.792221, 47.86972],
            [18.787777, 47.871666],
            [18.774441, 47.873329],
            [18.769997, 47.874992],
            [18.766941, 47.877777],
            [18.759441, 47.90361],
            [18.758888, 47.907494],
            [18.75972, 47.921661],
            [18.760555, 47.926109],
            [18.771664, 47.965553],
            [18.827366, 48.036125],
            [18.841576, 48.047195],
            [18.849098, 48.051064],
            [18.904503, 48.057693],
            [18.910069, 48.058258],
            [18.965675, 48.059799],
            [18.989799, 48.067101],
            [19.00127, 48.068954],
            [19.041714, 48.070641],
            [19.13945, 48.061676],
            [19.208336, 48.059448],
            [19.460548, 48.085831],
            [19.472218, 48.087219],
            [19.476383, 48.089165],
            [19.480553, 48.095551],
            [19.494442, 48.127495],
            [19.498608, 48.138329],
            [19.501663, 48.150276],
            [19.50861, 48.17305],
            [19.524166, 48.205826],
            [19.532513, 48.210861],
            [19.540016, 48.213196],
            [19.630554, 48.233887],
            [19.644444, 48.233887],
            [19.66222, 48.231941],
            [19.754997, 48.209442],
            [19.783607, 48.201111],
            [19.787777, 48.199165],
            [19.791111, 48.196938],
            [19.7925, 48.193054],
            [19.788887, 48.181664],
            [19.90361, 48.131943],
            [19.907776, 48.130272],
            [19.912498, 48.129715],
            [19.91861, 48.129997],
            [19.937775, 48.135277],
            [19.941944, 48.137215],
            [19.963608, 48.150276],
            [19.974442, 48.156662],
            [20.004997, 48.172775],
            [20.015274, 48.174995],
            [20.05933, 48.176308],
            [20.09333, 48.198326],
            [20.140553, 48.226105],
            [20.235554, 48.274994],
            [20.276386, 48.256104],
            [20.280277, 48.254166],
            [20.286663, 48.253883],
            [20.291943, 48.254715],
            [20.299721, 48.258606],
            [20.317219, 48.269722],
            [20.340832, 48.28611],
            [20.359165, 48.300278],
            [20.366943, 48.308884],
            [20.400555, 48.355553],
            [20.40361, 48.362778],
            [20.405277, 48.371109],
            [20.411942, 48.394165],
            [20.416386, 48.405273],
            [20.435833, 48.433609],
            [20.443607, 48.442215],
            [20.458611, 48.455276],
            [20.499443, 48.483059],
            [20.500832, 48.50444],
            [20.539719, 48.536942],
            [20.645275, 48.559998],
            [20.660553, 48.563332],
            [20.713333, 48.56916],
            [20.811665, 48.57666],
            [20.818607, 48.576385],
            [20.830276, 48.574997],
            [20.839165, 48.571663],
            [20.847775, 48.563606],
            [20.869999, 48.550827],
            [20.940277, 48.526382],
            [20.949718, 48.523605],
            [20.955276, 48.522499],
            [21.084442, 48.513611],
            [21.153332, 48.511108],
            [21.253887, 48.522217],
            [21.308712, 48.54805],
            [21.43111, 48.576111],
            [21.442776, 48.575272],
            [21.447777, 48.573883],
            [21.507221, 48.548882],
            [21.614166, 48.498329],
            [21.616665, 48.495552],
            [21.620552, 48.488884],
            [21.621666, 48.485275],
            [21.622776, 48.476944],
            [21.622776, 48.46833],
            [21.628052, 48.44944],
            [21.712776, 48.361382],
            [21.718609, 48.356384],
            [21.726665, 48.352493],
            [21.731388, 48.351105],
            [21.777496, 48.340828],
            [21.784443, 48.340553],
            [21.824165, 48.340271],
            [21.828331, 48.342216],
            [21.835831, 48.351105],
            [21.845276, 48.358604],
            [21.848888, 48.361382],
            [21.853054, 48.363052],
            [21.862778, 48.365555],
            [21.935833, 48.379166],
            [21.964996, 48.381943],
            [22.029442, 48.387497],
            [22.056664, 48.386665],
            [22.073055, 48.383606],
            [22.085831, 48.378052],
            [22.096107, 48.376389],
            [22.101665, 48.37722],
            [22.110832, 48.380272],
            [22.150555, 48.408607],
            [22.151442, 48.411919],
            [22.171715, 48.409058],
            [22.205551, 48.41777],
            [22.217216, 48.418602],
            [22.228882, 48.416939],
            [22.268887, 48.407211],
            [22.271385, 48.40416],
            [22.271111, 48.400543],
            [22.269444, 48.396942],
            [22.270275, 48.359993],
            [22.347775, 48.274994],
            [22.378609, 48.245544],
            [22.383331, 48.244156],
            [22.454716, 48.243607],
            [22.484718, 48.250549],
            [22.489716, 48.251663],
            [22.495827, 48.251106],
            [22.5, 48.249355],
            [22.504444, 48.24749],
            [22.507774, 48.24527],
            [22.574718, 48.18721],
            [22.597218, 48.147774],
            [22.598331, 48.143883],
            [22.60194, 48.128601],
            [22.602497, 48.115829],
            [22.604996, 48.113052],
            [22.611532, 48.108433],
            [22.621151, 48.101639],
            [22.630289, 48.099052],
            [22.643522, 48.09531],
            [22.650551, 48.093323],
            [22.670551, 48.092216],
            [22.680828, 48.094154],
            [22.697216, 48.101387],
            [22.737774, 48.114441],
            [22.78194, 48.117493],
            [22.788052, 48.117767],
            [22.79361, 48.116661],
            [22.797497, 48.114716],
            [22.84444, 48.084717],
            [22.846464, 48.083221],
            [22.85083, 48.079994],
            [22.879997, 48.049721],
            [22.882496, 48.046944],
            [22.886108, 48.040276],
            [22.88694, 48.036659],
            [22.886662, 48.031937],
            [22.881107, 48.02166],
            [22.859165, 47.993889],
            [22.894804, 47.95454],
            [22.782776, 47.849159],
            [22.782497, 47.844719],
            [22.780277, 47.84166],
            [22.774441, 47.836388],
            [22.65361, 47.776382],
            [22.634163, 47.77166],
            [22.612221, 47.768608],
            [22.594997, 47.766937],
            [22.557499, 47.766106],
            [22.546944, 47.768051],
            [22.503609, 47.789719],
            [22.5, 47.790852],
            [22.489441, 47.794167],
            [22.472775, 47.796944],
            [22.454441, 47.796387],
            [22.445274, 47.793327],
            [22.323055, 47.747498],
            [22.318886, 47.745827],
            [22.276943, 47.728607],
            [22.270554, 47.723885],
            [22.226387, 47.680832],
            [22.224163, 47.677773],
            [22.191944, 47.630829],
            [22.19083, 47.626663],
            [22.189838, 47.603958],
            [22.186386, 47.59861],
            [22.177219, 47.59111],
            [22.158607, 47.585548],
            [22.118008, 47.57811],
            [22.043053, 47.536942],
            [22.032497, 47.530273],
            [22.023888, 47.522499],
            [22.015274, 47.514442],
            [22.010277, 47.508606],
            [22.006107, 47.496941],
            [22.006664, 47.484161],
            [22.009998, 47.473053],
            [22.018608, 47.456383],
            [22.021942, 47.445274],
            [22.020554, 47.425278],
            [22.015553, 47.395828],
            [22.013054, 47.388054],
            [22.00972, 47.380829],
            [22.0075, 47.377777],
            [22.004719, 47.374992],
            [21.996387, 47.371666],
            [21.985554, 47.369995],
            [21.962498, 47.36805],
            [21.937222, 47.362778],
            [21.932499, 47.361382],
            [21.925552, 47.357216],
            [21.922497, 47.354439],
            [21.874165, 47.299721],
            [21.869164, 47.293327],
            [21.843052, 47.238327],
            [21.841663, 47.234718],
            [21.84111, 47.225555],
            [21.84333, 47.21833],
            [21.846943, 47.211937],
            [21.84861, 47.203888],
            [21.84861, 47.191666],
            [21.844719, 47.184998],
            [21.790833, 47.120277],
            [21.782219, 47.112221],
            [21.769997, 47.106941],
            [21.751389, 47.101662],
            [21.734997, 47.094719],
            [21.709999, 47.07972],
            [21.653889, 47.032494],
            [21.651108, 47.029716],
            [21.651665, 47.025551],
            [21.653332, 47.022499],
            [21.655502, 47.020866],
            [21.690277, 47.010551],
            [21.693607, 47.008049],
            [21.695274, 47.004997],
            [21.695831, 47.000832],
            [21.691944, 46.994164],
            [21.67083, 46.961388],
            [21.613331, 46.884163],
            [21.545555, 46.839439],
            [21.529163, 46.828049],
            [21.526386, 46.825272],
            [21.519722, 46.815277],
            [21.493053, 46.763054],
            [21.488052, 46.752777],
            [21.489166, 46.749161],
            [21.494999, 46.743889],
            [21.502777, 46.739998],
            [21.521664, 46.734718],
            [21.528053, 46.729996],
            [21.529163, 46.726387],
            [21.528332, 46.722221],
            [21.526943, 46.718605],
            [21.521942, 46.712776],
            [21.493889, 46.686943],
            [21.489407, 46.684532],
            [21.467499, 46.685829],
            [21.45472, 46.685555],
            [21.449997, 46.685272],
            [21.441944, 46.681938],
            [21.329441, 46.622772],
            [21.326664, 46.619995],
            [21.324718, 46.616943],
            [21.308887, 46.59166],
            [21.30722, 46.588051],
            [21.29361, 46.532494],
            [21.288887, 46.460548],
            [21.219166, 46.408333],
            [21.208332, 46.402222],
            [21.19722, 46.391388],
            [21.191387, 46.381386],
            [21.185276, 46.362495],
            [21.178608, 46.326942],
            [21.178055, 46.299164],
            [21.176666, 46.295555],
            [21.08083, 46.246941],
            [21.059444, 46.239166],
            [21.053608, 46.238884],
            [21.048332, 46.239998],
            [21.03611, 46.245277],
            [20.989719, 46.254715],
            [20.86861, 46.276108],
            [20.846386, 46.27916],
            [20.82972, 46.277222],
            [20.820274, 46.274719],
            [20.795898, 46.265724],
            [20.783054, 46.259438],
            [20.761387, 46.246941],
            [20.75333, 46.238884],
            [20.720554, 46.191666],
            [20.719997, 46.187492],
            [20.726955, 46.17556],
            [20.72583, 46.171104],
            [20.720554, 46.16555],
            [20.706387, 46.156662],
            [20.69589, 46.150391],
            [20.679443, 46.14222],
            [20.624722, 46.130272],
            [20.619442, 46.131386],
            [20.582775, 46.154999],
            [20.563332, 46.164993],
            [20.535275, 46.17305],
            [20.48695, 46.181107],
            [20.340275, 46.159439],
            [20.285275, 46.146942],
            [20.276665, 46.144722],
            [20.270832, 46.139717],
            [20.264442, 46.130272],
            [20.261024, 46.114853],
            [20.257774, 46.11805],
            [20.20472, 46.149719],
            [20.200832, 46.151382],
            [20.118332, 46.166939],
            [20.112221, 46.167496],
            [19.961109, 46.17083],
            [19.859722, 46.155273],
            [19.850277, 46.152771],
            [19.845833, 46.151382],
            [19.842499, 46.149162],
            [19.74472, 46.162216],
            [19.70372, 46.176392],
            [19.672775, 46.180832],
            [19.660275, 46.181389],
            [19.570553, 46.173607],
            [19.559998, 46.171944],
            [19.50861, 46.143883],
            [19.505833, 46.141106],
            [19.504444, 46.137497],
            [19.506386, 46.134438],
            [19.517498, 46.123886],
            [19.518887, 46.120277],
            [19.517498, 46.116661],
            [19.511387, 46.111664],
            [19.46722, 46.078606],
            [19.460552, 46.074165],
            [19.286388, 45.989441],
            [19.281666, 45.988327],
            [19.16111, 45.986664],
            [19.155277, 45.987221],
            [19.151386, 45.988884],
            [19.148609, 45.991661],
            [19.136387, 46.014999],
            [19.130554, 46.019997],
            [19.123886, 46.023605],
            [19.119164, 46.024994],
            [19.107498, 46.025833],
            [19.096386, 46.024437],
            [19.087776, 46.021385],
            [19.080555, 46.01722],
            [19.012775, 45.968887],
            [19.006664, 45.963882],
            [18.995552, 45.952499],
            [18.858887, 45.91111],
            [18.835831, 45.91111],
            [18.81702, 45.912964],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "IC",
        ISO2: "IS",
        ISO3: "ISL",
        UN: 352,
        NAME: "Iceland",
        AREA: 10025,
        POP2005: 295732,
        REGION: 150,
        SUBREGION: 154,
        LON: -18.48,
        LAT: 64.764,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-15.070835, 66.1436],
            [-15.142223, 66.138046],
            [-15.14889, 66.136108],
            [-15.161667, 66.127777],
            [-15.173334, 66.118881],
            [-15.17639, 66.115829],
            [-15.178335, 66.111938],
            [-15.176945, 66.108047],
            [-15.149445, 66.096375],
            [-15.011391, 66.049988],
            [-14.933889, 66.042221],
            [-14.826668, 66.045547],
            [-14.822224, 66.048325],
            [-14.782778, 66.059708],
            [-14.751667, 66.065277],
            [-14.730556, 66.066101],
            [-14.714724, 66.063599],
            [-14.688334, 66.056107],
            [-14.676945, 66.051666],
            [-14.663057, 66.04361],
            [-14.618891, 65.994431],
            [-14.611113, 65.974442],
            [-14.605835, 65.958054],
            [-14.605278, 65.948883],
            [-14.622223, 65.911102],
            [-14.625557, 65.907776],
            [-14.653057, 65.883041],
            [-14.726946, 65.849152],
            [-14.757223, 65.838882],
            [-14.776112, 65.837219],
            [-14.796946, 65.832214],
            [-14.801111, 65.829437],
            [-14.819168, 65.814163],
            [-14.855278, 65.771378],
            [-14.865557, 65.755829],
            [-14.848333, 65.731384],
            [-14.8325, 65.724442],
            [-14.81778, 65.721375],
            [-14.797224, 65.726379],
            [-14.745834, 65.737488],
            [-14.676668, 65.750549],
            [-14.66889, 65.751938],
            [-14.637222, 65.757217],
            [-14.418056, 65.787216],
            [-14.381668, 65.790833],
            [-14.349445, 65.791382],
            [-14.340279, 65.786102],
            [-14.336668, 65.783051],
            [-14.331945, 65.775543],
            [-14.313057, 65.669708],
            [-14.408611, 65.613876],
            [-14.508335, 65.554443],
            [-14.530834, 65.540833],
            [-14.539446, 65.535263],
            [-14.542501, 65.532211],
            [-14.547501, 65.525269],
            [-14.561945, 65.504166],
            [-14.563612, 65.494995],
            [-14.556112, 65.497498],
            [-14.551668, 65.500275],
            [-14.526669, 65.525833],
            [-14.332779, 65.640823],
            [-14.305557, 65.652496],
            [-14.292501, 65.656097],
            [-14.283611, 65.656387],
            [-14.192223, 65.630554],
            [-14.0, 65.598877],
            [-13.988056, 65.599991],
            [-13.969446, 65.60582],
            [-13.96389, 65.608322],
            [-13.939724, 65.611938],
            [-13.913334, 65.612488],
            [-13.870279, 65.612213],
            [-13.86389, 65.611374],
            [-13.680557, 65.54805],
            [-13.611389, 65.509995],
            [-13.607779, 65.502213],
            [-13.608612, 65.489166],
            [-13.609724, 65.484985],
            [-13.636946, 65.424713],
            [-13.673056, 65.376663],
            [-13.678335, 65.36972],
            [-13.731945, 65.320267],
            [-13.739445, 65.314438],
            [-13.660557, 65.301102],
            [-13.594723, 65.27861],
            [-13.583612, 65.27388],
            [-13.568335, 65.266663],
            [-13.567223, 65.262497],
            [-13.570278, 65.25943],
            [-13.574722, 65.256653],
            [-13.614445, 65.231934],
            [-13.628334, 65.224152],
            [-13.639168, 65.219437],
            [-13.660002, 65.214432],
            [-13.700834, 65.208603],
            [-13.747778, 65.205276],
            [-13.757502, 65.204712],
            [-13.788057, 65.203888],
            [-13.863056, 65.203888],
            [-14.025835, 65.193878],
            [-14.034723, 65.193054],
            [-14.018057, 65.186096],
            [-14.008335, 65.185822],
            [-13.978889, 65.18721],
            [-13.9475, 65.19249],
            [-13.92091, 65.195312],
            [-13.871668, 65.197495],
            [-13.850834, 65.19722],
            [-13.650557, 65.194443],
            [-13.622223, 65.19249],
            [-13.616945, 65.190277],
            [-13.618057, 65.186386],
            [-13.636946, 65.157776],
            [-13.591667, 65.122772],
            [-13.517502, 65.112213],
            [-13.499445, 65.069153],
            [-13.585001, 65.006943],
            [-13.593613, 65.001389],
            [-13.604168, 64.996658],
            [-13.616112, 64.992493],
            [-13.636667, 64.987488],
            [-13.659168, 64.983322],
            [-13.678612, 64.982208],
            [-13.766723, 64.991661],
            [-13.77639, 64.992989],
            [-13.78039, 64.994164],
            [-13.783057, 64.995651],
            [-13.785056, 64.997658],
            [-13.785724, 65.00016],
            [-13.817501, 65.012772],
            [-13.823334, 65.019714],
            [-13.853056, 65.034439],
            [-13.872501, 65.039993],
            [-13.886667, 65.043045],
            [-13.988056, 65.063889],
            [-14.006945, 65.017776],
            [-13.870556, 64.973328],
            [-13.762501, 64.945213],
            [-13.744334, 64.942047],
            [-13.707779, 64.93277],
            [-13.704445, 64.929718],
            [-13.700001, 64.922485],
            [-13.700834, 64.91832],
            [-13.70639, 64.915833],
            [-13.712778, 64.914154],
            [-13.761112, 64.911652],
            [-13.81389, 64.910828],
            [-13.941389, 64.921097],
            [-14.050835, 64.933884],
            [-14.051668, 64.930542],
            [-14.041668, 64.921097],
            [-14.025278, 64.913879],
            [-14.012222, 64.910263],
            [-14.004723, 64.908875],
            [-13.960556, 64.904999],
            [-13.932501, 64.90332],
            [-13.902224, 64.902771],
            [-13.870834, 64.90332],
            [-13.862223, 64.902496],
            [-13.846945, 64.899719],
            [-13.802502, 64.882217],
            [-13.791389, 64.877777],
            [-13.775278, 64.870819],
            [-13.770834, 64.868042],
            [-13.767502, 64.86499],
            [-13.765278, 64.861374],
            [-13.76639, 64.857208],
            [-13.772501, 64.85083],
            [-13.820278, 64.825272],
            [-13.871113, 64.799164],
            [-13.908611, 64.797485],
            [-14.011667, 64.796097],
            [-14.041389, 64.785828],
            [-14.044724, 64.782486],
            [-14.045557, 64.77832],
            [-14.038889, 64.771942],
            [-14.019167, 64.757492],
            [-14.014723, 64.754715],
            [-14.006945, 64.753601],
            [-14.001667, 64.751389],
            [-13.989723, 64.742493],
            [-13.989445, 64.738876],
            [-13.993612, 64.736099],
            [-14.018057, 64.723602],
            [-14.064724, 64.711655],
            [-14.079723, 64.708603],
            [-14.234167, 64.689713],
            [-14.242779, 64.688889],
            [-14.250278, 64.689163],
            [-14.320223, 64.711327],
            [-14.32689, 64.713989],
            [-14.32889, 64.715828],
            [-14.330223, 64.717987],
            [-14.33239, 64.725494],
            [-14.3675, 64.749161],
            [-14.422501, 64.7836],
            [-14.432501, 64.78833],
            [-14.444445, 64.792496],
            [-14.473612, 64.79805],
            [-14.493057, 64.798874],
            [-14.511112, 64.797485],
            [-14.513334, 64.795547],
            [-14.454445, 64.775833],
            [-14.387779, 64.722488],
            [-14.365945, 64.674103],
            [-14.367946, 64.659767],
            [-14.426645, 64.608948],
            [-14.429146, 64.607285],
            [-14.441145, 64.605614],
            [-14.464812, 64.60511],
            [-14.506945, 64.593323],
            [-14.555557, 64.592773],
            [-14.575001, 64.59166],
            [-14.584167, 64.586655],
            [-14.585279, 64.583328],
            [-14.579723, 64.576111],
            [-14.570557, 64.566101],
            [-14.529167, 64.551102],
            [-14.522779, 64.549164],
            [-14.506668, 64.546936],
            [-14.496946, 64.546661],
            [-14.480112, 64.539658],
            [-14.466779, 64.544495],
            [-14.459946, 64.546989],
            [-14.461612, 64.538986],
            [-14.472778, 64.505829],
            [-14.539167, 64.406097],
            [-14.543335, 64.40332],
            [-14.567501, 64.399994],
            [-14.595835, 64.398331],
            [-14.710001, 64.407776],
            [-14.871668, 64.339996],
            [-14.89139, 64.301666],
            [-14.877501, 64.280823],
            [-14.882778, 64.27832],
            [-14.925001, 64.26416],
            [-14.960556, 64.253601],
            [-14.974724, 64.260269],
            [-15.081112, 64.291656],
            [-15.093889, 64.295273],
            [-15.101667, 64.296387],
            [-15.220278, 64.298599],
            [-15.291389, 64.33194],
            [-15.383335, 64.371933],
            [-15.390278, 64.368332],
            [-15.378613, 64.354721],
            [-15.371668, 64.343597],
            [-15.36639, 64.33194],
            [-15.368891, 64.308884],
            [-15.383612, 64.277496],
            [-15.388613, 64.275269],
            [-15.436668, 64.255829],
            [-15.446945, 64.251938],
            [-15.49889, 64.241943],
            [-15.50639, 64.240555],
            [-15.636112, 64.226105],
            [-15.678612, 64.220276],
            [-15.707779, 64.214432],
            [-15.804167, 64.182495],
            [-16.015556, 64.133331],
            [-16.025558, 64.128601],
            [-16.029446, 64.125824],
            [-16.041115, 64.101105],
            [-16.17778, 64.038055],
            [-16.200836, 64.029709],
            [-16.213058, 64.025833],
            [-16.233612, 64.020828],
            [-16.257225, 64.017212],
            [-16.263615, 64.018051],
            [-16.339169, 63.986107],
            [-16.434448, 63.918053],
            [-16.443336, 63.912773],
            [-16.453056, 63.908051],
            [-16.488613, 63.895828],
            [-16.61417, 63.862221],
            [-16.805279, 63.826385],
            [-16.885002, 63.864998],
            [-16.947502, 63.907219],
            [-16.961113, 63.914993],
            [-16.966667, 63.917221],
            [-16.972778, 63.916107],
            [-17.009724, 63.859993],
            [-17.010559, 63.815826],
            [-17.023335, 63.793884],
            [-17.118057, 63.791107],
            [-17.136669, 63.791664],
            [-17.200558, 63.794167],
            [-17.243792, 63.798992],
            [-17.251114, 63.796661],
            [-17.306393, 63.783607],
            [-17.320557, 63.780548],
            [-17.722504, 63.713333],
            [-17.83667, 63.733055],
            [-17.852222, 63.733055],
            [-17.861668, 63.733055],
            [-17.869724, 63.731941],
            [-17.874447, 63.729439],
            [-17.973335, 63.66861],
            [-17.965279, 63.622215],
            [-17.944447, 63.608055],
            [-17.924168, 63.603607],
            [-17.870003, 63.601662],
            [-17.860558, 63.602493],
            [-17.863892, 63.596664],
            [-17.874168, 63.583611],
            [-17.913891, 63.54277],
            [-17.928337, 63.53083],
            [-17.933334, 63.528328],
            [-17.950836, 63.522217],
            [-18.113056, 63.48111],
            [-18.148056, 63.473053],
            [-18.164169, 63.470833],
            [-18.30167, 63.453606],
            [-18.566113, 63.417496],
            [-18.710003, 63.391106],
            [-18.729446, 63.389999],
            [-18.775002, 63.391388],
            [-19.086113, 63.412773],
            [-19.275837, 63.433327],
            [-19.394169, 63.461388],
            [-19.599167, 63.50444],
            [-19.627224, 63.50972],
            [-19.726948, 63.527496],
            [-19.780834, 63.536385],
            [-19.841667, 63.544441],
            [-19.868057, 63.545555],
            [-20.049446, 63.537498],
            [-20.071392, 63.536385],
            [-20.088337, 63.534439],
            [-20.110001, 63.533333],
            [-20.136948, 63.534164],
            [-20.170559, 63.536385],
            [-20.196945, 63.542496],
            [-20.22139, 63.549721],
            [-20.501114, 63.667496],
            [-20.518501, 63.687443],
            [-20.523668, 63.690773],
            [-20.530502, 63.696274],
            [-20.541168, 63.707108],
            [-20.54167, 63.722443],
            [-20.540836, 63.724609],
            [-20.543056, 63.745552],
            [-20.538612, 63.748055],
            [-20.486668, 63.766937],
            [-20.477222, 63.768051],
            [-20.4575, 63.768326],
            [-20.440556, 63.76722],
            [-20.412224, 63.762215],
            [-20.393333, 63.756943],
            [-20.370281, 63.743607],
            [-20.337223, 63.730827],
            [-20.321114, 63.729164],
            [-20.310837, 63.729721],
            [-20.312225, 63.731941],
            [-20.352222, 63.756386],
            [-20.361946, 63.761665],
            [-20.380001, 63.76722],
            [-20.443336, 63.783333],
            [-20.512779, 63.76722],
            [-20.555557, 63.753326],
            [-20.561111, 63.751106],
            [-20.564724, 63.748329],
            [-20.583946, 63.740105],
            [-20.583946, 63.737606],
            [-20.582445, 63.72744],
            [-20.581779, 63.720276],
            [-20.585279, 63.718937],
            [-20.650837, 63.728882],
            [-20.728447, 63.758884],
            [-20.731279, 63.760384],
            [-20.729113, 63.761719],
            [-20.711113, 63.762218],
            [-20.69228, 63.760052],
            [-20.684723, 63.762215],
            [-20.655281, 63.756104],
            [-20.607502, 63.761383],
            [-20.601788, 63.765297],
            [-20.673889, 63.847221],
            [-20.682779, 63.846756],
            [-20.685837, 63.844719],
            [-20.691669, 63.838333],
            [-20.752445, 63.806606],
            [-20.75528, 63.805107],
            [-20.799446, 63.793274],
            [-20.80678, 63.795441],
            [-20.84639, 63.79055],
            [-20.873337, 63.801666],
            [-20.902225, 63.811943],
            [-20.947781, 63.823051],
            [-21.014168, 63.833328],
            [-21.061668, 63.838608],
            [-21.075001, 63.841942],
            [-21.117226, 63.854996],
            [-21.163334, 63.871109],
            [-21.174725, 63.875275],
            [-21.179726, 63.877777],
            [-21.183613, 63.880829],
            [-21.185558, 63.884995],
            [-21.194447, 63.922775],
            [-21.193058, 63.926666],
            [-21.188614, 63.929161],
            [-21.180557, 63.93055],
            [-21.155281, 63.933884],
            [-21.146114, 63.934998],
            [-21.134167, 63.930832],
            [-21.127781, 63.929443],
            [-21.119167, 63.928886],
            [-21.110836, 63.929161],
            [-21.058891, 63.935829],
            [-21.050835, 63.937218],
            [-21.046112, 63.93972],
            [-21.046112, 63.943886],
            [-21.053612, 63.945],
            [-21.169724, 63.954163],
            [-21.186668, 63.954994],
            [-21.195004, 63.95472],
            [-21.203335, 63.953331],
            [-21.257504, 63.943329],
            [-21.264446, 63.941666],
            [-21.300282, 63.918053],
            [-21.319447, 63.887497],
            [-21.369167, 63.867493],
            [-21.431393, 63.849442],
            [-21.618893, 63.823883],
            [-21.639446, 63.822777],
            [-21.654724, 63.824715],
            [-21.682503, 63.835548],
            [-21.70417, 63.844444],
            [-21.854168, 63.852776],
            [-21.93, 63.84111],
            [-21.947224, 63.839722],
            [-22.046671, 63.834721],
            [-22.142223, 63.834717],
            [-22.249447, 63.849998],
            [-22.326115, 63.86055],
            [-22.420002, 63.847221],
            [-22.67028, 63.805832],
            [-22.675835, 63.803604],
            [-22.683334, 63.803604],
            [-22.689167, 63.80555],
            [-22.71917, 63.825554],
            [-22.740002, 63.982773],
            [-22.725559, 64.063889],
            [-22.715557, 64.072769],
            [-22.703335, 64.080826],
            [-22.697502, 64.083054],
            [-22.688335, 64.084152],
            [-22.673889, 64.081665],
            [-22.661114, 64.078323],
            [-22.643612, 64.07222],
            [-22.633614, 64.06749],
            [-22.589725, 64.044434],
            [-22.565834, 64.025833],
            [-22.555279, 64.010818],
            [-22.54528, 63.994995],
            [-22.54528, 63.991943],
            [-22.523056, 63.97805],
            [-22.454723, 63.975273],
            [-22.403893, 63.974442],
            [-22.395557, 63.974998],
            [-22.388615, 63.976662],
            [-22.381947, 63.982773],
            [-22.391113, 63.988327],
            [-22.392223, 63.991943],
            [-22.390003, 63.995277],
            [-22.373337, 64.009995],
            [-22.3675, 64.012207],
            [-22.257225, 64.02916],
            [-22.24778, 64.02916],
            [-22.240837, 64.027771],
            [-22.214725, 64.021378],
            [-22.203056, 64.017212],
            [-22.194447, 64.016937],
            [-22.18639, 64.018051],
            [-22.045559, 64.046661],
            [-21.969448, 64.068329],
            [-21.914722, 64.106934],
            [-21.915558, 64.109711],
            [-21.939445, 64.123322],
            [-21.974445, 64.145828],
            [-21.973335, 64.156937],
            [-21.870556, 64.157486],
            [-21.821945, 64.154434],
            [-21.750557, 64.16333],
            [-21.699448, 64.178879],
            [-21.704723, 64.186661],
            [-21.807781, 64.232498],
            [-21.823334, 64.234436],
            [-21.841393, 64.234711],
            [-21.871948, 64.233597],
            [-21.880001, 64.232208],
            [-21.835835, 64.283875],
            [-21.759167, 64.340271],
            [-21.748611, 64.344986],
            [-21.653336, 64.366943],
            [-21.624168, 64.373596],
            [-21.591114, 64.381104],
            [-21.583057, 64.382492],
            [-21.578056, 64.37999],
            [-21.571667, 64.367767],
            [-21.566669, 64.365265],
            [-21.549446, 64.364441],
            [-21.488892, 64.361938],
            [-21.435001, 64.368332],
            [-21.36278, 64.384987],
            [-21.366669, 64.387772],
            [-21.373611, 64.389435],
            [-21.477779, 64.395828],
            [-21.628056, 64.402496],
            [-21.646114, 64.402771],
            [-21.67778, 64.401108],
            [-21.73278, 64.386932],
            [-21.739445, 64.384995],
            [-21.75, 64.380264],
            [-21.788059, 64.360275],
            [-21.790558, 64.356934],
            [-21.792503, 64.349442],
            [-21.795002, 64.3461],
            [-21.809723, 64.338882],
            [-21.938614, 64.304443],
            [-21.976948, 64.296661],
            [-21.986389, 64.295822],
            [-22.022503, 64.295822],
            [-22.092503, 64.309433],
            [-22.099445, 64.311096],
            [-22.102501, 64.314438],
            [-22.024723, 64.418884],
            [-22.024445, 64.443329],
            [-21.978889, 64.500824],
            [-21.78278, 64.577499],
            [-21.709167, 64.60611],
            [-21.702225, 64.608047],
            [-21.691391, 64.608597],
            [-21.659447, 64.609161],
            [-21.651669, 64.608322],
            [-21.647503, 64.60527],
            [-21.644312, 64.587578],
            [-21.60854, 64.588737],
            [-21.583529, 64.570999],
            [-21.496862, 64.566055],
            [-21.567533, 64.57711],
            [-21.579166, 64.606773],
            [-21.606213, 64.60997],
            [-21.648092, 64.614044],
            [-21.656235, 64.613754],
            [-21.664669, 64.613754],
            [-21.675138, 64.614044],
            [-21.680279, 64.617767],
            [-21.610001, 64.6436],
            [-21.600281, 64.64444],
            [-21.559448, 64.640549],
            [-21.519726, 64.641098],
            [-21.510559, 64.642212],
            [-21.508057, 64.645554],
            [-21.513889, 64.647491],
            [-21.613892, 64.650269],
            [-21.701115, 64.627777],
            [-21.952503, 64.551666],
            [-22.028614, 64.521103],
            [-22.087502, 64.468597],
            [-22.162224, 64.453598],
            [-22.170834, 64.453888],
            [-22.17778, 64.455551],
            [-22.204723, 64.469986],
            [-22.347778, 64.554718],
            [-22.351948, 64.557495],
            [-22.355003, 64.561096],
            [-22.410004, 64.650833],
            [-22.326668, 64.689438],
            [-22.313892, 64.693604],
            [-22.299725, 64.704437],
            [-22.323059, 64.756104],
            [-22.327225, 64.759155],
            [-22.407223, 64.812485],
            [-22.535835, 64.804443],
            [-22.677502, 64.799988],
            [-22.690556, 64.803604],
            [-22.8675, 64.801102],
            [-22.878056, 64.800552],
            [-22.951389, 64.795822],
            [-23.043335, 64.794708],
            [-23.051945, 64.794998],
            [-23.140835, 64.798325],
            [-23.165558, 64.800827],
            [-23.200558, 64.80777],
            [-23.252781, 64.821381],
            [-23.26667, 64.824158],
            [-23.282501, 64.826111],
            [-23.291389, 64.826385],
            [-23.392223, 64.823044],
            [-23.527225, 64.811096],
            [-23.630836, 64.771652],
            [-23.631947, 64.760269],
            [-23.632778, 64.752213],
            [-23.645, 64.744156],
            [-23.663612, 64.737778],
            [-23.831669, 64.72583],
            [-23.840279, 64.726105],
            [-23.847504, 64.727493],
            [-23.901669, 64.739716],
            [-23.908337, 64.741379],
            [-23.918056, 64.746658],
            [-23.945004, 64.764709],
            [-24.01889, 64.825821],
            [-24.047501, 64.853607],
            [-24.050835, 64.856934],
            [-24.059532, 64.890884],
            [-23.943611, 64.916656],
            [-23.872223, 64.924713],
            [-23.833889, 64.927216],
            [-23.815834, 64.922485],
            [-23.777225, 64.911942],
            [-23.751114, 64.904709],
            [-23.716667, 64.897217],
            [-23.695557, 64.893051],
            [-23.670002, 64.891388],
            [-23.649445, 64.892212],
            [-23.634167, 64.895554],
            [-23.550282, 64.917221],
            [-23.544724, 64.919434],
            [-23.537224, 64.929153],
            [-23.522503, 64.940826],
            [-23.503891, 64.94693],
            [-23.363056, 64.96611],
            [-23.353615, 64.966385],
            [-23.23917, 64.990555],
            [-23.236115, 64.993607],
            [-23.220001, 65.004715],
            [-23.205002, 65.012497],
            [-23.190002, 65.015823],
            [-22.980003, 65.011383],
            [-22.971947, 65.010544],
            [-22.96167, 65.005554],
            [-22.9575, 65.002487],
            [-22.61639, 65.021103],
            [-22.613892, 65.024429],
            [-22.59639, 65.031097],
            [-22.565002, 65.041931],
            [-22.529446, 65.050827],
            [-22.521114, 65.051376],
            [-22.355278, 65.059433],
            [-22.322781, 65.056107],
            [-22.276947, 65.049438],
            [-22.231113, 65.04277],
            [-22.228889, 65.038605],
            [-22.225559, 65.035263],
            [-22.218891, 65.0336],
            [-22.172501, 65.02832],
            [-22.146667, 65.026657],
            [-21.949169, 65.025833],
            [-21.835835, 65.030273],
            [-21.800003, 65.060272],
            [-21.729446, 65.157486],
            [-21.727222, 65.160828],
            [-21.728889, 65.173874],
            [-21.73278, 65.191376],
            [-21.733891, 65.196106],
            [-21.736946, 65.199432],
            [-21.742226, 65.201935],
            [-21.759167, 65.203598],
            [-21.786945, 65.204437],
            [-21.808334, 65.203323],
            [-21.822781, 65.199707],
            [-21.831112, 65.194443],
            [-21.836945, 65.188049],
            [-21.83667, 65.183884],
            [-21.836113, 65.174164],
            [-21.878891, 65.155548],
            [-21.913334, 65.142212],
            [-21.994167, 65.115555],
            [-22.036945, 65.109161],
            [-22.070557, 65.104721],
            [-22.078335, 65.104721],
            [-22.279724, 65.127213],
            [-22.540836, 65.156937],
            [-22.547779, 65.1586],
            [-22.557224, 65.163879],
            [-22.560558, 65.167496],
            [-22.56139, 65.171097],
            [-22.505001, 65.228882],
            [-22.399445, 65.27388],
            [-22.353615, 65.289154],
            [-22.310558, 65.299988],
            [-22.277225, 65.305267],
            [-22.233334, 65.310272],
            [-22.217503, 65.312485],
            [-22.160278, 65.32666],
            [-22.056393, 65.362488],
            [-22.02417, 65.376389],
            [-21.982224, 65.39444],
            [-21.919445, 65.413605],
            [-21.912224, 65.415268],
            [-21.857502, 65.420822],
            [-21.818336, 65.422775],
            [-21.786667, 65.423874],
            [-21.762779, 65.428879],
            [-21.704723, 65.44693],
            [-21.698612, 65.449158],
            [-21.805, 65.433609],
            [-21.814724, 65.433609],
            [-21.871391, 65.445831],
            [-21.938614, 65.463043],
            [-21.941391, 65.46582],
            [-21.993057, 65.501099],
            [-22.037781, 65.499435],
            [-22.114723, 65.483322],
            [-22.118336, 65.480545],
            [-22.181114, 65.439438],
            [-22.195278, 65.431931],
            [-22.213337, 65.425552],
            [-22.222778, 65.424438],
            [-22.229725, 65.424988],
            [-22.287781, 65.441376],
            [-22.334057, 65.478386],
            [-22.335392, 65.480881],
            [-22.335558, 65.485718],
            [-22.334225, 65.487717],
            [-22.332224, 65.489548],
            [-22.323559, 65.494217],
            [-22.315725, 65.496552],
            [-22.310724, 65.497383],
            [-22.291725, 65.498047],
            [-22.267557, 65.500214],
            [-22.230003, 65.519714],
            [-22.205833, 65.524155],
            [-22.159168, 65.541656],
            [-22.149723, 65.551102],
            [-22.111115, 65.59166],
            [-22.108612, 65.594986],
            [-22.118614, 65.594711],
            [-22.126114, 65.593048],
            [-22.159447, 65.579437],
            [-22.166668, 65.573608],
            [-22.174725, 65.563889],
            [-22.188892, 65.552216],
            [-22.203056, 65.544434],
            [-22.231945, 65.533325],
            [-22.259445, 65.525833],
            [-22.317614, 65.519272],
            [-22.473614, 65.504715],
            [-22.494724, 65.504166],
            [-22.5, 65.508652],
            [-22.502224, 65.510544],
            [-22.573891, 65.531097],
            [-22.678059, 65.526657],
            [-22.719723, 65.501099],
            [-22.725559, 65.498886],
            [-22.74139, 65.49971],
            [-22.78278, 65.503876],
            [-22.853889, 65.554993],
            [-22.912502, 65.564713],
            [-23.017223, 65.539444],
            [-23.055279, 65.539154],
            [-23.085556, 65.540543],
            [-23.15028, 65.547775],
            [-23.200001, 65.498047],
            [-23.211391, 65.489441],
            [-23.222225, 65.484711],
            [-23.229168, 65.482773],
            [-23.24889, 65.481659],
            [-23.295002, 65.483322],
            [-23.375244, 65.491379],
            [-23.623337, 65.464432],
            [-23.654724, 65.456665],
            [-23.661667, 65.450546],
            [-23.712502, 65.422211],
            [-23.722778, 65.417221],
            [-23.740837, 65.414993],
            [-23.879448, 65.402496],
            [-23.907223, 65.403046],
            [-23.96278, 65.409714],
            [-23.976391, 65.413055],
            [-23.980835, 65.416107],
            [-23.993891, 65.437958],
            [-23.997501, 65.449997],
            [-24.015835, 65.469986],
            [-24.183334, 65.496384],
            [-24.265556, 65.498886],
            [-24.408337, 65.488602],
            [-24.454445, 65.483322],
            [-24.46278, 65.482773],
            [-24.508892, 65.489441],
            [-24.537502, 65.494995],
            [-24.542225, 65.497772],
            [-24.536945, 65.504166],
            [-24.465557, 65.530548],
            [-24.400837, 65.550827],
            [-24.376114, 65.559433],
            [-24.369724, 65.565277],
            [-24.367779, 65.568878],
            [-24.366947, 65.584442],
            [-24.3675, 65.588608],
            [-24.370834, 65.592209],
            [-24.375557, 65.594986],
            [-24.377224, 65.599442],
            [-24.375, 65.602768],
            [-24.367226, 65.608597],
            [-24.326115, 65.636108],
            [-24.31778, 65.637497],
            [-24.309448, 65.636658],
            [-24.157223, 65.608047],
            [-24.150002, 65.606659],
            [-24.143612, 65.604721],
            [-24.135834, 65.598328],
            [-24.126114, 65.593048],
            [-24.120556, 65.590546],
            [-24.050835, 65.564713],
            [-24.038059, 65.560822],
            [-23.892223, 65.518051],
            [-23.876114, 65.516098],
            [-23.845837, 65.518875],
            [-23.81139, 65.52832],
            [-23.805557, 65.530548],
            [-23.806393, 65.532486],
            [-23.912781, 65.553055],
            [-24.012779, 65.594711],
            [-24.058891, 65.623047],
            [-24.06778, 65.628876],
            [-24.071392, 65.632492],
            [-24.081112, 65.643326],
            [-24.083614, 65.647217],
            [-24.075279, 65.64888],
            [-24.065281, 65.64888],
            [-23.960835, 65.642212],
            [-23.947502, 65.638885],
            [-23.910835, 65.626938],
            [-23.81139, 65.607773],
            [-23.803337, 65.607773],
            [-23.804447, 65.610275],
            [-23.814167, 65.615829],
            [-23.829445, 65.623596],
            [-23.869446, 65.63916],
            [-23.916946, 65.655823],
            [-23.929447, 65.659714],
            [-23.938614, 65.659988],
            [-23.954723, 65.661942],
            [-23.993614, 65.667221],
            [-24.001114, 65.66861],
            [-24.014446, 65.671936],
            [-24.038891, 65.679993],
            [-24.059448, 65.690277],
            [-24.072781, 65.699158],
            [-24.110558, 65.732208],
            [-24.121391, 65.742493],
            [-24.124168, 65.750824],
            [-24.133057, 65.782776],
            [-24.131947, 65.786652],
            [-24.125557, 65.792496],
            [-24.113892, 65.801102],
            [-24.105835, 65.806656],
            [-24.100559, 65.807495],
            [-24.023335, 65.796097],
            [-23.946667, 65.77388],
            [-23.824169, 65.738876],
            [-23.730278, 65.720276],
            [-23.682781, 65.713608],
            [-23.633614, 65.703323],
            [-23.620003, 65.699997],
            [-23.608334, 65.695541],
            [-23.573502, 65.673767],
            [-23.571503, 65.671768],
            [-23.567001, 65.664429],
            [-23.554169, 65.649994],
            [-23.553337, 65.641663],
            [-23.527225, 65.627777],
            [-23.411667, 65.650833],
            [-23.343613, 65.666107],
            [-23.365837, 65.669998],
            [-23.386391, 65.66832],
            [-23.452778, 65.672485],
            [-23.513613, 65.696053],
            [-23.516113, 65.697884],
            [-23.539448, 65.71611],
            [-23.537224, 65.719437],
            [-23.495335, 65.724434],
            [-23.480835, 65.727272],
            [-23.461336, 65.730934],
            [-23.450336, 65.730431],
            [-23.442333, 65.728439],
            [-23.436834, 65.728104],
            [-23.366112, 65.731934],
            [-23.254169, 65.738052],
            [-23.232502, 65.739441],
            [-23.226391, 65.741653],
            [-23.192223, 65.775833],
            [-23.205559, 65.77916],
            [-23.214447, 65.77861],
            [-23.233612, 65.772491],
            [-23.255001, 65.766937],
            [-23.307503, 65.758881],
            [-23.400837, 65.754715],
            [-23.53167, 65.750824],
            [-23.548615, 65.751099],
            [-23.582226, 65.754166],
            [-23.728336, 65.77388],
            [-23.743614, 65.776108],
            [-23.756111, 65.779999],
            [-23.772224, 65.787216],
            [-23.837223, 65.826935],
            [-23.847778, 65.837494],
            [-23.873058, 65.866653],
            [-23.873611, 65.870819],
            [-23.871948, 65.878326],
            [-23.870834, 65.881943],
            [-23.868057, 65.88916],
            [-23.865837, 65.892487],
            [-23.84528, 65.910263],
            [-23.835835, 65.915268],
            [-23.829723, 65.917496],
            [-23.81139, 65.919998],
            [-23.793335, 65.919434],
            [-23.675003, 65.900833],
            [-23.638058, 65.894165],
            [-23.446392, 65.864716],
            [-23.255001, 65.837219],
            [-23.230278, 65.834717],
            [-23.220558, 65.835541],
            [-23.213337, 65.837494],
            [-23.213058, 65.839722],
            [-23.21917, 65.84166],
            [-23.302502, 65.85527],
            [-23.378613, 65.867218],
            [-23.438614, 65.877487],
            [-23.563614, 65.900833],
            [-23.585556, 65.905273],
            [-23.603615, 65.911377],
            [-23.746391, 65.96666],
            [-23.801113, 65.996109],
            [-23.805557, 65.998886],
            [-23.816113, 66.00943],
            [-23.81889, 66.013321],
            [-23.819168, 66.017487],
            [-23.81778, 66.029434],
            [-23.815002, 66.036652],
            [-23.800835, 66.056656],
            [-23.789169, 66.065277],
            [-23.783337, 66.06749],
            [-23.767223, 66.070541],
            [-23.733334, 66.067764],
            [-23.636112, 66.04966],
            [-23.62178, 66.047661],
            [-23.617279, 66.046829],
            [-23.530445, 66.029663],
            [-23.413891, 65.998886],
            [-23.409168, 65.996109],
            [-23.399445, 65.990555],
            [-23.393059, 65.988602],
            [-23.377781, 65.986374],
            [-23.371113, 65.986664],
            [-23.416389, 66.026382],
            [-23.425556, 66.032211],
            [-23.510056, 66.057152],
            [-23.52039, 66.057823],
            [-23.532558, 66.057655],
            [-23.537058, 66.058655],
            [-23.59339, 66.079491],
            [-23.603226, 66.083824],
            [-23.613224, 66.091156],
            [-23.665558, 66.111099],
            [-23.666668, 66.114716],
            [-23.579445, 66.161377],
            [-23.541115, 66.177765],
            [-23.535004, 66.179993],
            [-23.473614, 66.199158],
            [-23.46389, 66.200272],
            [-23.446392, 66.198883],
            [-23.352501, 66.191101],
            [-23.273056, 66.174988],
            [-23.160278, 66.144714],
            [-23.031391, 66.10527],
            [-23.025837, 66.102768],
            [-22.98917, 66.084991],
            [-22.985001, 66.082214],
            [-22.981392, 66.078598],
            [-22.978889, 66.074707],
            [-22.977501, 66.070267],
            [-22.978889, 66.034439],
            [-22.809723, 65.994156],
            [-22.760834, 66.053604],
            [-22.756947, 66.056656],
            [-22.748611, 66.058044],
            [-22.67778, 66.044998],
            [-22.616112, 66.011932],
            [-22.605003, 66.002213],
            [-22.590836, 65.983047],
            [-22.576668, 65.963333],
            [-22.587223, 65.930267],
            [-22.59639, 65.913605],
            [-22.598614, 65.910263],
            [-22.612782, 65.898605],
            [-22.621113, 65.888885],
            [-22.645, 65.85582],
            [-22.656391, 65.839157],
            [-22.656113, 65.8311],
            [-22.652779, 65.827499],
            [-22.646389, 65.825546],
            [-22.64167, 65.828049],
            [-22.634445, 65.834152],
            [-22.566948, 65.912491],
            [-22.532223, 65.958328],
            [-22.499725, 65.96611],
            [-22.423336, 65.924164],
            [-22.42028, 65.920822],
            [-22.418613, 65.916382],
            [-22.420559, 65.908875],
            [-22.431667, 65.875549],
            [-22.433891, 65.872208],
            [-22.440834, 65.866379],
            [-22.449448, 65.861099],
            [-22.460003, 65.852219],
            [-22.462502, 65.848877],
            [-22.466667, 65.838043],
            [-22.467781, 65.834152],
            [-22.463612, 65.832214],
            [-22.453613, 65.832214],
            [-22.445004, 65.833603],
            [-22.435558, 65.838882],
            [-22.424725, 65.847488],
            [-22.401669, 65.876938],
            [-22.394726, 65.886932],
            [-22.385834, 65.90416],
            [-22.388336, 65.926941],
            [-22.397503, 65.955826],
            [-22.409447, 65.986374],
            [-22.412781, 65.98999],
            [-22.5, 66.076965],
            [-22.59528, 66.107498],
            [-22.608891, 66.111099],
            [-22.661945, 66.120544],
            [-22.715557, 66.129166],
            [-22.751392, 66.131104],
            [-22.76778, 66.133041],
            [-22.827225, 66.14444],
            [-22.834446, 66.145828],
            [-22.841667, 66.147491],
            [-22.911945, 66.173599],
            [-22.943611, 66.193878],
            [-22.952503, 66.199997],
            [-22.96278, 66.210266],
            [-22.972225, 66.221375],
            [-22.965836, 66.229431],
            [-22.921947, 66.23999],
            [-22.856392, 66.255554],
            [-22.833336, 66.260544],
            [-22.801392, 66.261383],
            [-22.7425, 66.260818],
            [-22.735001, 66.25943],
            [-22.65778, 66.242218],
            [-22.590279, 66.23111],
            [-22.548058, 66.229996],
            [-22.458614, 66.255829],
            [-22.43417, 66.267776],
            [-22.445278, 66.266937],
            [-22.493336, 66.264999],
            [-22.522224, 66.265823],
            [-22.546947, 66.2686],
            [-22.671112, 66.286652],
            [-22.707779, 66.293884],
            [-22.832779, 66.323608],
            [-22.938335, 66.298599],
            [-22.945004, 66.298325],
            [-22.974724, 66.298599],
            [-23.027225, 66.30249],
            [-23.051392, 66.305832],
            [-23.073334, 66.309998],
            [-23.133614, 66.325821],
            [-23.146114, 66.329712],
            [-23.175282, 66.34082],
            [-23.180557, 66.343323],
            [-23.188614, 66.349716],
            [-23.190002, 66.353333],
            [-23.190174, 66.355904],
            [-23.132225, 66.358597],
            [-23.057503, 66.392487],
            [-23.078335, 66.436661],
            [-22.946114, 66.464996],
            [-22.9375, 66.466385],
            [-22.886948, 66.466385],
            [-22.861115, 66.464157],
            [-22.738056, 66.438599],
            [-22.611946, 66.442215],
            [-22.421669, 66.433319],
            [-22.258335, 66.340271],
            [-22.202503, 66.271942],
            [-22.086391, 66.268051],
            [-21.978889, 66.273041],
            [-21.969723, 66.272766],
            [-21.766392, 66.185822],
            [-21.75528, 66.178879],
            [-21.730278, 66.159714],
            [-21.644169, 66.066666],
            [-21.637222, 66.054718],
            [-21.637222, 66.050552],
            [-21.638336, 66.046936],
            [-21.65139, 66.018875],
            [-21.618614, 66.060547],
            [-21.510559, 66.061386],
            [-21.399445, 66.027222],
            [-21.392502, 65.983047],
            [-21.517223, 65.970825],
            [-21.534447, 65.968048],
            [-21.593613, 65.958328],
            [-21.599724, 65.956375],
            [-21.603058, 65.953323],
            [-21.600559, 65.944443],
            [-21.59417, 65.94249],
            [-21.585281, 65.94194],
            [-21.575558, 65.942764],
            [-21.551945, 65.947495],
            [-21.541115, 65.952209],
            [-21.532501, 65.953598],
            [-21.473335, 65.959152],
            [-21.463612, 65.959991],
            [-21.410278, 65.961655],
            [-21.39278, 65.960266],
            [-21.379211, 65.957092],
            [-21.302223, 65.933884],
            [-21.297226, 65.931381],
            [-21.288612, 65.925278],
            [-21.285278, 65.921661],
            [-21.283337, 65.91777],
            [-21.277779, 65.890549],
            [-21.278336, 65.85611],
            [-21.335556, 65.736664],
            [-21.33778, 65.733322],
            [-21.342781, 65.73082],
            [-21.398613, 65.703888],
            [-21.437778, 65.688049],
            [-21.471724, 65.686714],
            [-21.476725, 65.685883],
            [-21.589169, 65.688049],
            [-21.59417, 65.690552],
            [-21.639725, 65.723877],
            [-21.662502, 65.742218],
            [-21.664722, 65.746109],
            [-21.665001, 65.750275],
            [-21.663891, 65.753876],
            [-21.664722, 65.757492],
            [-21.67028, 65.760544],
            [-21.681667, 65.764999],
            [-21.724167, 65.773041],
            [-21.770557, 65.767487],
            [-21.777779, 65.765823],
            [-21.775837, 65.762772],
            [-21.652779, 65.65416],
            [-21.648335, 65.651108],
            [-21.62389, 65.643051],
            [-21.602779, 65.638611],
            [-21.58667, 65.636658],
            [-21.534946, 65.636597],
            [-21.504114, 65.638443],
            [-21.49328, 65.639771],
            [-21.482946, 65.638931],
            [-21.421391, 65.63472],
            [-21.406391, 65.632217],
            [-21.40028, 65.630264],
            [-21.308891, 65.596939],
            [-21.299446, 65.582214],
            [-21.295559, 65.573608],
            [-21.295559, 65.569443],
            [-21.295559, 65.553055],
            [-21.30278, 65.530823],
            [-21.283337, 65.479431],
            [-21.277779, 65.476944],
            [-21.204723, 65.435822],
            [-21.200558, 65.43277],
            [-21.198612, 65.428879],
            [-21.190556, 65.394714],
            [-21.187778, 65.340271],
            [-21.12167, 65.223877],
            [-21.084446, 65.159164],
            [-21.076115, 65.164444],
            [-21.066669, 65.177765],
            [-21.066669, 65.186096],
            [-21.06778, 65.190552],
            [-21.086113, 65.231659],
            [-21.096947, 65.436661],
            [-21.096947, 65.444992],
            [-21.094723, 65.452499],
            [-21.089725, 65.454987],
            [-21.08139, 65.4561],
            [-21.071392, 65.4561],
            [-21.064167, 65.454712],
            [-21.052223, 65.450546],
            [-21.043892, 65.444717],
            [-20.977501, 65.430832],
            [-20.978336, 65.44249],
            [-20.987225, 65.463608],
            [-20.988613, 65.468323],
            [-20.988335, 65.476379],
            [-20.984726, 65.508331],
            [-20.983334, 65.516098],
            [-20.982224, 65.519989],
            [-20.945557, 65.574158],
            [-20.943058, 65.577499],
            [-20.939445, 65.580551],
            [-20.927223, 65.588882],
            [-20.917503, 65.593887],
            [-20.852779, 65.626099],
            [-20.728889, 65.674164],
            [-20.682224, 65.691666],
            [-20.664169, 65.690826],
            [-20.626114, 65.676376],
            [-20.62389, 65.672211],
            [-20.62278, 65.66777],
            [-20.636669, 65.622772],
            [-20.644726, 65.56749],
            [-20.645279, 65.546936],
            [-20.644169, 65.54332],
            [-20.639168, 65.540543],
            [-20.501114, 65.488602],
            [-20.493057, 65.487488],
            [-20.474445, 65.487778],
            [-20.457226, 65.490265],
            [-20.450279, 65.491943],
            [-20.446667, 65.494995],
            [-20.325558, 65.628601],
            [-20.269447, 65.709152],
            [-20.263058, 65.723602],
            [-20.263615, 65.740555],
            [-20.271946, 65.769989],
            [-20.308891, 65.85611],
            [-20.310837, 65.860275],
            [-20.375, 65.924713],
            [-20.398891, 65.953598],
            [-20.415001, 66.00943],
            [-20.419445, 66.043884],
            [-20.424446, 66.083054],
            [-20.420834, 66.085831],
            [-20.179169, 66.12944],
            [-20.16917, 66.12944],
            [-20.094723, 66.12471],
            [-20.090557, 66.121658],
            [-19.993057, 66.024155],
            [-19.940556, 65.957764],
            [-19.926113, 65.939713],
            [-19.921947, 65.936661],
            [-19.874447, 65.910553],
            [-19.847225, 65.89888],
            [-19.789169, 65.88443],
            [-19.771114, 65.883331],
            [-19.751114, 65.884995],
            [-19.743057, 65.884155],
            [-19.736946, 65.881943],
            [-19.700279, 65.861938],
            [-19.698059, 65.857773],
            [-19.661667, 65.789444],
            [-19.656391, 65.771652],
            [-19.6525, 65.763611],
            [-19.647503, 65.756104],
            [-19.635559, 65.746933],
            [-19.607502, 65.740555],
            [-19.460556, 65.725555],
            [-19.451668, 65.72583],
            [-19.42667, 65.733047],
            [-19.422779, 65.736099],
            [-19.396389, 65.789154],
            [-19.390278, 65.828598],
            [-19.390003, 65.832764],
            [-19.390835, 65.83638],
            [-19.417778, 65.883331],
            [-19.450558, 65.922211],
            [-19.467781, 65.933884],
            [-19.472778, 65.936386],
            [-19.485001, 65.940552],
            [-19.475834, 65.98111],
            [-19.455833, 66.053055],
            [-19.453056, 66.056381],
            [-19.43639, 66.063324],
            [-19.387501, 66.080551],
            [-19.380001, 66.082214],
            [-19.260281, 66.089722],
            [-19.231113, 66.091385],
            [-19.150837, 66.083878],
            [-19.079723, 66.077499],
            [-19.090836, 66.124985],
            [-19.090279, 66.133331],
            [-19.087502, 66.140549],
            [-19.08028, 66.150833],
            [-19.077503, 66.15416],
            [-19.069725, 66.159988],
            [-19.064724, 66.162491],
            [-18.991112, 66.183319],
            [-18.968613, 66.188324],
            [-18.857224, 66.201111],
            [-18.848057, 66.200546],
            [-18.791389, 66.192764],
            [-18.784168, 66.191101],
            [-18.683056, 66.164719],
            [-18.653057, 66.149429],
            [-18.630001, 66.135544],
            [-18.555836, 66.087769],
            [-18.548058, 66.081665],
            [-18.533337, 66.063889],
            [-18.519169, 66.024155],
            [-18.52, 66.015823],
            [-18.532223, 66.003326],
            [-18.540001, 65.984711],
            [-18.540836, 65.976379],
            [-18.540001, 65.972763],
            [-18.536114, 65.969711],
            [-18.530003, 65.967773],
            [-18.442501, 65.954987],
            [-18.377781, 65.948318],
            [-18.358612, 65.947495],
            [-18.335556, 65.943054],
            [-18.325558, 65.937775],
            [-18.283337, 65.9086],
            [-18.206669, 65.821106],
            [-18.205002, 65.811935],
            [-18.182503, 65.73999],
            [-18.180557, 65.736099],
            [-18.091667, 65.657486],
            [-18.069447, 65.643326],
            [-18.063335, 65.64444],
            [-18.051392, 65.653046],
            [-18.048615, 65.656387],
            [-18.046947, 65.659988],
            [-18.046669, 65.664154],
            [-18.0625, 65.824432],
            [-18.070278, 65.838333],
            [-18.101112, 65.893326],
            [-18.145, 65.922775],
            [-18.152225, 65.924164],
            [-18.158337, 65.922211],
            [-18.164169, 65.915833],
            [-18.168056, 65.913055],
            [-18.174446, 65.910828],
            [-18.183334, 65.910553],
            [-18.221111, 65.929153],
            [-18.290001, 66.008606],
            [-18.293056, 66.012207],
            [-18.315556, 66.056656],
            [-18.317501, 66.060822],
            [-18.333057, 66.147766],
            [-18.332779, 66.151932],
            [-18.329723, 66.154999],
            [-18.299446, 66.174713],
            [-18.290836, 66.175827],
            [-18.254448, 66.179993],
            [-18.246391, 66.178879],
            [-18.218891, 66.171936],
            [-18.163059, 66.166931],
            [-18.083057, 66.159988],
            [-18.016113, 66.156662],
            [-17.968334, 66.154434],
            [-17.950836, 66.152222],
            [-17.912781, 66.145554],
            [-17.90667, 66.143326],
            [-17.752781, 66.080276],
            [-17.735001, 66.068878],
            [-17.722504, 66.059998],
            [-17.609169, 65.987488],
            [-17.419445, 65.984436],
            [-17.416389, 65.987778],
            [-17.365002, 66.054993],
            [-17.341667, 66.101379],
            [-17.265556, 66.166931],
            [-17.23278, 66.189713],
            [-17.222225, 66.194443],
            [-17.214725, 66.196106],
            [-17.131111, 66.210541],
            [-17.103336, 66.212769],
            [-17.04528, 66.208878],
            [-17.037224, 66.207764],
            [-17.023056, 66.204437],
            [-16.9925, 66.194153],
            [-16.968891, 66.185547],
            [-16.910004, 66.12471],
            [-16.736946, 66.114716],
            [-16.594723, 66.09111],
            [-16.656391, 66.125824],
            [-16.660004, 66.128876],
            [-16.688614, 66.159439],
            [-16.685558, 66.162491],
            [-16.558334, 66.189987],
            [-16.52639, 66.196106],
            [-16.508892, 66.198318],
            [-16.448059, 66.228043],
            [-16.43639, 66.236099],
            [-16.42778, 66.247208],
            [-16.416946, 66.270828],
            [-16.416389, 66.274994],
            [-16.418056, 66.27916],
            [-16.425835, 66.289719],
            [-16.509167, 66.392212],
            [-16.577225, 66.474991],
            [-16.578892, 66.478882],
            [-16.566948, 66.491943],
            [-16.563614, 66.49527],
            [-16.555557, 66.500824],
            [-16.527779, 66.508041],
            [-16.469448, 66.514709],
            [-16.430836, 66.517212],
            [-16.356392, 66.511658],
            [-16.24139, 66.511658],
            [-16.178059, 66.534439],
            [-16.172501, 66.534988],
            [-16.028893, 66.536102],
            [-16.021946, 66.536102],
            [-15.956945, 66.511383],
            [-15.894167, 66.487488],
            [-15.854168, 66.416931],
            [-15.832779, 66.414993],
            [-15.709723, 66.397217],
            [-15.698334, 66.383331],
            [-15.683889, 66.349991],
            [-15.681946, 66.341385],
            [-15.685835, 66.334152],
            [-15.688612, 66.330826],
            [-15.720556, 66.30777],
            [-15.73889, 66.296936],
            [-15.749723, 66.292221],
            [-15.728889, 66.265274],
            [-15.697779, 66.23082],
            [-15.691389, 66.224152],
            [-15.558889, 66.216385],
            [-15.381945, 66.142776],
            [-15.375278, 66.14444],
            [-15.370001, 66.146942],
            [-15.358057, 66.155823],
            [-15.340557, 66.175552],
            [-15.338612, 66.179153],
            [-15.331112, 66.198318],
            [-15.327778, 66.214722],
            [-15.212502, 66.26416],
            [-15.146112, 66.269989],
            [-15.128334, 66.271942],
            [-15.11278, 66.274994],
            [-15.099445, 66.278885],
            [-15.011946, 66.334152],
            [-15.007778, 66.341385],
            [-15.001806, 66.348831],
            [-15.0, 66.349861],
            [-14.970001, 66.366943],
            [-14.960279, 66.371933],
            [-14.943611, 66.378876],
            [-14.930279, 66.382767],
            [-14.906668, 66.386932],
            [-14.888889, 66.38916],
            [-14.855835, 66.389709],
            [-14.836668, 66.388611],
            [-14.710835, 66.367218],
            [-14.710835, 66.347763],
            [-14.804445, 66.326111],
            [-14.963612, 66.289444],
            [-14.976946, 66.285553],
            [-15.001112, 66.277222],
            [-15.006668, 66.274719],
            [-15.009724, 66.271652],
            [-15.010834, 66.267487],
            [-14.989723, 66.257767],
            [-14.975834, 66.254166],
            [-14.971111, 66.251663],
            [-14.948612, 66.233322],
            [-14.940279, 66.222763],
            [-14.9375, 66.219162],
            [-14.935556, 66.20694],
            [-14.93639, 66.203049],
            [-14.940556, 66.195541],
            [-14.945835, 66.188889],
            [-14.962778, 66.177765],
            [-14.976946, 66.169708],
            [-15.023056, 66.155548],
            [-15.070835, 66.1436],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "IS",
        ISO2: "IL",
        ISO3: "ISR",
        UN: 376,
        NAME: "Israel",
        AREA: 2171,
        POP2005: 6692037,
        REGION: 142,
        SUBREGION: 145,
        LON: 34.851,
        LAT: 31.026,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [35.25972, 31.787220000000104],
              [35.25444, 31.78639],
              [35.251663000000121, 31.788055],
              [35.243607, 31.803886],
              [35.24638, 31.80805],
              [35.248886, 31.808887000000141],
              [35.256386000000134, 31.80805],
              [35.26361, 31.803608],
              [35.262497, 31.789719000000105],
              [35.25972, 31.787220000000104],
            ],
          ],
          [
            [
              [35.62363, 33.245728],
              [35.626663000000121, 33.244164],
              [35.62944, 33.244164],
              [35.63358, 33.2466],
              [35.640274, 33.250549],
              [35.651382000000126, 33.255554],
              [35.66777, 33.252777],
              [35.669617, 33.251717],
              [35.676384, 33.251106000000107],
              [35.681938, 33.249161],
              [35.683052, 33.238884],
              [35.66902, 33.212173],
              [35.666939000000127, 33.205276],
              [35.652496, 33.124992],
              [35.650024, 33.091209000000106],
              [35.642494000000113, 33.050552],
              [35.634995000000117, 33.000000000000114],
              [35.634163, 32.940552],
              [35.633331000000112, 32.930832],
              [35.62722, 32.91],
              [35.621941, 32.901665],
              [35.614464000000112, 32.8949],
              [35.618607, 32.89138800000012],
              [35.639160000000118, 32.867493],
              [35.64222, 32.860550000000103],
              [35.642494000000113, 32.849716],
              [35.639206, 32.81531],
              [35.65666, 32.807495],
              [35.662216, 32.803329000000133],
              [35.664993, 32.79666],
              [35.667496, 32.781387000000109],
              [35.665482, 32.761993],
              [35.651939, 32.727493],
              [35.64666, 32.702774],
              [35.648888, 32.685272],
              [35.631935, 32.687218000000144],
              [35.627762000000132, 32.686096],
              [35.615829, 32.680275],
              [35.609764, 32.676132],
              [35.571938000000102, 32.645828],
              [35.54694400000011, 32.405],
              [35.55257, 32.394196],
              [35.48111, 32.412773],
              [35.425278, 32.48333],
              [35.422493, 32.48805],
              [35.412216, 32.500832000000116],
              [35.40416, 32.507500000000107],
              [35.35805, 32.522217000000126],
              [35.349716000000114, 32.523888],
              [35.347221, 32.523888],
              [35.32278, 32.517776],
              [35.311943, 32.516106],
              [35.29555, 32.515549000000135],
              [35.282494, 32.516937],
              [35.268883, 32.519722],
              [35.258049, 32.523605],
              [35.208054, 32.546387],
              [35.179443000000106, 32.527496],
              [35.092773000000136, 32.480827],
              [35.079994000000113, 32.470551],
              [35.077217, 32.46722],
              [35.06638, 32.44722],
              [35.056664000000126, 32.425278000000105],
              [35.04722, 32.394440000000145],
              [35.04583, 32.383331],
              [35.04833200000013, 32.371384],
              [35.04722, 32.363609],
              [35.026939, 32.240829000000133],
              [35.02416, 32.237778000000105],
              [34.979164, 32.15305],
              [34.985832, 32.132500000000107],
              [35.006104000000107, 32.054161],
              [35.0075, 32.028053],
              [35.00086, 31.985317000000123],
              [34.987495000000138, 31.968887000000109],
              [34.96611, 31.86138],
              [34.965557, 31.830551000000128],
              [34.971107, 31.824718000000132],
              [34.979164, 31.821941],
              [35.01416, 31.82027],
              [35.035828, 31.82222],
              [35.10828400000014, 31.833073],
              [35.153053, 31.813053],
              [35.209717000000126, 31.75],
              [35.166939, 31.745831],
              [35.158882000000119, 31.743889],
              [35.0975, 31.708332],
              [35.001663, 31.64694],
              [34.98555, 31.633331],
              [34.961365000000114, 31.603355000000136],
              [34.95361, 31.594719],
              [34.950829, 31.589722000000108],
              [34.948326, 31.581387],
              [34.945831, 31.559166],
              [34.95027, 31.51888700000012],
              [34.947777, 31.503609],
              [34.945, 31.495552],
              [34.942497, 31.489998],
              [34.937218, 31.481667],
              [34.910553, 31.443886],
              [34.89194, 31.420277],
              [34.884438, 31.40472],
              [34.884995000000117, 31.391388],
              [34.88777, 31.3825],
              [34.890549, 31.377499],
              [34.896111, 31.370831],
              [34.90416, 31.363609],
              [34.912216000000114, 31.357498000000135],
              [34.922775, 31.352219],
              [34.933609, 31.349998],
              [34.94694, 31.350277],
              [35.138611, 31.361942000000113],
              [35.211105, 31.374996],
              [35.229721, 31.37861],
              [35.24055, 31.384163],
              [35.259163, 31.40361],
              [35.373329, 31.481110000000115],
              [35.383888, 31.48722],
              [35.39608, 31.492119],
              [35.405273, 31.494999],
              [35.443054, 31.49944],
              [35.45916, 31.49944],
              [35.478195, 31.497322],
              [35.478607, 31.449165],
              [35.476387, 31.427776],
              [35.47388, 31.411942],
              [35.471107000000131, 31.400833],
              [35.452499000000103, 31.351387],
              [35.411385, 31.225277],
              [35.432777, 31.200275],
              [35.454163000000108, 31.170555],
              [35.459442, 31.158333],
              [35.462219, 31.149441],
              [35.462219, 31.121109],
              [35.454994000000113, 31.09972],
              [35.402214, 30.955818],
              [35.396378, 30.94721600000014],
              [35.390976000000137, 30.942017],
              [35.368134, 30.928661],
              [35.361107, 30.924164],
              [35.35472, 30.91805],
              [35.337776, 30.88694],
              [35.299995, 30.791111],
              [35.292496, 30.759163],
              [35.255554, 30.681942000000106],
              [35.219719000000111, 30.621944],
              [35.20611, 30.594719],
              [35.158607, 30.444164000000114],
              [35.15609, 30.415279000000112],
              [35.161385, 30.319443],
              [35.166939, 30.151665],
              [35.164719, 30.126389],
              [35.162216, 30.11889],
              [35.15694, 30.10944400000011],
              [35.143883, 30.094166],
              [35.12527, 30.0775],
              [35.112221, 30.062496000000124],
              [35.106941, 30.05611],
              [35.104439000000127, 30.051666],
              [35.101662, 30.043888],
              [35.073051, 29.953609000000142],
              [35.07222, 29.920830000000137],
              [35.07222, 29.898052],
              [35.073326000000122, 29.885277],
              [35.07611, 29.876663],
              [35.075554, 29.858887],
              [35.00722, 29.64083],
              [34.974625, 29.577015],
              [34.97749, 29.570000000000107],
              [34.97998, 29.545753000000104],
              [34.965828000000101, 29.549164],
              [34.96256, 29.55146],
              [34.938049, 29.52333],
              [34.903801, 29.486706],
              [34.877777, 29.532497],
              [34.862495, 29.598888],
              [34.870277, 29.614441000000113],
              [34.873329000000126, 29.623333],
              [34.874443, 29.63833],
              [34.873886, 29.645554000000118],
              [34.871666, 29.656109],
              [34.847771, 29.740833],
              [34.75361, 29.991108],
              [34.723343, 30.089344],
              [34.614441, 30.364998],
              [34.545273, 30.406944],
              [34.543327, 30.434719],
              [34.558884, 30.486111],
              [34.489441000000113, 30.691109],
              [34.401382, 30.85944400000011],
              [34.287498, 31.162777],
              [34.267578000000128, 31.216541],
              [34.33416, 31.25972],
              [34.367775, 31.291111000000114],
              [34.37055, 31.29472],
              [34.373055000000136, 31.29972],
              [34.373604, 31.31444],
              [34.364998000000128, 31.34777],
              [34.364166, 31.36083200000013],
              [34.388885, 31.394722],
              [34.478607, 31.471107],
              [34.513329, 31.498608],
              [34.539993, 31.514721],
              [34.558609, 31.533054],
              [34.559166000000118, 31.546944],
              [34.490547, 31.596096000000102],
              [34.49528, 31.603333],
              [34.51111, 31.626389000000131],
              [34.553886, 31.683887],
              [34.586105, 31.72694],
              [34.669998000000135, 31.874996],
              [34.70472, 31.940277],
              [34.711937, 31.954998],
              [34.729996, 32.000832],
              [34.731667, 32.006386],
              [34.732773000000122, 32.014442],
              [34.778885, 32.12555],
              [34.797775000000115, 32.178055],
              [34.802803, 32.192368],
              [34.83416, 32.29083],
              [34.868332, 32.407494],
              [34.871109000000104, 32.414444],
              [34.873886, 32.424995000000138],
              [34.89555, 32.510277],
              [34.939163, 32.71333],
              [34.945549000000142, 32.758049],
              [34.945549000000142, 32.776108000000136],
              [34.94694, 32.808609],
              [34.950554, 32.823883000000137],
              [34.953888, 32.828049],
              [34.961388, 32.833054],
              [34.98083, 32.839165],
              [34.983330000000137, 32.839165],
              [34.988052, 32.836388],
              [35.003883, 32.82444],
              [35.012772, 32.815552],
              [35.01722, 32.815277],
              [35.032494, 32.82222],
              [35.035828, 32.824165],
              [35.056389000000138, 32.84333],
              [35.06694, 32.854996000000142],
              [35.070831000000112, 32.863327],
              [35.075554, 32.88222],
              [35.077675, 32.89258],
              [35.072495000000117, 32.94694],
              [35.071663, 32.961937],
              [35.078888, 32.986938],
              [35.088051, 33.018051],
              [35.101944000000117, 33.068886000000134],
              [35.10305000000011, 33.077499000000103],
              [35.102776, 33.08833],
              [35.10083, 33.093605],
              [35.109444, 33.095551],
              [35.264999000000103, 33.09861],
              [35.32194, 33.088051000000121],
              [35.34916, 33.06305],
              [35.35472, 33.06194],
              [35.376389, 33.06194],
              [35.379166, 33.06222],
              [35.422775, 33.067772],
              [35.428329, 33.068886000000134],
              [35.50471, 33.09416],
              [35.505829, 33.10194],
              [35.505829, 33.11499],
              [35.522217, 33.123604000000114],
              [35.524994000000106, 33.12555],
              [35.527771, 33.12888],
              [35.543053, 33.188889000000131],
              [35.542496000000142, 33.204163],
              [35.585548, 33.270271],
              [35.62363, 33.245728],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "IT",
        ISO2: "IT",
        ISO3: "ITA",
        UN: 380,
        NAME: "Italy",
        AREA: 29411,
        POP2005: 5864636,
        REGION: 150,
        SUBREGION: 39,
        LON: 12.8,
        LAT: 42.7,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.127777, 47.001663000000121],
              [12.13611, 46.966942],
              [12.160276000000124, 46.92805],
              [12.181389000000138, 46.909721],
              [12.189722, 46.906105000000139],
              [12.232222, 46.888885],
              [12.301666, 46.84111],
              [12.378611, 46.72666],
              [12.388887000000125, 46.715553],
              [12.398333, 46.708328],
              [12.410276, 46.70277],
              [12.440554, 46.690826000000129],
              [12.486174000000119, 46.682365000000118],
              [12.554443, 46.661659],
              [12.590277, 46.658882000000119],
              [12.692499, 46.659721000000104],
              [12.728054, 46.642494],
              [12.732498, 46.64111],
              [12.73860900000011, 46.640274],
              [12.743332, 46.641388],
              [12.747929000000113, 46.644493],
              [12.753332, 46.648331],
              [12.76222, 46.651108000000136],
              [12.768888, 46.650833],
              [12.787777, 46.644997],
              [12.82361, 46.632217],
              [12.827499, 46.630272000000105],
              [13.2575, 46.56194],
              [13.428888, 46.56305],
              [13.551943, 46.55666],
              [13.558054, 46.555832],
              [13.611111000000108, 46.548050000000103],
              [13.718655, 46.526611000000116],
              [13.719444000000124, 46.522774],
              [13.718887, 46.51416],
              [13.711111, 46.492775],
              [13.69805, 46.46027400000014],
              [13.694721, 46.453331000000105],
              [13.689444, 46.447495],
              [13.685833, 46.44555],
              [13.657776, 46.449715],
              [13.511389, 46.384720000000129],
              [13.44083, 46.346382],
              [13.383055, 46.297218],
              [13.383888, 46.293053],
              [13.413055, 46.21583],
              [13.416111, 46.21333],
              [13.42055, 46.211662000000103],
              [13.425833, 46.21139],
              [13.450832000000105, 46.21611],
              [13.455, 46.217773000000136],
              [13.464998, 46.229439000000127],
              [13.485832, 46.232498],
              [13.491110000000106, 46.231384000000105],
              [13.55055, 46.218048],
              [13.657776, 46.187492],
              [13.664444, 46.183052],
              [13.669167, 46.177498],
              [13.669167, 46.17333200000013],
              [13.666943, 46.170273],
              [13.650555, 46.148605],
              [13.645832, 46.142494],
              [13.593611, 46.10527],
              [13.56861, 46.090553],
              [13.560276, 46.087494000000106],
              [13.555, 46.086937],
              [13.545555, 46.084160000000111],
              [13.538887000000102, 46.07944],
              [13.521944000000133, 46.063332],
              [13.479443, 46.013329000000113],
              [13.480000000000132, 46.01111],
              [13.502777, 45.99055],
              [13.516943, 45.981941],
              [13.53805, 45.969162],
              [13.5425, 45.967499],
              [13.560276, 45.972771],
              [13.564165000000116, 45.974442],
              [13.570833000000107, 45.97916],
              [13.580555, 45.991104],
              [13.584721, 45.992493],
              [13.601944000000117, 45.993607],
              [13.626944, 45.992218],
              [13.632221, 45.991104],
              [13.635, 45.988609],
              [13.636665, 45.985275],
              [13.6375, 45.974716],
              [13.635555, 45.952217],
              [13.633888000000127, 45.943604000000107],
              [13.618610000000103, 45.911385],
              [13.614443000000108, 45.904716],
              [13.611666, 45.902222],
              [13.593332, 45.892220000000123],
              [13.59111, 45.88916],
              [13.589167, 45.885551],
              [13.577776, 45.854164],
              [13.578888, 45.84638],
              [13.595833, 45.813606],
              [13.598055, 45.810829000000126],
              [13.610554, 45.80555],
              [13.697498, 45.784164],
              [13.784443, 45.756104000000107],
              [13.788887, 45.754440000000102],
              [13.796389, 45.750275000000101],
              [13.835278, 45.717773],
              [13.916943, 45.640274],
              [13.919167, 45.637497],
              [13.918610000000115, 45.63389],
              [13.863609, 45.589165],
              [13.850832, 45.585274],
              [13.827776, 45.584442],
              [13.802221, 45.586388],
              [13.716944, 45.596107],
              [13.785000000000139, 45.601105],
              [13.798054, 45.60527],
              [13.804443, 45.609993000000145],
              [13.804722, 45.613609],
              [13.73722, 45.693054000000132],
              [13.734165, 45.695549000000142],
              [13.656111, 45.753609],
              [13.632221, 45.769165],
              [13.627777, 45.77083],
              [13.579473, 45.78196000000014],
              [13.549999, 45.787216],
              [13.535276000000124, 45.779442],
              [13.528889000000106, 45.774719],
              [13.524443000000133, 45.763611],
              [13.523888, 45.758888],
              [13.523054000000116, 45.746666],
              [13.522778, 45.741943000000106],
              [13.523611, 45.739166],
              [13.530277, 45.734718],
              [13.529165, 45.724716],
              [13.49944, 45.70944],
              [13.433611, 45.67833],
              [13.424166, 45.676109],
              [13.392221, 45.672493],
              [13.386389, 45.67305],
              [13.377499, 45.67638],
              [13.376665000000116, 45.679993],
              [13.381388, 45.680275],
              [13.38722, 45.679443],
              [13.39194, 45.68055],
              [13.406111, 45.684166000000118],
              [13.409443, 45.686104],
              [13.423611000000108, 45.694443],
              [13.426943000000108, 45.696663000000115],
              [13.42861, 45.705276],
              [13.428333, 45.70944],
              [13.414165000000139, 45.722221],
              [13.411110000000122, 45.724442000000124],
              [13.40667, 45.726105],
              [13.367943, 45.73744],
              [13.216944000000126, 45.776939],
              [13.193333, 45.778053],
              [13.13111, 45.771942000000138],
              [13.126389, 45.77083],
              [13.114443, 45.765549000000135],
              [13.111666000000127, 45.763054000000125],
              [13.072222, 45.717773],
              [13.07, 45.714722],
              [13.06944, 45.709999],
              [13.073332, 45.696106],
              [13.096109, 45.651665],
              [13.089443, 45.637497],
              [13.086111, 45.635551],
              [13.06361, 45.63389],
              [13.000832000000116, 45.629997000000117],
              [12.922499, 45.618332],
              [12.86389, 45.595551],
              [12.798887, 45.568886000000134],
              [12.706944, 45.5311],
              [12.638054, 45.502220000000136],
              [12.617222, 45.494438],
              [12.5875, 45.483887],
              [12.425278, 45.43222],
              [12.420555, 45.431107],
              [12.41472, 45.431938],
              [12.41305, 45.435272],
              [12.412777, 45.439163000000121],
              [12.415277000000117, 45.44694],
              [12.422222, 45.456383],
              [12.43778, 45.476105000000132],
              [12.448055, 45.483604000000128],
              [12.451666, 45.48555],
              [12.456388000000118, 45.48778],
              [12.484999, 45.50027],
              [12.500277, 45.502777],
              [12.502222, 45.503052],
              [12.504999, 45.49694],
              [12.504166, 45.49472],
              [12.49472, 45.49249],
              [12.49194, 45.489716000000101],
              [12.492777, 45.486938],
              [12.497221, 45.485275],
              [12.509722, 45.485275],
              [12.514444, 45.486382000000106],
              [12.522499, 45.489716000000101],
              [12.577499000000103, 45.538055],
              [12.582499, 45.543884],
              [12.581388, 45.54666],
              [12.501944, 45.56916],
              [12.496666000000118, 45.56916],
              [12.48, 45.565826],
              [12.394444, 45.533051],
              [12.292776, 45.478607],
              [12.281387000000109, 45.468048000000124],
              [12.158333, 45.313889],
              [12.154682, 45.305084],
              [12.151943, 45.294441],
              [12.16111, 45.263885],
              [12.233332, 45.197495000000117],
              [12.361944, 45.056107],
              [12.443704000000139, 45.008236],
              [12.48444, 44.98583],
              [12.489166, 44.98722],
              [12.496387000000141, 44.98805],
              [12.51111, 44.986938],
              [12.51861, 44.98389],
              [12.521666, 44.981384],
              [12.535276000000124, 44.968605000000139],
              [12.539165, 44.961105],
              [12.538887000000102, 44.956383],
              [12.489166, 44.867493],
              [12.481388, 44.85416],
              [12.474722, 44.844719],
              [12.454721, 44.821938],
              [12.45194400000014, 44.81916],
              [12.446249, 44.815742],
              [12.44222, 44.814163000000121],
              [12.426388, 44.851662],
              [12.427221, 44.8555530000001],
              [12.433887, 44.864998],
              [12.440554, 44.87944],
              [12.442499, 44.8875],
              [12.440554, 44.894997],
              [12.433887, 44.899437],
              [12.428888, 44.900551],
              [12.415833000000134, 44.901108],
              [12.41194, 44.899437],
              [12.39138800000012, 44.872772],
              [12.389166000000102, 44.86972],
              [12.389444, 44.865555],
              [12.396944, 44.791382000000112],
              [12.356110000000115, 44.80389],
              [12.30722, 44.842216],
              [12.289721, 44.842499],
              [12.28555, 44.84083],
              [12.278055000000109, 44.827499000000103],
              [12.263887, 44.784164],
              [12.25916, 44.768326],
              [12.249722, 44.73194],
              [12.245554, 44.715828000000101],
              [12.24444, 44.701942000000145],
              [12.246387, 44.685829],
              [12.28, 44.476105000000132],
              [12.28889, 44.451660000000118],
              [12.349998, 44.286942],
              [12.356943000000115, 44.269722],
              [12.368332, 44.246666],
              [12.41555, 44.19583],
              [12.429165000000125, 44.182777000000101],
              [12.44639, 44.16777],
              [12.51861, 44.109993],
              [12.545832, 44.088608000000136],
              [12.681665000000123, 43.991104000000121],
              [12.697777, 43.983887],
              [12.72055, 43.976944],
              [12.74055, 43.972221],
              [12.753574, 43.971001],
              [12.764721, 43.970276],
              [12.810555, 43.965553],
              [12.815554, 43.964439],
              [12.824165, 43.961388],
              [12.903055, 43.924721],
              [13.049444, 43.840271],
              [13.0625, 43.83138300000013],
              [13.12555, 43.78666],
              [13.17118, 43.754059],
              [13.193333, 43.735832],
              [13.288055, 43.679443],
              [13.302500000000123, 43.67139],
              [13.35667, 43.649162000000103],
              [13.426109, 43.622772],
              [13.468054, 43.610275000000115],
              [13.479166, 43.60972],
              [13.487221, 43.611938],
              [13.546665, 43.604721],
              [13.557499000000121, 43.59861],
              [13.599443000000122, 43.57],
              [13.621666, 43.553886],
              [13.62389, 43.551666],
              [13.625832, 43.539993],
              [13.624166, 43.536385000000109],
              [13.61972, 43.530548000000124],
              [13.618610000000103, 43.526665],
              [13.62361, 43.501663],
              [13.6275, 43.491104],
              [13.63361, 43.48166700000013],
              [13.71167, 43.350555],
              [13.84805, 43.078331],
              [13.862499000000128, 43.00639],
              [13.870832, 42.97333],
              [13.876389, 42.955551000000128],
              [13.8825, 42.94221],
              [13.897499, 42.91333],
              [13.905554, 42.901382],
              [13.923611, 42.844719000000111],
              [13.939722, 42.803604000000121],
              [13.985277, 42.714165],
              [13.989166000000125, 42.70805],
              [14.016666, 42.669998000000135],
              [14.058332, 42.61972],
              [14.074999000000105, 42.600273000000129],
              [14.130554, 42.541107],
              [14.199999, 42.482498000000135],
              [14.50417, 42.261383],
              [14.561943, 42.22083],
              [14.569721, 42.216942],
              [14.60472, 42.204994],
              [14.628887, 42.198883000000137],
              [14.66139, 42.189163],
              [14.712221, 42.173882000000106],
              [14.715555, 42.17194],
              [14.718611, 42.165276],
              [14.718611, 42.16111],
              [14.714998, 42.14194],
              [14.720554000000106, 42.107498000000135],
              [14.722776, 42.10055],
              [14.733332, 42.090271],
              [14.739721, 42.085548000000131],
              [14.754721, 42.077774],
              [14.762182, 42.074783],
              [14.824999000000105, 42.045273],
              [14.8375, 42.040276000000119],
              [14.88889, 42.021660000000111],
              [14.89917, 42.01944],
              [14.939722, 42.015831],
              [14.996387, 42.004440000000102],
              [15.023888000000113, 41.987778000000105],
              [15.028055, 41.981941],
              [15.055832000000123, 41.956940000000145],
              [15.06972, 41.94861],
              [15.099165, 41.937218],
              [15.14192, 41.928024],
              [15.153889, 41.925552],
              [15.170832, 41.92333200000013],
              [15.37305, 41.905548],
              [15.396387000000118, 41.903885],
              [15.413055, 41.903885],
              [15.455555, 41.906387],
              [15.497221000000138, 41.909164],
              [15.6, 41.923607000000118],
              [15.6675, 41.91916700000013],
              [15.67555, 41.915833000000134],
              [15.68667, 41.914162],
              [15.759998, 41.91666],
              [15.770555, 41.917221],
              [15.856943000000115, 41.925278],
              [15.91361, 41.935272],
              [16.013054, 41.946663],
              [16.018055, 41.94722],
              [16.030277, 41.946388000000127],
              [16.053886, 41.943886],
              [16.0825, 41.936104000000114],
              [16.14194, 41.914162],
              [16.14527500000014, 41.912216],
              [16.1475, 41.909164],
              [16.18777, 41.842773],
              [16.194721, 41.827217],
              [16.19611, 41.823883],
              [16.195831, 41.80110900000011],
              [16.19527, 41.79666],
              [16.189999000000114, 41.781105],
              [16.164997, 41.75777],
              [16.138885, 41.740555],
              [16.030552, 41.676941],
              [15.986111, 41.655548],
              [15.974443000000122, 41.650833],
              [15.943609, 41.642776],
              [15.93194, 41.638329],
              [15.924721, 41.63472],
              [15.914999, 41.628052],
              [15.9, 41.616386],
              [15.895277, 41.610275000000115],
              [15.891666, 41.593048000000124],
              [15.89028, 41.583885000000123],
              [15.889721, 41.571106],
              [15.891109000000142, 41.559441],
              [15.895555000000115, 41.536942],
              [15.90111, 41.5236],
              [15.919998000000135, 41.493607],
              [15.932499000000121, 41.47805],
              [15.981667, 41.441940000000102],
              [15.988333, 41.437492000000134],
              [16.03305, 41.418884],
              [16.076111, 41.40749],
              [16.094444, 41.401939],
              [16.192219000000136, 41.365555],
              [16.491943, 41.25222],
              [16.657776, 41.191383],
              [16.78889, 41.154716],
              [17.04972, 41.08194],
              [17.17972200000014, 41.031387],
              [17.18777, 41.027771],
              [17.255, 40.989441],
              [17.28278, 40.973053],
              [17.29277, 40.96666],
              [17.301941000000113, 40.959717],
              [17.321941, 40.942772000000105],
              [17.471943, 40.829994],
              [17.475277, 40.827774],
              [17.496387, 40.819717],
              [17.76111, 40.730827],
              [17.937222, 40.678604000000121],
              [18.011665, 40.64444],
              [18.013611, 40.641663],
              [18.026108, 40.612221],
              [18.036388000000102, 40.579720000000123],
              [18.035275, 40.575829],
              [18.038609, 40.556938],
              [18.039719, 40.553604],
              [18.08166, 40.524994],
              [18.1275, 40.494438000000116],
              [18.274719, 40.410828],
              [18.423611, 40.289719],
              [18.426109, 40.287216],
              [18.44083, 40.265],
              [18.459721, 40.23111],
              [18.51222, 40.136665000000107],
              [18.512775, 40.132774],
              [18.514999, 40.107216000000108],
              [18.513885, 40.09861],
              [18.479721, 40.045273],
              [18.474442, 40.03999],
              [18.46778, 40.03583],
              [18.447498, 40.029716],
              [18.44028, 40.026382],
              [18.41972, 39.995827],
              [18.417774, 39.992218],
              [18.399441000000138, 39.936104],
              [18.395, 39.913887000000102],
              [18.39472, 39.909721],
              [18.39722, 39.903053],
              [18.401108, 39.896942000000138],
              [18.40166, 39.893326],
              [18.39139, 39.818054000000132],
              [18.390831, 39.814438],
              [18.378052, 39.800552],
              [18.372498, 39.79583],
              [18.349442, 39.791939000000127],
              [18.331387, 39.804993],
              [18.328053, 39.80722],
              [18.306942, 39.81916],
              [18.303055, 39.820831],
              [18.265831, 39.8316650000001],
              [18.24861, 39.833054000000118],
              [18.226944, 39.833328],
              [18.19944, 39.837494000000106],
              [18.179165, 39.846107],
              [18.175278000000105, 39.847771],
              [18.15583, 39.856667],
              [18.08527800000013, 39.900833],
              [18.078888, 39.904999],
              [18.049164, 39.928329],
              [18.04389, 39.93361],
              [18.035, 39.944443],
              [17.99472, 39.994164],
              [17.994164, 39.998055000000136],
              [17.996666, 40.001106],
              [18.000832, 40.001938000000109],
              [18.009998, 39.999161],
              [18.014442, 40.0],
              [18.019722000000115, 40.005554000000132],
              [18.022221000000116, 40.01361],
              [18.022221000000116, 40.017776],
              [18.01555, 40.094162],
              [18.015, 40.097771],
              [18.009163, 40.10667],
              [17.90639, 40.254997],
              [17.859165, 40.283607],
              [17.855274, 40.285271],
              [17.785, 40.29444100000012],
              [17.762775, 40.296661],
              [17.67889, 40.30389],
              [17.66805, 40.304161],
              [17.636387, 40.303329],
              [17.55, 40.29972],
              [17.509441, 40.296944],
              [17.504166, 40.298050000000103],
              [17.392776, 40.330551],
              [17.204441, 40.407219],
              [17.2025, 40.410271000000137],
              [17.203053, 40.414719000000105],
              [17.205276, 40.41777],
              [17.245831, 40.454994],
              [17.268055, 40.47333],
              [17.289997, 40.469719000000111],
              [17.31028, 40.471107],
              [17.317497, 40.474716],
              [17.321941, 40.48055],
              [17.326111000000139, 40.49139],
              [17.324165, 40.494438000000116],
              [17.315552, 40.497498],
              [17.31028, 40.49833],
              [17.089722, 40.520828000000108],
              [17.07888800000012, 40.521111],
              [17.068886000000134, 40.519997000000103],
              [17.046944, 40.515274],
              [17.017776, 40.506386000000134],
              [16.998333, 40.498886],
              [16.94722, 40.47083],
              [16.937222, 40.464722],
              [16.924999, 40.455551],
              [16.913609000000122, 40.445549000000142],
              [16.874165, 40.405273000000136],
              [16.863796, 40.390350000000126],
              [16.797497, 40.318604],
              [16.785553, 40.304161],
              [16.7525, 40.252777],
              [16.746944, 40.236938],
              [16.746387, 40.232498],
              [16.741665, 40.216385],
              [16.738609, 40.208611],
              [16.695274, 40.152771],
              [16.680832, 40.141388],
              [16.64135, 40.1183],
              [16.637218, 40.115829],
              [16.622776000000101, 40.103882000000112],
              [16.617222, 40.09861],
              [16.607777, 40.087219],
              [16.60472, 40.079437],
              [16.59916, 40.04555],
              [16.59972, 40.041664],
              [16.60805, 40.001389000000131],
              [16.61138, 39.991104],
              [16.563332, 39.898048],
              [16.536663, 39.871941000000106],
              [16.500275, 39.823883000000137],
              [16.498055, 39.820831],
              [16.491665000000125, 39.806389],
              [16.488609, 39.79361],
              [16.486664, 39.779999],
              [16.486664, 39.767494000000113],
              [16.49055, 39.749161],
              [16.52805, 39.665833],
              [16.531944, 39.659996],
              [16.5430530000001, 39.65028],
              [16.554165, 39.644722],
              [16.56277, 39.641663],
              [16.59694, 39.62971],
              [16.626389, 39.622772],
              [16.741386, 39.617218],
              [16.823608, 39.568604],
              [16.963055, 39.492775],
              [17.03416, 39.466110000000128],
              [17.139999, 39.402771],
              [17.151108000000136, 39.389999],
              [17.138611000000139, 39.370827],
              [17.133331, 39.360275],
              [17.116943, 39.318886000000134],
              [17.114998, 39.310272000000111],
              [17.10889, 39.263054],
              [17.116108, 39.10249],
              [17.117222, 39.09499],
              [17.138885, 39.05805],
              [17.144722, 39.049438],
              [17.149719000000118, 39.044167],
              [17.166664, 39.033882000000119],
              [17.169167, 38.997772],
              [17.169167, 38.96333],
              [17.126942, 38.91944100000012],
              [17.103611, 38.895271],
              [17.10111, 38.90833],
              [17.09528, 38.91305],
              [17.091389, 38.914719],
              [16.978333, 38.938606],
              [16.973331, 38.939438],
              [16.962498, 38.93972],
              [16.94333, 38.937775],
              [16.929443, 38.93583],
              [16.841427, 38.918610000000115],
              [16.828331, 38.91555],
              [16.730831, 38.875549],
              [16.621109, 38.82194],
              [16.608887, 38.813332],
              [16.594997, 38.80082700000014],
              [16.57361, 38.779716],
              [16.549999, 38.742493],
              [16.538887, 38.722496],
              [16.53389, 38.71194],
              [16.531944, 38.703331],
              [16.533333, 38.699997],
              [16.548885, 38.6486],
              [16.56166, 38.602776],
              [16.57, 38.55416],
              [16.575, 38.520271],
              [16.576664, 38.454636000000107],
              [16.576111, 38.442497],
              [16.571388000000127, 38.431389],
              [16.56694, 38.425278],
              [16.532776000000126, 38.391663000000108],
              [16.515553, 38.37694],
              [16.49055, 38.358055],
              [16.470554000000106, 38.346382],
              [16.448887, 38.33694],
              [16.414165, 38.32444],
              [16.364441000000113, 38.311104],
              [16.352497, 38.30722],
              [16.333885, 38.299721],
              [16.32694, 38.296104],
              [16.1655540000001, 38.13916],
              [16.161110000000122, 38.133049],
              [16.158333, 38.126389],
              [16.154999, 38.114441],
              [16.14527500000014, 38.0775],
              [16.141388, 38.060829],
              [16.138885, 38.047775],
              [16.138885, 38.035271000000137],
              [16.137775, 38.026382],
              [16.133331000000112, 38.015274],
              [16.116665000000125, 37.979721],
              [16.110275, 37.970833],
              [16.087776, 37.94611],
              [16.06889, 37.928329000000133],
              [16.062496, 37.924164000000133],
              [16.04888, 37.922218],
              [15.996111, 37.918884],
              [15.947222, 37.922493],
              [15.922777, 37.927773000000116],
              [15.866665, 37.92610900000011],
              [15.79472, 37.919167],
              [15.781111, 37.916939],
              [15.77583, 37.916939],
              [15.756109, 37.920830000000137],
              [15.72028, 37.931107000000111],
              [15.675278, 37.952217],
              [15.66889, 37.95638300000013],
              [15.663610000000119, 37.961388],
              [15.64028, 37.992218],
              [15.636389, 37.998055],
              [15.631666000000109, 38.011665],
              [15.632221, 38.016388],
              [15.645277, 38.063049],
              [15.63722, 38.17555],
              [15.629444, 38.19138],
              [15.626665, 38.198051],
              [15.626665, 38.206383],
              [15.628332000000114, 38.224159],
              [15.628887, 38.228607],
              [15.630554, 38.232216],
              [15.654444, 38.240273],
              [15.706944, 38.256386],
              [15.72361, 38.255272],
              [15.733055, 38.256386],
              [15.741665000000125, 38.258606],
              [15.76028, 38.26611],
              [15.793055, 38.280548000000124],
              [15.796389, 38.28249],
              [15.809721, 38.295273],
              [15.820833, 38.309715],
              [15.895555000000115, 38.451942000000145],
              [15.906111, 38.472771],
              [15.92063, 38.518036],
              [15.924166, 38.53249],
              [15.925278, 38.541382000000112],
              [15.919998000000135, 38.55055],
              [15.894722000000115, 38.57611],
              [15.876944, 38.59333],
              [15.851665, 38.61055],
              [15.839443, 38.614998],
              [15.8283330000001, 38.62055],
              [15.827221, 38.623886],
              [15.82778, 38.628326],
              [15.832777, 38.63916],
              [15.83917, 38.648331],
              [15.847221, 38.65583],
              [15.856388, 38.662498000000141],
              [15.982498, 38.720833],
              [15.98639, 38.722496],
              [16.023609, 38.723885],
              [16.045277, 38.72361],
              [16.067497, 38.720833],
              [16.088055000000111, 38.71722],
              [16.099163, 38.711662],
              [16.10416, 38.71083],
              [16.129166000000112, 38.715553],
              [16.171944, 38.740829],
              [16.178608, 38.744995],
              [16.18111, 38.747498000000121],
              [16.195, 38.76916],
              [16.2066650000001, 38.79388],
              [16.209442, 38.801666],
              [16.2175, 38.829720000000123],
              [16.219997, 38.843048000000124],
              [16.221107, 38.868607],
              [16.2225, 38.91083],
              [16.221107, 38.922493],
              [16.219166, 38.925278],
              [16.216389, 38.926941],
              [16.194164000000114, 38.931938000000116],
              [16.162220000000104, 38.945274],
              [16.151943000000131, 38.951111],
              [16.101109, 39.019440000000145],
              [16.09833, 39.026108000000136],
              [16.064163, 39.129166000000112],
              [16.056942000000106, 39.179718],
              [16.057499, 39.192772000000105],
              [16.05611, 39.224998],
              [16.053333, 39.256386],
              [16.038055, 39.330276],
              [16.034443000000124, 39.344994],
              [16.031387, 39.351105],
              [15.988333, 39.43666],
              [15.97972, 39.451942],
              [15.977777, 39.454994],
              [15.933611, 39.510551000000135],
              [15.919722, 39.522499],
              [15.903889, 39.533882],
              [15.853054, 39.609993],
              [15.808887000000141, 39.677773000000116],
              [15.806944, 39.680832],
              [15.80028, 39.705551],
              [15.799444, 39.709442000000138],
              [15.787498, 39.792496],
              [15.782221, 39.849998000000141],
              [15.783888000000104, 39.858604],
              [15.783054, 39.866661],
              [15.77833, 39.876106000000107],
              [15.754999, 39.918884],
              [15.748333, 39.92722],
              [15.728888, 39.95694],
              [15.712221, 39.979721],
              [15.666666, 40.03083],
              [15.660831, 40.035271],
              [15.642258, 40.042931],
              [15.625555, 40.059715],
              [15.611944, 40.069443],
              [15.588333, 40.073608],
              [15.577776, 40.075272],
              [15.565832, 40.07638],
              [15.555555, 40.075829],
              [15.519722, 40.073326],
              [15.51111, 40.071388],
              [15.504166000000112, 40.067772],
              [15.458611000000133, 40.02861],
              [15.42305, 39.994995],
              [15.416943, 39.990273],
              [15.412777, 39.990273],
              [15.365276000000108, 39.996941],
              [15.359722, 39.997772],
              [15.355833, 39.999443],
              [15.33861, 40.00944],
              [15.313055000000134, 40.031387],
              [15.270277, 40.06721],
              [15.258333, 40.07638],
              [15.145832, 40.155548],
              [15.128887000000134, 40.165833000000134],
              [15.1175, 40.171387],
              [15.106943, 40.17305],
              [15.096666, 40.172493000000145],
              [15.012499000000105, 40.19555],
              [14.941944, 40.23416],
              [14.927221, 40.271111000000133],
              [14.964167, 40.341385],
              [14.987778, 40.35527],
              [14.98972, 40.35833],
              [14.991943, 40.366661000000136],
              [14.993055, 40.375549],
              [14.992777, 40.392220000000123],
              [14.990555, 40.399162],
              [14.964443000000131, 40.445831],
              [14.903889000000106, 40.551666000000125],
              [14.892776, 40.565826],
              [14.839443, 40.623329],
              [14.831944, 40.6311],
              [14.825832000000105, 40.635826],
              [14.776943000000131, 40.672218],
              [14.77277800000013, 40.673882],
              [14.76222, 40.67555],
              [14.74472, 40.676384],
              [14.687167, 40.639336],
              [14.62861, 40.64944],
              [14.62167, 40.645828],
              [14.575528, 40.611755],
              [14.504721, 40.61972],
              [14.455353, 40.617008],
              [14.401943000000131, 40.6],
              [14.327296, 40.57301],
              [14.326639, 40.594681],
              [14.339117, 40.61832],
              [14.35444, 40.627777],
              [14.359165, 40.626663],
              [14.364443000000108, 40.626663],
              [14.373888, 40.628326000000129],
              [14.384722, 40.633606],
              [14.397221, 40.642494],
              [14.469999, 40.695549],
              [14.475555, 40.700829000000113],
              [14.477221, 40.704163000000108],
              [14.477499000000137, 40.708885],
              [14.476944, 40.712494],
              [14.475277000000119, 40.71583],
              [14.471943000000124, 40.721939],
              [14.458055, 40.742775000000108],
              [14.44749800000011, 40.753052],
              [14.3175, 40.823326],
              [14.30639, 40.829163],
              [14.28555, 40.836937],
              [14.2666660000001, 40.84166],
              [14.261665, 40.841110000000128],
              [14.22611, 40.827774],
              [14.216944000000126, 40.821106],
              [14.210554, 40.811943],
              [14.16694, 40.806938],
              [14.073889, 40.82194],
              [14.047222, 40.860275000000115],
              [14.046389, 40.864166],
              [14.030554000000109, 40.898048000000131],
              [14.026943000000131, 40.904442],
              [14.01777600000014, 40.919716],
              [13.99444, 40.956108],
              [13.983889, 40.970551000000114],
              [13.9, 41.078049000000135],
              [13.837221000000113, 41.152496],
              [13.802221, 41.189720000000136],
              [13.79389, 41.19694],
              [13.77583, 41.211105],
              [13.737654, 41.23474],
              [13.719721000000106, 41.247498],
              [13.713055000000111, 41.251389],
              [13.70805, 41.252777],
              [13.647221, 41.259438000000102],
              [13.641109, 41.259995],
              [13.620832, 41.257774],
              [13.608055, 41.254166],
              [13.56861, 41.23888],
              [13.564999, 41.237221],
              [13.294167, 41.295555],
              [13.276943, 41.295555],
              [13.2666660000001, 41.294716000000108],
              [13.21111100000013, 41.282494],
              [13.17, 41.26888300000013],
              [13.146944000000133, 41.259163],
              [13.12472, 41.248886],
              [13.108889, 41.237778000000105],
              [13.031944, 41.255272],
              [13.027222000000108, 41.265],
              [13.009722, 41.292221],
              [13.00111, 41.303604],
              [12.98389, 41.322495000000117],
              [12.97611, 41.33027600000014],
              [12.951944, 41.35305000000011],
              [12.93222, 41.37028],
              [12.913055, 41.383606],
              [12.892221, 41.395554000000118],
              [12.855, 41.409996],
              [12.67166, 41.45916],
              [12.66, 41.459442000000138],
              [12.646387000000118, 41.456383],
              [12.576111, 41.50722],
              [12.517776, 41.567772],
              [12.471943, 41.607216],
              [12.45194400000014, 41.624161000000129],
              [12.44222, 41.631104000000107],
              [12.356943000000115, 41.691666000000112],
              [12.345833, 41.697220000000129],
              [12.217222, 41.782494],
              [12.214443, 41.79361],
              [12.209721, 41.812218],
              [12.204443, 41.821663000000115],
              [12.179722, 41.864998],
              [12.17583, 41.871109],
              [12.16472, 41.885277],
              [12.152222, 41.898888],
              [12.129721, 41.91861],
              [12.116943000000106, 41.927498],
              [12.021111, 41.985832],
              [11.91944, 42.033882],
              [11.905554, 42.03805],
              [11.893055000000118, 42.038605],
              [11.8775, 42.036942000000124],
              [11.862221, 42.031105000000139],
              [11.838610000000131, 42.028610000000128],
              [11.833055, 42.028328],
              [11.82833, 42.029442],
              [11.823055, 42.034721],
              [11.804998000000126, 42.057495],
              [11.745832, 42.1325],
              [11.739166, 42.149719000000118],
              [11.73688, 42.155708],
              [11.73555, 42.160271000000137],
              [11.725555, 42.18222],
              [11.703888, 42.224442000000124],
              [11.63528, 42.292496],
              [11.62944, 42.29722],
              [11.623055, 42.301666000000125],
              [11.534166000000141, 42.342773000000136],
              [11.4975, 42.357498],
              [11.451317000000131, 42.37418],
              [11.387499, 42.400276000000133],
              [11.37472, 42.405],
              [11.364443, 42.406662],
              [11.264999, 42.41833],
              [11.259443, 42.418884],
              [11.23166700000013, 42.417496000000142],
              [11.206944, 42.413605],
              [11.205, 42.409996],
              [11.201387000000125, 42.39444],
              [11.202221, 42.387215],
              [11.18472, 42.36749],
              [11.181944, 42.364998000000128],
              [11.178333, 42.363327],
              [11.173887, 42.364716000000101],
              [11.106667, 42.389717000000132],
              [11.09889, 42.393051],
              [11.096109000000126, 42.395554],
              [11.088055, 42.407776],
              [11.083332, 42.42889],
              [11.085833, 42.431664],
              [11.097776, 42.44138],
              [11.105276, 42.44472],
              [11.114166, 42.443329],
              [11.122499000000118, 42.440277],
              [11.133055, 42.439438],
              [11.15472, 42.439163],
              [11.163055, 42.442215],
              [11.168333, 42.44749],
              [11.172499, 42.453606],
              [11.180832, 42.47583],
              [11.18694, 42.493889],
              [11.188889, 42.50222],
              [11.189722, 42.506386],
              [11.18833, 42.514160000000118],
              [11.181665, 42.527222000000108],
              [11.15805, 42.554993],
              [11.08027600000014, 42.63222],
              [10.973888000000102, 42.718887000000109],
              [10.9575, 42.729996],
              [10.931665000000123, 42.74333],
              [10.919443, 42.748329],
              [10.88944400000014, 42.758888000000127],
              [10.862499, 42.76694],
              [10.764444, 42.82471],
              [10.768610000000137, 42.835831],
              [10.771387, 42.848053000000107],
              [10.779444, 42.887497],
              [10.778055, 42.89555],
              [10.775276000000133, 42.902496],
              [10.767776, 42.910553],
              [10.742777, 42.924438000000123],
              [10.734999, 42.928055],
              [10.72639, 42.931107],
              [10.68778, 42.944717],
              [10.673611000000108, 42.948326],
              [10.588888000000111, 42.9575],
              [10.531387000000109, 43.044716000000108],
              [10.535276, 43.060829000000126],
              [10.540833, 43.123329],
              [10.542776, 43.145828],
              [10.542500000000132, 43.154442],
              [10.538332, 43.180832000000123],
              [10.530277, 43.22361],
              [10.522221, 43.249161],
              [10.51444400000014, 43.265831],
              [10.422777, 43.398048],
              [10.38361, 43.441109],
              [10.371666000000118, 43.450554000000125],
              [10.357498, 43.458611],
              [10.332222, 43.468048],
              [10.323055, 43.475273],
              [10.321388000000127, 43.478607],
              [10.298332, 43.533607],
              [10.29555, 43.54055000000011],
              [10.293333, 43.54805],
              [10.287607, 43.591301000000101],
              [10.276388, 43.689163],
              [10.276943000000131, 43.698326],
              [10.276943000000131, 43.714439],
              [10.275, 43.734993],
              [10.273333, 43.751663],
              [10.26861, 43.792496000000142],
              [10.266388, 43.79972],
              [10.252222, 43.84333],
              [10.239166000000125, 43.874443],
              [10.233332, 43.8836060000001],
              [10.221943, 43.898048],
              [10.209444000000133, 43.911942],
              [10.179443000000106, 43.944717],
              [10.11611, 44.0],
              [10.107498, 44.007500000000107],
              [10.09083, 44.01861],
              [10.068609, 44.029999],
              [10.050833000000125, 44.03611],
              [10.027334, 44.044174],
              [9.983606, 44.053879],
              [9.714996, 44.114716000000101],
              [9.66111, 44.140831000000105],
              [9.37278, 44.285271000000137],
              [9.340277, 44.30778],
              [9.332777000000135, 44.31166],
              [9.23361, 44.346382],
              [9.228611000000114, 44.347496],
              [8.815554, 44.42555],
              [8.76111, 44.429443],
              [8.748888000000136, 44.429161000000136],
              [8.74361, 44.428329],
              [8.735277, 44.425278],
              [8.64, 44.388329],
              [8.498888, 44.324715],
              [8.491665000000125, 44.320549000000142],
              [8.44944, 44.287773],
              [8.438889, 44.276939],
              [8.43805, 44.27277400000014],
              [8.44389, 44.26777600000014],
              [8.445555, 44.264442000000145],
              [8.44611, 44.26028],
              [8.44472, 44.25666],
              [8.415277, 44.190277],
              [8.39944, 44.178329000000133],
              [8.391109, 44.175278000000105],
              [8.332222, 44.158607],
              [8.310276, 44.1561],
              [8.2925, 44.150833],
              [8.280277, 44.145554],
              [8.267776, 44.136108],
              [8.236666, 44.103333],
              [8.231943000000115, 44.0975],
              [8.158054, 43.994438000000116],
              [8.155277000000126, 43.986938],
              [8.154444000000126, 43.978333],
              [8.1575, 43.971382],
              [8.161943000000122, 43.965553],
              [8.1655540000001, 43.958885],
              [8.1655540000001, 43.955276],
              [8.06778, 43.89305],
              [7.94889, 43.846382],
              [7.91389, 43.839996],
              [7.77277800000013, 43.815277],
              [7.740833, 43.797218],
              [7.736944000000108, 43.795273],
              [7.675278, 43.779716],
              [7.669444, 43.77916],
              [7.658610000000124, 43.779716],
              [7.613889, 43.788887000000102],
              [7.592222, 43.791664],
              [7.579721, 43.791664],
              [7.574444, 43.790833],
              [7.531935, 43.78204],
              [7.528055, 43.788605],
              [7.512500000000102, 43.82111],
              [7.49861, 43.849442],
              [7.493333, 43.862221],
              [7.492222, 43.869438],
              [7.493333, 43.877777],
              [7.495, 43.88166],
              [7.50111, 43.88694],
              [7.59833, 43.964722],
              [7.657222, 44.005272],
              [7.66, 44.00833],
              [7.70417, 44.07222],
              [7.70833, 44.07944],
              [7.709045000000117, 44.091309000000138],
              [7.66889, 44.122772],
              [7.661666, 44.131104],
              [7.658333, 44.137215],
              [7.657777000000124, 44.144722],
              [7.66222, 44.170830000000137],
              [7.61472, 44.180275],
              [7.52028, 44.1561],
              [7.466389000000106, 44.138611],
              [7.423055, 44.126663],
              [7.418888, 44.125549],
              [7.353333000000134, 44.131104],
              [7.348332, 44.131943],
              [7.031388, 44.246941],
              [6.9763880000001, 44.284164],
              [6.878888, 44.373604],
              [6.876944, 44.376663],
              [6.853611000000114, 44.517776],
              [6.852777, 44.540833],
              [6.950833, 44.664719000000105],
              [6.970555000000104, 44.684715],
              [6.980277, 44.691666],
              [7.02833, 44.74472],
              [7.031666, 44.83138300000013],
              [7.009999, 44.848610000000122],
              [7.002777, 44.852776],
              [6.973888, 44.862778],
              [6.964444, 44.865829],
              [6.948333, 44.869995],
              [6.936388, 44.871384],
              [6.917777, 44.861938000000123],
              [6.904444, 44.859161],
              [6.89222100000012, 44.860275],
              [6.85777800000011, 44.866661000000136],
              [6.84083, 44.874161],
              [6.775277000000131, 44.905548000000124],
              [6.751111, 44.91722],
              [6.746944, 44.91944],
              [6.661666, 45.039993],
              [6.61976, 45.110138],
              [6.621666000000118, 45.11388],
              [6.627222000000131, 45.11944],
              [6.634121, 45.124001],
              [6.637777, 45.126106000000107],
              [6.675833, 45.143883],
              [6.688889, 45.147774],
              [6.6975, 45.150276000000133],
              [6.760833, 45.168327],
              [6.771944, 45.16805],
              [6.816388000000131, 45.156387],
              [6.826944, 45.149719],
              [6.939444, 45.179443],
              [7.064722, 45.223053],
              [7.124999000000116, 45.254997],
              [7.127777, 45.25777],
              [7.129167, 45.262215],
              [7.15861, 45.377495],
              [7.146944, 45.43055],
              [7.089159, 45.47686],
              [7.002777, 45.516106],
              [6.99944, 45.518326000000116],
              [6.98972, 45.53333],
              [6.969444, 45.596939],
              [6.814166000000114, 45.72194],
              [6.809722000000136, 45.727776000000119],
              [6.80778, 45.73444400000011],
              [6.798970000000111, 45.78067],
              [6.79972, 45.796661],
              [6.807221000000141, 45.827217],
              [6.808888, 45.831383],
              [6.81861, 45.839165],
              [6.869721, 45.855827],
              [6.874999, 45.85611],
              [6.896111000000133, 45.850273],
              [6.908055, 45.849442],
              [6.92222, 45.852219000000105],
              [6.943889, 45.85833],
              [6.973055, 45.868889],
              [6.980833, 45.872215],
              [6.987499, 45.876938],
              [6.99667, 45.885551],
              [7.03805, 45.931938000000116],
              [7.062778, 45.90916],
              [7.077777, 45.896942],
              [7.091110000000128, 45.88749700000011],
              [7.099444, 45.883606],
              [7.105, 45.882217],
              [7.117499, 45.880829000000119],
              [7.183055, 45.879166],
              [7.188611, 45.879166],
              [7.19694, 45.882217],
              [7.23028, 45.898048],
              [7.291111, 45.92194400000011],
              [7.295555, 45.92305],
              [7.300278, 45.923882],
              [7.338888, 45.920555],
              [7.378888000000131, 45.914719],
              [7.3933320000001, 45.916107000000125],
              [7.429722, 45.929443000000106],
              [7.45805, 45.941109],
              [7.536666000000139, 45.98166700000013],
              [7.647499, 45.98111],
              [7.653055, 45.979996],
              [7.709167, 45.943329],
              [7.743333, 45.93222],
              [7.78389, 45.923607],
              [7.8483, 45.918755],
              [7.855742, 45.919052],
              [7.86639, 45.948326],
              [7.876666, 45.972496],
              [7.88194, 45.977776],
              [7.9025, 45.991104],
              [7.911111, 45.994164000000126],
              [7.95, 45.994164000000126],
              [7.97305, 45.996941],
              [7.998055000000136, 46.00222],
              [8.00861, 46.008331000000112],
              [8.014721, 46.013329000000113],
              [8.148888000000113, 46.14944],
              [8.150276, 46.153053],
              [8.158888000000104, 46.176666000000125],
              [8.159443, 46.180832],
              [8.158333, 46.188889],
              [8.14389, 46.219719],
              [8.139999, 46.226105000000132],
              [8.299999, 46.419716],
              [8.30278, 46.422493000000145],
              [8.306110000000103, 46.424721],
              [8.35722, 46.45],
              [8.365276, 46.45361],
              [8.430277, 46.463051],
              [8.436388, 46.463333],
              [8.447498, 46.461937],
              [8.45167, 46.459999],
              [8.459999, 46.452217000000132],
              [8.461666, 46.44444],
              [8.46611, 46.37722],
              [8.465832, 46.36805],
              [8.45833, 46.33416],
              [8.447498, 46.323326],
              [8.443333, 46.31721],
              [8.434999, 46.295273],
              [8.434166, 46.29111],
              [8.444443, 46.248604000000114],
              [8.445555, 46.245827],
              [8.460554000000116, 46.23333],
              [8.61389, 46.122215],
              [8.617777, 46.120277000000101],
              [8.691944, 46.10139],
              [8.70111, 46.10083],
              [8.714998, 46.10249],
              [8.723610000000122, 46.105553],
              [8.728855000000124, 46.108589],
              [8.747221, 46.121109],
              [8.818333, 46.100555],
              [8.826111, 46.09666],
              [8.835278, 46.089439],
              [8.844166, 46.08194],
              [8.846666, 46.079163],
              [8.85055, 46.072495],
              [8.85333, 46.061104000000114],
              [8.852499, 46.056938],
              [8.849998, 46.054443],
              [8.82361, 46.036110000000122],
              [8.816944, 46.03166],
              [8.813055, 45.988609],
              [8.82667, 45.984161],
              [8.895555, 45.955826],
              [8.9, 45.94971],
              [8.926666, 45.900833],
              [8.93639, 45.876938],
              [8.936666, 45.872772],
              [8.93611, 45.868889],
              [8.951111000000139, 45.845276000000126],
              [8.998333, 45.82944],
              [9.03666, 45.837776],
              [9.083887, 45.895554],
              [9.085554, 45.899162],
              [9.085554, 45.901939],
              [9.081388, 45.912498000000141],
              [9.079443, 45.915833],
              [9.066666000000112, 45.924164000000133],
              [9.031944000000124, 45.931664],
              [9.025, 45.935829],
              [9.0175, 45.94416],
              [8.996666000000118, 45.973328],
              [8.998055, 45.976944],
              [9.016666, 46.0225],
              [9.035831, 46.05722],
              [9.083332, 46.121109],
              [9.132221, 46.160271],
              [9.144439, 46.168049],
              [9.158609, 46.171661],
              [9.17722, 46.176941],
              [9.18055500000014, 46.17916],
              [9.189444, 46.186661],
              [9.238609, 46.2305530000001],
              [9.24341, 46.23671],
              [9.276667, 46.292496000000142],
              [9.291943000000117, 46.323051],
              [9.293333, 46.32666],
              [9.29749900000013, 46.348885],
              [9.296944, 46.35305],
              [9.282221, 46.419998000000135],
              [9.280554, 46.423332],
              [9.272778, 46.428329],
              [9.256943, 46.431389],
              [9.253054000000134, 46.433327],
              [9.25, 46.440277],
              [9.249722000000133, 46.448051],
              [9.273611, 46.487778000000105],
              [9.281944, 46.495827000000133],
              [9.288887, 46.500275000000101],
              [9.296944, 46.503883],
              [9.302221, 46.50471],
              [9.360832, 46.50861],
              [9.37278, 46.5075],
              [9.455, 46.472496],
              [9.450277, 46.426666],
              [9.45666, 46.387772],
              [9.458611, 46.384720000000129],
              [9.521387000000118, 46.319717],
              [9.5425, 46.306938000000116],
              [9.547222, 46.30555],
              [9.581944, 46.29694400000011],
              [9.624722000000133, 46.291939],
              [9.696943, 46.297218],
              [9.708332, 46.298332],
              [9.714998, 46.302773000000116],
              [9.770555, 46.342209],
              [9.81305, 46.35833],
              [9.85278, 46.369720000000143],
              [9.904999, 46.383049],
              [9.911110000000122, 46.383331000000112],
              [9.943888, 46.379997000000117],
              [9.949999000000105, 46.379166000000112],
              [9.984722, 46.361938],
              [9.991943000000106, 46.357773],
              [9.99361, 46.354439],
              [9.991388, 46.346664],
              [9.981943000000115, 46.33472],
              [9.982498, 46.331383],
              [9.994999, 46.291664],
              [10.05722, 46.22805],
              [10.063055, 46.222771000000137],
              [10.066666000000112, 46.221107000000131],
              [10.07278, 46.220276000000126],
              [10.078609, 46.22055],
              [10.129999, 46.227219000000105],
              [10.133888000000127, 46.228882],
              [10.1408330000001, 46.23333],
              [10.16972, 46.25444],
              [10.172499, 46.257217],
              [10.17639, 46.26833],
              [10.17722, 46.272499],
              [10.153889, 46.390274],
              [10.092777000000126, 46.423332],
              [10.088610000000131, 46.424164],
              [10.067221, 46.432495],
              [10.055555, 46.438332],
              [10.049166, 46.443054000000132],
              [10.046665, 46.445831],
              [10.045, 46.449165],
              [10.044443, 46.453331000000105],
              [10.04416700000013, 46.498055],
              [10.044722, 46.507217],
              [10.050278, 46.53999],
              [10.0525, 46.54305],
              [10.11916, 46.61138],
              [10.18111, 46.632217],
              [10.233332, 46.639999],
              [10.238609, 46.638885],
              [10.241665000000125, 46.636665],
              [10.253611, 46.622215],
              [10.254166000000112, 46.61805],
              [10.253054000000134, 46.613884],
              [10.24694, 46.599442],
              [10.245277, 46.59111],
              [10.245554, 46.587219],
              [10.247499, 46.583885],
              [10.301666, 46.555832],
              [10.305555, 46.55389],
              [10.337221000000113, 46.549438],
              [10.44972, 46.53916],
              [10.457531, 46.5425],
              [10.465277, 46.54639],
              [10.471109000000126, 46.55167],
              [10.47555, 46.562492],
              [10.485277, 46.590553],
              [10.486111000000108, 46.594719],
              [10.486666, 46.615273],
              [10.486387, 46.619438],
              [10.470833, 46.635826],
              [10.447498, 46.763054000000125],
              [10.471235, 46.871353],
              [10.474443000000122, 46.86694],
              [10.477777000000117, 46.864441],
              [10.49778, 46.855270000000132],
              [10.560833, 46.84861],
              [10.566387, 46.849159],
              [10.59972, 46.857773],
              [10.6425, 46.868889],
              [10.651388, 46.87194],
              [10.666943000000117, 46.874718],
              [10.679443, 46.874718],
              [10.684721, 46.873604],
              [10.689444, 46.872215],
              [10.758055, 46.838882],
              [10.764444, 46.83416],
              [10.76611, 46.826385],
              [10.764444, 46.82278],
              [10.791666, 46.801384],
              [10.83417, 46.786942],
              [10.887777, 46.771111],
              [11.014721, 46.7725],
              [11.018888, 46.774162000000103],
              [11.07028, 46.82194],
              [11.072498, 46.824997],
              [11.096666, 46.881660000000124],
              [11.09805, 46.885277],
              [11.09889, 46.89444],
              [11.094721, 46.905],
              [11.094444, 46.90916],
              [11.096666, 46.912498000000141],
              [11.099443, 46.91499],
              [11.11167, 46.924995],
              [11.11805500000014, 46.929993],
              [11.164444, 46.962219],
              [11.17139, 46.966660000000104],
              [11.186388, 46.97028],
              [11.483889, 47.01416],
              [11.61528, 47.013054],
              [11.62861, 47.012497],
              [11.7066650000001, 46.998604000000114],
              [11.71361, 46.994164000000126],
              [11.725832, 46.979996],
              [11.73639, 46.977776],
              [11.755833, 46.977493],
              [11.766666, 46.978882],
              [12.075277, 47.05944],
              [12.140131, 47.084812],
              [12.183054, 47.094444000000124],
              [12.189165000000116, 47.09472],
              [12.221666, 47.088333],
              [12.22611, 47.086662],
              [12.23111, 47.080826000000116],
              [12.230833, 47.07222],
              [12.223888, 47.063049],
              [12.204443, 47.039162],
              [12.19861, 47.033882000000119],
              [12.189999, 47.029999],
              [12.185276, 47.028885],
              [12.152777000000128, 47.024437],
              [12.138332, 47.020828],
              [12.134165, 47.019165],
              [12.128887, 47.013329],
              [12.127222, 47.00972],
              [12.127777, 47.001663000000121],
            ],
            [
              [12.45917, 43.896111],
              [12.464722000000108, 43.895554000000118],
              [12.474443, 43.897217],
              [12.48778, 43.90583],
              [12.494999, 43.914719000000105],
              [12.496387000000141, 43.923332],
              [12.510555, 43.939163],
              [12.511665, 43.943329000000119],
              [12.510277, 43.982773],
              [12.50999800000011, 43.986938],
              [12.505554, 43.98860900000011],
              [12.492777, 43.989166],
              [12.47167, 43.986938],
              [12.4625, 43.984718],
              [12.453888, 43.981667],
              [12.450554, 43.979721],
              [12.415798, 43.95795],
              [12.408888, 43.954994],
              [12.404999, 43.948326],
              [12.403889, 43.926666],
              [12.407822, 43.913658],
              [12.41222, 43.906105],
              [12.416388, 43.904716],
              [12.45917, 43.896111],
            ],
            [
              [12.445090330888604, 41.90311752178485],
              [12.456660170953796, 41.901426024699163],
              [12.451653339580503, 41.907989033391232],
              [12.445090330888604, 41.90311752178485],
            ],
          ],
          [
            [
              [12.422777, 45.420555],
              [12.425833000000125, 45.41861],
              [12.427221, 45.415276],
              [12.421944, 45.414162],
              [12.37829, 45.419754],
              [12.373888, 45.416107],
              [12.345276, 45.384720000000129],
              [12.336111, 45.372498],
              [12.328333, 45.35944400000011],
              [12.32667, 45.35583],
              [12.32361, 45.343887],
              [12.316387, 45.350555],
              [12.360832, 45.415833000000134],
              [12.368332, 45.424164],
              [12.37333, 45.428055],
              [12.379444, 45.429718],
              [12.390554, 45.430832],
              [12.402222, 45.429718],
              [12.422777, 45.420555],
            ],
          ],
          [
            [
              [9.84417, 43.034439000000134],
              [9.816111, 43.004440000000102],
              [9.81361, 43.005272],
              [9.806944000000101, 43.00972],
              [9.804443000000106, 43.012497],
              [9.799166, 43.022217000000126],
              [9.795277, 43.032776],
              [9.802776, 43.060272],
              [9.804165, 43.063889],
              [9.823055000000124, 43.077499000000103],
              [9.828054, 43.077499000000103],
              [9.831665, 43.075554],
              [9.834166, 43.07278],
              [9.851387, 43.052498],
              [9.846388, 43.037498],
              [9.84417, 43.034439000000134],
            ],
          ],
          [
            [
              [10.441111, 42.844444],
              [10.43111, 42.721664],
              [10.429443, 42.71333],
              [10.426943, 42.710831],
              [10.423054, 42.70888],
              [10.41861, 42.708611],
              [10.35472, 42.759163000000115],
              [10.34805, 42.763329],
              [10.34361, 42.765],
              [10.338055, 42.765549],
              [10.299721, 42.75972],
              [10.23472, 42.746384],
              [10.209166, 42.735275],
              [10.16028, 42.729439000000127],
              [10.149166, 42.72972],
              [10.13917, 42.731667],
              [10.1275, 42.737221],
              [10.12167, 42.741943],
              [10.116943, 42.747498],
              [10.104166, 42.765274],
              [10.101944000000117, 42.772499],
              [10.100555, 42.780548000000124],
              [10.101387, 42.78916],
              [10.10805, 42.797218],
              [10.11472, 42.801666],
              [10.126665, 42.80639],
              [10.145, 42.810829],
              [10.182777000000101, 42.813606000000107],
              [10.208611000000133, 42.809166],
              [10.218332, 42.802498000000128],
              [10.22361, 42.797218],
              [10.23111, 42.79333],
              [10.23583, 42.79222],
              [10.349443, 42.801941],
              [10.35389, 42.803055],
              [10.359722, 42.808052],
              [10.376944, 42.825829],
              [10.379166, 42.82888800000012],
              [10.391666, 42.852493],
              [10.394444, 42.85972],
              [10.406944000000124, 42.868889000000138],
              [10.411388000000102, 42.870277],
              [10.416943, 42.870552],
              [10.43611, 42.857216000000108],
              [10.439165000000116, 42.854721],
              [10.44028, 42.851105],
              [10.441111, 42.844444],
            ],
          ],
          [
            [
              [10.08833, 42.57222],
              [10.083332, 42.571388000000127],
              [10.075277, 42.57499700000011],
              [10.06944, 42.591942],
              [10.079721, 42.61555],
              [10.081944000000135, 42.61889],
              [10.0875, 42.617775],
              [10.08972, 42.614998],
              [10.101665, 42.5936],
              [10.098888, 42.58361],
              [10.097221000000104, 42.57972],
              [10.08833, 42.57222],
            ],
          ],
          [
            [
              [10.915833, 42.32527],
              [10.912222, 42.32361],
              [10.904165, 42.326942000000145],
              [10.868889, 42.355827],
              [10.866388, 42.358604000000128],
              [10.864443000000108, 42.36583],
              [10.877777, 42.388054],
              [10.881388, 42.388885],
              [10.89194300000014, 42.38694],
              [10.896111, 42.385551],
              [10.911943, 42.371666000000118],
              [10.914444, 42.368889],
              [10.928055, 42.339439],
              [10.92639, 42.335831],
              [10.91861, 42.327774],
              [10.915833, 42.32527],
            ],
          ],
          [
            [
              [10.316666, 42.317497],
              [10.305555, 42.31694],
              [10.294998, 42.317772000000105],
              [10.291943000000117, 42.32],
              [10.2897210000001, 42.323051],
              [10.28861, 42.32666],
              [10.28861, 42.338882],
              [10.289444000000117, 42.343048000000124],
              [10.293055, 42.349998],
              [10.296944, 42.351662],
              [10.301943000000108, 42.352493],
              [10.315277, 42.349159],
              [10.323055, 42.345833],
              [10.326111, 42.34333],
              [10.3283330000001, 42.328331],
              [10.3283330000001, 42.324715],
              [10.316666, 42.317497],
            ],
          ],
          [
            [
              [9.513332, 41.14666],
              [9.562498000000119, 41.117775000000108],
              [9.633888, 40.989166],
              [9.51444400000014, 40.929718],
              [9.50444, 40.92222],
              [9.50361, 40.91805],
              [9.505833, 40.915276],
              [9.509443, 40.91333],
              [9.526943000000131, 40.912498],
              [9.566387, 40.91305],
              [9.612778000000105, 40.921104],
              [9.659166, 40.85249],
              [9.746944, 40.682495],
              [9.75111, 40.66777],
              [9.751944, 40.659439000000134],
              [9.75111, 40.655273],
              [9.742498, 40.638611],
              [9.742777, 40.629997],
              [9.749443, 40.599159],
              [9.75111, 40.59583],
              [9.795277, 40.54833200000013],
              [9.803333, 40.540833000000134],
              [9.806944000000101, 40.537498],
              [9.814165, 40.535553],
              [9.82111, 40.53166],
              [9.82416, 40.529442],
              [9.825832, 40.526108],
              [9.825554000000125, 40.52166],
              [9.80944, 40.46833],
              [9.800278000000105, 40.442497],
              [9.77194, 40.394722],
              [9.764444, 40.386665],
              [9.758055000000127, 40.382217],
              [9.750832, 40.378883],
              [9.74222200000014, 40.376389000000131],
              [9.727499, 40.369438],
              [9.711388000000113, 40.358604000000128],
              [9.69972, 40.349442],
              [9.657221, 40.308327],
              [9.63694, 40.282219000000111],
              [9.62583, 40.262772],
              [9.623055, 40.255554],
              [9.622499, 40.251389],
              [9.62194, 40.237778000000105],
              [9.62333, 40.199715],
              [9.63, 40.186661],
              [9.652222, 40.144997000000103],
              [9.661388, 40.133331000000112],
              [9.692499, 40.106941],
              [9.70417, 40.097496],
              [9.713610000000131, 40.04055],
              [9.695, 39.935272],
              [9.674721, 39.808884],
              [9.670555, 39.779442000000131],
              [9.67028, 39.75694],
              [9.671665, 39.749161],
              [9.673887, 39.741661000000136],
              [9.675554, 39.738609],
              [9.676388, 39.73027],
              [9.675554, 39.712776000000133],
              [9.651667, 39.549164],
              [9.64222100000012, 39.486382],
              [9.630833, 39.430275],
              [9.600277000000119, 39.332771],
              [9.568054000000132, 39.2305530000001],
              [9.567221000000131, 39.22639],
              [9.563889000000131, 39.19722],
              [9.564165, 39.19305],
              [9.576944, 39.18471],
              [9.5791660000001, 39.181938],
              [9.579443, 39.178604],
              [9.569166000000109, 39.150551000000121],
              [9.565277, 39.14416],
              [9.556665000000123, 39.13721],
              [9.52167, 39.118332],
              [9.442636000000107, 39.12442],
              [9.410555000000102, 39.140831],
              [9.392221, 39.156944],
              [9.389444, 39.159164],
              [9.36611, 39.177498],
              [9.342499, 39.19416],
              [9.321665, 39.205826],
              [9.295277000000112, 39.213882],
              [9.018332, 39.266388],
              [9.01417, 39.265],
              [9.01111, 39.262772],
              [9.01055, 39.258606],
              [9.013332, 39.126389],
              [9.016109000000142, 39.10166],
              [9.02083, 39.083054],
              [9.02417, 39.076385],
              [9.043333, 39.044998],
              [9.006943, 38.98805],
              [8.906944, 38.90583],
              [8.897221, 38.89944],
              [8.859165, 38.879166],
              [8.85555, 38.877495000000124],
              [8.850277, 38.876938],
              [8.839722, 38.878052],
              [8.715277, 38.923607],
              [8.708055, 38.919998],
              [8.646387, 38.89027],
              [8.615833000000123, 38.918610000000115],
              [8.566387, 39.009995],
              [8.55139, 39.04999],
              [8.509776000000102, 39.06055],
              [8.507442, 39.061386],
              [8.501444000000106, 39.062218],
              [8.49861, 39.061718],
              [8.496444, 39.060715],
              [8.477276, 39.042885],
              [8.475777, 39.04121],
              [8.474777, 39.03938],
              [8.47011, 39.022717],
              [8.44916, 39.00944],
              [8.451185000000123, 38.992798],
              [8.449999, 38.98832700000014],
              [8.441944, 38.969719],
              [8.43111, 38.959717000000126],
              [8.41111, 38.957222],
              [8.40694, 38.958611],
              [8.404165, 38.961105],
              [8.361944, 39.02499],
              [8.35805, 39.035553],
              [8.346388000000104, 39.071938000000102],
              [8.345276000000126, 39.075554],
              [8.349722, 39.090553],
              [8.356667, 39.10833],
              [8.358332, 39.111382],
              [8.3625, 39.112778],
              [8.424444, 39.107773],
              [8.427221, 39.106384],
              [8.44472, 39.0925],
              [8.452221, 39.084717],
              [8.450999, 39.096161],
              [8.452665, 39.090996000000132],
              [8.454332, 39.086826],
              [8.45533, 39.085995],
              [8.461, 39.085331],
              [8.4625, 39.086998],
              [8.469000000000108, 39.095661000000121],
              [8.468665000000101, 39.097664],
              [8.459166, 39.117496],
              [8.43444, 39.160271],
              [8.429722, 39.165833000000134],
              [8.39694, 39.200554],
              [8.36611, 39.226105000000132],
              [8.424166000000127, 39.268883],
              [8.430277, 39.27777],
              [8.43361, 39.28916],
              [8.43361, 39.293884],
              [8.431944000000101, 39.301666],
              [8.418610000000115, 39.339439],
              [8.414721, 39.340828],
              [8.397499, 39.340553],
              [8.3933320000001, 39.341942],
              [8.386944, 39.35055],
              [8.371944, 39.371109000000104],
              [8.371111, 39.374718],
              [8.391943, 39.44722],
              [8.413055, 39.493607000000111],
              [8.44944, 39.628052],
              [8.447222000000124, 39.635277],
              [8.446665, 39.639442],
              [8.443333, 39.681938000000116],
              [8.44278, 39.75666],
              [8.444443, 39.75972],
              [8.448055000000124, 39.761383],
              [8.453054, 39.76221],
              [8.457777, 39.761383],
              [8.461111, 39.759438],
              [8.466389000000106, 39.75444],
              [8.49, 39.721939000000134],
              [8.50444, 39.72555],
              [8.52361100000013, 39.75222],
              [8.541943000000117, 39.779442000000131],
              [8.551666, 39.816666],
              [8.55722, 39.84499],
              [8.557499, 39.854164],
              [8.55666, 39.866104000000121],
              [8.553055, 39.872498],
              [8.548611, 39.878052],
              [8.526943000000131, 39.898048],
              [8.51805, 39.904999],
              [8.509722, 39.908051],
              [8.470554000000106, 39.91305],
              [8.458611000000133, 39.91333],
              [8.455, 39.911385],
              [8.442221, 39.902771000000143],
              [8.437498, 39.897499],
              [8.422499, 39.891663],
              [8.398611, 39.89666],
              [8.39583, 39.898888],
              [8.394722, 39.9025],
              [8.394722, 39.907219000000111],
              [8.398611, 39.9461060000001],
              [8.407499, 39.998604000000114],
              [8.41028, 40.014999],
              [8.464443, 40.143326],
              [8.461666, 40.22666],
              [8.457222000000115, 40.321388],
              [8.36722200000014, 40.492775],
              [8.306389, 40.58416],
              [8.301109, 40.589165],
              [8.293333, 40.592499],
              [8.201387, 40.615555],
              [8.190554, 40.616386],
              [8.172222, 40.598328],
              [8.167776, 40.592499],
              [8.166666, 40.588882],
              [8.16722, 40.584717],
              [8.16639, 40.580551000000128],
              [8.16139, 40.56611],
              [8.159443, 40.56277],
              [8.150276, 40.57833],
              [8.148333, 40.581665],
              [8.144444000000135, 40.592216],
              [8.14333, 40.605],
              [8.14361, 40.621666000000118],
              [8.146111, 40.624161000000129],
              [8.159721000000104, 40.6325],
              [8.17833, 40.636383000000137],
              [8.172222, 40.692215],
              [8.149721000000113, 40.721382],
              [8.148888000000113, 40.744164000000126],
              [8.192499, 40.913605],
              [8.228333, 40.94138],
              [8.227499000000137, 40.937492],
              [8.228054, 40.933327],
              [8.231388, 40.911385],
              [8.233055, 40.908051],
              [8.278055, 40.864441],
              [8.290833000000134, 40.855553],
              [8.304998000000126, 40.84805],
              [8.309166, 40.84666],
              [8.356388, 40.836105],
              [8.4575, 40.82194],
              [8.48, 40.820274],
              [8.505278, 40.823608],
              [8.543055, 40.831383],
              [8.579721, 40.84],
              [8.600832, 40.84666],
              [8.60472, 40.84833],
              [8.610832, 40.852776000000119],
              [8.617777, 40.861382],
              [8.623333, 40.87555],
              [8.627222, 40.881943],
              [8.63472, 40.889999000000103],
              [8.64222100000012, 40.89361],
              [8.650555000000111, 40.896385],
              [8.692221, 40.910271],
              [8.710554, 40.91444],
              [8.740276000000108, 40.91555],
              [8.751665, 40.914993],
              [8.7666660000001, 40.912216],
              [8.775276, 40.914993],
              [8.789999000000137, 40.921944],
              [8.810276000000101, 40.934441],
              [8.843887, 40.959717],
              [8.853888, 40.970551000000114],
              [8.858332, 40.97639],
              [8.872776, 40.997498],
              [8.874166000000116, 41.001389000000131],
              [9.010832, 41.121109000000104],
              [9.014444, 41.122772],
              [9.040277, 41.129715],
              [9.04389, 41.130554],
              [9.049444, 41.130829],
              [9.05416, 41.129997000000117],
              [9.160831, 41.191666],
              [9.16, 41.236382],
              [9.1625, 41.238327],
              [9.175554, 41.245827000000133],
              [9.233055, 41.254715],
              [9.513332, 41.14666],
            ],
          ],
          [
            [
              [8.339167, 41.062492000000134],
              [8.33055, 41.055275],
              [8.32805, 41.054718],
              [8.309444, 41.059166],
              [8.28833, 41.061661],
              [8.283888, 41.060272000000111],
              [8.2675, 41.054718],
              [8.240833, 41.030273],
              [8.24472, 40.986107],
              [8.22416, 40.986382000000106],
              [8.21528, 40.992493],
              [8.21417, 41.00444],
              [8.230833000000132, 41.04277],
              [8.28833, 41.099998],
              [8.314165000000116, 41.117218],
              [8.32111, 41.12138],
              [8.32472, 41.120277],
              [8.345276000000126, 41.094994],
              [8.347221000000104, 41.091660000000104],
              [8.346943, 41.088051000000121],
              [8.340555000000109, 41.066109],
              [8.339167, 41.062492000000134],
            ],
          ],
          [
            [
              [12.964167, 40.883888],
              [12.960278, 40.88222],
              [12.955, 40.883049],
              [12.952221, 40.885551000000135],
              [12.949999, 40.88833],
              [12.94583, 40.895828000000108],
              [12.944166, 40.899162000000103],
              [12.94611, 40.906387],
              [12.950277000000142, 40.91777],
              [12.953333, 40.919441],
              [12.97, 40.92722],
              [12.98805, 40.931389],
              [12.97555, 40.8975],
              [12.974165, 40.894722000000115],
              [12.964167, 40.883888],
            ],
          ],
          [
            [
              [13.951387000000125, 40.70138500000013],
              [13.891666, 40.69194],
              [13.863609, 40.701111],
              [13.856667, 40.704994000000113],
              [13.851944, 40.710548000000131],
              [13.85389, 40.73472],
              [13.86611, 40.75777],
              [13.879166, 40.76111],
              [13.88444, 40.76028],
              [13.943333, 40.743889],
              [13.948055000000124, 40.742493],
              [13.950832, 40.740273],
              [13.953609, 40.737778],
              [13.958332, 40.73055],
              [13.964998, 40.718605],
              [13.964998, 40.714439],
              [13.951387000000125, 40.70138500000013],
            ],
          ],
          [
            [
              [14.210554, 40.56055],
              [14.241388, 40.554993],
              [14.246387000000141, 40.55555],
              [14.249722, 40.557495000000131],
              [14.258333, 40.55971],
              [14.261665, 40.55778],
              [14.26194, 40.55555],
              [14.256666000000109, 40.551109],
              [14.254721000000131, 40.54805],
              [14.253611, 40.54416700000013],
              [14.250832, 40.542496],
              [14.24472, 40.546944],
              [14.239443, 40.547775],
              [14.23083, 40.545555],
              [14.219444, 40.540833000000134],
              [14.202499, 40.535828],
              [14.197222, 40.5366590000001],
              [14.19555, 40.539993],
              [14.19778, 40.553055],
              [14.19889, 40.55722],
              [14.200832, 40.560272],
              [14.210554, 40.56055],
            ],
          ],
          [
            [
              [8.292221, 39.093605000000139],
              [8.28722, 39.092773],
              [8.276667, 39.093605000000139],
              [8.25389, 39.103607000000125],
              [8.25111, 39.10583],
              [8.221109, 39.141937],
              [8.219999, 39.145554],
              [8.221388, 39.161942],
              [8.22389, 39.164719],
              [8.24361, 39.17222],
              [8.30278, 39.189995],
              [8.304443, 39.187492],
              [8.306665, 39.14416],
              [8.306389, 39.13222],
              [8.305555, 39.115273000000116],
              [8.304165000000125, 39.107216000000108],
              [8.295555, 39.095276],
              [8.292221, 39.093605000000139],
            ],
          ],
          [
            [
              [15.21361, 38.770554],
              [15.208332, 38.770554],
              [15.191387, 38.780548],
              [15.189165, 38.787498],
              [15.190277, 38.79055],
              [15.209444, 38.808052],
              [15.212221000000113, 38.81055],
              [15.216389, 38.811661],
              [15.227499000000137, 38.811104000000114],
              [15.239166, 38.806107],
              [15.241943000000106, 38.803604],
              [15.241943000000106, 38.799438000000123],
              [15.22972, 38.78083],
              [15.226944, 38.77833],
              [15.217777, 38.77166],
              [15.21361, 38.770554],
            ],
          ],
          [
            [
              [13.17333200000013, 38.690277],
              [13.158609, 38.688889],
              [13.154722000000106, 38.68972],
              [13.151943, 38.691940000000102],
              [13.152222, 38.695831],
              [13.16222, 38.714439],
              [13.165277, 38.716385000000116],
              [13.172777, 38.719719000000111],
              [13.18111, 38.721107],
              [13.184999, 38.719444000000124],
              [13.195555, 38.71388],
              [13.198332000000107, 38.711388],
              [13.19861, 38.707222000000115],
              [13.195833000000107, 38.70472],
              [13.180832, 38.693604000000107],
              [13.17778, 38.691666],
              [13.17333200000013, 38.690277],
            ],
          ],
          [
            [
              [14.868332000000123, 38.531387],
              [14.86472, 38.529716000000121],
              [14.854166, 38.531387],
              [14.835278, 38.540276],
              [14.796944, 38.55861],
              [14.79361, 38.56472],
              [14.79472, 38.56777],
              [14.803888, 38.58138300000013],
              [14.808611, 38.58194],
              [14.864166, 38.579437],
              [14.86861, 38.578049000000135],
              [14.873333, 38.572777],
              [14.873888, 38.56916],
              [14.873333, 38.564438],
              [14.868332000000123, 38.531387],
            ],
          ],
          [
            [
              [14.95528, 38.445549000000142],
              [14.950554, 38.445],
              [14.91222, 38.46611],
              [14.906111, 38.47083],
              [14.901667, 38.476105],
              [14.898054000000116, 38.486382],
              [14.898611, 38.490273000000116],
              [14.903889000000106, 38.509438000000102],
              [14.909166, 38.514717],
              [14.91222, 38.516663],
              [14.916111, 38.518326],
              [14.923887, 38.52],
              [14.957499, 38.52166],
              [14.961943, 38.520271],
              [14.963888, 38.517494],
              [14.96611, 38.510551],
              [14.963055, 38.452499],
              [14.96222, 38.449165],
              [14.95917, 38.44722],
              [14.95528, 38.445549000000142],
            ],
          ],
          [
            [
              [14.98889, 38.364166000000125],
              [14.983610000000112, 38.364166000000125],
              [14.979721, 38.365829],
              [14.95611, 38.379997000000117],
              [14.953054, 38.381943],
              [14.941111, 38.399437],
              [14.940277, 38.40305],
              [14.945555, 38.418327],
              [14.958887, 38.431107],
              [14.9625, 38.431938],
              [14.966389, 38.430275000000108],
              [14.99667, 38.395271],
              [15.004166, 38.379166000000112],
              [15.004166, 38.374992],
              [15.0, 38.368889000000138],
              [14.993055, 38.365273],
              [14.98889, 38.364166000000125],
            ],
          ],
          [
            [
              [15.528889, 38.13694],
              [15.50944, 38.089439],
              [15.504721, 38.078888],
              [15.502499, 38.075829],
              [15.497776, 38.07027],
              [15.427776, 38.000832000000116],
              [15.371387, 37.946663],
              [15.366665, 37.941109],
              [15.235277, 37.785271],
              [15.219721, 37.764442],
              [15.218054000000109, 37.711388],
              [15.2175, 37.70694],
              [15.20083, 37.651382],
              [15.178055, 37.575554000000125],
              [15.169722, 37.56333],
              [15.1675, 37.560272000000111],
              [15.156944, 37.548607],
              [15.154444000000126, 37.546104],
              [15.145555, 37.539444],
              [15.11861, 37.51944],
              [15.098331, 37.498604],
              [15.093611000000124, 37.49305],
              [15.091389000000106, 37.489998000000128],
              [15.08667, 37.479439],
              [15.08583, 37.463051],
              [15.091110000000128, 37.35804],
              [15.091944, 37.349716],
              [15.093887, 37.342773],
              [15.186943, 37.18388],
              [15.203888, 37.15749],
              [15.229443, 37.126106000000107],
              [15.23194, 37.123604],
              [15.251665, 37.111664000000133],
              [15.25611, 37.11027],
              [15.266109000000142, 37.108604],
              [15.29305, 37.10805],
              [15.2975, 37.106667],
              [15.303333, 37.102219],
              [15.305832, 37.095551000000114],
              [15.316111, 37.0430530000001],
              [15.316666000000112, 37.008888],
              [15.26222, 36.98167],
              [15.21417, 36.955276],
              [15.180277000000103, 36.935272000000111],
              [15.152777, 36.916382],
              [15.148611, 36.910271],
              [15.110277, 36.839996],
              [15.094721000000106, 36.79972],
              [15.095554000000106, 36.783607],
              [15.096388, 36.779716000000121],
              [15.104443, 36.755829],
              [15.113888, 36.745552],
              [15.119165, 36.736382],
              [15.135832000000107, 36.685272],
              [15.13611, 36.677773],
              [15.131943, 36.66666],
              [15.097221, 36.653885],
              [15.08583, 36.64972],
              [15.081388, 36.649162],
              [15.049166000000127, 36.68222],
              [15.038332, 36.691666],
              [15.027777, 36.69722],
              [15.019444, 36.69999700000011],
              [14.900833, 36.724998000000141],
              [14.890833, 36.72666],
              [14.868055, 36.728333],
              [14.858332000000132, 36.727776000000119],
              [14.813889000000131, 36.715],
              [14.77916, 36.70444],
              [14.721388, 36.718605],
              [14.55361, 36.780273],
              [14.460554, 36.830826],
              [14.457777, 36.837494],
              [14.44111, 36.873329],
              [14.421944, 36.9025],
              [14.414165, 36.91416],
              [14.410276, 36.919716],
              [14.39389, 36.942497],
              [14.37361, 36.966385000000116],
              [14.35368, 36.983864],
              [14.340555, 36.994720000000143],
              [14.283888, 37.036942],
              [14.268888, 37.04805],
              [14.245832, 37.062218],
              [14.15361, 37.096382000000119],
              [14.136389, 37.10166],
              [14.10972, 37.108887],
              [14.093887, 37.110832],
              [13.99805, 37.11027],
              [13.955755, 37.100349],
              [13.934999, 37.094719],
              [13.929722, 37.094719],
              [13.89472, 37.097771],
              [13.880554, 37.101105],
              [13.73833, 37.157776],
              [13.67305, 37.18972],
              [13.669998, 37.19194],
              [13.661943, 37.199165000000107],
              [13.655277, 37.20638300000013],
              [13.651388, 37.212219],
              [13.643888000000118, 37.219994],
              [13.571665, 37.272499],
              [13.56194, 37.27916],
              [13.543333, 37.28333],
              [13.50528, 37.287216000000114],
              [13.412777, 37.324165],
              [13.33, 37.361107],
              [13.27861, 37.389999000000103],
              [13.273333, 37.394722],
              [13.268888000000118, 37.404716000000121],
              [13.256666000000109, 37.421944],
              [13.218332, 37.45527600000014],
              [13.16667, 37.48778],
              [13.158888, 37.491104],
              [13.149166, 37.49305],
              [13.085833, 37.49305],
              [12.99, 37.536942000000124],
              [12.98, 37.546104],
              [12.970833, 37.552498],
              [12.953609000000142, 37.562218000000144],
              [12.925278000000105, 37.57249],
              [12.920555, 37.573608],
              [12.8025, 37.579994000000113],
              [12.783054, 37.578049000000135],
              [12.75611, 37.573051000000135],
              [12.734999, 37.567772],
              [12.7225, 37.564438],
              [12.688332, 37.556107000000111],
              [12.674444, 37.554161],
              [12.665277, 37.55555],
              [12.657499, 37.558609],
              [12.65083, 37.562492],
              [12.51417, 37.658882000000119],
              [12.468332, 37.699165],
              [12.424721, 37.789162],
              [12.422222, 37.796104],
              [12.422777, 37.799995],
              [12.426666000000125, 37.805275000000108],
              [12.43555, 37.80971],
              [12.439444, 37.808052],
              [12.441666, 37.806107],
              [12.452499, 37.811104000000114],
              [12.458055, 37.815826],
              [12.461666, 37.822495000000117],
              [12.478333, 37.863327],
              [12.47889, 37.872498],
              [12.4780540000001, 37.876106],
              [12.47611, 37.879166],
              [12.466389, 37.916107000000125],
              [12.50528, 38.00972],
              [12.515, 38.02055],
              [12.556389000000138, 38.059715],
              [12.559999, 38.061386],
              [12.73361, 38.139717],
              [12.821665, 38.068886],
              [12.875832, 38.030273000000136],
              [12.892221, 38.024437],
              [12.896666, 38.023331],
              [12.906666, 38.023048],
              [12.916666, 38.023888000000113],
              [12.930555, 38.02583],
              [12.955555, 38.032776000000126],
              [13.01916, 38.058884],
              [13.05583, 38.074715],
              [13.06278, 38.07861],
              [13.07028, 38.086388],
              [13.07249800000011, 38.089439],
              [13.07361, 38.098053],
              [13.064165, 38.121384],
              [13.06, 38.12722],
              [13.05472200000014, 38.131943],
              [13.05333, 38.135277],
              [13.054165, 38.138611],
              [13.091665, 38.17889],
              [13.100832, 38.185272],
              [13.104443, 38.186943],
              [13.316666, 38.21833],
              [13.320555, 38.21666],
              [13.356943, 38.188332000000116],
              [13.35889, 38.185555],
              [13.368889000000138, 38.16666],
              [13.375277, 38.153885000000116],
              [13.375277, 38.149719],
              [13.36861, 38.140831],
              [13.362778, 38.128609],
              [13.363609, 38.124718],
              [13.36972, 38.116104000000121],
              [13.372499, 38.11360900000011],
              [13.382500000000107, 38.107498],
              [13.711388, 37.976662],
              [13.752499, 37.971382],
              [13.768888, 37.970551],
              [13.791111, 37.972221],
              [13.820986000000119, 37.978737],
              [13.886665, 37.998055],
              [13.910276000000124, 38.006386],
              [13.916943, 38.009995000000117],
              [13.919443000000115, 38.012497],
              [13.940832, 38.027771],
              [13.947777, 38.031387000000109],
              [14.013887, 38.035828],
              [14.132776, 38.02277400000014],
              [14.242777, 38.01221],
              [14.31194, 38.01221],
              [14.36555, 38.018051],
              [14.37028, 38.018608],
              [14.519444, 38.042770000000132],
              [14.633055000000127, 38.07222],
              [14.637220000000127, 38.073326],
              [14.643888, 38.07666],
              [14.659721, 38.086937],
              [14.784721000000104, 38.154442],
              [14.87444, 38.170555],
              [14.963610000000131, 38.159721],
              [14.975277, 38.154716000000121],
              [15.074999, 38.121666],
              [15.08667, 38.120827000000133],
              [15.090832, 38.121666],
              [15.102499, 38.125832],
              [15.15083, 38.145554],
              [15.30167, 38.207222],
              [15.507221000000129, 38.29055],
              [15.523611, 38.295273],
              [15.540277000000117, 38.297493],
              [15.551388, 38.296387],
              [15.64805, 38.271660000000111],
              [15.652498, 38.27027],
              [15.65389, 38.26694],
              [15.65167, 38.263885],
              [15.64435, 38.260963],
              [15.61278, 38.251389000000131],
              [15.603611, 38.250000000000114],
              [15.587221000000113, 38.24528],
              [15.577221000000122, 38.239716000000101],
              [15.572498, 38.233887],
              [15.56805, 38.22805000000011],
              [15.559999, 38.21027400000014],
              [15.528889, 38.13694],
            ],
          ],
          [
            [
              [12.073889000000122, 37.953606],
              [12.077221000000122, 37.94472],
              [12.047222, 37.95388800000012],
              [12.043888, 37.95611],
              [12.02916, 37.983604],
              [12.029999, 37.986938],
              [12.059166, 37.989166000000125],
              [12.06055, 37.986664],
              [12.073889000000122, 37.953606],
            ],
          ],
          [
            [
              [12.354166, 37.9061],
              [12.349443, 37.905548],
              [12.292500000000132, 37.916664],
              [12.283888000000104, 37.919167],
              [12.272221, 37.932777000000101],
              [12.271387000000118, 37.936386],
              [12.273888000000113, 37.938889],
              [12.279165, 37.939163],
              [12.312777, 37.939438],
              [12.334444000000133, 37.935555],
              [12.33917, 37.934441000000106],
              [12.364721, 37.92305],
              [12.366388000000143, 37.91972],
              [12.363888, 37.912216],
              [12.357777, 37.907776],
              [12.354166, 37.9061],
            ],
          ],
          [
            [
              [12.01583, 36.738327],
              [12.000555000000134, 36.737495000000138],
              [11.993055, 36.73860900000011],
              [11.98722, 36.740555],
              [11.953609000000142, 36.761383],
              [11.92639, 36.793884],
              [11.92277700000011, 36.80416],
              [11.921665000000132, 36.81638],
              [11.923611, 36.821938],
              [11.930832000000123, 36.82972],
              [11.934999000000118, 36.833054],
              [11.940277, 36.835548],
              [11.94722, 36.836662000000103],
              [11.954721, 36.836937],
              [11.962221, 36.8361],
              [11.996666, 36.83028],
              [12.007500000000107, 36.825272],
              [12.048332, 36.796944],
              [12.050554, 36.79361],
              [12.055555, 36.771111000000133],
              [12.054165, 36.761665],
              [12.05139, 36.756943],
              [12.047777, 36.753052],
              [12.038332000000139, 36.747215],
              [12.027777, 36.74222],
              [12.01583, 36.738327],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "LG",
        ISO2: "LV",
        ISO3: "LVA",
        UN: 428,
        NAME: "Latvia",
        AREA: 6205,
        POP2005: 2301793,
        REGION: 150,
        SUBREGION: 154,
        LON: 25.641,
        LAT: 56.858,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [21.068607, 56.435547],
            [21.057774, 56.510551],
            [21.026665, 56.614159],
            [21.039719, 56.644157],
            [21.049442, 56.671936],
            [21.056107, 56.691376],
            [21.06472, 56.742767],
            [21.065273, 56.751938],
            [21.064163, 56.777771],
            [21.062775, 56.78611],
            [21.053349, 56.808739],
            [21.050274, 56.819717],
            [21.051941, 56.832771],
            [21.053608, 56.83638],
            [21.060555, 56.84166],
            [21.064999, 56.84388],
            [21.069996, 56.845825],
            [21.144997, 56.872765],
            [21.224438, 56.906654],
            [21.261387, 56.922768],
            [21.356106, 56.986107],
            [21.359718, 56.988602],
            [21.391663, 57.021935],
            [21.399719, 57.03138],
            [21.409439, 57.049438],
            [21.41555, 57.069443],
            [21.415829, 57.087212],
            [21.414997, 57.099998],
            [21.411385, 57.124435],
            [21.412216, 57.234436],
            [21.412773, 57.243607],
            [21.415829, 57.278046],
            [21.416939, 57.282211],
            [21.420551, 57.289436],
            [21.428883, 57.298882],
            [21.439438, 57.306938],
            [21.452496, 57.313324],
            [21.464718, 57.320549],
            [21.482494, 57.333878],
            [21.596107, 57.443321],
            [21.639996, 57.488884],
            [21.66555, 57.516663],
            [21.674164, 57.530823],
            [21.679718, 57.536942],
            [21.70583, 57.559715],
            [21.724716, 57.572495],
            [21.73333, 57.576942],
            [21.754997, 57.583328],
            [21.849442, 57.594994],
            [21.863052, 57.596657],
            [21.901108, 57.593605],
            [21.914719, 57.591377],
            [21.930828, 57.590546],
            [21.981937, 57.59388],
            [22.00111, 57.597214],
            [22.012218, 57.600273],
            [22.027222, 57.605827],
            [22.049164, 57.616661],
            [22.098331, 57.633881],
            [22.281387, 57.684715],
            [22.474438, 57.738045],
            [22.485828, 57.741104],
            [22.582775, 57.755272],
            [22.603607, 57.7575],
            [22.610275, 57.756386],
            [22.613331, 57.753609],
            [22.614719, 57.75],
            [22.609161, 57.743881],
            [22.601662, 57.738327],
            [22.598885, 57.735268],
            [22.584442, 57.697769],
            [22.583054, 57.684433],
            [22.584164, 57.676102],
            [22.591385, 57.644714],
            [22.595551, 57.633881],
            [22.599998, 57.627213],
            [22.637218, 57.588882],
            [22.649441, 57.581665],
            [22.672218, 57.571106],
            [22.75111, 57.535271],
            [22.905273, 57.454712],
            [22.934719, 57.434158],
            [22.942772, 57.429436],
            [22.952496, 57.424995],
            [23.014164, 57.398605],
            [23.049164, 57.385269],
            [23.083607, 57.375824],
            [23.103607, 57.37249],
            [23.134163, 57.365829],
            [23.137218, 57.363052],
            [23.167496, 57.312767],
            [23.239437, 57.172218],
            [23.242771, 57.165268],
            [23.249161, 57.114716],
            [23.253052, 57.103882],
            [23.259163, 57.098045],
            [23.305832, 57.073326],
            [23.327496, 57.06221],
            [23.341942, 57.056099],
            [23.351387, 57.052216],
            [23.586109, 56.976654],
            [23.646107, 56.966934],
            [23.660275, 56.964996],
            [23.668606, 56.964714],
            [23.765274, 56.968323],
            [23.785831, 56.970268],
            [23.850273, 56.983879],
            [23.873608, 56.988884],
            [23.955273, 57.011383],
            [23.984993, 57.022217],
            [24.155273, 57.097488],
            [24.223328, 57.128876],
            [24.366108, 57.213608],
            [24.373608, 57.21888],
            [24.38694, 57.229988],
            [24.400829, 57.245827],
            [24.407497, 57.25666],
            [24.413052, 57.272766],
            [24.41333, 57.281662],
            [24.410553, 57.346382],
            [24.407772, 57.362213],
            [24.362217, 57.580826],
            [24.332218, 57.698044],
            [24.329441, 57.700829],
            [24.307774, 57.724991],
            [24.303608, 57.731659],
            [24.297218, 57.744995],
            [24.289719, 57.792496],
            [24.286663, 57.824715],
            [24.288052, 57.83416],
            [24.294441, 57.850273],
            [24.31498, 57.871826],
            [24.32444, 57.87027],
            [24.373051, 57.868881],
            [24.402496, 57.870544],
            [24.420273, 57.874435],
            [24.427773, 57.879433],
            [24.433884, 57.885826],
            [24.438328, 57.892769],
            [24.441105, 57.900826],
            [24.443329, 57.904434],
            [24.453049, 57.913322],
            [24.542774, 57.95166],
            [24.553608, 57.954712],
            [24.560555, 57.955551],
            [24.723885, 57.964996],
            [25.015831, 58.039436],
            [25.03833, 58.05027],
            [25.060829, 58.061104],
            [25.069996, 58.065269],
            [25.091663, 58.071663],
            [25.124439, 58.076103],
            [25.139164, 58.07666],
            [25.163052, 58.075829],
            [25.169994, 58.07444],
            [25.179718, 58.070274],
            [25.192493, 58.059433],
            [25.199718, 58.049995],
            [25.203884, 58.039162],
            [25.207218, 58.028046],
            [25.210827, 58.012497],
            [25.214996, 58.005829],
            [25.223885, 57.997215],
            [25.232494, 57.992767],
            [25.247215, 57.992493],
            [25.285831, 58.003052],
            [25.294441, 58.0075],
            [25.299999, 58.01416],
            [25.300552, 58.018883],
            [25.300274, 58.026939],
            [25.296944, 58.038048],
            [25.29472, 58.041382],
            [25.288887, 58.047218],
            [25.264442, 58.061378],
            [25.263054, 58.06916],
            [25.266941, 58.076942],
            [25.275555, 58.081665],
            [25.28722, 58.08416],
            [25.294998, 58.084435],
            [25.301662, 58.083054],
            [25.307499, 58.081383],
            [25.421661, 58.035553],
            [25.436108, 58.029434],
            [25.439995, 58.026939],
            [25.444996, 58.020828],
            [25.44944, 58.005829],
            [25.453327, 57.999435],
            [25.461105, 57.994438],
            [25.618053, 57.918327],
            [25.622772, 57.916382],
            [25.801388, 57.865829],
            [25.836384, 57.86055],
            [25.883053, 57.855827],
            [25.946941, 57.853882],
            [26.034996, 57.823326],
            [26.204441, 57.694992],
            [26.274166, 57.629715],
            [26.287498, 57.618881],
            [26.299164, 57.611382],
            [26.313332, 57.604996],
            [26.511387, 57.5261],
            [26.523609, 57.523048],
            [26.538887, 57.522217],
            [26.602776, 57.525826],
            [26.608887, 57.526939],
            [26.612774, 57.529434],
            [26.615273, 57.533051],
            [26.619995, 57.544998],
            [26.626385, 57.551102],
            [26.634995, 57.555824],
            [26.697773, 57.575554],
            [26.873051, 57.630547],
            [26.883884, 57.633606],
            [26.898331, 57.633881],
            [26.906105, 57.633049],
            [26.969994, 57.623322],
            [26.996105, 57.618324],
            [27.018608, 57.611382],
            [27.03194, 57.604713],
            [27.03944, 57.599716],
            [27.051662, 57.588326],
            [27.070274, 57.567497],
            [27.080551, 57.563606],
            [27.087219, 57.56221],
            [27.310276, 57.53138],
            [27.372059, 57.535637],
            [27.424995, 57.531937],
            [27.44944, 57.531105],
            [27.471661, 57.53138],
            [27.547218, 57.536385],
            [27.542774, 57.493607],
            [27.526386, 57.449432],
            [27.525555, 57.445824],
            [27.525555, 57.441658],
            [27.527222, 57.438599],
            [27.53833, 57.430824],
            [27.562496, 57.420547],
            [27.580276, 57.415825],
            [27.606384, 57.410545],
            [27.687218, 57.37999],
            [27.825275, 57.323883],
            [27.849163, 57.313606],
            [27.85305, 57.311104],
            [27.861107, 57.302216],
            [27.865551, 57.291939],
            [27.866386, 57.288048],
            [27.863884, 57.262497],
            [27.851387, 57.187767],
            [27.848331, 57.174164],
            [27.846386, 57.169991],
            [27.774719, 57.057213],
            [27.70166, 56.914711],
            [27.731106, 56.869156],
            [27.762497, 56.873604],
            [27.79361, 56.877769],
            [27.80722, 56.878876],
            [27.815552, 56.878326],
            [27.837776, 56.875549],
            [27.860554, 56.868881],
            [27.935272, 56.827217],
            [27.938885, 56.82444],
            [27.940552, 56.821106],
            [27.940552, 56.81694],
            [27.933605, 56.801102],
            [27.931107, 56.797493],
            [27.924717, 56.791382],
            [27.917496, 56.78611],
            [27.943607, 56.722763],
            [28.009441, 56.648331],
            [28.114162, 56.517494],
            [28.147774, 56.471375],
            [28.182774, 56.40638],
            [28.233051, 56.289436],
            [28.23555, 56.282211],
            [28.237774, 56.271103],
            [28.237495, 56.262772],
            [28.199162, 56.18499],
            [28.194996, 56.17749],
            [28.184994, 56.163322],
            [28.181938, 56.160545],
            [28.168011, 56.150154],
            [28.161663, 56.154991],
            [28.154716, 56.159988],
            [28.149998, 56.162209],
            [28.132217, 56.166664],
            [28.124996, 56.16777],
            [28.118328, 56.167213],
            [27.92944, 56.113327],
            [27.925552, 56.110825],
            [27.918327, 56.100273],
            [27.916664, 56.0961],
            [27.902218, 56.074997],
            [27.89333, 56.065544],
            [27.796108, 56.001106],
            [27.712494, 55.9561],
            [27.654995, 55.929161],
            [27.647217, 55.924164],
            [27.641663, 55.912491],
            [27.63055, 55.864159],
            [27.630276, 55.855827],
            [27.633884, 55.849159],
            [27.633884, 55.844994],
            [27.632774, 55.840546],
            [27.631107, 55.83638],
            [27.619995, 55.818329],
            [27.601662, 55.793327],
            [27.598824, 55.791718],
            [27.559719, 55.789162],
            [27.531109, 55.788887],
            [27.310829, 55.807495],
            [27.211662, 55.825829],
            [27.156105, 55.846382],
            [27.149441, 55.846657],
            [26.989994, 55.834717],
            [26.981663, 55.829994],
            [26.908051, 55.778603],
            [26.901939, 55.772491],
            [26.888607, 55.750832],
            [26.885551, 55.742767],
            [26.883331, 55.739159],
            [26.875553, 55.729156],
            [26.863331, 55.716934],
            [26.849998, 55.710823],
            [26.765831, 55.687492],
            [26.745274, 55.686653],
            [26.731663, 55.688881],
            [26.692051, 55.701736],
            [26.668884, 55.705826],
            [26.661663, 55.705826],
            [26.651108, 55.702774],
            [26.633331, 55.69471],
            [26.629719, 55.692215],
            [26.619995, 55.683601],
            [26.613209, 55.674835],
            [26.591385, 55.674995],
            [26.575275, 55.676102],
            [26.531387, 55.680824],
            [26.51083, 55.683876],
            [26.498329, 55.686378],
            [26.375553, 55.714157],
            [26.35833, 55.71888],
            [26.338608, 55.726379],
            [26.313332, 55.739716],
            [26.275276, 55.76416],
            [26.268887, 55.76944],
            [26.263332, 55.775269],
            [26.256943, 55.784721],
            [26.240273, 55.814995],
            [26.239162, 55.818886],
            [26.221939, 55.839989],
            [26.210827, 55.851662],
            [26.20166, 55.859993],
            [26.19083, 55.867493],
            [26.058331, 55.938042],
            [26.014275, 55.955154],
            [25.996384, 55.959717],
            [25.942219, 55.976936],
            [25.932217, 55.980545],
            [25.891106, 55.999435],
            [25.714996, 56.089989],
            [25.707771, 56.094994],
            [25.704994, 56.098045],
            [25.699162, 56.108047],
            [25.696941, 56.115273],
            [25.582775, 56.151382],
            [25.429718, 56.166382],
            [25.327496, 56.169159],
            [25.262497, 56.180824],
            [25.183052, 56.183327],
            [25.160275, 56.184433],
            [25.145828, 56.186104],
            [25.133884, 56.188881],
            [25.106106, 56.197212],
            [25.096943, 56.201103],
            [25.081108, 56.210548],
            [25.072498, 56.219154],
            [25.0, 56.295547],
            [24.99305, 56.304993],
            [24.981937, 56.329163],
            [24.970551, 56.353607],
            [24.956661, 56.382492],
            [24.942219, 56.406937],
            [24.922218, 56.439987],
            [24.91555, 56.445267],
            [24.906105, 56.449432],
            [24.899719, 56.450546],
            [24.891384, 56.450829],
            [24.87944, 56.448601],
            [24.653328, 56.365829],
            [24.602776, 56.329163],
            [24.582497, 56.312492],
            [24.562775, 56.29055],
            [24.558331, 56.28833],
            [24.479996, 56.269714],
            [24.473328, 56.269157],
            [24.44944, 56.269714],
            [24.42944, 56.272766],
            [24.418327, 56.2761],
            [24.404163, 56.281937],
            [24.378883, 56.295547],
            [24.364719, 56.301659],
            [24.345276, 56.309158],
            [24.339718, 56.310822],
            [24.332218, 56.310547],
            [24.320274, 56.308327],
            [24.264999, 56.289436],
            [24.175274, 56.263329],
            [24.16333, 56.261108],
            [24.147774, 56.261383],
            [24.13583, 56.26416],
            [24.07444, 56.281662],
            [24.065273, 56.285553],
            [24.008331, 56.318054],
            [23.991383, 56.322769],
            [23.948883, 56.332214],
            [23.873608, 56.342766],
            [23.741104, 56.359993],
            [23.726383, 56.361382],
            [23.608608, 56.364159],
            [23.596943, 56.362213],
            [23.584721, 56.355553],
            [23.578884, 56.349159],
            [23.568054, 56.341377],
            [23.559441, 56.337212],
            [23.547497, 56.334717],
            [23.525276, 56.33416],
            [23.454441, 56.343048],
            [23.441662, 56.345268],
            [23.367775, 56.364998],
            [23.35833, 56.369156],
            [23.332218, 56.377769],
            [23.319996, 56.380272],
            [23.296108, 56.380821],
            [23.182217, 56.364716],
            [23.171108, 56.361938],
            [23.167496, 56.359161],
            [23.168053, 56.35527],
            [23.171108, 56.352219],
            [23.177494, 56.351105],
            [23.181385, 56.348877],
            [23.180275, 56.345543],
            [23.147217, 56.322495],
            [23.129997, 56.313881],
            [23.110275, 56.306656],
            [23.104443, 56.30555],
            [23.096107, 56.305824],
            [23.068054, 56.313606],
            [23.053886, 56.319443],
            [23.037498, 56.328606],
            [23.031387, 56.33416],
            [23.018055, 56.349434],
            [23.013054, 56.355553],
            [23.008331, 56.366104],
            [22.999161, 56.383331],
            [22.992771, 56.393051],
            [22.98666, 56.398605],
            [22.955551, 56.418053],
            [22.946941, 56.422218],
            [22.941383, 56.423882],
            [22.933884, 56.424438],
            [22.928051, 56.423325],
            [22.916939, 56.420547],
            [22.886383, 56.410271],
            [22.860275, 56.397491],
            [22.846107, 56.38694],
            [22.837498, 56.382492],
            [22.827221, 56.379158],
            [22.691383, 56.356659],
            [22.671108, 56.358604],
            [22.661385, 56.362495],
            [22.653606, 56.36721],
            [22.643608, 56.375267],
            [22.63583, 56.380272],
            [22.628052, 56.384995],
            [22.623329, 56.38694],
            [22.611942, 56.389992],
            [22.586941, 56.394714],
            [22.553608, 56.399719],
            [22.519165, 56.404434],
            [22.497215, 56.40638],
            [22.481384, 56.40638],
            [22.309441, 56.403877],
            [22.154442, 56.424164],
            [22.139439, 56.423607],
            [22.067219, 56.419441],
            [22.048885, 56.4161],
            [22.038609, 56.412766],
            [21.905273, 56.369156],
            [21.73555, 56.323326],
            [21.566666, 56.295273],
            [21.447773, 56.248878],
            [21.427773, 56.241936],
            [21.42194, 56.240547],
            [21.407772, 56.239433],
            [21.391384, 56.239716],
            [21.384995, 56.240829],
            [21.376663, 56.241104],
            [21.361107, 56.240829],
            [21.354443, 56.23999],
            [21.345829, 56.23555],
            [21.258888, 56.178604],
            [21.244438, 56.168327],
            [21.239162, 56.162209],
            [21.234718, 56.141106],
            [21.233883, 56.123047],
            [21.228882, 56.107216],
            [21.223328, 56.0961],
            [21.218052, 56.089989],
            [21.209717, 56.085548],
            [21.204716, 56.083878],
            [21.197216, 56.083328],
            [21.146664, 56.088043],
            [21.123886, 56.087494],
            [21.108887, 56.086655],
            [21.089165, 56.08416],
            [21.058052, 56.079437],
            [21.051685, 56.077309],
            [21.046387, 56.109161],
            [21.039165, 56.127487],
            [21.025829, 56.156097],
            [21.018887, 56.165825],
            [21.006386, 56.176941],
            [21.00222, 56.179161],
            [20.988884, 56.189987],
            [20.975273, 56.229988],
            [20.971939, 56.245827],
            [20.968605, 56.363609],
            [20.995548, 56.508331],
            [20.999718, 56.510551],
            [21.016388, 56.510277],
            [21.023052, 56.509438],
            [21.02861, 56.508049],
            [21.031666, 56.504997],
            [21.044441, 56.458328],
            [21.068607, 56.435547],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "BO",
        ISO2: "BY",
        ISO3: "BLR",
        UN: 112,
        NAME: "Belarus",
        AREA: 20748,
        POP2005: 9795287,
        REGION: 150,
        SUBREGION: 151,
        LON: 28.047,
        LAT: 53.54,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [26.613209, 55.674835],
            [26.619995, 55.683601],
            [26.629719, 55.692215],
            [26.633331, 55.69471],
            [26.651108, 55.702774],
            [26.661663, 55.705826],
            [26.668884, 55.705826],
            [26.692051, 55.701736],
            [26.731663, 55.688881],
            [26.745274, 55.686653],
            [26.765831, 55.687492],
            [26.849998, 55.710823],
            [26.863331, 55.716934],
            [26.875553, 55.729156],
            [26.883331, 55.739159],
            [26.885551, 55.742767],
            [26.888607, 55.750832],
            [26.901939, 55.772491],
            [26.908051, 55.778603],
            [26.981663, 55.829994],
            [26.989994, 55.834717],
            [27.149441, 55.846657],
            [27.156105, 55.846382],
            [27.211662, 55.825829],
            [27.310829, 55.807495],
            [27.531109, 55.788887],
            [27.559719, 55.789162],
            [27.598824, 55.791718],
            [27.601662, 55.793327],
            [27.619995, 55.818329],
            [27.631107, 55.83638],
            [27.632774, 55.840546],
            [27.633884, 55.844994],
            [27.633884, 55.849159],
            [27.630276, 55.855827],
            [27.63055, 55.864159],
            [27.641663, 55.912491],
            [27.647217, 55.924164],
            [27.654995, 55.929161],
            [27.712494, 55.9561],
            [27.796108, 56.001106],
            [27.89333, 56.065544],
            [27.902218, 56.074997],
            [27.916664, 56.0961],
            [27.918327, 56.100273],
            [27.925552, 56.110825],
            [27.92944, 56.113327],
            [28.118328, 56.167213],
            [28.124996, 56.16777],
            [28.132217, 56.166664],
            [28.149998, 56.162209],
            [28.154716, 56.159988],
            [28.161663, 56.154991],
            [28.168011, 56.150154],
            [28.168606, 56.148605],
            [28.185272, 56.135269],
            [28.188885, 56.132767],
            [28.307301, 56.052727],
            [28.312496, 56.049995],
            [28.339996, 56.051102],
            [28.34972, 56.05471],
            [28.353607, 56.056938],
            [28.358498, 56.061546],
            [28.362495, 56.066666],
            [28.367775, 56.078606],
            [28.37833, 56.092216],
            [28.382217, 56.094711],
            [28.387497, 56.0961],
            [28.520832, 56.10527],
            [28.535553, 56.104996],
            [28.613884, 56.100273],
            [28.628052, 56.098328],
            [28.646107, 56.093605],
            [28.653885, 56.088882],
            [28.697216, 56.03833],
            [28.702217, 56.032211],
            [28.705551, 56.025551],
            [28.707218, 56.018051],
            [28.705551, 56.005272],
            [28.707218, 55.997772],
            [28.70805, 55.994156],
            [28.719715, 55.974709],
            [28.73127, 55.96241],
            [28.738049, 55.958328],
            [28.754166, 55.95388],
            [28.832775, 55.942215],
            [28.846943, 55.94249],
            [28.849998, 55.945541],
            [28.845829, 55.951935],
            [28.845276, 55.955551],
            [28.846386, 55.960274],
            [28.850517, 55.969078],
            [28.860828, 55.976097],
            [28.869442, 55.980545],
            [29.006107, 56.02388],
            [29.021942, 56.028328],
            [29.033333, 56.030548],
            [29.059441, 56.032768],
            [29.139164, 56.021935],
            [29.172218, 56.015549],
            [29.401386, 55.96138],
            [29.412216, 55.957771],
            [29.425274, 55.951103],
            [29.44944, 55.933052],
            [29.45694, 55.924164],
            [29.463608, 55.914711],
            [29.464439, 55.911102],
            [29.461941, 55.908325],
            [29.442493, 55.906654],
            [29.419441, 55.902771],
            [29.410275, 55.89888],
            [29.40694, 55.895828],
            [29.404442, 55.892494],
            [29.360828, 55.802216],
            [29.35833, 55.793327],
            [29.359161, 55.789436],
            [29.371384, 55.770546],
            [29.379162, 55.761665],
            [29.38583, 55.756386],
            [29.392773, 55.751389],
            [29.47916, 55.69471],
            [29.487774, 55.690544],
            [29.493885, 55.688881],
            [29.515274, 55.689156],
            [29.526386, 55.691376],
            [29.540833, 55.702217],
            [29.656384, 55.765274],
            [29.90694, 55.8461],
            [29.928329, 55.851662],
            [29.946384, 55.854439],
            [29.972515, 55.856369],
            [30.245827, 55.854439],
            [30.466663, 55.80555],
            [30.489716, 55.799995],
            [30.493328, 55.79805],
            [30.603329, 55.7286],
            [30.612495, 55.720268],
            [30.614998, 55.717491],
            [30.613052, 55.704712],
            [30.655273, 55.660545],
            [30.75222, 55.598877],
            [30.756664, 55.596657],
            [30.768887, 55.593605],
            [30.782776, 55.59388],
            [30.79472, 55.595543],
            [30.836384, 55.612495],
            [30.846386, 55.615547],
            [30.863609, 55.618599],
            [30.876942, 55.619156],
            [30.893051, 55.617767],
            [30.910275, 55.613052],
            [30.918884, 55.60833],
            [30.926247, 55.60257],
            [30.930275, 55.577774],
            [30.939995, 55.495827],
            [30.940273, 55.415825],
            [30.939438, 55.399437],
            [30.937496, 55.395546],
            [30.927773, 55.386658],
            [30.915829, 55.379433],
            [30.911106, 55.377769],
            [30.891941, 55.376381],
            [30.886662, 55.374992],
            [30.857773, 55.353607],
            [30.831387, 55.329994],
            [30.817497, 55.313324],
            [30.815552, 55.309433],
            [30.813332, 55.301102],
            [30.81361, 55.293327],
            [30.814999, 55.289993],
            [30.819717, 55.283882],
            [30.91333, 55.203049],
            [30.922497, 55.198875],
            [30.939716, 55.193878],
            [30.94833, 55.18943],
            [30.97805, 55.152214],
            [31.026943, 55.056381],
            [31.029999, 55.049721],
            [31.02972, 55.043327],
            [31.028332, 55.038605],
            [31.024441, 55.030823],
            [30.94416, 54.966103],
            [30.936661, 54.961662],
            [30.916386, 54.955826],
            [30.899998, 54.952217],
            [30.864719, 54.947212],
            [30.838886, 54.922493],
            [30.798607, 54.851662],
            [30.790833, 54.835548],
            [30.783054, 54.814156],
            [30.779999, 54.796944],
            [30.781387, 54.79361],
            [30.786385, 54.791664],
            [30.83194, 54.782768],
            [30.844162, 54.779716],
            [30.876385, 54.769157],
            [30.919441, 54.751389],
            [31.004997, 54.711662],
            [31.012497, 54.706657],
            [31.10305, 54.645546],
            [31.144718, 54.582214],
            [31.131664, 54.570549],
            [31.111385, 54.547775],
            [31.097218, 54.531662],
            [31.086662, 54.517769],
            [31.082775, 54.50972],
            [31.082497, 54.505554],
            [31.084442, 54.498604],
            [31.086662, 54.495544],
            [31.092773, 54.491104],
            [31.106941, 54.485268],
            [31.13055, 54.4786],
            [31.198601, 54.460938],
            [31.221661, 54.460548],
            [31.228607, 54.459435],
            [31.231937, 54.456657],
            [31.311665, 54.35083],
            [31.313053, 54.347488],
            [31.312496, 54.343323],
            [31.310829, 54.323608],
            [31.309998, 54.304161],
            [31.310829, 54.296661],
            [31.326664, 54.24749],
            [31.329441, 54.240547],
            [31.331665, 54.237495],
            [31.524166, 54.150826],
            [31.544163, 54.143326],
            [31.675552, 54.106659],
            [31.717216, 54.105553],
            [31.735271, 54.107216],
            [31.75, 54.106384],
            [31.761665, 54.103325],
            [31.844162, 54.064438],
            [31.846943, 54.057495],
            [31.865273, 54.006104],
            [31.85722, 53.969711],
            [31.828884, 53.886383],
            [31.812775, 53.861382],
            [31.806942, 53.854996],
            [31.78833, 53.848328],
            [31.784443, 53.845825],
            [31.773888, 53.82888],
            [31.764225, 53.806076],
            [31.764225, 53.80262],
            [31.881386, 53.778603],
            [31.895828, 53.777489],
            [31.902218, 53.777771],
            [31.935551, 53.789162],
            [31.971382, 53.798332],
            [31.99305, 53.80249],
            [32.119713, 53.819992],
            [32.329437, 53.762215],
            [32.45166, 53.726379],
            [32.461662, 53.722763],
            [32.48027, 53.714439],
            [32.488327, 53.709991],
            [32.50666, 53.693878],
            [32.510277, 53.687492],
            [32.510551, 53.683601],
            [32.509163, 53.679161],
            [32.503883, 53.672218],
            [32.486382, 53.664436],
            [32.435265, 53.651657],
            [32.417213, 53.649719],
            [32.414711, 53.646385],
            [32.414993, 53.642494],
            [32.422493, 53.606384],
            [32.426384, 53.5961],
            [32.438599, 53.577774],
            [32.443878, 53.571938],
            [32.453049, 53.563881],
            [32.46888, 53.55471],
            [32.4786, 53.550827],
            [32.615547, 53.498329],
            [32.624992, 53.501389],
            [32.637772, 53.501938],
            [32.644714, 53.501389],
            [32.659714, 53.499718],
            [32.670547, 53.497215],
            [32.738045, 53.465828],
            [32.741104, 53.463051],
            [32.741379, 53.459435],
            [32.739716, 53.446938],
            [32.736542, 53.438362],
            [32.724434, 53.360275],
            [32.611938, 53.313049],
            [32.452217, 53.2211],
            [32.439987, 53.208885],
            [32.429718, 53.200829],
            [32.414154, 53.191376],
            [32.298882, 53.131935],
            [32.22332, 53.105553],
            [32.147491, 53.090546],
            [32.136658, 53.0886],
            [32.118599, 53.087212],
            [32.105553, 53.087212],
            [31.95805, 53.094437],
            [31.918327, 53.098328],
            [31.804996, 53.123604],
            [31.801109, 53.125824],
            [31.796665, 53.131935],
            [31.79583, 53.147217],
            [31.792221, 53.161659],
            [31.786663, 53.178879],
            [31.781666, 53.188881],
            [31.779442, 53.191658],
            [31.775555, 53.194153],
            [31.769165, 53.196098],
            [31.630276, 53.217209],
            [31.616108, 53.218323],
            [31.438885, 53.211662],
            [31.427494, 53.210274],
            [31.422497, 53.208885],
            [31.414162, 53.204437],
            [31.404716, 53.195824],
            [31.395275, 53.181381],
            [31.386383, 53.161934],
            [31.379997, 53.144997],
            [31.374828, 53.121933],
            [31.384995, 53.113884],
            [31.387218, 53.110825],
            [31.388607, 53.107498],
            [31.388329, 53.103325],
            [31.386383, 53.099159],
            [31.31472, 53.051384],
            [31.266941, 53.024712],
            [31.266388, 53.021935],
            [31.390831, 52.910271],
            [31.415272, 52.893051],
            [31.438885, 52.879433],
            [31.475826, 52.863327],
            [31.493885, 52.859161],
            [31.508888, 52.857498],
            [31.536942, 52.856102],
            [31.539997, 52.853325],
            [31.578609, 52.806099],
            [31.58083, 52.803047],
            [31.586662, 52.785828],
            [31.588329, 52.778603],
            [31.595551, 52.742218],
            [31.594997, 52.738045],
            [31.59222, 52.734161],
            [31.569717, 52.708603],
            [31.558331, 52.701385],
            [31.549164, 52.698326],
            [31.543331, 52.697487],
            [31.518055, 52.696938],
            [31.506664, 52.695267],
            [31.501942, 52.693878],
            [31.5, 52.689987],
            [31.500275, 52.686104],
            [31.506943, 52.677216],
            [31.583607, 52.594711],
            [31.590553, 52.589714],
            [31.608887, 52.491379],
            [31.629162, 52.374435],
            [31.629719, 52.370544],
            [31.628052, 52.361938],
            [31.614719, 52.339714],
            [31.609718, 52.332771],
            [31.602219, 52.328049],
            [31.597218, 52.32666],
            [31.589165, 52.322495],
            [31.586662, 52.318886],
            [31.59972, 52.30555],
            [31.701385, 52.2211],
            [31.758331, 52.179161],
            [31.772499, 52.173607],
            [31.782497, 52.165825],
            [31.786663, 52.159988],
            [31.787498, 52.152214],
            [31.78611, 52.124161],
            [31.783886, 52.108047],
            [31.734718, 52.106102],
            [31.622219, 52.108887],
            [31.523609, 52.116386],
            [31.502777, 52.117493],
            [31.422497, 52.119987],
            [31.379719, 52.11805],
            [31.361942, 52.116661],
            [31.35083, 52.114998],
            [31.341106, 52.112495],
            [31.323887, 52.104996],
            [31.301109, 52.091103],
            [31.291386, 52.082771],
            [31.132217, 52.08638],
            [31.106384, 52.08638],
            [30.974163, 52.082771],
            [30.963051, 52.081108],
            [30.958328, 52.07972],
            [30.943096, 52.073792],
            [30.935829, 52.063324],
            [30.934162, 52.060272],
            [30.93074, 52.034355],
            [30.930492, 52.030083],
            [30.958885, 52.000832],
            [30.896942, 51.977768],
            [30.824997, 51.947487],
            [30.746941, 51.895271],
            [30.665272, 51.826942],
            [30.662216, 51.823883],
            [30.660553, 51.819992],
            [30.660275, 51.815826],
            [30.661385, 51.812492],
            [30.668053, 51.803322],
            [30.669994, 51.796387],
            [30.668327, 51.792221],
            [30.62833, 51.71138],
            [30.623608, 51.704437],
            [30.564999, 51.643326],
            [30.553886, 51.541939],
            [30.586384, 51.489159],
            [30.643608, 51.370827],
            [30.643887, 51.366936],
            [30.644161, 51.332771],
            [30.641048, 51.32962],
            [30.620552, 51.325272],
            [30.611107, 51.322495],
            [30.570831, 51.301933],
            [30.568054, 51.299164],
            [30.566109, 51.294998],
            [30.551414, 51.251846],
            [30.464718, 51.294998],
            [30.350273, 51.35833],
            [30.34972, 51.386108],
            [30.348606, 51.401382],
            [30.348053, 51.405266],
            [30.344162, 51.407494],
            [30.213882, 51.48082],
            [30.20055, 51.486656],
            [30.183605, 51.491104],
            [30.176384, 51.491936],
            [30.161942, 51.493324],
            [30.142494, 51.493324],
            [30.043053, 51.490273],
            [30.012218, 51.489159],
            [29.98333, 51.486382],
            [29.911663, 51.472763],
            [29.881664, 51.459717],
            [29.834442, 51.441933],
            [29.766388, 51.440544],
            [29.759163, 51.441101],
            [29.744995, 51.446655],
            [29.739437, 51.452217],
            [29.737217, 51.455269],
            [29.73444, 51.461937],
            [29.73333, 51.469437],
            [29.731937, 51.472763],
            [29.726662, 51.482491],
            [29.722218, 51.488602],
            [29.717773, 51.494438],
            [29.70916, 51.498604],
            [29.681938, 51.499718],
            [29.669716, 51.498878],
            [29.626385, 51.491379],
            [29.621662, 51.48999],
            [29.409718, 51.402771],
            [29.353836, 51.37532],
            [29.345276, 51.373322],
            [29.339165, 51.373047],
            [29.324165, 51.378044],
            [29.313053, 51.384995],
            [29.309998, 51.387772],
            [29.300831, 51.399719],
            [29.248604, 51.495827],
            [29.250832, 51.504715],
            [29.250275, 51.512772],
            [29.243328, 51.537773],
            [29.239716, 51.544159],
            [29.181385, 51.61805],
            [29.16555, 51.626938],
            [29.160828, 51.628601],
            [29.118053, 51.63694],
            [29.089996, 51.638603],
            [29.083332, 51.638329],
            [29.072498, 51.636383],
            [29.052498, 51.631104],
            [28.845276, 51.554161],
            [28.828609, 51.546387],
            [28.810555, 51.534439],
            [28.793053, 51.516106],
            [28.773609, 51.494713],
            [28.766109, 51.484718],
            [28.762497, 51.477211],
            [28.761944, 51.46888],
            [28.769444, 51.448044],
            [28.765831, 51.421379],
            [28.764999, 51.416939],
            [28.757221, 51.412491],
            [28.752499, 51.411102],
            [28.745274, 51.411659],
            [28.740551, 51.413322],
            [28.672497, 51.441376],
            [28.660553, 51.451935],
            [28.654442, 51.46138],
            [28.651386, 51.468048],
            [28.638329, 51.506386],
            [28.636108, 51.513611],
            [28.632496, 51.532211],
            [28.631939, 51.540276],
            [28.633053, 51.544716],
            [28.633606, 51.557213],
            [28.632774, 51.560822],
            [28.63055, 51.563881],
            [28.62722, 51.566383],
            [28.622498, 51.568329],
            [28.493885, 51.581108],
            [28.487217, 51.581108],
            [28.475552, 51.57972],
            [28.460827, 51.576103],
            [28.433331, 51.566101],
            [28.319443, 51.589157],
            [28.265831, 51.65638],
            [28.263332, 51.659157],
            [28.25861, 51.661102],
            [28.239162, 51.660545],
            [28.218052, 51.65638],
            [28.213329, 51.654991],
            [28.188606, 51.643051],
            [28.178329, 51.635551],
            [28.172497, 51.629433],
            [28.157497, 51.609993],
            [28.141384, 51.585823],
            [28.134995, 51.580276],
            [28.113884, 51.570831],
            [28.104443, 51.568054],
            [28.088051, 51.564995],
            [28.069996, 51.563881],
            [28.006107, 51.56221],
            [27.992218, 51.563881],
            [27.975273, 51.567772],
            [27.955273, 51.574997],
            [27.933605, 51.58638],
            [27.922497, 51.593048],
            [27.912773, 51.60083],
            [27.895828, 51.613052],
            [27.88472, 51.619987],
            [27.86694, 51.623604],
            [27.860828, 51.623322],
            [27.851387, 51.62027],
            [27.838886, 51.614159],
            [27.825275, 51.604164],
            [27.816109, 51.595825],
            [27.811665, 51.5886],
            [27.809998, 51.57972],
            [27.812218, 51.572495],
            [27.81694, 51.562492],
            [27.817776, 51.558601],
            [27.819164, 51.543053],
            [27.818886, 51.534721],
            [27.817497, 51.530548],
            [27.811665, 51.524712],
            [27.751663, 51.466934],
            [27.746941, 51.465546],
            [27.741383, 51.46666],
            [27.683331, 51.491936],
            [27.679996, 51.494438],
            [27.709759, 51.550507],
            [27.724716, 51.564438],
            [27.728329, 51.571938],
            [27.72916, 51.576385],
            [27.72916, 51.580551],
            [27.727772, 51.583878],
            [27.725273, 51.586937],
            [27.719715, 51.592491],
            [27.711662, 51.596657],
            [27.687218, 51.601387],
            [27.597218, 51.615829],
            [27.511971, 51.628868],
            [27.460827, 51.604439],
            [27.445549, 51.601105],
            [27.416664, 51.597488],
            [27.292496, 51.595825],
            [27.285275, 51.596382],
            [27.279442, 51.597771],
            [27.273052, 51.602776],
            [27.199997, 51.670273],
            [27.19833, 51.673607],
            [27.199162, 51.686378],
            [27.203327, 51.713326],
            [27.20583, 51.721657],
            [27.206661, 51.74305],
            [27.20583, 51.746658],
            [27.200829, 51.75666],
            [27.196941, 51.758888],
            [27.179718, 51.762772],
            [27.160275, 51.765549],
            [27.08083, 51.771103],
            [27.029163, 51.76944],
            [27.01722, 51.7686],
            [27.001663, 51.764999],
            [26.971107, 51.75222],
            [26.948051, 51.748878],
            [26.933331, 51.749718],
            [26.919716, 51.751106],
            [26.894997, 51.755554],
            [26.820831, 51.772491],
            [26.772499, 51.785828],
            [26.722496, 51.80249],
            [26.672497, 51.814995],
            [26.649719, 51.820274],
            [26.634995, 51.821106],
            [26.608051, 51.821106],
            [26.57111, 51.818329],
            [26.53083, 51.813324],
            [26.498604, 51.811935],
            [26.457218, 51.812767],
            [26.444717, 51.814995],
            [26.439163, 51.820549],
            [26.438049, 51.824165],
            [26.438049, 51.832497],
            [26.441105, 51.854713],
            [26.436939, 51.856941],
            [26.42305, 51.85833],
            [26.364162, 51.858887],
            [26.338608, 51.857498],
            [26.303051, 51.853882],
            [26.290276, 51.853325],
            [26.207771, 51.85833],
            [26.180828, 51.861382],
            [26.169994, 51.864441],
            [26.149441, 51.87471],
            [26.139439, 51.88221],
            [26.026943, 51.910271],
            [25.818329, 51.935822],
            [25.775829, 51.939156],
            [25.764999, 51.93721],
            [25.741383, 51.929161],
            [25.725826, 51.925552],
            [25.695827, 51.922768],
            [25.676105, 51.921936],
            [25.598331, 51.918884],
            [25.562775, 51.919991],
            [25.546673, 51.922134],
            [25.54583, 51.921379],
            [25.439995, 51.922218],
            [25.361107, 51.926941],
            [25.343052, 51.930275],
            [25.312218, 51.939713],
            [25.277496, 51.951385],
            [25.261665, 51.955826],
            [25.24416, 51.959435],
            [25.237774, 51.960274],
            [25.17944, 51.959717],
            [25.166664, 51.958885],
            [25.093609, 51.942215],
            [25.051941, 51.932213],
            [24.99194, 51.911934],
            [24.903606, 51.901382],
            [24.891384, 51.899994],
            [24.740551, 51.889717],
            [24.700272, 51.893883],
            [24.409439, 51.887497],
            [24.396664, 51.886658],
            [24.391384, 51.885551],
            [24.37944, 51.879158],
            [24.31583, 51.825554],
            [24.313332, 51.822495],
            [24.307499, 51.811935],
            [24.304718, 51.794159],
            [24.298607, 51.7686],
            [24.296108, 51.760551],
            [24.288609, 51.746101],
            [24.28611, 51.74305],
            [24.279442, 51.73777],
            [24.070553, 51.624992],
            [24.043053, 51.610275],
            [24.0075, 51.5961],
            [23.988884, 51.589714],
            [23.973049, 51.586105],
            [23.953884, 51.584991],
            [23.943886, 51.588326],
            [23.940273, 51.590828],
            [23.937496, 51.597771],
            [23.931938, 51.607498],
            [23.925552, 51.616936],
            [23.920273, 51.622765],
            [23.910828, 51.630547],
            [23.902218, 51.634438],
            [23.896664, 51.635826],
            [23.76833, 51.651932],
            [23.753609, 51.652489],
            [23.741661, 51.651382],
            [23.666664, 51.640549],
            [23.650551, 51.63694],
            [23.641384, 51.633606],
            [23.621109, 51.623604],
            [23.614719, 51.618324],
            [23.612217, 51.615273],
            [23.608608, 51.608047],
            [23.608051, 51.603325],
            [23.609161, 51.599716],
            [23.611107, 51.596382],
            [23.621384, 51.589157],
            [23.623886, 51.58638],
            [23.631664, 51.573051],
            [23.647217, 51.538605],
            [23.647495, 51.534439],
            [23.646107, 51.520828],
            [23.64222, 51.5186],
            [23.636383, 51.518883],
            [23.604633, 51.527695],
            [23.581665, 51.531937],
            [23.578541, 51.532978],
            [23.571663, 51.535271],
            [23.563885, 51.539436],
            [23.561386, 51.542496],
            [23.559441, 51.546104],
            [23.539165, 51.592766],
            [23.534992, 51.653595],
            [23.552498, 51.660545],
            [23.555832, 51.663322],
            [23.556942, 51.666382],
            [23.556664, 51.670547],
            [23.547775, 51.686378],
            [23.558052, 51.752495],
            [23.611736, 51.913971],
            [23.613228, 51.917938],
            [23.625828, 51.950272],
            [23.627773, 51.95388],
            [23.660828, 52.006104],
            [23.638607, 52.079437],
            [23.594997, 52.111938],
            [23.35833, 52.204712],
            [23.353329, 52.206383],
            [23.340832, 52.208046],
            [23.297775, 52.211662],
            [23.223049, 52.221657],
            [23.206383, 52.225266],
            [23.19416, 52.231659],
            [23.191383, 52.234718],
            [23.1654, 52.282276],
            [23.24416, 52.37027],
            [23.249376, 52.375477],
            [23.377495, 52.498329],
            [23.397217, 52.514442],
            [23.417217, 52.525269],
            [23.503609, 52.567497],
            [23.523052, 52.573608],
            [23.597218, 52.596382],
            [23.633606, 52.605553],
            [23.655273, 52.610275],
            [23.688328, 52.61721],
            [23.710274, 52.616661],
            [23.721375, 52.615242],
            [23.736382, 52.613327],
            [23.74305, 52.613609],
            [23.753887, 52.615829],
            [23.883884, 52.678047],
            [23.908051, 52.690826],
            [23.91555, 52.695541],
            [23.928608, 52.7061],
            [23.933884, 52.712212],
            [23.937775, 52.719437],
            [23.94083, 52.732208],
            [23.941105, 52.749718],
            [23.939716, 52.770271],
            [23.93866, 52.774712],
            [23.931385, 52.858604],
            [23.927492, 52.948376],
            [23.933331, 53.009995],
            [23.933052, 53.01416],
            [23.858608, 53.195824],
            [23.785917, 53.314335],
            [23.70055, 53.453049],
            [23.68055, 53.481102],
            [23.674717, 53.491104],
            [23.669441, 53.501389],
            [23.640274, 53.559158],
            [23.620552, 53.604996],
            [23.613884, 53.623047],
            [23.608608, 53.637497],
            [23.594997, 53.677773],
            [23.590553, 53.692764],
            [23.590443, 53.694431],
            [23.580551, 53.731102],
            [23.539719, 53.840828],
            [23.512218, 53.89138],
            [23.507807, 53.907265],
            [23.503887, 53.921379],
            [23.502777, 53.94249],
            [23.50404, 53.947044],
            [23.516666, 53.946655],
            [23.54361, 53.943321],
            [23.568607, 53.939156],
            [23.589718, 53.93277],
            [23.598885, 53.928879],
            [23.709438, 53.923882],
            [23.783886, 53.935547],
            [23.898884, 53.940544],
            [23.986107, 53.938881],
            [24.016109, 53.93721],
            [24.075275, 53.936653],
            [24.088608, 53.937492],
            [24.100552, 53.93943],
            [24.110275, 53.94249],
            [24.121384, 53.949997],
            [24.123886, 53.953049],
            [24.134995, 53.960274],
            [24.143887, 53.964157],
            [24.155273, 53.966385],
            [24.175552, 53.967491],
            [24.197216, 53.965546],
            [24.209438, 53.963326],
            [24.223606, 53.957497],
            [24.238605, 53.948326],
            [24.244995, 53.943047],
            [24.25333, 53.934433],
            [24.259163, 53.924438],
            [24.25972, 53.9161],
            [24.262775, 53.909157],
            [24.269165, 53.903877],
            [24.277775, 53.899719],
            [24.380829, 53.888046],
            [24.38694, 53.888603],
            [24.392494, 53.889717],
            [24.406384, 53.894997],
            [24.463329, 53.920547],
            [24.471661, 53.924713],
            [24.505833, 53.946098],
            [24.523052, 53.954712],
            [24.612217, 53.992218],
            [24.685272, 54.001938],
            [24.691662, 54.001663],
            [24.696663, 54.0],
            [24.702217, 53.994156],
            [24.704163, 53.990829],
            [24.70805, 53.979988],
            [24.712772, 53.973877],
            [24.720829, 53.969437],
            [24.727772, 53.968597],
            [24.734718, 53.96888],
            [24.820831, 53.977211],
            [24.829163, 53.986382],
            [24.836109, 53.996658],
            [24.839439, 54.004166],
            [24.841385, 54.018051],
            [24.840553, 54.034439],
            [24.838329, 54.041939],
            [24.83083, 54.054993],
            [24.826107, 54.061378],
            [24.822498, 54.063881],
            [24.810555, 54.07888],
            [24.801388, 54.091377],
            [24.795551, 54.101387],
            [24.796944, 54.10527],
            [24.799721, 54.10833],
            [24.836941, 54.139717],
            [24.840275, 54.14222],
            [24.85083, 54.144997],
            [24.863052, 54.14666],
            [24.955273, 54.158043],
            [24.968884, 54.1586],
            [24.975826, 54.157768],
            [24.986107, 54.154709],
            [25.001389, 54.145271],
            [25.006664, 54.139435],
            [25.010277, 54.13694],
            [25.024441, 54.131104],
            [25.030552, 54.12999],
            [25.043053, 54.129715],
            [25.071941, 54.13472],
            [25.082497, 54.137497],
            [25.101387, 54.14444],
            [25.161942, 54.172493],
            [25.178883, 54.186104],
            [25.201385, 54.210548],
            [25.207497, 54.221375],
            [25.345829, 54.252777],
            [25.372498, 54.254166],
            [25.391663, 54.255829],
            [25.40583, 54.261108],
            [25.417217, 54.268326],
            [25.424164, 54.273605],
            [25.438328, 54.288887],
            [25.451939, 54.299721],
            [25.466106, 54.304993],
            [25.471661, 54.306099],
            [25.47805, 54.306656],
            [25.498882, 54.304161],
            [25.50333, 54.301933],
            [25.56472, 54.251938],
            [25.57444, 54.243607],
            [25.577221, 54.240273],
            [25.575829, 54.236382],
            [25.547775, 54.203323],
            [25.541386, 54.197769],
            [25.506107, 54.18721],
            [25.504719, 54.183052],
            [25.534443, 54.146942],
            [25.538887, 54.144997],
            [25.551941, 54.143051],
            [25.662216, 54.136108],
            [25.669163, 54.136108],
            [25.681107, 54.137772],
            [25.766109, 54.153877],
            [25.771664, 54.154991],
            [25.785275, 54.160545],
            [25.789997, 54.167213],
            [25.793053, 54.17527],
            [25.808052, 54.243881],
            [25.807774, 54.248047],
            [25.804996, 54.250832],
            [25.717495, 54.328606],
            [25.710552, 54.333603],
            [25.705273, 54.335266],
            [25.701107, 54.333328],
            [25.69833, 54.330276],
            [25.691105, 54.324997],
            [25.675552, 54.320831],
            [25.659161, 54.317215],
            [25.641384, 54.314438],
            [25.611107, 54.311378],
            [25.58194, 54.311661],
            [25.568886, 54.313606],
            [25.558331, 54.31694],
            [25.551388, 54.321938],
            [25.548607, 54.324997],
            [25.547497, 54.328606],
            [25.547497, 54.332771],
            [25.550274, 54.351105],
            [25.553051, 54.359161],
            [25.55722, 54.366104],
            [25.648884, 54.517494],
            [25.658329, 54.526657],
            [25.666939, 54.530823],
            [25.718327, 54.545273],
            [25.731106, 54.551659],
            [25.748882, 54.564438],
            [25.755554, 54.569992],
            [25.764164, 54.579163],
            [25.765553, 54.588326],
            [25.765274, 54.592491],
            [25.764164, 54.604439],
            [25.761387, 54.611382],
            [25.756664, 54.617767],
            [25.748604, 54.626381],
            [25.733051, 54.652489],
            [25.731106, 54.655823],
            [25.727219, 54.666664],
            [25.72694, 54.683052],
            [25.736107, 54.784996],
            [25.73666, 54.789436],
            [25.738884, 54.793053],
            [25.788887, 54.87027],
            [25.795277, 54.875824],
            [25.873051, 54.939987],
            [25.87722, 54.942215],
            [25.911942, 54.953606],
            [25.929996, 54.9561],
            [25.943329, 54.954994],
            [26.076385, 54.961937],
            [26.160828, 54.977211],
            [26.209995, 55.021378],
            [26.21944, 55.029991],
            [26.248329, 55.071106],
            [26.250275, 55.08194],
            [26.250832, 55.090546],
            [26.249718, 55.110825],
            [26.25333, 55.123604],
            [26.259441, 55.129715],
            [26.276108, 55.143326],
            [26.284164, 55.148048],
            [26.481663, 55.154991],
            [26.502777, 55.152214],
            [26.521385, 55.148331],
            [26.641663, 55.190826],
            [26.775276, 55.250549],
            [26.792221, 55.259163],
            [26.799721, 55.264442],
            [26.813885, 55.274994],
            [26.819717, 55.281105],
            [26.819717, 55.285271],
            [26.811665, 55.29361],
            [26.801109, 55.301102],
            [26.783886, 55.308884],
            [26.766941, 55.313606],
            [26.645828, 55.330276],
            [26.631386, 55.331108],
            [26.619164, 55.329437],
            [26.56694, 55.314713],
            [26.554718, 55.313049],
            [26.528885, 55.317772],
            [26.505833, 55.323883],
            [26.472771, 55.333603],
            [26.45916, 55.338882],
            [26.45583, 55.341377],
            [26.455551, 55.345543],
            [26.457218, 55.349716],
            [26.526665, 55.446938],
            [26.626663, 55.593048],
            [26.629162, 55.601662],
            [26.629162, 55.605827],
            [26.624439, 55.642769],
            [26.620831, 55.661934],
            [26.613209, 55.674835],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "LH",
        ISO2: "LT",
        ISO3: "LTU",
        UN: 440,
        NAME: "Lithuania",
        AREA: 6268,
        POP2005: 3425077,
        REGION: 150,
        SUBREGION: 154,
        LON: 23.897,
        LAT: 55.336,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [21.044441, 55.32638500000013],
              [20.984814, 55.27655],
              [20.942833, 55.287201],
              [20.982773, 55.330826],
              [21.002499, 55.352493],
              [21.039440000000127, 55.400826000000109],
              [21.04472, 55.411659],
              [21.049999, 55.422493000000145],
              [21.064442, 55.45166],
              [21.083054000000118, 55.499718],
              [21.088608, 55.514717],
              [21.09249, 55.531105000000139],
              [21.09444, 55.548882],
              [21.09583, 55.594154],
              [21.096386, 55.665268],
              [21.095276, 55.678329000000133],
              [21.09249, 55.703323000000125],
              [21.088329000000101, 55.718048],
              [21.09, 55.719986],
              [21.097218, 55.714714],
              [21.10944, 55.703606],
              [21.114998000000128, 55.697487],
              [21.122498, 55.688324],
              [21.127773, 55.677773000000116],
              [21.13472, 55.629158],
              [21.128052, 55.574997],
              [21.10305, 55.42083],
              [21.04888, 55.333054],
              [21.044441, 55.32638500000013],
            ],
          ],
          [
            [
              [25.000000000000114, 56.29555],
              [25.072498, 56.219154],
              [25.08111, 56.210548],
              [25.096943, 56.2011],
              [25.106106, 56.197212],
              [25.133884, 56.188881],
              [25.145828, 56.186104000000114],
              [25.160275000000127, 56.184433],
              [25.18305, 56.183327],
              [25.262497, 56.180824],
              [25.327496, 56.16916],
              [25.429718, 56.166382],
              [25.582775, 56.151382000000126],
              [25.696941, 56.115273000000116],
              [25.699162, 56.108047000000113],
              [25.704994000000113, 56.098045],
              [25.707771, 56.09499],
              [25.714996, 56.089989000000116],
              [25.891106, 55.999435000000119],
              [25.932217, 55.980545],
              [25.942219000000136, 55.97694],
              [25.996384, 55.959717000000126],
              [26.014275000000112, 55.955154],
              [26.058331, 55.93804200000011],
              [26.190830000000119, 55.867493000000138],
              [26.20166, 55.859993],
              [26.210827, 55.85166],
              [26.221939000000134, 55.83999],
              [26.239162, 55.818886],
              [26.240273, 55.814995],
              [26.256943, 55.78472],
              [26.263332, 55.775269],
              [26.268887, 55.76944],
              [26.275276, 55.764160000000118],
              [26.313332, 55.73972],
              [26.338608000000136, 55.726379000000122],
              [26.35833, 55.71888],
              [26.375553, 55.714157],
              [26.498329000000126, 55.686378],
              [26.51083, 55.683876],
              [26.531387000000109, 55.680824000000143],
              [26.57527, 55.676102],
              [26.59138, 55.674995000000138],
              [26.613209, 55.674835],
              [26.620831, 55.661934],
              [26.624439, 55.642769],
              [26.62916, 55.605827],
              [26.62916, 55.601662],
              [26.62666, 55.593048],
              [26.526665, 55.44694],
              [26.457218000000125, 55.349716],
              [26.455551, 55.345543],
              [26.45583, 55.34138],
              [26.45916, 55.338882000000126],
              [26.472771, 55.3336],
              [26.505833, 55.323883],
              [26.528885, 55.317772],
              [26.554718, 55.313049],
              [26.56694, 55.314713],
              [26.619164, 55.329437],
              [26.631386000000134, 55.33111],
              [26.645828000000108, 55.330276],
              [26.766941, 55.313606000000107],
              [26.783886, 55.308884],
              [26.80110900000011, 55.301102],
              [26.811665, 55.293610000000115],
              [26.819717000000139, 55.285271],
              [26.819717000000139, 55.281105],
              [26.813885, 55.274994000000106],
              [26.79972, 55.264442],
              [26.792221, 55.259163000000115],
              [26.775276000000133, 55.250549],
              [26.641663000000108, 55.190826],
              [26.521385000000123, 55.148331],
              [26.502777, 55.152214],
              [26.48166300000014, 55.15499],
              [26.284164, 55.148048000000131],
              [26.27611, 55.143326],
              [26.25944, 55.129715],
              [26.25333, 55.123604],
              [26.249718000000144, 55.11082],
              [26.250832000000116, 55.090546],
              [26.250275, 55.08194],
              [26.24833, 55.071106],
              [26.219440000000134, 55.029991],
              [26.209995, 55.021378],
              [26.16083, 54.977211],
              [26.07638500000013, 54.96194],
              [25.94333, 54.95499],
              [25.929996, 54.9561],
              [25.911942, 54.953606],
              [25.87722, 54.942215],
              [25.873051, 54.93999],
              [25.795277, 54.875824],
              [25.78889, 54.87027],
              [25.73888, 54.79305],
              [25.73666, 54.789436],
              [25.736107000000118, 54.785],
              [25.726940000000127, 54.68305],
              [25.727219000000105, 54.666664],
              [25.731106, 54.655823],
              [25.733051, 54.652489],
              [25.748604000000114, 54.626381],
              [25.75666, 54.61777],
              [25.761387000000127, 54.611382],
              [25.764164, 54.60444],
              [25.765274, 54.592491000000109],
              [25.765553, 54.588326000000109],
              [25.764164, 54.579163000000108],
              [25.755554000000132, 54.56999],
              [25.74888, 54.564438],
              [25.731106, 54.55166],
              [25.71833, 54.545273],
              [25.666939, 54.530823000000112],
              [25.658329, 54.526657],
              [25.648884, 54.517494],
              [25.55722, 54.366104000000121],
              [25.553051, 54.359161],
              [25.550274, 54.351105],
              [25.547497, 54.332771],
              [25.547497, 54.328606],
              [25.548607000000118, 54.324997],
              [25.55139, 54.321938000000102],
              [25.55833, 54.316940000000102],
              [25.568886, 54.313606000000107],
              [25.58194, 54.311661000000129],
              [25.611107, 54.311378],
              [25.641384, 54.314438],
              [25.659161, 54.31721],
              [25.67555, 54.320831],
              [25.691105, 54.324997],
              [25.698330000000112, 54.330276],
              [25.70111, 54.333328],
              [25.705273, 54.335266000000104],
              [25.710552, 54.3336],
              [25.717495, 54.328606],
              [25.804996, 54.250832],
              [25.807774, 54.248047],
              [25.80805, 54.243881000000101],
              [25.793053, 54.175270000000125],
              [25.79, 54.167213000000118],
              [25.785275, 54.16054],
              [25.771664000000101, 54.154991],
              [25.766109, 54.153877],
              [25.681107, 54.137772],
              [25.66916, 54.136108],
              [25.662216, 54.136108],
              [25.551941, 54.143051],
              [25.53889, 54.145],
              [25.534443, 54.146942000000138],
              [25.504719, 54.183052],
              [25.5061070000001, 54.18721],
              [25.54139, 54.197769],
              [25.547775, 54.203323],
              [25.575829, 54.23638],
              [25.577221000000122, 54.240273],
              [25.57444, 54.243607],
              [25.564720000000136, 54.251938000000109],
              [25.50333, 54.301933],
              [25.498882, 54.304161],
              [25.47805, 54.306656],
              [25.471661, 54.306099],
              [25.466106000000138, 54.304993000000138],
              [25.45194, 54.299721],
              [25.438328, 54.28889],
              [25.424164000000133, 54.2736],
              [25.41722, 54.26833],
              [25.40583, 54.26111],
              [25.391663, 54.255829],
              [25.372498, 54.254166],
              [25.345829, 54.252777],
              [25.2075, 54.221375000000137],
              [25.201385, 54.210548000000131],
              [25.17888, 54.186104],
              [25.161942, 54.172493],
              [25.101387, 54.14444],
              [25.082497000000103, 54.137497],
              [25.07194, 54.13472],
              [25.043053, 54.12971],
              [25.030552, 54.129990000000134],
              [25.02444, 54.131104000000107],
              [25.010277, 54.13694],
              [25.006664000000114, 54.139435],
              [25.001389, 54.145271],
              [24.986107, 54.154709],
              [24.97583, 54.157768],
              [24.968884, 54.1586],
              [24.955273, 54.158043],
              [24.86305, 54.14666],
              [24.85083, 54.145],
              [24.840275000000133, 54.14222],
              [24.836941000000138, 54.139717],
              [24.799721, 54.108330000000137],
              [24.79694, 54.10527],
              [24.79555, 54.10139],
              [24.80139, 54.091377],
              [24.810555, 54.07888],
              [24.82249800000011, 54.06388],
              [24.826107, 54.061378],
              [24.83083, 54.054993],
              [24.838329, 54.041939000000127],
              [24.840553, 54.034439],
              [24.84138, 54.018051],
              [24.839439, 54.004166000000112],
              [24.836109, 53.996658],
              [24.829163, 53.986382],
              [24.820831, 53.977211],
              [24.734718, 53.968880000000127],
              [24.727772, 53.9686],
              [24.720829, 53.969437],
              [24.712772, 53.973877],
              [24.70805, 53.97999],
              [24.704163000000108, 53.990829],
              [24.702217, 53.994156],
              [24.696663, 54.0],
              [24.69166, 54.001663000000121],
              [24.685272, 54.00194],
              [24.612217, 53.992218],
              [24.523052, 53.954712],
              [24.505833, 53.946098],
              [24.471661, 53.924713],
              [24.463329, 53.920547],
              [24.406384, 53.895],
              [24.392494, 53.889717000000132],
              [24.38694, 53.8886],
              [24.38083, 53.888046],
              [24.277775000000133, 53.899719000000118],
              [24.269165, 53.903877],
              [24.26277, 53.909157000000107],
              [24.25972, 53.9161],
              [24.259163, 53.924438],
              [24.25333, 53.93443],
              [24.244995, 53.943047],
              [24.238605, 53.948326],
              [24.223606, 53.9575],
              [24.209438, 53.963326],
              [24.197216, 53.96555],
              [24.175552, 53.967491],
              [24.155273000000136, 53.966385000000116],
              [24.143887, 53.964157],
              [24.134995000000117, 53.960274],
              [24.123886, 53.95305],
              [24.12138, 53.949997],
              [24.110275, 53.942490000000134],
              [24.100552000000107, 53.93943],
              [24.088608, 53.937492000000134],
              [24.07527, 53.93665],
              [24.016109, 53.93721],
              [23.986107000000118, 53.93888],
              [23.898884, 53.940544],
              [23.783886000000109, 53.93555],
              [23.70944, 53.923882],
              [23.598885000000109, 53.928879],
              [23.589718000000119, 53.93277],
              [23.5686070000001, 53.939156000000139],
              [23.54361, 53.94332],
              [23.51667, 53.946655000000135],
              [23.50404, 53.947044],
              [23.508053, 53.960548],
              [23.517776, 54.030273000000136],
              [23.51722, 54.0472180000001],
              [23.49416, 54.11721],
              [23.48444000000012, 54.138329],
              [23.459160000000111, 54.172768],
              [23.456383, 54.17555],
              [23.361942000000113, 54.23193],
              [23.350273, 54.238884],
              [23.333054, 54.247215],
              [23.20444, 54.287216000000114],
              [23.115829, 54.304436],
              [23.003052, 54.37999],
              [23.001991, 54.381054],
              [23.0, 54.383049],
              [22.992771000000118, 54.387772],
              [22.987495, 54.389160000000118],
              [22.870274, 54.408043],
              [22.85611, 54.4086],
              [22.843609, 54.406937],
              [22.826664, 54.40332],
              [22.81361, 54.397491],
              [22.810829, 54.39444],
              [22.78588, 54.36384],
              [22.776386, 54.376938],
              [22.740829, 54.419441],
              [22.731384, 54.42749],
              [22.713608, 54.439713],
              [22.707069, 54.44812],
              [22.702217, 54.455826],
              [22.694439000000102, 54.47332],
              [22.691383, 54.493607],
              [22.69389, 54.522766000000104],
              [22.695827, 54.53611],
              [22.719162, 54.691376],
              [22.721107, 54.694992],
              [22.74527, 54.717209000000139],
              [22.809441, 54.769714000000135],
              [22.81833, 54.773605],
              [22.83194, 54.77444],
              [22.837776, 54.775826000000109],
              [22.84249, 54.777489],
              [22.84944, 54.782768],
              [22.86138, 54.80027],
              [22.867775, 54.810547],
              [22.869164, 54.814438000000109],
              [22.869164, 54.823326000000122],
              [22.864998000000128, 54.8386],
              [22.853329, 54.875824],
              [22.84944, 54.88749700000011],
              [22.84249, 54.89694],
              [22.834995000000106, 54.901657],
              [22.732216000000108, 54.962494],
              [22.726662, 54.963882000000126],
              [22.719440000000134, 54.963608],
              [22.70166, 54.960548000000131],
              [22.68222, 54.958328000000108],
              [22.659161, 54.9586],
              [22.653049000000124, 54.959717000000126],
              [22.64833, 54.961662000000103],
              [22.643887, 54.963608],
              [22.640831000000105, 54.966385000000116],
              [22.63861, 54.969711000000132],
              [22.603607, 55.0430530000001],
              [22.602219000000105, 55.046661],
              [22.51277, 55.063324],
              [22.27972, 55.06721],
              [22.258053000000132, 55.066383],
              [22.197216, 55.06166],
              [22.184162, 55.060272],
              [22.146385, 55.055267000000129],
              [22.140553000000125, 55.053879],
              [22.13583, 55.052216000000101],
              [22.13222, 55.049438000000123],
              [22.124439, 55.040276],
              [22.121109, 55.037498],
              [22.108608, 55.030823],
              [22.09805, 55.028046],
              [22.077221, 55.026657],
              [22.061943, 55.027489],
              [22.050274, 55.029991],
              [21.732216000000108, 55.132767],
              [21.722771, 55.136658],
              [21.71999, 55.139435],
              [21.715549, 55.1461],
              [21.654442, 55.178879000000109],
              [21.640274, 55.18471],
              [21.56416, 55.19721],
              [21.431385, 55.251938],
              [21.389717, 55.282768],
              [21.38128300000011, 55.287094],
              [21.374165, 55.288605],
              [21.367878000000132, 55.288307],
              [21.363308, 55.286858000000109],
              [21.327656, 55.27063],
              [21.30027, 55.258888000000127],
              [21.280552000000114, 55.251938],
              [21.26915, 55.249306000000104],
              [21.263935000000117, 55.248985],
              [21.268602, 55.260639],
              [21.266163, 55.275684],
              [21.271448, 55.279343],
              [21.288609, 55.28333],
              [21.289719, 55.287498000000141],
              [21.289165, 55.291664],
              [21.27673, 55.322849000000133],
              [21.253965000000107, 55.334641],
              [21.255999, 55.365948000000117],
              [21.238516000000118, 55.36676],
              [21.230789, 55.359848],
              [21.194603, 55.34074],
              [21.183626000000118, 55.34074],
              [21.186878, 55.353344],
              [21.241768, 55.418396],
              [21.24787, 55.4371],
              [21.247215, 55.463326],
              [21.244438, 55.470543000000134],
              [21.197495000000117, 55.574997],
              [21.145275, 55.676102],
              [21.143051, 55.679161],
              [21.116386, 55.709435],
              [21.109997, 55.715],
              [21.097496, 55.722488],
              [21.079163, 55.730545],
              [21.07611, 55.73333],
              [21.073887000000127, 55.73666],
              [21.05833, 55.78166],
              [21.04472, 55.882767],
              [21.043331, 55.90416],
              [21.0430530000001, 55.916664],
              [21.047775, 55.927773],
              [21.057774, 55.945541000000105],
              [21.062218, 55.95694],
              [21.066666, 55.977768],
              [21.067219000000136, 55.991379],
              [21.060555000000136, 56.049995000000138],
              [21.057774, 56.061935],
              [21.051685, 56.077309],
              [21.05805, 56.079437],
              [21.089165, 56.084160000000111],
              [21.108887, 56.086655000000121],
              [21.123886, 56.087494],
              [21.146664, 56.088043],
              [21.19721600000014, 56.083328],
              [21.204716, 56.083878],
              [21.209717, 56.085548],
              [21.21805, 56.089989000000116],
              [21.223328, 56.0961],
              [21.228882, 56.107216000000108],
              [21.23388, 56.123047],
              [21.2347180000001, 56.141106],
              [21.239162, 56.162209000000132],
              [21.244438, 56.168327],
              [21.258888000000127, 56.178604],
              [21.34583, 56.23555],
              [21.354443, 56.23999],
              [21.361107, 56.240829000000133],
              [21.376663000000121, 56.241104],
              [21.384995000000117, 56.240829000000133],
              [21.39138400000013, 56.239716000000101],
              [21.40777, 56.239433000000133],
              [21.42194, 56.240547000000106],
              [21.427773, 56.241936],
              [21.44777, 56.248878],
              [21.566666000000112, 56.295273],
              [21.735550000000103, 56.32333],
              [21.905273, 56.36916],
              [22.038609, 56.41277],
              [22.04888, 56.416100000000142],
              [22.067219000000136, 56.419441],
              [22.13944, 56.423607],
              [22.154442, 56.42416],
              [22.309441000000106, 56.403877],
              [22.481384, 56.40638],
              [22.497215, 56.40638],
              [22.519165, 56.40443],
              [22.553608, 56.399719000000118],
              [22.586941, 56.394714],
              [22.611942000000113, 56.389992],
              [22.623329, 56.38694],
              [22.628052, 56.384995],
              [22.63583, 56.380272000000105],
              [22.643608, 56.375267],
              [22.653606, 56.36721],
              [22.661385, 56.362495],
              [22.671108, 56.3586],
              [22.691383, 56.35666],
              [22.827221000000122, 56.379158000000132],
              [22.837498, 56.382492000000127],
              [22.846107, 56.38694],
              [22.86027, 56.397491],
              [22.886383, 56.410271000000137],
              [22.916939, 56.420547],
              [22.92805, 56.423325],
              [22.93388, 56.424438],
              [22.94138, 56.423882000000106],
              [22.94694, 56.4222180000001],
              [22.955551, 56.4180530000001],
              [22.98666, 56.3986],
              [22.992771000000118, 56.39305],
              [22.999161, 56.383331],
              [23.008331, 56.366104],
              [23.013054, 56.35555],
              [23.018055000000118, 56.34943],
              [23.031387000000109, 56.33416],
              [23.0375, 56.328606],
              [23.053886, 56.319443],
              [23.068054, 56.313606],
              [23.096107, 56.305824000000143],
              [23.104443, 56.30555],
              [23.110275, 56.306656],
              [23.129997000000117, 56.313881],
              [23.147217000000126, 56.32249],
              [23.180275000000108, 56.345543],
              [23.181385, 56.348877],
              [23.177494, 56.351105],
              [23.171108000000117, 56.352219],
              [23.16805, 56.35527],
              [23.167496, 56.359161],
              [23.171108000000117, 56.36194],
              [23.182217, 56.36472],
              [23.296108, 56.380821],
              [23.32, 56.380272000000105],
              [23.332218000000125, 56.377769000000114],
              [23.35833, 56.36916],
              [23.367775000000108, 56.364998],
              [23.441662, 56.345268],
              [23.454441, 56.343048],
              [23.525276, 56.33416],
              [23.547497000000135, 56.334717000000126],
              [23.559441, 56.337212000000136],
              [23.56805, 56.341377000000136],
              [23.578884, 56.3491590000001],
              [23.584721, 56.35555],
              [23.596943, 56.362213],
              [23.608608, 56.364159],
              [23.726383000000112, 56.361382],
              [23.741104, 56.359993000000145],
              [23.873608, 56.34277],
              [23.948883, 56.332214000000135],
              [23.99138, 56.322769],
              [24.008331, 56.318054],
              [24.065273, 56.285553000000107],
              [24.07444, 56.281662],
              [24.135830000000112, 56.26416],
              [24.147774, 56.261383000000137],
              [24.16333, 56.261108],
              [24.175274, 56.263329],
              [24.265, 56.289436],
              [24.320274, 56.308327],
              [24.332218, 56.310547],
              [24.339718, 56.310822000000144],
              [24.345276000000126, 56.309158],
              [24.364719, 56.30166],
              [24.378883, 56.29555],
              [24.404163, 56.281937],
              [24.41833, 56.2761],
              [24.42944, 56.272766000000104],
              [24.44944, 56.269714],
              [24.47333, 56.269157000000121],
              [24.479996, 56.269714],
              [24.558331, 56.28833],
              [24.56277, 56.29055],
              [24.582497, 56.312492],
              [24.60278, 56.329163000000108],
              [24.653328, 56.365829],
              [24.87944, 56.448601],
              [24.89138400000013, 56.450829],
              [24.899719, 56.450546],
              [24.906105, 56.449432],
              [24.91555, 56.445267],
              [24.922218, 56.439987],
              [24.94222, 56.40694],
              [24.956661, 56.382492000000127],
              [24.970551000000114, 56.353607],
              [24.981937, 56.329163000000108],
              [24.99305, 56.304993],
              [25.000000000000114, 56.29555],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "LO",
        ISO2: "SK",
        ISO3: "SVK",
        UN: 703,
        NAME: "Slovakia",
        AREA: 4808,
        POP2005: 5386995,
        REGION: 150,
        SUBREGION: 151,
        LON: 19.491,
        LAT: 48.707,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [17.251656, 48.024994],
            [17.241713, 48.025551],
            [17.236664, 48.025833],
            [17.19083, 48.023048],
            [17.180832, 48.021111],
            [17.176388, 48.01944],
            [17.166386, 48.012497],
            [17.116665, 48.038605],
            [17.081108, 48.088333],
            [17.069145, 48.135265],
            [17.040051, 48.142464],
            [17.03075, 48.145859],
            [17.023331, 48.150276],
            [16.998016, 48.169701],
            [16.975277, 48.188332],
            [16.953888, 48.242775],
            [16.950832, 48.257774],
            [16.94972, 48.278049],
            [16.927219, 48.280273],
            [16.920555, 48.283882],
            [16.8475, 48.355827],
            [16.845276, 48.358604],
            [16.84222, 48.365273],
            [16.839996, 48.372215],
            [16.840275, 48.376389],
            [16.855831, 48.44944],
            [16.864441, 48.467216],
            [16.866943, 48.470276],
            [16.907497, 48.506943],
            [16.933331, 48.532776],
            [16.943333, 48.573326],
            [16.946182, 48.619064],
            [16.988331, 48.681664],
            [17.022499, 48.743607],
            [17.038887, 48.765274],
            [17.044167, 48.771385],
            [17.110554, 48.830551],
            [17.113888, 48.833054],
            [17.187908, 48.869446],
            [17.230274, 48.873055],
            [17.239998, 48.872772],
            [17.252777, 48.870827],
            [17.33083, 48.850273],
            [17.376389, 48.827499],
            [17.38583, 48.823326],
            [17.390274, 48.822777],
            [17.403889, 48.822777],
            [17.41861, 48.82666],
            [17.502777, 48.838882],
            [17.645554, 48.851944],
            [17.654999, 48.851944],
            [17.677498, 48.851944],
            [17.712219, 48.85611],
            [17.7575, 48.876663],
            [17.763054, 48.879715],
            [17.841942, 48.928329],
            [17.91111, 48.984993],
            [18.075279, 49.041943],
            [18.121944, 49.082771],
            [18.147778, 49.115555],
            [18.151386, 49.124443],
            [18.150833, 49.129997],
            [18.145277, 49.145],
            [18.15583, 49.159721],
            [18.158886, 49.165276],
            [18.161942, 49.174164],
            [18.174164, 49.210274],
            [18.174721, 49.241661],
            [18.175831, 49.244438],
            [18.179722, 49.249443],
            [18.208054, 49.284164],
            [18.212776, 49.288055],
            [18.216389, 49.289162],
            [18.269997, 49.299995],
            [18.281387, 49.301941],
            [18.30722, 49.303886],
            [18.317776, 49.307495],
            [18.379444, 49.330276],
            [18.386944, 49.335831],
            [18.541111, 49.453331],
            [18.546108, 49.457497],
            [18.548332, 49.463608],
            [18.547775, 49.478333],
            [18.548332, 49.481667],
            [18.551388, 49.486938],
            [18.562222, 49.493889],
            [18.568886, 49.496109],
            [18.581108, 49.497772],
            [18.655552, 49.504166],
            [18.792774, 49.513885],
            [18.851246, 49.517357],
            [18.968609, 49.481667],
            [18.96833, 49.456383],
            [18.970833, 49.405273],
            [18.971664, 49.402771],
            [18.973053, 49.400551],
            [18.978054, 49.39666],
            [18.993332, 49.39444],
            [19.031666, 49.391937],
            [19.155552, 49.399994],
            [19.163609, 49.400551],
            [19.185276, 49.409996],
            [19.198055, 49.418053],
            [19.195274, 49.430832],
            [19.203331, 49.444717],
            [19.240276, 49.50444],
            [19.244442, 49.509163],
            [19.264721, 49.524162],
            [19.270275, 49.527771],
            [19.276386, 49.530548],
            [19.447777, 49.60083],
            [19.475555, 49.599998],
            [19.520981, 49.574165],
            [19.535275, 49.535553],
            [19.574997, 49.461105],
            [19.579166, 49.45694],
            [19.658607, 49.406662],
            [19.710552, 49.397499],
            [19.768608, 49.408051],
            [19.781387, 49.408607],
            [19.786388, 49.408051],
            [19.790276, 49.406662],
            [19.791664, 49.404442],
            [19.804996, 49.364716],
            [19.826664, 49.28083],
            [19.826942, 49.278053],
            [19.826111, 49.275276],
            [19.824165, 49.272774],
            [19.821388, 49.271111],
            [19.798054, 49.252777],
            [19.773609, 49.233055],
            [19.765831, 49.215828],
            [19.766109, 49.213051],
            [19.771111, 49.206383],
            [19.778889, 49.201111],
            [19.789444, 49.196938],
            [19.794441, 49.196388],
            [19.839165, 49.191666],
            [19.846664, 49.19194],
            [19.86791, 49.197132],
            [19.907776, 49.224159],
            [19.913055, 49.227493],
            [19.916386, 49.228882],
            [19.936386, 49.23111],
            [19.97472, 49.227219],
            [19.984444, 49.225555],
            [19.995277, 49.221664],
            [20.002514, 49.213585],
            [20.020554, 49.19944],
            [20.039165, 49.188889],
            [20.064163, 49.177773],
            [20.074444, 49.175278],
            [20.081387, 49.175278],
            [20.084999, 49.177498],
            [20.089443, 49.183884],
            [20.091663, 49.196106],
            [20.093609, 49.213608],
            [20.103333, 49.248604],
            [20.143608, 49.314995],
            [20.206665, 49.340271],
            [20.327774, 49.383331],
            [20.360554, 49.393051],
            [20.602776, 49.395554],
            [20.740833, 49.388885],
            [20.812496, 49.330826],
            [20.910831, 49.296104],
            [20.916386, 49.296104],
            [20.95583, 49.301666],
            [20.980553, 49.308327],
            [20.984165, 49.310555],
            [21.035553, 49.359718],
            [21.049442, 49.408882],
            [21.051666, 49.412216],
            [21.066944, 49.420555],
            [21.076111, 49.423607],
            [21.278889, 49.456665],
            [21.285, 49.456108],
            [21.400845, 49.429054],
            [21.436386, 49.413887],
            [21.441109, 49.412498],
            [21.459442, 49.41111],
            [21.465832, 49.411385],
            [21.470833, 49.412773],
            [21.500832, 49.422218],
            [21.533607, 49.429718],
            [21.606388, 49.436661],
            [21.618889, 49.436386],
            [21.838055, 49.384438],
            [21.956944, 49.341385],
            [21.960278, 49.339165],
            [22.018887, 49.277496],
            [22.021385, 49.270271],
            [22.025276, 49.247215],
            [22.024166, 49.228882],
            [22.024719, 49.224716],
            [22.025833, 49.221107],
            [22.030277, 49.214996],
            [22.037777, 49.210831],
            [22.047497, 49.207771],
            [22.224998, 49.154716],
            [22.323887, 49.138611],
            [22.343052, 49.139442],
            [22.354721, 49.137497],
            [22.533054, 49.089439],
            [22.5425, 49.086388],
            [22.558052, 49.079437],
            [22.551662, 49.039436],
            [22.538887, 48.999161],
            [22.53722, 48.995544],
            [22.534164, 48.99305],
            [22.529163, 48.991661],
            [22.461384, 48.949432],
            [22.424995, 48.889435],
            [22.389164, 48.804993],
            [22.389164, 48.797218],
            [22.387497, 48.79361],
            [22.331108, 48.689987],
            [22.328884, 48.686935],
            [22.323608, 48.681107],
            [22.235271, 48.62471],
            [22.173607, 48.592766],
            [22.166939, 48.588043],
            [22.158886, 48.580276],
            [22.157219, 48.57666],
            [22.156105, 48.568054],
            [22.151442, 48.411919],
            [22.150555, 48.408607],
            [22.110832, 48.380272],
            [22.101665, 48.37722],
            [22.096107, 48.376389],
            [22.085831, 48.378052],
            [22.073055, 48.383606],
            [22.056664, 48.386665],
            [22.029442, 48.387497],
            [21.964996, 48.381943],
            [21.935833, 48.379166],
            [21.862778, 48.365555],
            [21.853054, 48.363052],
            [21.848888, 48.361382],
            [21.845276, 48.358604],
            [21.835831, 48.351105],
            [21.828331, 48.342216],
            [21.824165, 48.340271],
            [21.784443, 48.340553],
            [21.777496, 48.340828],
            [21.731388, 48.351105],
            [21.726665, 48.352493],
            [21.718609, 48.356384],
            [21.712776, 48.361382],
            [21.628052, 48.44944],
            [21.622776, 48.46833],
            [21.622776, 48.476944],
            [21.621666, 48.485275],
            [21.620552, 48.488884],
            [21.616665, 48.495552],
            [21.614166, 48.498329],
            [21.507221, 48.548882],
            [21.447777, 48.573883],
            [21.442776, 48.575272],
            [21.43111, 48.576111],
            [21.308712, 48.54805],
            [21.253887, 48.522217],
            [21.153332, 48.511108],
            [21.084442, 48.513611],
            [20.955276, 48.522499],
            [20.949718, 48.523605],
            [20.940277, 48.526382],
            [20.869999, 48.550827],
            [20.847775, 48.563606],
            [20.839165, 48.571663],
            [20.830276, 48.574997],
            [20.818607, 48.576385],
            [20.811665, 48.57666],
            [20.713333, 48.56916],
            [20.660553, 48.563332],
            [20.645275, 48.559998],
            [20.539719, 48.536942],
            [20.500832, 48.50444],
            [20.499443, 48.483059],
            [20.458611, 48.455276],
            [20.443607, 48.442215],
            [20.435833, 48.433609],
            [20.416386, 48.405273],
            [20.411942, 48.394165],
            [20.405277, 48.371109],
            [20.40361, 48.362778],
            [20.400555, 48.355553],
            [20.366943, 48.308884],
            [20.359165, 48.300278],
            [20.340832, 48.28611],
            [20.317219, 48.269722],
            [20.299721, 48.258606],
            [20.291943, 48.254715],
            [20.286663, 48.253883],
            [20.280277, 48.254166],
            [20.276386, 48.256104],
            [20.235554, 48.274994],
            [20.140553, 48.226105],
            [20.09333, 48.198326],
            [20.05933, 48.176308],
            [20.015274, 48.174995],
            [20.004997, 48.172775],
            [19.974442, 48.156662],
            [19.963608, 48.150276],
            [19.941944, 48.137215],
            [19.937775, 48.135277],
            [19.91861, 48.129997],
            [19.912498, 48.129715],
            [19.907776, 48.130272],
            [19.90361, 48.131943],
            [19.788887, 48.181664],
            [19.7925, 48.193054],
            [19.791111, 48.196938],
            [19.787777, 48.199165],
            [19.783607, 48.201111],
            [19.754997, 48.209442],
            [19.66222, 48.231941],
            [19.644444, 48.233887],
            [19.630554, 48.233887],
            [19.540016, 48.213196],
            [19.532513, 48.210861],
            [19.524166, 48.205826],
            [19.50861, 48.17305],
            [19.501663, 48.150276],
            [19.498608, 48.138329],
            [19.494442, 48.127495],
            [19.480553, 48.095551],
            [19.476383, 48.089165],
            [19.472218, 48.087219],
            [19.460548, 48.085831],
            [19.208336, 48.059448],
            [19.13945, 48.061676],
            [19.041714, 48.070641],
            [19.00127, 48.068954],
            [18.989799, 48.067101],
            [18.965675, 48.059799],
            [18.910069, 48.058258],
            [18.904503, 48.057693],
            [18.849098, 48.051064],
            [18.841576, 48.047195],
            [18.827366, 48.036125],
            [18.771664, 47.965553],
            [18.760555, 47.926109],
            [18.75972, 47.921661],
            [18.758888, 47.907494],
            [18.759441, 47.90361],
            [18.766941, 47.877777],
            [18.769997, 47.874992],
            [18.774441, 47.873329],
            [18.787777, 47.871666],
            [18.792221, 47.86972],
            [18.82, 47.855553],
            [18.853611, 47.833054],
            [18.855831, 47.830276],
            [18.84972, 47.817772],
            [18.788055, 47.817215],
            [18.765831, 47.815552],
            [18.749729, 47.813156],
            [18.738609, 47.807495],
            [18.732498, 47.797218],
            [18.726944, 47.791107],
            [18.720554, 47.78611],
            [18.690552, 47.770271],
            [18.675278, 47.762497],
            [18.67083, 47.760826],
            [18.655277, 47.758606],
            [18.636944, 47.759163],
            [18.597221, 47.763054],
            [18.540833, 47.767494],
            [18.451664, 47.767776],
            [18.446941, 47.766937],
            [18.41333, 47.753883],
            [18.378609, 47.747215],
            [18.337498, 47.740829],
            [18.312222, 47.737778],
            [18.297222, 47.737221],
            [18.195831, 47.747772],
            [18.131664, 47.755272],
            [18.119164, 47.756943],
            [18.086109, 47.759438],
            [17.976109, 47.763611],
            [17.916386, 47.75222],
            [17.901386, 47.749161],
            [17.896942, 47.747551],
            [17.790161, 47.746056],
            [17.784409, 47.746803],
            [17.712219, 47.770554],
            [17.485867, 47.877968],
            [17.466389, 47.888329],
            [17.457775, 47.895828],
            [17.448887, 47.907776],
            [17.447498, 47.91111],
            [17.442219, 47.916664],
            [17.411884, 47.944748],
            [17.355553, 47.988884],
            [17.340553, 47.997498],
            [17.335831, 47.998329],
            [17.311943, 47.998055],
            [17.273331, 48.001663],
            [17.264442, 48.004997],
            [17.26083, 48.007217],
            [17.254166, 48.016106],
            [17.251656, 48.024994],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "LS",
        ISO2: "LI",
        ISO3: "LIE",
        UN: 438,
        NAME: "Liechtenstein",
        AREA: 16,
        POP2005: 34598,
        REGION: 150,
        SUBREGION: 155,
        LON: 9.555,
        LAT: 47.153,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [9.533569, 47.274544],
            [9.566387, 47.243889],
            [9.622776, 47.150551],
            [9.633888, 47.130554],
            [9.63611, 47.103607],
            [9.634998, 47.094994],
            [9.627222, 47.086388],
            [9.610277, 47.070274],
            [9.603611, 47.065826],
            [9.598635, 47.063835],
            [9.544722, 47.07],
            [9.538055, 47.07],
            [9.506388, 47.06472],
            [9.485277, 47.061104],
            [9.474637, 47.057457],
            [9.510277, 47.092499],
            [9.512499, 47.100273],
            [9.512777, 47.109444],
            [9.511389, 47.121666],
            [9.505554, 47.139999],
            [9.49861, 47.15361],
            [9.489721, 47.16555],
            [9.484444, 47.179718],
            [9.484165, 47.192215],
            [9.485832, 47.200272],
            [9.491388, 47.215271],
            [9.502222, 47.231384],
            [9.533569, 47.274544],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "MK",
        ISO2: "MK",
        ISO3: "MKD",
        UN: 807,
        NAME: "The former Yugoslav Republic of Macedonia",
        AREA: 2543,
        POP2005: 2033655,
        REGION: 150,
        SUBREGION: 39,
        LON: 21.698,
        LAT: 41.6,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [20.82111, 40.908882],
            [20.811943, 40.901108],
            [20.802498, 40.899994],
            [20.759163, 40.904442],
            [20.75333, 40.905273],
            [20.743332, 40.907776],
            [20.735119, 40.911057],
            [20.733887, 40.911942],
            [20.669998, 41.088051],
            [20.654999, 41.090271],
            [20.600613, 41.093185],
            [20.578331, 41.162773],
            [20.519165, 41.246384],
            [20.502499, 41.304443],
            [20.495552, 41.320549],
            [20.492775, 41.331108],
            [20.496109, 41.34333],
            [20.497498, 41.347221],
            [20.50222, 41.348053],
            [20.524166, 41.350273],
            [20.549999, 41.373055],
            [20.562222, 41.403885],
            [20.562496, 41.408051],
            [20.561386, 41.411385],
            [20.50861, 41.459717],
            [20.471664, 41.497772],
            [20.469719, 41.500832],
            [20.460552, 41.515831],
            [20.458885, 41.518883],
            [20.457775, 41.522217],
            [20.458054, 41.526382],
            [20.46611, 41.55555],
            [20.533886, 41.63472],
            [20.514164, 41.727776],
            [20.516941, 41.743889],
            [20.519997, 41.75222],
            [20.533607, 41.776939],
            [20.568951, 41.874542],
            [20.589642, 41.882187],
            [20.605553, 41.869164],
            [20.615276, 41.862495],
            [20.623333, 41.858604],
            [20.631664, 41.855827],
            [20.702499, 41.85611],
            [20.713055, 41.856667],
            [20.726387, 41.860275],
            [20.733055, 41.863884],
            [20.744164, 41.874161],
            [20.773888, 41.918884],
            [20.777222, 41.925552],
            [20.778332, 41.929718],
            [20.778889, 41.938332],
            [20.778053, 41.946663],
            [20.761665, 41.974442],
            [20.759441, 41.981384],
            [20.759163, 41.993332],
            [20.769722, 42.04277],
            [20.771942, 42.050827],
            [20.785, 42.074715],
            [20.792774, 42.082497],
            [20.796108, 42.085274],
            [20.807777, 42.089996],
            [20.914997, 42.119995],
            [21.104721, 42.198883],
            [21.116943, 42.202499],
            [21.12833, 42.202499],
            [21.13361, 42.201385],
            [21.141941, 42.198051],
            [21.215275, 42.149994],
            [21.221107, 42.145271],
            [21.304996, 42.147774],
            [21.30611, 42.151382],
            [21.344444, 42.193054],
            [21.348053, 42.195549],
            [21.459999, 42.262497],
            [21.466663, 42.265831],
            [21.481941, 42.267776],
            [21.61972, 42.254166],
            [21.681389, 42.239716],
            [21.70472, 42.232773],
            [21.710831, 42.232216],
            [21.721386, 42.232773],
            [21.738331, 42.237495],
            [21.778889, 42.256943],
            [21.788609, 42.263329],
            [21.793888, 42.274162],
            [21.794441, 42.27861],
            [21.799721, 42.294167],
            [21.806664, 42.303329],
            [21.841389, 42.328331],
            [21.850277, 42.330826],
            [21.855553, 42.331108],
            [22.023609, 42.31694],
            [22.061943, 42.302216],
            [22.07222, 42.300552],
            [22.083332, 42.300552],
            [22.184719, 42.313889],
            [22.195, 42.315277],
            [22.198887, 42.316383],
            [22.206108, 42.32],
            [22.210831, 42.326111],
            [22.212776, 42.329437],
            [22.213886, 42.333611],
            [22.216389, 42.337219],
            [22.218609, 42.339722],
            [22.221943, 42.34166],
            [22.308609, 42.360275],
            [22.324444, 42.361382],
            [22.332775, 42.35833],
            [22.335552, 42.355827],
            [22.365276, 42.323883],
            [22.407776, 42.279442],
            [22.517776, 42.150833],
            [22.521111, 42.148605],
            [22.609444, 42.103333],
            [22.685833, 42.065277],
            [22.817497, 42.027771],
            [22.828609, 42.026939],
            [22.875832, 41.941666],
            [22.878052, 41.934715],
            [22.895832, 41.885277],
            [22.899441, 41.879166],
            [22.942497, 41.807777],
            [22.961941, 41.77861],
            [22.967499, 41.773605],
            [22.972221, 41.771942],
            [22.999722, 41.770271],
            [23.00972, 41.767494],
            [23.012775, 41.765274],
            [23.014721, 41.762215],
            [23.029999, 41.734718],
            [23.032776, 41.728333],
            [23.031387, 41.720551],
            [23.02972, 41.71666],
            [23.018608, 41.699997],
            [23.011387, 41.690826],
            [22.986942, 41.665833],
            [22.956387, 41.641663],
            [22.952499, 41.634438],
            [22.951664, 41.626106],
            [22.951664, 41.59861],
            [22.959164, 41.476387],
            [22.966663, 41.374161],
            [22.964722, 41.366104],
            [22.960831, 41.358604],
            [22.955555, 41.35305],
            [22.942497, 41.344719],
            [22.935604, 41.342125],
            [22.926388, 41.343048],
            [22.813053, 41.34861],
            [22.803886, 41.346939],
            [22.781387, 41.331665],
            [22.772221, 41.32444],
            [22.763988, 41.315315],
            [22.75972, 41.309441],
            [22.759441, 41.305275],
            [22.760555, 41.301941],
            [22.763611, 41.299721],
            [22.765274, 41.296661],
            [22.761543, 41.25174],
            [22.758053, 41.227776],
            [22.74361, 41.16333],
            [22.741943, 41.159164],
            [22.735832, 41.148888],
            [22.729164, 41.144722],
            [22.720554, 41.142776],
            [22.590275, 41.119995],
            [22.585552, 41.119438],
            [22.58083, 41.119995],
            [22.484722, 41.121384],
            [22.450275, 41.121384],
            [22.434719, 41.121384],
            [22.34333, 41.134438],
            [22.304722, 41.153328],
            [22.262497, 41.170555],
            [22.256664, 41.171387],
            [22.205555, 41.16777],
            [21.980553, 41.133606],
            [21.97361, 41.129997],
            [21.916111, 41.095276],
            [21.909164, 41.07444],
            [21.910553, 41.067215],
            [21.913887, 41.056938],
            [21.913609, 41.053329],
            [21.911942, 41.049438],
            [21.792221, 40.932777],
            [21.780277, 40.928886],
            [21.599998, 40.872772],
            [21.57972, 40.872215],
            [21.573608, 40.873055],
            [21.57, 40.874992],
            [21.548332, 40.891106],
            [21.536663, 40.904716],
            [21.533607, 40.907219],
            [21.52972, 40.908882],
            [21.513611, 40.910553],
            [21.41972, 40.919167],
            [21.415554, 40.91777],
            [21.405552, 40.911659],
            [21.399719, 40.906944],
            [21.380554, 40.888054],
            [21.36861, 40.878326],
            [21.356667, 40.874443],
            [21.343052, 40.871941],
            [21.31472, 40.868607],
            [21.150833, 40.857498],
            [21.121555, 40.857216],
            [20.98349, 40.855888],
            [20.984165, 40.891663],
            [20.983887, 40.893608],
            [20.982445, 40.895248],
            [20.971943, 40.906387],
            [20.968887, 40.908607],
            [20.957222, 40.914162],
            [20.944164, 40.919167],
            [20.848331, 40.935555],
            [20.840832, 40.932495],
            [20.830276, 40.92083],
            [20.82111, 40.908882],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "MT",
        ISO2: "MT",
        ISO3: "MLT",
        UN: 470,
        NAME: "Malta",
        AREA: 32,
        POP2005: 402617,
        REGION: 150,
        SUBREGION: 39,
        LON: 14.442,
        LAT: 35.89,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [14.562222, 35.820274],
              [14.519722000000115, 35.799995],
              [14.42389, 35.818604],
              [14.379721, 35.844444],
              [14.374998, 35.8475],
              [14.366943, 35.854721],
              [14.347221, 35.872498],
              [14.339443, 35.879715],
              [14.336388, 35.883888000000127],
              [14.333055000000115, 35.894997],
              [14.324999, 35.972771],
              [14.326387000000125, 35.97888],
              [14.332499, 35.981110000000115],
              [14.361666, 35.99139],
              [14.368332, 35.992493],
              [14.374998, 35.990829],
              [14.443333000000109, 35.960274],
              [14.510277, 35.92528],
              [14.54833200000013, 35.892220000000123],
              [14.563889, 35.877777],
              [14.57, 35.869438],
              [14.568054, 35.829437],
              [14.565832, 35.824165000000107],
              [14.562222, 35.820274],
            ],
          ],
          [
            [
              [14.2675, 36.011383],
              [14.251389000000131, 36.011383],
              [14.237221, 36.012772],
              [14.196943, 36.021942],
              [14.19111, 36.02444],
              [14.185833, 36.033333],
              [14.180832, 36.055275000000108],
              [14.181110000000103, 36.060829000000126],
              [14.190832, 36.066383],
              [14.208887000000118, 36.071663],
              [14.229166, 36.074997],
              [14.245832, 36.074165],
              [14.253332000000114, 36.073051],
              [14.314999, 36.053329],
              [14.320555, 36.051109],
              [14.34111, 36.033882],
              [14.34083, 36.029716000000121],
              [14.335833, 36.027222],
              [14.275, 36.011665000000107],
              [14.2675, 36.011383],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "BE",
        ISO2: "BE",
        ISO3: "BEL",
        UN: 56,
        NAME: "Belgium",
        AREA: 0,
        POP2005: 10398049,
        REGION: 150,
        SUBREGION: 155,
        LON: 4.664,
        LAT: 50.643,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4.302375, 51.263184],
            [4.309677, 51.262032],
            [4.327703, 51.290123],
            [4.290481, 51.307682],
            [4.283055, 51.317215],
            [4.280181, 51.3442],
            [4.260985, 51.355434],
            [4.252368, 51.375145],
            [4.279674, 51.376595],
            [4.346944, 51.362495],
            [4.358889, 51.359993],
            [4.388055, 51.357498],
            [4.407222, 51.357773],
            [4.418611, 51.359161],
            [4.428055, 51.361938],
            [4.431666, 51.364441],
            [4.437778, 51.375275],
            [4.436388, 51.378883],
            [4.417777, 51.398331],
            [4.401388, 51.410828],
            [4.396667, 51.416939],
            [4.393888, 51.450272],
            [4.397499, 51.452774],
            [4.481944, 51.479439],
            [4.486666, 51.480827],
            [4.539721, 51.48555],
            [4.545555, 51.484993],
            [4.549444, 51.482773],
            [4.550833, 51.479439],
            [4.549999, 51.474998],
            [4.544999, 51.462776],
            [4.543333, 51.458885],
            [4.538055, 51.452499],
            [4.535277, 51.443886],
            [4.535277, 51.43972],
            [4.537222, 51.432495],
            [4.541944, 51.426666],
            [4.546944, 51.425827],
            [4.644722, 51.42305],
            [4.650555, 51.423332],
            [4.671388, 51.427757],
            [4.673055, 51.430832],
            [4.670833, 51.433609],
            [4.668611, 51.440826],
            [4.671111, 51.44416],
            [4.69861, 51.464439],
            [4.705555, 51.469444],
            [4.757222, 51.496666],
            [4.769166, 51.502777],
            [4.781111, 51.503609],
            [4.788333, 51.503052],
            [4.806944, 51.499443],
            [4.825833, 51.492218],
            [4.845555, 51.48111],
            [4.84611, 51.477493],
            [4.844722, 51.461388],
            [4.832777, 51.429993],
            [4.853055, 51.414444],
            [4.929999, 51.398605],
            [4.93611, 51.399437],
            [4.940277, 51.401382],
            [4.955555, 51.409996],
            [4.989444, 51.43055],
            [5.0, 51.437775],
            [5.009444, 51.446388],
            [5.012777, 51.454163],
            [5.015277, 51.471664],
            [5.016944, 51.475555],
            [5.023611, 51.48111],
            [5.035555, 51.487221],
            [5.041389, 51.486664],
            [5.073333, 51.471664],
            [5.080277, 51.466942],
            [5.09611, 51.446106],
            [5.104444, 51.434998],
            [5.103333, 51.43055],
            [5.10111, 51.427216],
            [5.089444, 51.415276],
            [5.085833, 51.412773],
            [5.08, 51.406944],
            [5.077777, 51.403328],
            [5.076666, 51.398888],
            [5.077222, 51.395271],
            [5.07861, 51.391663],
            [5.083055, 51.385826],
            [5.139999, 51.320831],
            [5.143888, 51.318604],
            [5.155, 51.315826],
            [5.168056, 51.314438],
            [5.189166, 51.31916],
            [5.194444, 51.32],
            [5.201111, 51.319717],
            [5.223332, 51.313889],
            [5.233611, 51.310555],
            [5.237499, 51.308327],
            [5.238889, 51.304718],
            [5.238974, 51.262283],
            [5.329721, 51.262215],
            [5.4, 51.265549],
            [5.406111, 51.266106],
            [5.411388, 51.266937],
            [5.467777, 51.282776],
            [5.475555, 51.286942],
            [5.485833, 51.294998],
            [5.497222, 51.296104],
            [5.504444, 51.295273],
            [5.510833, 51.294441],
            [5.520833, 51.291107],
            [5.550278, 51.272499],
            [5.553333, 51.269722],
            [5.557777, 51.263885],
            [5.568334, 51.220711],
            [5.644722, 51.203606],
            [5.754167, 51.189995],
            [5.834444, 51.165833],
            [5.849171, 51.15638],
            [5.855, 51.151108],
            [5.855111, 51.148338],
            [5.851388, 51.14222],
            [5.848332, 51.139442],
            [5.818055, 51.114998],
            [5.776944, 51.025833],
            [5.764166, 50.989998],
            [5.758055, 50.959999],
            [5.657499, 50.880272],
            [5.65, 50.876938],
            [5.640555, 50.863052],
            [5.638888, 50.858887],
            [5.6375, 50.850273],
            [5.638055, 50.846664],
            [5.640833, 50.839722],
            [5.651667, 50.824715],
            [5.655555, 50.822495],
            [5.683611, 50.811386],
            [5.69394, 50.808815],
            [5.701944, 50.805832],
            [5.705, 50.785828],
            [5.70556, 50.781952],
            [5.701388, 50.774437],
            [5.691911, 50.760559],
            [5.69861, 50.757774],
            [5.737222, 50.759438],
            [5.742499, 50.760277],
            [5.7975, 50.76944],
            [5.870555, 50.760826],
            [5.898918, 50.753883],
            [5.926389, 50.756104],
            [6.011798, 50.757271],
            [6.054722, 50.72361],
            [6.167222, 50.656387],
            [6.268611, 50.623604],
            [6.270833, 50.621384],
            [6.271667, 50.618607],
            [6.270555, 50.615829],
            [6.247777, 50.589165],
            [6.264722, 50.497772],
            [6.309444, 50.498055],
            [6.317499, 50.496384],
            [6.333888, 50.489716],
            [6.344444, 50.484161],
            [6.371111, 50.448326],
            [6.37361, 50.443329],
            [6.374444, 50.440552],
            [6.398204, 50.323174],
            [6.349722, 50.312775],
            [6.280833, 50.283607],
            [6.173333, 50.232498],
            [6.165555, 50.22361],
            [6.163888, 50.221382],
            [6.139722, 50.154442],
            [6.134414, 50.127846],
            [6.12, 50.131943],
            [6.033889, 50.159164],
            [6.031111, 50.160828],
            [6.02861, 50.166107],
            [6.026256, 50.181252],
            [6.021944, 50.18222],
            [6.013888, 50.181389],
            [5.976388, 50.171387],
            [5.969722, 50.16861],
            [5.891666, 50.10611],
            [5.889444, 50.104164],
            [5.886666, 50.098885],
            [5.883055, 50.080551],
            [5.883055, 50.077217],
            [5.834444, 49.986938],
            [5.791389, 49.962494],
            [5.777499, 49.957771],
            [5.774722, 49.956108],
            [5.770833, 49.95166],
            [5.747777, 49.907494],
            [5.734444, 49.834999],
            [5.746666, 49.795273],
            [5.748055, 49.79277],
            [5.750833, 49.791107],
            [5.764999, 49.789993],
            [5.790277, 49.78083],
            [5.869444, 49.719719],
            [5.87615, 49.709885],
            [5.899166, 49.662773],
            [5.900277, 49.640549],
            [5.863055, 49.571663],
            [5.837777, 49.550278],
            [5.834167, 49.549164],
            [5.80788, 49.545044],
            [5.792222, 49.54583],
            [5.702222, 49.543053],
            [5.631944, 49.535828],
            [5.593333, 49.526382],
            [5.530555, 49.511108],
            [5.514444, 49.508888],
            [5.4775, 49.504166],
            [5.473055, 49.506104],
            [5.470277, 49.508888],
            [5.463611, 49.517776],
            [5.465278, 49.52166],
            [5.473888, 49.530548],
            [5.47611, 49.534164],
            [5.475555, 49.537773],
            [5.474166, 49.541107],
            [5.437778, 49.599998],
            [5.427221, 49.606941],
            [5.415, 49.613327],
            [5.398611, 49.621384],
            [5.392305, 49.622551],
            [5.331111, 49.656662],
            [4.996666, 49.802498],
            [4.984444, 49.804718],
            [4.959167, 49.802216],
            [4.944722, 49.79361],
            [4.935277, 49.790833],
            [4.924444, 49.789444],
            [4.912777, 49.788887],
            [4.906666, 49.789719],
            [4.873055, 49.797218],
            [4.863889, 49.80722],
            [4.820833, 49.992775],
            [4.838888, 50.06916],
            [4.853333, 50.095551],
            [4.880555, 50.126389],
            [4.883333, 50.129166],
            [4.8875, 50.131104],
            [4.894444, 50.136108],
            [4.894722, 50.140274],
            [4.882777, 50.154716],
            [4.832503, 50.16861],
            [4.819166, 50.167221],
            [4.814722, 50.165833],
            [4.763055, 50.135551],
            [4.696944, 50.090828],
            [4.693055, 50.083328],
            [4.688055, 50.071106],
            [4.687778, 50.067215],
            [4.693889, 50.061943],
            [4.697499, 50.05555],
            [4.694444, 50.041939],
            [4.679722, 50.001938],
            [4.673611, 49.996384],
            [4.510555, 49.947495],
            [4.464167, 49.938889],
            [4.458333, 49.938606],
            [4.445833, 49.940552],
            [4.430007, 49.945007],
            [4.413333, 49.949165],
            [4.317222, 49.969719],
            [4.248055, 49.964439],
            [4.231111, 49.962494],
            [4.215261, 49.959602],
            [4.183055, 49.976387],
            [4.174179, 49.979881],
            [4.149238, 49.978371],
            [4.147222, 50.009995],
            [4.171389, 50.137215],
            [4.194444, 50.237495],
            [4.165, 50.283051],
            [4.038333, 50.355553],
            [4.033177, 50.35643],
            [3.983889, 50.345276],
            [3.889722, 50.339996],
            [3.774722, 50.353882],
            [3.676944, 50.395271],
            [3.671667, 50.433327],
            [3.670555, 50.440826],
            [3.668889, 50.44416],
            [3.660555, 50.456383],
            [3.657728, 50.45887],
            [3.654444, 50.461662],
            [3.620155, 50.490044],
            [3.607778, 50.495827],
            [3.518055, 50.518883],
            [3.456666, 50.511383],
            [3.4525, 50.509438],
            [3.372777, 50.494995],
            [3.367222, 50.495552],
            [3.298611, 50.523048],
            [3.295555, 50.525551],
            [3.28, 50.53833],
            [3.278611, 50.541664],
            [3.243055, 50.660271],
            [3.242222, 50.668053],
            [3.197778, 50.727219],
            [3.187222, 50.746666],
            [3.182874, 50.75705],
            [3.164722, 50.780548],
            [3.162222, 50.783607],
            [3.154444, 50.78833],
            [3.149722, 50.789993],
            [3.143333, 50.790833],
            [3.116389, 50.791664],
            [3.050833, 50.780273],
            [3.041667, 50.777222],
            [3.026988, 50.769844],
            [3.02, 50.770554],
            [3.008611, 50.769165],
            [2.960556, 50.7575],
            [2.943055, 50.741386],
            [2.898056, 50.703049],
            [2.867503, 50.713379],
            [2.781944, 50.755554],
            [2.650555, 50.816109],
            [2.597777, 50.925827],
            [2.5975, 50.995827],
            [2.541667, 51.09111],
            [2.550833, 51.092499],
            [2.560277, 51.095551],
            [2.863055, 51.213333],
            [2.955277, 51.249718],
            [3.02, 51.276382],
            [3.095277, 51.311386],
            [3.112778, 51.318329],
            [3.131667, 51.324165],
            [3.179722, 51.336105],
            [3.370866, 51.373856],
            [3.373611, 51.309998],
            [3.379444, 51.276939],
            [3.380833, 51.273605],
            [3.388324, 51.268677],
            [3.434166, 51.246109],
            [3.439167, 51.244438],
            [3.451944, 51.242493],
            [3.465833, 51.241943],
            [3.483611, 51.243332],
            [3.520833, 51.248055],
            [3.524167, 51.250549],
            [3.524444, 51.263054],
            [3.5225, 51.274162],
            [3.520833, 51.277496],
            [3.520278, 51.281387],
            [3.521111, 51.285828],
            [3.524722, 51.28833],
            [3.595555, 51.303886],
            [3.600833, 51.304718],
            [3.608055, 51.304161],
            [3.669167, 51.29277],
            [3.782777, 51.264999],
            [3.793056, 51.26194],
            [3.796389, 51.259438],
            [3.790833, 51.237221],
            [3.790833, 51.233055],
            [3.793889, 51.223053],
            [3.796111, 51.220276],
            [3.806389, 51.216942],
            [3.890277, 51.205826],
            [3.8975, 51.205276],
            [3.903611, 51.205826],
            [3.9525, 51.214439],
            [4.062222, 51.25222],
            [4.127777, 51.278885],
            [4.161388, 51.294167],
            [4.173055, 51.300552],
            [4.214999, 51.330276],
            [4.228333, 51.340553],
            [4.238898, 51.350426],
            [4.255836, 51.336239],
            [4.26356, 51.317043],
            [4.280649, 51.301125],
            [4.309444, 51.290276],
            [4.312499, 51.287498],
            [4.313055, 51.283882],
            [4.300079, 51.267651],
            [4.302375, 51.263184],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "FO",
        ISO2: "FO",
        ISO3: "FRO",
        UN: 234,
        NAME: "Faroe Islands",
        AREA: 0,
        POP2005: 48205,
        REGION: 150,
        SUBREGION: 154,
        LON: -6.864,
        LAT: 62.05,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-6.655278, 61.389442],
              [-6.660278, 61.38833],
              [-6.66806, 61.389442],
              [-6.719167, 61.407494],
              [-6.845834, 61.46805],
              [-6.95833, 61.59861],
              [-6.962778, 61.619164000000126],
              [-6.96, 61.622772],
              [-6.94472, 61.636665000000107],
              [-6.92639, 61.641388],
              [-6.91222, 61.643608],
              [-6.889445, 61.644997],
              [-6.72889, 61.575829],
              [-6.72444, 61.573326],
              [-6.709445, 61.558327000000133],
              [-6.655278, 61.433052],
              [-6.64167, 61.40083],
              [-6.64222, 61.397217000000126],
              [-6.655278, 61.389442],
            ],
          ],
          [
            [
              [-6.60417, 61.821663],
              [-6.63, 61.761108],
              [-6.63889, 61.750549],
              [-6.65222, 61.742775],
              [-6.704722, 61.7775],
              [-6.836112, 61.81777],
              [-6.841111, 61.817497000000117],
              [-6.86611, 61.837494],
              [-6.90889, 61.901108],
              [-6.908334, 61.904716],
              [-6.904723, 61.907776],
              [-6.86444, 61.90749],
              [-6.855834, 61.90694],
              [-6.78333, 61.896942],
              [-6.776945, 61.895271],
              [-6.66139, 61.858887],
              [-6.65222, 61.853882],
              [-6.60417, 61.82611],
              [-6.60417, 61.821663],
            ],
          ],
          [
            [
              [-7.04972, 62.067772000000105],
              [-7.055, 62.060272],
              [-7.062778, 62.049438000000123],
              [-7.165278, 62.023605],
              [-7.185834, 62.019722],
              [-7.20167, 62.018608],
              [-7.191668, 62.031105],
              [-7.192223, 62.03972],
              [-7.19361, 62.043327],
              [-7.19833, 62.049995],
              [-7.21194, 62.057495],
              [-7.226667, 62.064438000000109],
              [-7.2325, 62.064720000000136],
              [-7.233334, 62.060272],
              [-7.25111, 62.042770000000132],
              [-7.34556, 62.052216000000101],
              [-7.35222, 62.053886],
              [-7.378056, 62.064995],
              [-7.381667, 62.068054000000132],
              [-7.43111, 62.116104],
              [-7.43389, 62.123604],
              [-7.43444, 62.127777],
              [-7.435, 62.14027],
              [-7.43361, 62.14361],
              [-7.42639, 62.144722000000115],
              [-7.231112, 62.159996],
              [-7.223333, 62.159439000000134],
              [-7.163073, 62.128815],
              [-7.05611, 62.09861],
              [-7.045, 62.094444],
              [-7.04139, 62.091385],
              [-7.040278, 62.087776],
              [-7.041112, 62.083054000000118],
              [-7.04972, 62.067772000000105],
            ],
          ],
          [
            [
              [-6.70694, 61.937492000000134],
              [-6.71778, 61.933327000000133],
              [-6.72528, 61.934441000000106],
              [-6.773056, 61.949997],
              [-6.86917, 61.997498000000121],
              [-6.961112, 62.046661],
              [-7.034582, 62.11211],
              [-7.13031, 62.125599],
              [-7.23222, 62.172493],
              [-7.23472, 62.175827],
              [-7.235001, 62.179993],
              [-7.233612, 62.193329],
              [-7.232779, 62.198051000000135],
              [-7.21083, 62.284721000000104],
              [-7.195556, 62.304718],
              [-7.192223, 62.307777000000101],
              [-7.135, 62.303886],
              [-7.12806, 62.302216],
              [-7.0875, 62.290833],
              [-7.070556, 62.284721000000104],
              [-7.06583, 62.282219],
              [-7.0625, 62.27916],
              [-7.0575, 62.272499],
              [-7.05222, 62.2575],
              [-7.045, 62.243332],
              [-7.0425, 62.239998],
              [-7.036667, 62.233604000000128],
              [-6.990834, 62.193054],
              [-6.97389, 62.182495],
              [-6.94583, 62.16805],
              [-6.91639, 62.153885000000116],
              [-6.84139, 62.12444],
              [-6.735001, 62.04361],
              [-6.72472, 62.035],
              [-6.71889, 62.02861],
              [-6.696389, 61.979439],
              [-6.696112, 61.975273000000129],
              [-6.7025, 61.940277],
              [-6.70694, 61.937492000000134],
            ],
          ],
          [
            [
              [-6.620001, 62.229721],
              [-6.62361, 62.226662],
              [-6.63222, 62.227493],
              [-6.65806, 62.234444],
              [-6.68139, 62.242493],
              [-6.68583, 62.244995000000131],
              [-6.71167, 62.293884000000105],
              [-6.720834, 62.331383],
              [-6.63222, 62.259163],
              [-6.625556, 62.253326],
              [-6.62028, 62.238052],
              [-6.619167, 62.234444],
              [-6.620001, 62.229721],
            ],
          ],
          [
            [
              [-6.6575, 62.0925],
              [-6.6575, 62.055832],
              [-6.66972, 62.058609000000104],
              [-6.75278, 62.092773],
              [-6.921945, 62.167221],
              [-6.94806, 62.182495],
              [-6.96417, 62.193329],
              [-7.01111, 62.226387],
              [-7.025, 62.237778],
              [-7.029445, 62.244438],
              [-7.0625, 62.295830000000137],
              [-7.06028, 62.313606000000107],
              [-6.958056, 62.339165],
              [-6.950278, 62.338051],
              [-6.938056, 62.334160000000111],
              [-6.807222, 62.290276],
              [-6.735001, 62.259995],
              [-6.60111, 62.196938],
              [-6.59778, 62.19416],
              [-6.588056, 62.134163000000115],
              [-6.64972, 62.10249],
              [-6.65417, 62.099716000000114],
              [-6.656945, 62.096107],
              [-6.6575, 62.0925],
            ],
          ],
          [
            [
              [-6.41861, 62.18388],
              [-6.518056, 62.168884],
              [-6.52722, 62.173882],
              [-6.55556, 62.196938],
              [-6.5725, 62.211662000000103],
              [-6.581944, 62.224998],
              [-6.588056, 62.239716],
              [-6.550858, 62.250984],
              [-6.548974, 62.3009],
              [-6.574403, 62.34988],
              [-6.541667, 62.357498],
              [-6.536667, 62.3425],
              [-6.522223, 62.318054],
              [-6.492778, 62.291382],
              [-6.48889, 62.28833],
              [-6.43, 62.268883],
              [-6.397779, 62.259995],
              [-6.392222, 62.25805],
              [-6.388889, 62.254997],
              [-6.388612, 62.250832],
              [-6.389723, 62.246109000000104],
              [-6.40722, 62.191666000000112],
              [-6.40861, 62.188606],
              [-6.41222, 62.185272],
              [-6.41861, 62.18388],
            ],
          ],
          [
            [
              [-6.58583, 62.256386],
              [-6.595, 62.256104],
              [-6.608334, 62.2586060000001],
              [-6.613056, 62.26111],
              [-6.620001, 62.26694],
              [-6.664445, 62.322495],
              [-6.66806, 62.32972],
              [-6.66833, 62.333885],
              [-6.66667, 62.347221],
              [-6.665833, 62.351944],
              [-6.660833, 62.372498],
              [-6.65472, 62.374161],
              [-6.64583, 62.374161],
              [-6.63806, 62.373055],
              [-6.63222, 62.370827],
              [-6.573611, 62.306389],
              [-6.56639, 62.296387],
              [-6.56139, 62.281387000000109],
              [-6.56111, 62.276939],
              [-6.56167, 62.273331],
              [-6.56556, 62.265274],
              [-6.5725, 62.258888000000127],
              [-6.58583, 62.256386],
            ],
          ],
          [
            [
              [-6.40611, 62.284439],
              [-6.415001, 62.284439],
              [-6.42278, 62.285553],
              [-6.480278, 62.29777],
              [-6.48861, 62.307495],
              [-6.546945, 62.38361],
              [-6.545279, 62.38694],
              [-6.530834, 62.39416],
              [-6.52528, 62.396111],
              [-6.51917, 62.396942],
              [-6.49833, 62.386383],
              [-6.48917, 62.381386000000134],
              [-6.39167, 62.29694],
              [-6.40611, 62.284439],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "AN",
        ISO2: "AD",
        ISO3: "AND",
        UN: 20,
        NAME: "Andorra",
        AREA: 0,
        POP2005: 73483,
        REGION: 150,
        SUBREGION: 39,
        LON: 1.576,
        LAT: 42.549,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1.78172, 42.569962],
            [1.774722, 42.571106],
            [1.768055, 42.571106],
            [1.753889, 42.57],
            [1.743055, 42.563606],
            [1.735278, 42.554443],
            [1.725278, 42.529999],
            [1.724444, 42.524994],
            [1.723333, 42.515274],
            [1.723611, 42.509438],
            [1.718889, 42.503052],
            [1.661111, 42.471382],
            [1.654444, 42.467773],
            [1.541667, 42.437218],
            [1.533333, 42.436104],
            [1.512222, 42.436386],
            [1.454722, 42.441666],
            [1.448333, 42.450829],
            [1.424166, 42.493332],
            [1.421389, 42.54583],
            [1.434444, 42.576385],
            [1.445833, 42.601944],
            [1.481111, 42.647217],
            [1.491944, 42.65361],
            [1.556389, 42.656387],
            [1.563056, 42.655548],
            [1.698333, 42.626106],
            [1.738611, 42.616386],
            [1.78172, 42.569962],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "LU",
        ISO2: "LU",
        ISO3: "LUX",
        UN: 442,
        NAME: "Luxembourg",
        AREA: 0,
        POP2005: 456613,
        REGION: 150,
        SUBREGION: 155,
        LON: 6.088,
        LAT: 49.771,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6.026256, 50.181252],
            [6.02861, 50.166107],
            [6.031111, 50.160828],
            [6.033889, 50.159164],
            [6.12, 50.131943],
            [6.134414, 50.127846],
            [6.130278, 50.121941],
            [6.128055, 50.116386],
            [6.118333, 50.090828],
            [6.112778, 50.058884],
            [6.113333, 50.055832],
            [6.130555, 50.013885],
            [6.140555, 49.993889],
            [6.173055, 49.952217],
            [6.175278, 49.949997],
            [6.234166, 49.897499],
            [6.250278, 49.884163],
            [6.255278, 49.880554],
            [6.315938, 49.855316],
            [6.321111, 49.848328],
            [6.395555, 49.817772],
            [6.429722, 49.808884],
            [6.481944, 49.811104],
            [6.522222, 49.811104],
            [6.524444, 49.808609],
            [6.524722, 49.80555],
            [6.505835, 49.706627],
            [6.484722, 49.696106],
            [6.473055, 49.693604],
            [6.46611, 49.691109],
            [6.420833, 49.665833],
            [6.356486, 49.525864],
            [6.362778, 49.489166],
            [6.36217, 49.459389],
            [6.328333, 49.469162],
            [6.302777, 49.476662],
            [6.247318, 49.505974],
            [6.239721, 49.507774],
            [6.229722, 49.508331],
            [6.165277, 49.504715],
            [6.156111, 49.503883],
            [6.124166, 49.489716],
            [6.123055, 49.487221],
            [6.122499, 49.480553],
            [6.12, 49.471664],
            [6.118055, 49.469719],
            [6.094444, 49.454163],
            [6.090555, 49.453049],
            [5.981388, 49.448326],
            [5.977777, 49.448608],
            [5.855277, 49.501106],
            [5.838611, 49.51416],
            [5.811666, 49.536385],
            [5.809999, 49.538887],
            [5.80788, 49.545044],
            [5.834167, 49.549164],
            [5.837777, 49.550278],
            [5.863055, 49.571663],
            [5.900277, 49.640549],
            [5.899166, 49.662773],
            [5.87615, 49.709885],
            [5.869444, 49.719719],
            [5.790277, 49.78083],
            [5.764999, 49.789993],
            [5.750833, 49.791107],
            [5.748055, 49.79277],
            [5.746666, 49.795273],
            [5.734444, 49.834999],
            [5.747777, 49.907494],
            [5.770833, 49.95166],
            [5.774722, 49.956108],
            [5.777499, 49.957771],
            [5.791389, 49.962494],
            [5.834444, 49.986938],
            [5.883055, 50.077217],
            [5.883055, 50.080551],
            [5.886666, 50.098885],
            [5.889444, 50.104164],
            [5.891666, 50.10611],
            [5.969722, 50.16861],
            [5.976388, 50.171387],
            [6.013888, 50.181389],
            [6.021944, 50.18222],
            [6.026256, 50.181252],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "MN",
        ISO2: "MC",
        ISO3: "MCO",
        UN: 492,
        NAME: "Monaco",
        AREA: 0,
        POP2005: 325,
        REGION: 150,
        SUBREGION: 155,
        LON: 7.412,
        LAT: 43.75,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7.439293, 43.757523],
            [7.423055, 43.739998],
            [7.4175, 43.734161],
            [7.391609, 43.727547],
            [7.386389, 43.741943],
            [7.386389, 43.745552],
            [7.387777, 43.748604],
            [7.403055, 43.761383],
            [7.416111, 43.770554],
            [7.419999, 43.772499],
            [7.424722, 43.773048],
            [7.429444, 43.771385],
            [7.4325, 43.769165],
            [7.438333, 43.760277],
            [7.439293, 43.757523],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "MJ",
        ISO2: "ME",
        ISO3: "MNE",
        UN: 499,
        NAME: "Montenegro",
        AREA: 0,
        POP2005: 607969,
        REGION: 150,
        SUBREGION: 39,
        LON: 19.254,
        LAT: 42.792,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [18.455555, 42.565826],
            [18.463886, 42.569443],
            [18.536663, 42.610832],
            [18.549999, 42.619438],
            [18.56583, 42.630554],
            [18.570553, 42.635826],
            [18.574444, 42.643326],
            [18.577499, 42.654999],
            [18.576385, 42.663055],
            [18.561665, 42.70916],
            [18.560276, 42.712219],
            [18.558052, 42.715271],
            [18.551388, 42.719162],
            [18.546665, 42.720833],
            [18.535553, 42.722221],
            [18.526386, 42.724442],
            [18.518608, 42.728607],
            [18.515831, 42.73111],
            [18.490833, 42.766388],
            [18.457222, 42.82222],
            [18.455555, 42.825554],
            [18.454441, 42.833328],
            [18.478611, 42.956383],
            [18.480553, 42.964439],
            [18.483887, 42.971939],
            [18.497219, 42.990273],
            [18.508888, 43.000549],
            [18.524441, 43.012215],
            [18.535553, 43.01722],
            [18.552219, 43.022774],
            [18.57972, 43.02916],
            [18.631664, 43.034439],
            [18.640831, 43.037216],
            [18.647221, 43.041382],
            [18.649998, 43.044167],
            [18.651665, 43.047493],
            [18.657776, 43.071938],
            [18.659164, 43.080276],
            [18.657776, 43.09166],
            [18.65361, 43.115273],
            [18.650555, 43.122215],
            [18.644997, 43.13166],
            [18.643887, 43.13916],
            [18.645832, 43.147217],
            [18.697777, 43.252495],
            [18.699997, 43.255554],
            [18.706665, 43.260277],
            [18.83934, 43.348022],
            [18.873325, 43.354691],
            [18.888332, 43.356384],
            [18.908607, 43.35833],
            [18.914238, 43.358315],
            [18.91972, 43.357216],
            [18.957497, 43.329163],
            [18.960293, 43.326683],
            [18.960545, 43.318924],
            [18.954166, 43.308884],
            [18.951942, 43.300278],
            [18.954441, 43.29361],
            [18.956921, 43.290833],
            [19.016666, 43.239441],
            [19.048866, 43.231026],
            [19.054996, 43.232498],
            [19.06583, 43.238884],
            [19.068607, 43.241386],
            [19.07222, 43.248055],
            [19.078888, 43.262497],
            [19.09222, 43.301666],
            [19.093609, 43.308884],
            [19.027496, 43.429161],
            [19.023052, 43.435555],
            [19.011387, 43.444717],
            [18.998608, 43.449997],
            [18.988609, 43.452499],
            [18.976944, 43.453049],
            [18.960278, 43.452499],
            [18.956665, 43.454437],
            [18.95583, 43.458328],
            [18.949718, 43.496941],
            [18.948608, 43.505272],
            [18.949444, 43.509438],
            [18.951664, 43.512497],
            [19.006664, 43.555832],
            [19.011665, 43.556107],
            [19.211666, 43.52166],
            [19.223888, 43.516388],
            [19.228809, 43.513214],
            [19.254719, 43.459999],
            [19.279442, 43.449715],
            [19.444164, 43.373604],
            [19.511944, 43.321938],
            [19.517776, 43.317215],
            [19.548332, 43.284996],
            [19.558609, 43.270271],
            [19.560276, 43.263329],
            [19.563332, 43.256386],
            [19.585831, 43.236107],
            [19.641941, 43.186104],
            [19.647778, 43.181664],
            [19.656666, 43.178055],
            [19.67083, 43.174438],
            [19.692497, 43.17083],
            [19.783607, 43.148048],
            [19.920277, 43.106384],
            [19.969719, 43.090553],
            [20.035831, 43.037216],
            [20.059719, 43.005554],
            [20.147499, 42.971664],
            [20.153053, 42.972221],
            [20.164165, 42.971107],
            [20.178333, 42.967499],
            [20.25972, 42.941666],
            [20.286942, 42.932495],
            [20.297497, 42.926384],
            [20.34333, 42.891106],
            [20.348888, 42.886383],
            [20.376942, 42.849159],
            [20.382774, 42.835548],
            [20.379444, 42.833328],
            [20.231941, 42.761108],
            [20.112778, 42.767494],
            [20.104443, 42.770271],
            [20.088608, 42.773605],
            [20.076664, 42.773888],
            [20.066666, 42.773048],
            [20.039444, 42.766106],
            [20.014999, 42.752495],
            [19.990833, 42.73333],
            [19.980274, 42.721939],
            [19.976944, 42.715271],
            [19.975277, 42.707497],
            [19.977497, 42.703888],
            [19.980274, 42.701385],
            [20.007774, 42.684441],
            [20.015274, 42.680832],
            [20.025276, 42.678886],
            [20.048611, 42.677773],
            [20.07, 42.673882],
            [20.094444, 42.664444],
            [20.101665, 42.659996],
            [20.10722, 42.654442],
            [20.106941, 42.64666],
            [20.105831, 42.642776],
            [20.071423, 42.560913],
            [20.064163, 42.563049],
            [20.057777, 42.563889],
            [20.053333, 42.563049],
            [20.049164, 42.561661],
            [19.935276, 42.518608],
            [19.919441, 42.512497],
            [19.822498, 42.471939],
            [19.801666, 42.48027],
            [19.79361, 42.483887],
            [19.790276, 42.486107],
            [19.773609, 42.497215],
            [19.765274, 42.504715],
            [19.746666, 42.543053],
            [19.746944, 42.546944],
            [19.75, 42.579994],
            [19.752499, 42.583054],
            [19.759998, 42.586388],
            [19.766109, 42.585548],
            [19.770275, 42.586937],
            [19.772778, 42.589996],
            [19.773609, 42.593605],
            [19.773052, 42.597496],
            [19.755833, 42.639717],
            [19.75333, 42.64222],
            [19.726665, 42.659996],
            [19.722775, 42.661942],
            [19.713055, 42.660553],
            [19.708885, 42.658882],
            [19.657219, 42.628326],
            [19.645832, 42.61805],
            [19.633331, 42.603333],
            [19.615833, 42.582497],
            [19.609444, 42.572495],
            [19.608608, 42.568054],
            [19.610832, 42.561104],
            [19.612499, 42.549995],
            [19.608887, 42.542496],
            [19.606388, 42.539444],
            [19.519722, 42.448608],
            [19.286942, 42.192215],
            [19.282497, 42.185555],
            [19.284443, 42.182777],
            [19.300278, 42.171104],
            [19.332222, 42.152496],
            [19.369999, 42.128883],
            [19.386387, 42.11805],
            [19.398331, 42.10833],
            [19.400276, 42.10527],
            [19.398888, 42.101387],
            [19.384163, 42.083611],
            [19.380981, 42.081001],
            [19.378052, 42.078606],
            [19.374603, 42.071487],
            [19.373333, 42.06694],
            [19.346943, 41.955551],
            [19.34333, 41.912498],
            [19.367771, 41.848999],
            [19.299442, 41.894722],
            [19.278889, 41.903328],
            [19.244999, 41.912216],
            [19.235554, 41.910828],
            [19.224442, 41.911942],
            [19.181664, 41.928604],
            [19.170555, 41.934441],
            [19.15472, 41.945831],
            [19.150833, 41.951942],
            [19.138885, 41.97361],
            [19.136387, 41.98027],
            [19.136387, 41.983604],
            [19.140274, 41.993607],
            [19.146664, 42.013054],
            [19.145275, 42.026108],
            [19.138611, 42.043327],
            [19.078609, 42.111664],
            [19.056389, 42.135826],
            [19.051666, 42.137215],
            [19.046108, 42.137497],
            [19.004997, 42.157494],
            [18.964443, 42.189995],
            [18.887775, 42.273048],
            [18.883331, 42.27861],
            [18.875832, 42.282494],
            [18.870552, 42.283607],
            [18.84972, 42.286659],
            [18.844997, 42.287216],
            [18.810833, 42.284721],
            [18.652496, 42.378052],
            [18.641666, 42.370552],
            [18.627499, 42.364998],
            [18.623055, 42.364166],
            [18.617496, 42.364998],
            [18.612221, 42.366104],
            [18.577221, 42.387215],
            [18.546387, 42.416107],
            [18.54583, 42.419998],
            [18.547222, 42.423882],
            [18.552776, 42.429443],
            [18.55611, 42.431389],
            [18.561943, 42.432777],
            [18.585831, 42.429718],
            [18.613052, 42.424721],
            [18.622498, 42.421944],
            [18.631386, 42.41555],
            [18.635555, 42.413605],
            [18.697498, 42.393883],
            [18.702499, 42.393326],
            [18.70472, 42.396385],
            [18.709164, 42.412498],
            [18.709164, 42.416664],
            [18.706108, 42.42305],
            [18.681942, 42.458328],
            [18.675278, 42.462776],
            [18.513611, 42.455276],
            [18.50861, 42.45472],
            [18.504997, 42.452774],
            [18.503197, 42.44944],
            [18.498055, 42.451111],
            [18.479443, 42.465271],
            [18.466389, 42.477776],
            [18.460278, 42.486938],
            [18.455276, 42.500275],
            [18.453331, 42.512497],
            [18.453331, 42.521111],
            [18.455555, 42.565826],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "NL",
        ISO2: "NL",
        ISO3: "NLD",
        UN: 528,
        NAME: "Netherlands",
        AREA: 3388,
        POP2005: 1632769,
        REGION: 150,
        SUBREGION: 155,
        LON: 5.389,
        LAT: 52.077,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [3.76417, 51.345276],
              [3.861944, 51.339165],
              [3.86722200000014, 51.339996],
              [3.961389000000111, 51.36972],
              [4.198055, 51.374443],
              [4.205277, 51.37389],
              [4.210833, 51.372498],
              [4.215, 51.370277000000101],
              [4.2175, 51.368332000000123],
              [4.23889800000012, 51.350426],
              [4.228333000000134, 51.340553000000114],
              [4.215, 51.33027600000014],
              [4.17305, 51.300552],
              [4.161388000000102, 51.29416700000013],
              [4.127777, 51.278885],
              [4.062222, 51.25222],
              [3.9525, 51.214439],
              [3.903611, 51.205826000000116],
              [3.8975, 51.205276],
              [3.890277, 51.205826000000116],
              [3.806389000000138, 51.216942],
              [3.796111, 51.220276],
              [3.793889, 51.223053000000107],
              [3.79083, 51.233055],
              [3.79083, 51.23722],
              [3.79639, 51.259438],
              [3.793056, 51.26194],
              [3.782777, 51.264999000000103],
              [3.669167, 51.29277],
              [3.608055, 51.304161000000136],
              [3.600833, 51.304718],
              [3.595555, 51.303886],
              [3.524722, 51.28833],
              [3.52111, 51.285828],
              [3.52028, 51.281387],
              [3.520833, 51.277496],
              [3.5225, 51.274162000000103],
              [3.524444, 51.263054000000125],
              [3.524167, 51.25055],
              [3.520833, 51.248055],
              [3.483611, 51.243332],
              [3.465833, 51.241943],
              [3.45194400000014, 51.242493],
              [3.439167, 51.244438],
              [3.434166, 51.246109],
              [3.388324, 51.268677000000139],
              [3.380833, 51.273605],
              [3.379444, 51.276939],
              [3.373611, 51.309998],
              [3.37087, 51.373856000000103],
              [3.40667, 51.385551],
              [3.519444, 51.411385],
              [3.538333000000137, 51.411942000000124],
              [3.550278000000105, 51.409721],
              [3.639722, 51.381660000000124],
              [3.72139, 51.35583],
              [3.735000000000127, 51.35],
              [3.740555, 51.34861],
              [3.76417, 51.345276],
            ],
          ],
          [
            [
              [5.763888, 52.415276],
              [5.754167, 52.412498],
              [5.720833, 52.41305],
              [5.693889, 52.408051],
              [5.638888000000122, 52.388611],
              [5.62444, 52.379715],
              [5.611944000000108, 52.36972],
              [5.57778, 52.369438000000116],
              [5.573055, 52.36805],
              [5.565000000000111, 52.36360900000011],
              [5.546111, 52.351944],
              [5.544999, 52.347496],
              [5.545555, 52.343887],
              [5.559166, 52.325829],
              [5.559722, 52.32222],
              [5.53889, 52.290276],
              [5.534166, 52.283333],
              [5.529722000000106, 52.281387000000109],
              [5.516944000000137, 52.27805],
              [5.428611, 52.264160000000118],
              [5.415833, 52.264160000000118],
              [5.404444000000126, 52.266937],
              [5.3975, 52.271942],
              [5.369721, 52.287498],
              [5.357778, 52.294167],
              [5.330555, 52.30917],
              [5.305555, 52.317772],
              [5.27861, 52.325829],
              [5.24861, 52.3325],
              [5.21194400000013, 52.34],
              [5.192778, 52.339439],
              [5.187222, 52.338608],
              [5.1775, 52.335548],
              [5.165833000000134, 52.334442],
              [5.160832, 52.335274],
              [5.156111, 52.337219000000118],
              [5.151944, 52.339439],
              [5.145833, 52.344719],
              [5.141944000000137, 52.35083],
              [5.135555000000124, 52.380272],
              [5.137777000000142, 52.382774],
              [5.168192, 52.393799000000115],
              [5.181110000000103, 52.405548],
              [5.203055, 52.414719],
              [5.296389, 52.451660000000118],
              [5.381944, 52.484444],
              [5.41309600000011, 52.49332],
              [5.45117, 52.509445],
              [5.454558, 52.524216],
              [5.456944, 52.528328000000101],
              [5.47805, 52.548882],
              [5.573333, 52.588333],
              [5.643611, 52.601105],
              [5.827222, 52.570549],
              [5.831388000000118, 52.568329000000119],
              [5.839444, 52.561104],
              [5.85556, 52.544167],
              [5.861388, 52.534996],
              [5.862928, 52.522232],
              [5.85556, 52.492493],
              [5.8475, 52.482498],
              [5.831111, 52.46333],
              [5.798333, 52.43055],
              [5.795278, 52.427498],
              [5.786666000000139, 52.423607],
              [5.763888, 52.415276],
            ],
          ],
          [
            [
              [5.423333, 52.636383],
              [5.44861, 52.61555],
              [5.457222, 52.607216000000108],
              [5.477221, 52.58416],
              [5.485555, 52.572777],
              [5.486111, 52.568886],
              [5.48527700000011, 52.565277],
              [5.46455, 52.560211],
              [5.447742, 52.53826],
              [5.447398, 52.51305],
              [5.439482, 52.508396000000118],
              [5.42691, 52.501411],
              [5.409215, 52.495358000000124],
              [5.377765, 52.488522000000103],
              [5.304445000000101, 52.457642],
              [5.190362, 52.41527],
              [5.180584000000124, 52.409214000000134],
              [5.174065, 52.404556],
              [5.168076, 52.397217000000126],
              [5.15777, 52.392914],
              [5.134019, 52.383137],
              [5.067196, 52.38626],
              [5.059339, 52.388771000000133],
              [5.054624, 52.39128],
              [5.051795, 52.394115],
              [5.050538, 52.39663],
              [5.052738, 52.400715],
              [5.08313, 52.415245],
              [5.093333, 52.436104],
              [5.095555, 52.436386],
              [5.10305, 52.44138],
              [5.105833000000132, 52.444443],
              [5.111388, 52.469994],
              [5.111666, 52.474159],
              [5.10743, 52.488533000000132],
              [5.104218, 52.497684],
              [5.100493, 52.505135000000109],
              [5.07162, 52.547043000000144],
              [5.048341000000107, 52.566135],
              [5.045547, 52.572655000000111],
              [5.03576900000013, 52.605247],
              [5.033441, 52.613167],
              [5.032509, 52.619217000000106],
              [5.033441, 52.6262],
              [5.03949, 52.633652],
              [5.046944, 52.636913],
              [5.05486, 52.638309],
              [5.101424, 52.63784],
              [5.1126000000001, 52.63226],
              [5.120516000000123, 52.6262],
              [5.126569, 52.619682],
              [5.13588, 52.61596],
              [5.142401, 52.61596],
              [5.149386, 52.616890000000126],
              [5.16382, 52.620617],
              [5.201072000000124, 52.633186],
              [5.22575, 52.642967],
              [5.23972, 52.650883],
              [5.247637, 52.656471],
              [5.25275900000014, 52.662056],
              [5.256949, 52.669041],
              [5.259278, 52.67696],
              [5.260675, 52.68301],
              [5.296389, 52.69111],
              [5.302221, 52.690552],
              [5.33, 52.68278],
              [5.378333000000111, 52.668327],
              [5.382222, 52.666107],
              [5.423333, 52.636383],
            ],
          ],
          [
            [
              [4.76472200000012, 52.990273000000116],
              [4.753611, 52.988609],
              [4.73861, 52.98972],
              [4.727777, 52.99305],
              [4.720555, 52.997772],
              [4.71583, 53.00388],
              [4.708333, 53.020554],
              [4.70667, 53.035828],
              [4.70805, 53.044441],
              [4.713888, 53.056107],
              [4.721666000000141, 53.06611],
              [4.743333, 53.0861],
              [4.853333, 53.181389000000138],
              [4.859722, 53.185829],
              [4.868889, 53.18833],
              [4.879167000000109, 53.186386],
              [4.883333, 53.184166],
              [4.885833000000105, 53.181664],
              [4.912222, 53.141937],
              [4.912222, 53.09861],
              [4.90889, 53.090553000000114],
              [4.90333, 53.08416],
              [4.876666000000114, 53.056938],
              [4.858611, 53.039162],
              [4.804722, 53.006943],
              [4.787499000000139, 52.998886],
              [4.76472200000012, 52.990273000000116],
            ],
          ],
          [
            [
              [4.957222000000115, 53.237778],
              [4.889722, 53.210831],
              [4.883055, 53.21194],
              [4.879999, 53.214439],
              [4.88111, 53.21916],
              [4.883333, 53.2225],
              [4.893055, 53.230827],
              [4.912222, 53.242493],
              [4.964722, 53.270828],
              [4.989444, 53.283333],
              [5.002222, 53.289162],
              [5.011666, 53.292496],
              [5.05472200000014, 53.304718],
              [5.07944, 53.310829],
              [5.09389, 53.309998],
              [5.099722, 53.308609],
              [5.104722, 53.306664],
              [5.106388, 53.30333],
              [5.103889, 53.29999],
              [4.957222000000115, 53.237778],
            ],
          ],
          [
            [
              [5.213055, 53.349998000000141],
              [5.20055, 53.349442000000124],
              [5.186666000000116, 53.349716],
              [5.174999, 53.35249],
              [5.16861, 53.357773],
              [5.16722, 53.361107],
              [5.166666000000134, 53.364998],
              [5.16889, 53.373886],
              [5.171111, 53.377495],
              [5.179999, 53.381104000000107],
              [5.218055, 53.39388300000013],
              [5.22805, 53.39666],
              [5.53972, 53.44944],
              [5.556666000000121, 53.451942000000145],
              [5.574721, 53.452774],
              [5.579721, 53.450829],
              [5.58194, 53.44778],
              [5.579721, 53.442497000000117],
              [5.577499000000103, 53.439163000000121],
              [5.574166, 53.436104000000114],
              [5.570555, 53.433609000000104],
              [5.56111, 53.430275000000108],
              [5.35333, 53.381104000000107],
              [5.311388, 53.371666],
              [5.213055, 53.349998000000141],
            ],
          ],
          [
            [
              [6.871666, 53.416107],
              [6.901667, 53.350273000000129],
              [6.939722, 53.324715],
              [6.945277, 53.321388],
              [7.078333, 53.26111],
              [7.088611000000128, 53.25694],
              [7.10111, 53.253883],
              [7.190277, 53.240273],
              [7.201111, 53.23972],
              [7.205277, 53.240829],
              [7.208364, 53.242805],
              [7.207222, 53.17610900000011],
              [7.211666, 53.015831],
              [7.210278, 53.001938],
              [7.200277, 52.970551],
              [7.197778, 52.965],
              [7.19333, 52.95722],
              [7.179722, 52.934166000000118],
              [7.133055, 52.888885],
              [7.091067000000123, 52.836906],
              [7.076944, 52.82444],
              [7.069722, 52.814995],
              [7.066944, 52.799164],
              [7.065555, 52.78583],
              [7.064722, 52.76861],
              [7.065277, 52.75222],
              [7.063611, 52.721382000000119],
              [7.058888, 52.663887],
              [7.055277, 52.651939],
              [7.051666, 52.643608],
              [7.048055, 52.63888500000013],
              [7.043333000000132, 52.634995000000117],
              [7.035832000000141, 52.632774],
              [7.030833, 52.632500000000107],
              [7.025, 52.632500000000107],
              [6.920278, 52.63888500000013],
              [6.916944, 52.640549000000135],
              [6.91305, 52.644997000000103],
              [6.905555000000106, 52.650551],
              [6.902222, 52.651939],
              [6.894722000000115, 52.653053],
              [6.78167, 52.654160000000104],
              [6.76805, 52.65222],
              [6.756666, 52.649162000000103],
              [6.720833, 52.62944],
              [6.718923000000132, 52.626785],
              [6.72611, 52.62111],
              [6.729444, 52.616104],
              [6.760833, 52.56721],
              [6.75944, 52.56472],
              [6.75611, 52.563332],
              [6.7225, 52.559441000000106],
              [6.690277, 52.551941],
              [6.688889, 52.549164000000133],
              [6.7025, 52.490555],
              [6.705555, 52.485832],
              [6.753333000000111, 52.462776],
              [6.76444400000014, 52.45916],
              [6.94611, 52.434441],
              [6.950833, 52.434998000000121],
              [6.95417, 52.436386],
              [6.965833, 52.443054],
              [6.973888, 52.448608],
              [6.983889, 52.46],
              [6.987499, 52.4611],
              [6.99083, 52.459717],
              [7.058888, 52.398605],
              [7.061944, 52.39361],
              [7.065555, 52.385826],
              [7.071111, 52.358887],
              [7.069722, 52.352776000000119],
              [7.058114000000103, 52.337639],
              [7.038055, 52.31277],
              [7.032222, 52.298882000000106],
              [7.028889, 52.286942],
              [7.028055, 52.280273000000136],
              [7.028055, 52.276939],
              [7.031388, 52.268883],
              [7.053094, 52.23776],
              [7.042222, 52.23166700000013],
              [6.96472, 52.190277],
              [6.904166, 52.17305],
              [6.901111, 52.171387],
              [6.8775, 52.151382],
              [6.876111, 52.148605],
              [6.87472, 52.13916],
              [6.87194, 52.130272],
              [6.86861, 52.125549],
              [6.860555, 52.12028],
              [6.8525, 52.11833],
              [6.8425, 52.117775],
              [6.759428, 52.114563],
              [6.73639, 52.076660000000118],
              [6.728611, 52.035271],
              [6.794444, 52.010277],
              [6.80055, 52.00722],
              [6.826111, 51.98860900000011],
              [6.83, 51.97749],
              [6.8308320000001, 51.971382],
              [6.828888, 51.965553],
              [6.789166, 51.928055],
              [6.776944, 51.921387],
              [6.746388, 51.906105],
              [6.724444, 51.898048],
              [6.720555, 51.89777400000014],
              [6.701944, 51.90361],
              [6.69361, 51.908882000000119],
              [6.691667, 51.911110000000122],
              [6.685555, 51.914162],
              [6.67611, 51.91389],
              [6.594722000000104, 51.896111],
              [6.5275, 51.874443],
              [6.462777, 51.853607],
              [6.35111, 51.848053],
              [6.182221, 51.895271],
              [6.12361, 51.888054],
              [6.00305, 51.82999],
              [5.9625, 51.807777],
              [5.964722, 51.80555],
              [5.98139, 51.785271],
              [5.984722, 51.780548],
              [5.986666, 51.766937],
              [5.985833, 51.763885],
              [5.980833, 51.760277],
              [5.95205, 51.747528],
              [6.028889, 51.706665],
              [6.093055000000106, 51.607216000000108],
              [6.094166, 51.604439],
              [6.131389, 51.572495],
              [6.136666, 51.569160000000124],
              [6.15861, 51.558327000000133],
              [6.202222, 51.51694],
              [6.2075, 51.509995],
              [6.221944, 51.468887],
              [6.222221000000104, 51.46583],
              [6.222777, 51.364716],
              [6.222221000000104, 51.361664000000133],
              [6.143055, 51.295273000000122],
              [6.07889, 51.242493],
              [6.076388, 51.240273],
              [6.072222, 51.218048],
              [6.071666, 51.215],
              [6.071388, 51.211662],
              [6.074721, 51.189995000000124],
              [6.07667, 51.181107000000111],
              [6.079444000000137, 51.175827],
              [6.083611000000133, 51.17166],
              [6.090278, 51.168884],
              [6.0975, 51.131104],
              [6.00305, 51.08416],
              [5.910277, 51.062492],
              [5.906944000000124, 51.063889],
              [5.902499, 51.06305],
              [5.866944, 51.048050000000103],
              [5.86472, 51.046104],
              [5.864166, 51.04361],
              [5.869444000000101, 51.018883],
              [5.891666, 50.972771],
              [5.900277, 50.971939],
              [5.908055, 50.973885],
              [5.9325, 50.982216],
              [5.944722, 50.984993],
              [5.948889, 50.984993],
              [6.0175, 50.98027],
              [6.025555, 50.978333],
              [6.02833, 50.97666],
              [6.080277000000137, 50.915833],
              [6.081388, 50.913605000000132],
              [6.084722, 50.873604],
              [6.08417, 50.870552],
              [6.071666, 50.85416],
              [6.06778, 50.849716],
              [6.064722, 50.848328],
              [6.060833, 50.847496],
              [6.056389, 50.848328],
              [6.051666, 50.851944],
              [6.04611, 50.851944],
              [6.026111, 50.847771],
              [6.013888000000122, 50.84166],
              [6.013333, 50.838608],
              [6.008055000000127, 50.802216],
              [6.011798, 50.757271],
              [5.92639, 50.756104],
              [5.898918, 50.753883],
              [5.870555, 50.760826],
              [5.7975, 50.76944],
              [5.742499, 50.76028],
              [5.737222, 50.75944],
              [5.69861, 50.75777],
              [5.691911, 50.760559],
              [5.701388, 50.774437],
              [5.705560000000105, 50.781952000000103],
              [5.705, 50.78583],
              [5.701944, 50.805832000000123],
              [5.69394, 50.80881],
              [5.68361, 50.811386],
              [5.655555, 50.822495],
              [5.65167, 50.824715],
              [5.6408330000001, 50.839722],
              [5.638055000000122, 50.846664],
              [5.6375, 50.850273000000129],
              [5.638888000000122, 50.85889],
              [5.640555, 50.86305],
              [5.65, 50.87694],
              [5.657499, 50.88027],
              [5.758055, 50.959999],
              [5.764166000000102, 50.989998000000128],
              [5.776944, 51.025833],
              [5.818055, 51.114998],
              [5.84833, 51.139442000000145],
              [5.851388, 51.142220000000123],
              [5.855111, 51.148338],
              [5.855000000000132, 51.151108],
              [5.849171000000126, 51.15638],
              [5.834444, 51.165833],
              [5.754167, 51.189995000000124],
              [5.644722, 51.203606],
              [5.568334000000107, 51.22071],
              [5.557777, 51.26388500000013],
              [5.553333, 51.269722],
              [5.550278, 51.2725],
              [5.520833, 51.291107],
              [5.510833, 51.294441],
              [5.504444, 51.295273000000122],
              [5.497222, 51.296104000000128],
              [5.485833000000127, 51.294998000000135],
              [5.475555, 51.286942],
              [5.467777, 51.282776000000126],
              [5.411388, 51.266937],
              [5.406111, 51.266106],
              [5.4, 51.265549000000135],
              [5.32972100000012, 51.26221],
              [5.23897, 51.262283],
              [5.238889, 51.304718],
              [5.2375, 51.308327],
              [5.233611, 51.31055],
              [5.223332, 51.313889000000131],
              [5.201111000000139, 51.319717],
              [5.194444, 51.32],
              [5.189166, 51.31916],
              [5.168056, 51.314438000000109],
              [5.155, 51.315826],
              [5.143888, 51.318604],
              [5.14, 51.320831],
              [5.083055, 51.385826],
              [5.07861, 51.391663],
              [5.077222, 51.395271],
              [5.07667, 51.398888],
              [5.077777, 51.403328],
              [5.08, 51.406944000000124],
              [5.085833, 51.412773000000129],
              [5.08944, 51.415276000000119],
              [5.101110000000119, 51.42722],
              [5.103333, 51.43055],
              [5.104444000000115, 51.434998],
              [5.096110000000124, 51.44611],
              [5.08028, 51.466942],
              [5.073333000000105, 51.471664],
              [5.041389, 51.486664],
              [5.03555, 51.487221],
              [5.02361100000013, 51.48111],
              [5.016944, 51.47555],
              [5.01527700000014, 51.471664],
              [5.012777, 51.454163000000108],
              [5.00944, 51.446388],
              [5.0, 51.437775],
              [4.989444, 51.43055],
              [4.955555, 51.409996],
              [4.940277, 51.401382],
              [4.93611, 51.39944],
              [4.929999, 51.398605],
              [4.85305, 51.414444],
              [4.832777000000135, 51.429993],
              [4.844722000000104, 51.461388],
              [4.84611, 51.477493],
              [4.845555000000104, 51.48111],
              [4.825833, 51.492218],
              [4.80694, 51.499443],
              [4.788333, 51.503052],
              [4.781111, 51.50361],
              [4.769166, 51.502777],
              [4.757222, 51.496666],
              [4.705555, 51.469444],
              [4.69861, 51.464439],
              [4.67111, 51.44416],
              [4.668611, 51.440826],
              [4.670833, 51.433609],
              [4.673055, 51.430832],
              [4.67139, 51.42776],
              [4.650555, 51.423332],
              [4.644722, 51.423050000000103],
              [4.546944, 51.425827],
              [4.541944000000115, 51.42667],
              [4.53722, 51.432495],
              [4.535277, 51.43972],
              [4.535277, 51.443886000000134],
              [4.53805, 51.452499000000103],
              [4.543333, 51.458885],
              [4.544999, 51.462776],
              [4.549999, 51.474998],
              [4.55083, 51.47944],
              [4.549444, 51.482773000000122],
              [4.545555, 51.484993000000145],
              [4.53972, 51.48555],
              [4.486666000000127, 51.480827],
              [4.481944, 51.47944],
              [4.3975, 51.452774],
              [4.393888, 51.450272],
              [4.396667, 51.416939],
              [4.401388, 51.41083],
              [4.417777, 51.39833],
              [4.43639, 51.378883],
              [4.437778, 51.375275000000101],
              [4.431666, 51.364441],
              [4.428055, 51.361938],
              [4.418611000000112, 51.35916],
              [4.40722, 51.357773],
              [4.388055, 51.357498],
              [4.35889, 51.359993],
              [4.346944, 51.362495000000138],
              [4.279674000000114, 51.376595],
              [4.252368, 51.375145],
              [4.202499000000103, 51.405],
              [4.05611, 51.425827],
              [3.928889, 51.434998],
              [3.92778, 51.43055],
              [3.92555, 51.426941],
              [3.906666, 51.399994],
              [3.899722, 51.395],
              [3.82972, 51.389717],
              [3.823055, 51.39],
              [3.573055000000124, 51.444443],
              [3.543333000000132, 51.454437],
              [3.533611, 51.458054],
              [3.4525, 51.521111],
              [3.443055, 51.528885],
              [3.440555, 51.531662],
              [3.440833, 51.535828],
              [3.446389, 51.541939],
              [3.45333, 51.54694],
              [3.465, 51.553329000000133],
              [3.485555, 51.563332],
              [3.510833000000105, 51.57444],
              [3.523889, 51.579994],
              [3.555277, 51.592216],
              [3.568889, 51.597221],
              [3.580277000000137, 51.59861],
              [3.6919, 51.6003070000001],
              [3.832778, 51.606667],
              [3.837222, 51.606667],
              [3.868889, 51.601387000000102],
              [3.872777, 51.59916],
              [3.89333, 51.584442000000138],
              [3.898056, 51.578606],
              [3.903611, 51.568886],
              [3.902778, 51.565277],
              [3.899167, 51.562775000000101],
              [3.865278, 51.54666],
              [3.843534, 51.554028],
              [3.820555, 51.549164000000133],
              [3.865850000000137, 51.538662],
              [3.886337, 51.54304900000011],
              [3.921389, 51.549164000000133],
              [3.92861, 51.548332],
              [3.93444, 51.54694],
              [4.006666, 51.525276],
              [4.040277000000117, 51.51277],
              [4.055833, 51.50555],
              [4.067499, 51.494995000000131],
              [4.06917, 51.491661000000136],
              [4.081944, 51.46916],
              [4.095833000000141, 51.45138500000013],
              [4.111111, 51.443604],
              [4.125555, 51.438332000000116],
              [4.145833, 51.43583],
              [4.152222, 51.435555],
              [4.23805, 51.43471],
              [4.243333, 51.435555],
              [4.252777, 51.438606],
              [4.26428, 51.44397],
              [4.277222000000108, 51.445274],
              [4.281944, 51.446663],
              [4.28611, 51.448608],
              [4.289166000000137, 51.451660000000118],
              [4.291389, 51.454994000000113],
              [4.293611, 51.46833],
              [4.292222, 51.47583],
              [4.290833, 51.47916],
              [4.284721, 51.48832700000014],
              [4.266944, 51.508331],
              [4.262777, 51.510551],
              [4.22963, 51.518616],
              [4.215278000000126, 51.516388],
              [4.203888, 51.514999],
              [4.082777, 51.53083],
              [3.995555000000138, 51.579437],
              [3.99, 51.584717],
              [3.990833, 51.588333],
              [3.994166000000121, 51.590828],
              [4.003055, 51.594444000000124],
              [4.041944, 51.60527],
              [4.062222, 51.610275000000115],
              [4.0791660000001, 51.612495],
              [4.169722, 51.605553],
              [4.19028, 51.60083],
              [4.195833000000107, 51.59916],
              [4.20751, 51.589478],
              [4.208611, 51.59],
              [4.209444, 51.594444000000124],
              [4.20583, 51.60083],
              [4.20111, 51.606667],
              [4.196388, 51.612495],
              [4.186167, 51.617043],
              [4.16583, 51.615273000000116],
              [4.153889000000106, 51.614441],
              [4.13972, 51.614998],
              [4.13472, 51.616104000000121],
              [4.113333, 51.630272],
              [4.110555, 51.63694],
              [4.10614, 51.650978],
              [4.10305, 51.647774],
              [4.09611, 51.642776],
              [4.088611, 51.638329000000113],
              [4.076111, 51.632500000000107],
              [4.066388000000131, 51.629715],
              [4.019722, 51.619720000000143],
              [4.008888, 51.617775],
              [3.98, 51.614716],
              [3.9675, 51.614441],
              [3.903889, 51.63361],
              [3.899167, 51.635277],
              [3.761944000000142, 51.674995],
              [3.71266, 51.674675],
              [3.704444, 51.676941000000113],
              [3.696389, 51.681389],
              [3.687778, 51.689438000000109],
              [3.68611, 51.692772000000105],
              [3.685555000000136, 51.69639],
              [3.687500000000114, 51.709717],
              [3.689167, 51.713608000000136],
              [3.693611, 51.720833],
              [3.7033330000001, 51.728607],
              [3.71417, 51.733887],
              [3.723611000000119, 51.73666],
              [3.777778, 51.746109],
              [3.783889000000102, 51.746666000000118],
              [3.8125, 51.74472],
              [3.82486, 51.74229],
              [3.87861, 51.743889],
              [3.885278, 51.743889],
              [3.95583, 51.735832],
              [3.968611, 51.733604000000128],
              [3.975833, 51.728882],
              [4.004444, 51.71],
              [4.06694, 51.679443],
              [4.104166, 51.661942],
              [4.112778000000105, 51.67083],
              [4.11611, 51.67333200000013],
              [4.124444, 51.67722],
              [4.155833, 51.68388],
              [4.167754000000116, 51.68557],
              [4.127222, 51.706665],
              [4.059722000000136, 51.751389000000131],
              [4.056666, 51.758049000000142],
              [4.03083, 51.78666],
              [4.027778000000126, 51.78916],
              [4.019722, 51.793610000000115],
              [4.005278, 51.798882],
              [3.993055, 51.801384],
              [3.980556, 51.802773000000116],
              [3.95583, 51.801666],
              [3.874189, 51.78637],
              [3.866111, 51.80722],
              [3.865278, 51.810829],
              [3.865555, 51.814995],
              [3.867777, 51.818604000000107],
              [3.880833000000109, 51.823883],
              [3.98333, 51.846382],
              [3.995, 51.847771],
              [4.006666, 51.846664],
              [4.015555, 51.842773],
              [4.0275, 51.836105],
              [4.06111, 51.860275],
              [4.01667, 51.9675],
              [4.011944, 51.977776000000119],
              [4.012221, 51.981667],
              [4.014999000000103, 51.984718],
              [4.021111, 51.988052],
              [4.0388880000001, 51.987495000000138],
              [4.044444000000112, 51.986107],
              [4.05917, 51.984718],
              [4.08, 51.983887],
              [4.09944, 51.98416],
              [4.111111, 51.98555],
              [4.125555, 51.989716],
              [4.138055, 51.995827000000133],
              [4.149444, 52.002495],
              [4.362222, 52.17166],
              [4.36861, 52.177216],
              [4.4, 52.205826],
              [4.408889, 52.214722],
              [4.420555, 52.226662],
              [4.428888, 52.236107],
              [4.44167, 52.252495],
              [4.49449, 52.327217000000132],
              [4.517777000000137, 52.360832],
              [4.53889, 52.39222],
              [4.542777000000115, 52.399719],
              [4.55111, 52.419716000000108],
              [4.568055000000129, 52.449165000000107],
              [4.576944, 52.458054],
              [4.584431, 52.461502],
              [4.657958, 52.453125],
              [4.706849, 52.427227],
              [4.845252, 52.410198],
              [4.88598, 52.390373],
              [4.90688, 52.37416],
              [4.952402, 52.373123],
              [4.991944000000103, 52.361107],
              [5.126944, 52.330276],
              [5.23667, 52.312492],
              [5.249166, 52.311943],
              [5.254722, 52.310555000000136],
              [5.289444, 52.301666],
              [5.298611, 52.297775],
              [5.3025, 52.29583],
              [5.330442000000119, 52.275826000000109],
              [5.337777, 52.275551],
              [5.36389, 52.271111],
              [5.375278, 52.26916],
              [5.383888, 52.264999],
              [5.4075, 52.25194],
              [5.4175, 52.249161],
              [5.424444, 52.2486],
              [5.43055500000014, 52.249161],
              [5.523889000000111, 52.264160000000118],
              [5.53361, 52.26722],
              [5.54417, 52.274162],
              [5.55305, 52.283333],
              [5.562499000000116, 52.297493000000145],
              [5.570000000000107, 52.313049],
              [5.57778, 52.32278],
              [5.585, 52.327774],
              [5.624722, 52.354164],
              [5.62944, 52.356384],
              [5.67055, 52.371384],
              [5.687485, 52.377464],
              [5.702777, 52.382774],
              [5.722221, 52.388329],
              [5.73249, 52.390091],
              [5.734459, 52.390625],
              [5.743055, 52.393051],
              [5.756389, 52.398048],
              [5.76667, 52.401901000000123],
              [5.774166, 52.405273],
              [5.810262, 52.426094],
              [5.81478, 52.429115],
              [5.819638000000111, 52.432556],
              [5.849999, 52.46139],
              [5.8525, 52.46472],
              [5.878055, 52.50944],
              [5.872415000000103, 52.523415],
              [5.8475, 52.568054],
              [5.84861, 52.587494],
              [5.855000000000132, 52.606911],
              [5.758888, 52.60667],
              [5.678888, 52.607216000000108],
              [5.664721, 52.60833],
              [5.601944000000117, 52.65583],
              [5.599444, 52.658607000000131],
              [5.598888, 52.662498],
              [5.595277, 52.740829000000133],
              [5.59722, 52.753609],
              [5.599166000000139, 52.757774],
              [5.619166, 52.779442],
              [5.659166000000141, 52.818329],
              [5.668611, 52.82638500000013],
              [5.676944000000105, 52.830551],
              [5.71835, 52.83802],
              [5.714444000000128, 52.840271],
              [5.651388, 52.85527],
              [5.645833, 52.85555],
              [5.595, 52.848328],
              [5.588888, 52.842216],
              [5.586666, 52.83861],
              [5.583611, 52.836105],
              [5.574721, 52.83194],
              [5.563333, 52.830826],
              [5.418611000000112, 52.851662],
              [5.412499, 52.85305],
              [5.39805, 52.858604000000128],
              [5.374166000000116, 52.872215],
              [5.36861, 52.877777],
              [5.363333000000125, 52.887215],
              [5.365833, 52.89111],
              [5.371944, 52.89666],
              [5.393611000000135, 52.906387000000109],
              [5.403889, 52.908882000000119],
              [5.412777, 52.912773],
              [5.41361, 52.91722],
              [5.418611000000112, 52.94944],
              [5.42055, 52.964439],
              [5.411388, 53.028885],
              [5.407777, 53.035],
              [5.375555, 53.070549],
              [5.364166000000125, 53.07027],
              [5.339167, 53.065552],
              [5.303055, 53.052773],
              [5.289444, 53.047218],
              [5.263055000000122, 53.035271],
              [5.19831, 52.995316],
              [5.100277000000119, 52.948051],
              [5.09167, 52.885826],
              [5.126111, 52.822495000000117],
              [5.193055, 52.754440000000102],
              [5.197222, 52.756386],
              [5.202222, 52.7575],
              [5.21611, 52.7575],
              [5.230833, 52.756104000000107],
              [5.27833, 52.750832],
              [5.286111000000119, 52.746109],
              [5.29055, 52.740829000000133],
              [5.292500000000132, 52.737778000000105],
              [5.29555, 52.73111],
              [5.304166, 52.706940000000145],
              [5.302221, 52.702774],
              [5.255305000000135, 52.691589],
              [5.24167, 52.660553],
              [5.230277, 52.65361],
              [5.196666, 52.637772],
              [5.167777, 52.62888],
              [5.147222, 52.623886],
              [5.141944000000137, 52.622772],
              [5.135, 52.622772],
              [5.133055, 52.626106],
              [5.106388, 52.64222],
              [5.101388, 52.64416],
              [5.055833, 52.64278],
              [5.05, 52.641937],
              [5.040833, 52.63861],
              [5.033333, 52.634163],
              [5.028889, 52.626663000000121],
              [5.028055000000109, 52.619720000000143],
              [5.02861, 52.615829],
              [5.0425, 52.573883],
              [5.047777, 52.564163],
              [5.067778, 52.541382],
              [5.087222, 52.517776],
              [5.091944, 52.5075],
              [5.092777, 52.50027],
              [5.090278, 52.433327],
              [5.078055, 52.416107],
              [5.046369, 52.40263],
              [5.028333, 52.375832],
              [5.0225, 52.375275000000101],
              [5.016388, 52.375832],
              [4.92139, 52.386108],
              [4.908333000000141, 52.388329],
              [4.875527, 52.415604],
              [4.82579, 52.425697],
              [4.71315600000014, 52.441013],
              [4.66846, 52.465885],
              [4.58, 52.471664],
              [4.579444, 52.475555],
              [4.588611, 52.489441000000113],
              [4.598332, 52.513885],
              [4.62222, 52.596664],
              [4.631944, 52.634163],
              [4.63611, 52.65222],
              [4.63583, 52.68055],
              [4.654166, 52.751663],
              [4.73, 52.948051],
              [4.734166, 52.955551],
              [4.74139, 52.960548],
              [4.749722000000133, 52.962494],
              [4.773889, 52.964722],
              [4.793056, 52.965271000000143],
              [4.796111, 52.964439],
              [4.809444, 52.953606],
              [4.809999, 52.942497],
              [4.8075, 52.939163],
              [4.805833000000121, 52.934998],
              [4.80694, 52.927498000000128],
              [4.808611, 52.924164000000133],
              [4.813333, 52.91833],
              [4.82639, 52.911942],
              [4.83611100000013, 52.90833],
              [4.8625, 52.89999],
              [4.872499000000118, 52.897217],
              [4.8875, 52.896111],
              [4.90472, 52.898048],
              [4.9325, 52.902496],
              [4.943055000000129, 52.905],
              [5.085833, 52.955276],
              [5.10305, 52.963051],
              [5.180277000000103, 53.003052000000139],
              [5.184206000000131, 53.005531],
              [5.224444, 53.032494],
              [5.24667, 53.046944],
              [5.254722, 53.051384],
              [5.301666, 53.07278],
              [5.32722200000012, 53.07944],
              [5.360833, 53.084442],
              [5.37861, 53.09166],
              [5.38611, 53.096664],
              [5.38861, 53.1],
              [5.4025, 53.121384],
              [5.411111, 53.14027],
              [5.416944, 53.163055],
              [5.415, 53.169998],
              [5.415277000000117, 53.174164],
              [5.442499, 53.21194],
              [5.458611, 53.226105],
              [5.46611, 53.230827],
              [5.573333, 53.288055],
              [5.58611100000013, 53.294716],
              [5.599166000000139, 53.30028],
              [5.890833, 53.38222],
              [5.98166700000013, 53.398888],
              [6.0925, 53.410828],
              [6.1725, 53.413605],
              [6.183332, 53.413887],
              [6.187288, 53.41243],
              [6.19472, 53.41],
              [6.29694400000011, 53.401939],
              [6.4525, 53.425278],
              [6.6975, 53.461937],
              [6.72111, 53.464722000000108],
              [6.741944000000103, 53.46583],
              [6.7775, 53.45916],
              [6.855000000000132, 53.439438000000109],
              [6.862778000000105, 53.437218],
              [6.869166, 53.43388],
              [6.87139, 53.431938],
              [6.870832, 53.42222],
              [6.871666, 53.416107],
            ],
          ],
          [
            [
              [5.699166, 53.462776],
              [5.720555, 53.461662],
              [5.804999, 53.463882],
              [5.854722, 53.466942000000131],
              [5.905, 53.469719],
              [5.937222000000133, 53.470551000000114],
              [5.951388, 53.468887000000109],
              [5.955555, 53.46666],
              [5.95611, 53.462776],
              [5.948055000000124, 53.458611],
              [5.81139, 53.438889],
              [5.798333, 53.438606],
              [5.77722, 53.440552],
              [5.771388, 53.442215],
              [5.74861, 53.44416],
              [5.737222, 53.442497000000117],
              [5.683888, 53.425278],
              [5.662499, 53.426384],
              [5.65, 53.429161000000136],
              [5.637777, 53.435829000000126],
              [5.633055000000127, 53.441666],
              [5.6325, 53.445549],
              [5.633333, 53.448051],
              [5.65361, 53.469719],
              [5.657499, 53.472221000000104],
              [5.663055, 53.473053],
              [5.668888, 53.471664],
              [5.674444, 53.466385],
              [5.699166, 53.462776],
            ],
          ],
          [
            [
              [6.134999000000107, 53.45361],
              [6.13028, 53.45361],
              [6.126389, 53.458328],
              [6.11639, 53.471939],
              [6.117222, 53.474998],
              [6.119444, 53.477219000000105],
              [6.13611, 53.491386],
              [6.144722, 53.496384],
              [6.148889, 53.497498],
              [6.158055, 53.49916],
              [6.303333, 53.511383000000137],
              [6.314722, 53.511108],
              [6.3325, 53.508049000000142],
              [6.339444, 53.504997],
              [6.34111, 53.502777],
              [6.34028, 53.50027],
              [6.3375, 53.498604],
              [6.272499, 53.484444],
              [6.234722, 53.47639],
              [6.225555, 53.474998],
              [6.16305, 53.471664],
              [6.15278, 53.467216],
              [6.134999000000107, 53.45361],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "NO",
        ISO2: "NO",
        ISO3: "NOR",
        UN: 578,
        NAME: "Norway",
        AREA: 30625,
        POP2005: 4638836,
        REGION: 150,
        SUBREGION: 154,
        LON: 8.74,
        LAT: 61.152,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [8.74361, 58.409721],
              [8.731943, 58.409721],
              [8.726944000000117, 58.41277],
              [8.730276000000117, 58.424164000000133],
              [8.733889, 58.429718],
              [8.737499, 58.434998],
              [8.74444, 58.438049],
              [8.7525, 58.439163],
              [8.761389000000122, 58.436661000000129],
              [8.761389000000122, 58.421387],
              [8.75778, 58.416107000000125],
              [8.751944, 58.412216],
              [8.74361, 58.409721],
            ],
          ],
          [
            [
              [5.778333, 58.947495],
              [5.772778, 58.945],
              [5.760833, 58.945831],
              [5.757222, 58.950829],
              [5.754999000000112, 58.956383],
              [5.763333000000102, 58.958885000000123],
              [5.769722, 58.9566650000001],
              [5.776111, 58.953049],
              [5.778333, 58.947495],
            ],
          ],
          [
            [
              [5.961944, 58.972221],
              [5.95361, 58.969719],
              [5.94444, 58.970551000000114],
              [5.945000000000107, 58.97749],
              [5.948055000000124, 58.982773],
              [5.958888, 58.983887],
              [5.96, 58.98194],
              [5.961944, 58.972221],
            ],
          ],
          [
            [
              [5.72639, 59.078049000000135],
              [5.715555, 59.076942],
              [5.69444, 59.079994000000113],
              [5.553333, 59.126389000000131],
              [5.548333, 59.130554000000132],
              [5.565277, 59.14277600000014],
              [5.688889, 59.129166],
              [5.7125, 59.12028],
              [5.725277, 59.113052],
              [5.736111, 59.098328],
              [5.73833, 59.09277],
              [5.737778, 59.085831],
              [5.73333, 59.08138300000013],
              [5.72639, 59.078049000000135],
            ],
          ],
          [
            [
              [5.952777, 59.228333],
              [5.928333, 59.22749],
              [5.905833, 59.229996],
              [5.900833, 59.234444],
              [5.907222, 59.245277],
              [5.90333, 59.263054000000125],
              [5.905277, 59.26944],
              [5.909721, 59.274162000000103],
              [5.94278, 59.284439],
              [5.961944, 59.28805],
              [5.983889, 59.290276],
              [6.006944, 59.29166],
              [6.0175, 59.289993],
              [6.02667, 59.287773],
              [6.037222, 59.283333],
              [6.042222, 59.279160000000104],
              [6.048611, 59.275551000000121],
              [6.05222, 59.270554],
              [6.056944000000101, 59.26638800000012],
              [6.059166000000118, 59.26083],
              [6.058611, 59.255272],
              [6.053055, 59.251389],
              [6.045833, 59.248055],
              [5.994721, 59.233604],
              [5.985277, 59.231667],
              [5.952777, 59.228333],
            ],
          ],
          [
            [
              [5.287777000000119, 59.218887],
              [5.259999, 59.14777400000014],
              [5.251944, 59.14666],
              [5.233333, 59.151108000000136],
              [5.222777000000121, 59.151108000000136],
              [5.190277, 59.14777400000014],
              [5.160555, 59.14277600000014],
              [5.155277, 59.146942],
              [5.13333, 59.20166],
              [5.13111, 59.20722],
              [5.13194, 59.22083],
              [5.1375, 59.263329000000113],
              [5.13917, 59.269722],
              [5.17805, 59.407776],
              [5.183611, 59.411942000000124],
              [5.194444, 59.413055],
              [5.205277, 59.409439000000134],
              [5.211666, 59.40583],
              [5.221944000000121, 59.397499],
              [5.28555, 59.321388000000127],
              [5.287777000000119, 59.315826],
              [5.29306, 59.25722],
              [5.293611, 59.24416],
              [5.29306, 59.23722],
              [5.287777000000119, 59.218887],
            ],
          ],
          [
            [
              [5.26333, 59.798607],
              [5.314444, 59.749443],
              [5.321944, 59.739716000000101],
              [5.345277, 59.704163],
              [5.340833, 59.69944],
              [5.311388, 59.686943],
              [5.294444, 59.681664000000126],
              [5.285, 59.679718],
              [5.273889, 59.678604],
              [5.268611, 59.68278],
              [5.273055, 59.686104000000114],
              [5.28, 59.689438000000109],
              [5.286944000000119, 59.69138],
              [5.30944, 59.700554],
              [5.29611100000011, 59.74083],
              [5.293611, 59.746384],
              [5.288610000000119, 59.750549],
              [5.224444, 59.752495000000124],
              [5.214722000000108, 59.750549],
              [5.192222, 59.741386],
              [5.186666000000116, 59.737221],
              [5.184722, 59.73111],
              [5.17222, 59.68805],
              [5.182037, 59.670364],
              [5.195277, 59.664162],
              [5.200277, 59.63721],
              [5.201111000000139, 59.631104000000107],
              [5.20139, 59.613884],
              [5.199444, 59.607773],
              [5.193889, 59.603607000000125],
              [5.1825, 59.595551],
              [5.169722, 59.588333],
              [5.155555000000106, 59.5816650000001],
              [5.148889000000111, 59.58111],
              [5.111666, 59.636665000000107],
              [5.07, 59.773605],
              [5.069166000000109, 59.78],
              [5.070833, 59.78611],
              [5.107499000000132, 59.86444],
              [5.110555, 59.869995000000131],
              [5.11889, 59.872498000000121],
              [5.131389, 59.873055],
              [5.143611, 59.87221],
              [5.151667, 59.868607],
              [5.258055000000127, 59.802773000000116],
              [5.26333, 59.798607],
            ],
          ],
          [
            [
              [5.413055, 59.751663],
              [5.400555, 59.751389000000131],
              [5.376111, 59.751663],
              [5.366666, 59.753883],
              [5.358611, 59.756943],
              [5.314166, 59.783882],
              [5.30889, 59.788055],
              [5.305277, 59.793053],
              [5.263611, 59.881104],
              [5.251666000000114, 59.90888],
              [5.273333, 59.961388],
              [5.276388, 59.966942],
              [5.28361, 59.970276],
              [5.291944000000115, 59.972771],
              [5.330555, 59.972221],
              [5.339999, 59.96999],
              [5.411944, 59.940277],
              [5.425278, 59.933327],
              [5.43694, 59.925552],
              [5.442222, 59.921104000000128],
              [5.464722, 59.89194],
              [5.468333, 59.886383],
              [5.484166, 59.86055],
              [5.490277000000106, 59.849998],
              [5.492499000000123, 59.844444],
              [5.493333, 59.83833],
              [5.494721, 59.81916],
              [5.495, 59.805832],
              [5.492777, 59.794167],
              [5.488333, 59.789444],
              [5.469166, 59.771385],
              [5.432221000000141, 59.755554000000132],
              [5.423888, 59.753052],
              [5.413055, 59.751663],
            ],
          ],
          [
            [
              [5.525, 59.893326],
              [5.512777000000142, 59.893051],
              [5.503333, 59.895271],
              [5.36139, 59.98194100000012],
              [5.357778, 59.986938],
              [5.360833, 59.992218],
              [5.445833, 60.040833000000134],
              [5.452777, 60.04416700000013],
              [5.50611, 60.05555],
              [5.525833, 60.059441],
              [5.645555, 60.07471],
              [5.658055, 60.075272],
              [5.660832000000141, 60.058052],
              [5.66361, 60.026382000000126],
              [5.663888, 60.013054000000125],
              [5.66278, 59.99944],
              [5.659721, 59.99389],
              [5.595, 59.927216000000101],
              [5.53361, 59.896111],
              [5.525, 59.893326],
            ],
          ],
          [
            [
              [5.268055, 60.004997],
              [5.259722, 60.002495],
              [5.199721, 60.013054000000125],
              [5.191667, 60.015831],
              [5.171944, 60.026665],
              [5.168056, 60.031387],
              [5.165555, 60.036942],
              [5.156388000000106, 60.063332000000116],
              [5.168333, 60.116943],
              [5.172777, 60.12167],
              [5.21833, 60.099998],
              [5.223611, 60.095833],
              [5.259722, 60.060829000000126],
              [5.27111, 60.046104],
              [5.27194, 60.039993],
              [5.268055, 60.004997],
            ],
          ],
          [
            [
              [5.954721, 60.089439],
              [5.931389000000138, 60.07471],
              [5.927777, 60.07972],
              [5.911388000000102, 60.111938000000123],
              [5.909721, 60.124161],
              [5.915, 60.135826],
              [5.924166, 60.14527],
              [5.929999, 60.149162],
              [5.937222000000133, 60.1525],
              [5.95417, 60.157776],
              [5.978055, 60.160553],
              [5.990555, 60.16083],
              [5.99861, 60.158051],
              [6.016944, 60.146660000000111],
              [6.020555, 60.141663],
              [6.025, 60.130554000000132],
              [6.024444, 60.123604000000114],
              [6.022499, 60.117493],
              [6.017777, 60.112778],
              [6.00611, 60.10472],
              [5.99889, 60.101662],
              [5.990277, 60.098885000000109],
              [5.97055, 60.095276000000126],
              [5.961944, 60.092773000000136],
              [5.954721, 60.089439],
            ],
          ],
          [
            [
              [5.216944000000126, 60.241943],
              [5.20583, 60.240829],
              [5.199166, 60.244438],
              [5.199721, 60.251106],
              [5.20555, 60.25527],
              [5.213888, 60.257774],
              [5.2263880000001, 60.258331000000112],
              [5.233333, 60.254715],
              [5.231388, 60.248604],
              [5.225555, 60.244438],
              [5.216944000000126, 60.241943],
            ],
          ],
          [
            [
              [5.111944, 60.185829],
              [5.103611000000114, 60.183327000000133],
              [4.995, 60.218048],
              [4.961389000000111, 60.23583200000013],
              [4.950833000000102, 60.244164000000126],
              [4.946944, 60.249161],
              [4.934722, 60.276665],
              [4.9325, 60.282219],
              [4.93139, 60.288605000000132],
              [4.9425, 60.427498],
              [4.967222, 60.44138],
              [4.97278, 60.440826],
              [5.072499, 60.34499],
              [5.085555, 60.33083],
              [5.08944, 60.32611],
              [5.09805, 60.309998],
              [5.099166, 60.303886],
              [5.101110000000119, 60.291382],
              [5.111388, 60.216110000000128],
              [5.112778000000105, 60.198326],
              [5.111944, 60.185829],
            ],
          ],
          [
            [
              [5.195277, 60.408882],
              [5.138611, 60.396111000000133],
              [5.111944, 60.41583],
              [5.02083, 60.492218],
              [5.000833, 60.531105],
              [5.086389, 60.513329],
              [5.156388000000106, 60.492218],
              [5.172777, 60.48638],
              [5.179444000000103, 60.482773000000122],
              [5.190000000000111, 60.474442],
              [5.199166, 60.465271],
              [5.201666, 60.459717],
              [5.208888, 60.42333],
              [5.206944000000135, 60.416939],
              [5.195277, 60.408882],
            ],
          ],
          [
            [
              [5.185277, 60.506104],
              [5.1725, 60.505829],
              [5.101666000000137, 60.533051000000114],
              [5.077222, 60.541664],
              [5.029722, 60.54666],
              [4.987222, 60.561104],
              [4.92805, 60.60055],
              [4.926944000000105, 60.60527],
              [5.010833, 60.60055],
              [5.021944, 60.59916],
              [5.103611000000114, 60.583328],
              [5.113333, 60.58111],
              [5.121666, 60.578049],
              [5.16361, 60.557495],
              [5.183888, 60.54694400000011],
              [5.189166, 60.54277],
              [5.19694, 60.532776],
              [5.199166, 60.527222000000108],
              [5.198333, 60.51361],
              [5.193889, 60.508888000000127],
              [5.185277, 60.506104],
            ],
          ],
          [
            [
              [5.549999, 60.431389000000138],
              [5.527499, 60.42916],
              [5.515, 60.429993],
              [5.50528, 60.432220000000143],
              [5.48361100000011, 60.442215],
              [5.464999, 60.453606],
              [5.453055, 60.461388],
              [5.36, 60.523888000000113],
              [5.39583, 60.552216],
              [5.45361, 60.575829],
              [5.530277, 60.60527],
              [5.55611, 60.61305],
              [5.563333, 60.61639],
              [5.581388, 60.628326],
              [5.584444, 60.633888],
              [5.58833, 60.646111],
              [5.590833, 60.659164],
              [5.589167, 60.671661],
              [5.58972, 60.678604],
              [5.592777000000126, 60.683884],
              [5.608611, 60.688606],
              [5.618889, 60.690277],
              [5.629999, 60.688889000000131],
              [5.675833, 60.683052],
              [5.682500000000118, 60.679443],
              [5.689166, 60.674438000000123],
              [5.69361, 60.643326],
              [5.681666, 60.47277],
              [5.67722, 60.468048],
              [5.606111000000112, 60.437218000000144],
              [5.549999, 60.431389000000138],
            ],
          ],
          [
            [
              [5.158333, 60.581665],
              [5.159166, 60.576942],
              [5.148055, 60.577217],
              [5.072222, 60.595551],
              [5.062499, 60.59833],
              [5.007777, 60.619995],
              [4.994166000000121, 60.626938],
              [4.916944000000115, 60.671661],
              [4.906111000000124, 60.679993],
              [4.876944, 60.7066650000001],
              [4.854444, 60.732498],
              [4.860277, 60.736382000000106],
              [4.871666000000118, 60.734993],
              [4.951111, 60.721382000000119],
              [4.98, 60.714722000000108],
              [4.986944000000108, 60.7111],
              [5.129722000000129, 60.615829],
              [5.140277, 60.60694100000012],
              [5.15583, 60.587219],
              [5.158333, 60.581665],
            ],
          ],
          [
            [
              [4.696388, 60.98722],
              [4.686388000000136, 60.986664],
              [4.64157, 61.0],
              [4.630833, 61.00666],
              [4.622777, 61.01638800000012],
              [4.62, 61.021942],
              [4.621666, 61.053604],
              [4.62361, 61.05971],
              [4.62805, 61.064438000000109],
              [4.635278, 61.067772000000105],
              [4.652778, 61.073051],
              [4.662499, 61.07222],
              [4.669444, 61.068886],
              [4.676389, 61.062492],
              [4.718221, 61.0],
              [4.719722, 60.996666],
              [4.714999, 60.991943],
              [4.696388, 60.98722],
            ],
          ],
          [
            [
              [4.986388, 61.104439000000127],
              [4.98, 61.093605],
              [4.968055, 61.085548],
              [4.95361, 61.078888],
              [4.91, 61.065552],
              [4.876944, 61.08527400000014],
              [4.873055000000136, 61.090271],
              [4.867499000000123, 61.094444],
              [4.856111, 61.094719],
              [4.84889, 61.091385],
              [4.817778, 61.071663],
              [4.81472, 61.06611],
              [4.804722, 61.044441],
              [4.799444000000108, 61.048607000000118],
              [4.795278, 61.053329],
              [4.794444000000112, 61.05971],
              [4.78805, 61.146385],
              [4.791111, 61.151939],
              [4.849999, 61.179993000000138],
              [4.927777000000106, 61.189995],
              [4.938889, 61.18833],
              [4.94583, 61.184998],
              [4.959722, 61.176384],
              [4.962222000000111, 61.170830000000137],
              [4.985833, 61.11749],
              [4.986944000000108, 61.111382000000106],
              [4.986388, 61.104439000000127],
            ],
          ],
          [
            [
              [4.934166, 61.77416],
              [4.9225, 61.773048],
              [4.889722, 61.783607],
              [4.88111, 61.78666],
              [4.808055, 61.835831],
              [4.804166, 61.84055],
              [4.808888, 61.84555],
              [4.86805500000014, 61.88528],
              [4.883333, 61.89194],
              [4.914166000000137, 61.897774],
              [4.92611, 61.898888000000113],
              [4.937778, 61.897499],
              [4.949166, 61.895828],
              [5.202222, 61.85416],
              [5.221944000000121, 61.84555],
              [5.22305, 61.84055],
              [5.219722000000104, 61.835274],
              [5.174999, 61.82222],
              [4.996111, 61.785553000000107],
              [4.934166, 61.77416],
            ],
          ],
          [
            [
              [5.068055, 61.92305],
              [5.059166000000118, 61.92055],
              [5.029166, 61.973885],
              [5.009722, 62.01361],
              [5.099722, 62.01916],
              [5.108333, 62.017494000000113],
              [5.127222, 61.992493],
              [5.078888, 61.931938000000116],
              [5.074444, 61.927216],
              [5.068055, 61.92305],
            ],
          ],
          [
            [
              [5.647778, 62.187492],
              [5.609166, 62.185272],
              [5.551666000000125, 62.18583],
              [5.54, 62.187492],
              [5.531388000000106, 62.19028],
              [5.50555, 62.21916],
              [5.50611, 62.224442],
              [5.516944000000137, 62.246384],
              [5.543333, 62.277496],
              [5.54805, 62.282494],
              [5.565000000000111, 62.28833],
              [5.57694, 62.289444],
              [5.686944, 62.294167],
              [5.70167, 62.293884000000105],
              [5.808055, 62.273048],
              [5.809166, 62.268326],
              [5.797222, 62.219719],
              [5.793611000000112, 62.214165],
              [5.78889, 62.209442],
              [5.773333, 62.202774],
              [5.755278, 62.197777],
              [5.744721, 62.195831000000112],
              [5.698333, 62.190552000000139],
              [5.647778, 62.187492],
            ],
          ],
          [
            [
              [5.840555000000109, 62.239998],
              [5.827222, 62.239716],
              [5.85111, 62.274437],
              [5.851666000000137, 62.27861],
              [5.836944, 62.32777],
              [5.834444, 62.333328],
              [5.809444, 62.334442000000138],
              [5.800833, 62.337494],
              [5.799999, 62.343605000000139],
              [5.803055, 62.360832],
              [5.804999, 62.366943],
              [5.828055, 62.39138800000012],
              [5.842777, 62.405548],
              [5.849166, 62.409439],
              [5.86472, 62.416107],
              [5.892221, 62.423882],
              [5.913610000000119, 62.427498],
              [5.926944, 62.428055],
              [5.937222000000133, 62.426941000000113],
              [5.95778, 62.422493000000145],
              [5.971944000000121, 62.415276],
              [5.977500000000134, 62.411110000000122],
              [6.02667, 62.352776000000119],
              [6.023889, 62.327217],
              [5.942222000000129, 62.282219],
              [5.928333, 62.274719000000118],
              [5.900277, 62.26028],
              [5.870832, 62.246384],
              [5.861666000000127, 62.243889],
              [5.840555000000109, 62.239998],
            ],
          ],
          [
            [
              [6.253888, 62.391663000000108],
              [6.228333, 62.390274],
              [6.213611, 62.390549000000135],
              [6.148055, 62.390549000000135],
              [6.119721, 62.390549000000135],
              [6.096389000000102, 62.39388300000013],
              [6.0775, 62.399162000000103],
              [6.060277, 62.404999],
              [6.027222000000108, 62.43055],
              [6.023055000000113, 62.43555],
              [6.1775, 62.442497],
              [6.189166, 62.442215],
              [6.318055000000129, 62.419716],
              [6.32805500000012, 62.417496],
              [6.333611, 62.41333],
              [6.333055000000115, 62.40778],
              [6.326666000000102, 62.40361],
              [6.308332, 62.399994],
              [6.286944000000119, 62.396385],
              [6.253888, 62.391663000000108],
            ],
          ],
          [
            [
              [6.736666, 62.66722],
              [6.677777000000106, 62.65361],
              [6.667500000000132, 62.656105],
              [6.650277, 62.67499],
              [6.649722, 62.681389],
              [6.675278000000105, 62.719162],
              [6.679166, 62.724716],
              [6.685555, 62.728607000000125],
              [6.69361, 62.73194100000012],
              [6.705832, 62.732773],
              [6.875833, 62.743607000000111],
              [6.88917, 62.742493000000138],
              [6.896388000000115, 62.738884],
              [6.901667, 62.73444400000011],
              [6.91944, 62.709160000000111],
              [6.920278, 62.702774],
              [6.911388000000102, 62.694160000000124],
              [6.892777000000137, 62.689163],
              [6.860555, 62.683884],
              [6.790277000000117, 62.676109],
              [6.747222, 62.669167],
              [6.736666, 62.66722],
            ],
          ],
          [
            [
              [6.886389, 62.776939],
              [6.87278, 62.776665],
              [6.782777, 62.805275000000108],
              [6.775277000000131, 62.839996],
              [6.77583, 62.845551000000114],
              [6.785277000000121, 62.848053],
              [6.81111, 62.849442],
              [6.911388000000102, 62.852219000000105],
              [6.924999, 62.851105000000132],
              [6.933611, 62.848328],
              [6.940555, 62.844444],
              [6.944444, 62.839439],
              [6.94694, 62.82361],
              [6.897222, 62.778885000000116],
              [6.886389, 62.776939],
            ],
          ],
          [
            [
              [7.548333, 62.948326],
              [7.510278, 62.938606000000107],
              [7.48389, 62.95388800000012],
              [7.476944, 62.957497000000103],
              [7.468055000000106, 62.960548000000131],
              [7.457777, 62.963051000000121],
              [7.446111, 62.964722],
              [7.418888, 62.966942],
              [7.40861, 62.969444],
              [7.4, 62.9725],
              [7.37583, 62.982216000000108],
              [7.368610000000103, 62.98583200000013],
              [7.36472, 62.990829],
              [7.365555, 62.99638],
              [7.399166, 63.057495],
              [7.60444, 63.093048000000124],
              [7.65, 63.081108],
              [7.711944, 63.002495],
              [7.70833, 62.998329000000126],
              [7.700000000000102, 62.995277],
              [7.548333, 62.948326],
            ],
          ],
          [
            [
              [7.809722000000136, 63.023331],
              [7.778333, 63.017494000000113],
              [7.75944, 63.023048],
              [7.7075, 63.041382],
              [7.69028, 63.047493],
              [7.683332, 63.051109],
              [7.679444, 63.056107],
              [7.70833, 63.084160000000111],
              [7.71528, 63.088051],
              [7.72611, 63.089722],
              [7.82, 63.094162],
              [7.846110000000124, 63.095276],
              [7.898611, 63.09],
              [7.905555, 63.086388],
              [7.91528, 63.079163],
              [7.914166, 63.07361],
              [7.902222, 63.056664],
              [7.888611, 63.048882000000106],
              [7.838333, 63.03055],
              [7.809722000000136, 63.023331],
            ],
          ],
          [
            [
              [8.268610000000137, 63.158882],
              [8.2175, 63.156105000000139],
              [8.208887, 63.159164],
              [8.193609, 63.185272],
              [8.17833, 63.21139],
              [8.179443, 63.216942000000131],
              [8.184721, 63.221664],
              [8.193054000000132, 63.22472],
              [8.202776, 63.226944000000117],
              [8.21528, 63.22805000000011],
              [8.230276, 63.227493],
              [8.239166, 63.224442],
              [8.278055, 63.19472],
              [8.304722, 63.172775],
              [8.308332000000121, 63.16777],
              [8.309166, 63.16305],
              [8.268610000000137, 63.158882],
            ],
          ],
          [
            [
              [8.060276, 63.14166],
              [8.005278, 63.140831],
              [7.979166, 63.141106],
              [7.928333, 63.166382000000112],
              [7.92639, 63.171944],
              [7.931666000000121, 63.176666000000125],
              [7.938611, 63.18055],
              [8.04777700000011, 63.227776],
              [8.062777, 63.233604000000128],
              [8.07361, 63.235275],
              [8.086111, 63.236107000000118],
              [8.09833, 63.235832],
              [8.111944000000108, 63.234444],
              [8.122221, 63.232216],
              [8.14194300000014, 63.221664],
              [8.169443, 63.195000000000107],
              [8.17305, 63.190277],
              [8.185555000000136, 63.157776],
              [8.186388000000136, 63.153053],
              [8.176666, 63.150551000000121],
              [8.13611, 63.14666],
              [8.086666, 63.142776],
              [8.060276, 63.14166],
            ],
          ],
          [
            [
              [8.391109, 63.159164],
              [8.377222000000131, 63.159164],
              [8.363609, 63.160271],
              [8.355, 63.16333],
              [8.34805, 63.167221],
              [8.271666, 63.227219000000105],
              [8.26638800000012, 63.231667],
              [8.268610000000137, 63.260551],
              [8.269722000000115, 63.26611],
              [8.425278000000105, 63.284439],
              [8.437498, 63.283882000000119],
              [8.451387000000125, 63.276665],
              [8.55778, 63.214439],
              [8.572222, 63.200554],
              [8.576111, 63.18944],
              [8.574720000000127, 63.182495000000131],
              [8.567499, 63.176666000000125],
              [8.5525, 63.171104],
              [8.52361100000013, 63.163887000000102],
              [8.487778, 63.160271],
              [8.391109, 63.159164],
            ],
          ],
          [
            [
              [8.511944, 63.319160000000124],
              [8.498055, 63.319160000000124],
              [8.470833, 63.321388],
              [8.439722, 63.32888800000012],
              [8.43111, 63.33194],
              [8.435276000000101, 63.337219],
              [8.48499900000013, 63.37138],
              [8.491943, 63.375275],
              [8.508333000000107, 63.38166],
              [8.52916, 63.385551000000135],
              [8.541943000000117, 63.386383],
              [8.591944, 63.382500000000107],
              [8.615833000000123, 63.378609],
              [8.62472, 63.37555],
              [8.666943, 63.35611],
              [8.67222, 63.351662],
              [8.675833000000125, 63.346664],
              [8.67111, 63.337219],
              [8.66555, 63.3325],
              [8.646111000000133, 63.32777],
              [8.634998, 63.326111],
              [8.56278, 63.319160000000124],
              [8.511944, 63.319160000000124],
            ],
          ],
          [
            [
              [8.162222, 63.361382],
              [8.156944, 63.35666700000013],
              [8.131109, 63.34166],
              [8.093054, 63.327217],
              [8.083332, 63.324715],
              [7.985277, 63.308884],
              [7.995000000000118, 63.339722],
              [7.991388, 63.344444],
              [7.982778, 63.347496],
              [7.924166, 63.357216000000108],
              [7.877777, 63.35527],
              [7.803333000000123, 63.362778],
              [7.794167, 63.371941],
              [7.785, 63.381386000000134],
              [7.782777, 63.38694],
              [7.778333, 63.40583],
              [7.780555, 63.410553],
              [7.98805, 63.466942],
              [8.0158330000001, 63.4675],
              [8.076111, 63.467216],
              [8.09166, 63.46666],
              [8.09861, 63.463051],
              [8.17417, 63.401665],
              [8.179443, 63.397217],
              [8.183611, 63.386108],
              [8.162222, 63.361382],
            ],
          ],
          [
            [
              [8.494165, 63.428329],
              [8.455276, 63.426384],
              [8.42610900000011, 63.426941000000113],
              [8.412222, 63.428055],
              [8.29528, 63.438606],
              [8.282776, 63.44666],
              [8.280832, 63.452499],
              [8.279999, 63.464722],
              [8.285, 63.483330000000137],
              [8.287498, 63.489441],
              [8.291666000000134, 63.49472],
              [8.29722, 63.49944],
              [8.334721, 63.517494],
              [8.365276, 63.531387],
              [8.431944000000101, 63.556664000000126],
              [8.45167, 63.561386],
              [8.462776000000133, 63.56305],
              [8.48944, 63.564163000000121],
              [8.614443, 63.568329],
              [8.61472, 63.609161],
              [8.815277, 63.63916],
              [8.944721, 63.653885],
              [8.957222, 63.654716],
              [8.971109, 63.65361],
              [9.17639, 63.56472],
              [9.173332, 63.55861],
              [9.165, 63.55555],
              [9.089167, 63.528328],
              [9.051388, 63.518051],
              [8.961666, 63.497498],
              [8.931110000000103, 63.491104],
              [8.874998, 63.483330000000137],
              [8.786943, 63.476944],
              [8.774443, 63.476105],
              [8.718611, 63.475555],
              [8.70611, 63.474716000000114],
              [8.66, 63.468887],
              [8.604166, 63.46083],
              [8.57361, 63.45444],
              [8.548611, 63.445],
              [8.541666, 63.44111],
              [8.525, 63.434715],
              [8.505554, 63.429993],
              [8.494165, 63.428329],
            ],
          ],
          [
            [
              [8.808332, 63.810272],
              [8.8275, 63.728607000000125],
              [8.82778, 63.722496],
              [8.82667, 63.716942],
              [8.822777, 63.712776000000133],
              [8.816944, 63.708328],
              [8.803055, 63.70055],
              [8.79444, 63.697495],
              [8.774721000000113, 63.692772],
              [8.752222000000131, 63.689438],
              [8.656666, 63.679443000000106],
              [8.474165, 63.662216000000114],
              [8.460278, 63.66333],
              [8.45833, 63.668884],
              [8.453609000000142, 63.677498000000128],
              [8.36972, 63.67166],
              [8.35861, 63.669998],
              [8.339167, 63.66528],
              [8.31944, 63.660271],
              [8.306944, 63.66083],
              [8.275276, 63.674438],
              [8.269999, 63.678886],
              [8.273888, 63.684166000000118],
              [8.283888, 63.686661000000129],
              [8.325832, 63.694717],
              [8.34833, 63.698051],
              [8.361111, 63.698883],
              [8.40028, 63.700829],
              [8.454443, 63.705826000000116],
              [8.528889, 63.719444000000124],
              [8.53861, 63.721939000000134],
              [8.673887, 63.756943],
              [8.685276, 63.768051],
              [8.674166, 63.766388],
              [8.67333, 63.770828000000108],
              [8.67861, 63.773888],
              [8.729443000000117, 63.800278],
              [8.738054, 63.803329],
              [8.78666, 63.811104000000114],
              [8.79777700000011, 63.81277],
              [8.808332, 63.810272],
            ],
          ],
          [
            [
              [11.06278, 63.759720000000129],
              [11.034721, 63.743889000000138],
              [11.022221000000116, 63.744720000000143],
              [11.01722100000012, 63.749161],
              [11.014166000000102, 63.754166000000112],
              [11.014166000000102, 63.760277],
              [11.0175, 63.766388],
              [11.022221000000116, 63.77166],
              [11.028055, 63.776382000000126],
              [11.054722, 63.797775],
              [11.06472, 63.799995],
              [11.147499, 63.808609000000104],
              [11.207222000000115, 63.814163],
              [11.222776, 63.813332],
              [11.22778, 63.808884],
              [11.22944, 63.803055],
              [11.22472, 63.797775],
              [11.216389, 63.796387],
              [11.203609000000142, 63.795555],
              [11.148611, 63.790276],
              [11.113609, 63.77861],
              [11.07, 63.763611],
              [11.06278, 63.759720000000129],
            ],
          ],
          [
            [
              [11.453609, 64.51416],
              [11.41805, 64.47194],
              [11.407221000000106, 64.478043],
              [11.282776000000126, 64.509430000000123],
              [11.270555, 64.511383],
              [11.255833, 64.511658],
              [11.232498000000135, 64.50861],
              [11.211666, 64.50417],
              [11.19861, 64.503601000000117],
              [11.18611, 64.50417],
              [11.17555, 64.506943],
              [11.044443, 64.593887000000109],
              [11.03944, 64.598328],
              [11.037777, 64.60416],
              [11.03805, 64.616379],
              [11.03861, 64.628876],
              [11.043333, 64.634155],
              [11.07389, 64.649155000000121],
              [11.086943, 64.649994000000106],
              [11.25, 64.599442],
              [11.44889, 64.524994],
              [11.453888, 64.520554],
              [11.453609, 64.51416],
            ],
          ],
          [
            [
              [11.35139, 64.649994000000106],
              [11.343054, 64.622772],
              [11.339998, 64.618042000000116],
              [11.325277, 64.602219000000105],
              [11.318888, 64.596939],
              [11.310833, 64.596664],
              [11.31111, 64.602768],
              [11.307777, 64.608047],
              [11.262777, 64.63611],
              [11.253887, 64.639435],
              [11.233332, 64.634995],
              [11.22, 64.63443],
              [11.204166, 64.635269],
              [11.1775, 64.638611],
              [11.17610900000011, 64.64444],
              [11.193333, 64.669708],
              [11.197777, 64.673874000000126],
              [11.218611, 64.678329000000133],
              [11.254166, 64.682495],
              [11.27916, 64.684433000000126],
              [11.294998, 64.683609],
              [11.330555, 64.671936],
              [11.344166, 64.664154],
              [11.349443, 64.659714],
              [11.35139, 64.649994000000106],
            ],
          ],
          [
            [
              [11.261665, 64.88472],
              [11.221109, 64.85916],
              [11.21361, 64.85554500000012],
              [11.18611, 64.845825],
              [11.1408330000001, 64.8311],
              [11.128887, 64.82944],
              [11.06278, 64.84833],
              [10.951387, 64.86972],
              [10.906111, 64.85472],
              [10.895832, 64.85249],
              [10.839443, 64.843597],
              [10.824999, 64.844986],
              [10.82472, 64.849991000000102],
              [10.841389, 64.856659],
              [10.909443, 64.883041],
              [11.10611, 64.950272],
              [11.115833000000123, 64.94971],
              [11.26444400000014, 64.8936],
              [11.26583, 64.888046],
              [11.261665, 64.88472],
            ],
          ],
          [
            [
              [11.110832, 64.96582],
              [10.815554000000134, 64.863602],
              [10.763611, 64.85249],
              [10.73972, 64.84944],
              [10.731388, 64.860275000000115],
              [10.730276, 64.86722],
              [10.743889, 64.897766000000104],
              [10.747221, 64.903885000000116],
              [10.753332000000114, 64.90832],
              [10.777777000000128, 64.918884],
              [10.789444, 64.920547000000113],
              [10.798887, 64.91861],
              [10.866943, 64.92749],
              [10.970276, 64.950546000000145],
              [11.000277, 64.95776],
              [11.01667, 64.963333000000148],
              [11.024443, 64.967209],
              [11.026295, 64.973511],
              [11.023888, 64.98166],
              [11.029999, 64.9861],
              [11.04194, 64.987778],
              [11.054998000000126, 64.986938000000123],
              [11.092777000000126, 64.982208],
              [11.103611, 64.97943],
              [11.11055, 64.975555],
              [11.115833000000123, 64.9711],
              [11.110832, 64.96582],
            ],
          ],
          [
            [
              [11.636665000000107, 65.065277],
              [11.582222000000115, 65.039154],
              [11.568054, 65.040833],
              [11.534166000000141, 65.048874000000126],
              [11.531387, 65.060822000000144],
              [11.533333000000141, 65.066376],
              [11.540277, 65.083328],
              [11.56778, 65.092209],
              [11.6425, 65.113602],
              [11.649166, 65.114441],
              [11.763611, 65.11555],
              [11.772778, 65.113602],
              [11.768332, 65.109711000000118],
              [11.749166, 65.096375],
              [11.715832, 65.08583],
              [11.69611, 65.080551],
              [11.674999, 65.07638],
              [11.636665000000107, 65.065277],
            ],
          ],
          [
            [
              [12.156387, 65.051376],
              [12.129721, 65.050278000000105],
              [12.01222, 65.069153],
              [11.98722, 65.073318],
              [11.98167, 65.07638],
              [12.092222, 65.178329],
              [12.09861, 65.182770000000119],
              [12.153055, 65.20111],
              [12.16222, 65.204163],
              [12.171665, 65.206940000000145],
              [12.18361, 65.208328],
              [12.19611, 65.206100000000106],
              [12.21, 65.19832],
              [12.25, 65.174438000000123],
              [12.261944, 65.166107],
              [12.315277, 65.109985],
              [12.316666, 65.104156],
              [12.311388, 65.098877],
              [12.300833, 65.091934],
              [12.285, 65.08444],
              [12.266388, 65.07888800000012],
              [12.218887, 65.06499],
              [12.198889, 65.059998],
              [12.156387, 65.051376],
            ],
          ],
          [
            [
              [12.075277, 65.211380000000133],
              [12.063055, 65.20999],
              [12.08027600000014, 65.23111],
              [12.096109, 65.253326000000129],
              [12.112499000000128, 65.276657],
              [12.122499000000118, 65.29693600000013],
              [12.174166, 65.403046],
              [12.19972, 65.471664000000146],
              [12.222500000000139, 65.541931],
              [12.24472, 65.56694],
              [12.25, 65.57222],
              [12.258055000000127, 65.57611],
              [12.271666, 65.57666],
              [12.282499, 65.57388],
              [12.29139, 65.570541],
              [12.396111, 65.505554],
              [12.439444, 65.471664000000146],
              [12.44444, 65.467209],
              [12.502777, 65.39194],
              [12.492498, 65.381378],
              [12.48444, 65.377777],
              [12.37361, 65.33804],
              [12.24472, 65.27916],
              [12.240833, 65.273041000000148],
              [12.188055000000134, 65.245544],
              [12.153610000000128, 65.232498],
              [12.144444, 65.22943],
              [12.085833, 65.213608],
              [12.075277, 65.211380000000133],
            ],
          ],
          [
            [
              [11.974165, 65.626938],
              [11.900555, 65.583054000000118],
              [11.903332, 65.5961],
              [11.896111, 65.59999],
              [11.863054, 65.611664000000133],
              [11.808887, 65.61055],
              [11.79944, 65.607773],
              [11.791388, 65.603882],
              [11.778332, 65.60472],
              [11.76722100000012, 65.607498],
              [11.760277, 65.611374000000126],
              [11.75861, 65.61694],
              [11.769722000000115, 65.634995],
              [11.778610000000128, 65.646378],
              [11.7925, 65.663055],
              [11.80278, 65.673599],
              [11.814722, 65.68332],
              [11.830555, 65.690826],
              [11.894444, 65.704437],
              [11.908054, 65.704987],
              [11.99361, 65.698608],
              [12.000832000000116, 65.69472],
              [12.007500000000107, 65.68471],
              [12.008888, 65.678879000000109],
              [12.005278, 65.673050000000103],
              [11.974165, 65.626938],
            ],
          ],
          [
            [
              [12.5425, 65.896942],
              [12.531666, 65.886383],
              [12.486666000000127, 65.87027],
              [12.464722000000108, 65.866104000000121],
              [12.43861, 65.864166],
              [12.474443, 65.88361],
              [12.481388, 65.88805],
              [12.481388, 65.893051],
              [12.453609, 65.896652],
              [12.439999, 65.8961],
              [12.414999, 65.8936],
              [12.424444000000108, 65.924164],
              [12.459444, 65.968597000000102],
              [12.464722000000108, 65.97388],
              [12.47305, 65.977493],
              [12.506666000000109, 65.990265],
              [12.534166000000141, 65.999710000000107],
              [12.553333, 66.005554000000132],
              [12.573889, 66.01054],
              [12.59611, 66.01471],
              [12.621111, 66.01721],
              [12.634998, 66.017776],
              [12.86722200000014, 66.020828],
              [12.8825, 66.020554],
              [12.89361, 66.017776],
              [12.900555, 66.013885],
              [12.90361, 66.008606],
              [12.89694, 66.004166],
              [12.879166, 65.998322],
              [12.835, 65.98999],
              [12.809999, 65.98749],
              [12.78805, 65.983322],
              [12.684444, 65.957764000000111],
              [12.674721, 65.954712],
              [12.58861, 65.920547000000113],
              [12.56416, 65.909439],
              [12.549166, 65.901382000000126],
              [12.5425, 65.896942],
            ],
          ],
          [
            [
              [12.352499, 66.022491000000116],
              [12.30028, 66.010269],
              [12.292500000000132, 66.01277],
              [12.34333, 66.07777],
              [12.481388, 66.131653000000142],
              [12.430277000000103, 66.161102000000142],
              [12.433611, 66.165833],
              [12.481667, 66.188599000000124],
              [12.490000000000123, 66.192215000000147],
              [12.55361, 66.214722],
              [12.56333, 66.217773],
              [12.576111, 66.215546],
              [12.60222, 66.193054000000132],
              [12.60555, 66.188049],
              [12.657221, 66.104721],
              [12.654444000000126, 66.098053000000107],
              [12.6475, 66.08804],
              [12.639166, 66.084442],
              [12.531944000000124, 66.054718],
              [12.457499, 66.03833],
              [12.4075, 66.033051],
              [12.352499, 66.022491000000116],
            ],
          ],
          [
            [
              [12.986666, 66.228333],
              [12.930832, 66.226379],
              [12.93222, 66.230545],
              [12.937777, 66.23555],
              [12.944721000000129, 66.239990000000148],
              [12.966944, 66.252777],
              [12.98361, 66.259995],
              [13.0225, 66.271378],
              [13.08, 66.2811],
              [13.13917, 66.281387],
              [13.155832, 66.280273],
              [13.158333, 66.277496],
              [13.134165, 66.269165],
              [13.087221, 66.255554],
              [12.998055, 66.230545],
              [12.986666, 66.228333],
            ],
          ],
          [
            [
              [12.796665, 66.214432],
              [12.785555, 66.212494000000106],
              [12.776388000000111, 66.215820000000122],
              [12.715277000000128, 66.241104000000121],
              [12.715832, 66.247498],
              [12.736666, 66.260818],
              [12.759998, 66.272491],
              [12.776667, 66.279709],
              [12.79611, 66.285553000000107],
              [12.839722000000108, 66.286377],
              [12.86583, 66.281937],
              [12.870832, 66.277496],
              [12.876389000000131, 66.26944],
              [12.86861, 66.249161000000129],
              [12.86055, 66.236938],
              [12.8522210000001, 66.23332],
              [12.796665, 66.214432],
            ],
          ],
          [
            [
              [14.257776, 67.133041],
              [14.208055, 67.007217],
              [14.200554, 67.002777],
              [14.19194, 66.999435],
              [14.178888, 66.99805],
              [14.16444, 66.99777],
              [14.15111, 67.023605],
              [14.148054000000116, 67.02888],
              [14.129444, 67.047485],
              [14.122499, 67.05138],
              [14.089722, 67.066376000000105],
              [14.080276, 67.06972],
              [14.063055, 67.070831000000112],
              [14.03555, 67.069153],
              [14.019444000000135, 67.06972],
              [14.004166, 67.07138],
              [13.99444, 67.073318],
              [13.99111, 67.078598],
              [13.997221, 67.0836],
              [14.058611, 67.117218],
              [14.208055, 67.13777],
              [14.257776, 67.133041],
            ],
          ],
          [
            [
              [14.253054, 67.358597],
              [14.22639, 67.356384000000105],
              [14.21666, 67.358322],
              [14.220554, 67.363052],
              [14.260277, 67.390274],
              [14.267776, 67.394714],
              [14.293055, 67.406097],
              [14.328609000000142, 67.42055],
              [14.352499, 67.424438],
              [14.36555, 67.425552],
              [14.374998, 67.422211],
              [14.375832000000116, 67.416656000000103],
              [14.366388, 67.396378],
              [14.358889, 67.383606],
              [14.354166000000134, 67.377487],
              [14.346666, 67.373322],
              [14.326666000000102, 67.368881000000101],
              [14.253054, 67.358597],
            ],
          ],
          [
            [
              [15.202221000000122, 67.900269],
              [15.14361, 67.898331],
              [15.01111, 67.90416],
              [14.976665000000139, 67.905823],
              [14.960833, 67.907776000000126],
              [14.938889, 67.919708],
              [14.931665, 67.923874],
              [14.93444, 67.92915],
              [14.959444, 67.949707000000103],
              [14.967222, 67.954163],
              [15.038332, 67.958054000000118],
              [15.09, 67.953598],
              [15.30361, 67.920273000000122],
              [15.298611, 67.917770000000132],
              [15.26639, 67.909714],
              [15.227777, 67.90332],
              [15.202221000000122, 67.900269],
            ],
          ],
          [
            [
              [15.90333, 67.978882],
              [15.86222, 67.97583],
              [15.67139, 67.978333],
              [15.61389, 67.975555],
              [15.515554, 67.979996000000142],
              [15.503887000000134, 67.983047],
              [15.498888, 67.987778000000105],
              [15.503887000000134, 67.993607000000111],
              [15.51833, 68.003052],
              [15.528889, 68.005829],
              [15.554998000000126, 68.00861],
              [15.60805, 68.01388],
              [15.621666000000118, 68.015],
              [15.651943, 68.01555],
              [15.711666, 68.01527],
              [15.743332, 68.015],
              [15.851110000000119, 68.013611],
              [15.864721, 68.011383],
              [15.899166, 68.00249],
              [15.91778, 67.99527],
              [15.922777, 67.990829000000133],
              [15.92333200000013, 67.984985000000108],
              [15.90333, 67.978882],
            ],
          ],
          [
            [
              [12.841944000000126, 67.808609],
              [12.797222, 67.806931],
              [12.785000000000139, 67.80832],
              [12.785555, 67.814713],
              [12.895555, 67.951935],
              [12.93805, 68.000824],
              [12.943888000000129, 68.006104000000107],
              [13.05472200000014, 68.101944000000117],
              [13.068333000000109, 68.103043],
              [13.10389, 68.094711],
              [13.147499, 68.083878000000141],
              [13.155832, 68.0811],
              [13.13722, 67.959152],
              [13.13444, 67.9525],
              [13.009998, 67.876663000000121],
              [12.841944000000126, 67.808609],
            ],
          ],
          [
            [
              [13.438055, 68.112778],
              [13.382500000000107, 68.028610000000128],
              [13.340555, 68.01388],
              [13.261665, 67.989990000000148],
              [13.25111, 67.987213],
              [13.239166, 67.985275000000115],
              [13.225277, 68.017212],
              [13.216389, 68.031662],
              [13.210833, 68.036102],
              [13.196388, 68.036942],
              [13.19194, 68.0311],
              [13.190554, 68.0186],
              [13.184721000000138, 68.004990000000134],
              [13.176388, 68.002777],
              [13.16861, 68.006653],
              [13.16305, 68.011383],
              [13.161943, 68.016937],
              [13.16083, 68.040543000000127],
              [13.16361, 68.047485],
              [13.291666, 68.145264000000111],
              [13.299166000000127, 68.149719000000118],
              [13.309721, 68.1525],
              [13.323332, 68.153885],
              [13.3575, 68.151108],
              [13.385555, 68.146652],
              [13.3975, 68.143875],
              [13.420277000000112, 68.13194],
              [13.436666, 68.118607],
              [13.438055, 68.112778],
            ],
          ],
          [
            [
              [14.870554, 68.211655000000121],
              [14.856667, 68.210541],
              [14.83861, 68.211655000000121],
              [14.8291660000001, 68.215271000000143],
              [14.82166500000011, 68.219162],
              [14.818609, 68.224152],
              [14.817778, 68.229996],
              [14.818888, 68.236099],
              [14.822222, 68.242767],
              [14.821388000000127, 68.248596],
              [14.826111, 68.25444],
              [14.834166, 68.25888],
              [14.844721, 68.261658],
              [14.88222, 68.275833000000148],
              [14.903889000000106, 68.2811],
              [14.916111, 68.279709],
              [14.92361, 68.27554],
              [14.933054, 68.272217],
              [14.940554000000134, 68.268051],
              [14.943609, 68.263046000000145],
              [14.935833000000116, 68.25861],
              [14.92361, 68.256653],
              [14.922777, 68.251938],
              [14.92805, 68.247498000000121],
              [14.92694, 68.241104],
              [14.920555, 68.236099],
              [14.912777, 68.231659],
              [14.903332, 68.22804],
              [14.895555000000115, 68.223877],
              [14.88917, 68.2186],
              [14.88139, 68.21443],
              [14.870554, 68.211655000000121],
            ],
          ],
          [
            [
              [13.968332, 68.238327],
              [14.003332, 68.236664],
              [14.024721000000113, 68.242218],
              [14.02861, 68.248047],
              [14.029444, 68.256653],
              [14.03861, 68.260269],
              [14.048611, 68.261658],
              [14.063889, 68.26221],
              [14.094166, 68.258041000000105],
              [14.127222, 68.248886],
              [14.132776, 68.244431],
              [14.135832000000107, 68.239441],
              [14.134998, 68.233047000000113],
              [14.128611, 68.22804],
              [14.039165, 68.177216],
              [14.02861, 68.174438],
              [14.01028, 68.175552],
              [13.937498, 68.171936],
              [13.860277, 68.158875],
              [13.836666, 68.13611],
              [13.8475, 68.126938000000109],
              [13.84861, 68.121384],
              [13.847776, 68.11499],
              [13.844721, 68.108322],
              [13.835554, 68.104721],
              [13.70833, 68.06694],
              [13.697777, 68.064163000000121],
              [13.685555, 68.061935],
              [13.644722, 68.066666000000112],
              [13.624722, 68.083878000000141],
              [13.56194, 68.07332],
              [13.521111000000133, 68.039444],
              [13.503054, 68.040543000000127],
              [13.489443, 68.04361],
              [13.47361, 68.049988],
              [13.458611, 68.058044000000109],
              [13.453054000000122, 68.062485],
              [13.449720000000127, 68.06749],
              [13.463333, 68.085541],
              [13.469166, 68.09082],
              [13.529444, 68.126099000000124],
              [13.53611, 68.203598000000113],
              [13.534443000000124, 68.229156],
              [13.519722000000115, 68.23027],
              [13.514444, 68.234711000000118],
              [13.56361, 68.260818],
              [13.572777, 68.26443],
              [13.659721, 68.286377],
              [13.67639, 68.285828],
              [13.803888, 68.268875],
              [13.888611, 68.253052000000139],
              [13.910276000000124, 68.246933000000126],
              [13.952221, 68.23999],
              [13.968332, 68.238327],
            ],
          ],
          [
            [
              [13.97333, 68.253326],
              [13.958055, 68.252777],
              [13.889444, 68.287216],
              [13.883333, 68.302216000000101],
              [13.918610000000115, 68.31749],
              [13.92916, 68.320267000000115],
              [13.961388, 68.320267000000115],
              [13.973055, 68.31749],
              [13.982777000000112, 68.313889000000131],
              [13.990555, 68.309998],
              [13.995832, 68.305542],
              [13.999166, 68.300278],
              [14.00028, 68.294708],
              [13.99805, 68.26555],
              [13.99472, 68.25888],
              [13.985554, 68.255264],
              [13.97333, 68.253326],
            ],
          ],
          [
            [
              [14.203609, 68.239166000000125],
              [14.188332, 68.238602],
              [14.170555, 68.241379000000109],
              [14.16111, 68.244720000000143],
              [14.054998, 68.286942],
              [14.049721, 68.29166],
              [14.048611, 68.297211],
              [14.049444, 68.303329],
              [14.068888, 68.320267000000115],
              [14.114721, 68.321655],
              [14.132776, 68.320267000000115],
              [14.214167, 68.301102000000128],
              [14.229166, 68.293045],
              [14.23778, 68.2836],
              [14.24111, 68.27861],
              [14.244165000000123, 68.273331],
              [14.245277, 68.26778],
              [14.240555, 68.261658],
              [14.221943, 68.246384000000148],
              [14.214167, 68.241943],
              [14.203609, 68.239166000000125],
            ],
          ],
          [
            [
              [15.026388, 68.354996000000142],
              [14.8425, 68.279160000000104],
              [14.813055, 68.26916],
              [14.781944, 68.260269],
              [14.77139, 68.257492000000127],
              [14.5325, 68.200546],
              [14.508055, 68.196655000000135],
              [14.39277600000014, 68.18332],
              [14.240833000000123, 68.155823000000112],
              [14.205832, 68.14915],
              [14.19972, 68.152222],
              [14.20194400000014, 68.200272],
              [14.206665, 68.2061],
              [14.304722, 68.304993],
              [14.317221, 68.315277],
              [14.326387000000125, 68.318878],
              [14.34166, 68.319153000000142],
              [14.35555, 68.31694],
              [14.365276000000108, 68.313599000000124],
              [14.370554, 68.308884],
              [14.373888, 68.303879],
              [14.41361, 68.292770000000132],
              [14.483055, 68.295822000000101],
              [14.495277000000101, 68.297775],
              [14.501665, 68.303055],
              [14.502777, 68.309158],
              [14.475277000000119, 68.337494000000106],
              [14.469166, 68.34082],
              [14.43111, 68.355820000000108],
              [14.48527700000011, 68.381378],
              [14.542221, 68.400833],
              [14.605555, 68.418045],
              [14.627499000000114, 68.423599],
              [14.639721000000122, 68.42555],
              [14.758888, 68.428604000000121],
              [14.775, 68.426941],
              [14.785276, 68.424713],
              [14.80472200000014, 68.41777],
              [14.803055, 68.399712],
              [14.806221, 68.397049],
              [14.808222, 68.394043],
              [14.80872, 68.390549],
              [14.808054000000141, 68.386879],
              [14.79855, 68.38171],
              [14.77605, 68.373215],
              [14.766555, 68.367882],
              [14.752222, 68.351654],
              [14.753332, 68.345825],
              [14.790998, 68.362762],
              [14.798332, 68.363937],
              [14.857, 68.378769],
              [14.861332, 68.380432],
              [14.862, 68.38427],
              [14.854666, 68.3964390000001],
              [14.85533, 68.400101],
              [14.89583, 68.428879000000109],
              [14.918333, 68.432220000000143],
              [15.144722, 68.45138500000013],
              [15.158609000000126, 68.452499000000103],
              [15.168888, 68.450546000000145],
              [15.156111, 68.44028],
              [15.11417, 68.411102],
              [15.03444, 68.359436],
              [15.026388, 68.354996000000142],
            ],
          ],
          [
            [
              [16.405552, 68.411102],
              [16.394444, 68.4086],
              [16.380554000000132, 68.407486],
              [16.349720000000104, 68.406937],
              [16.31472, 68.409164],
              [16.29944, 68.408875],
              [16.271664, 68.406937],
              [16.203331000000105, 68.400833],
              [16.19111, 68.39888],
              [16.121109000000104, 68.376389],
              [16.11305, 68.378876],
              [16.094444, 68.396652000000131],
              [16.096107, 68.402771000000143],
              [16.140553, 68.478607],
              [16.1475, 68.483597],
              [16.179996, 68.50082],
              [16.215553, 68.516098],
              [16.234997, 68.523041],
              [16.32694, 68.5336],
              [16.342499, 68.533875],
              [16.372498, 68.52943],
              [16.38416, 68.526382],
              [16.399998, 68.520828],
              [16.414444, 68.51277],
              [16.46167, 68.471939],
              [16.466663, 68.467499],
              [16.465, 68.461105],
              [16.405552, 68.411102],
            ],
          ],
          [
            [
              [17.116386, 68.75249],
              [17.09528, 68.746384],
              [17.082497000000103, 68.74472],
              [17.03, 68.747498],
              [17.014442, 68.747498],
              [16.959164, 68.742767],
              [16.933887, 68.739166],
              [16.82527, 68.719711],
              [16.81361, 68.72276],
              [16.813053, 68.728333],
              [16.839443, 68.765549],
              [16.97083, 68.84416],
              [16.98778, 68.852768],
              [17.000553, 68.854431],
              [17.013054, 68.852768],
              [17.1475, 68.774429],
              [17.14777800000013, 68.768875],
              [17.141666, 68.76527],
              [17.116386, 68.75249],
            ],
          ],
          [
            [
              [17.241665, 68.788605],
              [17.226109, 68.788605],
              [17.20972, 68.790543],
              [17.198055, 68.793610000000115],
              [17.190552, 68.79693600000013],
              [17.082222, 68.8986],
              [17.079441, 68.90361],
              [17.083611, 68.91026],
              [17.09083, 68.915268],
              [17.10055, 68.918884000000105],
              [17.296665, 68.919708],
              [17.331387, 68.916382],
              [17.355, 68.909988],
              [17.364441, 68.90666],
              [17.42805, 68.87471],
              [17.435276, 68.870544],
              [17.437775, 68.865265],
              [17.43444, 68.859985],
              [17.421665, 68.849152],
              [17.413055, 68.84499],
              [17.308331, 68.80499],
              [17.254444, 68.790543],
              [17.241665, 68.788605],
            ],
          ],
          [
            [
              [14.95444, 68.872772],
              [14.940277, 68.871658],
              [14.907499, 68.871933],
              [14.875277, 68.873322],
              [14.858889, 68.87498],
              [14.83917, 68.88194],
              [14.839722, 68.886932000000115],
              [14.852499000000137, 68.926376],
              [14.855276, 68.931931000000134],
              [14.868055, 68.933884],
              [14.885277, 68.933319],
              [14.95111, 68.926102000000128],
              [14.963888, 68.924438],
              [14.969444, 68.919998],
              [14.975277, 68.898041],
              [14.976944000000117, 68.886658],
              [14.973610000000122, 68.87999],
              [14.95444, 68.872772],
            ],
          ],
          [
            [
              [15.988054, 68.751938],
              [15.967222, 68.71138],
              [15.964167, 68.706100000000106],
              [15.953609, 68.694153000000142],
              [15.940277, 68.683884],
              [15.93222, 68.679718],
              [15.863888, 68.646942],
              [15.854166, 68.6436],
              [15.811943, 68.640274],
              [15.800833, 68.637497],
              [15.781666, 68.630554],
              [15.77361100000013, 68.626389],
              [15.76694300000014, 68.621109],
              [15.761665, 68.615265000000136],
              [15.740833, 68.532211],
              [15.739443000000108, 68.526108000000136],
              [15.748888, 68.526108000000136],
              [15.801943, 68.549438],
              [15.808611, 68.554443000000106],
              [15.813889000000131, 68.56055],
              [15.817499, 68.567215000000147],
              [15.818888, 68.573318],
              [15.813055, 68.5836],
              [15.809444, 68.594437],
              [15.808887000000141, 68.599991],
              [15.812498000000119, 68.606659],
              [15.819166000000109, 68.611664],
              [15.83694, 68.619720000000143],
              [15.846666000000141, 68.623047],
              [15.97639, 68.665833000000134],
              [16.09083, 68.732208],
              [16.11639, 68.78],
              [16.10889, 68.784164000000146],
              [16.096386, 68.79277],
              [16.088608, 68.802490000000148],
              [16.087219, 68.813889],
              [16.099442, 68.824707],
              [16.118889, 68.83166],
              [16.178886, 68.85165400000011],
              [16.2041660000001, 68.85527],
              [16.35472, 68.857208000000128],
              [16.436386, 68.847488],
              [16.44611, 68.843887],
              [16.49028, 68.810547],
              [16.544441, 68.76416],
              [16.568054000000132, 68.696381],
              [16.565, 68.65193],
              [16.563053, 68.645554],
              [16.55917, 68.63888500000013],
              [16.553886, 68.633041000000105],
              [16.53722, 68.624435],
              [16.527496, 68.621109],
              [16.509441, 68.613327],
              [16.493053, 68.604721],
              [16.487778, 68.598877],
              [16.48611, 68.592773],
              [16.501144, 68.55246],
              [16.364719, 68.555832000000123],
              [16.349442, 68.555542000000116],
              [16.23305, 68.549988],
              [16.22194, 68.547211],
              [16.13361, 68.51694],
              [16.082775, 68.497498],
              [16.072220000000129, 68.485825],
              [16.049999, 68.46304],
              [15.96027800000013, 68.380829000000119],
              [15.95222, 68.376663],
              [15.933054, 68.369431],
              [15.91111, 68.364166],
              [15.88333, 68.362213000000111],
              [15.869444, 68.364441],
              [15.86972, 68.399429],
              [15.855555, 68.431931],
              [15.78861, 68.39027],
              [15.697222000000124, 68.34111],
              [15.588888, 68.304993],
              [15.5325, 68.33083],
              [15.520832, 68.333603],
              [15.426109, 68.333603],
              [15.364166, 68.324158],
              [15.348888, 68.32361],
              [15.335, 68.32611],
              [15.327776, 68.33027600000014],
              [15.32194, 68.340271],
              [15.32111, 68.3461],
              [15.387777, 68.378876],
              [15.439444, 68.394165],
              [15.50111, 68.41333],
              [15.516943, 68.42193600000013],
              [15.57028, 68.460831],
              [15.589167, 68.478333000000134],
              [15.567778, 68.502213],
              [15.558332, 68.505829],
              [15.542221, 68.507492],
              [15.539165000000139, 68.502213],
              [15.542221, 68.497208],
              [15.54749900000013, 68.492493],
              [15.554722, 68.488602000000128],
              [15.56055, 68.478333000000134],
              [15.559166, 68.472214],
              [15.554165000000125, 68.46611],
              [15.51111, 68.44611],
              [15.441111, 68.41499],
              [15.431665000000123, 68.411377],
              [15.42055, 68.4086],
              [15.343332, 68.395264],
              [15.256943, 68.364716],
              [15.224443, 68.345825],
              [15.231667, 68.34193],
              [15.230276, 68.335831],
              [15.197222, 68.319153000000142],
              [15.111387, 68.28139],
              [15.101944, 68.277771],
              [15.027222, 68.249435],
              [15.014999, 68.247498000000121],
              [15.00111, 68.246384000000148],
              [14.986666, 68.247498000000121],
              [14.984999, 68.263046000000145],
              [14.994999, 68.297211],
              [15.0, 68.303055],
              [15.084166, 68.364166],
              [15.24361, 68.473053],
              [15.328609, 68.482498000000135],
              [15.335833, 68.485275],
              [15.262499, 68.519989],
              [15.24861, 68.522217],
              [15.217777, 68.521652],
              [15.191387, 68.518600000000106],
              [15.181665, 68.522217],
              [15.186666, 68.528046],
              [15.213333, 68.556931],
              [15.222776, 68.56055],
              [15.349165, 68.58583],
              [15.361666, 68.587769],
              [15.45833, 68.656937],
              [15.44611, 68.677216],
              [15.437222, 68.692764000000125],
              [15.435555, 68.703888],
              [15.446388, 68.724152],
              [15.45167, 68.73],
              [15.461943000000133, 68.731384000000105],
              [15.589998, 68.72916],
              [15.606943, 68.728607],
              [15.623333, 68.726944],
              [15.63499800000011, 68.72387700000013],
              [15.652222, 68.716385],
              [15.674444, 68.704163],
              [15.696665, 68.699158],
              [15.71361, 68.69861],
              [15.662498000000141, 68.731659],
              [15.655, 68.735825],
              [15.64555, 68.739166],
              [15.613609, 68.740829000000133],
              [15.565277, 68.740829000000133],
              [15.549721, 68.740555],
              [15.53722, 68.738602],
              [15.52611, 68.735825],
              [15.509165, 68.736374000000126],
              [15.497221000000138, 68.739441],
              [15.462221, 68.753052],
              [15.454721, 68.756943],
              [15.45167, 68.762207000000103],
              [15.455, 68.803879000000109],
              [15.459444000000133, 68.80832],
              [15.629444, 68.941666],
              [15.63611, 68.94665],
              [15.658609, 68.95221],
              [15.684166, 68.955826000000116],
              [15.86972, 68.964157],
              [15.88694, 68.963608],
              [15.898888, 68.960541000000148],
              [15.908756, 68.9567],
              [15.92805, 68.89194],
              [15.928888, 68.886383],
              [15.87583, 68.792221],
              [15.870554, 68.786377],
              [15.939722, 68.785553000000107],
              [15.95666, 68.784988000000112],
              [15.980276, 68.77888],
              [15.98333, 68.77388],
              [15.9875, 68.757492],
              [15.988054, 68.751938],
            ],
          ],
          [
            [
              [16.53722, 68.879715],
              [16.521385, 68.87944],
              [16.508053, 68.87999],
              [16.491665000000125, 68.88194],
              [16.418888, 68.893600000000106],
              [16.37611, 68.90666],
              [16.271385, 68.957489],
              [16.26388, 68.961380000000133],
              [16.261108, 68.96666],
              [16.265, 68.97333],
              [16.280277, 68.982498],
              [16.288609, 68.986938],
              [16.29833200000013, 68.990265000000136],
              [16.312775, 68.99138],
              [16.329998, 68.990829],
              [16.548611000000108, 68.967773],
              [16.56277, 68.96527],
              [16.5725, 68.961655000000121],
              [16.59444, 68.949707000000103],
              [16.601665, 68.945541],
              [16.60722, 68.935272],
              [16.591389, 68.892212],
              [16.586666, 68.88777],
              [16.56277, 68.883331],
              [16.53722, 68.879715],
            ],
          ],
          [
            [
              [15.38278, 68.84528],
              [15.403055000000109, 68.707764000000111],
              [15.402222000000108, 68.695831],
              [15.399443, 68.683609000000104],
              [15.395832, 68.676666000000125],
              [15.38944400000014, 68.671661],
              [15.381388, 68.667221],
              [15.362221, 68.660263],
              [15.322498, 68.646942],
              [15.070276, 68.575272],
              [15.059166000000118, 68.572495],
              [15.043888, 68.57222],
              [14.901388000000111, 68.581375],
              [14.864443, 68.583878],
              [14.85028, 68.58638],
              [14.804443, 68.612488],
              [14.80361, 68.618042],
              [14.815, 68.633331000000112],
              [14.82166500000011, 68.638321],
              [14.856110000000115, 68.645828000000108],
              [14.916943, 68.656387],
              [15.058332, 68.680832],
              [15.14361, 68.69388],
              [15.157776000000126, 68.694992000000127],
              [15.164444000000117, 68.699997],
              [15.15, 68.749161000000129],
              [15.135832000000107, 68.751663],
              [15.059166000000118, 68.75972],
              [15.00916, 68.763885],
              [14.99667, 68.761932],
              [15.006388, 68.758331],
              [15.046665000000132, 68.750824],
              [15.066111, 68.743881000000101],
              [15.067221, 68.738052],
              [15.060555, 68.733047],
              [15.039444, 68.718323],
              [14.996387, 68.69832],
              [14.906666, 68.677216],
              [14.894165, 68.675278],
              [14.82278, 68.666931],
              [14.743889000000138, 68.659164],
              [14.731943, 68.661942],
              [14.663610000000119, 68.66666],
              [14.54972, 68.619156],
              [14.50111, 68.601944],
              [14.44861, 68.604156],
              [14.436666, 68.606934],
              [14.429165, 68.611099],
              [14.41833, 68.619995],
              [14.38305, 68.657211000000132],
              [14.371111, 68.683609000000104],
              [14.37611, 68.68971],
              [14.442499, 68.765549],
              [14.48361, 68.786377],
              [14.519999, 68.80138],
              [14.529444, 68.80499],
              [14.63278, 68.826111],
              [14.645277, 68.82805],
              [14.662498000000141, 68.827499000000103],
              [14.676666, 68.825272],
              [14.68222, 68.820831000000112],
              [14.689444, 68.80499],
              [14.886665, 68.754166],
              [14.902222, 68.754440000000102],
              [14.910276, 68.758606],
              [14.939165000000116, 68.788055],
              [14.946943, 68.799438],
              [14.950554, 68.806107000000111],
              [14.949444, 68.811935],
              [14.946388, 68.81694],
              [14.941111, 68.82138],
              [14.910831, 68.837494],
              [14.905277, 68.841934],
              [14.942221, 68.856934],
              [14.951666000000102, 68.86055],
              [15.050833, 68.850266],
              [15.067221, 68.848328],
              [15.088888000000111, 68.841934],
              [15.10639, 68.834442],
              [15.116943, 68.825546000000145],
              [15.119999000000121, 68.820267],
              [15.123888, 68.816666000000112],
              [15.13361, 68.81305],
              [15.148611, 68.81221],
              [15.154999, 68.817215],
              [15.15639, 68.823318],
              [15.15333, 68.828598000000113],
              [15.144999, 68.83804],
              [15.139721, 68.842773],
              [15.07889, 68.892212],
              [15.034721, 68.922485],
              [15.027498, 68.927216000000101],
              [15.0166660000001, 68.936096000000134],
              [15.011665, 68.941376],
              [15.005278, 68.95166],
              [15.00444, 68.957214],
              [15.011665, 68.970825],
              [15.021666, 68.982498],
              [15.035, 68.993042],
              [15.04472, 68.99638],
              [15.087776000000133, 69.008041000000105],
              [15.132221000000129, 69.011383],
              [15.14444, 69.00833],
              [15.165833000000134, 68.990265000000136],
              [15.171944, 68.979996000000142],
              [15.168333, 68.97333],
              [15.2066650000001, 68.899429000000112],
              [15.292776, 68.87944],
              [15.37528, 68.849442],
              [15.38278, 68.84528],
            ],
          ],
          [
            [
              [17.416943, 68.99582],
              [17.37278, 68.984711],
              [17.358608, 68.987213],
              [17.35611, 68.992218],
              [17.355274, 68.99721],
              [17.352776, 69.024155],
              [17.360275, 69.036102],
              [17.388885, 69.05638],
              [17.410275, 69.07138],
              [17.418888, 69.075821000000133],
              [17.561386, 69.094986000000119],
              [17.563889000000131, 69.089722000000108],
              [17.529999, 69.05249],
              [17.52277800000013, 69.047485],
              [17.44278, 69.00833],
              [17.416943, 68.99582],
            ],
          ],
          [
            [
              [15.5225, 68.906097000000102],
              [15.468054, 68.874161],
              [15.453333, 68.87527],
              [15.44361, 68.878601],
              [15.43611, 68.882767000000115],
              [15.418333000000132, 68.896652],
              [15.415277, 68.901657],
              [15.42111, 68.97305],
              [15.422777, 68.979431],
              [15.56028, 69.094711],
              [15.568609, 69.09888],
              [15.613054, 69.118881000000101],
              [15.62278, 69.122208],
              [15.645277, 69.127777],
              [15.690554000000134, 69.138611],
              [15.736666, 69.14],
              [15.75111, 69.141098],
              [15.763887, 69.143051000000128],
              [15.77361100000013, 69.146378],
              [15.781944, 69.150833],
              [15.78889, 69.155823000000112],
              [15.809999000000118, 69.179443000000106],
              [15.848331, 69.222214000000122],
              [15.86360900000011, 69.238602],
              [15.974722, 69.280823],
              [15.994444, 69.287766000000147],
              [16.11194, 69.31277],
              [16.126389, 69.310272],
              [16.148052, 69.286377],
              [16.153889, 69.276108000000136],
              [16.154999, 69.264999],
              [16.088608, 69.157776],
              [16.081665, 69.152771],
              [16.058052, 69.13916],
              [16.02861, 69.128601],
              [16.01722, 69.126099000000124],
              [15.997499000000118, 69.119156],
              [15.969444, 69.107773000000122],
              [15.94444, 69.094986000000119],
              [15.873888, 69.053879],
              [15.870277, 69.047211000000118],
              [15.873055, 69.042221],
              [15.873888, 69.036377],
              [15.87222, 69.030273],
              [15.863888, 69.026108],
              [15.854166, 69.022491],
              [15.735554, 68.998886],
              [15.711388, 68.994431],
              [15.638054, 68.981659],
              [15.5225, 68.906097000000102],
            ],
          ],
          [
            [
              [17.63661, 69.516045],
              [17.686108000000104, 69.509155],
              [17.696388, 69.51277],
              [17.69611, 69.518326000000116],
              [17.693333, 69.52333],
              [17.66861, 69.546387],
              [17.652222, 69.588608],
              [17.651943, 69.594162],
              [17.662498, 69.597488],
              [17.84417, 69.589157],
              [17.85611, 69.586105],
              [17.86333100000013, 69.58194],
              [17.964443, 69.523041000000148],
              [18.074165000000107, 69.430832],
              [18.083885, 69.42139],
              [18.08639, 69.416382000000112],
              [18.10083, 69.363602],
              [18.10083, 69.358047],
              [18.09722, 69.352768],
              [18.086941, 69.349442000000124],
              [18.056389000000138, 69.34833],
              [17.968887, 69.343048000000124],
              [17.957222, 69.340546],
              [17.9175, 69.325546],
              [17.908607000000131, 69.321381],
              [17.904999, 69.316101],
              [17.875832000000116, 69.23972],
              [17.952221000000122, 69.199432],
              [17.968052, 69.199707],
              [17.981110000000115, 69.20138500000013],
              [17.998608, 69.20055],
              [18.005554, 69.19638],
              [18.003609, 69.190277],
              [17.99472, 69.186096],
              [17.901386, 69.168045],
              [17.862499, 69.162766],
              [17.583885, 69.156937],
              [17.522221, 69.190277],
              [17.406944000000124, 69.161652000000117],
              [17.21194, 69.090271],
              [17.194721, 69.081940000000145],
              [17.173332, 69.066666],
              [17.167774, 69.060822],
              [17.163609, 69.05415],
              [17.161663, 69.04805],
              [17.166664, 69.04332],
              [17.177776, 69.042496],
              [17.186943, 69.044708000000128],
              [17.19749800000011, 69.045822000000101],
              [17.205830000000105, 69.043045],
              [17.213055, 69.038879000000122],
              [17.215553, 69.03387],
              [17.209999, 69.028046000000131],
              [17.201385, 69.02388],
              [17.16722, 69.016098000000113],
              [17.09278, 69.003601000000117],
              [17.045555, 69.003326],
              [17.041943, 69.006943],
              [17.03805, 69.01638800000012],
              [17.037498, 69.022217000000126],
              [17.041664, 69.028885000000116],
              [17.082222, 69.04944],
              [17.128887, 69.06471],
              [17.13611, 69.069717],
              [17.135555, 69.07527],
              [17.12611, 69.078888],
              [17.109722, 69.081100000000106],
              [16.956108, 69.06776],
              [16.900555, 69.05415],
              [16.889164000000108, 69.051376000000118],
              [16.811665000000119, 69.049713],
              [16.775276, 69.064438000000109],
              [16.772778, 69.069717],
              [16.767498, 69.090271],
              [16.771664000000101, 69.096939],
              [16.77861, 69.102219000000105],
              [16.792774, 69.112213000000111],
              [16.80139, 69.116379],
              [16.814163, 69.118332000000123],
              [16.83, 69.118607],
              [16.91916700000013, 69.122772],
              [17.004444, 69.12999],
              [17.136944, 69.171387],
              [17.145554000000118, 69.175552],
              [17.16111, 69.184998],
              [17.16833, 69.18999],
              [17.17388, 69.19583],
              [17.165, 69.197220000000129],
              [17.15361, 69.19472],
              [17.123333, 69.184433000000126],
              [17.111942000000113, 69.181931],
              [17.085831, 69.178329000000133],
              [17.070000000000107, 69.17805],
              [17.032497, 69.181107000000111],
              [16.940277, 69.19472],
              [16.875832000000116, 69.22137],
              [16.885830000000112, 69.224991],
              [16.911663, 69.228333000000134],
              [16.940552, 69.230545],
              [17.001389, 69.232773],
              [17.039165, 69.229721],
              [17.072220000000129, 69.22555],
              [17.10833, 69.223602],
              [17.118610000000103, 69.22694],
              [17.125553, 69.231934],
              [17.14277600000014, 69.24943],
              [17.074776, 69.275826],
              [17.068443, 69.277161],
              [17.06328, 69.274666],
              [17.03928, 69.268494],
              [16.913609000000122, 69.29222],
              [16.90416, 69.295547],
              [16.89666, 69.299713000000111],
              [16.896111, 69.305267000000129],
              [16.901943, 69.311386],
              [16.91333, 69.313889000000131],
              [16.928055, 69.314987],
              [17.014442, 69.313599000000124],
              [17.07937, 69.315582],
              [17.087875000000111, 69.314079],
              [17.097542, 69.314079],
              [17.099876000000108, 69.316078],
              [17.089109, 69.342651000000103],
              [17.081944, 69.3445],
              [17.073275, 69.345985],
              [17.044275, 69.349152000000117],
              [17.0337770000001, 69.349495000000104],
              [17.02677, 69.347992],
              [17.020777, 69.345985],
              [17.0156080000001, 69.343323000000112],
              [16.977776, 69.350266],
              [16.963333, 69.349152000000117],
              [16.909443, 69.351944],
              [16.890553000000125, 69.353607000000125],
              [16.87611, 69.356110000000115],
              [16.874722000000133, 69.360275000000115],
              [16.930832, 69.392487000000131],
              [16.939442, 69.396652000000131],
              [17.043831, 69.398819],
              [17.203053, 69.40416],
              [17.291111, 69.407486],
              [17.39, 69.412491],
              [17.480831, 69.419708000000128],
              [17.490276000000108, 69.421936],
              [17.491386, 69.426666000000125],
              [17.48166700000013, 69.430267],
              [17.453053000000125, 69.435272],
              [17.406275, 69.436096],
              [17.390444, 69.433937],
              [17.38094, 69.43378],
              [17.32, 69.436935],
              [17.261108, 69.44444],
              [17.241665, 69.451660000000118],
              [17.234165, 69.455551],
              [17.186943, 69.490829],
              [17.186386, 69.496658],
              [17.196663000000115, 69.500000000000114],
              [17.212776000000133, 69.50027],
              [17.22472, 69.497208],
              [17.25166, 69.485825],
              [17.256664, 69.48111],
              [17.283886, 69.464432000000102],
              [17.29583, 69.46138],
              [17.313332, 69.460541],
              [17.359219, 69.476486],
              [17.365387, 69.478493],
              [17.361053, 69.480995],
              [17.343609, 69.501099000000124],
              [17.304443, 69.520828],
              [17.301666000000125, 69.526108],
              [17.310555, 69.530273],
              [17.32361, 69.531937],
              [17.339722000000108, 69.532211],
              [17.414165, 69.519989],
              [17.457222000000115, 69.512207000000103],
              [17.5425, 69.486374],
              [17.548332, 69.483322],
              [17.568333000000109, 69.464722000000108],
              [17.575554, 69.460541],
              [17.59, 69.45527600000014],
              [17.602331, 69.472832],
              [17.609331, 69.474319],
              [17.610165, 69.477158],
              [17.561497, 69.51116],
              [17.552664, 69.516],
              [17.519997, 69.534714],
              [17.502499, 69.53526],
              [17.48583200000013, 69.537491000000102],
              [17.47361, 69.540543],
              [17.459442, 69.564713],
              [17.459164, 69.570541],
              [17.46917, 69.5977630000001],
              [17.485275, 69.5977630000001],
              [17.528889, 69.58444],
              [17.538609000000122, 69.580826],
              [17.55333, 69.572769000000108],
              [17.567776, 69.564438],
              [17.59444, 69.55072],
              [17.616941000000111, 69.528214000000105],
              [17.63661, 69.516045],
            ],
          ],
          [
            [
              [30.155552, 69.781662],
              [30.144165, 69.7811],
              [30.11555, 69.782776],
              [30.110554, 69.787216],
              [30.116108000000111, 69.793045],
              [30.12611, 69.797485],
              [30.138054000000125, 69.795],
              [30.148331, 69.791107000000125],
              [30.15333, 69.786652],
              [30.155552, 69.781662],
            ],
          ],
          [
            [
              [18.889999, 69.69194],
              [18.794167, 69.671936],
              [18.776943, 69.65361],
              [18.77222, 69.647217],
              [18.7675, 69.64055],
              [18.7675, 69.63472],
              [18.77444, 69.630554],
              [18.789719, 69.62944],
              [18.80611, 69.62944],
              [18.820274, 69.626663000000121],
              [18.827499000000103, 69.622498000000121],
              [18.846386, 69.603882000000112],
              [18.846386, 69.598328],
              [18.78305, 69.569153],
              [18.762218, 69.562775000000101],
              [18.738331, 69.55777],
              [18.72361, 69.556931],
              [18.70444, 69.558609],
              [18.610832, 69.560272000000111],
              [18.537220000000104, 69.556107000000111],
              [18.40916, 69.54582],
              [18.39722, 69.543320000000108],
              [18.344166, 69.536652000000117],
              [18.24139, 69.530548000000124],
              [18.226665, 69.529709000000139],
              [18.190552, 69.53],
              [18.159721, 69.534714],
              [18.045277, 69.564713],
              [18.025833, 69.571930000000123],
              [17.99944, 69.583328],
              [17.99694, 69.588333],
              [18.001389, 69.594986],
              [18.031944, 69.622208000000114],
              [18.146385000000123, 69.63861],
              [18.16278, 69.63861],
              [18.268608, 69.619156],
              [18.279999, 69.63582],
              [18.187775000000101, 69.701385],
              [18.185276000000101, 69.706375],
              [18.19722, 69.708878],
              [18.298332, 69.705276],
              [18.314495, 69.703384],
              [18.396111000000133, 69.69999700000011],
              [18.589165, 69.69194],
              [18.622776, 69.68748],
              [18.632221000000129, 69.689713],
              [18.629719, 69.694717],
              [18.622776, 69.698883000000137],
              [18.610832, 69.701935],
              [18.522221, 69.71165],
              [18.48389, 69.715],
              [18.436386, 69.714157],
              [18.363609, 69.720276],
              [18.351665, 69.72333],
              [18.344444, 69.72749],
              [18.324444, 69.763046],
              [18.321941, 69.768051],
              [18.324444, 69.774155000000121],
              [18.331944, 69.77916],
              [18.353054, 69.786102],
              [18.387218, 69.794434],
              [18.399441000000138, 69.791107000000125],
              [18.481941, 69.760818],
              [18.63444, 69.763321],
              [18.646385, 69.726379],
              [18.648888, 69.721375],
              [18.656109, 69.711380000000133],
              [18.670555, 69.703323],
              [18.709721, 69.684158],
              [18.721664, 69.681107],
              [18.739441, 69.680267000000129],
              [18.751389, 69.682770000000119],
              [18.760277, 69.686935000000119],
              [18.766388, 69.765549],
              [18.753330000000119, 69.801102],
              [18.73416, 69.80832],
              [18.688332, 69.827209],
              [18.683609000000104, 69.83166],
              [18.661942, 69.8611],
              [18.659443, 69.866379],
              [18.664165000000139, 69.872772],
              [18.671944, 69.877777],
              [18.69305, 69.88443],
              [18.804443, 69.882767000000115],
              [18.821388, 69.880554000000132],
              [18.833611, 69.877487],
              [18.995831, 69.824997],
              [19.014999000000103, 69.817764],
              [19.04361, 69.801102],
              [19.05778, 69.787216],
              [19.06472, 69.771652000000131],
              [19.06472, 69.766098000000113],
              [19.05972, 69.75943],
              [19.04416700000013, 69.74971],
              [19.018055, 69.736374000000126],
              [18.933609, 69.704163],
              [18.912498, 69.697495],
              [18.889999, 69.69194],
            ],
          ],
          [
            [
              [20.680275, 69.80861],
              [20.60444, 69.796097000000145],
              [20.57333, 69.798325],
              [20.56444, 69.80777],
              [20.562496, 69.81305],
              [20.55611, 69.845551],
              [20.55639, 69.851105000000132],
              [20.55944, 69.857208],
              [20.586666, 69.888046],
              [20.59333, 69.893600000000106],
              [20.601387, 69.8986],
              [20.611111000000108, 69.902771],
              [20.623333000000116, 69.905],
              [20.730000000000132, 69.908875],
              [20.739166, 69.90527],
              [20.741108000000111, 69.899994000000106],
              [20.734997, 69.822495000000117],
              [20.729443, 69.818054],
              [20.71722, 69.815552000000139],
              [20.680275, 69.80861],
            ],
          ],
          [
            [
              [29.826664, 69.756943],
              [29.793331, 69.754440000000102],
              [29.730553, 69.75943],
              [29.716110000000128, 69.761932],
              [29.716389000000106, 69.766937],
              [29.770061, 69.801353],
              [29.808542, 69.821915000000104],
              [29.81012, 69.86513],
              [29.821663, 69.901382],
              [29.83083, 69.906662],
              [29.841942000000131, 69.91026],
              [29.87527, 69.907211],
              [29.893330000000105, 69.90443],
              [29.97805, 69.890823],
              [30.002777, 69.88472],
              [30.04805, 69.827499000000103],
              [30.0425, 69.80832],
              [29.96, 69.78805],
              [29.838608000000136, 69.75943],
              [29.826664, 69.756943],
            ],
          ],
          [
            [
              [21.730274, 69.931107000000111],
              [21.694164000000114, 69.925552],
              [21.681389, 69.927765],
              [21.672222, 69.931381],
              [21.668053, 69.936096],
              [21.66861, 69.941940000000102],
              [21.674721, 69.94611],
              [21.69944, 69.950821],
              [21.71722, 69.949707],
              [21.73139, 69.946655000000135],
              [21.735554, 69.941940000000102],
              [21.73472, 69.93639],
              [21.730274, 69.931107000000111],
            ],
          ],
          [
            [
              [19.567219, 69.85165400000011],
              [19.473888, 69.83972],
              [19.459442, 69.842499],
              [19.464165, 69.851105000000132],
              [19.522221, 69.884155],
              [19.540833, 69.892487],
              [19.798054, 70.00055],
              [19.81444, 70.00055],
              [19.833611, 69.998596],
              [19.845554, 69.995544000000109],
              [19.864719, 69.98805],
              [19.897778, 69.97221],
              [19.897499, 69.96666],
              [19.89333, 69.96138],
              [19.791386000000102, 69.873047],
              [19.783333, 69.868042],
              [19.772499, 69.864716000000101],
              [19.7275, 69.86249],
              [19.567219, 69.85165400000011],
            ],
          ],
          [
            [
              [19.959164, 70.005554],
              [19.944164000000114, 70.004715],
              [19.915833, 70.008041000000105],
              [19.90361, 70.011383],
              [19.899166, 70.016098],
              [19.908607, 70.019989000000123],
              [19.955276, 70.021378000000141],
              [19.974442000000124, 70.019714000000135],
              [19.988888, 70.016937],
              [19.996109, 70.012772],
              [19.959164, 70.005554],
            ],
          ],
          [
            [
              [20.892567, 70.030815],
              [20.947498, 70.001839000000132],
              [21.043474000000117, 70.005463000000134],
              [21.098053, 70.009430000000123],
              [21.1025, 70.004715],
              [20.95277, 69.945541],
              [20.928333, 69.940826000000129],
              [20.887218000000132, 69.936096],
              [20.872219, 69.93555],
              [20.839165, 69.935822000000144],
              [20.823887, 69.937485],
              [20.80278, 69.944443],
              [20.79722, 69.947769000000108],
              [20.772778, 69.970825],
              [20.759720000000129, 69.984985],
              [20.757774, 69.98999],
              [20.758053, 69.99582],
              [20.761108, 70.001938],
              [20.777496, 70.021652],
              [20.789997, 70.03387],
              [20.798054, 70.038879],
              [20.807777, 70.04277],
              [20.821388, 70.04416],
              [20.838055, 70.04416],
              [20.892567, 70.030815],
            ],
          ],
          [
            [
              [21.000832000000116, 70.019714000000135],
              [20.985554, 70.018875],
              [20.967777, 70.019989000000123],
              [20.953609000000142, 70.022766],
              [20.951942, 70.025833000000148],
              [20.955, 70.031937],
              [21.011944, 70.06248],
              [21.02861, 70.06248],
              [21.040276, 70.059158],
              [21.049164, 70.049713],
              [21.051109, 70.044708000000128],
              [21.050278, 70.038879],
              [21.04472, 70.032486000000119],
              [21.036663, 70.027496],
              [21.025555, 70.024429],
              [21.000832000000116, 70.019714000000135],
            ],
          ],
          [
            [
              [19.300552, 70.02611],
              [19.334164000000101, 70.010544],
              [19.363052, 69.999435],
              [19.394165, 69.988876000000118],
              [19.408607, 69.986099],
              [19.42361, 69.986938],
              [19.42139, 69.992218],
              [19.411942, 70.001389],
              [19.41222, 70.00722],
              [19.414719, 70.01332],
              [19.422775, 70.018326],
              [19.449444, 70.031387],
              [19.486942000000113, 70.047775],
              [19.49916, 70.050278],
              [19.512775, 70.051941000000113],
              [19.527775, 70.05249],
              [19.547222, 70.05082700000014],
              [19.561665, 70.04805],
              [19.651943000000131, 70.020264],
              [19.661388, 70.016388],
              [19.678055, 70.00861],
              [19.689720000000136, 69.99971],
              [19.69194, 69.994720000000143],
              [19.68666, 69.982498],
              [19.681389, 69.97583],
              [19.509441, 69.902222000000108],
              [19.41111, 69.835541],
              [19.395, 69.827774],
              [19.34944, 69.816376000000105],
              [19.287777, 69.804993],
              [19.179722, 69.791931],
              [19.13499800000011, 69.789444],
              [19.118889, 69.789444],
              [19.099720000000104, 69.791382000000112],
              [19.089996, 69.795],
              [19.065552, 69.81972],
              [19.063053, 69.82471],
              [19.041664000000139, 69.837219],
              [19.032219000000111, 69.84111],
              [18.955276, 69.870270000000119],
              [18.931389, 69.876663],
              [18.888054, 69.88472],
              [18.848888, 69.893051000000128],
              [18.769444, 69.91026],
              [18.7575, 69.913605],
              [18.738052, 69.920822],
              [18.73083, 69.924988],
              [18.721107000000131, 69.934158000000139],
              [18.721107000000131, 69.93999],
              [18.725, 69.945267],
              [18.835552000000121, 70.006104],
              [18.85555, 70.013611],
              [18.876942, 70.020264],
              [18.946388, 70.027771],
              [19.009998, 70.027222],
              [19.054443, 70.020264],
              [19.111111, 70.059998],
              [19.153332, 70.083054000000118],
              [19.16166, 70.085831],
              [19.21917, 70.096375],
              [19.23139, 70.093048000000124],
              [19.301666, 70.059998],
              [19.29139, 70.046936],
              [19.28889, 70.040833000000134],
              [19.29361, 70.030548],
              [19.300552, 70.02611],
            ],
          ],
          [
            [
              [18.785, 70.111374000000126],
              [18.79722, 70.102493],
              [18.936665000000119, 70.12027],
              [18.944721, 70.11749],
              [18.998055, 70.088882],
              [19.002777, 70.084152],
              [19.000275, 70.078049],
              [18.99389, 70.07222],
              [18.97055, 70.05722],
              [18.95833, 70.054993],
              [18.943333000000109, 70.05415],
              [18.908886000000109, 70.054993],
              [18.879997, 70.05249],
              [18.839165, 70.047485],
              [18.828609, 70.04416],
              [18.793053, 70.026657000000114],
              [18.785275, 70.021942],
              [18.772499, 70.010269],
              [18.764721, 70.005264],
              [18.746387000000141, 69.996933000000126],
              [18.73555, 69.993607],
              [18.708611, 69.990265000000136],
              [18.691666, 69.992493],
              [18.684444, 69.996658],
              [18.680832, 70.003326],
              [18.658886, 70.04388],
              [18.71027800000013, 70.125549],
              [18.714443000000131, 70.130829000000119],
              [18.7280540000001, 70.132492],
              [18.74361, 70.131104000000107],
              [18.753330000000119, 70.12749],
              [18.785, 70.111374000000126],
            ],
          ],
          [
            [
              [20.91972, 70.07944],
              [20.893608, 70.075546],
              [20.865555, 70.076935000000105],
              [20.82944, 70.09111],
              [20.822498, 70.095276],
              [20.815552, 70.099716000000114],
              [20.81361, 70.10472],
              [20.81472, 70.116104],
              [20.817776, 70.122208],
              [20.828888, 70.135269000000108],
              [20.842499, 70.146652000000131],
              [20.85083, 70.151657],
              [20.86138, 70.149155000000121],
              [20.86833, 70.144989],
              [20.87278, 70.14027],
              [20.89583, 70.128052],
              [20.914719, 70.120544],
              [20.926666, 70.117218],
              [20.935833, 70.113602],
              [20.94278, 70.10916],
              [20.94472, 70.104156000000103],
              [20.937775000000101, 70.098328],
              [20.926666, 70.085266],
              [20.91972, 70.07944],
            ],
          ],
          [
            [
              [19.6075, 70.101944],
              [19.581665, 70.098053],
              [19.53194, 70.098328],
              [19.501942, 70.102219000000105],
              [19.364166, 70.12305],
              [19.354443, 70.126663],
              [19.34972, 70.131378],
              [19.3525, 70.13749700000011],
              [19.358887, 70.143326000000116],
              [19.365555, 70.149155000000121],
              [19.393055, 70.17139],
              [19.400833, 70.17638],
              [19.41333, 70.178604000000121],
              [19.431389000000138, 70.177765000000136],
              [19.443333, 70.174713],
              [19.594719000000111, 70.130829000000119],
              [19.60416, 70.126938],
              [19.611385, 70.12277],
              [19.616108, 70.118332000000123],
              [19.618332, 70.113052],
              [19.61555, 70.106934000000138],
              [19.6075, 70.101944],
            ],
          ],
          [
            [
              [20.831944000000135, 70.19388],
              [20.79472, 70.059708],
              [20.783886, 70.05638],
              [20.738331, 70.054443],
              [20.650555, 70.046661],
              [20.609444, 70.042221],
              [20.562775, 70.076385],
              [20.526943, 70.060547],
              [20.515831000000105, 70.057495000000131],
              [20.499443, 70.057495000000131],
              [20.467499, 70.059158],
              [20.450554, 70.061386],
              [20.436108000000104, 70.064163],
              [20.424442000000113, 70.06749],
              [20.398331, 70.079163],
              [20.389442, 70.088608000000136],
              [20.385277, 70.09887700000013],
              [20.38583, 70.10443],
              [20.401108, 70.146378],
              [20.406944, 70.1586],
              [20.42333200000013, 70.178329],
              [20.429996000000131, 70.184158],
              [20.554165, 70.22555],
              [20.57777, 70.23111],
              [20.684719, 70.235825],
              [20.71639, 70.236374],
              [20.752499, 70.234161],
              [20.766941, 70.231384],
              [20.778889000000106, 70.228333000000134],
              [20.807220000000143, 70.216934],
              [20.816666000000112, 70.21304],
              [20.82361, 70.208878000000141],
              [20.832497, 70.199432],
              [20.831944000000135, 70.19388],
            ],
          ],
          [
            [
              [19.185276000000101, 70.122498],
              [19.141388, 70.119431],
              [19.040833000000134, 70.156937],
              [19.033607, 70.161102],
              [19.039997, 70.166931],
              [19.135277, 70.246109000000104],
              [19.202221, 70.257217],
              [19.218887, 70.257217],
              [19.23361, 70.25444],
              [19.248055, 70.246109000000104],
              [19.260830000000112, 70.17805],
              [19.258053, 70.17193600000013],
              [19.237778, 70.13971],
              [19.23278, 70.133331],
              [19.22333, 70.129166],
              [19.212498, 70.125824],
              [19.185276000000101, 70.122498],
            ],
          ],
          [
            [
              [20.11278, 70.10472],
              [20.014442, 70.061935000000119],
              [19.988331, 70.058044],
              [19.93222, 70.05249],
              [19.91528, 70.054993],
              [19.83416, 70.06248],
              [19.802498, 70.061661],
              [19.784443000000124, 70.06248],
              [19.77, 70.065277],
              [19.755833, 70.07361],
              [19.75111, 70.078323],
              [19.74889, 70.083603],
              [19.74694, 70.09444],
              [19.747776000000101, 70.111374000000126],
              [19.748055, 70.116943000000106],
              [19.750832, 70.12305],
              [19.75111, 70.1286],
              [19.74889, 70.133881],
              [19.706944, 70.175827],
              [19.680832, 70.193054],
              [19.659164, 70.205551],
              [19.639999000000103, 70.212769],
              [19.627777, 70.21611],
              [19.569443, 70.226944000000117],
              [19.545277, 70.233322000000101],
              [19.535831, 70.24277],
              [19.53611, 70.248322],
              [19.58, 70.26694],
              [19.590832, 70.270264000000111],
              [19.673611000000108, 70.287766000000147],
              [19.683331, 70.283875],
              [19.787777, 70.209442],
              [19.7925, 70.204712],
              [19.796665, 70.194443],
              [19.84639, 70.173050000000103],
              [19.984444, 70.141937],
              [20.068886, 70.124985],
              [20.11972, 70.118042000000116],
              [20.11278, 70.10472],
            ],
          ],
          [
            [
              [21.772778, 70.266663],
              [21.750275, 70.260269],
              [21.73222, 70.26138],
              [21.714165, 70.269714],
              [21.69722, 70.288605000000132],
              [21.691109, 70.298325],
              [21.684166000000118, 70.319153],
              [21.68639, 70.33583],
              [21.697777, 70.381943],
              [21.706387, 70.386658],
              [21.720276, 70.388046000000145],
              [21.735832, 70.386658],
              [21.747776, 70.383331000000112],
              [21.831944000000135, 70.354156],
              [21.841389, 70.350266],
              [21.844719, 70.34],
              [21.841389, 70.333878],
              [21.829720000000123, 70.320831],
              [21.779999, 70.272217],
              [21.772778, 70.266663],
            ],
          ],
          [
            [
              [22.834721, 70.332214],
              [22.89139, 70.322495],
              [22.906944000000124, 70.32304],
              [22.948055, 70.319153],
              [23.013611000000139, 70.274155],
              [23.021385000000123, 70.264709],
              [23.022778, 70.25943],
              [23.0191650000001, 70.253326],
              [23.00916, 70.249435000000119],
              [22.976109000000122, 70.245819],
              [22.92222, 70.24971],
              [22.86972, 70.252487],
              [22.841663, 70.24971],
              [22.79555, 70.248322],
              [22.778889, 70.2486],
              [22.638885, 70.26221],
              [22.573330000000112, 70.269165],
              [22.46861, 70.286652],
              [22.43777, 70.29193],
              [22.419167, 70.299713000000111],
              [22.372498000000121, 70.32971],
              [22.368610000000103, 70.33444],
              [22.37944, 70.3461],
              [22.472221, 70.374985],
              [22.48638, 70.376389],
              [22.664444, 70.39138800000012],
              [22.68111, 70.390823],
              [22.687775000000101, 70.386658],
              [22.693333, 70.37666],
              [22.69805, 70.361099],
              [22.834721, 70.332214],
            ],
          ],
          [
            [
              [23.595833, 70.57805],
              [23.653053, 70.501389000000131],
              [23.659443000000124, 70.462494],
              [23.656944000000124, 70.45111],
              [23.643887, 70.43832],
              [23.539719, 70.389435],
              [23.34528, 70.308884],
              [23.230553, 70.27832],
              [23.217777, 70.276108000000136],
              [23.156387, 70.274429000000112],
              [23.120277, 70.278885],
              [23.091942, 70.284988],
              [23.082775, 70.288879],
              [22.851109, 70.405823],
              [22.896111000000133, 70.44832],
              [22.906387, 70.452209],
              [23.178608, 70.544708],
              [23.189999, 70.547775000000115],
              [23.20444, 70.549164],
              [23.22389, 70.547211],
              [23.23555, 70.543610000000115],
              [23.253887, 70.53583],
              [23.260555, 70.531662],
              [23.406666, 70.555267],
              [23.400833, 70.60165400000011],
              [23.387775, 70.610275],
              [23.38639, 70.61555],
              [23.388885, 70.62027],
              [23.403332, 70.621658],
              [23.46833, 70.621658],
              [23.487778, 70.61972],
              [23.53861, 70.61194],
              [23.591942000000131, 70.583054],
              [23.595833, 70.57805],
            ],
          ],
          [
            [
              [23.871109, 70.512207000000103],
              [23.84, 70.511383000000137],
              [23.804996, 70.513046],
              [23.77138, 70.516098],
              [23.757221, 70.5191650000001],
              [23.749443, 70.522217],
              [23.727497, 70.534714],
              [23.714443, 70.543320000000108],
              [23.708054, 70.547775000000115],
              [23.704166, 70.552490000000148],
              [23.63277, 70.690552],
              [23.634163000000115, 70.696381],
              [23.688889, 70.739716],
              [23.698055000000124, 70.74472],
              [23.707222000000115, 70.747208],
              [23.739998, 70.747208],
              [23.80805, 70.74527],
              [23.826385, 70.744156],
              [23.83694, 70.74138],
              [23.973610000000122, 70.7025],
              [24.03083, 70.686096000000134],
              [24.04, 70.681931000000134],
              [24.121944, 70.619995000000131],
              [24.125832000000116, 70.615265],
              [24.123055, 70.604156],
              [24.121387, 70.598602],
              [24.114998, 70.592209],
              [24.10555, 70.587219],
              [23.952774, 70.522491000000116],
              [23.93972, 70.520264],
              [23.899719, 70.51471],
              [23.871109, 70.512207000000103],
            ],
          ],
          [
            [
              [23.451664, 70.7836],
              [23.4, 70.736374],
              [23.386944, 70.73416],
              [23.373608000000104, 70.736099],
              [23.300831, 70.708878],
              [23.180832, 70.650833],
              [23.08889, 70.5811],
              [22.898888, 70.536102],
              [22.784164, 70.519714],
              [22.76722, 70.519989],
              [22.763332, 70.524719],
              [22.761665000000107, 70.53],
              [22.765274, 70.536102],
              [22.77277800000013, 70.541656000000103],
              [22.775276, 70.546387],
              [22.766109, 70.550278000000105],
              [22.746387, 70.556656],
              [22.731941, 70.55971],
              [22.640831000000105, 70.565552000000139],
              [22.629166, 70.562485],
              [22.62833, 70.556931],
              [22.630276, 70.540833],
              [22.63499800000011, 70.525543],
              [22.631386, 70.51944],
              [22.621109, 70.515274],
              [22.465553, 70.495819],
              [22.451385, 70.494431000000134],
              [22.340553, 70.490265],
              [22.324997, 70.48999],
              [22.30944, 70.491379],
              [22.297497, 70.49472],
              [22.290833, 70.499161000000129],
              [22.250000000000114, 70.5061],
              [22.163887, 70.463608000000136],
              [22.149441, 70.464432000000102],
              [22.14027, 70.468048000000124],
              [22.138611, 70.473328],
              [22.138332, 70.477768],
              [22.155277, 70.51249700000011],
              [22.16111, 70.518875],
              [22.16861, 70.524429],
              [22.22583, 70.53999],
              [22.252220000000136, 70.554443000000106],
              [22.26044, 70.590714],
              [22.264942, 70.59405],
              [22.267776, 70.597214000000122],
              [22.23111, 70.59922],
              [22.221609000000115, 70.598877],
              [22.142443, 70.59288],
              [22.09583, 70.599152],
              [22.08444, 70.5961],
              [22.01472, 70.604431],
              [21.95138500000013, 70.640823],
              [21.949718, 70.646103],
              [21.953053000000125, 70.652222000000108],
              [21.960552000000121, 70.657776000000126],
              [21.977497, 70.657486000000119],
              [22.14811, 70.65271],
              [22.163443, 70.645546],
              [22.17444, 70.64488],
              [22.21027400000014, 70.646049],
              [22.27244, 70.652878],
              [22.378052, 70.675278],
              [22.373055, 70.69083],
              [22.380276, 70.702774],
              [22.387775, 70.708603],
              [22.399166, 70.711655000000121],
              [22.52083, 70.711929],
              [22.533886, 70.711929],
              [22.55083100000013, 70.70944],
              [22.617775, 70.693329000000119],
              [22.65611, 70.683609],
              [22.66139, 70.679993],
              [22.664165, 70.676376],
              [22.657776, 70.671936],
              [22.611664, 70.659714],
              [22.59389, 70.649994],
              [22.592777000000126, 70.644440000000145],
              [22.596943, 70.639709],
              [22.60611, 70.63582],
              [22.624443, 70.63472],
              [22.707775, 70.63582],
              [22.805275000000108, 70.640549],
              [22.81944, 70.64194],
              [22.828331000000105, 70.646652],
              [22.799442000000113, 70.69083],
              [22.7925, 70.694992],
              [22.762218, 70.7061],
              [22.732777, 70.72276],
              [22.72583, 70.726944],
              [22.717777, 70.736374],
              [22.716110000000128, 70.741653],
              [22.7225, 70.743881],
              [22.783607000000131, 70.755264],
              [22.864441, 70.728882],
              [22.89583, 70.694153],
              [22.897221000000116, 70.688889000000131],
              [22.945000000000107, 70.66666],
              [22.96361, 70.658875],
              [22.98055, 70.6586],
              [22.992222, 70.661652],
              [23.10639, 70.73416],
              [23.160000000000139, 70.788605],
              [23.282776, 70.771942],
              [23.298611, 70.770264],
              [23.340275, 70.7836],
              [23.348053, 70.789154],
              [23.34417, 70.793884],
              [23.335, 70.797775],
              [23.322777, 70.81193],
              [23.321388, 70.817215],
              [23.31416, 70.853882],
              [23.318054, 70.859985],
              [23.329998000000103, 70.863052],
              [23.343052, 70.863052],
              [23.35639, 70.860825],
              [23.368053, 70.857498],
              [23.377499, 70.853607],
              [23.441109, 70.81221],
              [23.451664, 70.7836],
            ],
          ],
          [
            [
              [24.06194, 70.908875],
              [24.046108, 70.908325],
              [24.026386, 70.910553],
              [23.909443, 70.950821],
              [23.879444, 70.98805],
              [23.880833, 70.993607],
              [23.92333200000013, 71.01555],
              [23.934166, 71.01944],
              [23.97389, 71.025833000000148],
              [23.988609, 71.026932000000102],
              [24.062775000000101, 71.02388],
              [24.078609000000142, 71.022217],
              [24.2225, 70.994720000000143],
              [24.243889, 70.951935],
              [24.167774000000122, 70.925827],
              [24.092220000000111, 70.912491000000102],
              [24.06194, 70.908875],
            ],
          ],
          [
            [
              [24.799442, 71.02388],
              [24.768887, 71.022217],
              [24.737499, 71.028046],
              [24.667774, 71.043884000000105],
              [24.656109000000129, 71.047485],
              [24.646942000000138, 71.051376],
              [24.64055, 71.05583],
              [24.639442, 71.060822],
              [24.641109000000142, 71.066376],
              [24.648052, 71.07304],
              [24.726387, 71.099991000000102],
              [24.738609, 71.103043],
              [24.75333, 71.104431],
              [24.770554000000118, 71.103882],
              [24.84861, 71.093307],
              [24.853611000000114, 71.089981],
              [24.8475, 71.07387],
              [24.81472, 71.0336],
              [24.807777000000101, 71.027222000000108],
              [24.799442, 71.02388],
            ],
          ],
          [
            [
              [5.336944, 61.592773],
              [5.34111, 61.589165],
              [5.291166, 61.591827],
              [5.283333000000141, 61.591496],
              [5.277166, 61.590328],
              [5.276833, 61.587997],
              [5.282, 61.586163],
              [5.297500000000127, 61.585163],
              [5.331333, 61.58483],
              [5.339166, 61.585163],
              [5.345333, 61.58633],
              [5.346499000000108, 61.589996],
              [5.336944, 61.592773],
              [5.320333, 61.598328],
              [5.296333, 61.603661000000102],
              [5.282666, 61.605663],
              [5.266999000000112, 61.606659],
              [5.234999, 61.608498000000111],
              [5.194833000000131, 61.607498000000135],
              [5.118055, 61.60999],
              [5.234722, 61.621941],
              [5.23222, 61.627495],
              [5.191667, 61.62694],
              [5.117777, 61.62722],
              [4.997499, 61.627777],
              [4.982778, 61.628052000000139],
              [4.974444, 61.62944],
              [4.967222, 61.633049],
              [4.96333, 61.638054],
              [4.939166, 61.671387],
              [4.938055000000134, 61.67638],
              [4.941388, 61.681664],
              [4.965555, 61.719162],
              [4.978333000000134, 61.736938],
              [4.983055, 61.741661],
              [4.991944000000103, 61.744438000000116],
              [5.067778, 61.768051],
              [5.28111, 61.8555530000001],
              [5.355, 61.903328000000101],
              [5.364166000000125, 61.90583],
              [5.41, 61.911385],
              [5.424444, 61.91111],
              [5.595833, 61.895271],
              [5.672222, 61.882217],
              [5.680833, 61.879166],
              [5.70167, 61.868607],
              [5.744721, 61.842216],
              [5.987499, 61.83028],
              [6.061944, 61.830551],
              [6.23222, 61.836937],
              [6.246666000000118, 61.836662000000103],
              [6.259722, 61.835548],
              [6.294444, 61.830551],
              [6.304166, 61.828331],
              [6.321111, 61.822495000000117],
              [6.335, 61.815277],
              [6.34333, 61.812218000000144],
              [6.353333000000134, 61.809998000000121],
              [6.40083, 61.80389],
              [6.469166, 61.800827],
              [6.50917, 61.805832],
              [6.518332, 61.80861],
              [6.53361, 61.814995],
              [6.546111, 61.823051000000135],
              [6.546944, 61.82972],
              [6.546111, 61.8361],
              [6.546944, 61.841660000000104],
              [6.549166, 61.847771000000137],
              [6.55389, 61.852493],
              [6.560277, 61.856384000000105],
              [6.583611, 61.866661],
              [6.593888, 61.868607],
              [6.6175, 61.870827],
              [6.630833000000109, 61.871109],
              [6.658333000000141, 61.86972],
              [6.68305, 61.866943],
              [6.7175, 61.861938000000123],
              [6.73889, 61.857773000000122],
              [6.763611000000139, 61.86805],
              [6.687778, 61.88194],
              [6.65167, 61.884995],
              [6.604444, 61.882217],
              [6.567499, 61.87971],
              [6.549166, 61.874718],
              [6.541666000000134, 61.871384],
              [6.53528, 61.867493],
              [6.530277, 61.862778],
              [6.521944, 61.852493],
              [6.518332, 61.847221000000104],
              [6.51611, 61.84083],
              [6.508888, 61.829994000000113],
              [6.501389, 61.82694],
              [6.490833, 61.824997],
              [6.422777, 61.828888],
              [6.38361, 61.83194],
              [6.349166000000139, 61.836937],
              [6.219444, 61.853882],
              [5.95128, 61.869606],
              [5.93461, 61.869442],
              [5.911278, 61.86411],
              [5.900444, 61.861107000000118],
              [5.810277, 61.857498],
              [5.801389, 61.854721],
              [5.788333, 61.855827],
              [5.76444, 61.865273],
              [5.75028, 61.872498],
              [5.726944, 61.887215],
              [5.73, 61.889999],
              [5.761389, 61.895554000000118],
              [5.796666, 61.899162],
              [5.808777000000134, 61.90322],
              [5.832611, 61.904053],
              [5.84044, 61.903389],
              [5.866777, 61.902885],
              [5.881777, 61.903717000000142],
              [5.893444000000102, 61.906387],
              [5.891944000000137, 61.908886],
              [5.884944, 61.909882],
              [5.86928, 61.911049],
              [5.834277, 61.91188],
              [5.78222, 61.91528],
              [5.534166, 61.926941],
              [5.433611, 61.934998],
              [5.398333, 61.931389],
              [5.387777, 61.929443000000106],
              [5.32083, 61.913605],
              [5.289721, 61.907776],
              [5.161111, 61.892776],
              [5.148055, 61.892220000000123],
              [5.103889, 61.909996],
              [5.101388, 61.915833],
              [5.104722, 61.921104],
              [5.137221000000125, 61.966110000000128],
              [5.141944000000137, 61.970833],
              [5.149444, 61.97416],
              [5.159721, 61.974716],
              [5.166666000000134, 61.971107],
              [5.187778, 61.956383],
              [5.220277, 61.961388],
              [5.3975, 62.01221],
              [5.40361, 62.016106],
              [5.401111, 62.02166],
              [5.394166, 62.025276],
              [5.278889, 62.074715],
              [5.206666, 62.09666],
              [5.186388, 62.101105],
              [5.115833, 62.103607],
              [5.098611000000119, 62.10805],
              [5.09305, 62.112221],
              [5.07361, 62.153053],
              [5.074166000000105, 62.158607],
              [5.0783330000001, 62.17805],
              [5.08167, 62.183327],
              [5.086389, 62.186661],
              [5.150277, 62.211937],
              [5.160832, 62.213882000000126],
              [5.1725, 62.212219],
              [5.193889, 62.201660000000118],
              [5.247777, 62.171661],
              [5.446666, 62.057495],
              [5.463333, 62.044716],
              [5.47111, 62.035],
              [5.470555, 62.028053],
              [5.462723, 62.00938],
              [5.46444, 62.005554],
              [5.473332000000141, 62.008049],
              [5.491128, 62.020248],
              [5.501666, 62.03027],
              [5.548333, 62.078331000000105],
              [5.51111, 62.089996],
              [5.463055, 62.09583],
              [5.4225, 62.10472],
              [5.38944, 62.116943000000106],
              [5.385555, 62.121941000000106],
              [5.38444, 62.128052],
              [5.415, 62.175827],
              [5.4225, 62.179161],
              [5.431666, 62.18166],
              [5.455555000000118, 62.184166],
              [5.48361100000011, 62.184166],
              [5.683332, 62.17222],
              [5.845277, 62.198051000000135],
              [5.85861, 62.198326000000122],
              [5.88194, 62.195000000000107],
              [5.89055, 62.192215],
              [5.911666, 62.181389000000138],
              [5.91722, 62.17722],
              [5.921111, 62.17222],
              [5.923611, 62.166664],
              [5.925278, 62.15416],
              [5.924722, 62.14722],
              [5.919999, 62.11360900000011],
              [5.950277, 62.106667],
              [6.042222, 62.09861],
              [6.262221, 62.075554],
              [6.270833, 62.072495],
              [6.277778, 62.068886],
              [6.281666, 62.064163],
              [6.286944000000119, 62.059715],
              [6.295555, 62.056938],
              [6.305833, 62.055832],
              [6.357222, 62.055275000000108],
              [6.365, 62.058609000000104],
              [6.36389, 62.063332],
              [6.355556, 62.066383],
              [6.275, 62.084999],
              [6.265, 62.087219000000118],
              [6.251944, 62.088333],
              [6.175833000000125, 62.094162],
              [6.123055, 62.09666],
              [6.098611000000119, 62.10139],
              [6.089999, 62.104439],
              [6.08305, 62.10805],
              [5.925278, 62.198883],
              [5.919722, 62.203331],
              [5.9175, 62.208885],
              [5.918056, 62.21583],
              [5.946666000000107, 62.251663],
              [5.951666000000102, 62.256386],
              [5.976944000000117, 62.272499],
              [6.00861, 62.2925],
              [6.024166, 62.298882000000106],
              [6.051666, 62.306664],
              [6.284166000000141, 62.368889000000138],
              [6.294722, 62.370827],
              [6.306666, 62.371666],
              [6.316944, 62.369438000000116],
              [6.323889, 62.365829],
              [6.463333, 62.247215],
              [6.478055, 62.233887],
              [6.549722, 62.16555],
              [6.563055, 62.15166],
              [6.565277, 62.146111000000133],
              [6.564444, 62.13916],
              [6.554444000000103, 62.12971],
              [6.53528, 62.117775],
              [6.530277, 62.113052],
              [6.529444, 62.10611],
              [6.53805, 62.10472],
              [6.581944000000135, 62.125549],
              [6.58833, 62.129440000000102],
              [6.590555000000109, 62.135551],
              [6.58611100000013, 62.146942000000138],
              [6.572222, 62.167221],
              [6.48555, 62.260551],
              [6.474722, 62.268883],
              [6.445833, 62.289719000000105],
              [6.42333, 62.300552],
              [6.41806, 62.304993000000138],
              [6.40861, 62.314163],
              [6.388333, 62.34499],
              [6.38611, 62.35055],
              [6.385278, 62.35694100000012],
              [6.38611, 62.363609],
              [6.388333, 62.369720000000143],
              [6.391944, 62.375275],
              [6.396944, 62.379997000000117],
              [6.403333, 62.383888],
              [6.411111, 62.38721],
              [6.429444, 62.39222],
              [6.69667, 62.44527],
              [6.709999, 62.44444],
              [6.867499, 62.41805],
              [6.876111, 62.414993],
              [6.883055, 62.411385],
              [6.88528, 62.40583],
              [6.884444, 62.398888],
              [6.873333, 62.382500000000107],
              [6.87111, 62.376389],
              [6.870277000000101, 62.369720000000143],
              [6.871666, 62.357216000000108],
              [6.879167, 62.347221],
              [6.92611, 62.30805],
              [6.940000000000111, 62.300552],
              [6.967222, 62.29222],
              [6.980833, 62.284996],
              [6.99, 62.275833],
              [6.996111, 62.265274],
              [7.000555, 62.254166],
              [7.008888000000127, 62.205551],
              [7.010278, 62.193054],
              [7.009166, 62.186104],
              [7.001944, 62.175278],
              [6.988889, 62.167496],
              [6.973332, 62.16111],
              [6.947499000000107, 62.145271],
              [6.942499000000112, 62.140549],
              [6.938333, 62.130829000000119],
              [6.937499000000116, 62.124161000000129],
              [6.938055, 62.117775],
              [6.940277, 62.112221],
              [6.944166, 62.107216],
              [6.956111000000135, 62.09861],
              [6.97, 62.091385],
              [6.978333, 62.088333],
              [7.003055000000131, 62.085548],
              [7.017777, 62.084999],
              [7.04306, 62.086388000000113],
              [7.064166, 62.089996],
              [7.073333, 62.0925],
              [7.090278, 62.098053],
              [7.084722, 62.110832],
              [7.069166, 62.104439],
              [7.059999, 62.101944],
              [7.038888, 62.09833],
              [7.010833000000105, 62.09833],
              [6.98222, 62.10611],
              [6.97, 62.114166],
              [6.967777000000126, 62.11972],
              [6.968888, 62.126663],
              [6.973888, 62.131386],
              [6.994721000000141, 62.143051],
              [7.0025, 62.146385],
              [7.02167, 62.158051],
              [7.03194, 62.167496],
              [7.03639, 62.179993],
              [7.038333000000137, 62.193604],
              [7.03639, 62.212219],
              [7.03194, 62.223610000000122],
              [7.023333, 62.258888000000127],
              [7.022778, 62.265274],
              [7.027778, 62.269722],
              [7.037222, 62.272217],
              [7.10417, 62.273888000000113],
              [7.293056, 62.278328000000101],
              [7.306389000000138, 62.277222000000108],
              [7.326388, 62.272499],
              [7.335, 62.269440000000145],
              [7.341944000000126, 62.26583],
              [7.362499, 62.254715],
              [7.388888000000122, 62.23333],
              [7.395833, 62.229721],
              [7.414721, 62.226944000000117],
              [7.41555, 62.232498000000135],
              [7.399166, 62.251663],
              [7.393888000000118, 62.255829],
              [7.362499, 62.276108000000136],
              [7.338611, 62.284439],
              [7.316944, 62.288605],
              [7.28889, 62.290276],
              [7.276944000000128, 62.28916],
              [7.23444400000011, 62.282219],
              [7.211666, 62.279442],
              [7.185, 62.278885],
              [7.171666, 62.28],
              [6.975277, 62.309998],
              [6.962777000000131, 62.316666],
              [6.9575, 62.320831],
              [6.917777, 62.356667],
              [6.915277, 62.36222],
              [6.923333, 62.365273000000116],
              [6.933888000000138, 62.366943],
              [6.959444, 62.368332],
              [6.97, 62.370277],
              [6.973611, 62.374161],
              [6.968055, 62.378609],
              [6.908055, 62.418884],
              [6.855277000000115, 62.44944],
              [6.791666, 62.476105000000132],
              [6.781388, 62.478333],
              [6.680833, 62.469608],
              [6.6745, 62.46844],
              [6.664999000000137, 62.464607],
              [6.647, 62.45644],
              [6.547777, 62.43555],
              [6.515833, 62.429993],
              [6.393888000000118, 62.419441],
              [6.380555, 62.418884],
              [6.367222, 62.419998000000135],
              [6.257222, 62.44888],
              [6.254167000000109, 62.463333],
              [6.37, 62.48416],
              [6.436666, 62.493332000000123],
              [6.49833, 62.49694],
              [6.51194, 62.497215],
              [6.588888, 62.49249],
              [6.618833, 62.494217],
              [6.644000000000119, 62.494385],
              [6.649499, 62.495884],
              [6.649833000000115, 62.498383],
              [6.631944, 62.512772],
              [6.556110000000103, 62.529716],
              [6.542777, 62.53083],
              [6.499444, 62.531105000000139],
              [6.458888, 62.530273],
              [6.314722, 62.524162],
              [6.2675, 62.529442],
              [6.248055000000136, 62.56972],
              [6.246944, 62.57471],
              [6.251944, 62.579437],
              [6.265, 62.587219],
              [6.288333, 62.597221],
              [6.306944, 62.602219],
              [6.325555, 62.60666700000013],
              [6.339167, 62.60889],
              [6.54361, 62.612221],
              [6.55694, 62.611107000000118],
              [6.565555, 62.60833],
              [6.601666, 62.583885],
              [6.704166, 62.636383],
              [6.735833, 62.649437],
              [6.757222, 62.652771],
              [6.964167, 62.649994],
              [7.089999, 62.64777400000014],
              [7.363333, 62.586105],
              [7.50694, 62.543053],
              [7.515277, 62.53999],
              [7.52083, 62.535553000000107],
              [7.524444, 62.530548],
              [7.539166, 62.499161000000129],
              [7.569722000000127, 62.542221],
              [7.575, 62.54694400000011],
              [7.584167, 62.549438],
              [7.594999, 62.55110900000011],
              [7.681389000000138, 62.557220000000143],
              [7.779722, 62.571938],
              [7.765555, 62.577774],
              [7.737499, 62.579437],
              [7.723888, 62.579163000000108],
              [7.606667, 62.568604],
              [7.583888, 62.566109],
              [7.551666, 62.560829],
              [7.524444, 62.560272000000111],
              [7.49778, 62.562492],
              [7.474444000000119, 62.566109],
              [7.45722, 62.572220000000129],
              [7.450277000000142, 62.575829000000113],
              [7.418888, 62.595551],
              [7.415, 62.60055],
              [7.40861, 62.617218],
              [7.409444, 62.622772],
              [7.414721, 62.627495],
              [7.522778, 62.666664],
              [7.601944, 62.69194],
              [7.63028, 62.699165],
              [7.780277, 62.723885],
              [7.791111, 62.725555],
              [7.825, 62.729721],
              [7.863055, 62.73194100000012],
              [7.9875, 62.73722],
              [8.00111, 62.736107],
              [8.01111, 62.733604],
              [8.067221, 62.717216],
              [8.08417, 62.711105],
              [8.115, 62.697495],
              [8.12861, 62.689995000000124],
              [8.13722, 62.686943],
              [8.145277000000135, 62.689995000000124],
              [8.144999, 62.696388],
              [8.14277600000014, 62.701942],
              [8.139166, 62.70694],
              [8.12861, 62.715553],
              [8.115, 62.72305],
              [8.04639, 62.75388],
              [7.999722, 62.76388500000013],
              [7.692499000000112, 62.731667],
              [7.669444, 62.72888],
              [7.556389, 62.69944],
              [7.540277000000117, 62.693054000000132],
              [7.523055, 62.68749],
              [7.494721, 62.67999],
              [7.482499, 62.679161],
              [7.4675, 62.67944],
              [7.389999, 62.68333],
              [7.367777000000103, 62.726105],
              [7.45361, 62.755272],
              [7.49111, 62.76527],
              [7.541111, 62.77583],
              [7.589999, 62.779999],
              [7.64055, 62.783051],
              [7.651388, 62.784721],
              [7.68111, 62.791382000000112],
              [7.640833, 62.794716],
              [7.625833000000114, 62.79527],
              [7.61361, 62.794441],
              [7.462777, 62.777222],
              [7.453333, 62.774719],
              [7.437222, 62.768326],
              [7.421389, 62.76194],
              [7.414721, 62.758049],
              [7.395833, 62.753052000000139],
              [7.326666000000102, 62.74472],
              [7.2033330000001, 62.735550000000103],
              [6.985833, 62.72166],
              [6.972221000000104, 62.721382],
              [6.958888, 62.722496],
              [6.950277, 62.725555],
              [6.97435, 62.798889],
              [6.991991, 62.85655],
              [6.938333, 62.9061],
              [6.949444, 62.93139],
              [7.03639, 62.967499],
              [7.090278, 62.98389],
              [7.11055, 62.98805],
              [7.258333, 63.01194],
              [7.271944000000133, 63.010826000000122],
              [7.29805, 63.001938000000109],
              [7.38111, 62.957222000000115],
              [7.441667, 62.916664],
              [7.44861, 62.912773000000129],
              [7.460555, 62.91111],
              [7.474166, 62.911385],
              [7.52083, 62.917496000000142],
              [7.568055, 62.929718],
              [7.583055, 62.93694],
              [7.59889, 62.95083],
              [7.60556, 62.95499],
              [7.620277000000101, 62.96194],
              [7.648889, 62.969162],
              [7.681666, 62.974442],
              [7.718611, 62.977219],
              [7.747499, 62.97694],
              [7.77277800000013, 62.9741590000001],
              [7.781388, 62.971107],
              [7.786666, 62.966660000000104],
              [7.78417, 62.960548000000131],
              [7.778889, 62.955826],
              [7.765555, 62.948051000000135],
              [7.749166, 62.94167],
              [7.73166700000013, 62.936104],
              [7.713888, 62.93055],
              [7.695000000000107, 62.925552],
              [7.67889, 62.919167],
              [7.67222, 62.915276000000119],
              [7.666666, 62.91055],
              [7.676944, 62.90833],
              [7.73, 62.917496000000142],
              [7.89055500000012, 62.952217],
              [7.900277, 62.95472],
              [7.94361, 62.968887],
              [7.964167, 62.973053000000107],
              [7.977777, 62.973328],
              [7.991388, 62.971939],
              [8.001665, 62.969719000000111],
              [8.020277, 62.964165],
              [8.05639, 62.95166],
              [8.081944, 62.942497],
              [8.085833, 62.938889],
              [8.107498000000135, 62.91555],
              [8.111387, 62.91055],
              [8.109165, 62.898048],
              [8.109444, 62.89194],
              [8.14389, 62.828331],
              [8.149721000000113, 62.817772000000105],
              [8.161665, 62.80971],
              [8.175554, 62.80222],
              [8.184166000000118, 62.799164],
              [8.214443, 62.791939],
              [8.286665, 62.78166],
              [8.306944, 62.776665],
              [8.48944, 62.717216],
              [8.496111, 62.713333],
              [8.520277000000135, 62.69722],
              [8.532221, 62.689163],
              [8.537498, 62.684715],
              [8.54472, 62.674721],
              [8.548332, 62.653885],
              [8.57, 62.672493],
              [8.56944, 62.678604],
              [8.566666, 62.703049],
              [8.564722000000131, 62.708611000000133],
              [8.559444, 62.713051],
              [8.5525, 62.71666],
              [8.537222, 62.72361],
              [8.33139, 62.801941000000113],
              [8.32278, 62.804993],
              [8.300833000000125, 62.809441],
              [8.25055, 62.815277],
              [8.240276, 62.817772000000105],
              [8.197777, 62.833328],
              [8.183887000000141, 62.84083],
              [8.17861, 62.844994],
              [8.174444, 62.856384000000105],
              [8.168888, 62.88472],
              [8.17166, 62.890831000000105],
              [8.175554, 62.896385],
              [8.175833, 62.914444],
              [8.158888000000104, 62.93972],
              [8.155277000000126, 62.94472],
              [8.141388, 62.952217],
              [8.006109, 62.995827],
              [7.967777000000126, 63.004166000000112],
              [7.951666, 62.997772],
              [7.94055, 62.996109000000104],
              [7.90083, 62.994720000000143],
              [7.888888, 62.99638],
              [7.878888, 62.998886],
              [7.876666, 63.00444],
              [7.879167, 63.010551],
              [7.968055, 63.07666],
              [7.981667, 63.084442],
              [8.033609, 63.101944],
              [8.043055, 63.104439],
              [8.06361, 63.108330000000137],
              [8.077499000000103, 63.108604],
              [8.089443, 63.10694100000012],
              [8.10666700000013, 63.100555],
              [8.117222, 63.091942],
              [8.131666, 63.078331000000105],
              [8.135555, 63.073326],
              [8.135832, 63.06721],
              [8.127777, 63.056389],
              [8.126944, 63.050827],
              [8.128887, 63.045273000000122],
              [8.13278, 63.040276],
              [8.307499000000121, 62.937775000000101],
              [8.333332, 62.896660000000111],
              [8.357777, 62.880554000000132],
              [8.496944, 62.846107000000131],
              [8.517221, 62.84111],
              [8.530832, 62.841385],
              [8.538887, 62.844444],
              [8.541666, 62.850555],
              [8.54139, 62.856667],
              [8.536110000000122, 62.861107],
              [8.510555, 62.87055],
              [8.415833, 62.948051000000135],
              [8.415277, 62.953049000000135],
              [8.423332, 62.95611],
              [8.445276, 62.959442000000138],
              [8.471388, 62.960548000000131],
              [8.51667, 62.958611],
              [8.57166500000011, 62.959442000000138],
              [8.5975, 62.960274],
              [8.646944000000133, 62.963882000000126],
              [8.656666, 62.966385000000116],
              [8.66333, 62.970276],
              [8.666111, 62.976387],
              [8.66416, 62.981941],
              [8.653889000000106, 62.984444],
              [8.515276, 62.983055],
              [8.430555, 62.978607],
              [8.389444, 62.970551],
              [8.374443, 62.971107],
              [8.22639, 63.027771],
              [8.159443, 63.11388],
              [8.159166, 63.120277000000101],
              [8.165833, 63.124161000000129],
              [8.24, 63.145554],
              [8.25111, 63.147217000000126],
              [8.300833000000125, 63.150833],
              [8.315832, 63.150276000000133],
              [8.531944, 63.135826],
              [8.570833, 63.13916],
              [8.567221000000131, 63.144165],
              [8.568333000000109, 63.157219000000111],
              [8.56944, 63.162773],
              [8.574999000000105, 63.167221],
              [8.592777, 63.172775],
              [8.63139, 63.182495000000131],
              [8.722776, 63.186386],
              [8.76784, 63.192848],
              [8.804165, 63.195549],
              [8.938332, 63.20666],
              [8.94194, 63.20916],
              [8.871387, 63.209442],
              [8.824608, 63.207497],
              [8.625277, 63.19778],
              [8.615000000000123, 63.200272],
              [8.60805, 63.204163000000108],
              [8.48166700000013, 63.28999],
              [8.477777, 63.293610000000115],
              [8.534443, 63.308609],
              [8.54555, 63.310272000000111],
              [8.584444, 63.312218],
              [8.62611, 63.312775000000101],
              [8.65111, 63.314438],
              [8.671944, 63.318329],
              [8.759443, 63.339722],
              [8.763611, 63.345276],
              [8.751665, 63.346939000000134],
              [8.723888, 63.346664],
              [8.711943, 63.34861],
              [8.703054, 63.351662],
              [8.69611, 63.35555],
              [8.641943, 63.386108],
              [8.636665, 63.390274],
              [8.63611, 63.395271],
              [8.63889, 63.401382],
              [8.644444, 63.406105],
              [8.652777000000128, 63.409164],
              [8.67222, 63.413887],
              [8.737303000000111, 63.415916],
              [8.74111, 63.4180530000001],
              [8.750832, 63.420273000000122],
              [8.967777, 63.444717],
              [8.988333, 63.4611],
              [8.995277000000101, 63.465],
              [9.004999, 63.4675],
              [9.01528, 63.465],
              [9.06194, 63.44416],
              [9.075832, 63.436661],
              [9.108889, 63.417221],
              [9.11944, 63.408607000000131],
              [9.146111, 63.374161],
              [9.23139, 63.353882000000112],
              [9.373333, 63.368332],
              [9.408333000000141, 63.372498000000121],
              [9.427776, 63.37694],
              [9.461666, 63.38944],
              [9.478611, 63.40305],
              [9.472221, 63.401939],
              [9.395, 63.382774],
              [9.224998, 63.36805],
              [9.21417, 63.36777],
              [9.202221, 63.369720000000143],
              [9.167500000000132, 63.38721],
              [9.162222, 63.391388],
              [9.15, 63.479164],
              [9.149721000000113, 63.48416],
              [9.152498, 63.490273000000116],
              [9.156666, 63.49555],
              [9.16361, 63.49944],
              [9.242777, 63.534721],
              [9.252499, 63.53583],
              [9.327776, 63.539444],
              [9.416666, 63.533882],
              [9.46917, 63.56694],
              [9.492222, 63.586662000000103],
              [9.49778, 63.589996],
              [9.530277000000126, 63.60305],
              [9.53889, 63.60611],
              [9.6475, 63.623886],
              [9.717499, 63.630272000000105],
              [9.9566650000001, 63.440826],
              [9.959999, 63.435829],
              [9.961666, 63.430275000000108],
              [9.959999, 63.423332],
              [9.956944, 63.417221],
              [9.943333000000109, 63.393051],
              [9.976110000000119, 63.35611],
              [10.04055, 63.348053000000107],
              [10.152498, 63.319717],
              [10.254721, 63.290276000000119],
              [10.256666, 63.26111],
              [10.262777, 63.260826],
              [10.26861, 63.265274],
              [10.27277800000013, 63.270554000000118],
              [10.27472, 63.2775],
              [10.27916, 63.313889],
              [10.277498, 63.319443],
              [10.264166000000102, 63.333328],
              [10.257500000000107, 63.337219],
              [10.235277, 63.341942],
              [10.221666, 63.34333],
              [10.164721, 63.343887],
              [10.1225, 63.347496],
              [10.083332, 63.35833],
              [10.066387, 63.36472],
              [10.051388, 63.372498000000121],
              [10.04611, 63.37694],
              [10.042776, 63.381943],
              [10.041111, 63.387497],
              [10.041111, 63.393883],
              [10.04722, 63.406105],
              [10.064444, 63.419716],
              [10.078888, 63.427216000000101],
              [10.095833, 63.433327],
              [10.12528, 63.440277],
              [10.146387000000118, 63.44416],
              [10.2675, 63.462219000000118],
              [10.27861, 63.463608],
              [10.2925, 63.463608],
              [10.308054, 63.463051],
              [10.443333, 63.452499],
              [10.525555, 63.43417],
              [10.550833, 63.430832],
              [10.5775, 63.431664],
              [10.73778, 63.438889000000131],
              [10.855371, 63.443703],
              [10.889166, 63.44722],
              [10.910276, 63.45111],
              [10.916111, 63.455551000000128],
              [10.9147210000001, 63.4611],
              [10.906111, 63.46444],
              [10.885832, 63.469719],
              [10.874166, 63.47166],
              [10.860554, 63.473053],
              [10.818888000000129, 63.474716000000114],
              [10.805277, 63.476105],
              [10.781666, 63.48027],
              [10.775, 63.48416],
              [10.764721, 63.49305],
              [10.75999800000011, 63.503609],
              [10.75999800000011, 63.50972],
              [10.76194, 63.516663],
              [10.76528, 63.522774],
              [10.776943, 63.531944000000124],
              [10.784166, 63.535553000000107],
              [10.792776, 63.538605],
              [10.802776, 63.54083],
              [10.81416, 63.542221],
              [10.889999, 63.54639],
              [10.912777, 63.549438],
              [10.919998, 63.55305],
              [10.922777, 63.557777],
              [10.92166, 63.598328],
              [10.91139, 63.60083],
              [10.89777800000013, 63.60222],
              [10.88389, 63.602493],
              [10.87389, 63.600273],
              [10.73555, 63.568054],
              [10.71833, 63.562218000000144],
              [10.68778, 63.547775],
              [10.679165, 63.544716000000108],
              [10.669443, 63.542496],
              [10.6575, 63.544441],
              [10.65889, 63.549995],
              [10.720554, 63.604996],
              [10.742498, 63.616386],
              [10.924444, 63.68694],
              [10.959166, 63.698883],
              [10.972776000000124, 63.702217],
              [11.03694, 63.713333],
              [11.0525, 63.712494],
              [11.060833, 63.70916],
              [11.070833, 63.700272],
              [11.084444, 63.698883],
              [11.155554, 63.705826000000116],
              [11.174444, 63.711105],
              [11.19167, 63.71722],
              [11.218611, 63.733604],
              [11.221943, 63.73972],
              [11.221943, 63.745827],
              [11.228611, 63.758049],
              [11.25361, 63.767776],
              [11.27361100000013, 63.772217000000126],
              [11.285276, 63.773605],
              [11.3375, 63.775551],
              [11.421665, 63.783051],
              [11.45583, 63.787216],
              [11.461943, 63.791939000000127],
              [11.4625, 63.804443],
              [11.459444, 63.809441],
              [11.437222, 63.834999],
              [11.43222, 63.839439],
              [11.42555, 63.84333],
              [11.41528, 63.846107],
              [11.294998, 63.865555],
              [11.282776000000126, 63.867493000000138],
              [11.267221, 63.868332000000123],
              [11.243055, 63.866386],
              [11.224165, 63.861107],
              [11.198055000000124, 63.852219000000105],
              [11.187777, 63.85],
              [11.1433320000001, 63.843605],
              [11.130554000000132, 63.842773000000136],
              [11.115000000000123, 63.843605],
              [11.106667, 63.846939],
              [11.099722, 63.85083],
              [11.096666, 63.85583],
              [11.090555000000109, 63.878326000000129],
              [11.091944000000126, 63.883888],
              [11.096666, 63.88916],
              [11.102777, 63.89361],
              [11.26472, 63.960831],
              [11.347221, 63.972771],
              [11.411665, 63.9761],
              [11.42444, 63.976662],
              [11.435833000000116, 63.978333000000134],
              [11.48222, 63.999718],
              [11.48972, 64.003601],
              [11.495832, 64.008041],
              [11.496111, 64.014435000000105],
              [11.492777, 64.019440000000145],
              [11.42361, 64.026932000000102],
              [11.318888, 64.032211],
              [11.356943000000115, 64.106384],
              [11.358332000000132, 64.110550000000103],
              [11.32028, 64.116104000000121],
              [11.30583, 64.116379000000109],
              [11.212776, 64.043884000000105],
              [11.205832, 64.025269],
              [11.202499000000103, 64.019440000000145],
              [11.180277, 64.008041],
              [11.130278, 63.988609],
              [11.092499, 63.978333000000134],
              [11.051943000000108, 63.969444],
              [11.006666, 63.955276],
              [10.945276, 63.934441],
              [10.923332, 63.923050000000103],
              [10.91861, 63.91777],
              [10.9125, 63.91305],
              [10.89777800000013, 63.905548],
              [10.806389000000138, 63.878052],
              [10.765, 63.86972],
              [10.73222, 63.866104],
              [10.702221000000122, 63.85916],
              [10.69333, 63.856384000000105],
              [10.684721, 63.853333],
              [10.58, 63.809441],
              [10.574165, 63.804993],
              [10.57639, 63.801941000000113],
              [10.58917, 63.802773],
              [10.639444, 63.814163],
              [10.751944, 63.845551000000114],
              [10.851665000000139, 63.876106000000107],
              [10.867777000000103, 63.883049000000142],
              [10.89277600000014, 63.892776],
              [10.904165, 63.894165],
              [10.91833, 63.894165],
              [11.014444, 63.877777],
              [11.026667, 63.875549],
              [11.033333, 63.871941000000106],
              [11.072222, 63.841942],
              [11.07722, 63.83749],
              [10.941944, 63.73805],
              [10.924721, 63.73194100000012],
              [10.9147210000001, 63.729721],
              [10.88055, 63.72555],
              [10.847776, 63.720276],
              [10.807499, 63.711388],
              [10.64167, 63.671104],
              [10.634165, 63.66722],
              [10.631388000000129, 63.662498000000141],
              [10.62778, 63.648888000000113],
              [10.623055, 63.643608],
              [10.60861, 63.635826],
              [10.54694, 63.615555],
              [10.392776, 63.568886000000134],
              [10.315, 63.557495],
              [10.259165, 63.557495],
              [10.246387, 63.556938],
              [10.225277, 63.55305],
              [10.208055000000115, 63.546944],
              [10.168766, 63.527283],
              [10.092777000000126, 63.50222],
              [10.047777, 63.496109],
              [10.0, 63.495255],
              [9.92833, 63.503326000000129],
              [9.91972, 63.506386],
              [9.912222, 63.51388],
              [9.809999, 63.61972],
              [9.806665, 63.624718],
              [9.789165, 63.662498000000141],
              [9.80110900000011, 63.686661000000129],
              [9.808332, 63.690552],
              [9.822498, 63.690552],
              [9.85166, 63.688606000000107],
              [9.86305, 63.689995000000124],
              [9.915277000000117, 63.699997],
              [10.004999, 63.720551],
              [10.063889, 63.743332],
              [10.096943, 63.756386000000134],
              [10.09833, 63.76194],
              [10.08611100000013, 63.76388500000013],
              [10.00528, 63.7725],
              [9.914165, 63.75278],
              [9.896944, 63.746666],
              [9.732777, 63.701111],
              [9.570276, 63.661385000000109],
              [9.56028, 63.65916],
              [9.54805, 63.659721],
              [9.539444, 63.662773],
              [9.53889, 63.66777],
              [9.543888, 63.763611],
              [9.54666, 63.768608],
              [9.57528, 63.783882],
              [9.5825, 63.787498],
              [9.622499, 63.804443],
              [9.639444, 63.81055],
              [9.700832, 63.82361],
              [9.825277000000142, 63.864441],
              [9.86194, 63.886108],
              [10.136944, 63.939438],
              [10.15111, 63.939438],
              [10.16139, 63.93694],
              [10.168333000000132, 63.933052],
              [10.176943, 63.929993],
              [10.189722, 63.93055],
              [10.195833, 63.935272],
              [10.173332, 63.952217],
              [10.119999, 63.985275],
              [10.059444, 63.982773000000122],
              [10.04944, 63.98055],
              [9.98222, 63.990555],
              [10.020277, 64.066376],
              [10.166111000000114, 64.18971],
              [10.254166000000112, 64.228882],
              [10.34916, 64.274155000000121],
              [10.447222, 64.324158],
              [10.461943, 64.342773],
              [10.47805, 64.35582],
              [10.505278, 64.367493],
              [10.519722, 64.367493],
              [10.549721, 64.365265],
              [10.558332, 64.362213],
              [10.575832, 64.355545],
              [10.581110000000137, 64.351105],
              [10.584444000000133, 64.3461],
              [10.591389000000106, 64.342499],
              [10.603611, 64.340271000000143],
              [10.652222, 64.353043000000127],
              [10.651943, 64.358047000000113],
              [10.566186, 64.389748],
              [10.489494, 64.401077],
              [10.460734, 64.402817000000141],
              [10.495291, 64.423813],
              [10.512220000000127, 64.42833],
              [10.527222000000108, 64.429443],
              [10.58861, 64.431381000000101],
              [10.651388, 64.425278],
              [10.672222, 64.413879],
              [10.76222, 64.37999],
              [10.808054, 64.365829],
              [10.845833, 64.368607],
              [10.85305, 64.372498000000121],
              [10.806944, 64.424713000000111],
              [10.791388, 64.438049],
              [10.781111000000124, 64.44083],
              [10.753332000000114, 64.439987],
              [10.741665, 64.438599000000124],
              [10.721109, 64.434158],
              [10.709444, 64.43277],
              [10.695, 64.43277],
              [10.68278, 64.434708],
              [10.672222, 64.43748],
              [10.66361, 64.440552],
              [10.65667, 64.444443],
              [10.658054, 64.44999700000011],
              [10.695555000000127, 64.468887],
              [10.802776, 64.506104000000107],
              [10.81444, 64.507767],
              [10.834953, 64.505157],
              [10.901110000000131, 64.489990000000148],
              [10.932777, 64.565826],
              [10.940277, 64.580826],
              [10.959166, 64.600555],
              [10.972221, 64.601379],
              [11.035276, 64.579163],
              [11.061666, 64.56944],
              [11.06472, 64.558044000000109],
              [11.06111, 64.545822000000101],
              [11.060833, 64.539719],
              [11.06389, 64.522217000000126],
              [11.06722, 64.516937],
              [11.273333, 64.45166],
              [11.28555, 64.37443],
              [11.221666, 64.316101000000117],
              [11.25889, 64.3336],
              [11.34472, 64.389160000000118],
              [11.43861, 64.465],
              [11.443609, 64.486374],
              [11.446943, 64.49249],
              [11.450554, 64.498596],
              [11.504166, 64.541931],
              [11.511944, 64.545822000000101],
              [11.531387, 64.55082700000014],
              [11.558887, 64.551376000000118],
              [11.573055000000124, 64.549713],
              [11.58787, 64.548973],
              [11.620554, 64.55194],
              [11.728054, 64.579712],
              [11.6875, 64.589722000000108],
              [11.590277, 64.578598],
              [11.546389, 64.56305],
              [11.533221, 64.563156000000106],
              [11.52689, 64.564827],
              [11.515554000000122, 64.567764],
              [11.501665, 64.575546000000145],
              [11.477777000000117, 64.592209],
              [11.460554, 64.604996],
              [11.399166, 64.66333],
              [11.3925, 64.67332],
              [11.397499, 64.678604000000121],
              [11.41778, 64.697769000000108],
              [11.438332000000116, 64.711105],
              [11.551666, 64.761658],
              [11.592222000000106, 64.771103],
              [11.60417, 64.772491],
              [11.6425, 64.774994],
              [11.668888, 64.771652],
              [11.73860900000011, 64.76944],
              [11.795, 64.778046],
              [11.84055, 64.792770000000132],
              [11.838610000000131, 64.796936],
              [11.79972, 64.802765],
              [11.786943, 64.803604],
              [11.742498, 64.802765],
              [11.691277, 64.808823],
              [11.64305, 64.818054000000132],
              [11.651943000000131, 64.840546],
              [11.658054, 64.844986],
              [11.733332000000132, 64.875549],
              [11.95278, 64.929993],
              [12.066013, 64.955887],
              [12.080555000000118, 64.958603],
              [12.095276, 64.958328000000108],
              [12.13805, 64.953598],
              [12.150555000000111, 64.951660000000118],
              [12.159166, 64.94832],
              [12.166111, 64.944443],
              [12.169443, 64.939163000000121],
              [12.176109, 64.935272],
              [12.190554000000134, 64.933884000000148],
              [12.218611, 64.934158],
              [12.224443000000122, 64.93721],
              [12.219444, 64.941666000000112],
              [12.20583, 64.94971],
              [12.186388, 64.955551],
              [12.156387, 64.964432000000102],
              [12.136665, 64.96916],
              [12.119444000000101, 64.971375],
              [12.08861, 64.972763],
              [12.047222, 64.971664],
              [12.035276, 64.970276000000126],
              [11.913332, 64.944992000000127],
              [11.89361, 64.93971],
              [11.747221, 64.892776],
              [11.444721, 64.77943],
              [11.3925, 64.752487],
              [11.384998, 64.748886],
              [11.375832, 64.745819],
              [11.353611000000114, 64.742218],
              [11.307499, 64.735825],
              [11.29583, 64.734436],
              [11.24444, 64.73082],
              [11.235554, 64.734161],
              [11.241665000000125, 64.738602],
              [11.2925, 64.75055],
              [11.37472, 64.80554],
              [11.329721, 64.808044],
              [11.244999000000121, 64.813599000000124],
              [11.234165, 64.816101],
              [11.23278, 64.82193],
              [11.238888, 64.826385],
              [11.2675, 64.839432],
              [11.278055000000109, 64.84166],
              [11.37444, 64.852219],
              [11.434721, 64.857208],
              [11.476944000000117, 64.856110000000115],
              [11.549721, 64.863876],
              [11.691387, 64.897491],
              [11.700554, 64.900269],
              [11.685999, 64.903328],
              [11.6805, 64.904488],
              [11.6725, 64.903992],
              [11.659832, 64.901497],
              [11.626944, 64.896378],
              [11.309999000000118, 64.855820000000108],
              [11.25694, 64.853043],
              [11.246387, 64.855820000000108],
              [11.252499, 64.860275000000115],
              [11.297222, 64.88361],
              [11.306389, 64.886658000000125],
              [11.351944, 64.901382000000126],
              [11.4275, 64.923599],
              [11.541943, 64.94832],
              [11.5525, 64.950546000000145],
              [11.62361, 64.962494],
              [11.634722, 64.9611],
              [11.645277000000135, 64.958328000000108],
              [11.68055500000014, 64.956879000000129],
              [11.68505, 64.955215],
              [11.713721, 64.95872],
              [11.779999, 64.9736],
              [11.80194, 64.990555],
              [11.799999, 64.99472],
              [11.800278, 65.00082],
              [11.810276, 65.011383000000137],
              [11.87861, 65.038605],
              [11.943054, 65.059158000000139],
              [11.967142, 65.064209],
              [11.974998, 65.065826000000129],
              [12.0, 65.061386],
              [12.00861, 65.058044],
              [12.008888, 65.053604],
              [12.009750000000111, 65.051697000000104],
              [12.008333000000107, 65.047211],
              [12.007776, 65.040833],
              [12.009165, 65.03526],
              [12.01944, 65.026108],
              [12.023155, 65.026886],
              [12.033054, 65.047485000000108],
              [12.03972, 65.052216],
              [12.047499, 65.055832000000123],
              [12.058887, 65.055832000000123],
              [12.148888, 65.039154],
              [12.25444, 65.053055],
              [12.420555, 65.08444],
              [12.624722, 65.13361],
              [12.939722, 65.30832],
              [12.945, 65.313599],
              [12.947777, 65.320541000000105],
              [12.946388, 65.326111],
              [12.94139, 65.330551],
              [12.931665, 65.331375],
              [12.922222, 65.328323],
              [12.820833, 65.270828],
              [12.70728, 65.216217000000142],
              [12.69861, 65.211380000000133],
              [12.67461, 65.200386],
              [12.488054, 65.135269],
              [12.4772210000001, 65.133331000000112],
              [12.465832, 65.133331000000112],
              [12.39667, 65.139709],
              [12.384165, 65.141663000000108],
              [12.370554, 65.149719],
              [12.36666, 65.15332],
              [12.36611, 65.1611],
              [12.369999, 65.166931],
              [12.422222, 65.23054500000012],
              [12.510277, 65.240265],
              [12.617498000000126, 65.242767],
              [12.674389000000133, 65.248932],
              [12.679889000000117, 65.25059],
              [12.67589, 65.25293],
              [12.67139, 65.254433],
              [12.64861100000013, 65.264435],
              [12.43861, 65.27194],
              [12.423611000000108, 65.27222],
              [12.367777, 65.26944],
              [12.348055000000102, 65.265823000000125],
              [12.330832, 65.259155000000135],
              [12.259443, 65.226105],
              [12.24889, 65.228607],
              [12.249166, 65.234985000000108],
              [12.335833, 65.292221],
              [12.4780540000001, 65.359985],
              [12.509192, 65.36661],
              [12.53801, 65.377884],
              [12.47972, 65.439163],
              [12.48111, 65.443329000000119],
              [12.5425, 65.446655000000135],
              [12.55611, 65.44722],
              [12.564999, 65.443878],
              [12.601387, 65.428329000000133],
              [12.615276000000108, 65.420547],
              [12.634165, 65.408051000000114],
              [12.638054, 65.418884000000105],
              [12.631666, 65.429153],
              [12.607498000000135, 65.459152000000131],
              [12.56194, 65.50444],
              [12.531111000000124, 65.516937],
              [12.51222, 65.511108],
              [12.49861, 65.510544],
              [12.481943, 65.511658],
              [12.471388000000104, 65.514435],
              [12.425554, 65.52693],
              [12.416666000000134, 65.530273],
              [12.395555, 65.541931],
              [12.39028, 65.54639],
              [12.35555, 65.590271],
              [12.351665, 65.636383000000137],
              [12.35555, 65.642487000000131],
              [12.360832, 65.647766000000104],
              [12.431389, 65.698318],
              [12.438055, 65.702774],
              [12.48639, 65.72499],
              [12.496111, 65.727768],
              [12.508333, 65.72916],
              [12.525, 65.728043000000127],
              [12.537777000000119, 65.72583],
              [12.55944, 65.720551],
              [12.568333, 65.717209],
              [12.575277, 65.713333000000148],
              [12.585554000000116, 65.704163000000108],
              [12.612778, 65.66777],
              [12.607498000000135, 65.662491],
              [12.606943, 65.656097],
              [12.60999900000013, 65.651108],
              [12.615276000000108, 65.646652000000131],
              [12.647221, 65.636932],
              [12.746387, 65.627213],
              [12.76166, 65.626938],
              [12.773888, 65.628326000000129],
              [12.783333, 65.631378],
              [12.78861, 65.636383000000137],
              [12.78944, 65.642776],
              [12.66639, 65.680267],
              [12.582222000000115, 65.727493],
              [12.554443, 65.743607],
              [12.55110900000011, 65.748886],
              [12.55361, 65.75555],
              [12.609165, 65.842773],
              [12.644722, 65.896942],
              [12.65, 65.90193],
              [12.6675, 65.916931],
              [12.67417, 65.92139],
              [12.690832000000114, 65.929443],
              [12.699165, 65.933044],
              [12.744444, 65.949158],
              [12.782776, 65.960541],
              [12.80361, 65.965546],
              [12.814444, 65.96777],
              [12.82833, 65.968323],
              [12.841389, 65.96611],
              [12.897778, 65.952774],
              [12.917500000000132, 65.946655],
              [13.05555500000014, 65.901382000000126],
              [13.158054000000106, 65.848877],
              [13.166943, 65.845551],
              [13.174999, 65.849152000000117],
              [13.17778, 65.855820000000108],
              [13.149721, 65.90666],
              [13.146666, 65.911652],
              [13.12194, 65.940277],
              [13.112499000000128, 65.94249],
              [13.078888, 65.93971],
              [13.062222, 65.940826],
              [12.987499, 65.95527600000014],
              [12.94972, 65.96805],
              [12.931944000000101, 65.97499],
              [12.924444, 65.982208],
              [12.926943, 65.989166],
              [12.955276, 66.036102],
              [12.959444, 66.042221],
              [12.905554, 66.05388],
              [12.885277, 66.050278000000105],
              [12.742222, 66.039154],
              [12.728333, 66.038605],
              [12.71361, 66.04027],
              [12.673611, 66.061935],
              [12.67389, 66.066940000000102],
              [12.83389, 66.126663000000121],
              [12.845, 66.128601],
              [12.895, 66.13388],
              [12.923054, 66.134995000000117],
              [12.955276, 66.1336060000001],
              [12.97778, 66.134155],
              [12.99028, 66.135544],
              [13.068609, 66.146652],
              [13.162777, 66.16693],
              [13.2272210000001, 66.18083],
              [13.260555, 66.195541],
              [13.2675, 66.19999700000011],
              [13.273054, 66.205276],
              [13.296665000000132, 66.21693],
              [13.31194, 66.220825],
              [13.351387000000102, 66.223602],
              [13.549999, 66.23582],
              [13.564722, 66.233887],
              [13.573889, 66.230545],
              [13.58083, 66.226654],
              [13.58, 66.220276],
              [13.576387, 66.207489],
              [13.569166, 66.203049],
              [13.527222, 66.193329000000119],
              [13.525833, 66.122208000000114],
              [13.53, 66.111374],
              [13.533054000000106, 66.106384],
              [13.53805, 66.10194],
              [13.54972, 66.10055],
              [13.610277, 66.189163],
              [13.615833, 66.194153],
              [13.655, 66.222214],
              [13.662222, 66.226654],
              [13.679722, 66.231934],
              [13.705, 66.23416],
              [13.745832, 66.236374000000126],
              [13.759722000000124, 66.236938],
              [13.775276, 66.236374000000126],
              [13.803055, 66.232498],
              [13.809999, 66.228607000000125],
              [13.855276, 66.2211],
              [13.877777, 66.225266],
              [13.99889, 66.248886],
              [14.135277, 66.311386],
              [14.14667, 66.321655],
              [14.145832, 66.327499],
              [14.14083, 66.33194],
              [14.131666, 66.335266],
              [14.118889000000138, 66.337769],
              [14.107498, 66.335541],
              [13.967222, 66.300827],
              [13.747221000000138, 66.276657],
              [13.726387000000102, 66.256653],
              [13.719444000000124, 66.252213],
              [13.70833, 66.25],
              [13.63944400000014, 66.238876],
              [13.626665, 66.237488],
              [13.611387, 66.237778000000105],
              [13.589443, 66.243607000000111],
              [13.48222, 66.251938],
              [13.367222, 66.241379],
              [13.195000000000107, 66.199707000000103],
              [13.173887, 66.194717],
              [13.141943, 66.18777],
              [13.074720000000127, 66.175552],
              [13.06611, 66.175278],
              [13.049444, 66.176376],
              [13.032776000000126, 66.18222],
              [13.027222000000108, 66.186096000000134],
              [13.024166, 66.191101],
              [13.029444000000126, 66.196381],
              [13.20639, 66.272217000000126],
              [13.21611, 66.274994],
              [13.335278, 66.299988],
              [13.349443, 66.30055],
              [13.41361, 66.29639],
              [13.491388, 66.295273],
              [13.518055, 66.296936],
              [13.536388000000102, 66.303604],
              [13.533054000000106, 66.308609000000104],
              [13.522221000000116, 66.311386],
              [13.47416, 66.31332],
              [13.326944, 66.318054],
              [13.254166, 66.30055],
              [13.21889, 66.294998000000135],
              [13.192221, 66.29332],
              [13.148888, 66.297485],
              [13.04361, 66.316101],
              [13.0325, 66.31888],
              [13.023333, 66.32222],
              [13.016388, 66.32611],
              [13.01111, 66.330551],
              [13.001389, 66.345825],
              [13.00028, 66.351379],
              [13.007221, 66.35582],
              [13.01694300000014, 66.358887],
              [13.04222, 66.361374],
              [13.076111, 66.367493],
              [13.144722000000115, 66.38749700000011],
              [13.161665, 66.394989],
              [13.167221, 66.399994000000106],
              [13.17139, 66.406097],
              [13.15667, 66.430832000000123],
              [13.15361, 66.435822000000144],
              [13.0875, 66.493607],
              [13.076387, 66.496384000000148],
              [13.060833, 66.496658],
              [13.033888000000104, 66.494995000000131],
              [13.020832, 66.497208000000114],
              [12.97722, 66.51443],
              [12.97, 66.518326],
              [12.978333000000134, 66.521942],
              [13.085554, 66.536942],
              [13.108332000000132, 66.536942],
              [13.130554, 66.53139],
              [13.208332, 66.511658],
              [13.213610000000131, 66.50722],
              [13.283888, 66.521378000000141],
              [13.456944, 66.558884],
              [13.483889, 66.577499],
              [13.493889, 66.580276],
              [13.545, 66.593597],
              [13.566387000000134, 66.598602],
              [13.621666, 66.601105],
              [13.63611, 66.601654],
              [13.65167, 66.601379],
              [13.66861, 66.599991000000102],
              [13.699999, 66.59944],
              [13.71417, 66.599991000000102],
              [13.72555, 66.601944],
              [13.714722, 66.60472],
              [13.654165, 66.611374000000126],
              [13.638611000000139, 66.611938],
              [13.5275, 66.606659],
              [13.515486000000124, 66.60469],
              [13.47639, 66.593323000000112],
              [13.467777, 66.589722],
              [13.448055, 66.575546],
              [13.43111, 66.559998],
              [13.422499, 66.556381000000101],
              [13.414444000000117, 66.55415],
              [13.401667, 66.552765],
              [13.277498, 66.539993],
              [13.260555, 66.541107],
              [13.234165, 66.545547],
              [13.211943, 66.551102000000128],
              [13.204721, 66.554993],
              [13.203054, 66.559433],
              [13.173054, 66.645554],
              [13.173054, 66.650543],
              [13.187222, 66.659164],
              [13.195833000000107, 66.66305],
              [13.390554, 66.653320000000122],
              [13.483332000000132, 66.6436],
              [13.535831, 66.63472],
              [13.517333, 66.645218000000114],
              [13.515332, 66.648384],
              [13.512332, 66.65105],
              [13.499499, 66.65822],
              [13.481833000000108, 66.663879000000122],
              [13.409166, 66.68138],
              [13.393888, 66.683044000000109],
              [13.32888800000012, 66.68721],
              [13.314444, 66.686661],
              [13.302776, 66.68805],
              [13.291666, 66.691101],
              [13.23, 66.708054],
              [13.2280540000001, 66.712494],
              [13.279165, 66.7211],
              [13.294998, 66.720825000000104],
              [13.402498, 66.716660000000104],
              [13.488333, 66.711105],
              [13.49944, 66.708054],
              [13.53966, 66.701324],
              [13.540332, 66.698],
              [13.556831000000102, 66.691826],
              [13.565832, 66.690826],
              [13.575333000000114, 66.690659],
              [13.690554, 66.689438],
              [13.703609000000142, 66.690552000000139],
              [13.715, 66.69249],
              [13.864166, 66.71944],
              [13.88416500000011, 66.72499],
              [13.892776, 66.728607],
              [13.88778, 66.733322000000101],
              [13.7395, 66.72665400000011],
              [13.696499, 66.725494],
              [13.691500000000133, 66.723328],
              [13.688833, 66.719666000000132],
              [13.68283300000013, 66.717995],
              [13.62305, 66.712494],
              [13.585833, 66.708054],
              [13.573055, 66.70694],
              [13.559166, 66.707764],
              [13.549999, 66.711105],
              [13.545, 66.715546000000131],
              [13.539444, 66.73193],
              [13.53972, 66.736938000000123],
              [13.54055, 66.743042],
              [13.55528, 66.752487],
              [13.56528, 66.755554000000132],
              [13.576666000000102, 66.757492],
              [13.602499, 66.759995],
              [13.616665, 66.760544],
              [13.62255, 66.7625],
              [13.631721, 66.761497],
              [13.64739, 66.75882],
              [13.665721, 66.756828],
              [13.67505, 66.7565],
              [13.689721, 66.758492],
              [13.695722, 66.760162],
              [13.691555, 66.762657],
              [13.682388, 66.763657],
              [13.643555000000106, 66.766991],
              [13.598610000000122, 66.771942],
              [13.568333, 66.771378],
              [13.545277, 66.76721],
              [13.534166, 66.769989],
              [13.51389, 66.776108],
              [13.506666, 66.78027],
              [13.503611, 66.78526],
              [13.51055, 66.789719],
              [13.522221000000116, 66.791656000000103],
              [13.569443, 66.799164000000133],
              [13.616665, 66.806381],
              [13.746387, 66.794998],
              [13.990833, 66.7836],
              [13.990833, 66.786942],
              [13.95917, 66.796097],
              [13.934999, 66.801102],
              [13.917776, 66.80249],
              [13.844721, 66.801102],
              [13.830832, 66.801941],
              [13.817778, 66.804153],
              [13.692221, 66.829987000000131],
              [13.526388000000111, 66.89444],
              [13.521111000000133, 66.899155],
              [13.529722000000106, 66.911102],
              [13.546944, 66.926666],
              [13.555832, 66.930267000000129],
              [13.565832, 66.933044],
              [13.577221, 66.935272],
              [13.590277, 66.936386],
              [13.604721, 66.936935000000119],
              [13.75611, 66.93748],
              [13.928333, 66.919708000000128],
              [13.944166, 66.91916],
              [13.956944, 66.920273000000122],
              [14.122499, 66.98027],
              [14.190554, 66.97276],
              [14.206388000000118, 66.97249],
              [14.218054000000109, 66.974442],
              [14.226944, 66.978043],
              [14.2683320000001, 67.01416],
              [14.272778, 67.020264],
              [14.274166, 67.031387],
              [14.27111, 67.036377],
              [14.304165, 67.053604000000121],
              [14.394999, 67.060547],
              [14.412498, 67.059433000000126],
              [14.52583, 67.044998],
              [14.53916, 67.04277],
              [14.54611, 67.03888],
              [14.551109, 67.034164000000146],
              [14.552221, 67.028610000000128],
              [14.551109, 67.022491000000116],
              [14.547777, 67.015549],
              [14.55305, 67.011108],
              [14.564722, 67.013046],
              [14.57472, 67.015823000000125],
              [14.589722000000108, 67.024429],
              [14.595554, 67.029709],
              [14.596666, 67.03583],
              [14.595833, 67.041656],
              [14.59083, 67.046097000000145],
              [14.583611, 67.049988],
              [14.574444, 67.053604000000121],
              [14.563332000000116, 67.05638],
              [14.425, 67.07111],
              [14.371111, 67.070541000000105],
              [14.29777700000011, 67.070831000000112],
              [14.272499, 67.07471],
              [14.26528, 67.078598],
              [14.32111, 67.14194],
              [14.33, 67.145554000000118],
              [14.35055, 67.151108000000136],
              [14.448332, 67.164444],
              [14.598610000000122, 67.162216000000114],
              [14.676388, 67.15638],
              [14.705832, 67.153046],
              [14.713055000000111, 67.149155],
              [14.718054, 67.144714],
              [14.72611, 67.134995],
              [14.728888, 67.129715],
              [14.73, 67.124161],
              [14.728888, 67.118042],
              [14.737778, 67.114441000000113],
              [14.748333000000116, 67.117218],
              [14.755554, 67.121658],
              [14.753054, 67.13861],
              [14.75, 67.143600000000106],
              [14.728611, 67.155823],
              [14.721666, 67.159714],
              [14.7125, 67.163055],
              [14.697222000000124, 67.164993],
              [14.613333, 67.174438],
              [14.59805, 67.176102],
              [14.541111, 67.173874000000126],
              [14.523611, 67.17528],
              [14.513887000000125, 67.177216000000101],
              [14.53167, 67.184433],
              [14.552221, 67.18999],
              [14.574165, 67.194717],
              [14.5875, 67.195831],
              [14.787777, 67.211655000000121],
              [14.803888, 67.211105],
              [14.92778, 67.206375],
              [14.938332000000116, 67.20221],
              [14.932777, 67.17944],
              [14.929722, 67.17248],
              [14.92361, 67.1675],
              [14.896666, 67.15694],
              [14.890554, 67.151657],
              [14.89138800000012, 67.146103],
              [14.894444, 67.140823],
              [14.967777000000126, 67.095825000000104],
              [14.974998, 67.091660000000104],
              [14.988054, 67.08943],
              [15.001389000000131, 67.090546000000131],
              [15.0075, 67.095551],
              [15.00861, 67.101944000000117],
              [15.00778, 67.107498000000135],
              [14.992777, 67.121109000000104],
              [14.980833, 67.129715],
              [14.960554, 67.13611],
              [14.93611, 67.141388],
              [14.93111, 67.146103],
              [14.96139, 67.171097],
              [14.967499, 67.176102],
              [15.0158330000001, 67.201385],
              [15.02611, 67.204163],
              [15.049721, 67.208054],
              [15.061388, 67.209717],
              [15.076111, 67.210266000000104],
              [15.251665, 67.18582],
              [15.354443000000117, 67.164154],
              [15.378887, 67.158875],
              [15.393055000000118, 67.150833],
              [15.395832, 67.145554000000118],
              [15.396387000000118, 67.139999],
              [15.395277000000135, 67.133881],
              [15.389166, 67.114716],
              [15.45389, 67.071930000000123],
              [15.495554, 67.06528],
              [15.472221, 67.139709],
              [15.39361, 67.187775000000101],
              [15.384443, 67.191376],
              [15.37944, 67.195831],
              [15.382221, 67.201385],
              [15.407055000000128, 67.205109000000107],
              [15.412388000000135, 67.207268],
              [15.419554000000119, 67.20843],
              [15.427054, 67.208275],
              [15.483055, 67.207489],
              [15.533888, 67.200821],
              [15.58417, 67.192764],
              [15.597221000000104, 67.190552],
              [15.6022210000001, 67.18582],
              [15.611111, 67.182495],
              [15.626389, 67.180542000000116],
              [15.71333, 67.170273],
              [15.729166000000134, 67.169708],
              [15.739721, 67.17248],
              [15.739166000000125, 67.178055],
              [15.734165, 67.18277],
              [15.69611, 67.206665],
              [15.41389, 67.235275000000115],
              [15.275833, 67.241379000000109],
              [15.261389, 67.241104000000121],
              [15.24944, 67.239166],
              [15.23555, 67.23332],
              [15.22389, 67.231384],
              [15.19611, 67.229996000000142],
              [15.077221, 67.24582],
              [15.063889, 67.248047],
              [15.066666, 67.253601000000117],
              [15.076944, 67.256104],
              [15.091665, 67.256653],
              [15.10333, 67.25861],
              [15.134722, 67.266663000000108],
              [15.14361, 67.270264],
              [15.149721, 67.275269],
              [15.161943000000122, 67.299713],
              [15.16305, 67.305832],
              [15.151943, 67.308884],
              [15.13861, 67.307770000000119],
              [15.038332, 67.295547],
              [14.859165000000132, 67.273605],
              [14.83578, 67.255325],
              [14.825277, 67.248047],
              [14.712776000000133, 67.216934],
              [14.692221, 67.21138],
              [14.668610000000115, 67.207489],
              [14.638054, 67.207489],
              [14.624166, 67.208603],
              [14.61833, 67.211929],
              [14.54639, 67.246933000000126],
              [14.533333, 67.24582],
              [14.361666, 67.23389],
              [14.362499, 67.24721],
              [14.464443, 67.29527],
              [14.560276, 67.349152],
              [14.57805, 67.390549],
              [14.573055, 67.395264],
              [14.61861, 67.414444],
              [14.627499000000114, 67.418045],
              [14.656387, 67.424988],
              [14.76111, 67.419708],
              [14.79222, 67.416107000000125],
              [14.80555500000014, 67.413605],
              [14.814722000000131, 67.4102630000001],
              [14.819721, 67.405548],
              [14.810555000000136, 67.393875],
              [14.804443, 67.388611],
              [14.883055, 67.404709000000139],
              [14.926888, 67.422989],
              [14.914887, 67.431824],
              [14.88455, 67.430161],
              [14.834721, 67.440277],
              [14.823332, 67.443054],
              [14.734165, 67.484436],
              [14.72833, 67.487778],
              [14.727499, 67.493332],
              [14.736387, 67.496933],
              [14.819166000000109, 67.528046],
              [14.91222, 67.553604],
              [14.9225, 67.556107],
              [14.971943, 67.563324],
              [15.035831, 67.570541],
              [15.066944, 67.570267],
              [15.080276, 67.568054000000132],
              [15.133055, 67.552216000000101],
              [15.151388, 67.545273000000122],
              [15.15639, 67.540833],
              [15.157221, 67.534988],
              [15.149721, 67.530823],
              [15.140554, 67.527222000000108],
              [15.00694, 67.486664],
              [14.986111000000108, 67.48111],
              [14.958944, 67.476273],
              [14.932278, 67.475769],
              [14.936277, 67.470444],
              [14.98578, 67.4686],
              [14.994611000000134, 67.468773],
              [15.014444, 67.4686],
              [15.03555, 67.473877],
              [15.10889, 67.493042],
              [15.326666000000102, 67.48277],
              [15.395555, 67.478333000000134],
              [15.42861, 67.474991],
              [15.441944, 67.472488],
              [15.460278, 67.465546000000131],
              [15.470276, 67.456375],
              [15.53028, 67.395828],
              [15.588055, 67.317215],
              [15.625277, 67.266098000000113],
              [15.64, 67.26638800000012],
              [15.648888, 67.269714000000135],
              [15.68111, 67.286377],
              [15.688889, 67.290543000000127],
              [15.695000000000107, 67.295822000000101],
              [15.69972, 67.3011],
              [15.701666000000102, 67.304993],
              [15.69694, 67.309708],
              [15.615000000000123, 67.351654],
              [15.51667, 67.425552],
              [15.531387, 67.464996],
              [15.541111, 67.47694],
              [15.553888, 67.487213],
              [15.586712, 67.5],
              [15.590277, 67.501389],
              [15.619165000000123, 67.51111],
              [15.69944, 67.534988],
              [15.71, 67.537766000000147],
              [15.755278, 67.546936],
              [15.767221, 67.5486],
              [15.794167, 67.550827],
              [15.852949, 67.55211],
              [15.883055, 67.55249],
              [15.894999, 67.55415],
              [15.899166, 67.558884],
              [15.894444, 67.563324],
              [15.878887000000134, 67.565277],
              [15.846388, 67.566376],
              [15.8316650000001, 67.566101],
              [15.722776, 67.558319],
              [15.700277, 67.553879],
              [15.65805, 67.54304500000012],
              [15.638054, 67.536942],
              [15.610832, 67.526382],
              [15.554443, 67.50972],
              [15.54389, 67.50694],
              [15.531944, 67.50499],
              [15.35999900000013, 67.51221],
              [15.278889000000106, 67.518326],
              [15.251944, 67.523041],
              [15.240555, 67.526108000000136],
              [15.23361, 67.529999],
              [15.22861, 67.534714],
              [15.180277000000103, 67.609711],
              [15.17722, 67.614716],
              [15.180555, 67.621384],
              [15.191666, 67.632492],
              [15.295832, 67.714432000000102],
              [15.299166, 67.71693],
              [15.30944, 67.718887000000109],
              [15.323055000000124, 67.71666],
              [15.357222, 67.707764000000111],
              [15.454721, 67.685822],
              [15.50861, 67.676102],
              [15.651943, 67.675278],
              [15.603889, 67.688721],
              [15.580555000000118, 67.696884],
              [15.566889, 67.700378],
              [15.558722, 67.701881],
              [15.549388, 67.703049],
              [15.531555, 67.702713],
              [15.51539, 67.701378],
              [15.506388000000129, 67.70122],
              [15.488555, 67.702881],
              [15.482887, 67.705048],
              [15.40167, 67.733322],
              [15.402222000000108, 67.738052],
              [15.480888, 67.729492],
              [15.538388, 67.733658],
              [15.572555, 67.735161],
              [15.581388000000118, 67.735321],
              [15.601555, 67.73349],
              [15.61389, 67.72966],
              [15.645888, 67.71666],
              [15.75889, 67.689438000000109],
              [15.768055000000118, 67.685822],
              [15.78861, 67.679443],
              [15.821388, 67.67139],
              [15.829721, 67.673599],
              [15.834999, 67.689987],
              [15.781111, 67.727768],
              [15.683887, 67.749710000000107],
              [15.631943, 67.759995],
              [15.589167, 67.766663],
              [15.379166, 67.797211],
              [15.37278, 67.791931],
              [15.357222, 67.783325],
              [15.186666, 67.713333000000148],
              [15.168333, 67.706375],
              [15.072777, 67.681107],
              [15.00111, 67.66305],
              [14.91861, 67.64888],
              [14.843887, 67.638611],
              [14.81278, 67.63888500000013],
              [14.761665000000107, 67.643051],
              [14.736666, 67.648331],
              [14.729443, 67.652496],
              [14.73055, 67.6586],
              [14.77861, 67.71944],
              [14.787777, 67.723053],
              [14.89917, 67.728333],
              [14.983889, 67.728043],
              [15.03611, 67.740265],
              [15.033609, 67.776108],
              [14.985832, 67.776657],
              [14.869444000000101, 67.768875],
              [14.8425, 67.766663],
              [14.7725, 67.781937],
              [14.765276, 67.786102],
              [14.755554, 67.799988],
              [14.758055, 67.805267],
              [14.784166, 67.816940000000102],
              [14.80222, 67.823883],
              [15.0025, 67.839157],
              [15.047222, 67.839996],
              [15.06111, 67.837769],
              [15.070276, 67.834152000000131],
              [15.0825, 67.836105],
              [15.10417, 67.849991],
              [15.099165, 67.854431],
              [15.064722, 67.856384],
              [15.049721, 67.85611],
              [15.00916, 67.85277],
              [14.943054, 67.8461],
              [14.906666, 67.840271000000143],
              [14.879721, 67.83804],
              [14.86472, 67.837769],
              [14.85111, 67.839996],
              [14.849443, 67.844437],
              [14.884998, 67.867767],
              [14.893610000000137, 67.869995000000131],
              [14.96805, 67.889160000000118],
              [14.992222, 67.893051],
              [15.022221, 67.893600000000106],
              [15.040277, 67.892212],
              [15.18222, 67.87944],
              [15.22528, 67.872772],
              [15.234722, 67.86916],
              [15.26194, 67.860825],
              [15.33083, 67.886658],
              [15.525276, 67.920547],
              [15.708611, 67.94693],
              [15.73583200000013, 67.948883000000137],
              [15.766109, 67.949432000000115],
              [15.781666, 67.947495],
              [15.80472200000014, 67.941666],
              [15.813889000000131, 67.938049],
              [15.82111, 67.934158],
              [15.826111, 67.929443],
              [15.829721, 67.91861],
              [15.87111, 67.923325],
              [15.90667, 67.94722],
              [15.95583, 67.993042],
              [15.96111100000013, 68.013046],
              [15.847776000000124, 68.038605],
              [15.80444, 68.034714000000122],
              [15.762777, 68.026657],
              [15.633888, 68.030823],
              [15.599443, 68.032776],
              [15.51949900000011, 68.046494000000109],
              [15.442221, 68.028885000000116],
              [15.440277, 68.007217],
              [15.437498000000119, 68.001938],
              [15.41389, 67.989166],
              [15.40167, 67.987213],
              [15.33111, 67.994995],
              [15.321665, 67.998596],
              [15.30722, 68.006653],
              [15.296944, 68.015823000000125],
              [15.283888, 68.029999],
              [15.283054000000106, 68.035553000000107],
              [15.289444, 68.04083],
              [15.343054, 68.07193],
              [15.358889, 68.080551],
              [15.432777000000101, 68.117767000000129],
              [15.486666, 68.131378],
              [15.50194, 68.131653000000142],
              [15.506943, 68.126938000000109],
              [15.501389, 68.116104],
              [15.49917, 68.105270000000132],
              [15.519644, 68.103836],
              [15.522643, 68.101173],
              [15.528311, 68.098999],
              [15.53648, 68.09767],
              [15.592388, 68.113937000000135],
              [15.614888000000121, 68.122437],
              [15.61972, 68.124939],
              [15.622389, 68.127769000000114],
              [15.665833, 68.146652],
              [15.713055, 68.143051000000128],
              [15.726665000000139, 68.140823],
              [15.73166700000013, 68.13611],
              [15.74111, 68.09416],
              [15.734444, 68.089157000000114],
              [15.72361, 68.08638],
              [15.706944, 68.08693],
              [15.691111, 68.088882],
              [15.64394, 68.085884],
              [15.634777, 68.085716],
              [15.63211, 68.083046],
              [15.61694, 68.06221],
              [15.617777, 68.05638],
              [15.62278, 68.051941],
              [15.632221, 68.048325],
              [15.64361, 68.045547000000113],
              [15.654444, 68.044708000000128],
              [15.851944, 68.091385],
              [15.866665, 68.10083],
              [15.873055, 68.10582],
              [15.879721, 68.1111],
              [15.897778, 68.127213],
              [15.933887, 68.182495],
              [15.94528, 68.227219],
              [15.946665, 68.233322],
              [15.95333, 68.238602],
              [15.961388000000113, 68.242767],
              [15.972221000000104, 68.245544000000109],
              [16.005833000000109, 68.244431],
              [16.021664000000101, 68.242493],
              [16.03333, 68.239441],
              [16.047497, 68.231384],
              [16.103611, 68.16611],
              [16.10555, 68.14915],
              [16.092499, 68.068054],
              [16.192776, 67.978333],
              [16.204720000000123, 67.969711],
              [16.215, 67.95471],
              [16.222221, 67.92749],
              [16.22083, 67.921387],
              [16.216942, 67.914719000000105],
              [16.2066650000001, 67.902771],
              [16.207222, 67.897217],
              [16.21722, 67.888046000000145],
              [16.393887, 67.821381],
              [16.423611, 67.811386],
              [16.468887, 67.799164000000133],
              [16.495831, 67.794159],
              [16.50194, 67.80499],
              [16.453331, 67.847488],
              [16.42639, 67.852493],
              [16.372219, 67.862488],
              [16.320553, 67.872772],
              [16.263611, 67.887772],
              [16.256664, 67.891937],
              [16.251663, 67.896652],
              [16.2075, 67.998322000000144],
              [16.2075, 68.001663],
              [16.239998000000128, 68.00972],
              [16.250832, 68.012207],
              [16.348888, 68.006653],
              [16.408054, 67.99222],
              [16.427776, 67.97387700000013],
              [16.441666, 67.965546],
              [16.460278, 67.958603],
              [16.471664, 67.955551000000128],
              [16.48722, 67.953598],
              [16.518887, 67.95332],
              [16.52972, 67.955826000000116],
              [16.539165000000139, 67.959152],
              [16.499165, 68.010818],
              [16.487778, 68.01388],
              [16.472221, 68.015823000000125],
              [16.422775000000115, 68.0211],
              [16.388332000000105, 68.02333],
              [16.372498, 68.025269],
              [16.363331, 68.028885000000116],
              [16.364719, 68.034988],
              [16.36861, 68.041656],
              [16.395275, 68.061935],
              [16.461109, 68.095276000000126],
              [16.4725, 68.092209],
              [16.500832000000116, 68.07611],
              [16.51944, 68.06888],
              [16.542221, 68.062775],
              [16.66166, 68.045547000000113],
              [16.676941, 68.045822],
              [16.684998000000121, 68.049988],
              [16.715275, 68.066666000000112],
              [16.538887, 68.08972],
              [16.513481, 68.114861],
              [16.445543, 68.11139],
              [16.409729, 68.089874000000123],
              [16.342499, 68.071655],
              [16.299999, 68.09972],
              [16.307777, 68.119995],
              [16.40916, 68.152771],
              [16.480831, 68.175827],
              [16.486942, 68.186661000000129],
              [16.458054, 68.2086],
              [16.421108, 68.209991],
              [16.34928, 68.2061],
              [16.317942, 68.202766],
              [16.292442, 68.19577],
              [16.242775, 68.188889],
              [16.226109, 68.189438],
              [16.189999000000114, 68.192215],
              [16.174164, 68.194153],
              [16.162777, 68.19722],
              [16.16, 68.2025],
              [16.165276, 68.215271000000143],
              [16.171944, 68.220276],
              [16.185555000000136, 68.221375],
              [16.203888, 68.219986],
              [16.2175, 68.217499],
              [16.24944, 68.217209],
              [16.308319, 68.227379],
              [16.315653000000111, 68.228386000000114],
              [16.319654, 68.231552],
              [16.318989000000101, 68.234055],
              [16.315987, 68.236877000000106],
              [16.303154, 68.244217000000106],
              [16.294821, 68.24571200000014],
              [16.281652, 68.242386000000124],
              [16.271332, 68.24721],
              [16.251663, 68.247772],
              [16.10972, 68.268051],
              [16.100277, 68.271378000000141],
              [16.103333000000134, 68.27693],
              [16.13361, 68.303879],
              [16.14167, 68.308319],
              [16.1775, 68.314438000000109],
              [16.189999000000114, 68.316376],
              [16.511108, 68.25499],
              [16.5225, 68.251938],
              [16.543888, 68.23972],
              [16.56361, 68.2211],
              [16.568886, 68.21083],
              [16.56944, 68.205276],
              [16.632774, 68.174164000000133],
              [16.71611, 68.14221],
              [16.727497, 68.13916],
              [16.76833, 68.131653000000142],
              [16.79777, 68.127213],
              [16.805832000000123, 68.131378],
              [16.79888, 68.13554],
              [16.73333, 68.171936],
              [16.651386000000116, 68.193054],
              [16.632774, 68.200272],
              [16.59666, 68.226379000000122],
              [16.591942, 68.23082],
              [16.589165, 68.236099],
              [16.593052000000114, 68.242767],
              [16.465553, 68.29416],
              [16.41389, 68.296936],
              [16.250832, 68.32361],
              [16.239166, 68.32666],
              [16.21944, 68.344986],
              [16.226109, 68.349991000000102],
              [16.292221, 68.363052],
              [16.317219, 68.366943000000106],
              [16.547497, 68.396378],
              [16.589443, 68.399429],
              [16.706387, 68.400833],
              [16.724442, 68.399155000000121],
              [16.738331, 68.396652000000131],
              [16.851944, 68.372772000000111],
              [16.861111, 68.369431],
              [16.875275, 68.3611],
              [16.88028, 68.356659],
              [16.87833, 68.350266000000147],
              [16.870277, 68.3461],
              [16.860554, 68.34277],
              [16.842777, 68.33499],
              [16.834442000000138, 68.33083],
              [16.8275, 68.325546],
              [16.825832, 68.31944],
              [16.834442000000138, 68.318054000000132],
              [16.887218, 68.32361],
              [16.899719, 68.325546],
              [16.981388, 68.341385],
              [16.992496, 68.343887000000109],
              [17.009163000000115, 68.35249],
              [17.026943, 68.359985000000108],
              [17.053608, 68.362778000000105],
              [17.12527, 68.368042000000116],
              [17.139999, 68.366943000000106],
              [17.151386, 68.363876],
              [17.1655540000001, 68.35554500000012],
              [17.32472, 68.255264],
              [17.32944, 68.25055],
              [17.331944000000135, 68.192764],
              [17.33027600000014, 68.186386],
              [17.326111000000139, 68.17972],
              [17.314442, 68.170273],
              [17.314999, 68.164444],
              [17.32722, 68.162766000000147],
              [17.338055, 68.165543],
              [17.35472, 68.173874000000126],
              [17.36138, 68.178879],
              [17.415276000000119, 68.229156],
              [17.41639, 68.234161],
              [17.415833, 68.23972],
              [17.41333, 68.244995],
              [17.399166, 68.25888],
              [17.39222, 68.262772],
              [17.343609, 68.285828],
              [17.326664, 68.292221],
              [17.315277, 68.295273000000122],
              [17.28805, 68.300552],
              [17.276943, 68.30415],
              [17.267776, 68.307770000000119],
              [17.221107, 68.331375],
              [17.214165, 68.33554],
              [17.200832000000105, 68.366943000000106],
              [17.204166, 68.372208],
              [17.246109, 68.400269],
              [17.25861, 68.40193],
              [17.324444, 68.400269],
              [17.34111, 68.399429],
              [17.386665, 68.392776],
              [17.409721, 68.386658000000125],
              [17.428169, 68.379044],
              [17.483055, 68.363602],
              [17.535553, 68.352768],
              [17.552219, 68.351944],
              [17.564720000000136, 68.353882],
              [17.574718000000132, 68.357208],
              [17.578053, 68.362488],
              [17.568607, 68.366104],
              [17.523331, 68.372772000000111],
              [17.48222, 68.380554],
              [17.381664000000114, 68.403046],
              [17.369999, 68.4061],
              [17.367496, 68.411377],
              [17.375832, 68.41554],
              [17.4025, 68.41832],
              [17.489166000000125, 68.422211000000118],
              [17.563053, 68.424438],
              [17.578609, 68.424438],
              [17.571941, 68.450272],
              [17.552776, 68.523880000000133],
              [17.54361, 68.527496],
              [17.53167, 68.526932000000102],
              [17.51916, 68.525269],
              [17.3530540000001, 68.496109000000104],
              [17.33083, 68.491104],
              [17.322498, 68.486938000000123],
              [17.308331, 68.47665400000011],
              [17.30305, 68.470825000000104],
              [17.289165000000139, 68.460831],
              [17.26194, 68.451111],
              [17.225555, 68.44499],
              [17.183609, 68.44194],
              [17.113888, 68.43721],
              [17.05666, 68.434158],
              [17.024441000000138, 68.434708000000114],
              [17.010555, 68.43721],
              [17.003609, 68.441376000000105],
              [17.004444, 68.44611],
              [17.01277, 68.450546000000145],
              [17.040833, 68.452499000000103],
              [17.05611, 68.452499000000103],
              [17.079998000000103, 68.45694],
              [17.089722, 68.460266],
              [17.096664, 68.465271],
              [17.098331000000144, 68.471664],
              [17.095833, 68.47665400000011],
              [17.06333, 68.486374],
              [17.005554, 68.501663],
              [16.991665, 68.504166],
              [16.968052000000114, 68.49971],
              [16.94861, 68.492767000000129],
              [16.940277, 68.488602000000128],
              [16.933331, 68.483597],
              [16.916664000000139, 68.47499],
              [16.908333, 68.470825000000104],
              [16.86861, 68.452209],
              [16.843609000000129, 68.448608],
              [16.65916, 68.437485],
              [16.52722, 68.433884000000148],
              [16.510555, 68.434433000000126],
              [16.498886, 68.437485],
              [16.462219, 68.502777],
              [16.459442000000138, 68.508041],
              [16.465, 68.513885],
              [16.48139, 68.522217],
              [16.5325, 68.538055],
              [16.546665, 68.538879],
              [16.576683, 68.530884],
              [16.599998000000141, 68.52832],
              [16.615276, 68.52861],
              [16.624996000000124, 68.53194],
              [16.633331, 68.53637700000013],
              [16.637218, 68.54304500000012],
              [16.63222, 68.54748],
              [16.585552, 68.559708],
              [16.576111, 68.563324],
              [16.56916, 68.567490000000134],
              [16.564163, 68.57193],
              [16.559998, 68.581375],
              [16.558887, 68.592773],
              [16.560555000000136, 68.598877],
              [16.56611, 68.604721],
              [16.579720000000123, 68.614990000000148],
              [16.61972, 68.636932],
              [16.629444, 68.64055],
              [16.771111, 68.66777],
              [16.842777, 68.681107],
              [16.964996, 68.701385],
              [16.98083, 68.70166],
              [17.169998, 68.707489],
              [17.257500000000107, 68.720551000000114],
              [17.34861, 68.711655],
              [17.364719, 68.709717],
              [17.374165000000119, 68.706100000000106],
              [17.381386, 68.701935000000105],
              [17.386108, 68.697495],
              [17.388611, 68.692215],
              [17.39833, 68.683044],
              [17.405552, 68.678879],
              [17.424164, 68.671661],
              [17.43583, 68.66861],
              [17.463608, 68.6636],
              [17.481941, 68.661942],
              [17.6675, 68.652771],
              [17.68027, 68.654434],
              [17.677498, 68.659714000000122],
              [17.670555, 68.663879000000122],
              [17.654163, 68.67139],
              [17.635555000000124, 68.678604],
              [17.621666, 68.681107],
              [17.605553, 68.683319],
              [17.588608, 68.683884],
              [17.544998, 68.68193],
              [17.49528, 68.683319],
              [17.479164000000139, 68.685547],
              [17.301666000000125, 68.72972],
              [17.290276, 68.732773],
              [17.23860900000011, 68.749710000000107],
              [17.236111, 68.754715000000147],
              [17.243053, 68.75972],
              [17.430275, 68.807495],
              [17.443054, 68.809433000000126],
              [17.457497000000103, 68.810272000000111],
              [17.47583, 68.80888],
              [17.489719, 68.806381],
              [17.5225, 68.79639],
              [17.575832000000105, 68.78583],
              [17.767776, 68.754715000000147],
              [17.792500000000132, 68.756943],
              [17.78722, 68.772766000000104],
              [17.784721, 68.778046],
              [17.78, 68.782486],
              [17.768330000000105, 68.785553000000107],
              [17.751389000000131, 68.786377],
              [17.735832, 68.786377],
              [17.707497, 68.784439000000134],
              [17.691666000000112, 68.784439000000134],
              [17.66083, 68.787766],
              [17.633053, 68.79277],
              [17.472775, 68.825272],
              [17.47, 68.830276],
              [17.491386, 68.83638],
              [17.646664, 68.87471],
              [17.715275, 68.889999],
              [17.730831, 68.890274],
              [17.735832, 68.885544],
              [17.733608000000117, 68.87944],
              [17.738331, 68.87471],
              [17.74778, 68.871109000000104],
              [17.761665, 68.868607],
              [17.811386, 68.8636],
              [17.828331, 68.86305],
              [17.839722, 68.865555],
              [17.84833, 68.86972],
              [17.84833, 68.87527],
              [17.84111, 68.87944],
              [17.718609, 68.928604],
              [17.685833000000116, 68.92915],
              [17.628609, 68.925552],
              [17.572777, 68.921097],
              [17.518608, 68.915543],
              [17.494442, 68.91138],
              [17.474442, 68.90443],
              [17.46583, 68.900269],
              [17.45583, 68.896942],
              [17.444443, 68.894440000000145],
              [17.43111, 68.894714],
              [17.42610900000011, 68.899429000000112],
              [17.425831, 68.904999],
              [17.487778, 68.989990000000148],
              [17.629997, 69.100555],
              [17.637218, 69.10554500000012],
              [17.648609, 69.108047],
              [17.687496, 69.113327],
              [17.716389, 69.115265],
              [17.903889, 69.126938],
              [18.117496, 69.144714],
              [18.143608, 69.148041000000148],
              [18.152222, 69.152222],
              [18.020275, 69.22694],
              [18.001389, 69.228333000000134],
              [17.989441, 69.23166],
              [17.996387, 69.28027],
              [18.004444, 69.29222],
              [18.01638800000012, 69.303879],
              [18.025276000000133, 69.308044],
              [18.035275, 69.311386],
              [18.07611, 69.31583],
              [18.08639, 69.319153],
              [18.13194, 69.339157],
              [18.172222, 69.386383],
              [18.176666, 69.404434],
              [18.17639, 69.409988],
              [18.173611, 69.432220000000143],
              [18.204441, 69.462769],
              [18.256943, 69.486374],
              [18.268887, 69.488876],
              [18.285000000000139, 69.488876],
              [18.296665, 69.485825],
              [18.306389, 69.482208],
              [18.34222, 69.467209],
              [18.356388, 69.458878000000141],
              [18.497219, 69.373322000000144],
              [18.511665, 69.348053],
              [18.539444, 69.299164],
              [18.679443, 69.259995000000117],
              [18.68972, 69.25777],
              [18.699997, 69.26111],
              [18.704720000000123, 69.26777600000014],
              [18.707222, 69.27388],
              [18.707222, 69.27943],
              [18.702499, 69.284164],
              [18.688332, 69.292496],
              [18.678886, 69.296097],
              [18.671944, 69.300278],
              [18.667221, 69.304993],
              [18.667221, 69.31055],
              [18.676109, 69.314713],
              [18.68777, 69.317215000000147],
              [18.771111000000133, 69.324707000000103],
              [18.869442, 69.31944],
              [18.88583, 69.31749],
              [18.89527500000014, 69.313599000000124],
              [18.89435, 69.307762000000139],
              [18.8975, 69.302765],
              [18.946663000000115, 69.290833],
              [18.97472, 69.28526],
              [18.991108000000111, 69.283325],
              [19.007221000000129, 69.283051000000114],
              [19.014721, 69.288055],
              [19.014721, 69.293884000000105],
              [18.968052, 69.317764000000125],
              [18.94944, 69.32499700000011],
              [18.91639, 69.32944],
              [18.83416, 69.340271],
              [18.800831, 69.34111],
              [18.78416, 69.343323000000112],
              [18.756107, 69.348602],
              [18.674999, 69.364166],
              [18.637218, 69.373322000000144],
              [18.61666, 69.380829],
              [18.46111, 69.444992000000127],
              [18.453888, 69.449158],
              [18.453053000000125, 69.459152],
              [18.462219, 69.504166],
              [18.464165, 69.50943],
              [18.471664, 69.514435],
              [18.49528, 69.51944],
              [18.66805, 69.54111],
              [18.841942, 69.552765],
              [18.85611, 69.550278000000105],
              [18.86083200000013, 69.545547],
              [18.91111, 69.48111],
              [18.91111, 69.464157000000114],
              [18.91333, 69.458878000000141],
              [18.9180530000001, 69.454437],
              [19.004719, 69.399155],
              [19.01194, 69.394989],
              [19.021111, 69.39138800000012],
              [19.096107000000131, 69.361938],
              [19.11722200000014, 69.35527],
              [19.145554, 69.349716],
              [19.161942000000124, 69.34776],
              [19.179443000000106, 69.346664000000146],
              [19.239166000000125, 69.349152000000117],
              [19.255276, 69.349152000000117],
              [19.292774000000122, 69.345551],
              [19.325554, 69.34111],
              [19.34889, 69.334717],
              [19.367496, 69.3275],
              [19.37444, 69.323318],
              [19.38139, 69.313324],
              [19.38111, 69.307770000000119],
              [19.36472, 69.290833],
              [19.355553, 69.286652],
              [19.345276, 69.2836],
              [19.321663000000115, 69.27861],
              [19.30833, 69.276932000000102],
              [19.277775, 69.276108000000136],
              [19.212776, 69.277222000000108],
              [19.19944, 69.27554],
              [19.187775000000101, 69.273041],
              [19.178608000000111, 69.268875],
              [19.171108, 69.264160000000118],
              [19.165, 69.258331000000112],
              [19.164719, 69.252487],
              [19.171665000000132, 69.248596],
              [19.189163, 69.247498000000121],
              [19.31166, 69.22137],
              [19.343887, 69.219162],
              [19.440552000000139, 69.22583],
              [19.451664000000108, 69.251663000000121],
              [19.45417, 69.31166],
              [19.449718, 69.32193],
              [19.4175, 69.34887700000013],
              [19.364166, 69.371658000000139],
              [19.3525, 69.37471],
              [19.300831, 69.381104000000107],
              [19.284164, 69.38304],
              [19.26694, 69.384155000000135],
              [19.25222, 69.383331],
              [19.212498, 69.378326000000129],
              [19.169998, 69.375275000000101],
              [19.1525, 69.376099],
              [19.124443, 69.381378],
              [19.002777, 69.451660000000118],
              [18.998055, 69.456375],
              [18.995552, 69.46138],
              [18.995831, 69.467209],
              [19.00333, 69.502487],
              [19.005833, 69.508606],
              [19.09111, 69.534164000000146],
              [19.168053, 69.545547],
              [19.182777000000101, 69.546387],
              [19.197220000000129, 69.543884],
              [19.21583, 69.53637700000013],
              [19.23694, 69.523880000000133],
              [19.246387, 69.520264],
              [19.26111, 69.521103],
              [19.261387, 69.526657],
              [19.22666, 69.564438],
              [19.213608, 69.566376],
              [19.198887, 69.565552],
              [19.088055, 69.55499],
              [19.064163000000121, 69.549988],
              [19.053608, 69.54666],
              [19.03833, 69.53694],
              [19.02916, 69.532776],
              [19.014442, 69.531937],
              [19.000275, 69.534439],
              [18.990833, 69.53833],
              [18.955555, 69.559158000000139],
              [18.94611, 69.573883],
              [18.943886, 69.584717000000126],
              [18.939442, 69.606384],
              [18.944164000000114, 69.61305],
              [18.9566650000001, 69.624435],
              [18.994999, 69.64943],
              [19.10833, 69.712219000000118],
              [19.177776, 69.745544],
              [19.246666, 69.77194],
              [19.272221, 69.775833],
              [19.706944, 69.81221],
              [19.73972, 69.811935],
              [19.758888, 69.810272],
              [19.77083, 69.806931],
              [19.780277, 69.803329],
              [19.78083, 69.798874],
              [19.772778, 69.780548],
              [19.707497, 69.703888],
              [19.678333, 69.678879],
              [19.676666, 69.674164],
              [19.67639, 69.66832],
              [19.685833, 69.664719000000105],
              [19.716663, 69.659714],
              [19.72361, 69.655548],
              [19.72583, 69.650269],
              [19.72528, 69.639160000000118],
              [19.71944, 69.61555],
              [19.714165, 69.60333],
              [19.702499, 69.59082],
              [19.69611, 69.585266000000104],
              [19.627499, 69.51082],
              [19.529163, 69.39888],
              [19.531387, 69.3936],
              [19.54444, 69.395264],
              [19.679165, 69.429443],
              [19.686943, 69.434433],
              [19.713608, 69.472214],
              [19.71611, 69.478333],
              [19.718887, 69.50583],
              [19.714443, 69.523880000000133],
              [19.828053, 69.714432],
              [19.93972, 69.786942000000124],
              [19.972775, 69.784714000000122],
              [20.046108000000117, 69.799713],
              [20.078053, 69.84277],
              [20.151943, 69.933044],
              [20.157497, 69.937485],
              [20.281944, 69.973877],
              [20.294998, 69.971939000000134],
              [20.304165, 69.968323],
              [20.318333000000109, 69.95972],
              [20.387218, 69.912216000000114],
              [20.41444, 69.889709],
              [20.42333200000013, 69.880264000000125],
              [20.424999, 69.869431000000134],
              [20.41972, 69.862778],
              [20.39138800000012, 69.825272],
              [20.351665, 69.753052],
              [20.33472, 69.716385],
              [20.331944, 69.710266],
              [20.317219000000136, 69.673874],
              [20.29361, 69.574707],
              [20.28333, 69.481934000000138],
              [20.280552000000114, 69.47583],
              [20.27027500000014, 69.462769],
              [20.257221, 69.45111],
              [20.190552000000139, 69.402222],
              [20.171944, 69.394165],
              [20.099442, 69.370544],
              [20.05722, 69.357498],
              [20.00944, 69.34776],
              [19.998886, 69.344711],
              [19.989719, 69.340546],
              [19.98194100000012, 69.335541000000148],
              [19.919167, 69.277222000000108],
              [19.91639, 69.271103],
              [19.91611, 69.265274],
              [19.918331000000137, 69.260269],
              [19.929722, 69.25694],
              [19.94694, 69.256104],
              [20.02361, 69.306107],
              [20.04055, 69.315277],
              [20.178333, 69.368607000000111],
              [20.198330000000112, 69.375824],
              [20.210278, 69.378326000000129],
              [20.306664, 69.416382000000112],
              [20.323608, 69.435547],
              [20.356110000000115, 69.471375],
              [20.463055, 69.570267],
              [20.469719, 69.576111],
              [20.484444, 69.576935],
              [20.496109, 69.573608],
              [20.514721, 69.566101000000117],
              [20.528332, 69.557495],
              [20.555832, 69.546387],
              [20.611385, 69.52943],
              [20.690552, 69.51166],
              [20.70472, 69.508881],
              [20.842499, 69.4861],
              [20.8530540000001, 69.489166],
              [20.853611, 69.49472],
              [20.846943, 69.499161],
              [20.823887, 69.505554000000132],
              [20.671387, 69.553604000000121],
              [20.510555, 69.616943],
              [20.49222200000014, 69.624435],
              [20.485275, 69.628601],
              [20.48083, 69.633331000000112],
              [20.481388, 69.638885],
              [20.56583, 69.761383],
              [20.62028, 69.767487000000131],
              [20.709721, 69.781387],
              [20.770832, 69.79332],
              [20.794441, 69.799438],
              [20.80389, 69.803604],
              [20.808609000000104, 69.806656],
              [20.813053, 69.811935],
              [20.825832, 69.829987],
              [20.826111000000139, 69.835541],
              [20.824444, 69.840546000000131],
              [20.82, 69.845276000000126],
              [20.79944, 69.858047],
              [20.794998000000135, 69.862778],
              [20.790833000000134, 69.867493],
              [20.791386, 69.873047],
              [20.80083100000013, 69.877213],
              [20.901943, 69.90416],
              [21.059444, 69.94611],
              [21.073055, 69.947769000000108],
              [21.089722, 69.945267],
              [21.091663, 69.940277],
              [21.08333, 69.935272000000111],
              [21.064163, 69.927216],
              [21.05333, 69.924164000000133],
              [21.02861, 69.919434],
              [21.006664, 69.913055],
              [20.996944, 69.908875],
              [20.97916, 69.899994000000106],
              [20.895554, 69.85416],
              [20.893608, 69.849442],
              [20.945274, 69.812485],
              [20.990833, 69.78805],
              [21.0, 69.784164],
              [21.01916, 69.78221],
              [21.044998, 69.786102],
              [21.051666, 69.791931],
              [21.13694, 69.868881000000101],
              [21.227497, 69.973053000000107],
              [21.241943, 69.992218],
              [21.247498, 69.998596],
              [21.261665, 70.008041000000105],
              [21.30722, 70.019714000000135],
              [21.319443, 70.022217000000126],
              [21.347221, 70.024994],
              [21.377499, 70.026382000000126],
              [21.414444000000117, 70.023331],
              [21.442776, 70.017487],
              [21.554996, 69.98332],
              [21.601944000000117, 69.953598000000113],
              [21.603886, 69.948608],
              [21.60055, 69.942490000000134],
              [21.594719, 69.935822000000144],
              [21.58083, 69.924438],
              [21.585, 69.919708],
              [21.624165, 69.905],
              [21.67972200000014, 69.88777],
              [21.693886, 69.884995],
              [21.711666, 69.883881],
              [21.744442, 69.883331],
              [21.775, 69.878052],
              [21.793331, 69.870270000000119],
              [21.89111, 69.82805],
              [21.9175, 69.811096],
              [21.92805, 69.801941],
              [21.964443, 69.770264],
              [21.977776, 69.743332000000123],
              [21.981941, 69.738327],
              [22.034721000000104, 69.732773],
              [22.068607, 69.731384],
              [22.09333, 69.736099],
              [22.101665, 69.740829000000133],
              [22.1025, 69.746384],
              [22.10083, 69.751663],
              [22.015274, 69.842209],
              [21.90472, 69.940277],
              [21.797222, 70.0336],
              [21.801941000000113, 70.038879],
              [21.811665, 70.04277],
              [21.82278, 70.045822000000101],
              [21.849163, 70.049713],
              [21.890553, 70.053879],
              [21.98166700000013, 70.055267000000129],
              [22.009441, 70.058044],
              [22.021942, 70.060272],
              [22.031666, 70.064163],
              [22.092777, 70.097214],
              [22.09972, 70.109436],
              [22.09666, 70.113327],
              [22.084164000000101, 70.113052],
              [22.05694, 70.101654],
              [22.048332, 70.09887700000013],
              [21.986385, 70.0861],
              [21.961388, 70.0816650000001],
              [21.750275, 70.056107],
              [21.734997, 70.055542],
              [21.715832, 70.057495000000131],
              [21.481388, 70.095551000000114],
              [21.471943, 70.099442],
              [21.465275, 70.103607],
              [21.461109, 70.108322],
              [21.433331, 70.141663],
              [21.329166, 70.159439000000134],
              [21.309719, 70.161377],
              [21.29555, 70.164154],
              [21.276665, 70.17166],
              [21.20444, 70.202209],
              [21.209019, 70.20752],
              [21.213055, 70.209991],
              [21.224442, 70.213333000000148],
              [21.245216, 70.217804],
              [21.299999000000128, 70.246933],
              [21.51639, 70.303879],
              [21.58416, 70.304153],
              [21.583332, 70.2986],
              [21.586941, 70.288055],
              [21.591389, 70.2836],
              [21.613609, 70.265549],
              [21.62278, 70.261658],
              [21.63472, 70.258331],
              [21.73, 70.23749],
              [21.806664000000126, 70.236099],
              [21.804996000000131, 70.241104],
              [21.806664000000126, 70.252487],
              [21.812496, 70.258881],
              [21.82111, 70.263885],
              [21.840832, 70.271652],
              [21.97694, 70.317215000000147],
              [21.989441000000113, 70.319443],
              [22.00361, 70.320831],
              [22.153889, 70.283051000000114],
              [22.227776, 70.28749],
              [22.26111, 70.286942],
              [22.298611, 70.283875],
              [22.310276000000101, 70.280548000000124],
              [22.316944, 70.276108000000136],
              [22.31583, 70.270554000000118],
              [22.27861, 70.18138],
              [22.34417, 70.14444],
              [22.532497, 70.12027],
              [22.550278, 70.118881],
              [22.557777, 70.122498],
              [22.553608, 70.127213],
              [22.544441, 70.131104000000107],
              [22.51888700000012, 70.13749700000011],
              [22.5, 70.140732],
              [22.488052, 70.142776],
              [22.387775, 70.157776],
              [22.353333000000134, 70.159164000000146],
              [22.336666, 70.161652000000117],
              [22.3275, 70.165543],
              [22.328331, 70.171097000000145],
              [22.37706, 70.249359],
              [22.38472, 70.253326],
              [22.39889, 70.254715],
              [22.4155540000001, 70.25444],
              [22.5, 70.251938000000109],
              [22.519444, 70.24971],
              [22.58639, 70.237778],
              [22.598053, 70.234161],
              [22.598331000000144, 70.229996],
              [22.667500000000132, 70.222488],
              [22.84694, 70.210266],
              [22.86472, 70.209152],
              [22.93111, 70.207764],
              [22.950554, 70.205551],
              [22.964443, 70.202774],
              [22.973610000000122, 70.198883],
              [22.977497, 70.194153],
              [22.973888, 70.18805],
              [22.95916, 70.17667],
              [22.89027, 70.13971],
              [22.832497, 70.114441],
              [22.821388000000127, 70.111374000000126],
              [22.796108000000117, 70.106934000000138],
              [22.720833, 70.098602000000142],
              [22.569164, 70.084717],
              [22.538609, 70.083603],
              [22.52083, 70.084991],
              [22.487778000000105, 70.085541],
              [22.4725, 70.084991],
              [22.444721, 70.082214],
              [22.41972, 70.077774],
              [22.328609000000142, 70.053879],
              [22.30611, 70.047485],
              [22.296108, 70.04361],
              [22.287777000000119, 70.038879],
              [22.296665000000132, 70.034988],
              [22.31194, 70.035553],
              [22.32444, 70.037766],
              [22.358055, 70.047211],
              [22.383053, 70.051666],
              [22.44861, 70.0611],
              [22.490276, 70.065277],
              [22.5, 70.065598000000136],
              [22.566109, 70.067764000000125],
              [22.595276000000126, 70.069717],
              [22.650833, 70.07527],
              [22.81361, 70.094162],
              [22.866665, 70.101379],
              [22.879444, 70.103607],
              [22.991665, 70.088333],
              [23.04555, 70.022766],
              [23.166664000000139, 69.957764],
              [23.31194, 69.940826000000129],
              [23.323330000000112, 69.943878],
              [23.464722, 69.981934],
              [23.47472, 69.985825],
              [23.536663, 70.016937],
              [23.53278, 70.021652],
              [23.51888700000012, 70.024719],
              [23.50111, 70.025833000000148],
              [23.466942, 70.027771],
              [23.433887000000141, 70.02861],
              [23.389721000000122, 70.026382000000126],
              [23.373333, 70.026657000000114],
              [23.35555, 70.028046000000131],
              [23.338886, 70.030548],
              [23.324997, 70.0336],
              [23.260277, 70.049438000000123],
              [23.248608, 70.052765],
              [23.23083, 70.060547],
              [23.17555, 70.088882],
              [23.181942, 70.09332],
              [23.271942000000138, 70.107773],
              [23.34367, 70.114532000000111],
              [23.357777000000112, 70.146378],
              [23.323887, 70.190552000000139],
              [23.33111, 70.219711000000132],
              [23.37833, 70.22028],
              [23.50222, 70.23389],
              [23.519444, 70.23832700000014],
              [23.53083, 70.241379],
              [23.519444, 70.244995000000131],
              [23.464443, 70.24971],
              [23.446388, 70.25082],
              [23.43111, 70.250549],
              [23.41833, 70.248322],
              [23.409164, 70.27388],
              [23.465, 70.311386],
              [23.585552, 70.38361],
              [23.64583, 70.40778],
              [23.652222, 70.414444000000117],
              [23.66, 70.419998000000135],
              [23.808609, 70.482498],
              [23.819164000000114, 70.486374000000126],
              [23.854164, 70.49527],
              [23.894165, 70.500824],
              [23.978611, 70.50943],
              [24.012218000000132, 70.508606],
              [24.030277, 70.507217],
              [24.25222, 70.48111],
              [24.280277, 70.47499],
              [24.303333, 70.468048000000124],
              [24.316109, 70.459442],
              [24.324997, 70.45555],
              [24.34166, 70.452774],
              [24.355831, 70.453888],
              [24.359997, 70.459991],
              [24.35611, 70.464722000000108],
              [24.261387, 70.508881],
              [24.25222, 70.513046],
              [24.229164, 70.519989],
              [24.209721, 70.522217],
              [24.155277000000126, 70.568054],
              [24.29583, 70.66832],
              [24.327499000000103, 70.679718],
              [24.363052, 70.688599000000124],
              [24.476109, 70.677765],
              [24.50194, 70.671387],
              [24.514721, 70.66249],
              [24.623608, 70.621109000000104],
              [24.646664, 70.614166000000125],
              [24.680275, 70.610825],
              [24.694721000000129, 70.61194],
              [24.707775, 70.614166000000125],
              [24.719719, 70.617218],
              [24.729164000000139, 70.621933],
              [24.734444, 70.626938000000109],
              [24.738888, 70.63721],
              [24.737778, 70.642487],
              [24.73055, 70.651932000000102],
              [24.718052, 70.660828],
              [24.699165000000107, 70.67387],
              [24.562222, 70.738876],
              [24.548054, 70.741943000000106],
              [24.52972, 70.743332],
              [24.48, 70.743881],
              [24.40694, 70.749435],
              [24.391388, 70.751099],
              [24.272499, 70.76527],
              [24.258331, 70.7686],
              [24.249165, 70.772491],
              [24.24555, 70.777222],
              [24.25611, 70.831375],
              [24.26555, 70.8361],
              [24.2775, 70.839157000000114],
              [24.38472, 70.865829],
              [24.401943, 70.865555],
              [24.40833, 70.8611],
              [24.41222, 70.856384000000105],
              [24.41333, 70.851105000000132],
              [24.41166, 70.845551000000114],
              [24.467220000000111, 70.81694],
              [24.478886000000102, 70.81332],
              [24.591663, 70.783051],
              [24.617775, 70.776382000000126],
              [24.63472, 70.77583],
              [24.642776, 70.781662],
              [24.64583, 70.79277],
              [24.643887, 70.80305],
              [24.64, 70.80777],
              [24.60805, 70.856384000000105],
              [24.574718000000132, 70.934708],
              [24.584999, 70.958878],
              [24.591942, 70.96304],
              [24.659721, 70.972488],
              [24.67555, 70.973053000000107],
              [24.707497000000103, 70.973602],
              [24.783886000000109, 70.966385000000116],
              [24.853333, 70.934418],
              [24.85972, 70.929977],
              [24.863331, 70.925262],
              [24.859165, 70.919144],
              [24.84972, 70.914703000000145],
              [24.879444, 70.907471],
              [24.97083, 70.909988000000112],
              [24.985275, 70.911102],
              [24.989998000000128, 70.943878],
              [24.990276, 70.948318],
              [24.989166, 70.953323],
              [24.98305, 70.957764],
              [24.97389, 70.961655],
              [24.970276, 70.96637],
              [24.974720000000104, 70.972458],
              [24.988052, 70.974442],
              [25.000000000000114, 70.97267],
              [25.019444, 70.9686],
              [25.031109000000129, 70.965271000000143],
              [25.06333, 70.95416],
              [25.16111, 70.915833],
              [25.216663, 70.88194],
              [25.222775, 70.877487],
              [25.236385, 70.863602000000128],
              [25.249722000000133, 70.849716000000114],
              [25.25333, 70.844711],
              [25.261387, 70.829987],
              [25.262218, 70.824997],
              [25.261387, 70.814163000000121],
              [25.259720000000129, 70.808609000000104],
              [25.277775, 70.802765],
              [25.345554, 70.814163000000121],
              [25.391109, 70.871384],
              [25.394444, 70.882492],
              [25.392776, 70.892776],
              [25.37861, 70.911942000000124],
              [25.359722, 70.924988],
              [25.35083, 70.929153],
              [25.343609, 70.938599],
              [25.339165, 70.948608],
              [25.33833, 70.953598000000113],
              [25.339996, 70.959152000000131],
              [25.347221000000104, 70.96582],
              [25.35805, 70.969437],
              [25.374165000000119, 70.969711000000132],
              [25.393608, 70.967499],
              [25.40805, 70.96443],
              [25.44278, 70.953598000000113],
              [25.46333, 70.94611],
              [25.510555, 70.926666],
              [25.52833, 70.918884],
              [25.534443, 70.914444],
              [25.54139, 70.904709000000139],
              [25.63777, 70.89194],
              [25.85555, 70.893875],
              [25.868889000000138, 70.8936],
              [25.89889, 70.89082],
              [25.907776000000126, 70.88666],
              [25.924164, 70.868042000000116],
              [25.927498, 70.863052],
              [25.92305, 70.857208],
              [25.91333, 70.852493],
              [25.86222, 70.831100000000106],
              [25.851387000000102, 70.827209],
              [25.773888, 70.80194],
              [25.687222, 70.77388],
              [25.654720000000111, 70.734985000000108],
              [25.655277, 70.729721],
              [25.64833, 70.72333],
              [25.64, 70.717773],
              [25.63028, 70.713043],
              [25.527222000000108, 70.671936],
              [25.356388, 70.60611],
              [25.218609000000129, 70.555832],
              [25.2066650000001, 70.55305],
              [25.10055, 70.515],
              [25.089722, 70.511108],
              [25.080555, 70.506378],
              [25.073608, 70.500000000000114],
              [25.085, 70.496384],
              [25.099163, 70.497498],
              [25.152775, 70.50499],
              [25.188332, 70.513611],
              [25.259163, 70.488602000000128],
              [25.26861, 70.40887],
              [25.274719, 70.404709],
              [25.273052000000121, 70.39888],
              [25.266109000000142, 70.392487],
              [25.256664, 70.387772],
              [25.24361, 70.385818],
              [25.228333, 70.387772],
              [25.200275, 70.391937],
              [25.187496000000124, 70.39416],
              [25.141666, 70.38138],
              [25.089996, 70.361664],
              [25.083332, 70.35527],
              [25.103333000000134, 70.319443],
              [25.109444, 70.31499],
              [25.124996, 70.315277],
              [25.136665, 70.318329000000119],
              [25.13389, 70.27943],
              [25.019444, 70.240265],
              [24.988052, 70.228882],
              [24.98, 70.223328],
              [24.964165, 70.19388],
              [24.94639, 70.1525],
              [24.943333, 70.14139],
              [24.940552, 70.098053],
              [24.942497, 70.087769],
              [24.94861, 70.083328],
              [24.98333, 70.06749],
              [25.000000000000114, 70.060989],
              [25.003052, 70.059998],
              [25.02083, 70.058609000000104],
              [25.034721, 70.059708],
              [25.045277, 70.063599000000124],
              [25.05722, 70.083992],
              [25.056053, 70.090157],
              [25.045053000000109, 70.097992],
              [25.034721, 70.102829],
              [25.030554, 70.10849],
              [25.030054, 70.111664000000133],
              [25.03089, 70.11499],
              [25.033386, 70.118652000000111],
              [25.042889000000116, 70.123993],
              [25.065241, 70.141533],
              [25.092499, 70.147217],
              [25.085831, 70.140823000000125],
              [25.086220000000139, 70.124657000000127],
              [25.08372, 70.120995],
              [25.082720000000108, 70.117653],
              [25.09489, 70.093987],
              [25.09689, 70.091],
              [25.111942000000113, 70.07666],
              [25.143608, 70.076385],
              [25.157776000000126, 70.077499],
              [25.23472, 70.089722000000108],
              [25.255554, 70.09749],
              [25.264999000000103, 70.102219000000105],
              [25.39583, 70.198608],
              [25.513611000000139, 70.26416],
              [25.525, 70.276657],
              [25.529442000000131, 70.282486],
              [25.536663, 70.29332],
              [25.535, 70.303604],
              [25.52138, 70.306931000000134],
              [25.489166000000125, 70.30722],
              [25.45388800000012, 70.312210000000107],
              [25.432499, 70.3186],
              [25.42388, 70.322495],
              [25.43111, 70.333328],
              [25.45027, 70.348877],
              [25.460552000000121, 70.354431],
              [25.472221, 70.357208],
              [25.512218, 70.374161],
              [25.582222, 70.408325000000104],
              [25.79805, 70.51721],
              [25.9475, 70.582489],
              [25.95833, 70.586105],
              [25.969166, 70.589996],
              [25.999165000000119, 70.603043000000127],
              [26.007774, 70.608597000000145],
              [26.012218, 70.614441000000113],
              [26.024441000000138, 70.64277600000014],
              [26.026386000000116, 70.648331],
              [26.242496, 70.78944],
              [26.35139, 70.85083],
              [26.36972, 70.8611],
              [26.523331, 70.925827],
              [26.54555, 70.933044],
              [26.570274, 70.938889],
              [26.679443, 70.953598000000113],
              [26.693886, 70.9525],
              [26.723053, 70.926102],
              [26.72639, 70.921387],
              [26.734444, 70.896103],
              [26.690277, 70.73582],
              [26.68528, 70.729721],
              [26.66805, 70.718887],
              [26.649719, 70.708603],
              [26.627777, 70.701385],
              [26.603333, 70.695541],
              [26.565830000000119, 70.688049],
              [26.539165, 70.684158],
              [26.48222, 70.678879],
              [26.45666, 70.67387],
              [26.370831000000123, 70.654999],
              [26.350277, 70.646652],
              [26.342777, 70.640274],
              [26.35139, 70.63611],
              [26.368332000000123, 70.635544],
              [26.408054000000106, 70.641388],
              [26.445553, 70.649155],
              [26.498886, 70.65694],
              [26.51333, 70.658051000000114],
              [26.54472, 70.6586],
              [26.644444, 70.643600000000106],
              [26.653053, 70.639435000000105],
              [26.65361, 70.63443],
              [26.651386000000116, 70.628876],
              [26.60639, 70.538605],
              [26.597775, 70.533325],
              [26.55555, 70.498322],
              [26.514164, 70.431931],
              [26.51222, 70.426376000000118],
              [26.50444, 70.368332],
              [26.504997, 70.36305],
              [26.516666, 70.354156],
              [26.527775, 70.350555],
              [26.54666, 70.348053000000107],
              [26.561108, 70.349152000000117],
              [26.571941, 70.35277],
              [26.62722, 70.372772000000111],
              [26.758053000000132, 70.421661],
              [26.79444100000012, 70.44194],
              [26.801941, 70.44832],
              [26.80389, 70.453888],
              [26.803608000000111, 70.468597000000102],
              [26.798332, 70.477219000000105],
              [26.84166, 70.48054500000012],
              [26.92639, 70.476105000000132],
              [26.97389, 70.456665],
              [27.029442, 70.474152],
              [26.99055, 70.519714],
              [26.975277000000119, 70.562775],
              [26.97472, 70.567764],
              [27.01194, 70.58804],
              [27.058331, 70.61055],
              [27.071388, 70.610275],
              [27.08833, 70.602219],
              [27.099442, 70.598602],
              [27.23472, 70.582214000000135],
              [27.26777600000014, 70.578598000000113],
              [27.268608, 70.583054],
              [27.259998, 70.586929],
              [27.23222, 70.598877],
              [27.209999, 70.60611],
              [27.146385000000123, 70.623322],
              [27.084442, 70.699707000000103],
              [27.089443000000131, 70.705551000000128],
              [27.104443000000117, 70.718323000000112],
              [27.1325, 70.738052],
              [27.139721000000122, 70.742218],
              [27.153332, 70.744156],
              [27.254997000000117, 70.749161],
              [27.28055, 70.7686],
              [27.283054, 70.774155],
              [27.304165, 70.813889],
              [27.30917, 70.819992000000127],
              [27.319164000000114, 70.82443],
              [27.334999, 70.82471],
              [27.351944, 70.823883],
              [27.424164, 70.815277],
              [27.514721000000122, 70.806931],
              [27.565552, 70.804718],
              [27.51028, 70.861938000000123],
              [27.46, 70.875824],
              [27.382774, 70.878601],
              [27.30917, 70.880829000000119],
              [27.276386, 70.881378],
              [27.258331000000112, 70.883041],
              [27.205276, 70.88916],
              [27.174442, 70.895554],
              [27.16333, 70.899155000000121],
              [27.13472, 70.91083],
              [27.123055000000136, 70.919708],
              [27.122498, 70.924988],
              [27.13611, 70.95833],
              [27.22333, 71.018875],
              [27.23333, 71.0236],
              [27.258331000000112, 71.02916],
              [27.273052, 71.03027],
              [27.458885, 71.00665],
              [27.475555, 71.003876000000105],
              [27.519722, 71.070831],
              [27.522221, 71.076385],
              [27.531109, 71.08194],
              [27.565277, 71.092773],
              [27.651665, 71.113052],
              [27.730831000000137, 71.087219000000118],
              [27.7675, 71.051666],
              [27.869999, 71.032211],
              [27.88611, 71.032211],
              [27.965832, 71.045273000000122],
              [27.978333, 71.04805],
              [28.008053, 71.06248],
              [28.03083, 71.069717],
              [28.207775, 71.079987],
              [28.224442, 71.076935],
              [28.235554, 71.07332],
              [28.243889, 71.069153],
              [28.255276, 71.060272],
              [28.26111, 71.050552],
              [28.26139, 71.045273000000122],
              [28.343609000000129, 71.003326],
              [28.377777, 71.001663000000121],
              [28.467777000000126, 70.99388],
              [28.486942, 70.991104],
              [28.5175, 70.984711000000118],
              [28.539444, 70.977219],
              [28.547775000000115, 70.973053000000107],
              [28.550831, 70.968323],
              [28.533886, 70.941101000000117],
              [28.520554, 70.923599],
              [28.4436070000001, 70.860275],
              [28.364441, 70.82443],
              [28.263611000000139, 70.791107],
              [28.25222, 70.787491],
              [28.239719, 70.784714000000122],
              [28.225277, 70.7836],
              [28.13777, 70.780273],
              [28.01638800000012, 70.790833000000134],
              [28.00528, 70.794434],
              [27.800278, 70.791656],
              [27.785831, 70.790833000000134],
              [27.772221000000116, 70.788879000000122],
              [27.762218, 70.784439],
              [27.765, 70.779434],
              [27.828331, 70.767487],
              [27.886665, 70.76388500000013],
              [27.921665000000132, 70.761383],
              [28.113609, 70.737778000000105],
              [28.127220000000136, 70.73443600000013],
              [28.131664000000114, 70.730820000000108],
              [28.125553, 70.72583],
              [28.116386, 70.720276],
              [28.086109000000135, 70.7066650000001],
              [28.074997, 70.703049],
              [28.037777, 70.694717],
              [27.842499, 70.650543],
              [27.658607000000131, 70.60889],
              [27.6475, 70.60527],
              [27.663887, 70.602493],
              [27.710831, 70.60277],
              [27.740833000000123, 70.603882000000112],
              [27.796665, 70.609436],
              [27.836941, 70.615265],
              [28.128052, 70.66693],
              [28.165276000000119, 70.675278],
              [28.176388, 70.678879],
              [28.186665, 70.683319],
              [28.195553, 70.688889000000131],
              [28.203331, 70.695267],
              [28.2125, 70.700546],
              [28.272221, 70.716110000000128],
              [28.286663, 70.716934],
              [28.294998, 70.712769],
              [28.297775, 70.708054],
              [28.300831, 70.69804],
              [28.30139, 70.682495],
              [28.28889, 70.654709],
              [28.283607000000131, 70.6486],
              [28.275833, 70.642487],
              [28.250832, 70.62443],
              [28.241943, 70.61888],
              [28.22277, 70.60889],
              [28.1925, 70.595551],
              [28.151108, 70.578323],
              [28.129997, 70.569992],
              [27.99722, 70.525543],
              [27.974998, 70.518326000000116],
              [27.941944, 70.50943],
              [27.917500000000132, 70.503876],
              [27.87527, 70.492767000000129],
              [27.856941, 70.484985],
              [27.851665000000139, 70.478882],
              [27.879051000000118, 70.448166],
              [27.901386, 70.44194],
              [27.97416, 70.476379],
              [28.065277, 70.491104],
              [28.1055530000001, 70.49666],
              [28.147778, 70.500549],
              [28.176666, 70.502213],
              [28.182220000000143, 70.497772],
              [28.17222, 70.493332000000123],
              [28.134441, 70.4861],
              [28.109997, 70.48054500000012],
              [28.087498, 70.473328],
              [28.057499, 70.459717],
              [28.048611000000108, 70.454163],
              [28.041111, 70.447769],
              [28.041111, 70.44276],
              [28.04416700000013, 70.43777],
              [28.052219, 70.433884],
              [28.11972, 70.434708],
              [28.130833000000109, 70.43832],
              [28.138611, 70.444717],
              [28.149721, 70.454102000000148],
              [28.154388, 70.457771],
              [28.178333, 70.473328],
              [28.231941, 70.505829000000119],
              [28.304165, 70.51054],
              [28.318607, 70.511383000000137],
              [28.332775, 70.51027],
              [28.335552, 70.505554000000132],
              [28.330276, 70.499435],
              [28.32249800000011, 70.493332000000123],
              [28.305832000000123, 70.481384000000105],
              [28.254166, 70.44722],
              [28.1925, 70.406387],
              [28.169167, 70.387207],
              [28.153889000000106, 70.369431],
              [28.154163, 70.35916],
              [28.15916, 70.228882],
              [28.163055, 70.203323],
              [28.179996, 70.174438],
              [28.185276, 70.169998],
              [28.18583, 70.159439000000134],
              [28.183331, 70.15388],
              [28.165554, 70.130554],
              [28.158054000000106, 70.124161000000129],
              [28.132774, 70.106934000000138],
              [28.106667, 70.09082],
              [28.088608000000136, 70.081375],
              [28.038887, 70.061935000000119],
              [28.06722, 70.063599000000124],
              [28.080555000000118, 70.065552],
              [28.101944, 70.070831],
              [28.123608, 70.078049],
              [28.13361, 70.082489],
              [28.159721, 70.09887700000013],
              [28.198055000000124, 70.130264],
              [28.227219, 70.15971],
              [28.23222, 70.165543],
              [28.23222, 70.17082],
              [28.21583, 70.184158],
              [28.198887, 70.21304],
              [28.191109, 70.279999],
              [28.19083, 70.28526],
              [28.224442, 70.38916],
              [28.23222, 70.400833000000148],
              [28.331944, 70.474152],
              [28.480274000000122, 70.629715],
              [28.509163000000115, 70.675278],
              [28.528053, 70.705826000000116],
              [28.522221, 70.715546],
              [28.522221, 70.720825],
              [28.5275, 70.726654],
              [28.543610000000115, 70.739166],
              [28.742222, 70.855270000000132],
              [28.754444, 70.859436],
              [28.803333, 70.871384],
              [28.828609, 70.876663],
              [28.853886, 70.880554000000132],
              [28.883331, 70.882217],
              [28.899166, 70.882217],
              [28.949165, 70.880554000000132],
              [29.036110000000122, 70.87416],
              [29.24305, 70.845825],
              [29.253887, 70.84193],
              [29.262218000000132, 70.837769],
              [29.318886, 70.79332],
              [29.3475, 70.690277],
              [29.346943000000124, 70.664154],
              [29.57888800000012, 70.7066650000001],
              [29.624722, 70.720825],
              [29.656109, 70.73416],
              [29.6655540000001, 70.739441],
              [29.677219, 70.743042],
              [29.693886, 70.742218],
              [29.765274, 70.734711],
              [29.78167, 70.731659],
              [29.78611, 70.706375],
              [29.785553, 70.695831],
              [29.7825, 70.685272],
              [29.776665, 70.67416],
              [29.765553000000125, 70.662216000000114],
              [29.757221000000129, 70.656097000000102],
              [29.747776, 70.650543],
              [29.733055, 70.64305],
              [29.701942, 70.629715],
              [29.691944, 70.627487],
              [29.681664, 70.623047],
              [29.676109, 70.617218],
              [29.689442, 70.613602],
              [29.703888, 70.614441000000113],
              [29.796944, 70.628601],
              [29.835552, 70.635544],
              [29.846943, 70.639160000000118],
              [29.855274, 70.645264000000111],
              [29.85833, 70.650833],
              [29.866665, 70.65694],
              [29.87611, 70.66249],
              [29.944164, 70.699432],
              [29.95472, 70.703888],
              [29.980831, 70.708328],
              [30.009163, 70.71083],
              [30.07111, 70.711380000000133],
              [30.08694, 70.711380000000133],
              [30.101944, 70.709152],
              [30.115276, 70.705551000000128],
              [30.19527, 70.679443],
              [30.338333, 70.605545],
              [30.34861, 70.59637],
              [30.341663, 70.591385000000116],
              [30.297775000000115, 70.575821],
              [30.234997, 70.554443000000106],
              [30.066387, 70.536102],
              [30.015553, 70.53999],
              [30.00111, 70.539154],
              [30.002499, 70.5352630000001],
              [30.013054, 70.531387],
              [30.036942, 70.524155000000121],
              [30.05555, 70.521378],
              [30.142776, 70.512772],
              [30.158333, 70.512772],
              [30.172775, 70.513611],
              [30.213608000000136, 70.5186],
              [30.2666660000001, 70.526382],
              [30.279163, 70.528885],
              [30.302219, 70.536102],
              [30.312775000000101, 70.540543],
              [30.336666, 70.54666],
              [30.362778, 70.550827],
              [30.40555, 70.554153],
              [30.434719, 70.555832],
              [30.465, 70.556381],
              [30.482777, 70.554443000000106],
              [30.58416, 70.541107000000125],
              [30.597221000000104, 70.537766],
              [30.605, 70.5336],
              [30.604721, 70.528320000000122],
              [30.637775, 70.490265],
              [30.825832000000105, 70.432495000000131],
              [30.92916, 70.451935000000105],
              [30.943886000000134, 70.44971],
              [30.951664000000108, 70.445541],
              [31.00861, 70.395828000000108],
              [31.040833, 70.346375],
              [31.078053, 70.289154],
              [31.074718, 70.2836],
              [31.063332, 70.28027],
              [30.91111, 70.258881],
              [30.896664, 70.258041],
              [30.881386, 70.258331],
              [30.733055, 70.257492000000127],
              [30.535275, 70.243042],
              [30.523052000000121, 70.240555],
              [30.361385, 70.179718],
              [30.35305, 70.173599],
              [30.349998, 70.168045],
              [30.352497, 70.16305],
              [30.357498000000135, 70.1586],
              [30.364166000000125, 70.155273],
              [30.38472, 70.147491000000116],
              [30.381664, 70.141937],
              [30.373333000000116, 70.135818],
              [30.353886000000102, 70.126099],
              [30.343609, 70.121658000000139],
              [30.32, 70.115555],
              [30.114998, 70.070541],
              [30.094444000000124, 70.068604],
              [29.933609, 70.063049],
              [29.906666, 70.06277],
              [29.876389000000131, 70.06277],
              [29.796944, 70.065826],
              [29.780552, 70.06694],
              [29.762218, 70.069717],
              [29.515, 70.096939],
              [29.263611000000139, 70.116379],
              [29.035553, 70.128326000000129],
              [28.816666000000112, 70.16832],
              [28.748333, 70.17667],
              [28.73194100000012, 70.177490000000148],
              [28.700275, 70.178329],
              [28.656387000000109, 70.17638],
              [28.616665000000125, 70.171097000000145],
              [28.594719000000111, 70.16388],
              [28.594719000000111, 70.1586],
              [28.61222, 70.156662],
              [28.656109, 70.1586],
              [28.697777, 70.162216],
              [28.711109, 70.164154],
              [28.740555, 70.16499],
              [28.75389, 70.161652000000117],
              [28.75389, 70.156387],
              [28.74389, 70.151932],
              [28.668888, 70.124985],
              [28.644444000000135, 70.119431],
              [28.61533, 70.11566],
              [28.60972, 70.112488],
              [28.612499, 70.107773],
              [28.62833, 70.10472],
              [28.83277500000014, 70.074432000000115],
              [29.001942, 70.052765],
              [29.20111, 70.01388500000013],
              [29.263054, 70.012772],
              [29.394722, 70.001663000000121],
              [29.524719, 69.987213],
              [29.640274, 69.973602],
              [29.671665000000132, 69.9675],
              [29.660831, 69.96083],
              [29.587219, 69.932495],
              [29.561386, 69.927216],
              [29.501942, 69.913055],
              [29.432499, 69.894440000000145],
              [29.371666, 69.860275],
              [29.36555, 69.855270000000132],
              [29.377499, 69.852768],
              [29.40861, 69.85165400000011],
              [29.422775, 69.852768],
              [29.434719, 69.855270000000132],
              [29.471386000000109, 69.878876],
              [29.481941, 69.890823],
              [29.525276000000133, 69.90582],
              [29.536388000000102, 69.909439],
              [29.550278, 69.91026],
              [29.70472, 69.915268],
              [29.721943000000124, 69.91333],
              [29.73222, 69.909714],
              [29.737499, 69.90527],
              [29.77166, 69.837219],
              [29.771385, 69.83194],
              [29.74139, 69.804993],
              [29.692219000000136, 69.781937],
              [29.67388, 69.774155000000121],
              [29.648609000000135, 69.769989],
              [29.636665, 69.767212],
              [29.49472, 69.667221],
              [29.486664000000133, 69.660828],
              [29.486664000000133, 69.655548],
              [29.499722, 69.657211],
              [29.532497, 69.668045],
              [29.551388, 69.677765],
              [29.557499, 69.682770000000119],
              [29.563053000000139, 69.688889000000131],
              [29.570831000000112, 69.694992],
              [29.57972, 69.70027],
              [29.65361, 69.728043],
              [29.664719000000105, 69.731659],
              [29.689720000000136, 69.73582],
              [29.716663, 69.738602],
              [29.94833, 69.753876],
              [30.026108000000136, 69.731934],
              [30.14138800000012, 69.69249],
              [30.173611000000108, 69.687210000000107],
              [30.18861, 69.687210000000107],
              [30.188889, 69.69249],
              [30.184998000000121, 69.696106],
              [30.143055, 69.723602],
              [30.129038, 69.761818],
              [30.190186, 69.764458],
              [30.160139000000129, 69.802933],
              [30.158054000000106, 69.851944000000117],
              [30.16694, 69.873596000000134],
              [30.17805, 69.877213],
              [30.294167, 69.880829],
              [30.308609, 69.878601],
              [30.321663, 69.87527],
              [30.329166, 69.870819],
              [30.400555, 69.827499000000103],
              [30.402775, 69.822495000000117],
              [30.4175, 69.767776],
              [30.41972, 69.721375],
              [30.418331, 69.700546],
              [30.412498, 69.689713],
              [30.406944, 69.683609],
              [30.39666, 69.67915],
              [30.385830000000112, 69.67582700000014],
              [30.346664, 69.670547],
              [30.337219, 69.66832],
              [30.351387000000102, 69.666107],
              [30.367496000000131, 69.664993],
              [30.411388, 69.665543],
              [30.423611, 69.66832],
              [30.433609, 69.672775],
              [30.442776, 69.678055],
              [30.449444, 69.683044],
              [30.452221000000122, 69.688599000000124],
              [30.469166, 69.739166],
              [30.46944, 69.744431],
              [30.465, 69.754166],
              [30.454445, 69.763924],
              [30.450275, 69.767776],
              [30.444721, 69.803329],
              [30.445, 69.80832],
              [30.455276, 69.812775],
              [30.46833, 69.814438],
              [30.556942, 69.815552000000139],
              [30.587219, 69.815277],
              [30.634441, 69.81305],
              [30.710278, 69.80638],
              [30.723053000000107, 69.802765000000136],
              [30.788002, 69.790573],
              [30.854839, 69.792313],
              [30.902775000000133, 69.731934],
              [30.943333, 69.690552],
              [30.947220000000129, 69.654434],
              [30.95138500000013, 69.613876000000118],
              [30.950275, 69.603607],
              [30.945831000000112, 69.58221],
              [30.936665, 69.565826000000129],
              [30.920277, 69.553329000000133],
              [30.91, 69.548874000000126],
              [30.898888, 69.545273],
              [30.86389, 69.536652000000117],
              [30.824718000000132, 69.531662],
              [30.796944, 69.530273],
              [30.76722, 69.530548000000124],
              [30.546108, 69.544159],
              [30.529163, 69.546097],
              [30.511387, 69.549164000000133],
              [30.453331000000105, 69.567215],
              [30.39305, 69.59055],
              [30.370552, 69.603043000000127],
              [30.345554000000106, 69.615265000000136],
              [30.335552000000121, 69.619156],
              [30.305275, 69.630554],
              [30.203609, 69.663879],
              [30.188332000000116, 69.66693],
              [30.172497000000135, 69.668045],
              [30.1575, 69.668045],
              [30.129444, 69.666382],
              [30.115833, 69.664650000000108],
              [30.103333, 69.663055],
              [30.083885, 69.65639],
              [30.076385, 69.65222],
              [30.073608, 69.646652],
              [30.072777, 69.631104],
              [30.088055, 69.627777],
              [30.102219, 69.628601],
              [30.13179, 69.628403],
              [30.142776, 69.628326],
              [30.182499000000121, 69.589157],
              [30.184998000000121, 69.582764],
              [30.182220000000143, 69.574158000000125],
              [30.176388, 69.566101000000117],
              [30.097775, 69.503326],
              [30.06277, 69.487778],
              [29.898609, 69.43277],
              [29.665, 69.373886],
              [29.603333000000134, 69.360275000000115],
              [29.57194, 69.353882],
              [29.53833, 69.347214],
              [29.483608, 69.340820000000122],
              [29.408333, 69.333054],
              [29.321663000000115, 69.31944],
              [29.309998, 69.315277],
              [29.302219, 69.31055],
              [29.29694400000011, 69.304443],
              [29.29444, 69.29887],
              [29.294167, 69.29361],
              [29.296665000000132, 69.2836],
              [29.304165, 69.26916],
              [29.311665000000119, 69.25972],
              [29.316666, 69.255264],
              [29.321663000000115, 69.245544000000109],
              [29.32025, 69.24209],
              [29.315628, 69.230774],
              [29.298332, 69.193878],
              [29.293053, 69.18277],
              [29.25444, 69.119995],
              [29.239166, 69.107498],
              [29.2305530000001, 69.101944],
              [29.20472, 69.085831],
              [29.19611, 69.08055],
              [29.177776, 69.070541],
              [29.129719, 69.04805],
              [29.09916, 69.036377],
              [29.063332, 69.029160000000104],
              [29.049721, 69.02832],
              [29.019997000000103, 69.031387],
              [29.004776000000106, 69.035248],
              [28.995337, 69.03851],
              [28.957340000000102, 69.05162],
              [28.890553, 69.07138],
              [28.857777000000112, 69.082214],
              [28.827499, 69.093597000000102],
              [28.802219, 69.10554500000012],
              [28.786942, 69.119156],
              [28.784443, 69.123886],
              [28.781944, 69.13415],
              [28.78167, 69.149719],
              [28.784164, 69.16055],
              [28.796665, 69.188324],
              [28.819164, 69.231934],
              [28.82694, 69.23805],
              [28.83639, 69.242767],
              [28.902775, 69.274994],
              [28.92194400000011, 69.284164],
              [28.931664, 69.288605000000132],
              [28.991665000000125, 69.313889000000131],
              [29.002499, 69.317215000000147],
              [29.033333, 69.330551000000128],
              [29.064163, 69.343887],
              [29.122219, 69.37082],
              [29.2691650000001, 69.451935000000105],
              [29.285553, 69.463608000000136],
              [29.299721, 69.480270000000132],
              [29.299721, 69.48555],
              [29.29472, 69.495270000000119],
              [29.183887, 69.626099],
              [29.176109, 69.635269],
              [29.127499, 69.685822],
              [29.106667, 69.703888],
              [29.09889, 69.708054000000118],
              [29.009441, 69.720551000000114],
              [28.992222, 69.722488000000112],
              [28.94611, 69.72861],
              [28.909721, 69.733887],
              [28.744164, 69.75972],
              [28.694721, 69.7686],
              [28.404999, 69.821655],
              [28.379719, 69.827499000000103],
              [28.37194, 69.83166],
              [28.366665, 69.836105],
              [28.358330000000137, 69.845551],
              [28.358330000000137, 69.85083],
              [28.34472, 69.87498],
              [28.339165, 69.87944],
              [28.32333, 69.8875],
              [28.31028, 69.890823],
              [28.276108000000136, 69.896652],
              [28.226665000000139, 69.902222000000108],
              [28.197220000000129, 69.906387000000109],
              [28.165833, 69.912216000000114],
              [28.1525, 69.915543],
              [28.109997, 69.930542000000116],
              [28.094166, 69.938599],
              [27.998055, 69.993607],
              [27.98472, 70.00221],
              [27.979164, 70.006653],
              [27.973331, 70.016388],
              [27.9725, 70.037216],
              [27.974998, 70.04277],
              [27.97472, 70.04805],
              [27.968887, 70.057495000000131],
              [27.960552, 70.06694],
              [27.944164000000114, 70.08027600000014],
              [27.936108, 70.084442],
              [27.926556, 70.087158],
              [27.918888, 70.088333],
              [27.902496, 70.088882],
              [27.87305, 70.088043],
              [27.599442000000124, 70.072495],
              [27.57333, 70.068878],
              [27.567497, 70.063889000000131],
              [27.42139, 70.016663000000108],
              [27.299999, 69.99055],
              [27.29555, 69.98443600000013],
              [27.297497, 69.979431],
              [27.303886, 69.975266],
              [27.306942, 69.970276],
              [27.31028, 69.960266000000104],
              [27.303055, 69.95389],
              [27.291943000000117, 69.949997],
              [27.28055, 69.94722],
              [27.20611, 69.93332],
              [27.08083, 69.910553],
              [27.068886, 69.9086],
              [27.054443, 69.907486],
              [27.03722, 69.908051000000114],
              [26.90361, 69.924164000000133],
              [26.884998, 69.926666],
              [26.87222, 69.929718],
              [26.866108, 69.934433],
              [26.865276000000108, 69.944717],
              [26.85722, 69.948608],
              [26.80658, 69.95206],
              [26.61639, 69.95166],
              [26.601944, 69.950272],
              [26.483055, 69.937485],
              [26.470554, 69.935272000000111],
              [26.449997, 69.927216],
              [26.43583, 69.914444],
              [26.424164, 69.901932],
              [26.416111000000114, 69.889999],
              [26.402222, 69.871933],
              [26.395, 69.865555],
              [26.378052, 69.854431],
              [26.36944, 69.84999],
              [26.174164000000133, 69.751663],
              [26.15583, 69.74249],
              [26.134441, 69.734985000000108],
              [26.10055, 69.726379],
              [26.009998, 69.713333],
              [25.99889, 69.71054],
              [25.988331, 69.7066650000001],
              [25.978333, 69.701935],
              [25.965832, 69.691376],
              [25.952774, 69.679993],
              [25.945831, 69.673325],
              [25.94194, 69.667221],
              [25.942497, 69.66222],
              [25.94778, 69.65805],
              [25.964722, 69.649719],
              [25.97416, 69.635269],
              [25.97472, 69.630264],
              [25.973331, 69.624161],
              [25.971107, 69.61888],
              [25.963608, 69.601944],
              [25.957497, 69.590271000000143],
              [25.949165, 69.57805],
              [25.874165, 69.486374],
              [25.83583, 69.389435],
              [25.833611000000133, 69.384155000000135],
              [25.82972, 69.37805],
              [25.811665, 69.368607000000111],
              [25.770554000000118, 69.353882],
              [25.754997, 69.342209000000139],
              [25.749722, 69.336105],
              [25.739441000000113, 69.318329000000119],
              [25.71333, 69.255264],
              [25.707775, 69.211655],
              [25.708332, 69.206375],
              [25.73222, 69.109161],
              [25.768330000000105, 69.04527],
              [25.76111, 68.989166],
              [25.692219, 68.933884],
              [25.661388000000102, 68.911652],
              [25.652775000000133, 68.906387000000109],
              [25.647499, 68.899719000000118],
              [25.63222, 68.888885],
              [25.623333, 68.884155],
              [25.612221, 68.88138],
              [25.585552, 68.878876],
              [25.57111, 68.878601],
              [25.554443, 68.88026],
              [25.508053, 68.888321000000133],
              [25.49028, 68.890823],
              [25.47333, 68.892212],
              [25.444443, 68.891663],
              [25.43111, 68.890549],
              [25.406944000000124, 68.886383],
              [25.38472, 68.88055],
              [25.36389, 68.873886],
              [25.234165, 68.825272],
              [25.214443, 68.81749],
              [25.188332, 68.803329],
              [25.17305, 68.792221],
              [25.166664, 68.78583],
              [25.15472, 68.767776],
              [25.10611, 68.678055],
              [25.10305, 68.66666],
              [25.104721, 68.656387],
              [25.111385, 68.646652],
              [25.109722, 68.641098],
              [25.103333000000134, 68.634720000000129],
              [25.095833, 68.629166000000112],
              [25.07638500000013, 68.621384000000148],
              [24.93492, 68.580811],
              [24.859203, 68.587341],
              [24.855862, 68.59201],
              [24.843624, 68.60601800000012],
              [24.834442000000138, 68.614990000000148],
              [24.82889, 68.619431],
              [24.811665000000119, 68.63249],
              [24.79777, 68.640823],
              [24.773331, 68.652771],
              [24.75444, 68.660263],
              [24.69028, 68.676376],
              [24.628887, 68.68721],
              [24.578888, 68.691376],
              [24.513332, 68.695831],
              [24.45027, 68.69888],
              [24.416943, 68.70166],
              [24.363331, 68.708328],
              [24.351387, 68.710541],
              [24.33833, 68.713608000000136],
              [24.215553, 68.746384],
              [24.19666, 68.751663],
              [24.120552, 68.7836],
              [24.098053000000107, 68.79582],
              [24.092220000000111, 68.799988],
              [24.088608, 68.804718],
              [24.082775, 68.809158],
              [24.066109, 68.81694],
              [24.055553, 68.820541000000105],
              [24.04472, 68.823883],
              [24.029163, 68.82666],
              [23.97639, 68.83249],
              [23.899441000000138, 68.833878000000141],
              [23.856388, 68.83249],
              [23.83, 68.829987],
              [23.821388000000127, 68.825272],
              [23.816666, 68.819992],
              [23.802219, 68.79582],
              [23.796108, 68.789154],
              [23.783886000000109, 68.776382],
              [23.762497, 68.75943],
              [23.740833, 68.74249],
              [23.711941, 68.719986],
              [23.703609000000142, 68.715271],
              [23.69278, 68.712219000000118],
              [23.679722, 68.710831],
              [23.664165, 68.71138],
              [23.583054000000118, 68.70527600000014],
              [23.517498000000103, 68.69861],
              [23.46722, 68.691666],
              [23.407776, 68.680832],
              [23.333054, 68.659439],
              [23.291386000000102, 68.646378000000141],
              [23.281944000000124, 68.642487],
              [23.260555, 68.636383],
              [23.204166, 68.628601000000117],
              [23.18861, 68.631104],
              [23.16472, 68.637497],
              [23.139442, 68.649155],
              [23.09916, 68.674713],
              [23.072498, 68.691666],
              [23.063889, 68.695541],
              [22.86360900000011, 68.69305],
              [22.802776000000108, 68.691376],
              [22.549999, 68.73778],
              [22.5, 68.728989],
              [22.398331, 68.7111],
              [22.369720000000143, 68.786102],
              [22.363888, 68.804718],
              [22.34861, 68.842499],
              [22.346664, 68.844711000000132],
              [22.27889, 68.881653000000142],
              [22.19722, 68.928055],
              [22.194164, 68.938599],
              [22.197498, 68.944717],
              [22.203053, 68.951111],
              [22.208332, 68.954987000000131],
              [22.04139, 69.05222],
              [21.9946020000001, 69.078369000000123],
              [21.68194, 69.284714],
              [21.320831, 69.326111],
              [21.054996, 69.228607],
              [21.039165, 69.218887],
              [21.0325, 69.21304],
              [21.02805, 69.208054],
              [21.04222, 69.16083],
              [21.053608, 69.140549],
              [21.06611, 69.126389000000131],
              [21.0791660000001, 69.117767000000129],
              [21.113052, 69.108047],
              [21.112499000000128, 69.102219000000105],
              [21.109722, 69.0961],
              [21.10139, 69.083328],
              [21.084721, 69.058044],
              [21.074165, 69.044998000000135],
              [21.067497, 69.03915400000011],
              [21.059444, 69.034439],
              [21.033054, 69.033325000000104],
              [20.98055, 69.04527],
              [20.935555, 69.058609000000104],
              [20.835831, 69.083603],
              [20.82222, 69.08638],
              [20.773888, 69.093597000000102],
              [20.738331, 69.096375],
              [20.72389, 69.095825],
              [20.69749800000011, 69.09277],
              [20.675, 69.087219000000118],
              [20.609444, 69.06944],
              [20.580929, 69.0603],
              [20.535275, 69.05638],
              [20.096943, 69.042221],
              [20.238888, 68.968597],
              [20.314720000000136, 68.92833],
              [20.350277000000119, 68.786652000000117],
              [20.313889, 68.754715000000147],
              [20.23833100000013, 68.691376],
              [20.202499000000103, 68.662216],
              [20.177219, 68.646942],
              [20.063053, 68.583054],
              [19.956387, 68.543884000000105],
              [20.088055, 68.501663],
              [20.211109, 68.482208000000128],
              [20.208611, 68.47583],
              [20.198608, 68.462769],
              [20.175831, 68.448044],
              [20.167221, 68.44388],
              [20.07583, 68.414719],
              [20.048054, 68.403320000000122],
              [20.03028, 68.394989],
              [20.006664, 68.381104000000107],
              [19.976665, 68.361374000000126],
              [19.96416, 68.349716000000114],
              [19.956665, 68.344711],
              [19.94805, 68.34082],
              [19.937775000000101, 68.337494000000106],
              [19.92388, 68.336655],
              [19.898331, 68.341385],
              [19.860554, 68.349991000000102],
              [19.71722, 68.372772000000111],
              [19.543888, 68.399719],
              [19.41333, 68.419434],
              [18.952221, 68.487778],
              [18.611942, 68.475266],
              [18.35805, 68.539154],
              [18.149441, 68.515274],
              [18.099541, 68.508926],
              [18.09083, 68.507767000000115],
              [18.08166, 68.490829],
              [18.058052, 68.439987],
              [18.04583, 68.409439000000134],
              [18.053333, 68.391098000000113],
              [18.069443, 68.35443],
              [18.085831, 68.317764000000125],
              [18.103886, 68.280823],
              [18.155277, 68.16611],
              [18.135555, 68.150269],
              [17.939720000000136, 67.997772000000111],
              [17.884163, 67.945541],
              [17.858055, 67.94861],
              [17.83111, 67.953598],
              [17.82, 67.95694],
              [17.801941, 67.964157],
              [17.74333, 67.984711],
              [17.68027, 68.004440000000102],
              [17.648888, 68.01416],
              [17.5925, 68.029709],
              [17.273609, 68.090546],
              [17.252583, 68.07457],
              [17.234547, 68.062103],
              [17.188332, 68.030273],
              [16.726944000000117, 67.899155],
              [16.68472, 67.83221],
              [16.620277000000101, 67.732208],
              [16.588055, 67.682220000000143],
              [16.57694, 67.665543000000127],
              [16.57027, 67.656937],
              [16.508331000000112, 67.60916],
              [16.403332, 67.529999],
              [16.3825, 67.515549],
              [16.206108, 67.501663000000121],
              [16.192219000000136, 67.5],
              [16.085831, 67.411652000000117],
              [16.086941000000138, 67.406662],
              [16.089722, 67.401657],
              [16.10416, 67.387772],
              [16.11111, 67.383606],
              [16.138611000000139, 67.36749],
              [16.161663, 67.35582],
              [16.204720000000123, 67.337494],
              [16.220554, 67.329987],
              [16.26194, 67.305542],
              [16.3375, 67.260818],
              [16.36138, 67.237778],
              [16.399166, 67.177765],
              [16.40583, 67.16333],
              [16.353886, 67.017776],
              [16.00999800000011, 66.890823],
              [15.73111, 66.684998000000121],
              [15.625832, 66.605820000000108],
              [15.527777, 66.558044],
              [15.362778, 66.479996],
              [15.371387, 66.461655],
              [15.400555, 66.406937],
              [15.446854, 66.32138],
              [15.468054, 66.28387],
              [15.025276, 66.149994],
              [14.981388, 66.149155],
              [14.717777, 66.140549],
              [14.505, 66.132492000000127],
              [14.509165, 66.11472],
              [14.519165, 66.07888800000012],
              [14.534721, 66.025269],
              [14.54055, 66.007492],
              [14.56944, 65.949432000000115],
              [14.58027600000014, 65.931107],
              [14.608889, 65.876389],
              [14.634722, 65.826935],
              [14.631666000000109, 65.816666],
              [14.621387000000141, 65.797211],
              [14.60389, 65.773331],
              [14.588055, 65.75694],
              [14.565277, 65.736374],
              [14.53944, 65.708878000000141],
              [14.535, 65.702774],
              [14.532221000000106, 65.69611],
              [14.50055, 65.585831],
              [14.49722, 65.516098],
              [14.495277000000101, 65.446381],
              [14.49361, 65.376389000000131],
              [14.494444000000101, 65.358887],
              [14.493055, 65.313599],
              [14.368889, 65.246658000000139],
              [14.35611, 65.208603],
              [14.329166, 65.149719],
              [14.319443, 65.12999],
              [14.30883, 65.115234],
              [14.296438000000137, 65.102127],
              [14.235277, 65.048874000000126],
              [14.09139, 64.949158],
              [13.95583, 64.835541000000148],
              [13.879166, 64.771103],
              [13.832777000000135, 64.733322000000101],
              [13.725571, 64.652267],
              [13.7075, 64.63971],
              [13.69694, 64.62944],
              [13.676943, 64.607773000000122],
              [13.664999000000137, 64.589722000000108],
              [13.6625, 64.582764000000111],
              [13.663332, 64.577209],
              [13.68222, 64.5711060000001],
              [13.82028, 64.529434],
              [13.900833, 64.507492],
              [14.032499, 64.488052],
              [14.11639, 64.470551],
              [14.149721, 64.34499],
              [14.151388, 64.3336],
              [14.154722, 64.185822],
              [14.14667, 64.173874],
              [13.988333000000125, 64.018051000000128],
              [13.98166700000013, 64.013046],
              [13.29139, 64.086655000000121],
              [13.23, 64.093048],
              [13.193609, 64.09],
              [13.135555000000124, 64.083603],
              [13.032221, 64.071106],
              [12.988333000000125, 64.064438],
              [12.93805, 64.053329000000133],
              [12.846943, 64.025269],
              [12.794443, 64.007217],
              [12.681944, 63.967216000000121],
              [12.63389, 63.942772],
              [12.53083, 63.87277],
              [12.47305, 63.833328],
              [12.346666, 63.728882000000112],
              [12.153889000000106, 63.594994],
              [12.139444, 63.58416],
              [12.17861, 63.512215],
              [12.195000000000107, 63.485275000000115],
              [12.13722, 63.436661],
              [12.0783330000001, 63.388329000000113],
              [11.998888, 63.323883],
              [11.936388, 63.272217],
              [12.027491, 63.182449],
              [12.036943000000122, 63.173882],
              [12.144165, 63.045273000000122],
              [12.16861, 63.015831],
              [12.15111, 62.999443],
              [12.113333, 62.967216000000121],
              [12.058332, 62.918610000000115],
              [12.028889, 62.892494],
              [12.050278, 62.838882],
              [12.066666, 62.80305],
              [12.089443, 62.74944],
              [12.07278, 62.715828000000101],
              [12.046665, 62.665276],
              [12.047499, 62.589996],
              [12.084721, 62.52916],
              [12.14917, 62.46027400000014],
              [12.17222, 62.43777],
              [12.18444, 62.423882],
              [12.19972, 62.404716000000121],
              [12.21, 62.389999000000103],
              [12.245344, 62.337982000000125],
              [12.256388, 62.327217],
              [12.271387000000118, 62.30805],
              [12.291666, 62.272499],
              [12.295832000000132, 62.261665],
              [12.294617, 62.258217],
              [12.25861, 62.142494],
              [12.214998, 62.006104],
              [12.200277, 61.963333],
              [12.181665, 61.912498000000141],
              [12.169998, 61.87861],
              [12.159443000000124, 61.844444],
              [12.12444, 61.72861],
              [12.144444, 61.7175],
              [12.392776, 61.580551],
              [12.40667, 61.573326],
              [12.430277000000103, 61.569443],
              [12.444721, 61.568604000000107],
              [12.468332, 61.56972],
              [12.481388, 61.569443],
              [12.52305, 61.567215],
              [12.53, 61.566109],
              [12.773888, 61.414719],
              [12.85611, 61.362495000000138],
              [12.83111, 61.312218],
              [12.796665, 61.244995000000131],
              [12.772221000000116, 61.20083],
              [12.670277, 61.087776],
              [12.637825000000134, 61.057541],
              [12.621944, 61.053055],
              [12.60222, 61.049721],
              [12.567221, 61.04805],
              [12.500277, 61.05082700000014],
              [12.458055, 61.053886],
              [12.432499, 61.054443],
              [12.40778, 61.053886],
              [12.388054000000125, 61.05055],
              [12.294167, 61.029442],
              [12.24778, 61.01861],
              [12.222500000000139, 61.01083],
              [12.215555, 61.006943],
              [12.21, 61.002495],
              [12.212776, 60.997498],
              [12.217222, 60.99305],
              [12.233610000000112, 60.98083],
              [12.245554, 60.973053000000107],
              [12.271944, 60.946106],
              [12.308611, 60.887215],
              [12.336111, 60.835831],
              [12.351110000000119, 60.804718],
              [12.353611000000114, 60.79972],
              [12.364721, 60.779442],
              [12.378887000000134, 60.760277],
              [12.38611, 60.750832],
              [12.424999, 60.71027400000014],
              [12.505833000000109, 60.629997000000117],
              [12.5875, 60.526665],
              [12.594444, 60.51694],
              [12.605833, 60.479996],
              [12.608055, 60.468605],
              [12.607498000000135, 60.462494],
              [12.60278, 60.44277],
              [12.597500000000139, 60.424995],
              [12.589722, 60.399162],
              [12.57194, 60.378052],
              [12.537777000000119, 60.343887],
              [12.527777000000128, 60.334160000000111],
              [12.504444, 60.210548],
              [12.507776, 60.193604000000107],
              [12.508333, 60.181938000000116],
              [12.508055, 60.175552],
              [12.5075, 60.16944100000012],
              [12.502777, 60.144722],
              [12.498333, 60.124718],
              [12.496387000000141, 60.11805],
              [12.494165000000123, 60.111107000000118],
              [12.489166, 60.098328],
              [12.476944, 60.076385],
              [12.461943, 60.063606],
              [12.32361, 59.97639],
              [12.310276000000101, 59.968887],
              [12.191944, 59.910271000000137],
              [12.16305, 59.896942],
              [12.14, 59.888329000000113],
              [12.129721, 59.88694],
              [12.10722, 59.885826000000122],
              [12.034166, 59.88611],
              [12.008333000000107, 59.88861],
              [11.998055, 59.890549],
              [11.98, 59.896111],
              [11.968054, 59.89777400000014],
              [11.956944, 59.896942],
              [11.875832, 59.869995000000131],
              [11.852777000000117, 59.861382],
              [11.815960000000132, 59.8461],
              [11.86944, 59.811661],
              [11.881109, 59.803886],
              [11.886665, 59.799164000000133],
              [11.891109, 59.79472],
              [11.896387000000118, 59.784721],
              [11.89885, 59.772469],
              [11.903055, 59.738327],
              [11.903332, 59.720276000000126],
              [11.902777, 59.707771],
              [11.900833, 59.70111],
              [11.896387000000118, 59.695],
              [11.82833, 59.651939],
              [11.820555, 59.648888],
              [11.811666000000116, 59.646942],
              [11.781666, 59.642776],
              [11.76417, 59.63833],
              [11.75639, 59.635551000000135],
              [11.666248, 59.595482],
              [11.667776000000117, 59.59166],
              [11.739166, 59.429718],
              [11.783054000000106, 59.324715],
              [11.79083, 59.303329],
              [11.796944, 59.275276],
              [11.798887, 59.257774],
              [11.79833, 59.245277],
              [11.795277, 59.23917],
              [11.792288, 59.236641000000134],
              [11.784721, 59.23027],
              [11.769547, 59.217537],
              [11.764721, 59.211662],
              [11.759165, 59.200829],
              [11.754444, 59.188049],
              [11.750832, 59.174438],
              [11.739443, 59.12722],
              [11.739443, 59.122498],
              [11.742222, 59.117493],
              [11.746387, 59.112778],
              [11.751944, 59.102776],
              [11.75305, 59.09722],
              [11.75111, 59.090271],
              [11.626665000000116, 58.909164],
              [11.621387, 58.904716],
              [11.599968000000104, 58.899185],
              [11.585833, 58.89666],
              [11.49667, 58.884720000000129],
              [11.463055, 58.88361],
              [11.450832, 58.883888],
              [11.439165000000116, 58.885277],
              [11.431944, 58.88861],
              [11.42778, 58.893051],
              [11.426109, 58.897217],
              [11.424999, 58.903053],
              [11.422777, 58.920273000000122],
              [11.423054, 58.926666],
              [11.429192, 58.98764],
              [11.432499000000121, 58.990555],
              [11.434444, 58.997215],
              [11.431665, 59.00222],
              [11.38583, 59.076111],
              [11.363333, 59.103882],
              [11.356110000000115, 59.107216],
              [11.33694, 59.111938000000123],
              [11.298332, 59.113884],
              [11.203333, 59.106941],
              [11.064165, 59.116661000000136],
              [11.033888, 59.125549],
              [10.940832000000114, 59.164993],
              [10.900276, 59.142494],
              [10.797499, 59.18639],
              [10.764721, 59.220276],
              [10.659166, 59.36388],
              [10.652777, 59.434998],
              [10.65889, 59.432495],
              [10.669998000000135, 59.433052],
              [10.676388, 59.43694],
              [10.680277000000103, 59.442215],
              [10.689999, 59.459717000000126],
              [10.692778, 59.465553],
              [10.692778, 59.471939],
              [10.69146, 59.479263],
              [10.673887, 59.49528],
              [10.660555, 59.5086060000001],
              [10.654722, 59.518608],
              [10.642163, 59.556328000000121],
              [10.63959, 59.610706],
              [10.619899, 59.641106],
              [10.560555, 59.717499],
              [10.557777000000101, 59.728607],
              [10.55944, 59.73555],
              [10.584444000000133, 59.78999],
              [10.60055, 59.811386],
              [10.633888, 59.85305],
              [10.640276, 59.85666700000013],
              [10.649721, 59.85555],
              [10.657221, 59.852219],
              [10.671944, 59.839722],
              [10.695555000000127, 59.799438],
              [10.696943, 59.793610000000115],
              [10.738646, 59.80377],
              [10.760784000000115, 59.836571],
              [10.748333, 59.88694],
              [10.74222200000014, 59.890831],
              [10.725832, 59.89666],
              [10.69417, 59.902771],
              [10.683054, 59.90333],
              [10.67056, 59.887161000000106],
              [10.66472, 59.8836060000001],
              [10.655832, 59.881386],
              [10.58305, 59.877495],
              [10.559721, 59.878052],
              [10.5375, 59.876663000000121],
              [10.527498, 59.875275],
              [10.502222000000131, 59.867775000000108],
              [10.495832, 59.863884],
              [10.474165, 59.847771],
              [10.471666, 59.84333],
              [10.473055, 59.837494],
              [10.481388, 59.802498],
              [10.482777000000112, 59.79694400000011],
              [10.4925, 59.78029],
              [10.491665, 59.763054],
              [10.49111, 59.738052],
              [10.494165, 59.726944],
              [10.5191650000001, 59.681107],
              [10.523611, 59.676666000000125],
              [10.529444, 59.672775],
              [10.555574, 59.666893],
              [10.579166, 59.65666],
              [10.585278, 59.653053],
              [10.59861, 59.639717],
              [10.604443, 59.629715],
              [10.611387, 59.601387000000102],
              [10.611387, 59.595276],
              [10.60972, 59.588333],
              [10.606943, 59.5825],
              [10.594999, 59.566383],
              [10.583611000000133, 59.55805],
              [10.558054, 59.5430530000001],
              [10.513054, 59.524994],
              [10.488054, 59.517494],
              [10.469444, 59.513885],
              [10.458332, 59.513054],
              [10.444721000000129, 59.513885],
              [10.426943, 59.519165],
              [10.4225, 59.5236],
              [10.419443, 59.52861],
              [10.419722, 59.534721000000104],
              [10.423887, 59.564995000000124],
              [10.425278, 59.571663000000115],
              [10.42805, 59.577774],
              [10.429722, 59.584717],
              [10.429722, 59.590828000000101],
              [10.41472, 59.66305],
              [10.413332, 59.66861],
              [10.410555000000102, 59.67361],
              [10.380554, 59.698883],
              [10.374722, 59.702774],
              [10.288055, 59.732773000000122],
              [10.26861, 59.737221],
              [10.247499, 59.734993],
              [10.228611, 59.731384000000105],
              [10.222221, 59.727493],
              [10.225277, 59.7225],
              [10.258333000000107, 59.698326000000122],
              [10.270555, 59.692215],
              [10.276943000000131, 59.68972],
              [10.30551, 59.685265],
              [10.31944, 59.683052],
              [10.3283330000001, 59.679993],
              [10.374998000000119, 59.662498],
              [10.379444, 59.658051],
              [10.3825, 59.653328],
              [10.38694, 59.64249],
              [10.396944000000133, 59.603333],
              [10.39833, 59.591385],
              [10.39833, 59.584999],
              [10.385832, 59.536659],
              [10.383055, 59.530548000000124],
              [10.378054, 59.526108000000136],
              [10.370554, 59.523048],
              [10.358332000000132, 59.523048],
              [10.33861, 59.526382],
              [10.329443, 59.528885],
              [10.305832, 59.538605000000132],
              [10.289444000000117, 59.544441],
              [10.256388, 59.556107],
              [10.247499, 59.558609],
              [10.235277, 59.558609],
              [10.235277, 59.552216000000101],
              [10.23694, 59.54805],
              [10.24694, 59.537773],
              [10.263332, 59.525833],
              [10.3475, 59.47583],
              [10.423611, 59.444443],
              [10.47472, 59.424164],
              [10.483610000000112, 59.415276000000119],
              [10.516388, 59.310829000000126],
              [10.516388, 59.304718],
              [10.513611000000139, 59.298607000000118],
              [10.473610000000122, 59.25388],
              [10.46333, 59.244995],
              [10.45583, 59.241943],
              [10.447222, 59.23972],
              [10.441387000000134, 59.243332],
              [10.43861, 59.248604],
              [10.437222000000133, 59.254166000000112],
              [10.43111, 59.257774],
              [10.383333, 59.268326],
              [10.371387, 59.268326],
              [10.36389, 59.265274],
              [10.359999, 59.259995000000117],
              [10.327221000000122, 59.205276],
              [10.23111, 59.038605],
              [10.148888, 59.019722000000115],
              [10.156387, 59.022774],
              [10.162498000000141, 59.02666],
              [10.167500000000132, 59.031105000000139],
              [10.170277, 59.037216],
              [10.168888, 59.04277],
              [10.163055, 59.046661],
              [10.152222, 59.04722],
              [10.13278, 59.04417],
              [10.026667, 59.006737000000101],
              [10.029722000000106, 58.989532000000111],
              [10.029722000000106, 58.983147],
              [10.02861, 58.97758],
              [10.025833, 58.971764000000121],
              [10.02083, 58.967041000000108],
              [10.00611, 58.96093],
              [9.954721, 58.951942000000145],
              [9.877499, 58.954994],
              [9.833887, 58.964165],
              [9.841389000000106, 58.967216],
              [9.846388, 58.971939],
              [9.848888, 58.97805000000011],
              [9.848888, 58.990555],
              [9.847221, 58.996109],
              [9.842777, 59.000549],
              [9.825554000000125, 59.014442],
              [9.821613, 59.017059],
              [9.786943, 59.03611],
              [9.614166, 59.117775000000108],
              [9.559999000000118, 59.116661000000136],
              [9.54805, 59.116386],
              [9.540833, 59.114716],
              [9.5397210000001, 59.109444],
              [9.544167, 59.104996],
              [9.626389, 59.057777],
              [9.684166, 59.031944000000124],
              [9.693054, 58.98305],
              [9.608055, 58.926666],
              [9.603333, 58.923607000000118],
              [9.5075, 58.891937],
              [9.409443000000124, 58.841385000000116],
              [9.348709, 58.75869],
              [9.339998, 58.750832],
              [9.191111, 58.658333],
              [9.176666, 58.652222],
              [9.064165000000116, 58.616386],
              [9.030554, 58.607216],
              [9.003054, 58.60139],
              [8.995832, 58.59833],
              [8.951666, 58.573051],
              [8.831110000000137, 58.480827],
              [8.79695, 58.464714],
              [8.73927, 58.44874],
              [8.712645, 58.441936000000112],
              [8.7135320000001, 58.417976],
              [8.691944, 58.377220000000136],
              [8.51028, 58.270271],
              [8.40278, 58.254440000000102],
              [8.248055, 58.201942],
              [8.24472, 58.198051],
              [8.24389, 58.16722],
              [8.221666000000141, 58.123886],
              [8.216944, 58.119438],
              [8.211111, 58.11555],
              [8.201944, 58.115273],
              [8.19194, 58.116943],
              [8.155188, 58.140007],
              [8.132221, 58.101662],
              [8.127499, 58.096939],
              [8.118055, 58.095276],
              [7.934722, 58.079437],
              [7.809444, 58.0675],
              [7.660555000000102, 58.044167],
              [7.6275, 58.021385],
              [7.620555, 58.018326000000116],
              [7.611111, 58.016663],
              [7.55972, 58.010826],
              [7.528333, 58.008049000000142],
              [7.48389, 58.005554000000132],
              [7.362778, 58.012772],
              [7.251111, 58.034721],
              [7.22361, 58.043884],
              [7.151388, 58.047775000000115],
              [7.080555, 58.031662],
              [7.07361, 58.028328000000101],
              [7.075555, 58.022774],
              [7.07888800000012, 58.017776],
              [7.080832, 58.012215],
              [7.080277000000137, 58.006660000000124],
              [7.073333, 58.003609],
              [7.049166000000127, 57.996109],
              [7.014444, 57.98778],
              [7.001389000000131, 57.988052],
              [6.93611, 58.03916],
              [6.902778, 58.056107000000111],
              [6.78167, 58.111382],
              [6.73139, 58.116386],
              [6.728333000000134, 58.064163],
              [6.60805, 58.068604000000107],
              [6.597777000000121, 58.070274],
              [6.558888, 58.0975],
              [6.556389, 58.120827],
              [6.587222, 58.15361],
              [6.612778, 58.174995],
              [6.684166, 58.207222],
              [6.767221, 58.238327],
              [6.752777, 58.24972],
              [6.61667, 58.25861],
              [6.360277, 58.27083],
              [6.347587, 58.270782],
              [6.284166000000141, 58.306664000000126],
              [6.23305, 58.321663],
              [6.215278, 58.326385],
              [6.151944, 58.335548],
              [6.134166000000107, 58.339996],
              [6.011944, 58.37971],
              [5.993055, 58.390274],
              [5.98333300000013, 58.398888],
              [5.973055, 58.413605],
              [5.970833, 58.419167],
              [5.968611, 58.437775000000101],
              [5.965555, 58.462494],
              [5.961944, 58.467499],
              [5.95694, 58.471664],
              [5.93778, 58.47555],
              [5.924444, 58.47583],
              [5.900833, 58.474998],
              [5.890277, 58.473885],
              [5.853333, 58.473328],
              [5.77805, 58.48333],
              [5.757222, 58.486664],
              [5.749444, 58.48944],
              [5.644722, 58.544716],
              [5.62583, 58.55555],
              [5.620832, 58.559715],
              [5.51028, 58.665276],
              [5.506666, 58.67],
              [5.457777, 58.744438],
              [5.457672000000116, 58.751083],
              [5.468333, 58.76028],
              [5.518332, 58.825829],
              [5.543333, 58.874718000000144],
              [5.55389, 58.909164],
              [5.551944, 58.9675],
              [5.54083, 58.982216],
              [5.539444, 58.998604],
              [5.54722, 59.028885000000116],
              [5.552777, 59.032776],
              [5.563333, 59.031105000000139],
              [5.57111, 59.028328],
              [5.709722, 58.975273],
              [5.71489, 58.970486],
              [5.705829, 58.941963000000101],
              [5.744419000000107, 58.928204],
              [5.793747, 58.924175],
              [5.817237, 58.928539],
              [5.81623100000013, 58.9475],
              [5.83417, 58.962776],
              [5.84639, 58.963333],
              [5.856944, 58.961662],
              [5.874999, 58.956940000000145],
              [5.89055, 58.95111],
              [5.935555, 58.93305],
              [5.941944, 58.929443],
              [6.008888000000127, 58.88861],
              [6.058055, 58.859161],
              [6.064444, 58.85555],
              [6.11055, 58.837776000000133],
              [6.13028, 58.833885],
              [6.168611000000112, 58.832222000000115],
              [6.2272210000001, 58.83416],
              [6.230277, 58.838333],
              [6.224166, 58.841942],
              [6.200277, 58.842499],
              [6.176110000000108, 58.84166],
              [6.164166, 58.842773],
              [6.14333, 58.846107],
              [6.134166000000107, 58.84833],
              [6.10972, 58.856384],
              [6.101944, 58.859444],
              [6.088055, 58.865829],
              [6.070555, 58.877495],
              [6.060555, 58.885826000000122],
              [6.056944000000101, 58.890831],
              [6.056389, 58.896942],
              [6.059444, 58.902496],
              [6.090555, 58.935272],
              [6.105, 58.948883000000137],
              [6.11639, 58.9566650000001],
              [6.12361, 58.959999],
              [6.131666, 58.962494000000106],
              [6.19194, 58.978882],
              [6.218055, 58.985832],
              [6.25611, 58.99305],
              [6.404166, 59.01722],
              [6.48555, 59.028885000000116],
              [6.588888, 59.042496],
              [6.607778, 59.046104],
              [6.623333, 59.05167],
              [6.623888000000136, 59.057220000000143],
              [6.613333, 59.05888],
              [6.503888, 59.048882],
              [6.39944400000013, 59.03611],
              [6.377777, 59.033051],
              [6.210555000000113, 59.005272],
              [6.1725, 58.998055],
              [6.154722, 58.993607000000111],
              [6.13111, 58.98527],
              [6.117222, 58.978607],
              [6.099999, 58.96666],
              [6.042500000000132, 58.905548],
              [6.040833, 58.902771],
              [6.035277, 58.898888],
              [6.027499, 58.901939],
              [6.0175, 58.91027],
              [5.974619000000132, 58.961929000000112],
              [5.963881, 59.01294],
              [5.936364, 59.0126],
              [5.872222, 59.061661],
              [5.86861, 59.066666000000112],
              [5.866388, 59.072220000000129],
              [5.868333, 59.078331],
              [5.871388, 59.083611],
              [5.875833000000114, 59.08833],
              [5.88722, 59.096382],
              [5.89555, 59.098885],
              [5.95583, 59.115555],
              [6.00944, 59.143051000000128],
              [6.00444, 59.147217],
              [6.00222, 59.152771],
              [6.00417, 59.158882000000119],
              [6.007222000000127, 59.164444],
              [6.064722, 59.204437],
              [6.146667, 59.244995],
              [6.167777, 59.254715],
              [6.31028, 59.30555],
              [6.326944, 59.31055],
              [6.34611, 59.314163],
              [6.367777000000103, 59.316383],
              [6.404444000000126, 59.317497],
              [6.429999000000123, 59.31611],
              [6.4541660000001, 59.316666],
              [6.465278, 59.317772000000105],
              [6.464444000000128, 59.322495],
              [6.45528, 59.324997],
              [6.406666, 59.326385],
              [6.375833, 59.326385],
              [6.331944, 59.32194],
              [6.312778, 59.318329],
              [6.29611100000011, 59.313332],
              [6.281944000000124, 59.306938],
              [6.258888, 59.290833000000134],
              [6.243333, 59.284439],
              [6.134444, 59.258888],
              [6.12361, 59.258049],
              [6.115833, 59.26083],
              [5.995555, 59.329720000000123],
              [5.997499, 59.3361],
              [6.027499, 59.36972],
              [6.031944, 59.374443],
              [6.037777, 59.378326000000129],
              [6.073055, 59.39472],
              [6.102777, 59.40722],
              [6.214722000000108, 59.473053],
              [6.220555000000104, 59.491661000000136],
              [6.229722, 59.501106],
              [6.235555, 59.504997],
              [6.243889, 59.5075],
              [6.39111000000014, 59.540833],
              [6.418888, 59.546944],
              [6.446666, 59.553055],
              [6.46889, 59.555275],
              [6.427500000000123, 59.563332],
              [6.258055, 59.582222],
              [6.248333, 59.565826000000129],
              [6.23083, 59.539444],
              [6.224444, 59.529999],
              [6.171389, 59.47361],
              [6.166944, 59.468887],
              [6.153333, 59.45472],
              [6.1475, 59.450829000000113],
              [6.128888, 59.439438],
              [6.10889, 59.42889],
              [6.081944, 59.415276000000119],
              [5.949166, 59.353607],
              [5.94361, 59.351662],
              [5.933888000000138, 59.35],
              [5.92611, 59.352776],
              [5.921111, 59.356941],
              [5.884166, 59.399162],
              [5.876944, 59.408882],
              [5.878055, 59.42139],
              [5.88194, 59.433609],
              [5.884999, 59.43916],
              [5.88972, 59.443886000000134],
              [5.89667, 59.447220000000129],
              [5.908889000000102, 59.44611],
              [5.916666, 59.443054],
              [5.942222000000129, 59.44194],
              [5.987222, 59.445549],
              [6.143055, 59.4741590000001],
              [6.151388, 59.476662],
              [6.147778, 59.48166700000013],
              [6.139999000000103, 59.48472],
              [6.129167, 59.486382],
              [6.118333, 59.486664],
              [5.895277, 59.476662],
              [5.80778, 59.46916],
              [5.713055000000111, 59.436661],
              [5.665277, 59.411442000000136],
              [5.661777, 59.409107],
              [5.664944, 59.407272],
              [5.66, 59.401382],
              [5.68111, 59.411385],
              [5.696388, 59.417221],
              [5.704721, 59.419716000000108],
              [5.722777, 59.424164],
              [5.74194, 59.427773000000116],
              [5.76528, 59.429443],
              [5.7775, 59.429718],
              [5.789444000000117, 59.42889],
              [5.7975, 59.425827],
              [5.853333, 59.386108],
              [5.858333, 59.381943],
              [5.861944, 59.376938],
              [5.862778000000105, 59.370827000000133],
              [5.856667, 59.345551000000114],
              [5.84833, 59.342773000000136],
              [5.687499, 59.308609000000104],
              [5.625278, 59.32027],
              [5.627777, 59.33749],
              [5.61233, 59.352386],
              [5.611, 59.355717000000141],
              [5.602499, 59.371216],
              [5.598833, 59.37672],
              [5.595, 59.378716],
              [5.589333000000124, 59.380219],
              [5.581333, 59.380386],
              [5.574833000000126, 59.379547000000116],
              [5.572166, 59.37672],
              [5.576833, 59.37505],
              [5.584000000000117, 59.37455],
              [5.587999, 59.372383000000127],
              [5.590166000000124, 59.369385],
              [5.575555, 59.32527],
              [5.572499000000107, 59.32],
              [5.568055, 59.315277],
              [5.536111, 59.28278],
              [5.521944000000133, 59.276108],
              [5.51111, 59.274994],
              [5.485555, 59.276382000000126],
              [5.46444, 59.279442],
              [5.393611000000135, 59.289719],
              [5.38444, 59.29194],
              [5.287222, 59.346664],
              [5.27694, 59.355270000000132],
              [5.203888, 59.430832],
              [5.186646, 59.49189],
              [5.17889, 59.50222],
              [5.17805, 59.508331],
              [5.179722, 59.514442000000145],
              [5.304166, 59.623604],
              [5.430833, 59.699715],
              [5.47528, 59.72583],
              [5.48222, 59.729164],
              [5.491944, 59.730827],
              [5.51055, 59.70666],
              [5.512777000000142, 59.700829],
              [5.50778, 59.67083],
              [5.505833, 59.664719],
              [5.482499000000132, 59.60722],
              [5.45361, 59.548607],
              [5.459735, 59.519218],
              [5.486944, 59.524719000000118],
              [5.495277000000101, 59.527222000000108],
              [5.5025, 59.530548000000124],
              [5.513888, 59.538605000000132],
              [5.517802, 59.542763],
              [5.525833, 59.55333],
              [5.53972, 59.57444],
              [5.54167, 59.580551],
              [5.540555, 59.586937],
              [5.538333, 59.5925],
              [5.531111, 59.602219],
              [5.525833, 59.606384],
              [5.523611, 59.611938],
              [5.52417, 59.617493000000138],
              [5.527778, 59.629715],
              [5.537777, 59.653053],
              [5.54083, 59.658333],
              [5.549722, 59.66777],
              [5.555555, 59.671944],
              [5.562499000000116, 59.675278],
              [5.57111, 59.677773],
              [5.58472, 59.677498],
              [5.677777000000106, 59.66805],
              [5.74139, 59.677773],
              [5.745832000000121, 59.682495000000131],
              [5.806389, 59.721107000000131],
              [5.813611, 59.724159],
              [5.82194, 59.726944],
              [5.890277, 59.740555],
              [5.93361, 59.738052],
              [5.941667, 59.735275],
              [5.953888, 59.734161],
              [6.056944000000101, 59.741943],
              [6.066667000000109, 59.743889],
              [6.299166, 59.839996],
              [6.306389000000138, 59.84333],
              [6.31111, 59.848053000000107],
              [6.313055000000134, 59.852776],
              [6.301944, 59.851662],
              [6.206666, 59.83194],
              [6.172777, 59.821938000000102],
              [6.157222, 59.816109],
              [6.135555000000124, 59.80639],
              [6.123888, 59.798332],
              [6.10639, 59.787773000000129],
              [6.057777000000101, 59.76416],
              [6.049166000000127, 59.761665],
              [6.029722, 59.75777],
              [5.986944000000108, 59.752777],
              [5.973332, 59.753052],
              [5.840555000000109, 59.76694],
              [5.798055, 59.780273],
              [5.698333, 59.832771],
              [5.705277000000137, 59.86639],
              [5.735, 59.909164],
              [5.77083, 59.925552],
              [5.82417, 59.939438],
              [5.875833000000114, 59.94722],
              [5.898055, 59.949715],
              [5.950277, 59.949715],
              [5.96, 59.95166],
              [5.967222, 59.954994],
              [5.973055, 59.958885000000123],
              [5.980833, 59.969162],
              [5.98416600000013, 59.974442000000124],
              [5.980556, 59.979439],
              [5.95361, 60.002777],
              [5.982499, 60.030273],
              [6.003333, 60.047775],
              [6.026944, 60.063606],
              [6.03417, 60.06694],
              [6.108333, 60.106384000000105],
              [6.071944, 60.173607],
              [6.071111, 60.17972],
              [6.071666, 60.185272000000111],
              [6.075, 60.190552],
              [6.082777, 60.19805],
              [6.204721, 60.29555],
              [6.331944, 60.35583],
              [6.470833000000141, 60.41499],
              [6.478333, 60.41805],
              [6.504167, 60.425827],
              [6.524166, 60.429443],
              [6.564722, 60.42889],
              [6.59889, 60.424438],
              [6.61805500000014, 60.419716000000108],
              [6.634166, 60.413887000000102],
              [6.640555, 60.410271],
              [6.638611, 60.40416],
              [6.626389000000131, 60.396111000000133],
              [6.6075, 60.377495000000124],
              [6.59, 60.357773],
              [6.579721, 60.34166],
              [6.53167, 60.258888],
              [6.508888, 60.153328000000101],
              [6.504444, 60.113609],
              [6.5075, 60.101662],
              [6.51611, 60.079437],
              [6.521111, 60.076660000000118],
              [6.524444, 60.08194],
              [6.526111, 60.095833],
              [6.523333, 60.12055],
              [6.525555000000111, 60.14111],
              [6.533889, 60.165833],
              [6.57833, 60.254997000000117],
              [6.611944, 60.318604],
              [6.618889, 60.32944],
              [6.65, 60.370827000000133],
              [6.65472, 60.375275000000101],
              [6.741666, 60.43694],
              [6.771944, 60.45694],
              [6.785277000000121, 60.464165],
              [6.801389, 60.469719],
              [6.833888, 60.473610000000122],
              [6.927777, 60.4847180000001],
              [6.940277, 60.484993000000145],
              [6.979166, 60.482216],
              [7.012221, 60.47722],
              [7.02167, 60.474716],
              [7.043611, 60.471382],
              [7.05611, 60.471664],
              [7.07361, 60.476662],
              [7.081111, 60.479996],
              [7.101944, 60.490273],
              [7.108055, 60.494164],
              [7.104444, 60.499161],
              [7.093611, 60.500832],
              [6.979444, 60.505829],
              [6.973332, 60.546104],
              [7.00944, 60.577217],
              [7.014444, 60.582771],
              [7.013611, 60.587494],
              [7.002222000000131, 60.587776000000133],
              [6.97611, 60.580276],
              [6.952499, 60.570831],
              [6.908333, 60.543884],
              [6.89, 60.531944],
              [6.875833, 60.51777600000014],
              [6.81194, 60.488609],
              [6.688889, 60.439995],
              [6.67277700000011, 60.434166],
              [6.655277, 60.42916],
              [6.631389000000127, 60.427773],
              [6.620555, 60.429443],
              [6.604444, 60.435272],
              [6.597777000000121, 60.438889],
              [6.592777000000126, 60.443329],
              [6.589167, 60.448051000000135],
              [6.59111, 60.454437],
              [6.568055, 60.459717],
              [6.466944, 60.44194],
              [6.374999, 60.419441],
              [6.344444, 60.407219000000111],
              [6.315277, 60.394165],
              [6.300555, 60.387772],
              [6.290555, 60.385826],
              [6.279444, 60.386108],
              [6.258888, 60.39],
              [6.250833000000114, 60.393051],
              [6.244166, 60.39666],
              [6.22583, 60.408051],
              [6.22083, 60.412498],
              [6.212777000000131, 60.400833],
              [6.187778, 60.347771],
              [6.16028, 60.28083],
              [6.150277, 60.264717],
              [6.138888, 60.248886],
              [6.129722000000129, 60.23972],
              [6.12111, 60.236938],
              [6.111666, 60.239441],
              [5.982222, 60.236107],
              [5.899722000000111, 60.151382],
              [5.880555, 60.047775],
              [5.878611, 60.04166],
              [5.865000000000123, 60.027496],
              [5.853333, 60.01944],
              [5.814722000000131, 60.004440000000102],
              [5.799166, 59.998604],
              [5.756666, 59.985832],
              [5.747222, 59.986664000000133],
              [5.711389000000111, 60.003326000000129],
              [5.704721, 60.006943],
              [5.683888, 60.036942],
              [5.684696, 60.04393],
              [5.687222, 60.060829000000126],
              [5.646111, 60.147217],
              [5.6375, 60.14444],
              [5.604166, 60.14111],
              [5.57917, 60.140274],
              [5.566944, 60.14111],
              [5.557221, 60.143326000000116],
              [5.549166, 60.146385000000123],
              [5.54417, 60.150551],
              [5.544444, 60.156105],
              [5.633333, 60.311943],
              [5.673611, 60.35805],
              [5.680833, 60.361382],
              [5.701944, 60.364166],
              [5.720277000000124, 60.368607000000111],
              [5.732222, 60.376663],
              [5.736666, 60.381386],
              [5.734444, 60.38694],
              [5.727777, 60.390549],
              [5.71667, 60.389442],
              [5.708055000000115, 60.38694],
              [5.630555, 60.362221],
              [5.624722, 60.358330000000137],
              [5.615555, 60.348885],
              [5.544444, 60.258049],
              [5.45083, 60.179161],
              [5.411111, 60.12971],
              [5.401667, 60.13194],
              [5.36111, 60.146385000000123],
              [5.3061, 60.189484000000107],
              [5.222514, 60.203999],
              [5.222982, 60.209385],
              [5.314061, 60.25949],
              [5.309612, 60.263],
              [5.168056, 60.27722],
              [5.160555, 60.286942],
              [5.14222100000012, 60.346382000000119],
              [5.143055, 60.360275000000115],
              [5.145, 60.366386],
              [5.149444, 60.371109],
              [5.203888, 60.39222],
              [5.2525, 60.42805],
              [5.23, 60.46833],
              [5.229166, 60.473053],
              [5.229444, 60.479996],
              [5.23583, 60.490829],
              [5.25944, 60.50694],
              [5.27833, 60.51833],
              [5.292777000000115, 60.524994000000106],
              [5.304166, 60.524719000000118],
              [5.320555, 60.5191650000001],
              [5.3475, 60.50471],
              [5.364721, 60.492775000000108],
              [5.389999, 60.477776],
              [5.459444, 60.436661],
              [5.479722, 60.425827],
              [5.494444000000101, 60.419441],
              [5.516666, 60.416107000000125],
              [5.529166, 60.415276],
              [5.543056, 60.41499],
              [5.60722, 60.41499],
              [5.63361, 60.415276],
              [5.6408330000001, 60.41861],
              [5.7025, 60.454437],
              [5.707222000000115, 60.45916],
              [5.713611000000128, 60.469994],
              [5.715555, 60.490829],
              [5.719999, 60.674438000000123],
              [5.70083, 60.69416],
              [5.66111, 60.709442],
              [5.627777, 60.713051],
              [5.562499000000116, 60.690277],
              [5.534444, 60.639160000000118],
              [5.360277, 60.564995000000124],
              [5.319166, 60.558327000000133],
              [5.275277, 60.55277],
              [5.261389000000122, 60.553055],
              [5.250278, 60.554718],
              [5.232499, 60.559715],
              [5.19861, 60.5775],
              [5.09389, 60.646111],
              [5.089999, 60.65111],
              [5.0875, 60.65666],
              [5.093333, 60.660553],
              [5.103333, 60.662498],
              [5.11611, 60.66305],
              [5.127222, 60.661385],
              [5.143611, 60.655548],
              [5.170278, 60.634438],
              [5.183888, 60.627495],
              [5.19889, 60.621109],
              [5.215278000000126, 60.615273],
              [5.224999, 60.614441],
              [5.22805, 60.618332],
              [5.14138800000012, 60.7066650000001],
              [5.130833, 60.714996],
              [5.114444000000105, 60.722221000000104],
              [5.106111, 60.725],
              [5.086666, 60.72972],
              [5.026944, 60.743607],
              [4.92889, 60.798882],
              [4.933332, 60.80222],
              [4.997222, 60.804718],
              [5.012221, 60.798332],
              [5.101944, 60.76861],
              [5.218055, 60.734993],
              [5.276388, 60.72166],
              [5.284444, 60.718605],
              [5.298055, 60.711662],
              [5.30861, 60.703049],
              [5.309722, 60.69694],
              [5.30639, 60.691383],
              [5.306944000000101, 60.678329],
              [5.33, 60.648888],
              [5.340555, 60.640549000000135],
              [5.35417, 60.633331000000112],
              [5.365277, 60.631943],
              [5.4225, 60.62722],
              [5.433611, 60.62722],
              [5.437499, 60.65666],
              [5.436388000000136, 60.66305],
              [5.411111, 60.69778],
              [5.40583, 60.701942000000145],
              [5.364166000000125, 60.728333],
              [5.331111, 60.737778000000105],
              [5.321388, 60.739998000000128],
              [5.261666000000105, 60.752777],
              [5.251944, 60.754997],
              [5.24361, 60.758049000000142],
              [5.238333, 60.762215],
              [5.234444, 60.767776],
              [5.236388, 60.773888],
              [5.24083, 60.778610000000128],
              [5.35055, 60.848328],
              [5.365277, 60.854996],
              [5.375278, 60.856941],
              [5.429444, 60.864166000000125],
              [5.44111, 60.865273],
              [5.455, 60.864998],
              [5.47305, 60.859993000000145],
              [5.48305, 60.859161],
              [5.495832, 60.859444],
              [5.514444, 60.863884],
              [5.530555000000106, 60.86972],
              [5.53361, 60.872498],
              [5.460555, 60.898048],
              [5.352777, 60.875832],
              [5.335278, 60.870827],
              [5.326111, 60.861107000000118],
              [5.32083, 60.849716],
              [5.31722, 60.837219],
              [5.313889, 60.83194],
              [5.30944, 60.826942],
              [5.302221, 60.823883],
              [5.258888000000127, 60.81083],
              [5.248888000000136, 60.810272],
              [5.145555000000115, 60.807777],
              [5.117777, 60.81528],
              [5.119828, 60.834564],
              [5.111944, 60.831108],
              [5.101944, 60.829163000000108],
              [5.090555, 60.828049000000135],
              [5.076388, 60.828331],
              [5.063889000000131, 60.831108],
              [5.05555500000014, 60.83416],
              [5.048611, 60.837494],
              [5.04333, 60.841942],
              [5.03555, 60.851662],
              [4.983611, 60.946663000000115],
              [4.982499, 60.95166],
              [4.98416600000013, 60.957771],
              [5.003975, 61.0],
              [5.004722, 61.031944],
              [5.007777, 61.037216],
              [5.0125, 61.04194],
              [5.024166, 61.049995],
              [5.046389, 61.059998000000121],
              [5.055, 61.06277],
              [5.073889, 61.067215],
              [5.104166, 61.073051],
              [5.12833, 61.07194],
              [5.16361, 61.06916],
              [5.174999, 61.067772000000105],
              [5.236944, 61.056938],
              [5.24528, 61.054161000000136],
              [5.251944, 61.05055],
              [5.263888000000122, 61.035828],
              [5.270555, 61.032494],
              [5.290277, 61.027771],
              [5.303055, 61.026939],
              [5.419444000000112, 61.025551000000121],
              [5.4558320000001, 61.035271],
              [5.462222, 61.0461],
              [5.47444, 61.054161000000136],
              [5.48305, 61.056664000000126],
              [5.625278, 61.089165],
              [5.725833, 61.097496],
              [5.791944, 61.10305000000011],
              [5.829444, 61.107773],
              [5.92083, 61.123055000000136],
              [6.11, 61.116661],
              [6.12278, 61.115555],
              [6.248888000000136, 61.094719],
              [6.258611, 61.092216],
              [6.265277, 61.088608000000136],
              [6.27055, 61.084442],
              [6.274444, 61.07944],
              [6.321388, 61.06611],
              [6.372222, 61.061943],
              [6.406944, 61.066666],
              [6.513055, 61.096939],
              [6.590555000000109, 61.151382],
              [6.655, 61.151665],
              [6.812499, 61.142494],
              [6.823889000000122, 61.140831000000105],
              [6.83361, 61.138329],
              [6.84167, 61.135277],
              [6.95361, 61.083054000000118],
              [6.963888, 61.07444],
              [7.009166, 61.015831],
              [7.128333000000111, 60.927498000000128],
              [7.130555, 60.92194],
              [7.129444, 60.914993],
              [7.125555000000134, 60.896385000000123],
              [7.12111, 60.884163],
              [7.117499, 60.878883],
              [7.10389, 60.859993000000145],
              [7.11389, 60.860275],
              [7.129999000000112, 60.865829],
              [7.1425, 60.873886],
              [7.15222, 60.883049],
              [7.162777, 60.899437],
              [7.1675, 60.911659],
              [7.168333, 60.91861],
              [7.169444000000112, 60.93861],
              [7.1675, 60.944160000000124],
              [7.159444000000121, 60.94722],
              [7.146667, 60.948326],
              [7.113333000000125, 60.953331000000105],
              [7.103611, 60.955826000000116],
              [7.088888000000111, 60.962494000000106],
              [7.071944, 60.974716],
              [7.018888000000118, 61.036385],
              [6.997222000000136, 61.079163],
              [6.99667, 61.08527400000014],
              [6.9975, 61.09083],
              [7.00083, 61.096107000000131],
              [7.02, 61.100555],
              [7.031666, 61.10139],
              [7.05861, 61.099998],
              [7.083055000000115, 61.10139],
              [7.1725, 61.10805],
              [7.313055000000134, 61.123604],
              [7.428611, 61.181389000000138],
              [7.403055000000109, 61.193886000000134],
              [7.37917, 61.196663],
              [7.362778, 61.20277],
              [7.357778, 61.207222000000115],
              [7.348888, 61.216385000000116],
              [7.30444, 61.288055],
              [7.30389, 61.294441],
              [7.364166, 61.364998],
              [7.455277000000137, 61.426109],
              [7.468055000000106, 61.43388],
              [7.48333, 61.440277],
              [7.51944, 61.45027],
              [7.529722, 61.451942000000145],
              [7.53889, 61.45444],
              [7.554166, 61.460831],
              [7.56055, 61.464722000000108],
              [7.570555000000127, 61.474159],
              [7.574444, 61.479439000000127],
              [7.567222, 61.480270000000132],
              [7.558055, 61.477776],
              [7.46417, 61.44778],
              [7.447499, 61.442215],
              [7.424444, 61.432777],
              [7.32833, 61.375832],
              [7.309166, 61.362495000000138],
              [7.279444, 61.325554],
              [7.273055, 61.278885],
              [7.297777, 61.25055],
              [7.353889, 61.189995],
              [7.278055, 61.158607],
              [7.14861100000013, 61.142776],
              [6.966944000000126, 61.1097180000001],
              [6.95555, 61.109993],
              [6.934722, 61.114166],
              [6.926666000000125, 61.11694],
              [6.922777, 61.12194],
              [6.916944, 61.1325],
              [6.91639, 61.138611],
              [6.91861, 61.145],
              [6.906388000000106, 61.16166],
              [6.84528, 61.17472],
              [6.814444, 61.181107000000111],
              [6.77444400000013, 61.180832],
              [6.739721, 61.177498],
              [6.726666, 61.177216],
              [6.713888000000111, 61.178329],
              [6.587222, 61.208611],
              [6.570833, 61.214722],
              [6.564166, 61.21833],
              [6.563555, 61.225552],
              [6.564055, 61.229717],
              [6.57055, 61.234886],
              [6.57694400000014, 61.241943],
              [6.590555000000109, 61.249161],
              [6.620832, 61.262215],
              [6.639444, 61.274162],
              [6.693333, 61.340271],
              [6.69667, 61.34583],
              [6.718055000000106, 61.390549000000135],
              [6.715833, 61.396111],
              [6.712222000000111, 61.401108],
              [6.70361, 61.401382000000126],
              [6.697222000000124, 61.397499],
              [6.591389, 61.268608],
              [6.52041, 61.246201],
              [6.538573, 61.204319],
              [6.504444, 61.13444],
              [6.49833, 61.130272],
              [6.433611, 61.114166],
              [6.42333, 61.112221],
              [6.34611, 61.110275],
              [6.32361, 61.113609],
              [6.313889, 61.11583],
              [6.237499000000128, 61.134995],
              [5.96528, 61.156387],
              [5.749166000000116, 61.15277],
              [5.563333, 61.1325],
              [5.553333, 61.130554000000132],
              [5.523611, 61.117218],
              [5.50555, 61.105270000000132],
              [5.46861, 61.088608000000136],
              [5.407222000000104, 61.070549],
              [5.39722, 61.068604],
              [5.325277000000142, 61.096107000000131],
              [5.277778, 61.110832],
              [5.159444, 61.132774],
              [5.115833, 61.141663],
              [5.05, 61.158607],
              [5.044444, 61.162773000000129],
              [5.041944, 61.16833],
              [5.046666, 61.173050000000103],
              [5.058611, 61.181107000000111],
              [5.084722, 61.188889],
              [5.097777, 61.189438],
              [5.123333, 61.187775],
              [5.162777, 61.17889],
              [5.169722, 61.175278000000105],
              [5.193333, 61.165833],
              [5.201666, 61.163055],
              [5.213055, 61.161385],
              [5.224444, 61.162498000000141],
              [5.245832, 61.180275],
              [5.240277, 61.184441000000106],
              [5.214167, 61.19944],
              [5.19889, 61.205826],
              [5.135833, 61.2241590000001],
              [5.113055, 61.224442],
              [5.08861, 61.222771],
              [5.019444000000135, 61.214722],
              [4.995, 61.215828],
              [4.988055, 61.219444],
              [4.951666000000102, 61.25361],
              [4.953333, 61.2586060000001],
              [5.17083300000013, 61.33361],
              [5.415, 61.370827000000133],
              [5.451111, 61.373604],
              [5.48972, 61.370827000000133],
              [5.522499, 61.36555],
              [5.562222000000133, 61.36055],
              [5.628333, 61.35916],
              [5.634166, 61.36055],
              [5.617499, 61.366386],
              [5.59611, 61.370277000000101],
              [5.44694, 61.375832],
              [5.40667, 61.376389],
              [5.263611, 61.365829000000133],
              [5.251944, 61.364716],
              [5.16639, 61.35166],
              [5.145833, 61.347771],
              [5.12833, 61.342773],
              [5.111944, 61.336662],
              [5.0825, 61.323326],
              [5.07361, 61.320831],
              [5.05333, 61.31694],
              [5.04055, 61.317772],
              [5.00361, 61.34805],
              [4.950000000000102, 61.408051],
              [4.948889, 61.412773],
              [4.963611, 61.419441],
              [4.972500000000139, 61.42222],
              [5.063333000000114, 61.443604],
              [5.073333000000105, 61.445549],
              [5.08361, 61.44722],
              [5.183611, 61.453331],
              [5.336389000000111, 61.452217],
              [5.527499, 61.428604],
              [5.539166, 61.429993],
              [5.62167, 61.451660000000118],
              [5.764722, 61.452217],
              [5.771388, 61.44861],
              [5.781388, 61.446388],
              [5.794167, 61.445549],
              [5.804444000000103, 61.44722],
              [5.804999, 61.452774],
              [5.771111, 61.477776],
              [5.76444, 61.481384000000105],
              [5.73917, 61.49],
              [5.717777, 61.493889],
              [5.705, 61.494995],
              [5.680277, 61.49472],
              [5.643888000000118, 61.491943],
              [5.63361, 61.49],
              [5.626111, 61.486938000000123],
              [5.62, 61.482773000000122],
              [5.606388, 61.475555],
              [5.583888, 61.465553000000114],
              [5.567778, 61.459717],
              [5.5575, 61.457771],
              [5.46444, 61.449997],
              [5.45167, 61.450829000000113],
              [5.188333, 61.498886],
              [5.145833, 61.513329],
              [5.138888, 61.51694],
              [5.133611, 61.52111],
              [5.130833, 61.526665],
              [5.13, 61.532776],
              [5.142777000000137, 61.551941],
              [5.250000000000114, 61.55138],
              [5.273888, 61.557774],
              [5.248555000000124, 61.568939000000114],
              [5.212777000000131, 61.5775],
              [5.158333, 61.58666],
              [5.148333, 61.588882000000126],
              [5.148611, 61.593048],
              [5.206944000000135, 61.5991590000001],
              [5.273611, 61.598053000000107],
              [5.325555, 61.594444],
              [5.336944, 61.592773],
            ],
          ],
          [
            [
              [25.82805, 71.098602],
              [25.881943, 71.09082],
              [25.891109, 71.09111],
              [25.90361, 71.093887],
              [25.94611, 71.10554500000012],
              [25.979164, 71.114716],
              [25.98889, 71.119156],
              [26.003609, 71.12027],
              [26.019444, 71.118332000000123],
              [26.028332, 71.114441],
              [26.03805, 71.10527],
              [26.04472, 71.095551],
              [26.045555, 71.090546],
              [26.04083, 71.084442],
              [26.032219000000111, 71.078888],
              [26.022499, 71.074432000000115],
              [26.011387, 71.070541],
              [25.962219000000118, 71.059158],
              [25.924164, 71.051376],
              [25.928333, 71.00444],
              [25.939720000000136, 71.00082],
              [25.9566650000001, 70.998047],
              [26.02417, 70.996384000000148],
              [26.05611, 70.996658],
              [26.068333, 70.99971],
              [26.078053, 71.004166000000112],
              [26.091389, 71.015823],
              [26.099998, 71.021378000000141],
              [26.109722, 71.025833000000148],
              [26.143055000000118, 71.03722],
              [26.167500000000132, 71.042770000000132],
              [26.18111, 71.044708],
              [26.19722, 71.044998],
              [26.209999, 71.042770000000132],
              [26.218887, 71.038605000000132],
              [26.219719000000111, 71.0336],
              [26.213608, 71.016663000000108],
              [26.208885, 71.01082],
              [26.20027, 71.005264],
              [26.176941, 70.998596],
              [26.083885, 70.974442],
              [26.071663, 70.971664],
              [25.91972, 70.961655],
              [25.903889, 70.96138],
              [25.843052, 70.96304],
              [25.720554, 70.955276],
              [25.62555, 70.928055],
              [25.613331, 70.925278000000105],
              [25.599998000000141, 70.92332],
              [25.585278, 70.922211],
              [25.551941, 70.923874000000126],
              [25.53889, 70.926102],
              [25.527222000000108, 70.929718],
              [25.51833, 70.933884],
              [25.416664, 70.982208000000128],
              [25.427776, 70.985825],
              [25.441109, 70.98805],
              [25.52166, 71.000275],
              [25.549721, 71.003326],
              [25.560833, 71.00722],
              [25.559719, 71.01221],
              [25.548332, 71.015823],
              [25.531387000000109, 71.018600000000106],
              [25.462776, 71.025269],
              [25.43472, 71.022217],
              [25.394444, 71.016098],
              [25.369999, 71.010269],
              [25.34333, 71.006104],
              [25.307499000000121, 71.008041000000105],
              [25.29611, 71.011658],
              [25.289719, 71.016098],
              [25.28611, 71.020828000000108],
              [25.294441, 71.04222],
              [25.313889, 71.069717],
              [25.320831, 71.073883000000137],
              [25.33416, 71.076111],
              [25.390553, 71.082489],
              [25.51111, 71.09],
              [25.58343, 71.092491],
              [25.615833, 71.107208],
              [25.67361, 71.138321],
              [25.784721, 71.154709],
              [25.800552, 71.152771000000143],
              [25.806664, 71.14833],
              [25.79888, 71.126099],
              [25.79444, 71.119995],
              [25.82805, 71.098602],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "PL",
        ISO2: "PL",
        ISO3: "POL",
        UN: 616,
        NAME: "Poland",
        AREA: 30629,
        POP2005: 38195558,
        REGION: 150,
        SUBREGION: 151,
        LON: 19.401,
        LAT: 52.125,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [18.851246, 49.517357],
            [18.852219, 49.527771],
            [18.847775, 49.554161],
            [18.839443, 49.594994],
            [18.811665, 49.672218],
            [18.809998, 49.674438],
            [18.786942, 49.681938],
            [18.634163, 49.737778],
            [18.57935, 49.814995],
            [18.581108, 49.907494],
            [18.579441, 49.912498],
            [18.577221, 49.914444],
            [18.557777, 49.921661],
            [18.553608, 49.92305],
            [18.549721, 49.922493],
            [18.350277, 49.938889],
            [18.270275, 49.957771],
            [18.094166, 50.038055],
            [18.053162, 50.055931],
            [18.009441, 50.011108],
            [17.933052, 49.979721],
            [17.922497, 49.976944],
            [17.913609, 49.976387],
            [17.887775, 49.976662],
            [17.882774, 49.976944],
            [17.867222, 49.98111],
            [17.843887, 49.988327],
            [17.836388, 49.990829],
            [17.657776, 50.108055],
            [17.60722, 50.147774],
            [17.60083, 50.153885],
            [17.597775, 50.158333],
            [17.59861, 50.161659],
            [17.600555, 50.164162],
            [17.607498, 50.170555],
            [17.614719, 50.172493],
            [17.623333, 50.172775],
            [17.63361, 50.171944],
            [17.651943, 50.171944],
            [17.691666, 50.178055],
            [17.698887, 50.179993],
            [17.762497, 50.205551],
            [17.763885, 50.208611],
            [17.764164, 50.211662],
            [17.763054, 50.231941],
            [17.762775, 50.234718],
            [17.753052, 50.297775],
            [17.726109, 50.318329],
            [17.722775, 50.319717],
            [17.703888, 50.323326],
            [17.69611, 50.321938],
            [17.694164, 50.319443],
            [17.693886, 50.316383],
            [17.695, 50.307777],
            [17.694443, 50.298882],
            [17.692219, 50.296661],
            [17.665554, 50.274719],
            [17.656666, 50.269997],
            [17.63361, 50.265549],
            [17.619999, 50.265549],
            [17.433052, 50.270271],
            [17.37833, 50.279442],
            [17.283607, 50.320274],
            [17.226944, 50.345276],
            [17.208611, 50.358055],
            [17.201942, 50.363884],
            [17.118053, 50.39666],
            [17.057777, 50.410553],
            [16.941387, 50.434998],
            [16.910831, 50.440132],
            [16.898609, 50.440277],
            [16.890274, 50.439438],
            [16.887497, 50.437492],
            [16.869999, 50.415833],
            [16.868053, 50.413055],
            [16.867496, 50.410553],
            [16.869442, 50.405273],
            [16.937496, 50.340553],
            [16.972775, 50.309998],
            [17.00222, 50.216942],
            [16.968609, 50.222771],
            [16.913609, 50.222496],
            [16.909164, 50.222221],
            [16.849998, 50.203331],
            [16.843887, 50.200272],
            [16.815552, 50.183884],
            [16.806942, 50.174995],
            [16.802935, 50.169651],
            [16.786663, 50.140549],
            [16.725277, 50.099716],
            [16.71833, 50.097771],
            [16.713886, 50.097496],
            [16.703888, 50.098328],
            [16.641941, 50.10833],
            [16.638054, 50.109444],
            [16.614441, 50.11972],
            [16.587776, 50.139999],
            [16.567497, 50.160553],
            [16.56361, 50.164719],
            [16.566387, 50.178055],
            [16.565277, 50.202217],
            [16.559166, 50.214165],
            [16.549999, 50.224998],
            [16.546108, 50.229164],
            [16.458611, 50.303604],
            [16.441387, 50.316666],
            [16.371944, 50.361107],
            [16.303055, 50.378052],
            [16.266109, 50.389717],
            [16.220554, 50.409439],
            [16.217499, 50.41111],
            [16.20583, 50.423882],
            [16.203331, 50.428604],
            [16.202774, 50.431389],
            [16.203888, 50.437775],
            [16.209164, 50.445549],
            [16.213886, 50.449715],
            [16.310833, 50.504166],
            [16.319164, 50.505272],
            [16.338333, 50.499161],
            [16.346664, 50.496941],
            [16.351944, 50.496384],
            [16.361111, 50.496384],
            [16.368332, 50.498604],
            [16.406666, 50.523048],
            [16.448055, 50.572777],
            [16.449165, 50.575829],
            [16.447777, 50.581108],
            [16.444443, 50.585548],
            [16.431389, 50.600555],
            [16.429165, 50.602493],
            [16.369999, 50.644165],
            [16.341942, 50.66111],
            [16.334999, 50.663887],
            [16.325554, 50.66555],
            [16.237499, 50.670555],
            [16.137497, 50.656105],
            [16.118053, 50.657799],
            [16.071388, 50.635551],
            [16.024441, 50.629997],
            [15.946943, 50.689438],
            [15.787498, 50.744164],
            [15.606667, 50.772774],
            [15.488333, 50.786659],
            [15.37972, 50.779442],
            [15.36972, 50.831665],
            [15.364166, 50.841385],
            [15.361944, 50.84333],
            [15.355555, 50.846107],
            [15.328888, 50.854721],
            [15.310555, 50.85833],
            [15.30361, 50.864166],
            [15.283333, 50.890831],
            [15.282221, 50.893326],
            [15.274443, 50.91111],
            [15.270832, 50.921387],
            [15.271944, 50.931107],
            [15.272778, 50.934441],
            [15.276943, 50.938889],
            [15.294167, 50.948608],
            [15.295277, 50.954163],
            [15.275276, 50.974998],
            [15.239443, 50.991943],
            [15.176943, 51.014717],
            [15.010555, 50.984161],
            [15.013887, 50.979721],
            [15.020555, 50.967773],
            [15.020555, 50.964722],
            [15.019165, 50.950554],
            [15.006943, 50.869995],
            [15.005278, 50.867218],
            [15.001665, 50.866386],
            [14.966665, 50.859161],
            [14.828333, 50.865829],
            [14.824999, 50.876389],
            [14.824165, 50.881943],
            [14.827776, 50.88694],
            [14.896944, 50.959442],
            [14.93111, 51.002495],
            [14.964722, 51.050827],
            [14.966389, 51.053604],
            [14.978888, 51.078331],
            [14.994444, 51.118607],
            [15.032221, 51.239166],
            [15.038887, 51.27166],
            [15.036388, 51.285553],
            [15.029999, 51.294716],
            [15.009722, 51.312492],
            [14.995554, 51.321106],
            [14.986111, 51.328888],
            [14.980555, 51.338333],
            [14.971666, 51.355553],
            [14.971666, 51.358887],
            [14.981833, 51.36805],
            [14.975555, 51.440826],
            [14.955832, 51.467499],
            [14.954166, 51.469719],
            [14.951111, 51.471382],
            [14.92111, 51.481941],
            [14.8375, 51.498604],
            [14.742777, 51.524994],
            [14.736111, 51.528053],
            [14.714998, 51.554722],
            [14.754444, 51.596939],
            [14.759998, 51.604439],
            [14.761389, 51.611382],
            [14.76111, 51.617218],
            [14.7575, 51.659439],
            [14.756388, 51.667496],
            [14.755278, 51.669998],
            [14.728333, 51.687775],
            [14.715832, 51.69416],
            [14.698055, 51.702217],
            [14.678333, 51.714165],
            [14.666943, 51.724159],
            [14.663332, 51.728607],
            [14.604721, 51.808884],
            [14.599443, 51.818604],
            [14.599165, 51.821388],
            [14.600555, 51.831383],
            [14.603333, 51.84111],
            [14.605, 51.843887],
            [14.61611, 51.853882],
            [14.640276, 51.862221],
            [14.645277, 51.864998],
            [14.648054, 51.866943],
            [14.687222, 51.894997],
            [14.692499, 51.898888],
            [14.71656, 51.941132],
            [14.718542, 51.945091],
            [14.760765, 52.069862],
            [14.713333, 52.239166],
            [14.710554, 52.243889],
            [14.703888, 52.249718],
            [14.692497, 52.25444],
            [14.655832, 52.260277],
            [14.601665, 52.271111],
            [14.596109, 52.274437],
            [14.581665, 52.28611],
            [14.578054, 52.29055],
            [14.534443, 52.394722],
            [14.534443, 52.397774],
            [14.537222, 52.406944],
            [14.543888, 52.424721],
            [14.54611, 52.426941],
            [14.548611, 52.428886],
            [14.559166, 52.432495],
            [14.567221, 52.433884],
            [14.582499, 52.438049],
            [14.587776, 52.441666],
            [14.623333, 52.477219],
            [14.636389, 52.490555],
            [14.63722, 52.497215],
            [14.641388, 52.57],
            [14.640276, 52.572495],
            [14.638332, 52.574715],
            [14.604334, 52.601723],
            [14.587221, 52.611938],
            [14.561666, 52.624443],
            [14.547499, 52.629997],
            [14.527777, 52.636108],
            [14.518332, 52.637772],
            [14.505833, 52.641388],
            [14.481943, 52.650833],
            [14.475555, 52.65416],
            [14.448332, 52.675278],
            [14.383333, 52.730827],
            [14.361111, 52.744995],
            [14.348888, 52.751663],
            [14.214443, 52.816666],
            [14.196388, 52.820549],
            [14.149166, 52.862778],
            [14.145555, 52.953888],
            [14.146111, 52.957497],
            [14.149443, 52.962776],
            [14.168888, 52.973328],
            [14.200277, 52.984718],
            [14.221943, 52.987495],
            [14.228888, 52.990273],
            [14.287777, 53.016106],
            [14.299702, 53.021431],
            [14.342222, 53.044998],
            [14.352499, 53.052773],
            [14.378054, 53.103882],
            [14.3825, 53.116386],
            [14.391689, 53.144165],
            [14.412777, 53.304443],
            [14.413261, 53.338959],
            [14.309721, 53.55555],
            [14.275627, 53.699066],
            [14.36611, 53.69944],
            [14.403332, 53.683327],
            [14.41361, 53.678886],
            [14.422499, 53.676666],
            [14.525, 53.660553],
            [14.554722, 53.678604],
            [14.619444, 53.764442],
            [14.621111, 53.771385],
            [14.614166, 53.816383],
            [14.584999, 53.844719],
            [14.576666, 53.850273],
            [14.558332, 53.857216],
            [14.548611, 53.85833],
            [14.485277, 53.863884],
            [14.468054, 53.865273],
            [14.412222, 53.866661],
            [14.414721, 53.864716],
            [14.416388, 53.859444],
            [14.413055, 53.846107],
            [14.407499, 53.842499],
            [14.341665, 53.804718],
            [14.337221, 53.804993],
            [14.289999, 53.822777],
            [14.266109, 53.836662],
            [14.218887, 53.869019],
            [14.215832, 53.899994],
            [14.225555, 53.928604],
            [14.24, 53.923882],
            [14.259722, 53.92083],
            [14.327776, 53.912498],
            [14.350277, 53.910553],
            [14.36972, 53.911385],
            [14.383055, 53.913055],
            [14.416666, 53.919167],
            [14.434166, 53.925827],
            [14.483332, 53.94722],
            [14.497776, 53.956108],
            [14.510832, 53.962219],
            [14.559444, 53.976662],
            [14.745277, 54.02861],
            [14.814444, 54.039162],
            [14.979721, 54.071388],
            [15.228054, 54.12944],
            [15.294722, 54.146111],
            [15.310833, 54.149437],
            [15.353888, 54.156387],
            [15.395859, 54.160629],
            [15.429443, 54.162216],
            [15.486944, 54.16555],
            [15.5, 54.167496],
            [15.65, 54.193054],
            [15.658333, 54.194717],
            [15.744444, 54.212219],
            [15.760277, 54.21611],
            [15.794167, 54.226105],
            [15.833332, 54.239998],
            [15.845276, 54.242775],
            [15.876389, 54.246384],
            [16.047775, 54.261665],
            [16.129162, 54.283104],
            [16.130823, 54.280197],
            [16.110466, 54.267319],
            [16.071663, 54.2575],
            [16.074165, 54.255554],
            [16.087498, 54.25222],
            [16.09222, 54.251938],
            [16.141666, 54.252777],
            [16.146385, 54.253052],
            [16.174721, 54.259163],
            [16.217777, 54.273605],
            [16.217232, 54.28809],
            [16.21557, 54.296814],
            [16.209339, 54.300552],
            [16.175274, 54.29266],
            [16.141106, 54.287052],
            [16.173716, 54.297646],
            [16.198538, 54.30637],
            [16.25732, 54.341473],
            [16.230318, 54.322361],
            [16.230526, 54.319038],
            [16.234056, 54.318207],
            [16.239666, 54.318417],
            [16.255035, 54.318001],
            [16.261061, 54.31966],
            [16.262722, 54.326725],
            [16.267084, 54.329216],
            [16.328053, 54.344994],
            [16.332775, 54.349442],
            [16.333611, 54.352776],
            [16.330555, 54.363609],
            [16.326111, 54.373604],
            [16.323608, 54.375549],
            [16.318607, 54.376389],
            [16.306389, 54.373604],
            [16.299721, 54.370827],
            [16.294998, 54.368332],
            [16.318333, 54.391106],
            [16.408222, 54.461525],
            [16.460552, 54.499718],
            [16.489529, 54.518669],
            [16.515553, 54.534164],
            [16.54361, 54.544716],
            [16.571663, 54.551109],
            [16.638611, 54.563606],
            [16.665276, 54.56694],
            [16.694443, 54.568604],
            [16.709442, 54.568886],
            [16.793331, 54.575829],
            [16.884163, 54.589722],
            [16.915276, 54.597771],
            [16.930553, 54.602219],
            [16.94833, 54.608604],
            [17.013332, 54.643883],
            [17.024998, 54.651108],
            [17.032219, 54.657776],
            [17.040833, 54.66333],
            [17.060276, 54.671661],
            [17.071388, 54.675278],
            [17.247219, 54.729164],
            [17.254997, 54.731384],
            [17.362221, 54.747772],
            [17.434166, 54.752777],
            [17.530552, 54.762215],
            [17.584442, 54.768608],
            [17.601387, 54.771385],
            [17.686607, 54.789093],
            [17.774441, 54.806389],
            [17.896942, 54.823883],
            [17.918888, 54.82666],
            [18.033607, 54.833611],
            [18.053055, 54.834442],
            [18.32972, 54.836937],
            [18.334999, 54.836662],
            [18.349998, 54.833611],
            [18.372776, 54.816109],
            [18.449333, 54.788273],
            [18.526833, 54.760773],
            [18.578165, 54.744106],
            [18.605833, 54.735607],
            [18.703888, 54.700272],
            [18.739998, 54.685272],
            [18.774719, 54.666382],
            [18.82972, 54.629997],
            [18.831944, 54.627777],
            [18.834721, 54.623055],
            [18.836388, 54.61805],
            [18.836388, 54.611938],
            [18.830555, 54.599716],
            [18.826942, 54.594162],
            [18.82333, 54.592773],
            [18.818054, 54.593048],
            [18.815552, 54.594994],
            [18.78611, 54.618607],
            [18.775833, 54.629166],
            [18.76833, 54.638054],
            [18.760277, 54.649437],
            [18.750832, 54.662773],
            [18.738888, 54.672775],
            [18.722775, 54.683884],
            [18.708054, 54.692772],
            [18.704441, 54.694443],
            [18.571943, 54.72966],
            [18.503942, 54.753498],
            [18.487274, 54.759331],
            [18.484276, 54.759827],
            [18.481775, 54.759331],
            [18.480276, 54.757996],
            [18.466944, 54.736832],
            [18.405277, 54.74305],
            [18.406109, 54.734444],
            [18.407776, 54.732216],
            [18.46833, 54.665833],
            [18.511387, 54.631104],
            [18.54361, 54.59333],
            [18.550278, 54.584442],
            [18.553608, 54.57972],
            [18.566109, 54.553329],
            [18.567219, 54.54805],
            [18.572498, 54.486107],
            [18.570831, 54.479439],
            [18.567776, 54.47361],
            [18.568054, 54.467499],
            [18.571941, 54.451385],
            [18.576664, 54.441666],
            [18.582775, 54.435272],
            [18.590553, 54.429718],
            [18.596664, 54.426109],
            [18.610832, 54.419998],
            [18.708332, 54.382774],
            [18.757774, 54.370827],
            [18.836388, 54.353333],
            [18.851109, 54.350273],
            [18.884998, 54.346107],
            [18.901386, 54.344994],
            [18.92083, 54.345551],
            [18.933887, 54.347221],
            [18.953888, 54.351662],
            [18.968052, 54.345551],
            [18.973053, 54.344719],
            [19.022778, 54.342216],
            [19.046387, 54.342216],
            [19.138885, 54.346664],
            [19.212498, 54.353882],
            [19.374443, 54.373604],
            [19.4175, 54.380554],
            [19.43972, 54.385826],
            [19.50972, 54.404442],
            [19.523888, 54.409721],
            [19.562775, 54.428886],
            [19.613331, 54.45472],
            [19.627258, 54.463272],
            [19.651108, 54.455826],
            [19.632639, 54.444477],
            [19.628052, 54.441666],
            [19.524441, 54.39666],
            [19.428333, 54.365273],
            [19.408051, 54.358887],
            [19.38583, 54.353607],
            [19.366386, 54.351387],
            [19.286942, 54.347496],
            [19.26833, 54.344719],
            [19.234444, 54.336937],
            [19.227493, 54.33194],
            [19.226662, 54.32888],
            [19.250553, 54.278877],
            [19.256107, 54.277496],
            [19.371109, 54.2686],
            [19.471664, 54.311104],
            [19.485828, 54.317215],
            [19.560833, 54.346382],
            [19.567219, 54.347496],
            [19.574997, 54.347496],
            [19.581108, 54.346382],
            [19.623608, 54.348877],
            [19.633884, 54.352219],
            [19.713608, 54.383331],
            [19.797007, 54.43755],
            [19.857704, 54.429909],
            [20.004166, 54.419159],
            [20.090553, 54.418602],
            [20.158607, 54.411934],
            [20.301388, 54.397774],
            [20.329082, 54.393833],
            [20.331182, 54.393532],
            [20.371662, 54.387772],
            [20.432774, 54.38166],
            [20.738884, 54.358047],
            [20.898052, 54.356102],
            [21.126385, 54.34166],
            [21.181938, 54.33638],
            [21.231937, 54.332771],
            [21.283607, 54.329994],
            [21.367218, 54.327217],
            [21.411942, 54.325829],
            [21.442493, 54.325554],
            [21.524166, 54.326942],
            [21.570435, 54.328209],
            [21.577515, 54.328403],
            [21.625553, 54.32972],
            [21.729996, 54.330826],
            [21.732765, 54.330845],
            [21.855553, 54.331665],
            [21.981937, 54.332771],
            [22.164997, 54.334991],
            [22.265553, 54.338043],
            [22.292496, 54.339432],
            [22.294336, 54.339672],
            [22.305275, 54.341103],
            [22.425552, 54.345543],
            [22.43391, 54.345543],
            [22.455551, 54.345543],
            [22.629997, 54.348877],
            [22.664162, 54.351105],
            [22.7575, 54.35833],
            [22.775829, 54.361107],
            [22.785885, 54.363838],
            [22.810829, 54.39444],
            [22.81361, 54.397491],
            [22.826664, 54.40332],
            [22.843609, 54.406937],
            [22.856106, 54.4086],
            [22.870274, 54.408043],
            [22.987495, 54.38916],
            [22.992771, 54.387772],
            [23.0, 54.383049],
            [23.001991, 54.381054],
            [23.003052, 54.37999],
            [23.115829, 54.304436],
            [23.204441, 54.287216],
            [23.333054, 54.247215],
            [23.350273, 54.238884],
            [23.361942, 54.231934],
            [23.456383, 54.175552],
            [23.45916, 54.172768],
            [23.48444, 54.138329],
            [23.49416, 54.11721],
            [23.51722, 54.047218],
            [23.517776, 54.030273],
            [23.508053, 53.960548],
            [23.50404, 53.947044],
            [23.502777, 53.94249],
            [23.503887, 53.921379],
            [23.507807, 53.907265],
            [23.512218, 53.89138],
            [23.539719, 53.840828],
            [23.580551, 53.731102],
            [23.590443, 53.694431],
            [23.590553, 53.692764],
            [23.594997, 53.677773],
            [23.608608, 53.637497],
            [23.613884, 53.623047],
            [23.620552, 53.604996],
            [23.640274, 53.559158],
            [23.669441, 53.501389],
            [23.674717, 53.491104],
            [23.68055, 53.481102],
            [23.70055, 53.453049],
            [23.785917, 53.314335],
            [23.858608, 53.195824],
            [23.933052, 53.01416],
            [23.933331, 53.009995],
            [23.927492, 52.948376],
            [23.931385, 52.858604],
            [23.93866, 52.774712],
            [23.939716, 52.770271],
            [23.941105, 52.749718],
            [23.94083, 52.732208],
            [23.937775, 52.719437],
            [23.933884, 52.712212],
            [23.928608, 52.7061],
            [23.91555, 52.695541],
            [23.908051, 52.690826],
            [23.883884, 52.678047],
            [23.753887, 52.615829],
            [23.74305, 52.613609],
            [23.736382, 52.613327],
            [23.721375, 52.615242],
            [23.710274, 52.616661],
            [23.688328, 52.61721],
            [23.655273, 52.610275],
            [23.633606, 52.605553],
            [23.597218, 52.596382],
            [23.523052, 52.573608],
            [23.503609, 52.567497],
            [23.417217, 52.525269],
            [23.397217, 52.514442],
            [23.377495, 52.498329],
            [23.249376, 52.375477],
            [23.24416, 52.37027],
            [23.1654, 52.282276],
            [23.191383, 52.234718],
            [23.19416, 52.231659],
            [23.206383, 52.225266],
            [23.223049, 52.221657],
            [23.297775, 52.211662],
            [23.340832, 52.208046],
            [23.353329, 52.206383],
            [23.35833, 52.204712],
            [23.594997, 52.111938],
            [23.638607, 52.079437],
            [23.660828, 52.006104],
            [23.627773, 51.95388],
            [23.625828, 51.950272],
            [23.613228, 51.917938],
            [23.611736, 51.913971],
            [23.558052, 51.752495],
            [23.547775, 51.686378],
            [23.556664, 51.670547],
            [23.556942, 51.666382],
            [23.555832, 51.663322],
            [23.552498, 51.660545],
            [23.534992, 51.653595],
            [23.539165, 51.592766],
            [23.559441, 51.546104],
            [23.561386, 51.542496],
            [23.563885, 51.539436],
            [23.571663, 51.535271],
            [23.578541, 51.532978],
            [23.581665, 51.531937],
            [23.604633, 51.527695],
            [23.611107, 51.503326],
            [23.614, 51.49675],
            [23.616665, 51.493607],
            [23.623608, 51.488602],
            [23.624754, 51.48822],
            [23.628609, 51.486938],
            [23.641417, 51.486938],
            [23.642494, 51.486938],
            [23.654163, 51.484718],
            [23.656887, 51.480968],
            [23.658607, 51.4786],
            [23.69305, 51.404709],
            [23.692493, 51.399994],
            [23.682217, 51.371101],
            [23.680275, 51.367493],
            [23.683884, 51.288605],
            [23.731937, 51.214714],
            [23.756664, 51.199432],
            [23.811108, 51.168884],
            [23.904442, 51.069443],
            [23.905552, 51.066666],
            [23.931665, 50.994072],
            [23.963882, 50.951935],
            [23.966385, 50.948875],
            [23.988327, 50.931107],
            [24.028885, 50.901657],
            [24.035553, 50.896942],
            [24.043888, 50.892769],
            [24.058609, 50.888046],
            [24.064384, 50.887001],
            [24.087776, 50.882767],
            [24.092773, 50.881104],
            [24.14222, 50.861107],
            [24.144718, 50.858047],
            [24.14444, 50.849434],
            [24.134441, 50.836937],
            [24.13055, 50.834991],
            [24.114719, 50.831383],
            [24.076942, 50.829437],
            [24.052498, 50.831383],
            [24.023678, 50.831783],
            [24.020113, 50.831722],
            [23.989162, 50.831108],
            [23.972771, 50.828049],
            [23.964439, 50.82444],
            [23.958885, 50.818604],
            [23.95694, 50.814995],
            [23.953327, 50.802773],
            [23.953115, 50.800724],
            [23.952496, 50.794716],
            [23.954716, 50.787216],
            [23.957218, 50.784164],
            [24.014721, 50.73999],
            [24.07222, 50.695824],
            [24.10722, 50.633606],
            [24.108414, 50.6259],
            [24.111385, 50.56694],
            [24.004997, 50.417213],
            [23.999439, 50.411659],
            [23.991661, 50.407211],
            [23.974716, 50.404709],
            [23.92944, 50.403603],
            [23.881496, 50.405411],
            [23.846943, 50.406654],
            [23.814442, 50.405823],
            [23.791943, 50.402489],
            [23.755833, 50.39444],
            [23.729225, 50.387413],
            [23.721107, 50.385269],
            [23.712259, 50.382137],
            [23.707771, 50.380547],
            [23.703884, 50.378326],
            [23.697495, 50.373047],
            [23.693886, 50.365829],
            [23.693182, 50.363255],
            [23.686253, 50.337929],
            [23.684994, 50.333328],
            [23.683416, 50.330395],
            [23.676941, 50.32444],
            [23.591106, 50.269157],
            [23.568886, 50.255829],
            [23.540276, 50.242779],
            [23.496105, 50.220825],
            [23.37833, 50.149719],
            [23.342823, 50.127491],
            [23.341942, 50.126938],
            [23.32444, 50.115273],
            [23.303608, 50.10083],
            [23.232773, 50.049995],
            [23.223606, 50.043327],
            [23.146107, 49.983047],
            [23.110828, 49.954994],
            [22.779999, 49.674995],
            [22.717216, 49.604439],
            [22.686068, 49.577095],
            [22.680828, 49.572495],
            [22.676105, 49.566383],
            [22.658051, 49.535828],
            [22.655273, 49.528046],
            [22.656105, 49.519714],
            [22.694439, 49.450829],
            [22.729439, 49.401657],
            [22.73041, 49.400532],
            [22.736382, 49.393608],
            [22.738327, 49.390274],
            [22.739437, 49.386658],
            [22.760277, 49.295273],
            [22.759998, 49.281937],
            [22.754719, 49.271103],
            [22.726662, 49.217766],
            [22.704994, 49.18055],
            [22.700829, 49.173607],
            [22.699997, 49.169716],
            [22.700272, 49.165543],
            [22.703606, 49.163048],
            [22.706659, 49.163048],
            [22.70916, 49.163048],
            [22.778053, 49.150543],
            [22.852776, 49.105827],
            [22.876106, 49.089989],
            [22.877773, 49.086655],
            [22.876106, 49.083054],
            [22.863052, 49.058884],
            [22.861956, 49.05011],
            [22.861385, 49.045547],
            [22.864162, 49.038605],
            [22.868328, 49.028877],
            [22.886074, 49.002914],
            [22.875275, 49.00222],
            [22.868885, 49.001938],
            [22.856384, 49.003326],
            [22.851662, 49.004715],
            [22.737774, 49.047218],
            [22.598053, 49.091103],
            [22.594929, 49.09145],
            [22.585552, 49.092491],
            [22.574165, 49.090828],
            [22.562775, 49.084991],
            [22.558052, 49.079437],
            [22.5425, 49.086388],
            [22.533054, 49.089439],
            [22.354721, 49.137497],
            [22.343052, 49.139442],
            [22.323887, 49.138611],
            [22.224998, 49.154716],
            [22.047497, 49.207771],
            [22.037777, 49.210831],
            [22.030277, 49.214996],
            [22.025833, 49.221107],
            [22.024719, 49.224716],
            [22.024166, 49.228882],
            [22.025276, 49.247215],
            [22.021385, 49.270271],
            [22.018887, 49.277496],
            [21.960278, 49.339165],
            [21.956944, 49.341385],
            [21.838055, 49.384438],
            [21.618889, 49.436386],
            [21.606388, 49.436661],
            [21.533607, 49.429718],
            [21.500832, 49.422218],
            [21.470833, 49.412773],
            [21.465832, 49.411385],
            [21.459442, 49.41111],
            [21.441109, 49.412498],
            [21.436386, 49.413887],
            [21.400845, 49.429054],
            [21.285, 49.456108],
            [21.278889, 49.456665],
            [21.076111, 49.423607],
            [21.066944, 49.420555],
            [21.051666, 49.412216],
            [21.049442, 49.408882],
            [21.035553, 49.359718],
            [20.984165, 49.310555],
            [20.980553, 49.308327],
            [20.95583, 49.301666],
            [20.916386, 49.296104],
            [20.910831, 49.296104],
            [20.812496, 49.330826],
            [20.740833, 49.388885],
            [20.602776, 49.395554],
            [20.360554, 49.393051],
            [20.327774, 49.383331],
            [20.206665, 49.340271],
            [20.143608, 49.314995],
            [20.103333, 49.248604],
            [20.093609, 49.213608],
            [20.091663, 49.196106],
            [20.089443, 49.183884],
            [20.084999, 49.177498],
            [20.081387, 49.175278],
            [20.074444, 49.175278],
            [20.064163, 49.177773],
            [20.039165, 49.188889],
            [20.020554, 49.19944],
            [20.002514, 49.213585],
            [19.995277, 49.221664],
            [19.984444, 49.225555],
            [19.97472, 49.227219],
            [19.936386, 49.23111],
            [19.916386, 49.228882],
            [19.913055, 49.227493],
            [19.907776, 49.224159],
            [19.86791, 49.197132],
            [19.846664, 49.19194],
            [19.839165, 49.191666],
            [19.794441, 49.196388],
            [19.789444, 49.196938],
            [19.778889, 49.201111],
            [19.771111, 49.206383],
            [19.766109, 49.213051],
            [19.765831, 49.215828],
            [19.773609, 49.233055],
            [19.798054, 49.252777],
            [19.821388, 49.271111],
            [19.824165, 49.272774],
            [19.826111, 49.275276],
            [19.826942, 49.278053],
            [19.826664, 49.28083],
            [19.804996, 49.364716],
            [19.791664, 49.404442],
            [19.790276, 49.406662],
            [19.786388, 49.408051],
            [19.781387, 49.408607],
            [19.768608, 49.408051],
            [19.710552, 49.397499],
            [19.658607, 49.406662],
            [19.579166, 49.45694],
            [19.574997, 49.461105],
            [19.535275, 49.535553],
            [19.520981, 49.574165],
            [19.475555, 49.599998],
            [19.447777, 49.60083],
            [19.276386, 49.530548],
            [19.270275, 49.527771],
            [19.264721, 49.524162],
            [19.244442, 49.509163],
            [19.240276, 49.50444],
            [19.203331, 49.444717],
            [19.195274, 49.430832],
            [19.198055, 49.418053],
            [19.185276, 49.409996],
            [19.163609, 49.400551],
            [19.155552, 49.399994],
            [19.031666, 49.391937],
            [18.993332, 49.39444],
            [18.978054, 49.39666],
            [18.973053, 49.400551],
            [18.971664, 49.402771],
            [18.970833, 49.405273],
            [18.96833, 49.456383],
            [18.968609, 49.481667],
            [18.851246, 49.517357],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "PO",
        ISO2: "PT",
        ISO3: "PRT",
        UN: 620,
        NAME: "Portugal",
        AREA: 9150,
        POP2005: 10528226,
        REGION: 150,
        SUBREGION: 39,
        LON: -8.058,
        LAT: 40.309,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-8.20472, 41.874718000000144],
            [-8.201117, 41.872498000000121],
            [-8.187778, 41.873886],
            [-8.181114, 41.872498000000121],
            [-8.175556, 41.871109],
            [-8.16528, 41.86305],
            [-8.16111, 41.857498],
            [-8.16, 41.842773],
            [-8.16167, 41.8275],
            [-8.163807, 41.817184],
            [-8.140556, 41.809166000000118],
            [-8.13167, 41.809166000000118],
            [-8.08778, 41.809441000000106],
            [-8.067501, 41.815277],
            [-8.055065, 41.81952],
            [-8.035278, 41.827217],
            [-7.93222, 41.874718000000144],
            [-7.921112, 41.880829],
            [-7.88, 41.852776000000119],
            [-7.873334, 41.85249],
            [-7.866945, 41.85555],
            [-7.84917, 41.864441],
            [-7.759445, 41.8975],
            [-7.70583, 41.904442],
            [-7.6925, 41.904999],
            [-7.686389, 41.903053],
            [-7.59806, 41.865273],
            [-7.609167, 41.845551],
            [-7.611945, 41.834999],
            [-7.607779, 41.83111],
            [-7.426667, 41.82222],
            [-7.41056, 41.823326],
            [-7.331112, 41.84499],
            [-7.26833, 41.863609],
            [-7.207348, 41.883835],
            [-7.200556, 41.88361],
            [-7.18694, 41.898331],
            [-7.17361, 41.922775],
            [-7.17472, 41.928055],
            [-7.183056, 41.93777],
            [-7.187222, 41.975273],
            [-7.18278, 41.979439],
            [-7.14, 41.994164],
            [-7.13361, 41.994995],
            [-7.125556, 41.99305],
            [-7.10528, 41.986938],
            [-7.092501, 41.98027],
            [-7.081112, 41.966385],
            [-7.08167, 41.961388000000113],
            [-7.0775, 41.957497],
            [-7.063056, 41.951385],
            [-7.05611, 41.95111],
            [-7.01444, 41.952499],
            [-7.003056, 41.9566650000001],
            [-6.982848, 41.973862],
            [-6.94472, 41.952774],
            [-6.93611, 41.94944],
            [-6.90611, 41.944717],
            [-6.71694, 41.936661],
            [-6.696945, 41.936661],
            [-6.6875, 41.936661],
            [-6.618334, 41.940552],
            [-6.6025, 41.94888],
            [-6.594167, 41.95361],
            [-6.548612, 41.921944],
            [-6.52806, 41.839439],
            [-6.547501, 41.764999],
            [-6.55222, 41.698051000000135],
            [-6.55139, 41.691109],
            [-6.539445, 41.679443],
            [-6.50611, 41.661385],
            [-6.4975, 41.65749],
            [-6.469167, 41.666664],
            [-6.452778, 41.67472],
            [-6.434167, 41.680275],
            [-6.42472, 41.679718],
            [-6.34722, 41.67222],
            [-6.303612, 41.66333],
            [-6.26, 41.643051],
            [-6.25222, 41.637772],
            [-6.19444, 41.593048000000124],
            [-6.18722, 41.579720000000123],
            [-6.18875, 41.576057000000105],
            [-6.191389, 41.569717],
            [-6.203611, 41.548332],
            [-6.210556, 41.538887],
            [-6.217501, 41.529442000000131],
            [-6.29583, 41.436104],
            [-6.357779, 41.380554000000132],
            [-6.438056, 41.318886],
            [-6.51028, 41.265],
            [-6.558333, 41.242218],
            [-6.58, 41.239716],
            [-6.59833, 41.244164],
            [-6.618056, 41.246384],
            [-6.64389, 41.24472],
            [-6.686389, 41.212494000000106],
            [-6.690556, 41.208054],
            [-6.75333, 41.136665],
            [-6.75417, 41.112495],
            [-6.75444, 41.102493],
            [-6.768612, 41.07777],
            [-6.780278, 41.063606000000107],
            [-6.805556, 41.045555],
            [-6.835, 41.031662],
            [-6.848333, 41.028610000000128],
            [-6.92441, 41.03096],
            [-6.931667, 41.018051000000128],
            [-6.92944, 41.013054],
            [-6.891389, 40.974716000000114],
            [-6.87167, 40.95916],
            [-6.865556, 40.956383],
            [-6.85722, 40.947495000000117],
            [-6.803889, 40.874161],
            [-6.79972, 40.856110000000115],
            [-6.801667, 40.848885],
            [-6.81944, 40.73333],
            [-6.79611, 40.52444],
            [-6.815556, 40.38777],
            [-6.83111, 40.317215],
            [-6.862303, 40.271523000000116],
            [-6.873889, 40.263329],
            [-6.88278, 40.260277],
            [-6.91028, 40.256386],
            [-6.946526, 40.25898],
            [-7.005834, 40.23083],
            [-7.01083, 40.222771],
            [-7.02722, 40.18777],
            [-7.013056, 40.139442],
            [-7.004723, 40.126106],
            [-6.98722, 40.120552],
            [-6.97806, 40.117775],
            [-6.96, 40.115829],
            [-6.95056, 40.11666],
            [-6.9425, 40.112778],
            [-6.93472, 40.1075],
            [-6.928889, 40.101662],
            [-6.8825, 40.044167],
            [-6.87056, 40.021660000000111],
            [-6.87083, 40.01028],
            [-6.989722, 39.724716],
            [-7.01722, 39.674995000000138],
            [-7.04812, 39.665253],
            [-7.05763, 39.662254],
            [-7.146111, 39.658607],
            [-7.1525, 39.658882],
            [-7.166112, 39.661942000000124],
            [-7.205556, 39.66722],
            [-7.260279, 39.672218],
            [-7.266945, 39.67194400000011],
            [-7.307222, 39.656662],
            [-7.32556, 39.648605],
            [-7.33083, 39.644722],
            [-7.3375, 39.643883],
            [-7.4075, 39.64833],
            [-7.41472, 39.649162],
            [-7.5325, 39.669418],
            [-7.526945, 39.64],
            [-7.523056, 39.633331],
            [-7.505834, 39.605827],
            [-7.499722, 39.599716000000114],
            [-7.38, 39.496109],
            [-7.371389, 39.491386],
            [-7.32278, 39.388329],
            [-7.31361, 39.344719000000111],
            [-7.24278, 39.213051],
            [-7.149167, 39.116661],
            [-7.1425, 39.111107],
            [-7.13389, 39.108604],
            [-7.115834, 39.104164],
            [-7.10278, 39.104721],
            [-7.065556, 39.114716],
            [-7.05667, 39.11805],
            [-7.05056, 39.124161],
            [-7.040278, 39.122772000000111],
            [-7.02139, 39.11639],
            [-7.005, 39.107216000000108],
            [-6.98278, 39.09138],
            [-6.961112, 39.056664],
            [-6.95479, 39.026382],
            [-6.956944, 39.019997],
            [-7.06, 38.86055],
            [-7.08417, 38.835548],
            [-7.16417, 38.781944],
            [-7.207355, 38.749268],
            [-7.24556, 38.73389],
            [-7.257223, 38.728333],
            [-7.260279, 38.723053000000107],
            [-7.265556, 38.708328],
            [-7.267222, 38.703331],
            [-7.32111, 38.44944],
            [-7.313056, 38.439995],
            [-7.304167, 38.435829],
            [-7.28889, 38.426941000000113],
            [-7.280834, 38.4222180000001],
            [-7.274445, 38.41666],
            [-7.192223, 38.320274],
            [-7.16972, 38.284439],
            [-7.145, 38.246109],
            [-7.13, 38.22583],
            [-7.10222, 38.189163000000121],
            [-7.10111, 38.184166],
            [-7.08778, 38.174438],
            [-7.081112, 38.17472],
            [-7.02833, 38.187492],
            [-7.01694, 38.191666000000112],
            [-7.01167, 38.195549],
            [-7.01028, 38.200554],
            [-6.993334, 38.209442],
            [-6.96139, 38.21583],
            [-6.947779, 38.21833],
            [-6.94056, 38.217773000000136],
            [-6.93375, 38.209068],
            [-6.939167, 38.17805],
            [-6.94389, 38.162773],
            [-6.95167, 38.14],
            [-7.00139, 38.034164],
            [-7.006667, 38.028053000000114],
            [-7.12361, 38.009995000000117],
            [-7.21083, 37.996941],
            [-7.24556, 37.990829],
            [-7.25444, 37.987495],
            [-7.259445, 37.98166700000013],
            [-7.25472, 37.974716],
            [-7.25194, 37.959442000000138],
            [-7.25194, 37.933609],
            [-7.25361, 37.928329000000133],
            [-7.27833, 37.87083],
            [-7.285, 37.860275],
            [-7.320001, 37.815277],
            [-7.379168, 37.77444],
            [-7.394723, 37.764999000000103],
            [-7.42306, 37.743889000000138],
            [-7.446945, 37.69944],
            [-7.524445, 37.552498],
            [-7.512534, 37.528549],
            [-7.503056, 37.522499],
            [-7.48472, 37.498886],
            [-7.47139, 37.481384000000105],
            [-7.46139, 37.457222],
            [-7.44722, 37.41861],
            [-7.43472, 37.366943],
            [-7.43185, 37.253189],
            [-7.414445, 37.186104],
            [-7.423612, 37.174995],
            [-7.43833, 37.178329],
            [-7.45083, 37.179161],
            [-7.47194, 37.177773],
            [-7.553056, 37.155548],
            [-7.56611, 37.150833],
            [-7.5775, 37.145828],
            [-7.58333, 37.143051],
            [-7.613056, 37.128609],
            [-7.616389, 37.123604],
            [-7.615001, 37.118332000000123],
            [-7.61722, 37.113327],
            [-7.62194, 37.109993],
            [-7.75833, 37.035],
            [-7.89778, 37.008888],
            [-7.97306, 37.008331000000112],
            [-8.00806, 37.018608],
            [-8.017778, 37.025551],
            [-8.039446, 37.039993],
            [-8.04972, 37.046104000000128],
            [-8.06778, 37.054718],
            [-8.104168, 37.07166],
            [-8.1175, 37.076942000000145],
            [-8.17528, 37.092216],
            [-8.3675, 37.103882],
            [-8.380001, 37.100273],
            [-8.39833, 37.092773],
            [-8.41722, 37.088608],
            [-8.43639, 37.085548],
            [-8.44278, 37.086662],
            [-8.511112, 37.10305000000011],
            [-8.65889, 37.108887],
            [-8.81472, 37.06694],
            [-8.926668, 37.016106],
            [-8.984446, 37.020271],
            [-8.99028, 37.023048000000131],
            [-8.99139, 37.028053],
            [-8.990835, 37.033882],
            [-8.984167, 37.052216000000101],
            [-8.95917, 37.0925],
            [-8.95083, 37.101105],
            [-8.94528, 37.103882],
            [-8.94111, 37.107773],
            [-8.926111, 37.127495000000124],
            [-8.922779, 37.132774],
            [-8.913612, 37.147499],
            [-8.905834, 37.16166],
            [-8.90333, 37.166664],
            [-8.85806, 37.27277400000014],
            [-8.82889, 37.380554],
            [-8.795862, 37.44251],
            [-8.78722, 37.524162],
            [-8.7875, 37.722221],
            [-8.80583, 37.76638800000012],
            [-8.791866, 37.819092],
            [-8.79139, 37.824165],
            [-8.79056, 37.83416],
            [-8.794445, 37.897217],
            [-8.797501, 37.912773000000129],
            [-8.79972, 37.91777],
            [-8.80556, 37.928329000000133],
            [-8.81056, 37.931938000000116],
            [-8.84222, 38.009438],
            [-8.83667, 38.019997],
            [-8.80806, 38.086105],
            [-8.80556, 38.091942],
            [-8.796112, 38.118332],
            [-8.789446, 38.139442],
            [-8.77917, 38.18055],
            [-8.77582, 38.211761],
            [-8.77694, 38.250549],
            [-8.7775, 38.262215],
            [-8.77972, 38.30110900000011],
            [-8.78639, 38.32888800000012],
            [-8.79222, 38.34916],
            [-8.8025, 38.374443],
            [-8.72333, 38.41666],
            [-8.673334, 38.413887],
            [-8.76889, 38.51722],
            [-8.89222, 38.518051],
            [-8.905001, 38.517494],
            [-8.91139, 38.516106],
            [-8.92639, 38.503883],
            [-8.99278, 38.463608],
            [-9.062778, 38.437218],
            [-9.083612, 38.43305],
            [-9.18389, 38.419716],
            [-9.200279, 38.45166],
            [-9.184446, 38.475273],
            [-9.18306, 38.48083],
            [-9.179167, 38.506660000000124],
            [-9.17861, 38.511665],
            [-9.182501, 38.531944000000124],
            [-9.18528, 38.541939],
            [-9.20389, 38.59277],
            [-9.206945, 38.598053],
            [-9.218613, 38.617218],
            [-9.22167, 38.621666],
            [-9.23333, 38.63528],
            [-9.246389, 38.64666],
            [-9.27444, 38.66416],
            [-9.278612, 38.66861],
            [-9.27195, 38.671104],
            [-9.215279, 38.678329000000133],
            [-9.16889, 38.678886],
            [-9.150557, 38.676941],
            [-9.07445, 38.631104],
            [-9.028057, 38.699997],
            [-9.015556, 38.729439],
            [-8.964169, 38.758331000000112],
            [-8.951389, 38.763054000000125],
            [-8.93861, 38.764999000000103],
            [-8.91975, 38.765892],
            [-8.91972, 38.770271],
            [-8.928057, 38.79805],
            [-8.93083, 38.802773],
            [-8.955849, 38.840858000000139],
            [-8.96667, 38.834717],
            [-8.972502, 38.838608000000136],
            [-8.979168, 38.846939],
            [-8.9825, 38.851944],
            [-8.98389, 38.857216],
            [-8.99194, 38.892776],
            [-8.98695, 38.908607],
            [-8.984446, 38.947777],
            [-8.990835, 38.945274],
            [-8.99917, 38.93694],
            [-9.00278, 38.932495],
            [-9.06528, 38.855],
            [-9.07639, 38.835548],
            [-9.08167, 38.825554],
            [-9.087778, 38.810272],
            [-9.09056, 38.799721],
            [-9.092501, 38.783051],
            [-9.093613, 38.773048000000131],
            [-9.093334, 38.767494000000113],
            [-9.09167, 38.76221],
            [-9.092779, 38.75222],
            [-9.097778, 38.742493],
            [-9.106945, 38.727219],
            [-9.113611, 38.7175],
            [-9.12, 38.71416],
            [-9.13333, 38.709999],
            [-9.2125, 38.690826000000129],
            [-9.322224, 38.676666],
            [-9.429724, 38.691940000000102],
            [-9.46139, 38.698051],
            [-9.47389, 38.703049],
            [-9.484446, 38.709999],
            [-9.49472, 38.78527],
            [-9.49306, 38.790276],
            [-9.48778, 38.799995],
            [-9.46583, 38.834717],
            [-9.45917, 38.844444],
            [-9.450556, 38.851944],
            [-9.447224, 38.856667],
            [-9.442501, 38.866661],
            [-9.43778, 38.876938],
            [-9.42195, 38.91805],
            [-9.41417, 38.94416],
            [-9.411112, 38.95472],
            [-9.41417, 38.984161],
            [-9.41556, 38.989441000000113],
            [-9.41722, 38.99472],
            [-9.4225, 38.998604000000114],
            [-9.42639, 39.00361],
            [-9.42611, 39.019440000000145],
            [-9.41917, 39.078606],
            [-9.39667, 39.117775],
            [-9.36639, 39.160553],
            [-9.363056, 39.16555],
            [-9.342501, 39.215271],
            [-9.33694, 39.234444],
            [-9.337223, 39.255829000000119],
            [-9.3375, 39.270828],
            [-9.338345, 39.292976],
            [-9.361668, 39.348328],
            [-9.3575, 39.364998],
            [-9.293335, 39.391388],
            [-9.22722, 39.435272],
            [-9.14417, 39.526382000000126],
            [-9.085556, 39.615],
            [-9.07944, 39.640274],
            [-9.047501, 39.732216000000108],
            [-9.026945, 39.775551],
            [-8.98472, 39.850555],
            [-8.93195, 39.964165],
            [-8.896362, 40.0454],
            [-8.89306, 40.050278000000105],
            [-8.88889, 40.059715],
            [-8.874723, 40.096107],
            [-8.86278, 40.130829],
            [-8.86195, 40.148048000000131],
            [-8.88139, 40.242775],
            [-8.85056, 40.306938],
            [-8.84028, 40.336388],
            [-8.800001, 40.46833],
            [-8.790279, 40.504166000000112],
            [-8.785866, 40.520706000000132],
            [-8.782501, 40.537773],
            [-8.77806, 40.55778],
            [-8.77694, 40.562492],
            [-8.74539, 40.628387],
            [-8.72989, 40.63705],
            [-8.721724, 40.638718],
            [-8.691668, 40.66111],
            [-8.66083, 40.687218000000144],
            [-8.65944, 40.695000000000107],
            [-8.678335, 40.775833],
            [-8.70306, 40.718605],
            [-8.71961, 40.691277],
            [-8.727278, 40.680611],
            [-8.73128, 40.67961],
            [-8.73528, 40.680275],
            [-8.73361, 40.689438],
            [-8.72667, 40.727776],
            [-8.717779, 40.752777],
            [-8.702778, 40.794167],
            [-8.6975, 40.799438],
            [-8.69306, 40.814995000000124],
            [-8.67778, 40.869164],
            [-8.66806, 40.903885000000116],
            [-8.646112, 40.997215],
            [-8.645, 41.008049000000142],
            [-8.64554, 41.018578],
            [-8.65722, 41.041939],
            [-8.729445, 41.236664000000133],
            [-8.78972, 41.421387],
            [-8.778841, 41.467575],
            [-8.781113, 41.484444],
            [-8.79972, 41.566666],
            [-8.81509, 41.617241],
            [-8.86945, 41.716660000000104],
            [-8.876667, 41.731941],
            [-8.880001, 41.746666],
            [-8.881668, 41.75666],
            [-8.880001, 41.83888],
            [-8.87945, 41.843887],
            [-8.86861, 41.857773],
            [-8.85611, 41.870277],
            [-8.81361, 41.902496],
            [-8.786217, 41.91909],
            [-8.75242, 41.931732],
            [-8.74501, 41.952499],
            [-8.74445, 41.961937],
            [-8.743057, 41.96666],
            [-8.73861, 41.971382000000119],
            [-8.64, 42.045273],
            [-8.62083, 42.053604000000121],
            [-8.606945, 42.059166],
            [-8.521389, 42.082771],
            [-8.51472, 42.083328000000108],
            [-8.47361, 42.084717000000126],
            [-8.44611, 42.084717000000126],
            [-8.31056, 42.103607],
            [-8.25194, 42.13861],
            [-8.201223, 42.15274],
            [-8.19444, 42.1486],
            [-8.09, 42.068886000000134],
            [-8.085556, 42.06472],
            [-8.079723, 42.054161],
            [-8.08167, 42.03],
            [-8.0825, 42.025276000000133],
            [-8.085, 42.020271],
            [-8.08944, 42.01639],
            [-8.09556, 42.013329],
            [-8.10889, 42.008606],
            [-8.134724, 41.99889],
            [-8.16528, 41.974442],
            [-8.20472, 41.933609000000104],
            [-8.212778, 41.92388],
            [-8.218613, 41.9136],
            [-8.219168, 41.90861],
            [-8.217779, 41.903885],
            [-8.20472, 41.874718000000144],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "RO",
        ISO2: "RO",
        ISO3: "ROU",
        UN: 642,
        NAME: "Romania",
        AREA: 22987,
        POP2005: 21627557,
        REGION: 150,
        SUBREGION: 151,
        LON: 24.969,
        LAT: 45.844,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [20.726955, 46.17556],
            [20.719997, 46.187492],
            [20.720554, 46.191666],
            [20.75333, 46.238884],
            [20.761387, 46.246941],
            [20.783054, 46.259438],
            [20.795898, 46.265724],
            [20.820274, 46.274719],
            [20.82972, 46.277222],
            [20.846386, 46.27916],
            [20.86861, 46.276108],
            [20.989719, 46.254715],
            [21.03611, 46.245277],
            [21.048332, 46.239998],
            [21.053608, 46.238884],
            [21.059444, 46.239166],
            [21.08083, 46.246941],
            [21.176666, 46.295555],
            [21.178055, 46.299164],
            [21.178608, 46.326942],
            [21.185276, 46.362495],
            [21.191387, 46.381386],
            [21.19722, 46.391388],
            [21.208332, 46.402222],
            [21.219166, 46.408333],
            [21.288887, 46.460548],
            [21.29361, 46.532494],
            [21.30722, 46.588051],
            [21.308887, 46.59166],
            [21.324718, 46.616943],
            [21.326664, 46.619995],
            [21.329441, 46.622772],
            [21.441944, 46.681938],
            [21.449997, 46.685272],
            [21.45472, 46.685555],
            [21.467499, 46.685829],
            [21.489407, 46.684532],
            [21.493889, 46.686943],
            [21.521942, 46.712776],
            [21.526943, 46.718605],
            [21.528332, 46.722221],
            [21.529163, 46.726387],
            [21.528053, 46.729996],
            [21.521664, 46.734718],
            [21.502777, 46.739998],
            [21.494999, 46.743889],
            [21.489166, 46.749161],
            [21.488052, 46.752777],
            [21.493053, 46.763054],
            [21.519722, 46.815277],
            [21.526386, 46.825272],
            [21.529163, 46.828049],
            [21.545555, 46.839439],
            [21.613331, 46.884163],
            [21.67083, 46.961388],
            [21.691944, 46.994164],
            [21.695831, 47.000832],
            [21.695274, 47.004997],
            [21.693607, 47.008049],
            [21.690277, 47.010551],
            [21.655502, 47.020866],
            [21.653332, 47.022499],
            [21.651665, 47.025551],
            [21.651108, 47.029716],
            [21.653889, 47.032494],
            [21.709999, 47.07972],
            [21.734997, 47.094719],
            [21.751389, 47.101662],
            [21.769997, 47.106941],
            [21.782219, 47.112221],
            [21.790833, 47.120277],
            [21.844719, 47.184998],
            [21.84861, 47.191666],
            [21.84861, 47.203888],
            [21.846943, 47.211937],
            [21.84333, 47.21833],
            [21.84111, 47.225555],
            [21.841663, 47.234718],
            [21.843052, 47.238327],
            [21.869164, 47.293327],
            [21.874165, 47.299721],
            [21.922497, 47.354439],
            [21.925552, 47.357216],
            [21.932499, 47.361382],
            [21.937222, 47.362778],
            [21.962498, 47.36805],
            [21.985554, 47.369995],
            [21.996387, 47.371666],
            [22.004719, 47.374992],
            [22.0075, 47.377777],
            [22.00972, 47.380829],
            [22.013054, 47.388054],
            [22.015553, 47.395828],
            [22.020554, 47.425278],
            [22.021942, 47.445274],
            [22.018608, 47.456383],
            [22.009998, 47.473053],
            [22.006664, 47.484161],
            [22.006107, 47.496941],
            [22.010277, 47.508606],
            [22.015274, 47.514442],
            [22.023888, 47.522499],
            [22.032497, 47.530273],
            [22.043053, 47.536942],
            [22.118008, 47.57811],
            [22.158607, 47.585548],
            [22.177219, 47.59111],
            [22.186386, 47.59861],
            [22.189838, 47.603958],
            [22.19083, 47.626663],
            [22.191944, 47.630829],
            [22.224163, 47.677773],
            [22.226387, 47.680832],
            [22.270554, 47.723885],
            [22.276943, 47.728607],
            [22.318886, 47.745827],
            [22.323055, 47.747498],
            [22.445274, 47.793327],
            [22.454441, 47.796387],
            [22.472775, 47.796944],
            [22.489441, 47.794167],
            [22.5, 47.790852],
            [22.503609, 47.789719],
            [22.546944, 47.768051],
            [22.557499, 47.766106],
            [22.594997, 47.766937],
            [22.612221, 47.768608],
            [22.634163, 47.77166],
            [22.65361, 47.776382],
            [22.774441, 47.836388],
            [22.780277, 47.84166],
            [22.782497, 47.844719],
            [22.782776, 47.849159],
            [22.894804, 47.95454],
            [22.896111, 47.953888],
            [22.929996, 47.960548],
            [23.043331, 47.99305],
            [23.084442, 48.011108],
            [23.091106, 48.015831],
            [23.09972, 48.028877],
            [23.104717, 48.039719],
            [23.110828, 48.054436],
            [23.114162, 48.071106],
            [23.119164, 48.08194],
            [23.123886, 48.088326],
            [23.129719, 48.093605],
            [23.147774, 48.104164],
            [23.15694, 48.107216],
            [23.168053, 48.108604],
            [23.180275, 48.108047],
            [23.256386, 48.091934],
            [23.264999, 48.088326],
            [23.276943, 48.078331],
            [23.281387, 48.07222],
            [23.29361, 48.049164],
            [23.296108, 48.046387],
            [23.299442, 48.043884],
            [23.30722, 48.039993],
            [23.356106, 48.021103],
            [23.410275, 48.000549],
            [23.480553, 47.977493],
            [23.487499, 47.977219],
            [23.497776, 47.978333],
            [23.509163, 47.98333],
            [23.512218, 47.985832],
            [23.514267, 47.989338],
            [23.566097, 47.999992],
            [23.823887, 47.966942],
            [23.969719, 47.961388],
            [24.026665, 47.95694],
            [24.038055, 47.954994],
            [24.089443, 47.938049],
            [24.096386, 47.933609],
            [24.109444, 47.919716],
            [24.116386, 47.915276],
            [24.125553, 47.911942],
            [24.131107, 47.910828],
            [24.136944, 47.909996],
            [24.244164, 47.90361],
            [24.249722, 47.90416],
            [24.326942, 47.928886],
            [24.412498, 47.956108],
            [24.427776, 47.95916],
            [24.433331, 47.959717],
            [24.453888, 47.958611],
            [24.556389, 47.953049],
            [24.572289, 47.949478],
            [24.588333, 47.945831],
            [24.609997, 47.936943],
            [24.620831, 47.93055],
            [24.668053, 47.902222],
            [24.672775, 47.89666],
            [24.673885, 47.892776],
            [24.673332, 47.888329],
            [24.66861, 47.87722],
            [24.668053, 47.872498],
            [24.668888, 47.868889],
            [24.670555, 47.865555],
            [24.676109, 47.860275],
            [24.693886, 47.849159],
            [24.709999, 47.84111],
            [24.723888, 47.836105],
            [24.770275, 47.820549],
            [24.802776, 47.817772],
            [24.812775, 47.814995],
            [24.816387, 47.813049],
            [24.822777, 47.808052],
            [24.832497, 47.797493],
            [24.863331, 47.759995],
            [24.891941, 47.721382],
            [24.894444, 47.718605],
            [24.901386, 47.714165],
            [24.906666, 47.712776],
            [24.919441, 47.711662],
            [24.928917, 47.713142],
            [24.953609, 47.719444],
            [24.968887, 47.722221],
            [24.999506, 47.724461],
            [25.029716, 47.728867],
            [25.049438, 47.73333],
            [25.085548, 47.744431],
            [25.109997, 47.75499],
            [25.123882, 47.763878],
            [25.148331, 47.784431],
            [25.156937, 47.792763],
            [25.161659, 47.798882],
            [25.17083, 47.816666],
            [25.17944, 47.829987],
            [25.218601, 47.870827],
            [25.23027, 47.881371],
            [25.237774, 47.885544],
            [25.254993, 47.89193],
            [25.326103, 47.915268],
            [25.34166, 47.918053],
            [25.501659, 47.933327],
            [25.524998, 47.934708],
            [25.568329, 47.935822],
            [25.588608, 47.934433],
            [25.646107, 47.933594],
            [25.773331, 47.93499],
            [25.783333, 47.937202],
            [25.791943, 47.940262],
            [25.817219, 47.955269],
            [25.833328, 47.962494],
            [25.843327, 47.964432],
            [25.922215, 47.974709],
            [26.037216, 47.983597],
            [26.102711, 47.981716],
            [26.114998, 47.981361],
            [26.149998, 47.982201],
            [26.167213, 47.988312],
            [26.183601, 47.995537],
            [26.194717, 48.001663],
            [26.197773, 48.00444],
            [26.272221, 48.076103],
            [26.322498, 48.162491],
            [26.322498, 48.166664],
            [26.318607, 48.172768],
            [26.317116, 48.176022],
            [26.315552, 48.179436],
            [26.314907, 48.186165],
            [26.463051, 48.217209],
            [26.474716, 48.217766],
            [26.499161, 48.215271],
            [26.515831, 48.211662],
            [26.524166, 48.208046],
            [26.52972, 48.207497],
            [26.534721, 48.208603],
            [26.567776, 48.222488],
            [26.634995, 48.257164],
            [26.704163, 48.263885],
            [26.808609, 48.249435],
            [26.825829, 48.244156],
            [26.954716, 48.185547],
            [27.000553, 48.155548],
            [27.158604, 47.985817],
            [27.200829, 47.902199],
            [27.211102, 47.845818],
            [27.238323, 47.785255],
            [27.280273, 47.693047],
            [27.297215, 47.661377],
            [27.298317, 47.66],
            [27.299438, 47.6586],
            [27.32777, 47.636658],
            [27.361191, 47.616978],
            [27.433331, 47.565262],
            [27.472916, 47.485977],
            [27.576103, 47.366096],
            [27.628326, 47.311928],
            [27.634163, 47.306931],
            [27.64138, 47.302483],
            [27.67944, 47.293877],
            [27.712494, 47.287209],
            [27.718601, 47.287209],
            [27.720778, 47.285671],
            [27.725269, 47.282494],
            [27.742214, 47.262772],
            [27.784718, 47.204987],
            [27.78611, 47.201653],
            [27.798054, 47.152489],
            [27.861382, 47.102486],
            [27.939995, 47.044991],
            [27.940893, 47.044476],
            [27.943886, 47.042763],
            [27.955872, 47.041542],
            [27.98966, 47.030838],
            [28.007771, 47.024712],
            [28.033886, 47.015549],
            [28.07111, 46.991096],
            [28.07972, 46.983597],
            [28.08194, 46.980537],
            [28.084721, 46.973877],
            [28.10638, 46.920273],
            [28.115826, 46.887772],
            [28.119717, 46.854404],
            [28.117493, 46.849434],
            [28.114716, 46.84137],
            [28.114716, 46.837212],
            [28.116108, 46.833878],
            [28.174435, 46.739716],
            [28.20388, 46.698601],
            [28.217495, 46.682213],
            [28.229713, 46.672493],
            [28.23315, 46.667683],
            [28.233883, 46.666656],
            [28.245827, 46.615822],
            [28.246958, 46.606525],
            [28.247211, 46.604439],
            [28.252499, 46.435822],
            [28.250111, 46.430672],
            [28.245544, 46.42083],
            [28.193604, 46.330269],
            [28.138882, 46.190536],
            [28.115829, 46.124718],
            [28.108326, 46.102291],
            [28.091385, 46.075829],
            [28.084438, 46.011658],
            [28.085831, 46.004166],
            [28.09277, 45.991653],
            [28.094994, 45.988884],
            [28.097387, 45.984425],
            [28.10722, 45.966103],
            [28.120274, 45.921928],
            [28.163609, 45.725548],
            [28.164436, 45.721657],
            [28.164993, 45.71804],
            [28.166939, 45.670273],
            [28.16666, 45.6661],
            [28.162495, 45.631927],
            [28.161102, 45.628036],
            [28.158604, 45.624985],
            [28.154995, 45.623047],
            [28.145662, 45.620529],
            [28.12888, 45.62027],
            [28.06916, 45.583321],
            [28.17194, 45.474709],
            [28.176941, 45.469437],
            [28.211311, 45.450111],
            [28.21484, 45.448647],
            [28.218601, 45.449997],
            [28.229324, 45.449207],
            [28.272774, 45.435547],
            [28.27916, 45.430817],
            [28.281109, 45.42804],
            [28.283886, 45.421371],
            [28.284992, 45.413872],
            [28.284161, 45.409424],
            [28.283926, 45.398788],
            [28.283886, 45.396935],
            [28.285275, 45.389435],
            [28.287777, 45.382767],
            [28.29472, 45.37027],
            [28.303608, 45.354996],
            [28.310799, 45.344677],
            [28.311939, 45.34304],
            [28.316666, 45.337494],
            [28.33083, 45.324997],
            [28.343327, 45.315536],
            [28.375828, 45.300545],
            [28.574715, 45.24276],
            [28.688328, 45.220818],
            [28.694714, 45.219986],
            [28.695932, 45.219986],
            [28.700846, 45.219986],
            [28.706657, 45.219986],
            [28.785275, 45.229996],
            [28.797218, 45.234711],
            [28.799622, 45.237656],
            [28.799721, 45.240822],
            [28.84861, 45.301659],
            [28.968052, 45.321106],
            [29.217216, 45.424721],
            [29.226109, 45.426941],
            [29.318886, 45.438889],
            [29.324162, 45.439156],
            [29.411385, 45.435822],
            [29.503326, 45.412766],
            [29.51833, 45.4086],
            [29.571938, 45.392487],
            [29.589439, 45.385544],
            [29.603333, 45.376938],
            [29.636944, 45.350266],
            [29.644997, 45.342499],
            [29.654999, 45.327766],
            [29.667217, 45.301659],
            [29.67083, 45.287491],
            [29.672497, 45.276375],
            [29.671944, 45.268044],
            [29.664331, 45.211803],
            [29.632214, 45.215828],
            [29.626942, 45.215271],
            [29.623882, 45.213051],
            [29.62447, 45.211285],
            [29.624992, 45.209717],
            [29.641106, 45.173882],
            [29.660275, 45.112762],
            [29.64138, 44.981934],
            [29.613049, 44.851662],
            [29.607494, 44.840828],
            [29.599716, 44.837494],
            [29.549438, 44.820267],
            [29.450829, 44.808884],
            [29.389996, 44.802216],
            [29.353046, 44.799721],
            [29.340069, 44.799721],
            [29.330547, 44.799721],
            [29.250832, 44.79583],
            [29.214161, 44.793053],
            [29.067493, 44.822762],
            [29.051941, 44.842484],
            [29.049995, 44.845543],
            [29.044994, 44.858887],
            [29.038326, 44.911934],
            [29.039436, 44.92054],
            [29.04277, 44.927773],
            [29.051105, 44.936371],
            [29.063885, 44.945534],
            [29.07111, 44.949425],
            [29.084721, 44.952766],
            [29.095276, 44.953606],
            [29.10416, 44.955826],
            [29.110271, 44.960541],
            [29.111664, 44.964706],
            [29.111938, 44.96888],
            [29.109715, 44.971657],
            [29.099442, 44.978325],
            [29.047215, 45.002769],
            [29.04166, 45.003609],
            [28.98999, 45.006104],
            [28.979713, 45.006104],
            [28.975552, 45.004715],
            [28.899998, 44.96666],
            [28.873882, 44.948601],
            [28.868324, 44.943047],
            [28.866383, 44.939713],
            [28.862217, 44.927773],
            [28.861107, 44.919159],
            [28.862492, 44.881653],
            [28.863605, 44.878319],
            [28.869991, 44.873604],
            [28.89027, 44.865273],
            [28.897217, 44.861107],
            [28.944996, 44.830269],
            [28.949715, 44.824715],
            [28.949715, 44.821381],
            [28.926941, 44.778328],
            [28.907219, 44.755547],
            [28.896107, 44.755272],
            [28.872215, 44.751099],
            [28.859715, 44.746941],
            [28.798328, 44.719437],
            [28.793327, 44.713326],
            [28.783051, 44.697487],
            [28.781109, 44.693871],
            [28.779716, 44.669434],
            [28.779142, 44.657059],
            [28.783886, 44.647484],
            [28.789928, 44.642387],
            [28.79277, 44.639992],
            [28.799164, 44.639435],
            [28.814159, 44.641373],
            [28.843609, 44.645821],
            [28.851662, 44.648598],
            [28.85833, 44.653046],
            [28.904442, 44.684433],
            [28.907494, 44.686646],
            [28.909992, 44.689713],
            [28.9104, 44.692337],
            [28.90527, 44.698318],
            [28.898331, 44.70694],
            [28.899715, 44.710815],
            [28.90416, 44.709984],
            [28.930027, 44.701225],
            [28.954163, 44.699158],
            [28.95916, 44.697762],
            [28.987774, 44.688881],
            [28.99194, 44.687202],
            [28.994717, 44.684708],
            [28.995274, 44.680817],
            [28.993881, 44.676941],
            [28.972218, 44.645546],
            [28.969711, 44.642487],
            [28.955273, 44.630814],
            [28.951656, 44.628876],
            [28.946938, 44.627762],
            [28.943604, 44.62999],
            [28.94138, 44.633041],
            [28.942219, 44.636658],
            [28.958324, 44.656647],
            [28.969162, 44.662491],
            [28.975269, 44.667206],
            [28.98027, 44.673325],
            [28.981663, 44.677216],
            [28.981167, 44.678406],
            [28.98027, 44.68055],
            [28.976936, 44.68277],
            [28.960274, 44.689713],
            [28.954437, 44.68998],
            [28.819672, 44.616951],
            [28.796518, 44.630844],
            [28.767494, 44.629715],
            [28.763611, 44.628052],
            [28.760551, 44.625275],
            [28.755833, 44.61805],
            [28.75444, 44.614441],
            [28.7575, 44.519722],
            [28.803219, 44.525768],
            [28.813051, 44.537106],
            [28.927773, 44.617493],
            [28.913052, 44.588051],
            [28.881943, 44.542213],
            [28.871666, 44.52916],
            [28.845276, 44.497208],
            [28.831387, 44.482216],
            [28.825272, 44.476944],
            [28.805664, 44.463833],
            [28.803165, 44.462826],
            [28.790161, 44.455326],
            [28.758053, 44.431389],
            [28.745548, 44.42083],
            [28.65416, 44.339432],
            [28.645271, 44.331383],
            [28.642773, 44.328049],
            [28.634995, 44.311935],
            [28.629993, 44.298607],
            [28.629166, 44.294434],
            [28.628883, 44.271935],
            [28.632771, 44.157494],
            [28.660275, 43.975548],
            [28.647221, 43.95443],
            [28.613605, 43.881653],
            [28.594994, 43.831657],
            [28.585278, 43.800819],
            [28.579437, 43.764709],
            [28.579437, 43.758041],
            [28.583244, 43.747765],
            [28.484997, 43.744164],
            [28.403889, 43.750275],
            [28.257771, 43.764435],
            [28.235554, 43.769997],
            [28.181942, 43.785271],
            [28.133053, 43.801659],
            [28.047218, 43.831657],
            [28.029716, 43.839165],
            [28.001942, 43.8536],
            [27.997215, 43.859154],
            [27.991108, 43.871666],
            [27.962215, 43.938332],
            [27.958328, 43.951653],
            [27.957771, 43.958878],
            [27.95472, 43.972771],
            [27.951664, 43.978882],
            [27.944717, 43.987221],
            [27.927773, 44.002769],
            [27.918884, 44.005547],
            [27.914444, 44.004433],
            [27.86805, 43.984154],
            [27.852776, 43.977486],
            [27.833328, 43.969162],
            [27.820271, 43.965828],
            [27.806107, 43.964165],
            [27.747215, 43.95916],
            [27.736382, 43.959717],
            [27.730827, 43.961098],
            [27.717773, 43.966942],
            [27.711662, 43.971657],
            [27.706944, 43.977219],
            [27.698353, 43.993607],
            [27.684715, 44.020821],
            [27.67944, 44.029999],
            [27.676941, 44.032776],
            [27.673882, 44.035271],
            [27.660828, 44.040833],
            [27.656109, 44.042496],
            [27.650555, 44.043053],
            [27.64222, 44.040276],
            [27.631943, 44.0336],
            [27.629719, 44.030266],
            [27.623333, 44.025269],
            [27.614162, 44.023598],
            [27.475826, 44.01944],
            [27.416943, 44.020554],
            [27.399998, 44.021935],
            [27.396111, 44.024155],
            [27.299995, 44.080544],
            [27.29055, 44.088051],
            [27.279716, 44.102219],
            [27.278889, 44.105553],
            [27.272713, 44.132149],
            [27.250549, 44.124985],
            [27.237778, 44.121666],
            [27.222775, 44.119987],
            [27.199715, 44.122208],
            [27.187492, 44.124435],
            [27.165833, 44.12999],
            [27.111111, 44.140831],
            [27.036427, 44.147339],
            [26.913403, 44.136124],
            [26.890205, 44.131989],
            [26.840832, 44.115555],
            [26.79472, 44.095276],
            [26.671104, 44.071938],
            [26.478611, 44.049431],
            [26.438416, 44.041306],
            [26.413036, 44.043129],
            [26.391388, 44.044434],
            [26.381943, 44.04332],
            [26.301941, 44.030823],
            [26.144161, 43.986382],
            [26.128609, 43.979156],
            [26.111664, 43.968323],
            [26.085278, 43.949715],
            [25.947495, 43.852219],
            [25.938049, 43.844719],
            [25.89027, 43.801941],
            [25.887238, 43.799103],
            [25.8825, 43.792213],
            [25.878262, 43.778824],
            [25.786942, 43.713051],
            [25.772495, 43.705544],
            [25.760551, 43.701111],
            [25.739246, 43.695122],
            [25.731377, 43.694077],
            [25.681339, 43.69043],
            [25.609161, 43.662209],
            [25.53194, 43.6436],
            [25.463852, 43.639206],
            [25.440952, 43.630112],
            [25.430229, 43.626778],
            [25.416111, 43.624718],
            [25.396111, 43.623322],
            [25.380711, 43.622437],
            [25.375275, 43.622765],
            [25.363049, 43.624718],
            [25.348885, 43.62999],
            [25.339439, 43.636932],
            [25.314442, 43.652222],
            [25.275272, 43.672493],
            [25.261944, 43.678055],
            [25.224716, 43.687485],
            [25.022751, 43.71019],
            [24.881386, 43.712219],
            [24.79361, 43.712776],
            [24.722775, 43.714165],
            [24.705555, 43.715271],
            [24.686932, 43.718384],
            [24.613331, 43.749161],
            [24.598331, 43.753883],
            [24.562496, 43.759163],
            [24.52861, 43.761108],
            [24.506386, 43.762215],
            [24.497219, 43.760277],
            [24.457775, 43.74472],
            [24.43861, 43.736382],
            [24.405277, 43.719719],
            [24.364719, 43.699715],
            [24.360832, 43.698051],
            [24.352497, 43.695549],
            [24.343052, 43.69416],
            [24.319706, 43.696632],
            [24.307777, 43.697495],
            [24.286388, 43.697495],
            [24.257221, 43.694443],
            [24.224163, 43.689438],
            [24.195553, 43.685272],
            [24.185833, 43.684441],
            [24.179996, 43.684715],
            [24.155617, 43.689911],
            [24.116077, 43.699913],
            [24.067982, 43.720627],
            [23.987499, 43.744164],
            [23.774166, 43.78833],
            [23.629719, 43.794998],
            [23.612499, 43.796104],
            [23.601665, 43.798607],
            [23.570274, 43.806938],
            [23.539352, 43.819328],
            [23.528042, 43.825523],
            [23.516003, 43.835381],
            [23.50703, 43.83773],
            [23.446663, 43.851105],
            [23.427147, 43.855232],
            [23.418224, 43.856171],
            [23.283607, 43.85083],
            [23.269009, 43.849243],
            [23.255142, 43.846321],
            [23.224499, 43.838661],
            [23.198608, 43.831383],
            [23.162109, 43.81823],
            [23.147499, 43.811104],
            [23.138885, 43.808327],
            [23.071457, 43.802177],
            [23.063602, 43.802177],
            [22.966942, 43.81694],
            [22.894444, 43.836105],
            [22.875275, 43.842499],
            [22.863331, 43.848328],
            [22.857471, 43.853256],
            [22.847618, 43.86821],
            [22.840687, 43.888283],
            [22.843243, 43.90506],
            [22.879719, 43.981667],
            [22.88472, 43.988052],
            [22.906944, 43.998886],
            [22.919857, 44.002838],
            [22.959431, 44.012276],
            [22.98222, 44.011383],
            [22.987499, 44.011665],
            [22.995831, 44.01416],
            [23.003407, 44.017799],
            [23.032497, 44.044716],
            [23.042774, 44.056664],
            [23.044441, 44.060555],
            [23.046108, 44.06916],
            [23.044167, 44.076111],
            [23.03722, 44.084442],
            [23.021942, 44.092773],
            [23.003609, 44.099442],
            [22.997444, 44.100632],
            [22.951385, 44.103607],
            [22.945274, 44.104439],
            [22.921665, 44.108604],
            [22.907497, 44.113609],
            [22.696941, 44.212219],
            [22.686386, 44.218887],
            [22.681435, 44.224701],
            [22.691666, 44.26416],
            [22.691109, 44.27166],
            [22.687496, 44.277771],
            [22.680832, 44.282494],
            [22.672775, 44.286385],
            [22.657776, 44.29055],
            [22.641109, 44.294167],
            [22.616676, 44.298035],
            [22.591942, 44.300827],
            [22.576111, 44.304718],
            [22.567219, 44.308327],
            [22.549721, 44.323051],
            [22.536942, 44.336388],
            [22.529999, 44.345276],
            [22.463333, 44.449997],
            [22.461712, 44.453201],
            [22.457333, 44.466698],
            [22.457333, 44.474358],
            [22.459999, 44.482216],
            [22.463055, 44.484444],
            [22.582222, 44.546104],
            [22.590275, 44.549164],
            [22.609444, 44.552216],
            [22.621387, 44.551109],
            [22.6325, 44.548607],
            [22.645554, 44.543053],
            [22.667774, 44.530548],
            [22.677219, 44.527222],
            [22.686817, 44.523979],
            [22.699585, 44.522522],
            [22.709164, 44.523888],
            [22.734722, 44.531662],
            [22.743053, 44.534439],
            [22.754444, 44.539719],
            [22.76088, 44.544411],
            [22.763432, 44.547325],
            [22.765255, 44.551338],
            [22.765781, 44.555199],
            [22.764893, 44.559006],
            [22.762703, 44.56192],
            [22.71722, 44.602493],
            [22.713886, 44.604721],
            [22.709999, 44.606667],
            [22.671944, 44.618889],
            [22.659721, 44.619995],
            [22.644444, 44.618607],
            [22.622219, 44.618889],
            [22.609722, 44.620552],
            [22.604721, 44.622215],
            [22.592499, 44.628052],
            [22.574444, 44.638611],
            [22.543053, 44.658607],
            [22.519722, 44.674721],
            [22.508053, 44.684715],
            [22.496944, 44.695],
            [22.489998, 44.703331],
            [22.479164, 44.710274],
            [22.469719, 44.713608],
            [22.457775, 44.715553],
            [22.436386, 44.714439],
            [22.431664, 44.713333],
            [22.423611, 44.710274],
            [22.320553, 44.668327],
            [22.31361, 44.664162],
            [22.308609, 44.657776],
            [22.303608, 44.645828],
            [22.297775, 44.635826],
            [22.273331, 44.604164],
            [22.25861, 44.585274],
            [22.187222, 44.493889],
            [22.176941, 44.481941],
            [22.168888, 44.478607],
            [22.146385, 44.479164],
            [22.128609, 44.481384],
            [22.106667, 44.490273],
            [22.09111, 44.498329],
            [22.084442, 44.503052],
            [22.039444, 44.551666],
            [22.035553, 44.557495],
            [22.033333, 44.564438],
            [22.031261, 44.589424],
            [22.029163, 44.593887],
            [22.003887, 44.628609],
            [22.001389, 44.631104],
            [21.993889, 44.635551],
            [21.988888, 44.63694],
            [21.909164, 44.649437],
            [21.783607, 44.661942],
            [21.738609, 44.656944],
            [21.729721, 44.654716],
            [21.655552, 44.656944],
            [21.649441, 44.657776],
            [21.639721, 44.660828],
            [21.632221, 44.664993],
            [21.622776, 44.672218],
            [21.618332, 44.678329],
            [21.614998, 44.688606],
            [21.614719, 44.692215],
            [21.614719, 44.697495],
            [21.616386, 44.710274],
            [21.61565, 44.717705],
            [21.604164, 44.747498],
            [21.600277, 44.753609],
            [21.594997, 44.758888],
            [21.588333, 44.763329],
            [21.565552, 44.77166],
            [21.543053, 44.776382],
            [21.524441, 44.778328],
            [21.47472, 44.777771],
            [21.453609, 44.776665],
            [21.405869, 44.779732],
            [21.400398, 44.780823],
            [21.394196, 44.785934],
            [21.362091, 44.823143],
            [21.363052, 44.833057],
            [21.366108, 44.864441],
            [21.373055, 44.868607],
            [21.400276, 44.874992],
            [21.415276, 44.877495],
            [21.444443, 44.876389],
            [21.462776, 44.874443],
            [21.478886, 44.875275],
            [21.50222, 44.879715],
            [21.548611, 44.889442],
            [21.552776, 44.890831],
            [21.555832, 44.893326],
            [21.558609, 44.896111],
            [21.559719, 44.900551],
            [21.559719, 44.908607],
            [21.556389, 44.91861],
            [21.551388, 44.928055],
            [21.546944, 44.933884],
            [21.540833, 44.938606],
            [21.527775, 44.94416],
            [21.475555, 44.961662],
            [21.470833, 44.963051],
            [21.459164, 44.964439],
            [21.441109, 44.960274],
            [21.429722, 44.961662],
            [21.408886, 44.971107],
            [21.405552, 44.973328],
            [21.37611, 44.996666],
            [21.371109, 45.00222],
            [21.366943, 45.008331],
            [21.367222, 45.015549],
            [21.369442, 45.018608],
            [21.372776, 45.020828],
            [21.381943, 45.023331],
            [21.443054, 45.053604],
            [21.512775, 45.123329],
            [21.514164, 45.126938],
            [21.516109, 45.139717],
            [21.515274, 45.147774],
            [21.513611, 45.151108],
            [21.482777, 45.183609],
            [21.47337, 45.187447],
            [21.416664, 45.214722],
            [21.404999, 45.21611],
            [21.351387, 45.217773],
            [21.276386, 45.229721],
            [21.267498, 45.232773],
            [21.048885, 45.316383],
            [20.986664, 45.345833],
            [20.808331, 45.478882],
            [20.794167, 45.507774],
            [20.76833, 45.602219],
            [20.766666, 45.609993],
            [20.766941, 45.619164],
            [20.76833, 45.622772],
            [20.772499, 45.629166],
            [20.780552, 45.637497],
            [20.796108, 45.649437],
            [20.798885, 45.656662],
            [20.804722, 45.744164],
            [20.804443, 45.757217],
            [20.801388, 45.76416],
            [20.79583, 45.769165],
            [20.788055, 45.773048],
            [20.782776, 45.773888],
            [20.776943, 45.773605],
            [20.773052, 45.771942],
            [20.767498, 45.766663],
            [20.764164, 45.75972],
            [20.757774, 45.750275],
            [20.747776, 45.743607],
            [20.738609, 45.741104],
            [20.727497, 45.739998],
            [20.721664, 45.740555],
            [20.713333, 45.743889],
            [20.709999, 45.746109],
            [20.664165, 45.795555],
            [20.660553, 45.801941],
            [20.656944, 45.813049],
            [20.656944, 45.830826],
            [20.654999, 45.833885],
            [20.591663, 45.894165],
            [20.578888, 45.903328],
            [20.561943, 45.909996],
            [20.545555, 45.912498],
            [20.526665, 45.912216],
            [20.515553, 45.913055],
            [20.506386, 45.915833],
            [20.378052, 45.97805],
            [20.368332, 45.984993],
            [20.360832, 45.993332],
            [20.355, 46.003052],
            [20.352776, 46.010277],
            [20.353611, 46.023605],
            [20.352497, 46.027222],
            [20.321388, 46.063606],
            [20.306664, 46.076111],
            [20.261024, 46.114853],
            [20.264442, 46.130272],
            [20.270832, 46.139717],
            [20.276665, 46.144722],
            [20.285275, 46.146942],
            [20.340275, 46.159439],
            [20.48695, 46.181107],
            [20.535275, 46.17305],
            [20.563332, 46.164993],
            [20.582775, 46.154999],
            [20.619442, 46.131386],
            [20.624722, 46.130272],
            [20.679443, 46.14222],
            [20.69589, 46.150391],
            [20.706387, 46.156662],
            [20.720554, 46.16555],
            [20.72583, 46.171104],
            [20.726955, 46.17556],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "MD",
        ISO2: "MD",
        ISO3: "MDA",
        UN: 498,
        NAME: "Republic of Moldova",
        AREA: 3288,
        POP2005: 3876661,
        REGION: 150,
        SUBREGION: 151,
        LON: 28.599,
        LAT: 47.193,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [28.119717, 46.854404],
            [28.115826, 46.887772],
            [28.10638, 46.920273],
            [28.084721, 46.973877],
            [28.08194, 46.980537],
            [28.07972, 46.983597],
            [28.07111, 46.991096],
            [28.033886, 47.015549],
            [28.007771, 47.024712],
            [27.98966, 47.030838],
            [27.955872, 47.041542],
            [27.943886, 47.042763],
            [27.940893, 47.044476],
            [27.939995, 47.044991],
            [27.861382, 47.102486],
            [27.798054, 47.152489],
            [27.78611, 47.201653],
            [27.784718, 47.204987],
            [27.742214, 47.262772],
            [27.725269, 47.282494],
            [27.720778, 47.285671],
            [27.718601, 47.287209],
            [27.712494, 47.287209],
            [27.67944, 47.293877],
            [27.64138, 47.302483],
            [27.634163, 47.306931],
            [27.628326, 47.311928],
            [27.576103, 47.366096],
            [27.472916, 47.485977],
            [27.433331, 47.565262],
            [27.361191, 47.616978],
            [27.32777, 47.636658],
            [27.299438, 47.6586],
            [27.298317, 47.66],
            [27.297215, 47.661377],
            [27.280273, 47.693047],
            [27.238323, 47.785255],
            [27.211102, 47.845818],
            [27.200829, 47.902199],
            [27.158604, 47.985817],
            [27.000553, 48.155548],
            [26.954716, 48.185547],
            [26.825829, 48.244156],
            [26.808609, 48.249435],
            [26.704163, 48.263885],
            [26.634995, 48.257164],
            [26.635935, 48.267365],
            [26.636383, 48.272217],
            [26.643051, 48.287498],
            [26.648884, 48.29805],
            [26.654442, 48.303604],
            [26.695549, 48.340546],
            [26.698883, 48.343048],
            [26.703049, 48.344711],
            [26.711662, 48.340828],
            [26.720829, 48.329163],
            [26.808331, 48.333054],
            [26.981106, 48.357773],
            [27.233883, 48.367767],
            [27.244995, 48.368881],
            [27.454163, 48.439713],
            [27.51952, 48.4655],
            [27.547218, 48.468323],
            [27.755554, 48.451385],
            [27.770832, 48.447769],
            [27.862495, 48.402771],
            [27.869995, 48.398331],
            [27.876663, 48.389435],
            [27.883884, 48.372765],
            [27.888329, 48.366936],
            [27.893608, 48.361382],
            [27.912773, 48.348045],
            [27.932217, 48.337494],
            [27.948605, 48.32972],
            [27.963051, 48.324997],
            [28.014721, 48.316666],
            [28.066109, 48.313606],
            [28.08194, 48.309715],
            [28.085552, 48.307495],
            [28.088608, 48.304993],
            [28.095276, 48.296104],
            [28.096664, 48.288605],
            [28.094162, 48.274994],
            [28.086384, 48.260551],
            [28.08194, 48.243324],
            [28.082497, 48.239433],
            [28.086109, 48.23333],
            [28.089165, 48.23082],
            [28.09444, 48.229431],
            [28.203606, 48.207771],
            [28.222496, 48.205269],
            [28.233604, 48.2061],
            [28.238049, 48.207497],
            [28.259998, 48.220543],
            [28.28611, 48.234718],
            [28.294998, 48.238045],
            [28.339718, 48.24305],
            [28.345276, 48.243607],
            [28.35194, 48.24305],
            [28.356663, 48.241104],
            [28.363331, 48.236382],
            [28.365551, 48.233604],
            [28.369164, 48.227211],
            [28.373329, 48.217209],
            [28.373886, 48.20916],
            [28.370552, 48.196098],
            [28.364441, 48.185822],
            [28.388607, 48.163879],
            [28.436661, 48.145828],
            [28.501942, 48.134163],
            [28.551388, 48.160545],
            [28.560829, 48.163048],
            [28.567219, 48.163048],
            [28.642494, 48.153603],
            [28.737495, 48.138603],
            [28.802776, 48.127213],
            [28.811943, 48.123604],
            [28.824997, 48.114159],
            [28.831665, 48.10527],
            [28.87981, 48.010452],
            [28.880829, 48.009438],
            [28.882217, 48.005554],
            [28.893047, 47.99498],
            [28.907768, 47.982201],
            [28.9561, 47.949982],
            [28.967213, 47.943314],
            [28.975269, 47.939423],
            [28.98999, 47.934418],
            [29.010277, 47.93248],
            [29.022774, 47.932198],
            [29.038883, 47.933861],
            [29.047215, 47.937485],
            [29.054165, 47.941643],
            [29.059715, 47.947762],
            [29.063885, 47.954697],
            [29.066936, 47.962761],
            [29.068604, 47.971642],
            [29.070827, 47.975258],
            [29.073605, 47.97831],
            [29.080547, 47.982758],
            [29.094994, 47.985817],
            [29.111938, 47.987206],
            [29.13583, 47.987206],
            [29.141937, 47.986092],
            [29.149441, 47.981644],
            [29.152218, 47.979149],
            [29.17305, 47.957481],
            [29.178051, 47.95192],
            [29.256943, 47.771935],
            [29.258327, 47.768593],
            [29.258053, 47.764435],
            [29.25666, 47.760544],
            [29.198048, 47.612206],
            [29.192772, 47.606102],
            [29.163326, 47.58416],
            [29.156937, 47.579163],
            [29.140831, 47.561371],
            [29.135548, 47.55526],
            [29.131386, 47.548325],
            [29.131386, 47.544159],
            [29.132496, 47.536942],
            [29.134995, 47.529984],
            [29.139164, 47.519981],
            [29.146664, 47.503609],
            [29.184441, 47.443047],
            [29.186661, 47.43998],
            [29.193047, 47.435265],
            [29.198879, 47.434151],
            [29.204437, 47.434708],
            [29.213326, 47.437485],
            [29.220268, 47.447487],
            [29.225552, 47.453316],
            [29.233047, 47.457207],
            [29.237492, 47.458603],
            [29.243607, 47.458878],
            [29.248878, 47.457497],
            [29.252499, 47.455269],
            [29.299438, 47.422211],
            [29.358887, 47.378319],
            [29.380276, 47.357773],
            [29.38166, 47.354439],
            [29.381939, 47.346375],
            [29.377495, 47.328873],
            [29.378052, 47.325272],
            [29.383606, 47.315819],
            [29.405552, 47.294991],
            [29.416386, 47.288322],
            [29.428326, 47.28611],
            [29.466385, 47.289429],
            [29.478882, 47.294159],
            [29.481663, 47.297211],
            [29.487217, 47.308037],
            [29.490273, 47.321663],
            [29.48999, 47.333603],
            [29.49305, 47.34166],
            [29.496384, 47.344147],
            [29.500832, 47.345543],
            [29.51722, 47.346657],
            [29.554165, 47.344437],
            [29.563885, 47.341103],
            [29.57111, 47.336655],
            [29.57888, 47.328606],
            [29.590549, 47.310265],
            [29.595825, 47.296944],
            [29.600269, 47.279709],
            [29.600552, 47.271935],
            [29.600269, 47.267769],
            [29.573048, 47.144707],
            [29.571381, 47.140831],
            [29.593327, 47.025269],
            [29.59166, 47.021103],
            [29.573887, 46.950272],
            [29.573605, 46.946091],
            [29.575554, 46.943047],
            [29.737492, 46.890266],
            [29.85944, 46.864441],
            [29.868881, 46.861382],
            [29.880276, 46.854996],
            [29.939995, 46.821106],
            [29.947212, 46.816666],
            [29.949997, 46.814156],
            [29.970551, 46.749428],
            [29.972771, 46.734428],
            [29.968884, 46.575272],
            [29.967495, 46.571381],
            [29.962769, 46.564995],
            [29.959435, 46.562485],
            [29.95499, 46.561104],
            [29.921383, 46.55999],
            [29.916386, 46.559151],
            [29.90547, 46.555149],
            [29.896107, 46.551659],
            [29.896107, 46.536942],
            [29.898602, 46.529984],
            [29.906937, 46.522217],
            [29.928608, 46.505272],
            [30.006943, 46.45665],
            [30.035275, 46.443047],
            [30.065826, 46.435265],
            [30.090549, 46.42971],
            [30.102493, 46.429436],
            [30.109158, 46.428596],
            [30.123955, 46.424332],
            [30.133228, 46.416901],
            [30.132214, 46.409714],
            [30.131048, 46.407284],
            [30.128609, 46.402206],
            [30.122215, 46.39193],
            [30.11694, 46.386101],
            [30.103886, 46.381927],
            [30.093052, 46.380547],
            [30.048607, 46.378876],
            [29.996384, 46.378876],
            [29.96666, 46.379715],
            [29.929993, 46.383606],
            [29.920273, 46.381927],
            [29.913052, 46.378876],
            [29.866383, 46.346375],
            [29.825272, 46.368599],
            [29.735825, 46.44249],
            [29.733047, 46.439423],
            [29.662212, 46.379433],
            [29.647774, 46.371094],
            [29.639164, 46.368317],
            [29.626659, 46.369156],
            [29.620831, 46.37027],
            [29.60638, 46.374985],
            [29.597775, 46.378593],
            [29.499718, 46.432213],
            [29.492214, 46.440262],
            [29.491657, 46.444153],
            [29.49416, 46.452492],
            [29.506943, 46.473038],
            [29.508053, 46.477486],
            [29.5075, 46.481102],
            [29.506104, 46.484428],
            [29.503326, 46.487206],
            [29.495544, 46.491096],
            [29.489716, 46.49221],
            [29.478329, 46.491936],
            [29.350826, 46.469986],
            [29.303326, 46.434151],
            [29.305832, 46.427483],
            [29.309158, 46.417206],
            [29.310272, 46.409714],
            [29.309158, 46.405266],
            [29.306664, 46.402206],
            [29.303326, 46.399712],
            [29.238323, 46.368317],
            [29.229713, 46.36554],
            [29.224159, 46.365273],
            [29.212769, 46.367203],
            [29.20499, 46.371094],
            [29.201382, 46.37748],
            [29.200829, 46.381371],
            [29.202496, 46.385262],
            [29.20499, 46.388329],
            [29.210274, 46.39415],
            [29.218052, 46.403046],
            [29.224712, 46.413048],
            [29.226379, 46.416939],
            [29.228329, 46.484711],
            [29.224995, 46.511375],
            [29.223328, 46.522484],
            [29.219437, 46.532761],
            [29.203297, 46.544968],
            [29.173882, 46.539719],
            [29.043053, 46.498047],
            [29.034718, 46.49527],
            [28.994434, 46.478325],
            [28.98333, 46.472481],
            [28.969437, 46.463875],
            [28.935825, 46.435822],
            [28.932217, 46.428322],
            [28.931934, 46.419991],
            [28.949997, 46.289429],
            [29.017494, 46.221375],
            [29.025826, 46.213875],
            [29.038609, 46.201096],
            [29.04055, 46.197762],
            [29.041103, 46.193871],
            [29.040276, 46.189423],
            [28.976662, 46.013054],
            [28.971935, 46.006653],
            [28.968884, 46.004166],
            [28.955547, 46.000542],
            [28.896664, 45.99054],
            [28.829437, 45.978325],
            [28.801105, 45.972481],
            [28.772221, 45.966385],
            [28.759438, 45.961937],
            [28.755833, 45.959984],
            [28.753326, 45.957207],
            [28.749435, 45.950272],
            [28.747494, 45.941093],
            [28.747768, 45.929153],
            [28.751389, 45.922768],
            [28.755276, 45.912491],
            [28.766937, 45.874161],
            [28.768887, 45.866936],
            [28.768604, 45.862762],
            [28.762497, 45.847481],
            [28.688885, 45.784157],
            [28.682774, 45.77916],
            [28.675274, 45.775269],
            [28.671104, 45.773872],
            [28.654995, 45.772484],
            [28.604713, 45.770264],
            [28.594994, 45.768593],
            [28.583607, 45.763054],
            [28.524441, 45.711098],
            [28.490551, 45.668053],
            [28.489433, 45.664986],
            [28.492214, 45.661934],
            [28.514996, 45.65387],
            [28.525555, 45.647484],
            [28.528332, 45.644707],
            [28.530273, 45.64193],
            [28.530552, 45.531662],
            [28.525272, 45.520821],
            [28.522774, 45.517769],
            [28.511944, 45.511932],
            [28.503326, 45.509163],
            [28.488602, 45.506653],
            [28.477489, 45.506386],
            [28.404995, 45.511101],
            [28.394157, 45.512497],
            [28.366383, 45.517769],
            [28.345551, 45.523041],
            [28.316383, 45.527489],
            [28.293884, 45.526649],
            [28.283886, 45.525269],
            [28.274998, 45.523041],
            [28.258053, 45.517212],
            [28.250275, 45.513329],
            [28.243607, 45.508881],
            [28.238049, 45.503319],
            [28.226662, 45.487488],
            [28.216103, 45.465546],
            [28.214718, 45.461372],
            [28.21484, 45.448647],
            [28.211311, 45.450111],
            [28.176941, 45.469437],
            [28.17194, 45.474709],
            [28.06916, 45.583321],
            [28.12888, 45.62027],
            [28.145662, 45.620529],
            [28.154995, 45.623047],
            [28.158604, 45.624985],
            [28.161102, 45.628036],
            [28.162495, 45.631927],
            [28.16666, 45.6661],
            [28.166939, 45.670273],
            [28.164993, 45.71804],
            [28.164436, 45.721657],
            [28.163609, 45.725548],
            [28.120274, 45.921928],
            [28.10722, 45.966103],
            [28.097387, 45.984425],
            [28.094994, 45.988884],
            [28.09277, 45.991653],
            [28.085831, 46.004166],
            [28.084438, 46.011658],
            [28.091385, 46.075829],
            [28.108326, 46.102291],
            [28.115829, 46.124718],
            [28.138882, 46.190536],
            [28.193604, 46.330269],
            [28.245544, 46.42083],
            [28.250111, 46.430672],
            [28.252499, 46.435822],
            [28.247211, 46.604439],
            [28.246958, 46.606525],
            [28.245827, 46.615822],
            [28.233883, 46.666656],
            [28.23315, 46.667683],
            [28.229713, 46.672493],
            [28.217495, 46.682213],
            [28.20388, 46.698601],
            [28.174435, 46.739716],
            [28.116108, 46.833878],
            [28.114716, 46.837212],
            [28.114716, 46.84137],
            [28.117493, 46.849434],
            [28.119717, 46.854404],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "SI",
        ISO2: "SI",
        ISO3: "SVN",
        UN: 705,
        NAME: "Slovenia",
        AREA: 2014,
        POP2005: 1999425,
        REGION: 150,
        SUBREGION: 39,
        LON: 14.827,
        LAT: 46.124,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [13.718655, 46.526611],
            [13.77611, 46.518326],
            [13.845554, 46.519997],
            [13.936943, 46.515831],
            [14.079721, 46.489716],
            [14.084721, 46.488609],
            [14.112499, 46.48111],
            [14.119165, 46.476662],
            [14.12611, 46.467773],
            [14.131666, 46.458328],
            [14.150555, 46.443886],
            [14.154165, 46.44194],
            [14.159443, 46.440826],
            [14.478054, 46.419441],
            [14.544998, 46.407494],
            [14.811666, 46.509995],
            [14.814722, 46.512772],
            [14.824999, 46.541382],
            [14.832499, 46.566666],
            [14.834999, 46.574715],
            [14.864443, 46.610832],
            [14.870554, 46.615829],
            [15.045832, 46.652222],
            [15.064444, 46.651939],
            [15.074408, 46.648571],
            [15.100555, 46.656105],
            [15.105276, 46.657219],
            [15.139444, 46.657219],
            [15.406111, 46.652496],
            [15.602499, 46.686661],
            [15.806665, 46.718605],
            [15.832777, 46.722221],
            [15.849722, 46.723328],
            [15.868332, 46.723053],
            [15.988054, 46.751106],
            [15.987778, 46.759163],
            [15.985554, 46.826942],
            [15.985554, 46.831108],
            [15.988609, 46.833611],
            [15.99361, 46.834717],
            [16.009308, 46.835487],
            [16.111805, 46.86972],
            [16.136387, 46.859993],
            [16.140831, 46.85833],
            [16.145554, 46.85833],
            [16.175831, 46.862495],
            [16.180832, 46.863609],
            [16.191666, 46.86972],
            [16.226944, 46.875832],
            [16.231941, 46.876663],
            [16.269722, 46.874443],
            [16.293331, 46.870827],
            [16.303055, 46.867775],
            [16.346107, 46.846939],
            [16.348888, 46.844444],
            [16.350555, 46.84111],
            [16.350555, 46.836937],
            [16.337219, 46.809166],
            [16.318886, 46.799995],
            [16.315277, 46.797775],
            [16.313889, 46.793884],
            [16.313889, 46.785553],
            [16.324165, 46.757217],
            [16.326385, 46.75444],
            [16.356388, 46.721382],
            [16.359444, 46.718887],
            [16.364998, 46.719162],
            [16.375328, 46.722771],
            [16.385555, 46.70166],
            [16.408607, 46.658882],
            [16.529442, 46.510277],
            [16.532497, 46.507774],
            [16.607872, 46.476234],
            [16.599258, 46.47496],
            [16.584721, 46.473053],
            [16.572498, 46.475273],
            [16.556412, 46.478905],
            [16.517792, 46.491646],
            [16.498055, 46.501389],
            [16.494438, 46.503326],
            [16.495831, 46.5075],
            [16.49361, 46.510551],
            [16.466389, 46.520271],
            [16.461388, 46.52166],
            [16.384163, 46.535828],
            [16.335552, 46.533882],
            [16.292507, 46.530815],
            [16.267498, 46.514442],
            [16.258331, 46.506943],
            [16.251858, 46.498924],
            [16.249443, 46.490273],
            [16.25, 46.486107],
            [16.266109, 46.419441],
            [16.139999, 46.406662],
            [16.13583, 46.405273],
            [16.075924, 46.384331],
            [16.074718, 46.372498],
            [16.074165, 46.363609],
            [16.077499, 46.352776],
            [16.079441, 46.349998],
            [16.083332, 46.33416],
            [16.081108, 46.331108],
            [16.077774, 46.328888],
            [16.01722, 46.29805],
            [15.797777, 46.23333],
            [15.695276, 46.225273],
            [15.676666, 46.226662],
            [15.671389, 46.226387],
            [15.661388, 46.223885],
            [15.654722, 46.219444],
            [15.649166, 46.213882],
            [15.611944, 46.166939],
            [15.60111, 46.146111],
            [15.599722, 46.142494],
            [15.606388, 46.115829],
            [15.629444, 46.086937],
            [15.636389, 46.082222],
            [15.656944, 46.069443],
            [15.661388, 46.067215],
            [15.679165, 46.065826],
            [15.706944, 46.057495],
            [15.711666, 46.055832],
            [15.714722, 46.053604],
            [15.718332, 46.047218],
            [15.719444, 46.038887],
            [15.724443, 45.938606],
            [15.697777, 45.844162],
            [15.694443, 45.841942],
            [15.656666, 45.823326],
            [15.650833, 45.823051],
            [15.646387, 45.823883],
            [15.634722, 45.82972],
            [15.624722, 45.836662],
            [15.620277, 45.842216],
            [15.614721, 45.847496],
            [15.609444, 45.84861],
            [15.602777, 45.84861],
            [15.499443, 45.835831],
            [15.333887, 45.766388],
            [15.322498, 45.761383],
            [15.309166, 45.751938],
            [15.29611, 45.737495],
            [15.291943, 45.73111],
            [15.281666, 45.705826],
            [15.280832, 45.701385],
            [15.283333, 45.694717],
            [15.289721, 45.689163],
            [15.294167, 45.687775],
            [15.302776, 45.690826],
            [15.304998, 45.693886],
            [15.304998, 45.698051],
            [15.304165, 45.706383],
            [15.348331, 45.715553],
            [15.35861, 45.714439],
            [15.365555, 45.709717],
            [15.367498, 45.70694],
            [15.368055, 45.702774],
            [15.352591, 45.651756],
            [15.307089, 45.629868],
            [15.293999, 45.594536],
            [15.302677, 45.54097],
            [15.304165, 45.537773],
            [15.306358, 45.534805],
            [15.277222, 45.462776],
            [15.174458, 45.425819],
            [15.162794, 45.426643],
            [15.150555, 45.431938],
            [15.093504, 45.470261],
            [15.090555, 45.472771],
            [14.979067, 45.500473],
            [14.918644, 45.493149],
            [14.91361, 45.481667],
            [14.91132, 45.4785],
            [14.907776, 45.476662],
            [14.863714, 45.468658],
            [14.831673, 45.465454],
            [14.822975, 45.464767],
            [14.818054, 45.46611],
            [14.72361, 45.531387],
            [14.62611, 45.606941],
            [14.615555, 45.617218],
            [14.609722, 45.626938],
            [14.609444, 45.63916],
            [14.612221, 45.664162],
            [14.611666, 45.669167],
            [14.609722, 45.671944],
            [14.606667, 45.674438],
            [14.601387, 45.675278],
            [14.576944, 45.669441],
            [14.564999, 45.664993],
            [14.562498, 45.661659],
            [14.535, 45.612221],
            [14.501389, 45.551666],
            [14.495832, 45.541664],
            [14.485832, 45.529716],
            [14.419722, 45.494164],
            [14.407221, 45.489166],
            [14.397499, 45.486938],
            [14.387499, 45.485275],
            [14.13722, 45.475273],
            [13.995832, 45.471939],
            [13.989166, 45.462776],
            [13.986666, 45.459999],
            [13.981388, 45.458885],
            [13.952499, 45.456665],
            [13.906944, 45.453331],
            [13.703609, 45.44416],
            [13.678888, 45.445],
            [13.668055, 45.446388],
            [13.647778, 45.451111],
            [13.639444, 45.453888],
            [13.626944, 45.458885],
            [13.607498, 45.468605],
            [13.595276, 45.477776],
            [13.59174, 45.481697],
            [13.589443, 45.516937],
            [13.665833, 45.543053],
            [13.74472, 45.54583],
            [13.749443, 45.546944],
            [13.752222, 45.549721],
            [13.753332, 45.553604],
            [13.716944, 45.596107],
            [13.802221, 45.586388],
            [13.827776, 45.584442],
            [13.850832, 45.585274],
            [13.863609, 45.589165],
            [13.91861, 45.633888],
            [13.919167, 45.637497],
            [13.916943, 45.640274],
            [13.835278, 45.717773],
            [13.796389, 45.750275],
            [13.788887, 45.75444],
            [13.784443, 45.756104],
            [13.697498, 45.784164],
            [13.610554, 45.80555],
            [13.598055, 45.810829],
            [13.595833, 45.813606],
            [13.578888, 45.846382],
            [13.577776, 45.854164],
            [13.589167, 45.885551],
            [13.59111, 45.88916],
            [13.593332, 45.89222],
            [13.611666, 45.902222],
            [13.614443, 45.904716],
            [13.61861, 45.911385],
            [13.633888, 45.943604],
            [13.635555, 45.952217],
            [13.637499, 45.974716],
            [13.636665, 45.985275],
            [13.634998, 45.988609],
            [13.632221, 45.991104],
            [13.626944, 45.992218],
            [13.601944, 45.993607],
            [13.584721, 45.992493],
            [13.580555, 45.991104],
            [13.570833, 45.979164],
            [13.564165, 45.974442],
            [13.560276, 45.972771],
            [13.5425, 45.967499],
            [13.538055, 45.969162],
            [13.516943, 45.981941],
            [13.502777, 45.990555],
            [13.48, 46.011108],
            [13.479443, 46.013329],
            [13.521944, 46.063332],
            [13.538887, 46.079437],
            [13.545555, 46.08416],
            [13.554998, 46.086937],
            [13.560276, 46.087494],
            [13.568609, 46.090553],
            [13.593611, 46.10527],
            [13.645832, 46.142494],
            [13.650555, 46.148605],
            [13.666943, 46.170273],
            [13.669167, 46.173332],
            [13.669167, 46.177498],
            [13.664444, 46.183052],
            [13.657776, 46.187492],
            [13.550554, 46.218048],
            [13.49111, 46.231384],
            [13.485832, 46.232498],
            [13.464998, 46.229439],
            [13.455, 46.217773],
            [13.450832, 46.21611],
            [13.425833, 46.211388],
            [13.420555, 46.211662],
            [13.416111, 46.213333],
            [13.413055, 46.215828],
            [13.383888, 46.293053],
            [13.383055, 46.297218],
            [13.440832, 46.346382],
            [13.511389, 46.38472],
            [13.657776, 46.449715],
            [13.685833, 46.445549],
            [13.689444, 46.447495],
            [13.694721, 46.453331],
            [13.698055, 46.460274],
            [13.711111, 46.492775],
            [13.718887, 46.51416],
            [13.719444, 46.522774],
            [13.718655, 46.526611],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "SP",
        ISO2: "ES",
        ISO3: "ESP",
        UN: 724,
        NAME: "Spain",
        AREA: 49904,
        POP2005: 43397491,
        REGION: 150,
        SUBREGION: 39,
        LON: -3.649,
        LAT: 40.227,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-2.925278, 35.266663000000108],
              [-2.93694, 35.263054],
              [-2.94444, 35.263329000000113],
              [-2.950278, 35.264717],
              [-2.959445, 35.271111],
              [-2.962778, 35.274994],
              [-2.967223, 35.284439],
              [-2.97083, 35.294716],
              [-2.971111, 35.306389],
              [-2.969167, 35.312492],
              [-2.962778, 35.321388000000127],
              [-2.958611, 35.32499700000011],
              [-2.946945, 35.329163],
              [-2.93056, 35.29555],
              [-2.91472, 35.2736],
              [-2.925278, 35.266663000000108],
            ],
          ],
          [
            [
              [-5.31944, 35.876938000000109],
              [-5.345834, 35.841660000000104],
              [-5.35444, 35.847221],
              [-5.375834, 35.869438],
              [-5.37861, 35.873604000000114],
              [-5.386945, 35.88694],
              [-5.39139, 35.896942],
              [-5.395556, 35.909164],
              [-5.395557, 35.916336000000115],
              [-5.37306, 35.9180530000001],
              [-5.36528, 35.9180530000001],
              [-5.357779, 35.916382],
              [-5.345, 35.9125],
              [-5.3225, 35.895828],
              [-5.31944, 35.876938000000109],
            ],
          ],
          [
            [
              [-3.036111, 35.912773],
              [-3.04639, 35.907776],
              [-3.051111, 35.909721000000104],
              [-3.051111, 35.915833],
              [-3.048611, 35.919716],
              [-3.038333, 35.92499],
              [-3.02722, 35.924438],
              [-3.02722, 35.919441],
              [-3.036111, 35.912773],
            ],
          ],
          [
            [
              [-6.925, 37.17083],
              [-6.92139, 37.162216],
              [-6.927501, 37.163605],
              [-6.933333, 37.166939],
              [-6.95417, 37.180275],
              [-6.958889, 37.184441],
              [-6.96972, 37.203606],
              [-6.97306, 37.210274],
              [-6.964723, 37.212219],
              [-6.95833, 37.210548000000131],
              [-6.948611, 37.203331],
              [-6.925, 37.17083],
            ],
          ],
          [
            [
              [1.57778, 38.687775000000101],
              [1.586667, 38.672493],
              [1.588055, 38.66722],
              [1.576111, 38.655548000000124],
              [1.56944, 38.65416],
              [1.556389, 38.65416],
              [1.530555, 38.65416],
              [1.524167, 38.654716],
              [1.518055000000118, 38.656944],
              [1.505278, 38.66944],
              [1.49444, 38.675552],
              [1.463055, 38.685555],
              [1.456666, 38.68694],
              [1.443889, 38.682777000000101],
              [1.390278000000137, 38.64333],
              [1.386389, 38.64777400000014],
              [1.385556, 38.658051000000114],
              [1.383611, 38.68305],
              [1.383055, 38.693886],
              [1.383055, 38.715553],
              [1.383055, 38.720551],
              [1.399167, 38.737778],
              [1.445278, 38.741104000000121],
              [1.573056, 38.691383],
              [1.57778, 38.687775000000101],
            ],
          ],
          [
            [
              [1.531667, 38.951942],
              [1.405833, 38.845551000000114],
              [1.371944, 38.830826],
              [1.36805500000014, 38.851105],
              [1.361666000000127, 38.86055],
              [1.3575, 38.864998000000128],
              [1.35278, 38.868332000000123],
              [1.34639, 38.871109],
              [1.277222, 38.87971],
              [1.270555, 38.878052],
              [1.257500000000107, 38.863609],
              [1.252500000000111, 38.85916],
              [1.24611, 38.86027],
              [1.2225, 38.874161000000129],
              [1.211944, 38.89833],
              [1.227778, 38.948051000000135],
              [1.2425, 38.968048],
              [1.29416700000013, 39.031387000000109],
              [1.303611000000103, 39.038605000000132],
              [1.329167, 39.055275],
              [1.3625, 39.072777],
              [1.472778, 39.10527],
              [1.519722, 39.118332],
              [1.545833, 39.11805],
              [1.600555, 39.096107],
              [1.605278, 39.09166],
              [1.609167, 39.081383],
              [1.615, 39.02833],
              [1.531667, 38.951942],
            ],
          ],
          [
            [
              [3.247777, 39.73472],
              [3.260833, 39.733604],
              [3.275, 39.737778],
              [3.29333, 39.745827],
              [3.32361, 39.759438],
              [3.333333, 39.76611],
              [3.343889, 39.77583],
              [3.382778, 39.773331],
              [3.439722, 39.750275],
              [3.480278, 39.721664],
              [3.479722, 39.711105],
              [3.463611, 39.661385],
              [3.4475, 39.640274],
              [3.3775, 39.552773],
              [3.371666, 39.549164],
              [3.331944, 39.526382000000126],
              [3.320278, 39.520554],
              [3.30555500000014, 39.50222],
              [3.288055, 39.4675],
              [3.266944, 39.412773],
              [3.241944000000103, 39.364441000000113],
              [3.081944000000135, 39.273048],
              [3.063611, 39.263611],
              [3.05694, 39.263054],
              [3.029166, 39.283051],
              [2.98555, 39.318604000000107],
              [2.829722, 39.353333000000134],
              [2.799444, 39.36055],
              [2.78639, 39.36472],
              [2.781389, 39.369164000000126],
              [2.75528, 39.392494],
              [2.745555, 39.406387000000109],
              [2.743055, 39.411659],
              [2.727777, 39.47305],
              [2.741666000000123, 39.490829000000133],
              [2.746388, 39.49472],
              [2.752778, 39.496666],
              [2.754722, 39.502495],
              [2.753611, 39.5075],
              [2.745000000000118, 39.515831],
              [2.73639, 39.523888],
              [2.731667, 39.527496],
              [2.694444, 39.55194],
              [2.675278, 39.559441],
              [2.6625, 39.563606],
              [2.656111, 39.564438000000109],
              [2.546389, 39.524719],
              [2.542500000000132, 39.520271],
              [2.436944, 39.52166],
              [2.38917, 39.524994],
              [2.364166, 39.555832],
              [2.386111000000142, 39.612778],
              [2.538611, 39.700272],
              [2.683888, 39.793884000000105],
              [2.777778, 39.844719],
              [2.987778, 39.91111],
              [3.071389, 39.921944],
              [3.096944, 39.911385],
              [3.091944, 39.901382000000126],
              [3.088889000000108, 39.89138800000012],
              [3.089444, 39.885826],
              [3.124444, 39.812218],
              [3.134722, 39.79222],
              [3.13833, 39.787498],
              [3.151944000000128, 39.77583],
              [3.180833, 39.759995000000117],
              [3.241389, 39.736107],
              [3.247777, 39.73472],
            ],
          ],
          [
            [
              [4.273333, 39.96139],
              [4.315555, 39.878883],
              [4.316944, 39.846107],
              [4.313889, 39.83194],
              [4.299999000000128, 39.814163],
              [4.29528, 39.810555000000136],
              [4.289166000000137, 39.807495],
              [4.276388, 39.806389],
              [4.263055000000122, 39.808884],
              [4.25667, 39.810555000000136],
              [4.238333, 39.81611],
              [4.116388, 39.868332000000123],
              [4.100833000000137, 39.877777],
              [4.09083, 39.88472],
              [4.088333, 39.89055],
              [4.084722000000113, 39.895554],
              [4.079721, 39.89916],
              [4.041111, 39.91555],
              [4.02861, 39.92],
              [3.98472, 39.93027],
              [3.965555, 39.93361],
              [3.938333, 39.932495000000131],
              [3.924166000000127, 39.92916],
              [3.91111, 39.925827],
              [3.891111, 39.92083],
              [3.884722, 39.920273],
              [3.878055000000131, 39.92],
              [3.826666, 39.922493],
              [3.796944, 40.017220000000123],
              [3.83139, 40.052773000000116],
              [3.83611100000013, 40.056389],
              [3.868333, 40.05805],
              [3.9375, 40.058884],
              [4.122499000000118, 40.056107000000111],
              [4.174444, 40.050278000000105],
              [4.241388, 39.993607],
              [4.273333, 39.96139],
            ],
          ],
          [
            [
              [-7.85556, 43.759995],
              [-7.85056, 43.714722000000108],
              [-7.81111, 43.724159],
              [-7.79389, 43.72972],
              [-7.724445, 43.747498],
              [-7.685556, 43.748604],
              [-7.51667, 43.73444],
              [-7.463612, 43.72639],
              [-7.365834, 43.676109],
              [-7.36139, 43.672218],
              [-7.337778, 43.645828000000108],
              [-7.32917, 43.631386000000134],
              [-7.29861, 43.598053000000107],
              [-7.293334, 43.594162],
              [-7.25389, 43.565277],
              [-7.240834, 43.559166000000118],
              [-7.21139, 43.564995000000124],
              [-7.198056, 43.56472],
              [-7.045279, 43.559441000000106],
              [-7.038611, 43.557495],
              [-7.036112, 43.54694],
              [-7.03389, 43.537216000000114],
              [-7.044819, 43.490402],
              [-7.01917, 43.539719000000105],
              [-6.99944, 43.560829],
              [-6.94333, 43.57777],
              [-6.76667, 43.567772],
              [-6.60083, 43.558327000000133],
              [-6.48139, 43.554993000000138],
              [-6.34278, 43.55694],
              [-6.29583, 43.569443],
              [-6.10861, 43.561661000000129],
              [-6.095, 43.561943],
              [-6.07583, 43.565826000000129],
              [-5.94472, 43.593887],
              [-5.88333, 43.62333],
              [-5.854167, 43.648048000000131],
              [-5.778611, 43.617218],
              [-5.758334, 43.594162],
              [-5.748889, 43.586662],
              [-5.733334, 43.576385],
              [-5.69056, 43.548332],
              [-5.67778, 43.543884000000105],
              [-5.670834, 43.54361],
              [-5.64972, 43.544716],
              [-5.64194, 43.545273],
              [-5.61, 43.550278000000105],
              [-5.54889, 43.552216],
              [-5.459723, 43.553886],
              [-5.398056, 43.552498000000128],
              [-5.288611, 43.533882000000119],
              [-5.27111, 43.52499],
              [-5.259167, 43.518326],
              [-5.23444, 43.495552],
              [-5.214445, 43.479721],
              [-5.2075, 43.477776],
              [-5.19417, 43.47805],
              [-5.05639, 43.469994],
              [-4.98, 43.461105],
              [-4.88194, 43.448608],
              [-4.760556, 43.428329],
              [-4.74694, 43.423050000000103],
              [-4.73333, 43.41917],
              [-4.656667, 43.408607],
              [-4.6375, 43.406662],
              [-4.59472, 43.403053],
              [-4.51455, 43.396347000000105],
              [-4.50111, 43.401108],
              [-4.42472, 43.40166],
              [-4.39, 43.397774],
              [-4.31556, 43.390549],
              [-4.273056, 43.390549],
              [-4.22389, 43.396111000000133],
              [-4.212778, 43.397774],
              [-4.12194, 43.416382000000112],
              [-4.05139, 43.442497000000117],
              [-3.944723, 43.46777],
              [-3.81028, 43.492493],
              [-3.79, 43.491386],
              [-3.785, 43.487778],
              [-3.766389, 43.469994],
              [-3.585556, 43.51028],
              [-3.55361, 43.50805],
              [-3.546112, 43.505829],
              [-3.451389, 43.465553],
              [-3.32528, 43.418327],
              [-3.22472, 43.396942000000138],
              [-3.15059, 43.353561],
              [-3.022223, 43.357498],
              [-3.0025, 43.383331],
              [-2.94139, 43.435555],
              [-2.92778, 43.43583],
              [-2.85639, 43.432777],
              [-2.80778, 43.430275],
              [-2.73556, 43.426384],
              [-2.56528, 43.39027],
              [-2.513889, 43.378609],
              [-2.507223, 43.376663],
              [-2.48972, 43.361382],
              [-2.48556, 43.356384],
              [-2.464723, 43.34111],
              [-2.45222, 43.334717],
              [-2.354167, 43.305832],
              [-2.347778, 43.304443],
              [-2.29556, 43.296104000000128],
              [-2.170278, 43.291107],
              [-2.15639, 43.291107],
              [-2.12194, 43.296661],
              [-1.97472, 43.332497],
              [-1.83917, 43.380554],
              [-1.79472, 43.391663],
              [-1.787778, 43.39222],
              [-1.78083, 43.388885],
              [-1.78088, 43.359924],
              [-1.776945, 43.3425],
              [-1.73038, 43.29898100000014],
              [-1.711389, 43.304161000000136],
              [-1.69278, 43.30778],
              [-1.65556, 43.309441],
              [-1.50361, 43.287773],
              [-1.40889, 43.273048000000131],
              [-1.39139, 43.262772],
              [-1.38417, 43.253052000000139],
              [-1.3825, 43.24721],
              [-1.38278, 43.217773],
              [-1.385, 43.20166],
              [-1.41139, 43.136665],
              [-1.42222, 43.123604000000114],
              [-1.429445, 43.116386],
              [-1.45167, 43.10305],
              [-1.45861, 43.10305],
              [-1.46889, 43.095833],
              [-1.4725, 43.09111],
              [-1.47056, 43.085831],
              [-1.45, 43.056664000000126],
              [-1.445833, 43.051666000000125],
              [-1.43444, 43.045555],
              [-1.42778, 43.04361],
              [-1.398056, 43.03805],
              [-1.360278, 43.031662],
              [-1.346667, 43.034721],
              [-1.34306, 43.039162],
              [-1.300278, 43.071663],
              [-1.200556, 43.04583],
              [-1.07278, 43.00639],
              [-0.99361, 42.976105],
              [-0.946389, 42.955826000000116],
              [-0.93417, 42.9525],
              [-0.81861, 42.946106],
              [-0.79056, 42.9525],
              [-0.786945, 42.95694],
              [-0.76694, 42.964722],
              [-0.76, 42.96611],
              [-0.746667, 42.965553],
              [-0.742778, 42.9611],
              [-0.72417, 42.937218],
              [-0.722778, 42.922493000000145],
              [-0.72332, 42.918945],
              [-0.73278, 42.909164],
              [-0.73389, 42.904442000000131],
              [-0.73194, 42.899162],
              [-0.72389, 42.891388],
              [-0.718889, 42.886665000000107],
              [-0.712778, 42.882500000000107],
              [-0.562222, 42.781387],
              [-0.54944, 42.77861],
              [-0.39194, 42.796387],
              [-0.323611, 42.82666],
              [-0.31778, 42.83111],
              [-0.315, 42.835831],
              [-0.308739, 42.848381],
              [-0.30556, 42.844162],
              [-0.300833, 42.839439],
              [-0.2625, 42.817497],
              [-0.20556, 42.794167],
              [-0.18, 42.78444],
              [-0.151944, 42.776657],
              [-0.12361, 42.7575],
              [-0.063056, 42.71583],
              [-0.060833, 42.70916],
              [-0.06194, 42.703331],
              [-0.06194, 42.69778],
              [-0.057222, 42.69416],
              [-0.05056, 42.69194],
              [-0.00556, 42.684998000000121],
              [0.0, 42.68544],
              [0.008333, 42.68693],
              [0.111944000000108, 42.709442],
              [0.14417, 42.722221000000104],
              [0.172222, 42.73333],
              [0.178611, 42.735275],
              [0.186389, 42.7347180000001],
              [0.261944000000142, 42.717499],
              [0.269722000000115, 42.707771],
              [0.2725, 42.702499],
              [0.43278, 42.686661],
              [0.501667000000111, 42.69138],
              [0.509167, 42.69194],
              [0.56, 42.695831000000112],
              [0.59556, 42.695],
              [0.661667, 42.69194],
              [0.675506, 42.688484],
              [0.680000000000121, 42.693329],
              [0.683056, 42.70805],
              [0.683889, 42.713051],
              [0.681389000000138, 42.729439000000127],
              [0.668056, 42.748055000000136],
              [0.655555000000106, 42.754166],
              [0.651944, 42.784996],
              [0.66778, 42.839165],
              [0.692778, 42.853607],
              [0.712222, 42.858604],
              [0.72, 42.859161],
              [0.823611000000142, 42.833054],
              [0.896944, 42.813049],
              [1.085, 42.785271],
              [1.091666, 42.78444],
              [1.121111, 42.768608],
              [1.132222000000127, 42.760826],
              [1.1400000000001, 42.753052],
              [1.1408330000001, 42.741661],
              [1.137778000000139, 42.736938000000123],
              [1.1408330000001, 42.731941],
              [1.144722, 42.727776],
              [1.150833, 42.723610000000122],
              [1.17389, 42.709717],
              [1.321666, 42.714996],
              [1.328333, 42.719994],
              [1.359167000000127, 42.715271],
              [1.390278000000137, 42.688332000000116],
              [1.41722, 42.65083],
              [1.445833000000107, 42.601944],
              [1.43444, 42.576385],
              [1.42139, 42.54583],
              [1.424166, 42.493332],
              [1.448333, 42.45083],
              [1.454722, 42.44167],
              [1.512222000000122, 42.436386],
              [1.53333, 42.436104],
              [1.54167, 42.43722],
              [1.65444, 42.467773],
              [1.661111, 42.471382],
              [1.718889000000104, 42.503052],
              [1.723611, 42.50944],
              [1.78, 42.48832700000014],
              [1.851389, 42.469994],
              [1.906389000000104, 42.446938],
              [1.95917, 42.41083],
              [1.968889, 42.384163000000115],
              [1.976666000000137, 42.374718],
              [1.987778000000105, 42.367775],
              [2.004722000000129, 42.357216],
              [2.017222, 42.35305000000011],
              [2.023889000000111, 42.352219000000105],
              [2.062222, 42.356941],
              [2.093611, 42.364166],
              [2.116944, 42.383331],
              [2.123055000000136, 42.393326000000116],
              [2.124166, 42.39833],
              [2.129167000000109, 42.408051],
              [2.137777, 42.417221],
              [2.151389, 42.421387],
              [2.2625, 42.436661],
              [2.269166, 42.43722],
              [2.280534, 42.434288],
              [2.332222, 42.418053],
              [2.438889, 42.380554000000132],
              [2.442778, 42.376389000000131],
              [2.46972, 42.353333],
              [2.484722, 42.343048000000124],
              [2.525833, 42.333328],
              [2.54194, 42.332497],
              [2.666389, 42.341942000000131],
              [2.674444000000108, 42.357216],
              [2.656944, 42.37944],
              [2.65722, 42.38444],
              [2.678333, 42.401665],
              [2.724722, 42.41944100000012],
              [2.95, 42.48055],
              [3.045278, 42.474716],
              [3.047778000000108, 42.469719000000111],
              [3.049444000000108, 42.459717000000126],
              [3.075833, 42.439438],
              [3.092222, 42.429993000000138],
              [3.106111, 42.429161],
              [3.158333000000141, 42.433327],
              [3.17111100000011, 42.435555],
              [3.177655000000129, 42.436806],
              [3.169167, 42.42610900000011],
              [3.159166000000141, 42.3825],
              [3.159166000000141, 42.378883],
              [3.166111000000114, 42.361938],
              [3.170833, 42.357498],
              [3.189444, 42.344994],
              [3.193889, 42.342216],
              [3.198333, 42.34083],
              [3.2025, 42.342499],
              [3.2025, 42.346107000000131],
              [3.206666, 42.348328],
              [3.218055, 42.349442],
              [3.234167, 42.349716000000114],
              [3.266388, 42.344444],
              [3.279722, 42.339439],
              [3.317222, 42.324997],
              [3.319167, 42.32139],
              [3.317778, 42.317772000000105],
              [3.286666, 42.267776],
              [3.279722, 42.258049],
              [3.266388, 42.243332],
              [3.262777, 42.240829],
              [3.218611, 42.232498],
              [3.208889, 42.234993],
              [3.196666000000107, 42.24139],
              [3.185, 42.251938],
              [3.182222000000138, 42.255829],
              [3.178333, 42.259163],
              [3.164444, 42.263054000000125],
              [3.158611, 42.262497],
              [3.153611, 42.261383],
              [3.142222, 42.253609],
              [3.119722, 42.22888],
              [3.11638900000014, 42.221382],
              [3.11444, 42.214165],
              [3.110833000000127, 42.196663000000115],
              [3.110278, 42.19221],
              [3.11444, 42.151939],
              [3.119722, 42.13694],
              [3.133889, 42.118332],
              [3.14333, 42.115829],
              [3.148056, 42.116661000000136],
              [3.162222, 42.115555],
              [3.166944000000115, 42.114441000000113],
              [3.179444, 42.107216],
              [3.185, 42.1011],
              [3.208889, 42.071938],
              [3.21333, 42.061104],
              [3.220555, 41.94694],
              [3.201666000000102, 41.892776],
              [3.175278, 41.867493],
              [3.123611, 41.84861],
              [3.011944, 41.773048],
              [2.946389, 41.724716],
              [2.939444, 41.719994],
              [2.931944000000101, 41.71583],
              [2.7175, 41.627495000000124],
              [2.676666, 41.612778000000105],
              [2.605833, 41.590828000000101],
              [2.557777000000101, 41.577217000000132],
              [2.53778, 41.57027],
              [2.273056, 41.463333],
              [2.261111, 41.456383],
              [2.253889, 41.449997],
              [2.248888, 41.444717],
              [2.24278, 41.437492000000134],
              [2.16472, 41.342499],
              [2.153055, 41.315277],
              [2.149444, 41.308609000000104],
              [2.123888000000136, 41.29277],
              [2.11083, 41.285828],
              [2.07833, 41.275276000000133],
              [2.054166, 41.26861],
              [2.016944000000137, 41.263054000000125],
              [2.0075, 41.263054000000125],
              [1.998055, 41.263329],
              [1.89, 41.251106000000107],
              [1.76167, 41.218605],
              [1.701389, 41.205551000000128],
              [1.675833000000125, 41.20166],
              [1.651389, 41.199165],
              [1.616389, 41.195831],
              [1.531944, 41.184998],
              [1.498333, 41.178604],
              [1.3225, 41.12944],
              [1.205, 41.101387],
              [1.039444, 41.062492000000134],
              [0.993055, 41.04805],
              [0.964444, 41.032776],
              [0.94333, 41.016663],
              [0.936389, 41.0075],
              [0.92472, 40.991104],
              [0.905555, 40.984993],
              [0.893333, 40.975555],
              [0.704167, 40.813049],
              [0.70028, 40.80555],
              [0.699444, 40.801941],
              [0.698889, 40.798332],
              [0.7, 40.794716],
              [0.713055, 40.783333],
              [0.723055, 40.775833],
              [0.73805, 40.766388],
              [0.838611000000128, 40.73027],
              [0.8575, 40.728607],
              [0.867222, 40.731384],
              [0.873333000000116, 40.7336],
              [0.88861, 40.73055],
              [0.895, 40.728333000000134],
              [0.9, 40.724442],
              [0.902778000000126, 40.719719],
              [0.885278, 40.702774],
              [0.864167, 40.684441],
              [0.85167, 40.67610900000011],
              [0.689722, 40.571663],
              [0.671111, 40.564163],
              [0.6575, 40.561386],
              [0.64333, 40.560272],
              [0.629444, 40.563332],
              [0.623055, 40.565552],
              [0.60722, 40.575829],
              [0.60805, 40.580551000000128],
              [0.615, 40.593605],
              [0.621667, 40.59166],
              [0.6275, 40.588882],
              [0.634444, 40.589439],
              [0.709167, 40.59583],
              [0.73805, 40.639717],
              [0.73139, 40.64027],
              [0.696667, 40.63749700000011],
              [0.616667, 40.626389],
              [0.603611000000114, 40.623604],
              [0.58917, 40.61278],
              [0.541944, 40.56916],
              [0.51917, 40.533882],
              [0.518939000000103, 40.52874],
              [0.458333, 40.44722],
              [0.358333, 40.30305],
              [0.354444, 40.298607],
              [0.280556, 40.23666],
              [0.213056, 40.183601000000124],
              [0.048889, 40.036102],
              [0.04611100000011, 40.03138],
              [0.032778, 40.007767000000115],
              [-0.03722, 39.893326],
              [-0.08444, 39.85139],
              [-0.10722, 39.82861],
              [-0.115833, 39.818604],
              [-0.179167, 39.736107],
              [-0.31472, 39.519722000000115],
              [-0.32056, 39.509995],
              [-0.326111, 39.49472],
              [-0.337222, 39.440552],
              [-0.338056, 39.435555000000136],
              [-0.24111, 39.14388300000013],
              [-0.195, 39.053604],
              [-0.1825, 39.02916],
              [-0.14333, 38.978333000000134],
              [-0.09222, 38.929718],
              [-0.07, 38.908882],
              [-0.06, 38.901108],
              [-0.04917, 38.894165],
              [-0.033063, 38.884254],
              [0.008889, 38.862213000000111],
              [0.029167, 38.857208],
              [0.048611, 38.858879000000115],
              [0.055, 38.861099000000138],
              [0.061389000000133, 38.861656],
              [0.06778, 38.860268],
              [0.086389, 38.854988],
              [0.14777800000013, 38.828323],
              [0.195556, 38.805824],
              [0.201389, 38.801659],
              [0.215278, 38.758041000000105],
              [0.207222, 38.73221],
              [0.164167, 38.697487],
              [0.14417, 38.684708],
              [0.041667, 38.638046],
              [-0.006667, 38.62861],
              [-0.0175, 38.622498],
              [-0.05028, 38.595551],
              [-0.055278, 38.59111],
              [-0.138611, 38.53805],
              [-0.15167, 38.53583],
              [-0.288611, 38.486382],
              [-0.30056, 38.481667],
              [-0.31722, 38.473053],
              [-0.322778, 38.46999],
              [-0.37194, 38.441666],
              [-0.38667, 38.430832],
              [-0.51167, 38.324997],
              [-0.600278, 38.185272],
              [-0.656667, 38.046944],
              [-0.749167, 37.89222],
              [-0.75194, 37.887215],
              [-0.75944, 37.861938000000123],
              [-0.760556, 37.856941],
              [-0.76102, 37.845955],
              [-0.80139, 37.801384],
              [-0.84194, 37.748886],
              [-0.858333, 37.72166],
              [-0.86, 37.71666],
              [-0.8575, 37.711937],
              [-0.81417, 37.664719000000105],
              [-0.804722, 37.657219],
              [-0.786945, 37.64777400000014],
              [-0.74083, 37.630272000000105],
              [-0.73472, 37.62944],
              [-0.721944, 37.635826000000122],
              [-0.71833, 37.640549],
              [-0.71833, 37.645554000000118],
              [-0.710278, 37.643883],
              [-0.69667, 37.6325],
              [-0.70833, 37.616386],
              [-0.715556, 37.606941],
              [-0.73139, 37.5975],
              [-0.744167, 37.593887],
              [-0.915, 37.552216],
              [-0.92167, 37.551384],
              [-0.9525, 37.555832],
              [-0.976111, 37.572777],
              [-0.97972, 37.576942],
              [-1.048333, 37.579163000000108],
              [-1.23861, 37.575272],
              [-1.3275, 37.558052],
              [-1.350833, 37.549438],
              [-1.44278, 37.494438],
              [-1.45389, 37.48749],
              [-1.46278, 37.479164],
              [-1.471945, 37.465553000000114],
              [-1.48389, 37.44111],
              [-1.48556, 37.436104000000114],
              [-1.50944, 37.421944],
              [-1.56778, 37.399719],
              [-1.633415, 37.376862],
              [-1.64361, 37.372772],
              [-1.678889, 37.349442000000124],
              [-1.68917, 37.3425],
              [-1.791111, 37.232216],
              [-1.79806, 37.22277],
              [-1.80917, 37.202499000000103],
              [-1.81167, 37.196388],
              [-1.81611, 37.181389000000138],
              [-1.82361, 37.150833],
              [-1.825556, 37.130554],
              [-1.82778, 37.11944],
              [-1.846667, 37.081940000000145],
              [-1.902222, 36.972221],
              [-1.928889, 36.93972],
              [-1.93528, 36.938889],
              [-1.98639, 36.895828],
              [-1.998889, 36.88416],
              [-2.058333, 36.810555],
              [-2.059167, 36.80555],
              [-2.05889, 36.789719],
              [-2.06, 36.779442],
              [-2.06361, 36.774994],
              [-2.116667, 36.73555],
              [-2.129167, 36.731384],
              [-2.1875, 36.716385],
              [-2.19667, 36.72444],
              [-2.217223, 36.745552],
              [-2.23111, 36.764442],
              [-2.281389, 36.820000000000107],
              [-2.28667, 36.823608],
              [-2.29861, 36.829437],
              [-2.34389, 36.840271],
              [-2.350278, 36.84083],
              [-2.481945, 36.829994000000113],
              [-2.55528, 36.81472],
              [-2.56056, 36.811386],
              [-2.578333, 36.79305],
              [-2.590278, 36.779999],
              [-2.59556, 36.769722000000115],
              [-2.59722, 36.764717],
              [-2.60056, 36.752777],
              [-2.6, 36.747215],
              [-2.60556, 36.736938],
              [-2.616667, 36.722221],
              [-2.63944, 36.701111],
              [-2.650278, 36.69444],
              [-2.6925, 36.685272],
              [-2.7225, 36.681664],
              [-2.768889, 36.678329],
              [-2.859445, 36.69527],
              [-2.87417, 36.705276],
              [-2.878889, 36.710274],
              [-2.881389, 36.715553],
              [-2.888056, 36.724716],
              [-2.89611, 36.733604],
              [-2.91806, 36.744995],
              [-2.928889, 36.749718],
              [-3.125, 36.750275000000101],
              [-3.230834, 36.748055],
              [-3.25917, 36.746941000000106],
              [-3.3275, 36.739716],
              [-3.34639, 36.734718],
              [-3.35556, 36.726944],
              [-3.36, 36.721939],
              [-3.36056, 36.716942],
              [-3.36361, 36.712219000000118],
              [-3.418334, 36.69444],
              [-3.43278, 36.692772],
              [-3.452778, 36.691666],
              [-3.467223, 36.69221],
              [-3.47972, 36.69444],
              [-3.486667, 36.696663000000115],
              [-3.529445, 36.715828000000101],
              [-3.59528, 36.746941000000106],
              [-3.607778, 36.745827000000133],
              [-3.63972, 36.740555],
              [-3.66944, 36.733604],
              [-3.67556, 36.730553],
              [-3.69444, 36.728333],
              [-3.72556, 36.72861],
              [-3.78556, 36.742493000000138],
              [-3.81639, 36.75],
              [-3.84889, 36.752495000000124],
              [-4.024723, 36.741386],
              [-4.17049, 36.719864],
              [-4.23972, 36.713333],
              [-4.32167, 36.710548],
              [-4.327778, 36.710548],
              [-4.35972, 36.7175],
              [-4.39167, 36.723053],
              [-4.398334, 36.722221],
              [-4.40472, 36.720276],
              [-4.43417, 36.69944],
              [-4.43694, 36.694717],
              [-4.46194, 36.65583],
              [-4.485278, 36.62221],
              [-4.495001, 36.60833],
              [-4.633056, 36.510551],
              [-4.646389, 36.506104],
              [-4.70833, 36.488609],
              [-4.714723, 36.487778],
              [-4.754168, 36.485832],
              [-4.76139, 36.48555],
              [-4.781667, 36.487221],
              [-4.794168, 36.490273],
              [-4.81361, 36.496384],
              [-4.832223, 36.498886],
              [-4.852501, 36.500832],
              [-4.87806, 36.500832],
              [-4.91389, 36.498886],
              [-4.940001, 36.491661],
              [-5.07361, 36.448883],
              [-5.086667, 36.44416],
              [-5.16528, 36.415276],
              [-5.171945, 36.412773],
              [-5.176667, 36.409721],
              [-5.219167, 36.370552],
              [-5.311389, 36.233604],
              [-5.31361, 36.228607],
              [-5.326112, 36.19749],
              [-5.33333, 36.17194400000011],
              [-5.334508, 36.16256],
              [-5.355799, 36.163307],
              [-5.38139, 36.178329],
              [-5.395278, 36.179443000000106],
              [-5.41611, 36.17889],
              [-5.4225, 36.177773000000116],
              [-5.431667, 36.169167],
              [-5.44528, 36.143883],
              [-5.44389, 36.133606],
              [-5.431667, 36.083885000000123],
              [-5.42194, 36.075829],
              [-5.42528, 36.070831],
              [-5.44889, 36.05222],
              [-5.61361, 36.006104],
              [-5.79722, 36.073883],
              [-5.807222, 36.08055],
              [-5.81111, 36.085],
              [-5.822223, 36.098328],
              [-5.82917, 36.107773],
              [-5.83639, 36.116386],
              [-5.84028, 36.12083],
              [-5.854167, 36.134995],
              [-5.87944, 36.16055],
              [-5.88417, 36.16416],
              [-5.91139, 36.179161],
              [-5.91833, 36.181107000000111],
              [-6.025556, 36.184441000000106],
              [-6.03267, 36.181156],
              [-6.0375, 36.180275],
              [-6.050834, 36.19194],
              [-6.158334, 36.305275],
              [-6.22694, 36.404716000000121],
              [-6.26139, 36.469994],
              [-6.26306, 36.481667],
              [-6.24972, 36.46833],
              [-6.239722, 36.461937],
              [-6.233334, 36.461388000000113],
              [-6.22611, 36.463608000000136],
              [-6.22, 36.466942000000131],
              [-6.21528, 36.470833],
              [-6.172778, 36.512215],
              [-6.17667, 36.516663],
              [-6.230834, 36.574997],
              [-6.238056, 36.58138300000013],
              [-6.2975, 36.613884],
              [-6.33722, 36.620552],
              [-6.361945, 36.61639],
              [-6.36833, 36.616943],
              [-6.38667, 36.623886],
              [-6.3925, 36.626389],
              [-6.40083, 36.634163],
              [-6.427501, 36.68278],
              [-6.432501, 36.69221],
              [-6.435, 36.69722],
              [-6.44361, 36.718887],
              [-6.441668, 36.739441],
              [-6.437222, 36.743607000000111],
              [-6.35556, 36.860832],
              [-6.578889, 37.01944],
              [-6.725834, 37.091942],
              [-6.904723, 37.16555],
              [-6.95992, 37.221836],
              [-6.978722, 37.212608],
              [-6.97223, 37.17775],
              [-6.99684, 37.19107],
              [-7.053334, 37.213051],
              [-7.080278, 37.217499],
              [-7.12722, 37.220551],
              [-7.17333, 37.217216],
              [-7.258612, 37.208054],
              [-7.28472, 37.204994000000113],
              [-7.32556, 37.197220000000129],
              [-7.34056, 37.188889],
              [-7.339445, 37.183609],
              [-7.344445, 37.179718],
              [-7.35639, 37.175827],
              [-7.384167, 37.169716000000108],
              [-7.39861, 37.180832],
              [-7.40944, 37.201660000000118],
              [-7.43185, 37.253189],
              [-7.43472, 37.366943],
              [-7.44722, 37.41861],
              [-7.46139, 37.457222],
              [-7.47139, 37.481384000000105],
              [-7.48472, 37.498886],
              [-7.503056, 37.522499],
              [-7.512534, 37.528549],
              [-7.524445, 37.552498],
              [-7.446945, 37.69944],
              [-7.42306, 37.743889000000138],
              [-7.394723, 37.764999000000103],
              [-7.379168, 37.77444],
              [-7.320001, 37.815277],
              [-7.285, 37.860275],
              [-7.27833, 37.87083],
              [-7.25361, 37.928329000000133],
              [-7.25194, 37.933609],
              [-7.25194, 37.959442000000138],
              [-7.25472, 37.974716],
              [-7.259445, 37.98166700000013],
              [-7.25444, 37.987495],
              [-7.24556, 37.990829],
              [-7.21083, 37.996941],
              [-7.12361, 38.009995000000117],
              [-7.006667, 38.028053000000114],
              [-7.00139, 38.034164],
              [-6.95167, 38.14],
              [-6.94389, 38.162773],
              [-6.939167, 38.17805],
              [-6.93375, 38.209068],
              [-6.94056, 38.217773000000136],
              [-6.947779, 38.21833],
              [-6.96139, 38.21583],
              [-6.993334, 38.209442],
              [-7.01028, 38.200554],
              [-7.01167, 38.195549],
              [-7.01694, 38.191666000000112],
              [-7.02833, 38.187492],
              [-7.081112, 38.17472],
              [-7.08778, 38.174438],
              [-7.10111, 38.184166],
              [-7.10222, 38.189163000000121],
              [-7.13, 38.22583],
              [-7.145, 38.246109],
              [-7.16972, 38.284439],
              [-7.192223, 38.320274],
              [-7.274445, 38.41666],
              [-7.280834, 38.4222180000001],
              [-7.28889, 38.426941000000113],
              [-7.304167, 38.435829],
              [-7.313056, 38.439995],
              [-7.32111, 38.44944],
              [-7.267222, 38.703331],
              [-7.265556, 38.708328],
              [-7.260279, 38.723053000000107],
              [-7.257223, 38.728333],
              [-7.24556, 38.73389],
              [-7.207355, 38.749268],
              [-7.16417, 38.781944],
              [-7.08417, 38.835548],
              [-7.06, 38.86055],
              [-6.956944, 39.019997],
              [-6.95479, 39.026382],
              [-6.961112, 39.056664],
              [-6.98278, 39.09138],
              [-7.005, 39.107216000000108],
              [-7.02139, 39.11639],
              [-7.040278, 39.122772000000111],
              [-7.05056, 39.124161],
              [-7.05667, 39.11805],
              [-7.065556, 39.114716],
              [-7.10278, 39.104721],
              [-7.115834, 39.104164],
              [-7.13389, 39.108604],
              [-7.1425, 39.111107],
              [-7.149167, 39.116661],
              [-7.24278, 39.213051],
              [-7.31361, 39.344719000000111],
              [-7.32278, 39.388329],
              [-7.371389, 39.491386],
              [-7.38, 39.496109],
              [-7.499722, 39.599716000000114],
              [-7.505834, 39.605827],
              [-7.523056, 39.633331],
              [-7.526945, 39.64],
              [-7.5325, 39.669418],
              [-7.41472, 39.649162],
              [-7.4075, 39.64833],
              [-7.3375, 39.643883],
              [-7.33083, 39.644722],
              [-7.32556, 39.648605],
              [-7.307222, 39.656662],
              [-7.266945, 39.67194400000011],
              [-7.260279, 39.672218],
              [-7.205556, 39.66722],
              [-7.166112, 39.661942000000124],
              [-7.1525, 39.658882],
              [-7.146111, 39.658607],
              [-7.05763, 39.662254],
              [-7.04812, 39.665253],
              [-7.01722, 39.674995000000138],
              [-6.989722, 39.724716],
              [-6.87083, 40.01028],
              [-6.87056, 40.021660000000111],
              [-6.8825, 40.044167],
              [-6.928889, 40.101662],
              [-6.93472, 40.1075],
              [-6.9425, 40.112778],
              [-6.95056, 40.11666],
              [-6.96, 40.115829],
              [-6.97806, 40.117775],
              [-6.98722, 40.120552],
              [-7.004723, 40.126106],
              [-7.013056, 40.139442],
              [-7.02722, 40.18777],
              [-7.01083, 40.222771],
              [-7.005834, 40.23083],
              [-6.946526, 40.25898],
              [-6.91028, 40.256386],
              [-6.88278, 40.260277],
              [-6.873889, 40.263329],
              [-6.862303, 40.271523000000116],
              [-6.83111, 40.317215],
              [-6.815556, 40.38777],
              [-6.79611, 40.52444],
              [-6.81944, 40.73333],
              [-6.801667, 40.848885],
              [-6.79972, 40.856110000000115],
              [-6.803889, 40.874161],
              [-6.85722, 40.947495000000117],
              [-6.865556, 40.956383],
              [-6.87167, 40.95916],
              [-6.891389, 40.974716000000114],
              [-6.92944, 41.013054],
              [-6.931667, 41.018051000000128],
              [-6.92441, 41.03096],
              [-6.848333, 41.028610000000128],
              [-6.835, 41.031662],
              [-6.805556, 41.045555],
              [-6.780278, 41.063606000000107],
              [-6.768612, 41.07777],
              [-6.75444, 41.102493],
              [-6.75417, 41.112495],
              [-6.75333, 41.136665],
              [-6.690556, 41.208054],
              [-6.686389, 41.212494000000106],
              [-6.64389, 41.24472],
              [-6.618056, 41.246384],
              [-6.59833, 41.244164],
              [-6.58, 41.239716],
              [-6.558333, 41.242218],
              [-6.51028, 41.265],
              [-6.438056, 41.318886],
              [-6.357779, 41.380554000000132],
              [-6.29583, 41.436104],
              [-6.217501, 41.529442000000131],
              [-6.210556, 41.538887],
              [-6.203611, 41.548332],
              [-6.191389, 41.569717],
              [-6.18875, 41.576057000000105],
              [-6.18722, 41.579720000000123],
              [-6.19444, 41.593048000000124],
              [-6.25222, 41.637772],
              [-6.26, 41.643051],
              [-6.303612, 41.66333],
              [-6.34722, 41.67222],
              [-6.42472, 41.679718],
              [-6.434167, 41.680275],
              [-6.452778, 41.67472],
              [-6.469167, 41.666664],
              [-6.4975, 41.65749],
              [-6.50611, 41.661385],
              [-6.539445, 41.679443],
              [-6.55139, 41.691109],
              [-6.55222, 41.698051000000135],
              [-6.547501, 41.764999],
              [-6.52806, 41.839439],
              [-6.548612, 41.921944],
              [-6.594167, 41.95361],
              [-6.6025, 41.94888],
              [-6.618334, 41.940552],
              [-6.6875, 41.936661],
              [-6.696945, 41.936661],
              [-6.71694, 41.936661],
              [-6.90611, 41.944717],
              [-6.93611, 41.94944],
              [-6.94472, 41.952774],
              [-6.982848, 41.973862],
              [-7.003056, 41.9566650000001],
              [-7.01444, 41.952499],
              [-7.05611, 41.95111],
              [-7.063056, 41.951385],
              [-7.0775, 41.957497],
              [-7.08167, 41.961388000000113],
              [-7.081112, 41.966385],
              [-7.092501, 41.98027],
              [-7.10528, 41.986938],
              [-7.125556, 41.99305],
              [-7.13361, 41.994995],
              [-7.14, 41.994164],
              [-7.18278, 41.979439],
              [-7.187222, 41.975273],
              [-7.183056, 41.93777],
              [-7.17472, 41.928055],
              [-7.17361, 41.922775],
              [-7.18694, 41.898331],
              [-7.200556, 41.88361],
              [-7.207348, 41.883835],
              [-7.26833, 41.863609],
              [-7.331112, 41.84499],
              [-7.41056, 41.823326],
              [-7.426667, 41.82222],
              [-7.607779, 41.83111],
              [-7.611945, 41.834999],
              [-7.609167, 41.845551],
              [-7.59806, 41.865273],
              [-7.686389, 41.903053],
              [-7.6925, 41.904999],
              [-7.70583, 41.904442],
              [-7.759445, 41.8975],
              [-7.84917, 41.864441],
              [-7.866945, 41.85555],
              [-7.873334, 41.85249],
              [-7.88, 41.852776000000119],
              [-7.921112, 41.880829],
              [-7.93222, 41.874718000000144],
              [-8.035278, 41.827217],
              [-8.055065, 41.81952],
              [-8.067501, 41.815277],
              [-8.08778, 41.809441000000106],
              [-8.13167, 41.809166000000118],
              [-8.140556, 41.809166000000118],
              [-8.163807, 41.817184],
              [-8.16167, 41.8275],
              [-8.16, 41.842773],
              [-8.16111, 41.857498],
              [-8.16528, 41.86305],
              [-8.175556, 41.871109],
              [-8.181114, 41.872498000000121],
              [-8.187778, 41.873886],
              [-8.201117, 41.872498000000121],
              [-8.20472, 41.874718000000144],
              [-8.217779, 41.903885],
              [-8.219168, 41.90861],
              [-8.218613, 41.9136],
              [-8.212778, 41.92388],
              [-8.20472, 41.933609000000104],
              [-8.16528, 41.974442],
              [-8.134724, 41.99889],
              [-8.10889, 42.008606],
              [-8.09556, 42.013329],
              [-8.08944, 42.01639],
              [-8.085, 42.020271],
              [-8.0825, 42.025276000000133],
              [-8.08167, 42.03],
              [-8.079723, 42.054161],
              [-8.085556, 42.06472],
              [-8.09, 42.068886000000134],
              [-8.19444, 42.1486],
              [-8.201223, 42.15274],
              [-8.25194, 42.13861],
              [-8.31056, 42.103607],
              [-8.44611, 42.084717000000126],
              [-8.47361, 42.084717000000126],
              [-8.51472, 42.083328000000108],
              [-8.521389, 42.082771],
              [-8.606945, 42.059166],
              [-8.62083, 42.053604000000121],
              [-8.64, 42.045273],
              [-8.73861, 41.971382000000119],
              [-8.743057, 41.96666],
              [-8.74445, 41.961937],
              [-8.74501, 41.952499],
              [-8.757223, 41.940552],
              [-8.77278, 41.929443],
              [-8.78389, 41.922775],
              [-8.816443, 41.920189000000107],
              [-8.84804, 41.899582],
              [-8.86528, 41.87555],
              [-8.871946, 41.875832000000116],
              [-8.881668, 41.883331000000112],
              [-8.88833, 41.933609000000104],
              [-8.898613, 42.108055],
              [-8.89639, 42.11305],
              [-8.810835, 42.186943],
              [-8.77389, 42.213108],
              [-8.75889, 42.219440000000134],
              [-8.722778, 42.240273000000116],
              [-8.64417, 42.28833],
              [-8.58, 42.346382000000119],
              [-8.57972, 42.351662],
              [-8.6, 42.353607],
              [-8.61972, 42.349998],
              [-8.632223, 42.340553000000114],
              [-8.653057, 42.319717],
              [-8.656389, 42.314995],
              [-8.65806, 42.30971],
              [-8.65, 42.301384],
              [-8.649723, 42.29583],
              [-8.65472, 42.292221],
              [-8.683613, 42.279716000000121],
              [-8.76083, 42.259163],
              [-8.79411, 42.253384],
              [-8.85722, 42.247772000000111],
              [-8.86389, 42.248055],
              [-8.869167, 42.251389],
              [-8.85278, 42.2961],
              [-8.821945, 42.328331],
              [-8.793612, 42.337776],
              [-8.69222, 42.400833],
              [-8.67195, 42.414444],
              [-8.65611, 42.427773000000116],
              [-8.689167, 42.439438],
              [-8.70306, 42.435829],
              [-8.742224, 42.416664],
              [-8.751667, 42.408607],
              [-8.775167, 42.399994000000106],
              [-8.777168, 42.39716],
              [-8.784667, 42.395332],
              [-8.84083, 42.391388],
              [-8.879168, 42.41944100000012],
              [-8.88194, 42.423882],
              [-8.908335, 42.467499],
              [-8.90389, 42.48277],
              [-8.89139, 42.496666],
              [-8.88611, 42.50027],
              [-8.871668, 42.500832000000116],
              [-8.86444, 42.499718],
              [-8.85889, 42.49638],
              [-8.85639, 42.491661000000136],
              [-8.855001, 42.486664],
              [-8.856668, 42.478882000000112],
              [-8.85806, 42.473885],
              [-8.864723, 42.471382],
              [-8.870001, 42.46833],
              [-8.872501, 42.46333],
              [-8.86945, 42.453606],
              [-8.862501, 42.45388800000012],
              [-8.836113, 42.46194],
              [-8.81444, 42.491661000000136],
              [-8.80972, 42.519440000000145],
              [-8.825556, 42.535828],
              [-8.833612, 42.550278],
              [-8.83417, 42.555275],
              [-8.827778, 42.574715],
              [-8.8225, 42.578331000000105],
              [-8.81583, 42.576942],
              [-8.81056, 42.573883000000137],
              [-8.80444, 42.576111],
              [-8.77889, 42.596107],
              [-8.74695, 42.638054000000125],
              [-8.71972, 42.675278],
              [-8.719446, 42.695831000000112],
              [-8.72155, 42.7011490000001],
              [-8.85139, 42.66111],
              [-8.91833, 42.628326],
              [-8.92333, 42.625275000000101],
              [-8.935, 42.61055],
              [-8.93639, 42.604721],
              [-8.93528, 42.599998000000141],
              [-8.943056, 42.586105],
              [-8.99556, 42.532494],
              [-9.016945, 42.52138],
              [-9.02333, 42.521111],
              [-9.03583, 42.525276],
              [-9.04139, 42.528885],
              [-9.06139, 42.57944],
              [-9.056667, 42.609993],
              [-9.03472, 42.67083],
              [-9.024723, 42.69444],
              [-9.020279, 42.70472],
              [-9.00639, 42.720833],
              [-8.92, 42.784721],
              [-8.911667, 42.79333],
              [-9.00861, 42.776382],
              [-9.08667, 42.740273],
              [-9.10583, 42.75249],
              [-9.123335, 42.768883],
              [-9.140278, 42.794998],
              [-9.13593, 42.799164000000133],
              [-9.12667, 42.802498000000128],
              [-9.12444, 42.839996],
              [-9.14389, 42.893326],
              [-9.16278, 42.925827],
              [-9.185001, 42.9525],
              [-9.19139, 42.94999700000011],
              [-9.257223, 42.915833],
              [-9.270557, 42.911659],
              [-9.293335, 42.922493000000145],
              [-9.259167, 43.04722],
              [-9.209446, 43.152771],
              [-9.206945, 43.15749],
              [-9.16972, 43.185829],
              [-9.145279, 43.193054],
              [-9.13194, 43.196663],
              [-9.125557, 43.197495],
              [-9.089445, 43.190552],
              [-9.03528, 43.20388800000012],
              [-8.952223, 43.23055],
              [-8.935835, 43.239441],
              [-8.979168, 43.270828000000108],
              [-8.981668, 43.27611],
              [-8.980278, 43.28139],
              [-8.96889, 43.286110000000122],
              [-8.95028, 43.29361],
              [-8.87639, 43.319717],
              [-8.824446, 43.327217000000132],
              [-8.78278, 43.303055],
              [-8.72417, 43.291107],
              [-8.70139, 43.287216],
              [-8.68944, 43.292221],
              [-8.6575, 43.303329],
              [-8.40556, 43.38472],
              [-8.329723, 43.403885000000116],
              [-8.265556, 43.55277],
              [-8.006668, 43.703888],
              [-7.898056, 43.76416],
              [-7.865834, 43.772217],
              [-7.85611, 43.765],
              [-7.85556, 43.759995],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "SW",
        ISO2: "SE",
        ISO3: "SWE",
        UN: 752,
        NAME: "Sweden",
        AREA: 41033,
        POP2005: 9038049,
        REGION: 150,
        SUBREGION: 154,
        LON: 15.27,
        LAT: 62.011,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [16.83667, 56.826942],
              [16.82805, 56.82527],
              [16.816944, 56.825829],
              [16.808331000000123, 56.824165],
              [16.785, 56.809998],
              [16.779442, 56.80583],
              [16.77027500000014, 56.79583],
              [16.726665000000139, 56.702217],
              [16.63555, 56.51888300000013],
              [16.576664, 56.406944],
              [16.570553000000132, 56.394440000000145],
              [16.56944, 56.388054],
              [16.57027, 56.376938000000109],
              [16.571941, 56.371666],
              [16.575275, 56.367218],
              [16.575554, 56.361382],
              [16.57166, 56.354996],
              [16.553055, 56.32638500000013],
              [16.49611, 56.240829000000133],
              [16.486385, 56.231384000000105],
              [16.47361, 56.224442],
              [16.43722, 56.211388000000113],
              [16.429722, 56.208885000000123],
              [16.420830000000137, 56.2111],
              [16.416111000000114, 56.215271],
              [16.410831, 56.225],
              [16.403332, 56.274162],
              [16.3916660000001, 56.465],
              [16.393330000000105, 56.529160000000104],
              [16.39583, 56.535828],
              [16.420277, 56.586388000000113],
              [16.5425, 56.776382],
              [16.611942, 56.868332],
              [16.616665, 56.873604],
              [16.629166, 56.879166],
              [16.645, 56.88361],
              [16.749443, 56.93972],
              [16.848053000000107, 57.064163],
              [16.9, 57.134995000000117],
              [16.959442, 57.22361],
              [16.963055, 57.229439],
              [16.965553000000114, 57.241661],
              [16.960278, 57.256943],
              [16.959164, 57.274162],
              [16.960552, 57.280273],
              [16.96611, 57.29361],
              [16.973331, 57.305275],
              [16.982777, 57.315552000000139],
              [16.99305, 57.32471],
              [17.00999800000011, 57.337494],
              [17.02222, 57.344994],
              [17.035553000000107, 57.351944000000117],
              [17.05666, 57.359161],
              [17.09861, 57.350555],
              [17.10555, 57.348328],
              [17.124165, 57.320831000000112],
              [17.05055, 57.186661],
              [17.008888, 57.131943],
              [16.961109000000135, 57.075272],
              [16.926666, 57.038055],
              [16.88028, 56.929718],
              [16.848331, 56.843887],
              [16.841110000000128, 56.832222],
              [16.83667, 56.826942],
            ],
          ],
          [
            [
              [18.20611, 56.911942],
              [18.168888, 56.909996],
              [18.147778, 56.911942],
              [18.140274, 56.914993],
              [18.142498, 56.920273],
              [18.15833, 56.941666000000112],
              [18.209164, 56.989166],
              [18.256664, 57.032219],
              [18.254444, 57.079163],
              [18.173332, 57.141937],
              [18.14833, 57.235275000000115],
              [18.158054, 57.315826],
              [18.142498, 57.409439],
              [18.115276000000108, 57.480827],
              [18.110275, 57.496109],
              [18.109997, 57.513054000000125],
              [18.111385, 57.51944],
              [18.119164, 57.531105],
              [18.138611, 57.551109],
              [18.179165, 57.588333],
              [18.191441, 57.596138],
              [18.211941000000138, 57.60583],
              [18.227776, 57.611382000000106],
              [18.242222, 57.617493000000138],
              [18.249165, 57.620827000000133],
              [18.27611, 57.634163000000115],
              [18.29472, 57.645828],
              [18.338886, 57.68166],
              [18.355831000000137, 57.695831000000112],
              [18.381943, 57.718605],
              [18.40166, 57.738609],
              [18.41972, 57.76028],
              [18.456387, 57.802773],
              [18.461388, 57.807777000000101],
              [18.46722, 57.811943],
              [18.48111, 57.8186],
              [18.681942, 57.913605],
              [18.689999, 57.916107],
              [18.71611, 57.9211],
              [18.725, 57.922775],
              [18.88194, 57.919716],
              [18.902496, 57.918327],
              [18.914165, 57.917496],
              [19.004719, 57.908607],
              [19.00611, 57.90361],
              [19.003887000000134, 57.898888],
              [19.033333, 57.826942],
              [18.92944, 57.739716],
              [18.848888, 57.72111],
              [18.809166, 57.703606],
              [18.793331, 57.65916],
              [18.75972, 57.508049],
              [18.768055, 57.472221],
              [18.769444, 57.46722],
              [18.78833, 57.448326],
              [18.714443000000131, 57.246941000000106],
              [18.711941, 57.241661],
              [18.658054, 57.22083],
              [18.551941, 57.18278],
              [18.514721000000122, 57.169441],
              [18.498333, 57.165276],
              [18.455555, 57.156944],
              [18.43944, 57.152771],
              [18.417221, 57.14416],
              [18.39722, 57.134163],
              [18.39139, 57.129997000000117],
              [18.386665, 57.124992],
              [18.345554, 57.07972],
              [18.341389, 57.073883],
              [18.339165, 57.068604000000107],
              [18.335552, 57.02333],
              [18.335831, 57.017494],
              [18.34333, 57.014442],
              [18.34666, 56.998604000000114],
              [18.302498, 56.937492],
              [18.294998000000135, 56.93471],
              [18.215553, 56.91305],
              [18.20611, 56.911942],
            ],
          ],
          [
            [
              [19.334442, 57.955826],
              [19.286663, 57.937492],
              [19.277496, 57.940277],
              [19.274441, 57.945],
              [19.26805, 57.94861],
              [19.256664, 57.94944],
              [19.23805, 57.94694],
              [19.170555, 57.929443],
              [19.162777000000119, 57.926941000000113],
              [19.150833, 57.91861],
              [19.14583, 57.913605],
              [19.1416660000001, 57.90778],
              [19.14, 57.901665],
              [19.12611, 57.839722],
              [19.09333, 57.851944],
              [19.077774, 57.85833],
              [19.073055, 57.862495],
              [19.037498, 57.896385],
              [19.034443, 57.901108],
              [19.034443, 57.912498],
              [19.03611, 57.91861],
              [19.088886, 57.970276000000126],
              [19.095833, 57.97361],
              [19.10472, 57.975273],
              [19.285831, 57.976662],
              [19.296387, 57.976662],
              [19.307499, 57.974442],
              [19.3325, 57.965271],
              [19.335552, 57.960548],
              [19.334442, 57.955826],
            ],
          ],
          [
            [
              [11.594444, 57.932495000000131],
              [11.584999, 57.930832],
              [11.57472, 57.931664000000126],
              [11.528055, 57.948051],
              [11.522499, 57.951942000000145],
              [11.518125, 57.98069],
              [11.509722, 57.989716000000101],
              [11.498333, 58.006943],
              [11.497221, 58.012772],
              [11.498055000000136, 58.031387],
              [11.501944, 58.03666],
              [11.520555, 58.047775000000115],
              [11.53, 58.049164],
              [11.735884, 58.041714],
              [11.741110000000106, 58.030548],
              [11.742222, 58.024994000000106],
              [11.736944, 58.00444],
              [11.734165000000132, 57.998604],
              [11.729166, 57.993889],
              [11.72278, 57.990273],
              [11.659443, 57.957497],
              [11.646111, 57.950829],
              [11.594444, 57.932495000000131],
            ],
          ],
          [
            [
              [16.816666, 58.116104],
              [16.78333, 58.096664],
              [16.77861, 58.10055],
              [16.778053000000114, 58.106384],
              [16.781944, 58.112221],
              [16.78778, 58.116386],
              [16.801109, 58.123329000000126],
              [16.810833, 58.124443],
              [16.818886, 58.12138],
              [16.816666, 58.116104],
            ],
          ],
          [
            [
              [11.806389000000138, 58.120552],
              [11.800278, 58.116943],
              [11.714722, 58.101105],
              [11.67639, 58.098885],
              [11.624722, 58.107498000000135],
              [11.62361, 58.11305],
              [11.60666700000013, 58.118607],
              [11.583055000000115, 58.118889],
              [11.553333, 58.115273],
              [11.467222, 58.101387],
              [11.46583, 58.095833],
              [11.463610000000131, 58.071663],
              [11.464998, 58.066109],
              [11.454721, 58.07249],
              [11.450554, 58.076942],
              [11.40111, 58.130272000000105],
              [11.402777, 58.13694],
              [11.410555, 58.1475],
              [11.668888, 58.284439],
              [11.6775, 58.2866590000001],
              [11.708887000000118, 58.285828],
              [11.721666000000141, 58.284721],
              [11.736666000000127, 58.281662],
              [11.786665, 58.245552],
              [11.809999, 58.224442000000124],
              [11.812498, 58.219162],
              [11.81361, 58.213608],
              [11.815832, 58.171944],
              [11.814722, 58.147217],
              [11.81111, 58.1336060000001],
              [11.806389000000138, 58.120552],
            ],
          ],
          [
            [
              [19.23694, 58.33722],
              [19.226109, 58.33722],
              [19.21833, 58.340271],
              [19.18722, 58.381386],
              [19.184166, 58.38611],
              [19.186665, 58.391388],
              [19.224998, 58.389717000000132],
              [19.261665, 58.384163000000115],
              [19.30583, 58.37527],
              [19.324718000000132, 58.36972],
              [19.331108, 58.366104],
              [19.3275, 58.361664],
              [19.315277, 58.353333],
              [19.302219, 58.346107000000131],
              [19.294167, 58.343605],
              [19.285275000000127, 58.341942000000131],
              [19.23694, 58.33722],
            ],
          ],
          [
            [
              [17.691387, 58.916939000000127],
              [17.706387, 58.904442000000131],
              [17.695831000000112, 58.905548],
              [17.676388, 58.916382],
              [17.67139, 58.920555],
              [17.66444, 58.929993],
              [17.641109000000142, 58.965828000000101],
              [17.63916, 58.971107],
              [17.63916, 58.97666],
              [17.641941, 58.989166],
              [17.660553000000107, 59.039719],
              [17.667774, 59.05222],
              [17.67583100000013, 59.054718],
              [17.682220000000143, 59.051109],
              [17.696388, 59.039719],
              [17.71805, 59.018051],
              [17.721664, 59.007774],
              [17.720276000000126, 59.001663],
              [17.71611, 58.99555],
              [17.70417, 58.987221],
              [17.69611, 58.975555],
              [17.690277, 58.950829],
              [17.687775, 58.926941000000113],
              [17.688053, 58.921387],
              [17.691387, 58.916939000000127],
            ],
          ],
          [
            [
              [18.40583, 59.023888],
              [18.377499000000114, 59.01944],
              [18.365555, 59.020271],
              [18.36055, 59.02444],
              [18.357498, 59.02916],
              [18.35722, 59.034996],
              [18.396942000000138, 59.080826],
              [18.407219000000111, 59.09083],
              [18.41333, 59.094994],
              [18.444164, 59.115829],
              [18.450554000000125, 59.11805],
              [18.459721, 59.11972],
              [18.469719, 59.120552],
              [18.479164000000139, 59.119995000000131],
              [18.491665, 59.102776],
              [18.490555, 59.098053],
              [18.424164, 59.036385],
              [18.40583, 59.023888],
            ],
          ],
          [
            [
              [18.537220000000104, 59.223885],
              [18.527222000000108, 59.223053000000107],
              [18.515274, 59.223885],
              [18.503887, 59.22583],
              [18.435555, 59.253609],
              [18.42889, 59.25722],
              [18.389442, 59.284721],
              [18.391941, 59.290276],
              [18.46666, 59.29277],
              [18.478886, 59.29194],
              [18.49472, 59.290833000000134],
              [18.50361, 59.288887],
              [18.601944, 59.257500000000107],
              [18.610275000000115, 59.254166000000112],
              [18.57194, 59.232216000000108],
              [18.56361, 59.229721],
              [18.537220000000104, 59.223885],
            ],
          ],
          [
            [
              [17.78694, 59.31055],
              [17.77777, 59.308609000000104],
              [17.75444, 59.309441],
              [17.721664, 59.31611],
              [17.686943, 59.328049],
              [17.671944, 59.334717],
              [17.661942, 59.343048000000124],
              [17.617496, 59.397774],
              [17.605553, 59.416664],
              [17.610554, 59.42166],
              [17.61861, 59.424438],
              [17.627777, 59.42610900000011],
              [17.63888500000013, 59.42610900000011],
              [17.650555000000111, 59.424164],
              [17.7375, 59.393326000000116],
              [17.744164, 59.389717],
              [17.773888, 59.37277],
              [17.777222, 59.36805],
              [17.789165, 59.321388000000127],
              [17.789165, 59.315826],
              [17.78694, 59.31055],
            ],
          ],
          [
            [
              [17.734722, 59.2961],
              [17.817497, 59.277771],
              [17.758053000000132, 59.28083],
              [17.681942, 59.289719],
              [17.658886, 59.293884],
              [17.649166, 59.29639],
              [17.63916, 59.299164],
              [17.622776000000101, 59.305275000000108],
              [17.610832, 59.313049],
              [17.52055, 59.406944000000124],
              [17.518887, 59.411942000000124],
              [17.52027500000014, 59.41833],
              [17.523609000000135, 59.422775000000115],
              [17.53167, 59.425278],
              [17.539165, 59.426666],
              [17.570553000000132, 59.428604000000121],
              [17.622776000000101, 59.378609],
              [17.629719, 59.369438],
              [17.63694, 59.348885000000109],
              [17.637218, 59.343048000000124],
              [17.635555000000124, 59.336937],
              [17.636108, 59.325554],
              [17.63777, 59.320549],
              [17.647778, 59.317772000000105],
              [17.734722, 59.2961],
            ],
          ],
          [
            [
              [17.26638800000012, 59.374443],
              [17.256386000000134, 59.373329],
              [17.231110000000115, 59.375549],
              [17.155552000000114, 59.383606],
              [17.147221, 59.386665],
              [17.070274, 59.45388800000012],
              [17.070000000000107, 59.459442],
              [17.089722, 59.46],
              [17.150555, 59.45666],
              [17.236111, 59.44971],
              [17.256943, 59.446663],
              [17.266941, 59.44416],
              [17.28028, 59.43694],
              [17.31611, 59.408051],
              [17.31805, 59.403053],
              [17.317219, 59.398048],
              [17.30972, 59.394165],
              [17.26638800000012, 59.374443],
            ],
          ],
          [
            [
              [18.575554, 59.44833],
              [18.565277, 59.44749],
              [18.553055, 59.44833],
              [18.526665, 59.468605],
              [18.521664, 59.472771],
              [18.519997, 59.4836],
              [18.519997, 59.489441000000113],
              [18.522778, 59.49472],
              [18.528889, 59.498886],
              [18.570274, 59.526382],
              [18.610832, 59.546661],
              [18.63361, 59.555832000000123],
              [18.64361, 59.556664],
              [18.73889, 59.548332],
              [18.746944, 59.544998],
              [18.732498, 59.53833],
              [18.724442, 59.535828],
              [18.715275, 59.534164],
              [18.66805, 59.526665],
              [18.591389000000106, 59.501106],
              [18.588608, 59.495552],
              [18.590275000000133, 59.490555],
              [18.60694100000012, 59.467216000000121],
              [18.605274, 59.461105],
              [18.583611000000133, 59.450829000000113],
              [18.575554, 59.44833],
            ],
          ],
          [
            [
              [18.57, 60.30778],
              [18.561665000000119, 60.305275000000108],
              [18.549164000000133, 60.306107],
              [18.521111, 60.315826],
              [18.512775, 60.31916],
              [18.401108, 60.365273000000116],
              [18.394165, 60.374718],
              [18.3925, 60.37971],
              [18.381943, 60.416382000000112],
              [18.371666000000118, 60.494164],
              [18.374165000000119, 60.499718],
              [18.380554, 60.503883],
              [18.39, 60.505554000000132],
              [18.408886, 60.499718],
              [18.422497, 60.486664],
              [18.456108, 60.427498],
              [18.507221, 60.348053],
              [18.537220000000104, 60.3425],
              [18.572777, 60.313332],
              [18.57, 60.30778],
            ],
          ],
          [
            [
              [17.509163, 62.363327],
              [17.484722, 62.36305],
              [17.456665, 62.365273000000116],
              [17.444164, 62.367493],
              [17.42222, 62.372498],
              [17.416664, 62.37666],
              [17.412777000000119, 62.381386000000134],
              [17.369164, 62.46666],
              [17.36722200000014, 62.471664],
              [17.373333, 62.474442],
              [17.463055000000111, 62.461662],
              [17.472221, 62.458328],
              [17.51444, 62.414444000000117],
              [17.5425, 62.366104000000121],
              [17.509163, 62.363327],
            ],
          ],
          [
            [
              [18.060833000000116, 62.67083],
              [18.04972, 62.669998],
              [18.04166, 62.6722180000001],
              [18.03611, 62.67638],
              [18.02666, 62.685272],
              [18.023052000000121, 62.689995000000124],
              [18.019165, 62.700272],
              [18.022499, 62.712494000000106],
              [18.03916, 62.735550000000103],
              [18.04583, 62.739716],
              [18.060276, 62.743889000000138],
              [18.070553, 62.745552],
              [18.129719000000136, 62.74055],
              [18.141388, 62.739166],
              [18.146942, 62.734993],
              [18.153053000000114, 62.72888],
              [18.15694, 62.71833],
              [18.155, 62.712219],
              [18.114166, 62.686943],
              [18.10722, 62.682777],
              [18.099442, 62.67944],
              [18.060833000000116, 62.67083],
            ],
          ],
          [
            [
              [20.885555, 63.751663000000121],
              [20.875832, 63.749161],
              [20.84083, 63.763054000000125],
              [20.8375, 63.767776],
              [20.838055, 63.773331],
              [20.84222, 63.779999],
              [20.8475, 63.785828],
              [20.855, 63.789993],
              [20.873333, 63.795555],
              [20.88499800000011, 63.796104000000128],
              [20.899998, 63.79416700000013],
              [20.91111, 63.791382],
              [20.92194400000011, 63.782776000000126],
              [20.928608000000111, 63.773331],
              [20.92722, 63.768608],
              [20.885555, 63.751663000000121],
            ],
          ],
          [
            [
              [21.809166, 68.570541],
              [21.82472, 68.570267],
              [21.864719, 68.573608],
              [21.881386, 68.572495],
              [21.89722, 68.569992],
              [21.933887, 68.555267],
              [21.959442, 68.543884000000105],
              [21.99778, 68.5236],
              [22.003887, 68.519440000000145],
              [22.0225, 68.506653000000142],
              [22.035, 68.498047],
              [22.038055, 68.487778],
              [22.041943, 68.483047],
              [22.050552, 68.47916],
              [22.063889000000131, 68.4761],
              [22.15083, 68.465546000000131],
              [22.1675, 68.46443],
              [22.371944, 68.46361],
              [22.43055, 68.451660000000118],
              [22.5, 68.440132],
              [22.58166, 68.42722],
              [22.659721, 68.422485],
              [22.67388, 68.42082],
              [22.82361, 68.388046],
              [22.829720000000123, 68.383881],
              [22.86360900000011, 68.357498],
              [22.899719, 68.3316650000001],
              [22.910275, 68.328323],
              [22.936386, 68.32222],
              [22.969444, 68.317764000000125],
              [23.04805, 68.29388],
              [23.058609, 68.290268],
              [23.066944, 68.286377],
              [23.353333000000134, 68.083603],
              [23.367496000000131, 68.06471],
              [23.376942, 68.055542],
              [23.394444000000135, 68.042496],
              [23.53167, 67.99249],
              [23.638332000000105, 67.958054000000118],
              [23.648888, 67.95471],
              [23.656944000000124, 67.950821],
              [23.666111000000114, 67.941666],
              [23.667221, 67.936386],
              [23.665554, 67.929993],
              [23.659721, 67.9236],
              [23.65277, 67.918045],
              [23.644722, 67.913055],
              [23.607777, 67.897491],
              [23.596386000000109, 67.89526],
              [23.545555, 67.889999],
              [23.511108, 67.8836060000001],
              [23.492496, 67.87582],
              [23.486942, 67.86916],
              [23.48333, 67.86305],
              [23.471107, 67.822769000000108],
              [23.469997, 67.816940000000102],
              [23.49139, 67.712494],
              [23.507774, 67.665543000000127],
              [23.471943000000124, 67.556381000000101],
              [23.433331000000123, 67.491943],
              [23.429996, 67.485825],
              [23.428886, 67.47583],
              [23.43111, 67.465546000000131],
              [23.44833, 67.452499000000103],
              [23.464165, 67.44472],
              [23.474442000000124, 67.441101000000117],
              [23.486942, 67.43805],
              [23.500553000000139, 67.436386],
              [23.51194, 67.438599],
              [23.527496, 67.448044],
              [23.536663, 67.451935],
              [23.549164, 67.453323],
              [23.581944000000135, 67.449997],
              [23.734997000000135, 67.426102],
              [23.761944, 67.420273],
              [23.76777600000014, 67.416107000000125],
              [23.768887, 67.41083],
              [23.783054, 67.332214],
              [23.781944, 67.326385],
              [23.773331, 67.314438000000109],
              [23.749722, 67.289444000000117],
              [23.741665000000125, 67.284714000000122],
              [23.73166700000013, 67.28166],
              [23.708054, 67.278046000000131],
              [23.683052, 67.27554],
              [23.63583, 67.2686],
              [23.624722, 67.26638800000012],
              [23.614441, 67.263321],
              [23.6055530000001, 67.259430000000123],
              [23.594444, 67.24638],
              [23.586666, 67.234985000000108],
              [23.57055, 67.161942],
              [23.571663, 67.156662],
              [23.580555000000118, 67.147491],
              [23.68111, 67.047485],
              [23.73111, 67.008331],
              [23.744442, 67.000000000000114],
              [23.75777, 66.991943000000106],
              [23.787777, 66.981384000000105],
              [23.866943000000106, 66.931107],
              [23.935833000000116, 66.884155],
              [23.94111, 66.87999],
              [23.949997, 66.87082],
              [24.00111, 66.810272000000111],
              [24.00777, 66.800552],
              [24.006386, 66.794998],
              [23.999722, 66.791382],
              [23.987778, 66.790268],
              [23.948055, 66.788879],
              [23.936943, 66.786942],
              [23.89361, 66.749161],
              [23.89, 66.743042],
              [23.891109000000142, 66.737778],
              [23.90083, 66.712494],
              [23.902775, 66.680267],
              [23.891941, 66.5816650000001],
              [23.887497, 66.569992],
              [23.884163, 66.563889000000131],
              [23.878609, 66.55722],
              [23.87194, 66.551666],
              [23.861942, 66.5486],
              [23.826942, 66.543884000000105],
              [23.80722, 66.53777],
              [23.725277, 66.50082],
              [23.66639, 66.465271000000143],
              [23.658886, 66.460541],
              [23.652222, 66.454712],
              [23.646664000000101, 66.448318],
              [23.640274, 66.436096],
              [23.639164, 66.430542],
              [23.660831, 66.317215],
              [23.661942000000124, 66.31221],
              [23.66639, 66.30222],
              [23.68472, 66.263321],
              [23.71917, 66.204987],
              [23.722221, 66.20027],
              [23.727776, 66.195831],
              [23.735275, 66.19194],
              [23.754719, 66.184998],
              [23.80833, 66.169708],
              [23.82027, 66.16666],
              [23.84805, 66.161377],
              [23.864166, 66.159164],
              [23.879444, 66.158051000000114],
              [23.89333, 66.15527],
              [23.912498, 66.148331],
              [23.92555, 66.139999],
              [23.930832, 66.135544],
              [23.940277, 66.121384000000148],
              [23.94861, 66.101379000000122],
              [23.967777000000126, 66.072495],
              [24.031387, 66.020264],
              [24.160553, 65.84],
              [24.166664, 65.830551],
              [24.16861, 65.819992],
              [24.167007, 65.814026],
              [24.15305, 65.805542000000116],
              [24.144444000000135, 65.801666],
              [24.12111, 65.798874000000126],
              [24.10611, 65.80028],
              [24.08083, 65.806107],
              [24.05222, 65.808044],
              [24.040276000000119, 65.806656],
              [23.986111, 65.792496],
              [23.956108, 65.784164],
              [23.95194, 65.778885],
              [23.94861, 65.772766],
              [23.943333, 65.766388],
              [23.936943, 65.76082],
              [23.928333, 65.75694],
              [23.91666, 65.757767000000115],
              [23.773888000000113, 65.792770000000132],
              [23.77277800000013, 65.797775],
              [23.65389, 65.806381000000101],
              [23.51833, 65.800827],
              [23.434719, 65.760544],
              [23.394444000000135, 65.767487],
              [23.249722, 65.800827],
              [23.23444, 65.76361],
              [23.141109, 65.714722],
              [23.131664, 65.711655],
              [23.08111, 65.698883],
              [23.073608, 65.702774],
              [23.00027, 65.752777],
              [22.828888, 65.815277],
              [22.826385, 65.825546],
              [22.823055, 65.830551],
              [22.790276, 65.856384],
              [22.723331, 65.886108],
              [22.675831, 65.902222],
              [22.644722, 65.905548],
              [22.637218000000132, 65.902771000000143],
              [22.638611, 65.897766],
              [22.649719000000118, 65.88888500000013],
              [22.666943, 65.881653],
              [22.674442, 65.877777],
              [22.679996, 65.873596],
              [22.683331000000123, 65.868881],
              [22.70472, 65.807495],
              [22.684998, 65.763885],
              [22.677776, 65.759155],
              [22.66944, 65.75499],
              [22.66, 65.751938000000109],
              [22.648609, 65.75055],
              [22.651386, 65.756653000000142],
              [22.656387, 65.763321000000133],
              [22.657219, 65.76887],
              [22.650555, 65.77832],
              [22.608608000000117, 65.796936],
              [22.479164, 65.851105],
              [22.451385, 65.856110000000115],
              [22.41861, 65.85943600000013],
              [22.375553, 65.86082],
              [22.363888, 65.85916],
              [22.35778, 65.855820000000108],
              [22.329166, 65.82971],
              [22.25777, 65.691101000000117],
              [22.249054, 65.632492],
              [22.27272, 65.627655],
              [22.281054, 65.626152],
              [22.289387, 65.62599200000011],
              [22.300554, 65.629822000000104],
              [22.31667, 65.618042000000116],
              [22.321388, 65.624710000000107],
              [22.322220000000129, 65.630264],
              [22.31667, 65.63472],
              [22.309166, 65.638611],
              [22.298054, 65.647217],
              [22.286942000000124, 65.659988000000112],
              [22.283607, 65.66499],
              [22.289719, 65.668320000000108],
              [22.303608000000111, 65.665833],
              [22.323055000000124, 65.659164000000146],
              [22.385555, 65.628876],
              [22.423611, 65.558884],
              [22.42639, 65.548599],
              [22.423332, 65.542221],
              [22.41639, 65.53749],
              [22.40583, 65.535263],
              [22.39416, 65.53833],
              [22.379166000000112, 65.545822000000101],
              [22.366108, 65.55415],
              [22.241833, 65.577271],
              [22.206329, 65.578773000000126],
              [22.07972, 65.607208],
              [21.86389, 65.666656],
              [21.854164, 65.669998],
              [21.846386000000109, 65.673874],
              [21.840832, 65.67805],
              [21.82694, 65.697220000000129],
              [21.82139, 65.70138500000013],
              [21.766941, 65.722488],
              [21.760830000000112, 65.716934],
              [21.762497, 65.711655],
              [21.773052000000121, 65.69749],
              [21.828053, 65.66527],
              [21.84333, 65.657776],
              [21.8530540000001, 65.654434],
              [22.0225, 65.598053],
              [22.057777, 65.589157],
              [22.116108000000111, 65.583054000000118],
              [22.12583, 65.579712],
              [22.199165, 65.545273000000122],
              [22.194164, 65.540833000000134],
              [22.184998000000121, 65.537766],
              [22.164165000000139, 65.533051],
              [22.05384800000013, 65.517441],
              [22.00027, 65.513611],
              [21.987499, 65.515274],
              [21.90916, 65.526657000000114],
              [21.89944, 65.529999],
              [21.891666, 65.53387],
              [21.887218, 65.537216],
              [21.879997, 65.536652],
              [21.85916, 65.532211000000132],
              [21.8525, 65.529999],
              [21.85805, 65.525833000000148],
              [21.901108, 65.496658],
              [21.914165, 65.488602],
              [21.925831, 65.485550000000103],
              [21.93972, 65.485275000000115],
              [21.922497, 65.506943],
              [21.925278, 65.510818],
              [21.93694, 65.508041000000105],
              [21.979164000000139, 65.48972],
              [22.030277000000126, 65.462219],
              [22.031666, 65.457214],
              [22.017498, 65.428604],
              [22.010555, 65.423874000000126],
              [21.929443, 65.398041],
              [21.675831, 65.391098],
              [21.662220000000104, 65.391388],
              [21.647499, 65.392487],
              [21.635555, 65.395554000000118],
              [21.628052, 65.399155],
              [21.611385, 65.412216000000114],
              [21.601665000000139, 65.415543],
              [21.586941, 65.416382],
              [21.54472, 65.408051000000114],
              [21.47416, 65.386658],
              [21.46833, 65.380829],
              [21.497276000000113, 65.35527],
              [21.506275, 65.3446],
              [21.534277, 65.327271],
              [21.543110000000127, 65.326775],
              [21.57972, 65.31471],
              [21.587776, 65.31888],
              [21.590275, 65.324997],
              [21.586941, 65.329712],
              [21.588886, 65.332214000000135],
              [21.612221, 65.32638500000013],
              [21.621944, 65.323044],
              [21.69722, 65.291382000000112],
              [21.70472, 65.287491],
              [21.704166, 65.281937],
              [21.700832, 65.270264],
              [21.695, 65.264435],
              [21.66389, 65.247498],
              [21.65472, 65.244156],
              [21.588055, 65.234711],
              [21.56528, 65.231659],
              [21.553608, 65.234711],
              [21.548054, 65.238876],
              [21.541111, 65.248322000000144],
              [21.53805, 65.258881],
              [21.493887, 65.28671],
              [21.468887000000109, 65.310883],
              [21.46422200000012, 65.31321000000014],
              [21.338055000000111, 65.36972],
              [21.32444, 65.371933],
              [21.314163, 65.36972],
              [21.266388, 65.34111],
              [21.260555, 65.337494],
              [21.266109, 65.333328000000108],
              [21.32111, 65.323608],
              [21.336941000000138, 65.321655],
              [21.417221, 65.306107],
              [21.50528, 65.248596],
              [21.548054, 65.21944],
              [21.559166, 65.210831],
              [21.613609, 65.16249],
              [21.620552, 65.153046000000131],
              [21.621944, 65.147766],
              [21.621387, 65.142212],
              [21.583885, 65.062775000000101],
              [21.577221, 65.05777],
              [21.56583, 65.056381],
              [21.533703, 65.05875],
              [21.494164, 65.061096],
              [21.48305, 65.059708],
              [21.472775, 65.05722],
              [21.46833, 65.050552],
              [21.4675, 65.044998],
              [21.470554, 65.034439],
              [21.480000000000132, 65.031097],
              [21.466663, 65.007217],
              [21.373333000000116, 64.975555],
              [21.300831, 64.954437],
              [21.254997, 64.949432],
              [21.243889, 64.947769],
              [21.20528, 64.891663],
              [21.20666, 64.886383],
              [21.208885, 64.862488],
              [21.183052, 64.829987],
              [21.131664, 64.818878],
              [21.122776000000101, 64.818054000000132],
              [21.109165000000132, 64.820267000000115],
              [21.0975, 64.82332],
              [21.091942, 64.8275],
              [21.084999, 64.836929],
              [21.086109, 64.84833],
              [21.0825, 64.853043],
              [21.073055, 64.856384],
              [21.060555000000136, 64.855820000000108],
              [21.044998, 64.84776],
              [21.039444000000117, 64.84193],
              [21.036942, 64.83583],
              [21.036110000000122, 64.824432000000115],
              [21.039444000000117, 64.819717],
              [21.044998, 64.815277],
              [21.0825, 64.788605000000132],
              [21.09, 64.784714],
              [21.0975, 64.781097000000102],
              [21.10694, 64.777771],
              [21.125608000000113, 64.775826000000109],
              [21.134275000000116, 64.7751540000001],
              [21.159443, 64.77554],
              [21.214996, 64.782776000000126],
              [21.229443000000117, 64.78194],
              [21.258331, 64.777496],
              [21.292774, 64.768875],
              [21.30222, 64.76555],
              [21.307777000000101, 64.761383],
              [21.310833, 64.75082],
              [21.304996, 64.661942000000124],
              [21.289719, 64.663879],
              [21.278332, 64.666656000000103],
              [21.268608, 64.669998],
              [21.23889, 64.685272000000111],
              [21.161942, 64.7227630000001],
              [21.143721, 64.724442],
              [21.13622, 64.725433],
              [21.121721, 64.724602],
              [21.105000000000132, 64.7227630000001],
              [21.104443, 64.716934],
              [21.111942, 64.691101000000117],
              [21.118889, 64.681381],
              [21.133888, 64.673874000000126],
              [21.271385000000123, 64.615265],
              [21.356941, 64.59082],
              [21.361385, 64.597214],
              [21.366943, 64.603043],
              [21.373333000000116, 64.605270000000132],
              [21.465275, 64.575546000000145],
              [21.55416, 64.532486],
              [21.585, 64.439713],
              [21.458054000000118, 64.361099],
              [21.390553, 64.335266],
              [21.32222, 64.309998],
              [21.313332, 64.306931],
              [21.28611, 64.29832],
              [21.276108, 64.29582],
              [21.267220000000123, 64.294998],
              [21.25972, 64.298599],
              [21.258331, 64.30388],
              [21.254997, 64.308609],
              [21.242775000000108, 64.310272000000111],
              [21.234997, 64.306107000000111],
              [20.971664, 64.148605],
              [20.9575, 64.139435],
              [20.954166, 64.134155],
              [20.905, 64.049438],
              [20.895554, 64.002487],
              [20.79389, 63.886383],
              [20.777775, 63.869164],
              [20.770275, 63.864998000000128],
              [20.728611000000114, 63.848053],
              [20.638332, 63.813332],
              [20.535, 63.799164],
              [20.508053000000132, 63.82027],
              [20.499722, 63.82278],
              [20.494164, 63.81916],
              [20.44778, 63.758331000000112],
              [20.41777, 63.697777],
              [20.41361, 63.691109],
              [20.38694, 63.674164000000133],
              [20.37917, 63.672493],
              [20.369999, 63.675552],
              [20.316666, 63.659996],
              [20.298611, 63.646385000000123],
              [20.263885, 63.665833],
              [20.1, 63.65583],
              [20.011944, 63.635826],
              [19.899441, 63.609161],
              [19.893055000000118, 63.60638],
              [19.775276000000133, 63.533333],
              [19.749165000000119, 63.516663],
              [19.747219, 63.510551],
              [19.74889, 63.505272],
              [19.754166, 63.501106000000107],
              [19.761665, 63.497215],
              [19.768887, 63.487778000000105],
              [19.779163, 63.462494000000106],
              [19.772644000000128, 63.457535],
              [19.704998, 63.431938],
              [19.68305, 63.429718],
              [19.6680530000001, 63.431389],
              [19.641109, 63.442497],
              [19.635830000000112, 63.44666],
              [19.639999000000103, 63.459160000000111],
              [19.643055, 63.46444],
              [19.64333, 63.46999],
              [19.639721, 63.474716000000114],
              [19.61639, 63.49472],
              [19.501663, 63.549438],
              [19.475555, 63.55971],
              [19.463608000000136, 63.561104],
              [19.453053, 63.559441],
              [19.42805, 63.549438],
              [19.422775, 63.54583],
              [19.42444, 63.54055],
              [19.473610000000122, 63.453049],
              [19.44722, 63.440277],
              [19.365833, 63.434998],
              [19.351665, 63.435272],
              [19.318333000000109, 63.449165],
              [19.31277, 63.453331000000105],
              [19.309185000000127, 63.463608],
              [19.296665, 63.463608],
              [19.289444000000117, 63.459442],
              [19.283333, 63.45444],
              [19.27833, 63.44861],
              [19.274441, 63.44194],
              [19.27583, 63.419716],
              [19.277496, 63.408882],
              [19.23055, 63.3275],
              [19.158607, 63.315277],
              [19.14, 63.310272000000111],
              [19.058609000000104, 63.25361],
              [19.045555, 63.244438],
              [19.04055, 63.238609],
              [19.04416700000013, 63.22805000000011],
              [19.049721, 63.21833],
              [19.05972, 63.216385],
              [19.08527800000013, 63.214165],
              [19.108608, 63.213608000000136],
              [19.110275, 63.208328000000108],
              [19.066666, 63.178604],
              [19.058331, 63.175278],
              [19.046944, 63.174438],
              [19.036942, 63.176384],
              [18.9725, 63.21],
              [18.966942, 63.214439],
              [18.963333, 63.218887000000109],
              [18.965, 63.225273],
              [18.96527, 63.230827],
              [18.95611, 63.24528],
              [18.90361, 63.272774],
              [18.88972, 63.2736],
              [18.811554000000115, 63.251774],
              [18.806053, 63.25027],
              [18.802887000000112, 63.248108],
              [18.80105, 63.244942],
              [18.8033870000001, 63.242107],
              [18.810055, 63.24044],
              [18.847219, 63.234104000000116],
              [18.88389, 63.227104],
              [18.908054, 63.21027400000014],
              [18.915276, 63.20666],
              [18.8975, 63.191666000000112],
              [18.784721, 63.161942],
              [18.775833, 63.162773],
              [18.761108, 63.170273],
              [18.751942, 63.18471],
              [18.74866500000013, 63.192436],
              [18.752163, 63.195606000000112],
              [18.757664, 63.1971],
              [18.765331000000117, 63.1971],
              [18.78083, 63.194439],
              [18.794, 63.195938],
              [18.791832, 63.198772],
              [18.787331, 63.200939000000119],
              [18.780664, 63.202606],
              [18.771832000000131, 63.20361],
              [18.73616, 63.20760700000011],
              [18.728664, 63.20760700000011],
              [18.722332, 63.206604],
              [18.719831, 63.203773000000126],
              [18.720997, 63.200775],
              [18.73555, 63.17249],
              [18.739166, 63.16777],
              [18.647221, 63.14055],
              [18.566944, 63.117493000000138],
              [18.382221, 63.051666],
              [18.289165000000139, 62.99721],
              [18.34666, 62.98805],
              [18.367222, 62.99139],
              [18.39, 62.993332],
              [18.4025, 62.993332],
              [18.524998, 62.98583200000013],
              [18.539719000000105, 62.984444],
              [18.552498000000128, 62.982216000000108],
              [18.561943, 62.978882000000112],
              [18.567497, 62.974716],
              [18.576664, 62.965828],
              [18.580276, 62.955551],
              [18.576385, 62.951111],
              [18.473888, 62.862495],
              [18.466942, 62.85833],
              [18.208611000000133, 62.77861],
              [18.19944, 62.776108],
              [18.12611, 62.765831],
              [18.082775, 62.781105],
              [18.104443000000117, 62.804161000000136],
              [18.129166, 62.804443],
              [18.138332000000105, 62.806938],
              [18.145275, 62.811104000000114],
              [18.144997, 62.816666],
              [18.137775, 62.820549],
              [18.073330000000112, 62.836662],
              [18.03722, 62.839165],
              [17.984997, 62.82222],
              [17.978333, 62.818054],
              [17.97472, 62.811386],
              [17.927498, 62.842499],
              [17.87222, 62.918610000000115],
              [17.862499, 62.933052],
              [17.84333, 62.962219],
              [17.828331, 62.993332],
              [17.820274, 62.995827],
              [17.701664, 62.995552],
              [17.696663, 62.991943],
              [17.70222, 62.987778],
              [17.7305530000001, 62.972771],
              [17.752777, 62.96194],
              [17.771385000000123, 62.955551],
              [17.793610000000115, 62.950554000000125],
              [17.834721000000116, 62.933327000000133],
              [17.88194, 62.883606],
              [17.99472, 62.730553],
              [18.004444, 62.70472],
              [18.004719, 62.693329000000119],
              [17.996387, 62.65666],
              [17.991386, 62.653053000000114],
              [17.979164, 62.652771],
              [17.964443, 62.660271000000137],
              [17.956944, 62.669441],
              [17.946388000000127, 62.669998],
              [17.879719, 62.669441],
              [17.874165, 62.664444],
              [17.877777, 62.659721000000104],
              [17.88528, 62.656105],
              [17.966389, 62.63444],
              [18.034721, 62.62639],
              [18.045555, 62.623604000000114],
              [18.048054, 62.601387],
              [18.04472, 62.589165],
              [17.978054, 62.555275],
              [17.84333, 62.487221],
              [17.835552000000121, 62.483887],
              [17.82527, 62.482216],
              [17.81194, 62.482773],
              [17.789719, 62.499443],
              [17.780552, 62.502495000000124],
              [17.767220000000123, 62.503326000000129],
              [17.723610000000122, 62.498886],
              [17.693333, 62.493607],
              [17.685555, 62.490273],
              [17.658607, 62.473328],
              [17.654163, 62.467216],
              [17.661663, 62.458054000000118],
              [17.676388, 62.450829],
              [17.67139, 62.43777],
              [17.619164, 62.434166],
              [17.605831000000137, 62.434998],
              [17.564163, 62.440277],
              [17.54583, 62.446388000000127],
              [17.53833, 62.449997],
              [17.528889, 62.458885000000123],
              [17.513885, 62.477219000000105],
              [17.50444, 62.486107],
              [17.47472, 62.506386],
              [17.437496, 62.53],
              [17.422497, 62.537216],
              [17.40916, 62.538055],
              [17.401386, 62.534439000000134],
              [17.334442, 62.49194],
              [17.328888, 62.486938],
              [17.325554, 62.480270000000132],
              [17.359722, 62.360275000000115],
              [17.371944, 62.329163],
              [17.375832, 62.32444],
              [17.465275, 62.265549],
              [17.502497, 62.25849],
              [17.552164, 62.25016],
              [17.576998000000117, 62.247162],
              [17.623886, 62.239441000000113],
              [17.645554, 62.234161],
              [17.654720000000111, 62.23111],
              [17.649719, 62.227493],
              [17.599998000000141, 62.209442],
              [17.556664, 62.195549],
              [17.545277, 62.196938],
              [17.537777, 62.200554000000125],
              [17.535831, 62.205551],
              [17.538609000000122, 62.211105],
              [17.555641, 62.216953],
              [17.567001, 62.226334000000122],
              [17.55786, 62.235104],
              [17.542677, 62.23152],
              [17.53243, 62.23004],
              [17.519958, 62.230782],
              [17.509464, 62.22893],
              [17.510036000000127, 62.204578],
              [17.508038, 62.200584000000106],
              [17.483253000000104, 62.125145],
              [17.463608, 62.006386000000134],
              [17.45166, 61.996941],
              [17.445, 61.992775],
              [17.437222000000133, 61.989441],
              [17.427498, 61.987778],
              [17.418331000000137, 61.990829],
              [17.408607, 61.992493],
              [17.399998, 61.989998],
              [17.393330000000105, 61.985550000000103],
              [17.354164, 61.951111],
              [17.349720000000104, 61.945274],
              [17.345276000000126, 61.92638],
              [17.336388000000113, 61.818054],
              [17.385666000000128, 61.756496],
              [17.440277, 61.726944],
              [17.469719000000111, 61.732216],
              [17.48389, 61.73083],
              [17.49472, 61.72805],
              [17.5, 61.723885],
              [17.523609000000135, 61.70166],
              [17.523609000000135, 61.696106],
              [17.50111, 61.639717],
              [17.498886, 61.635826000000122],
              [17.493610000000103, 61.630829],
              [17.487221, 61.626389],
              [17.477219, 61.624718000000144],
              [17.445274, 61.62888],
              [17.432777, 61.631104],
              [17.42194400000011, 61.639160000000118],
              [17.419998, 61.64444],
              [17.414165, 61.65416],
              [17.39, 61.687218],
              [17.386108, 61.69194],
              [17.36811, 61.700386],
              [17.354109, 61.706551000000104],
              [17.339443000000131, 61.712494000000106],
              [17.32694, 61.714439],
              [17.23389, 61.722496],
              [17.22083, 61.723053],
              [17.15, 61.721382000000119],
              [17.140274, 61.719719],
              [17.142220000000123, 61.714439],
              [17.149441, 61.71083],
              [17.15833, 61.70777],
              [17.183887000000141, 61.704994],
              [17.194721, 61.706108],
              [17.207775, 61.705276],
              [17.220276, 61.703331000000105],
              [17.26083, 61.69111],
              [17.269722000000115, 61.688049],
              [17.27166, 61.68305],
              [17.26861, 61.67638],
              [17.263054000000125, 61.671104000000128],
              [17.189999000000114, 61.63611],
              [17.18111, 61.633331000000112],
              [17.171387, 61.63166],
              [17.15833, 61.63222],
              [17.146111, 61.634163],
              [17.128052, 61.640549],
              [17.09861, 61.602776],
              [17.117775000000108, 61.55555],
              [17.162777, 61.521660000000111],
              [17.1680530000001, 61.517494],
              [17.222775, 61.44194],
              [17.21972, 61.429443],
              [17.213333, 61.425278],
              [17.171387, 61.420555],
              [17.15416, 61.42805],
              [17.150555, 61.432777],
              [17.139721000000122, 61.431664000000126],
              [17.109444, 61.408051],
              [17.104164000000139, 61.403053],
              [17.102776, 61.396942000000138],
              [17.104721, 61.39166],
              [17.144997, 61.357773],
              [17.20472, 61.328606],
              [17.213608, 61.325554],
              [17.20361, 61.278885],
              [17.18111, 61.190277],
              [17.162754, 61.046661],
              [17.150555, 60.945],
              [17.154442000000131, 60.940552],
              [17.201664, 60.916939],
              [17.241108000000111, 60.895828],
              [17.24472, 60.89111],
              [17.276108, 60.843048],
              [17.283607, 60.771660000000111],
              [17.28527, 60.731941],
              [17.275276, 60.676109],
              [17.359722, 60.640549000000135],
              [17.3771, 60.618988],
              [17.397499, 60.629166000000112],
              [17.406109000000129, 60.63166],
              [17.52055, 60.643051],
              [17.555275, 60.643326],
              [17.578331000000105, 60.639999000000103],
              [17.609165000000132, 60.63222],
              [17.63583, 60.618607],
              [17.649719, 60.611382],
              [17.656944, 60.601944],
              [17.651665, 60.596939000000134],
              [17.644165, 60.593605000000139],
              [17.60944400000011, 60.58416],
              [17.602219, 60.580551],
              [17.6025, 60.574997],
              [17.607777, 60.556107000000111],
              [17.609722, 60.550827],
              [17.629444, 60.522499],
              [17.634720000000129, 60.51833],
              [17.65361, 60.50694],
              [17.66222, 60.503883],
              [17.682777, 60.498604000000114],
              [17.693054, 60.496109000000104],
              [17.73111, 60.491661000000136],
              [17.740555, 60.493607],
              [17.740276, 60.499161],
              [17.734997, 60.508888000000127],
              [17.727776, 60.51833],
              [17.726109000000122, 60.523331],
              [17.725555, 60.534721],
              [17.72889, 60.541382],
              [17.73305, 60.547493],
              [17.773052, 60.57111],
              [17.842499, 60.59],
              [17.880554, 60.596939000000134],
              [17.891109, 60.597771],
              [17.937222, 60.598053000000107],
              [17.949718000000132, 60.597221],
              [17.95833, 60.594162],
              [17.965275, 60.590553],
              [17.970554, 60.586388],
              [17.993332000000123, 60.558884],
              [18.099998, 60.453049000000135],
              [18.21416, 60.343048000000124],
              [18.227776, 60.330276],
              [18.234444, 60.32666],
              [18.243889000000138, 60.328331000000105],
              [18.25222, 60.33083],
              [18.25861, 60.334999],
              [18.26667, 60.345276],
              [18.273052, 60.34944],
              [18.2825, 60.35139],
              [18.313889000000131, 60.353882],
              [18.431942, 60.343887],
              [18.44028, 60.340828000000101],
              [18.447220000000129, 60.331383],
              [18.46583, 60.299438000000123],
              [18.574165, 60.25],
              [18.601109, 60.241104],
              [18.607777, 60.23722],
              [18.606110000000115, 60.23111],
              [18.59861, 60.227776],
              [18.58, 60.224442],
              [18.55694, 60.224442],
              [18.531109, 60.226944],
              [18.470833, 60.234993],
              [18.448887, 60.23972],
              [18.440552000000139, 60.24277],
              [18.425278, 60.249718000000144],
              [18.388332, 60.266937],
              [18.374722, 60.274162000000103],
              [18.354164, 60.290833],
              [18.325554, 60.310829],
              [18.315277, 60.313332],
              [18.31361, 60.30722],
              [18.313889000000131, 60.301384],
              [18.396111000000133, 60.208054],
              [18.421665, 60.187218],
              [18.507431, 60.15266],
              [18.531666, 60.153053],
              [18.62611, 60.145828],
              [18.639442, 60.1441650000001],
              [18.711388000000113, 60.128052],
              [18.776665, 60.110832],
              [18.816387000000134, 60.09638],
              [18.81472, 60.090271],
              [18.81472, 60.078888],
              [18.816387000000134, 60.073883],
              [18.823055000000124, 60.05888],
              [18.886665, 59.96278],
              [18.89333, 59.953331000000105],
              [18.904999, 59.93999],
              [18.909721000000104, 59.935829],
              [18.92972200000014, 59.924721],
              [18.95022, 59.92033],
              [18.96372, 59.92033],
              [19.007221000000129, 59.912773],
              [19.045555, 59.899162],
              [19.070553, 59.889717],
              [19.07, 59.838608],
              [19.068333, 59.832497000000103],
              [19.065552, 59.827217],
              [19.059166, 59.823051000000135],
              [19.05055, 59.822777],
              [19.04055, 59.825272],
              [19.02583, 59.832222000000115],
              [18.96922, 59.865608],
              [18.936108, 59.869995000000131],
              [18.864719, 59.79805],
              [18.934719, 59.783607],
              [18.968609000000129, 59.783607],
              [19.07389, 59.774162],
              [19.08055, 59.770554],
              [19.082222, 59.765274],
              [19.081944000000135, 59.75972],
              [19.075275, 59.740555],
              [19.07, 59.735832],
              [19.032219000000111, 59.719994],
              [18.99139, 59.71666],
              [18.98, 59.71666],
              [18.95361, 59.719994],
              [18.841389, 59.712494],
              [18.74555, 59.689163000000121],
              [18.71722, 59.67139],
              [18.69444, 59.645271],
              [18.699997, 59.64249],
              [18.71027800000013, 59.643326],
              [18.728611, 59.64666],
              [18.739998000000128, 59.64666],
              [18.74472, 59.64249],
              [18.73416, 59.632500000000107],
              [18.666386, 59.591385],
              [18.645554, 59.580551],
              [18.378330000000119, 59.467499],
              [18.368332000000123, 59.466385000000116],
              [18.31722, 59.47361],
              [18.27972, 59.476662],
              [18.270554, 59.474998],
              [18.259443, 59.448051000000135],
              [18.259443, 59.44472],
              [18.276665, 59.41777],
              [18.28167, 59.413605],
              [18.28833, 59.409996],
              [18.299721, 59.407776],
              [18.326111000000139, 59.404442],
              [18.335831, 59.401939],
              [18.337498, 59.396660000000111],
              [18.331387, 59.392494],
              [18.32222, 59.390831000000105],
              [18.311108000000104, 59.390831000000105],
              [18.174999000000128, 59.405548],
              [18.165, 59.408051],
              [18.16, 59.412216],
              [18.162498000000141, 59.417496000000142],
              [18.176941, 59.424438],
              [18.188053, 59.424438],
              [18.19805, 59.42166],
              [18.203777, 59.427719],
              [18.199276000000111, 59.442551],
              [18.198277, 59.445721000000106],
              [18.195831, 59.455276],
              [18.18694, 59.45694],
              [18.124443, 59.45472],
              [18.115555, 59.453049000000135],
              [18.08972, 59.437218000000144],
              [18.084721, 59.431938000000116],
              [18.057220000000143, 59.391388],
              [18.088886, 59.367218],
              [18.091389, 59.334442],
              [18.007360000000119, 59.344963000000121],
              [17.94111, 59.335548],
              [17.928886, 59.336388000000113],
              [17.9175, 59.338608000000136],
              [17.89777800000013, 59.343887000000109],
              [17.859165, 59.35611],
              [17.832775, 59.364998000000128],
              [17.816109, 59.371109],
              [17.801388, 59.377777],
              [17.782776, 59.38916],
              [17.76444, 59.400551],
              [17.75777, 59.409996],
              [17.7575, 59.42139],
              [17.758888000000127, 59.427498],
              [17.78, 59.48555],
              [17.78722, 59.498329000000126],
              [17.79139, 59.504166],
              [17.801941, 59.51472],
              [17.81639, 59.52166],
              [17.841663, 59.52833],
              [17.845276, 59.533051000000114],
              [17.822777, 59.580826000000116],
              [17.816109, 59.59027],
              [17.809166, 59.593887],
              [17.751942, 59.638611],
              [17.71722, 59.66333],
              [17.724163, 59.653885000000116],
              [17.722221000000104, 59.626106000000107],
              [17.71805, 59.620277],
              [17.710552, 59.618889000000138],
              [17.6425, 59.637497],
              [17.603962, 59.65063],
              [17.59222, 59.656105],
              [17.598331, 59.660271],
              [17.607498, 59.661942],
              [17.62805, 59.662216],
              [17.64027, 59.66333],
              [17.648331, 59.665833000000134],
              [17.652496, 59.671661],
              [17.653339, 59.682129],
              [17.654163, 59.71805],
              [17.6313, 59.784073],
              [17.62805, 59.78889],
              [17.594166, 59.806938000000116],
              [17.58778, 59.804718],
              [17.588055, 59.793610000000115],
              [17.586666, 59.787216],
              [17.58361, 59.780548],
              [17.579441, 59.774719],
              [17.574444, 59.769722],
              [17.5425, 59.749443],
              [17.534443, 59.746941],
              [17.513885, 59.744995],
              [17.448055000000124, 59.73555],
              [17.444721000000129, 59.676109],
              [17.510555, 59.587219],
              [17.520832, 59.579163],
              [17.527496, 59.575554],
              [17.535831, 59.57222],
              [17.543152000000134, 59.573006],
              [17.52166, 59.611382],
              [17.515553, 59.63833],
              [17.513332, 59.654716000000121],
              [17.50889, 59.68777],
              [17.50861, 59.693329],
              [17.509998, 59.69944],
              [17.513054, 59.706383],
              [17.537498, 59.732216],
              [17.588886, 59.736938000000123],
              [17.599998000000141, 59.736938000000123],
              [17.611664000000133, 59.734993],
              [17.618332, 59.731384000000105],
              [17.620277000000101, 59.72639],
              [17.616108000000111, 59.695549],
              [17.561171000000115, 59.668449],
              [17.58971, 59.639427],
              [17.694164, 59.607498],
              [17.74222200000014, 59.590553],
              [17.757221, 59.583885],
              [17.7675, 59.569717],
              [17.78666, 59.535828],
              [17.785, 59.529442000000131],
              [17.737221, 59.446938],
              [17.73111, 59.442772],
              [17.72, 59.442772],
              [17.551941, 59.488609],
              [17.543888, 59.491661000000136],
              [17.525276, 59.503052],
              [17.52027500000014, 59.507217],
              [17.519089, 59.510254],
              [17.51833, 59.512215],
              [17.5225, 59.51805],
              [17.546082, 59.536987],
              [17.50027, 59.539719000000105],
              [17.490276000000108, 59.542496],
              [17.44694, 59.55722],
              [17.43861, 59.560272],
              [17.377777, 59.604721],
              [17.37278, 59.608887],
              [17.370831000000123, 59.614166],
              [17.37055, 59.61972],
              [17.386108, 59.651108],
              [17.38361, 59.654999],
              [17.375553, 59.652222],
              [17.344166, 59.622772000000111],
              [17.353333, 59.606110000000115],
              [17.370831000000123, 59.583054],
              [17.403332, 59.55333],
              [17.406666, 59.548607],
              [17.408607, 59.543327],
              [17.419167, 59.492775000000108],
              [17.41944100000012, 59.487221],
              [17.418053, 59.48111],
              [17.41, 59.46916],
              [17.398888, 59.46916],
              [17.325554, 59.48805],
              [17.26194, 59.50444],
              [17.25528, 59.508049],
              [17.18528, 59.538605000000132],
              [17.117222, 59.547775],
              [17.068054, 59.54361],
              [17.06194, 59.539444],
              [17.031387, 59.536385000000109],
              [17.019165, 59.537216000000114],
              [16.94972, 59.54361],
              [16.93972, 59.546104000000128],
              [16.8649640000001, 59.58473],
              [16.826385, 59.585274],
              [16.786942, 59.558884],
              [16.66166, 59.54805],
              [16.658054000000106, 59.552498000000128],
              [16.623055, 59.5816650000001],
              [16.616386, 59.585274],
              [16.565277, 59.60916],
              [16.551941000000113, 59.610550000000103],
              [16.541943000000117, 59.60944400000011],
              [16.53389, 59.60694100000012],
              [16.501663000000121, 59.596382],
              [16.495552, 59.591942],
              [16.497498000000121, 59.586937],
              [16.52166, 59.571663000000115],
              [16.542221, 59.561104],
              [16.547497, 59.556938],
              [16.546108000000117, 59.550827],
              [16.543331, 59.543884000000105],
              [16.53833, 59.53889],
              [16.489166000000125, 59.502014],
              [16.4725, 59.497498000000121],
              [16.329998, 59.467773],
              [16.178055, 59.464996],
              [16.16861, 59.465271],
              [16.10166, 59.471107],
              [16.091663, 59.473328],
              [16.06639, 59.482498000000135],
              [16.044167, 59.492493],
              [16.03555, 59.495552],
              [16.025555, 59.497772],
              [16.020275, 59.494995000000131],
              [16.022221, 59.48972],
              [16.026108, 59.485275],
              [16.041664, 59.473053],
              [16.066109, 59.457771],
              [16.072777, 59.454437],
              [16.08138700000012, 59.45138500000013],
              [16.101387, 59.446388],
              [16.11305, 59.444443],
              [16.169167, 59.439995],
              [16.181389, 59.439438],
              [16.261387, 59.4425],
              [16.276417, 59.443985],
              [16.304722, 59.450272],
              [16.313889, 59.451942],
              [16.335, 59.453331],
              [16.659443000000124, 59.4741590000001],
              [16.67, 59.473053],
              [16.679996, 59.470551],
              [16.686665, 59.467216000000121],
              [16.69028, 59.462494],
              [16.700554, 59.454437],
              [16.75, 59.424164],
              [16.80611, 59.390549],
              [16.812775000000101, 59.38694],
              [16.822777, 59.384438000000102],
              [16.869999, 59.381386],
              [16.88111, 59.381660000000124],
              [16.889999000000103, 59.383331],
              [16.893055, 59.39],
              [16.89416, 59.396111000000133],
              [16.89222, 59.401382],
              [16.885555000000124, 59.405],
              [16.86222, 59.405273],
              [16.85083, 59.40749],
              [16.842220000000111, 59.410553000000107],
              [16.808887, 59.422493],
              [16.79222, 59.428604000000121],
              [16.726665000000139, 59.453606],
              [16.697777, 59.467216000000121],
              [16.69278, 59.471382],
              [16.693333, 59.476105],
              [16.82889, 59.491386],
              [16.840275000000133, 59.489441000000113],
              [16.848888000000102, 59.486382],
              [16.8975, 59.467499],
              [16.924442000000113, 59.453331],
              [16.93555, 59.446388],
              [16.945831, 59.43833],
              [16.95444, 59.429718],
              [16.961388000000113, 59.420273],
              [17.111664, 59.374443],
              [17.174442, 59.373055000000136],
              [17.280552, 59.356667],
              [17.302219, 59.351944],
              [17.310555, 59.348885000000109],
              [17.315552, 59.344719],
              [17.317497, 59.339722000000108],
              [17.31611, 59.333328],
              [17.311943, 59.327499],
              [17.306110000000103, 59.323326],
              [17.298054, 59.320831],
              [17.287777, 59.319717],
              [17.26388500000013, 59.290833000000134],
              [17.25194, 59.269722],
              [17.253887000000134, 59.258888],
              [17.286942, 59.259048000000121],
              [17.29194, 59.25722],
              [17.365276, 59.248604],
              [17.375832, 59.247498],
              [17.387775, 59.246941],
              [17.398052, 59.247772],
              [17.39611, 59.25278],
              [17.386108, 59.261108],
              [17.379444, 59.264717],
              [17.364166, 59.277222],
              [17.358887, 59.286942],
              [17.355, 59.297218],
              [17.349442, 59.318329],
              [17.35083, 59.32444],
              [17.361942, 59.324715],
              [17.413055, 59.312218],
              [17.44278, 59.304718],
              [17.470833, 59.29639],
              [17.58583, 59.282219],
              [17.740276, 59.26944],
              [17.847221, 59.264442],
              [17.908054, 59.297218],
              [17.940552, 59.316666],
              [17.94749800000011, 59.32],
              [17.97639, 59.331383],
              [17.98444400000011, 59.333885000000123],
              [17.996666, 59.333054000000118],
              [18.016666, 59.32222],
              [18.026386000000116, 59.319717],
              [18.052498, 59.316383],
              [18.074718, 59.316666],
              [18.13361, 59.31805],
              [18.206944, 59.32944],
              [18.242092000000127, 59.347084000000109],
              [18.250832000000116, 59.354439],
              [18.272221, 59.364441],
              [18.280277000000126, 59.36694],
              [18.289444000000117, 59.368607],
              [18.34861, 59.373329],
              [18.39222, 59.368607],
              [18.403610000000128, 59.366661],
              [18.43972, 59.355],
              [18.444721000000129, 59.35083],
              [18.441275, 59.34477],
              [18.43694, 59.342773000000136],
              [18.43211, 59.341278],
              [18.434998, 59.336388000000113],
              [18.45472, 59.331108],
              [18.46666, 59.33027600000014],
              [18.474163, 59.334442],
              [18.478611, 59.340271],
              [18.478333000000134, 59.34583],
              [18.468609, 59.365555],
              [18.450275, 59.394165],
              [18.431389000000138, 59.421104],
              [18.42805, 59.425827],
              [18.42805, 59.431389000000138],
              [18.43444, 59.433609],
              [18.47722, 59.435272000000111],
              [18.498333, 59.43055],
              [18.523052, 59.421104],
              [18.52972, 59.417496000000142],
              [18.607777, 59.37194],
              [18.612778, 59.36805],
              [18.640274, 59.338882],
              [18.648609, 59.32444],
              [18.650276, 59.31916],
              [18.646942, 59.312492],
              [18.639721, 59.309166],
              [18.630554, 59.307495000000131],
              [18.593052, 59.301666000000125],
              [18.522221, 59.29583],
              [18.389164, 59.301941000000113],
              [18.37722, 59.302498],
              [18.35361, 59.30555],
              [18.343609, 59.307495000000131],
              [18.335278, 59.31055],
              [18.337776, 59.31611],
              [18.3365, 59.322052],
              [18.328833, 59.325054],
              [18.318886, 59.32833],
              [18.27722, 59.310829000000126],
              [18.26944, 59.268608],
              [18.309998, 59.219719000000111],
              [18.311386, 59.1325],
              [18.230274, 59.118607],
              [18.221386, 59.116943],
              [18.140274, 59.09083],
              [18.021385, 59.041939],
              [17.895832, 58.90972],
              [17.89278, 58.903053],
              [17.891388, 58.89666],
              [17.89194, 58.874161],
              [17.894722, 58.85889],
              [17.789444, 58.943054000000132],
              [17.756664000000114, 59.018326000000116],
              [17.768887, 59.096664],
              [17.768330000000105, 59.113609],
              [17.7666660000001, 59.118889],
              [17.764721000000122, 59.123886],
              [17.759163000000115, 59.126663],
              [17.66861, 59.166382],
              [17.663887, 59.16833],
              [17.624165, 59.07444],
              [17.611664000000133, 59.04055],
              [17.610275000000115, 59.034439000000134],
              [17.612221, 59.029442],
              [17.617222, 59.025276000000133],
              [17.62555, 59.01639],
              [17.62889, 59.011665],
              [17.61360900000011, 58.974716000000114],
              [17.578327000000115, 58.950508000000127],
              [17.59139, 58.943604],
              [17.630554, 58.914993],
              [17.62917, 58.908882],
              [17.62611, 58.901939],
              [17.58333, 58.849442000000124],
              [17.578888, 58.845551],
              [17.349998, 58.752220000000136],
              [17.271111, 58.736938000000123],
              [17.22361, 58.7305530000001],
              [17.156666, 58.732773000000122],
              [17.093609, 58.76249700000011],
              [17.083332, 58.76361],
              [17.032776, 58.750549],
              [17.028610000000128, 58.746941],
              [17.033607, 58.742775000000108],
              [17.082222, 58.723053],
              [17.134163, 58.702217],
              [17.145554000000118, 58.700272],
              [17.143055000000118, 58.69472],
              [17.13833, 58.68972],
              [17.034443000000124, 58.637215],
              [16.915276, 58.616943000000106],
              [16.90528, 58.616104000000121],
              [16.89333, 58.616661],
              [16.789719, 58.623604],
              [16.736122000000137, 58.62899],
              [16.677776, 58.63694],
              [16.461388, 58.655548],
              [16.436386, 58.65749],
              [16.41278, 58.658882],
              [16.29833200000013, 58.66305],
              [16.242222, 58.664719],
              [16.233608, 58.66305],
              [16.193607, 58.627495000000124],
              [16.293331, 58.61360900000011],
              [16.37055, 58.60527],
              [16.41166, 58.613327],
              [16.432499, 58.637772],
              [16.436665, 58.64138800000012],
              [16.649441000000138, 58.620552],
              [16.710831, 58.606667],
              [16.72722, 58.600555],
              [16.777496, 58.581383],
              [16.928608, 58.492493],
              [16.93861, 58.484161],
              [16.83472, 58.445],
              [16.826942, 58.442215],
              [16.809166000000118, 58.438606000000107],
              [16.75444, 58.429443000000106],
              [16.737778, 58.428604000000121],
              [16.600555, 58.446938000000102],
              [16.578053, 58.450829],
              [16.568619, 58.453239],
              [16.548885, 58.45833],
              [16.5325, 58.464439],
              [16.514721, 58.469994],
              [16.496666, 58.475273],
              [16.47555, 58.479721],
              [16.435555, 58.479996],
              [16.425552, 58.47916],
              [16.416943, 58.477219],
              [16.41333, 58.474716],
              [16.573055, 58.435829],
              [16.68361, 58.41083],
              [16.693886000000134, 58.409721],
              [16.71, 58.40361],
              [16.769997, 58.367218],
              [16.78889, 58.32222],
              [16.824718, 58.19944],
              [16.825832, 58.176666],
              [16.80282, 58.138672],
              [16.764471, 58.125179],
              [16.742811, 58.08612],
              [16.731806, 58.049198],
              [16.75027, 58.012772],
              [16.743610000000103, 58.009163000000115],
              [16.639252, 57.98749],
              [16.622498, 57.988609],
              [16.61389, 57.986938],
              [16.62194, 57.983887],
              [16.6555, 57.977745],
              [16.671944, 57.980270000000132],
              [16.725277, 57.974159],
              [16.733055, 57.971107000000131],
              [16.739998, 57.961937],
              [16.744164, 57.953049],
              [16.742561000000137, 57.950333],
              [16.773331, 57.923607000000118],
              [16.778053000000114, 57.919441],
              [16.78, 57.914444000000117],
              [16.770554000000118, 57.884438],
              [16.763885, 57.881104],
              [16.749443, 57.874992],
              [16.741665, 57.872498],
              [16.732498000000135, 57.872772000000111],
              [16.65916, 57.883331000000112],
              [16.622219, 57.890274],
              [16.61360900000011, 57.89222],
              [16.6025, 57.922775],
              [16.60611, 57.925278],
              [16.60278, 57.940277],
              [16.518608, 57.99694],
              [16.510555, 57.996384],
              [16.502777, 57.993889],
              [16.49861, 57.990273],
              [16.495552, 57.98555],
              [16.494442, 57.979439000000127],
              [16.522331000000122, 57.87783],
              [16.56433, 57.854164],
              [16.677219, 57.765549],
              [16.693333, 57.753883],
              [16.703331, 57.745552],
              [16.700706, 57.74015],
              [16.692219, 57.738884],
              [16.68444, 57.742218],
              [16.618889, 57.771385000000123],
              [16.615555, 57.776108000000136],
              [16.61138, 57.786385000000109],
              [16.60278, 57.794716],
              [16.590553000000114, 57.802773],
              [16.561108, 57.821388],
              [16.554722, 57.82499700000011],
              [16.418610000000115, 57.893326],
              [16.418888, 57.88721],
              [16.420830000000137, 57.882500000000107],
              [16.463421, 57.849297],
              [16.469753, 57.844627],
              [16.47642, 57.839966],
              [16.593775, 57.773163],
              [16.605442, 57.76683],
              [16.660553000000107, 57.741104],
              [16.692219, 57.721939],
              [16.701942, 57.713882000000126],
              [16.710278, 57.705276],
              [16.7125, 57.699997],
              [16.625553, 57.61972],
              [16.6325, 57.552216],
              [16.689163000000121, 57.485275],
              [16.693333, 57.475273000000129],
              [16.693333, 57.469162],
              [16.67139, 57.41083],
              [16.664719, 57.407494],
              [16.65583, 57.405],
              [16.63694, 57.403053000000114],
              [16.63222, 57.38166],
              [16.63111, 57.376938000000109],
              [16.624165000000119, 57.374443],
              [16.60083, 57.377495],
              [16.566387, 57.383331],
              [16.554996, 57.383606],
              [16.546108000000117, 57.38166],
              [16.541943000000117, 57.376938000000109],
              [16.472221, 57.290276],
              [16.467220000000111, 57.27666],
              [16.464722, 57.264442],
              [16.455555, 57.205276],
              [16.455276, 57.200554],
              [16.458054, 57.178329],
              [16.460278, 57.167496],
              [16.467220000000111, 57.158607000000131],
              [16.513885, 57.117218],
              [16.523331, 57.11666],
              [16.530277000000126, 57.119438],
              [16.539997, 57.120552],
              [16.546108000000117, 57.116943],
              [16.563332, 57.093887],
              [16.584164000000101, 57.049438],
              [16.584721, 57.043884],
              [16.501663000000121, 57.03666],
              [16.49277, 57.03916],
              [16.454441, 56.95527600000014],
              [16.440552, 56.89388300000013],
              [16.426666, 56.843605],
              [16.407776, 56.79555],
              [16.375, 56.720833],
              [16.308052, 56.655],
              [16.30055, 56.65833],
              [16.29055, 56.65916],
              [16.272499, 56.656662],
              [16.253609, 56.64611],
              [16.21611, 56.607216],
              [16.123886, 56.461662],
              [16.117222, 56.449715],
              [16.10416, 56.425552],
              [16.090553, 56.394997],
              [16.054722, 56.313606],
              [16.043331000000137, 56.268883],
              [16.008331, 56.217773000000136],
              [15.99861, 56.208328],
              [15.86555, 56.09222],
              [15.78861, 56.111938],
              [15.77583, 56.147774],
              [15.658888, 56.178886],
              [15.59805, 56.194717],
              [15.37528, 56.138054000000125],
              [15.225832, 56.151108],
              [15.088888000000111, 56.16],
              [14.84805, 56.161385],
              [14.717222000000106, 56.1616590000001],
              [14.696665, 56.161110000000122],
              [14.69055, 56.15778],
              [14.686666, 56.152771],
              [14.679722, 56.132500000000107],
              [14.679443000000106, 56.120552],
              [14.681944000000101, 56.11555],
              [14.686666, 56.111382],
              [14.69278, 56.108055],
              [14.709999, 56.102776000000119],
              [14.714722, 56.09916],
              [14.750832000000116, 56.059715],
              [14.76778, 56.036385000000109],
              [14.76667, 56.030273000000136],
              [14.738333000000125, 56.010826],
              [14.72, 56.00027],
              [14.63528, 56.0075],
              [14.620832, 56.029442],
              [14.603611, 56.051941],
              [14.558887, 56.05722],
              [14.551388, 56.055275],
              [14.541388, 56.051109],
              [14.51166, 56.0375],
              [14.36944, 55.958885],
              [14.330276, 55.93694],
              [14.263611, 55.886108],
              [14.24472, 55.866943000000106],
              [14.232777, 55.85166],
              [14.217222, 55.83027600000014],
              [14.207777000000135, 55.812492],
              [14.202776, 55.799721],
              [14.200554, 55.792770000000132],
              [14.196665, 55.779716],
              [14.193333, 55.766663000000108],
              [14.190832, 55.74166],
              [14.19111, 55.731384],
              [14.19222, 55.72583],
              [14.19611, 55.715828],
              [14.203333, 55.70694],
              [14.217777000000126, 55.694717],
              [14.276943, 55.647217],
              [14.341389, 55.578606],
              [14.363333000000125, 55.551941],
              [14.37028, 55.54277],
              [14.37278, 55.537773000000129],
              [14.369165, 55.531662],
              [14.361944000000108, 55.522774],
              [14.336666, 55.501106000000107],
              [14.312498, 55.486664000000133],
              [14.193546, 55.386147],
              [14.16305, 55.380272000000105],
              [14.122499, 55.37944],
              [14.058887000000141, 55.38611],
              [14.0375, 55.38944],
              [14.00472, 55.40583],
              [13.969444, 55.421104000000128],
              [13.93583, 55.431389],
              [13.911943, 55.433884],
              [13.89139, 55.433609],
              [13.73055, 55.425552],
              [13.710278, 55.424164],
              [13.6416660000001, 55.417496],
              [13.632221, 55.415833],
              [13.497776000000101, 55.38222],
              [13.465832, 55.3736],
              [13.429722, 55.35666700000013],
              [13.418333, 55.352493],
              [13.375555000000134, 55.339996],
              [13.344721000000106, 55.339165],
              [13.300833, 55.340828],
              [13.289999000000137, 55.341942],
              [12.982222, 55.400551],
              [12.918055, 55.538605],
              [12.91639, 55.54416700000013],
              [12.914444, 55.562218000000144],
              [12.914721, 55.565552000000139],
              [12.91639, 55.568329],
              [12.922499, 55.57471],
              [12.93111, 55.581108],
              [12.960278, 55.59111],
              [12.981943, 55.599159],
              [13.034721000000104, 55.623886],
              [13.0405540000001, 55.627495],
              [13.044998, 55.6325],
              [13.058887000000141, 55.662773],
              [13.063332, 55.68222],
              [13.0625, 55.684998],
              [13.059721, 55.693054],
              [12.92805, 55.823051],
              [12.912777000000119, 55.838051],
              [12.681389, 56.061943],
              [12.66361, 56.078606],
              [12.63389, 56.10305],
              [12.623888, 56.107773],
              [12.615, 56.109444],
              [12.609722, 56.111664],
              [12.58111, 56.141663000000108],
              [12.453054000000122, 56.29333],
              [12.451666, 56.297775000000115],
              [12.461666, 56.298332],
              [12.47389, 56.297218],
              [12.629166, 56.258888],
              [12.645277000000135, 56.253326000000129],
              [12.718681, 56.222778],
              [12.78722, 56.222221000000104],
              [12.794443, 56.223053],
              [12.801943000000108, 56.225555],
              [12.813332000000116, 56.232773],
              [12.824165, 56.241661],
              [12.830089, 56.250000000000114],
              [12.83166, 56.252220000000136],
              [12.834721, 56.258049000000142],
              [12.835, 56.26416],
              [12.833055, 56.269165],
              [12.740833, 56.352219],
              [12.730555, 56.359444],
              [12.72389, 56.36305],
              [12.676109, 56.379715],
              [12.66389, 56.380272000000105],
              [12.644722, 56.38472],
              [12.636665, 56.38777],
              [12.62611, 56.395271],
              [12.62278, 56.399994],
              [12.622221, 56.411942],
              [12.62639, 56.424721],
              [12.62861, 56.431389],
              [12.63194, 56.436943],
              [12.635555, 56.44221],
              [12.641388, 56.446106],
              [12.672777, 56.463608],
              [12.67972200000014, 56.466385],
              [12.721943000000124, 56.4675],
              [12.732498, 56.4675],
              [12.74917, 56.464722],
              [12.78583, 56.450272],
              [12.793333, 56.447777],
              [12.812498, 56.443329000000119],
              [12.832777000000135, 56.439720000000136],
              [12.85265, 56.439919],
              [12.86861, 56.441383],
              [12.87611, 56.4436],
              [12.88361, 56.446388],
              [12.90111, 56.457222],
              [12.910831, 56.466942],
              [12.918055, 56.478333],
              [12.930277, 56.501106000000107],
              [12.937498, 56.521111],
              [12.93694, 56.532494],
              [12.933332, 56.543327],
              [12.93139, 56.54833200000013],
              [12.91722, 56.57861],
              [12.887499000000105, 56.638329],
              [12.876665, 56.646385],
              [12.86916, 56.648888],
              [12.821665, 56.65833],
              [12.813332000000116, 56.656662],
              [12.785000000000139, 56.643608],
              [12.758055, 56.64],
              [12.725277000000119, 56.639717000000132],
              [12.718611000000124, 56.643326000000116],
              [12.67083, 56.67610900000011],
              [12.613609, 56.746941],
              [12.599998, 56.777771],
              [12.59833, 56.783333],
              [12.599165, 56.79583],
              [12.601387, 56.8025],
              [12.599998, 56.80805],
              [12.597500000000139, 56.813332],
              [12.593332, 56.817497],
              [12.579443, 56.830276],
              [12.573889, 56.833885000000123],
              [12.484722, 56.88166],
              [12.468332, 56.887772],
              [12.41805, 56.897217000000126],
              [12.350277000000119, 56.914444],
              [12.3475, 56.91916700000013],
              [12.349998, 56.969994],
              [12.28611, 57.03249],
              [12.25361, 57.04805],
              [12.237778, 57.059715],
              [12.149443000000133, 57.183884],
              [12.146666, 57.188332],
              [12.109999, 57.25],
              [12.13472, 57.275551000000121],
              [12.148611, 57.281105000000139],
              [12.151388000000111, 57.287216],
              [12.14583, 57.309166],
              [12.094999, 57.426941],
              [12.058332, 57.45472],
              [12.05139, 57.457771],
              [12.043888, 57.45972],
              [12.036943000000122, 57.45694],
              [12.011665000000107, 57.434166000000118],
              [12.007776, 57.428886],
              [12.005833, 57.422218],
              [12.00861, 57.411385000000109],
              [12.007776, 57.405],
              [11.989443, 57.3475],
              [11.986111, 57.341385],
              [11.97917, 57.343605],
              [11.94278, 57.376106],
              [11.917776, 57.402222000000108],
              [11.904165, 57.42194400000011],
              [11.901388, 57.426666],
              [11.906666, 57.514999000000103],
              [11.911112, 57.52665],
              [11.913332, 57.52861],
              [11.915833, 57.534439],
              [11.922222, 57.563889000000131],
              [11.913332, 57.613609],
              [11.91055, 57.618607],
              [11.906387, 57.623329],
              [11.897499, 57.624443],
              [11.894444, 57.618332000000123],
              [11.862499, 57.607773],
              [11.83, 57.661385],
              [11.86861, 57.68055],
              [11.887777, 57.693886000000134],
              [11.75055, 57.688889],
              [11.741388, 57.688606],
              [11.704443, 57.693329],
              [11.698889000000122, 57.697220000000129],
              [11.699720000000127, 57.71583],
              [11.72305, 57.80722],
              [11.668055, 57.84583],
              [11.688055, 57.88166],
              [11.694166000000109, 57.885277],
              [11.702221000000122, 57.88721],
              [11.711666, 57.88916],
              [11.741388, 57.89222],
              [11.75722, 57.897217000000126],
              [11.795555, 58.0061],
              [11.801388, 58.026382],
              [11.80055, 58.038055],
              [11.799166, 58.043884],
              [11.79361, 58.048050000000103],
              [11.776667, 58.05314],
              [11.776667, 58.059441000000106],
              [11.79611, 58.095276],
              [11.83722, 58.154716],
              [11.87028, 58.19111],
              [11.88083, 58.19999700000011],
              [11.884722, 58.205276],
              [11.88611, 58.211937],
              [11.798054, 58.318329],
              [11.734999, 58.328331],
              [11.723331, 58.328888],
              [11.622776, 58.276108],
              [11.6075, 58.262772],
              [11.594721000000106, 58.255272],
              [11.53611, 58.23027],
              [11.526388, 58.230553],
              [11.5158330000001, 58.23194100000012],
              [11.49528, 58.236107],
              [11.405554, 58.261108],
              [11.384165, 58.311943],
              [11.238333000000125, 58.346939],
              [11.201387000000125, 58.399437],
              [11.235554, 58.505272000000105],
              [11.254166, 58.551109],
              [11.257221, 58.556938],
              [11.266388, 58.57944],
              [11.26111, 58.632217],
              [11.259443, 58.637772],
              [11.252222, 58.653053],
              [11.24778, 58.65749],
              [11.210278, 58.679718],
              [11.180832, 58.70916],
              [11.17805, 58.713882],
              [11.176943, 58.730827],
              [11.181665, 58.747772],
              [11.200832, 58.769997],
              [11.218054, 58.78416],
              [11.229166000000134, 58.79222],
              [11.233889, 58.79694400000011],
              [11.236111000000108, 58.803604],
              [11.233055, 58.833054],
              [11.23139, 58.845276],
              [11.194166, 58.917496],
              [11.166666, 58.924438000000123],
              [11.131943, 58.935272],
              [11.123055000000136, 58.938332],
              [11.115833000000123, 58.941383],
              [11.106943, 58.95],
              [11.113333, 59.003609],
              [11.119165000000123, 59.015831],
              [11.127499000000114, 59.02638],
              [11.166388, 59.064438],
              [11.172499, 59.068604],
              [11.18667, 59.074997],
              [11.204166, 59.079437],
              [11.26555, 59.093887],
              [11.314999000000114, 59.101387],
              [11.324999000000105, 59.0991590000001],
              [11.338333, 59.091942],
              [11.349998000000141, 59.084442],
              [11.373333, 59.050827],
              [11.401667, 59.012772],
              [11.419443, 58.989716],
              [11.427082, 58.985786000000132],
              [11.429192, 58.98764],
              [11.423054, 58.926666],
              [11.422777, 58.920273000000122],
              [11.424999, 58.903053],
              [11.426109, 58.897217],
              [11.42778, 58.893051],
              [11.431944, 58.88861],
              [11.439165000000116, 58.885277],
              [11.450832, 58.883888],
              [11.463055, 58.88361],
              [11.49667, 58.884720000000129],
              [11.585833, 58.89666],
              [11.599968000000104, 58.899185],
              [11.621387, 58.904716],
              [11.626665000000116, 58.909164],
              [11.75111, 59.090271],
              [11.75305, 59.09722],
              [11.751944, 59.102776],
              [11.746387, 59.112778],
              [11.742222, 59.117493],
              [11.739443, 59.122498],
              [11.739443, 59.12722],
              [11.750832, 59.174438],
              [11.754444, 59.188049],
              [11.759165, 59.200829],
              [11.764721, 59.211662],
              [11.769547, 59.217537],
              [11.784721, 59.23027],
              [11.792288, 59.236641000000134],
              [11.795277, 59.23917],
              [11.79833, 59.245277],
              [11.798887, 59.257774],
              [11.796944, 59.275276],
              [11.79083, 59.303329],
              [11.783054000000106, 59.324715],
              [11.739166, 59.429718],
              [11.667776000000117, 59.59166],
              [11.666248, 59.595482],
              [11.75639, 59.635551000000135],
              [11.76417, 59.63833],
              [11.781666, 59.642776],
              [11.811666000000116, 59.646942],
              [11.820555, 59.648888],
              [11.82833, 59.651939],
              [11.896387000000118, 59.695],
              [11.900833, 59.70111],
              [11.902777, 59.707771],
              [11.903332, 59.720276000000126],
              [11.903055, 59.738327],
              [11.89885, 59.772469],
              [11.896387000000118, 59.784721],
              [11.891109, 59.79472],
              [11.886665, 59.799164000000133],
              [11.881109, 59.803886],
              [11.86944, 59.811661],
              [11.815960000000132, 59.8461],
              [11.852777000000117, 59.861382],
              [11.875832, 59.869995000000131],
              [11.956944, 59.896942],
              [11.968054, 59.89777400000014],
              [11.98, 59.896111],
              [11.998055, 59.890549],
              [12.008333000000107, 59.88861],
              [12.034166, 59.88611],
              [12.10722, 59.885826000000122],
              [12.129721, 59.88694],
              [12.14, 59.888329000000113],
              [12.16305, 59.896942],
              [12.191944, 59.910271000000137],
              [12.310276000000101, 59.968887],
              [12.32361, 59.97639],
              [12.461943, 60.063606],
              [12.476944, 60.076385],
              [12.489166, 60.098328],
              [12.494165000000123, 60.111107000000118],
              [12.496387000000141, 60.11805],
              [12.498333, 60.124718],
              [12.502777, 60.144722],
              [12.5075, 60.16944100000012],
              [12.508055, 60.175552],
              [12.508333, 60.181938000000116],
              [12.507776, 60.193604000000107],
              [12.504444, 60.210548],
              [12.527777000000128, 60.334160000000111],
              [12.537777000000119, 60.343887],
              [12.57194, 60.378052],
              [12.589722, 60.399162],
              [12.597500000000139, 60.424995],
              [12.60278, 60.44277],
              [12.607498000000135, 60.462494],
              [12.608055, 60.468605],
              [12.605833, 60.479996],
              [12.594444, 60.51694],
              [12.5875, 60.526665],
              [12.505833000000109, 60.629997000000117],
              [12.424999, 60.71027400000014],
              [12.38611, 60.750832],
              [12.378887000000134, 60.760277],
              [12.364721, 60.779442],
              [12.353611000000114, 60.79972],
              [12.351110000000119, 60.804718],
              [12.336111, 60.835831],
              [12.308611, 60.887215],
              [12.271944, 60.946106],
              [12.245554, 60.973053000000107],
              [12.233610000000112, 60.98083],
              [12.217222, 60.99305],
              [12.212776, 60.997498],
              [12.21, 61.002495],
              [12.215555, 61.006943],
              [12.222500000000139, 61.01083],
              [12.24778, 61.01861],
              [12.294167, 61.029442],
              [12.388054000000125, 61.05055],
              [12.40778, 61.053886],
              [12.432499, 61.054443],
              [12.458055, 61.053886],
              [12.500277, 61.05082700000014],
              [12.567221, 61.04805],
              [12.60222, 61.049721],
              [12.621944, 61.053055],
              [12.637825000000134, 61.057541],
              [12.670277, 61.087776],
              [12.772221000000116, 61.20083],
              [12.796665, 61.244995000000131],
              [12.83111, 61.312218],
              [12.85611, 61.362495000000138],
              [12.773888, 61.414719],
              [12.53, 61.566109],
              [12.52305, 61.567215],
              [12.481388, 61.569443],
              [12.468332, 61.56972],
              [12.444721, 61.568604000000107],
              [12.430277000000103, 61.569443],
              [12.40667, 61.573326],
              [12.392776, 61.580551],
              [12.144444, 61.7175],
              [12.12444, 61.72861],
              [12.159443000000124, 61.844444],
              [12.169998, 61.87861],
              [12.181665, 61.912498000000141],
              [12.200277, 61.963333],
              [12.214998, 62.006104],
              [12.25861, 62.142494],
              [12.294617, 62.258217],
              [12.295832000000132, 62.261665],
              [12.291666, 62.272499],
              [12.271387000000118, 62.30805],
              [12.256388, 62.327217],
              [12.245344, 62.337982000000125],
              [12.21, 62.389999000000103],
              [12.19972, 62.404716000000121],
              [12.18444, 62.423882],
              [12.17222, 62.43777],
              [12.14917, 62.46027400000014],
              [12.084721, 62.52916],
              [12.047499, 62.589996],
              [12.046665, 62.665276],
              [12.07278, 62.715828000000101],
              [12.089443, 62.74944],
              [12.066666, 62.80305],
              [12.050278, 62.838882],
              [12.028889, 62.892494],
              [12.058332, 62.918610000000115],
              [12.113333, 62.967216000000121],
              [12.15111, 62.999443],
              [12.16861, 63.015831],
              [12.144165, 63.045273000000122],
              [12.036943000000122, 63.173882],
              [12.027491, 63.182449],
              [11.936388, 63.272217],
              [11.998888, 63.323883],
              [12.0783330000001, 63.388329000000113],
              [12.13722, 63.436661],
              [12.195000000000107, 63.485275000000115],
              [12.17861, 63.512215],
              [12.139444, 63.58416],
              [12.153889000000106, 63.594994],
              [12.346666, 63.728882000000112],
              [12.47305, 63.833328],
              [12.53083, 63.87277],
              [12.63389, 63.942772],
              [12.681944, 63.967216000000121],
              [12.794443, 64.007217],
              [12.846943, 64.025269],
              [12.93805, 64.053329000000133],
              [12.988333000000125, 64.064438],
              [13.032221, 64.071106],
              [13.135555000000124, 64.083603],
              [13.193609, 64.09],
              [13.23, 64.093048],
              [13.29139, 64.086655000000121],
              [13.98166700000013, 64.013046],
              [13.988333000000125, 64.018051000000128],
              [14.14667, 64.173874],
              [14.154722, 64.185822],
              [14.151388, 64.3336],
              [14.149721, 64.34499],
              [14.11639, 64.470551],
              [14.032499, 64.488052],
              [13.900833, 64.507492],
              [13.82028, 64.529434],
              [13.68222, 64.5711060000001],
              [13.663332, 64.577209],
              [13.6625, 64.582764000000111],
              [13.664999000000137, 64.589722000000108],
              [13.676943, 64.607773000000122],
              [13.69694, 64.62944],
              [13.7075, 64.63971],
              [13.725571, 64.652267],
              [13.832777000000135, 64.733322000000101],
              [13.879166, 64.771103],
              [13.95583, 64.835541000000148],
              [14.09139, 64.949158],
              [14.235277, 65.048874000000126],
              [14.296438000000137, 65.102127],
              [14.30883, 65.115234],
              [14.319443, 65.12999],
              [14.329166, 65.149719],
              [14.35611, 65.208603],
              [14.368889, 65.246658000000139],
              [14.493055, 65.313599],
              [14.494444000000101, 65.358887],
              [14.49361, 65.376389000000131],
              [14.495277000000101, 65.446381],
              [14.49722, 65.516098],
              [14.50055, 65.585831],
              [14.532221000000106, 65.69611],
              [14.535, 65.702774],
              [14.53944, 65.708878000000141],
              [14.565277, 65.736374],
              [14.588055, 65.75694],
              [14.60389, 65.773331],
              [14.621387000000141, 65.797211],
              [14.631666000000109, 65.816666],
              [14.634722, 65.826935],
              [14.608889, 65.876389],
              [14.58027600000014, 65.931107],
              [14.56944, 65.949432000000115],
              [14.54055, 66.007492],
              [14.534721, 66.025269],
              [14.519165, 66.07888800000012],
              [14.509165, 66.11472],
              [14.505, 66.132492000000127],
              [14.717777, 66.140549],
              [14.981388, 66.149155],
              [15.025276, 66.149994],
              [15.468054, 66.28387],
              [15.446854, 66.32138],
              [15.400555, 66.406937],
              [15.371387, 66.461655],
              [15.362778, 66.479996],
              [15.527777, 66.558044],
              [15.625832, 66.605820000000108],
              [15.73111, 66.684998000000121],
              [16.00999800000011, 66.890823],
              [16.353886, 67.017776],
              [16.40583, 67.16333],
              [16.399166, 67.177765],
              [16.36138, 67.237778],
              [16.3375, 67.260818],
              [16.26194, 67.305542],
              [16.220554, 67.329987],
              [16.204720000000123, 67.337494],
              [16.161663, 67.35582],
              [16.138611000000139, 67.36749],
              [16.11111, 67.383606],
              [16.10416, 67.387772],
              [16.089722, 67.401657],
              [16.086941000000138, 67.406662],
              [16.085831, 67.411652000000117],
              [16.192219000000136, 67.5],
              [16.206108, 67.501663000000121],
              [16.3825, 67.515549],
              [16.403332, 67.529999],
              [16.508331000000112, 67.60916],
              [16.57027, 67.656937],
              [16.57694, 67.665543000000127],
              [16.588055, 67.682220000000143],
              [16.620277000000101, 67.732208],
              [16.68472, 67.83221],
              [16.726944000000117, 67.899155],
              [17.188332, 68.030273],
              [17.234547, 68.062103],
              [17.252583, 68.07457],
              [17.273609, 68.090546],
              [17.5925, 68.029709],
              [17.648888, 68.01416],
              [17.68027, 68.004440000000102],
              [17.74333, 67.984711],
              [17.801941, 67.964157],
              [17.82, 67.95694],
              [17.83111, 67.953598],
              [17.858055, 67.94861],
              [17.884163, 67.945541],
              [17.939720000000136, 67.997772000000111],
              [18.135555, 68.150269],
              [18.155277, 68.16611],
              [18.103886, 68.280823],
              [18.085831, 68.317764000000125],
              [18.069443, 68.35443],
              [18.053333, 68.391098000000113],
              [18.04583, 68.409439000000134],
              [18.058052, 68.439987],
              [18.08166, 68.490829],
              [18.09083, 68.507767000000115],
              [18.099541, 68.508926],
              [18.149441, 68.515274],
              [18.35805, 68.539154],
              [18.611942, 68.475266],
              [18.952221, 68.487778],
              [19.41333, 68.419434],
              [19.543888, 68.399719],
              [19.71722, 68.372772000000111],
              [19.860554, 68.349991000000102],
              [19.898331, 68.341385],
              [19.92388, 68.336655],
              [19.937775000000101, 68.337494000000106],
              [19.94805, 68.34082],
              [19.956665, 68.344711],
              [19.96416, 68.349716000000114],
              [19.976665, 68.361374000000126],
              [20.006664, 68.381104000000107],
              [20.03028, 68.394989],
              [20.048054, 68.403320000000122],
              [20.07583, 68.414719],
              [20.167221, 68.44388],
              [20.175831, 68.448044],
              [20.198608, 68.462769],
              [20.208611, 68.47583],
              [20.211109, 68.482208000000128],
              [20.088055, 68.501663],
              [19.956387, 68.543884000000105],
              [20.063053, 68.583054],
              [20.177219, 68.646942],
              [20.202499000000103, 68.662216],
              [20.23833100000013, 68.691376],
              [20.313889, 68.754715000000147],
              [20.350277000000119, 68.786652000000117],
              [20.314720000000136, 68.92833],
              [20.238888, 68.968597],
              [20.096943, 69.042221],
              [20.535275, 69.05638],
              [20.580929, 69.0603],
              [20.604164000000139, 69.05305],
              [20.65006, 69.043793000000107],
              [20.744164, 69.0311],
              [20.79166, 69.023331],
              [20.846386000000109, 69.011932],
              [20.866665, 69.00499],
              [20.884441, 68.997498],
              [20.908886, 68.985550000000103],
              [20.928608000000111, 68.97305],
              [20.932777000000101, 68.968323000000112],
              [20.938889, 68.958328],
              [20.938332, 68.952774],
              [20.93111, 68.946381],
              [20.915554, 68.939438],
              [20.888885, 68.925827],
              [20.883053000000132, 68.91333],
              [20.88277, 68.907776000000126],
              [20.888611, 68.898041],
              [20.895275, 68.893600000000106],
              [20.904163, 68.889999],
              [20.915276000000119, 68.886658],
              [20.94472, 68.88138],
              [20.959442000000138, 68.87999],
              [20.990833, 68.87944],
              [21.02472, 68.877487],
              [21.058887000000141, 68.873322],
              [21.081387, 68.86665],
              [21.207775, 68.81972],
              [21.21666, 68.816101000000117],
              [21.420555, 68.724152],
              [21.44861, 68.691101],
              [21.452774, 68.686661],
              [21.465553000000114, 68.678055],
              [21.487499000000128, 68.67139],
              [21.500832, 68.66832],
              [21.55055, 68.661652],
              [21.585278, 68.6586],
              [21.601109000000122, 68.6561],
              [21.62305, 68.649429],
              [21.64277600000014, 68.642487],
              [21.701664, 68.62082],
              [21.710278, 68.617218],
              [21.714165, 68.612488],
              [21.711109, 68.606384],
              [21.710552, 68.60055],
              [21.71833, 68.591110000000128],
              [21.735554, 68.5836],
              [21.757500000000107, 68.576935],
              [21.773331, 68.574432],
              [21.809166, 68.570541],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "SZ",
        ISO2: "CH",
        ISO3: "CHE",
        UN: 756,
        NAME: "Switzerland",
        AREA: 4000,
        POP2005: 7424389,
        REGION: 150,
        SUBREGION: 155,
        LON: 7.908,
        LAT: 46.861,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7.697223, 47.543327],
            [7.769722, 47.553329],
            [7.906388, 47.558052],
            [7.91361, 47.553886],
            [7.918888, 47.552773],
            [7.931944, 47.552216],
            [8.033333, 47.556107],
            [8.086666, 47.560555],
            [8.092222, 47.561661],
            [8.099722, 47.565552],
            [8.102499, 47.568329],
            [8.103888, 47.571938],
            [8.108055, 47.578331],
            [8.110832, 47.581108],
            [8.185276, 47.617218],
            [8.193333, 47.620827],
            [8.198889, 47.621666],
            [8.205555, 47.621666],
            [8.240833, 47.619438],
            [8.283333, 47.613052],
            [8.288055, 47.611664],
            [8.2925, 47.605827],
            [8.390833, 47.579994],
            [8.435833, 47.573608],
            [8.464998, 47.602493],
            [8.477499, 47.612221],
            [8.51111, 47.631104],
            [8.519999, 47.634163],
            [8.531387, 47.632774],
            [8.558332, 47.623329],
            [8.562222, 47.621384],
            [8.565554, 47.614441],
            [8.56943, 47.598537],
            [8.57642, 47.59137],
            [8.591389, 47.599442],
            [8.594721, 47.601662],
            [8.629166, 47.646111],
            [8.630833, 47.649719],
            [8.629444, 47.653328],
            [8.626944, 47.656105],
            [8.620832, 47.66111],
            [8.610254, 47.667732],
            [8.580555, 47.66861],
            [8.551388, 47.668327],
            [8.545832, 47.667496],
            [8.536943, 47.664444],
            [8.528055, 47.656944],
            [8.525833, 47.65361],
            [8.518332, 47.649719],
            [8.495277, 47.647217],
            [8.475555, 47.646942],
            [8.424721, 47.669441],
            [8.413332, 47.678329],
            [8.407221, 47.699715],
            [8.406666, 47.703888],
            [8.473331, 47.767494],
            [8.47611, 47.769997],
            [8.479443, 47.772499],
            [8.559721, 47.806389],
            [8.566111, 47.806938],
            [8.60861, 47.804161],
            [8.614721, 47.803604],
            [8.661388, 47.79805],
            [8.685555, 47.786659],
            [8.734999, 47.761383],
            [8.736944, 47.758049],
            [8.736944, 47.75444],
            [8.734999, 47.713882],
            [8.734165, 47.709717],
            [8.730698, 47.705673],
            [8.729166, 47.703888],
            [8.720222, 47.696625],
            [8.745277, 47.695],
            [8.761389, 47.692215],
            [8.800133, 47.681725],
            [8.774721, 47.710274],
            [8.772778, 47.713333],
            [8.772221, 47.717499],
            [8.777777, 47.722771],
            [8.799999, 47.735275],
            [8.804165, 47.737221],
            [8.808887, 47.735832],
            [8.835278, 47.718048],
            [8.855833, 47.698883],
            [8.883299, 47.654148],
            [8.892776, 47.651382],
            [8.904999, 47.650276],
            [8.917776, 47.650551],
            [8.934166, 47.653053],
            [8.947777, 47.657494],
            [8.973331, 47.667496],
            [8.985554, 47.672775],
            [8.996666, 47.679161],
            [9.004999, 47.682495],
            [9.024166, 47.687775],
            [9.0425, 47.688889],
            [9.078333, 47.685829],
            [9.086943, 47.684998],
            [9.261095, 47.662842],
            [9.478322, 47.575851],
            [9.566724, 47.540451],
            [9.557772, 47.505783],
            [9.559721, 47.499718],
            [9.562222, 47.496666],
            [9.567499, 47.491104],
            [9.590277, 47.470276],
            [9.594166, 47.46833],
            [9.611666, 47.468887],
            [9.646944, 47.460274],
            [9.65111, 47.458328],
            [9.65361, 47.455551],
            [9.673332, 47.398605],
            [9.673054, 47.394997],
            [9.669998, 47.387772],
            [9.664999, 47.381386],
            [9.650555, 47.373055],
            [9.641666, 47.369995],
            [9.631388, 47.36805],
            [9.625832, 47.367218],
            [9.624422, 47.367252],
            [9.614443, 47.367493],
            [9.605276, 47.359993],
            [9.599722, 47.354164],
            [9.539999, 47.284164],
            [9.533569, 47.274544],
            [9.502222, 47.231384],
            [9.491388, 47.215271],
            [9.485832, 47.200272],
            [9.484165, 47.192215],
            [9.484444, 47.179718],
            [9.489721, 47.16555],
            [9.49861, 47.15361],
            [9.505554, 47.139999],
            [9.511389, 47.121666],
            [9.512777, 47.109444],
            [9.512499, 47.100273],
            [9.510277, 47.092499],
            [9.474637, 47.057457],
            [9.485277, 47.061104],
            [9.506388, 47.06472],
            [9.538055, 47.07],
            [9.544722, 47.07],
            [9.598635, 47.063835],
            [9.6325, 47.056664],
            [9.719444, 47.050278],
            [9.870277, 47.023598],
            [9.875555, 47.022491],
            [9.891943, 47.003876],
            [9.893055, 47.000267],
            [9.889444, 46.993324],
            [9.880833, 46.98082],
            [9.875555, 46.970543],
            [9.873333, 46.962769],
            [9.87361, 46.958603],
            [9.87611, 46.941658],
            [9.879444, 46.939156],
            [9.934999, 46.912773],
            [10.058887, 46.866386],
            [10.109444, 46.850273],
            [10.122776, 46.849716],
            [10.140276, 46.851105],
            [10.141807, 46.851341],
            [10.15111, 46.852776],
            [10.170555, 46.857216],
            [10.22361, 46.874992],
            [10.231388, 46.878883],
            [10.313332, 46.933609],
            [10.323332, 46.955551],
            [10.345833, 46.986382],
            [10.353611, 46.994995],
            [10.357222, 46.997215],
            [10.385555, 47.002777],
            [10.391109, 47.003609],
            [10.400833, 47.001106],
            [10.429998, 46.984161],
            [10.487499, 46.937775],
            [10.488913, 46.934212],
            [10.471235, 46.871353],
            [10.447498, 46.763054],
            [10.470833, 46.635826],
            [10.486387, 46.619438],
            [10.486666, 46.615273],
            [10.486111, 46.594719],
            [10.485277, 46.590553],
            [10.475555, 46.562492],
            [10.471109, 46.551666],
            [10.465277, 46.546387],
            [10.457531, 46.542503],
            [10.44972, 46.539162],
            [10.337221, 46.549438],
            [10.305555, 46.553886],
            [10.301666, 46.555832],
            [10.247499, 46.583885],
            [10.245554, 46.587219],
            [10.245277, 46.59111],
            [10.246944, 46.599442],
            [10.253054, 46.613884],
            [10.254166, 46.61805],
            [10.253611, 46.622215],
            [10.241665, 46.636665],
            [10.238609, 46.638885],
            [10.233332, 46.639999],
            [10.18111, 46.632217],
            [10.119165, 46.611382],
            [10.0525, 46.543053],
            [10.050278, 46.539993],
            [10.044722, 46.507217],
            [10.044167, 46.498055],
            [10.044443, 46.453331],
            [10.044998, 46.449165],
            [10.046665, 46.445831],
            [10.049166, 46.443054],
            [10.055555, 46.438332],
            [10.067221, 46.432495],
            [10.08861, 46.424164],
            [10.092777, 46.423332],
            [10.153889, 46.390274],
            [10.177221, 46.272499],
            [10.176388, 46.268326],
            [10.172499, 46.257217],
            [10.169722, 46.25444],
            [10.140833, 46.23333],
            [10.133888, 46.228882],
            [10.129999, 46.227219],
            [10.078609, 46.220551],
            [10.072777, 46.220276],
            [10.066666, 46.221107],
            [10.063055, 46.222771],
            [10.05722, 46.22805],
            [9.994999, 46.291664],
            [9.982498, 46.331383],
            [9.981943, 46.334717],
            [9.991388, 46.346664],
            [9.99361, 46.354439],
            [9.991943, 46.357773],
            [9.984722, 46.361938],
            [9.949999, 46.379166],
            [9.943888, 46.379997],
            [9.91111, 46.383331],
            [9.904999, 46.383049],
            [9.852777, 46.36972],
            [9.813055, 46.35833],
            [9.770555, 46.342209],
            [9.714998, 46.302773],
            [9.708332, 46.298332],
            [9.696943, 46.297218],
            [9.624722, 46.291939],
            [9.581944, 46.296944],
            [9.547222, 46.30555],
            [9.5425, 46.306938],
            [9.521387, 46.319717],
            [9.458611, 46.38472],
            [9.456665, 46.387772],
            [9.450277, 46.426666],
            [9.455, 46.472496],
            [9.372776, 46.5075],
            [9.360832, 46.508606],
            [9.302221, 46.504715],
            [9.296944, 46.503883],
            [9.288887, 46.500275],
            [9.281944, 46.495827],
            [9.273611, 46.487778],
            [9.249722, 46.448051],
            [9.25, 46.440277],
            [9.253054, 46.433327],
            [9.256943, 46.431389],
            [9.272778, 46.428329],
            [9.280554, 46.423332],
            [9.282221, 46.419998],
            [9.296944, 46.35305],
            [9.297499, 46.348885],
            [9.293333, 46.32666],
            [9.291943, 46.323051],
            [9.276667, 46.292496],
            [9.24341, 46.23671],
            [9.238609, 46.230553],
            [9.189444, 46.186661],
            [9.180555, 46.179161],
            [9.177221, 46.176941],
            [9.158609, 46.171661],
            [9.144439, 46.168049],
            [9.132221, 46.160271],
            [9.083332, 46.121109],
            [9.035831, 46.05722],
            [9.016666, 46.022499],
            [8.998055, 45.976944],
            [8.996666, 45.973328],
            [9.0175, 45.94416],
            [9.025, 45.935829],
            [9.031944, 45.931664],
            [9.066666, 45.924164],
            [9.079443, 45.915833],
            [9.081388, 45.912498],
            [9.085554, 45.901939],
            [9.085554, 45.899162],
            [9.083887, 45.895554],
            [9.036665, 45.837776],
            [8.998333, 45.829437],
            [8.951111, 45.845276],
            [8.93611, 45.868889],
            [8.936666, 45.872772],
            [8.936388, 45.876938],
            [8.926666, 45.900833],
            [8.9, 45.949715],
            [8.895555, 45.955826],
            [8.826666, 45.984161],
            [8.813055, 45.988609],
            [8.816944, 46.031662],
            [8.82361, 46.03611],
            [8.849998, 46.054443],
            [8.852499, 46.056938],
            [8.853333, 46.061104],
            [8.850555, 46.072495],
            [8.846666, 46.079163],
            [8.844166, 46.08194],
            [8.835278, 46.089439],
            [8.826111, 46.096664],
            [8.818333, 46.100555],
            [8.747221, 46.121109],
            [8.728855, 46.108589],
            [8.72361, 46.105553],
            [8.714998, 46.102493],
            [8.701111, 46.10083],
            [8.691944, 46.101387],
            [8.617777, 46.120277],
            [8.613888, 46.122215],
            [8.460554, 46.23333],
            [8.445555, 46.245827],
            [8.444443, 46.248604],
            [8.434166, 46.291107],
            [8.434999, 46.295273],
            [8.443333, 46.317215],
            [8.447498, 46.323326],
            [8.458332, 46.33416],
            [8.465832, 46.36805],
            [8.46611, 46.37722],
            [8.461666, 46.444443],
            [8.459999, 46.452217],
            [8.451666, 46.459999],
            [8.447498, 46.461937],
            [8.436388, 46.463333],
            [8.430277, 46.463051],
            [8.365276, 46.453606],
            [8.357222, 46.449997],
            [8.30611, 46.424721],
            [8.302776, 46.422493],
            [8.299999, 46.419716],
            [8.139999, 46.226105],
            [8.143888, 46.219719],
            [8.158333, 46.188889],
            [8.159443, 46.180832],
            [8.158888, 46.176666],
            [8.150276, 46.153053],
            [8.148888, 46.149437],
            [8.014721, 46.013329],
            [8.00861, 46.008331],
            [7.998055, 46.00222],
            [7.973055, 45.996941],
            [7.95, 45.994164],
            [7.911111, 45.994164],
            [7.902499, 45.991104],
            [7.881944, 45.977776],
            [7.876666, 45.972496],
            [7.866388, 45.948326],
            [7.855742, 45.919052],
            [7.8483, 45.918755],
            [7.783889, 45.923607],
            [7.743333, 45.93222],
            [7.709167, 45.943329],
            [7.653055, 45.979996],
            [7.647499, 45.98111],
            [7.536666, 45.981667],
            [7.458055, 45.941109],
            [7.429722, 45.929443],
            [7.393332, 45.916107],
            [7.378888, 45.914719],
            [7.338888, 45.920555],
            [7.300278, 45.923882],
            [7.295555, 45.92305],
            [7.291111, 45.921944],
            [7.230277, 45.898048],
            [7.196944, 45.882217],
            [7.188611, 45.879166],
            [7.183055, 45.879166],
            [7.117499, 45.880829],
            [7.105, 45.882217],
            [7.099444, 45.883606],
            [7.09111, 45.887497],
            [7.077777, 45.896942],
            [7.062778, 45.909164],
            [7.038054, 45.931938],
            [7.030555, 45.961937],
            [7.008611, 45.996666],
            [7.005833, 45.999443],
            [6.933055, 46.055275],
            [6.873888, 46.088051],
            [6.788055, 46.14222],
            [6.783889, 46.148048],
            [6.781111, 46.162498],
            [6.780833, 46.166107],
            [6.799999, 46.378326],
            [6.807016, 46.404228],
            [6.809444, 46.415276],
            [6.808332, 46.41861],
            [6.803055, 46.427773],
            [6.800278, 46.43055],
            [6.791389, 46.434166],
            [6.737778, 46.447495],
            [6.702777, 46.45472],
            [6.633611, 46.464165],
            [6.52, 46.45916],
            [6.510278, 46.457771],
            [6.491944, 46.453049],
            [6.328333, 46.406944],
            [6.31111, 46.401382],
            [6.295555, 46.394165],
            [6.246388, 46.357773],
            [6.243333, 46.354996],
            [6.236388, 46.344719],
            [6.23, 46.333885],
            [6.225555, 46.322495],
            [6.228055, 46.319717],
            [6.243747, 46.31551],
            [6.271944, 46.26194],
            [6.245555, 46.21833],
            [6.189166, 46.173332],
            [6.185833, 46.17083],
            [6.152222, 46.15361],
            [6.133611, 46.149437],
            [6.12361, 46.148048],
            [5.996388, 46.146942],
            [5.967222, 46.201942],
            [5.96611, 46.205276],
            [5.966666, 46.209442],
            [5.968055, 46.212494],
            [5.981388, 46.221939],
            [6.009166, 46.233887],
            [6.03, 46.241386],
            [6.060833, 46.250549],
            [6.072499, 46.249718],
            [6.0825, 46.246666],
            [6.107778, 46.253052],
            [6.117222, 46.260551],
            [6.119166, 46.264442],
            [6.118055, 46.268051],
            [6.106109, 46.297489],
            [6.115, 46.30555],
            [6.120277, 46.311943],
            [6.154166, 46.363052],
            [6.15861, 46.369995],
            [6.158333, 46.373886],
            [6.157222, 46.37722],
            [6.151667, 46.386383],
            [6.148333, 46.388611],
            [6.111111, 46.409721],
            [6.071111, 46.426384],
            [6.086944, 46.44944],
            [6.135278, 46.539719],
            [6.129722, 46.583054],
            [6.127222, 46.585831],
            [6.127777, 46.589996],
            [6.129999, 46.59333],
            [6.269166, 46.682777],
            [6.346666, 46.711388],
            [6.355, 46.714439],
            [6.366666, 46.720551],
            [6.434999, 46.758049],
            [6.452777, 46.774437],
            [6.4575, 46.78083],
            [6.458611, 46.785271],
            [6.446944, 46.839439],
            [6.460278, 46.895828],
            [6.528333, 46.971664],
            [6.566388, 46.979996],
            [6.620832, 46.994438],
            [6.629722, 46.997215],
            [6.639722, 47.004166],
            [6.678333, 47.034164],
            [6.699444, 47.063889],
            [6.793333, 47.130829],
            [6.849721, 47.164989],
            [6.838888, 47.16777],
            [6.8375, 47.171104],
            [6.839722, 47.173607],
            [6.971666, 47.291939],
            [7.000833, 47.364998],
            [6.980833, 47.361664],
            [6.931389, 47.358887],
            [6.88111, 47.356941],
            [6.879999, 47.360275],
            [6.88111, 47.364716],
            [6.884444, 47.372772],
            [6.990555, 47.497215],
            [7.025, 47.508049],
            [7.14642, 47.499054],
            [7.178333, 47.445831],
            [7.187499, 47.442215],
            [7.241111, 47.421944],
            [7.246944, 47.42083],
            [7.251389, 47.421944],
            [7.275555, 47.432495],
            [7.308332, 47.440277],
            [7.336944, 47.439438],
            [7.343611, 47.438606],
            [7.355897, 47.434017],
            [7.358055, 47.433609],
            [7.3825, 47.432495],
            [7.388333, 47.434166],
            [7.415555, 47.445274],
            [7.433054, 47.460548],
            [7.452777, 47.469994],
            [7.496944, 47.494995],
            [7.502222, 47.500549],
            [7.497222, 47.544441],
            [7.49861, 47.54805],
            [7.501389, 47.550552],
            [7.513055, 47.556664],
            [7.521667, 47.559715],
            [7.546665, 47.565552],
            [7.550833, 47.576385],
            [7.557221, 47.581383],
            [7.567222, 47.583611],
            [7.586944, 47.584999],
            [7.588268, 47.58448],
            [7.640555, 47.603882],
            [7.674444, 47.606384],
            [7.676944, 47.603607],
            [7.671944, 47.579437],
            [7.669999, 47.576385],
            [7.666666, 47.574165],
            [7.621111, 47.561104],
            [7.656111, 47.550552],
            [7.697223, 47.543327],
          ],
          [
            [8.710255, 47.696808],
            [8.709721, 47.70694],
            [8.708332, 47.710548],
            [8.705, 47.713051],
            [8.698889, 47.713608],
            [8.675278, 47.712494],
            [8.670555, 47.711105],
            [8.670277, 47.707497],
            [8.673298, 47.701771],
            [8.675554, 47.697495],
            [8.678595, 47.693344],
            [8.710255, 47.696808],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "TU",
        ISO2: "TR",
        ISO3: "TUR",
        UN: 792,
        NAME: "Turkey",
        AREA: 76963,
        POP2005: 72969723,
        REGION: 142,
        SUBREGION: 145,
        LON: 35.179,
        LAT: 39.061,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [26.078053, 39.7836],
              [26.07027, 39.779999],
              [26.059998000000121, 39.780823],
              [26.0186, 39.799431],
              [25.984997, 39.815269000000114],
              [25.981384, 39.817772],
              [25.97749, 39.82278],
              [25.975552, 39.826111],
              [25.974995, 39.829987],
              [25.97749, 39.83332],
              [25.99305, 39.839432],
              [26.012772, 39.8425],
              [26.034161, 39.842766],
              [26.047771000000125, 39.842209000000139],
              [26.07111, 39.8411],
              [26.075829000000113, 39.839722],
              [26.084721, 39.83332],
              [26.086388, 39.829987],
              [26.086388, 39.825554],
              [26.082222, 39.789444000000117],
              [26.078053, 39.7836],
            ],
          ],
          [
            [
              [25.82444, 40.100266],
              [25.731667, 40.09304],
              [25.671104, 40.11805],
              [25.664444, 40.122208000000114],
              [25.663883000000112, 40.126389],
              [25.67083, 40.151375],
              [25.67361, 40.153603],
              [25.688889, 40.164986],
              [25.715275, 40.181389],
              [25.776665, 40.212212],
              [25.934441, 40.241096],
              [25.940552, 40.241096],
              [25.943604, 40.23888],
              [26.011387, 40.16027],
              [26.013611, 40.157494],
              [26.013611, 40.153603],
              [26.0111, 40.144722],
              [25.989998000000128, 40.128876000000105],
              [25.958054000000118, 40.121101],
              [25.82444, 40.100266],
            ],
          ],
          [
            [
              [27.60722, 40.57222],
              [27.601662, 40.57194],
              [27.553608000000111, 40.586937],
              [27.531666, 40.598053],
              [27.528606, 40.60027],
              [27.528332, 40.604439],
              [27.526382, 40.637772],
              [27.526665, 40.642487000000131],
              [27.531109, 40.64833],
              [27.534161, 40.650551],
              [27.54139, 40.65388],
              [27.550549, 40.656097],
              [27.59833, 40.65833],
              [27.614998, 40.658875],
              [27.65111, 40.65722],
              [27.66333, 40.656097],
              [27.706944, 40.649994000000106],
              [27.729443, 40.639153000000135],
              [27.73305, 40.637215],
              [27.735271, 40.634438000000102],
              [27.736382, 40.630829000000119],
              [27.73305, 40.622208],
              [27.723885000000109, 40.615555],
              [27.715832, 40.612488],
              [27.62777, 40.579163],
              [27.611382, 40.57332],
              [27.60722, 40.57222],
            ],
          ],
          [
            [
              [35.096931, 41.961655],
              [35.091942000000131, 41.93055],
              [35.093323, 41.92305],
              [35.0961, 41.916382],
              [35.10416, 41.904709],
              [35.136932000000115, 41.858047000000113],
              [35.212494, 41.770554000000118],
              [35.265266, 41.725822],
              [35.286652, 41.713051],
              [35.45638300000013, 41.653603],
              [35.479439000000127, 41.64666],
              [35.493172, 41.643867],
              [35.506386, 41.63805],
              [35.549431, 41.630829000000119],
              [35.576653000000135, 41.627213],
              [35.61222, 41.630272],
              [35.621666, 41.631653],
              [35.64388300000013, 41.636658000000125],
              [35.769157000000121, 41.669434],
              [35.78443, 41.673607],
              [35.876656, 41.700829000000113],
              [35.91111, 41.713051],
              [35.928596, 41.723053],
              [35.934166000000118, 41.728043],
              [35.950554, 41.734154],
              [35.955544, 41.734993000000145],
              [35.973053000000107, 41.732216],
              [36.0511, 41.691933],
              [36.061104000000114, 41.685555],
              [36.070541, 41.678596],
              [36.07861, 41.671097000000145],
              [36.110268000000133, 41.63637],
              [36.116936, 41.627769],
              [36.130829000000119, 41.59915],
              [36.131386, 41.5911],
              [36.133606, 41.552773],
              [36.132767, 41.535828],
              [36.120544, 41.521378000000141],
              [36.11749, 41.513878],
              [36.115555, 41.50527],
              [36.114998000000128, 41.496666],
              [36.116936, 41.489441],
              [36.121277, 41.478798],
              [36.126099, 41.470276],
              [36.130829000000119, 41.46443],
              [36.172768, 41.419434],
              [36.240273, 41.35611],
              [36.34499, 41.283333],
              [36.396378, 41.256104000000107],
              [36.403885000000116, 41.252213],
              [36.429153, 41.242775],
              [36.43388, 41.241379],
              [36.461937, 41.240555],
              [36.471931, 41.241653],
              [36.485268000000133, 41.244431],
              [36.499718, 41.251389],
              [36.531662, 41.26777],
              [36.538605, 41.271935],
              [36.56971, 41.294434],
              [36.572495, 41.296944],
              [36.612488, 41.347488],
              [36.648041, 41.359444],
              [36.667496, 41.362221],
              [36.71165, 41.364998],
              [36.73444400000011, 41.363045],
              [36.809998000000121, 41.3555530000001],
              [36.856934000000138, 41.347214],
              [36.871101000000124, 41.34304],
              [36.930832000000123, 41.31582],
              [36.998604, 41.281937],
              [37.009995000000117, 41.276108],
              [37.023331, 41.267487000000131],
              [37.029709, 41.259163],
              [37.0311, 41.251656000000139],
              [37.029999, 41.230553],
              [37.028885, 41.217766],
              [37.028885, 41.205269],
              [37.029999, 41.197777],
              [37.033333, 41.188332],
              [37.036652, 41.183044],
              [37.04332, 41.175545],
              [37.04999, 41.171097],
              [37.058044, 41.167496],
              [37.121384, 41.148331],
              [37.137215, 41.145264000000111],
              [37.152283000000125, 41.144913],
              [37.238045, 41.14111],
              [37.296654000000103, 41.13693],
              [37.41776, 41.08054],
              [37.499161000000129, 41.041939],
              [37.526375000000144, 41.030266],
              [37.537209, 41.028046],
              [37.547493, 41.028603],
              [37.58138300000013, 41.037491000000102],
              [37.60777, 41.047768],
              [37.613045, 41.053322],
              [37.629715, 41.07943],
              [37.654999, 41.1161],
              [37.657494, 41.118889],
              [37.67305, 41.130272000000105],
              [37.683044, 41.13610100000011],
              [37.687485, 41.13721],
              [37.753609, 41.119164000000126],
              [37.786385, 41.100548000000117],
              [37.78443, 41.09693],
              [37.78054, 41.074432],
              [37.78027, 41.070267],
              [37.782776, 41.063599],
              [37.787766, 41.054153],
              [37.79361, 41.045547],
              [37.813332000000116, 41.028328000000101],
              [37.816376, 41.026108],
              [37.892487, 40.982773000000122],
              [37.897774, 40.981934000000138],
              [37.934441000000106, 40.988319],
              [37.979996, 40.987778],
              [37.99638, 40.98749],
              [38.0925, 40.964989],
              [38.101944, 40.962212],
              [38.11609, 40.955475],
              [38.159988, 40.949432000000115],
              [38.319153, 40.921654],
              [38.336388, 40.915276],
              [38.350266, 40.91111],
              [38.361382, 40.90943],
              [38.420547, 40.912209000000132],
              [38.5186, 40.92027],
              [38.709991000000116, 40.949997],
              [38.734444, 40.963051],
              [38.758324, 40.976662],
              [38.769997000000103, 40.986382000000106],
              [38.778603, 40.993889],
              [38.7886, 41.000000000000114],
              [38.81611, 41.009995],
              [38.924164, 41.0411],
              [38.93388, 41.040833],
              [38.998322, 41.037491000000102],
              [39.004715, 41.033051],
              [39.009995, 41.032219],
              [39.05471, 41.0411],
              [39.09833, 41.050819000000104],
              [39.123878000000104, 41.05721],
              [39.144722000000115, 41.063332],
              [39.151108, 41.067772],
              [39.154716000000121, 41.073402],
              [39.163048000000117, 41.082497000000103],
              [39.16861, 41.082497000000103],
              [39.208878, 41.074997],
              [39.212769, 41.073318],
              [39.229439000000127, 41.058327000000133],
              [39.23666, 41.054436],
              [39.25721, 41.049721],
              [39.2686, 41.048882],
              [39.278603, 41.049721],
              [39.290833, 41.053322],
              [39.326653, 41.066109],
              [39.3536, 41.076378],
              [39.380272000000105, 41.086655],
              [39.390549, 41.091660000000104],
              [39.40666, 41.102219],
              [39.41249, 41.106934],
              [39.41666, 41.10833],
              [39.421097, 41.109444],
              [39.476379, 41.101662],
              [39.48582, 41.09861],
              [39.493607000000111, 41.094994],
              [39.546944, 41.056107000000111],
              [39.555275000000108, 41.04832],
              [39.69055, 41.003052],
              [39.912491, 40.956657],
              [40.081383, 40.921654],
              [40.102776, 40.917496],
              [40.110550000000103, 40.916656],
              [40.128593000000137, 40.916382000000112],
              [40.149994, 40.92027],
              [40.26915, 40.957207],
              [40.337494, 40.978867],
              [40.353043000000127, 40.988319],
              [40.358200000000124, 40.994102],
              [40.359711, 40.995804],
              [40.371368, 41.008881],
              [40.386658, 41.016106],
              [40.39001, 41.01738],
              [40.398331, 41.020546000000138],
              [40.458046, 41.042496000000142],
              [40.465271000000143, 41.043877],
              [40.474152000000117, 41.043610000000115],
              [40.48916, 41.041382],
              [40.580544, 41.054703000000131],
              [40.637772, 41.078606],
              [40.729706, 41.13693],
              [40.772758, 41.166382],
              [40.833054, 41.194984],
              [40.839149, 41.19665],
              [40.847019, 41.19665],
              [40.84833, 41.19665],
              [40.855743000000132, 41.19492],
              [40.882767, 41.188599000000124],
              [40.906937, 41.186104],
              [40.91582, 41.185822],
              [40.931107, 41.18748],
              [41.043877, 41.230263],
              [41.171692000000121, 41.285301],
              [41.20876, 41.3076],
              [41.226929, 41.320541000000105],
              [41.242493000000138, 41.328873],
              [41.320541000000105, 41.36554],
              [41.338875, 41.37165],
              [41.3461, 41.372765000000129],
              [41.371933, 41.37165],
              [41.38749700000011, 41.37305],
              [41.388462, 41.373772000000145],
              [41.391930000000116, 41.37638],
              [41.408875, 41.390831000000105],
              [41.417206000000135, 41.39804],
              [41.49305, 41.475548000000117],
              [41.504433, 41.487488],
              [41.53156, 41.523876],
              [41.569153000000142, 41.518044000000145],
              [41.724709000000132, 41.492493],
              [41.75972, 41.4686],
              [41.82082400000013, 41.433601],
              [41.828606, 41.42971],
              [41.833321000000126, 41.428322],
              [41.837769, 41.428879],
              [41.883041000000105, 41.458321000000126],
              [41.901375, 41.478043000000127],
              [41.90527, 41.484993],
              [41.916939000000127, 41.494987],
              [41.94778, 41.512772],
              [41.954987, 41.516388],
              [41.963051, 41.518883],
              [41.96804, 41.519157],
              [41.979439, 41.518044000000145],
              [42.097771, 41.507500000000107],
              [42.166939, 41.507500000000107],
              [42.182487, 41.507500000000107],
              [42.272774, 41.491653],
              [42.28749, 41.487488],
              [42.311935000000119, 41.476662],
              [42.366936, 41.460274],
              [42.45527, 41.434708],
              [42.472214000000122, 41.433327000000133],
              [42.48333, 41.438332],
              [42.550819, 41.49527],
              [42.564995000000124, 41.508324],
              [42.590271, 41.579163],
              [42.597771, 41.583054000000118],
              [42.61055, 41.586388000000113],
              [42.651665, 41.592766],
              [42.681389, 41.594719],
              [42.816109, 41.586937],
              [42.827492, 41.58499],
              [42.84024, 41.578873],
              [42.892769000000101, 41.506943],
              [43.016106, 41.393326000000116],
              [43.039719, 41.374161],
              [43.12638, 41.320000000000107],
              [43.233597000000145, 41.190269],
              [43.349709, 41.201935],
              [43.369713, 41.202766],
              [43.387215, 41.200554],
              [43.425819, 41.185265000000129],
              [43.434166, 41.18166],
              [43.451935, 41.171097],
              [43.454987, 41.168877],
              [43.457497000000103, 41.166100000000142],
              [43.473053, 41.143044000000145],
              [43.474709000000132, 41.139992],
              [43.475548, 41.136375],
              [43.474152, 41.1325],
              [43.46077, 41.112961],
              [43.454987, 41.10194],
              [43.453888, 41.097214000000122],
              [43.453888, 41.090271000000143],
              [43.477486, 41.028328000000101],
              [43.47916, 41.025269],
              [43.48527, 41.020554],
              [43.493599, 41.01693],
              [43.554153, 40.99805],
              [43.559166000000118, 40.996666000000118],
              [43.569443, 40.995544],
              [43.581135, 40.996418],
              [43.584435, 40.996666000000118],
              [43.590546, 40.99583],
              [43.59943, 40.992493],
              [43.60638, 40.988319],
              [43.671654, 40.92805],
              [43.673325, 40.92499],
              [43.74249, 40.770264000000111],
              [43.748878, 40.75],
              [43.751938, 40.739998],
              [43.741379, 40.666656],
              [43.719208, 40.622681],
              [43.71666, 40.619156],
              [43.653046000000131, 40.531380000000127],
              [43.59277, 40.501099],
              [43.583054, 40.451111],
              [43.606934, 40.368889],
              [43.661652, 40.27444],
              [43.72054, 40.166939000000127],
              [43.72166, 40.163322],
              [43.72166, 40.159714],
              [43.719719, 40.15638],
              [43.711937, 40.15333],
              [43.707764000000111, 40.15222],
              [43.68193, 40.152489],
              [43.670547, 40.148041],
              [43.663849, 40.14446],
              [43.65778, 40.139709],
              [43.650269, 40.13055],
              [43.648331, 40.126381],
              [43.647774, 40.122765],
              [43.648888, 40.119713000000104],
              [43.657494, 40.108597000000145],
              [43.668877000000123, 40.102486],
              [43.673607000000118, 40.100822],
              [43.91249, 40.0186],
              [43.933884, 40.01361],
              [43.971375, 40.01082],
              [44.032219000000111, 40.006653000000142],
              [44.040543000000127, 40.008606],
              [44.052208, 40.013054],
              [44.279999, 40.046097],
              [44.285271000000137, 40.046097],
              [44.347214, 40.023888000000113],
              [44.356110000000115, 40.020554000000118],
              [44.399155, 40.00361],
              [44.487778, 39.962769],
              [44.54832, 39.91221],
              [44.552216, 39.898888],
              [44.551941, 39.895264],
              [44.55471, 39.888611],
              [44.560265, 39.879433],
              [44.590828, 39.833054000000118],
              [44.594162, 39.830544],
              [44.63388, 39.807770000000119],
              [44.64889, 39.799721],
              [44.746101, 39.73055],
              [44.778862, 39.70638300000013],
              [44.789986, 39.698044],
              [44.801384, 39.684441000000106],
              [44.80305, 39.681656],
              [44.816376000000105, 39.64582],
              [44.81304200000011, 39.63081],
              [44.742615000000114, 39.696953],
              [44.730820000000108, 39.70665],
              [44.611107, 39.777771],
              [44.60582, 39.78054],
              [44.471085, 39.698868],
              [44.47789, 39.640656],
              [44.431931, 39.44694],
              [44.43027, 39.44165],
              [44.424988, 39.431931000000134],
              [44.4161, 39.425262],
              [44.406380000000127, 39.41916],
              [44.395821, 39.413872],
              [44.340271, 39.395546],
              [44.31554, 39.387497],
              [44.308987, 39.387245000000121],
              [44.300819, 39.386932000000115],
              [44.292763, 39.387497],
              [44.240822, 39.400536],
              [44.232201, 39.407204],
              [44.229561, 39.41026],
              [44.2286, 39.41138],
              [44.224152, 39.41471],
              [44.21804, 39.416939000000127],
              [44.20054, 39.416939000000127],
              [44.086098000000106, 39.413048],
              [44.070267000000115, 39.411652],
              [44.064995, 39.408875],
              [44.038605, 39.388596],
              [44.034157, 39.384995000000117],
              [44.034157, 39.379715],
              [44.034954, 39.377445000000137],
              [44.060547, 39.352486],
              [44.074715, 39.336098],
              [44.215828, 39.140831],
              [44.217484, 39.135262],
              [44.216660000000104, 39.12915],
              [44.198032, 39.056675],
              [44.168877, 39.014992],
              [44.161095, 39.0075],
              [44.159424, 39.00221],
              [44.160271, 38.996094],
              [44.17332, 38.96804],
              [44.208046, 38.895821000000126],
              [44.210815, 38.891106],
              [44.24749, 38.866653],
              [44.25361, 38.864441],
              [44.27887, 38.86388],
              [44.285828, 38.862488],
              [44.291100000000142, 38.859711],
              [44.297211, 38.85082],
              [44.30332, 38.83443],
              [44.304993, 38.815536],
              [44.30138, 38.804436000000123],
              [44.26277, 38.72693],
              [44.26082, 38.721657],
              [44.294716, 38.65694],
              [44.30526, 38.65137],
              [44.3122, 38.643044],
              [44.31388, 38.63777],
              [44.31721, 38.613045],
              [44.32222, 38.52387],
              [44.32222, 38.511391],
              [44.32222, 38.510277],
              [44.31944, 38.491936],
              [44.314156, 38.475548],
              [44.309383000000139, 38.464306000000136],
              [44.30555, 38.455269],
              [44.302773, 38.443604],
              [44.30526, 38.400536000000102],
              [44.307316, 38.38784],
              [44.30987, 38.3846],
              [44.3122, 38.38165],
              [44.318329000000119, 38.379433],
              [44.32527, 38.378036],
              [44.332829000000118, 38.378036],
              [44.333878, 38.378036],
              [44.434708000000114, 38.395546],
              [44.436672, 38.394833],
              [44.44082, 38.393326],
              [44.48333, 38.351662],
              [44.484154, 38.345543],
              [44.48304, 38.33943],
              [44.47955, 38.328575],
              [44.477768, 38.32304],
              [44.47527, 38.318329],
              [44.471657, 38.314156000000139],
              [44.468204000000128, 38.311474],
              [44.399017, 38.2113],
              [44.323318, 38.097214],
              [44.238884, 37.960274],
              [44.223969, 37.89915],
              [44.2930530000001, 37.873322],
              [44.574158000000125, 37.76804],
              [44.57943, 37.765549000000135],
              [44.61805, 37.72777],
              [44.619713000000104, 37.722214],
              [44.618874000000119, 37.716103],
              [44.614441, 37.705826000000116],
              [44.598877, 37.690819],
              [44.584435, 37.613884],
              [44.586098, 37.451935000000105],
              [44.58795, 37.443253],
              [44.588593, 37.440262],
              [44.59277, 37.436928],
              [44.598877, 37.434708],
              [44.609303000000125, 37.434708],
              [44.614159, 37.434708],
              [44.628876000000105, 37.432770000000119],
              [44.6486, 37.427773],
              [44.801659, 37.321663000000115],
              [44.815262000000132, 37.30526],
              [44.819443, 37.294991],
              [44.822762, 37.28416],
              [44.821938, 37.271103],
              [44.819153, 37.266388],
              [44.79276, 37.174988],
              [44.78734, 37.149712],
              [44.777771000000143, 37.16388],
              [44.774712, 37.166382000000112],
              [44.766106, 37.169716000000108],
              [44.745827000000133, 37.174431000000141],
              [44.646378000000141, 37.189438],
              [44.638054, 37.187485],
              [44.584435, 37.16416],
              [44.5811, 37.162209],
              [44.57222, 37.15527],
              [44.563042, 37.144157000000121],
              [44.554993000000138, 37.136101],
              [44.546097, 37.129166],
              [44.490555, 37.091652],
              [44.470276000000126, 37.08083],
              [44.436378000000104, 37.063042],
              [44.349709, 37.038322],
              [44.341103, 37.006653],
              [44.321106, 36.97193],
              [44.31721, 36.970543],
              [44.25888, 36.984711000000118],
              [44.255272000000105, 36.986664],
              [44.19971, 37.08416],
              [44.195, 37.09332],
              [44.193329, 37.10027],
              [44.195824, 37.107773],
              [44.226379000000122, 37.152771000000143],
              [44.234154, 37.15527],
              [44.25888, 37.160553000000107],
              [44.26277, 37.16193],
              [44.265831, 37.16416],
              [44.267769000000101, 37.167496],
              [44.268883, 37.171944],
              [44.268326, 37.195000000000107],
              [44.264992, 37.22832],
              [44.261658, 37.241936000000123],
              [44.25694, 37.247498],
              [44.23389, 37.274155],
              [44.227219, 37.278328000000101],
              [44.121384, 37.314995000000124],
              [44.116379, 37.316376],
              [44.0961, 37.31721],
              [44.072945, 37.316376],
              [44.04805, 37.32222],
              [44.014153, 37.320541],
              [44.003876000000105, 37.314995000000124],
              [43.959160000000111, 37.286652],
              [43.956657000000121, 37.283875],
              [43.95471, 37.275826],
              [43.952766, 37.272217],
              [43.936935, 37.251938000000109],
              [43.919716, 37.23166700000013],
              [43.917213, 37.228882],
              [43.911385000000109, 37.224152],
              [43.9036, 37.221657],
              [43.816376000000105, 37.22193],
              [43.623047, 37.229996],
              [43.494713, 37.249718],
              [43.48527, 37.252769000000114],
              [43.15694, 37.373878000000104],
              [43.004433, 37.339989000000116],
              [43.001099, 37.338326],
              [42.976105, 37.326935],
              [42.960274, 37.322487],
              [42.955544, 37.32222],
              [42.950554, 37.322487],
              [42.924164, 37.327766],
              [42.89444, 37.33554],
              [42.826653000000135, 37.354439],
              [42.824158, 37.361107],
              [42.823318, 37.372208000000114],
              [42.822220000000129, 37.375832000000116],
              [42.82, 37.378319],
              [42.81555, 37.37999],
              [42.790825, 37.384720000000129],
              [42.78611, 37.384438],
              [42.779442, 37.380829],
              [42.765732, 37.371216000000118],
              [42.724709, 37.351944],
              [42.590546, 37.181656],
              [42.58554, 37.169716000000108],
              [42.584160000000111, 37.16111],
              [42.581657000000121, 37.152771000000143],
              [42.578331000000105, 37.150826],
              [42.57387, 37.149994],
              [42.53166, 37.147491000000116],
              [42.376938, 37.117493000000138],
              [42.355614, 37.10693],
              [42.357216, 37.122208],
              [42.356934000000138, 37.137215],
              [42.355263, 37.224434],
              [42.354439000000127, 37.227768],
              [42.351105000000132, 37.233887],
              [42.345276000000126, 37.238602000000128],
              [42.294434, 37.269722],
              [42.215828, 37.289444],
              [42.180832000000123, 37.290543],
              [42.151665, 37.261658],
              [42.145821, 37.25694],
              [42.083321, 37.208321],
              [42.056931, 37.192772],
              [41.99527, 37.172768],
              [41.840271000000143, 37.129990000000134],
              [41.557213, 37.086388000000113],
              [41.539162, 37.08416],
              [41.483047000000113, 37.080269],
              [41.454163, 37.078888],
              [41.36249, 37.075],
              [41.221657000000107, 37.071106],
              [41.216385, 37.071381],
              [41.205826000000116, 37.07638],
              [41.118332, 37.09749],
              [40.929993, 37.12971],
              [40.901108, 37.128609],
              [40.806656, 37.12249],
              [40.770821, 37.11805],
              [40.697220000000129, 37.099709],
              [40.67971, 37.091385],
              [40.676941, 37.08887],
              [40.663605, 37.081383],
              [40.634987, 37.068886],
              [40.51888300000013, 37.024994],
              [40.5072100000001, 37.021378000000141],
              [40.48249, 37.020821],
              [40.455826000000116, 37.017487],
              [40.439713, 37.013054],
              [40.415268, 37.001381],
              [40.279709, 36.928596],
              [40.263878, 36.919487],
              [40.214432, 36.895821],
              [40.007767000000115, 36.81471],
              [39.94277, 36.79276],
              [39.923325, 36.786385],
              [39.826111, 36.755829],
              [39.809998, 36.751389],
              [39.588051, 36.71888],
              [39.439301000000114, 36.697517000000119],
              [39.308601, 36.678322],
              [39.257767, 36.6680530000001],
              [39.229996, 36.665276],
              [39.220276000000126, 36.665276],
              [39.205826, 36.665543],
              [39.178596, 36.667763],
              [39.164719, 36.671654],
              [39.13055, 36.683601000000124],
              [39.096375, 36.695541],
              [39.074715, 36.702766],
              [39.048882000000106, 36.707764],
              [39.038048, 36.708611],
              [39.011375, 36.708054000000118],
              [39.004166, 36.705269],
              [38.987778, 36.701111],
              [38.966103, 36.69694],
              [38.922493, 36.695267000000115],
              [38.912766, 36.695],
              [38.774712000000136, 36.69804],
              [38.736931000000141, 36.700554],
              [38.73138, 36.701111],
              [38.72193, 36.70361],
              [38.71083, 36.709160000000111],
              [38.684166000000118, 36.725548],
              [38.62832, 36.768044],
              [38.549431000000141, 36.839165],
              [38.532776, 36.849442],
              [38.513611, 36.858047],
              [38.432770000000119, 36.88554],
              [38.3863750000001, 36.89833],
              [38.249718, 36.913879],
              [38.244164, 36.914444],
              [38.229996, 36.913322000000107],
              [38.181107, 36.905823000000112],
              [38.102776000000119, 36.876099000000124],
              [38.095276, 36.873055000000136],
              [38.088326, 36.869713],
              [38.05555, 36.850548],
              [38.023369, 36.83036],
              [37.993332, 36.82471],
              [37.964989, 36.816933],
              [37.947220000000129, 36.80888],
              [37.924721, 36.794434],
              [37.91083, 36.787766],
              [37.891388, 36.7811],
              [37.784157, 36.748604],
              [37.777222, 36.747498],
              [37.76221, 36.747208],
              [37.736107, 36.747765],
              [37.719162, 36.749718],
              [37.70138, 36.746941000000106],
              [37.669716, 36.737221],
              [37.577209, 36.700829],
              [37.566376000000105, 36.696381],
              [37.552498, 36.689713],
              [37.53333, 36.677773],
              [37.381386000000134, 36.653885],
              [37.371941, 36.656097000000102],
              [37.360550000000103, 36.657494],
              [37.269440000000145, 36.664444000000117],
              [37.248878, 36.664719000000105],
              [37.127495000000124, 36.659157],
              [37.0430530000001, 36.714432],
              [37.038605000000132, 36.71999],
              [37.028046000000131, 36.729713],
              [36.994431, 36.753876],
              [36.988045000000113, 36.75832400000013],
              [36.976379000000122, 36.763611],
              [36.933601, 36.77805],
              [36.702766, 36.82943],
              [36.673607000000118, 36.834435],
              [36.659943, 36.83371],
              [36.663322, 36.824158],
              [36.663879, 36.811935],
              [36.659714, 36.800278],
              [36.586388, 36.619713000000104],
              [36.549988, 36.49221],
              [36.549164000000133, 36.48333],
              [36.566109, 36.424164],
              [36.567215, 36.42083],
              [36.57111, 36.414719],
              [36.582764, 36.397491],
              [36.661133, 36.310982],
              [36.688599000000124, 36.289444],
              [36.691666, 36.283051000000114],
              [36.693047, 36.247765],
              [36.69221, 36.239159],
              [36.690269000000114, 36.23611],
              [36.684441, 36.23166700000013],
              [36.678055, 36.227486],
              [36.674431, 36.226105],
              [36.628609, 36.219437],
              [36.619431, 36.2186],
              [36.60889, 36.219994],
              [36.575554000000125, 36.227776],
              [36.535553, 36.23555],
              [36.506653, 36.23333],
              [36.39222, 36.213326000000109],
              [36.37554, 36.182213000000104],
              [36.37472, 36.177498],
              [36.37472, 36.17332],
              [36.377495, 36.109993],
              [36.378609, 36.102486],
              [36.3822100000001, 36.092499],
              [36.38721, 36.083321],
              [36.38361, 36.03054],
              [36.377747, 36.0],
              [36.372192, 35.995827],
              [36.299995, 35.96972],
              [36.23277, 35.9675],
              [36.228607, 35.96638],
              [36.21916, 35.960274],
              [36.213882000000126, 35.95472],
              [36.190826, 35.92055],
              [36.187492, 35.913605000000132],
              [36.184998, 35.905548000000124],
              [36.18388, 35.901382],
              [36.182495, 35.879715],
              [36.182495, 35.854996],
              [36.176384, 35.82471],
              [36.17166, 35.81916],
              [36.168053, 35.817497000000117],
              [36.157776, 35.817497000000117],
              [36.155876, 35.818443],
              [36.1441650000001, 35.833611],
              [36.128052, 35.852219],
              [36.109993, 35.861382],
              [36.015831, 35.899719000000118],
              [35.92244, 35.92699],
              [35.980217, 35.9955],
              [35.97666, 36.009720000000129],
              [35.954987000000131, 36.066376],
              [35.941933, 36.095276000000126],
              [35.850266, 36.218880000000127],
              [35.790276000000119, 36.284157],
              [35.78333, 36.296387],
              [35.782776, 36.308601000000124],
              [35.783875, 36.31248],
              [35.787766, 36.319153],
              [35.818886000000134, 36.354996000000142],
              [35.92083, 36.447495000000117],
              [35.928596, 36.454163],
              [36.036385, 36.529709000000139],
              [36.04639, 36.535271],
              [36.149712, 36.587494],
              [36.1586, 36.588875],
              [36.169434, 36.58833],
              [36.174164, 36.588875],
              [36.182487, 36.591385000000116],
              [36.188889, 36.594437],
              [36.193604000000107, 36.599991],
              [36.195267, 36.603333000000134],
              [36.215828, 36.646378000000141],
              [36.21777, 36.654999],
              [36.21777, 36.658875],
              [36.206657, 36.763878],
              [36.205826, 36.770821000000126],
              [36.193329, 36.791939],
              [36.16638, 36.828606],
              [36.134995, 36.85833],
              [36.124435, 36.86805],
              [36.076935000000105, 36.903328000000101],
              [36.061935000000119, 36.914444],
              [36.031380000000127, 36.924164000000133],
              [36.021935, 36.92638],
              [36.01693, 36.92638],
              [36.012772, 36.925278000000105],
              [36.001656, 36.920830000000137],
              [35.96194, 36.89804],
              [35.953049, 36.891663],
              [35.936935, 36.876389000000131],
              [35.910271000000137, 36.8461],
              [35.899437, 36.8361],
              [35.826935, 36.779442],
              [35.820824, 36.775551000000121],
              [35.797768, 36.767487000000131],
              [35.789719, 36.76471],
              [35.72083, 36.75639],
              [35.709991, 36.757767],
              [35.705544, 36.759163],
              [35.702492, 36.761101],
              [35.693604, 36.763878],
              [35.64666, 36.753609],
              [35.643044000000145, 36.752213],
              [35.609444, 36.733887],
              [35.573914, 36.707352],
              [35.572495, 36.70361],
              [35.572495, 36.70027],
              [35.574432, 36.689156],
              [35.575829, 36.685822],
              [35.57972, 36.684998],
              [35.611107, 36.68777],
              [35.636101, 36.682213],
              [35.638054000000125, 36.64193],
              [35.636658, 36.61805],
              [35.635544, 36.614159],
              [35.63388, 36.610550000000103],
              [35.628876000000105, 36.604996],
              [35.616379000000109, 36.59693],
              [35.60582, 36.59166],
              [35.566933, 36.57916],
              [35.562218, 36.578606],
              [35.556664, 36.57916],
              [35.54832, 36.582222000000115],
              [35.545273, 36.58416],
              [35.532494, 36.59693],
              [35.50721, 36.609711000000118],
              [35.50361, 36.611382],
              [35.498878, 36.611931000000141],
              [35.48333, 36.60666700000013],
              [35.412491, 36.58027],
              [35.354156000000103, 36.550819000000104],
              [35.33999, 36.53916],
              [35.178879, 36.621941],
              [35.023598, 36.700554],
              [34.994431, 36.714989000000116],
              [34.983047, 36.71999],
              [34.973053, 36.721931],
              [34.945267, 36.724709],
              [34.92915, 36.724991000000102],
              [34.915543, 36.723053],
              [34.911942, 36.721375],
              [34.90424, 36.717064],
              [34.89222, 36.742775],
              [34.889153, 36.749161000000129],
              [34.881386, 36.759438000000102],
              [34.873055, 36.766663],
              [34.844437, 36.785553000000107],
              [34.827209, 36.795273],
              [34.777222, 36.808601],
              [34.74082, 36.812485],
              [34.729439000000127, 36.813332000000116],
              [34.705544, 36.811104],
              [34.65943, 36.80527],
              [34.57222, 36.775826],
              [34.559166000000118, 36.768044],
              [34.476662, 36.705544],
              [34.36278, 36.637772],
              [34.345276, 36.629433],
              [34.32278, 36.61555],
              [34.289719, 36.59166],
              [34.26693, 36.574158],
              [34.255829, 36.564438],
              [34.245544000000109, 36.553879],
              [34.234444, 36.538879],
              [34.228333, 36.524712],
              [34.22361, 36.519157000000121],
              [34.215828, 36.51137],
              [34.152489, 36.461098000000106],
              [34.12861, 36.44860100000011],
              [34.083054, 36.41111],
              [34.076378, 36.402489],
              [34.0738750000001, 36.394722000000115],
              [34.073318, 36.390266],
              [34.072777, 36.377495],
              [34.073601, 36.369431],
              [34.074997, 36.361931],
              [34.031662, 36.303055],
              [33.988602, 36.277771],
              [33.936935000000119, 36.280266],
              [33.935555000000136, 36.282776000000126],
              [33.92305, 36.293877],
              [33.883041000000105, 36.31248],
              [33.878609, 36.313889000000131],
              [33.873055, 36.314156],
              [33.86222, 36.309441],
              [33.859444, 36.306931000000134],
              [33.816109, 36.26082],
              [33.745270000000119, 36.20638300000013],
              [33.705269000000101, 36.179436],
              [33.654442, 36.187485],
              [33.645, 36.189713],
              [33.610268, 36.182213000000104],
              [33.606377, 36.181107000000111],
              [33.540833, 36.13971],
              [33.362778, 36.137772],
              [33.287209000000132, 36.124435],
              [33.045273, 36.0911],
              [32.95027, 36.096657],
              [32.93889, 36.097214],
              [32.934441, 36.096657],
              [32.864441, 36.068329],
              [32.822495, 36.03749],
              [32.808884, 36.025551000000121],
              [32.77166, 36.028885000000116],
              [32.669716000000108, 36.039162],
              [32.581100000000106, 36.080269000000101],
              [32.578049, 36.082222],
              [32.566628, 36.092712],
              [32.53166, 36.092499],
              [32.517487, 36.09388],
              [32.50499, 36.097771000000137],
              [32.497208000000114, 36.101105000000132],
              [32.369431000000134, 36.173882],
              [32.36665, 36.176384],
              [32.275826, 36.268326],
              [32.204720000000123, 36.34388],
              [32.19999700000011, 36.349152000000117],
              [32.188599000000124, 36.366936],
              [32.179436000000123, 36.390549000000135],
              [32.171387, 36.40193],
              [32.149155, 36.429436],
              [32.106934, 36.473053],
              [32.064713, 36.516388],
              [32.022491000000116, 36.541939],
              [32.015266, 36.545547],
              [32.0075, 36.547768],
              [32.003052, 36.54805],
              [31.993607, 36.544434],
              [31.823051, 36.589722],
              [31.742222, 36.63472],
              [31.73833100000013, 36.636375],
              [31.582771, 36.696381],
              [31.38528, 36.782776],
              [31.37221, 36.79083],
              [31.359161, 36.798882],
              [31.343609, 36.804436],
              [31.297497, 36.814995],
              [31.28222, 36.817215],
              [31.04666, 36.849152],
              [30.99305, 36.85416],
              [30.970833, 36.8555530000001],
              [30.88805, 36.8536],
              [30.826111000000139, 36.8461],
              [30.811108000000104, 36.844994],
              [30.763329000000113, 36.84416],
              [30.73722, 36.854713],
              [30.73389, 36.856667],
              [30.708881, 36.873322],
              [30.697495, 36.882767000000115],
              [30.688332, 36.884995],
              [30.682774, 36.88528],
              [30.66416, 36.877213],
              [30.650555, 36.870270000000119],
              [30.643887, 36.866379],
              [30.623333, 36.850822],
              [30.6097180000001, 36.83639],
              [30.601383, 36.825272],
              [30.580555, 36.797211000000118],
              [30.574162, 36.788322],
              [30.57027, 36.782219000000111],
              [30.560833000000116, 36.726105],
              [30.553608, 36.615822],
              [30.528332, 36.494431000000134],
              [30.481384, 36.42694],
              [30.47444, 36.39304],
              [30.47444, 36.385277],
              [30.485828, 36.363319000000104],
              [30.497772000000111, 36.346657000000107],
              [30.5111, 36.339722],
              [30.503883, 36.320541],
              [30.428608, 36.227776],
              [30.409443, 36.2061],
              [30.40694, 36.203606],
              [30.40333, 36.201935],
              [30.399715, 36.208054],
              [30.390831, 36.235268],
              [30.365829, 36.261375],
              [30.28583, 36.296654],
              [30.276382, 36.300278],
              [30.26249700000011, 36.303596],
              [30.257217, 36.30415],
              [30.216389, 36.30415],
              [30.200829000000113, 36.303596],
              [30.178883, 36.298882000000106],
              [30.14583, 36.289719000000105],
              [30.1436, 36.288048],
              [30.14333, 36.285271000000137],
              [30.14583, 36.27916],
              [30.14694, 36.273331],
              [30.14583, 36.255829],
              [30.14388700000012, 36.252769000000114],
              [30.12694, 36.244713],
              [30.092216, 36.235268],
              [29.97583, 36.211655],
              [29.77527, 36.151665],
              [29.770828000000108, 36.15277],
              [29.736111, 36.161385],
              [29.73222, 36.161942000000124],
              [29.717216, 36.16083],
              [29.714439, 36.159431],
              [29.687492000000134, 36.138054],
              [29.677216000000101, 36.118332000000123],
              [29.62861, 36.17055],
              [29.570271, 36.199432],
              [29.504440000000102, 36.20554],
              [29.349716, 36.23111],
              [29.315273, 36.247208000000114],
              [29.283604, 36.27193],
              [29.25887, 36.29583],
              [29.183605, 36.328331000000105],
              [29.162216, 36.338875000000144],
              [29.146664, 36.348885],
              [29.141663, 36.352776000000119],
              [29.117222, 36.383324],
              [29.098053, 36.472214],
              [29.0975, 36.476379],
              [29.124722, 36.526375000000144],
              [29.125832, 36.533051],
              [29.125275000000101, 36.537209],
              [29.12388, 36.540543],
              [29.106937, 36.553596],
              [29.080830000000105, 36.558884],
              [29.075829, 36.558601],
              [29.052216000000101, 36.554436],
              [29.049164, 36.552216],
              [29.04832800000014, 36.549164000000133],
              [29.050831, 36.542213],
              [29.047497, 36.540276000000119],
              [29.044437, 36.539986000000113],
              [29.020199000000105, 36.541054],
              [29.016663000000108, 36.543320000000108],
              [29.02389, 36.583321],
              [29.028889, 36.603043000000127],
              [29.033604, 36.613319],
              [29.035275000000127, 36.616379000000109],
              [29.039444000000117, 36.61777],
              [29.087215000000128, 36.626656],
              [29.052498, 36.681107],
              [28.938332, 36.741653],
              [28.924721, 36.746666],
              [28.866940000000113, 36.688889000000131],
              [28.864441000000113, 36.686378],
              [28.851662, 36.658875],
              [28.850552, 36.656097000000102],
              [28.79277, 36.671097],
              [28.65694, 36.710274],
              [28.619717, 36.77],
              [28.608604, 36.803322],
              [28.458611, 36.880272],
              [28.454163, 36.881386],
              [28.396111, 36.863602000000128],
              [28.39249, 36.861931],
              [28.37888, 36.84999],
              [28.376389, 36.847214],
              [28.376106000000107, 36.843597000000102],
              [28.379993, 36.837494],
              [28.38499, 36.832497000000103],
              [28.388882, 36.83276],
              [28.395271, 36.836655],
              [28.405273, 36.837769],
              [28.420277000000112, 36.831383],
              [28.421944, 36.828049000000135],
              [28.421104, 36.824997],
              [28.417217, 36.811378000000104],
              [28.403606, 36.786942],
              [28.401665, 36.78387],
              [28.398605, 36.781662],
              [28.382771, 36.7811],
              [28.378052000000139, 36.782219000000111],
              [28.310833, 36.825829000000113],
              [28.288609, 36.844719],
              [28.279999, 36.847214],
              [28.267494, 36.847488],
              [28.256386, 36.842766],
              [28.248608000000104, 36.835274],
              [28.243607, 36.825272],
              [28.238049, 36.811104],
              [28.235271, 36.803879000000109],
              [28.234161, 36.800278],
              [28.234444, 36.796097000000145],
              [28.247498000000121, 36.766106],
              [28.269444000000135, 36.744431],
              [28.27583, 36.729439],
              [28.230827, 36.698601],
              [28.066383, 36.589722],
              [27.98389, 36.552773000000116],
              [27.96722, 36.573875],
              [27.95972, 36.593323],
              [27.958881, 36.59693],
              [27.959995, 36.599709000000132],
              [27.982494, 36.602486],
              [28.005833, 36.599442],
              [28.014721, 36.597488],
              [28.02166, 36.594437],
              [28.027222, 36.594437],
              [28.05083100000013, 36.597771],
              [28.07055, 36.618889000000138],
              [28.084721, 36.634995000000117],
              [28.086662, 36.638329000000113],
              [28.085548, 36.64193],
              [28.061108000000104, 36.673607000000118],
              [28.04472, 36.68777],
              [28.036110000000122, 36.690552],
              [28.033886, 36.68777],
              [28.033051, 36.683601000000124],
              [28.035553, 36.676659],
              [28.035000000000139, 36.672493000000145],
              [28.031384, 36.67083],
              [28.0186, 36.66832],
              [28.013611, 36.6680530000001],
              [27.989162, 36.671097],
              [27.966389000000106, 36.674164],
              [27.963608, 36.676659],
              [27.963882, 36.68249],
              [27.965549, 36.685822],
              [27.974995, 36.689713],
              [28.002773, 36.69916],
              [28.038609000000122, 36.707222],
              [28.08083, 36.708054000000118],
              [28.085831, 36.702766],
              [28.090275, 36.701935],
              [28.09444, 36.70221],
              [28.12194, 36.719437],
              [28.12388, 36.722488000000112],
              [28.124439, 36.791382000000112],
              [28.123333, 36.794991],
              [28.118332000000123, 36.800278],
              [28.114441, 36.801659],
              [28.093884, 36.801384],
              [28.090832, 36.799988],
              [28.0736050000001, 36.78611],
              [28.036942, 36.769157],
              [28.008053, 36.758041],
              [27.98416, 36.752213],
              [27.923611, 36.737778000000105],
              [27.91972, 36.737221],
              [27.917500000000132, 36.740273000000116],
              [27.91611, 36.748055],
              [27.911942, 36.749435],
              [27.817219, 36.75721],
              [27.800278, 36.7575],
              [27.737221, 36.75721],
              [27.72749, 36.756104000000107],
              [27.715832, 36.751656000000139],
              [27.709995000000106, 36.747208],
              [27.703888, 36.738319000000104],
              [27.688332, 36.715546],
              [27.676105, 36.691666],
              [27.511944, 36.674431],
              [27.495548, 36.665833],
              [27.48111, 36.654709],
              [27.475277, 36.649994],
              [27.379440000000102, 36.68083],
              [27.369999, 36.687218],
              [27.359997, 36.69999700000011],
              [27.358604, 36.703331000000105],
              [27.358604, 36.70694],
              [27.470833, 36.750275000000101],
              [27.474442, 36.749161000000129],
              [27.496105000000114, 36.745827000000133],
              [27.737495000000138, 36.777771000000143],
              [27.918884000000105, 36.79416700000013],
              [28.02583, 36.82278],
              [28.066383, 36.934998],
              [28.199997, 36.975822],
              [28.32444, 37.023331],
              [28.32749600000011, 37.025551],
              [28.328888, 37.035828],
              [28.328606, 37.03972],
              [28.323605, 37.044991],
              [28.320827, 37.045547],
              [28.273048, 37.04361],
              [28.210278, 37.039444000000117],
              [28.034443, 37.024712000000136],
              [27.848610000000122, 37.01722],
              [27.67639, 37.001938],
              [27.51499600000011, 36.992775],
              [27.426388, 37.027489],
              [27.42139, 37.028046000000131],
              [27.344719, 37.016388],
              [27.33583, 37.014153],
              [27.32944, 37.009995000000117],
              [27.328888, 37.006104],
              [27.336662, 36.998604],
              [27.338329000000101, 36.99527],
              [27.32278, 36.98082],
              [27.311108, 36.97193],
              [27.302216000000101, 36.966103],
              [27.290276, 36.961388],
              [27.272221, 36.955826],
              [27.257500000000107, 36.962494],
              [27.252499, 36.967499],
              [27.228611, 37.03527],
              [27.225552000000107, 37.051941000000113],
              [27.225277, 37.056107],
              [27.234161, 37.07278],
              [27.23611, 37.07611],
              [27.32278, 37.15193],
              [27.325829, 37.15416],
              [27.368332000000123, 37.150551],
              [27.407219000000111, 37.127213],
              [27.439716, 37.104713],
              [27.549995000000138, 37.131653],
              [27.595276, 37.232491],
              [27.563889, 37.273598000000106],
              [27.521381000000133, 37.261658],
              [27.48582800000014, 37.267487],
              [27.413326, 37.302216],
              [27.40416, 37.308884],
              [27.39027, 37.325272],
              [27.388611, 37.328331],
              [27.38555, 37.339432],
              [27.38472, 37.35138],
              [27.421082000000126, 37.407906],
              [27.414444, 37.410553],
              [27.403332, 37.411110000000122],
              [27.375549, 37.401665],
              [27.371941000000106, 37.399712000000136],
              [27.360828, 37.376099],
              [27.356667, 37.37027],
              [27.3325, 37.353043],
              [27.313606, 37.342209],
              [27.243607, 37.33583],
              [27.239162000000135, 37.33694],
              [27.197495, 37.349152000000117],
              [27.19389, 37.350822],
              [27.19416, 37.35471],
              [27.218327, 37.411385],
              [27.2241590000001, 37.473328],
              [27.214993, 37.58194],
              [27.213329, 37.585274],
              [27.208881, 37.59083],
              [27.19389, 37.60444],
              [27.225277, 37.712494000000106],
              [27.240829, 37.727776000000119],
              [27.248608000000104, 37.739998],
              [27.251106, 37.74721],
              [27.261944, 37.794716],
              [27.264164000000108, 37.811661],
              [27.261662, 37.88444],
              [27.264164000000108, 37.887215],
              [27.267773, 37.8936],
              [27.27389, 37.920547],
              [27.274441, 37.924721],
              [27.27389, 37.928596],
              [27.268887, 37.951653000000135],
              [27.267773, 37.95554],
              [27.249722, 37.973053000000107],
              [27.244164000000126, 37.977776],
              [27.24055, 37.979713000000118],
              [26.985271000000125, 38.065269],
              [26.98083, 38.066376],
              [26.97555, 38.06693300000012],
              [26.943333000000109, 38.064156],
              [26.92305, 38.062218],
              [26.81805, 38.15527],
              [26.772221, 38.208878000000141],
              [26.766388, 38.213326000000109],
              [26.76249700000011, 38.214722000000108],
              [26.751942, 38.214989],
              [26.681107, 38.201653],
              [26.627773, 38.156662],
              [26.623882, 38.141106],
              [26.610828, 38.103333],
              [26.606667, 38.101944],
              [26.59111, 38.10166],
              [26.58583, 38.102219],
              [26.54694, 38.115273000000116],
              [26.544167, 38.117493000000138],
              [26.5236, 38.138329],
              [26.488888, 38.172211000000118],
              [26.438889, 38.212769],
              [26.420277, 38.21666],
              [26.366108, 38.22499],
              [26.351109, 38.223328],
              [26.33999, 38.223885000000109],
              [26.330555000000118, 38.225822],
              [26.31611, 38.232773000000122],
              [26.27583, 38.264435],
              [26.275, 38.285553],
              [26.28416, 38.345833],
              [26.28749, 38.366379000000109],
              [26.29055, 38.368607],
              [26.314442, 38.374435],
              [26.31805, 38.373322],
              [26.32833, 38.354156],
              [26.328053, 38.349442],
              [26.32638, 38.34637],
              [26.319717, 38.342209],
              [26.317493, 38.33943],
              [26.316666, 38.335541],
              [26.318604, 38.332222000000115],
              [26.32138, 38.329987000000131],
              [26.351383, 38.314995000000124],
              [26.36944, 38.306107000000111],
              [26.374722, 38.30555],
              [26.448330000000112, 38.344437],
              [26.45194, 38.34637],
              [26.463608, 38.35526],
              [26.476383, 38.368332],
              [26.499165, 38.400269],
              [26.50944, 38.419716],
              [26.510551, 38.423325],
              [26.51083, 38.428055],
              [26.50861, 38.430832],
              [26.481937, 38.44722],
              [26.47499, 38.450829],
              [26.437222000000133, 38.4675],
              [26.42916, 38.470276],
              [26.423882, 38.47083],
              [26.418610000000115, 38.470276],
              [26.41555, 38.46804],
              [26.414444, 38.464432],
              [26.41416, 38.4561],
              [26.412495, 38.453049],
              [26.39472, 38.444153000000142],
              [26.38944, 38.44444],
              [26.384163000000115, 38.449715],
              [26.35833, 38.566376000000105],
              [26.34861, 38.617775000000108],
              [26.347218, 38.62999],
              [26.350277, 38.646111],
              [26.352776, 38.653328000000101],
              [26.358887, 38.657776],
              [26.369999, 38.661942],
              [26.39833, 38.666939],
              [26.428329, 38.670830000000137],
              [26.47916, 38.668053],
              [26.48333, 38.666656000000103],
              [26.5236, 38.633041],
              [26.562222, 38.599709000000132],
              [26.564442, 38.596931],
              [26.61222, 38.529709],
              [26.62944, 38.458054000000118],
              [26.595551, 38.453049],
              [26.644444, 38.337494],
              [26.651382000000126, 38.329163],
              [26.673611000000108, 38.309998],
              [26.682217, 38.307487],
              [26.687492, 38.306931],
              [26.692219, 38.308044],
              [26.69889, 38.311935],
              [26.700554, 38.315269],
              [26.793053, 38.3536],
              [26.834995, 38.36555],
              [26.904716, 38.373878000000104],
              [27.088882, 38.398041],
              [27.101109000000122, 38.401932000000102],
              [27.116108, 38.4086],
              [27.122498, 38.41249],
              [27.161942000000124, 38.443886],
              [27.162777000000119, 38.44722],
              [27.16111, 38.45027],
              [27.155827000000102, 38.455544],
              [27.152493000000106, 38.456383],
              [27.046104, 38.461098],
              [27.040276, 38.461098],
              [27.000275000000101, 38.456383],
              [26.996105, 38.454987],
              [26.990273000000116, 38.450554],
              [26.94722, 38.441666],
              [26.88055, 38.502495000000124],
              [26.753326000000129, 38.61999],
              [26.73889, 38.63528],
              [26.734444, 38.640831000000105],
              [26.730827, 38.645821],
              [26.720833, 38.716103],
              [26.722218, 38.719719000000111],
              [26.73222, 38.73026],
              [26.735828, 38.731934],
              [26.822777, 38.754166000000112],
              [26.828053000000125, 38.754433],
              [26.898888000000113, 38.814156],
              [26.901939, 38.816376],
              [27.011387, 38.86416],
              [27.01527, 38.865555],
              [27.01833, 38.863319000000104],
              [27.019722000000115, 38.855263],
              [27.022778, 38.853043],
              [27.027493, 38.853043],
              [27.03167, 38.854156000000103],
              [27.05971, 38.868889],
              [27.062492, 38.871101],
              [27.064442, 38.874435],
              [27.065273000000104, 38.878319],
              [27.059166, 38.920273],
              [27.058048, 38.923882],
              [27.05305, 38.929153],
              [27.040833000000134, 38.933327],
              [26.959164000000101, 38.937485],
              [26.953888, 38.936935],
              [26.922497, 38.933327],
              [26.918327, 38.932213000000104],
              [26.887497, 38.920547000000113],
              [26.869442, 38.911652000000117],
              [26.861111000000108, 38.909157],
              [26.85722, 38.90971],
              [26.802773000000116, 38.95443],
              [26.800549000000103, 38.957222],
              [26.796104, 38.97193],
              [26.794167, 38.98389],
              [26.794167, 38.988319],
              [26.79666, 39.019997],
              [26.798611, 39.027771],
              [26.864441000000113, 39.058884],
              [26.878052, 39.061935],
              [26.881104, 39.06416],
              [26.88583, 39.069443],
              [26.88472, 39.073318],
              [26.871666, 39.09499],
              [26.867775000000108, 39.100822000000107],
              [26.848885, 39.12721],
              [26.843884000000116, 39.132500000000107],
              [26.820553, 39.151108],
              [26.80555, 39.162209000000132],
              [26.75933, 39.173264],
              [26.72889, 39.221375],
              [26.644722000000115, 39.263054],
              [26.664993, 39.301102],
              [26.811382, 39.398888000000113],
              [26.894997, 39.474152000000117],
              [26.932499, 39.481377],
              [26.936665000000119, 39.48249],
              [26.93972, 39.484711],
              [26.951939, 39.548882],
              [26.951664, 39.552773],
              [26.944717, 39.56582],
              [26.939159, 39.574997],
              [26.932774, 39.579163],
              [26.923882000000106, 39.582222],
              [26.892773, 39.57943],
              [26.882771000000105, 39.578049],
              [26.876106, 39.574158],
              [26.817493, 39.561661],
              [26.761662000000115, 39.556107],
              [26.69444, 39.555275000000108],
              [26.66972, 39.554993],
              [26.659443, 39.551659],
              [26.581387, 39.534714000000122],
              [26.538609, 39.529709],
              [26.212215, 39.465271],
              [26.208611000000133, 39.463326],
              [26.199715, 39.461098],
              [26.13388, 39.453049],
              [26.128052, 39.453049],
              [26.118607, 39.454987],
              [26.101383, 39.460274],
              [26.08083, 39.467209000000139],
              [26.07299, 39.47084],
              [26.068886000000134, 39.475266],
              [26.067219, 39.483047],
              [26.06749, 39.487488],
              [26.069717000000139, 39.494987],
              [26.101383, 39.581657],
              [26.10749, 39.5911],
              [26.133327, 39.607773000000122],
              [26.153332, 39.629166],
              [26.156384, 39.636101],
              [26.160275, 39.656097],
              [26.163052, 39.68638],
              [26.158051000000114, 39.821381],
              [26.154442, 39.8936],
              [26.149162, 39.907776],
              [26.1486, 39.916656],
              [26.154442, 39.93971],
              [26.160553, 39.953606],
              [26.174721, 39.979439000000127],
              [26.187492000000134, 39.997208],
              [26.19305, 40.002213],
              [26.200272, 40.00583],
              [26.208611000000133, 40.006104],
              [26.216942, 40.00332],
              [26.220551, 40.001389000000131],
              [26.226383000000112, 39.99667],
              [26.237778, 39.99165],
              [26.248882, 39.991096],
              [26.28972, 40.005272],
              [26.325829, 40.0186],
              [26.332497, 40.022774],
              [26.336941, 40.0286],
              [26.38472, 40.102486],
              [26.398605, 40.139992],
              [26.433331, 40.191666],
              [26.443333, 40.193047],
              [26.499439000000109, 40.20916],
              [26.514439, 40.215828000000101],
              [26.521111, 40.219994],
              [26.60833, 40.283333],
              [26.611382, 40.285553000000107],
              [26.682774000000109, 40.346375000000137],
              [26.685272, 40.349152],
              [26.701382, 40.372765000000129],
              [26.707222, 40.384995],
              [26.809998, 40.395821],
              [26.886944, 40.395554000000118],
              [26.9575, 40.3836060000001],
              [26.9675, 40.38221],
              [27.026665, 40.39111],
              [27.053883, 40.416382],
              [27.056664000000126, 40.427216],
              [27.05888, 40.429993000000138],
              [27.084721, 40.446938000000102],
              [27.088882, 40.448318],
              [27.118607, 40.452766],
              [27.264164000000108, 40.458611000000133],
              [27.30472200000014, 40.406662],
              [27.299164, 40.407219],
              [27.29499, 40.40582],
              [27.296661, 40.402489],
              [27.305275, 40.386375],
              [27.307499, 40.3836060000001],
              [27.387215, 40.343323],
              [27.401939, 40.336098],
              [27.429165000000125, 40.324158],
              [27.470276000000126, 40.313889],
              [27.47499, 40.312775],
              [27.508884000000137, 40.305832],
              [27.514439, 40.305275],
              [27.551941, 40.30305],
              [27.565273, 40.306389000000138],
              [27.57502, 40.313271],
              [27.678329, 40.309441],
              [27.741108000000111, 40.309998000000121],
              [27.772495, 40.31304200000011],
              [27.777493, 40.313889],
              [27.781666, 40.314995],
              [27.788883000000112, 40.318604],
              [27.871666, 40.365555],
              [27.874992, 40.367775000000108],
              [27.879993, 40.373322],
              [27.881104, 40.376938000000109],
              [27.88083, 40.37999],
              [27.876659000000132, 40.381653000000142],
              [27.836941, 40.39666],
              [27.826111, 40.39777400000014],
              [27.817219, 40.395821],
              [27.800549000000103, 40.390266000000111],
              [27.79583, 40.389435000000105],
              [27.791111, 40.390266000000111],
              [27.788052000000107, 40.392769000000101],
              [27.688889000000131, 40.482216000000108],
              [27.686665, 40.49416],
              [27.686382, 40.497208000000114],
              [27.707497, 40.513329000000113],
              [27.724442, 40.523598],
              [27.728333, 40.525269],
              [27.73305, 40.526108],
              [27.752499000000114, 40.529442],
              [27.757217, 40.529999],
              [27.856937, 40.522491],
              [28.00555, 40.493889000000138],
              [28.019161, 40.490273000000116],
              [28.025555, 40.486107],
              [28.030273, 40.48055],
              [28.03083, 40.4675],
              [28.024441, 40.458611000000133],
              [28.009163, 40.447495],
              [27.99305, 40.436935],
              [27.934441000000106, 40.413605],
              [27.921104, 40.410271000000137],
              [27.911942, 40.40833],
              [27.898331, 40.395821],
              [27.896938, 40.392220000000123],
              [27.896664000000101, 40.3875],
              [27.900555, 40.381386],
              [27.917500000000132, 40.366936000000123],
              [27.929993000000138, 40.36249],
              [27.947777, 40.357491],
              [27.958611000000133, 40.356377],
              [28.035828, 40.369164],
              [28.07527, 40.379715],
              [28.105000000000132, 40.38861],
              [28.114162, 40.390549],
              [28.153606000000138, 40.396378],
              [28.18055, 40.398041],
              [28.190826, 40.397491],
              [28.20388000000014, 40.394066000000123],
              [28.243889, 40.403328000000101],
              [28.249439000000109, 40.4036],
              [28.48333, 40.396378],
              [28.509163000000115, 40.395264000000111],
              [28.674438000000123, 40.363602000000128],
              [28.750832, 40.390266000000111],
              [28.759438000000102, 40.392769000000101],
              [28.785275, 40.394997],
              [28.797497000000135, 40.394722],
              [28.82972, 40.391930000000116],
              [28.873333, 40.385544],
              [28.881386, 40.38221],
              [28.890553, 40.37498],
              [28.912216, 40.363884],
              [28.921104, 40.361107000000118],
              [28.93722, 40.359444],
              [28.97916, 40.357216],
              [28.985271, 40.35693],
              [29.044437, 40.364159],
              [29.054165, 40.365822],
              [29.062222, 40.368607],
              [29.1436, 40.427216],
              [29.146664, 40.429436],
              [29.148048, 40.433044],
              [29.144161, 40.439156000000139],
              [29.137772, 40.443604000000107],
              [29.084438, 40.47638],
              [29.075554, 40.478882000000112],
              [29.04361, 40.48138],
              [29.026939, 40.481110000000115],
              [29.017773, 40.478882000000112],
              [28.98833100000013, 40.46999],
              [28.975826, 40.461098],
              [28.971104000000139, 40.460274],
              [28.966106000000138, 40.46054],
              [28.917217, 40.468323000000112],
              [28.912495, 40.469437],
              [28.89194, 40.476944],
              [28.777493, 40.522217000000126],
              [28.77527, 40.524994],
              [28.776108, 40.528885],
              [28.778049, 40.532219],
              [28.79528, 40.551384],
              [28.804165000000125, 40.558327],
              [28.81194, 40.561378],
              [28.852493, 40.575554],
              [28.894161000000111, 40.588608000000136],
              [28.90984, 40.593117],
              [28.95527, 40.624718],
              [28.974442, 40.637215],
              [28.986382, 40.64193],
              [29.001389, 40.643883],
              [29.154716000000121, 40.65749],
              [29.251659, 40.662491],
              [29.386662, 40.702492],
              [29.391388, 40.703049000000135],
              [29.395554, 40.701653],
              [29.424, 40.6858],
              [29.479443, 40.72028],
              [29.50555, 40.732216],
              [29.510551, 40.73277],
              [29.513329, 40.73055],
              [29.53583, 40.70638300000013],
              [29.548054, 40.68833],
              [29.551105000000121, 40.686104],
              [29.555832, 40.684998],
              [29.561108, 40.685265],
              [29.70149, 40.705009000000132],
              [29.893055, 40.712769],
              [29.91, 40.713051000000121],
              [29.92472, 40.714989],
              [29.932774, 40.7186],
              [29.93805, 40.723885],
              [29.940273, 40.731377000000123],
              [29.940552000000139, 40.743889],
              [29.934441000000106, 40.760544],
              [29.916943, 40.761658],
              [29.726109, 40.772217],
              [29.591660000000104, 40.775551],
              [29.562222000000133, 40.771111],
              [29.518055, 40.769157],
              [29.41249, 40.769722],
              [29.339993, 40.802773],
              [29.333328, 40.811378],
              [29.29028, 40.84805],
              [29.254993, 40.868332],
              [29.149441000000138, 40.903046000000131],
              [29.129440000000102, 40.91444],
              [29.043327, 40.973053],
              [29.025555, 41.034431],
              [29.041832, 41.051285000000121],
              [29.088221, 41.118622],
              [29.088221, 41.139568000000111],
              [29.07278, 41.156097000000102],
              [29.076382000000137, 41.16277],
              [29.080830000000105, 41.16861],
              [29.093884, 41.181931000000134],
              [29.131943, 41.211655000000121],
              [29.134995, 41.213875000000144],
              [29.153889000000106, 41.222488000000112],
              [29.166111, 41.22666],
              [29.213055, 41.236931],
              [29.21833, 41.237221],
              [29.22388, 41.236664000000133],
              [29.29028, 41.228043],
              [29.471104, 41.195541],
              [29.579601000000139, 41.172997],
              [29.60833, 41.171097],
              [29.613049, 41.171944],
              [29.616940000000113, 41.173607000000118],
              [29.622498, 41.17832],
              [29.628052, 41.177773],
              [29.754719, 41.163048],
              [29.862206, 41.147224000000108],
              [29.868889, 41.145821],
              [29.88055, 41.144997],
              [29.981384, 41.139709],
              [29.987495, 41.139435000000105],
              [30.155827, 41.140549],
              [30.161385, 41.140831],
              [30.195, 41.151375],
              [30.261662000000115, 41.19221],
              [30.284718, 41.208054],
              [30.32444, 41.20361],
              [30.32916, 41.20249200000012],
              [30.3475, 41.193886],
              [30.351383000000112, 41.18777],
              [30.356937, 41.183044],
              [30.36472, 41.179436000000123],
              [30.376942, 41.17499],
              [30.425049, 41.164963],
              [30.486382, 41.148888000000113],
              [30.500549, 41.14555],
              [30.516937, 41.143326],
              [30.60611, 41.13388],
              [30.748333000000116, 41.089165],
              [30.75666, 41.086098],
              [30.761944, 41.085274],
              [30.879719, 41.076935],
              [30.933605, 41.07471],
              [30.954735, 41.07457],
              [30.98027, 41.074997],
              [31.07333, 41.078331],
              [31.23111, 41.088875],
              [31.235828, 41.089722],
              [31.298882, 41.113884],
              [31.335831, 41.13582],
              [31.338608, 41.13861],
              [31.340542000000141, 41.14263],
              [31.37555, 41.170547],
              [31.402775, 41.196663000000115],
              [31.41111, 41.209160000000111],
              [31.413052, 41.217209000000139],
              [31.421944, 41.277222],
              [31.421104000000128, 41.280823],
              [31.547771, 41.361931],
              [31.557217, 41.363602000000128],
              [31.60833, 41.37749],
              [31.621105, 41.381386],
              [31.745831, 41.432213],
              [31.749722, 41.433884],
              [31.99222200000014, 41.542496],
              [32.154442000000131, 41.605553],
              [32.158333, 41.607216],
              [32.164986, 41.611382],
              [32.179436000000123, 41.63332400000013],
              [32.272774, 41.716103],
              [32.282219000000111, 41.72277],
              [32.53027, 41.809166000000118],
              [32.588326, 41.828331],
              [32.60082, 41.832222000000115],
              [32.61082, 41.833321000000126],
              [32.684433000000126, 41.833755],
              [32.69249, 41.83943],
              [32.721375000000137, 41.849152000000117],
              [32.77277400000014, 41.858047000000113],
              [32.79805, 41.85889],
              [32.828049, 41.859154],
              [32.912209000000132, 41.874985],
              [32.950829, 41.884995000000117],
              [32.978333, 41.895821],
              [32.981667, 41.897774],
              [32.984444, 41.900551],
              [32.987221, 41.908051],
              [32.989441, 41.911110000000122],
              [32.992775, 41.913322],
              [33.061661, 41.936378],
              [33.074997, 41.939713],
              [33.219719, 41.976379],
              [33.32943, 42.019157000000121],
              [33.333878, 42.020264],
              [33.345551000000114, 42.02],
              [33.398598, 42.01693],
              [33.536110000000122, 42.005829000000119],
              [33.551102000000128, 42.002495000000124],
              [33.563889000000131, 41.997765],
              [33.5825, 41.992493000000138],
              [33.598885, 41.989998000000128],
              [33.63221, 41.986382000000106],
              [33.738045, 41.979713],
              [33.77415, 41.977776],
              [33.83472, 41.974991000000102],
              [33.92388, 41.973053],
              [33.993889, 41.98111],
              [34.101944000000117, 41.976105],
              [34.209435, 41.95943],
              [34.249718000000144, 41.94832],
              [34.2613750000001, 41.94694],
              [34.315269000000114, 41.94082],
              [34.364441, 41.943329],
              [34.55471, 41.948044],
              [34.614716, 41.940269000000114],
              [34.64138800000012, 41.939713],
              [34.715546, 41.94249],
              [34.744431000000134, 41.946663],
              [34.78583, 41.954987],
              [34.799164000000133, 41.958054000000118],
              [34.832497000000103, 41.96832],
              [34.850822, 41.979439],
              [34.889709, 42.010277],
              [34.917213, 42.036652000000117],
              [34.945541, 42.066933],
              [34.948601, 42.07471],
              [34.945, 42.084991],
              [34.945, 42.089165],
              [34.946106, 42.09304],
              [34.957764, 42.09277],
              [34.978882, 42.091942],
              [35.00639, 42.086098],
              [35.027489, 42.078049000000135],
              [35.047211000000118, 42.065269],
              [35.116936000000123, 42.004166],
              [35.113045, 41.997765],
              [35.101662, 41.972771000000137],
              [35.096931, 41.961655],
            ],
          ],
          [
            [
              [27.395, 42.008041],
              [27.41, 41.995827000000133],
              [27.413052000000107, 41.993607],
              [27.441109, 41.976944],
              [27.556107000000111, 41.910553],
              [27.566666, 41.907776000000126],
              [27.57222, 41.907219],
              [27.576664, 41.907776000000126],
              [27.580555, 41.90943],
              [27.581661, 41.913048],
              [27.595551, 41.93555],
              [27.628609, 41.95333],
              [27.638054, 41.958321],
              [27.705830000000105, 41.97749],
              [27.830273, 42.001389],
              [27.834721, 42.001938],
              [27.864441000000113, 42.005547],
              [27.869717, 42.005547],
              [27.903606, 41.994713],
              [27.971104000000139, 41.984154000000103],
              [28.013054000000125, 41.982216],
              [28.02833, 41.93748],
              [28.032494, 41.909157],
              [28.008053, 41.891663000000108],
              [27.996941, 41.894157],
              [27.99194, 41.894157],
              [27.987778, 41.893044000000145],
              [27.980827, 41.889153],
              [27.977776000000119, 41.8863750000001],
              [27.970551, 41.876389],
              [27.964722, 41.86472],
              [27.963329, 41.85667],
              [27.966942, 41.83194],
              [27.968327, 41.824997],
              [28.076664, 41.647774],
              [28.090549000000124, 41.631386],
              [28.132217, 41.594162],
              [28.19278, 41.54166],
              [28.201664000000108, 41.534157],
              [28.216942, 41.5236],
              [28.242775000000108, 41.50888],
              [28.260786, 41.502075000000104],
              [28.284718, 41.48972],
              [28.301105, 41.481934],
              [28.331944, 41.469437],
              [28.458054000000118, 41.419434],
              [28.7925, 41.297211000000118],
              [28.834995, 41.282219000000111],
              [28.938049, 41.256104000000107],
              [29.01722, 41.241096],
              [29.027775, 41.240555],
              [29.031384, 41.24221],
              [29.039162, 41.251656000000139],
              [29.046104000000128, 41.255272],
              [29.050831, 41.255829],
              [29.084438, 41.248055],
              [29.093327000000102, 41.244431],
              [29.103611000000114, 41.237778000000105],
              [29.107777, 41.232216],
              [29.10916, 41.228882],
              [29.10916, 41.225266],
              [29.107777, 41.214165],
              [29.106937, 41.209991000000116],
              [29.07101200000011, 41.174362],
              [29.039215, 41.154533],
              [29.068394, 41.123108000000116],
              [29.05555, 41.082497000000103],
              [29.039162, 41.05721],
              [29.033333, 41.051941],
              [28.902493000000106, 40.977776],
              [28.838608000000136, 40.957764000000111],
              [28.830273, 40.955544],
              [28.824299, 40.95533],
              [28.815552000000139, 40.955269000000101],
              [28.627773000000104, 40.960541],
              [28.604717000000107, 40.964722000000108],
              [28.600277, 40.96666],
              [28.59711, 40.97721],
              [28.59711, 40.97938],
              [28.59811, 40.982052000000124],
              [28.59894, 40.987045],
              [28.599442, 41.00361],
              [28.597218000000112, 41.010277],
              [28.583611, 41.043053],
              [28.581944, 41.046387],
              [28.571384, 41.064438],
              [28.566940000000102, 41.07],
              [28.559715, 41.074432],
              [28.550831, 41.078049000000135],
              [28.52916, 41.08027],
              [28.524998, 41.07916],
              [28.53666, 41.061935],
              [28.542500000000132, 41.060555],
              [28.551941, 41.061104],
              [28.557217, 41.059708],
              [28.559441000000106, 41.056931],
              [28.56778, 41.02304],
              [28.56778, 41.01944],
              [28.550995, 40.996101000000124],
              [28.549328, 40.994438],
              [28.538883, 40.986107],
              [28.528332, 40.986931],
              [28.52333, 40.988319],
              [28.51527, 40.99221],
              [28.473610000000122, 41.01499200000012],
              [28.4625, 41.025269],
              [28.451664, 41.031662],
              [28.44444, 41.03583],
              [28.431107, 41.041382],
              [28.415833000000134, 41.045830000000137],
              [28.376106000000107, 41.054436],
              [28.242775000000108, 41.07916],
              [28.213055, 41.08027],
              [28.167217000000107, 41.078331],
              [28.148605, 41.076653000000135],
              [28.131943, 41.071663],
              [28.117228, 41.065269],
              [28.084721, 41.061935],
              [28.068333, 41.057487],
              [28.010830000000112, 41.03555],
              [27.999722000000133, 41.03054],
              [27.989998, 41.023888],
              [27.98722, 41.02111],
              [27.981384, 41.00944],
              [27.98, 41.001389000000131],
              [27.978333, 40.996941],
              [27.958054, 40.971931],
              [27.94305, 40.96804],
              [27.933605, 40.967499],
              [27.888054, 40.96804],
              [27.866940000000113, 40.969994],
              [27.85722, 40.973053],
              [27.852776, 40.978600000000142],
              [27.84417, 40.986107],
              [27.828053000000125, 40.993889],
              [27.779442, 41.00944],
              [27.773605, 41.01054],
              [27.74138, 41.013329],
              [27.7225, 41.011658000000125],
              [27.686108000000104, 41.00721],
              [27.514164, 40.984444],
              [27.50972, 40.983597],
              [27.501942, 40.98082],
              [27.495548, 40.976379],
              [27.487495, 40.967499],
              [27.482777000000112, 40.960831],
              [27.460548, 40.913605],
              [27.452496, 40.892487],
              [27.448330000000112, 40.860268],
              [27.44611, 40.851944],
              [27.443886000000134, 40.84861],
              [27.29805, 40.70443],
              [27.285, 40.69611],
              [27.176662, 40.631653],
              [27.137383000000113, 40.617943],
              [27.020281, 40.592216],
              [26.970551, 40.55471],
              [26.878326, 40.53278],
              [26.730827, 40.48055],
              [26.719994, 40.47555],
              [26.682217, 40.45389],
              [26.679722, 40.451111],
              [26.677773, 40.44722],
              [26.679993, 40.440819],
              [26.685272, 40.431931],
              [26.686108000000104, 40.428322],
              [26.684166, 40.424431],
              [26.614998, 40.35611],
              [26.583328, 40.327492],
              [26.579994, 40.325272],
              [26.550831, 40.306389000000138],
              [26.440273, 40.237488],
              [26.3475, 40.138329000000113],
              [26.32194, 40.108597000000145],
              [26.221943000000124, 40.054153],
              [26.21388, 40.05166],
              [26.181107, 40.045273],
              [26.17639, 40.045273],
              [26.164719, 40.047211],
              [26.160275, 40.048882],
              [26.158051000000114, 40.05166],
              [26.157219, 40.055275],
              [26.157776, 40.059166000000118],
              [26.159718, 40.063042],
              [26.237495, 40.166939000000127],
              [26.249165, 40.176659],
              [26.258884, 40.195],
              [26.260830000000112, 40.198875],
              [26.26722, 40.216385],
              [26.268055, 40.220551000000114],
              [26.272778, 40.250275000000101],
              [26.269722, 40.256386],
              [26.262772, 40.26471],
              [26.23167, 40.301659],
              [26.20972, 40.317215],
              [26.208328, 40.320267],
              [26.21416, 40.325554000000125],
              [26.24194, 40.340271],
              [26.41805, 40.42638],
              [26.543156, 40.482986],
              [26.59833, 40.506104],
              [26.611111, 40.509163],
              [26.624992, 40.510277],
              [26.64666, 40.508324],
              [26.676388, 40.50861],
              [26.689442, 40.511101],
              [26.777222, 40.555832],
              [26.797497, 40.567772000000105],
              [26.82444, 40.58416],
              [26.827221, 40.586937],
              [26.82694, 40.59444],
              [26.82471500000014, 40.60082],
              [26.805275, 40.63749700000011],
              [26.793884, 40.651108],
              [26.78805, 40.656097],
              [26.784443000000124, 40.658051],
              [26.77916, 40.659431],
              [26.768330000000105, 40.660553000000107],
              [26.763891, 40.659988000000112],
              [26.69833, 40.640549],
              [26.685555, 40.637772],
              [26.6711, 40.636932],
              [26.63694, 40.636101],
              [26.58027, 40.631653],
              [26.43805, 40.616653],
              [26.35944, 40.60833],
              [26.346104, 40.606667],
              [26.32138, 40.595276],
              [26.308331, 40.59304],
              [26.288883, 40.59221],
              [26.1486, 40.59221],
              [26.1275, 40.593597000000102],
              [26.109718, 40.59666],
              [26.086662000000103, 40.604439],
              [26.077221, 40.611382000000106],
              [26.07027, 40.619431000000134],
              [26.057774, 40.651932],
              [26.056942, 40.655266],
              [26.04472, 40.735825],
              [26.051804, 40.734375],
              [26.067219, 40.734154],
              [26.090549, 40.736107000000118],
              [26.107777000000112, 40.73972],
              [26.118332, 40.745544],
              [26.124722, 40.75],
              [26.129993, 40.75555],
              [26.173328, 40.8186],
              [26.213608, 40.877213],
              [26.251106, 40.888611],
              [26.28749, 40.90193],
              [26.35944, 40.951935000000105],
              [26.361382000000106, 40.955826],
              [26.375549, 41.02193],
              [26.375275000000101, 41.025551],
              [26.37388, 41.028603],
              [26.36722200000014, 41.03333],
              [26.323887000000127, 41.09304],
              [26.325, 41.234711],
              [26.35833, 41.256943],
              [26.368607, 41.254166],
              [26.379719, 41.253319],
              [26.38472, 41.253319],
              [26.415276000000119, 41.259438000000102],
              [26.603611000000114, 41.32943],
              [26.611382, 41.332497],
              [26.617775, 41.336937],
              [26.63166, 41.350822],
              [26.633884, 41.354439000000127],
              [26.635277, 41.358887],
              [26.636662, 41.366936000000123],
              [26.63721500000014, 41.37861],
              [26.636662, 41.408875],
              [26.636387, 41.416382],
              [26.63583, 41.419716],
              [26.604443, 41.546097],
              [26.570271, 41.611382],
              [26.519444000000135, 41.63361],
              [26.39833, 41.690819],
              [26.36109, 41.711052],
              [26.35583, 41.71443],
              [26.35026, 41.72],
              [26.342773000000136, 41.727486],
              [26.333611, 41.738319],
              [26.332222, 41.741379],
              [26.331944000000135, 41.748878],
              [26.332771, 41.753052],
              [26.33999, 41.774712],
              [26.345551000000114, 41.78665],
              [26.350277, 41.793320000000108],
              [26.374722, 41.819153],
              [26.377499000000114, 41.821938000000102],
              [26.381660000000124, 41.82304],
              [26.39139, 41.82387],
              [26.446663, 41.824997],
              [26.467773, 41.824158000000125],
              [26.477776, 41.824158000000125],
              [26.528332, 41.826111],
              [26.538052, 41.826935],
              [26.542217, 41.828049],
              [26.544994, 41.830826000000116],
              [26.5472180000001, 41.83416],
              [26.558331000000123, 41.85166],
              [26.565826000000129, 41.87138],
              [26.57529, 41.89864],
              [26.560593, 41.92892],
              [26.566383, 41.934708],
              [26.568083, 41.935966],
              [26.572777, 41.939438000000109],
              [26.62138, 41.973053],
              [26.93055, 42.006943],
              [26.935555000000136, 42.006943],
              [26.962221, 42.003323],
              [27.031384000000116, 42.08138300000013],
              [27.04305, 42.085831],
              [27.070271000000105, 42.089989],
              [27.233051000000103, 42.109993000000145],
              [27.282494, 42.102219],
              [27.287777, 42.100548],
              [27.292217, 42.098885],
              [27.304993, 42.093323],
              [27.313332, 42.08943],
              [27.361664000000133, 42.064995],
              [27.364162, 42.062218000000144],
              [27.365555, 42.059166],
              [27.373055, 42.039986000000113],
              [27.391937, 42.01054],
              [27.395, 42.008041],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "UK",
        ISO2: "GB",
        ISO3: "GBR",
        UN: 826,
        NAME: "United Kingdom",
        AREA: 24193,
        POP2005: 60244834,
        REGION: 150,
        SUBREGION: 154,
        LON: -1.6,
        LAT: 53.0,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-6.29083, 49.912216],
              [-6.311389, 49.9116590000001],
              [-6.317223, 49.911942],
              [-6.3175, 49.915276],
              [-6.308056, 49.928886],
              [-6.305556, 49.931938],
              [-6.30139, 49.933609000000104],
              [-6.295, 49.933884],
              [-6.2875, 49.929443],
              [-6.285, 49.926666000000125],
              [-6.280001, 49.92083],
              [-6.27917, 49.918884],
              [-6.28639, 49.913887],
              [-6.29083, 49.912216],
            ],
          ],
          [
            [
              [-1.059722, 50.687492],
              [-1.168334, 50.601944],
              [-1.19139, 50.593605],
              [-1.215278, 50.587219],
              [-1.241667, 50.5825],
              [-1.2825, 50.578888],
              [-1.3675, 50.618607000000111],
              [-1.47306, 50.660828],
              [-1.49361, 50.667221],
              [-1.49917, 50.66861],
              [-1.512222, 50.668884],
              [-1.52333, 50.667496],
              [-1.53806, 50.663605],
              [-1.569167, 50.657494],
              [-1.57, 50.660553000000107],
              [-1.550833, 50.675278],
              [-1.52333, 50.695274],
              [-1.308889, 50.771111],
              [-1.296945, 50.771942],
              [-1.29139, 50.771385000000123],
              [-1.118056, 50.737495],
              [-1.11389, 50.735275],
              [-1.093889, 50.72055],
              [-1.059722, 50.687492],
            ],
          ],
          [
            [
              [-0.938333, 50.7775],
              [-0.960556, 50.774437],
              [-0.972778, 50.776108],
              [-1.0225, 50.78583],
              [-1.02167, 50.789444],
              [-1.018889, 50.791939],
              [-0.975833, 50.830276],
              [-0.970833, 50.830826],
              [-0.96444, 50.82972],
              [-0.94917, 50.822495],
              [-0.946389, 50.819443],
              [-0.93611, 50.780548000000124],
              [-0.938333, 50.7775],
            ],
          ],
          [
            [
              [-4.65167, 51.159439],
              [-4.66361, 51.15833],
              [-4.669168, 51.159439],
              [-4.673334, 51.161385000000109],
              [-4.674445, 51.16528],
              [-4.67139, 51.185272000000111],
              [-4.66944, 51.193054],
              [-4.66556, 51.195],
              [-4.65889, 51.195],
              [-4.656389, 51.19221],
              [-4.646389, 51.164444],
              [-4.646945, 51.16083],
              [-4.65167, 51.159439],
            ],
          ],
          [
            [
              [0.904722, 51.35805],
              [0.89917, 51.357216],
              [0.885278, 51.358330000000137],
              [0.787500000000136, 51.36944],
              [0.78111, 51.37055],
              [0.766111, 51.375832],
              [0.75944, 51.380829000000119],
              [0.745278, 51.39444],
              [0.74083, 51.400276000000133],
              [0.735, 51.40833],
              [0.74055600000014, 51.429718],
              [0.748889, 51.443604],
              [0.760278, 51.44472],
              [0.791111000000114, 51.439995],
              [0.892222, 51.42139],
              [0.90417, 51.418884],
              [0.908889, 51.416939],
              [0.930555, 51.398888],
              [0.93667, 51.39361],
              [0.943889000000127, 51.384995],
              [0.947500000000105, 51.378609],
              [0.947778, 51.374718],
              [0.94694, 51.371109],
              [0.9425, 51.369164],
              [0.904722, 51.35805],
            ],
          ],
          [
            [
              [-4.571389, 53.238609],
              [-4.5775, 53.23805],
              [-4.606945, 53.256104],
              [-4.66444, 53.27833],
              [-4.67694, 53.280273000000136],
              [-4.68306, 53.285553],
              [-4.69389, 53.30138],
              [-4.69194, 53.304161],
              [-4.68139, 53.317772],
              [-4.67861, 53.320831],
              [-4.672501, 53.321388],
              [-4.62667, 53.323051],
              [-4.62167, 53.321388],
              [-4.59083, 53.2972180000001],
              [-4.560556, 53.258331],
              [-4.55944, 53.25444],
              [-4.55944, 53.25055],
              [-4.560834, 53.24638],
              [-4.56361, 53.243332],
              [-4.571389, 53.238609],
            ],
          ],
          [
            [
              [-4.153483959575122, 53.225729952837661],
              [-4.218056, 53.200272],
              [-4.325556, 53.145],
              [-4.35139, 53.124443],
              [-4.40222, 53.125832],
              [-4.47889, 53.176666],
              [-4.49444, 53.189438],
              [-4.5675, 53.273331],
              [-4.569167, 53.388054000000125],
              [-4.56694, 53.39138800000012],
              [-4.56, 53.39666],
              [-4.47472, 53.41861],
              [-4.429167, 53.42444],
              [-4.42306, 53.424995],
              [-4.416112, 53.424995],
              [-4.31389, 53.411942],
              [-4.2925, 53.407494],
              [-4.28361, 53.403328],
              [-4.27694, 53.398331],
              [-4.27, 53.388611],
              [-4.22222, 53.321663000000115],
              [-4.12694, 53.310555000000136],
              [-4.12222, 53.311943],
              [-4.115834, 53.31249],
              [-4.110001, 53.312218],
              [-4.06, 53.30555],
              [-4.04667, 53.30333],
              [-4.04639, 53.299721],
              [-4.09, 53.254997],
              [-4.10139, 53.247772],
              [-4.153483959575122, 53.225729952837661],
            ],
          ],
          [
            [
              [-6.353333, 55.237778],
              [-6.255, 55.211937],
              [-6.168334, 55.218605],
              [-6.14944, 55.221107000000131],
              [-6.14222, 55.220276000000126],
              [-6.10389, 55.21027400000014],
              [-6.098612, 55.208611],
              [-6.06667, 55.19444],
              [-6.060834, 55.188606],
              [-6.0375, 55.1616590000001],
              [-6.03361, 55.154999],
              [-6.033334, 55.15083],
              [-6.0425, 55.102776000000119],
              [-6.049445, 55.087219],
              [-6.03611, 55.057777],
              [-5.84444, 54.896111000000133],
              [-5.79139, 54.85139],
              [-5.781945, 54.854996],
              [-5.77556, 54.8555530000001],
              [-5.74694, 54.853607],
              [-5.73639, 54.850273],
              [-5.73194, 54.848328],
              [-5.710556, 54.833054000000118],
              [-5.708056, 54.83027600000014],
              [-5.69278, 54.812218],
              [-5.688056, 54.806107],
              [-5.686528, 54.771233],
              [-5.68639, 54.764999000000103],
              [-5.6875, 54.761108],
              [-5.69056, 54.756104],
              [-5.69333, 54.751938],
              [-5.696389, 54.748886],
              [-5.711112, 54.739166],
              [-5.74256, 54.72544],
              [-5.745556, 54.724442000000124],
              [-5.74939, 54.724106],
              [-5.76706, 54.724106],
              [-5.785833, 54.71972],
              [-5.816389, 54.710548],
              [-5.821667, 54.708885],
              [-5.8625, 54.691940000000102],
              [-5.87111, 54.687492000000134],
              [-5.87806, 54.682495],
              [-5.88833, 54.674721],
              [-5.891389, 54.671387],
              [-5.92389, 54.633888000000127],
              [-5.925, 54.629715],
              [-5.90833, 54.604721],
              [-5.904723, 54.602219],
              [-5.898334, 54.6011],
              [-5.88722, 54.603333000000134],
              [-5.88306, 54.60555],
              [-5.88, 54.6086],
              [-5.87472, 54.61972],
              [-5.855834, 54.637497],
              [-5.816389, 54.655548000000124],
              [-5.803056, 54.661385000000109],
              [-5.74061, 54.67316],
              [-5.73811, 54.673832],
              [-5.73411, 54.674164000000133],
              [-5.629168, 54.67944],
              [-5.59917, 54.679161],
              [-5.576945, 54.678055],
              [-5.571667, 54.67638],
              [-5.53889, 54.654442000000131],
              [-5.53528, 54.651939],
              [-5.53333, 54.6486],
              [-5.52778, 54.629997],
              [-5.479445, 54.536385],
              [-5.43528, 54.489441],
              [-5.430556, 54.487221],
              [-5.429723, 54.483604],
              [-5.43528, 54.460548],
              [-5.436389, 54.456383],
              [-5.46111, 54.385551000000135],
              [-5.50089, 54.364609],
              [-5.50389, 54.36377],
              [-5.508056, 54.363609],
              [-5.51406, 54.36578],
              [-5.51772, 54.36911],
              [-5.545223, 54.40144],
              [-5.54639, 54.403439000000105],
              [-5.54689, 54.405609],
              [-5.54722, 54.41061],
              [-5.545723, 54.414944000000105],
              [-5.544389, 54.41711],
              [-5.54289, 54.41894],
              [-5.53222, 54.426777],
              [-5.545834, 54.441666],
              [-5.541667, 54.44888],
              [-5.54056, 54.452774],
              [-5.54361, 54.476944],
              [-5.55, 54.499161000000129],
              [-5.55194, 54.502495000000124],
              [-5.55972, 54.515831],
              [-5.561667, 54.518883],
              [-5.56806, 54.52444],
              [-5.59972, 54.541939],
              [-5.63944, 54.559166],
              [-5.659167, 54.56638],
              [-5.68056, 54.573051000000135],
              [-5.69278, 54.575272],
              [-5.698611, 54.574165000000107],
              [-5.700556, 54.570549],
              [-5.704722, 54.533607],
              [-5.675834, 54.523048],
              [-5.67139, 54.521660000000111],
              [-5.64502, 54.492676],
              [-5.57334, 54.377033],
              [-5.568172, 54.366867],
              [-5.561172, 54.3447],
              [-5.562838, 54.342865],
              [-5.559167, 54.290833],
              [-5.56222, 54.283051000000114],
              [-5.586667, 54.264999],
              [-5.60833, 54.249718],
              [-5.648056, 54.22722],
              [-5.65333, 54.225555],
              [-5.65861, 54.226387],
              [-5.66222, 54.228882],
              [-5.666945, 54.234993000000145],
              [-5.68444, 54.24305],
              [-5.69, 54.24472],
              [-5.696945, 54.24555],
              [-5.73056, 54.247498],
              [-5.74611, 54.248055000000136],
              [-5.8225, 54.240273],
              [-5.8275, 54.238884],
              [-5.85556, 54.22805],
              [-5.86389, 54.22388],
              [-5.87306, 54.21333],
              [-5.87389, 54.204994000000113],
              [-5.87194, 54.197495000000117],
              [-5.865834, 54.187775],
              [-5.865001, 54.18388],
              [-5.86389, 54.17139],
              [-5.86528, 54.162498],
              [-5.885, 54.116386],
              [-5.896389, 54.09944],
              [-5.903611, 54.094162],
              [-5.92028, 54.08583],
              [-5.968334, 54.063889000000131],
              [-6.04389, 54.03139],
              [-6.06778, 54.027771],
              [-6.075, 54.027496],
              [-6.081944, 54.02833],
              [-6.10833, 54.03638],
              [-6.170834, 54.06944],
              [-6.17722, 54.07499700000011],
              [-6.18583, 54.087494000000106],
              [-6.192223, 54.09333],
              [-6.19667, 54.095276],
              [-6.202778, 54.09666],
              [-6.26697, 54.099831],
              [-6.2675, 54.101944],
              [-6.2725, 54.104996000000142],
              [-6.278611, 54.107216],
              [-6.288611, 54.108604],
              [-6.33889, 54.115555],
              [-6.34972, 54.115555],
              [-6.355, 54.114166],
              [-6.360001, 54.111664000000133],
              [-6.363611, 54.108604],
              [-6.36528, 54.105553],
              [-6.36611, 54.10249],
              [-6.365834, 54.09944],
              [-6.4475, 54.058327],
              [-6.5675, 54.05082700000014],
              [-6.60583, 54.044441],
              [-6.608056, 54.042221],
              [-6.620001, 54.03722],
              [-6.625, 54.039162],
              [-6.632501, 54.045273000000122],
              [-6.65556, 54.065277],
              [-6.73472, 54.18361],
              [-6.851667, 54.287498000000141],
              [-6.85056, 54.291939],
              [-6.87, 54.33888],
              [-6.87611, 54.345276],
              [-6.91722, 54.373604],
              [-6.92694, 54.379166000000112],
              [-6.974445, 54.401665],
              [-7.02528, 54.416939000000127],
              [-7.030834, 54.41777],
              [-7.03639, 54.417221],
              [-7.05833, 54.41],
              [-7.16083, 54.336662],
              [-7.175556, 54.28916],
              [-7.145, 54.258888000000127],
              [-7.1425, 54.255829],
              [-7.14139, 54.252495],
              [-7.14583, 54.225273],
              [-7.280834, 54.124992000000134],
              [-7.28694, 54.121941000000106],
              [-7.313334, 54.112495000000138],
              [-7.330278, 54.113052],
              [-7.55944, 54.126938],
              [-7.610001, 54.142494],
              [-7.620001, 54.146111000000133],
              [-7.62361, 54.148888],
              [-7.624167, 54.155548],
              [-7.62306, 54.16305],
              [-7.624445, 54.166382000000112],
              [-7.62778, 54.169716000000108],
              [-7.69694, 54.202499000000103],
              [-7.7025, 54.202499000000103],
              [-7.74778, 54.200272],
              [-7.81556, 54.199165000000107],
              [-7.82056, 54.199165000000107],
              [-7.85139, 54.212219],
              [-7.86194, 54.218048],
              [-7.8675, 54.2241590000001],
              [-7.86917, 54.23111],
              [-7.86944, 54.253052],
              [-7.874722, 54.282494],
              [-7.875556, 54.28583],
              [-7.878056, 54.28916],
              [-7.90028, 54.294167],
              [-7.94139, 54.299438],
              [-8.030279, 54.357216000000108],
              [-8.045279, 54.361382],
              [-8.05583, 54.36639],
              [-8.065556, 54.372772],
              [-8.15667, 54.438606],
              [-8.15944, 54.44194],
              [-8.17167, 54.463879000000134],
              [-8.04695, 54.507217],
              [-7.95083, 54.532219000000111],
              [-7.833611, 54.55389],
              [-7.752223, 54.594444],
              [-7.7775, 54.626938000000109],
              [-7.849445, 54.633049],
              [-7.855278, 54.63472],
              [-7.90639, 54.664444],
              [-7.91389, 54.671104],
              [-7.927501, 54.698883000000137],
              [-7.92528, 54.702217],
              [-7.843056, 54.733604],
              [-7.82972, 54.735550000000103],
              [-7.824445, 54.73444400000011],
              [-7.819167, 54.731110000000115],
              [-7.73917, 54.710548],
              [-7.553334, 54.762772],
              [-7.482839, 54.82993],
              [-7.458056, 54.857773],
              [-7.44389, 54.8825],
              [-7.40639, 54.953331],
              [-7.32639, 55.045273000000122],
              [-7.25251, 55.070595],
              [-7.255, 55.047493],
              [-7.25111, 55.046104000000128],
              [-7.095, 55.036942],
              [-7.073611, 55.037773],
              [-7.06417, 55.04055000000011],
              [-7.05528, 55.044441],
              [-7.047501, 55.04916],
              [-7.02917, 55.061943],
              [-7.01972, 55.07027],
              [-6.994167, 55.110275000000115],
              [-6.966945, 55.156105000000139],
              [-6.889723, 55.16777],
              [-6.82472, 55.16805],
              [-6.730278, 55.180275000000108],
              [-6.613334, 55.207222],
              [-6.515556, 55.23305],
              [-6.37639, 55.239166],
              [-6.353333, 55.237778],
            ],
          ],
          [
            [
              [-6.172778, 55.293053],
              [-6.18111, 55.265],
              [-6.18472, 55.261383000000137],
              [-6.18833, 55.25972],
              [-6.23444, 55.291382],
              [-6.262778, 55.290276000000119],
              [-6.277779, 55.290833],
              [-6.2825, 55.29222],
              [-6.281389, 55.296387],
              [-6.262778, 55.303886],
              [-6.252501, 55.307777000000101],
              [-6.23889, 55.308609],
              [-6.19111, 55.302498000000128],
              [-6.178334, 55.299721],
              [-6.17472, 55.297493],
              [-6.172778, 55.293053],
            ],
          ],
          [
            [
              [-5.103612, 55.438606],
              [-5.171945, 55.429443],
              [-5.22361, 55.429993],
              [-5.23167, 55.430275],
              [-5.23694, 55.431938],
              [-5.283334, 55.44694],
              [-5.292778, 55.451111],
              [-5.34028, 55.474998000000141],
              [-5.342223, 55.477219],
              [-5.35722, 55.504166],
              [-5.400278, 55.600555],
              [-5.40083, 55.608887],
              [-5.400278, 55.617775000000108],
              [-5.396389, 55.628883],
              [-5.38111, 55.668610000000115],
              [-5.37806, 55.67166],
              [-5.370833, 55.676941],
              [-5.33, 55.699715],
              [-5.325556, 55.701942],
              [-5.295279, 55.71666],
              [-5.26556, 55.717216000000121],
              [-5.25194, 55.716110000000128],
              [-5.239167, 55.713608],
              [-5.22833, 55.710274],
              [-5.19833, 55.699165],
              [-5.18528, 55.692772],
              [-5.16806, 55.684166000000118],
              [-5.16028, 55.679161],
              [-5.15472, 55.673332],
              [-5.085279, 55.556664000000126],
              [-5.08389, 55.55305],
              [-5.07472, 55.463333],
              [-5.07444, 55.459160000000111],
              [-5.07583, 55.455276],
              [-5.07889, 55.452217000000132],
              [-5.093334, 55.441666],
              [-5.103612, 55.438606],
            ],
          ],
          [
            [
              [-5.016389, 55.721939000000134],
              [-5.023056, 55.721382],
              [-5.030278, 55.722221],
              [-5.03472, 55.72416],
              [-5.11889, 55.77722],
              [-5.12194, 55.78027],
              [-5.198611, 55.874161000000129],
              [-5.20056, 55.877495000000124],
              [-5.20583, 55.891937],
              [-5.20667, 55.895828],
              [-5.206389, 55.89944],
              [-5.181667, 55.91805],
              [-5.17694, 55.919998],
              [-5.170556, 55.918884],
              [-5.16056, 55.915276000000119],
              [-5.08028, 55.876938],
              [-5.03639, 55.837776],
              [-5.00889, 55.783051],
              [-5.00556, 55.77611],
              [-5.00528, 55.76778],
              [-5.00694, 55.73055],
              [-5.00917, 55.726944],
              [-5.016389, 55.721939000000134],
            ],
          ],
          [
            [
              [-6.121667, 55.878883],
              [-6.10306, 55.811104000000114],
              [-6.10194, 55.80722],
              [-6.0975, 55.796661],
              [-6.093334, 55.789993],
              [-6.08833, 55.783882],
              [-6.07556, 55.777496],
              [-6.05944, 55.772217],
              [-6.052222, 55.76722],
              [-6.05, 55.764160000000118],
              [-6.03028, 55.720551],
              [-6.024723, 55.680832000000123],
              [-6.0275, 55.677773000000116],
              [-6.038334, 55.669998],
              [-6.07667, 55.649994000000106],
              [-6.22889, 55.592216],
              [-6.274445, 55.57278],
              [-6.300556, 55.57694],
              [-6.317223, 55.58166],
              [-6.325556, 55.586662000000103],
              [-6.3275, 55.589439],
              [-6.32194, 55.615273],
              [-6.320834, 55.618889],
              [-6.28583, 55.707222000000115],
              [-6.25306, 55.76361],
              [-6.25111, 55.76722],
              [-6.25139, 55.771385],
              [-6.25444, 55.774719],
              [-6.25917, 55.776665],
              [-6.265278, 55.777771],
              [-6.32528, 55.78139],
              [-6.33167, 55.78139],
              [-6.33778, 55.78027],
              [-6.34556, 55.774994],
              [-6.348333, 55.771385],
              [-6.352501, 55.764717],
              [-6.35639, 55.758049],
              [-6.36056, 55.750275],
              [-6.3675, 55.740829],
              [-6.379723, 55.72805],
              [-6.393056, 55.717216000000121],
              [-6.41083, 55.70388800000012],
              [-6.44944, 55.680275],
              [-6.4625, 55.673882],
              [-6.473333, 55.669998],
              [-6.485, 55.668610000000115],
              [-6.491389, 55.66944],
              [-6.50139, 55.673332],
              [-6.505, 55.676666],
              [-6.509167, 55.68222],
              [-6.51, 55.690552],
              [-6.5, 55.721382],
              [-6.49528, 55.733604],
              [-6.44972, 55.84861],
              [-6.441668, 55.853607],
              [-6.36972, 55.86944],
              [-6.309723, 55.86360900000011],
              [-6.192223, 55.916382000000112],
              [-6.16306, 55.927498],
              [-6.14194, 55.933609],
              [-6.13667, 55.934441],
              [-6.12944, 55.933609],
              [-6.12194, 55.92889],
              [-6.118611, 55.921661],
              [-6.12278, 55.895],
              [-6.121667, 55.878883],
            ],
          ],
          [
            [
              [-6.19389, 56.02916],
              [-6.2, 56.028053000000114],
              [-6.240556, 56.031944],
              [-6.26306, 56.03611],
              [-6.234167, 56.077217],
              [-6.22861, 56.082771],
              [-6.210556, 56.09583],
              [-6.2025, 56.10055],
              [-6.17861, 56.11305],
              [-6.173612, 56.115273000000116],
              [-6.13889, 56.121666],
              [-6.130834, 56.120827],
              [-6.129723, 56.117218],
              [-6.178056, 56.03916],
              [-6.189723, 56.03083],
              [-6.19389, 56.02916],
            ],
          ],
          [
            [
              [-5.94694, 55.829994],
              [-5.971945, 55.78833],
              [-6.027223, 55.79166],
              [-6.0325, 55.7930530000001],
              [-6.053056, 55.800278],
              [-6.063056, 55.803886],
              [-6.07056, 55.808327],
              [-6.073611, 55.811661],
              [-6.07556, 55.815552],
              [-6.07917, 55.82666],
              [-6.088056, 55.877495000000124],
              [-6.087778, 55.881660000000124],
              [-6.084445, 55.894165],
              [-6.07889, 55.905548],
              [-5.96806, 56.0236],
              [-5.95583, 56.030548000000124],
              [-5.906389, 56.058327000000133],
              [-5.90167, 56.060829],
              [-5.80917, 56.10972],
              [-5.755, 56.133331000000112],
              [-5.745001, 56.137497],
              [-5.71139, 56.150276],
              [-5.705556, 56.15083],
              [-5.69444, 56.147217000000126],
              [-5.685, 56.125832000000116],
              [-5.68444, 56.121941],
              [-5.68444, 56.117493],
              [-5.68611, 56.11305],
              [-5.69083, 56.106667],
              [-5.7025, 56.098885],
              [-5.708056, 56.096107],
              [-5.71694, 56.089439],
              [-5.73028, 56.078049],
              [-5.74611, 56.063606000000107],
              [-5.75194, 56.05694],
              [-5.845834, 55.94944],
              [-5.90417, 55.8825],
              [-5.94694, 55.829994],
            ],
          ],
          [
            [
              [-5.735001, 56.158051],
              [-5.7425, 56.158051],
              [-5.748056, 56.159721],
              [-5.75, 56.162773],
              [-5.744167, 56.16916700000013],
              [-5.73556, 56.177773],
              [-5.69139, 56.19444],
              [-5.68556, 56.195549],
              [-5.67972, 56.194717],
              [-5.67528, 56.19194],
              [-5.67389, 56.189163],
              [-5.673612, 56.184998],
              [-5.673612, 56.17305],
              [-5.675834, 56.169441],
              [-5.68528, 56.16555],
              [-5.7025, 56.161385],
              [-5.71333, 56.159439],
              [-5.735001, 56.158051],
            ],
          ],
          [
            [
              [-5.63, 56.19694],
              [-5.638056, 56.186661],
              [-5.64417, 56.18777],
              [-5.648056, 56.18972],
              [-5.663334, 56.21249],
              [-5.665278, 56.21583],
              [-5.64417, 56.2561],
              [-5.64194, 56.260277],
              [-5.60944, 56.2575],
              [-5.60639, 56.254440000000102],
              [-5.60688, 56.250000000000114],
              [-5.63, 56.19694],
            ],
          ],
          [
            [
              [-5.616667, 56.268883],
              [-5.62278, 56.26722],
              [-5.630834, 56.268051],
              [-5.635556, 56.27],
              [-5.648056, 56.293053],
              [-5.64556, 56.30110900000011],
              [-5.64333, 56.304443],
              [-5.630834, 56.316109],
              [-5.62194, 56.320831000000112],
              [-5.61444, 56.32111],
              [-5.589723, 56.321388],
              [-5.58389, 56.31972],
              [-5.583611, 56.315552000000139],
              [-5.585279, 56.311386],
              [-5.60306, 56.27916],
              [-5.60861, 56.27333],
              [-5.616667, 56.268883],
            ],
          ],
          [
            [
              [-6.404723, 56.303604000000121],
              [-6.41, 56.301941],
              [-6.418334, 56.302216],
              [-6.433056, 56.308327],
              [-6.436389, 56.310555],
              [-6.41639, 56.33138300000013],
              [-6.393889, 56.34111],
              [-6.387778, 56.342216000000121],
              [-6.38194, 56.34083],
              [-6.38083, 56.337494],
              [-6.38917, 56.322777],
              [-6.39333, 56.315826],
              [-6.40111, 56.306107000000111],
              [-6.404723, 56.303604000000121],
            ],
          ],
          [
            [
              [-5.54361, 56.38277],
              [-5.55278, 56.378052],
              [-5.584445, 56.382217],
              [-5.586667, 56.384995],
              [-5.587778, 56.38916],
              [-5.585556, 56.392220000000123],
              [-5.56778, 56.406105],
              [-5.545834, 56.409439],
              [-5.51, 56.41111],
              [-5.53639, 56.38777],
              [-5.54361, 56.38277],
            ],
          ],
          [
            [
              [-6.165833, 56.464722],
              [-6.19889, 56.458611000000133],
              [-6.23278, 56.465],
              [-6.238611, 56.466110000000128],
              [-6.25889, 56.477776000000119],
              [-6.26, 56.48194100000012],
              [-6.258612, 56.485550000000103],
              [-6.241667, 56.49472],
              [-6.236667, 56.496666],
              [-6.22472, 56.499161],
              [-6.215556, 56.497772000000111],
              [-6.205, 56.49472],
              [-6.162778, 56.475273000000129],
              [-6.15972, 56.472771],
              [-6.157778, 56.469444000000124],
              [-6.16056, 56.465828000000101],
              [-6.165833, 56.464722],
            ],
          ],
          [
            [
              [-6.739167, 56.515831],
              [-6.758612, 56.51416],
              [-6.774167, 56.515831],
              [-6.78944, 56.51527],
              [-6.79583, 56.514717],
              [-6.801667, 56.513054000000125],
              [-6.806111, 56.511383],
              [-6.87639, 56.474998000000141],
              [-6.88194, 56.468887],
              [-6.892778, 56.43861],
              [-6.925, 56.439995000000124],
              [-6.97222, 56.449165],
              [-6.990834, 56.494438000000116],
              [-6.98861, 56.498055],
              [-6.97333, 56.508049],
              [-6.958056, 56.513054000000125],
              [-6.76389, 56.54833200000013],
              [-6.75806, 56.549164],
              [-6.7525, 56.547493000000145],
              [-6.74472, 56.542221],
              [-6.733334, 56.53083],
              [-6.729167, 56.52444],
              [-6.72889, 56.520271],
              [-6.739167, 56.515831],
            ],
          ],
          [
            [
              [-5.783611, 56.508888],
              [-5.714723, 56.47888],
              [-5.65111, 56.451111],
              [-5.64889, 56.443886],
              [-5.64833, 56.435829],
              [-5.65861, 56.403053000000114],
              [-5.66306, 56.395554000000118],
              [-5.701945, 56.359161],
              [-5.714723, 56.351944000000117],
              [-5.80861, 56.3175],
              [-5.84028, 56.30888],
              [-5.84694, 56.308052],
              [-5.860001, 56.310555],
              [-5.87194, 56.31416],
              [-5.87806, 56.31916],
              [-5.87139, 56.325272],
              [-5.865834, 56.327217],
              [-5.85972, 56.332497000000103],
              [-5.85389, 56.339165],
              [-5.85222, 56.342773],
              [-5.852501, 56.347771],
              [-5.85472, 56.349716],
              [-5.860278, 56.351944000000117],
              [-5.86778, 56.352493],
              [-5.8825, 56.351944000000117],
              [-5.892778, 56.3491590000001],
              [-5.983612, 56.318604],
              [-6.016111, 56.304718],
              [-6.26472, 56.258888],
              [-6.32111, 56.26416],
              [-6.325, 56.266663],
              [-6.33944, 56.276382],
              [-6.346111, 56.281662],
              [-6.348333, 56.284439000000134],
              [-6.36611, 56.30888],
              [-6.366389, 56.31305],
              [-6.363611, 56.329994000000113],
              [-6.350278, 56.33694],
              [-6.33944, 56.339165],
              [-6.29778, 56.34083],
              [-6.29056, 56.339996],
              [-6.281667, 56.336105],
              [-6.278056, 56.333328000000108],
              [-6.271945, 56.327499000000103],
              [-6.23194, 56.318329],
              [-6.06583, 56.354996],
              [-6.027223, 56.365273],
              [-6.022223, 56.367493],
              [-6.01861, 56.36972],
              [-6.01778, 56.374718],
              [-6.01917, 56.378326],
              [-6.021945, 56.381104],
              [-6.0275, 56.38277],
              [-6.03444, 56.382217],
              [-6.07889, 56.371109000000104],
              [-6.10472, 56.362778],
              [-6.115834, 56.359993000000145],
              [-6.169168, 56.35611],
              [-6.185, 56.35666700000013],
              [-6.19361, 56.361382],
              [-6.198611, 56.367775000000108],
              [-6.203056, 56.378052],
              [-6.200278, 56.386665],
              [-6.14306, 56.428055],
              [-6.083056, 56.442772],
              [-6.07167, 56.446106],
              [-6.03194, 56.45944],
              [-6.021389, 56.463333],
              [-6.012778, 56.4675],
              [-6.00694, 56.47416],
              [-6.005556, 56.477776000000119],
              [-6.002223, 56.489998],
              [-6.00278, 56.494164],
              [-6.00639, 56.496109],
              [-6.017691, 56.496552],
              [-6.09889, 56.481110000000115],
              [-6.118056, 56.47333],
              [-6.12639, 56.473885],
              [-6.13194, 56.475273000000129],
              [-6.32528, 56.53944],
              [-6.33778, 56.546661],
              [-6.323056, 56.599998],
              [-6.320001, 56.60305000000011],
              [-6.18667, 56.643051000000128],
              [-6.14056, 56.652771],
              [-6.133889, 56.653328000000101],
              [-6.116667, 56.65028],
              [-6.06889, 56.638885],
              [-6.05694, 56.635826],
              [-6.03944, 56.622772],
              [-5.99611, 56.583328],
              [-5.99306, 56.579994],
              [-5.974445, 56.55082700000014],
              [-5.971111, 56.544441],
              [-5.85639, 56.519165],
              [-5.80056, 56.513611],
              [-5.79389, 56.512772],
              [-5.783611, 56.508888],
            ],
          ],
          [
            [
              [-6.58917, 56.579994],
              [-6.678334, 56.55555],
              [-6.68583, 56.556664000000126],
              [-6.69444, 56.56944],
              [-6.69889, 56.579994],
              [-6.696112, 56.583328],
              [-6.61389, 56.63444],
              [-6.57389, 56.653328000000101],
              [-6.545834, 56.666107000000125],
              [-6.509723, 56.68222],
              [-6.504723, 56.683884],
              [-6.49333, 56.68722],
              [-6.465556, 56.688889],
              [-6.45722, 56.689163],
              [-6.454445, 56.686104],
              [-6.45306, 56.682495],
              [-6.454445, 56.678886],
              [-6.485, 56.638611],
              [-6.49333, 56.629997],
              [-6.50139, 56.62499],
              [-6.574445, 56.585548],
              [-6.578889, 56.583328],
              [-6.58917, 56.579994],
            ],
          ],
          [
            [
              [-6.14472, 56.869995],
              [-6.159167, 56.869164],
              [-6.178056, 56.873055],
              [-6.21139, 56.88721],
              [-6.21361, 56.89055],
              [-6.21444, 56.898888],
              [-6.214723, 56.903053],
              [-6.213056, 56.906944],
              [-6.2075, 56.91333],
              [-6.158611, 56.940826],
              [-6.14972, 56.945000000000107],
              [-6.1375, 56.943054],
              [-6.11361, 56.932495000000131],
              [-6.1075, 56.92694],
              [-6.10806, 56.921104],
              [-6.114722, 56.895554],
              [-6.119722, 56.883888],
              [-6.123334, 56.881104000000107],
              [-6.13889, 56.871384],
              [-6.14472, 56.869995],
            ],
          ],
          [
            [
              [-6.3175, 56.934166],
              [-6.325556, 56.934166],
              [-6.33056, 56.935555],
              [-6.361945, 56.946388],
              [-6.44833, 56.998886],
              [-6.45222, 57.002220000000136],
              [-6.45167, 57.006104],
              [-6.41556, 57.032776],
              [-6.39333, 57.043884],
              [-6.38417, 57.04805],
              [-6.347501, 57.053055],
              [-6.32611, 57.054161],
              [-6.277223, 57.04333],
              [-6.27056, 57.041664],
              [-6.26167, 57.03777],
              [-6.254168, 57.03194],
              [-6.24972, 57.025833],
              [-6.249167, 57.022217],
              [-6.2475, 56.99555],
              [-6.255, 56.964165],
              [-6.25694, 56.960548],
              [-6.26667, 56.951660000000118],
              [-6.27833, 56.94444],
              [-6.29861, 56.937218000000144],
              [-6.310556, 56.934441],
              [-6.3175, 56.934166],
            ],
          ],
          [
            [
              [-7.466945, 56.940826],
              [-7.47528, 56.940826],
              [-7.51528, 56.943054],
              [-7.53056, 56.94416],
              [-7.55028, 56.947495000000117],
              [-7.55944, 56.951385],
              [-7.560556, 56.955551],
              [-7.56, 56.96027400000014],
              [-7.55361, 56.966385],
              [-7.44556, 57.05555],
              [-7.43972, 57.054443000000106],
              [-7.418612, 57.043884],
              [-7.41472, 57.041382],
              [-7.378056, 56.982216],
              [-7.37611, 56.978607],
              [-7.43472, 56.945000000000107],
              [-7.43917, 56.942772000000105],
              [-7.466945, 56.940826],
            ],
          ],
          [
            [
              [-6.49917, 57.052216],
              [-6.581112, 57.043884],
              [-6.6025, 57.046387],
              [-6.60139, 57.05110900000011],
              [-6.593334, 57.054993000000138],
              [-6.55556, 57.066383],
              [-6.549445, 57.068054],
              [-6.543612, 57.067497],
              [-6.499722, 57.062218],
              [-6.49417, 57.060555],
              [-6.491945, 57.05722],
              [-6.495, 57.054161],
              [-6.49917, 57.052216],
            ],
          ],
          [
            [
              [-5.939167, 57.278053],
              [-5.94611, 57.277771000000143],
              [-5.96889, 57.279999],
              [-5.980278, 57.282776],
              [-5.996389, 57.28833],
              [-6.008334, 57.295273],
              [-6.018056, 57.303329],
              [-6.01917, 57.307777],
              [-6.01778, 57.311661],
              [-6.015, 57.314438],
              [-6.00583, 57.318604],
              [-5.98778, 57.320549],
              [-5.95667, 57.318604],
              [-5.95028, 57.317215],
              [-5.933889, 57.311661],
              [-5.93, 57.30971],
              [-5.92083, 57.301109],
              [-5.91861, 57.297775],
              [-5.91778, 57.29417],
              [-5.91833, 57.289444],
              [-5.923334, 57.283333],
              [-5.928056, 57.28083],
              [-5.939167, 57.278053],
            ],
          ],
          [
            [
              [-7.22306, 57.337494],
              [-7.231112, 57.332771],
              [-7.24611, 57.327774],
              [-7.25222, 57.326660000000118],
              [-7.258889, 57.327217],
              [-7.28528, 57.336105],
              [-7.28806, 57.322495000000117],
              [-7.25917, 57.152496],
              [-7.21472, 57.114441],
              [-7.21528, 57.110275],
              [-7.225834, 57.096939000000134],
              [-7.230278, 57.094719000000111],
              [-7.265556, 57.103607],
              [-7.28722, 57.10611],
              [-7.303334, 57.10611],
              [-7.333611, 57.099998],
              [-7.356112, 57.09916],
              [-7.36306, 57.099998],
              [-7.38139, 57.108604],
              [-7.38667, 57.11472],
              [-7.3925, 57.124992],
              [-7.39611, 57.131943],
              [-7.4175, 57.182495],
              [-7.41889, 57.186661],
              [-7.420834, 57.21833],
              [-7.425, 57.382217],
              [-7.42222, 57.38528],
              [-7.41222, 57.389717000000132],
              [-7.368056, 57.401382],
              [-7.335556, 57.395828],
              [-7.28583, 57.381104],
              [-7.271945, 57.37527],
              [-7.267222, 57.372215],
              [-7.224445, 57.341660000000104],
              [-7.22306, 57.337494],
            ],
          ],
          [
            [
              [-7.268889, 57.398888000000113],
              [-7.28333, 57.397499],
              [-7.31361, 57.399719000000118],
              [-7.32028, 57.401382],
              [-7.378056, 57.420273],
              [-7.388056, 57.423882],
              [-7.40472, 57.441940000000102],
              [-7.40944, 57.448326],
              [-7.410001, 57.452217],
              [-7.40639, 57.46416],
              [-7.40417, 57.467773],
              [-7.40028, 57.470276],
              [-7.357779, 57.488327],
              [-7.351111, 57.489441],
              [-7.300556, 57.483604],
              [-7.276112, 57.48055],
              [-7.24417, 57.476387000000102],
              [-7.204722, 57.46083],
              [-7.2025, 57.4575],
              [-7.202223, 57.418884],
              [-7.20444, 57.41499],
              [-7.23944, 57.40361],
              [-7.24472, 57.402222000000108],
              [-7.268889, 57.398888000000113],
            ],
          ],
          [
            [
              [-6.02694, 57.328606],
              [-6.051111, 57.32444],
              [-6.06028, 57.32471],
              [-6.06611, 57.32638500000013],
              [-6.06833, 57.329163000000108],
              [-6.079445, 57.34888],
              [-6.07972, 57.35305],
              [-6.07833, 57.3941650000001],
              [-6.07306, 57.43055],
              [-6.06528, 57.451111],
              [-6.06361, 57.45472],
              [-6.031667, 57.491943],
              [-6.02778, 57.494438],
              [-6.003056, 57.50861],
              [-5.98, 57.495827],
              [-5.976945, 57.492493],
              [-5.976667, 57.488327],
              [-5.990001, 57.349998],
              [-5.99444, 57.34277],
              [-5.997223, 57.33972],
              [-6.00639, 57.335],
              [-6.02694, 57.328606],
            ],
          ],
          [
            [
              [-5.967778, 57.522774],
              [-5.97139, 57.515274],
              [-5.978333, 57.515831],
              [-5.98889, 57.524162000000103],
              [-5.99028, 57.527771],
              [-5.990834, 57.540833000000134],
              [-5.98222, 57.562492],
              [-5.96639, 57.57278],
              [-5.961667, 57.575],
              [-5.95583, 57.57388],
              [-5.95389, 57.57055],
              [-5.95333, 57.567215],
              [-5.967778, 57.522774],
            ],
          ],
          [
            [
              [-6.14389, 57.568054000000132],
              [-6.13667, 57.484444],
              [-6.14667, 57.419167],
              [-6.14778, 57.40416],
              [-6.134723, 57.31305],
              [-6.127223, 57.306107],
              [-5.899167, 57.241943000000106],
              [-5.88667, 57.239166],
              [-5.88, 57.239998000000128],
              [-5.83333, 57.253609],
              [-5.76889, 57.27222],
              [-5.750556, 57.276108],
              [-5.743056, 57.275833],
              [-5.64917, 57.259995],
              [-5.64611, 57.256660000000124],
              [-5.66139, 57.209160000000111],
              [-5.66389, 57.204994],
              [-5.670279, 57.199715],
              [-5.803612, 57.11666],
              [-5.816389, 57.110275],
              [-5.82694, 57.10666700000013],
              [-5.833056, 57.10555],
              [-5.847501, 57.10527],
              [-5.859167, 57.092773],
              [-5.88917, 57.063889],
              [-5.893056, 57.061104],
              [-5.928056, 57.038605],
              [-5.93944, 57.035553],
              [-5.98, 57.026939],
              [-5.99833, 57.0236],
              [-6.011945, 57.022217],
              [-6.01667, 57.024719000000118],
              [-6.03222, 57.047775000000115],
              [-6.03472, 57.05472],
              [-6.033334, 57.058327000000133],
              [-5.990834, 57.111664],
              [-5.974167, 57.13027],
              [-6.03056, 57.177498],
              [-6.073611, 57.126389],
              [-6.07722, 57.124161],
              [-6.085556, 57.124992],
              [-6.09667, 57.128326],
              [-6.17667, 57.17055],
              [-6.31444, 57.157494],
              [-6.318334, 57.159439],
              [-6.44694, 57.263329],
              [-6.4525, 57.26944],
              [-6.47917, 57.29972],
              [-6.48139, 57.30305],
              [-6.48083, 57.307495],
              [-6.42611, 57.332771],
              [-6.421667, 57.334717],
              [-6.41306, 57.335],
              [-6.39833, 57.328606],
              [-6.37389, 57.314438],
              [-6.345834, 57.30222],
              [-6.33528, 57.29833],
              [-6.32944, 57.29722],
              [-6.314167, 57.297493],
              [-6.31028, 57.299995],
              [-6.309723, 57.30416],
              [-6.52694, 57.406662],
              [-6.533334, 57.40833],
              [-6.573611, 57.38416],
              [-6.573611, 57.375832],
              [-6.56444, 57.353882],
              [-6.56333, 57.350273],
              [-6.56361, 57.345551],
              [-6.56722, 57.337494],
              [-6.57, 57.335],
              [-6.575556, 57.333328000000108],
              [-6.582778, 57.333885],
              [-6.625, 57.34416],
              [-6.68917, 57.360832],
              [-6.7, 57.363884],
              [-6.709723, 57.36805],
              [-6.720834, 57.376106],
              [-6.72278, 57.37944],
              [-6.72472, 57.387215],
              [-6.72444, 57.40361],
              [-6.772779, 57.42777],
              [-6.77667, 57.430275],
              [-6.77889, 57.43305],
              [-6.78583, 57.44611],
              [-6.78472, 57.449997],
              [-6.7475, 57.492775],
              [-6.6375, 57.605553],
              [-6.62278, 57.60583],
              [-6.615834, 57.60472],
              [-6.60722, 57.600555],
              [-6.58639, 57.588608000000136],
              [-6.57833, 57.583054000000118],
              [-6.572223, 57.577774],
              [-6.56556, 57.568329],
              [-6.56444, 57.555832],
              [-6.56333, 57.552216],
              [-6.55722, 57.546387],
              [-6.46333, 57.508888],
              [-6.43, 57.504997000000117],
              [-6.375556, 57.524162000000103],
              [-6.39583, 57.602776],
              [-6.42028, 57.63472],
              [-6.42139, 57.63749700000011],
              [-6.419168, 57.641937],
              [-6.40722, 57.648888],
              [-6.34556, 57.68471],
              [-6.304167, 57.686104],
              [-6.276945, 57.67222],
              [-6.18139, 57.614441],
              [-6.174445, 57.608604],
              [-6.16306, 57.597221000000104],
              [-6.15806, 57.59111],
              [-6.14611, 57.575],
              [-6.14389, 57.568054000000132],
            ],
          ],
          [
            [
              [-7.18861, 57.687218000000144],
              [-7.075278, 57.64222],
              [-7.0675, 57.63749700000011],
              [-7.06583, 57.633331],
              [-7.1475, 57.514999000000103],
              [-7.15389, 57.509438],
              [-7.16833, 57.508049],
              [-7.233612, 57.503609],
              [-7.31472, 57.504166000000112],
              [-7.32139, 57.505272],
              [-7.32611, 57.507774],
              [-7.3275, 57.527496],
              [-7.32528, 57.54416700000013],
              [-7.347778, 57.55082700000014],
              [-7.411667, 57.568054000000132],
              [-7.455556, 57.563889000000131],
              [-7.467778, 57.561943],
              [-7.47694, 57.562492],
              [-7.48611, 57.56611],
              [-7.53639, 57.5861],
              [-7.540278, 57.588051],
              [-7.54333, 57.590828000000101],
              [-7.54333, 57.595551000000114],
              [-7.491389, 57.646385],
              [-7.48389, 57.651939],
              [-7.47278, 57.655],
              [-7.432501, 57.653328],
              [-7.275, 57.656387],
              [-7.271111, 57.659439000000134],
              [-7.24472, 57.676941],
              [-7.197223, 57.68694],
              [-7.18861, 57.687218000000144],
            ],
          ],
          [
            [
              [-7.196667, 57.702217],
              [-7.20444, 57.701942],
              [-7.21972, 57.703331],
              [-7.219167, 57.707771],
              [-7.21278, 57.713608],
              [-7.19861, 57.724716],
              [-7.189723, 57.728882],
              [-7.17389, 57.7336],
              [-7.16667, 57.734718],
              [-7.16, 57.734161],
              [-7.14472, 57.723610000000122],
              [-7.145278, 57.718887],
              [-7.15, 57.716660000000104],
              [-7.155001, 57.714996],
              [-7.196667, 57.702217],
            ],
          ],
          [
            [
              [-8.55528, 57.810829],
              [-8.575556, 57.798607],
              [-8.5825, 57.798882000000106],
              [-8.606112, 57.804718],
              [-8.61195, 57.806389],
              [-8.62139, 57.822777],
              [-8.61861, 57.826111],
              [-8.583612, 57.823883000000137],
              [-8.565556, 57.819717],
              [-8.554724, 57.816109],
              [-8.552223, 57.813889],
              [-8.55528, 57.810829],
            ],
          ],
          [
            [
              [-7.00639, 57.881386000000134],
              [-7.073611, 57.877777],
              [-7.077778, 57.88],
              [-7.07667, 57.892776],
              [-7.073611, 57.896111],
              [-7.032778, 57.91555],
              [-7.0275, 57.91694],
              [-7.007223, 57.919716],
              [-6.99944, 57.919998000000135],
              [-6.993611, 57.91861],
              [-6.994167, 57.913887],
              [-6.9975, 57.890831],
              [-6.998889, 57.88721],
              [-7.00639, 57.881386000000134],
            ],
          ],
          [
            [
              [-6.802222, 58.203049],
              [-6.83889, 58.201942],
              [-6.86917, 58.203888],
              [-6.873056, 58.206383],
              [-6.888889, 58.244438000000116],
              [-6.89, 58.248604],
              [-6.889723, 58.252495],
              [-6.88167, 58.25417],
              [-6.860278, 58.251106000000107],
              [-6.854167, 58.25],
              [-6.809723, 58.228607000000125],
              [-6.79444, 58.218048],
              [-6.79139, 58.20694],
              [-6.79444, 58.203331000000105],
              [-6.802222, 58.203049],
            ],
          ],
          [
            [
              [-6.20417, 58.35611],
              [-6.2325, 58.317772000000105],
              [-6.279723, 58.287773],
              [-6.32389, 58.263611],
              [-6.32828, 58.23794],
              [-6.32844, 58.23544],
              [-6.32761, 58.23344],
              [-6.32528, 58.231773],
              [-6.32178, 58.230774],
              [-6.28511, 58.22293900000011],
              [-6.28128, 58.222275],
              [-6.276945, 58.222775],
              [-6.273612, 58.223606],
              [-6.265445, 58.227444],
              [-6.22083, 58.233604],
              [-6.208611, 58.240829000000133],
              [-6.1725, 58.25833],
              [-6.167778, 58.260551000000135],
              [-6.160001, 58.259720000000129],
              [-6.148056, 58.256104000000107],
              [-6.146945, 58.252777],
              [-6.158334, 58.21833],
              [-6.164445, 58.212219],
              [-6.17222, 58.20694],
              [-6.22472, 58.183609],
              [-6.263778, 58.17661],
              [-6.32911, 58.182774],
              [-6.366667, 58.158607000000131],
              [-6.37472, 58.135551],
              [-6.37694, 58.13194],
              [-6.382223, 58.129715],
              [-6.497223, 58.0975],
              [-6.54806, 58.091942],
              [-6.60111, 58.085],
              [-6.62028, 58.08194],
              [-6.619167, 58.078331],
              [-6.59472, 58.078331],
              [-6.49694, 58.087494],
              [-6.42028, 58.102219],
              [-6.41028, 58.10555],
              [-6.4025, 58.105827],
              [-6.396111, 58.104721],
              [-6.390556, 58.09861],
              [-6.35389, 58.033051],
              [-6.356668, 58.03],
              [-6.386111, 58.009163000000115],
              [-6.457778, 57.968048000000124],
              [-6.47389, 57.948326000000122],
              [-6.472778, 57.94416],
              [-6.47389, 57.940277],
              [-6.53806, 57.916382],
              [-6.544168, 57.914993],
              [-6.57056, 57.911385],
              [-6.5775, 57.910828],
              [-6.62111, 57.914444000000117],
              [-6.628056, 57.915276],
              [-6.65306, 57.919998000000135],
              [-6.66222, 57.924164],
              [-6.66639, 57.926941000000113],
              [-6.69194, 57.958054000000118],
              [-6.698611, 57.967499],
              [-6.704722, 57.98666],
              [-6.70694, 57.998886],
              [-6.70611, 58.0075],
              [-6.6975, 58.021385],
              [-6.69444, 58.024437],
              [-6.662778, 58.04444100000012],
              [-6.659167, 58.04666],
              [-6.652779, 58.048332],
              [-6.62944, 58.048332],
              [-6.62194, 58.047775000000115],
              [-6.615001, 58.046104],
              [-6.59861, 58.045273],
              [-6.59361, 58.046387],
              [-6.590279, 58.049995000000138],
              [-6.59528, 58.052498],
              [-6.60028, 58.05389],
              [-6.60778, 58.054718],
              [-6.67, 58.058052],
              [-6.678334, 58.058327],
              [-6.68444, 58.057495],
              [-6.68917, 58.054993000000138],
              [-6.76139, 57.998329],
              [-6.725834, 57.95444],
              [-6.72278, 57.95111],
              [-6.71889, 57.949165],
              [-6.70528, 57.94694],
              [-6.696389, 57.942497],
              [-6.685, 57.934441],
              [-6.679723, 57.928329],
              [-6.677501, 57.92555],
              [-6.66472, 57.900551000000121],
              [-6.66056, 57.884720000000129],
              [-6.66222, 57.880554],
              [-6.735278, 57.825829],
              [-6.960834, 57.727493],
              [-6.965556, 57.72555],
              [-6.9725, 57.724716],
              [-6.97833, 57.72583],
              [-6.98389, 57.728333000000134],
              [-7.120001, 57.814163],
              [-7.12306, 57.817497],
              [-7.124445, 57.820831],
              [-7.126667, 57.833328],
              [-7.125278, 57.837776000000133],
              [-7.118334, 57.838051],
              [-7.10389, 57.836662],
              [-7.092223, 57.832771],
              [-7.083611, 57.824715],
              [-7.06583, 57.820831],
              [-7.02889, 57.83222],
              [-6.83028, 57.90083],
              [-6.83417, 57.90361],
              [-6.87944, 57.932495000000131],
              [-6.935, 57.949715],
              [-6.946112, 57.952774],
              [-6.985, 57.959442],
              [-6.992778, 57.95916],
              [-7.021945, 57.951942000000145],
              [-7.02972, 57.95222],
              [-7.03556, 57.953331],
              [-7.075278, 57.962494],
              [-7.11278, 57.983887],
              [-7.11389, 57.987221],
              [-7.08417, 58.008049000000142],
              [-7.05556, 58.020271],
              [-7.05778, 58.036385],
              [-7.093889, 58.070549],
              [-7.126667, 58.123329000000126],
              [-7.128334, 58.130272000000105],
              [-7.12806, 58.13472],
              [-7.09444, 58.181938],
              [-7.05917, 58.220276],
              [-7.05556, 58.22333],
              [-7.04056, 58.233330000000137],
              [-7.031945, 58.238052],
              [-7.008056, 58.235275000000115],
              [-7.00111, 58.23444400000011],
              [-6.91972, 58.216110000000128],
              [-6.90806, 58.21278],
              [-6.905834, 58.209717],
              [-6.90806, 58.206108],
              [-6.920279, 58.203606],
              [-6.93611, 58.188049],
              [-6.87417, 58.11111],
              [-6.86806, 58.10611],
              [-6.861945, 58.103882000000112],
              [-6.86, 58.108055],
              [-6.873279, 58.17859],
              [-6.805183, 58.195866],
              [-6.750374, 58.185238],
              [-6.74473, 58.197197],
              [-6.78658, 58.229416000000128],
              [-6.808056, 58.259720000000129],
              [-6.81778, 58.279999],
              [-6.815556, 58.284721],
              [-6.79778, 58.30222],
              [-6.67306, 58.349159],
              [-6.658334, 58.349442],
              [-6.65222, 58.348610000000122],
              [-6.646945, 58.341942000000131],
              [-6.56028, 58.3597180000001],
              [-6.55028, 58.363327],
              [-6.355278, 58.4575],
              [-6.310556, 58.47916],
              [-6.292778, 58.488327],
              [-6.276945, 58.508331000000112],
              [-6.272223, 58.510551],
              [-6.266945, 58.512497],
              [-6.25972, 58.512772],
              [-6.25306, 58.511665000000107],
              [-6.24444, 58.5086060000001],
              [-6.23472, 58.504166000000112],
              [-6.22333, 58.49638],
              [-6.166112, 58.425278000000105],
              [-6.165833, 58.420555],
              [-6.20417, 58.35611],
            ],
          ],
          [
            [
              [-4.15333, 53.22555],
              [-4.138056, 53.229721],
              [-4.13111, 53.229721],
              [-4.105278, 53.227493],
              [-4.066389, 53.226387],
              [-4.018612, 53.237495],
              [-4.00306, 53.241943],
              [-3.85444, 53.284439],
              [-3.732778, 53.290276],
              [-3.7275, 53.288605000000132],
              [-3.6925, 53.285553],
              [-3.61306, 53.27916],
              [-3.606667, 53.279716],
              [-3.58944, 53.282219],
              [-3.46167, 53.320549000000142],
              [-3.388056, 53.3436],
              [-3.36278, 53.346107],
              [-3.336389, 53.347221],
              [-3.32278, 53.347221],
              [-3.315, 53.34666],
              [-3.21167, 53.297493],
              [-3.13056, 53.2575],
              [-3.12139, 53.25361],
              [-3.10222, 53.247772],
              [-3.0886, 53.26001],
              [-3.083611, 53.263885],
              [-3.08167, 53.267494],
              [-3.0825, 53.271385000000123],
              [-3.12611, 53.32499700000011],
              [-3.15417, 53.34833],
              [-3.164444, 53.356110000000115],
              [-3.16944, 53.358055],
              [-3.17639, 53.362778000000105],
              [-3.187222, 53.37444],
              [-3.190556, 53.381104000000107],
              [-3.192223, 53.385551000000135],
              [-3.187222, 53.391106],
              [-3.180278, 53.396111],
              [-3.17083, 53.400276],
              [-3.07574, 53.408562],
              [-3.069222, 53.410164],
              [-3.06172, 53.410831000000144],
              [-3.054556, 53.4095],
              [-3.04839, 53.4075],
              [-3.04439, 53.40466],
              [-3.04089, 53.401161000000116],
              [-3.02989, 53.3863300000001],
              [-3.02789, 53.377495],
              [-2.98944, 53.367218],
              [-2.9425, 53.310555000000136],
              [-2.928292, 53.302162],
              [-2.899723, 53.289162],
              [-2.8825, 53.285271000000137],
              [-2.86222, 53.282776000000126],
              [-2.776389, 53.292496],
              [-2.755, 53.303055],
              [-2.75139, 53.30555],
              [-2.7025, 53.346382],
              [-2.70083, 53.350273000000129],
              [-2.70444, 53.35249],
              [-2.71194, 53.353333],
              [-2.7175, 53.35249],
              [-2.765278, 53.341110000000128],
              [-2.773612, 53.337494000000106],
              [-2.77667, 53.33444],
              [-2.778889, 53.33111],
              [-2.853611, 53.320549000000142],
              [-2.861111, 53.321106],
              [-2.87361, 53.324165],
              [-2.883056, 53.327217000000132],
              [-2.95389, 53.360275000000115],
              [-2.963889, 53.367775],
              [-3.006778, 53.417385000000138],
              [-3.01328, 53.425053],
              [-3.1075, 53.551666],
              [-3.106667, 53.560272000000111],
              [-3.104167, 53.563889],
              [-3.09361, 53.57638500000013],
              [-3.073056, 53.598053000000107],
              [-2.98222, 53.690552],
              [-2.97861, 53.693604],
              [-2.97417, 53.695549000000142],
              [-2.94222, 53.708054],
              [-2.902223, 53.720551],
              [-2.898889, 53.723053],
              [-2.8975, 53.72666],
              [-2.900556, 53.72972],
              [-2.90417, 53.731667],
              [-2.91028, 53.733055],
              [-2.924445, 53.73444400000011],
              [-2.93944, 53.734718],
              [-2.966111, 53.733604],
              [-2.992778, 53.732773],
              [-3.006389, 53.734993],
              [-3.02167, 53.739716],
              [-3.033611, 53.746941000000106],
              [-3.04056, 53.751938],
              [-3.05139, 53.764717],
              [-3.054167, 53.77],
              [-3.05806, 53.78083],
              [-3.05972, 53.788887000000102],
              [-3.05972, 53.79749],
              [-3.053056, 53.90583],
              [-3.05222, 53.909439],
              [-3.04722, 53.916382],
              [-3.03972, 53.921104],
              [-3.025, 53.92610900000011],
              [-2.9325, 53.950554000000125],
              [-2.896945, 53.998886],
              [-2.83361, 54.084999],
              [-2.8175, 54.142776],
              [-2.81361, 54.22277],
              [-2.926667, 54.155273],
              [-2.93528, 54.15138],
              [-3.152223, 54.081940000000145],
              [-3.21472, 54.095551000000114],
              [-3.226111, 54.09861],
              [-3.23389, 54.103333],
              [-3.380556, 54.244438],
              [-3.409167, 54.276665],
              [-3.411945, 54.283607],
              [-3.41222, 54.291107],
              [-3.43389, 54.348053000000107],
              [-3.466111, 54.378609],
              [-3.493056, 54.40333],
              [-3.52472, 54.426109],
              [-3.55694, 54.448326],
              [-3.61306, 54.488609],
              [-3.62972, 54.505829000000119],
              [-3.63417, 54.51194],
              [-3.63333, 54.515549],
              [-3.569167, 54.642494],
              [-3.429167, 54.815552],
              [-3.39167, 54.876389000000131],
              [-3.38111, 54.88444],
              [-3.29194, 54.93694],
              [-3.28667, 54.938889],
              [-3.27, 54.94138],
              [-3.20861, 54.94944],
              [-3.194723, 54.949997],
              [-3.18944, 54.948608],
              [-3.185, 54.94611],
              [-3.18333, 54.942215],
              [-3.178889, 54.940552000000139],
              [-3.13639, 54.931389000000138],
              [-3.12944, 54.931389000000138],
              [-3.103333, 54.93388],
              [-3.02639, 54.945549],
              [-3.025, 54.94944],
              [-3.023056, 54.970551],
              [-3.031111, 54.975273],
              [-3.04139, 54.978882000000112],
              [-3.05103, 54.979866000000129],
              [-3.063889, 54.975273],
              [-3.068889, 54.9741590000001],
              [-3.143611, 54.964996],
              [-3.150278, 54.964996],
              [-3.36056, 54.971382],
              [-3.376389, 54.9725],
              [-3.390556, 54.9741590000001],
              [-3.44528, 54.986382],
              [-3.57111, 54.990829],
              [-3.58028, 54.971664],
              [-3.58111, 54.967216000000121],
              [-3.615834, 54.87527],
              [-3.62889, 54.877495000000124],
              [-3.688889, 54.8811],
              [-3.69611, 54.8811],
              [-3.81222, 54.848885000000109],
              [-3.869722, 54.805275000000108],
              [-3.953611, 54.767494000000113],
              [-3.965, 54.765274],
              [-3.97944, 54.765274],
              [-4.09556, 54.767776],
              [-4.13583, 54.774719],
              [-4.34833, 54.857773],
              [-4.35278, 54.860275],
              [-4.37611, 54.879166],
              [-4.380834, 54.88472],
              [-4.38194, 54.888611],
              [-4.37944, 54.897774],
              [-4.379723, 54.901665],
              [-4.38139, 54.905],
              [-4.385, 54.90749],
              [-4.39306, 54.908051],
              [-4.398056, 54.906387],
              [-4.42333, 54.883049000000142],
              [-4.42556, 54.879997],
              [-4.429167, 54.872215],
              [-4.428889, 54.863609],
              [-4.428056, 54.860275],
              [-4.411112, 54.825829],
              [-4.35972, 54.771111],
              [-4.346111, 54.711105],
              [-4.345278, 54.70722],
              [-4.34806, 54.699165],
              [-4.35583, 54.688049],
              [-4.365001, 54.680275],
              [-4.375834, 54.676666],
              [-4.38722, 54.675552],
              [-4.40222, 54.676941],
              [-4.49639, 54.698883000000137],
              [-4.50611, 54.70277],
              [-4.55694, 54.737495],
              [-4.558889, 54.74055],
              [-4.56, 54.748329],
              [-4.561667, 54.75166],
              [-4.598612, 54.780273],
              [-4.680834, 54.799721],
              [-4.740556, 54.821663],
              [-4.79722, 54.85305000000011],
              [-4.80528, 54.85805],
              [-4.81417, 54.86166],
              [-4.825556, 54.864441],
              [-4.85222, 54.868607],
              [-4.89389, 54.851944],
              [-4.920279, 54.839439],
              [-4.928334, 54.834717],
              [-4.935556, 54.829720000000123],
              [-4.96111, 54.802498],
              [-4.96194, 54.797775],
              [-4.96, 54.79361],
              [-4.944723, 54.767494000000113],
              [-4.911945, 54.71666],
              [-4.9, 54.701111],
              [-4.89083, 54.696938000000102],
              [-4.885, 54.695274],
              [-4.876667, 54.691109],
              [-4.87028, 54.68527],
              [-4.868334, 54.682495],
              [-4.855834, 54.631386],
              [-4.85861, 54.627777],
              [-4.864167, 54.62722],
              [-4.9225, 54.640549],
              [-4.9325, 54.644440000000145],
              [-4.94111, 54.648888000000113],
              [-4.94833, 54.65333],
              [-4.95194, 54.656662],
              [-4.960556, 54.673332],
              [-4.96333, 54.680275],
              [-4.96361, 54.683884],
              [-4.96167, 54.687492000000134],
              [-4.95444, 54.693054],
              [-4.95083, 54.700272],
              [-4.95694, 54.722771],
              [-4.96, 54.725555],
              [-5.005, 54.763329000000113],
              [-5.03528, 54.782219],
              [-5.07472, 54.805832],
              [-5.1025, 54.821663],
              [-5.11333, 54.829163],
              [-5.12, 54.834442],
              [-5.13194, 54.845276000000126],
              [-5.142222, 54.857216],
              [-5.17, 54.891106],
              [-5.17639, 54.900551],
              [-5.17944, 54.908051],
              [-5.18444, 54.92166],
              [-5.185694, 54.934654000000137],
              [-5.18556, 54.937775],
              [-5.178334, 54.988884],
              [-5.174167, 55.00055],
              [-5.16222, 55.00889],
              [-5.15222, 55.011665],
              [-5.105, 55.023888000000113],
              [-5.054167, 55.046661],
              [-5.053056, 55.05138],
              [-5.013612, 55.13166],
              [-5.01139, 55.135277],
              [-4.99917, 55.141937],
              [-4.97389, 55.154999],
              [-4.935, 55.178604],
              [-4.868334, 55.21916],
              [-4.865556, 55.222221000000104],
              [-4.86389, 55.226105000000132],
              [-4.84778, 55.26944],
              [-4.83917, 55.310829],
              [-4.83833, 55.319443],
              [-4.835556, 55.322495],
              [-4.75028, 55.409164],
              [-4.746667, 55.411942],
              [-4.72889, 55.420273000000122],
              [-4.713612, 55.424995],
              [-4.682501, 55.433884],
              [-4.656667, 55.436661],
              [-4.65083, 55.43777],
              [-4.641389, 55.441383],
              [-4.637778, 55.443886],
              [-4.61389, 55.486382],
              [-4.61333, 55.494995],
              [-4.62194, 55.512215],
              [-4.62389, 55.51555],
              [-4.65944, 55.561943],
              [-4.685834, 55.595833],
              [-4.68861, 55.599159],
              [-4.695, 55.604439000000127],
              [-4.698611, 55.606941],
              [-4.707778, 55.611107000000118],
              [-4.729445, 55.617775000000108],
              [-4.76917, 55.62861],
              [-4.81361, 55.645554000000118],
              [-4.860834, 55.672218],
              [-4.875834, 55.681938000000116],
              [-4.90389, 55.68972],
              [-4.91583, 55.696938000000102],
              [-4.916945, 55.70472],
              [-4.88111, 55.932220000000143],
              [-4.87972, 55.936104],
              [-4.87611, 55.938889],
              [-4.82406, 55.949497],
              [-4.79739, 55.952827],
              [-4.79256, 55.952332000000126],
              [-4.78939, 55.95133],
              [-4.78222, 55.946999000000119],
              [-4.751667, 55.94611],
              [-4.71333, 55.934441],
              [-4.706112, 55.933609],
              [-4.57028, 55.921104],
              [-4.523056, 55.91861],
              [-4.481668, 55.921104],
              [-4.489167, 55.926109],
              [-4.50111, 55.929161],
              [-4.627223, 55.945549],
              [-4.77659, 55.979771],
              [-4.81015, 55.976418000000137],
              [-4.85461, 55.98648500000013],
              [-4.86636, 56.031784],
              [-4.85965, 56.070377000000121],
              [-4.846223, 56.086315],
              [-4.82861, 56.11316],
              [-4.8672, 56.105610000000127],
              [-4.881458, 56.071217],
              [-4.898236, 55.981449],
              [-4.91334, 55.96131],
              [-4.928438, 55.933632000000102],
              [-4.96194, 55.879997],
              [-4.97889, 55.866104],
              [-4.985001, 55.864716],
              [-4.991389, 55.864441],
              [-5.012222, 55.866943000000106],
              [-5.02583, 55.86972],
              [-5.11, 55.903053],
              [-5.173334, 55.929161],
              [-5.20612, 55.921886],
              [-5.22458, 55.901752],
              [-5.229611, 55.874069000000134],
              [-5.208056, 55.844444],
              [-5.202778, 55.833611],
              [-5.204445, 55.829163],
              [-5.208056, 55.826385],
              [-5.214723, 55.825829],
              [-5.2925, 55.847496],
              [-5.303334, 55.850555],
              [-5.30722, 55.853882],
              [-5.33861, 55.89722],
              [-5.34028, 55.900833],
              [-5.340556, 55.905],
              [-5.34083, 55.926109],
              [-5.30972, 56.002495],
              [-5.309389, 56.005329],
              [-5.308556, 56.0075],
              [-5.28106, 56.034496000000104],
              [-5.27356, 56.04166],
              [-5.202778, 56.117218],
              [-5.198611, 56.119995],
              [-5.07222, 56.186943],
              [-4.974167, 56.23333],
              [-4.947263, 56.250000000000114],
              [-4.92306, 56.265],
              [-4.91806, 56.271111000000133],
              [-4.92056, 56.27444],
              [-4.927501, 56.273888],
              [-5.03222, 56.232498],
              [-5.20583, 56.13721],
              [-5.23889, 56.118889000000138],
              [-5.258889, 56.10694100000012],
              [-5.287445, 56.084053],
              [-5.305945, 56.069221],
              [-5.316778, 56.055386],
              [-5.33894, 56.034554000000128],
              [-5.35611, 56.02489],
              [-5.39083, 56.0],
              [-5.397779, 55.999443],
              [-5.40417, 55.999718],
              [-5.42333, 56.003326],
              [-5.428889, 56.004997],
              [-5.431667, 56.00777],
              [-5.41889, 55.906662],
              [-5.38, 55.750275],
              [-5.40417, 55.736382],
              [-5.44444, 55.708328],
              [-5.4475, 55.705276],
              [-5.45333, 55.68694],
              [-5.45694, 55.684441000000106],
              [-5.46889, 55.668610000000115],
              [-5.48639, 55.643051000000128],
              [-5.5552, 55.414398],
              [-5.53528, 55.398331],
              [-5.53278, 55.39555],
              [-5.51583, 55.365273],
              [-5.514723, 55.361664],
              [-5.523056, 55.352219],
              [-5.53528, 55.340553],
              [-5.56694, 55.316666],
              [-5.59583, 55.305832],
              [-5.73778, 55.29222],
              [-5.752501, 55.291939],
              [-5.76583, 55.293610000000115],
              [-5.7775, 55.29666],
              [-5.785833, 55.30138],
              [-5.787778, 55.304993000000138],
              [-5.79, 55.312492000000134],
              [-5.795279, 55.360275],
              [-5.79583, 55.373329000000126],
              [-5.795, 55.38611],
              [-5.793612, 55.390274],
              [-5.787778, 55.396385],
              [-5.759167, 55.417496],
              [-5.7275, 55.431389],
              [-5.72111, 55.436661],
              [-5.718889, 55.440277],
              [-5.71639, 55.448883000000137],
              [-5.718056, 55.515],
              [-5.70167, 55.588608000000136],
              [-5.669168, 55.66166],
              [-5.60778, 55.75861],
              [-5.61194, 55.759995000000117],
              [-5.6475, 55.78139],
              [-5.67222, 55.803604],
              [-5.674167, 55.806938],
              [-5.67672, 55.88727200000011],
              [-5.67722, 55.889606000000128],
              [-5.67789, 55.899441000000138],
              [-5.67589, 55.911774],
              [-5.67189, 55.915276000000119],
              [-5.66439, 55.919273],
              [-5.654889, 55.92494],
              [-5.63361, 55.96611],
              [-5.58167, 56.011665],
              [-5.578611, 56.014717000000132],
              [-5.57056, 56.037216000000114],
              [-5.576112, 56.038055],
              [-5.582778, 56.0375],
              [-5.5975, 56.032219],
              [-5.625556, 56.020554000000118],
              [-5.65956, 55.983551],
              [-5.661223, 55.981716],
              [-5.66806, 55.974384],
              [-5.67022, 55.97272],
              [-5.67422, 55.972389],
              [-5.67756, 55.973385],
              [-5.67939, 55.975052],
              [-5.67989, 55.989220000000103],
              [-5.67972, 55.991386],
              [-5.67589, 55.997719],
              [-5.642222, 56.043053],
              [-5.632501, 56.051941],
              [-5.60139, 56.076385],
              [-5.563334, 56.113327],
              [-5.521111, 56.162773],
              [-5.518889, 56.16694],
              [-5.51167, 56.181664000000126],
              [-5.511945, 56.185829000000126],
              [-5.51667, 56.187492],
              [-5.52278, 56.186104000000114],
              [-5.53222, 56.182495000000131],
              [-5.558889, 56.169441],
              [-5.57389, 56.16],
              [-5.597778, 56.159721],
              [-5.59667, 56.252777],
              [-5.59639, 56.261108],
              [-5.57361, 56.32471],
              [-5.569167, 56.33194],
              [-5.52611, 56.373604000000114],
              [-5.525556, 56.38194],
              [-5.52444, 56.385826000000122],
              [-5.521111, 56.389442000000145],
              [-5.437223, 56.422329],
              [-5.428223, 56.428829000000121],
              [-5.42056, 56.432999],
              [-5.33156, 56.436161],
              [-5.32372, 56.435329],
              [-5.308556, 56.429661],
              [-5.241667, 56.436386],
              [-5.23583, 56.435555000000136],
              [-5.22083, 56.435829],
              [-5.210556, 56.438889000000131],
              [-5.20167, 56.443054000000132],
              [-5.19333, 56.448326],
              [-5.135556, 56.484993],
              [-5.120556, 56.495552],
              [-5.107779, 56.507774],
              [-5.06861, 56.55722],
              [-5.066389, 56.560555],
              [-5.06944, 56.56277],
              [-5.07611, 56.562218],
              [-5.08083, 56.55971],
              [-5.0875, 56.554443],
              [-5.095834, 56.544716],
              [-5.10389, 56.529442],
              [-5.115556, 56.512772],
              [-5.19111, 56.461937],
              [-5.203056, 56.454163],
              [-5.214445, 56.451942],
              [-5.22889, 56.450829],
              [-5.23528, 56.451111],
              [-5.368334, 56.474331],
              [-5.39867, 56.478664],
              [-5.37718, 56.52112],
              [-5.363512, 56.514954000000102],
              [-5.343678, 56.515453],
              [-5.339012, 56.51578],
              [-5.33234, 56.517452],
              [-5.253056, 56.550278],
              [-5.249167, 56.552773],
              [-5.246389, 56.555832],
              [-5.245556, 56.560272],
              [-5.253056, 56.560272],
              [-5.312389, 56.55949],
              [-5.315556, 56.55816],
              [-5.322556, 56.553829],
              [-5.333722, 56.549328000000116],
              [-5.339556, 56.547165],
              [-5.34639, 56.545498000000123],
              [-5.35139, 56.545498000000123],
              [-5.35872, 56.547165],
              [-5.37622, 56.556164000000138],
              [-5.37189, 56.562328],
              [-5.38306, 56.583054000000118],
              [-5.314723, 56.656662],
              [-5.242223, 56.712219],
              [-5.17639, 56.759995000000117],
              [-5.133889, 56.792496],
              [-5.130834, 56.79555],
              [-5.12167, 56.81277],
              [-5.12, 56.816666],
              [-5.15444, 56.799164],
              [-5.18889, 56.776382],
              [-5.23417, 56.743332],
              [-5.363334, 56.661942000000124],
              [-5.56389, 56.54055],
              [-5.592778, 56.524162000000103],
              [-5.601945, 56.51944],
              [-5.67694, 56.493889000000138],
              [-5.68972, 56.509163],
              [-5.6975, 56.513611],
              [-5.79056, 56.53805],
              [-5.82667, 56.542221],
              [-5.88417, 56.553329],
              [-5.895556, 56.556938],
              [-5.930556, 56.569717],
              [-5.94278, 56.576660000000118],
              [-5.99583, 56.611382000000106],
              [-6.007223, 56.619438],
              [-6.01139, 56.625549],
              [-6.011111, 56.62944],
              [-6.008334, 56.63749700000011],
              [-6.00083, 56.643051000000128],
              [-5.99278, 56.647499],
              [-5.9875, 56.649437],
              [-5.97472, 56.651382],
              [-5.882612, 56.656662],
              [-5.69917, 56.682777000000101],
              [-5.64861, 56.680275],
              [-5.6125, 56.681938000000116],
              [-5.55611, 56.685555],
              [-5.545, 56.688332],
              [-5.54694, 56.691940000000102],
              [-5.55139, 56.69416],
              [-5.73944, 56.711662000000103],
              [-5.76222, 56.71194],
              [-5.76972, 56.710831],
              [-5.779445, 56.707771],
              [-5.792778, 56.70138500000013],
              [-5.826223, 56.691551],
              [-5.842056, 56.681717000000106],
              [-5.84872, 56.68005],
              [-5.91917, 56.673882],
              [-6.191389, 56.679718],
              [-6.20917, 56.684166],
              [-6.22472, 56.694443],
              [-6.230834, 56.699997],
              [-6.235001, 56.710274],
              [-6.23528, 56.714996],
              [-6.235001, 56.719162],
              [-6.23278, 56.7225],
              [-6.19389, 56.747772],
              [-6.19028, 56.75],
              [-6.14, 56.75777],
              [-5.966945, 56.780273000000136],
              [-5.95361, 56.78166],
              [-5.94861, 56.779999],
              [-5.94028, 56.775551],
              [-5.905001, 56.75666],
              [-5.8675, 56.742775000000108],
              [-5.853333, 56.741943],
              [-5.845834, 56.746941],
              [-5.798612, 56.789162],
              [-5.805556, 56.794441],
              [-5.83944, 56.803604],
              [-5.84972, 56.80778],
              [-5.85639, 56.813049],
              [-5.858612, 56.81583],
              [-5.85889, 56.820549000000142],
              [-5.858056, 56.824715],
              [-5.854445, 56.827774],
              [-5.85, 56.82944],
              [-5.785834, 56.839554],
              [-5.753334, 56.8425],
              [-5.745001, 56.841942],
              [-5.733056, 56.839165],
              [-5.718056, 56.839439],
              [-5.66472, 56.864716],
              [-5.660833, 56.86889],
              [-5.66306, 56.871666],
              [-5.672501, 56.876106000000107],
              [-5.73889, 56.89361],
              [-5.746667, 56.89388300000013],
              [-5.7675, 56.892494],
              [-5.818056, 56.88555],
              [-5.86528, 56.879440000000102],
              [-5.87861, 56.878609],
              [-5.886945, 56.879440000000102],
              [-5.91722, 56.886108],
              [-5.92194, 56.888054000000125],
              [-5.829722, 57.000832],
              [-5.821945, 57.006104],
              [-5.806111, 57.011383000000137],
              [-5.79417, 57.013611],
              [-5.763445, 57.01022],
              [-5.75111, 57.011719],
              [-5.73794, 57.012218000000132],
              [-5.73494, 57.011051],
              [-5.73311, 57.00956],
              [-5.72894, 57.003555000000119],
              [-5.722278, 56.996719],
              [-5.697223, 56.989166],
              [-5.671667, 56.97972],
              [-5.661112, 56.976105000000132],
              [-5.64889, 56.972771000000137],
              [-5.64333, 56.971664],
              [-5.629723, 56.973053],
              [-5.57917, 56.979996],
              [-5.56611, 56.982216],
              [-5.53806, 56.989441000000113],
              [-5.52389, 56.993889],
              [-5.520278, 56.996384],
              [-5.522223, 56.999718],
              [-5.529723, 56.999443],
              [-5.547501, 56.99528],
              [-5.55639, 56.991104],
              [-5.569167, 56.989716000000101],
              [-5.616112, 56.9847180000001],
              [-5.63139, 56.984993000000145],
              [-5.65389, 56.991943],
              [-5.773612, 57.04555],
              [-5.784167, 57.049438],
              [-5.78722, 57.051941],
              [-5.78917, 57.05555],
              [-5.788611, 57.059441000000106],
              [-5.785833, 57.068054],
              [-5.778611, 57.07805],
              [-5.771945, 57.083328],
              [-5.72472, 57.11305],
              [-5.691612, 57.110939000000144],
              [-5.65294, 57.115944],
              [-5.64928, 57.11627],
              [-5.62444, 57.112606],
              [-5.61644, 57.108608],
              [-5.61161, 57.103439],
              [-5.5775, 57.097496],
              [-5.55944, 57.092499],
              [-5.540833, 57.088608],
              [-5.53333, 57.087776000000133],
              [-5.518056, 57.088051000000121],
              [-5.399723, 57.105827],
              [-5.40083, 57.10972],
              [-5.40389, 57.112495],
              [-5.407778, 57.114441],
              [-5.42083, 57.11777],
              [-5.44361, 57.118332],
              [-5.45722, 57.11666],
              [-5.481668, 57.11222],
              [-5.55028, 57.11639],
              [-5.63961, 57.15594],
              [-5.64611, 57.15794],
              [-5.64828, 57.159607000000108],
              [-5.64961, 57.16161000000011],
              [-5.64911, 57.164444000000117],
              [-5.64611, 57.234993],
              [-5.61267, 57.23977],
              [-5.60817, 57.24261],
              [-5.560667, 57.254772],
              [-5.55017, 57.256775],
              [-5.546834, 57.256104000000107],
              [-5.540833, 57.248436],
              [-5.5385, 57.246605],
              [-5.49472, 57.23888],
              [-5.481112, 57.231384],
              [-5.472501, 57.22778],
              [-5.449722, 57.221382000000119],
              [-5.428334, 57.218048000000124],
              [-5.42194, 57.219719],
              [-5.406112, 57.229439],
              [-5.40417, 57.232498],
              [-5.51267, 57.277443],
              [-5.571167, 57.284107],
              [-5.59884, 57.330486000000121],
              [-5.57784, 57.331818],
              [-5.57351, 57.33248],
              [-5.520556, 57.359161],
              [-5.4925, 57.370827],
              [-5.46278, 57.38694],
              [-5.45889, 57.389999],
              [-5.45278, 57.396111],
              [-5.44861, 57.412773],
              [-5.44833, 57.417496000000142],
              [-5.45028, 57.420273],
              [-5.45778, 57.42166],
              [-5.46222, 57.419998],
              [-5.50333, 57.401108],
              [-5.632556, 57.37055],
              [-5.75111, 57.34333],
              [-5.769444, 57.339996],
              [-5.77806, 57.340271],
              [-5.788611, 57.34389],
              [-5.81694, 57.361107000000118],
              [-5.819167, 57.363884],
              [-5.860001, 57.450829],
              [-5.86694, 57.467773],
              [-5.87139, 57.479164],
              [-5.87056, 57.491661],
              [-5.869167, 57.496109],
              [-5.85111, 57.547775],
              [-5.84972, 57.551666],
              [-5.83972, 57.57278],
              [-5.823611, 57.57833],
              [-5.8175, 57.579720000000123],
              [-5.81083, 57.57944],
              [-5.776945, 57.57],
              [-5.750278, 57.552498],
              [-5.749722, 57.54416700000013],
              [-5.65556, 57.509438],
              [-5.65056, 57.508049],
              [-5.64278, 57.50861],
              [-5.62, 57.524719],
              [-5.530834, 57.52833],
              [-5.51167, 57.53166],
              [-5.508612, 57.53472],
              [-5.517778, 57.547493000000145],
              [-5.52167, 57.549438000000123],
              [-5.53528, 57.552216],
              [-5.64361, 57.552216],
              [-5.65361, 57.54833200000013],
              [-5.65639, 57.54583],
              [-5.6625, 57.544716],
              [-5.669168, 57.54583],
              [-5.674167, 57.54805],
              [-5.695556, 57.559441],
              [-5.81028, 57.637772],
              [-5.811389, 57.64139],
              [-5.8175, 57.81721],
              [-5.816668, 57.821663000000115],
              [-5.803612, 57.852776000000119],
              [-5.79917, 57.854996000000142],
              [-5.766945, 57.864716],
              [-5.755, 57.867493],
              [-5.71694, 57.869438000000116],
              [-5.696611, 57.85305],
              [-5.690778, 57.85088],
              [-5.685611, 57.848217],
              [-5.683279, 57.846386],
              [-5.68244, 57.84422],
              [-5.664445, 57.791664],
              [-5.661667, 57.78611],
              [-5.64111, 57.773888000000113],
              [-5.614722, 57.764999],
              [-5.60722, 57.765274],
              [-5.6025, 57.767220000000123],
              [-5.58222, 57.817497],
              [-5.58083, 57.821388],
              [-5.58056, 57.829994],
              [-5.582778, 57.833328],
              [-5.5975, 57.843605000000139],
              [-5.60167, 57.846107],
              [-5.625556, 57.852219],
              [-5.63467, 57.864388],
              [-5.644001, 57.875381000000118],
              [-5.644667, 57.877716],
              [-5.644333, 57.88338],
              [-5.6435, 57.885883],
              [-5.64444, 57.899719],
              [-5.635556, 57.908882],
              [-5.628056, 57.914162],
              [-5.61111, 57.923607000000118],
              [-5.4575, 57.85889],
              [-5.43444, 57.898331],
              [-5.430556, 57.90083],
              [-5.425, 57.902496],
              [-5.33861, 57.92083],
              [-5.217501, 57.90083],
              [-5.1275, 57.869438000000116],
              [-5.111945, 57.85944400000011],
              [-5.102778, 57.85083],
              [-5.098333, 57.86805],
              [-5.18944, 57.948326000000122],
              [-5.19722, 57.953049],
              [-5.203056, 57.954720000000123],
              [-5.26278, 57.971107000000131],
              [-5.398056, 58.0311],
              [-5.41694, 58.04277],
              [-5.448056, 58.06694],
              [-5.45417, 58.072777],
              [-5.45528, 58.07638500000013],
              [-5.45389, 58.080551],
              [-5.44917, 58.087776],
              [-5.443056, 58.093887],
              [-5.43861, 58.096382],
              [-5.42667, 58.09861],
              [-5.41917, 58.097771],
              [-5.40833, 58.09416],
              [-5.38417, 58.083611],
              [-5.37194, 58.076111],
              [-5.31944, 58.064438],
              [-5.31083, 58.063889],
              [-5.2975, 58.06667],
              [-5.289167, 58.070274],
              [-5.285001, 58.073326],
              [-5.28139, 58.076111],
              [-5.27972, 58.07972],
              [-5.27389, 58.117218],
              [-5.274445, 58.1486],
              [-5.290833, 58.148888000000113],
              [-5.2975, 58.15083],
              [-5.396389, 58.242493000000138],
              [-5.39889, 58.249161],
              [-5.399167, 58.253326],
              [-5.396111, 58.25722],
              [-5.39222, 58.259438000000102],
              [-5.38667, 58.261108],
              [-5.37111, 58.259995],
              [-5.36611, 58.25833],
              [-5.203611, 58.250832],
              [-5.071667, 58.264717],
              [-5.07556, 58.26722],
              [-5.08222, 58.26888300000013],
              [-5.12639, 58.287498],
              [-5.16472, 58.32527],
              [-5.17472, 58.349998],
              [-5.16889, 58.365],
              [-5.109445, 58.508331000000112],
              [-5.00472, 58.623329],
              [-4.99833, 58.624992000000134],
              [-4.772223, 58.60361],
              [-4.76806, 58.60166],
              [-4.70167, 58.558609],
              [-4.676667, 58.524437],
              [-4.701945, 58.509995000000117],
              [-4.717778, 58.494438],
              [-4.76111, 58.45138500000013],
              [-4.76361, 58.446938000000102],
              [-4.76444, 58.443329],
              [-4.756667, 58.442497],
              [-4.741389, 58.448326],
              [-4.66806, 58.488327],
              [-4.60389, 58.523331],
              [-4.598612, 58.529999],
              [-4.596945, 58.53388],
              [-4.59806, 58.546387],
              [-4.60139, 58.553604],
              [-4.59972, 58.55805],
              [-4.595, 58.56499],
              [-4.588612, 58.570831],
              [-4.57833, 58.57444],
              [-4.565001, 58.576111],
              [-4.556111, 58.575554],
              [-4.50667, 58.567772],
              [-4.47611, 58.561104000000114],
              [-4.44083, 58.55138],
              [-4.43222, 58.546661],
              [-4.428889, 58.539719000000105],
              [-4.27722, 58.533607000000131],
              [-4.080556, 58.555275],
              [-3.90333, 58.558327],
              [-3.84833, 58.559998],
              [-3.78528, 58.566666],
              [-3.78, 58.56833],
              [-3.730278, 58.592773],
              [-3.71417, 58.602776000000119],
              [-3.70917, 58.60472],
              [-3.660278, 58.61972],
              [-3.576111, 58.621941000000106],
              [-3.553334, 58.60916],
              [-3.37361, 58.59583],
              [-3.365, 58.595276],
              [-3.36083, 58.597771],
              [-3.35833, 58.60139],
              [-3.35167, 58.612495000000138],
              [-3.35083, 58.616104000000121],
              [-3.35472, 58.618607000000111],
              [-3.37333, 58.627495000000124],
              [-3.35389, 58.660553000000107],
              [-3.17639, 58.64944],
              [-3.02556, 58.647499],
              [-3.01972, 58.645554],
              [-3.01583, 58.643051],
              [-3.01361, 58.633331],
              [-3.05556, 58.454437],
              [-3.06028, 58.447220000000129],
              [-3.10972, 58.38166],
              [-3.12194, 58.369438],
              [-3.2025, 58.308052],
              [-3.20861, 58.304443],
              [-3.3375, 58.276939],
              [-3.35333, 58.276939],
              [-3.35972, 58.27583],
              [-3.36417, 58.273888],
              [-3.38194, 58.264717],
              [-3.420278, 58.243607000000111],
              [-3.44222, 58.226944],
              [-3.44639, 58.219162],
              [-3.45583, 58.206108],
              [-3.4625, 58.19999700000011],
              [-3.483334, 58.182777],
              [-3.51111, 58.164993],
              [-3.51528, 58.162498],
              [-3.56611, 58.139160000000118],
              [-3.68444, 58.089722],
              [-3.845, 58.02],
              [-3.99694, 57.950554],
              [-4.01167, 57.926941000000113],
              [-3.992222, 57.910271],
              [-3.99111, 57.901939],
              [-4.015, 57.867775],
              [-4.106668, 57.851944],
              [-4.12, 57.85083],
              [-4.243056, 57.870277],
              [-4.35861, 57.895271],
              [-4.366389, 57.900276],
              [-4.378056, 57.90361],
              [-4.39222, 57.905273],
              [-4.39111, 57.8975],
              [-4.35417, 57.862495],
              [-4.34556, 57.85833],
              [-4.297501, 57.846382],
              [-4.283334, 57.844162],
              [-4.149723, 57.825272],
              [-4.043223, 57.814384],
              [-3.92639, 57.807495],
              [-3.874722, 57.815277],
              [-3.85056, 57.82],
              [-3.84167, 57.824715],
              [-3.834723, 57.830551],
              [-3.82667, 57.845276],
              [-3.82028, 57.851387000000102],
              [-3.81139, 57.856384],
              [-3.80222, 57.859993],
              [-3.788333, 57.861107],
              [-3.775, 57.858604],
              [-3.773056, 57.851105],
              [-3.77778, 57.843605000000139],
              [-3.815834, 57.807495],
              [-3.82306, 57.801666],
              [-3.865556, 57.768608],
              [-3.94417, 57.717216000000121],
              [-3.951945, 57.712494],
              [-3.96861, 57.702499000000103],
              [-3.97778, 57.69833],
              [-3.98889, 57.695274],
              [-4.00111, 57.693054],
              [-4.012, 57.698051000000135],
              [-4.021, 57.699383],
              [-4.02283, 57.703384000000142],
              [-4.0205, 57.708218],
              [-4.01617, 57.711552],
              [-4.01639, 57.721382],
              [-4.019444, 57.72805],
              [-4.031112, 57.731384],
              [-4.08528, 57.7261],
              [-4.097778, 57.723885],
              [-4.296667, 57.674438],
              [-4.41639, 57.60166],
              [-4.43583, 57.575],
              [-4.42722, 57.57055],
              [-4.41472, 57.57278],
              [-4.378334, 57.589722000000108],
              [-4.343612, 57.607773],
              [-4.330278, 57.618889],
              [-4.3125, 57.628052],
              [-4.259445, 57.655273],
              [-4.24944, 57.659439000000134],
              [-4.227778, 57.66499],
              [-4.19139, 57.67139],
              [-4.08078, 57.665329],
              [-4.04667, 57.642776],
              [-4.11139, 57.598328],
              [-4.179445, 57.562492],
              [-4.210834, 57.536110000000122],
              [-4.22889, 57.515549000000135],
              [-4.240556, 57.5],
              [-4.235, 57.493332],
              [-4.225278, 57.48917],
              [-4.21306, 57.486107],
              [-4.196667, 57.48583],
              [-4.179167, 57.489441],
              [-4.15889, 57.496666],
              [-4.04139, 57.554161000000136],
              [-4.03833, 57.55722],
              [-3.754137, 57.625038],
              [-3.639445, 57.643883],
              [-3.641945, 57.640831],
              [-3.6425, 57.636383],
              [-3.638611, 57.634163000000115],
              [-3.62444, 57.6325],
              [-3.59806, 57.636108],
              [-3.59278, 57.637215],
              [-3.522223, 57.66333],
              [-3.50639, 57.673607],
              [-3.503334, 57.676109],
              [-3.49694, 57.682777],
              [-3.493611, 57.689995],
              [-3.494722, 57.693604],
              [-3.497222, 57.696938],
              [-3.49861, 57.700829000000113],
              [-3.4975, 57.70472],
              [-3.48806, 57.709442],
              [-3.339723, 57.723328],
              [-3.28944, 57.72583],
              [-3.28306, 57.7241590000001],
              [-3.28, 57.72111],
              [-3.276111, 57.714996],
              [-3.261111, 57.70472],
              [-3.24611, 57.69833],
              [-3.223333, 57.691666000000112],
              [-3.123333, 57.67166],
              [-3.08083, 57.66555],
              [-3.041945, 57.662216],
              [-3.035, 57.662773000000129],
              [-3.0225, 57.665276000000119],
              [-2.98944, 57.674164],
              [-2.9675, 57.680275],
              [-2.9425, 57.689438],
              [-2.923611, 57.696938],
              [-2.898056, 57.70694],
              [-2.852778, 57.705826],
              [-2.79056, 57.702499000000103],
              [-2.782222, 57.701942],
              [-2.64583, 57.68805],
              [-2.57, 57.679718],
              [-2.51, 57.67166],
              [-2.44444, 57.668327],
              [-2.40028, 57.666382000000112],
              [-2.392222, 57.666382000000112],
              [-2.18611, 57.668610000000115],
              [-2.172778, 57.669998],
              [-2.16722, 57.671944],
              [-2.14028, 57.690552000000139],
              [-2.131389, 57.695274],
              [-2.12, 57.697495000000117],
              [-2.07556, 57.69944],
              [-2.022223, 57.693886000000134],
              [-1.929722, 57.677773000000116],
              [-1.91833, 57.670555],
              [-1.86, 57.621384],
              [-1.82194, 57.57861],
              [-1.781389, 57.505554],
              [-1.774167, 57.490829],
              [-1.773334, 57.458054],
              [-1.855834, 57.398888000000113],
              [-1.95889, 57.332497000000103],
              [-1.971945, 57.320274],
              [-1.977778, 57.313889],
              [-2.054167, 57.218605],
              [-2.061667, 57.204163],
              [-2.06583, 57.190552],
              [-2.075, 57.151382],
              [-2.073611, 57.143883],
              [-2.06722, 57.134438],
              [-2.093334, 57.070274],
              [-2.166945, 57.000549],
              [-2.19028, 56.97472],
              [-2.196389, 56.96222],
              [-2.1975, 56.945549],
              [-2.19667, 56.942215],
              [-2.189723, 56.932495000000131],
              [-2.18528, 56.92222],
              [-2.186389, 56.91805],
              [-2.19417, 56.902496],
              [-2.219722, 56.867775],
              [-2.315556, 56.798882000000106],
              [-2.32417, 56.793884000000105],
              [-2.34806, 56.784439],
              [-2.39, 56.77166],
              [-2.41528, 56.7586060000001],
              [-2.47806, 56.715271000000143],
              [-2.462778, 56.696388],
              [-2.448084, 56.699646000000143],
              [-2.44806, 56.69167],
              [-2.44889, 56.68722],
              [-2.48861, 56.614166],
              [-2.52722, 56.57861],
              [-2.535278, 56.57361],
              [-2.55139, 56.563889],
              [-2.64083, 56.5225],
              [-2.720834, 56.488884],
              [-2.89528, 56.463882],
              [-2.958611, 56.45611],
              [-3.03639, 56.454437],
              [-3.04472, 56.454994],
              [-3.05194, 56.454994],
              [-3.07028, 56.451942],
              [-3.08083, 56.448608],
              [-3.278056, 56.357498000000135],
              [-3.264722, 56.346107],
              [-3.2525, 56.348053],
              [-3.193056, 56.35889],
              [-3.18778, 56.360275],
              [-2.995556, 56.414162],
              [-2.93222, 56.442772],
              [-2.919167, 56.44944],
              [-2.91389, 56.450829],
              [-2.90083, 56.452217000000132],
              [-2.884445, 56.451385],
              [-2.87, 56.44944],
              [-2.81528, 56.440277],
              [-2.808889, 56.438889000000131],
              [-2.804167, 56.432777],
              [-2.799167, 56.41861],
              [-2.79806, 56.414719000000105],
              [-2.79972, 56.410828],
              [-2.803056, 56.407219],
              [-2.80944, 56.39666],
              [-2.81528, 56.373604000000114],
              [-2.813334, 56.362778],
              [-2.804167, 56.346939],
              [-2.80056, 56.344444],
              [-2.771389, 56.332497000000103],
              [-2.765833, 56.33111],
              [-2.730834, 56.32471],
              [-2.723333, 56.323883],
              [-2.70417, 56.32471],
              [-2.675278, 56.32333],
              [-2.66889, 56.322220000000129],
              [-2.643611, 56.316666000000112],
              [-2.63889, 56.314995],
              [-2.63361, 56.312775],
              [-2.58583, 56.283882],
              [-2.582222, 56.281387],
              [-2.577778, 56.274994000000106],
              [-2.582778, 56.268051],
              [-2.58667, 56.265549],
              [-2.67333, 56.216942000000131],
              [-2.678056, 56.214996],
              [-2.683056, 56.213333],
              [-2.78806, 56.187492],
              [-2.82, 56.184166],
              [-2.834445, 56.183609000000104],
              [-2.846945, 56.186386],
              [-2.857778, 56.190277],
              [-2.875, 56.19861],
              [-2.88028, 56.200554],
              [-2.887778, 56.201942000000145],
              [-2.916667, 56.204994],
              [-2.931667, 56.20527600000014],
              [-2.956944, 56.20222],
              [-2.976111, 56.194717],
              [-3.13556, 56.113609],
              [-3.1425, 56.108055],
              [-3.151111, 56.09333],
              [-3.152778, 56.089722],
              [-3.15417, 56.085548],
              [-3.341389, 56.024162],
              [-3.346667, 56.022499],
              [-3.3925, 56.01111],
              [-3.39917, 56.010551],
              [-3.40944, 56.0125],
              [-3.44111, 56.0191650000001],
              [-3.4975, 56.034439],
              [-3.571389, 56.053604],
              [-3.5825, 56.054993000000138],
              [-3.71972, 56.056664],
              [-3.73722, 56.05555],
              [-3.726944, 56.03083],
              [-3.725278, 56.027496],
              [-3.72139, 56.025551],
              [-3.66639, 56.007217],
              [-3.66194, 56.005829],
              [-3.646111, 56.004997],
              [-3.454722, 55.991943],
              [-3.254723, 55.971664],
              [-3.088056, 55.948051000000135],
              [-3.0675, 55.944443],
              [-3.053056, 55.943604],
              [-3.01806, 55.94944],
              [-2.935, 55.969444],
              [-2.924445, 55.9725],
              [-2.91028, 55.97805],
              [-2.90639, 55.979996],
              [-2.895556, 55.988609],
              [-2.865834, 56.021385000000123],
              [-2.868333, 56.028328000000101],
              [-2.86528, 56.031944],
              [-2.83389, 56.051109],
              [-2.82028, 56.05694],
              [-2.79417, 56.06027],
              [-2.782222, 56.06139],
              [-2.657222, 56.059715],
              [-2.63111, 56.054718],
              [-2.60056, 56.04333],
              [-2.502223, 56.002777],
              [-2.375278, 55.95694],
              [-2.260278, 55.91861],
              [-2.13028, 55.885826],
              [-2.079722, 55.867218],
              [-2.072778, 55.853607],
              [-2.06833, 55.847496],
              [-2.06111, 55.839996],
              [-2.02167, 55.806107],
              [-2.013611, 55.794998000000135],
              [-2.00083, 55.78027],
              [-1.98, 55.75666],
              [-1.973611, 55.751663000000121],
              [-1.85139, 55.657219],
              [-1.819722, 55.63416],
              [-1.815556, 55.63194],
              [-1.80833, 55.63083],
              [-1.80167, 55.631386],
              [-1.79472, 55.63694],
              [-1.74694, 55.624992],
              [-1.69, 55.6055530000001],
              [-1.638056, 55.583054],
              [-1.633889, 55.580826],
              [-1.58139, 55.48555],
              [-1.58056, 55.481667],
              [-1.57333, 55.419716],
              [-1.57556, 55.410828],
              [-1.57972, 55.40333],
              [-1.585278, 55.39666],
              [-1.593056, 55.391663000000108],
              [-1.599445, 55.385826000000122],
              [-1.598611, 55.38194],
              [-1.565834, 55.287216],
              [-1.520556, 55.164162],
              [-1.515, 55.149719],
              [-1.485, 55.089722],
              [-1.480834, 55.082771],
              [-1.412778, 54.999443],
              [-1.38139, 54.976387],
              [-1.365, 54.927773000000116],
              [-1.34556, 54.871384],
              [-1.30444, 54.771385],
              [-1.2975, 54.763611],
              [-1.165278, 54.649719000000118],
              [-1.061389, 54.617218],
              [-1.04389, 54.61305],
              [-0.875833, 54.570274],
              [-0.564722, 54.48],
              [-0.521389, 54.45027],
              [-0.515556, 54.444717],
              [-0.4575, 54.376938],
              [-0.43611, 54.350273000000129],
              [-0.42167, 54.332222000000115],
              [-0.39333, 54.27277400000014],
              [-0.39417, 54.2691650000001],
              [-0.39278, 54.265831000000105],
              [-0.38194, 54.255554000000132],
              [-0.2625, 54.174438],
              [-0.200529, 54.151711],
              [-0.15167, 54.14138800000012],
              [-0.116944, 54.132217],
              [-0.0825, 54.118889],
              [-0.07833, 54.116661],
              [-0.075, 54.111938],
              [-0.08139, 54.106110000000115],
              [-0.1125, 54.09833],
              [-0.136111, 54.095551000000114],
              [-0.141389, 54.094162],
              [-0.16111, 54.088051],
              [-0.17389, 54.0816650000001],
              [-0.202778, 54.054718],
              [-0.208611, 54.048332],
              [-0.21333, 54.035828],
              [-0.21583, 54.026665],
              [-0.216111, 54.0225],
              [-0.215, 54.014999000000103],
              [-0.212222, 54.008331000000112],
              [-0.17111, 53.92166],
              [-0.16722, 53.915276000000119],
              [-0.1275, 53.86388],
              [-0.112778, 53.850555],
              [-0.099444, 53.839722000000108],
              [-0.053889, 53.80305],
              [-0.01306, 53.76861],
              [0.061111, 53.705276],
              [0.06417, 53.7025],
              [0.12639, 53.645271],
              [0.141111, 53.62722],
              [0.14944400000013, 53.61472],
              [0.153611000000126, 53.604721],
              [0.154167, 53.60083],
              [0.151944, 53.591942],
              [0.146944, 53.584999],
              [0.143611000000135, 53.58194],
              [0.140556000000117, 53.57916],
              [0.118056, 53.564438],
              [0.112778, 53.563049],
              [0.11389, 53.56667],
              [0.11944, 53.573051000000135],
              [0.123333, 53.575554000000125],
              [0.135833, 53.587494],
              [0.137778000000139, 53.591385000000116],
              [0.138889, 53.595833],
              [0.138333, 53.599716],
              [0.13056, 53.60833],
              [0.109167, 53.619164000000126],
              [0.089167, 53.626663000000121],
              [0.0675, 53.633331000000112],
              [0.044167, 53.639160000000118],
              [0.02972, 53.639999],
              [0.01694, 53.639442000000145],
              [0.01111, 53.63861],
              [0.0, 53.635536000000116],
              [-0.03472, 53.62555],
              [-0.05167, 53.623055],
              [-0.071389, 53.622498000000121],
              [-0.078889, 53.623329000000126],
              [-0.085556, 53.624443],
              [-0.105833, 53.63166],
              [-0.12972, 53.641388],
              [-0.141944, 53.648048],
              [-0.171667, 53.675278],
              [-0.23139, 53.72166],
              [-0.24944, 53.72972],
              [-0.2725, 53.73555],
              [-0.29389, 53.736664000000133],
              [-0.35728, 53.730553],
              [-0.38094, 53.726551],
              [-0.422611, 53.717552],
              [-0.54917, 53.706108],
              [-0.560833, 53.709160000000111],
              [-0.569167, 53.713608],
              [-0.57778, 53.72166],
              [-0.586111, 53.72666],
              [-0.605833, 53.72972],
              [-0.61972, 53.729996000000142],
              [-0.632222, 53.729164],
              [-0.65444, 53.72527],
              [-0.674167, 53.719162],
              [-0.683333, 53.715828000000101],
              [-0.718889, 53.699715],
              [-0.71417, 53.693054000000132],
              [-0.69306, 53.686104],
              [-0.519722, 53.685272],
              [-0.50489, 53.68644],
              [-0.457889, 53.696106],
              [-0.39022, 53.70794],
              [-0.30556, 53.713608],
              [-0.297778, 53.71278],
              [-0.287778, 53.70861],
              [-0.26444, 53.69083],
              [-0.24157, 53.6680530000001],
              [-0.23056, 53.65333],
              [-0.222778, 53.644440000000145],
              [-0.20722, 53.630829],
              [-0.117222, 53.58194],
              [-0.100833, 53.573051000000135],
              [0.026944000000128, 53.50972],
              [0.085278, 53.486382000000106],
              [0.12278, 53.474716000000114],
              [0.12861, 53.474159],
              [0.14, 53.47583],
              [0.146944, 53.474716000000114],
              [0.168611, 53.46],
              [0.216944, 53.416939],
              [0.235556, 53.39944],
              [0.2475, 53.380554],
              [0.255, 53.367775],
              [0.27, 53.346382],
              [0.338889000000108, 53.236382],
              [0.340278000000126, 53.233055],
              [0.353889, 53.187218000000144],
              [0.35639, 53.176384],
              [0.357778, 53.16083],
              [0.356667, 53.148605],
              [0.35417, 53.139442],
              [0.34167, 53.09583],
              [0.336667, 53.088882],
              [0.329167, 53.083885000000123],
              [0.324167, 53.082497],
              [0.276667, 53.06694],
              [0.203889, 53.028053],
              [0.17333, 53.009163],
              [0.032222, 52.91722],
              [0.001840000000129, 52.882835],
              [0.000037000000134, 52.87955],
              [0.006562, 52.877563000000123],
              [0.02806, 52.880829],
              [0.05778, 52.88916],
              [0.068889, 52.89083],
              [0.075278, 52.89111],
              [0.086389, 52.889717000000132],
              [0.122222, 52.877495],
              [0.1475, 52.868607],
              [0.157222000000104, 52.864716],
              [0.165278, 52.860275],
              [0.17167, 52.854996],
              [0.17611, 52.8491590000001],
              [0.18694, 52.837776],
              [0.217778000000123, 52.806938],
              [0.23389, 52.798050000000103],
              [0.238611000000105, 52.796104],
              [0.24389, 52.795273],
              [0.363333, 52.780273],
              [0.378889, 52.781387],
              [0.4275, 52.822495000000117],
              [0.43056, 52.825554000000125],
              [0.433056, 52.828888],
              [0.436944, 52.836937],
              [0.438333, 52.845551],
              [0.443333, 52.863609],
              [0.445278, 52.867775000000108],
              [0.488611, 52.931107],
              [0.494167, 52.937492000000134],
              [0.540833, 52.964722],
              [0.545833, 52.966110000000128],
              [0.552222, 52.966942],
              [0.66722, 52.976105],
              [0.877778, 52.967773],
              [0.88278, 52.96722],
              [0.88917, 52.965271000000143],
              [0.89861100000013, 52.957771],
              [0.9075, 52.953049],
              [0.911667, 52.952217],
              [0.942222, 52.950829],
              [0.969722, 52.94999700000011],
              [0.994722, 52.951111],
              [1.005833, 52.95277],
              [1.183889, 52.938889],
              [1.28222, 52.927498000000128],
              [1.305833, 52.92166],
              [1.3525, 52.909721000000104],
              [1.372778, 52.902496],
              [1.39333, 52.893608],
              [1.432222000000138, 52.874718],
              [1.468611, 52.854439000000127],
              [1.50361, 52.837494],
              [1.517222000000118, 52.83138300000013],
              [1.530833, 52.825272],
              [1.645278, 52.771111000000133],
              [1.656944, 52.76416],
              [1.675278, 52.748055],
              [1.686389, 52.736664000000133],
              [1.7025, 52.715828000000101],
              [1.707222, 52.706108],
              [1.721111, 52.676666],
              [1.743889, 52.62722],
              [1.746389000000136, 52.620277],
              [1.746666000000118, 52.61666],
              [1.748982, 52.529106],
              [1.74944, 52.455826],
              [1.730278, 52.411385],
              [1.73305, 52.393051],
              [1.72667, 52.381660000000124],
              [1.685751, 52.326302000000112],
              [1.63, 52.195274],
              [1.627778, 52.182495],
              [1.625, 52.173607],
              [1.588611000000128, 52.085548],
              [1.586111, 52.082222],
              [1.579722, 52.076385],
              [1.390278000000137, 51.96999],
              [1.333889000000113, 51.929161],
              [1.328611, 51.92833],
              [1.317778, 51.943604],
              [1.28083, 51.982773],
              [1.27417, 51.988327],
              [1.264722, 51.992493000000138],
              [1.17028, 52.02583],
              [1.16472, 52.025551000000121],
              [1.16028, 52.023331],
              [1.158611, 52.019722000000115],
              [1.208333, 51.950829],
              [1.278055, 51.881104],
              [1.283889, 51.880829],
              [1.288889, 51.87944],
              [1.293611000000112, 51.877495],
              [1.295278, 51.86972],
              [1.28639, 51.854996],
              [1.280278, 51.849716],
              [1.266111, 51.839165],
              [1.223611000000119, 51.80888],
              [1.208333, 51.799995000000138],
              [1.199722, 51.796104],
              [1.181389, 51.789719],
              [1.132222000000127, 51.776939],
              [1.111666, 51.77333],
              [1.08833, 51.770554],
              [1.05, 51.770554],
              [1.03722, 51.772774],
              [1.034167, 51.775551],
              [0.9975, 51.810829],
              [0.986667, 51.826111],
              [0.978889, 51.82444],
              [0.93667, 51.807777],
              [0.928056, 51.80389],
              [0.862111, 51.773605],
              [0.724167, 51.726662],
              [0.704167, 51.722221000000104],
              [0.699722, 51.719444],
              [0.70028, 51.71611],
              [0.75861, 51.691383],
              [0.764184, 51.691902],
              [0.863055, 51.711662],
              [0.872778, 51.714722000000108],
              [0.88, 51.71916],
              [0.89944400000013, 51.733273],
              [0.901611, 51.73444],
              [0.904611000000102, 51.735443],
              [0.91889, 51.740555],
              [0.926111, 51.740273],
              [0.93167, 51.738609],
              [0.939722000000131, 51.734444],
              [0.94694, 51.725555],
              [0.955, 51.614166],
              [0.953889000000117, 51.609993],
              [0.950555000000122, 51.606384],
              [0.910000000000139, 51.581383],
              [0.875278, 51.561104],
              [0.820833, 51.535553],
              [0.808056, 51.529999],
              [0.789444, 51.524162],
              [0.779167, 51.521942],
              [0.766944, 51.521385000000123],
              [0.680555, 51.532219],
              [0.655, 51.536942],
              [0.648889000000111, 51.536659],
              [0.465, 51.503052],
              [0.451667, 51.49805],
              [0.382778, 51.450554000000125],
              [0.38685, 51.448456],
              [0.393055, 51.446938],
              [0.412222, 51.446938],
              [0.443889, 51.451660000000118],
              [0.4525, 51.455276],
              [0.456111, 51.457771],
              [0.463889, 51.467499],
              [0.468056, 51.474998],
              [0.471111, 51.47805],
              [0.47889, 51.482216],
              [0.489167, 51.484444],
              [0.536111, 51.48805],
              [0.54889, 51.48805],
              [0.588333, 51.48805],
              [0.59556, 51.487495],
              [0.6975, 51.470833],
              [0.707778, 51.467499],
              [0.716111000000126, 51.46333],
              [0.72, 51.461105],
              [0.725278000000117, 51.455276],
              [0.726667, 51.451942],
              [0.726944000000117, 51.44833],
              [0.725278000000117, 51.44416],
              [0.722778, 51.440826],
              [0.719167, 51.438332000000116],
              [0.70889, 51.436104],
              [0.690833000000111, 51.435272],
              [0.684167000000116, 51.435555],
              [0.66583, 51.43916],
              [0.644722000000115, 51.441109],
              [0.64, 51.43972],
              [0.558056000000136, 51.41111],
              [0.556389, 51.408051],
              [0.558611, 51.405],
              [0.564722000000131, 51.399719],
              [0.5783330000001, 51.39],
              [0.582222, 51.387772],
              [0.58778, 51.386383],
              [0.61972, 51.383049000000142],
              [0.704167, 51.377495000000124],
              [0.905, 51.340828000000101],
              [0.911111, 51.340553000000114],
              [0.98139, 51.345551000000114],
              [0.999167, 51.347771000000137],
              [1.012222, 51.351944],
              [1.033333, 51.361938],
              [1.05278, 51.367218],
              [1.06278, 51.368889],
              [1.069722, 51.36944],
              [1.191944, 51.378609],
              [1.385556, 51.387772],
              [1.4275, 51.331108],
              [1.411111000000119, 51.201111],
              [1.408889000000102, 51.188332],
              [1.406389, 51.179443000000106],
              [1.398333, 51.16389],
              [1.390278000000137, 51.15416],
              [1.368889, 51.135826],
              [1.35805, 51.12861],
              [1.35361, 51.126663],
              [1.262500000000102, 51.101662],
              [1.231944, 51.10083],
              [1.220556000000101, 51.099716],
              [1.100278000000117, 51.073608],
              [1.086944, 51.068604],
              [1.045555, 51.049438],
              [1.03, 51.04083],
              [1.001111, 51.02166],
              [0.994444000000101, 51.01638800000012],
              [0.986111, 51.007217],
              [0.978889, 50.996666000000118],
              [0.97278, 50.985275000000115],
              [0.969722, 50.976944],
              [0.968055, 50.96833],
              [0.970000000000141, 50.94527],
              [0.975000000000136, 50.931938],
              [0.85667, 50.925552],
              [0.814167, 50.934441],
              [0.793333000000132, 50.936104000000114],
              [0.781389, 50.935555000000136],
              [0.716389, 50.904999],
              [0.705833, 50.897774],
              [0.6825, 50.879166000000112],
              [0.675278, 50.874443],
              [0.66222, 50.869438],
              [0.567222, 50.847771],
              [0.49861, 50.838051000000121],
              [0.452778000000137, 50.833885],
              [0.430833, 50.83111],
              [0.400556, 50.82444],
              [0.371944, 50.816383],
              [0.349444, 50.808609],
              [0.307222, 50.780548000000124],
              [0.296389, 50.77333],
              [0.286944, 50.765],
              [0.276944, 50.751663],
              [0.271111, 50.745827],
              [0.263611, 50.741386],
              [0.253889000000129, 50.738609],
              [0.242222, 50.738052],
              [0.227778000000114, 50.739441000000113],
              [0.215278, 50.741661],
              [0.123333, 50.75944],
              [0.098333000000139, 50.767776],
              [0.056944, 50.78083],
              [-0.09444, 50.810272000000111],
              [-0.138056, 50.818329],
              [-0.15694, 50.821388],
              [-0.190833, 50.825829],
              [-0.206111, 50.82666],
              [-0.255, 50.82638],
              [-0.57722, 50.795273],
              [-0.6375, 50.787216],
              [-0.675278, 50.781105],
              [-0.711389, 50.773888],
              [-0.74611, 50.765831000000105],
              [-0.76806, 50.752777],
              [-0.76667, 50.74667],
              [-0.76667, 50.74305],
              [-0.76917, 50.734993000000145],
              [-0.77639, 50.72916],
              [-0.78056, 50.727493],
              [-0.785278, 50.726105000000132],
              [-0.79639, 50.725273],
              [-0.8025, 50.727219000000105],
              [-0.90333, 50.768051000000128],
              [-0.910278, 50.772217],
              [-0.91083, 50.776108],
              [-0.908611, 50.779442],
              [-0.894444, 50.789444],
              [-0.89056, 50.791382],
              [-0.869167, 50.795273],
              [-0.865833, 50.797775000000115],
              [-0.86361, 50.800827],
              [-0.86472, 50.80472],
              [-0.87194, 50.808884],
              [-0.92694, 50.839439],
              [-0.9299, 50.83987],
              [-0.939167, 50.840828],
              [-1.094445, 50.845833],
              [-1.15472, 50.844162],
              [-1.15944, 50.842773],
              [-1.16222, 50.839722],
              [-1.159167, 50.83666],
              [-1.14667, 50.83111],
              [-1.118056, 50.81194],
              [-1.116389, 50.808884],
              [-1.115834, 50.805275],
              [-1.1175, 50.801666],
              [-1.127222, 50.787216],
              [-1.12944, 50.78416],
              [-1.13278, 50.781662],
              [-1.13694, 50.779442],
              [-1.14167, 50.778328000000101],
              [-1.146945, 50.7775],
              [-1.331389, 50.791382],
              [-1.40806, 50.770828],
              [-1.592778, 50.724159],
              [-1.61417, 50.72972],
              [-1.663611, 50.737495],
              [-1.672361, 50.738258],
              [-1.68444, 50.73888],
              [-1.701389, 50.736938000000123],
              [-1.816389, 50.723053],
              [-1.934167, 50.712776],
              [-2.009445, 50.714996],
              [-2.020556, 50.717773000000136],
              [-2.0275, 50.722221000000104],
              [-2.02972, 50.725555],
              [-2.03194, 50.732498],
              [-2.03611, 50.734161],
              [-2.041945, 50.733887],
              [-2.06556, 50.71555],
              [-2.06806, 50.713051],
              [-2.079445, 50.700554],
              [-2.081389, 50.697495000000117],
              [-2.079722, 50.69416],
              [-1.97472, 50.670273],
              [-1.96322, 50.663609],
              [-1.95906, 50.666607],
              [-1.95622, 50.667774],
              [-1.95289, 50.66711],
              [-1.95139, 50.66544],
              [-1.95056, 50.663445],
              [-1.935556, 50.639442],
              [-1.95833, 50.59861],
              [-1.9625, 50.59666],
              [-1.96833, 50.59583],
              [-2.05139, 50.58583],
              [-2.0575, 50.585548],
              [-2.12194, 50.607216],
              [-2.133889, 50.613327],
              [-2.14472, 50.616943000000106],
              [-2.197222, 50.626106000000107],
              [-2.388056, 50.64166],
              [-2.393889, 50.64166],
              [-2.43111, 50.634995],
              [-2.446667, 50.626389],
              [-2.464445, 50.59833],
              [-2.4675, 50.59],
              [-2.46583, 50.583885000000123],
              [-2.458611, 50.57499700000011],
              [-2.42472, 50.559998],
              [-2.434451, 50.54179],
              [-2.45523, 50.548901],
              [-2.458239, 50.56175],
              [-2.4946, 50.595654],
              [-2.563056, 50.63222],
              [-2.661945, 50.67333200000013],
              [-2.700556, 50.686943],
              [-2.72111, 50.693329],
              [-2.771389, 50.708611],
              [-2.82306, 50.720276000000126],
              [-2.86389, 50.728333],
              [-2.88278, 50.73111],
              [-2.90694, 50.73333],
              [-2.92472, 50.731941],
              [-2.93028, 50.7305530000001],
              [-2.94444, 50.723328],
              [-2.959445, 50.712776],
              [-2.97806, 50.706383],
              [-3.09444, 50.692215],
              [-3.17056, 50.688606],
              [-3.17639, 50.68805],
              [-3.24417, 50.674438],
              [-3.25417, 50.671944],
              [-3.41139, 50.616104000000121],
              [-3.43722, 50.604996000000142],
              [-3.458611, 50.590553],
              [-3.465, 50.585274],
              [-3.494167, 50.546387],
              [-3.500278, 50.535828],
              [-3.55139, 50.438332],
              [-3.553334, 50.425552],
              [-3.651945, 50.231110000000115],
              [-3.675, 50.220276],
              [-3.70667, 50.209717],
              [-3.71667, 50.2066650000001],
              [-3.72889, 50.206383],
              [-3.78944, 50.212219],
              [-3.803056, 50.214165],
              [-3.813334, 50.217216],
              [-3.83333, 50.227219],
              [-3.839723, 50.23222],
              [-3.845, 50.238052],
              [-3.851944, 50.251663],
              [-3.876389, 50.279999],
              [-3.878889, 50.282776],
              [-3.94083, 50.312492],
              [-3.946945, 50.314438000000109],
              [-3.951945, 50.315552],
              [-3.958611, 50.315552],
              [-3.97583, 50.313889],
              [-3.98556, 50.311386],
              [-4.005, 50.306107],
              [-4.01167, 50.301109],
              [-4.01417, 50.29833200000013],
              [-4.022779, 50.294441],
              [-4.028056, 50.29305],
              [-4.033611, 50.29277],
              [-4.05278, 50.29583],
              [-4.061389, 50.299995],
              [-4.11139, 50.33027600000014],
              [-4.16556, 50.370277],
              [-4.175, 50.377777],
              [-4.38, 50.36388],
              [-4.42556, 50.353333],
              [-4.433889, 50.349442],
              [-4.440984, 50.34444],
              [-4.45083, 50.336937],
              [-4.45333, 50.33416],
              [-4.46639, 50.329163],
              [-4.482779, 50.325829],
              [-4.51056, 50.322495000000117],
              [-4.54333, 50.32222],
              [-4.645278, 50.32361],
              [-4.67861, 50.325829],
              [-4.7625, 50.311386],
              [-4.8575, 50.231667],
              [-4.95278, 50.193329000000119],
              [-5.04806, 50.171104000000128],
              [-5.05944, 50.13916],
              [-5.07528, 50.084717000000126],
              [-5.07111, 50.082497000000103],
              [-5.06861, 50.07972],
              [-5.054723, 50.06194],
              [-5.053612, 50.058327],
              [-5.055556, 50.04972],
              [-5.05944, 50.042496000000142],
              [-5.065556, 50.037498000000141],
              [-5.086112, 50.022774],
              [-5.159167, 50.004440000000102],
              [-5.16222, 50.001938],
              [-5.176667, 49.982773],
              [-5.18111, 49.97639],
              [-5.19306, 49.95527600000014],
              [-5.19889, 49.955551000000128],
              [-5.202778, 49.957771],
              [-5.22861, 49.973328],
              [-5.2375, 49.98111],
              [-5.255834, 50.000832],
              [-5.257223, 50.004166],
              [-5.25694, 50.007774],
              [-5.25111, 50.018326000000116],
              [-5.250834, 50.023048],
              [-5.253334, 50.03],
              [-5.27667, 50.05971],
              [-5.28972, 50.069443],
              [-5.33361, 50.091385000000116],
              [-5.47056, 50.124992],
              [-5.4825, 50.126938000000109],
              [-5.48944, 50.12722],
              [-5.50111, 50.126106],
              [-5.51139, 50.123886],
              [-5.530834, 50.11805],
              [-5.5375, 50.11332700000014],
              [-5.54139, 50.10611],
              [-5.54194, 50.101662],
              [-5.53806, 50.086662000000103],
              [-5.53778, 50.082497000000103],
              [-5.53944, 50.073883],
              [-5.54389, 50.067215],
              [-5.55194, 50.059441],
              [-5.559167, 50.054718],
              [-5.56722, 50.05110900000011],
              [-5.582778, 50.047775000000115],
              [-5.65389, 50.03666],
              [-5.65972, 50.03583],
              [-5.666667, 50.036385],
              [-5.67778, 50.038605],
              [-5.6875, 50.041939],
              [-5.7125, 50.053604000000121],
              [-5.717501, 50.059441],
              [-5.71861, 50.06305],
              [-5.71861, 50.067215],
              [-5.71, 50.129166],
              [-5.69583, 50.153053000000114],
              [-5.688056, 50.157219],
              [-5.54639, 50.205276],
              [-5.51167, 50.214165],
              [-5.49583, 50.216942],
              [-5.483612, 50.215],
              [-5.47889, 50.213333],
              [-5.47389, 50.2075],
              [-5.471111, 50.200554],
              [-5.46889, 50.197777],
              [-5.46306, 50.196388],
              [-5.43944, 50.192497],
              [-5.43278, 50.192772],
              [-5.42778, 50.193886],
              [-5.26806, 50.273888],
              [-5.15389, 50.342499],
              [-5.15028, 50.344994],
              [-5.05194, 50.422218],
              [-5.04889, 50.424995000000138],
              [-5.044168, 50.43139],
              [-5.024445, 50.466660000000104],
              [-5.02389, 50.470276],
              [-5.027223, 50.47694],
              [-5.03944, 50.495827],
              [-5.03889, 50.500275],
              [-5.021111, 50.540276],
              [-5.013889, 50.544998],
              [-4.91583, 50.577217000000132],
              [-4.8975, 50.578888],
              [-4.873889, 50.578888],
              [-4.80139, 50.589439],
              [-4.785833, 50.592773],
              [-4.78139, 50.594444000000124],
              [-4.77167, 50.601944],
              [-4.76167, 50.614716],
              [-4.751667, 50.64138800000012],
              [-4.743611, 50.667496],
              [-4.70083, 50.688332000000116],
              [-4.651389, 50.715271],
              [-4.564723, 50.7736],
              [-4.558056, 50.778885],
              [-4.553612, 50.785271],
              [-4.54944, 50.802498000000128],
              [-4.5475, 50.816383],
              [-4.54722, 50.824997],
              [-4.54639, 50.854721],
              [-4.54667, 50.85889],
              [-4.54833, 50.86222],
              [-4.54333, 50.926941000000113],
              [-4.527223, 51.009995],
              [-4.523612, 51.01527],
              [-4.51722, 51.015831],
              [-4.47444, 51.01416],
              [-4.43056, 51.009995],
              [-4.42417, 51.009163],
              [-4.411945, 51.002777],
              [-4.37639, 50.991104],
              [-4.35778, 50.989441],
              [-4.339445, 50.990555],
              [-4.32472, 50.995277000000101],
              [-4.30361, 51.004166],
              [-4.241389, 51.04361],
              [-4.23833, 51.045555],
              [-4.23417, 51.048607],
              [-4.211667, 51.070549],
              [-4.20889, 51.074165000000107],
              [-4.220278, 51.11055],
              [-4.22972, 51.18639],
              [-4.22639, 51.189163],
              [-4.208611, 51.195831],
              [-4.19861, 51.198326],
              [-4.116667, 51.212219],
              [-4.071667, 51.21388],
              [-3.98472, 51.216942],
              [-3.883889, 51.22416],
              [-3.7925, 51.23917],
              [-3.70028, 51.229996],
              [-3.63222, 51.218048],
              [-3.61861, 51.21666],
              [-3.59694, 51.220276],
              [-3.5875, 51.22333],
              [-3.574722, 51.228882000000112],
              [-3.565556, 51.23167],
              [-3.51056, 51.223885],
              [-3.503889, 51.222771],
              [-3.4425, 51.208611000000133],
              [-3.437778, 51.20694],
              [-3.43444, 51.204994],
              [-3.423334, 51.193054],
              [-3.416667, 51.188049],
              [-3.40861, 51.184441000000106],
              [-3.397223, 51.181664],
              [-3.39, 51.181107000000111],
              [-3.37028, 51.181107000000111],
              [-3.30139, 51.181107000000111],
              [-3.02833, 51.20611],
              [-3.00944, 51.249718000000144],
              [-3.01333, 51.256104],
              [-3.01417, 51.259720000000129],
              [-3.01333, 51.272774],
              [-3.00694, 51.30722],
              [-2.96, 51.374992000000134],
              [-2.852778, 51.44472],
              [-2.770556, 51.489166000000125],
              [-2.65333, 51.563889],
              [-2.63944, 51.578888],
              [-2.553056, 51.657219],
              [-2.47167, 51.724442],
              [-2.45917, 51.730270000000132],
              [-2.45056, 51.73305],
              [-2.428889, 51.736938],
              [-2.406389, 51.739716000000101],
              [-2.401389, 51.741104],
              [-2.391945, 51.744164],
              [-2.384722, 51.749161000000129],
              [-2.38, 51.755554000000132],
              [-2.378889, 51.760277],
              [-2.379723, 51.763885],
              [-2.381389, 51.76722],
              [-2.386945, 51.772774],
              [-2.390833, 51.774994000000106],
              [-2.39667, 51.776382],
              [-2.460556, 51.746666000000118],
              [-2.578889, 51.677773],
              [-2.629167, 51.64416],
              [-2.665, 51.614998],
              [-2.67472, 51.60694100000012],
              [-2.698889, 51.589439],
              [-2.71472, 51.580826000000116],
              [-2.847778, 51.544998],
              [-2.89278, 51.538605000000132],
              [-2.91889, 51.537773],
              [-2.95472, 51.539719000000105],
              [-2.966389, 51.541664],
              [-3.02111, 51.525276],
              [-3.115556, 51.489998],
              [-3.12194, 51.484993000000145],
              [-3.12778, 51.478882],
              [-3.15167, 51.453049000000135],
              [-3.160278, 51.437218000000144],
              [-3.158611, 51.433609],
              [-3.15806, 51.429993],
              [-3.158611, 51.42139],
              [-3.16167, 51.41333],
              [-3.16389, 51.409721],
              [-3.16639, 51.406662],
              [-3.17667, 51.399162],
              [-3.185556, 51.395554],
              [-3.26833, 51.380554],
              [-3.273612, 51.37971],
              [-3.346111, 51.378609],
              [-3.359445, 51.378609],
              [-3.40333, 51.37971],
              [-3.41639, 51.380554],
              [-3.451111, 51.38472],
              [-3.48861, 51.39],
              [-3.5425, 51.397774],
              [-3.56028, 51.405548],
              [-3.67194, 51.473885],
              [-3.74944, 51.525276],
              [-3.753757, 51.53334],
              [-3.761111, 51.544441],
              [-3.781667, 51.567497],
              [-3.835556, 51.619164],
              [-3.840278, 51.620827],
              [-3.949722, 51.612778],
              [-3.965556, 51.609718],
              [-4.20028, 51.5425],
              [-4.20222, 51.534721000000104],
              [-4.20556, 51.532219],
              [-4.21139, 51.531662],
              [-4.217223, 51.532776],
              [-4.242778, 51.540833],
              [-4.27778, 51.556664],
              [-4.29306, 51.60249],
              [-4.29306, 51.606667],
              [-4.291112, 51.610275000000115],
              [-4.250556, 51.628609],
              [-4.231945, 51.633049],
              [-4.21139, 51.62666],
              [-4.180556, 51.622498],
              [-4.17444, 51.62221],
              [-4.1625, 51.623329],
              [-4.116389, 51.634163],
              [-4.078056, 51.646111],
              [-4.075, 51.648605],
              [-4.065556, 51.661942],
              [-4.06389, 51.665833000000134],
              [-4.065001, 51.669716],
              [-4.070136, 51.67464],
              [-4.074722, 51.67722],
              [-4.1975, 51.679161000000136],
              [-4.262222, 51.676941000000113],
              [-4.43611, 51.737221],
              [-4.57444, 51.734161],
              [-4.62833, 51.728882],
              [-4.64583, 51.726662],
              [-4.66722, 51.722496],
              [-4.675834, 51.718887000000109],
              [-4.682501, 51.713608000000136],
              [-4.68611, 51.706108],
              [-4.686667, 51.689438000000109],
              [-4.69028, 51.66666],
              [-4.708611, 51.650276],
              [-4.71333, 51.648888],
              [-4.783334, 51.631943],
              [-4.78972, 51.632774],
              [-4.79472, 51.634438],
              [-4.80722, 51.640549000000135],
              [-4.827778, 51.644997000000103],
              [-4.834445, 51.645828000000108],
              [-4.84028, 51.645271],
              [-4.86194, 51.640831],
              [-4.866389, 51.639442],
              [-4.890278, 51.626938],
              [-4.941389, 51.594162],
              [-5.00528, 51.606384],
              [-5.0425, 51.616661],
              [-5.05139, 51.620277],
              [-5.021278, 51.66861],
              [-4.970612, 51.675774],
              [-4.905001, 51.69694],
              [-4.89417, 51.69944],
              [-4.86111, 51.713333],
              [-4.867223, 51.722771000000137],
              [-4.88444, 51.746666000000118],
              [-4.89, 51.732773],
              [-4.89056, 51.724716000000114],
              [-4.8925, 51.721107000000131],
              [-4.899445, 51.71583],
              [-4.90417, 51.713882],
              [-4.91333, 51.7111],
              [-5.004056, 51.703995],
              [-5.01072, 51.702995],
              [-5.065056, 51.704994],
              [-5.19111, 51.708885000000123],
              [-5.22861, 51.723053],
              [-5.24694, 51.730270000000132],
              [-5.16111, 51.762215],
              [-5.15111, 51.765],
              [-5.14528, 51.765549],
              [-5.12417, 51.765274],
              [-5.11222, 51.766663],
              [-5.107779, 51.768326000000116],
              [-5.104445, 51.770828],
              [-5.101945, 51.778885],
              [-5.101945, 51.783051],
              [-5.11472, 51.83138300000013],
              [-5.115834, 51.835274],
              [-5.12, 51.845551],
              [-5.12194, 51.848885],
              [-5.127223, 51.854439],
              [-5.136111, 51.85833],
              [-5.181667, 51.869164000000126],
              [-5.18833, 51.869995000000131],
              [-5.21333, 51.870552],
              [-5.258889, 51.870552],
              [-5.239167, 51.916382],
              [-5.101945, 51.959717],
              [-5.096945, 51.961388],
              [-5.08167, 51.975273000000129],
              [-5.07972, 51.978607000000125],
              [-5.07667, 51.996109],
              [-4.84444, 52.01388500000013],
              [-4.832223, 52.01527],
              [-4.82833, 52.01722],
              [-4.76778, 52.064438000000109],
              [-4.759167, 52.073051],
              [-4.74611, 52.090271],
              [-4.73694, 52.103607],
              [-4.722778, 52.113052],
              [-4.66944, 52.130272],
              [-4.646945, 52.134163000000115],
              [-4.641111, 52.13472],
              [-4.62667, 52.134163000000115],
              [-4.59056, 52.13166],
              [-4.527223, 52.130829000000119],
              [-4.5, 52.136383000000137],
              [-4.49528, 52.13777],
              [-4.291945, 52.222496],
              [-4.23167, 52.248886],
              [-4.19361, 52.276382],
              [-4.143056, 52.32027],
              [-4.13083, 52.334717],
              [-4.098333, 52.381943],
              [-4.095, 52.389717],
              [-4.09194, 52.397774],
              [-4.059723, 52.485832],
              [-4.06111, 52.506104],
              [-4.080556, 52.553329000000133],
              [-4.12389, 52.59861],
              [-4.12639, 52.601662],
              [-4.1275, 52.60527],
              [-4.12611, 52.609444],
              [-4.10639, 52.65083],
              [-4.053334, 52.71666],
              [-4.063334, 52.724159],
              [-4.13056, 52.777771000000143],
              [-4.146111, 52.795273],
              [-4.14833, 52.79833],
              [-4.149445, 52.801941],
              [-4.149445, 52.806107],
              [-4.13639, 52.876663],
              [-4.135, 52.881104],
              [-4.133056, 52.884163],
              [-4.12667, 52.890274],
              [-4.11833, 52.894440000000145],
              [-4.133612, 52.914444],
              [-4.23333, 52.914993],
              [-4.30944, 52.905548000000124],
              [-4.31639, 52.904442],
              [-4.414167, 52.88472],
              [-4.440556, 52.872498],
              [-4.47722, 52.854996],
              [-4.500278, 52.829437],
              [-4.53944, 52.79305],
              [-4.727778, 52.781387],
              [-4.740834, 52.78083],
              [-4.7475, 52.781662],
              [-4.75611, 52.785553000000107],
              [-4.76086, 52.788971000000117],
              [-4.752223, 52.806938],
              [-4.741112, 52.819443],
              [-4.721945, 52.836105],
              [-4.65111, 52.88694],
              [-4.61889, 52.90916],
              [-4.58611, 52.923882000000106],
              [-4.55278, 52.928886],
              [-4.54028, 52.93055],
              [-4.52667, 52.935829],
              [-4.50583, 52.946106],
              [-4.4625, 52.970276],
              [-4.36444, 53.026382000000126],
              [-4.3575, 53.031387],
              [-4.35472, 53.034439],
              [-4.35056, 53.04166],
              [-4.345, 53.06277],
              [-4.344167, 53.067497],
              [-4.330278, 53.112221],
              [-4.19639, 53.20611],
              [-4.15333, 53.22555],
            ],
          ],
          [
            [
              [-2.918334, 58.731941],
              [-2.93944, 58.729996],
              [-2.94806, 58.7305530000001],
              [-2.957778, 58.7347180000001],
              [-2.97056, 58.741943],
              [-2.98, 58.75027],
              [-3.036945, 58.818054],
              [-3.033611, 58.820831],
              [-3.02889, 58.823051],
              [-3.01, 58.831665],
              [-3.00444, 58.833054],
              [-2.97472, 58.835274],
              [-2.91611, 58.83888],
              [-2.89917, 58.838333],
              [-2.89417, 58.83694],
              [-2.886389, 58.83194],
              [-2.87778, 58.824165],
              [-2.87667, 58.820274],
              [-2.91389, 58.733887],
              [-2.918334, 58.731941],
            ],
          ],
          [
            [
              [-3.23139, 58.775551],
              [-3.28889, 58.775551],
              [-3.295834, 58.776108],
              [-3.300834, 58.778053000000114],
              [-3.43111, 58.87138],
              [-3.43306, 58.874718000000144],
              [-3.43306, 58.87888],
              [-3.41806, 58.904160000000104],
              [-3.41222, 58.910553],
              [-3.398056, 58.917221],
              [-3.34917, 58.926941000000113],
              [-3.335556, 58.927498],
              [-3.23306, 58.88721],
              [-3.228333, 58.884995000000117],
              [-3.21472, 58.874161],
              [-3.13639, 58.804161],
              [-3.13472, 58.800827],
              [-3.136945, 58.78666],
              [-3.14167, 58.784721],
              [-3.160278, 58.781105],
              [-3.180833, 58.77916],
              [-3.23139, 58.775551],
            ],
          ],
          [
            [
              [-2.79306, 58.951385],
              [-2.75583, 58.917770000000132],
              [-2.82444, 58.87888],
              [-2.86917, 58.893326],
              [-2.97, 58.939438000000109],
              [-3.008334, 58.939995],
              [-3.05722, 58.935829],
              [-3.11056, 58.928055],
              [-3.119722, 58.923332],
              [-3.119722, 58.919167],
              [-3.17222, 58.910828],
              [-3.188334, 58.91],
              [-3.195, 58.911110000000122],
              [-3.303334, 58.945831],
              [-3.313334, 58.95],
              [-3.34556, 58.965828000000101],
              [-3.361111, 58.992218],
              [-3.36306, 58.99555],
              [-3.368056, 59.009995],
              [-3.368056, 59.01416],
              [-3.35139, 59.10638],
              [-3.350278, 59.109993000000145],
              [-3.3175, 59.12944],
              [-3.27778, 59.139999],
              [-3.272223, 59.141388],
              [-3.23889, 59.146111],
              [-3.21889, 59.1486],
              [-3.2025, 59.1486],
              [-3.195834, 59.147217],
              [-3.076945, 59.121666],
              [-3.073056, 59.119164],
              [-2.998333, 59.06972],
              [-2.99528, 59.066666000000112],
              [-2.995833, 59.055832],
              [-2.94722, 58.998329],
              [-2.85222, 58.975555],
              [-2.79306, 58.951385],
            ],
          ],
          [
            [
              [-2.681389, 59.195831],
              [-2.68583, 59.184166000000118],
              [-2.689723, 59.186661000000129],
              [-2.691667, 59.189995000000124],
              [-2.69361, 59.197495],
              [-2.6925, 59.210274],
              [-2.690556, 59.214439],
              [-2.68444, 59.22083],
              [-2.59278, 59.29055],
              [-2.55556, 59.303055],
              [-2.534445, 59.304993],
              [-2.41444, 59.313606],
              [-2.407222, 59.31389],
              [-2.402223, 59.31277],
              [-2.4, 59.310272],
              [-2.397223, 59.303329],
              [-2.390278, 59.283051],
              [-2.39, 59.279716000000121],
              [-2.495556, 59.244995],
              [-2.57083, 59.242218],
              [-2.577222, 59.242218],
              [-2.620556, 59.236107],
              [-2.625, 59.233604],
              [-2.681389, 59.195831],
            ],
          ],
          [
            [
              [-2.89, 59.295273000000122],
              [-2.84972, 59.268051],
              [-2.85306, 59.24944],
              [-2.8775, 59.228607000000125],
              [-2.873056, 59.251938],
              [-2.873056, 59.256104],
              [-2.87694, 59.25861],
              [-2.936667, 59.28361],
              [-2.958611, 59.287773],
              [-2.965556, 59.28805],
              [-2.971945, 59.287216],
              [-2.97639, 59.284721],
              [-2.97417, 59.281387],
              [-2.976944, 59.272774],
              [-2.98806, 59.264160000000118],
              [-2.992222, 59.261665000000107],
              [-2.999167, 59.261108],
              [-3.003334, 59.263611],
              [-3.02833, 59.285],
              [-3.073611, 59.324165],
              [-3.075556, 59.327499],
              [-3.076389, 59.331383],
              [-3.07167, 59.331383],
              [-3.04889, 59.329163],
              [-2.897223, 59.299721],
              [-2.89, 59.295273000000122],
            ],
          ],
          [
            [
              [-1.296111, 60.491104],
              [-1.286667, 60.471107000000131],
              [-1.16389, 60.454437],
              [-1.04139, 60.446938],
              [-1.03722, 60.44416],
              [-1.03778, 60.439995],
              [-1.06611, 60.35805],
              [-1.101111, 60.27583],
              [-1.164167, 60.258331000000112],
              [-1.165833, 60.26194],
              [-1.18694, 60.269722],
              [-1.195, 60.270828000000108],
              [-1.19889, 60.26778],
              [-1.200556, 60.263329000000113],
              [-1.19806, 60.255829],
              [-1.18556, 60.23055],
              [-1.18056, 60.224998],
              [-1.1575, 60.194717],
              [-1.12611, 60.151665],
              [-1.125556, 60.147774],
              [-1.12861, 60.1441650000001],
              [-1.14667, 60.13194],
              [-1.15306, 60.133049000000142],
              [-1.16306, 60.13749700000011],
              [-1.170556, 60.137215],
              [-1.18722, 60.127220000000136],
              [-1.212222, 60.102776],
              [-1.22056, 60.022499],
              [-1.26028, 59.86222],
              [-1.2625, 59.85833],
              [-1.26861, 59.851105],
              [-1.30694, 59.857498000000135],
              [-1.37194, 59.891663],
              [-1.37806, 59.902222000000108],
              [-1.37778, 59.906387000000109],
              [-1.33167, 59.996941000000106],
              [-1.33004, 60.0],
              [-1.326389, 60.004440000000102],
              [-1.3225, 60.0075],
              [-1.316389, 60.008888],
              [-1.311389, 60.00666],
              [-1.308056, 60.008888],
              [-1.305833, 60.012772],
              [-1.26833, 60.093605],
              [-1.26306, 60.106941],
              [-1.26111, 60.115829],
              [-1.26028, 60.124161],
              [-1.26167, 60.13083],
              [-1.285, 60.21999],
              [-1.29139, 60.24139],
              [-1.40333, 60.255829],
              [-1.410278, 60.254997000000117],
              [-1.41417, 60.25194],
              [-1.410278, 60.249443],
              [-1.3875, 60.23722],
              [-1.363611, 60.229721],
              [-1.35306, 60.208885],
              [-1.358333, 60.192497],
              [-1.44861, 60.151108],
              [-1.45361, 60.1525],
              [-1.490556, 60.16777],
              [-1.520278, 60.181389],
              [-1.527222, 60.18694],
              [-1.52778, 60.190826000000129],
              [-1.52667, 60.194443],
              [-1.519722, 60.201111],
              [-1.588889, 60.215828],
              [-1.647778, 60.224716],
              [-1.655, 60.226105],
              [-1.66472, 60.230827],
              [-1.674445, 60.239441],
              [-1.678056, 60.24638],
              [-1.693056, 60.279716],
              [-1.69278, 60.283882],
              [-1.69139, 60.28833],
              [-1.666945, 60.299721],
              [-1.65528, 60.303055],
              [-1.628334, 60.30722],
              [-1.59667, 60.30805],
              [-1.589722, 60.306389],
              [-1.47472, 60.314995],
              [-1.445833, 60.318604],
              [-1.42694, 60.321388000000127],
              [-1.345834, 60.34],
              [-1.32028, 60.356384],
              [-1.445833, 60.460548000000131],
              [-1.502222, 60.469719],
              [-1.55361, 60.475555],
              [-1.558333, 60.473053],
              [-1.565, 60.473053],
              [-1.60972, 60.4741590000001],
              [-1.61167, 60.476662],
              [-1.61, 60.48138],
              [-1.593056, 60.50777],
              [-1.54694, 60.53583],
              [-1.41611, 60.604996],
              [-1.41056, 60.60694100000012],
              [-1.301944, 60.636665000000107],
              [-1.29583, 60.634720000000129],
              [-1.29417, 60.631104],
              [-1.2875, 60.613327],
              [-1.296111, 60.491104],
            ],
          ],
          [
            [
              [-1.029444, 60.495827],
              [-1.10472, 60.48555],
              [-1.1275, 60.48638],
              [-1.14, 60.489441000000113],
              [-1.14278, 60.492493],
              [-1.170278, 60.527222000000108],
              [-1.1825, 60.59499],
              [-1.18361, 60.602776000000119],
              [-1.18139, 60.623604],
              [-1.17944, 60.632500000000107],
              [-1.17722, 60.636665000000107],
              [-1.11, 60.72583],
              [-1.098611, 60.73],
              [-1.0925, 60.731384000000105],
              [-1.08472, 60.731667],
              [-1.05694, 60.73083],
              [-0.99667, 60.724716000000114],
              [-0.99111, 60.719994],
              [-0.9825, 60.655548],
              [-0.982778, 60.651382000000126],
              [-1.017778, 60.519440000000145],
              [-1.01917, 60.514999],
              [-1.02333, 60.503052],
              [-1.025556, 60.498886],
              [-1.029444, 60.495827],
            ],
          ],
          [
            [
              [-0.819722, 60.688889000000131],
              [-0.835, 60.67333200000013],
              [-0.935556, 60.674438000000123],
              [-0.95861, 60.682495000000131],
              [-0.96556, 60.688049],
              [-0.95972, 60.711388000000113],
              [-0.938889, 60.79444100000012],
              [-0.88306, 60.842216000000121],
              [-0.878333, 60.844444],
              [-0.80611, 60.840553],
              [-0.772778, 60.831108],
              [-0.76778, 60.82888800000012],
              [-0.758056, 60.817772],
              [-0.757222, 60.813889],
              [-0.76361, 60.793327],
              [-0.819722, 60.688889000000131],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "UP",
        ISO2: "UA",
        ISO3: "UKR",
        UN: 804,
        NAME: "Ukraine",
        AREA: 57935,
        POP2005: 46917544,
        REGION: 150,
        SUBREGION: 151,
        LON: 31.388,
        LAT: 49.016,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [33.040276000000119, 46.011375],
              [33.00832400000013, 46.00972],
              [32.97832, 46.01193],
              [32.901093, 46.01998],
              [32.75944, 46.036110000000122],
              [32.84943, 46.058037],
              [32.854996000000142, 46.058327],
              [32.878593000000137, 46.056931000000134],
              [32.965271, 46.049431],
              [32.971657, 46.048607000000118],
              [33.049164, 46.034157],
              [33.057487, 46.030266],
              [33.059433000000126, 46.027489],
              [33.060265, 46.023872],
              [33.05888, 46.020821],
              [33.056099000000131, 46.018044000000145],
              [33.04832, 46.014435000000105],
              [33.040276000000119, 46.011375],
            ],
          ],
          [
            [
              [34.227486000000113, 46.061928],
              [34.197487, 46.060822],
              [34.191933, 46.062202],
              [34.18055, 46.06833],
              [34.168877, 46.07861],
              [34.161095000000103, 46.08665],
              [34.1586, 46.09304],
              [34.158043000000134, 46.100548],
              [34.1586, 46.104706000000135],
              [34.16137700000013, 46.113602],
              [34.16387, 46.116936],
              [34.220818000000122, 46.18499],
              [34.224152000000117, 46.187202],
              [34.229149, 46.187759000000142],
              [34.23471, 46.186646],
              [34.23972, 46.180817],
              [34.243317, 46.174706000000128],
              [34.263611, 46.135818],
              [34.264435, 46.132484],
              [34.264709, 46.128593],
              [34.259438, 46.08554],
              [34.25888, 46.081657],
              [34.2572100000001, 46.077766],
              [34.251389, 46.07194],
              [34.24054, 46.06554],
              [34.236649000000114, 46.06388],
              [34.227486000000113, 46.061928],
            ],
          ],
          [
            [
              [32.167763, 46.145821000000126],
              [32.168602, 46.143883],
              [32.088875, 46.162766],
              [32.049721, 46.171371],
              [31.96027400000014, 46.18971],
              [31.877769, 46.201653],
              [31.858330000000137, 46.204163000000108],
              [31.796387, 46.209435],
              [31.759438, 46.212212000000136],
              [31.727772, 46.216385],
              [31.688602000000117, 46.22499],
              [31.58416, 46.25332],
              [31.570271000000105, 46.258881],
              [31.559158, 46.265266000000111],
              [31.55305, 46.269981000000143],
              [31.542217, 46.28054],
              [31.524715, 46.303596],
              [31.5111, 46.324715],
              [31.506104000000107, 46.333878],
              [31.501106000000107, 46.351105],
              [31.5, 46.361931000000141],
              [31.501106000000107, 46.366653],
              [31.506943, 46.371933000000126],
              [31.511387, 46.373047],
              [31.51638800000012, 46.371651],
              [31.51833, 46.368599000000131],
              [31.524715, 46.356659],
              [31.529160000000104, 46.347481],
              [31.531384000000116, 46.340828],
              [31.533333, 46.32972],
              [31.53416, 46.314438],
              [31.536385, 46.30777],
              [31.551105, 46.2911],
              [31.55888, 46.28333],
              [31.575554, 46.271660000000111],
              [31.591385, 46.26361],
              [31.613331, 46.25443300000012],
              [31.62305, 46.251389000000131],
              [31.694157, 46.23304],
              [31.704716, 46.230537],
              [31.74305, 46.226089],
              [31.855553, 46.2161],
              [32.085258000000124, 46.176659],
              [32.095818, 46.174164],
              [32.128876000000105, 46.162491],
              [32.167763, 46.145821000000126],
            ],
          ],
          [
            [
              [33.417702000000133, 52.3554],
              [33.512772, 52.326942],
              [33.60166, 52.33194],
              [33.628601000000117, 52.34193],
              [33.68138, 52.357773],
              [33.69638, 52.361664000000133],
              [33.753052, 52.3686],
              [33.771378, 52.368881],
              [33.818329000000119, 52.366936],
              [33.830551, 52.364716],
              [33.83888, 52.36055],
              [34.056656, 52.20138500000013],
              [34.06916, 52.190826000000129],
              [34.09777, 52.151932],
              [34.10083, 52.145546000000138],
              [34.100273, 52.14138],
              [34.079437, 52.125549],
              [34.075829000000113, 52.116936000000123],
              [34.073051000000135, 52.060272],
              [34.074165000000107, 52.056938],
              [34.07972, 52.04361],
              [34.087494, 52.031380000000127],
              [34.129158000000132, 51.986107],
              [34.240547, 51.91138],
              [34.334991, 51.85777],
              [34.339714000000129, 51.85555],
              [34.38403, 51.843109],
              [34.419716000000108, 51.80888],
              [34.424713, 51.799438],
              [34.440544, 51.76721],
              [34.442764, 51.760551],
              [34.44249, 51.752495000000124],
              [34.438599, 51.739433000000133],
              [34.433327, 51.73276],
              [34.418884, 51.72388],
              [34.405548, 51.718597000000102],
              [34.390831000000105, 51.714996],
              [34.37971, 51.713608000000136],
              [34.255272, 51.7011],
              [34.197769000000108, 51.696655],
              [34.114716, 51.680824],
              [34.10555, 51.677773],
              [34.102776, 51.67444],
              [34.0991590000001, 51.6661],
              [34.098045000000127, 51.653877000000136],
              [34.1011, 51.647491],
              [34.10416, 51.644714000000135],
              [34.163048, 51.614716],
              [34.232208, 51.54999],
              [34.23416, 51.54666],
              [34.236107, 51.539993],
              [34.24305, 51.515549],
              [34.245544000000109, 51.50139],
              [34.246101, 51.49388],
              [34.240547, 51.436104],
              [34.23916, 51.427773000000116],
              [34.38221, 51.263611],
              [34.406937, 51.263611],
              [34.550545, 51.23333],
              [34.669991, 51.179436],
              [34.674713, 51.17749],
              [34.708603, 51.174164000000133],
              [34.734993, 51.172493],
              [34.766663, 51.171379000000115],
              [34.801102, 51.173607],
              [34.827217, 51.178047],
              [34.917770000000132, 51.197212],
              [34.922768000000133, 51.198601],
              [34.932213, 51.2061],
              [34.939430000000129, 51.215828],
              [34.947487, 51.219986],
              [34.958046000000138, 51.22221],
              [34.974991000000102, 51.223602],
              [35.07381, 51.221481],
              [35.079086000000132, 51.21982],
              [35.111305000000129, 51.209541],
              [35.11852, 51.2048190000001],
              [35.121582000000103, 51.19843],
              [35.124634, 51.18426],
              [35.124916, 51.180382],
              [35.124916, 51.176765],
              [35.119637000000125, 51.151764],
              [35.148804, 51.07676],
              [35.152695000000108, 51.070648],
              [35.160744000000136, 51.062309],
              [35.170753, 51.054802000000109],
              [35.185196, 51.048973000000103],
              [35.204926, 51.047577],
              [35.222145000000125, 51.04842],
              [35.244095000000129, 51.050911],
              [35.28521, 51.059235],
              [35.30188, 51.060616],
              [35.358559, 51.047546000000125],
              [35.368279000000143, 51.043938],
              [35.371887, 51.041435],
              [35.37661, 51.035606],
              [35.377724, 51.032257],
              [35.375504, 51.024483],
              [35.37022, 51.017822000000137],
              [35.358559, 51.01088],
              [35.344948000000102, 51.006439000000114],
              [35.309662, 50.982552],
              [35.305771000000107, 50.96033],
              [35.348831, 50.936432],
              [35.35578, 50.931709],
              [35.361336, 50.926147000000128],
              [35.365227, 50.920036],
              [35.456627, 50.772789000000103],
              [35.460243000000105, 50.766685],
              [35.463295, 50.756409],
              [35.486076, 50.678627],
              [35.420502000000113, 50.65335],
              [35.406883, 50.648643],
              [35.39883, 50.644753],
              [35.395775, 50.641975],
              [35.393555, 50.63808],
              [35.39271, 50.63392],
              [35.441055, 50.511971],
              [35.458282, 50.488068],
              [35.589149, 50.377769],
              [35.606651, 50.369438],
              [35.644714000000135, 50.354164],
              [35.67527, 50.347214],
              [35.687492, 50.346657],
              [35.693092, 50.347412],
              [35.73916, 50.383331],
              [35.747215, 50.387215],
              [35.820831000000112, 50.420830000000137],
              [35.834435, 50.425270000000125],
              [35.850273, 50.428604000000121],
              [35.865829, 50.430824000000143],
              [35.894157, 50.433327000000133],
              [35.92749, 50.435822000000144],
              [35.9786, 50.438324],
              [36.007774, 50.439156000000139],
              [36.059433, 50.43499],
              [36.09193, 50.431107000000111],
              [36.13916, 50.425270000000125],
              [36.145271, 50.423882],
              [36.154709000000139, 50.41999],
              [36.184715, 50.403603],
              [36.188324, 50.4011],
              [36.190269, 50.398048],
              [36.190269, 50.390549],
              [36.193878, 50.380547],
              [36.20527, 50.366104],
              [36.215828, 50.354996],
              [36.27388, 50.29805],
              [36.284439, 50.290833000000134],
              [36.297493, 50.284439],
              [36.302773, 50.282768],
              [36.321663000000115, 50.280273],
              [36.3325, 50.281380000000127],
              [36.34694, 50.285],
              [36.36055, 50.289436],
              [36.369156, 50.29277],
              [36.381104000000107, 50.298882],
              [36.419991, 50.313881],
              [36.47721, 50.301384],
              [36.553879, 50.280273],
              [36.558884, 50.278603],
              [36.563324, 50.276382000000126],
              [36.566101000000117, 50.273605],
              [36.566101000000117, 50.269989],
              [36.564156000000139, 50.265549000000135],
              [36.55777, 50.25999],
              [36.548882, 50.25055],
              [36.54666, 50.246658000000139],
              [36.54666, 50.23916],
              [36.550270000000125, 50.232765],
              [36.552773000000116, 50.229988],
              [36.55555, 50.227211],
              [36.562492000000134, 50.222488000000112],
              [36.571938000000102, 50.218597],
              [36.584991, 50.216103],
              [36.598877, 50.213882],
              [36.61805, 50.212212],
              [36.640274, 50.212494000000106],
              [36.649994, 50.214714],
              [36.65332, 50.217491],
              [36.662209, 50.23305],
              [36.667213, 50.240273000000116],
              [36.672768000000133, 50.246941000000106],
              [36.685822, 50.258049],
              [36.7011, 50.266937],
              [36.717491, 50.274712000000136],
              [36.810272, 50.314156],
              [36.88444, 50.335823000000119],
              [36.899162, 50.338882],
              [36.97332, 50.34888],
              [36.9786, 50.349434],
              [37.00722, 50.34888],
              [37.026382, 50.344994],
              [37.046387, 50.337494],
              [37.052773, 50.336937],
              [37.068886, 50.3386],
              [37.130547, 50.348328],
              [37.216934, 50.369713],
              [37.239716, 50.376938],
              [37.251663, 50.382767],
              [37.270828, 50.393883],
              [37.291107, 50.410545],
              [37.293884000000105, 50.413879],
              [37.311378, 50.426384],
              [37.315826000000129, 50.428047],
              [37.331665, 50.430275],
              [37.418602, 50.43804],
              [37.458603, 50.439713],
              [37.461937, 50.43721],
              [37.463608000000136, 50.433876],
              [37.649437, 50.18416],
              [37.73305, 50.087769],
              [37.744156, 50.080826],
              [37.753609, 50.07666],
              [37.793327, 50.06916],
              [37.823326000000122, 50.061661],
              [37.916664, 50.02916],
              [37.925270000000125, 50.024712],
              [37.928604000000121, 50.022217],
              [37.974991, 49.9761],
              [37.98832700000014, 49.96249],
              [38.01361, 49.934433],
              [38.02422300000012, 49.903084],
              [38.103607000000125, 49.938599000000124],
              [38.181107, 50.06221],
              [38.184158, 50.065544],
              [38.188324000000136, 50.06694],
              [38.19388, 50.0675],
              [38.301933, 50.073883],
              [38.30777, 50.073883],
              [38.320274, 50.071663],
              [38.32888, 50.067215],
              [38.33221, 50.06471],
              [38.33721, 50.059158],
              [38.34277, 50.04972],
              [38.34499, 50.043053],
              [38.350548000000117, 50.026382],
              [38.351936, 50.01944],
              [38.359161, 50.003609],
              [38.363327, 49.99777],
              [38.376099, 49.98749],
              [38.393051, 49.982491],
              [38.492767, 49.95361],
              [38.498878, 49.951935000000105],
              [38.515549, 49.951385],
              [38.54722, 49.954712],
              [38.58028, 49.963326],
              [38.595268, 49.96583],
              [38.614441000000113, 49.963882],
              [38.652214000000129, 49.958885000000123],
              [38.689156000000139, 49.93526],
              [38.825829, 49.88138],
              [38.866386, 49.874435],
              [38.88916, 49.86805],
              [38.897491000000116, 49.863609],
              [38.903320000000122, 49.85833],
              [38.905823000000112, 49.85555],
              [38.92083, 49.835548],
              [38.93277, 49.817772],
              [38.937767000000122, 49.812210000000107],
              [38.945267, 49.807495],
              [38.951660000000118, 49.806656],
              [38.963326000000109, 49.806656],
              [38.979431, 49.80777],
              [39.059433, 49.815544],
              [39.069160000000124, 49.817772],
              [39.07777, 49.820831],
              [39.084991000000116, 49.825554],
              [39.091934, 49.83111],
              [39.121933000000126, 49.856102000000135],
              [39.183739, 49.8804090000001],
              [39.19276, 49.877769],
              [39.2011, 49.873322],
              [39.207771, 49.868324],
              [39.21027400000014, 49.865547],
              [39.236938, 49.809158000000139],
              [39.241379, 49.796104],
              [39.24583, 49.778877],
              [39.25027, 49.769714],
              [39.258606, 49.76138],
              [39.273605, 49.751938000000109],
              [39.296387, 49.74388],
              [39.328606, 49.736938000000123],
              [39.35416, 49.732765],
              [39.365273, 49.733047],
              [39.375824000000136, 49.733879],
              [39.390549, 49.736938000000123],
              [39.408043, 49.743324],
              [39.41582, 49.74749],
              [39.43305, 49.754715],
              [39.45249200000012, 49.7586060000001],
              [39.464157, 49.758331],
              [39.476379, 49.756104],
              [39.580826, 49.73082],
              [39.58638, 49.725548],
              [39.58804, 49.722488],
              [39.595543, 49.706657],
              [39.613052, 49.668602000000135],
              [39.62249, 49.638603000000103],
              [39.625549, 49.632492],
              [39.63166, 49.623604],
              [39.639717000000132, 49.615547],
              [39.647217, 49.61055],
              [39.66137700000013, 49.604713],
              [39.796944, 49.55305],
              [39.809433, 49.55027],
              [39.821663000000115, 49.549438000000123],
              [39.859535, 49.551758],
              [39.89833, 49.559433],
              [39.921661, 49.565544000000102],
              [39.939156, 49.57166],
              [39.950829000000113, 49.578049],
              [39.957771, 49.583328],
              [39.969986000000119, 49.595825],
              [39.980270000000132, 49.603882],
              [39.991936000000123, 49.61027],
              [40.004997, 49.614441],
              [40.04277, 49.616661],
              [40.068329000000119, 49.613052],
              [40.139763, 49.601051],
              [40.148048000000131, 49.586655],
              [40.149994, 49.581108],
              [40.149994, 49.574165],
              [40.147774, 49.568886],
              [40.141106, 49.559158],
              [40.13138, 49.551659],
              [40.103607000000125, 49.542496],
              [40.08416, 49.534439],
              [40.07444, 49.526939],
              [40.062492000000134, 49.51388500000013],
              [40.055824000000143, 49.49749],
              [40.053322, 49.484993],
              [40.053047, 49.478325],
              [40.054161, 49.47193],
              [40.058044, 49.460823],
              [40.08888, 49.424713],
              [40.10972, 49.403877],
              [40.141663000000108, 49.376099000000124],
              [40.15638, 49.364998],
              [40.17083, 49.354996],
              [40.17388, 49.350273],
              [40.177773, 49.339157000000114],
              [40.179718, 49.32694],
              [40.168327, 49.254715],
              [40.166939000000127, 49.248604],
              [40.081741000000136, 49.18383],
              [40.054161, 49.174164],
              [40.008606, 49.15443],
              [39.997215, 49.148048],
              [39.986382000000106, 49.140549],
              [39.966385, 49.123878000000104],
              [39.951103, 49.107773],
              [39.94054, 49.093880000000127],
              [39.93832, 49.085548000000131],
              [39.93943, 49.078606],
              [39.945267, 49.066101000000117],
              [39.942215, 49.05777],
              [39.938881, 49.054993000000138],
              [39.92555, 49.050827],
              [39.909714000000122, 49.049721],
              [39.823326, 49.052216],
              [39.7075, 49.03666],
              [39.703323, 49.035271],
              [39.699158, 49.022766],
              [39.696655000000135, 49.010826],
              [39.693047, 48.979988],
              [39.694435000000112, 48.973045],
              [39.767212, 48.903877000000136],
              [39.777771, 48.899994],
              [39.790276, 48.896942000000138],
              [39.949997, 48.867493000000138],
              [40.01361, 48.889435],
              [40.021378, 48.89361],
              [40.030273, 48.8961],
              [40.041939, 48.89583],
              [40.054436, 48.89277],
              [40.064156000000139, 48.88888500000013],
              [40.070549, 48.88388],
              [40.075272, 48.878326],
              [40.07666, 48.874992000000134],
              [40.076942, 48.867767],
              [40.07666, 48.86416],
              [40.070831, 48.85083],
              [40.068329000000119, 48.847214],
              [40.05999, 48.836937],
              [40.039719, 48.82027],
              [40.025269, 48.810822],
              [40.017494, 48.806656],
              [39.86360900000011, 48.819992],
              [39.85027, 48.822495],
              [39.8316650000001, 48.824715],
              [39.826385, 48.82444],
              [39.812210000000107, 48.821381],
              [39.803879, 48.817772],
              [39.78277, 48.802773],
              [39.727211, 48.762215],
              [39.70416, 48.7186],
              [39.656937, 48.616661],
              [39.655548000000124, 48.608887],
              [39.6586, 48.602493],
              [39.66966200000013, 48.587639],
              [39.732491, 48.582497],
              [39.760551, 48.582497],
              [39.78138, 48.58416],
              [39.798882000000106, 48.583054000000118],
              [39.810272, 48.579720000000123],
              [39.81944, 48.575554],
              [39.843605, 48.562492],
              [39.85083, 48.557495000000131],
              [39.853325, 48.55471],
              [39.854713, 48.551659],
              [39.858047, 48.541382],
              [39.86721, 48.50388],
              [39.921516, 48.368393],
              [39.998878, 48.29722],
              [39.9488750000001, 48.220825],
              [39.932762, 48.213326],
              [39.91749, 48.198326],
              [39.903595000000109, 48.181664],
              [39.77609, 48.026382],
              [39.775261, 48.023048],
              [39.777481, 48.020271],
              [39.792488, 48.007217],
              [39.80749, 47.994431000000134],
              [39.812202, 47.988884],
              [39.81944, 47.973038],
              [39.819984, 47.969704],
              [39.81971, 47.96583],
              [39.806931000000134, 47.876656000000139],
              [39.805817, 47.87249],
              [39.803879, 47.86805],
              [39.796387, 47.857216],
              [39.781097000000102, 47.842209000000139],
              [39.768044000000145, 47.831383],
              [39.760544, 47.82721],
              [39.738884, 47.81998],
              [39.723877, 47.81833],
              [39.693604000000107, 47.82194],
              [39.674164000000133, 47.825554],
              [39.643044, 47.832764000000111],
              [39.610825, 47.838593000000117],
              [39.599152, 47.839432],
              [39.479706000000135, 47.839432],
              [39.432213, 47.831383],
              [39.422493, 47.829987],
              [39.411652, 47.829720000000123],
              [39.40609, 47.831383],
              [39.398041, 47.835815],
              [39.388596, 47.843323000000112],
              [39.38055, 47.847771],
              [39.36249, 47.851929],
              [39.345261, 47.853043],
              [39.262772, 47.853325],
              [39.24665, 47.852486000000113],
              [39.189156, 47.84304],
              [39.14666, 47.834717],
              [39.1363750000001, 47.833878],
              [39.123604, 47.835815],
              [39.11304, 47.839149],
              [39.03817, 47.8658],
              [38.924706, 47.868317000000104],
              [38.897217, 47.868317000000104],
              [38.871933, 47.86554],
              [38.862488, 47.863319000000104],
              [38.853600000000142, 47.86082],
              [38.838326, 47.85278],
              [38.82861, 47.8447],
              [38.81693300000012, 47.83221],
              [38.789986, 47.77887],
              [38.7711, 47.726646],
              [38.769707, 47.714989],
              [38.765831, 47.698601],
              [38.761658, 47.69026],
              [38.754715, 47.68555],
              [38.75054200000011, 47.683868000000132],
              [38.614716000000101, 47.640831000000105],
              [38.60582, 47.638039],
              [38.577492, 47.632484],
              [38.53721, 47.62804],
              [38.504990000000134, 47.626938],
              [38.488319000000104, 47.627213],
              [38.458878, 47.62943300000012],
              [38.44887, 47.62832],
              [38.36776, 47.613602000000128],
              [38.35833, 47.611382000000106],
              [38.349991, 47.60833],
              [38.33943, 47.601379],
              [38.303322, 47.55859],
              [38.29832, 47.551659],
              [38.280823000000112, 47.506104000000107],
              [38.223312000000135, 47.339989],
              [38.301102, 47.301102],
              [38.253876, 47.228043],
              [38.231377, 47.215546],
              [38.222755, 47.206383],
              [38.2161, 47.19471],
              [38.214432000000102, 47.190262],
              [38.214149000000134, 47.18277],
              [38.225548, 47.127762000000132],
              [38.235825, 47.109428],
              [38.136101, 47.059433],
              [38.131371, 47.064995000000124],
              [38.074432, 47.0947],
              [38.068329000000119, 47.095261],
              [37.896660000000111, 47.097214],
              [37.859711, 47.096931],
              [37.835815000000139, 47.092766],
              [37.801659, 47.081383],
              [37.770264, 47.073318],
              [37.751656000000139, 47.06971],
              [37.74138, 47.0686],
              [37.648331, 47.07499700000011],
              [37.60943, 47.085815],
              [37.574158, 47.088593],
              [37.563599, 47.088326],
              [37.554436, 47.086098],
              [37.5461, 47.082764],
              [37.538879, 47.078606],
              [37.459984000000134, 47.01110100000011],
              [37.3936, 46.949158],
              [37.32387, 46.895546000000138],
              [37.32304, 46.899155000000121],
              [37.320541, 46.901932],
              [37.316666, 46.90387],
              [37.26028, 46.929993],
              [37.250542, 46.933327],
              [37.239159, 46.934151],
              [37.205269, 46.928596],
              [37.188599, 46.922768],
              [37.078331000000105, 46.885262],
              [37.03951, 46.874023],
              [36.99305, 46.857491],
              [36.920273, 46.827766000000111],
              [36.913048, 46.82332],
              [36.875259, 46.796944],
              [36.86055, 46.784714000000122],
              [36.763878, 46.751099],
              [36.746941000000106, 46.763054000000125],
              [36.736382, 46.766106],
              [36.705826000000116, 46.772217000000126],
              [36.694427, 46.772758000000124],
              [36.613602, 46.775269],
              [36.52193, 46.754715],
              [36.50832, 46.751389],
              [36.416656, 46.72443],
              [36.395546, 46.717209],
              [36.37554, 46.708878],
              [36.357773, 46.697762],
              [36.351379, 46.692757],
              [36.241379, 46.631371],
              [36.236649, 46.636658],
              [36.216103, 46.658318],
              [36.213051000000121, 46.660812000000135],
              [36.199158, 46.666382],
              [36.187202, 46.6675],
              [36.06749, 46.670273],
              [35.907204, 46.651093000000117],
              [35.817772, 46.621094],
              [35.805817, 46.616096],
              [35.768044, 46.59693],
              [35.753052, 46.588875],
              [35.731934000000138, 46.575554000000125],
              [35.725548, 46.570541000000105],
              [35.699158, 46.544716000000108],
              [35.653313, 46.503876],
              [35.646378000000141, 46.499428],
              [35.628036, 46.48916],
              [35.582764, 46.472214],
              [35.557487, 46.463051],
              [35.539429, 46.458603],
              [35.525269, 46.456093],
              [35.51110100000011, 46.45471],
              [35.49416, 46.448868],
              [35.487206, 46.444427],
              [35.477768, 46.436646],
              [35.352219, 46.331657000000121],
              [35.281197, 46.25453],
              [35.205544, 46.163048000000117],
              [35.19942, 46.156937],
              [35.189980000000105, 46.14887],
              [35.174431, 46.136101],
              [35.163605, 46.129715],
              [35.15221, 46.124161000000129],
              [35.124428, 46.112488],
              [35.010544, 46.074715],
              [35.001656000000139, 46.072495],
              [34.989426, 46.07387],
              [34.985268, 46.075829],
              [34.979424, 46.0811],
              [34.979424, 46.084717],
              [34.980820000000108, 46.089149],
              [35.043877000000123, 46.136658000000125],
              [35.04749, 46.139153000000135],
              [35.059151, 46.14415],
              [35.06805, 46.14666],
              [35.109428, 46.15554],
              [35.141930000000116, 46.16221],
              [35.161652000000117, 46.164986],
              [35.179436, 46.169716000000108],
              [35.191093, 46.174988],
              [35.201378, 46.181664000000126],
              [35.20721, 46.187202],
              [35.248047, 46.23333],
              [35.267563000000109, 46.259811000000127],
              [35.279709, 46.268044],
              [35.286110000000122, 46.27304],
              [35.331657, 46.318604000000107],
              [35.336937, 46.324715],
              [35.347481, 46.3436],
              [35.34887700000013, 46.348038],
              [35.348595, 46.35193],
              [35.346931, 46.354996],
              [35.19804, 46.44331],
              [35.214706, 46.415543],
              [35.21666, 46.404984],
              [35.210815, 46.393326],
              [35.199997, 46.380814],
              [35.119713, 46.299431],
              [35.110764000000131, 46.294083],
              [35.060265, 46.262215],
              [35.053040000000124, 46.258041],
              [35.038048000000117, 46.251656],
              [35.029709, 46.248604000000114],
              [34.812485, 46.181374000000119],
              [34.702492, 46.175819],
              [34.630272, 46.100548],
              [34.633324, 46.082764],
              [34.6322100000001, 46.074715],
              [34.630272, 46.070824],
              [34.587494000000106, 46.00499],
              [34.577766, 45.991379000000109],
              [34.571106, 45.986931000000141],
              [34.561661000000129, 45.98499],
              [34.546387, 45.983597000000145],
              [34.535271000000137, 45.983871],
              [34.501938000000109, 45.986649],
              [34.414986000000113, 46.00054200000011],
              [34.40942, 46.00194],
              [34.40277, 46.00665],
              [34.401649, 46.013878],
              [34.40221, 46.017769000000101],
              [34.40416, 46.02166],
              [34.441376000000105, 46.09388],
              [34.46243, 46.098209000000111],
              [34.480427, 46.11087],
              [34.48543, 46.112549],
              [34.48827, 46.112549],
              [34.508263000000113, 46.112213],
              [34.511269, 46.11121],
              [34.512932, 46.105049],
              [34.512600000000134, 46.102715],
              [34.530823, 46.096375],
              [34.534157, 46.089989000000116],
              [34.538048, 46.08777],
              [34.543877, 46.08665],
              [34.548607, 46.087212],
              [34.552483, 46.088875000000144],
              [34.55555, 46.09166],
              [34.563324, 46.101379],
              [34.56749, 46.108597],
              [34.570267, 46.121094],
              [34.575272, 46.148041],
              [34.57499700000011, 46.151649],
              [34.574158000000125, 46.154984000000127],
              [34.571663000000115, 46.158318],
              [34.552216000000101, 46.18027],
              [34.54665, 46.185265],
              [34.542496, 46.187485],
              [34.536652, 46.187759000000142],
              [34.532204, 46.186646],
              [34.526375, 46.180817],
              [34.480492, 46.16437900000011],
              [34.478992000000119, 46.16238],
              [34.477325, 46.16071],
              [34.471161, 46.15655],
              [34.46315, 46.15438],
              [34.45665, 46.154213],
              [34.452824, 46.154881000000103],
              [34.329430000000116, 46.170273],
              [34.242210000000114, 46.225548],
              [34.236931000000141, 46.23082],
              [34.206093, 46.25916],
              [34.189423, 46.271378],
              [34.177216, 46.27749],
              [34.161934, 46.28249],
              [34.15638, 46.2822],
              [34.152489, 46.28054],
              [34.127762, 46.206093],
              [34.116379, 46.166382000000112],
              [34.123871, 46.16193],
              [34.126381, 46.159157],
              [34.12915, 46.152771000000143],
              [34.13777, 46.125824],
              [34.137215, 46.12193],
              [34.13081, 46.116653],
              [34.125824000000136, 46.116096],
              [34.120827, 46.116653],
              [34.034157, 46.13221],
              [34.030823, 46.134438000000102],
              [33.997208, 46.165543000000127],
              [33.98888, 46.173607],
              [33.981102, 46.18971],
              [33.979149, 46.19638],
              [33.97304, 46.205269000000101],
              [33.966385, 46.209984000000134],
              [33.957207, 46.213608000000136],
              [33.779427000000112, 46.248047],
              [33.773598, 46.248322],
              [33.769440000000145, 46.248047],
              [33.681641, 46.221657],
              [33.671928, 46.220818],
              [33.669159, 46.21804],
              [33.669434, 46.214432000000102],
              [33.673607, 46.208603],
              [33.702209, 46.169159],
              [33.70916, 46.160812],
              [33.724152, 46.14833],
              [33.734993000000145, 46.141663],
              [33.7786, 46.119156],
              [33.78916, 46.1186],
              [33.793053, 46.120537000000127],
              [33.798882, 46.126099],
              [33.80138, 46.134163],
              [33.802773000000116, 46.146378],
              [33.80304, 46.158043],
              [33.80166, 46.16527],
              [33.802216, 46.173050000000103],
              [33.806099, 46.174988],
              [33.810822000000144, 46.173325],
              [33.844147, 46.161377],
              [33.847481, 46.159157],
              [33.884438, 46.075829],
              [33.885262, 46.07222],
              [33.884995000000117, 46.064438],
              [33.87915, 46.058884],
              [33.899994, 46.038605000000132],
              [33.957497, 46.017769000000101],
              [33.963051, 46.016388],
              [33.97387700000013, 46.016663000000108],
              [33.978325, 46.018044000000145],
              [33.98888, 46.024712],
              [33.99027, 46.02887],
              [33.994507, 46.068787],
              [33.994431, 46.069984],
              [33.991379, 46.072495],
              [33.979149, 46.074715],
              [33.956093, 46.075554],
              [33.94471, 46.078331000000105],
              [33.938881, 46.08332],
              [33.937759, 46.08665],
              [33.938881, 46.090271],
              [33.94082, 46.094147],
              [33.944153000000142, 46.096375],
              [33.952492, 46.099434],
              [33.962212, 46.100822000000107],
              [33.99027, 46.100548],
              [34.002213, 46.099709],
              [34.006653, 46.098595],
              [34.02222, 46.090271],
              [34.114265000000103, 46.017605],
              [34.118317, 45.9786],
              [34.113319, 45.97777],
              [34.112206000000128, 45.974152],
              [34.114998, 45.96777],
              [34.11916, 45.96194],
              [34.13610100000011, 45.942490000000134],
              [34.142769000000101, 45.937759],
              [34.152206, 45.936371],
              [34.17054000000013, 45.939156000000139],
              [34.189156000000139, 45.943047],
              [34.197205, 45.94582400000013],
              [34.200829, 45.948318],
              [34.203049, 45.951653000000135],
              [34.204163, 45.959717000000126],
              [34.202766, 45.970818],
              [34.199715, 45.988319],
              [34.197762, 45.99527],
              [34.196648, 45.998047],
              [34.223652000000129, 46.006325],
              [34.219315000000108, 46.008987],
              [34.19249, 46.019817000000103],
              [34.179657, 46.030327],
              [34.176147, 46.033325],
              [34.175983, 46.035652],
              [34.17799, 46.036983],
              [34.185482, 46.036156],
              [34.34748100000013, 46.022758],
              [34.356377, 46.019150000000138],
              [34.364716000000101, 46.011375],
              [34.381653, 45.992210000000114],
              [34.41193, 45.955826],
              [34.4161, 45.950272],
              [34.41638, 45.946381],
              [34.414986000000113, 45.941933],
              [34.40554, 45.928596],
              [34.40221, 45.926102],
              [34.393883, 45.92332],
              [34.383041, 45.92305],
              [34.37915, 45.921371000000136],
              [34.373604, 45.9161],
              [34.35804000000013, 45.88777],
              [34.356934000000138, 45.884163000000115],
              [34.359428, 45.881371],
              [34.488884, 45.873604],
              [34.494713, 45.873322],
              [34.503052, 45.876099000000124],
              [34.568047, 45.915268],
              [34.571381, 45.917496000000142],
              [34.574158000000125, 45.920273],
              [34.576096, 45.924164000000133],
              [34.574158000000125, 45.931107000000111],
              [34.572495, 45.934151],
              [34.568329000000119, 45.939980000000105],
              [34.542496, 45.962494],
              [34.54166, 45.965828],
              [34.546097, 45.966927],
              [34.551926, 45.96666],
              [34.613884, 45.948318],
              [34.633324, 45.94165],
              [34.6363750000001, 45.939423],
              [34.638039000000106, 45.936104],
              [34.63833, 45.932487],
              [34.635262, 45.924706],
              [34.627213, 45.909424],
              [34.61304, 45.88777],
              [34.608330000000137, 45.881104],
              [34.60166, 45.875542],
              [34.58971, 45.870827],
              [34.54583, 45.842209],
              [34.462769, 45.776649],
              [34.459717000000126, 45.773598],
              [34.4586, 45.770264],
              [34.460541, 45.767212],
              [34.466385000000116, 45.76666],
              [34.649155, 45.785553000000107],
              [34.785271, 45.715828000000101],
              [34.913872, 45.662209],
              [34.986649000000114, 45.631927],
              [35.068329, 45.55388],
              [35.073044, 45.54832],
              [35.083321, 45.529984000000127],
              [35.085815000000139, 45.51971],
              [35.096931, 45.471375],
              [35.096375, 45.467209],
              [35.09193, 45.459984000000134],
              [35.089149000000134, 45.457207],
              [35.076096, 45.44776],
              [35.052483, 45.437759],
              [35.03943, 45.434433],
              [35.020264, 45.431374000000119],
              [35.01666, 45.42944],
              [35.013611, 45.426659],
              [35.011658, 45.422768],
              [35.011932, 45.41916],
              [35.053596, 45.36887],
              [35.063881, 45.361931000000141],
              [35.114441000000113, 45.3311],
              [35.126656, 45.326096],
              [35.133041, 45.32499700000011],
              [35.15221, 45.333603],
              [35.164429, 45.33804],
              [35.169716, 45.338326],
              [35.181931, 45.336655000000121],
              [35.338593000000117, 45.28611],
              [35.34304, 45.3325],
              [35.232201, 45.44305],
              [35.14693, 45.527489000000116],
              [35.093323, 45.57972],
              [35.08194, 45.589989],
              [35.058327, 45.606102],
              [35.05026, 45.613884],
              [35.002213, 45.671928],
              [34.98249, 45.697762000000125],
              [34.979149, 45.70387],
              [34.960381, 45.73988],
              [34.946381, 45.75417],
              [34.904209, 45.8131],
              [34.864876, 45.863434],
              [34.84871, 45.898106],
              [34.763054, 46.015549],
              [34.756653, 46.010544],
              [34.752495000000124, 46.009163],
              [34.747208, 46.009995000000117],
              [34.716927000000112, 46.030823],
              [34.700539, 46.046387],
              [34.666382000000112, 46.0811],
              [34.662209000000132, 46.086937],
              [34.664146, 46.090828000000101],
              [34.666939, 46.093597],
              [34.67083, 46.095261],
              [34.73082, 46.10804000000013],
              [34.736107, 46.108330000000137],
              [34.799480000000131, 46.087723],
              [34.820087, 46.07579],
              [34.827209, 46.06944],
              [34.853043000000127, 46.000832000000116],
              [34.864998, 45.962494],
              [34.90221, 45.883484],
              [34.939541, 45.819824],
              [34.979424, 45.753319],
              [34.981125000000134, 45.751442],
              [34.991096, 45.733330000000137],
              [35.053879000000109, 45.65387],
              [35.06582, 45.639992],
              [35.075829000000113, 45.62915],
              [35.249161, 45.44665],
              [35.311661, 45.383041000000105],
              [35.326935, 45.370827],
              [35.359711, 45.351105],
              [35.382767, 45.338593],
              [35.453873000000101, 45.300545],
              [35.461937, 45.296387],
              [35.475266, 45.291100000000142],
              [35.48555, 45.288048],
              [35.491936000000123, 45.286942],
              [35.503052, 45.286652],
              [35.54554000000013, 45.2930530000001],
              [35.688599000000124, 45.326096],
              [35.706093, 45.330826000000116],
              [35.863045, 45.404427],
              [35.886658, 45.39193],
              [35.93277, 45.37027],
              [35.946938000000102, 45.365273000000116],
              [35.963326, 45.361107],
              [35.987206, 45.35833],
              [35.998322000000144, 45.35804],
              [36.00861, 45.3586],
              [36.02166, 45.361931000000141],
              [36.035553, 45.371368],
              [36.04583, 45.384163],
              [36.056931, 45.402771],
              [36.062202, 45.414986],
              [36.06805, 45.425819],
              [36.070824, 45.428596],
              [36.074432000000115, 45.430817],
              [36.119713, 45.452492],
              [36.13554, 45.45916],
              [36.13971, 45.460541],
              [36.149994000000106, 45.461098000000106],
              [36.290833, 45.465271],
              [36.485268000000133, 45.441376],
              [36.59859, 45.423607000000118],
              [36.60582, 45.41916],
              [36.615273, 45.408043],
              [36.636375, 45.379715],
              [36.63721, 45.376099],
              [36.63721, 45.3536],
              [36.636658, 45.345818000000122],
              [36.631927, 45.338593],
              [36.62554200000011, 45.333603],
              [36.616936, 45.331383],
              [36.607216000000108, 45.330269],
              [36.579987000000131, 45.330826000000116],
              [36.569153, 45.33221],
              [36.549431, 45.338875000000144],
              [36.54554000000013, 45.341103],
              [36.539429, 45.342209000000139],
              [36.527771, 45.343323000000112],
              [36.506386, 45.34304],
              [36.497208, 45.34137],
              [36.489426, 45.33804],
              [36.48333, 45.33221],
              [36.43277, 45.275269],
              [36.429436, 45.266930000000116],
              [36.410538, 45.19971],
              [36.40527, 45.163605],
              [36.404709, 45.151932],
              [36.40554, 45.14471],
              [36.41193, 45.132484],
              [36.41805, 45.123871000000122],
              [36.436928, 45.101929],
              [36.44638, 45.094704],
              [36.456093, 45.084717],
              [36.456940000000145, 45.081100000000106],
              [36.456383, 45.077209],
              [36.454163, 45.07332],
              [36.451378, 45.070541],
              [36.43971, 45.065536],
              [36.23333, 45.006104],
              [36.223038, 45.00555],
              [36.140266, 45.018593000000124],
              [36.128593, 45.0211],
              [36.009163, 45.0113750000001],
              [36.004166000000112, 45.004715],
              [35.998322000000144, 44.999161],
              [35.991096, 44.99527],
              [35.981377, 44.994156],
              [35.856934, 44.986382],
              [35.844704, 44.988045000000113],
              [35.834717000000126, 44.991096],
              [35.829163000000108, 44.99638],
              [35.827236, 45.0],
              [35.817772, 45.017769],
              [35.805817, 45.031380000000127],
              [35.78888, 45.050545],
              [35.781937, 45.054993],
              [35.736931, 45.076935000000105],
              [35.71888, 45.08416],
              [35.677216, 45.10027],
              [35.64193, 45.111382000000106],
              [35.59304, 45.119156],
              [35.570267, 45.120537000000127],
              [35.554436, 45.120537000000127],
              [35.5336, 45.119713],
              [35.523872, 45.118317000000104],
              [35.515266000000111, 45.116096],
              [35.428879000000109, 45.074158],
              [35.41832, 45.068047],
              [35.406937, 45.05693],
              [35.399712, 45.046944],
              [35.39471, 45.034157],
              [35.249718000000144, 44.95609],
              [35.15054, 44.893044],
              [35.147217, 44.890831000000105],
              [35.138596000000121, 44.88248],
              [35.12915, 44.869431000000134],
              [35.123604000000114, 44.857773000000122],
              [35.12165, 44.849434],
              [35.113045, 44.824997],
              [35.10332, 44.806099000000131],
              [35.094994, 44.797211000000118],
              [35.088326000000109, 44.79276],
              [35.076378, 44.788048000000117],
              [35.07222, 44.786942000000124],
              [35.0611, 44.78721],
              [35.054993, 44.788322],
              [35.046097000000145, 44.791939],
              [35.035828, 44.802483],
              [35.004433, 44.830269],
              [34.99749, 44.834717],
              [34.987206, 44.837769],
              [34.964149, 44.83943],
              [34.73082, 44.811104],
              [34.717484, 44.807487],
              [34.518593, 44.744431],
              [34.46777, 44.72304],
              [34.45638300000013, 44.717766],
              [34.446938, 44.71054],
              [34.435547, 44.699158],
              [34.398598, 44.650826000000109],
              [34.376938, 44.621651],
              [34.359711, 44.593323],
              [34.339432000000102, 44.553322],
              [34.335258, 44.546097],
              [34.331940000000145, 44.543610000000115],
              [34.1375, 44.439156],
              [34.122765000000129, 44.431664000000126],
              [34.011658000000125, 44.395821],
              [33.955544, 44.381104000000107],
              [33.930275000000108, 44.37915],
              [33.85193, 44.397484],
              [33.84137, 44.398598],
              [33.83554, 44.398872],
              [33.826096, 44.397484],
              [33.802216, 44.388596],
              [33.788322000000107, 44.385818],
              [33.723595000000103, 44.390831],
              [33.711937, 44.393044],
              [33.707207, 44.394707],
              [33.699997, 44.398872],
              [33.623871000000122, 44.452209],
              [33.60166, 44.476372],
              [33.59158, 44.486359],
              [33.579720000000123, 44.49305],
              [33.57416, 44.49416],
              [33.568886, 44.493874],
              [33.552483, 44.488602000000128],
              [33.539162, 44.485268000000133],
              [33.535271000000137, 44.484993000000145],
              [33.524994, 44.487762],
              [33.465546000000131, 44.50972],
              [33.453606, 44.515831000000105],
              [33.39471, 44.553322],
              [33.37943300000012, 44.565819],
              [33.366936000000123, 44.579163],
              [33.365273, 44.58221],
              [33.366096, 44.585541],
              [33.368317, 44.589149],
              [33.373604, 44.589149],
              [33.37999, 44.588326],
              [33.464706, 44.603043000000127],
              [33.554436000000123, 44.623604],
              [33.538605000000132, 44.672493000000145],
              [33.51944, 44.77916],
              [33.51998, 44.783051],
              [33.52887, 44.796654],
              [33.540543, 44.825554],
              [33.544991, 44.832497000000103],
              [33.552773, 44.84137],
              [33.559433, 44.8461],
              [33.56749, 44.849152],
              [33.592766, 44.851105000000132],
              [33.600822000000107, 44.853882],
              [33.6036, 44.85693],
              [33.608597, 44.86916],
              [33.621368000000132, 44.908875],
              [33.622208, 44.920830000000137],
              [33.61998, 44.931374],
              [33.614441, 44.955826000000116],
              [33.61055, 44.969437],
              [33.571663000000115, 45.080269000000101],
              [33.566376, 45.089432000000102],
              [33.556374, 45.099991000000102],
              [33.550545, 45.105],
              [33.541939000000127, 45.111931],
              [33.513329000000113, 45.129433],
              [33.426102, 45.173325],
              [33.404709000000139, 45.183327],
              [33.3936, 45.185822],
              [33.381927, 45.186646],
              [33.366379, 45.185547],
              [33.35833, 45.182487],
              [33.338875, 45.174164],
              [33.285553000000107, 45.15527],
              [33.275551000000121, 45.15416],
              [33.25804, 45.15749],
              [33.177483, 45.189156],
              [33.173325, 45.191093000000137],
              [33.146378, 45.209435],
              [33.123047, 45.22914900000012],
              [33.07972, 45.263054],
              [33.06667, 45.272217],
              [33.011658000000125, 45.304436],
              [32.936928, 45.341927],
              [32.932213, 45.343597],
              [32.86998, 45.356659],
              [32.85804, 45.3586],
              [32.846375, 45.359428],
              [32.834717, 45.359993],
              [32.743317, 45.356659],
              [32.727486, 45.355820000000108],
              [32.723038, 45.354706],
              [32.715546000000131, 45.351105],
              [32.693314, 45.33971],
              [32.682487, 45.333321000000126],
              [32.675819, 45.328606],
              [32.665825, 45.316093],
              [32.662766, 45.313599],
              [32.654427, 45.31055],
              [32.643883, 45.310265],
              [32.577492, 45.317772],
              [32.562202, 45.321938000000102],
              [32.509720000000129, 45.33971],
              [32.481659, 45.39222],
              [32.480537, 45.395821],
              [32.491379000000109, 45.418877000000123],
              [32.49638, 45.42499],
              [32.5211, 45.451096000000121],
              [32.536385, 45.463875],
              [32.573875, 45.482491],
              [32.629990000000134, 45.509995],
              [32.834435, 45.604996],
              [32.898598, 45.642769000000101],
              [32.92526, 45.655266],
              [32.937202, 45.65998100000013],
              [33.022484, 45.68748],
              [33.18415, 45.738602],
              [33.22998, 45.74276],
              [33.23582, 45.742493000000138],
              [33.25861, 45.747765],
              [33.304436, 45.763611],
              [33.316376, 45.768326],
              [33.359154, 45.787491],
              [33.37387, 45.795273],
              [33.388039, 45.80526],
              [33.40054, 45.815536],
              [33.408875, 45.824158],
              [33.415543, 45.828873],
              [33.432487, 45.83443],
              [33.480537, 45.848038],
              [33.56582, 45.861664],
              [33.62305, 45.87748],
              [33.768044, 45.9186],
              [33.77193, 45.92054000000013],
              [33.77415, 45.923882],
              [33.773315, 45.927216],
              [33.768883, 45.933044],
              [33.758881, 45.939980000000105],
              [33.75, 45.943604000000107],
              [33.739426, 45.946381],
              [33.673882, 45.957207],
              [33.662491, 45.9575],
              [33.646378, 45.970818],
              [33.627213, 45.996651],
              [33.625542, 45.999718000000144],
              [33.628319, 46.064438],
              [33.622993000000122, 46.124016],
              [33.616653, 46.138039],
              [33.611382, 46.147217000000126],
              [33.606102, 46.152489],
              [33.59804, 46.156647],
              [33.587212, 46.1586],
              [33.582764, 46.157204],
              [33.52943, 46.119713],
              [33.526649000000134, 46.116936],
              [33.522484000000134, 46.109428],
              [33.522758, 46.105820000000108],
              [33.51082, 46.083878],
              [33.49527, 46.066376],
              [33.47443, 46.05304],
              [33.435265, 46.044716],
              [33.428879, 46.04554],
              [33.419159, 46.048882000000106],
              [33.38888, 46.07332],
              [33.386101, 46.08777],
              [33.381104, 46.09304],
              [33.377762, 46.095543000000134],
              [33.31582, 46.124428],
              [33.26915, 46.141663],
              [33.19249, 46.16193],
              [33.184708, 46.158318],
              [33.126938000000109, 46.131653],
              [33.122765, 46.130547],
              [32.910538, 46.111382],
              [32.900269, 46.11055],
              [32.89388300000013, 46.111382],
              [32.8461, 46.11998],
              [32.814995000000124, 46.128876],
              [32.808594, 46.129715],
              [32.774437, 46.129990000000134],
              [32.744713, 46.126099],
              [32.634438000000102, 46.109154000000103],
              [32.585541, 46.0961],
              [32.546944, 46.082764],
              [32.540833000000134, 46.077492],
              [32.537209000000132, 46.075829],
              [32.527206, 46.07416],
              [32.509438, 46.07499700000011],
              [32.491379000000109, 46.077492],
              [32.409981, 46.09166],
              [32.337494, 46.10804000000013],
              [32.267212, 46.125259],
              [32.26305, 46.127213],
              [32.26054, 46.129990000000134],
              [32.243317000000104, 46.173050000000103],
              [32.02721, 46.256386],
              [31.918661, 46.28383],
              [31.89444, 46.28611],
              [31.89333, 46.28249],
              [31.890553000000125, 46.279709000000139],
              [31.880829, 46.278046],
              [31.831104, 46.276932],
              [31.81916, 46.27749],
              [31.801659, 46.279984],
              [31.791943000000117, 46.283051000000114],
              [31.78833, 46.285271],
              [31.76805, 46.30304],
              [31.759438, 46.310822000000144],
              [31.76028, 46.314156000000139],
              [31.762497, 46.317772],
              [31.773331, 46.32387],
              [31.810555000000136, 46.33804],
              [31.81944, 46.341103],
              [31.844830000000115, 46.341934],
              [31.857996, 46.342602000000113],
              [31.876829, 46.340771000000132],
              [31.887493, 46.34027],
              [31.917213000000118, 46.340271000000143],
              [31.942772000000105, 46.34304],
              [31.96666, 46.347481],
              [31.98416, 46.352776],
              [32.055817000000104, 46.383041000000105],
              [32.059151, 46.385544],
              [32.061371000000122, 46.388878],
              [32.059151, 46.395821],
              [32.05526, 46.40165],
              [32.04805, 46.40998100000013],
              [32.015549, 46.44193300000012],
              [32.009995, 46.447205],
              [32.003876, 46.451096000000121],
              [31.998604000000114, 46.451935000000105],
              [31.96666, 46.453049],
              [31.816330000000107, 46.483017],
              [31.809715, 46.484993],
              [31.77833, 46.493317000000104],
              [31.766388, 46.493874],
              [31.716103, 46.49276],
              [31.71083, 46.492493000000138],
              [31.703323, 46.489716],
              [31.693886000000134, 46.481934],
              [31.658325, 46.471375],
              [31.602776, 46.503609],
              [31.532494, 46.55222],
              [31.521664, 46.562759000000142],
              [31.507771, 46.57972],
              [31.51083, 46.58138300000013],
              [31.515831, 46.57972],
              [31.523605, 46.575554000000125],
              [31.533333, 46.568329],
              [31.546661, 46.55526],
              [31.550274, 46.55304],
              [31.56277, 46.547211000000118],
              [31.57861, 46.54305],
              [31.596943, 46.540833],
              [31.620274, 46.540276000000119],
              [31.663326, 46.54305],
              [31.681934000000126, 46.547211000000118],
              [31.69055, 46.549988],
              [31.70055, 46.551384],
              [31.738049, 46.553879000000109],
              [31.748878, 46.554436],
              [31.760830000000112, 46.553879000000109],
              [31.766663, 46.552773],
              [31.837498, 46.529709],
              [31.852528, 46.522675],
              [31.896381, 46.51859],
              [32.092484000000127, 46.50972],
              [32.181107, 46.491379],
              [32.276649, 46.46859],
              [32.3197100000001, 46.461937],
              [32.33943, 46.45943],
              [32.35666, 46.458878],
              [32.415825, 46.48582],
              [32.422493, 46.49027],
              [32.424706, 46.493874],
              [32.422768, 46.496941000000106],
              [32.419434, 46.499161000000129],
              [32.410271, 46.502495000000124],
              [32.407494, 46.505272],
              [32.40582, 46.50832400000013],
              [32.40609, 46.512497],
              [32.410271, 46.525269],
              [32.412491000000102, 46.528603],
              [32.421654000000103, 46.536942000000124],
              [32.448723, 46.552299000000119],
              [32.490822, 46.575554000000125],
              [32.551384, 46.594704],
              [32.564438000000109, 46.59859],
              [32.589706, 46.60193],
              [32.60249, 46.606102],
              [32.609711, 46.61027],
              [32.619713, 46.617493],
              [32.64471, 46.63777],
              [32.647217, 46.64111],
              [32.64444, 46.643883],
              [32.640266, 46.645821],
              [32.634438000000102, 46.646103],
              [32.629990000000134, 46.644707],
              [32.518593000000124, 46.60833],
              [32.45609, 46.584717000000126],
              [32.421371000000136, 46.568329],
              [32.399994000000106, 46.561371],
              [32.375259, 46.557487],
              [32.342484, 46.556099000000131],
              [32.331657, 46.555817],
              [32.325829000000113, 46.556099000000131],
              [32.31332, 46.558037],
              [32.304153, 46.561661],
              [32.293877000000123, 46.568329],
              [32.28721, 46.573044],
              [32.274994, 46.582764],
              [32.255829000000119, 46.59748],
              [32.248322000000144, 46.601662],
              [32.236649000000114, 46.603043000000127],
              [32.231659, 46.60222],
              [32.184708, 46.580826],
              [32.1486, 46.561371],
              [32.144707, 46.559433000000126],
              [32.139153, 46.559151],
              [32.134995000000117, 46.561104],
              [32.01971, 46.62943300000012],
              [32.0075, 46.639153],
              [31.996658, 46.649712],
              [31.989433000000133, 46.658043000000134],
              [31.971378, 46.691933],
              [31.97027, 46.695267],
              [31.966415, 46.726807],
              [31.951103, 46.73776],
              [31.94638, 46.743607],
              [31.936661, 46.76221],
              [31.935268, 46.765831],
              [31.934441, 46.77693],
              [31.934441, 46.79276],
              [31.935268, 46.800819],
              [31.936378000000104, 46.80555],
              [31.941936, 46.816666],
              [31.951382, 46.824432000000115],
              [31.976105000000132, 46.840271],
              [31.98333, 46.84999],
              [31.99305, 46.868874],
              [32.008041, 46.904984000000127],
              [32.011932000000115, 46.922493],
              [32.01054, 46.92971],
              [31.98082, 47.0075],
              [31.839993000000106, 47.179710000000114],
              [31.75361, 47.251389000000131],
              [31.74943, 47.253319],
              [31.73555, 47.250000000000114],
              [31.729439, 47.244713],
              [31.724712, 47.237762],
              [31.723045000000127, 47.233871],
              [31.72193, 47.22914900000012],
              [31.722218000000112, 47.225548],
              [31.725552000000107, 47.219147000000135],
              [31.730824, 47.213875],
              [31.745544000000109, 47.204987],
              [31.764164, 47.19832],
              [31.789993, 47.19471],
              [31.807774, 47.18748],
              [31.813332, 47.182213],
              [31.81971, 47.17361],
              [31.870274, 47.08804],
              [31.871384, 47.084717],
              [31.871384, 47.076935],
              [31.86805, 47.069984],
              [31.845825, 47.04665],
              [31.838882, 47.036385000000109],
              [31.836105, 47.028046],
              [31.836384000000123, 47.016388],
              [31.840549000000124, 47.006653000000142],
              [31.844437, 47.000542],
              [31.90194, 46.927216],
              [31.908051, 46.92221],
              [31.918324, 46.919159],
              [31.929714000000104, 46.919159],
              [31.94305, 46.923050000000103],
              [31.950829000000113, 46.926941],
              [31.964436, 46.930275],
              [31.96944, 46.928596],
              [31.973045, 46.926384],
              [31.97499, 46.92332],
              [31.972218, 46.910271],
              [31.964161, 46.88999200000012],
              [31.94971500000014, 46.864441],
              [31.94249, 46.85471],
              [31.93971, 46.851662],
              [31.931934, 46.848038],
              [31.89333, 46.835258],
              [31.882496, 46.829163],
              [31.873882, 46.820541],
              [31.869442000000106, 46.813599000000124],
              [31.865551, 46.806099],
              [31.863331, 46.797211],
              [31.862774000000115, 46.79305],
              [31.863605000000121, 46.785553],
              [31.86694, 46.775551000000121],
              [31.87694, 46.764435],
              [31.89166, 46.755829],
              [31.899715, 46.747765],
              [31.90527, 46.738884],
              [31.908886, 46.7286],
              [31.913052000000107, 46.659981],
              [31.911942, 46.65554],
              [31.907494, 46.648872],
              [31.90083, 46.644150000000138],
              [31.893047, 46.640266000000111],
              [31.859715, 46.62832],
              [31.81472, 46.615822],
              [31.809158, 46.61554],
              [31.738884, 46.627213],
              [31.711941000000138, 46.638039],
              [31.691936000000112, 46.644150000000138],
              [31.653046, 46.653046],
              [31.641106, 46.6536],
              [31.621384, 46.650269],
              [31.612492, 46.64777400000014],
              [31.604443, 46.644440000000145],
              [31.601109000000122, 46.642220000000123],
              [31.594994, 46.636932000000115],
              [31.59055, 46.62943300000012],
              [31.586941, 46.616096],
              [31.582497, 46.609154],
              [31.57888, 46.607216],
              [31.57389, 46.60666],
              [31.567219, 46.607216],
              [31.481106000000125, 46.628593],
              [31.476936, 46.630547],
              [31.47416, 46.633324],
              [31.473045, 46.636658],
              [31.47333, 46.64083],
              [31.479439, 46.651649000000134],
              [31.48222, 46.654427000000112],
              [31.486107, 46.65638],
              [31.503609, 46.661652],
              [31.509720000000129, 46.666939],
              [31.51527, 46.672768],
              [31.550549, 46.71888],
              [31.598053, 46.789162],
              [31.59333, 46.804993],
              [31.520828000000108, 46.739983],
              [31.506386000000134, 46.720543],
              [31.503052000000139, 46.712494],
              [31.471378, 46.669991],
              [31.468601, 46.667206000000135],
              [31.423607, 46.627213],
              [31.415829, 46.623604000000114],
              [31.34528, 46.60222],
              [31.334991, 46.6011],
              [31.32249, 46.60222],
              [31.268055, 46.60804],
              [31.242767, 46.611664],
              [31.231934000000138, 46.614159],
              [31.189056000000107, 46.62455],
              [31.176941000000113, 46.625542],
              [31.1561, 46.623604000000114],
              [31.07333, 46.614441000000113],
              [31.053051, 46.611931],
              [31.0152700000001, 46.6036],
              [30.941105, 46.582497000000103],
              [30.832771, 46.548325],
              [30.779999, 46.481377],
              [30.79361, 46.44832],
              [30.79388, 46.44471],
              [30.7930530000001, 46.43998],
              [30.76722, 46.382484],
              [30.763054, 46.37554200000011],
              [30.659718, 46.258041],
              [30.651661, 46.249161],
              [30.509163, 46.096375],
              [30.251659, 45.876656],
              [30.240826, 45.87054],
              [30.163609, 45.82972],
              [30.14444, 45.820541],
              [30.06611, 45.799988],
              [30.060555000000136, 45.79972],
              [30.049721, 45.80999],
              [30.044994, 45.815536],
              [30.041103, 45.821663],
              [30.033604, 45.830269000000101],
              [30.027493, 45.834984000000134],
              [30.01833, 45.838326],
              [30.001942, 45.841927000000112],
              [29.983883, 45.844704],
              [29.978603, 45.84444],
              [29.969994, 45.84166],
              [29.929993000000138, 45.817772000000105],
              [29.804440000000113, 45.736931],
              [29.801105, 45.734711],
              [29.798607000000118, 45.731659],
              [29.7961, 45.723312],
              [29.79639, 45.715271],
              [29.797497000000135, 45.711937],
              [29.799721, 45.709160000000111],
              [29.821381, 45.688324],
              [29.824997, 45.686104],
              [29.834991, 45.68333],
              [29.85304600000012, 45.682213],
              [29.86166, 45.678596],
              [29.864159, 45.676102000000128],
              [29.865551, 45.672768000000133],
              [29.863605, 45.66916],
              [29.856663, 45.664986],
              [29.82277, 45.648331],
              [29.78416, 45.63055],
              [29.776108, 45.62721],
              [29.746941, 45.619431],
              [29.738323, 45.628593],
              [29.67999, 45.694427],
              [29.67944, 45.69804],
              [29.67666, 45.735268],
              [29.677773, 45.743874],
              [29.68305, 45.759438000000102],
              [29.684715, 45.76333],
              [29.689995000000124, 45.76915],
              [29.696106, 45.774155],
              [29.697773, 45.778046000000131],
              [29.697212, 45.781662],
              [29.68305, 45.802483],
              [29.679714, 45.804703],
              [29.641663, 45.821938],
              [29.637215, 45.822762],
              [29.6336060000001, 45.8211060000001],
              [29.63194, 45.81693],
              [29.596943, 45.687759],
              [29.595825000000104, 45.68333],
              [29.594719, 45.674706],
              [29.59277, 45.55888],
              [29.59333, 45.55526],
              [29.619164000000126, 45.487762],
              [29.674164000000133, 45.465546],
              [29.729439, 45.472214],
              [29.73444000000012, 45.471657],
              [29.738602, 45.469704],
              [29.752216, 45.452766000000111],
              [29.754166000000112, 45.449715],
              [29.75528, 45.44249],
              [29.760830000000112, 45.324432],
              [29.75999, 45.319984],
              [29.73333, 45.227768],
              [29.730549, 45.224709000000132],
              [29.70861, 45.213326000000109],
              [29.671383000000105, 45.209717000000126],
              [29.664993, 45.210541],
              [29.664331000000118, 45.211803],
              [29.67194, 45.268044],
              [29.672497, 45.276375],
              [29.67083, 45.28749],
              [29.667217, 45.30166],
              [29.654999, 45.327766],
              [29.644997, 45.3425],
              [29.636944, 45.350266],
              [29.603333000000134, 45.376938],
              [29.589439, 45.385544],
              [29.571938, 45.392487],
              [29.51833, 45.4086],
              [29.503326000000129, 45.412766],
              [29.411385, 45.435822],
              [29.324162000000115, 45.439156],
              [29.318886, 45.43889],
              [29.226109000000122, 45.426941000000113],
              [29.217216, 45.424721],
              [28.968052, 45.321106],
              [28.848610000000122, 45.30166],
              [28.79972, 45.240822],
              [28.799622000000113, 45.237656],
              [28.79722, 45.234711],
              [28.785275, 45.229996],
              [28.706657000000121, 45.219986000000119],
              [28.700846, 45.219986000000119],
              [28.695932, 45.219986000000119],
              [28.69471, 45.219986000000119],
              [28.688328, 45.220818],
              [28.57471, 45.24276],
              [28.375828, 45.300545],
              [28.343327000000102, 45.315536000000122],
              [28.330830000000105, 45.32499700000011],
              [28.316666, 45.337494000000106],
              [28.311939, 45.34304],
              [28.310799, 45.344677],
              [28.303608, 45.354996000000142],
              [28.29472, 45.37027],
              [28.287777, 45.382767],
              [28.285275000000127, 45.389435],
              [28.283886000000109, 45.396935],
              [28.283926, 45.398788],
              [28.28416, 45.409424000000115],
              [28.28499, 45.413872],
              [28.283886000000109, 45.421371],
              [28.281109, 45.428040000000124],
              [28.27916, 45.430817],
              [28.27277400000014, 45.435547],
              [28.229324, 45.449207],
              [28.2186, 45.449997],
              [28.21484, 45.448647],
              [28.214718, 45.461372],
              [28.216103, 45.465546],
              [28.226662, 45.48749],
              [28.238049, 45.503319],
              [28.243607, 45.508881],
              [28.25027, 45.513329],
              [28.25805, 45.51721],
              [28.275, 45.52304],
              [28.283886000000109, 45.525269],
              [28.293884000000105, 45.526649],
              [28.316383, 45.527489000000116],
              [28.345551, 45.52304],
              [28.366383, 45.517769],
              [28.394157, 45.51249700000011],
              [28.404995, 45.511101],
              [28.477489, 45.506386],
              [28.488602000000128, 45.506653],
              [28.50333, 45.509163000000115],
              [28.511944, 45.511932],
              [28.522774, 45.517769],
              [28.525272, 45.520821000000126],
              [28.530552, 45.531662],
              [28.530273, 45.641930000000116],
              [28.528332, 45.644707],
              [28.525555, 45.647484000000134],
              [28.51499600000011, 45.65387],
              [28.492214, 45.661934],
              [28.489433000000133, 45.664986],
              [28.490551, 45.6680530000001],
              [28.52444, 45.711098],
              [28.583607000000143, 45.763054000000125],
              [28.594994, 45.768593000000124],
              [28.604713000000118, 45.770264],
              [28.654995, 45.772484],
              [28.671104000000128, 45.773872],
              [28.675274, 45.775269],
              [28.682774, 45.779160000000104],
              [28.688885000000141, 45.784157],
              [28.762497, 45.84748100000013],
              [28.7686, 45.862762],
              [28.76888700000012, 45.866936000000123],
              [28.766937, 45.87416],
              [28.75528, 45.912491000000102],
              [28.751389, 45.922768],
              [28.747768000000121, 45.929153],
              [28.747494, 45.94109],
              [28.749435, 45.950272],
              [28.753326000000129, 45.957207],
              [28.755833, 45.959984],
              [28.759438000000102, 45.96194],
              [28.772221000000116, 45.966385000000116],
              [28.801105, 45.972481],
              [28.829437, 45.978325],
              [28.896664000000101, 45.990540000000124],
              [28.955547, 46.00054200000011],
              [28.968884000000116, 46.004166000000112],
              [28.97193, 46.00665],
              [28.976662, 46.013054],
              [29.040276, 46.18942],
              [29.041103, 46.193871000000115],
              [29.04055, 46.197762],
              [29.038609000000122, 46.201096],
              [29.025826000000109, 46.213875],
              [29.017494000000113, 46.221375000000137],
              [28.949997, 46.289429],
              [28.93193, 46.419991],
              [28.93222, 46.428322],
              [28.935825, 46.435822],
              [28.969437, 46.46387],
              [28.98333, 46.472481],
              [28.994434, 46.478325],
              [29.034718, 46.49527],
              [29.0430530000001, 46.49805],
              [29.173882, 46.539719],
              [29.203297, 46.54497],
              [29.21944, 46.532761],
              [29.223328, 46.522484],
              [29.22499, 46.51137],
              [29.22833, 46.484711],
              [29.226379, 46.416939000000127],
              [29.224712, 46.413048],
              [29.218052, 46.403046000000131],
              [29.210274, 46.39415],
              [29.204990000000123, 46.388329000000113],
              [29.202496, 46.385262],
              [29.200829000000113, 46.381371000000115],
              [29.201382, 46.37748],
              [29.204990000000123, 46.37109],
              [29.212769, 46.367203],
              [29.2241590000001, 46.365273],
              [29.229713, 46.365540000000124],
              [29.238323, 46.368317],
              [29.303326, 46.399712000000136],
              [29.306664, 46.402206],
              [29.309158000000139, 46.405266],
              [29.310272000000111, 46.409714],
              [29.309158000000139, 46.417206],
              [29.305832000000123, 46.427483],
              [29.303326, 46.43415],
              [29.350826, 46.469986],
              [29.478329, 46.491936],
              [29.489716, 46.49221],
              [29.495544, 46.491096],
              [29.503326000000129, 46.487206],
              [29.506104000000107, 46.484428],
              [29.5075, 46.481102],
              [29.508053, 46.47749],
              [29.506943, 46.47304],
              [29.49416, 46.452492],
              [29.491657, 46.444153000000142],
              [29.492214, 46.440262],
              [29.499718, 46.432213],
              [29.59777, 46.378593000000137],
              [29.60638, 46.374985],
              [29.620831, 46.37027],
              [29.626659000000132, 46.369156],
              [29.639164, 46.368317],
              [29.64777400000014, 46.37109],
              [29.662212000000125, 46.379433],
              [29.73305, 46.439423],
              [29.73582, 46.44249],
              [29.82527, 46.368599000000131],
              [29.86638, 46.346375],
              [29.91305, 46.378876000000105],
              [29.920273, 46.381927000000132],
              [29.929993000000138, 46.38361],
              [29.966660000000104, 46.379715],
              [29.99638, 46.378876000000105],
              [30.048607, 46.378876000000105],
              [30.093052, 46.38055],
              [30.10389, 46.381927000000132],
              [30.11694, 46.386101],
              [30.122215, 46.39193],
              [30.128609, 46.402206],
              [30.131048, 46.407284000000118],
              [30.132214, 46.409714],
              [30.13323, 46.416901],
              [30.123955, 46.424332],
              [30.109158, 46.428596],
              [30.10249, 46.429436000000123],
              [30.090549, 46.42971],
              [30.06583, 46.435265000000129],
              [30.035275000000127, 46.443047],
              [30.00694, 46.456650000000138],
              [29.928608000000111, 46.505272],
              [29.906937, 46.52222],
              [29.898602, 46.529984000000127],
              [29.89611, 46.536942000000124],
              [29.89611, 46.551659],
              [29.90547, 46.555149],
              [29.916386000000102, 46.559151],
              [29.921383, 46.55999],
              [29.95499, 46.561104],
              [29.959435, 46.562485],
              [29.962769, 46.564995],
              [29.967495, 46.57138],
              [29.968884000000116, 46.575272],
              [29.972771, 46.734428],
              [29.970551, 46.749428000000137],
              [29.949997, 46.814156],
              [29.94721, 46.816666],
              [29.939995, 46.8211060000001],
              [29.880276, 46.855],
              [29.868881000000101, 46.861382000000106],
              [29.85944, 46.864441],
              [29.737492, 46.890266],
              [29.575554000000125, 46.94305],
              [29.5736, 46.946091000000138],
              [29.573887, 46.950272],
              [29.591660000000104, 47.021103],
              [29.59333, 47.025269],
              [29.57138, 47.140831],
              [29.573048, 47.144707],
              [29.600269, 47.267769],
              [29.600552, 47.27193],
              [29.600269, 47.279709000000139],
              [29.595825000000104, 47.29694400000011],
              [29.590549, 47.310265],
              [29.57888000000014, 47.328606],
              [29.57111, 47.336655],
              [29.563885, 47.341103],
              [29.55416, 47.344437],
              [29.51722, 47.346657],
              [29.500832, 47.345543],
              [29.496384, 47.344147],
              [29.49305, 47.341660000000104],
              [29.48999, 47.3336],
              [29.49027, 47.321663],
              [29.487217, 47.308037],
              [29.481663, 47.297211],
              [29.478882, 47.294159],
              [29.466385, 47.289429],
              [29.428326, 47.28611],
              [29.416386, 47.288322000000107],
              [29.405552, 47.29499],
              [29.38361, 47.315819],
              [29.378052000000139, 47.325272],
              [29.377495, 47.328873000000101],
              [29.381939, 47.346375000000137],
              [29.38166, 47.354439],
              [29.38028, 47.357773],
              [29.35889, 47.37832],
              [29.299438, 47.422211],
              [29.2525, 47.455269],
              [29.248878, 47.4575],
              [29.243607, 47.458878],
              [29.23749, 47.458603],
              [29.233047, 47.45721],
              [29.225552, 47.453316],
              [29.220268, 47.447487],
              [29.213326000000109, 47.43748],
              [29.204437, 47.434708],
              [29.198879, 47.43415],
              [29.19305, 47.435265000000129],
              [29.186661, 47.43998],
              [29.184441, 47.443047],
              [29.146664, 47.503609],
              [29.139164, 47.519981],
              [29.134995, 47.529984],
              [29.132496, 47.536942],
              [29.131386, 47.544159],
              [29.131386, 47.548325],
              [29.135548, 47.55526],
              [29.140831, 47.561371],
              [29.156937, 47.579163000000108],
              [29.163326, 47.58416],
              [29.19277, 47.606102],
              [29.198048, 47.612206],
              [29.25666, 47.760544],
              [29.258053000000132, 47.76443],
              [29.258327, 47.768593],
              [29.25694, 47.771935],
              [29.17805, 47.95192],
              [29.173050000000103, 47.957481],
              [29.152218, 47.97914900000012],
              [29.149441000000138, 47.981644000000131],
              [29.141937, 47.986092],
              [29.13583, 47.987206],
              [29.111938, 47.987206],
              [29.09499, 47.985817000000111],
              [29.080547000000138, 47.98276],
              [29.073605, 47.97831],
              [29.070827, 47.975258],
              [29.068604, 47.971642],
              [29.066936, 47.962761],
              [29.063885000000141, 47.954697],
              [29.059715, 47.947762],
              [29.054165, 47.941643],
              [29.047215, 47.937485],
              [29.038883, 47.933861],
              [29.022774, 47.932198],
              [29.01028, 47.93248],
              [28.98999, 47.934418000000107],
              [28.975269000000139, 47.93942],
              [28.967213, 47.943314],
              [28.9561, 47.949982],
              [28.90777, 47.982201],
              [28.893047000000138, 47.994980000000112],
              [28.882217, 48.005554000000132],
              [28.88083, 48.00944],
              [28.87981, 48.010452],
              [28.83166, 48.10527],
              [28.824997, 48.114159],
              [28.811943, 48.123604],
              [28.80278, 48.12721],
              [28.737495000000138, 48.138603],
              [28.642494000000113, 48.153603],
              [28.567219, 48.163048],
              [28.560829, 48.163048],
              [28.551388, 48.160545000000127],
              [28.501942, 48.134163],
              [28.436661, 48.145828000000108],
              [28.388607, 48.163879],
              [28.364441, 48.185822],
              [28.370552, 48.19609800000012],
              [28.373886, 48.20916],
              [28.373329, 48.21721],
              [28.369164, 48.227211000000125],
              [28.365551, 48.233604],
              [28.363331, 48.236382000000106],
              [28.356663, 48.241104],
              [28.35194, 48.24305],
              [28.345276, 48.243607],
              [28.339718, 48.24305],
              [28.294998, 48.238045],
              [28.28611, 48.234718],
              [28.259998, 48.220543000000134],
              [28.238049, 48.207497],
              [28.2336, 48.206100000000106],
              [28.2225, 48.205269000000101],
              [28.203606, 48.207771],
              [28.09444, 48.22943],
              [28.089165, 48.23082],
              [28.086109000000135, 48.233330000000137],
              [28.082497, 48.239433],
              [28.08194, 48.24332],
              [28.086384000000123, 48.260551],
              [28.094162, 48.274994],
              [28.096664, 48.288605],
              [28.095276, 48.296104],
              [28.088608000000136, 48.304993],
              [28.085552, 48.307495],
              [28.08194, 48.30971],
              [28.06611, 48.313606],
              [28.014721, 48.316666000000112],
              [27.963051, 48.324997],
              [27.948605, 48.32972],
              [27.932217, 48.337494],
              [27.912773, 48.348045000000127],
              [27.893608, 48.361382],
              [27.888329, 48.366936000000123],
              [27.88388, 48.37276],
              [27.876663, 48.389435000000105],
              [27.869995000000131, 48.398331],
              [27.862495, 48.402771],
              [27.77083, 48.44777],
              [27.755554, 48.451385],
              [27.547218, 48.468323000000112],
              [27.51952, 48.465500000000134],
              [27.454163000000108, 48.439713],
              [27.244995000000131, 48.36888],
              [27.233883, 48.36777],
              [26.981106000000125, 48.357773000000122],
              [26.808331, 48.333054],
              [26.720829, 48.329163000000108],
              [26.711662, 48.34083],
              [26.703049, 48.344711000000132],
              [26.698883, 48.343048],
              [26.695549, 48.340546000000131],
              [26.654442, 48.303604000000121],
              [26.648884, 48.298050000000103],
              [26.643051, 48.287498],
              [26.636383, 48.272217],
              [26.635935000000131, 48.26736],
              [26.63499, 48.257164000000103],
              [26.567776, 48.22249],
              [26.534721000000104, 48.208603],
              [26.52972, 48.207497],
              [26.524166, 48.20805],
              [26.51583, 48.211662],
              [26.499161, 48.215271],
              [26.474716, 48.217766],
              [26.463051000000121, 48.21721],
              [26.314907, 48.186165],
              [26.315552, 48.179436000000123],
              [26.317116, 48.176022000000103],
              [26.3186070000001, 48.17277],
              [26.3225, 48.16666],
              [26.3225, 48.16249],
              [26.272221, 48.076103000000103],
              [26.197773, 48.00444],
              [26.194717, 48.001663],
              [26.183601, 47.995537],
              [26.167213, 47.988312000000121],
              [26.149998, 47.982201],
              [26.114998, 47.981361],
              [26.102711, 47.981716],
              [26.037216, 47.983597],
              [25.922215, 47.974709000000132],
              [25.843327, 47.96443],
              [25.833328, 47.962494],
              [25.817219, 47.955269],
              [25.791943, 47.940262000000132],
              [25.78333, 47.937202],
              [25.77333, 47.93499],
              [25.646107000000143, 47.93359],
              [25.588608, 47.934433000000126],
              [25.56833, 47.935822],
              [25.525, 47.934708000000114],
              [25.501659000000132, 47.933327],
              [25.34166, 47.91805],
              [25.3261, 47.91527],
              [25.254993, 47.89193],
              [25.237774000000115, 47.88554],
              [25.23027, 47.881371],
              [25.218601, 47.870827000000133],
              [25.17944, 47.829987],
              [25.17083, 47.816666],
              [25.161659, 47.798882000000106],
              [25.15694, 47.792763],
              [25.148331, 47.784431],
              [25.123882, 47.763878],
              [25.109997000000135, 47.75499],
              [25.085548000000131, 47.744431],
              [25.049438, 47.73333],
              [25.029716, 47.728867],
              [24.99950600000011, 47.724461],
              [24.968887000000109, 47.722221],
              [24.953609, 47.719444],
              [24.928917, 47.713142],
              [24.919441, 47.71166],
              [24.90667, 47.712776000000133],
              [24.901386, 47.714165],
              [24.894444, 47.718605000000139],
              [24.891941, 47.721382],
              [24.863331, 47.759995000000117],
              [24.8325, 47.797493000000145],
              [24.822777, 47.80805],
              [24.816387, 47.813049],
              [24.812775000000101, 47.814995],
              [24.802776, 47.817772],
              [24.77027500000014, 47.820549000000142],
              [24.723888, 47.8361],
              [24.71, 47.84111],
              [24.693886000000134, 47.84916],
              [24.676109, 47.860275000000115],
              [24.670555, 47.865555],
              [24.66889, 47.868889],
              [24.66805, 47.872498],
              [24.66861, 47.87722],
              [24.67333, 47.888329],
              [24.673885, 47.892776],
              [24.672775, 47.89666],
              [24.66805, 47.902222],
              [24.620831000000123, 47.93055],
              [24.609997, 47.93694],
              [24.588333, 47.945831000000112],
              [24.572289, 47.949478],
              [24.556389, 47.953049000000135],
              [24.45389, 47.958611],
              [24.433331000000123, 47.959717],
              [24.427776, 47.95916],
              [24.412498000000141, 47.956108],
              [24.32694, 47.92889],
              [24.24972, 47.90416],
              [24.244164, 47.903610000000128],
              [24.136944, 47.909996],
              [24.1311070000001, 47.91083],
              [24.125553000000139, 47.911942000000124],
              [24.11639, 47.915276],
              [24.109444, 47.919716000000108],
              [24.096386, 47.93361],
              [24.089443, 47.93805],
              [24.038055, 47.954994000000113],
              [24.026665, 47.95694],
              [23.969719, 47.961388],
              [23.823887000000127, 47.966942000000131],
              [23.566097, 47.999992],
              [23.514267000000132, 47.989338],
              [23.512218, 47.985832],
              [23.509163, 47.98333],
              [23.497776, 47.978333000000134],
              [23.487499, 47.97722],
              [23.480553, 47.977493],
              [23.410275, 48.000549],
              [23.356106, 48.021103],
              [23.307220000000143, 48.03999],
              [23.299442, 48.043884],
              [23.296108, 48.046387],
              [23.293610000000115, 48.049164000000133],
              [23.281387, 48.07222],
              [23.276943, 48.078331],
              [23.265, 48.088326],
              [23.256386, 48.091934],
              [23.180275000000108, 48.108047000000113],
              [23.16805, 48.108604],
              [23.15694, 48.107216000000108],
              [23.147774, 48.104164],
              [23.129719, 48.093605000000139],
              [23.123886, 48.088326],
              [23.11916, 48.08194],
              [23.114162, 48.07111],
              [23.110828, 48.054436],
              [23.104717000000107, 48.039719],
              [23.09972, 48.028877],
              [23.091106000000138, 48.015831000000105],
              [23.084442000000138, 48.01111],
              [23.043331000000137, 47.99305],
              [22.929996, 47.960548000000131],
              [22.896111000000133, 47.953888],
              [22.8948, 47.95454],
              [22.859165000000132, 47.993889],
              [22.88111, 48.02166],
              [22.886662, 48.03194],
              [22.88694, 48.036659],
              [22.886108, 48.04028],
              [22.882496, 48.04694400000011],
              [22.879997, 48.049721],
              [22.85083, 48.079994],
              [22.84646400000014, 48.083221],
              [22.84444, 48.08472],
              [22.797497, 48.11472],
              [22.79361, 48.116661],
              [22.788052, 48.117767],
              [22.78194, 48.117493],
              [22.737774, 48.114441],
              [22.697216, 48.101387000000102],
              [22.680828000000133, 48.094154000000117],
              [22.67055, 48.09222],
              [22.650551, 48.093323],
              [22.643522, 48.09531],
              [22.630289, 48.09905],
              [22.621151, 48.10164],
              [22.611532, 48.108433000000105],
              [22.604996, 48.11305],
              [22.602497, 48.115829],
              [22.601940000000127, 48.128601],
              [22.598331000000144, 48.14388300000013],
              [22.597218, 48.147774],
              [22.574718, 48.18721],
              [22.507774, 48.24527],
              [22.504444, 48.24749],
              [22.5, 48.249355],
              [22.495827000000133, 48.251106000000107],
              [22.489716, 48.251663],
              [22.484718, 48.250549],
              [22.454716000000133, 48.243607],
              [22.383331000000112, 48.244156],
              [22.37861, 48.245544],
              [22.347775, 48.274994],
              [22.270275, 48.359993000000145],
              [22.269444, 48.396942],
              [22.27111, 48.400543],
              [22.271385, 48.40416],
              [22.268887, 48.407211],
              [22.228882, 48.416939],
              [22.217216, 48.418602],
              [22.20555, 48.417770000000132],
              [22.17171500000012, 48.40905800000013],
              [22.15144, 48.411919],
              [22.156105, 48.56805],
              [22.157219000000111, 48.57666],
              [22.158886, 48.58027600000014],
              [22.166939, 48.588043],
              [22.17361, 48.592766],
              [22.235271, 48.624710000000107],
              [22.323608, 48.681107000000111],
              [22.32888400000013, 48.686935],
              [22.33111, 48.68999],
              [22.387497, 48.79361],
              [22.389164, 48.7972180000001],
              [22.389164, 48.804993],
              [22.424995, 48.889435],
              [22.461384000000123, 48.94943],
              [22.529163, 48.991661],
              [22.534164, 48.99305],
              [22.53722, 48.995544],
              [22.538887000000102, 48.99916],
              [22.55166, 49.039436],
              [22.558052, 49.079437],
              [22.562775, 49.084991],
              [22.574165000000107, 49.090828],
              [22.585552, 49.09249],
              [22.594929, 49.09145],
              [22.598053, 49.091103],
              [22.737774, 49.047218],
              [22.85166, 49.00471],
              [22.856384, 49.00333],
              [22.868885, 49.001938],
              [22.875275000000101, 49.002220000000136],
              [22.886074000000121, 49.00291],
              [22.868328000000133, 49.028877],
              [22.864162, 49.038605],
              [22.86138, 49.045547],
              [22.861956000000134, 49.05011],
              [22.863052, 49.058884],
              [22.876106000000107, 49.083054],
              [22.877773, 49.086655],
              [22.876106000000107, 49.089989],
              [22.85278, 49.105827],
              [22.77805, 49.15054],
              [22.70916, 49.163048],
              [22.706659, 49.163048],
              [22.703606, 49.163048],
              [22.700272, 49.165543],
              [22.699997, 49.169716],
              [22.700829, 49.173607000000118],
              [22.704994, 49.18055],
              [22.726662, 49.217766],
              [22.754719, 49.2711],
              [22.759998, 49.281937],
              [22.76028, 49.295273],
              [22.739437, 49.386658],
              [22.738327, 49.390274],
              [22.736382, 49.393608],
              [22.73041, 49.400532],
              [22.729439, 49.401657],
              [22.694439000000102, 49.450829],
              [22.656105, 49.519714000000135],
              [22.655273, 49.528046000000131],
              [22.658051, 49.535828],
              [22.676105, 49.566383],
              [22.680828000000133, 49.572495],
              [22.686068, 49.57709],
              [22.717216000000121, 49.604439],
              [22.779999, 49.674995],
              [23.110828, 49.954994],
              [23.146107, 49.983047],
              [23.223606, 50.04333],
              [23.232773, 50.049995],
              [23.303608, 50.10083],
              [23.32444, 50.115273],
              [23.341942, 50.126938000000109],
              [23.342823, 50.127491],
              [23.37833, 50.149719000000118],
              [23.496105, 50.220825],
              [23.540276, 50.24278],
              [23.568886, 50.255829],
              [23.591106, 50.269157],
              [23.676941, 50.32444],
              [23.683416, 50.330395],
              [23.684994, 50.333328],
              [23.686253, 50.337929],
              [23.69318, 50.36325],
              [23.693886000000134, 50.36583],
              [23.69749, 50.37305],
              [23.70388400000013, 50.37833],
              [23.707771, 50.380547],
              [23.712259000000131, 50.382137],
              [23.721107, 50.385269],
              [23.729225, 50.387413],
              [23.755833, 50.39444],
              [23.791943, 50.402489000000116],
              [23.814442, 50.405823000000112],
              [23.846943000000124, 50.406654000000117],
              [23.881496, 50.405411000000129],
              [23.92944, 50.403603],
              [23.97472, 50.404709000000139],
              [23.991661, 50.407211],
              [23.999439, 50.41166],
              [24.004997, 50.417213],
              [24.111385, 50.56694],
              [24.108414, 50.625900000000115],
              [24.10722, 50.63361],
              [24.07222, 50.695824],
              [24.014721000000122, 50.73999],
              [23.957218, 50.78416],
              [23.954716, 50.787216],
              [23.952496, 50.794716],
              [23.953115, 50.800724],
              [23.953327, 50.802773000000116],
              [23.95694, 50.814995000000124],
              [23.95888, 50.818604000000107],
              [23.964439, 50.82444],
              [23.972771000000137, 50.82805],
              [23.989162, 50.83111],
              [24.020113, 50.831722000000127],
              [24.023678000000132, 50.831783],
              [24.052498000000128, 50.831383],
              [24.076942, 50.829437],
              [24.114719, 50.831383],
              [24.13055, 50.834991],
              [24.134441, 50.83694],
              [24.14444, 50.84943],
              [24.144718, 50.858047000000113],
              [24.14222, 50.861107],
              [24.092773, 50.881104],
              [24.087776000000133, 50.882767],
              [24.06438, 50.887001],
              [24.058609, 50.888046000000145],
              [24.043888, 50.892769000000101],
              [24.035553, 50.896942],
              [24.028885, 50.901657000000114],
              [23.988327, 50.931107],
              [23.966385, 50.948875],
              [23.963882, 50.951935],
              [23.931665, 50.994072],
              [23.905552, 51.066666000000112],
              [23.904442, 51.069443],
              [23.811108, 51.168884],
              [23.756664, 51.199432],
              [23.731937, 51.214714],
              [23.68388, 51.2886],
              [23.680275, 51.367493000000138],
              [23.682217, 51.371101],
              [23.692493, 51.399994],
              [23.69305, 51.404709],
              [23.658607, 51.4786],
              [23.656887, 51.480968],
              [23.654163, 51.484718],
              [23.642494, 51.486938000000123],
              [23.641417000000104, 51.486938000000123],
              [23.62861, 51.486938000000123],
              [23.624754, 51.48822],
              [23.623608, 51.4886],
              [23.616665, 51.493607],
              [23.614, 51.49675],
              [23.611107, 51.503326],
              [23.60463, 51.527695],
              [23.636383000000137, 51.518883],
              [23.64222, 51.518600000000106],
              [23.64611, 51.520828],
              [23.647495000000106, 51.534439],
              [23.647217, 51.538605000000132],
              [23.631664000000114, 51.573051],
              [23.623886, 51.58638],
              [23.621384, 51.589157],
              [23.611107, 51.596382],
              [23.609161, 51.599716],
              [23.60805, 51.603325],
              [23.608608, 51.60805],
              [23.612217000000101, 51.615273000000116],
              [23.614719, 51.618324000000143],
              [23.621109, 51.623604],
              [23.641384, 51.63361],
              [23.650551, 51.63694],
              [23.666664, 51.640549000000135],
              [23.741661000000136, 51.651382000000126],
              [23.75361, 51.652489],
              [23.76833, 51.65193],
              [23.896664, 51.63583],
              [23.902218, 51.634438],
              [23.910828, 51.63055],
              [23.920273, 51.622765],
              [23.92555, 51.616936],
              [23.931938, 51.607498],
              [23.937496, 51.597771],
              [23.940273000000104, 51.590828],
              [23.943886, 51.588326],
              [23.953884, 51.584991000000116],
              [23.973049, 51.586105],
              [23.98888, 51.589714],
              [24.0075, 51.5961],
              [24.043053, 51.610275000000115],
              [24.070553, 51.624992],
              [24.279442, 51.73777],
              [24.28611, 51.74305],
              [24.288609, 51.746101],
              [24.296108, 51.760551],
              [24.298607, 51.7686],
              [24.304718, 51.794159],
              [24.307499000000121, 51.811935],
              [24.313332000000116, 51.82249],
              [24.31583, 51.825554000000125],
              [24.37944, 51.879158000000132],
              [24.391384, 51.885551],
              [24.396664000000101, 51.886658],
              [24.409439, 51.887497],
              [24.700272, 51.893883],
              [24.74055, 51.889717],
              [24.89138400000013, 51.899994],
              [24.903606, 51.901382],
              [24.99194, 51.911934],
              [25.051941, 51.932213],
              [25.093609, 51.94221],
              [25.166664, 51.958885],
              [25.17944, 51.959717],
              [25.237774000000115, 51.960274],
              [25.24416, 51.95943],
              [25.26166, 51.955826000000116],
              [25.277496, 51.951385],
              [25.312218, 51.939713],
              [25.343052000000114, 51.930275],
              [25.361107, 51.926941],
              [25.439995, 51.9222180000001],
              [25.54583, 51.921379000000115],
              [25.546673000000112, 51.922134],
              [25.56277, 51.919991],
              [25.598331, 51.918884000000105],
              [25.676105, 51.921936],
              [25.695827000000122, 51.922768000000133],
              [25.72583, 51.925552],
              [25.74138, 51.929161],
              [25.765, 51.937210000000107],
              [25.775829000000101, 51.939156],
              [25.818329, 51.935822],
              [26.026943, 51.910271000000137],
              [26.139439, 51.88221],
              [26.149441, 51.87471],
              [26.169994, 51.864441000000113],
              [26.180828000000133, 51.861382],
              [26.207771, 51.85833],
              [26.290276, 51.85332],
              [26.30305, 51.853882000000112],
              [26.338608000000136, 51.857498000000135],
              [26.364162, 51.85889],
              [26.423050000000103, 51.85833],
              [26.436939, 51.856941],
              [26.441105, 51.854713000000118],
              [26.43805, 51.832497000000103],
              [26.43805, 51.824165000000107],
              [26.43916, 51.820549],
              [26.444717000000139, 51.814995],
              [26.457218000000125, 51.812767000000122],
              [26.498604000000114, 51.811935],
              [26.53083, 51.813324],
              [26.57111, 51.818329],
              [26.608051000000103, 51.82111],
              [26.63499, 51.82111],
              [26.649719, 51.820274],
              [26.672497000000135, 51.814995],
              [26.722496, 51.80249],
              [26.772499, 51.78583],
              [26.82083, 51.772491000000116],
              [26.894997, 51.755554000000132],
              [26.919716, 51.75111],
              [26.933331000000123, 51.749718],
              [26.948051, 51.748878],
              [26.971107, 51.752220000000136],
              [27.001663, 51.765],
              [27.01722, 51.7686],
              [27.029163, 51.76944],
              [27.08083, 51.771103],
              [27.160275, 51.765549],
              [27.179718, 51.762772],
              [27.19694, 51.758888],
              [27.200829, 51.756660000000124],
              [27.20583, 51.74666],
              [27.206661, 51.74305],
              [27.20583, 51.721657],
              [27.203327, 51.713326],
              [27.199162, 51.686378],
              [27.19833, 51.673607000000118],
              [27.199997, 51.67027],
              [27.273052, 51.602776000000119],
              [27.279442000000131, 51.597771],
              [27.285275000000127, 51.596382],
              [27.292496, 51.595825],
              [27.41666, 51.597488000000112],
              [27.445549, 51.601105],
              [27.460827000000108, 51.604439],
              [27.511971000000131, 51.628868],
              [27.597218000000112, 51.615829],
              [27.687218, 51.601387000000102],
              [27.711662, 51.596657000000107],
              [27.719715, 51.592491],
              [27.725273, 51.58694],
              [27.727772, 51.583878],
              [27.72916, 51.580551],
              [27.72916, 51.576385],
              [27.728329, 51.571938000000102],
              [27.724716000000114, 51.564438],
              [27.709759000000133, 51.550507],
              [27.679996, 51.494438],
              [27.683331, 51.491936000000123],
              [27.74138, 51.466660000000104],
              [27.746941000000106, 51.465546000000131],
              [27.751663, 51.466934],
              [27.811665, 51.524712],
              [27.817497000000117, 51.530548000000124],
              [27.818886000000134, 51.534721000000104],
              [27.819164, 51.5430530000001],
              [27.81778, 51.558601],
              [27.81694, 51.562492000000134],
              [27.812218000000144, 51.572495],
              [27.809998000000121, 51.57972],
              [27.811665, 51.5886],
              [27.816109, 51.595825],
              [27.825275, 51.604164],
              [27.838886, 51.61416],
              [27.851387, 51.62027],
              [27.86082800000014, 51.623322000000144],
              [27.866940000000113, 51.623604],
              [27.88472, 51.619987],
              [27.895828, 51.61305],
              [27.912773, 51.60083],
              [27.922497, 51.593048],
              [27.933605, 51.58638],
              [27.95527, 51.57499700000011],
              [27.975273000000129, 51.567772],
              [27.992218, 51.56388],
              [28.00611, 51.562210000000107],
              [28.069996, 51.56388],
              [28.088051, 51.564995000000124],
              [28.104443, 51.568054],
              [28.11388, 51.570831],
              [28.134995, 51.580276],
              [28.141384, 51.585823],
              [28.157497, 51.609993],
              [28.172497, 51.629433],
              [28.178329, 51.635551000000135],
              [28.188606, 51.643051],
              [28.21333, 51.654991000000109],
              [28.218052, 51.656380000000127],
              [28.239162000000135, 51.660545000000127],
              [28.25861, 51.661102],
              [28.263332, 51.659157],
              [28.265831, 51.656380000000127],
              [28.319443, 51.589157],
              [28.433331, 51.566101],
              [28.460827, 51.576103000000103],
              [28.475552, 51.57972],
              [28.487217000000101, 51.58111],
              [28.493885, 51.58111],
              [28.622498000000121, 51.568329000000119],
              [28.62722, 51.566383],
              [28.63055, 51.56388],
              [28.63277, 51.56082],
              [28.6336060000001, 51.557213],
              [28.633053, 51.544716],
              [28.631939, 51.540276],
              [28.632496000000117, 51.532211],
              [28.63611, 51.51361],
              [28.638329000000113, 51.506386],
              [28.651386, 51.468048],
              [28.654442000000131, 51.46138],
              [28.660553, 51.451935],
              [28.672497, 51.441376000000105],
              [28.740551, 51.413322],
              [28.745274, 51.41166],
              [28.752499, 51.411102],
              [28.757221000000129, 51.412491],
              [28.765, 51.416939],
              [28.765831, 51.421379],
              [28.769444, 51.448044],
              [28.76194, 51.468880000000127],
              [28.762497, 51.477211],
              [28.766109000000142, 51.484718],
              [28.773609, 51.494713],
              [28.79305, 51.51611],
              [28.810555, 51.534439],
              [28.828609, 51.546387],
              [28.845276000000126, 51.554161],
              [29.052498, 51.631104],
              [29.07249800000011, 51.636383],
              [29.08333, 51.638329000000113],
              [29.09, 51.638603],
              [29.11805, 51.63694],
              [29.16083, 51.628601000000117],
              [29.16555, 51.626938],
              [29.18138, 51.61805],
              [29.239716000000101, 51.544159],
              [29.243328, 51.537773],
              [29.25027, 51.51277],
              [29.250832, 51.504715],
              [29.248604000000114, 51.495827],
              [29.300831, 51.399719],
              [29.309998, 51.387772],
              [29.313053, 51.384995],
              [29.324165, 51.378044],
              [29.33916, 51.37305],
              [29.345276, 51.37332],
              [29.353836, 51.375320000000102],
              [29.409718, 51.402771000000143],
              [29.621662, 51.48999],
              [29.626385, 51.491379],
              [29.669716, 51.498878],
              [29.681938, 51.499718],
              [29.709160000000111, 51.498604000000114],
              [29.717773, 51.494438],
              [29.72222, 51.4886],
              [29.72666, 51.482491],
              [29.73193700000013, 51.472763],
              [29.73333, 51.469437],
              [29.73444000000012, 51.46194],
              [29.737217, 51.45527],
              [29.739437, 51.452217],
              [29.744995, 51.446655],
              [29.759163, 51.441101000000117],
              [29.76638800000012, 51.44054],
              [29.834442, 51.441933],
              [29.881664000000114, 51.459717000000126],
              [29.91166, 51.472763],
              [29.98333, 51.486382],
              [30.012218, 51.489159],
              [30.0430530000001, 51.490273],
              [30.14249, 51.493324],
              [30.161942, 51.493324],
              [30.176384, 51.491936000000123],
              [30.1836, 51.491104],
              [30.20055, 51.486656],
              [30.213882, 51.48082],
              [30.344162, 51.40749],
              [30.348053000000107, 51.40527],
              [30.348606, 51.401382],
              [30.34972, 51.386108],
              [30.350273, 51.358330000000137],
              [30.464718000000119, 51.294998000000135],
              [30.551414, 51.251846],
              [30.566109, 51.294998000000135],
              [30.568054, 51.299164],
              [30.570831000000112, 51.30193],
              [30.611107000000118, 51.322495],
              [30.62055, 51.32527],
              [30.641048000000126, 51.32962],
              [30.644161000000111, 51.332771],
              [30.643887, 51.366936],
              [30.643608, 51.370827000000133],
              [30.586384, 51.489159],
              [30.55389, 51.541939],
              [30.564999, 51.643326],
              [30.623608, 51.70444],
              [30.62833, 51.71138],
              [30.66833, 51.792221],
              [30.669994, 51.796387],
              [30.668053, 51.803322],
              [30.661385, 51.812492],
              [30.660275, 51.815826],
              [30.660553, 51.819992],
              [30.662216000000114, 51.823883],
              [30.665272, 51.826942],
              [30.746941, 51.895271],
              [30.825, 51.947487],
              [30.896942000000138, 51.97777],
              [30.958885, 52.000832],
              [30.930492, 52.030083000000104],
              [30.93074, 52.034355],
              [30.934162, 52.060272],
              [30.93583, 52.063324000000136],
              [30.943096000000139, 52.07379200000014],
              [30.958328000000108, 52.07972],
              [30.963051, 52.081108],
              [30.974163, 52.082771],
              [31.106384, 52.08638],
              [31.132217000000139, 52.08638],
              [31.291386000000102, 52.082771],
              [31.30110900000011, 52.0911],
              [31.323887, 52.104996],
              [31.341106, 52.112495],
              [31.35083, 52.115],
              [31.361942000000113, 52.116661],
              [31.379719, 52.11805],
              [31.422497, 52.11999],
              [31.502777, 52.117493],
              [31.523609, 52.116386],
              [31.622219, 52.108887],
              [31.73472, 52.106102],
              [31.783886000000109, 52.108047],
              [31.818886, 52.111382000000106],
              [31.8316650000001, 52.111382000000106],
              [31.846386, 52.1097180000001],
              [31.865829000000133, 52.106102],
              [31.88805, 52.099998],
              [31.897774, 52.0961],
              [31.905273, 52.09166],
              [31.908886, 52.084991],
              [31.908886, 52.06944],
              [31.995827, 52.054436],
              [32.112213, 52.043327],
              [32.124435, 52.043884],
              [32.129158000000132, 52.045273],
              [32.224991000000102, 52.07944],
              [32.287216, 52.102776],
              [32.299164, 52.109436],
              [32.303047, 52.112213000000111],
              [32.335548000000131, 52.157211],
              [32.336937, 52.16166],
              [32.335548000000131, 52.165268],
              [32.332771, 52.16777],
              [32.328331, 52.173882],
              [32.328049000000135, 52.177773000000116],
              [32.35833, 52.30999],
              [32.360275, 52.314156],
              [32.36805, 52.32444],
              [32.371101000000124, 52.327217000000132],
              [32.38416, 52.33277],
              [32.394157, 52.335266],
              [32.413322000000107, 52.335548],
              [32.527214, 52.32444],
              [32.55249, 52.319992],
              [32.58443, 52.309715],
              [32.608887, 52.300545],
              [32.63916, 52.289436000000137],
              [32.700829000000113, 52.268326],
              [32.73166, 52.261383],
              [32.7586060000001, 52.257774],
              [32.909988, 52.248047],
              [32.923607000000118, 52.24721],
              [32.941658000000132, 52.25388],
              [32.971931, 52.272766],
              [33.038048, 52.305824],
              [33.195267, 52.37638],
              [33.20471, 52.379715],
              [33.211380000000133, 52.379158],
              [33.378601, 52.364998000000128],
              [33.414612, 52.355888],
              [33.417702000000133, 52.3554],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "SM",
        ISO2: "SM",
        ISO3: "SMR",
        UN: 674,
        NAME: "San Marino",
        AREA: 0,
        POP2005: 30214,
        REGION: 150,
        SUBREGION: 39,
        LON: 12.46,
        LAT: 43.942,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [12.415798, 43.957954],
            [12.450554, 43.979721],
            [12.453888, 43.981667],
            [12.4625, 43.984718],
            [12.471666, 43.986938],
            [12.492777, 43.989166],
            [12.505554, 43.988609],
            [12.509998, 43.986938],
            [12.510277, 43.982773],
            [12.511665, 43.943329],
            [12.510555, 43.939163],
            [12.496387, 43.923332],
            [12.494999, 43.914719],
            [12.487778, 43.90583],
            [12.474443, 43.897217],
            [12.464722, 43.895554],
            [12.459166, 43.896111],
            [12.416388, 43.904716],
            [12.412222, 43.906105],
            [12.407822, 43.913658],
            [12.403889, 43.926666],
            [12.404999, 43.948326],
            [12.408888, 43.954994],
            [12.415798, 43.957954],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "RB",
        ISO2: "RS",
        ISO3: "SRB",
        UN: 688,
        NAME: "Serbia",
        AREA: 0,
        POP2005: 9863026,
        REGION: 150,
        SUBREGION: 39,
        LON: 20.806,
        LAT: 44.032,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [20.071423, 42.560913],
            [20.105831, 42.642776],
            [20.106941, 42.64666],
            [20.10722, 42.654442],
            [20.101665, 42.659996],
            [20.094444, 42.664444],
            [20.07, 42.673882],
            [20.048611, 42.677773],
            [20.025276, 42.678886],
            [20.015274, 42.680832],
            [20.007774, 42.684441],
            [19.980274, 42.701385],
            [19.977497, 42.703888],
            [19.975277, 42.707497],
            [19.976944, 42.715271],
            [19.980274, 42.721939],
            [19.990833, 42.73333],
            [20.014999, 42.752495],
            [20.039444, 42.766106],
            [20.066666, 42.773048],
            [20.076664, 42.773888],
            [20.088608, 42.773605],
            [20.104443, 42.770271],
            [20.112778, 42.767494],
            [20.231941, 42.761108],
            [20.379444, 42.833328],
            [20.382774, 42.835548],
            [20.376942, 42.849159],
            [20.348888, 42.886383],
            [20.34333, 42.891106],
            [20.297497, 42.926384],
            [20.286942, 42.932495],
            [20.25972, 42.941666],
            [20.178333, 42.967499],
            [20.164165, 42.971107],
            [20.153053, 42.972221],
            [20.147499, 42.971664],
            [20.059719, 43.005554],
            [20.035831, 43.037216],
            [19.969719, 43.090553],
            [19.920277, 43.106384],
            [19.783607, 43.148048],
            [19.692497, 43.17083],
            [19.67083, 43.174438],
            [19.656666, 43.178055],
            [19.647778, 43.181664],
            [19.641941, 43.186104],
            [19.585831, 43.236107],
            [19.563332, 43.256386],
            [19.560276, 43.263329],
            [19.558609, 43.270271],
            [19.548332, 43.284996],
            [19.517776, 43.317215],
            [19.511944, 43.321938],
            [19.444164, 43.373604],
            [19.279442, 43.449715],
            [19.254719, 43.459999],
            [19.228809, 43.513214],
            [19.287498, 43.544167],
            [19.408607, 43.584442],
            [19.480553, 43.571388],
            [19.493889, 43.588051],
            [19.51083, 43.679718],
            [19.510277, 43.69194],
            [19.50972, 43.700272],
            [19.505554, 43.718887],
            [19.500832, 43.733887],
            [19.498333, 43.740273],
            [19.492775, 43.753609],
            [19.487499, 43.763329],
            [19.475277, 43.772774],
            [19.437496, 43.800278],
            [19.366943, 43.859444],
            [19.251221, 43.962379],
            [19.237019, 44.002831],
            [19.237019, 44.011009],
            [19.239441, 44.01416],
            [19.244335, 44.01445],
            [19.30674, 43.998528],
            [19.311108, 43.996941],
            [19.351498, 43.981743],
            [19.355274, 43.979721],
            [19.359722, 43.974159],
            [19.365833, 43.969162],
            [19.374165, 43.965553],
            [19.428532, 43.960655],
            [19.485275, 43.958885],
            [19.514175, 43.958076],
            [19.524502, 43.958939],
            [19.532249, 43.962379],
            [19.616173, 44.016602],
            [19.619442, 44.018883],
            [19.621765, 44.021767],
            [19.620476, 44.048454],
            [19.61972, 44.052216],
            [19.617031, 44.054909],
            [19.596943, 44.060272],
            [19.485832, 44.120277],
            [19.357952, 44.209412],
            [19.239998, 44.264999],
            [19.234867, 44.265358],
            [19.165833, 44.284439],
            [19.161705, 44.286011],
            [19.158054, 44.28833],
            [19.130276, 44.313889],
            [19.127705, 44.316574],
            [19.104443, 44.355827],
            [19.105553, 44.376663],
            [19.123402, 44.514542],
            [19.128136, 44.521423],
            [19.135883, 44.524864],
            [19.193981, 44.560158],
            [19.31361, 44.70472],
            [19.336109, 44.747215],
            [19.344612, 44.766304],
            [19.345833, 44.769165],
            [19.382774, 44.863052],
            [19.381622, 44.866577],
            [19.371387, 44.88916],
            [19.310276, 44.908607],
            [19.299442, 44.910271],
            [19.188053, 44.923332],
            [19.177219, 44.923607],
            [19.168053, 44.921387],
            [19.121109, 44.901382],
            [19.039719, 44.861382],
            [19.02861, 44.880272],
            [19.015831, 44.889442],
            [19.009441, 44.89444],
            [19.004719, 44.900276],
            [19.004444, 44.904442],
            [19.006107, 44.907776],
            [19.01083, 44.914162],
            [19.013611, 44.916664],
            [19.032497, 44.930832],
            [19.036663, 44.932495],
            [19.043053, 44.931664],
            [19.050831, 44.928055],
            [19.115555, 45.031944],
            [19.104164, 45.096664],
            [19.163609, 45.212219],
            [19.171108, 45.216385],
            [19.187496, 45.216942],
            [19.207331, 45.211662],
            [19.21833, 45.208332],
            [19.234997, 45.198883],
            [19.247219, 45.184715],
            [19.250832, 45.182777],
            [19.261665, 45.180275],
            [19.352497, 45.173332],
            [19.41111, 45.174995],
            [19.415833, 45.175827],
            [19.422775, 45.179993],
            [19.424442, 45.189163],
            [19.426109, 45.209999],
            [19.423885, 45.22583],
            [19.418331, 45.234718],
            [19.400093, 45.235832],
            [19.388962, 45.235748],
            [19.356667, 45.234161],
            [19.34446, 45.235001],
            [19.320339, 45.238365],
            [19.285004, 45.243408],
            [19.260521, 45.247429],
            [19.190205, 45.270332],
            [19.138611, 45.287498],
            [19.112499, 45.29805],
            [18.988609, 45.370827],
            [18.980324, 45.378624],
            [18.978054, 45.389717],
            [18.996387, 45.48333],
            [18.997711, 45.48745],
            [19.0, 45.490829],
            [19.010239, 45.497169],
            [19.020523, 45.498665],
            [19.030621, 45.495483],
            [19.0425, 45.489716],
            [19.051666, 45.486664],
            [19.057545, 45.48558],
            [19.073887, 45.486107],
            [19.087837, 45.489502],
            [19.094753, 45.493805],
            [19.0998, 45.499786],
            [19.101673, 45.508949],
            [19.099987, 45.515869],
            [19.095875, 45.521851],
            [19.024719, 45.561386],
            [19.020523, 45.562988],
            [19.014164, 45.563889],
            [19.003887, 45.562492],
            [18.999771, 45.561119],
            [18.996944, 45.558052],
            [18.973969, 45.541298],
            [18.965366, 45.538681],
            [18.955269, 45.537186],
            [18.942181, 45.538681],
            [18.933018, 45.541855],
            [18.925346, 45.547844],
            [18.904785, 45.567284],
            [18.902496, 45.570274],
            [18.900833, 45.577499],
            [18.907215, 45.613281],
            [18.909458, 45.620758],
            [18.912498, 45.623329],
            [18.933609, 45.625275],
            [18.939163, 45.630829],
            [18.960552, 45.65416],
            [18.968357, 45.663017],
            [18.969166, 45.667496],
            [18.969479, 45.671616],
            [18.958611, 45.77861],
            [18.957489, 45.781944],
            [18.955276, 45.784721],
            [18.924442, 45.811943],
            [18.908886, 45.819443],
            [18.90361, 45.820274],
            [18.889721, 45.824997],
            [18.883053, 45.828888],
            [18.833054, 45.873886],
            [18.831654, 45.877129],
            [18.81702, 45.912964],
            [18.835831, 45.91111],
            [18.858887, 45.91111],
            [18.995552, 45.952499],
            [19.006664, 45.963882],
            [19.012775, 45.968887],
            [19.080555, 46.01722],
            [19.087776, 46.021385],
            [19.096386, 46.024437],
            [19.107498, 46.025833],
            [19.119164, 46.024994],
            [19.123886, 46.023605],
            [19.130554, 46.019997],
            [19.136387, 46.014999],
            [19.148609, 45.991661],
            [19.151386, 45.988884],
            [19.155277, 45.987221],
            [19.16111, 45.986664],
            [19.281666, 45.988327],
            [19.286388, 45.989441],
            [19.460552, 46.074165],
            [19.46722, 46.078606],
            [19.511387, 46.111664],
            [19.517498, 46.116661],
            [19.518887, 46.120277],
            [19.517498, 46.123886],
            [19.506386, 46.134438],
            [19.504444, 46.137497],
            [19.505833, 46.141106],
            [19.50861, 46.143883],
            [19.559998, 46.171944],
            [19.570553, 46.173607],
            [19.660275, 46.181389],
            [19.672775, 46.180832],
            [19.70372, 46.176392],
            [19.74472, 46.162216],
            [19.842499, 46.149162],
            [19.845833, 46.151382],
            [19.850277, 46.152771],
            [19.859722, 46.155273],
            [19.961109, 46.17083],
            [20.112221, 46.167496],
            [20.118332, 46.166939],
            [20.200832, 46.151382],
            [20.20472, 46.149719],
            [20.257774, 46.11805],
            [20.261024, 46.114853],
            [20.306664, 46.076111],
            [20.321388, 46.063606],
            [20.352497, 46.027222],
            [20.353611, 46.023605],
            [20.352776, 46.010277],
            [20.355, 46.003052],
            [20.360832, 45.993332],
            [20.368332, 45.984993],
            [20.378052, 45.97805],
            [20.506386, 45.915833],
            [20.515553, 45.913055],
            [20.526665, 45.912216],
            [20.545555, 45.912498],
            [20.561943, 45.909996],
            [20.578888, 45.903328],
            [20.591663, 45.894165],
            [20.654999, 45.833885],
            [20.656944, 45.830826],
            [20.656944, 45.813049],
            [20.660553, 45.801941],
            [20.664165, 45.795555],
            [20.709999, 45.746109],
            [20.713333, 45.743889],
            [20.721664, 45.740555],
            [20.727497, 45.739998],
            [20.738609, 45.741104],
            [20.747776, 45.743607],
            [20.757774, 45.750275],
            [20.764164, 45.75972],
            [20.767498, 45.766663],
            [20.773052, 45.771942],
            [20.776943, 45.773605],
            [20.782776, 45.773888],
            [20.788055, 45.773048],
            [20.79583, 45.769165],
            [20.801388, 45.76416],
            [20.804443, 45.757217],
            [20.804722, 45.744164],
            [20.798885, 45.656662],
            [20.796108, 45.649437],
            [20.780552, 45.637497],
            [20.772499, 45.629166],
            [20.76833, 45.622772],
            [20.766941, 45.619164],
            [20.766666, 45.609993],
            [20.76833, 45.602219],
            [20.794167, 45.507774],
            [20.808331, 45.478882],
            [20.986664, 45.345833],
            [21.048885, 45.316383],
            [21.267498, 45.232773],
            [21.276386, 45.229721],
            [21.351387, 45.217773],
            [21.404999, 45.21611],
            [21.416664, 45.214722],
            [21.47337, 45.187447],
            [21.482777, 45.183609],
            [21.513611, 45.151108],
            [21.515274, 45.147774],
            [21.516109, 45.139717],
            [21.514164, 45.126938],
            [21.512775, 45.123329],
            [21.443054, 45.053604],
            [21.381943, 45.023331],
            [21.372776, 45.020828],
            [21.369442, 45.018608],
            [21.367222, 45.015549],
            [21.366943, 45.008331],
            [21.371109, 45.00222],
            [21.37611, 44.996666],
            [21.405552, 44.973328],
            [21.408886, 44.971107],
            [21.429722, 44.961662],
            [21.441109, 44.960274],
            [21.459164, 44.964439],
            [21.470833, 44.963051],
            [21.475555, 44.961662],
            [21.527775, 44.94416],
            [21.540833, 44.938606],
            [21.546944, 44.933884],
            [21.551388, 44.928055],
            [21.556389, 44.91861],
            [21.559719, 44.908607],
            [21.559719, 44.900551],
            [21.558609, 44.896111],
            [21.555832, 44.893326],
            [21.552776, 44.890831],
            [21.548611, 44.889442],
            [21.50222, 44.879715],
            [21.478886, 44.875275],
            [21.462776, 44.874443],
            [21.444443, 44.876389],
            [21.415276, 44.877495],
            [21.400276, 44.874992],
            [21.373055, 44.868607],
            [21.366108, 44.864441],
            [21.363052, 44.833057],
            [21.362091, 44.823143],
            [21.394196, 44.785934],
            [21.400398, 44.780823],
            [21.405869, 44.779732],
            [21.453609, 44.776665],
            [21.47472, 44.777771],
            [21.524441, 44.778328],
            [21.543053, 44.776382],
            [21.565552, 44.77166],
            [21.588333, 44.763329],
            [21.594997, 44.758888],
            [21.600277, 44.753609],
            [21.604164, 44.747498],
            [21.61565, 44.717705],
            [21.616386, 44.710274],
            [21.614719, 44.697495],
            [21.614719, 44.692215],
            [21.614998, 44.688606],
            [21.618332, 44.678329],
            [21.622776, 44.672218],
            [21.632221, 44.664993],
            [21.639721, 44.660828],
            [21.649441, 44.657776],
            [21.655552, 44.656944],
            [21.729721, 44.654716],
            [21.738609, 44.656944],
            [21.783607, 44.661942],
            [21.909164, 44.649437],
            [21.988888, 44.63694],
            [21.993889, 44.635551],
            [22.001389, 44.631104],
            [22.003887, 44.628609],
            [22.029163, 44.593887],
            [22.031261, 44.589424],
            [22.033333, 44.564438],
            [22.035553, 44.557495],
            [22.039444, 44.551666],
            [22.084442, 44.503052],
            [22.09111, 44.498329],
            [22.106667, 44.490273],
            [22.128609, 44.481384],
            [22.146385, 44.479164],
            [22.168888, 44.478607],
            [22.176941, 44.481941],
            [22.187222, 44.493889],
            [22.25861, 44.585274],
            [22.273331, 44.604164],
            [22.297775, 44.635826],
            [22.303608, 44.645828],
            [22.308609, 44.657776],
            [22.31361, 44.664162],
            [22.320553, 44.668327],
            [22.423611, 44.710274],
            [22.431664, 44.713333],
            [22.436386, 44.714439],
            [22.457775, 44.715553],
            [22.469719, 44.713608],
            [22.479164, 44.710274],
            [22.489998, 44.703331],
            [22.496944, 44.695],
            [22.508053, 44.684715],
            [22.519722, 44.674721],
            [22.543053, 44.658607],
            [22.574444, 44.638611],
            [22.592499, 44.628052],
            [22.604721, 44.622215],
            [22.609722, 44.620552],
            [22.622219, 44.618889],
            [22.644444, 44.618607],
            [22.659721, 44.619995],
            [22.671944, 44.618889],
            [22.709999, 44.606667],
            [22.713886, 44.604721],
            [22.71722, 44.602493],
            [22.762703, 44.56192],
            [22.764893, 44.559006],
            [22.765781, 44.555199],
            [22.765255, 44.551338],
            [22.763432, 44.547325],
            [22.76088, 44.544411],
            [22.754444, 44.539719],
            [22.743053, 44.534439],
            [22.734722, 44.531662],
            [22.709164, 44.523888],
            [22.699585, 44.522522],
            [22.686817, 44.523979],
            [22.677219, 44.527222],
            [22.667774, 44.530548],
            [22.645554, 44.543053],
            [22.6325, 44.548607],
            [22.621387, 44.551109],
            [22.609444, 44.552216],
            [22.590275, 44.549164],
            [22.582222, 44.546104],
            [22.463055, 44.484444],
            [22.459999, 44.482216],
            [22.457333, 44.474358],
            [22.457333, 44.466698],
            [22.461712, 44.453201],
            [22.463333, 44.449997],
            [22.529999, 44.345276],
            [22.536942, 44.336388],
            [22.549721, 44.323051],
            [22.567219, 44.308327],
            [22.576111, 44.304718],
            [22.591942, 44.300827],
            [22.616676, 44.298035],
            [22.641109, 44.294167],
            [22.657776, 44.29055],
            [22.672775, 44.286385],
            [22.680832, 44.282494],
            [22.687496, 44.277771],
            [22.691109, 44.27166],
            [22.691666, 44.26416],
            [22.681435, 44.224701],
            [22.676388, 44.224716],
            [22.653332, 44.214439],
            [22.650276, 44.211937],
            [22.619164, 44.169998],
            [22.614998, 44.121666],
            [22.614719, 44.117493],
            [22.552776, 44.063889],
            [22.536942, 44.057777],
            [22.420277, 44.009438],
            [22.416943, 44.006943],
            [22.367222, 43.826942],
            [22.406666, 43.725555],
            [22.414165, 43.709442],
            [22.536388, 43.480827],
            [22.543331, 43.472496],
            [22.550552, 43.46833],
            [22.628052, 43.430832],
            [22.669167, 43.415833],
            [22.718609, 43.401382],
            [22.724163, 43.399994],
            [22.761944, 43.387497],
            [22.766666, 43.385826],
            [22.824997, 43.336388],
            [22.833054, 43.328888],
            [22.834999, 43.325829],
            [22.845276, 43.291664],
            [22.845554, 43.288055],
            [22.847221, 43.284996],
            [22.84972, 43.282219],
            [22.904442, 43.230827],
            [22.907497, 43.228607],
            [22.940552, 43.210548],
            [23.004997, 43.192772],
            [22.99361, 43.141663],
            [22.990555, 43.133049],
            [22.966389, 43.101662],
            [22.745552, 42.893608],
            [22.741943, 42.891663],
            [22.73333, 42.889717],
            [22.66222, 42.880829],
            [22.654999, 42.884995],
            [22.614998, 42.894722],
            [22.603886, 42.896111],
            [22.585831, 42.892776],
            [22.524998, 42.878609],
            [22.520832, 42.87722],
            [22.514164, 42.873055],
            [22.44833, 42.82666],
            [22.442219, 42.821663],
            [22.44083, 42.818604],
            [22.440277, 42.81472],
            [22.44722, 42.599442],
            [22.464165, 42.568886],
            [22.472221, 42.564995],
            [22.522499, 42.531105],
            [22.544441, 42.515549],
            [22.549442, 42.510277],
            [22.558887, 42.487495],
            [22.558052, 42.479164],
            [22.538055, 42.427498],
            [22.536388, 42.423332],
            [22.522221, 42.402222],
            [22.519444, 42.399162],
            [22.459442, 42.363052],
            [22.410831, 42.335274],
            [22.365276, 42.323883],
            [22.335552, 42.355827],
            [22.332775, 42.35833],
            [22.324444, 42.361382],
            [22.308609, 42.360275],
            [22.221943, 42.34166],
            [22.218609, 42.339722],
            [22.216389, 42.337219],
            [22.213886, 42.333611],
            [22.212776, 42.329437],
            [22.210831, 42.326111],
            [22.206108, 42.32],
            [22.198887, 42.316383],
            [22.195, 42.315277],
            [22.184719, 42.313889],
            [22.083332, 42.300552],
            [22.07222, 42.300552],
            [22.061943, 42.302216],
            [22.023609, 42.31694],
            [21.855553, 42.331108],
            [21.850277, 42.330826],
            [21.841389, 42.328331],
            [21.806664, 42.303329],
            [21.799721, 42.294167],
            [21.794441, 42.27861],
            [21.793888, 42.274162],
            [21.788609, 42.263329],
            [21.778889, 42.256943],
            [21.738331, 42.237495],
            [21.721386, 42.232773],
            [21.710831, 42.232216],
            [21.70472, 42.232773],
            [21.681389, 42.239716],
            [21.61972, 42.254166],
            [21.481941, 42.267776],
            [21.466663, 42.265831],
            [21.459999, 42.262497],
            [21.348053, 42.195549],
            [21.344444, 42.193054],
            [21.30611, 42.151382],
            [21.304996, 42.147774],
            [21.221107, 42.145271],
            [21.215275, 42.149994],
            [21.141941, 42.198051],
            [21.13361, 42.201385],
            [21.12833, 42.202499],
            [21.116943, 42.202499],
            [21.104721, 42.198883],
            [20.914997, 42.119995],
            [20.807777, 42.089996],
            [20.796108, 42.085274],
            [20.792774, 42.082497],
            [20.785, 42.074715],
            [20.771942, 42.050827],
            [20.769722, 42.04277],
            [20.759163, 41.993332],
            [20.759441, 41.981384],
            [20.761665, 41.974442],
            [20.778053, 41.946663],
            [20.778889, 41.938332],
            [20.778332, 41.929718],
            [20.777222, 41.925552],
            [20.773888, 41.918884],
            [20.744164, 41.874161],
            [20.733055, 41.863884],
            [20.726387, 41.860275],
            [20.713055, 41.856667],
            [20.702499, 41.85611],
            [20.631664, 41.855827],
            [20.623333, 41.858604],
            [20.615276, 41.862495],
            [20.605553, 41.869164],
            [20.589642, 41.882187],
            [20.58083, 41.906662],
            [20.581108, 41.918884],
            [20.583054, 41.922218],
            [20.588608, 41.927498],
            [20.595276, 41.931938],
            [20.611385, 41.937492],
            [20.617775, 41.941666],
            [20.621944, 41.954163],
            [20.623886, 41.963333],
            [20.623333, 41.966942],
            [20.595276, 42.04361],
            [20.526108, 42.211662],
            [20.524166, 42.214439],
            [20.508888, 42.23027],
            [20.470432, 42.264557],
            [20.458054, 42.274437],
            [20.450832, 42.278328],
            [20.386944, 42.304161],
            [20.355675, 42.311844],
            [20.2575, 42.323326],
            [20.25222, 42.32444],
            [20.24472, 42.328606],
            [20.24361, 42.33194],
            [20.237499, 42.352493],
            [20.237778, 42.356667],
            [20.241108, 42.364166],
            [20.241943, 42.368889],
            [20.224163, 42.423332],
            [20.220833, 42.433327],
            [20.16861, 42.506943],
            [20.161942, 42.511665],
            [20.158054, 42.513329],
            [20.106667, 42.529999],
            [20.0975, 42.536942],
            [20.071423, 42.560913],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "VT",
        ISO2: "VA",
        ISO3: "VAT",
        UN: 336,
        NAME: "Holy See (Vatican City)",
        AREA: 0,
        POP2005: 783,
        REGION: 150,
        SUBREGION: 39,
        LON: 12.451,
        LAT: 41.904,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [12.445090330888604, 41.90311752178485],
            [12.451653339580503, 41.907989033391232],
            [12.456660170953796, 41.901426024699163],
            [12.445090330888604, 41.90311752178485],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        FID: 0.0,
        FIPS: "RS",
        ISO2: "RU",
        ISO3: "RUS",
        UN: 643,
        NAME: "Russia",
        AREA: 1638094,
        POP2005: 143953092,
        REGION: 150,
        SUBREGION: 151,
        LON: 96.689,
        LAT: 61.988,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [21.363354622193278, 55.286872782397928],
              [21.390757332488977, 55.281998261816483],
              [21.431385, 55.251938],
              [21.56416, 55.19721],
              [21.640274, 55.18471],
              [21.654442, 55.178879000000109],
              [21.715549, 55.1461],
              [21.71999, 55.139435],
              [21.722771, 55.136658],
              [21.732216000000108, 55.132767],
              [22.050274, 55.029991],
              [22.061943, 55.027489],
              [22.077221, 55.026657],
              [22.09805, 55.028046],
              [22.108608, 55.030823],
              [22.121109, 55.037498],
              [22.124439, 55.040276],
              [22.13222, 55.049438000000123],
              [22.13583, 55.052216000000101],
              [22.140553000000125, 55.053879],
              [22.146385, 55.055267000000129],
              [22.184162, 55.060272],
              [22.197216, 55.06166],
              [22.258053000000132, 55.066383],
              [22.27972, 55.06721],
              [22.51277, 55.063324],
              [22.602219000000105, 55.046661],
              [22.603607, 55.0430530000001],
              [22.63861, 54.969711000000132],
              [22.640831000000105, 54.966385000000116],
              [22.643887, 54.963608],
              [22.64833, 54.961662000000103],
              [22.653049000000124, 54.959717000000126],
              [22.659161, 54.9586],
              [22.68222, 54.958328000000108],
              [22.70166, 54.960548000000131],
              [22.719440000000134, 54.963608],
              [22.726662, 54.963882000000126],
              [22.732216000000108, 54.962494],
              [22.834995000000106, 54.901657],
              [22.84249, 54.89694],
              [22.84944, 54.88749700000011],
              [22.853329, 54.875824],
              [22.864998000000128, 54.8386],
              [22.869164, 54.823326000000122],
              [22.869164, 54.814438000000109],
              [22.867775, 54.810547],
              [22.86138, 54.80027],
              [22.84944, 54.782768],
              [22.84249, 54.777489],
              [22.837776, 54.775826000000109],
              [22.83194, 54.77444],
              [22.81833, 54.773605],
              [22.809441, 54.769714000000135],
              [22.74527, 54.717209000000139],
              [22.721107, 54.694992],
              [22.719162, 54.691376],
              [22.695827, 54.53611],
              [22.69389, 54.522766000000104],
              [22.691383, 54.493607],
              [22.694439000000102, 54.47332],
              [22.702217, 54.455826],
              [22.707069, 54.44812],
              [22.713608, 54.439713],
              [22.731384, 54.42749],
              [22.740829, 54.419441],
              [22.776386, 54.376938],
              [22.78588, 54.36384],
              [22.77583, 54.361107],
              [22.757500000000107, 54.35833],
              [22.66416, 54.351105],
              [22.629997, 54.348877],
              [22.455551000000128, 54.345543],
              [22.43391, 54.345543],
              [22.425552, 54.345543],
              [22.305275, 54.341103],
              [22.29434, 54.339672],
              [22.292496000000142, 54.33943],
              [22.265553, 54.338043],
              [22.164997, 54.334991000000116],
              [21.981937, 54.332771],
              [21.8555530000001, 54.331665],
              [21.732765, 54.330845],
              [21.729996, 54.330826000000116],
              [21.625553, 54.32972],
              [21.577515, 54.328403],
              [21.570435, 54.328209],
              [21.52417, 54.326942],
              [21.442493, 54.32555],
              [21.411942, 54.325829],
              [21.367218, 54.327217],
              [21.283607, 54.329994],
              [21.231937, 54.332771],
              [21.181938, 54.33638],
              [21.126385, 54.34166],
              [20.898052, 54.356102000000135],
              [20.73888, 54.358047000000113],
              [20.432774000000109, 54.38166],
              [20.371662, 54.387772],
              [20.331182, 54.393532],
              [20.329082, 54.393833],
              [20.30139, 54.397774],
              [20.158607, 54.411934],
              [20.090553000000114, 54.418602],
              [20.004166000000112, 54.41916],
              [19.857704000000126, 54.429909],
              [19.797007000000121, 54.43755],
              [19.820274, 54.465271],
              [19.824444, 54.4675],
              [19.93519, 54.493874],
              [19.961805, 54.529434],
              [19.97684, 54.557884],
              [19.997164, 54.57333],
              [20.02236, 54.570076],
              [20.036110000000122, 54.563881],
              [20.05447, 54.55016],
              [20.067877, 54.55179],
              [20.1025, 54.574165000000107],
              [20.216938, 54.60332],
              [20.23832700000014, 54.609161],
              [20.252777, 54.614441000000113],
              [20.380829, 54.664711000000125],
              [20.398331, 54.673607],
              [20.404999, 54.679161],
              [20.404999, 54.682777000000101],
              [20.19361, 54.696938000000102],
              [20.172323, 54.694031000000109],
              [20.149565000000109, 54.68184],
              [20.109331, 54.67127],
              [20.09145, 54.650543],
              [20.066252, 54.65583],
              [20.052027000000123, 54.668831000000125],
              [20.049995, 54.696877],
              [20.038616, 54.711506],
              [20.01833, 54.71999],
              [20.004166000000112, 54.71999],
              [19.997776, 54.719162],
              [19.98139, 54.70549],
              [19.96505, 54.698490000000106],
              [19.96122, 54.695328000000131],
              [19.960218, 54.693161],
              [19.957552, 54.683495],
              [19.944160000000124, 54.65916],
              [19.944164000000114, 54.654716],
              [19.946388, 54.646942],
              [19.94944, 54.644157],
              [19.961388, 54.641663],
              [19.96277, 54.638046],
              [19.961109, 54.63444],
              [19.95722, 54.63221],
              [19.950832, 54.631386],
              [19.929443000000106, 54.629997],
              [19.900829000000101, 54.628326],
              [19.87271, 54.640549],
              [19.872772, 54.642220000000123],
              [19.899162, 54.68888],
              [19.913216, 54.707211000000143],
              [19.917551000000117, 54.710213],
              [19.928717, 54.71488],
              [19.93255, 54.718052],
              [19.957771, 54.760551000000135],
              [19.95944, 54.76416],
              [19.961105, 54.772491],
              [19.960827, 54.794716],
              [19.958607000000143, 54.80249],
              [19.939438, 54.836937],
              [19.930275, 54.849998],
              [19.924164000000133, 54.8555530000001],
              [19.921108, 54.86277],
              [19.919716, 54.875549],
              [19.926662, 54.899162],
              [19.936661000000129, 54.921104],
              [19.940830000000119, 54.928047],
              [19.95055, 54.940826],
              [19.969440000000134, 54.957497000000103],
              [19.978882000000112, 54.961105],
              [19.985271000000125, 54.96194],
              [19.992493, 54.96138],
              [19.99638, 54.95916],
              [19.99721, 54.95499],
              [19.999439, 54.95166],
              [20.004166000000112, 54.949997],
              [20.023331, 54.946938],
              [20.037498, 54.945824],
              [20.361942, 54.941933],
              [20.41777, 54.945824],
              [20.427494, 54.949432],
              [20.548607, 54.99638],
              [20.604717, 55.0236],
              [20.624996, 55.034721000000104],
              [20.672497, 55.06249],
              [20.69194, 55.074165],
              [20.701939, 55.082214],
              [20.827774, 55.18471],
              [20.89444, 55.24305],
              [20.935551, 55.27943],
              [20.942833, 55.287201],
              [20.984814, 55.27655],
              [20.91166, 55.231102],
              [20.90499, 55.225548],
              [20.889717000000132, 55.208603],
              [20.88694, 55.200829000000113],
              [20.879997, 55.19027],
              [20.87749, 55.18721],
              [20.848053, 55.15332],
              [20.838051, 55.145271],
              [20.708328, 55.06388],
              [20.672497, 55.043327],
              [20.630829, 55.021103],
              [20.590275, 55.003326],
              [20.577221, 54.996941],
              [20.530277, 54.973877],
              [20.52777, 54.970825000000104],
              [20.528332, 54.966660000000104],
              [20.53, 54.962769],
              [20.53805, 54.949432],
              [20.541107000000125, 54.946655],
              [20.555275, 54.940544],
              [20.566387000000134, 54.937767000000122],
              [20.58083, 54.938599],
              [20.591942, 54.941101000000117],
              [20.654995, 54.94249],
              [20.75528, 54.94305],
              [20.785275, 54.941658],
              [20.79639, 54.939713],
              [20.805832, 54.936935],
              [20.859997, 54.90416],
              [20.870274, 54.900826],
              [20.98444, 54.892494],
              [21.090275, 54.895],
              [21.09583, 54.896385],
              [21.2225, 54.931938000000116],
              [21.242218, 54.943604000000107],
              [21.246662, 54.950272],
              [21.246941, 54.95499],
              [21.244438, 54.971375000000137],
              [21.239162, 54.977486],
              [21.227772, 54.984436],
              [21.223328, 54.991104],
              [21.221382, 54.998878],
              [21.21666, 55.018600000000106],
              [21.19083, 55.149162000000103],
              [21.224163, 55.199997],
              [21.231106, 55.19943],
              [21.26028, 55.200546000000145],
              [21.263332000000105, 55.202492],
              [21.266109, 55.205551],
              [21.274166, 55.224159],
              [21.274441, 55.228600000000142],
              [21.273888000000113, 55.23276],
              [21.263935000000117, 55.248985],
              [21.26915, 55.249306000000104],
              [21.280552000000114, 55.251938],
              [21.30027, 55.258888000000127],
              [21.327656, 55.27063],
              [21.363308, 55.286858000000109],
              [21.363354622193278, 55.286872782397928],
            ],
          ],
          [
            [
              [37.022655216680675, 63.899530105053636],
              [47.868018619285216, 50.333924535807647],
              [47.883755601558164, 50.289860985443397],
              [47.760826000000122, 50.375267],
              [47.63444, 50.454712],
              [47.620270000000119, 50.459991],
              [47.59972, 50.460823],
              [47.576103, 50.45638300000013],
              [47.553879000000109, 50.44971],
              [47.52083, 50.43638],
              [47.490829000000133, 50.421379],
              [47.480545, 50.413879],
              [47.445786, 50.378342],
              [47.446396, 50.376953],
              [47.43888, 50.360825],
              [47.432495, 50.350273],
              [47.416100000000142, 50.331940000000145],
              [47.404991, 50.32527],
              [47.37027, 50.314156],
              [47.354439, 50.311104000000114],
              [47.32666, 50.30222],
              [47.32083, 50.299164],
              [47.31667, 50.294441],
              [47.314438, 50.288605],
              [47.281937, 50.18888],
              [47.280548, 50.182213],
              [47.282768, 50.176941],
              [47.300545, 50.161102000000142],
              [47.30999, 50.1536],
              [47.320549, 50.146385000000123],
              [47.32638500000013, 50.143326],
              [47.335823, 50.135551],
              [47.346382, 50.12221],
              [47.353325, 50.107216],
              [47.35555, 50.102219],
              [47.35666, 50.096382],
              [47.35666, 50.090271],
              [47.34943, 50.080276],
              [47.341103, 50.07138],
              [47.30249, 50.031937],
              [47.265274, 49.999435],
              [47.260277, 49.995544],
              [47.199997, 49.95027],
              [47.188324000000136, 49.944153000000142],
              [47.150826000000109, 49.934433],
              [47.119713000000104, 49.928604],
              [47.089432, 49.921661],
              [47.045273, 49.910545000000127],
              [47.009163, 49.900826000000109],
              [46.98166, 49.891663000000108],
              [46.95527, 49.88166],
              [46.94332, 49.875824],
              [46.933327, 49.86805],
              [46.929436, 49.863609],
              [46.861107, 49.5961],
              [46.802216, 49.364998],
              [46.79583, 49.339714],
              [46.81221, 49.337212000000136],
              [46.838043, 49.33194],
              [46.86832, 49.322769],
              [46.8811, 49.31694],
              [46.899719, 49.308044000000109],
              [46.923050000000103, 49.295273],
              [46.946098, 49.28221],
              [47.01472, 49.243324000000143],
              [47.0261, 49.236107],
              [47.039993, 49.224709],
              [47.057495, 49.202774],
              [47.060822, 49.19193300000012],
              [47.065269, 49.168884000000105],
              [47.06388, 49.149437],
              [47.062767, 49.142769000000101],
              [47.056381000000101, 49.124435],
              [47.0472180000001, 49.108604],
              [47.040276, 49.098602],
              [47.016388, 49.071381],
              [46.995544, 49.049438],
              [46.969154, 49.024437],
              [46.954437, 49.013054],
              [46.943604, 49.006104],
              [46.914711, 48.990273],
              [46.88193, 48.97832],
              [46.848328, 48.96693],
              [46.815826, 48.954712],
              [46.803322, 48.94943],
              [46.778877000000136, 48.936653],
              [46.63113, 48.663788000000125],
              [46.606941, 48.61721],
              [46.556099000000131, 48.52388],
              [46.527489000000116, 48.470825],
              [46.499161000000129, 48.4175],
              [46.659714, 48.381104],
              [46.819992000000127, 48.343605],
              [46.979988000000105, 48.306099000000131],
              [47.119713000000104, 48.272491000000116],
              [47.122765, 48.271660000000111],
              [47.134872, 48.248108],
              [47.130272, 48.237213000000111],
              [47.12221, 48.102219],
              [47.11998, 47.946091000000138],
              [47.136658, 47.822495],
              [47.141373000000101, 47.81388],
              [47.150269, 47.806099],
              [47.189423, 47.783875000000137],
              [47.255829000000119, 47.750832000000116],
              [47.383324, 47.68888],
              [47.390266000000111, 47.686104],
              [47.395264000000111, 47.686371000000122],
              [47.397484000000134, 47.692490000000134],
              [47.400826, 47.70527],
              [47.41249, 47.764709],
              [47.413605000000132, 47.777489],
              [47.410812000000135, 47.806931000000134],
              [47.410812000000135, 47.81944],
              [47.413048, 47.831657],
              [47.416939000000127, 47.836098],
              [47.421928, 47.83999],
              [47.427483, 47.842766],
              [47.435822, 47.843597],
              [47.45387, 47.840828000000101],
              [47.485268, 47.832764000000111],
              [47.521378, 47.820824],
              [47.59999, 47.79416],
              [47.62527, 47.78315],
              [47.640831000000105, 47.776375],
              [47.663315, 47.76944],
              [47.691376, 47.765831],
              [47.738045000000113, 47.773041],
              [47.79554, 47.7786],
              [47.918877000000123, 47.782494],
              [48.028046, 47.78276],
              [48.046654000000103, 47.782494],
              [48.064713, 47.779709],
              [48.0961, 47.771378000000141],
              [48.109428, 47.766106],
              [48.128319, 47.757500000000107],
              [48.140549000000135, 47.751389],
              [48.15165, 47.744987],
              [48.204430000000116, 47.704987000000131],
              [48.223312000000135, 47.69026],
              [48.240822, 47.674706],
              [48.260277, 47.64804],
              [48.268593, 47.634163000000115],
              [48.316093000000137, 47.572495000000117],
              [48.37999, 47.501656000000139],
              [48.443871, 47.436928],
              [48.45694, 47.431664],
              [48.46471, 47.429436000000123],
              [48.568886, 47.372765],
              [48.576096000000121, 47.35833],
              [48.624702000000127, 47.270821000000126],
              [48.7211, 47.09833],
              [48.98166, 46.824158],
              [49.02721, 46.776093],
              [48.941376, 46.704163],
              [48.765266000000111, 46.690819],
              [48.755829, 46.704163],
              [48.753876, 46.709160000000111],
              [48.731934, 46.740273000000116],
              [48.720261, 46.752495],
              [48.710541, 46.759720000000129],
              [48.691093000000137, 46.76777],
              [48.665825, 46.772758000000124],
              [48.636932, 46.774994],
              [48.60332, 46.773315],
              [48.589432000000102, 46.769707],
              [48.550545, 46.756653],
              [48.538605, 46.751656],
              [48.52166, 46.74305],
              [48.509163, 46.731659],
              [48.50499, 46.7197],
              [48.498604, 46.688324],
              [48.494431, 46.667206000000135],
              [48.560547, 46.564995],
              [48.574715, 46.560265],
              [48.584717, 46.559433000000126],
              [48.61998, 46.559433000000126],
              [48.668877, 46.56304200000011],
              [48.677216, 46.564438],
              [48.714149, 46.56304200000011],
              [48.732758, 46.560547],
              [48.740273, 46.558327],
              [48.745537, 46.554993],
              [48.754166, 46.547493],
              [48.765831, 46.535271],
              [48.768883, 46.530823],
              [48.785828, 46.515266],
              [48.833878, 46.484993],
              [48.847137, 46.479240000000118],
              [48.883324, 46.481659],
              [48.911377, 46.486382],
              [48.918129, 46.48922],
              [49.17499, 46.369713000000104],
              [49.22253, 46.346306000000141],
              [49.225815, 46.322495],
              [49.229706000000135, 46.312202000000127],
              [49.232758, 46.30777],
              [49.236931, 46.303879],
              [49.251938, 46.293610000000115],
              [49.262497, 46.28694],
              [49.298882, 46.270546000000138],
              [49.30555, 46.263054],
              [49.304153, 46.257767000000115],
              [49.301102, 46.252495],
              [49.294716000000108, 46.25027],
              [49.287491, 46.249161],
              [49.277489, 46.25],
              [49.18748, 46.273598],
              [49.15443, 46.28665],
              [49.046387, 46.195824],
              [48.91109, 46.130547],
              [48.78194, 46.092766],
              [48.713875, 46.130547],
              [48.70638300000013, 46.132484],
              [48.672768, 46.11998],
              [48.667206000000135, 46.116936],
              [48.6311, 46.086098],
              [48.627762, 46.082764],
              [48.633041, 46.079720000000123],
              [48.646935, 46.074715],
              [48.692215, 46.062202],
              [48.698601, 46.059433],
              [48.702766, 46.05555],
              [48.721375000000137, 46.02887],
              [48.727486, 46.01998],
              [48.729424, 46.014992],
              [48.738884, 45.96804],
              [48.761658, 45.854706],
              [48.713326000000109, 45.830269000000101],
              [48.628876, 45.908875],
              [48.624702000000127, 45.912766],
              [48.607216, 45.934433000000126],
              [48.600822, 45.9433140000001],
              [48.596931, 45.953316],
              [48.592766, 45.957207],
              [48.587494, 45.960541],
              [48.572495, 45.964706],
              [48.56582, 45.965828],
              [48.55749, 45.965271000000143],
              [48.458603, 45.936104],
              [48.446648, 45.931107000000111],
              [48.373322, 45.87498],
              [48.34137, 45.837494],
              [48.256943, 45.76804],
              [48.22387700000013, 45.744156],
              [48.192757, 45.737488],
              [48.13721, 45.74054],
              [47.978043, 45.728043],
              [47.858887, 45.71859],
              [47.85166, 45.717209000000139],
              [47.847771, 45.712769],
              [47.830544, 45.655823],
              [47.615974000000108, 45.75717],
              [47.596657, 45.764153000000135],
              [47.55999, 45.76888300000013],
              [47.55222, 45.76944],
              [47.55026, 45.764709],
              [47.551102, 45.74054],
              [47.556374000000119, 45.737488],
              [47.58859, 45.724434],
              [47.622208, 45.713326],
              [47.625259, 45.708878],
              [47.6572, 45.615822],
              [47.653046, 45.603882000000112],
              [47.649994000000106, 45.59859],
              [47.642487, 45.588875],
              [47.653046, 45.565262000000132],
              [47.65498, 45.560265],
              [47.651375000000144, 45.555817000000104],
              [47.645, 45.553596],
              [47.637215, 45.55304],
              [47.62748, 45.55388],
              [47.619980000000112, 45.555817000000104],
              [47.61554, 45.55971],
              [47.613602000000128, 45.564713],
              [47.612762, 45.576378],
              [47.5961, 45.603882000000112],
              [47.576935000000105, 45.630272000000105],
              [47.56971, 45.638596],
              [47.50388, 45.713051],
              [47.491096, 45.724434],
              [47.48555, 45.72777],
              [47.403313000000139, 45.747765],
              [47.393600000000106, 45.748604],
              [47.385544, 45.747765],
              [47.380272000000105, 45.74471],
              [47.37999, 45.738602],
              [47.38221, 45.733597],
              [47.41277, 45.676659],
              [47.41582, 45.672211],
              [47.470818000000122, 45.653313000000139],
              [47.478325, 45.651093000000117],
              [47.487206, 45.651093000000117],
              [47.493317000000104, 45.653313000000139],
              [47.501938, 45.651932000000102],
              [47.535271, 45.639435000000105],
              [47.546097000000145, 45.633041],
              [47.55999, 45.600266],
              [47.567215, 45.5811],
              [47.57027, 45.564156000000139],
              [47.56915, 45.557487],
              [47.566093000000137, 45.552216],
              [47.54749, 45.529709000000139],
              [47.54305, 45.525826],
              [47.536652, 45.528603],
              [47.50305, 45.556931],
              [47.505272, 45.551926],
              [47.51777, 45.521935],
              [47.519981, 45.494987],
              [47.49054, 45.422493000000145],
              [47.486107, 45.418602],
              [47.479706000000135, 45.416382],
              [47.471375, 45.41776],
              [47.421654, 45.36304],
              [47.37109, 45.23333],
              [47.24082, 45.055817],
              [47.135262, 44.940262],
              [47.116653, 44.868317],
              [47.116653, 44.862206],
              [47.075554, 44.782761],
              [47.071106, 44.7836],
              [47.033051000000114, 44.829987],
              [46.988045, 44.808327],
              [46.969704, 44.78583],
              [46.948868, 44.768883],
              [46.886658000000125, 44.748604],
              [46.856102, 44.72637],
              [46.777771, 44.69498],
              [46.772484, 44.69193300000012],
              [46.763611, 44.684433],
              [46.715271000000143, 44.602486],
              [46.67971, 44.52304],
              [46.67971, 44.51054],
              [46.680817000000104, 44.50499],
              [46.696938000000102, 44.452492],
              [46.69999700000011, 44.442757000000142],
              [46.707764, 44.431107],
              [46.719437, 44.419159],
              [46.760277, 44.39193],
              [46.78443, 44.38721],
              [46.800545, 44.385262],
              [46.80749, 44.386932],
              [46.816376, 44.39444],
              [46.822495, 44.39666],
              [46.840546, 44.395821],
              [46.989159, 44.366096],
              [47.012215, 44.36082],
              [47.031097000000102, 44.353043],
              [47.040543, 44.3461],
              [47.047768000000133, 44.33804],
              [47.05526, 44.323601],
              [47.05833, 44.313042],
              [47.060265000000129, 44.301926],
              [47.066376, 44.286942],
              [47.076935, 44.26221],
              [47.08194, 44.25277],
              [47.088326, 44.24416],
              [47.092484000000127, 44.240273],
              [47.152206, 44.203049000000135],
              [47.1586, 44.20054],
              [47.166939, 44.199158],
              [47.175545000000113, 44.199158],
              [47.181664000000126, 44.201378],
              [47.197487000000137, 44.210274],
              [47.265831000000105, 44.1436],
              [47.350266, 44.026649],
              [47.488045, 43.815536],
              [47.49221, 43.80555],
              [47.501099, 43.774155000000121],
              [47.501938, 43.768593],
              [47.499161000000129, 43.763329],
              [47.45138, 43.681107],
              [47.399155, 43.612488],
              [47.395546, 43.60804],
              [47.391373, 43.60582],
              [47.383041, 43.607216000000108],
              [47.376938000000109, 43.60971],
              [47.368874000000119, 43.617203],
              [47.363884, 43.61554],
              [47.36276, 43.610268],
              [47.36276, 43.59166],
              [47.36472, 43.58694],
              [47.403046, 43.504715],
              [47.407204, 43.501099000000124],
              [47.42638, 43.498604000000114],
              [47.43499, 43.498604000000114],
              [47.44471, 43.505272000000105],
              [47.44804, 43.50972],
              [47.461655000000121, 43.528328000000101],
              [47.463608, 43.534431],
              [47.464149, 43.571381],
              [47.471924, 43.629433],
              [47.47387700000013, 43.635544],
              [47.475815, 43.641373000000101],
              [47.522758000000124, 43.756386],
              [47.537766, 43.78916],
              [47.539719, 43.795273],
              [47.541939, 43.80888],
              [47.542213000000118, 43.82111],
              [47.539162, 43.831657],
              [47.536385, 43.848328],
              [47.536385, 43.85444],
              [47.539162, 43.859711000000118],
              [47.54639, 43.868599],
              [47.55526, 43.8761],
              [47.588326000000109, 43.892220000000123],
              [47.60582, 43.899712],
              [47.612762, 43.901093000000117],
              [47.62832, 43.902489],
              [47.643883, 43.899155],
              [47.686104, 43.880272000000105],
              [47.691376, 43.876938000000109],
              [47.698318, 43.868874000000119],
              [47.692490000000134, 43.86665],
              [47.67971, 43.864441000000113],
              [47.674431, 43.861382],
              [47.665825, 43.85526],
              [47.64887, 43.834984],
              [47.63888, 43.820824],
              [47.632484, 43.811104],
              [47.607216, 43.76388],
              [47.584984000000134, 43.722214],
              [47.566376000000105, 43.684708],
              [47.554993, 43.656380000000127],
              [47.532761, 43.59804],
              [47.524994, 43.574158000000125],
              [47.487206, 43.45638300000013],
              [47.483871000000136, 43.436104],
              [47.483597, 43.41776],
              [47.491936, 43.332207],
              [47.528603, 43.310547],
              [47.541939, 43.32166],
              [47.547768, 43.323875],
              [47.566666000000112, 43.329720000000123],
              [47.572495000000117, 43.330544],
              [47.577492, 43.327209],
              [47.580544000000145, 43.323044],
              [47.586655, 43.308037],
              [47.588326000000109, 43.296944],
              [47.583603, 43.285828],
              [47.542496, 43.24638],
              [47.538048000000117, 43.24276],
              [47.526093, 43.238319],
              [47.50639, 43.23333],
              [47.496094, 43.227211],
              [47.491653, 43.22359],
              [47.483330000000137, 43.207764],
              [47.454987, 43.09304],
              [47.45387, 43.0861],
              [47.462212, 43.01915],
              [47.464432, 43.014153000000135],
              [47.47637, 43.002769],
              [47.538048000000117, 42.953049],
              [47.614716000000101, 42.90443],
              [47.636101, 42.89222],
              [47.65638, 42.885544],
              [47.686928, 42.872765],
              [47.696938000000102, 42.866379000000109],
              [47.702766, 42.857491],
              [47.711655, 42.827492],
              [47.720261, 42.77387],
              [47.719147, 42.75027],
              [47.71804, 42.743607],
              [47.713326, 42.732201],
              [47.708321000000126, 42.724709],
              [47.706383, 42.71859],
              [47.706093000000124, 42.712494],
              [47.729424, 42.646935],
              [47.732201, 42.642487],
              [47.738319, 42.63388],
              [47.748322, 42.627480000000105],
              [47.76028, 42.622208],
              [47.798882000000106, 42.613884],
              [47.831383, 42.60804000000013],
              [47.84444, 42.6036],
              [47.859428, 42.59388],
              [47.871368000000132, 42.5825],
              [47.887215, 42.561371000000122],
              [47.89722, 42.543877],
              [47.908875, 42.520264000000111],
              [47.920273, 42.49665],
              [47.92526, 42.48749],
              [47.93499, 42.474991],
              [47.944984, 42.462494],
              [47.952766, 42.454712],
              [48.024155, 42.386658000000125],
              [48.041100000000142, 42.373322],
              [48.087051, 42.352097000000128],
              [48.109993, 42.33416],
              [48.11776, 42.326378],
              [48.303596, 42.09748],
              [48.308327, 42.088326000000109],
              [48.319443, 42.05777],
              [48.321938, 42.0411],
              [48.32471, 42.030823000000112],
              [48.364441000000113, 41.955826],
              [48.369980000000112, 41.947205],
              [48.386658, 41.926384],
              [48.394440000000145, 41.918877],
              [48.40916, 41.909157],
              [48.42083, 41.90387],
              [48.427773, 41.90165],
              [48.44804, 41.896378000000141],
              [48.479149, 41.891106],
              [48.506104, 41.888329000000113],
              [48.537766, 41.882484],
              [48.544716, 41.880272],
              [48.549721, 41.87721],
              [48.583954, 41.83577],
              [48.531380000000127, 41.76721],
              [48.436928, 41.639153000000135],
              [48.42305, 41.613319000000104],
              [48.416100000000142, 41.604706000000135],
              [48.399712, 41.589149],
              [48.38582, 41.579163],
              [48.370827, 41.570267000000115],
              [48.248871000000122, 41.509163],
              [48.231377, 41.502495],
              [48.225548, 41.50054200000011],
              [48.186104000000114, 41.492210000000114],
              [48.149994, 41.488319],
              [48.115273, 41.482758],
              [48.096375, 41.47777],
              [48.074432, 41.46777],
              [48.066093, 41.460274],
              [47.958321, 41.35582],
              [47.908318000000122, 41.290833000000134],
              [47.9072, 41.27916],
              [47.908043, 41.273598],
              [47.909981, 41.26888300000013],
              [47.915825, 41.259995],
              [47.919716000000108, 41.25639],
              [47.92526, 41.24749],
              [47.926384, 41.24221],
              [47.926102, 41.236107],
              [47.91999, 41.22637],
              [47.910812, 41.2197],
              [47.904984000000127, 41.217766],
              [47.859154000000103, 41.207764],
              [47.796097, 41.198868000000118],
              [47.76693, 41.196091],
              [47.7586060000001, 41.196381],
              [47.750832000000116, 41.197762000000125],
              [47.72137, 41.21054],
              [47.659714, 41.23555],
              [47.643326000000116, 41.23555],
              [47.636932000000115, 41.234154000000103],
              [47.624428, 41.22998],
              [47.599434, 41.215271],
              [47.587769, 41.210815],
              [47.580544000000145, 41.210274],
              [47.571663, 41.211098],
              [47.56471, 41.213051],
              [47.37109, 41.271935],
              [47.28555, 41.312202],
              [47.275551, 41.318604],
              [47.271660000000111, 41.322495000000117],
              [47.265831000000105, 41.331100000000106],
              [47.261101, 41.359154],
              [47.260277, 41.370827],
              [47.260277, 41.376938],
              [47.26249700000011, 41.390266],
              [47.263611, 41.403313],
              [47.260818, 41.419716],
              [47.258881, 41.424706],
              [47.253052, 41.433327000000133],
              [47.160538, 41.561104000000114],
              [47.156647, 41.564713],
              [47.141663000000108, 41.574158],
              [47.135818, 41.576653],
              [47.127762000000132, 41.578049],
              [47.11304, 41.576653],
              [47.100548, 41.57304],
              [47.084160000000111, 41.565536],
              [47.021378, 41.618599],
              [46.940536, 41.683868],
              [46.861664000000133, 41.734711],
              [46.80693, 41.769150000000138],
              [46.77887, 41.78916],
              [46.770821, 41.796654000000103],
              [46.76888300000013, 41.807487],
              [46.76888300000013, 41.819984],
              [46.769981, 41.826653000000135],
              [46.769981, 41.832764],
              [46.76888300000013, 41.844437],
              [46.76693, 41.85526],
              [46.764992, 41.860268],
              [46.760818, 41.863884],
              [46.754166000000112, 41.862488],
              [46.644707, 41.819153],
              [46.639709, 41.816093],
              [46.57138, 41.871933000000126],
              [46.568329, 41.882484],
              [46.563324, 41.885544],
              [46.556374000000119, 41.887497],
              [46.505272, 41.8936],
              [46.451752, 41.897057],
              [46.446381, 41.904427],
              [46.430275000000108, 41.91916],
              [46.421371, 41.926102000000128],
              [46.40609, 41.935547],
              [46.39415, 41.940536],
              [46.253052, 41.996941000000106],
              [46.239983, 42.001389],
              [46.231934000000138, 42.002769],
              [46.05415, 42.024994],
              [45.986931000000141, 42.028603],
              [45.66277, 42.195267],
              [45.647484000000134, 42.20471],
              [45.639153, 42.21194],
              [45.637215, 42.216927],
              [45.636932000000115, 42.22304],
              [45.638596, 42.228867],
              [45.646103, 42.244713000000104],
              [45.655266, 42.259163],
              [45.689713, 42.319153000000142],
              [45.7075, 42.356102],
              [45.754715, 42.457207],
              [45.760544, 42.473312],
              [45.760277, 42.477913],
              [45.756943, 42.482201],
              [45.74471, 42.493317],
              [45.730263, 42.50332],
              [45.724991000000102, 42.506386],
              [45.700539, 42.51611],
              [45.576096, 42.546097],
              [45.552773000000116, 42.550262],
              [45.526932, 42.550819],
              [45.49527, 42.548882000000106],
              [45.481102, 42.546387],
              [45.432213, 42.53749],
              [45.376381, 42.526932000000102],
              [45.35889, 42.527489],
              [45.35166, 42.529427000000112],
              [45.343323000000112, 42.536652],
              [45.33804, 42.54583],
              [45.335815, 42.550819],
              [45.334717, 42.556374],
              [45.3325, 42.561104],
              [45.32304, 42.574158000000125],
              [45.315819, 42.58194],
              [45.241936000000123, 42.65083],
              [45.216927, 42.672768],
              [45.207497000000103, 42.679436],
              [45.171371, 42.700829000000113],
              [45.158875, 42.705826],
              [45.151649, 42.707764000000111],
              [45.134438000000102, 42.70943],
              [45.12027, 42.706940000000145],
              [45.091476000000114, 42.697422],
              [45.082764000000111, 42.69498],
              [45.068604, 42.69249],
              [45.060265000000129, 42.69249],
              [45.05304, 42.694153000000142],
              [45.04583, 42.696091],
              [45.017769, 42.709984000000134],
              [45.00221, 42.719147000000135],
              [44.976372, 42.734993],
              [44.97221, 42.73888],
              [44.962769, 42.74554],
              [44.947205, 42.755272],
              [44.934708, 42.760277],
              [44.927483000000109, 42.761932],
              [44.900826, 42.763054],
              [44.886658, 42.760277],
              [44.86916, 42.75332],
              [44.859154, 42.747208],
              [44.854996, 42.743317],
              [44.808327, 42.66527],
              [44.765549, 42.67054],
              [44.75471, 42.688881],
              [44.747208, 42.696938],
              [44.705269, 42.72721],
              [44.684433, 42.739426],
              [44.671928, 42.74416],
              [44.657494, 42.747765000000129],
              [44.640266, 42.749428],
              [44.63826, 42.74881],
              [44.633041000000105, 42.751389000000131],
              [44.62582, 42.753052],
              [44.593880000000127, 42.75832],
              [44.566376, 42.759995],
              [44.549721, 42.75944],
              [44.52721, 42.756653],
              [44.499718, 42.750832],
              [44.369431, 42.708046],
              [44.244431, 42.660538],
              [44.23776, 42.651375],
              [44.225548000000117, 42.639992],
              [44.220818, 42.636932],
              [44.20916, 42.631927000000132],
              [44.197487, 42.627213],
              [44.189728, 42.625206],
              [44.184433000000126, 42.623871],
              [43.911934, 42.583321000000126],
              [43.784714, 42.600822000000107],
              [43.778328, 42.603043],
              [43.77304, 42.6061],
              [43.73888, 42.634995],
              [43.73555, 42.639153000000135],
              [43.735268000000133, 42.645264],
              [43.73654, 42.64831],
              [43.740822, 42.65527],
              [43.744713, 42.659157],
              [43.762772, 42.67305],
              [43.806099000000131, 42.702209],
              [43.8238750000001, 42.7161],
              [43.836098, 42.727768],
              [43.837769, 42.733871],
              [43.838036000000102, 42.739159],
              [43.835815, 42.74416],
              [43.832497000000103, 42.748322],
              [43.827209, 42.751389000000131],
              [43.82111, 42.75361],
              [43.756386, 42.775826],
              [43.71249, 42.779427],
              [43.69694, 42.7822],
              [43.67083, 42.7911],
              [43.649712000000136, 42.802773000000116],
              [43.641106, 42.80999],
              [43.636932, 42.813599],
              [43.623604, 42.83138300000013],
              [43.619431, 42.834984],
              [43.6036, 42.843880000000127],
              [43.591927, 42.849152],
              [43.56055, 42.860825],
              [43.532494, 42.868317],
              [43.44720500000011, 42.889153],
              [43.39289, 42.900124],
              [43.377762, 42.900536],
              [43.213608, 42.931664],
              [43.200829, 42.93637],
              [43.183868000000132, 42.944427],
              [43.14471, 42.963875000000144],
              [43.133881, 42.9697],
              [43.010818, 43.056656],
              [43.009438000000102, 43.061928000000137],
              [43.010818, 43.06805],
              [42.94887, 43.12165],
              [42.863602, 43.175262],
              [42.857216000000108, 43.177483000000109],
              [42.849991, 43.179153],
              [42.76944, 43.185822000000144],
              [42.701096, 43.182487],
              [42.688881, 43.17804],
              [42.679993, 43.171097],
              [42.67361, 43.16165],
              [42.665543000000127, 43.15387],
              [42.660812, 43.150536],
              [42.649155, 43.145546000000138],
              [42.642487, 43.143883],
              [42.625824, 43.143044],
              [42.613045, 43.147774],
              [42.539719000000105, 43.178322],
              [42.534431, 43.181107000000111],
              [42.52887, 43.184151],
              [42.489159, 43.216103],
              [42.4786, 43.22275500000012],
              [42.466660000000104, 43.22777],
              [42.453873000000101, 43.232201],
              [42.43304, 43.23776],
              [42.41527, 43.239159],
              [42.388329, 43.239426],
              [42.37137, 43.238602],
              [42.36388, 43.237488],
              [42.270821, 43.238045000000113],
              [42.196938000000102, 43.23721],
              [42.181107, 43.235550000000103],
              [42.174431, 43.233871],
              [42.16387, 43.22804],
              [42.111176, 43.197281],
              [42.031097, 43.187485],
              [41.605263, 43.220261],
              [41.58971, 43.22275500000012],
              [41.564995, 43.232201],
              [41.43555, 43.296097],
              [41.213608, 43.378876],
              [41.193047, 43.38472],
              [41.1680530000001, 43.387215],
              [41.134438, 43.385262],
              [41.11916, 43.383041],
              [41.077766, 43.37305],
              [41.05999, 43.372765],
              [41.044159, 43.374985],
              [41.037766, 43.377213],
              [41.021378, 43.385818],
              [41.006653, 43.395546],
              [40.961098000000106, 43.423607],
              [40.898041, 43.460815],
              [40.882484, 43.469986000000119],
              [40.863884, 43.477211],
              [40.834160000000111, 43.48333],
              [40.810822, 43.486931],
              [40.749718, 43.50443300000012],
              [40.73776, 43.50944],
              [40.7211, 43.517769000000101],
              [40.716660000000104, 43.521378],
              [40.695969, 43.54301],
              [40.68471, 43.545830000000137],
              [40.676102, 43.546654000000103],
              [40.658318000000122, 43.546097],
              [40.642487000000131, 43.544434000000138],
              [40.635818, 43.5425],
              [40.613045, 43.53194],
              [40.603325, 43.525269],
              [40.588036, 43.51611],
              [40.582497, 43.51361],
              [40.569153000000142, 43.50972],
              [40.54305, 43.5086060000001],
              [40.518593000000124, 43.511658],
              [40.488884, 43.517769000000101],
              [40.36805, 43.553322],
              [40.354996, 43.55777],
              [40.343880000000127, 43.563324],
              [40.324432, 43.56971],
              [40.294716000000108, 43.576096],
              [40.253387, 43.582520000000102],
              [40.220818, 43.584717],
              [40.201935000000105, 43.584717],
              [40.177483, 43.5825],
              [40.16249, 43.579987000000131],
              [40.126656, 43.57222],
              [40.106934, 43.566376],
              [40.089989, 43.558327000000133],
              [40.084984, 43.554993000000138],
              [40.07749200000012, 43.54694],
              [40.021103, 43.444153],
              [40.00916, 43.41193],
              [40.002968, 43.379265],
              [39.945534, 43.396935],
              [39.923325, 43.40638],
              [39.919716000000108, 43.4086],
              [39.91109, 43.4161],
              [39.90749, 43.421928],
              [39.903603, 43.431374000000119],
              [39.8961, 43.457497000000103],
              [39.890831, 43.469986000000119],
              [39.887215, 43.476089],
              [39.878876, 43.487206000000128],
              [39.87027, 43.494713],
              [39.8536, 43.506386],
              [39.837212, 43.514435000000105],
              [39.696648, 43.60166],
              [39.589989, 43.674706000000128],
              [39.471924, 43.757767],
              [39.458603, 43.76721],
              [39.44999700000011, 43.774712],
              [39.416939000000127, 43.80999],
              [39.391930000000116, 43.843880000000127],
              [39.379715, 43.857216],
              [39.373871, 43.862206000000128],
              [39.286942000000124, 43.926941],
              [39.05166, 44.080269000000101],
              [38.971375000000137, 44.1436],
              [38.963875, 44.14804],
              [38.950539000000106, 44.153603],
              [38.935265, 44.1586],
              [38.923882, 44.16137700000013],
              [38.900826, 44.164429],
              [38.882484, 44.168053],
              [38.869156, 44.173607],
              [38.84444, 44.189980000000105],
              [38.814713, 44.214706],
              [38.772217000000126, 44.260544],
              [38.760277, 44.270264000000111],
              [38.747208000000114, 44.276375],
              [38.6055530000001, 44.328049],
              [38.59415, 44.330826000000116],
              [38.57111, 44.333878],
              [38.413605000000132, 44.350266],
              [38.350822, 44.354996000000142],
              [38.324432, 44.359711],
              [38.219704, 44.38361],
              [38.197487000000137, 44.389435],
              [38.180817, 44.397217000000126],
              [38.170273, 44.40416],
              [38.16193, 44.411652],
              [38.15527, 44.419991],
              [38.146378, 44.438881],
              [38.145821, 44.442215],
              [38.13332400000013, 44.46666],
              [38.116096, 44.489159],
              [37.87165, 44.68888],
              [37.86554, 44.693871],
              [37.852776, 44.699715],
              [37.788048000000117, 44.724991000000102],
              [37.781937, 44.726089],
              [37.777489, 44.724991000000102],
              [37.775551000000121, 44.7211],
              [37.777489, 44.71471],
              [37.794434, 44.695534],
              [37.80415, 44.684708],
              [37.820824, 44.669434000000138],
              [37.823875, 44.663315000000125],
              [37.82527, 44.652489],
              [37.82276, 44.64415],
              [37.820541, 44.640266],
              [37.813881, 44.636101],
              [37.79639, 44.63165],
              [37.766663000000108, 44.629715],
              [37.75083, 44.62999],
              [37.556656, 44.654160000000104],
              [37.48832, 44.669434000000138],
              [37.483597, 44.671371],
              [37.476089, 44.675545],
              [37.378319, 44.738602],
              [37.370537, 44.746651],
              [37.299164000000133, 44.859428],
              [37.296387, 44.87165],
              [37.308327000000133, 44.882767000000115],
              [37.31082, 44.88610100000011],
              [37.312485, 44.894150000000138],
              [37.311104, 44.900826],
              [37.309433, 44.90416],
              [37.304703000000131, 44.909714],
              [37.27637, 44.931107000000111],
              [37.207497000000103, 44.97693],
              [37.200272, 44.981659],
              [37.19638, 44.983597000000145],
              [36.88221, 45.085815000000139],
              [36.722214, 45.098595000000103],
              [36.710815, 45.099709],
              [36.629433, 45.125259],
              [36.621651, 45.129433],
              [36.579987000000131, 45.175545000000113],
              [36.575272, 45.184708000000114],
              [36.575272, 45.188324],
              [36.576096, 45.19249],
              [36.57805, 45.19638],
              [36.580544, 45.19971],
              [36.58416, 45.201935],
              [36.594147, 45.202492],
              [36.669716, 45.20527],
              [36.699715, 45.199997],
              [36.704987, 45.199997],
              [36.7286, 45.203316],
              [36.831383, 45.226372],
              [36.83581, 45.227486],
              [36.848038, 45.231934],
              [36.888596000000121, 45.246941],
              [36.96054, 45.27499],
              [36.964149, 45.283051000000114],
              [36.9697, 45.300545],
              [36.96888, 45.307487],
              [36.96666, 45.310265],
              [36.96194, 45.312202000000127],
              [36.779709, 45.384720000000129],
              [36.77387, 45.385262],
              [36.768883, 45.384720000000129],
              [36.756104000000107, 45.380814],
              [36.71888, 45.361931000000141],
              [36.708603, 45.35526],
              [36.697487, 45.343323000000112],
              [36.693604, 45.33554],
              [36.691093, 45.33221],
              [36.68748, 45.329987000000131],
              [36.67971, 45.326653000000135],
              [36.669434000000138, 45.326096],
              [36.665543, 45.328049],
              [36.663315000000125, 45.330826000000116],
              [36.66249, 45.334435],
              [36.663315000000125, 45.338326],
              [36.667206, 45.3461],
              [36.675819, 45.355553],
              [36.684708, 45.363602],
              [36.71859, 45.393044000000145],
              [36.731377, 45.402771],
              [36.74527, 45.411652],
              [36.756943, 45.41666],
              [36.821663, 45.43499],
              [36.830826, 45.436646],
              [36.836655, 45.436104000000114],
              [36.896378, 45.423607000000118],
              [37.094147, 45.340546],
              [37.068047, 45.26082],
              [37.065536, 45.2575],
              [37.063881, 45.249428],
              [37.063881, 45.245827],
              [37.068604, 45.240273],
              [37.077209, 45.236382],
              [37.104996000000142, 45.23443],
              [37.115822, 45.23443],
              [37.15416, 45.23943],
              [37.226372, 45.248871],
              [37.314713, 45.269981000000143],
              [37.318604000000107, 45.27166],
              [37.31971, 45.275269],
              [37.318329000000119, 45.27833],
              [37.308884, 45.28194],
              [37.297211, 45.284431],
              [37.216385, 45.298607],
              [37.205269, 45.299164000000133],
              [37.204163000000108, 45.324158000000125],
              [37.316933, 45.321663000000115],
              [37.397774, 45.316376],
              [37.4261, 45.320541],
              [37.442757, 45.326096],
              [37.461937, 45.334717],
              [37.483597, 45.346657000000107],
              [37.514153000000135, 45.361931000000141],
              [37.518593, 45.36304],
              [37.52304, 45.362488],
              [37.52777, 45.36082],
              [37.58416, 45.338326],
              [37.596657, 45.33221],
              [37.60193, 45.326935],
              [37.604996, 45.313324],
              [37.713326, 45.296097],
              [37.729424, 45.29583],
              [37.733871000000136, 45.29694],
              [37.737206, 45.299164000000133],
              [37.73804, 45.303322],
              [37.740822, 45.383041000000105],
              [37.703049, 45.55555],
              [37.70138, 45.55859],
              [37.699158000000125, 45.561371],
              [37.64599, 45.587994],
              [37.641487, 45.59082],
              [37.640324000000135, 45.588989],
              [37.638325000000123, 45.583656],
              [37.63732, 45.578823],
              [37.62165, 45.571938],
              [37.62249, 45.568604000000107],
              [37.624702, 45.565819],
              [37.62943300000012, 45.563881],
              [37.647484000000134, 45.520264],
              [37.64666, 45.45361],
              [37.645821, 45.449425],
              [37.634995, 45.427483],
              [37.63221, 45.424431],
              [37.623322, 45.4161],
              [37.61916, 45.41443],
              [37.614159, 45.413605],
              [37.60332, 45.414986],
              [37.593323, 45.41832],
              [37.586098, 45.422768],
              [37.583878000000141, 45.425545],
              [37.582497000000103, 45.428879],
              [37.582497000000103, 45.43249],
              [37.59137, 45.62748],
              [37.598328, 45.645821],
              [37.60666, 45.655266],
              [37.619980000000112, 45.664429],
              [37.623604000000114, 45.66666],
              [37.628593, 45.66582],
              [37.634163, 45.660538],
              [37.635544, 45.657494],
              [37.636375, 45.65387],
              [37.635544, 45.649712],
              [37.633041, 45.64666],
              [37.645264000000111, 45.62915],
              [37.66348, 45.618603],
              [37.666313, 45.61526],
              [37.671486, 45.612938],
              [37.676987, 45.613934],
              [37.70387, 45.618874000000119],
              [37.705826000000116, 45.621933],
              [37.702766, 45.628036],
              [37.67137, 45.648872],
              [37.663605000000132, 45.65694],
              [37.65998100000013, 45.66277],
              [37.660271000000137, 45.666100000000142],
              [37.663048, 45.66916],
              [37.67083, 45.672493],
              [37.692757, 45.67832],
              [37.7197, 45.691376],
              [37.803040000000124, 45.735268],
              [37.816666, 45.744431],
              [37.828873, 45.755272],
              [37.840271, 45.767487],
              [37.848038, 45.777206],
              [37.854439000000127, 45.788879000000122],
              [37.868317, 45.816666000000112],
              [37.876938, 45.838875],
              [37.88444, 45.864159],
              [37.88472, 45.872208],
              [37.883606, 45.890266],
              [37.88888, 45.914711000000125],
              [37.892487, 45.931107000000111],
              [37.912766, 45.987488],
              [37.923607, 46.00665],
              [37.931374, 46.016663000000108],
              [37.940262000000132, 46.025826000000109],
              [37.946938000000102, 46.03054],
              [37.95443, 46.034431],
              [37.963051000000121, 46.037209],
              [38.052216000000101, 46.05915],
              [38.06721, 46.06055],
              [38.08554, 46.057770000000119],
              [38.094147, 46.053596],
              [38.096657000000107, 46.050819],
              [38.070541, 45.953606],
              [38.095543000000134, 45.944984],
              [38.159157, 46.099991000000102],
              [38.163872, 46.107216],
              [38.172768, 46.115822],
              [38.179436, 46.120827000000133],
              [38.190262, 46.127213],
              [38.202209, 46.13193],
              [38.21583, 46.135262],
              [38.225548, 46.136101],
              [38.252213, 46.136375],
              [38.264153, 46.13361],
              [38.27193, 46.129433],
              [38.278328000000101, 46.124428],
              [38.314156000000139, 46.097771],
              [38.35555, 46.07332],
              [38.40638, 46.045273000000122],
              [38.445534, 46.027489],
              [38.456940000000145, 46.025269],
              [38.467766, 46.025269],
              [38.54361, 46.025826000000109],
              [38.548325, 46.026375],
              [38.556374000000119, 46.02943],
              [38.56304200000011, 46.034431],
              [38.565262000000132, 46.038322],
              [38.566376000000105, 46.042213],
              [38.569984, 46.058594],
              [38.574158, 46.08221],
              [38.574432, 46.08971],
              [38.573044, 46.096657000000107],
              [38.565262000000132, 46.104706000000135],
              [38.557487, 46.109154000000103],
              [38.51499200000012, 46.12915],
              [38.424706, 46.167496],
              [38.34499, 46.199158],
              [38.308594, 46.210541],
              [38.296097, 46.216660000000104],
              [38.293053, 46.219147000000135],
              [38.28611, 46.227486],
              [38.280823000000112, 46.240273],
              [38.279427, 46.247208],
              [38.272758, 46.266930000000116],
              [38.265831000000105, 46.275269],
              [38.25972, 46.280266],
              [38.160812, 46.34859],
              [38.09137, 46.388039000000106],
              [38.08332, 46.39222],
              [38.07304, 46.395546],
              [38.060822, 46.39748],
              [37.993874000000119, 46.399155],
              [37.984154, 46.39748],
              [37.98026, 46.395821],
              [37.97443, 46.389709],
              [37.97443, 46.386101],
              [37.980537, 46.381104],
              [37.990273, 46.37748],
              [38.00694, 46.373047],
              [38.01082, 46.370827],
              [38.016388, 46.365540000000124],
              [38.009438, 46.354706],
              [38.004166000000112, 46.348038],
              [38.000832000000116, 46.345261],
              [37.996941, 46.34388],
              [37.991936, 46.3447],
              [37.983871, 46.348877],
              [37.90416, 46.402206],
              [37.89137, 46.412209000000132],
              [37.827209, 46.476089],
              [37.820824, 46.483871000000136],
              [37.7336, 46.661934],
              [37.732758, 46.665268],
              [37.734993, 46.669159],
              [37.73916, 46.671371000000136],
              [37.744156, 46.671928],
              [37.748871, 46.669991],
              [37.77693, 46.654984],
              [37.801384, 46.638878],
              [37.809433, 46.63444],
              [37.839706, 46.624161],
              [37.851379, 46.622208],
              [37.873604, 46.621368],
              [38.00054200000011, 46.618874],
              [38.01611, 46.618874],
              [38.034714, 46.62249],
              [38.051102000000128, 46.628876],
              [38.058327, 46.633324],
              [38.096375, 46.665825],
              [38.103043, 46.670830000000137],
              [38.117493000000138, 46.679436],
              [38.125824, 46.68277],
              [38.258881, 46.724152000000117],
              [38.268044, 46.72609],
              [38.27415, 46.72555],
              [38.279709000000139, 46.723877],
              [38.282761, 46.721375],
              [38.288879, 46.709160000000111],
              [38.292496000000142, 46.699425],
              [38.294716, 46.685265],
              [38.299164000000133, 46.67971],
              [38.302483000000109, 46.677216],
              [38.312759, 46.673882000000106],
              [38.387772, 46.652771],
              [38.44860100000011, 46.641663],
              [38.466385, 46.639709],
              [38.577209, 46.649712],
              [38.581657, 46.650826],
              [38.585258, 46.652771],
              [38.591103, 46.658875],
              [38.59304, 46.666939],
              [38.592484, 46.67804],
              [38.584435, 46.6933140000001],
              [38.578873000000101, 46.698601],
              [38.565536, 46.708046],
              [38.550819, 46.71666],
              [38.492493000000138, 46.737488],
              [38.473595, 46.74054],
              [38.417496, 46.74305],
              [38.40331, 46.74054],
              [38.39526, 46.737206],
              [38.388329000000113, 46.73249],
              [38.386658, 46.728043],
              [38.3863750000001, 46.720543],
              [38.38943, 46.714432],
              [38.390266, 46.710815],
              [38.389153, 46.70665],
              [38.385262, 46.705269],
              [38.38027, 46.70694],
              [38.37721, 46.709435],
              [38.373322, 46.715546],
              [38.366936, 46.738884],
              [38.36472, 46.749161],
              [38.366653, 46.753609],
              [38.408043, 46.824715],
              [38.410812000000135, 46.828049],
              [38.414429, 46.830269000000101],
              [38.462494000000106, 46.856934000000138],
              [38.470543000000134, 46.860268000000133],
              [38.480263, 46.861664000000133],
              [38.48582, 46.861664000000133],
              [38.49221, 46.86055],
              [38.503319, 46.857491],
              [38.639435000000105, 46.85915],
              [38.673836, 46.861191],
              [38.697762, 46.860825],
              [38.70721, 46.862206],
              [38.777489, 46.881927],
              [38.800377, 46.88929000000013],
              [38.914146, 46.937759000000142],
              [38.989983, 46.977211],
              [39.014992, 46.993874000000119],
              [39.065819, 47.024712],
              [39.06971, 47.026649000000134],
              [39.07887, 47.02887],
              [39.084435, 47.0286],
              [39.183594, 47.020264000000111],
              [39.252495000000124, 47.008881],
              [39.264435, 47.0075],
              [39.26971, 47.007767000000115],
              [39.273598, 47.00944],
              [39.276932, 47.012215],
              [39.281937, 47.019150000000138],
              [39.28583, 47.028046],
              [39.299988, 47.076935],
              [39.278603, 47.226089],
              [39.276649, 47.236382000000106],
              [39.272217, 47.24583],
              [39.265831000000105, 47.253876],
              [39.256386, 47.26137],
              [39.24665, 47.26499200000012],
              [39.092484000000127, 47.28054],
              [39.067490000000134, 47.277771],
              [38.965271, 47.258606],
              [38.952492, 47.254433],
              [38.943604, 47.24527],
              [38.930817, 47.2211],
              [38.929710000000114, 47.213326],
              [38.810547, 47.162209000000132],
              [38.76888300000013, 47.159714000000122],
              [38.753876000000105, 47.158318],
              [38.659157000000107, 47.135818],
              [38.566376000000105, 47.11304],
              [38.562759000000142, 47.111107],
              [38.55777, 47.110550000000103],
              [38.551659, 47.111107],
              [38.52276, 47.116936],
              [38.49305, 47.124161],
              [38.48249, 47.127480000000105],
              [38.479424, 47.12999],
              [38.477768, 47.133041000000105],
              [38.47998, 47.136932],
              [38.503609, 47.162209000000132],
              [38.551384, 47.209717],
              [38.55777, 47.214989],
              [38.565819, 47.218323],
              [38.574997, 47.220261000000107],
              [38.599152, 47.224434],
              [38.67638, 47.236382000000106],
              [38.74305, 47.24221],
              [38.768593000000124, 47.253319],
              [38.674431, 47.248604],
              [38.604706, 47.240273],
              [38.58194, 47.234993],
              [38.545273, 47.220261000000107],
              [38.529984000000127, 47.212212],
              [38.51693, 47.201935000000105],
              [38.488319000000104, 47.17083],
              [38.454163, 47.136101],
              [38.44999700000011, 47.134438],
              [38.353882000000112, 47.121651],
              [38.3336, 47.119713000000104],
              [38.32721, 47.120827],
              [38.314156000000139, 47.127213],
              [38.308327000000133, 47.127762000000132],
              [38.303596, 47.126656000000139],
              [38.235825, 47.109428],
              [38.225548, 47.127762000000132],
              [38.214149000000134, 47.18277],
              [38.214432000000102, 47.190262],
              [38.2161, 47.19471],
              [38.222755, 47.206383],
              [38.231377, 47.215546],
              [38.253876, 47.228043],
              [38.301102, 47.301102],
              [38.223312000000135, 47.339989],
              [38.280823000000112, 47.506104000000107],
              [38.29832, 47.551659],
              [38.303322, 47.55859],
              [38.33943, 47.601379],
              [38.349991, 47.60833],
              [38.35833, 47.611382000000106],
              [38.36776, 47.613602000000128],
              [38.44887, 47.62832],
              [38.458878, 47.62943300000012],
              [38.488319000000104, 47.627213],
              [38.504990000000134, 47.626938],
              [38.53721, 47.62804],
              [38.577492, 47.632484],
              [38.60582, 47.638039],
              [38.614716000000101, 47.640831000000105],
              [38.75054200000011, 47.683868000000132],
              [38.754715, 47.68555],
              [38.761658, 47.69026],
              [38.765831, 47.698601],
              [38.769707, 47.714989],
              [38.7711, 47.726646],
              [38.789986, 47.77887],
              [38.81693300000012, 47.83221],
              [38.82861, 47.8447],
              [38.838326, 47.85278],
              [38.853600000000142, 47.86082],
              [38.862488, 47.863319000000104],
              [38.871933, 47.86554],
              [38.897217, 47.868317000000104],
              [38.924706, 47.868317000000104],
              [39.03817, 47.8658],
              [39.11304, 47.839149],
              [39.123604, 47.835815],
              [39.1363750000001, 47.833878],
              [39.14666, 47.834717],
              [39.189156, 47.84304],
              [39.24665, 47.852486000000113],
              [39.262772, 47.853325],
              [39.345261, 47.853043],
              [39.36249, 47.851929],
              [39.38055, 47.847771],
              [39.388596, 47.843323000000112],
              [39.398041, 47.835815],
              [39.40609, 47.831383],
              [39.411652, 47.829720000000123],
              [39.422493, 47.829987],
              [39.432213, 47.831383],
              [39.479706000000135, 47.839432],
              [39.599152, 47.839432],
              [39.610825, 47.838593000000117],
              [39.643044, 47.832764000000111],
              [39.674164000000133, 47.825554],
              [39.693604000000107, 47.82194],
              [39.723877, 47.81833],
              [39.738884, 47.81998],
              [39.760544, 47.82721],
              [39.768044000000145, 47.831383],
              [39.781097000000102, 47.842209000000139],
              [39.796387, 47.857216],
              [39.803879, 47.86805],
              [39.805817, 47.87249],
              [39.806931000000134, 47.876656000000139],
              [39.81971, 47.96583],
              [39.819984, 47.969704],
              [39.81944, 47.973038],
              [39.812202, 47.988884],
              [39.80749, 47.994431000000134],
              [39.792488, 48.007217],
              [39.777481, 48.020271],
              [39.775261, 48.023048],
              [39.77609, 48.026382],
              [39.903595000000109, 48.181664],
              [39.91749, 48.198326],
              [39.932762, 48.213326],
              [39.9488750000001, 48.220825],
              [39.998878, 48.29722],
              [39.921516, 48.368393],
              [39.86721, 48.50388],
              [39.858047, 48.541382],
              [39.854713, 48.551659],
              [39.853325, 48.55471],
              [39.85083, 48.557495000000131],
              [39.843605, 48.562492],
              [39.81944, 48.575554],
              [39.810272, 48.579720000000123],
              [39.798882000000106, 48.583054000000118],
              [39.78138, 48.58416],
              [39.760551, 48.582497],
              [39.732491, 48.582497],
              [39.66966200000013, 48.587639],
              [39.6586, 48.602493],
              [39.655548000000124, 48.608887],
              [39.656937, 48.616661],
              [39.70416, 48.7186],
              [39.727211, 48.762215],
              [39.78277, 48.802773],
              [39.803879, 48.817772],
              [39.812210000000107, 48.821381],
              [39.826385, 48.82444],
              [39.8316650000001, 48.824715],
              [39.85027, 48.822495],
              [39.86360900000011, 48.819992],
              [40.017494, 48.806656],
              [40.025269, 48.810822],
              [40.039719, 48.82027],
              [40.05999, 48.836937],
              [40.068329000000119, 48.847214],
              [40.070831, 48.85083],
              [40.07666, 48.86416],
              [40.076942, 48.867767],
              [40.07666, 48.874992000000134],
              [40.075272, 48.878326],
              [40.070549, 48.88388],
              [40.064156000000139, 48.88888500000013],
              [40.054436, 48.89277],
              [40.041939, 48.89583],
              [40.030273, 48.8961],
              [40.021378, 48.89361],
              [40.01361, 48.889435],
              [39.949997, 48.867493000000138],
              [39.790276, 48.896942000000138],
              [39.777771, 48.899994],
              [39.767212, 48.903877000000136],
              [39.694435000000112, 48.973045],
              [39.693047, 48.979988],
              [39.696655000000135, 49.010826],
              [39.699158, 49.022766],
              [39.703323, 49.035271],
              [39.7075, 49.03666],
              [39.823326, 49.052216],
              [39.909714000000122, 49.049721],
              [39.92555, 49.050827],
              [39.938881, 49.054993000000138],
              [39.942215, 49.05777],
              [39.945267, 49.066101000000117],
              [39.93943, 49.078606],
              [39.93832, 49.085548000000131],
              [39.94054, 49.093880000000127],
              [39.951103, 49.107773],
              [39.966385, 49.123878000000104],
              [39.986382000000106, 49.140549],
              [39.997215, 49.148048],
              [40.008606, 49.15443],
              [40.054161, 49.174164],
              [40.081741000000136, 49.18383],
              [40.166939000000127, 49.248604],
              [40.168327, 49.254715],
              [40.179718, 49.32694],
              [40.177773, 49.339157000000114],
              [40.17388, 49.350273],
              [40.17083, 49.354996],
              [40.15638, 49.364998],
              [40.141663000000108, 49.376099000000124],
              [40.10972, 49.403877],
              [40.08888, 49.424713],
              [40.058044, 49.460823],
              [40.054161, 49.47193],
              [40.053047, 49.478325],
              [40.053322, 49.484993],
              [40.055824000000143, 49.49749],
              [40.062492000000134, 49.51388500000013],
              [40.07444, 49.526939],
              [40.08416, 49.534439],
              [40.103607000000125, 49.542496],
              [40.13138, 49.551659],
              [40.141106, 49.559158],
              [40.147774, 49.568886],
              [40.149994, 49.574165],
              [40.149994, 49.581108],
              [40.148048000000131, 49.586655],
              [40.139763, 49.601051],
              [40.068329000000119, 49.613052],
              [40.04277, 49.616661],
              [40.004997, 49.614441],
              [39.991936000000123, 49.61027],
              [39.980270000000132, 49.603882],
              [39.969986000000119, 49.595825],
              [39.957771, 49.583328],
              [39.950829000000113, 49.578049],
              [39.939156, 49.57166],
              [39.921661, 49.565544000000102],
              [39.89833, 49.559433],
              [39.859535, 49.551758],
              [39.821663000000115, 49.549438000000123],
              [39.809433, 49.55027],
              [39.796944, 49.55305],
              [39.66137700000013, 49.604713],
              [39.647217, 49.61055],
              [39.639717000000132, 49.615547],
              [39.63166, 49.623604],
              [39.625549, 49.632492],
              [39.62249, 49.638603000000103],
              [39.613052, 49.668602000000135],
              [39.595543, 49.706657],
              [39.58804, 49.722488],
              [39.58638, 49.725548],
              [39.580826, 49.73082],
              [39.476379, 49.756104],
              [39.464157, 49.758331],
              [39.45249200000012, 49.7586060000001],
              [39.43305, 49.754715],
              [39.41582, 49.74749],
              [39.408043, 49.743324],
              [39.390549, 49.736938000000123],
              [39.375824000000136, 49.733879],
              [39.365273, 49.733047],
              [39.35416, 49.732765],
              [39.328606, 49.736938000000123],
              [39.296387, 49.74388],
              [39.273605, 49.751938000000109],
              [39.258606, 49.76138],
              [39.25027, 49.769714],
              [39.24583, 49.778877],
              [39.241379, 49.796104],
              [39.236938, 49.809158000000139],
              [39.21027400000014, 49.865547],
              [39.207771, 49.868324],
              [39.2011, 49.873322],
              [39.19276, 49.877769],
              [39.183739, 49.8804090000001],
              [39.121933000000126, 49.856102000000135],
              [39.091934, 49.83111],
              [39.084991000000116, 49.825554],
              [39.07777, 49.820831],
              [39.069160000000124, 49.817772],
              [39.059433, 49.815544],
              [38.979431, 49.80777],
              [38.963326000000109, 49.806656],
              [38.951660000000118, 49.806656],
              [38.945267, 49.807495],
              [38.937767000000122, 49.812210000000107],
              [38.93277, 49.817772],
              [38.92083, 49.835548],
              [38.905823000000112, 49.85555],
              [38.903320000000122, 49.85833],
              [38.897491000000116, 49.863609],
              [38.88916, 49.86805],
              [38.866386, 49.874435],
              [38.825829, 49.88138],
              [38.689156000000139, 49.93526],
              [38.652214000000129, 49.958885000000123],
              [38.614441000000113, 49.963882],
              [38.595268, 49.96583],
              [38.58028, 49.963326],
              [38.54722, 49.954712],
              [38.515549, 49.951385],
              [38.498878, 49.951935000000105],
              [38.492767, 49.95361],
              [38.393051, 49.982491],
              [38.376099, 49.98749],
              [38.363327, 49.99777],
              [38.359161, 50.003609],
              [38.351936, 50.01944],
              [38.350548000000117, 50.026382],
              [38.34499, 50.043053],
              [38.34277, 50.04972],
              [38.33721, 50.059158],
              [38.33221, 50.06471],
              [38.32888, 50.067215],
              [38.320274, 50.071663],
              [38.30777, 50.073883],
              [38.301933, 50.073883],
              [38.19388, 50.0675],
              [38.188324000000136, 50.06694],
              [38.184158, 50.065544],
              [38.181107, 50.06221],
              [38.103607000000125, 49.938599000000124],
              [38.02422300000012, 49.903084],
              [38.01361, 49.934433],
              [37.98832700000014, 49.96249],
              [37.974991, 49.9761],
              [37.928604000000121, 50.022217],
              [37.925270000000125, 50.024712],
              [37.916664, 50.02916],
              [37.823326000000122, 50.061661],
              [37.793327, 50.06916],
              [37.753609, 50.07666],
              [37.744156, 50.080826],
              [37.73305, 50.087769],
              [37.649437, 50.18416],
              [37.463608000000136, 50.433876],
              [37.461937, 50.43721],
              [37.458603, 50.439713],
              [37.418602, 50.43804],
              [37.331665, 50.430275],
              [37.315826000000129, 50.428047],
              [37.311378, 50.426384],
              [37.293884000000105, 50.413879],
              [37.291107, 50.410545],
              [37.270828, 50.393883],
              [37.251663, 50.382767],
              [37.239716, 50.376938],
              [37.216934, 50.369713],
              [37.130547, 50.348328],
              [37.068886, 50.3386],
              [37.052773, 50.336937],
              [37.046387, 50.337494],
              [37.026382, 50.344994],
              [37.00722, 50.34888],
              [36.9786, 50.349434],
              [36.97332, 50.34888],
              [36.899162, 50.338882],
              [36.88444, 50.335823000000119],
              [36.810272, 50.314156],
              [36.717491, 50.274712000000136],
              [36.7011, 50.266937],
              [36.685822, 50.258049],
              [36.672768000000133, 50.246941000000106],
              [36.667213, 50.240273000000116],
              [36.662209, 50.23305],
              [36.65332, 50.217491],
              [36.649994, 50.214714],
              [36.640274, 50.212494000000106],
              [36.61805, 50.212212],
              [36.598877, 50.213882],
              [36.584991, 50.216103],
              [36.571938000000102, 50.218597],
              [36.562492000000134, 50.222488000000112],
              [36.55555, 50.227211],
              [36.552773000000116, 50.229988],
              [36.550270000000125, 50.232765],
              [36.54666, 50.23916],
              [36.54666, 50.246658000000139],
              [36.548882, 50.25055],
              [36.55777, 50.25999],
              [36.564156000000139, 50.265549000000135],
              [36.566101000000117, 50.269989],
              [36.566101000000117, 50.273605],
              [36.563324, 50.276382000000126],
              [36.558884, 50.278603],
              [36.553879, 50.280273],
              [36.47721, 50.301384],
              [36.419991, 50.313881],
              [36.381104000000107, 50.298882],
              [36.369156, 50.29277],
              [36.36055, 50.289436],
              [36.34694, 50.285],
              [36.3325, 50.281380000000127],
              [36.321663000000115, 50.280273],
              [36.302773, 50.282768],
              [36.297493, 50.284439],
              [36.284439, 50.290833000000134],
              [36.27388, 50.29805],
              [36.215828, 50.354996],
              [36.20527, 50.366104],
              [36.193878, 50.380547],
              [36.190269, 50.390549],
              [36.190269, 50.398048],
              [36.188324, 50.4011],
              [36.184715, 50.403603],
              [36.154709000000139, 50.41999],
              [36.145271, 50.423882],
              [36.13916, 50.425270000000125],
              [36.09193, 50.431107000000111],
              [36.059433, 50.43499],
              [36.007774, 50.439156000000139],
              [35.9786, 50.438324],
              [35.92749, 50.435822000000144],
              [35.894157, 50.433327000000133],
              [35.865829, 50.430824000000143],
              [35.850273, 50.428604000000121],
              [35.834435, 50.425270000000125],
              [35.820831000000112, 50.420830000000137],
              [35.747215, 50.387215],
              [35.73916, 50.383331],
              [35.693092, 50.347412],
              [35.687492, 50.346657],
              [35.67527, 50.347214],
              [35.644714000000135, 50.354164],
              [35.606651, 50.369438],
              [35.589149, 50.377769],
              [35.458282, 50.488068],
              [35.441055, 50.511971],
              [35.39271, 50.63392],
              [35.393555, 50.63808],
              [35.395775, 50.641975],
              [35.39883, 50.644753],
              [35.406883, 50.648643],
              [35.420502000000113, 50.65335],
              [35.486076, 50.678627],
              [35.463295, 50.756409],
              [35.460243000000105, 50.766685],
              [35.456627, 50.772789000000103],
              [35.365227, 50.920036],
              [35.361336, 50.926147000000128],
              [35.35578, 50.931709],
              [35.348831, 50.936432],
              [35.305771000000107, 50.96033],
              [35.309662, 50.982552],
              [35.344948000000102, 51.006439000000114],
              [35.358559, 51.01088],
              [35.37022, 51.017822000000137],
              [35.375504, 51.024483],
              [35.377724, 51.032257],
              [35.37661, 51.035606],
              [35.371887, 51.041435],
              [35.368279000000143, 51.043938],
              [35.358559, 51.047546000000125],
              [35.30188, 51.060616],
              [35.28521, 51.059235],
              [35.244095000000129, 51.050911],
              [35.222145000000125, 51.04842],
              [35.204926, 51.047577],
              [35.185196, 51.048973000000103],
              [35.170753, 51.054802000000109],
              [35.160744000000136, 51.062309],
              [35.152695000000108, 51.070648],
              [35.148804, 51.07676],
              [35.119637000000125, 51.151764],
              [35.124916, 51.176765],
              [35.124916, 51.180382],
              [35.124634, 51.18426],
              [35.121582000000103, 51.19843],
              [35.11852, 51.2048190000001],
              [35.111305000000129, 51.209541],
              [35.079086000000132, 51.21982],
              [35.07381, 51.221481],
              [34.974991000000102, 51.223602],
              [34.958046000000138, 51.22221],
              [34.947487, 51.219986],
              [34.939430000000129, 51.215828],
              [34.932213, 51.2061],
              [34.922768000000133, 51.198601],
              [34.917770000000132, 51.197212],
              [34.827217, 51.178047],
              [34.801102, 51.173607],
              [34.766663, 51.171379000000115],
              [34.734993, 51.172493],
              [34.708603, 51.174164000000133],
              [34.674713, 51.17749],
              [34.669991, 51.179436],
              [34.550545, 51.23333],
              [34.406937, 51.263611],
              [34.38221, 51.263611],
              [34.23916, 51.427773000000116],
              [34.240547, 51.436104],
              [34.246101, 51.49388],
              [34.245544000000109, 51.50139],
              [34.24305, 51.515549],
              [34.236107, 51.539993],
              [34.23416, 51.54666],
              [34.232208, 51.54999],
              [34.163048, 51.614716],
              [34.10416, 51.644714000000135],
              [34.1011, 51.647491],
              [34.098045000000127, 51.653877000000136],
              [34.0991590000001, 51.6661],
              [34.102776, 51.67444],
              [34.10555, 51.677773],
              [34.114716, 51.680824],
              [34.197769000000108, 51.696655],
              [34.255272, 51.7011],
              [34.37971, 51.713608000000136],
              [34.390831000000105, 51.714996],
              [34.405548, 51.718597000000102],
              [34.418884, 51.72388],
              [34.433327, 51.73276],
              [34.438599, 51.739433000000133],
              [34.44249, 51.752495000000124],
              [34.442764, 51.760551],
              [34.440544, 51.76721],
              [34.424713, 51.799438],
              [34.419716000000108, 51.80888],
              [34.38403, 51.843109],
              [34.339714000000129, 51.85555],
              [34.334991, 51.85777],
              [34.240547, 51.91138],
              [34.129158000000132, 51.986107],
              [34.087494, 52.031380000000127],
              [34.07972, 52.04361],
              [34.074165000000107, 52.056938],
              [34.073051000000135, 52.060272],
              [34.075829000000113, 52.116936000000123],
              [34.079437, 52.125549],
              [34.100273, 52.14138],
              [34.10083, 52.145546000000138],
              [34.09777, 52.151932],
              [34.06916, 52.190826000000129],
              [34.056656, 52.20138500000013],
              [33.83888, 52.36055],
              [33.830551, 52.364716],
              [33.818329000000119, 52.366936],
              [33.771378, 52.368881],
              [33.753052, 52.3686],
              [33.69638, 52.361664000000133],
              [33.68138, 52.357773],
              [33.628601000000117, 52.34193],
              [33.60166, 52.33194],
              [33.512772, 52.326942],
              [33.417702000000133, 52.3554],
              [33.414612, 52.355888],
              [33.378601, 52.364998000000128],
              [33.211380000000133, 52.379158],
              [33.20471, 52.379715],
              [33.195267, 52.37638],
              [33.038048, 52.305824],
              [32.971931, 52.272766],
              [32.941658000000132, 52.25388],
              [32.923607000000118, 52.24721],
              [32.909988, 52.248047],
              [32.7586060000001, 52.257774],
              [32.73166, 52.261383],
              [32.700829000000113, 52.268326],
              [32.63916, 52.289436000000137],
              [32.608887, 52.300545],
              [32.58443, 52.309715],
              [32.55249, 52.319992],
              [32.527214, 52.32444],
              [32.413322000000107, 52.335548],
              [32.394157, 52.335266],
              [32.38416, 52.33277],
              [32.371101000000124, 52.327217000000132],
              [32.36805, 52.32444],
              [32.360275, 52.314156],
              [32.35833, 52.30999],
              [32.328049000000135, 52.177773000000116],
              [32.328331, 52.173882],
              [32.332771, 52.16777],
              [32.335548000000131, 52.165268],
              [32.336937, 52.16166],
              [32.335548000000131, 52.157211],
              [32.303047, 52.112213000000111],
              [32.299164, 52.109436],
              [32.287216, 52.102776],
              [32.224991000000102, 52.07944],
              [32.129158000000132, 52.045273],
              [32.124435, 52.043884],
              [32.112213, 52.043327],
              [31.995827, 52.054436],
              [31.908886, 52.06944],
              [31.908886, 52.084991],
              [31.905273, 52.09166],
              [31.897774, 52.0961],
              [31.88805, 52.099998],
              [31.865829000000133, 52.106102],
              [31.846386, 52.1097180000001],
              [31.8316650000001, 52.111382000000106],
              [31.818886, 52.111382000000106],
              [31.783886000000109, 52.108047],
              [31.786110000000122, 52.12416],
              [31.787498, 52.152214000000129],
              [31.786663, 52.159988000000112],
              [31.7825, 52.165825],
              [31.7725, 52.173607],
              [31.758331000000112, 52.179161],
              [31.70138500000013, 52.2211],
              [31.599720000000104, 52.30555],
              [31.586662, 52.318886],
              [31.589165, 52.322495],
              [31.597218, 52.32666],
              [31.602219000000105, 52.328049],
              [31.6097180000001, 52.33277],
              [31.614719, 52.339714000000129],
              [31.628052, 52.361938],
              [31.629719000000136, 52.370544],
              [31.629162, 52.374435],
              [31.608887, 52.491379],
              [31.590553000000114, 52.589714],
              [31.583607, 52.59471],
              [31.506943, 52.677216000000101],
              [31.500275, 52.686104000000114],
              [31.5, 52.689987],
              [31.50194, 52.693878],
              [31.506664, 52.695267000000115],
              [31.518055, 52.69694],
              [31.543331, 52.697487000000137],
              [31.549164, 52.698326],
              [31.558331, 52.701385],
              [31.569717, 52.708603],
              [31.59222, 52.73416],
              [31.595, 52.738045],
              [31.595551000000114, 52.742218],
              [31.58833, 52.778603],
              [31.586662, 52.78583],
              [31.58083, 52.803047],
              [31.578609, 52.806099000000131],
              [31.539997, 52.85332],
              [31.536942, 52.856102],
              [31.508888, 52.857498000000135],
              [31.49388, 52.859161],
              [31.475826, 52.86332700000014],
              [31.438885000000141, 52.87943300000012],
              [31.415272, 52.893051000000128],
              [31.390831, 52.910271000000137],
              [31.266388, 53.021935],
              [31.266941, 53.024712000000136],
              [31.31472, 53.051384],
              [31.386383, 53.099159],
              [31.388329, 53.103325],
              [31.38861, 53.107498],
              [31.38722, 53.110825],
              [31.384995, 53.11388],
              [31.374828, 53.121933],
              [31.379997, 53.145],
              [31.386383, 53.16193],
              [31.39527500000014, 53.181381],
              [31.404716, 53.195824],
              [31.414162, 53.204437],
              [31.422497, 53.208885],
              [31.42749, 53.210274],
              [31.438885000000141, 53.211662000000103],
              [31.616108, 53.218323],
              [31.630276, 53.217209],
              [31.76916, 53.196098],
              [31.775555, 53.194153],
              [31.779442000000131, 53.191658],
              [31.78167, 53.188881],
              [31.786663, 53.178879000000109],
              [31.79222, 53.16166],
              [31.79583, 53.147217],
              [31.796665, 53.13193],
              [31.801109, 53.125824],
              [31.804996, 53.123604],
              [31.918327, 53.098328],
              [31.95805, 53.09444],
              [32.10555, 53.087212],
              [32.118599000000131, 53.087212],
              [32.136658, 53.0886],
              [32.147491, 53.090546],
              [32.22332, 53.1055530000001],
              [32.298882, 53.13193],
              [32.414154, 53.191376000000105],
              [32.429718, 53.200829000000113],
              [32.43999, 53.208885],
              [32.452217, 53.2211],
              [32.611938, 53.313049],
              [32.724434, 53.360275000000115],
              [32.736542, 53.438362],
              [32.739716, 53.44694],
              [32.741379, 53.45943],
              [32.741104, 53.463051],
              [32.738045, 53.46583],
              [32.670547000000113, 53.497215],
              [32.65971, 53.499718],
              [32.644714, 53.501389000000131],
              [32.637772, 53.501938],
              [32.624992000000134, 53.501389000000131],
              [32.615547000000106, 53.498329],
              [32.4786, 53.550827],
              [32.46888, 53.55471],
              [32.453049, 53.563881],
              [32.443878, 53.571938000000102],
              [32.438599, 53.57777],
              [32.42638, 53.5961],
              [32.422493, 53.606384],
              [32.41499, 53.642494000000113],
              [32.414711000000125, 53.64638],
              [32.417213, 53.64972],
              [32.435265, 53.651657000000114],
              [32.486382, 53.664436000000137],
              [32.50388, 53.6722180000001],
              [32.509163, 53.679161],
              [32.510551000000135, 53.683601000000124],
              [32.510277, 53.687492],
              [32.50666, 53.693878],
              [32.488327, 53.709991000000116],
              [32.48027, 53.714439],
              [32.461662, 53.72276],
              [32.45166, 53.726379],
              [32.329437, 53.76221],
              [32.119713000000104, 53.819992000000127],
              [31.99305, 53.80249],
              [31.97138, 53.79833200000013],
              [31.935551, 53.789162],
              [31.902218, 53.777771000000143],
              [31.89583, 53.777489],
              [31.88139, 53.778603],
              [31.76422, 53.80262],
              [31.76422, 53.806076000000132],
              [31.773888000000113, 53.82888000000014],
              [31.784443, 53.845825],
              [31.78833, 53.848328],
              [31.806942, 53.854996],
              [31.81277, 53.861382000000106],
              [31.828884, 53.886383000000137],
              [31.85722, 53.96971],
              [31.865273000000116, 54.006104],
              [31.846943000000124, 54.057495],
              [31.844162, 54.064438000000109],
              [31.761665, 54.103325],
              [31.75, 54.106384],
              [31.735271, 54.107216],
              [31.717216000000121, 54.105553],
              [31.675552, 54.106659],
              [31.54416300000014, 54.143326],
              [31.524166, 54.150826],
              [31.33166, 54.237495],
              [31.329441, 54.24055],
              [31.326664000000108, 54.24749],
              [31.310829, 54.29666],
              [31.309998, 54.304161],
              [31.310829, 54.323608],
              [31.312496, 54.343323],
              [31.313053000000139, 54.347488],
              [31.311665, 54.35083],
              [31.231937, 54.456657],
              [31.228607, 54.45943],
              [31.221661, 54.460548],
              [31.19860100000011, 54.460938],
              [31.13055, 54.478600000000142],
              [31.10694100000012, 54.485268],
              [31.092773, 54.491104],
              [31.086662, 54.495544],
              [31.084442000000138, 54.498604],
              [31.0825, 54.505554],
              [31.082775, 54.50972],
              [31.086662, 54.517769],
              [31.097218000000112, 54.531662],
              [31.111385, 54.547775000000115],
              [31.131664, 54.570549],
              [31.144718000000125, 54.582214000000135],
              [31.10305, 54.64555],
              [31.0125, 54.706657000000121],
              [31.004997, 54.711662],
              [30.91944100000012, 54.751389],
              [30.876385, 54.769157],
              [30.844162, 54.779716000000121],
              [30.83194, 54.782768],
              [30.78638, 54.79166],
              [30.78139, 54.79361],
              [30.779999, 54.796944],
              [30.783054, 54.814156],
              [30.790833000000134, 54.835548],
              [30.798607000000118, 54.851662],
              [30.838886, 54.922493],
              [30.864719, 54.94721],
              [30.899998, 54.952217],
              [30.916386000000102, 54.955826],
              [30.936661, 54.961662000000103],
              [30.94416, 54.966103],
              [31.024441, 55.030823],
              [31.028332, 55.038605000000132],
              [31.02972, 55.043327],
              [31.03, 55.049721],
              [31.026943, 55.056381000000101],
              [30.97805, 55.152214],
              [30.948330000000112, 55.18943],
              [30.939716, 55.19388],
              [30.922497, 55.198875],
              [30.91333, 55.203049],
              [30.819717, 55.283882],
              [30.815, 55.28999],
              [30.81361, 55.29333],
              [30.813332, 55.301102],
              [30.815552, 55.309433000000126],
              [30.817497, 55.313324],
              [30.831387, 55.329994],
              [30.857773, 55.353607],
              [30.886662000000115, 55.374992],
              [30.891941, 55.376381],
              [30.911106, 55.37777],
              [30.915829, 55.379433],
              [30.927773, 55.386658],
              [30.937496, 55.395546],
              [30.939438, 55.399437],
              [30.940273, 55.41582],
              [30.939995, 55.495827000000133],
              [30.930275, 55.577774],
              [30.926247000000103, 55.60257],
              [30.918884, 55.60833],
              [30.910275, 55.613052],
              [30.893051, 55.617767000000129],
              [30.87694, 55.61916],
              [30.86360900000011, 55.618599],
              [30.846386000000109, 55.615547000000106],
              [30.836384000000123, 55.612495],
              [30.79472, 55.595543],
              [30.782776000000126, 55.59388],
              [30.768887, 55.593605],
              [30.756664, 55.596657],
              [30.75222, 55.598877],
              [30.655273, 55.660545],
              [30.613052, 55.704712],
              [30.614998, 55.717491],
              [30.612495, 55.720268],
              [30.60333, 55.7286],
              [30.493328000000133, 55.79805],
              [30.489716, 55.799995],
              [30.466663, 55.80555],
              [30.245827, 55.854439],
              [29.97251, 55.856369],
              [29.946384, 55.854439],
              [29.928329, 55.85166],
              [29.906940000000134, 55.8461],
              [29.656384, 55.765274],
              [29.540833, 55.702217],
              [29.52639, 55.691376],
              [29.51527, 55.689156000000139],
              [29.493885, 55.68888],
              [29.48777, 55.690544],
              [29.47916, 55.69471],
              [29.392773, 55.751389],
              [29.385830000000112, 55.756386000000134],
              [29.379162000000122, 55.761665000000107],
              [29.37138, 55.770546],
              [29.359161, 55.78944],
              [29.35833, 55.793327],
              [29.360828, 55.802216000000101],
              [29.404442, 55.892494],
              [29.40694, 55.895828],
              [29.410275000000127, 55.89888],
              [29.419441, 55.902771000000143],
              [29.442493, 55.906654000000117],
              [29.461941, 55.908325],
              [29.464439, 55.911102],
              [29.463608000000136, 55.914711],
              [29.45694, 55.924164],
              [29.44944, 55.933052],
              [29.425274, 55.951103],
              [29.412216, 55.957771],
              [29.401386, 55.96138],
              [29.17222, 56.015549],
              [29.139164, 56.02193],
              [29.059441, 56.03277],
              [29.033333, 56.030548000000124],
              [29.021942, 56.028328000000101],
              [29.0061070000001, 56.023880000000133],
              [28.869442, 55.980545],
              [28.860828, 55.976097],
              [28.850517000000139, 55.969078000000138],
              [28.846386000000109, 55.960274],
              [28.845276000000126, 55.955551],
              [28.845829, 55.951935],
              [28.849998, 55.945541000000105],
              [28.846943, 55.94249],
              [28.83277500000014, 55.942215],
              [28.754166, 55.95388000000014],
              [28.73805, 55.958328000000108],
              [28.73127, 55.96241],
              [28.719715, 55.974709000000132],
              [28.708050000000128, 55.99416],
              [28.707218, 55.997772],
              [28.705551000000128, 56.005272000000105],
              [28.707218, 56.018051000000128],
              [28.705551000000128, 56.025551],
              [28.702217000000132, 56.032211],
              [28.697216, 56.03833],
              [28.653885, 56.088882],
              [28.646107, 56.093605000000139],
              [28.628052, 56.09833],
              [28.613884, 56.100273000000129],
              [28.53555, 56.104996],
              [28.52083, 56.10527],
              [28.387497, 56.0961],
              [28.382217000000139, 56.094711],
              [28.37833, 56.09222],
              [28.367775, 56.078606],
              [28.362495000000138, 56.066666],
              [28.358498, 56.061546],
              [28.353607000000125, 56.05694],
              [28.34972, 56.05471],
              [28.34, 56.051102],
              [28.312496000000124, 56.049995000000138],
              [28.307301, 56.052727],
              [28.188885, 56.132767],
              [28.185272000000111, 56.135269],
              [28.168606000000125, 56.148605],
              [28.168011, 56.1501540000001],
              [28.181938000000116, 56.160545000000127],
              [28.184994, 56.163322],
              [28.195, 56.17749],
              [28.199162, 56.18499],
              [28.237495, 56.262772],
              [28.237774, 56.271103],
              [28.23555, 56.282211],
              [28.233051, 56.289436],
              [28.182774, 56.40638],
              [28.147774, 56.471375],
              [28.114162, 56.51749],
              [28.00944, 56.64833],
              [27.943607, 56.722763],
              [27.9175, 56.786110000000122],
              [27.924717, 56.791382],
              [27.931107, 56.797493],
              [27.933605, 56.801102000000128],
              [27.940552, 56.81694],
              [27.940552, 56.821106],
              [27.938885000000141, 56.82444],
              [27.93527, 56.827217000000132],
              [27.860554, 56.868881],
              [27.837776, 56.875549],
              [27.815552000000139, 56.878326000000129],
              [27.807220000000143, 56.87888],
              [27.79361, 56.877769],
              [27.762497, 56.873604],
              [27.731106, 56.869156],
              [27.70166, 56.914711],
              [27.774719, 57.057213],
              [27.846386, 57.169991],
              [27.848331000000144, 57.174164],
              [27.851387, 57.187767],
              [27.863884, 57.262497],
              [27.866386, 57.288048000000117],
              [27.865551, 57.291939],
              [27.861107000000118, 57.30222],
              [27.85305, 57.311104],
              [27.849163, 57.313606],
              [27.825275, 57.323883],
              [27.687218, 57.37999],
              [27.606384, 57.410545],
              [27.580276, 57.415825],
              [27.562496000000124, 57.420547],
              [27.53833, 57.430824000000143],
              [27.527222, 57.438599],
              [27.525555, 57.441658],
              [27.525555, 57.44582400000013],
              [27.526386, 57.449432],
              [27.542774, 57.493607],
              [27.547218, 57.536385],
              [27.47166, 57.531380000000127],
              [27.44944, 57.531105],
              [27.424995, 57.531937],
              [27.372059, 57.535637],
              [27.363331, 57.54416],
              [27.361664000000133, 57.547493000000145],
              [27.353329, 57.568604],
              [27.348053, 57.583054000000118],
              [27.34694, 57.586937],
              [27.34694, 57.5911],
              [27.348053, 57.595543000000134],
              [27.400829, 57.678047],
              [27.40583, 57.68499],
              [27.545830000000137, 57.817772],
              [27.55139, 57.819443],
              [27.577221, 57.82277],
              [27.629997000000117, 57.828606],
              [27.673607000000118, 57.830276],
              [27.702217000000132, 57.831665],
              [27.734993, 57.835548],
              [27.753052, 57.839157],
              [27.785275, 57.84833],
              [27.813885, 57.860275000000115],
              [27.82111, 57.865829],
              [27.822773, 57.869713000000104],
              [27.823051000000135, 57.873878000000104],
              [27.820274, 57.881104],
              [27.817497000000117, 57.88388],
              [27.809998000000121, 57.88888500000013],
              [27.805275, 57.891106],
              [27.784721, 57.89888],
              [27.77333, 57.902214],
              [27.686661, 57.965271],
              [27.680828, 58.062492],
              [27.677219, 58.074165000000107],
              [27.67332800000014, 58.07888000000014],
              [27.663052, 58.087212000000136],
              [27.65, 58.094154],
              [27.641106, 58.0961],
              [27.625275, 58.101662],
              [27.60972, 58.107216],
              [27.60194, 58.109993000000145],
              [27.58, 58.11916],
              [27.565830000000119, 58.125267],
              [27.554165, 58.132767000000115],
              [27.54888, 58.13694],
              [27.48055, 58.203606],
              [27.476662, 58.208603],
              [27.474163, 58.213882],
              [27.47166, 58.226379],
              [27.464439, 58.283882],
              [27.464718, 58.297775],
              [27.467216, 58.303047],
              [27.48582800000014, 58.320831000000112],
              [27.496662, 58.32888],
              [27.514999, 58.339989],
              [27.525829000000101, 58.348045],
              [27.534996, 58.356941],
              [27.539165, 58.361664],
              [27.541943, 58.36721],
              [27.543331000000137, 58.373322],
              [27.543610000000115, 58.393883],
              [27.542496000000142, 58.413879],
              [27.535275, 58.450829],
              [27.521385000000123, 58.498329000000126],
              [27.517498, 58.50972],
              [27.500832, 58.548882000000106],
              [27.495827, 58.55999],
              [27.490551, 58.570831],
              [27.488049, 58.576385],
              [27.451107, 58.686935],
              [27.421661, 58.78138],
              [27.421661, 58.78833],
              [27.423050000000103, 58.80138],
              [27.426105, 58.813606000000107],
              [27.428608, 58.819160000000124],
              [27.435551, 58.829437],
              [27.43944, 58.83416],
              [27.457218, 58.85249],
              [27.493607, 58.881935],
              [27.533886, 58.902214],
              [27.549999000000128, 58.907768],
              [27.596943000000124, 58.931381000000101],
              [27.689438000000109, 58.97943],
              [27.704994, 58.98582],
              [27.788052000000107, 59.058601],
              [27.792221, 59.063324],
              [27.803329, 59.085266],
              [27.810555, 59.102493],
              [27.837219, 59.150826],
              [27.879847, 59.22806],
              [27.912537, 59.271820000000105],
              [27.920444, 59.275509],
              [27.951551, 59.285530000000108],
              [27.97106, 59.287109],
              [27.995840000000101, 59.284473],
              [28.01113, 59.279728],
              [28.030111, 59.277092],
              [28.055418, 59.279202],
              [28.09549, 59.283947],
              [28.143995, 59.290802],
              [28.158232000000112, 59.297653],
              [28.170359, 59.30978],
              [28.17932100000013, 59.328236000000118],
              [28.19361, 59.363327],
              [28.195274, 59.369438],
              [28.193886000000134, 59.375824],
              [28.180828, 59.389435],
              [28.170273, 59.397774],
              [28.10944, 59.436104],
              [28.07611, 59.453323],
              [28.026386, 59.47499],
              [28.015831, 59.4786],
              [28.021942, 59.483047],
              [28.03944, 59.50222],
              [28.063053, 59.536659],
              [28.06944, 59.552216000000101],
              [28.069996, 59.561378],
              [28.069164, 59.57888],
              [28.066666, 59.595543000000134],
              [28.06028, 59.610275000000115],
              [28.034721, 59.64277],
              [28.022774, 59.654709],
              [28.008888, 59.6661],
              [27.996941, 59.678047],
              [27.993607, 59.685547],
              [27.992218, 59.69388],
              [28.00861, 59.758888000000127],
              [28.068886, 59.79277],
              [28.08027600000014, 59.796387],
              [28.096386000000109, 59.795273],
              [28.10722, 59.791382],
              [28.169716000000108, 59.767494],
              [28.187218000000144, 59.758049000000142],
              [28.19416, 59.752495000000124],
              [28.19944, 59.74583],
              [28.202496, 59.738327],
              [28.204994000000113, 59.721931],
              [28.204441, 59.712769],
              [28.20583, 59.70444],
              [28.20916, 59.69694],
              [28.214161000000104, 59.69054],
              [28.222771, 59.685822],
              [28.244160000000136, 59.678047],
              [28.35944000000012, 59.661377],
              [28.374165, 59.661102],
              [28.385273, 59.664711],
              [28.394718000000125, 59.66916],
              [28.402218, 59.67444],
              [28.412216, 59.688042],
              [28.416386, 59.695267000000115],
              [28.42111, 59.711937],
              [28.422497000000135, 59.730270000000132],
              [28.42111, 59.738602000000128],
              [28.414997, 59.75333],
              [28.41361, 59.761665],
              [28.414997, 59.779991],
              [28.419716, 59.796387],
              [28.432217, 59.818329],
              [28.43805, 59.82444],
              [28.445827000000122, 59.82999],
              [28.491104, 59.85305],
              [28.500553, 59.857498000000135],
              [28.511944, 59.860825],
              [28.526665, 59.86055],
              [28.660275000000127, 59.81667],
              [28.671108000000117, 59.813049],
              [28.684719, 59.80166],
              [28.68972, 59.794998],
              [28.696663000000115, 59.789436],
              [28.705551000000128, 59.784721],
              [28.718052, 59.781662],
              [28.736107, 59.78138],
              [28.825829000000113, 59.782211],
              [28.838608000000136, 59.784721],
              [28.950829, 59.817497],
              [28.962215, 59.82083],
              [28.981106, 59.82972],
              [29.024441, 59.863609],
              [29.030277000000126, 59.869713],
              [29.034721000000104, 59.87721],
              [29.039719000000105, 59.893608],
              [29.038609000000122, 59.901932000000102],
              [29.03167, 59.907494],
              [29.02833, 59.93055],
              [29.06277, 59.969154000000117],
              [29.101109, 59.98666],
              [29.112495000000138, 59.990273000000116],
              [29.187218000000144, 60.006943],
              [29.201939, 60.00666],
              [29.492771, 59.97387700000013],
              [29.762775, 59.940269],
              [29.791664000000139, 59.935822],
              [29.930828, 59.902489],
              [30.003887, 59.883049],
              [30.01444, 59.879158000000132],
              [30.039440000000127, 59.872765],
              [30.068054000000132, 59.868324],
              [30.08444, 59.866936],
              [30.155552, 59.863884],
              [30.179996000000131, 59.869438],
              [30.189716, 59.873878],
              [30.213608000000136, 59.889717],
              [30.2225, 59.90416],
              [30.24666, 59.96693],
              [30.245827, 59.975266],
              [30.239162, 59.980820000000108],
              [30.23054900000011, 59.98582],
              [30.219994, 59.989716],
              [30.178608, 59.99749],
              [30.164162, 59.999718],
              [30.158609, 60.0],
              [30.076664, 60.004166],
              [30.043888, 60.006943],
              [30.03005800000011, 60.00906],
              [29.971382, 60.018051],
              [29.958885, 60.021378],
              [29.94833, 60.025269],
              [29.934994, 60.0366590000001],
              [29.892773, 60.087494],
              [29.891941, 60.095825],
              [29.896385, 60.10305000000011],
              [29.9025, 60.109161],
              [29.905273, 60.117493],
              [29.9025, 60.124710000000107],
              [29.897774, 60.131378],
              [29.884163000000115, 60.142769],
              [29.875553, 60.147774],
              [29.845551000000114, 60.160271],
              [29.824165, 60.16833],
              [29.748604, 60.186935],
              [29.721661, 60.192215],
              [29.6722180000001, 60.196098],
              [29.579998000000103, 60.198601],
              [29.560469, 60.197948],
              [29.546665, 60.197487],
              [29.51861, 60.193604000000107],
              [29.478882, 60.186378],
              [29.466682000000105, 60.180901000000119],
              [29.459717, 60.177773000000116],
              [29.453327, 60.171379],
              [29.436108000000104, 60.163605],
              [29.409718, 60.158882000000119],
              [29.39138400000013, 60.159157000000107],
              [29.170551000000103, 60.168053],
              [29.154163, 60.169159],
              [29.046387, 60.181664],
              [29.03167, 60.183876],
              [29.021111, 60.187767000000122],
              [29.00333, 60.197487],
              [28.98972, 60.2086],
              [28.984627000000103, 60.215294],
              [28.876106, 60.289162],
              [28.842495, 60.308884],
              [28.792774, 60.335548],
              [28.78167, 60.334160000000111],
              [28.739437, 60.341377],
              [28.724033, 60.34493],
              [28.714161, 60.347214],
              [28.64333, 60.36805],
              [28.632496000000117, 60.371658000000139],
              [28.60194, 60.384438000000102],
              [28.594719000000111, 60.38999200000012],
              [28.44777, 60.543884],
              [28.442772000000105, 60.55027],
              [28.44138, 60.558601],
              [28.45111, 60.563049],
              [28.49916, 60.558601],
              [28.508331, 60.553879],
              [28.513332000000105, 60.547493],
              [28.512775, 60.538048],
              [28.515831000000105, 60.53082],
              [28.52111, 60.524437],
              [28.525839, 60.520462000000123],
              [28.528053, 60.518600000000106],
              [28.563885, 60.499718],
              [28.58194, 60.490273],
              [28.656105, 60.462212000000136],
              [28.676105, 60.455269],
              [28.688885000000141, 60.452492],
              [28.701939, 60.454994000000113],
              [28.704073, 60.457127],
              [28.708050000000128, 60.461105],
              [28.708885000000123, 60.470268],
              [28.668606, 60.575829],
              [28.666372, 60.578533000000107],
              [28.66333, 60.582214],
              [28.656384, 60.587769],
              [28.64555, 60.59166],
              [28.63277, 60.594711],
              [28.619442, 60.59222],
              [28.618422, 60.591549],
              [28.611385, 60.58694],
              [28.612568, 60.579842],
              [28.612774, 60.578606],
              [28.611048, 60.5768],
              [28.60666300000014, 60.57222],
              [28.595276, 60.570549],
              [28.584442000000138, 60.57444],
              [28.575554000000125, 60.579163],
              [28.563332, 60.591377],
              [28.553051, 60.604439],
              [28.555553, 60.612495],
              [28.568329, 60.634438],
              [28.57444, 60.640831],
              [28.587498, 60.64138000000014],
              [28.595732, 60.639523],
              [28.61333100000013, 60.635551000000135],
              [28.617851, 60.631752],
              [28.620274000000109, 60.629715],
              [28.620529, 60.62818],
              [28.621662, 60.621376],
              [28.626663000000121, 60.614998],
              [28.637775, 60.611107],
              [28.67305, 60.60943600000013],
              [28.682774, 60.613884],
              [28.732216, 60.673607000000118],
              [28.732773, 60.680824],
              [28.733604, 60.713051],
              [28.728329, 60.71944],
              [28.68666, 60.73582],
              [28.671661, 60.738045],
              [28.661942, 60.733604],
              [28.513611, 60.680275000000108],
              [28.417217, 60.666382],
              [28.403885000000116, 60.663879],
              [28.389996, 60.652214],
              [28.38777, 60.645828000000108],
              [28.386383, 60.627487],
              [28.38055, 60.621101],
              [28.34111, 60.594154000000117],
              [28.146664, 60.52943],
              [28.020323, 60.528000000000134],
              [27.823887, 60.526108],
              [27.807831, 60.546402],
              [27.88472, 60.58916],
              [28.093887000000109, 60.712219000000118],
              [28.246387, 60.793327],
              [28.269444000000135, 60.804161],
              [28.298611, 60.820549],
              [28.326385, 60.838882000000126],
              [28.3325, 60.84416],
              [28.33444, 60.849998],
              [28.338055, 60.855827],
              [28.344166, 60.861382],
              [28.351109, 60.865829],
              [28.38888500000013, 60.886665],
              [28.466389, 60.92528],
              [28.520554, 60.952217],
              [28.529163, 60.954994],
              [28.547775000000115, 60.958885],
              [28.57777, 60.961662],
              [28.612499, 60.958885],
              [28.622498000000121, 60.959717],
              [28.6311070000001, 60.962494000000106],
              [28.638885, 60.966110000000128],
              [28.652222000000108, 60.976105],
              [28.674164, 61.00166],
              [28.719997, 61.04527],
              [28.812775, 61.103333],
              [28.820553, 61.106941],
              [28.970833, 61.162773000000129],
              [29.071941, 61.19944],
              [29.157497, 61.228882000000112],
              [29.174164, 61.235275],
              [29.21361, 61.253326],
              [29.249722, 61.27583],
              [29.271111, 61.289444],
              [29.277496, 61.294716],
              [29.285076000000117, 61.302864],
              [29.301941, 61.318329000000119],
              [29.334164, 61.345276],
              [29.348053000000107, 61.35527],
              [29.362499, 61.364166],
              [29.497498, 61.436661],
              [29.652496, 61.517776],
              [29.683331000000123, 61.533882],
              [29.79472, 61.5991590000001],
              [29.809166, 61.60833],
              [29.991386, 61.729439],
              [30.005554, 61.739441],
              [30.142174000000125, 61.846954],
              [30.155102, 61.85635],
              [30.203888, 61.890549],
              [30.300552, 61.95611],
              [30.396111, 62.016663000000108],
              [30.6325, 62.166107000000125],
              [30.704166, 62.210548000000131],
              [30.7925, 62.253883],
              [30.834442, 62.271385000000123],
              [30.964165, 62.339165],
              [31.082775, 62.41305],
              [31.251942, 62.503326000000129],
              [31.25972, 62.507774],
              [31.269165, 62.51861],
              [31.280277, 62.53611],
              [31.294167, 62.56416],
              [31.310555, 62.598053],
              [31.32194, 62.615273],
              [31.429996, 62.758888],
              [31.4675, 62.806389],
              [31.480553, 62.818886],
              [31.501389, 62.835548],
              [31.521664, 62.853333],
              [31.574997, 62.901382],
              [31.588928000000124, 62.914413000000138],
              [31.524166, 62.978333000000134],
              [31.514999000000103, 62.986938],
              [31.38305, 63.06916],
              [31.245831000000123, 63.20111],
              [31.24222200000014, 63.205551],
              [31.236664000000133, 63.21027400000014],
              [31.219719, 63.223053],
              [31.186386, 63.238327],
              [30.91222, 63.353607],
              [30.714722, 63.424438000000123],
              [30.648888000000113, 63.439720000000136],
              [30.481667, 63.47861],
              [30.4775, 63.481110000000115],
              [30.472775, 63.48555],
              [30.461941, 63.499161000000129],
              [30.4525, 63.508049],
              [30.399441, 63.546104],
              [30.391388, 63.549995],
              [30.357498000000135, 63.559998000000121],
              [30.308887, 63.572495000000117],
              [30.254719000000136, 63.58972],
              [30.244442, 63.593048],
              [30.228333, 63.600555],
              [30.206387, 63.612778],
              [30.00333, 63.729439],
              [29.995831, 63.738884],
              [29.993332, 63.743607],
              [29.996712, 63.74802],
              [30.004719, 63.75278],
              [30.013054, 63.756386000000134],
              [30.033054, 63.760826000000122],
              [30.063053, 63.766663000000108],
              [30.114719, 63.775276],
              [30.134998, 63.779999],
              [30.210552, 63.80082700000014],
              [30.255833000000109, 63.817772000000105],
              [30.263611, 63.82222],
              [30.27861, 63.832771],
              [30.398052, 63.93055],
              [30.47194, 63.968887],
              [30.48860900000011, 63.977776],
              [30.528610000000128, 64.0],
              [30.54361, 64.009995],
              [30.558887, 64.020554000000118],
              [30.595276000000126, 64.046936],
              [30.608887, 64.06499],
              [30.611664, 64.075821],
              [30.614441000000113, 64.086655000000121],
              [30.611111000000108, 64.101654],
              [30.578053, 64.221375],
              [30.576664000000108, 64.226105000000132],
              [30.573887, 64.23082],
              [30.566666000000112, 64.23999],
              [30.560833000000116, 64.244431000000134],
              [30.55278, 64.248322],
              [30.389721, 64.309433000000126],
              [30.359444, 64.31972],
              [30.321663, 64.329437],
              [30.196941, 64.348877],
              [30.17028, 64.351379000000122],
              [30.156109, 64.354156],
              [30.135277, 64.361374],
              [30.12722, 64.36499],
              [30.11889, 64.36916],
              [30.065552, 64.396942],
              [30.053608, 64.404999],
              [30.061386, 64.422485],
              [30.083054, 64.45221],
              [30.088333, 64.467773],
              [30.088608, 64.478333],
              [30.087219, 64.483047],
              [30.068607, 64.49472],
              [30.04888, 64.50249],
              [30.01139, 64.511658],
              [30.00967, 64.51286],
              [29.986942000000113, 64.55305],
              [29.974998, 64.57443],
              [29.974998, 64.581100000000106],
              [29.980831, 64.585831],
              [30.020554000000118, 64.5961],
              [30.033333, 64.599152],
              [30.07249800000011, 64.60443],
              [30.141666, 64.619431000000134],
              [30.17028, 64.628052],
              [30.17889, 64.631653],
              [30.186386, 64.63777],
              [30.199165, 64.65027],
              [30.208611, 64.662491000000102],
              [30.210552, 64.66777],
              [30.20916, 64.672775000000115],
              [30.144722000000115, 64.769989000000123],
              [30.140831, 64.774155],
              [30.126389, 64.782486000000119],
              [30.115833, 64.785828],
              [30.08778, 64.79166],
              [30.074444, 64.79361],
              [30.04805, 64.795547],
              [29.95027, 64.795547],
              [29.926388, 64.794708],
              [29.8916660000001, 64.793045],
              [29.843052000000114, 64.792496],
              [29.818333, 64.792496],
              [29.804722, 64.793884000000105],
              [29.79416700000013, 64.797211],
              [29.774441, 64.809708],
              [29.755, 64.822495],
              [29.736664, 64.834991000000116],
              [29.730553, 64.839432],
              [29.714443, 64.852219],
              [29.67194, 64.887207],
              [29.652775, 64.904709],
              [29.644997, 64.913879000000122],
              [29.636665, 64.92805],
              [29.609997000000135, 64.991943],
              [29.60666700000013, 65.001663],
              [29.60639, 65.007217],
              [29.609444, 65.02304],
              [29.616665000000125, 65.044998],
              [29.622498, 65.056381],
              [29.628887, 65.063049],
              [29.63722, 65.068329000000119],
              [29.65472, 65.075546],
              [29.664719000000105, 65.079163],
              [29.683609, 65.08444],
              [29.726387000000102, 65.092499],
              [29.773888, 65.09471],
              [29.806942, 65.099152],
              [29.836666, 65.106934],
              [29.864719, 65.116653],
              [29.873886, 65.12082],
              [29.874443, 65.12582],
              [29.87278, 65.19832],
              [29.869999, 65.203323],
              [29.866108, 65.208054000000118],
              [29.853611, 65.21611],
              [29.843052000000114, 65.219986],
              [29.827499, 65.22249],
              [29.81389, 65.224442],
              [29.787498, 65.226379],
              [29.73722, 65.226654],
              [29.6655540000001, 65.22333],
              [29.652222000000108, 65.22333],
              [29.639721000000122, 65.224442],
              [29.62639, 65.22749],
              [29.609444, 65.23527],
              [29.60305, 65.239441],
              [29.599163, 65.243607000000111],
              [29.596386, 65.24889],
              [29.596943, 65.253876],
              [29.598888, 65.25972],
              [29.605274000000122, 65.265823000000125],
              [29.620831, 65.276657],
              [29.662220000000104, 65.298874],
              [29.679996, 65.306931],
              [29.70611, 65.31972],
              [29.747498, 65.341934],
              [29.74944, 65.347763],
              [29.75, 65.352768],
              [29.745552, 65.414719000000105],
              [29.739719, 65.455551],
              [29.738331, 65.481110000000115],
              [29.746109, 65.514435],
              [29.761387, 65.523041],
              [29.77916, 65.530273],
              [29.798054, 65.53749],
              [29.834164, 65.588333],
              [29.818886, 65.653320000000122],
              [29.992496000000131, 65.685272000000111],
              [30.024441, 65.691101000000117],
              [30.036110000000122, 65.68999],
              [30.068054000000132, 65.679443],
              [30.085278, 65.67139],
              [30.111664000000133, 65.66527],
              [30.123886, 65.66499],
              [30.13361, 65.676941],
              [30.135277, 65.703598000000113],
              [30.134998, 65.709152],
              [30.134163, 65.71916],
              [30.1025, 65.8186],
              [30.09666, 65.833328],
              [30.091110000000128, 65.842773],
              [30.032219, 65.922211000000118],
              [29.94833, 66.049713],
              [29.918888, 66.112778],
              [29.910275, 66.126938000000109],
              [29.897221, 66.140823],
              [29.876389000000131, 66.152222000000108],
              [29.849998, 66.163605000000132],
              [29.826111000000139, 66.175552],
              [29.799164, 66.19249],
              [29.782219, 66.205276],
              [29.770832, 66.214157],
              [29.638611000000139, 66.322495000000117],
              [29.62527, 66.33638],
              [29.590275, 66.382767000000115],
              [29.583332, 66.39221],
              [29.577499000000103, 66.401657],
              [29.574718, 66.406937],
              [29.573055000000124, 66.41137700000013],
              [29.567924000000119, 66.42857400000014],
              [29.554443, 66.470276],
              [29.414165000000139, 66.599991000000102],
              [29.385548, 66.62831100000011],
              [29.359444, 66.673325],
              [29.350277000000119, 66.682495],
              [29.33, 66.700272],
              [29.318886, 66.708878000000141],
              [29.273331, 66.73832700000014],
              [29.25972, 66.746658],
              [29.246109000000104, 66.75499],
              [29.221107000000131, 66.76694],
              [29.202774, 66.774429000000112],
              [29.13444, 66.8161],
              [29.123055, 66.824707],
              [29.097775, 66.846939000000134],
              [29.09333, 66.85138],
              [29.086388000000113, 66.860825],
              [29.077221000000122, 66.874985],
              [29.07499700000011, 66.87999],
              [29.07499700000011, 66.895828000000108],
              [29.075275, 66.911377],
              [29.079998, 66.943604],
              [29.083054000000118, 66.958603],
              [29.087776, 66.969986],
              [29.0925, 66.97583],
              [29.134163, 67.013611],
              [29.156944000000124, 67.030823000000112],
              [29.525276000000133, 67.293884],
              [29.745552, 67.41638],
              [29.881664000000114, 67.483597000000145],
              [29.899998, 67.492493],
              [29.932777, 67.513885],
              [29.95472, 67.532776000000126],
              [29.964722, 67.544434000000138],
              [29.977776, 67.572495],
              [30.02861, 67.69472],
              [29.9025, 67.740829],
              [29.7275, 67.803329000000133],
              [29.691666, 67.815277],
              [29.539444, 67.938889000000131],
              [29.38361, 68.062485],
              [29.35694100000012, 68.082489000000123],
              [29.16, 68.11665],
              [28.823330000000112, 68.172485000000108],
              [28.696663000000115, 68.193329000000119],
              [28.693333000000109, 68.197495],
              [28.663055, 68.239441],
              [28.559998, 68.385818],
              [28.457497, 68.53194],
              [28.458611, 68.534714],
              [28.46583, 68.540833],
              [28.510277, 68.578049],
              [28.525833, 68.589722],
              [28.654999, 68.679993],
              [28.73860900000011, 68.73416],
              [28.759163, 68.751938],
              [28.76416, 68.757767],
              [28.796108, 68.804443],
              [28.803333, 68.815826],
              [28.820553, 68.844437],
              [28.815552000000139, 68.848877],
              [28.812775, 68.850266],
              [28.792774, 68.85777],
              [28.737778000000105, 68.87582],
              [28.705830000000105, 68.878326],
              [28.564999, 68.874435000000119],
              [28.509163000000115, 68.872772],
              [28.479164, 68.873596],
              [28.4625, 68.87527],
              [28.447498, 68.878326],
              [28.43222, 68.886383],
              [28.431942, 68.896942],
              [28.439163000000121, 68.908325],
              [28.446663, 68.914719000000105],
              [28.456944000000135, 68.91832],
              [28.746387, 68.99721],
              [28.8555530000001, 69.029709],
              [28.877777, 69.036102],
              [28.91333, 69.04332],
              [28.957340000000102, 69.05162],
              [28.995337, 69.03851],
              [29.004776000000106, 69.035248],
              [29.019997000000103, 69.031387],
              [29.049721, 69.02832],
              [29.063332, 69.029160000000104],
              [29.09916, 69.036377],
              [29.129719, 69.04805],
              [29.177776, 69.070541],
              [29.19611, 69.08055],
              [29.20472, 69.085831],
              [29.2305530000001, 69.101944],
              [29.239166, 69.107498],
              [29.25444, 69.119995],
              [29.293053, 69.18277],
              [29.298332, 69.193878],
              [29.315628, 69.230774],
              [29.32025, 69.24209],
              [29.321663000000115, 69.245544000000109],
              [29.316666, 69.255264],
              [29.311665000000119, 69.25972],
              [29.304165, 69.26916],
              [29.296665000000132, 69.2836],
              [29.294167, 69.29361],
              [29.29444, 69.29887],
              [29.29694400000011, 69.304443],
              [29.302219, 69.31055],
              [29.309998, 69.315277],
              [29.321663000000115, 69.31944],
              [29.408333, 69.333054],
              [29.483608, 69.340820000000122],
              [29.53833, 69.347214],
              [29.57194, 69.353882],
              [29.603333000000134, 69.360275000000115],
              [29.665, 69.373886],
              [29.898609, 69.43277],
              [30.06277, 69.487778],
              [30.097775, 69.503326],
              [30.176388, 69.566101000000117],
              [30.182220000000143, 69.574158000000125],
              [30.184998000000121, 69.582764],
              [30.182499000000121, 69.589157],
              [30.142776, 69.628326],
              [30.13179, 69.628403],
              [30.102219, 69.628601],
              [30.088055, 69.627777],
              [30.072777, 69.631104],
              [30.073608, 69.646652],
              [30.076385, 69.65222],
              [30.083885, 69.65639],
              [30.103333, 69.663055],
              [30.115833, 69.664650000000108],
              [30.129444, 69.666382],
              [30.1575, 69.668045],
              [30.172497000000135, 69.668045],
              [30.188332000000116, 69.66693],
              [30.203609, 69.663879],
              [30.305275, 69.630554],
              [30.335552000000121, 69.619156],
              [30.345554000000106, 69.615265000000136],
              [30.370552, 69.603043000000127],
              [30.39305, 69.59055],
              [30.453331000000105, 69.567215],
              [30.511387, 69.549164000000133],
              [30.529163, 69.546097],
              [30.546108, 69.544159],
              [30.76722, 69.530548000000124],
              [30.796944, 69.530273],
              [30.824718000000132, 69.531662],
              [30.86389, 69.536652000000117],
              [30.898888, 69.545273],
              [30.91, 69.548874000000126],
              [30.920277, 69.553329000000133],
              [30.936665, 69.565826000000129],
              [30.945831000000112, 69.58221],
              [30.950275, 69.603607],
              [30.95138500000013, 69.613876000000118],
              [30.947220000000129, 69.654434],
              [30.943333, 69.690552],
              [30.902775000000133, 69.731934],
              [30.854839, 69.792313],
              [30.921383, 69.78804],
              [31.240829000000133, 69.757767],
              [31.40583, 69.716095],
              [31.541647, 69.69696],
              [31.727772, 69.680817],
              [31.773888000000113, 69.681091],
              [31.79472, 69.682205],
              [31.808609, 69.686371],
              [31.81028, 69.693588],
              [31.80139, 69.699142000000109],
              [31.789719000000105, 69.703873],
              [31.760830000000112, 69.71165],
              [31.726383000000112, 69.718048000000124],
              [31.6915130000001, 69.732155],
              [31.708885, 69.818054],
              [31.713329, 69.82582],
              [31.715372000000116, 69.827866],
              [31.720272, 69.832764],
              [31.72916, 69.838593],
              [31.75694, 69.846649],
              [31.793888, 69.851089],
              [31.817219000000136, 69.851089],
              [31.837219, 69.848877],
              [31.848505, 69.846878],
              [31.854443, 69.845825000000104],
              [31.85995, 69.844269000000111],
              [31.869164, 69.841660000000104],
              [31.96472, 69.812485],
              [31.990829, 69.803589000000102],
              [32.00249, 69.798874],
              [32.011383000000137, 69.79332],
              [32.029716, 69.77388],
              [32.038605, 69.768326],
              [32.045898, 69.767242000000124],
              [32.053604000000121, 69.766098000000113],
              [32.096382, 69.7836],
              [32.103325, 69.79054],
              [32.098244, 69.80154],
              [32.096657, 69.804977],
              [32.09055, 69.811371],
              [32.037216, 69.844711000000132],
              [32.013885, 69.854431],
              [31.993328, 69.8647],
              [31.984161, 69.8702550000001],
              [31.918327, 69.916656000000103],
              [31.91291, 69.92792],
              [31.911385, 69.931091],
              [31.931938, 69.96138],
              [31.941105, 69.967484000000127],
              [31.942532000000142, 69.967407],
              [32.01277, 69.963608],
              [32.035553, 69.961929],
              [32.055824000000143, 69.95943],
              [32.084717000000126, 69.95166],
              [32.096382, 69.94693],
              [32.213326, 69.898880000000133],
              [32.357773000000122, 69.878586],
              [32.374992, 69.875259],
              [32.389435000000105, 69.871368],
              [32.468651, 69.847458],
              [32.50666, 69.81888],
              [32.499718000000144, 69.81192],
              [32.49985, 69.808174],
              [32.5, 69.803864],
              [32.506104, 69.797485],
              [32.57194, 69.783875],
              [32.588882, 69.780548],
              [32.608887, 69.77805],
              [32.629967, 69.777351],
              [32.634438000000102, 69.77721],
              [32.65527, 69.778320000000122],
              [32.671379, 69.781372],
              [32.685547, 69.785538],
              [32.704163000000108, 69.797211000000118],
              [32.91694, 69.776657],
              [32.936935000000119, 69.774155000000121],
              [33.093605, 69.747482000000105],
              [33.104996, 69.742752],
              [33.1216, 69.731865],
              [33.130432, 69.72607],
              [33.11805, 69.655823],
              [33.11305, 69.648041],
              [33.107864, 69.644791000000112],
              [33.094437, 69.636383],
              [33.07111, 69.626373000000115],
              [33.04555, 69.617477],
              [32.92749, 69.588593],
              [32.894997000000103, 69.582764],
              [32.874435, 69.581665],
              [32.866615000000138, 69.582069],
              [32.82666, 69.584152000000131],
              [32.617493000000138, 69.612488],
              [32.467491, 69.634155],
              [32.326103, 69.64055],
              [32.178604, 69.653046],
              [32.161659, 69.656372000000147],
              [32.110275, 69.675812000000121],
              [32.02639, 69.636536],
              [32.06388, 69.61304],
              [32.099998, 69.594147],
              [32.213608, 69.58998],
              [32.386383000000137, 69.578323000000125],
              [32.40638, 69.575821],
              [32.42332, 69.572495],
              [32.434715, 69.567764],
              [32.498604, 69.511383000000137],
              [32.497414000000106, 69.506409],
              [32.496941, 69.50444],
              [32.485268, 69.4994200000001],
              [32.277214, 69.440262],
              [32.261108, 69.43719],
              [32.210705, 69.43132],
              [32.206383, 69.430817],
              [32.190269000000114, 69.427765000000136],
              [32.199715, 69.424149],
              [32.222488000000112, 69.424149],
              [32.268051, 69.424423],
              [32.286385, 69.42665],
              [32.299995, 69.430542],
              [32.363884, 69.452484],
              [32.437492000000134, 69.48137],
              [32.487770000000125, 69.4897],
              [32.668327, 69.499710000000107],
              [32.825272, 69.488037],
              [33.02941, 69.47186],
              [33.008492, 69.435783],
              [32.945541, 69.409988],
              [32.933876, 69.404984],
              [32.913048000000117, 69.39415],
              [32.834717, 69.34887700000013],
              [32.83194, 69.344307],
              [32.829994, 69.341095],
              [32.83451, 69.330414000000133],
              [32.808601, 69.308868],
              [32.803947000000107, 69.304214],
              [32.80166, 69.301926],
              [32.80999, 69.296097],
              [32.895271, 69.30304],
              [32.906937, 69.317764000000125],
              [32.9211, 69.34137],
              [32.944435, 69.37082],
              [32.958603, 69.384720000000129],
              [32.969292, 69.387764000000118],
              [32.972214, 69.388596],
              [32.990547000000106, 69.39055],
              [33.16582, 69.419144],
              [33.326942000000145, 69.448868],
              [33.4575, 69.444138],
              [33.510551, 69.426926],
              [33.52166, 69.421921000000111],
              [33.521935, 69.414154],
              [33.471329, 69.350441],
              [33.368881000000101, 69.301086],
              [33.352776, 69.298325],
              [33.307495000000131, 69.298035],
              [33.289162, 69.296097],
              [33.236938, 69.273041],
              [33.237770000000125, 69.266663],
              [33.254440000000102, 69.26361],
              [33.265457, 69.26554],
              [33.270271, 69.266388],
              [33.379158, 69.284714],
              [33.399719, 69.285812000000135],
              [33.419159, 69.283325],
              [33.47443, 69.274994],
              [33.538887, 69.212769],
              [33.540257, 69.209068],
              [33.54166, 69.205261],
              [33.53194, 69.189697000000137],
              [33.522491, 69.183868000000132],
              [33.510826000000122, 69.17886],
              [33.314156, 69.115814],
              [33.273048000000131, 69.103867],
              [33.236938, 69.09999],
              [33.196098, 69.09776],
              [33.121658, 69.09082],
              [33.07638500000013, 69.080826],
              [33.048882, 69.072769],
              [33.037773000000129, 69.068054],
              [33.01944, 69.05609],
              [33.016937, 69.047211000000118],
              [33.008331, 68.981369],
              [33.008888, 68.96527],
              [33.01073, 68.963142],
              [33.014442, 68.958878],
              [33.02277, 68.953323000000125],
              [33.031662, 68.957489],
              [33.03611, 68.96527],
              [33.038605, 68.974152000000117],
              [33.040409000000125, 68.989395000000115],
              [33.040833, 68.99914600000011],
              [33.045273, 69.032761],
              [33.047775000000115, 69.041656],
              [33.05249, 69.049423],
              [33.075272, 69.059418],
              [33.088882000000126, 69.06331],
              [33.104713000000118, 69.066376],
              [33.285553000000107, 69.08638],
              [33.418884, 69.097488],
              [33.434715, 69.10054],
              [33.446381, 69.10554500000012],
              [33.567772, 69.183853000000113],
              [33.573051, 69.193588],
              [33.575829, 69.20248400000014],
              [33.575829, 69.210266000000104],
              [33.572124, 69.219704],
              [33.559715, 69.273315000000139],
              [33.559715, 69.281372000000147],
              [33.562492, 69.290268],
              [33.57444, 69.304977000000122],
              [33.5816650000001, 69.3119200000001],
              [33.609436, 69.319717],
              [33.64138, 69.325546],
              [33.719154, 69.331375],
              [33.871101, 69.332764],
              [34.001106000000107, 69.327484],
              [34.173607, 69.321381],
              [34.351936000000137, 69.318329000000119],
              [34.371376000000112, 69.315811],
              [34.407211, 69.309708],
              [34.414036, 69.307663000000105],
              [34.421104, 69.305542000000116],
              [34.426846000000126, 69.295448],
              [34.44305, 69.281372000000147],
              [34.647472000000107, 69.25093],
              [34.79277, 69.234711000000118],
              [34.94694, 69.221649],
              [35.028999000000113, 69.218933],
              [35.047333, 69.220596],
              [35.070114000000103, 69.220596],
              [35.10762, 69.219757],
              [35.129562000000135, 69.217804000000115],
              [35.140396, 69.212814],
              [35.145393, 69.206146],
              [35.14512, 69.19836],
              [35.142342, 69.191132],
              [35.14484, 69.183914],
              [35.15845, 69.179749],
              [35.178185, 69.17891],
              [35.19208, 69.182526000000109],
              [35.263496, 69.21141],
              [35.265991, 69.218628],
              [35.250153, 69.230026],
              [35.16874700000011, 69.25531],
              [35.157898, 69.260315000000105],
              [35.149849, 69.265869000000123],
              [35.155411000000129, 69.273926],
              [35.178192000000138, 69.273651],
              [35.295181000000127, 69.268906],
              [35.458572, 69.253326],
              [35.543312, 69.236649],
              [35.836655, 69.198868],
              [35.974991, 69.173035000000141],
              [36.264717, 69.074432000000115],
              [36.476379, 69.0336],
              [36.55471, 69.023041],
              [36.568604000000107, 69.020538000000101],
              [36.60083, 69.013321],
              [36.991379000000109, 68.897217],
              [37.1511, 68.845825000000104],
              [37.294998, 68.799423],
              [37.494995, 68.73526],
              [37.646385000000123, 68.712769],
              [37.69332, 68.70166],
              [37.77332, 68.676086],
              [37.824715, 68.658325000000104],
              [37.95416, 68.590820000000122],
              [38.040276, 68.542755000000113],
              [38.054436000000123, 68.531097000000102],
              [38.322495, 68.44136],
              [38.33221, 68.436371],
              [38.392494000000113, 68.398041000000148],
              [38.39666, 68.39137],
              [38.398048, 68.383881],
              [38.39666, 68.375809],
              [38.432770000000119, 68.339157],
              [38.546104, 68.32527],
              [38.608604000000128, 68.327484],
              [38.52222, 68.351379],
              [38.502777, 68.36165],
              [38.506104000000107, 68.368591],
              [38.519989, 68.372208],
              [38.603882, 68.387497],
              [38.621933, 68.38443],
              [38.6375, 68.3808140000001],
              [38.93055, 68.303589],
              [38.94305, 68.299149],
              [38.952774, 68.294144000000131],
              [38.956657, 68.28749],
              [38.950272, 68.279709],
              [39.10943600000013, 68.21138],
              [39.262215, 68.166092],
              [39.464714000000129, 68.09526],
              [39.495827000000133, 68.08028],
              [39.520271, 68.0711060000001],
              [39.535553000000107, 68.067215],
              [39.5711060000001, 68.061096],
              [39.741379000000109, 68.046646],
              [39.834991000000116, 68.039703],
              [39.853882, 68.038315],
              [39.86416, 68.043869],
              [39.857498, 68.054428],
              [39.791382, 68.122208],
              [39.772491, 68.132751],
              [39.733047000000113, 68.145538],
              [39.72082, 68.150269],
              [39.71138, 68.155548000000124],
              [39.7075, 68.162201],
              [39.713051000000121, 68.16804500000012],
              [39.729156, 68.170532],
              [39.752495, 68.168869],
              [39.770546, 68.165543],
              [39.785553, 68.16165],
              [39.80999, 68.152771],
              [39.895546, 68.120819],
              [39.919991, 68.111649],
              [39.929436, 68.10637],
              [39.93138, 68.091660000000104],
              [39.929436, 68.083603],
              [39.932495000000131, 68.076096],
              [39.97832, 68.034424000000115],
              [39.99416, 68.023041],
              [40.013054, 68.012772],
              [40.138603, 67.953049],
              [40.150826000000109, 67.94832],
              [40.183327, 67.941360000000145],
              [40.269714, 67.926376],
              [40.356102, 67.902206],
              [40.36805, 67.897766],
              [40.41137700000013, 67.870529],
              [40.414993, 67.863876000000118],
              [40.410271000000137, 67.855255],
              [40.398048, 67.85054],
              [40.38221, 67.848328],
              [40.33943, 67.849716],
              [40.323326000000122, 67.847488],
              [40.31972, 67.840271000000143],
              [40.399437, 67.79221],
              [40.463608, 67.75499],
              [40.47555, 67.750549],
              [40.49305, 67.747208],
              [40.511665000000107, 67.745819],
              [40.529160000000104, 67.747208],
              [40.696655, 67.770264],
              [40.79805, 67.727203],
              [40.80999, 67.72276],
              [40.825829, 67.720535],
              [40.841377, 67.723038],
              [40.871376, 67.728592],
              [40.885269000000108, 67.732208],
              [40.9011, 67.734421],
              [40.918884, 67.735809000000131],
              [40.939156, 67.733322],
              [40.992218, 67.716095],
              [41.04805, 67.661926],
              [41.051384, 67.655258],
              [41.055267, 67.641373000000101],
              [41.056656, 67.626373],
              [41.054436, 67.618317000000104],
              [41.049438, 67.609711],
              [41.037498000000141, 67.593323000000112],
              [41.030823000000112, 67.585541000000148],
              [41.03583, 67.467758],
              [41.058601, 67.46582],
              [41.07583, 67.462769],
              [41.090271000000143, 67.4586],
              [41.101936, 67.454163000000108],
              [41.110825, 67.448593],
              [41.147217, 67.419983],
              [41.15332, 67.413879],
              [41.14111, 67.350815000000125],
              [41.13277, 67.311096],
              [41.13055, 67.303040000000124],
              [41.105827, 67.259155],
              [41.112495, 67.24582],
              [41.118599, 67.2397],
              [41.12721, 67.23442],
              [41.138885, 67.22971],
              [41.15332, 67.225815],
              [41.170273000000122, 67.222488000000112],
              [41.224434, 67.213318],
              [41.24527, 67.212494000000106],
              [41.260826, 67.215],
              [41.2711, 67.220261],
              [41.278046000000131, 67.228043],
              [41.29166, 67.231369],
              [41.30971, 67.22998],
              [41.32694, 67.226654],
              [41.34444, 67.215820000000122],
              [41.359436, 67.204437],
              [41.362495, 67.197754000000145],
              [41.390549, 67.122757],
              [41.39111, 67.115540000000124],
              [41.304436, 66.950821000000133],
              [41.299438, 66.9422],
              [41.283051, 66.916931],
              [41.271378, 66.90054],
              [41.246384, 66.86859],
              [41.219711, 66.837769],
              [41.155823, 66.794434],
              [41.12721, 66.776932],
              [41.096939, 66.759995],
              [41.049721, 66.742203],
              [40.972488, 66.707489000000123],
              [40.741661000000136, 66.589981],
              [40.73166, 66.584427],
              [40.723602, 66.577774],
              [40.718880000000127, 66.568878],
              [40.720268, 66.55415],
              [40.723602, 66.547485],
              [40.7241590000001, 66.539978],
              [40.716103, 66.533325000000104],
              [40.56554, 66.453873],
              [40.46638, 66.409988000000112],
              [40.44332, 66.400818],
              [40.401657, 66.39137],
              [40.35305, 66.38611],
              [40.323051000000135, 66.381363],
              [40.29639, 66.3744200000001],
              [40.178604, 66.34082],
              [40.166939000000127, 66.33638],
              [40.137772, 66.31944],
              [40.105827, 66.292755],
              [40.0961, 66.286926],
              [40.073326, 66.277771000000143],
              [40.05999, 66.274429],
              [39.80999, 66.23027],
              [39.584991, 66.194138000000123],
              [39.3836060000001, 66.143875],
              [39.359161, 66.135544],
              [39.3461, 66.131927],
              [39.32083, 66.126648000000102],
              [39.276382, 66.119141],
              [39.11082, 66.104431],
              [39.019440000000145, 66.102203],
              [38.846382000000119, 66.080276],
              [38.81694, 66.075272],
              [38.607773000000122, 66.0522],
              [38.553047, 66.050812],
              [38.492767, 66.052475000000129],
              [38.199158, 66.067215],
              [37.98999, 66.07916],
              [37.968048, 66.080826],
              [37.909988000000112, 66.087494],
              [37.673607, 66.12109],
              [37.48276, 66.167755000000113],
              [37.406937, 66.193039000000113],
              [37.395271, 66.19748],
              [37.295273, 66.224152000000117],
              [37.266388, 66.231369],
              [37.147774, 66.251938],
              [37.016106, 66.2686],
              [36.97443, 66.272217000000126],
              [36.908325, 66.276382000000126],
              [36.757774, 66.285812],
              [36.715271, 66.287491],
              [36.65443, 66.288589000000115],
              [36.634438, 66.288879000000122],
              [36.615829, 66.28804],
              [36.534721, 66.28943],
              [36.3822100000001, 66.299423],
              [36.303879, 66.30775],
              [36.23555, 66.31915],
              [36.215828, 66.32138],
              [35.914436000000137, 66.353317],
              [35.732208, 66.369980000000112],
              [35.579704, 66.381073],
              [35.5572, 66.382172],
              [35.517746000000102, 66.38635],
              [35.500519000000111, 66.38913],
              [35.43689, 66.4016],
              [35.404938, 66.40797],
              [35.37798, 66.415741],
              [35.164581, 66.484833],
              [35.078743000000145, 66.514832000000126],
              [35.02763, 66.539261],
              [34.97416, 66.563873],
              [34.87555, 66.59804],
              [34.845825000000104, 66.60498],
              [34.780273, 66.607208],
              [34.76194, 66.606369],
              [34.747215, 66.603592],
              [34.7347180000001, 66.599716000000114],
              [34.708328, 66.581940000000145],
              [34.68721, 66.57193],
              [34.66193, 66.564148],
              [34.55138, 66.538040000000137],
              [34.522217, 66.532211],
              [34.50361, 66.531097000000102],
              [34.48777, 66.531097000000102],
              [34.470268, 66.5336],
              [34.448044, 66.543045],
              [34.438324, 66.548035],
              [34.369438, 66.59915],
              [34.354713, 66.610809],
              [34.356941, 66.618042000000116],
              [34.361382000000106, 66.625809],
              [34.369987, 66.631927],
              [34.38082, 66.636658000000125],
              [34.393326000000116, 66.640823000000125],
              [34.41193, 66.641663],
              [34.429993, 66.640823000000125],
              [34.438599, 66.646652000000131],
              [34.318604, 66.665817],
              [34.241936, 66.669434],
              [34.157494, 66.669983],
              [33.933327, 66.684708000000114],
              [33.85555, 66.692474],
              [33.82555, 66.69942],
              [33.815269, 66.704437],
              [33.80777, 66.709991],
              [33.802773000000116, 66.716660000000104],
              [33.797775000000115, 66.73137],
              [33.797775000000115, 66.739426],
              [33.79277, 66.746094],
              [33.780273, 66.758331],
              [33.772766, 66.76416],
              [33.75, 66.773315000000139],
              [33.737495, 66.777481],
              [33.59887700000013, 66.82304],
              [33.521103, 66.824707],
              [33.516663000000108, 66.816666],
              [33.516663000000108, 66.808594],
              [33.51944, 66.801086],
              [33.53194, 66.788879],
              [33.539719000000105, 66.783325],
              [33.569992, 66.76833],
              [33.607773, 66.755829],
              [33.628044, 66.746094],
              [33.5430530000001, 66.720825000000104],
              [33.526657000000114, 66.7186],
              [33.483879, 66.72137],
              [33.251389, 66.794434],
              [33.188042, 66.81499],
              [33.154991, 66.82887],
              [33.0886, 66.856934],
              [32.94276, 66.92499],
              [32.901657000000114, 66.944427],
              [32.834717, 66.98054500000012],
              [32.819160000000124, 66.991928000000144],
              [32.808327000000133, 67.004990000000134],
              [32.80027, 67.018875],
              [32.794716, 67.0336],
              [32.798607, 67.049423],
              [32.80499, 67.056641],
              [32.793884000000105, 67.085815],
              [32.696098, 67.111923],
              [32.66777, 67.11943],
              [32.621376000000112, 67.12915],
              [32.603607, 67.131653000000142],
              [32.583054000000118, 67.133331],
              [32.564156, 67.132202],
              [32.530823, 67.128036],
              [32.51194, 67.126923],
              [32.488884, 67.127762],
              [32.450546, 67.131653000000142],
              [32.419716, 67.138321000000133],
              [32.40665, 67.142487],
              [32.364716000000101, 67.161926000000108],
              [32.346939, 67.164154],
              [32.332214000000135, 67.161102000000142],
              [32.240273000000116, 67.144714],
              [32.066101000000117, 67.133331],
              [32.024994000000106, 67.136658],
              [31.99416, 67.143051000000128],
              [31.981106, 67.146942],
              [31.973049, 67.152771],
              [31.94194, 67.159149],
              [31.923885, 67.161652],
              [31.879997, 67.162201],
              [31.865273000000116, 67.158875],
              [31.854996000000142, 67.15387],
              [31.85441, 67.151093000000117],
              [31.860554, 67.147491],
              [31.91583, 67.123871],
              [31.93138, 67.120819],
              [32.061661000000129, 67.113876],
              [32.080276, 67.113037000000134],
              [32.101105, 67.113312000000121],
              [32.117767, 67.115540000000124],
              [32.13027, 67.11943],
              [32.140549000000135, 67.12469],
              [32.153046, 67.128586],
              [32.192764000000125, 67.129974000000118],
              [32.215828000000101, 67.12915],
              [32.254166, 67.125259],
              [32.264717, 67.12025],
              [32.35638, 67.075821],
              [32.492218, 67.033875],
              [32.502495, 67.02887],
              [32.520828000000108, 67.018326000000116],
              [32.538887, 67.007767],
              [32.55471, 66.996368000000132],
              [32.55999, 66.989975],
              [32.563049, 66.982483],
              [32.558601000000124, 66.974701],
              [32.529434, 66.94859300000013],
              [32.518326, 66.88220200000012],
              [32.679718, 66.82748400000014],
              [32.85055, 66.785812],
              [32.908882, 66.771927],
              [32.91666, 66.766098],
              [32.93499, 66.739151000000106],
              [32.926659, 66.733322000000101],
              [32.84499, 66.726379],
              [32.826942, 66.727203],
              [32.80916, 66.729706],
              [32.793884000000105, 66.733047],
              [32.7925, 66.727478],
              [32.808044, 66.716095],
              [32.934433, 66.69136],
              [32.969711, 66.686371],
              [33.05999, 66.68275],
              [33.119713, 66.684143],
              [33.15694, 66.686096],
              [33.179436000000123, 66.685257],
              [33.214714000000129, 66.680267],
              [33.229713, 66.676926],
              [33.318054, 66.647766000000104],
              [33.325554, 66.642212],
              [33.325829000000113, 66.625809],
              [33.31554, 66.62082],
              [33.299995, 66.622482000000105],
              [33.194992, 66.639435],
              [33.15221, 66.650269],
              [33.13166, 66.649994],
              [33.117210000000114, 66.64722],
              [33.108604, 66.641098000000113],
              [33.10416, 66.623306],
              [33.099716, 66.615265],
              [33.093605, 66.60832],
              [33.085266, 66.602203000000145],
              [33.07471, 66.597214],
              [33.062492, 66.593323000000112],
              [33.033607, 66.587204],
              [33.013611, 66.588882],
              [32.97832, 66.593872],
              [32.938324000000136, 66.597214],
              [32.895271, 66.59804],
              [32.876656, 66.596939],
              [32.864441, 66.593048000000124],
              [32.862549000000115, 66.58528],
              [32.862213, 66.583878],
              [32.87221, 66.579163],
              [32.887497, 66.575821],
              [33.051884, 66.578217000000109],
              [33.062881000000118, 66.578873],
              [33.083885, 66.58072],
              [33.151718, 66.60088],
              [33.15555, 66.605042],
              [33.231934, 66.615265],
              [33.248329, 66.617203000000131],
              [33.283607, 66.612198],
              [33.40638, 66.59444],
              [33.421379, 66.591095],
              [33.433876, 66.586929000000112],
              [33.52943, 66.535812000000135],
              [33.534439, 66.529434],
              [33.5261, 66.52331],
              [33.50972, 66.521378000000141],
              [33.487213, 66.522217],
              [33.434715, 66.529984],
              [33.389717000000132, 66.539978],
              [33.342216, 66.549149],
              [33.306938, 66.55443],
              [33.20683, 66.564339],
              [33.194492, 66.564339],
              [33.18866, 66.563004],
              [33.181389, 66.55395],
              [33.174438000000123, 66.551651000000106],
              [33.139717, 66.5486],
              [33.11916, 66.5486],
              [33.079163000000108, 66.551926],
              [33.062767000000122, 66.549713],
              [32.9661, 66.536377],
              [32.951935000000105, 66.533325000000104],
              [32.943604, 66.527481],
              [32.94609800000012, 66.519989000000123],
              [32.96138, 66.516663000000108],
              [33.03138, 66.50665],
              [33.07638500000013, 66.50499],
              [33.117210000000114, 66.505264],
              [33.1336060000001, 66.50722],
              [33.145828, 66.511108],
              [33.16277, 66.523041],
              [33.17305, 66.52832],
              [33.20388, 66.533325000000104],
              [33.222214, 66.534424],
              [33.239716, 66.53166],
              [33.254715, 66.52832],
              [33.30249, 66.511108],
              [33.302773, 66.494705000000124],
              [33.322769, 66.484985],
              [33.337769, 66.481659],
              [33.407768, 66.47137],
              [33.444992, 66.466934],
              [33.530823, 66.465271000000143],
              [33.5430530000001, 66.469147],
              [33.547493000000145, 66.477203],
              [33.556099, 66.483047000000113],
              [33.566383, 66.48804],
              [33.580826000000116, 66.491089000000102],
              [33.60139, 66.491089000000102],
              [33.616386, 66.48776],
              [33.628601000000117, 66.483597000000145],
              [33.638603000000103, 66.478592000000106],
              [33.727486, 66.430267],
              [33.732491, 66.423874000000126],
              [33.721931, 66.418869],
              [33.705551, 66.416931],
              [33.668884, 66.41499],
              [33.563049, 66.39221],
              [33.439156000000139, 66.342484],
              [33.34305, 66.329163000000108],
              [33.32888, 66.326096],
              [33.31638, 66.32222],
              [33.312767, 66.316086],
              [33.328049, 66.314423000000147],
              [33.49388, 66.311096],
              [33.51028, 66.31303400000013],
              [33.553322, 66.32222],
              [33.636383, 66.31303400000013],
              [33.75, 66.290817],
              [33.77943, 66.284149],
              [33.883331000000112, 66.260269000000108],
              [34.103607, 66.251099],
              [34.115829, 66.246933000000126],
              [34.167213, 66.214432],
              [34.350548, 66.157761000000107],
              [34.423882, 66.132477000000108],
              [34.496941, 66.106934],
              [34.531105, 66.0936],
              [34.566666, 66.07805],
              [34.712494, 65.990814],
              [34.847488, 65.901093],
              [34.852776, 65.896378000000141],
              [34.867767, 65.880264],
              [34.965828000000101, 65.7247],
              [34.963608, 65.717758],
              [34.939987, 65.698868],
              [34.929718, 65.693863],
              [34.91277, 65.696640000000116],
              [34.888885, 65.705261],
              [34.841377000000136, 65.730545],
              [34.815269, 65.746368],
              [34.758049000000142, 65.776657],
              [34.690826, 65.803864],
              [34.687492, 65.799423000000104],
              [34.674164, 65.777206],
              [34.687767, 65.720261],
              [34.69249, 65.713608],
              [34.74527, 65.639984],
              [34.759163000000115, 65.628311],
              [34.773323, 65.616653],
              [34.779991, 65.602478],
              [34.782211, 65.595261000000107],
              [34.777771, 65.5872],
              [34.681664000000126, 65.451096],
              [34.671379, 65.446091],
              [34.657494, 65.4433140000001],
              [34.61805, 65.4433140000001],
              [34.541382, 65.451096],
              [34.501938000000109, 65.451096],
              [34.488045, 65.448318],
              [34.422493, 65.418869],
              [34.38472, 65.386932000000115],
              [34.377769, 65.378311],
              [34.469711000000132, 65.280823],
              [34.47916, 65.275543],
              [34.550545, 65.251938],
              [34.586105, 65.253876],
              [34.607498, 65.252777],
              [34.631104000000107, 65.244141],
              [34.63805, 65.238312],
              [34.686104000000114, 65.18748],
              [34.69054, 65.180817],
              [34.678604, 65.176926],
              [34.682213, 65.108322],
              [34.744995, 65.057755],
              [34.795273, 65.015823],
              [34.774712, 64.968597000000102],
              [34.83916, 64.916656],
              [34.936104, 64.838318],
              [34.957214, 64.652771],
              [34.835266000000104, 64.58638],
              [34.810822000000144, 64.568329],
              [34.787773000000129, 64.54776],
              [34.852219, 64.521378],
              [34.868324, 64.5186],
              [34.947769, 64.514435],
              [34.966103, 64.50417],
              [34.968048000000124, 64.49664300000012],
              [34.966385, 64.484146000000123],
              [34.963326, 64.466934],
              [34.958046000000138, 64.448868000000118],
              [35.13587200000012, 64.384964],
              [35.324829, 64.326523],
              [35.398727, 64.320511000000124],
              [35.415634, 64.321457],
              [35.428818, 64.324387],
              [35.538605, 64.35553],
              [35.57267, 64.389099],
              [35.565948000000105, 64.394958],
              [35.561729, 64.401642],
              [35.57012, 64.407455],
              [35.588570000000118, 64.405457],
              [35.604782, 64.40264900000011],
              [35.63249, 64.395264000000111],
              [35.798607, 64.34499],
              [35.80971, 64.34082],
              [35.870270000000119, 64.312195],
              [35.879158000000132, 64.307205],
              [35.894714, 64.2961],
              [35.89888, 64.289429],
              [35.898331, 64.281097],
              [35.888885, 64.265274],
              [35.897217, 64.251938],
              [35.9786, 64.19832],
              [35.98999, 64.19386],
              [36.005829, 64.191086],
              [36.01944, 64.19386],
              [36.025826000000109, 64.200821000000133],
              [36.026382000000126, 64.209152],
              [36.1097180000001, 64.231369],
              [36.2736, 64.148331],
              [36.282494, 64.143326],
              [36.28194, 64.13499],
              [36.267212, 64.079163],
              [36.263054, 64.023315000000139],
              [36.264717, 64.015823],
              [36.275826, 64.01138],
              [36.289162, 64.008041],
              [36.473320000000115, 63.970268],
              [36.489159, 63.967209],
              [36.50777, 63.966934],
              [36.521660000000111, 63.967209],
              [36.52261, 63.96765900000014],
              [36.56055, 63.968048],
              [36.596657, 63.963882000000126],
              [36.789162, 63.933327],
              [36.804710000000114, 63.924164],
              [36.824165000000107, 63.914436],
              [36.835266, 63.909988000000112],
              [36.8486, 63.90638],
              [36.980545, 63.900826],
              [37.022655216680675, 63.899530105053636],
            ],
          ],
        ],
      },
    },
  ],
};

export default europeData;
